
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("icqFF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $ae3c6a4bb713dccb$export$4da28cf324280418 = (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const navigationTrackingId = options?.navigationTrackingId ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $42omo.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const onKeydownCallback = options?.onKeydownCallback;
    const onHighlightedCallback = options?.onHighlightedCallback;
    const unregister = (0, $42omo.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $42omo.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $42omo.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $42omo.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
/**
 * Legacy class implementation. Retained behind the
 * `search_refactor_keyboard_highlight_provider` feature gate while the
 * function-component replacement is rolled out. The exported
 * {@link KeyboardHighlightProvider} switches between the two.
 */ class $ae3c6a4bb713dccb$var$KeyboardHighlightProviderClass extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.attach(this.props.listenerNode);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.listenerNode !== this.props.listenerNode) {
            this.detach(prevProps.listenerNode);
            this.attach(this.props.listenerNode);
        }
    }
    componentWillUnmount() {
        this.detach(this.props.listenerNode);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1.Provider, {
            value: {
                registerKeyboardEnabled: this.registerKeyboardEnabled,
                unregisterKeyboardEnabled: this.unregisterKeyboardEnabled,
                getSelectedIndex: this.getSelectedIndex,
                highlightComponentAt: this.highlightComponentAt,
                unhighlightComponentAt: this.unhighlightComponentAt,
                unhighlightAll: this.unhighlightAll,
                keyboardNavComponents: this.keyboardNavComponents
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.currentlySelected = undefined;
        this.currentSelectedTrackingId = null;
        this.keyboardNavComponents = [];
        this.registerKeyboardEnabled = (currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCallback)=>{
            const indexAt = this.keyboardNavComponents.findIndex(({ id: id })=>id === currentId);
            // If the currentId is null or we can't find any records of the id we will create a new entry
            const isNew = currentId === null || currentId === undefined || indexAt === -1;
            const id = isNew ? Math.max(...this.keyboardNavComponents.map((component)=>component.id), 0) + 1 : this.keyboardNavComponents[indexAt].id;
            if (isNew) this.keyboardNavComponents.push({
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            });
            else // Otherwise we will update the current entry
            this.keyboardNavComponents[indexAt] = {
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            };
            this.keyboardNavComponents = this.keyboardNavComponents.sort((c1, c2)=>{
                const result = c1.domRef.compareDocumentPosition(c2.domRef);
                if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
                else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
                return 0;
            });
            const indexToHighlight = this.getSearchIdIndex(this.currentSelectedTrackingId);
            if (indexToHighlight !== undefined && indexToHighlight >= 0) {
                this.unhighlightAll();
                this.highlightComponentAt(indexToHighlight);
            }
            return id;
        };
        this.unregisterKeyboardEnabled = (unregisterRef)=>{
            if (this.currentlySelected === unregisterRef) this.currentlySelected = undefined;
            this.keyboardNavComponents = this.keyboardNavComponents.filter(({ id: ref })=>ref !== unregisterRef);
            // Reset currentSelectedTrackingId when all components are unregistered
            if (this.keyboardNavComponents.length === 0 && (0, $dh538.fg)('search_fix_keyboard_highlight_persistence')) this.currentSelectedTrackingId = null;
        };
        this.onKeyDownCallbackAt = (index, e)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const onKeyDown = this.keyboardNavComponents[index].onKeyDownWhenHighlighted;
                onKeyDown && onKeyDown(e, this.keyboardNavComponents[index].domRef);
            }
        };
        this.onHighlightedCallback = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const callback = this.keyboardNavComponents[index].onHighlightedCallback;
                callback && callback(index);
            }
        };
        this.unhighlightComponentAt = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) this.keyboardNavComponents[index].onHighlightChanged(false);
        };
        this.highlightComponentAt = (index)=>{
            if (index >= 0 && index < this.keyboardNavComponents.length) {
                const { id: id, navigationTrackingId: navigationTrackingId } = this.keyboardNavComponents[index];
                this.currentlySelected = id;
                this.currentSelectedTrackingId = navigationTrackingId;
                this.keyboardNavComponents[index].onHighlightChanged(true);
            }
        };
        this.unhighlightAll = ()=>{
            this.currentSelectedTrackingId = null;
            this.currentlySelected = undefined;
            this.keyboardNavComponents.forEach((component)=>component.onHighlightChanged(false));
        };
        this.getSelectedIndex = ()=>{
            if (!this.currentlySelected) return undefined;
            return this.keyboardNavComponents.findIndex(({ id: id })=>id === this.currentlySelected);
        };
        this.getSearchIdIndex = (searchId)=>searchId === null ? undefined : this.keyboardNavComponents.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId);
        this.onKeyDown = (e)=>{
            if (this.keyboardNavComponents.length === 0) return;
            if (e.isComposing || e.keyCode === 229) return;
            let currentIndex = this.getSelectedIndex();
            const prevIndex = currentIndex;
            if (e.code === 'ArrowDown' || e.keyCode === 40) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = 0;
                    else currentIndex = (currentIndex + 1) % this.keyboardNavComponents.length;
                    e.preventDefault();
                }
            } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = this.keyboardNavComponents.length - 1;
                    else {
                        currentIndex -= 1;
                        if (currentIndex < 0) currentIndex = this.keyboardNavComponents.length - Math.abs(currentIndex);
                    }
                    e.preventDefault();
                }
            } else {
                if (typeof currentIndex !== 'undefined') this.onKeyDownCallbackAt(currentIndex, e);
                return;
            }
            if (prevIndex !== currentIndex && currentIndex !== undefined) {
                this.unhighlightComponentAt(prevIndex);
                this.highlightComponentAt(currentIndex);
                this.onHighlightedCallback(currentIndex);
            }
        };
        this.attach = (listenerNode)=>{
            if (listenerNode) listenerNode.addEventListener('keydown', this.onKeyDown);
        };
        this.detach = (listenerNode)=>{
            if (listenerNode) listenerNode.removeEventListener('keydown', this.onKeyDown);
        };
    }
}
/**
 * Function-component implementation of `KeyboardHighlightProvider`.
 */ const $ae3c6a4bb713dccb$var$KeyboardHighlightProviderFn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, listenerNode: listenerNode }, ref)=>{
    const currentlySelectedRef = (0, $42omo.useRef)(undefined);
    const currentSelectedTrackingIdRef = (0, $42omo.useRef)(null);
    const keyboardNavComponentsRef = (0, $42omo.useRef)([]);
    const getSelectedIndex = (0, $42omo.useCallback)(()=>{
        const currentlySelected = currentlySelectedRef.current;
        if (!currentlySelected) return undefined;
        return keyboardNavComponentsRef.current.findIndex(({ id: id })=>id === currentlySelected);
    }, []);
    const getSearchIdIndex = (0, $42omo.useCallback)((searchId)=>searchId === null ? undefined : keyboardNavComponentsRef.current.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), []);
    const unhighlightComponentAt = (0, $42omo.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) components[index].onHighlightChanged(false);
    }, []);
    const highlightComponentAt = (0, $42omo.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (index >= 0 && index < components.length) {
            const { id: id, navigationTrackingId: navigationTrackingId } = components[index];
            currentlySelectedRef.current = id;
            currentSelectedTrackingIdRef.current = navigationTrackingId;
            components[index].onHighlightChanged(true);
        }
    }, []);
    const unhighlightAll = (0, $42omo.useCallback)(()=>{
        currentSelectedTrackingIdRef.current = null;
        currentlySelectedRef.current = undefined;
        keyboardNavComponentsRef.current.forEach((component)=>component.onHighlightChanged(false));
    }, []);
    const onHighlightedCallback = (0, $42omo.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const callback = components[index].onHighlightedCallback;
            callback && callback(index);
        }
    }, []);
    const onKeyDownCallbackAt = (0, $42omo.useCallback)((index, e)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const onKeyDown = components[index].onKeyDownWhenHighlighted;
            onKeyDown && onKeyDown(e, components[index].domRef);
        }
    }, []);
    const registerKeyboardEnabled = (0, $42omo.useCallback)((currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCb)=>{
        const components = keyboardNavComponentsRef.current;
        const indexAt = components.findIndex(({ id: id })=>id === currentId);
        // If the currentId is null or we can't find any records of the id we will create a new entry
        const isNew = currentId === null || currentId === undefined || indexAt === -1;
        const id = isNew ? Math.max(...components.map((component)=>component.id), 0) + 1 : components[indexAt].id;
        if (isNew) components.push({
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        });
        else // Otherwise we will update the current entry
        components[indexAt] = {
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        };
        keyboardNavComponentsRef.current = components.sort((c1, c2)=>{
            const result = c1.domRef.compareDocumentPosition(c2.domRef);
            if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
            else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
            return 0;
        });
        const indexToHighlight = getSearchIdIndex(currentSelectedTrackingIdRef.current);
        if (indexToHighlight !== undefined && indexToHighlight >= 0) {
            unhighlightAll();
            highlightComponentAt(indexToHighlight);
        }
        return id;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
    const unregisterKeyboardEnabled = (0, $42omo.useCallback)((unregisterRef)=>{
        if (currentlySelectedRef.current === unregisterRef) currentlySelectedRef.current = undefined;
        keyboardNavComponentsRef.current = keyboardNavComponentsRef.current.filter(({ id: ref })=>ref !== unregisterRef);
        // Reset currentSelectedTrackingId when all components are unregistered
        if (keyboardNavComponentsRef.current.length === 0 && (0, $dh538.fg)('search_fix_keyboard_highlight_persistence')) currentSelectedTrackingIdRef.current = null;
    }, []);
    const onKeyDown = (0, $42omo.useCallback)((e)=>{
        const components = keyboardNavComponentsRef.current;
        if (components.length === 0) return;
        if (e.isComposing || e.keyCode === 229) return;
        let currentIndex = getSelectedIndex();
        const prevIndex = currentIndex;
        if (e.code === 'ArrowDown' || e.keyCode === 40) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = 0;
                else currentIndex = (currentIndex + 1) % components.length;
                e.preventDefault();
            }
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = components.length - 1;
                else {
                    currentIndex -= 1;
                    if (currentIndex < 0) currentIndex = components.length - Math.abs(currentIndex);
                }
                e.preventDefault();
            }
        } else {
            if (typeof currentIndex !== 'undefined') onKeyDownCallbackAt(currentIndex, e);
            return;
        }
        if (prevIndex !== currentIndex && currentIndex !== undefined) {
            unhighlightComponentAt(prevIndex);
            highlightComponentAt(currentIndex);
            onHighlightedCallback(currentIndex);
        }
    }, [
        getSelectedIndex,
        onKeyDownCallbackAt,
        unhighlightComponentAt,
        highlightComponentAt,
        onHighlightedCallback
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!listenerNode) return;
        listenerNode.addEventListener('keydown', onKeyDown);
        return ()=>{
            listenerNode.removeEventListener('keydown', onKeyDown);
        };
    }, [
        listenerNode,
        onKeyDown
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            registerKeyboardEnabled: registerKeyboardEnabled,
            unregisterKeyboardEnabled: unregisterKeyboardEnabled,
            getSelectedIndex: getSelectedIndex,
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            get keyboardNavComponents () {
                // Always read the latest registry from the ref so consumers that
                // destructure `keyboardNavComponents` from the context still see
                // up-to-date data without forcing a re-render of the provider.
                return keyboardNavComponentsRef.current;
            }
        }), [
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        getSelectedIndex,
        highlightComponentAt,
        unhighlightComponentAt,
        unhighlightAll
    ]);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            getSelectedIndex: getSelectedIndex
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1.Provider, {
        value: contextValue
    }, children);
});
const $ae3c6a4bb713dccb$export$c8551b32665b42b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    if ((0, $dh538.fg)('search_refactor_keyboard_highlight_provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$var$KeyboardHighlightProviderFn, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$var$KeyboardHighlightProviderClass, props);
});
const $ae3c6a4bb713dccb$export$cbeda0f7f7a8026c = ()=>{
    return (0, $42omo.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1);
};
module.exports["useKeyboardNavigation"] = $ae3c6a4bb713dccb$export$4da28cf324280418;
module.exports["KeyboardHighlightProvider"] = $ae3c6a4bb713dccb$export$c8551b32665b42b;
module.exports["useKeyboardHighlightProvider"] = $ae3c6a4bb713dccb$export$cbeda0f7f7a8026c;

});

parcelRegister("1yEFx", function(module, exports) {
$parcel$export(module.exports, "ProductKeys", () => (parcelRequire("b4tvS")).ProductKeys);
$parcel$export(module.exports, "all3pProductKeys", () => (parcelRequire("b4tvS")).all3pProductKeys);

var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");

var $4Nwes = parcelRequire("4Nwes");


var $hB77E = parcelRequire("hB77E");


var $9yyKc = parcelRequire("9yyKc");




const $d52b37ba90dc95d4$export$24d355ce80de5803 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));





const $a167bd50b2e4c9cb$export$b0a52366c3fb9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));





const $e108be1bca7d778f$export$4b1b9db11d699ccb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $25d6378a84ef5509$export$93ca83db1787dea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));





const $506871dc04f0c8db$export$4d0238652f4b6bc4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $b412ffda38aeedd7$export$1afe31d4b2891d7a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));



var $fl27B = parcelRequire("fl27B");


var $bj3ok = parcelRequire("bj3ok");


var $brMqq = parcelRequire("brMqq");




const $c190735ed0251a79$export$7221b4e3b691d1b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));



var $6Gsan = parcelRequire("6Gsan");


var $b4tvS = parcelRequire("b4tvS");



const $2acca743010e8c82$export$2e51523f0c1b4542 = {
    [(0, $b4tvS.ProductKeys).Confluence]: {
        displayName: 'Confluence',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'Confluence'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $25d6378a84ef5509$export$93ca83db1787dea), 'Confluence', 'large')
    },
    [(0, $b4tvS.ProductKeys).Atlas]: {
        displayName: 'Home',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $4Nwes.AtlassianIcon), 'Home'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $a167bd50b2e4c9cb$export$b0a52366c3fb9b), 'Home', 'large')
    },
    [(0, $b4tvS.ProductKeys).Jira]: {
        displayName: 'Jira',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraIcon), 'Jira'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $fl27B.JiraSearchResultIcon), 'Jira', 'large')
    },
    [(0, $b4tvS.ProductKeys).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $b412ffda38aeedd7$export$1afe31d4b2891d7a), 'Jira Product Discovery', 'large')
    },
    [(0, $b4tvS.ProductKeys).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraServiceManagementIcon), 'Jira Service Management'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $bj3ok.JiraServiceManagementSearchResultIcon), 'Jira Service Management', 'large')
    },
    [(0, $b4tvS.ProductKeys).Bitbucket]: {
        displayName: 'Bitbucket',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.BitbucketIcon), 'Bitbucket'),
        SearchResultIcon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.BitbucketIcon), 'large')
    },
    [(0, $b4tvS.ProductKeys).Trello]: {
        displayName: 'Trello',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.TrelloIcon), 'Trello'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $c190735ed0251a79$export$7221b4e3b691d1b3), 'Trello', 'large')
    },
    [(0, $b4tvS.ProductKeys).Compass]: {
        displayName: 'Compass',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.CompassIcon), 'Compass'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $e108be1bca7d778f$export$4b1b9db11d699ccb), 'Compass', 'large')
    },
    [(0, $b4tvS.ProductKeys).Focus]: {
        displayName: 'Focus',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.FocusIcon), 'Focus'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $506871dc04f0c8db$export$4d0238652f4b6bc4), 'Focus', 'large')
    },
    [(0, $b4tvS.ProductKeys).Assets]: {
        displayName: 'Assets',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.AssetsIcon), 'Assets'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $d52b37ba90dc95d4$export$24d355ce80de5803), 'Assets', 'large')
    },
    [(0, $b4tvS.ProductKeys).Talent]: {
        displayName: 'Talent',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.TalentIcon), 'Talent'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $brMqq.TalentSearchResultIcon), 'Talent', 'large')
    }
};
const $2acca743010e8c82$var$getProducts3PFromConfig = ()=>{
    // The use of Partial, the if (config) and the cast here are intentional TS gymnastics
    // We KNOW that this returns a config for all the ProductKeys3P, so we cast that
    // The TS compiler can't know that, and we'd be forced to write UI code like:
    //
    // const Icon = configs[productKey].Icon
    // return Icon && <Icon />
    //
    // Because TS can't prove productKey can be guaranteed to index into configs. But we know it can!
    const thirdPartyProducts = (0, $hB77E.getThirdPartyConfigs)();
    const configs = {};
    (0, $b4tvS.all3pProductKeys).map((productKey3P)=>{
        const config = thirdPartyProducts.get(productKey3P);
        if (config) configs[productKey3P] = {
            displayName: config.displayName,
            Icon: config.icon,
            IconBorderless: config.iconBorderless,
            is3P: true,
            ...config.searchResultIcon && {
                SearchResultIcon: config.searchResultIcon
            }
        };
    });
    return configs;
};
const $2acca743010e8c82$export$e2c1afe0b1afaf49 = ()=>{
    return (0, $42omo.useMemo)(()=>{
        const thirdPartyProducts = $2acca743010e8c82$var$getProducts3PFromConfig();
        return {
            ...$2acca743010e8c82$export$2e51523f0c1b4542,
            ...thirdPartyProducts
        };
    }, []);
};
const $2acca743010e8c82$export$ede9abe489c9321b = (productKey)=>{
    return $2acca743010e8c82$export$e2c1afe0b1afaf49()[productKey];
};
// Used by SAIN to detrermine knowledge source filtering
var $2acca743010e8c82$var$KnowledgeSourceTypeValues = /*#__PURE__*/ function(KnowledgeSourceTypeValues) {
    KnowledgeSourceTypeValues["GITHUB"] = "github";
    KnowledgeSourceTypeValues["CONFLUENCE"] = "confluence";
    KnowledgeSourceTypeValues["JIRA"] = "jira";
    KnowledgeSourceTypeValues["ATLAS"] = "atlas";
    KnowledgeSourceTypeValues["HELP_AGGREGATOR"] = "help_aggregator";
    KnowledgeSourceTypeValues["GOOGLE_DRIVE"] = "google_drive";
    KnowledgeSourceTypeValues["MICROSOFT_SHAREPOINT"] = "microsoft_sharepoint";
    KnowledgeSourceTypeValues["SLACK"] = "slack";
    KnowledgeSourceTypeValues["MICROSOFT_TEAMS"] = "teams";
    KnowledgeSourceTypeValues["FIGMA"] = "figma";
    KnowledgeSourceTypeValues["CONFLUENCE_DC"] = "confluence-dc";
    KnowledgeSourceTypeValues["ATLASSIAN_WEB_CRAWLER"] = "atlassian-web-crawler";
    KnowledgeSourceTypeValues["LOOM"] = "loom";
    KnowledgeSourceTypeValues["GOOGLE_CALENDAR"] = "google_calendar";
    KnowledgeSourceTypeValues["ASSETS"] = "cmdb";
    KnowledgeSourceTypeValues["SALESFORCE"] = "salesforce";
    KnowledgeSourceTypeValues["ZENDESK"] = "zendesk";
    KnowledgeSourceTypeValues["SERVICENOW"] = "servicenow";
    return KnowledgeSourceTypeValues;
}($2acca743010e8c82$var$KnowledgeSourceTypeValues || {});
const $2acca743010e8c82$export$4fbc006e529fd6c0 = {
    [(0, $b4tvS.ProductKeys).Confluence]: "confluence",
    [(0, $b4tvS.ProductKeys).Github]: "github",
    [(0, $b4tvS.ProductKeys).Jira]: "jira",
    [(0, $b4tvS.ProductKeys).Atlas]: "atlas",
    [(0, $b4tvS.ProductKeys).GoogleDrive]: "google_drive",
    [(0, $b4tvS.ProductKeys).Sharepoint]: "microsoft_sharepoint",
    [(0, $b4tvS.ProductKeys).Slack]: "slack",
    [(0, $b4tvS.ProductKeys).Teams]: "teams",
    [(0, $b4tvS.ProductKeys).Figma]: "figma",
    [(0, $b4tvS.ProductKeys).ConfluenceDC]: "confluence-dc",
    [(0, $b4tvS.ProductKeys).AtlassianWebCrawler]: "atlassian-web-crawler",
    [(0, $b4tvS.ProductKeys).Loom]: "loom",
    [(0, $b4tvS.ProductKeys).GoogleCalendar]: "google_calendar",
    [(0, $b4tvS.ProductKeys).Assets]: "cmdb",
    [(0, $b4tvS.ProductKeys).Salesforce]: "salesforce",
    [(0, $b4tvS.ProductKeys).Zendesk]: "zendesk",
    [(0, $b4tvS.ProductKeys).ServiceNow]: "servicenow"
};
module.exports["products1P"] = $2acca743010e8c82$export$2e51523f0c1b4542;
module.exports["useProductConfigs"] = $2acca743010e8c82$export$e2c1afe0b1afaf49;
module.exports["useProductConfig"] = $2acca743010e8c82$export$ede9abe489c9321b;
module.exports["MapProductToKnowledgeSources"] = $2acca743010e8c82$export$4fbc006e529fd6c0;

});

parcelRegister("hB77E", function(module, exports) {
$parcel$export(module.exports, "ProductKeys3P", () => (parcelRequire("hdfeV")).ProductKeys3P);

var $dh538 = parcelRequire("dh538");


var $a5RR2 = parcelRequire("a5RR2");


var $1A1pg = parcelRequire("1A1pg");


var $2Znam = parcelRequire("2Znam");


var $9yyKc = parcelRequire("9yyKc");


var $42omo = parcelRequire("42omo");

const $6ae04d3601d944f0$export$600af2172b0f5fb = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#584CCC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
        fill: "white"
    }));
};





const $18da8b9d7017c546$export$9efd1df023dc9339 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#584CCC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
        fill: "white"
    }));
};


const $66e851fe802529fd$export$8130889f372e8ca5 = {
    displayName: 'Adobe Sign',
    id: 'adobe-sign',
    resourceType: 'adobe-sign-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $6ae04d3601d944f0$export$600af2172b0f5fb), 'Adobe Sign', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $18da8b9d7017c546$export$9efd1df023dc9339), 'Adobe Sign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};



var $6aYi6 = parcelRequire("6aYi6");










const $fc6a0ef8f9f5c7bc$export$be8cba599441db6e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#470137"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.5802 7.40457L9.75898 12.1789L12.7683 17.2427C12.7871 17.2812 12.7965 17.3198 12.7871 17.3584C12.7777 17.397 12.7401 17.368 12.6836 17.3777H10.5301C10.3796 17.3777 10.2762 17.368 10.2104 17.2716C10.0129 16.8665 9.806 16.471 9.60851 16.0659C9.41103 15.6705 9.19473 15.2654 8.96903 14.8507C8.74334 14.4359 8.51764 14.0212 8.29194 13.5968H8.27313C8.07565 14.0115 7.85935 14.4263 7.64306 14.841C7.42677 15.2558 7.21047 15.6705 7.00359 16.0756C6.78729 16.4807 6.571 16.8954 6.3547 17.2909C6.31709 17.3873 6.24186 17.397 6.13841 17.397H4.06952C4.0319 17.397 4.00369 17.4163 4.00369 17.368C3.99429 17.3295 4.00369 17.2909 4.0225 17.262L6.94716 12.3429L4.09773 7.39492C4.06952 7.35634 4.06011 7.31776 4.07892 7.29847C4.09773 7.26953 4.13535 7.25989 4.17296 7.25989H6.30768C6.3547 7.25989 6.40173 7.26953 6.43934 7.27918C6.47696 7.29847 6.50517 7.3274 6.53338 7.36598C6.71206 7.78073 6.91895 8.19547 7.13524 8.61021C7.36094 9.02496 7.57723 9.43006 7.81233 9.83515C8.03803 10.2403 8.24492 10.6453 8.44241 11.0601H8.46122C8.6587 10.6357 8.86559 10.221 9.07248 9.81586C9.27937 9.41077 9.49566 9.00567 9.71196 8.60057C9.92825 8.19547 10.1351 7.78073 10.342 7.38528C10.3514 7.34669 10.3702 7.30811 10.3985 7.28882C10.4361 7.26953 10.4737 7.25989 10.5207 7.26953H12.505C12.552 7.25989 12.599 7.28882 12.6084 7.33705C12.6178 7.34669 12.599 7.38528 12.5802 7.40457Z",
        fill: "#FF61F6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.9248 17.5803C16.2289 17.5899 15.533 17.4453 14.9029 17.1463C14.3105 16.8666 13.8215 16.4036 13.4829 15.8345C13.135 15.2462 12.9657 14.5131 12.9657 13.6354C12.9563 12.9217 13.135 12.2176 13.4829 11.6003C13.8403 10.9733 14.3575 10.4525 14.9782 10.1053C15.6364 9.72911 16.4264 9.54585 17.3574 9.54585C17.4044 9.54585 17.4702 9.54585 17.5549 9.5555C17.711 9.5733 17.8464 9.43978 17.8464 9.28259V6.52691C17.8464 6.45939 17.8746 6.42081 17.9404 6.42081H19.791C19.8299 6.42081 19.873 6.41051 19.9052 6.43245C19.9189 6.44186 19.9299 6.45544 19.937 6.4702C19.9425 6.48177 19.9435 6.50762 19.9435 6.50762C19.9435 6.50762 19.9435 6.50762 19.9435 6.50762V15.6898C19.9435 15.8635 19.9529 16.0564 19.9623 16.2686C19.9811 16.4711 19.9905 16.664 19.9999 16.828C19.9999 16.8955 19.9717 16.9534 19.9059 16.9823C19.4169 17.1945 18.8996 17.3488 18.373 17.4453C17.8934 17.5321 17.4138 17.5803 16.9248 17.5803ZM17.5438 15.7015C17.7293 15.7077 17.8464 15.5265 17.8464 15.3409V11.666C17.8464 11.5147 17.7428 11.3763 17.5925 11.3591C17.489 11.3495 17.3856 11.3399 17.2821 11.3399C16.9154 11.3399 16.5486 11.417 16.2195 11.5906C15.8998 11.7546 15.627 11.9957 15.4201 12.3044C15.2133 12.613 15.1098 13.0278 15.1098 13.5293C15.1004 13.8669 15.1568 14.2045 15.2697 14.5228C15.3637 14.7832 15.5048 15.0147 15.6929 15.2076C15.8715 15.3812 16.0878 15.5162 16.3323 15.5934C16.5862 15.6802 16.8496 15.7188 17.1129 15.7188C17.2409 15.7188 17.3612 15.7108 17.4737 15.7022C17.4964 15.7004 17.521 15.7007 17.5438 15.7015Z",
        fill: "#FF61F6"
    }));
};





const $df497511c4b16838$export$145a936ff16d9011 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#470137"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.7738 9.87271L13.0121 16.2385L17.0245 22.9902C17.0496 23.0416 17.0621 23.0931 17.0496 23.1445C17.0371 23.1959 16.9869 23.1574 16.9117 23.1702H14.0403C13.8397 23.1702 13.7018 23.1574 13.614 23.0288C13.3507 22.4886 13.0748 21.9614 12.8115 21.4212C12.5482 20.894 12.2598 20.3538 11.9589 19.8008C11.6579 19.2478 11.357 18.6948 11.0561 18.129H11.031C10.7677 18.682 10.4793 19.235 10.1909 19.788C9.90252 20.341 9.61413 20.894 9.33828 21.4341C9.04989 21.9742 8.76149 22.5272 8.4731 23.0545C8.42295 23.1831 8.32264 23.1959 8.18471 23.1959H5.42619C5.37603 23.1959 5.33842 23.2217 5.33842 23.1574C5.32588 23.1059 5.33842 23.0545 5.36349 23.0159L9.26304 16.4572L5.4638 9.85985C5.42619 9.80841 5.41365 9.75697 5.43872 9.73125C5.4638 9.69267 5.51396 9.67981 5.56411 9.67981H8.41041C8.4731 9.67981 8.5358 9.69267 8.58595 9.70553C8.63611 9.73125 8.67372 9.76983 8.71134 9.82127C8.94958 10.3743 9.22543 10.9273 9.51382 11.4802C9.81475 12.0332 10.1031 12.5734 10.4166 13.1135C10.7175 13.6536 10.9934 14.1938 11.2567 14.7468H11.2818C11.5451 14.1809 11.8209 13.6279 12.0968 13.0878C12.3727 12.5476 12.661 12.0075 12.9494 11.4674C13.2378 10.9273 13.5137 10.3743 13.7895 9.84699C13.8021 9.79555 13.8271 9.74411 13.8648 9.71839C13.9149 9.69267 13.9651 9.67981 14.0278 9.69267H16.6734C16.7361 9.67981 16.7988 9.71839 16.8114 9.78269C16.8239 9.79555 16.7988 9.84699 16.7738 9.87271Z",
        fill: "#FF61F6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.5666 23.4404C21.6388 23.4533 20.7109 23.2604 19.8708 22.8617C19.0809 22.4887 18.4289 21.8714 17.9775 21.1127C17.5135 20.3282 17.2878 19.3508 17.2878 18.1806C17.2753 17.2289 17.5135 16.2901 17.9775 15.467C18.4539 14.6311 19.1436 13.9367 19.9711 13.4737C20.8488 12.9721 21.9021 12.7278 23.1434 12.7278C23.2061 12.7278 23.2939 12.7278 23.4067 12.7407C23.615 12.7644 23.7954 12.5864 23.7954 12.3768V8.70254C23.7954 8.61252 23.8331 8.56108 23.9208 8.56108H26.3882C26.4401 8.56108 26.4976 8.54735 26.5405 8.5766C26.5588 8.58915 26.5735 8.60725 26.5829 8.62694C26.5903 8.64235 26.5916 8.67682 26.5916 8.67682C26.5916 8.67682 26.5916 8.67682 26.5916 8.67682V20.9198C26.5916 21.1513 26.6041 21.4085 26.6167 21.6914C26.6417 21.9615 26.6543 22.2187 26.6668 22.4373C26.6668 22.5273 26.6292 22.6045 26.5414 22.6431C25.8894 22.926 25.1998 23.1318 24.4976 23.2604C23.8581 23.3761 23.2187 23.4404 22.5666 23.4404ZM23.3919 20.9354C23.6393 20.9437 23.7954 20.7021 23.7954 20.4546V15.5546C23.7954 15.3529 23.6573 15.1684 23.4569 15.1455C23.319 15.1327 23.181 15.1198 23.0431 15.1198C22.5541 15.1198 22.0651 15.2227 21.6262 15.4542C21.1999 15.6728 20.8363 15.9943 20.5604 16.4058C20.2846 16.8174 20.1467 17.3704 20.1467 18.0391C20.1341 18.4892 20.2094 18.9393 20.3598 19.3637C20.4852 19.7109 20.6733 20.0196 20.9241 20.2768C21.1623 20.5083 21.4507 20.6883 21.7767 20.7912C22.1152 20.9069 22.4663 20.9584 22.8174 20.9584C22.9881 20.9584 23.1485 20.9478 23.2985 20.9362C23.3288 20.9339 23.3616 20.9343 23.3919 20.9354Z",
        fill: "#FF61F6"
    }));
};


const $550d38c9b57936f7$export$e69f90b2aa757835 = {
    displayName: 'AdobeXD',
    id: 'adobexd',
    resourceType: 'smartlinks-connector-adobexd',
    icon: (0, $9yyKc.get3PLogo)((0, $fc6a0ef8f9f5c7bc$export$be8cba599441db6e), 'AdobeXD', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $df497511c4b16838$export$145a936ff16d9011), 'AdobeXD', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};



var $dD8Tu = parcelRequire("dD8Tu");










const $38d5eef3851b2cfa$export$f28fe6c5ebff8c30 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#0172CE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.5114 14.3589C13.4961 13.9874 13.4858 13.6157 13.4829 13.2439C13.4806 12.9476 13.4822 12.6512 13.4798 12.3549C13.4779 12.1238 13.4776 11.8926 13.4483 11.6628C13.4314 11.5303 13.4041 11.4003 13.3459 11.2789C13.2429 11.0639 13.0729 10.9187 12.8595 10.8216C12.562 10.6863 12.2524 10.6769 11.9374 10.742C11.6833 10.7945 11.4482 10.8957 11.2248 11.0259C11.1582 11.0647 11.0935 11.1066 11.0248 11.1522C11.0248 11.139 11.0248 11.1317 11.0248 11.1242C11.024 10.9117 11.0232 10.6993 11.0223 10.4868C11.0205 10.0525 11.0181 9.61825 11.0083 9.18407C11.0075 9.14589 11.0068 9.1076 11.003 9.06965C10.9985 9.02436 10.9605 8.99346 10.9209 9.00118C10.7482 9.03488 10.5756 9.06898 10.403 9.10296C10.182 9.14651 9.96017 9.18597 9.73703 9.21771C9.63006 9.23294 9.52302 9.24761 9.41605 9.26266C9.40776 9.26384 9.39813 9.26496 9.39433 9.27313C9.38968 9.28299 9.39892 9.28864 9.4053 9.29306C9.41476 9.29956 9.4137 9.30885 9.41498 9.31786C9.43737 9.47365 9.45467 9.63006 9.46883 9.7868C9.49083 10.0299 9.5041 10.2737 9.51339 10.5176C9.52722 10.8799 9.53366 11.2423 9.53607 11.6048C9.54323 12.6756 9.53573 13.7464 9.52577 14.8172C9.52515 14.8822 9.54228 14.8991 9.60722 14.8982C9.9839 14.8933 10.3605 14.8882 10.7372 14.8834C10.8454 14.882 10.9536 14.8819 11.0617 14.88C11.1067 14.8793 11.1419 14.8617 11.1375 14.803C11.1263 14.6534 11.1212 14.5034 11.1135 14.3536C11.0966 14.0279 11.0824 13.7021 11.0754 13.376C11.0725 13.24 11.0686 13.104 11.0675 12.968C11.065 12.6502 11.064 12.3324 11.0619 12.0146C11.0618 12.0001 11.0668 11.9933 11.0802 11.9881C11.1314 11.9683 11.1821 11.9472 11.233 11.9266C11.3449 11.8813 11.4598 11.8553 11.582 11.8677C11.6869 11.8784 11.7678 11.9237 11.8182 12.0183C11.8354 12.0504 11.8491 12.0839 11.8596 12.1188C11.9079 12.2798 11.9208 12.4461 11.9309 12.6124C11.9449 12.8432 11.9481 13.0743 11.9491 13.3054C11.9514 13.8152 11.9454 14.3249 11.943 14.8346C11.9427 14.8967 11.9627 14.9166 12.025 14.9164C12.2432 14.9154 12.4613 14.9063 12.6794 14.9013C12.7968 14.8986 12.9143 14.8968 13.0318 14.9015C13.1743 14.9071 13.3167 14.9164 13.4594 14.9164C13.5133 14.9164 13.5378 14.89 13.5351 14.8365C13.527 14.6775 13.5179 14.5184 13.5113 14.3592L13.5114 14.3589Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.9366 9.01969C19.8949 9.01381 19.8552 9.02663 19.8151 9.03307C19.5797 9.07063 19.3445 9.10948 19.1092 9.14766C18.8849 9.18405 18.6607 9.22071 18.4363 9.25626C18.3593 9.26846 18.3278 9.30709 18.335 9.3844C18.3477 9.52166 18.3605 9.65887 18.372 9.79624C18.3901 10.0134 18.4071 10.2308 18.4246 10.448C18.4441 10.6912 18.4592 10.9349 18.473 11.1785C18.4862 11.4092 18.4974 11.64 18.5087 11.8708C18.5253 12.2067 18.5413 12.5427 18.5572 12.8786C18.5601 12.9403 18.5901 12.9699 18.6524 12.9689C18.8259 12.966 18.9992 12.9627 19.1727 12.9596C19.1727 12.959 19.1727 12.9585 19.1727 12.9579C19.2109 12.9579 19.2491 12.9584 19.2874 12.9578C19.4272 12.9557 19.567 12.9535 19.7069 12.9509C19.7598 12.9499 19.7931 12.9184 19.7943 12.8695C19.7981 12.7158 19.8008 12.5621 19.8057 12.4084C19.8128 12.1849 19.8201 11.9614 19.8299 11.7379C19.8428 11.4466 19.8577 11.1554 19.8727 10.8642C19.8815 10.6958 19.8914 10.5274 19.9024 10.3592C19.9159 10.1537 19.9299 9.94834 19.9456 9.74312C19.9583 9.57691 19.9737 9.41088 19.9879 9.24479C19.9923 9.19379 19.9984 9.14279 20 9.09168C20.0016 9.04511 19.9823 9.02619 19.9366 9.01969H19.9366Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.8688 14.1793C19.8688 13.9604 19.8688 13.7414 19.8688 13.5225C19.8688 13.4553 19.8458 13.4339 19.7778 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3336 13.4735 19.0533 13.4827 18.7725 13.4746C18.6672 13.4715 18.562 13.4672 18.4571 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3715 13.5886 18.3713 13.6537 18.3731 13.7185C18.3774 13.8731 18.3778 14.0277 18.3757 14.1823C18.3727 14.4096 18.372 14.6369 18.3711 14.8643C18.3709 14.9132 18.3988 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.695 14.9194C18.9465 14.9041 19.198 14.9013 19.4498 14.9076C19.5653 14.9104 19.6808 14.9132 19.7964 14.9166C19.8276 14.9174 19.8511 14.9065 19.864 14.8775C19.8706 14.8627 19.8688 14.8464 19.8688 14.8306C19.8689 14.6135 19.8688 14.3964 19.8688 14.1793Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.07031 14.2687C8.61418 12.7687 8.15801 11.2688 7.70189 9.76881C7.63667 9.55441 7.57151 9.34 7.50612 9.1256C7.48597 9.05949 7.43526 9.0268 7.36791 9.03771C7.25763 9.05557 7.14763 9.07522 7.03735 9.09313C6.67802 9.15152 6.31852 9.20884 5.96031 9.274C5.86772 9.29085 5.80132 9.34224 5.77154 9.43248C5.18325 11.2134 4.59553 12.9943 4.00768 14.7753C3.98317 14.8496 4.01849 14.8982 4.09703 14.8982C4.53249 14.8982 4.96801 14.8982 5.40348 14.8983C5.42128 14.8983 5.43902 14.8983 5.45593 14.8922C5.47636 14.8849 5.49142 14.8721 5.49635 14.8498C5.51896 14.7472 5.54136 14.6445 5.56425 14.5419C5.6335 14.2314 5.70297 13.921 5.77233 13.6105C5.77546 13.5964 5.77815 13.5867 5.79847 13.587C6.27581 13.5939 6.7532 13.6 7.23054 13.6053C7.25254 13.6055 7.26054 13.6121 7.26508 13.633C7.3552 14.0446 7.446 14.456 7.53669 14.8675C7.54811 14.9193 7.56759 14.935 7.62116 14.9357C7.63141 14.9358 7.64165 14.9352 7.6519 14.9349C7.90072 14.9282 8.14961 14.9214 8.34341 14.9162C8.65494 14.9162 8.91138 14.9165 9.16782 14.9161C9.22923 14.916 9.25593 14.8791 9.2383 14.8211C9.18226 14.6369 9.12623 14.4528 9.07025 14.2686L9.07031 14.2687ZM7.00544 12.4829C6.70517 12.4823 6.4049 12.4822 6.10457 12.483C6.07881 12.4831 6.07909 12.4754 6.08486 12.4548C6.22089 11.9665 6.3497 11.4762 6.47397 10.9849C6.50952 10.8442 6.54289 10.703 6.57737 10.562C6.57866 10.5569 6.58056 10.5518 6.58465 10.5392C6.6816 10.937 6.76787 11.3295 6.85732 11.7211C6.91319 11.966 6.96978 12.2107 7.02739 12.4552C7.03299 12.479 7.02834 12.4829 7.0055 12.4828L7.00544 12.4829Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.6715 14.483C17.6508 14.1846 17.6368 13.8858 17.6337 13.5866C17.6292 13.1505 17.6392 12.7144 17.6459 12.2783C17.6489 12.0854 17.6451 11.8927 17.6116 11.7017C17.5626 11.4229 17.427 11.1973 17.2 11.0277C17.0326 10.9026 16.8409 10.8332 16.6391 10.7888C16.3129 10.7171 15.9826 10.7133 15.6513 10.735C15.4224 10.75 15.1954 10.7808 14.9697 10.822C14.7443 10.8632 14.5215 10.9154 14.3015 10.9796C14.2482 10.9951 14.2304 11.018 14.2279 11.0738C14.225 11.1361 14.2232 11.1986 14.2205 11.2609C14.2138 11.4201 14.2068 11.5793 14.2002 11.7385C14.1971 11.812 14.193 11.8856 14.1925 11.9591C14.192 12.0256 14.2482 12.0552 14.2961 12.0363C14.4737 11.9667 14.6519 11.899 14.8344 11.8434C15.1069 11.7603 15.3843 11.7096 15.6705 11.7156C15.765 11.7175 15.8584 11.726 15.9472 11.7617C16.0354 11.797 16.0909 11.8595 16.1043 11.9553C16.11 11.996 16.1065 12.0371 16.106 12.0781C16.1057 12.1005 16.0979 12.1097 16.0745 12.1129C15.9739 12.127 15.8735 12.1417 15.7735 12.1592C15.4704 12.2122 15.1722 12.2838 14.8841 12.3937C14.6487 12.4835 14.426 12.5963 14.2307 12.7575C14.0093 12.9403 13.8519 13.1654 13.7916 13.4492C13.733 13.7249 13.7543 13.9976 13.8446 14.2642C13.9131 14.4664 14.0269 14.6385 14.1966 14.7708C14.3761 14.9107 14.5826 14.976 14.8076 14.9892C14.8076 14.9907 14.8078 14.9922 14.808 14.9937H14.9647C14.9647 14.9921 14.9647 14.9906 14.9649 14.989C15.0468 14.9825 15.1278 14.9702 15.2076 14.9506C15.5361 14.87 15.8352 14.7248 16.1143 14.5361C16.1279 14.527 16.1412 14.5175 16.1583 14.5057V14.5414C16.1583 14.6448 16.1582 14.7483 16.1584 14.8517C16.1585 14.9143 16.1809 14.9365 16.2426 14.9356C16.3964 14.9334 16.5502 14.9309 16.7041 14.9288C17.0099 14.9245 17.3157 14.9204 17.6215 14.9161C17.6734 14.9154 17.696 14.8915 17.6952 14.8397C17.6951 14.8341 17.6948 14.8285 17.6945 14.823C17.6868 14.7095 17.6793 14.5962 17.6714 14.4828L17.6715 14.483ZM16.1219 13.3558C16.1219 13.4806 16.1214 13.6055 16.1224 13.7302C16.1226 13.7497 16.1161 13.76 16.0995 13.7695C15.9485 13.857 15.7891 13.9147 15.6115 13.9032C15.4004 13.8894 15.2482 13.7607 15.226 13.5542C15.2022 13.3329 15.2951 13.1667 15.5135 13.0711C15.6245 13.0225 15.7419 12.9981 15.861 12.9813C15.9384 12.9704 16.0164 12.9631 16.0939 12.9531C16.1155 12.9503 16.1227 12.9553 16.1224 12.9785C16.1213 13.1043 16.1219 13.2301 16.1219 13.3558Z",
        fill: "white"
    }));
};





const $7e71d35b557ef27f$export$7dd76757b7d2d978 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#0172CE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.0155 19.1452C17.9951 18.6499 17.9814 18.1543 17.9775 17.6586C17.9744 17.2634 17.9766 16.8683 17.9734 16.4732C17.9708 16.1651 17.9704 15.8569 17.9314 15.5505C17.9089 15.3738 17.8725 15.2004 17.7949 15.0385C17.6576 14.7518 17.4309 14.5583 17.1463 14.4289C16.7497 14.2484 16.3369 14.2358 15.9169 14.3226C15.5781 14.3927 15.2646 14.5276 14.9667 14.7012C14.8779 14.7529 14.7917 14.8088 14.7001 14.8696C14.7001 14.8521 14.7001 14.8422 14.7001 14.8323C14.699 14.5489 14.6979 14.2657 14.6967 13.9824C14.6944 13.4033 14.6912 12.8243 14.6781 12.2454C14.677 12.1945 14.676 12.1435 14.671 12.0929C14.665 12.0325 14.6143 11.9913 14.5615 12.0016C14.3313 12.0465 14.1011 12.092 13.871 12.1373C13.5763 12.1953 13.2805 12.248 12.983 12.2903C12.8404 12.3106 12.6977 12.3301 12.5551 12.3502C12.544 12.3518 12.5312 12.3533 12.5261 12.3642C12.5199 12.3773 12.5322 12.3849 12.5407 12.3907C12.5533 12.3994 12.5519 12.4118 12.5536 12.4238C12.5835 12.6315 12.6066 12.8401 12.6254 13.0491C12.6548 13.3732 12.6725 13.6982 12.6849 14.0235C12.7033 14.5065 12.7119 14.9898 12.7151 15.4731C12.7246 16.9008 12.7146 18.3285 12.7013 19.7562C12.7005 19.843 12.7234 19.8654 12.8099 19.8643C13.3122 19.8577 13.8144 19.851 14.3166 19.8445C14.4608 19.8427 14.6051 19.8425 14.7492 19.8401C14.8093 19.839 14.8562 19.8156 14.8503 19.7373C14.8354 19.5379 14.8286 19.3379 14.8183 19.1381C14.7958 18.7039 14.7768 18.2695 14.7675 17.8347C14.7636 17.6533 14.7584 17.472 14.757 17.2906C14.7536 16.8669 14.7523 16.4432 14.7495 16.0195C14.7494 16.0002 14.7561 15.9911 14.7739 15.9842C14.8422 15.9578 14.9098 15.9296 14.9776 15.9022C15.1269 15.8417 15.2801 15.8071 15.4429 15.8236C15.5828 15.8378 15.6907 15.8982 15.758 16.0244C15.7808 16.0673 15.7992 16.1119 15.8131 16.1584C15.8776 16.3731 15.8947 16.5948 15.9082 16.8166C15.9268 17.1242 15.9311 17.4323 15.9324 17.7405C15.9355 18.4203 15.9276 19.0999 15.9243 19.7795C15.9239 19.8622 15.9506 19.8888 16.0337 19.8885C16.3246 19.8872 16.6154 19.8751 16.9062 19.8683C17.0627 19.8648 17.2194 19.8624 17.376 19.8686C17.566 19.8762 17.7559 19.8886 17.9463 19.8885C18.0181 19.8885 18.0508 19.8533 18.0471 19.7821C18.0363 19.5699 18.0242 19.3578 18.0154 19.1456L18.0155 19.1452Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.5819 12.0263C26.5263 12.0185 26.4734 12.0356 26.4199 12.0441C26.106 12.0942 25.7924 12.146 25.4787 12.1969C25.1797 12.2454 24.8807 12.2943 24.5815 12.3417C24.4788 12.358 24.4368 12.4095 24.4464 12.5126C24.4634 12.6956 24.4804 12.8785 24.4957 13.0617C24.5199 13.3513 24.5425 13.641 24.5658 13.9306C24.592 14.255 24.612 14.5799 24.6305 14.9048C24.648 15.2124 24.6629 15.5201 24.6781 15.8278C24.7001 16.2757 24.7215 16.7237 24.7427 17.1716C24.7465 17.2537 24.7865 17.2932 24.8697 17.2919C25.1009 17.288 25.3321 17.2837 25.5633 17.2795C25.5633 17.2787 25.5633 17.278 25.5633 17.2773C25.6143 17.2773 25.6653 17.2779 25.7162 17.2771C25.9027 17.2743 26.0891 17.2714 26.2756 17.2679C26.3462 17.2666 26.3906 17.2246 26.3922 17.1594C26.3973 16.9544 26.4008 16.7495 26.4073 16.5446C26.4169 16.2466 26.4265 15.9485 26.4397 15.6506C26.4568 15.2622 26.4767 14.8739 26.4968 14.4856C26.5084 14.2611 26.5217 14.0366 26.5363 13.8123C26.5542 13.5383 26.573 13.2645 26.5939 12.9909C26.6108 12.7693 26.6314 12.5479 26.6503 12.3264C26.6561 12.2584 26.6642 12.1904 26.6665 12.1223C26.6685 12.0602 26.6428 12.035 26.5818 12.0263H26.5819Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.4919 18.9057C26.4919 18.6137 26.4919 18.3218 26.4919 18.0299C26.4919 17.9403 26.4612 17.9118 26.3705 17.9194C26.2975 17.9254 26.2247 17.9351 26.1516 17.94C25.7782 17.9645 25.4044 17.9768 25.0301 17.966C24.8897 17.9619 24.7495 17.9562 24.6096 17.943C24.5359 17.9361 24.4951 17.967 24.4952 18.0314C24.4955 18.1181 24.4952 18.2049 24.4976 18.2912C24.5032 18.4975 24.5038 18.7035 24.5011 18.9097C24.497 19.2127 24.4961 19.5158 24.4949 19.8189C24.4946 19.8842 24.5318 19.9181 24.5958 19.9141C24.7062 19.9073 24.8164 19.8991 24.9268 19.8924C25.262 19.872 25.5974 19.8684 25.9331 19.8767C26.0872 19.8805 26.2412 19.8842 26.3953 19.8887C26.4368 19.8898 26.4683 19.8752 26.4854 19.8366C26.4942 19.8169 26.4919 19.7951 26.4919 19.774C26.4919 19.4846 26.4919 19.1951 26.4919 18.9057Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.0937 19.025C11.4855 17.025 10.8773 15.0251 10.2691 13.0252C10.1821 12.7393 10.0953 12.4534 10.0081 12.1676C9.98122 12.0794 9.91359 12.0358 9.8238 12.0504C9.67676 12.0742 9.53009 12.1004 9.38306 12.1243C8.90394 12.2021 8.42461 12.2785 7.94699 12.3654C7.82354 12.3879 7.73502 12.4564 7.69531 12.5767C6.91092 14.9512 6.12729 17.3259 5.3435 19.7005C5.31081 19.7995 5.3579 19.8643 5.46262 19.8643C6.04324 19.8643 6.62394 19.8643 7.20456 19.8644C7.22829 19.8644 7.25195 19.8644 7.27449 19.8564C7.30174 19.8466 7.32181 19.8296 7.32838 19.7998C7.35854 19.663 7.38839 19.5261 7.41892 19.3893C7.51125 18.9753 7.60388 18.5614 7.69635 18.1474C7.70053 18.1286 7.70412 18.1157 7.73121 18.1161C8.36766 18.1253 9.00419 18.1335 9.64064 18.1405C9.66997 18.1408 9.68064 18.1496 9.68669 18.1774C9.80686 18.7262 9.92792 19.2748 10.0488 19.8235C10.0641 19.8924 10.09 19.9134 10.1615 19.9143C10.1751 19.9144 10.1888 19.9136 10.2024 19.9133C10.5342 19.9043 10.8661 19.8953 11.1245 19.8884C11.5398 19.8884 11.8818 19.8887 12.2237 19.8882C12.3056 19.888 12.3412 19.8388 12.3177 19.7615C12.2429 19.5159 12.1682 19.2705 12.0936 19.0249L12.0937 19.025ZM9.34051 16.644C8.94015 16.6432 8.53978 16.643 8.13934 16.6441C8.10501 16.6442 8.10538 16.634 8.11307 16.6064C8.29444 15.9554 8.46619 15.3017 8.63188 14.6465C8.67928 14.459 8.72377 14.2707 8.76974 14.0828C8.77146 14.0759 8.774 14.0692 8.77945 14.0523C8.90872 14.5827 9.02374 15.106 9.14302 15.6283C9.21751 15.9548 9.29297 16.281 9.36977 16.607C9.37723 16.6387 9.37104 16.6439 9.34059 16.6438L9.34051 16.644Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.5622 19.3106C23.5346 18.9127 23.5159 18.5144 23.5118 18.1155C23.5057 17.5339 23.5191 16.9525 23.5281 16.3711C23.532 16.1138 23.5269 15.8569 23.4822 15.6023C23.4169 15.2305 23.2362 14.9298 22.9335 14.7035C22.7102 14.5368 22.4547 14.4442 22.1857 14.385C21.7507 14.2894 21.3103 14.2844 20.8686 14.3134C20.5634 14.3334 20.2606 14.3744 19.9598 14.4294C19.6592 14.4843 19.3621 14.5539 19.0689 14.6394C18.9978 14.6602 18.9741 14.6907 18.9707 14.765C18.9668 14.8482 18.9644 14.9314 18.9609 15.0146C18.9519 15.2268 18.9426 15.439 18.9337 15.6513C18.9296 15.7494 18.9242 15.8475 18.9235 15.9455C18.9229 16.0341 18.9977 16.0735 19.0616 16.0485C19.2984 15.9556 19.536 15.8654 19.7794 15.7912C20.1426 15.6804 20.5126 15.6128 20.8941 15.6208C21.0202 15.6234 21.1447 15.6347 21.2631 15.6822C21.3808 15.7294 21.4547 15.8127 21.4726 15.9404C21.4802 15.9947 21.4756 16.0495 21.4748 16.1041C21.4744 16.134 21.464 16.1462 21.4328 16.1506C21.2987 16.1693 21.1648 16.1889 21.0315 16.2122C20.6274 16.283 20.2297 16.3784 19.8456 16.5249C19.5317 16.6446 19.2349 16.795 18.9744 17.01C18.6792 17.2537 18.4694 17.5539 18.3889 17.9322C18.3108 18.2999 18.3393 18.6635 18.4597 19.019C18.551 19.2885 18.7027 19.518 18.929 19.6944C19.1683 19.8809 19.4436 19.968 19.7436 19.9856C19.7437 19.9876 19.7439 19.9896 19.7442 19.9917H19.9531C19.9531 19.9895 19.9531 19.9874 19.9534 19.9853C20.0626 19.9767 20.1706 19.9602 20.2769 19.9341C20.715 19.8266 21.1138 19.633 21.4859 19.3815C21.504 19.3693 21.5218 19.3567 21.5446 19.341V19.3885C21.5446 19.5264 21.5444 19.6644 21.5447 19.8023C21.5448 19.8857 21.5747 19.9153 21.6569 19.9141C21.862 19.9112 22.0671 19.9079 22.2723 19.905C22.68 19.8993 23.0878 19.8939 23.4955 19.8881C23.5647 19.8872 23.5949 19.8553 23.5937 19.7863C23.5936 19.7788 23.5932 19.7713 23.5928 19.7639C23.5825 19.6127 23.5725 19.4616 23.5621 19.3104L23.5622 19.3106ZM21.496 17.8077C21.496 17.9742 21.4954 18.1406 21.4967 18.307C21.4969 18.3329 21.4882 18.3466 21.4662 18.3593C21.2648 18.476 21.0523 18.5529 20.8154 18.5375C20.534 18.5192 20.3311 18.3477 20.3015 18.0723C20.2698 17.7772 20.3936 17.5557 20.6849 17.4282C20.8328 17.3634 20.9893 17.3308 21.1482 17.3084C21.2514 17.2939 21.3553 17.2842 21.4588 17.2708C21.4875 17.2671 21.497 17.2737 21.4967 17.3047C21.4952 17.4724 21.496 17.6401 21.496 17.8077Z",
        fill: "white"
    }));
};


const $f55ccfed6e002ce8$export$ad976bfe08240460 = {
    displayName: 'Aha',
    id: 'aha',
    resourceType: 'aha-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $38d5eef3851b2cfa$export$f28fe6c5ebff8c30), 'Aha', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $7e71d35b557ef27f$export$7dd76757b7d2d978), 'Aha', 'large'),
    integrationAri: 'ari:cloud:platform::integration/aha',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $b6fac48c247386ba$export$88b64eee273831fd = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.375",
        y: "0.375",
        width: "23.25",
        height: "23.25",
        rx: "5.625",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
        fill: "#FFBF00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
        fill: "#26B5F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
        fill: "#ED3049"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
        fill: "black",
        fillOpacity: "0.25"
    }));
};





const $c40804a00e4b92d9$export$826c628c1cea041a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "31",
        height: "31",
        rx: "7.5",
        stroke: "#0B1228",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.8596 6.89182L6.90601 10.1829C6.46371 10.366 6.46829 10.9942 6.91336 11.1706L14.9003 14.3379C15.6021 14.6162 16.3836 14.6162 17.0853 14.3379L25.0723 11.1706C25.5172 10.9942 25.5219 10.366 25.0795 10.1829L17.126 6.89182C16.4003 6.59156 15.5852 6.59156 14.8596 6.89182Z",
        fill: "#FFBF00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.7012 16.0675V23.9798C16.7012 24.3561 17.0807 24.6138 17.4305 24.4751L26.3303 21.0206C26.5335 20.9401 26.6667 20.7437 26.6667 20.5252V12.613C26.6667 12.2366 26.2873 11.9789 25.9375 12.1176L17.0376 15.5721C16.8345 15.6527 16.7012 15.849 16.7012 16.0675Z",
        fill: "#26B5F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.6231 16.4758L11.9818 17.7511L11.7136 17.8807L6.13804 20.5522C5.7846 20.7227 5.3335 20.4652 5.3335 20.0725V12.6462C5.3335 12.5042 5.40633 12.3816 5.504 12.2892C5.54476 12.2483 5.59094 12.2147 5.63894 12.188C5.77218 12.1081 5.96222 12.0867 6.12381 12.1506L14.5787 15.5006C15.0085 15.6711 15.0422 16.2733 14.6231 16.4758Z",
        fill: "#ED3049"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.623 16.4758L11.9817 17.7511L5.50391 12.2892C5.54466 12.2483 5.59085 12.2147 5.63884 12.188C5.77209 12.1081 5.96213 12.0867 6.12371 12.1506L14.5786 15.5006C15.0084 15.6711 15.0421 16.2733 14.623 16.4758Z",
        fill: "black",
        fillOpacity: "0.25"
    }));
};


const $a840f57b79db2ae9$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: 'airtable-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $b6fac48c247386ba$export$88b64eee273831fd), 'Airtable', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $c40804a00e4b92d9$export$826c628c1cea041a), 'Airtable', 'large'),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $e2057eb553a6eabc$export$5e013c7991ef7bd0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#007FD2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.0516 7.60124C11.0073 7.54277 10.9568 7.51208 10.9007 7.51208C10.8545 7.51208 10.8122 7.53281 10.7851 7.55016C10.3591 7.88478 9.77609 9.30229 9.29834 11.1701L9.72131 11.1749C10.5565 11.1844 11.419 11.1942 12.2715 11.2073C12.0468 10.3518 11.8344 9.61843 11.6397 9.02646C11.3552 8.16124 11.1629 7.77393 11.0516 7.60124Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12.0001C20 16.4183 16.4183 20.0001 12 20.0001C7.58169 20.0001 4 16.4183 4 12.0001C4 7.58181 7.58169 4.00012 12 4.00012C16.4183 4.00012 20 7.58181 20 12.0001ZM17.9088 11.8171C17.9088 11.6117 17.764 11.4404 17.569 11.4014C17.5679 11.4012 17.5667 11.4009 17.5655 11.4006C17.5632 11.4003 17.561 11.3995 17.5587 11.3992L17.5508 11.3984C17.5301 11.395 17.5091 11.3929 17.4876 11.3926L17.4315 11.3873C16.0916 11.2914 14.7131 11.2536 13.4199 11.2278L13.4173 11.2183C12.788 8.85747 12.0018 6.44382 10.9417 6.44382C9.9539 6.44831 9.06345 8.03418 8.29446 11.1584C7.75116 11.1514 7.2559 11.1439 6.78892 11.1359C6.76241 11.1354 6.73863 11.1352 6.71743 11.1352C6.61783 11.1352 6.56916 11.1394 6.54506 11.1426C6.28209 11.1892 6.09124 11.4186 6.09124 11.6883C6.09124 11.9633 6.29655 12.1992 6.56402 12.2377L6.56948 12.2433H8.04257C7.90586 12.8684 7.78602 13.4865 7.68594 14.0821L7.64209 14.3442L7.64161 14.3567C7.64257 14.559 7.80787 14.7235 8.00996 14.7235C8.13815 14.7235 8.2543 14.6567 8.32064 14.5526L8.33108 14.5609L9.05526 12.2433H12.5435C12.81 13.2502 13.0864 14.2899 13.4517 15.2657C13.6471 15.7874 14.1044 17.0094 14.8688 17.0155H14.8774C16.0604 17.0155 16.5214 15.1047 16.8268 13.8398C16.8924 13.5677 16.9491 13.3327 17.0026 13.16L17.0239 13.0886H17.0238C17.0289 13.0719 17.0316 13.0543 17.0316 13.0358C17.0316 12.9346 16.9496 12.8525 16.8484 12.8525C16.7698 12.8525 16.703 12.9018 16.6768 12.9712L16.6765 12.971L16.6508 13.0421C16.5504 13.32 16.4575 13.5828 16.3753 13.8157L16.369 13.8332C15.857 15.2833 15.6233 15.9452 15.1655 15.9453L15.1542 15.9452L15.1478 15.9461L15.1364 15.9458C14.5504 15.9458 13.9986 13.5635 13.7908 12.6668C13.7549 12.5114 13.7219 12.3688 13.6916 12.2433H17.481C17.5521 12.2433 17.6191 12.2255 17.6779 12.1947C17.6784 12.1945 17.6787 12.1943 17.679 12.1942C17.685 12.1911 17.6906 12.1876 17.6964 12.1842C17.7028 12.1805 17.7091 12.1768 17.7152 12.1728C17.7182 12.1709 17.7211 12.1688 17.724 12.1667C17.7332 12.1604 17.742 12.1539 17.7507 12.1468C17.7513 12.1463 17.7518 12.1458 17.7524 12.1453C17.8479 12.0671 17.9088 11.9486 17.9088 11.8171Z",
        fill: "white"
    }));
};





const $5b4da4c9c9d719ab$export$49b3130ea0e9d6dd = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#007FD2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.7351 10.135C14.676 10.057 14.6088 10.0161 14.534 10.0161C14.4723 10.0161 14.416 10.0437 14.3798 10.0669C13.8118 10.513 13.0345 12.403 12.3975 14.8934L12.9614 14.8999C14.075 14.9125 15.225 14.9256 16.3617 14.9431C16.062 13.8024 15.7789 12.8246 15.5193 12.0353C15.14 10.8817 14.8836 10.3652 14.7351 10.135Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.6666 16.0002C26.6666 21.891 21.891 26.6668 15.9999 26.6668C10.1088 26.6668 5.33325 21.891 5.33325 16.0002C5.33325 10.1091 10.1088 5.3335 15.9999 5.3335C21.891 5.3335 26.6666 10.1091 26.6666 16.0002ZM23.8783 15.7562C23.8783 15.4823 23.6853 15.2539 23.4252 15.2019C23.4237 15.2017 23.4222 15.2012 23.4205 15.2008C23.4175 15.2004 23.4145 15.1993 23.4115 15.1989L23.401 15.1978C23.3734 15.1933 23.3454 15.1905 23.3167 15.1901L23.2419 15.183C21.4553 15.0552 19.6174 15.0048 17.8931 14.9703L17.8897 14.9577C17.0505 11.81 16.0023 8.59176 14.5888 8.59176C13.2718 8.59775 12.0845 10.7122 11.0592 14.8778C10.3348 14.8686 9.67446 14.8585 9.05181 14.8478C9.01646 14.8472 8.98476 14.847 8.95649 14.847C8.82369 14.847 8.75879 14.8525 8.72667 14.8568C8.37604 14.9189 8.12158 15.2248 8.12158 15.5844C8.12158 15.9511 8.39531 16.2655 8.75194 16.317L8.75922 16.3244H10.7233C10.5411 17.1579 10.3813 17.9821 10.2478 18.7761L10.1894 19.1256L10.1887 19.1423C10.19 19.412 10.4104 19.6313 10.6799 19.6313C10.8508 19.6313 11.0056 19.5422 11.0941 19.4034L11.108 19.4146L12.0736 16.3244H16.7245C17.0799 17.667 17.4485 19.0532 17.9356 20.3542C18.196 21.0499 18.8058 22.6793 19.8249 22.6874H19.8365C21.4138 22.6874 22.0285 20.1396 22.4357 18.4531C22.5231 18.0902 22.5987 17.7769 22.67 17.5466L22.6985 17.4515H22.6983C22.7051 17.4292 22.7088 17.4057 22.7088 17.381C22.7088 17.2461 22.5993 17.1367 22.4644 17.1367C22.3597 17.1367 22.2705 17.2024 22.2356 17.2949L22.2352 17.2947L22.2009 17.3894C22.0671 17.7599 21.9433 18.1104 21.8336 18.4209L21.8252 18.4443C21.1426 20.3778 20.831 21.2602 20.2205 21.2605L20.2055 21.2602L20.197 21.2615L20.1818 21.2611C19.4004 21.2611 18.6647 18.0847 18.3877 16.8891C18.3397 16.6819 18.2958 16.4917 18.2553 16.3244H23.3079C23.4028 16.3244 23.4921 16.3007 23.5705 16.2595C23.5711 16.2593 23.5715 16.2591 23.572 16.2589C23.5799 16.2548 23.5874 16.2501 23.5951 16.2456C23.6037 16.2407 23.612 16.2358 23.6202 16.2304C23.6242 16.2278 23.6281 16.2251 23.6319 16.2223C23.6441 16.2139 23.6559 16.2051 23.6675 16.1957C23.6684 16.1951 23.669 16.1944 23.6699 16.1938C23.7971 16.0895 23.8783 15.9314 23.8783 15.7562Z",
        fill: "white"
    }));
};


const $0fca80b1ee670a5c$export$a0702b571a9392d4 = {
    displayName: 'Amplitude',
    id: 'amplitude',
    resourceType: 'smartlinks-connector-amplitude',
    icon: (0, $9yyKc.get3PLogo)((0, $e2057eb553a6eabc$export$5e013c7991ef7bd0), 'Amplitude', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5b4da4c9c9d719ab$export$49b3130ea0e9d6dd), 'Amplitude', 'large'),
    integrationAri: 'ari:cloud:platform::integration/amplitude',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $a16262d82ea80893$export$671541d0c7918cd9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#F06A6A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9553 12.3807C14.2737 12.3807 12.9105 13.7439 12.9105 15.4256C12.9105 17.1072 14.2737 18.4704 15.9553 18.4704C17.6369 18.4704 19 17.1072 19 15.4256C19 13.7439 17.6369 12.3807 15.9553 12.3807ZM8.04475 12.381C6.3632 12.381 5 13.7439 5 15.4256C5 17.1072 6.3632 18.4704 8.04475 18.4704C9.72637 18.4704 11.0896 17.1072 11.0896 15.4256C11.0896 13.7439 9.72637 12.381 8.04475 12.381ZM15.0447 8.57471C15.0447 10.2564 13.6816 11.6197 12 11.6197C10.3184 11.6197 8.95526 10.2564 8.95526 8.57471C8.95526 6.89309 10.3184 5.52979 12 5.52979C13.6816 5.52979 15.0447 6.89309 15.0447 8.57471Z",
        fill: "white"
    }));
};





const $c5f2f99b79d37b38$export$c3fa6bf9156b56f9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#F06A6A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.2735 16.5076C19.0314 16.5076 17.2139 18.3252 17.2139 20.5674C17.2139 22.8095 19.0314 24.6271 21.2735 24.6271C23.5156 24.6271 25.3332 22.8095 25.3332 20.5674C25.3332 18.3252 23.5156 16.5076 21.2735 16.5076ZM10.7262 16.5079C8.4841 16.5079 6.6665 18.3252 6.6665 20.5674C6.6665 22.8095 8.4841 24.6271 10.7262 24.6271C12.9683 24.6271 14.786 22.8095 14.786 20.5674C14.786 18.3252 12.9683 16.5079 10.7262 16.5079ZM20.0594 11.4329C20.0594 13.6751 18.2419 15.4929 15.9999 15.4929C13.7577 15.4929 11.94 13.6751 11.94 11.4329C11.94 9.19071 13.7577 7.37305 15.9999 7.37305C18.2419 7.37305 20.0594 9.19071 20.0594 11.4329Z",
        fill: "white"
    }));
};


const $52e926522dd1141c$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $9yyKc.get3PLogo)((0, $a16262d82ea80893$export$671541d0c7918cd9), 'Asana', 'medium'),
    resourceType: 'asana-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $c5f2f99b79d37b38$export$c3fa6bf9156b56f9), 'Asana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: [
                    ...(0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Task
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};



var $9zZIW = parcelRequire("9zZIW");













const $a9e2eec98c2c075b$export$abf71a44e930800c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture-BG/64/Storage",
        fill: "#7AA116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
        transform: "scale(0.3) translate(12.999900, 11.999600)",
        fill: "#FFFFFF",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
        id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
    }))));





const $4a9fa78211195885$export$30c777236008d219 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture-BG/64/Storage",
        fill: "#7AA116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "24",
        height: "25"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
        transform: "translate(12.999900, 11.999600)",
        fill: "#FFFFFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
        id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
    }))));


const $7c234a4c5938682d$export$7a257877f5f8c5de = {
    displayName: 'Amazon Web Services S3',
    id: 'aws-s3',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $a9e2eec98c2c075b$export$abf71a44e930800c), 'Amazon Web Services S3'),
    resourceType: 'aws-s3-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $4a9fa78211195885$export$30c777236008d219), 'Amazon Web Services S3', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    // Keeping this disabled for team demo. We only need GitBook enabled for demo.
    isEnabled: ()=>false
};



var $7YJRT = parcelRequire("7YJRT");













const $fefeace148d8b1a3$export$2dcf704e717ca168 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5 7.30929V16.4293L15.75 19.5L9.9375 17.3839V19.4818L6.64714 15.1821L16.2375 15.9321V7.71964L19.5 7.30929ZM16.3029 7.76786L10.9221 4.5V6.64393L5.98071 8.09571L4.5 9.99643V14.3132L6.61929 15.2486V9.71679L16.3029 7.76786Z",
        fill: "white"
    }));
};





const $a4759d010fe75e4b$export$a64bb17da4dc2efb = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26 9.74571V21.9057L21 26L13.25 23.1786V25.9757L8.86286 20.2429L21.65 21.2429V10.2929L26 9.74571ZM21.7371 10.3571L14.5629 6V8.85857L7.97429 10.7943L6 13.3286V19.0843L8.82571 20.3314V12.9557L21.7371 10.3571Z",
        fill: "white"
    }));
};


const $952a8dcaa64c7f0f$export$f324080d91cfb196 = {
    displayName: 'Azure DevOps',
    id: 'azure-devops',
    resourceType: 'azure-devops-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $fefeace148d8b1a3$export$2dcf704e717ca168), 'AzureDevOps', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $a4759d010fe75e4b$export$a64bb17da4dc2efb), 'AzureDevOps', 'large'),
    integrationAri: 'ari:cloud:platform::integration/azure-devops',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $0fb7bd9c7158811f$export$adedf1569d7107de = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#0071F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.8589 15.3516C20.0587 15.6312 20.0187 15.9907 19.779 16.1905C19.4994 16.3902 19.0999 16.3502 18.9002 16.1106L17.5021 14.313L16.1439 16.0706C15.9441 16.3502 15.5447 16.3502 15.265 16.1505C14.9854 15.9508 14.9455 15.5913 15.1452 15.3116L16.7431 13.2344L15.1452 11.1571C14.9455 10.8775 15.0254 10.478 15.265 10.2783C15.5447 10.0786 15.9441 10.1585 16.1439 10.3982L17.5021 12.1958L18.9002 10.478C19.0999 10.1984 19.4595 10.1585 19.779 10.3582C20.0587 10.5579 20.0587 10.9574 19.8589 11.237L18.301 13.2743L19.8589 15.3516ZM12.5886 15.1119C11.55 15.1119 10.7111 14.313 10.7111 13.2743C10.7111 12.2757 11.55 11.4368 12.5886 11.4368C13.6272 11.4368 14.4661 12.2757 14.4661 13.2743C14.4261 14.313 13.5873 15.1119 12.5886 15.1119ZM7.07591 15.1119C6.03729 15.1119 5.19841 14.313 5.19841 13.2743C5.19841 12.2757 6.03729 11.4368 7.07591 11.4368C8.11453 11.4368 8.95342 12.2757 8.95342 13.2743C8.95342 14.313 8.11453 15.1119 7.07591 15.1119ZM12.5886 10.2384C11.4301 10.2384 10.3915 10.8775 9.8722 11.8362C9.35289 10.8775 8.31427 10.2384 7.11586 10.2384C6.39682 10.2384 5.75766 10.478 5.23835 10.8376V8.28097C5.23835 7.96139 4.95873 7.68176 4.63915 7.68176C4.27963 7.68176 4 7.96139 4 8.28097V13.3143C4.03995 14.9921 5.39814 16.3103 7.07591 16.3103C8.27432 16.3103 9.31294 15.6312 9.83225 14.6725C10.3516 15.6312 11.3902 16.3103 12.5486 16.3103C14.2664 16.3103 15.6645 14.9521 15.6645 13.2344C15.7045 11.5966 14.3063 10.2384 12.5886 10.2384Z",
        fill: "white"
    }));
};





const $fdcbf77c9a3758b4$export$f9ea3a56c013af54 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#0071F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.4785 20.4687C26.7448 20.8416 26.6915 21.3209 26.372 21.5872C25.9991 21.8535 25.4665 21.8003 25.2002 21.4807L23.336 19.0839L21.5251 21.4275C21.2588 21.8003 20.7261 21.8003 20.3533 21.534C19.9805 21.2677 19.9272 20.7883 20.1935 20.4155L22.324 17.6458L20.1935 14.8762C19.9272 14.5033 20.0337 13.9707 20.3533 13.7044C20.7261 13.4381 21.2588 13.5446 21.5251 13.8642L23.336 16.261L25.2002 13.9707C25.4665 13.5979 25.9459 13.5446 26.372 13.8109C26.7448 14.0772 26.7448 14.6098 26.4785 14.9827L24.4013 17.6991L26.4785 20.4687ZM16.7847 20.1491C15.3999 20.1491 14.2814 19.0839 14.2814 17.6991C14.2814 16.3675 15.3999 15.249 16.7847 15.249C18.1695 15.249 19.288 16.3675 19.288 17.6991C19.2348 19.0839 18.1163 20.1491 16.7847 20.1491ZM9.43447 20.1491C8.04964 20.1491 6.93113 19.0839 6.93113 17.6991C6.93113 16.3675 8.04964 15.249 9.43447 15.249C10.8193 15.249 11.9378 16.3675 11.9378 17.6991C11.9378 19.0839 10.8193 20.1491 9.43447 20.1491ZM16.7847 13.6511C15.2401 13.6511 13.8553 14.5033 13.1629 15.7816C12.4704 14.5033 11.0856 13.6511 9.48773 13.6511C8.52901 13.6511 7.67681 13.9707 6.98439 14.4501V11.0412C6.98439 10.6151 6.61155 10.2423 6.18545 10.2423C5.70609 10.2423 5.33325 10.6151 5.33325 11.0412V17.7523C5.38651 19.9894 7.19744 21.747 9.43447 21.747C11.0323 21.747 12.4172 20.8416 13.1096 19.5633C13.802 20.8416 15.1868 21.747 16.7314 21.747C19.0217 21.747 20.8859 19.9361 20.8859 17.6458C20.9392 15.462 19.075 13.6511 16.7847 13.6511Z",
        fill: "white"
    }));
};


const $f9ec6128a54edafb$export$3e7603f097ea326e = {
    displayName: 'Box',
    id: 'box',
    resourceType: 'box-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $0fb7bd9c7158811f$export$adedf1569d7107de), 'Box', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $fdcbf77c9a3758b4$export$f9ea3a56c013af54), 'Box', 'large'),
    integrationAri: 'ari:cloud:platform::integration/box',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document,
                    (0, $2Znam.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $e8b95f2997ae5497$export$3ad1ba1bf426d64a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_1737_5849)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#00C4CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_1737_5849"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "white"
    }))));
};





const $467a7e6b5107a82f$export$ac6bbd7ba99716e3 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_1737_5841)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#00C4CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.6962 18.8754C22.5778 18.8754 22.4735 18.9755 22.365 19.1939C21.1399 21.6781 19.024 23.4358 16.5754 23.4358C13.7441 23.4358 11.9908 20.88 11.9908 17.3492C11.9908 11.3683 15.3232 7.91022 18.2502 7.91022C19.6179 7.91022 20.4532 8.76974 20.4532 10.1375C20.4532 11.7609 19.5309 12.6204 19.5309 13.193C19.5309 13.45 19.6908 13.6056 20.0078 13.6056C21.2814 13.6056 22.7762 12.1421 22.7762 10.0747C22.7762 8.07013 21.0315 6.59668 18.1046 6.59668C13.2673 6.59668 8.96826 11.0813 8.96826 17.2863C8.96826 22.0894 11.711 25.2633 15.9429 25.2633C20.4346 25.2633 23.0318 20.7944 23.0318 19.3438C23.0318 19.0226 22.8676 18.8754 22.6962 18.8754Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_1737_5841"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }))));
};


const $77752e716bcbf673$export$75e56657ffc0207b = {
    displayName: 'Canva',
    id: 'canva',
    resourceType: 'canva-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $e8b95f2997ae5497$export$3ad1ba1bf426d64a), 'Canva', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $467a7e6b5107a82f$export$ac6bbd7ba99716e3), 'Canva', 'large'),
    integrationAri: 'ari:cloud:platform::integration/canva',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $ed645382243aaf78$export$592b235c95c5fb2b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.48145 15.6486L7.88428 13.6389C9.16896 15.4425 10.525 16.2927 12.0238 16.2927C13.5226 16.2927 14.8549 15.4682 16.0682 13.6647L18.5186 15.6228C16.7581 18.1993 14.5694 19.5649 12.0238 19.5649C9.50203 19.5649 7.28952 18.1993 5.48145 15.6486Z",
        fill: "#6686FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 7.58303L7.53864 11.2685L5.48145 8.9621L12.0248 3.5647L18.5186 8.9621L16.4366 11.2447L12 7.58303Z",
        fill: "#FF6479"
    }));
};





const $db239286d3d3730a$export$d29fdfa1300ec8ae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 12.0837L3.90283 10.074C5.18752 11.8776 6.54357 12.7278 8.04237 12.7278C9.54117 12.7278 10.8734 11.9034 12.0867 10.0998L14.5372 12.058C12.7767 14.6345 10.5879 16 8.04237 16C5.52059 16 3.30807 14.6345 1.5 12.0837Z",
        fill: "#6686FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.01858 4.01833L3.5572 7.70378L1.5 5.3974L8.04337 0L14.5372 5.3974L12.4552 7.68L8.01858 4.01833Z",
        fill: "#FF6479"
    }));





const $32ca20b134ccb661$export$7ca2508a62493599 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.30859 20.8905L10.5124 18.2109C12.2253 20.6157 14.0334 21.7494 16.0318 21.7494C18.0302 21.7494 19.8065 20.65 21.4243 18.2453L24.6915 20.8562C22.3442 24.2915 19.4259 26.1123 16.0318 26.1123C12.6694 26.1123 9.71936 24.2915 7.30859 20.8905Z",
        fill: "#6686FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 10.1366L10.0515 15.0505L7.30859 11.9753L16.0331 4.77881L24.6915 11.9753L21.9155 15.0188L16 10.1366Z",
        fill: "#FF6479"
    }));
};


const $c046599e1123811b$export$7ef79ba9bf00ce19 = {
    displayName: 'ClickUp',
    id: 'clickup',
    resourceType: 'smartlinks-connector-clickup',
    icon: (0, $9yyKc.get3PLogo)((0, $ed645382243aaf78$export$592b235c95c5fb2b), 'ClickUp', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $db239286d3d3730a$export$d29fdfa1300ec8ae), 'ClickUp', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $32ca20b134ccb661$export$7ca2508a62493599), 'ClickUp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/clickup',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};



var $lAFHW = parcelRequire("lAFHW");


var $3ZVQ6 = parcelRequire("3ZVQ6");





var $k8y62 = parcelRequire("k8y62");







const $85a80012baeabd4e$export$3dab4b73b27a9d7e = {
    displayName: 'Confluence Data Center',
    id: 'confluence-dc',
    resourceType: 'confluence-dc-connector',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'Confluence Data Center'),
    searchResultIcon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/confluence-dc',
    typeFilterConfig: (()=>{
        const typeFilter = new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                {
                    entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                    subTypes3P: [
                        (0, $2Znam.NounSubtypeKey).Space
                    ]
                }
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Page,
                {
                    entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $2Znam.NounSubtypeKey).Page
                    ]
                }
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Blogpost,
                {
                    entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $2Znam.NounSubtypeKey).Blogpost
                    ]
                }
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Comment,
                {
                    entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                    subTypes3P: []
                }
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Attachment,
                {
                    entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $2Znam.NounSubtypeKey).Archive,
                        (0, $2Znam.NounSubtypeKey).Audio,
                        (0, $2Znam.NounSubtypeKey).Code,
                        (0, $2Znam.NounSubtypeKey).Document,
                        (0, $2Znam.NounSubtypeKey).Image,
                        (0, $2Znam.NounSubtypeKey).Pdf,
                        (0, $2Znam.NounSubtypeKey).Presentation,
                        (0, $2Znam.NounSubtypeKey).Spreadsheet,
                        (0, $2Znam.NounSubtypeKey).Video,
                        (0, $2Znam.NounSubtypeKey).WebPage,
                        (0, $2Znam.NounSubtypeKey).Other
                    ]
                }
            ]
        ]);
        return typeFilter;
    })(),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'createdBy',
        'content',
        'space',
        'label'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};



var $aIjYQ = parcelRequire("aIjYQ");


var $hLHb5 = parcelRequire("hLHb5");










const $65e84b7b6d408f68$export$d86876f5e6aac5e0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6.41265C0 2.88041 2.86345 0.0169678 6.39569 0.0169678H17.6043C21.1366 0.0169678 24 2.88041 24 6.41265V17.6213C24 21.1535 21.1366 24.017 17.6043 24.017H6.39569C2.86345 24.017 0 21.1535 0 17.6213V6.41265Z",
        fill: "#FF3621"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.156 15.3084V12.9538L17.9015 12.7947L11.7922 16.1357L6.00105 12.9538V11.5855L11.7922 14.7357L18.1879 11.2673V8.94453L17.9333 8.78544L11.7922 12.1583L6.22379 9.10363L11.7922 6.04897L16.2787 8.49906L16.6287 8.30815V8.05359L11.7922 5.41259L5.39648 8.8809V9.23091L11.7922 12.731L17.5833 9.5491V10.9492L11.7922 14.1311L5.65104 10.7582L5.39648 10.9173V13.272L11.7922 16.7403L17.5833 13.5902V14.9584L11.7922 18.1403L5.65104 14.7993L5.39648 14.9584V15.3084L11.7922 18.7767L18.156 15.3084Z",
        fill: "white"
    }));
};





const $94cf102d60d39e02$export$efd3770b613bb37b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.870117 8.24377C0.870117 3.8255 4.45184 0.243774 8.87012 0.243774H24.8701C29.2884 0.243774 32.8701 3.8255 32.8701 8.24377V24.2438C32.8701 28.6621 29.2884 32.2438 24.8701 32.2438H8.87012C4.45184 32.2438 0.870117 28.6621 0.870117 24.2438V8.24377Z",
        fill: "#FF3621"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M25.8263 21.1692V17.8557L25.4681 17.6319L16.8711 22.3334L8.72184 17.8557V15.9304L16.8711 20.3632L25.8711 15.4826V12.2139L25.5129 11.9901L16.8711 16.7363L9.03527 12.4378L16.8711 8.13932L23.1845 11.5871L23.6771 11.3184V10.9602L16.8711 7.2438L7.87109 12.1244V12.6169L16.8711 17.5423L25.0203 13.0647V15.0348L16.8711 19.5125L8.2293 14.7662L7.87109 14.9901V18.3035L16.8711 23.1841L25.0203 18.7513V20.6766L16.8711 25.1542L8.2293 20.4528L7.87109 20.6766V21.1692L16.8711 26.0498L25.8263 21.1692Z",
        fill: "white"
    }));
};


const $900640e2493d0e9d$export$a9b5a82aefd10fde = {
    displayName: 'Databricks',
    id: 'databricks',
    resourceType: 'databricks-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $65e84b7b6d408f68$export$d86876f5e6aac5e0), 'Databricks', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $94cf102d60d39e02$export$efd3770b613bb37b), 'Databricks', 'large'),
    integrationAri: 'ari:cloud:platform::integration/databricks',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $67c131926920b640$export$393452da0e179bab = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "31",
        height: "31",
        rx: "7.5",
        stroke: "#0B1228",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
        fill: "#4C00FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
        fill: "#FF5252"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
        fill: "black"
    }));
};





const $11083adc7abc003f$export$db2f9bd1f316d475 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.5227 11.4761V15.5511C11.5227 15.7652 11.3493 15.9381 11.1345 15.9381H0.388221C0.173459 15.9381 0 15.7652 0 15.5511V4.84901C0 4.63492 0.173459 4.46204 0.388221 4.46204H4.46867V11.0892C4.46867 11.3032 4.64213 11.4761 4.85689 11.4761H11.5227Z",
        fill: "#4C00FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.9998 5.72983C15.9998 9.15447 13.9926 11.4678 11.5228 11.476V7.16226C11.5228 7.03879 11.4732 6.91523 11.3824 6.83297L9.13569 4.59374C9.04482 4.50321 8.92921 4.4538 8.80524 4.4538H4.47705V0.386951C4.47705 0.172901 4.65051 2.19893e-05 4.86526 2.19893e-05H10.9199C13.7943 -0.00821231 15.9998 2.29687 15.9998 5.72983Z",
        fill: "#FF5252"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.3824 6.82451C11.4732 6.91513 11.5228 7.03033 11.5228 7.15388V11.4677H4.86526C4.65051 11.4677 4.47705 11.2948 4.47705 11.0807V4.45361H8.80524C8.92921 4.45361 9.0531 4.50302 9.13569 4.59355L11.3824 6.82451Z",
        fill: "black"
    }));





const $578524381ae0907d$export$4cdd065eb81c5a09 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "31",
        height: "31",
        rx: "7.5",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "31",
        height: "31",
        rx: "7.5",
        stroke: "#0B1228",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
        fill: "#4C00FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
        fill: "#FF5252"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
        fill: "black"
    }));
};


const $8939dbaf0b2ff159$export$cee55280cabc1aa1 = {
    displayName: 'Docusign',
    id: 'docusign',
    resourceType: 'docusign-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $67c131926920b640$export$393452da0e179bab), 'Docusign', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $11083adc7abc003f$export$db2f9bd1f316d475), 'Docusign', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $578524381ae0907d$export$4cdd065eb81c5a09), 'Docusign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/docusign',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $bb144df551d9e565$export$e67ec9178da81ba8 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.77446 13.8484C5.74119 13.8676 5.74119 13.9156 5.77446 13.9349L8.90847 15.7448C8.93934 15.7626 8.95836 15.7956 8.95836 15.8312V19.4501C8.95836 19.4885 8.99997 19.5125 9.03327 19.4933L12.1673 17.6834C12.1981 17.6656 12.2172 17.6326 12.2172 17.597V13.9492C12.2172 13.9136 12.1981 13.8806 12.1672 13.8628L8.95836 12.0106L5.77446 13.8484Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.77446 6.32257C5.74119 6.3418 5.74119 6.38983 5.77446 6.40903L8.90847 8.21896C8.93934 8.23681 8.95836 8.26975 8.95836 8.30542V12.0108L12.2172 10.1288V6.42346C12.2172 6.38779 12.1981 6.35482 12.1672 6.33697L9.00828 4.51363C8.97741 4.49578 8.93934 4.49578 8.90847 4.51363L5.77446 6.32257Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.2173 10.1281L15.4261 11.9813C15.457 11.9991 15.4761 12.0321 15.4761 12.0678V15.6866C15.4761 15.7251 15.5177 15.7491 15.5509 15.7299L18.6849 13.9199C18.7158 13.9021 18.7348 13.8691 18.7348 13.8335V10.1858C18.7348 10.1501 18.7158 10.1171 18.6849 10.0993L15.526 8.27594C15.4951 8.25812 15.457 8.25812 15.4261 8.27594L12.2173 10.1281Z",
        fill: "white"
    }));
};





const $df42b92f5da11926$export$ba101884e6c20332 = ()=>{
    return(// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, "\\", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.69929 18.4645C7.65493 18.4901 7.65493 18.5542 7.69929 18.5798L11.878 20.993C11.9191 21.0168 11.9445 21.0608 11.9445 21.1083V25.9335C11.9445 25.9847 12 26.0167 12.0444 25.9911L16.223 23.5779C16.2642 23.5541 16.2896 23.5102 16.2896 23.4626V18.599C16.2896 18.5514 16.2642 18.5075 16.223 18.4837L11.9445 16.0142L7.69929 18.4645Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.69929 8.43014C7.65493 8.45578 7.65493 8.51982 7.69929 8.54542L11.878 10.9587C11.9191 10.9825 11.9445 11.0264 11.9445 11.0739V16.0144L16.2896 13.5051V8.56466C16.2896 8.5171 16.2642 8.47314 16.223 8.44934L12.011 6.01822C11.9699 5.99442 11.9191 5.99442 11.878 6.01822L7.69929 8.43014Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.2896 13.5041L20.568 15.975C20.6092 15.9988 20.6346 16.0427 20.6346 16.0903V20.9155C20.6346 20.9667 20.6901 20.9987 20.7344 20.9731L24.9131 18.5599C24.9543 18.5361 24.9796 18.4921 24.9796 18.4446V13.581C24.9796 13.5334 24.9543 13.4895 24.9131 13.4657L20.7012 11.0345C20.66 11.0108 20.6092 11.0108 20.568 11.0345L16.2896 13.5041Z",
        fill: "white"
    })));
};


const $b03eb7cb3646ea18$export$74bb7abed969b4a3 = {
    displayName: 'Dovetail',
    id: 'dovetail',
    resourceType: 'smartlinks-connector-dovetail',
    icon: (0, $9yyKc.get3PLogo)((0, $bb144df551d9e565$export$e67ec9178da81ba8), 'Dovetail', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $df42b92f5da11926$export$ba101884e6c20332), 'Dovetail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dovetail',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $d7ac9c127b9053c9$export$5e2362bb78414664 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#0061FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.0098 8.48964L8.24219 10.8931L12.0098 13.2965L8.24219 15.7L4.47461 13.2836L8.24219 10.8801L4.47461 8.48964L8.24219 6.08618L12.0098 8.48964ZM8.2227 16.473L11.9903 14.0695L15.7579 16.473L11.9903 18.8765L8.2227 16.473ZM12.0098 13.2836L15.7773 10.8801L12.0098 8.48964L15.7579 6.08618L19.5254 8.48964L15.7579 10.8931L19.5254 13.2965L15.7579 15.7L12.0098 13.2836Z",
        fill: "white"
    }));
};





const $0ba946ccc5d1e455$export$197780c70679b508 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#0061FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.0129 10.9983L10.9891 14.2031L16.0129 17.4079L10.9891 20.6128L5.96533 17.3906L10.9891 14.1858L5.96533 10.9983L10.9891 7.79346L16.0129 10.9983ZM10.9631 21.6435L15.9869 18.4387L21.0107 21.6435L15.9869 24.8483L10.9631 21.6435ZM16.0129 17.3906L21.0367 14.1858L16.0129 10.9983L21.0107 7.79346L26.0345 10.9983L21.0107 14.2031L26.0345 17.4079L21.0107 20.6128L16.0129 17.3906Z",
        fill: "white"
    }));
};


const $736ae5964b52ab76$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: 'dropbox-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $d7ac9c127b9053c9$export$5e2362bb78414664), 'Dropbox', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $0ba946ccc5d1e455$export$197780c70679b508), 'Dropbox', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document,
                    (0, $2Znam.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};



var $iUN2Z = parcelRequire("iUN2Z");













const $b0408f51f36c91ad$export$54e0f4982aa79afe = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12 12C12 11.337 12.254 10.7011 12.7061 10.2322C13.1582 9.76339 13.7714 9.5 14.4107 9.5C15.0501 9.5 15.6633 9.76339 16.1153 10.2322C16.5674 10.7011 16.8214 11.337 16.8214 12C16.8214 12.663 16.5674 13.2989 16.1153 13.7678C15.6633 14.2366 15.0501 14.5 14.4107 14.5C13.7714 14.5 13.1582 14.2366 12.7061 13.7678C12.254 13.2989 12 12.663 12 12Z",
        fill: "#1ABCFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.17871 17C7.17871 16.337 7.4327 15.7011 7.88479 15.2322C8.33689 14.7634 8.95006 14.5 9.58943 14.5H12.0001V17C12.0001 17.663 11.7462 18.2989 11.2941 18.7678C10.842 19.2366 10.2288 19.5 9.58943 19.5C8.95006 19.5 8.33689 19.2366 7.88479 18.7678C7.4327 18.2989 7.17871 17.663 7.17871 17V17Z",
        fill: "#0ACF83"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12 4.5V9.5H14.4107C15.0501 9.5 15.6633 9.23661 16.1153 8.76777C16.5674 8.29893 16.8214 7.66304 16.8214 7C16.8214 6.33696 16.5674 5.70107 16.1153 5.23223C15.6633 4.76339 15.0501 4.5 14.4107 4.5H12Z",
        fill: "#FF7262"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.17871 7C7.17871 7.66304 7.4327 8.29893 7.88479 8.76777C8.33689 9.23661 8.95006 9.5 9.58943 9.5H12.0001V4.5H9.58943C8.95006 4.5 8.33689 4.76339 7.88479 5.23223C7.4327 5.70107 7.17871 6.33696 7.17871 7V7Z",
        fill: "#F24E1E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.17871 12C7.17871 12.663 7.4327 13.2989 7.88479 13.7678C8.33689 14.2366 8.95006 14.5 9.58943 14.5H12.0001V9.5H9.58943C8.95006 9.5 8.33689 9.76339 7.88479 10.2322C7.4327 10.7011 7.17871 11.337 7.17871 12V12Z",
        fill: "#A259FF"
    })));
};





const $fc193e0e706d6ae9$export$b31792ff95c3d83f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.9995 16C15.9995 15.1159 16.3382 14.2681 16.941 13.6429C17.5438 13.0178 18.3613 12.6666 19.2138 12.6666C20.0663 12.6666 20.8838 13.0178 21.4866 13.6429C22.0894 14.2681 22.4281 15.1159 22.4281 16C22.4281 16.884 22.0894 17.7319 21.4866 18.357C20.8838 18.9821 20.0663 19.3333 19.2138 19.3333C18.3613 19.3333 17.5438 18.9821 16.941 18.357C16.3382 17.7319 15.9995 16.884 15.9995 16Z",
        fill: "#1ABCFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.57104 22.6666C9.57104 21.7825 9.90969 20.9347 10.5125 20.3096C11.1153 19.6844 11.9328 19.3333 12.7853 19.3333H15.9996V22.6666C15.9996 23.5506 15.661 24.3985 15.0582 25.0236C14.4554 25.6487 13.6378 25.9999 12.7853 25.9999C11.9328 25.9999 11.1153 25.6487 10.5125 25.0236C9.90969 24.3985 9.57104 23.5506 9.57104 22.6666V22.6666Z",
        fill: "#0ACF83"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.9995 6V12.6667H19.2138C20.0663 12.6667 20.8838 12.3155 21.4866 11.6904C22.0894 11.0652 22.4281 10.2174 22.4281 9.33333C22.4281 8.44928 22.0894 7.60143 21.4866 6.97631C20.8838 6.35119 20.0663 6 19.2138 6H15.9995Z",
        fill: "#FF7262"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.57129 9.33333C9.57129 10.2174 9.90994 11.0652 10.5127 11.6904C11.1155 12.3155 11.9331 12.6667 12.7856 12.6667H15.9999V6H12.7856C11.9331 6 11.1155 6.35119 10.5127 6.97631C9.90994 7.60143 9.57129 8.44928 9.57129 9.33333V9.33333Z",
        fill: "#F24E1E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.57104 16C9.57104 16.884 9.90969 17.7319 10.5125 18.357C11.1153 18.9821 11.9328 19.3333 12.7853 19.3333H15.9996V12.6666H12.7853C11.9328 12.6666 11.1153 13.0178 10.5125 13.6429C9.90969 14.2681 9.57104 15.1159 9.57104 16V16Z",
        fill: "#A259FF"
    })));
};


const $ae51f698a2238858$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: 'figma-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $b0408f51f36c91ad$export$54e0f4982aa79afe), 'Figma', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $fc193e0e706d6ae9$export$b31792ff95c3d83f), 'Figma', 'large'),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $f4de9135588d44e0$export$31bc4bf573db3488 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        width: "24",
        height: "24",
        viewBox: "0 0 120 120",
        enableBackground: "new 0 0 120 120",
        xmlSpace: "preserve"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4EAE8",
        opacity: "1.000000",
        stroke: "none",
        d: " M76.000000,121.000000  C50.666668,121.000000 25.833334,121.000000 1.000000,121.000000  C1.000000,81.000000 1.000000,41.000000 1.000000,1.000000  C41.000000,1.000000 81.000000,1.000000 121.000000,1.000000  C121.000000,41.000000 121.000000,81.000000 121.000000,121.000000  C106.166664,121.000000 91.333336,121.000000 76.000000,121.000000 M62.263176,19.060066  C50.996426,19.075516 42.247055,24.466097 38.773026,34.221611  C37.638844,37.406521 35.857670,38.863720 32.982101,40.200188  C23.188688,44.751854 17.890841,55.936722 20.272135,66.484962  C22.861870,77.956520 33.360901,84.342522 43.491947,86.014969  C50.326443,87.143219 55.707760,84.249313 60.596325,79.992630  C65.522552,75.703156 70.984940,72.981033 77.720123,72.948860  C85.075142,72.913742 89.779495,68.094574 89.990685,60.712646  C90.087982,57.311523 90.007256,53.905312 90.007256,49.725838  C96.250122,54.823402 95.770119,61.053692 94.653046,66.727623  C93.452408,72.825928 88.920235,76.874992 82.747787,78.246613  C79.439178,78.981842 77.959923,80.470528 77.013176,83.756348  C73.641945,95.456734 60.734417,99.714951 50.472446,93.147980  C47.960659,91.540611 44.484413,91.440361 41.451588,90.647202  C41.322243,91.170441 41.192898,91.693680 41.063553,92.216919  C46.222862,99.533493 53.364048,103.372185 62.318932,102.654411  C71.656143,101.905991 78.349434,96.896553 82.437683,88.297714  C83.302124,86.479515 85.176079,84.676788 87.023216,83.868111  C96.678192,79.641167 102.544991,70.587334 102.005142,60.097221  C101.507645,50.430080 94.254456,41.358860 84.230858,39.029640  C74.934387,36.869381 65.991173,36.725124 58.192295,44.358093  C55.084240,47.400028 49.996651,49.980045 45.790779,50.009647  C37.440773,50.068432 32.053486,53.933083 31.886557,62.435261  C31.819893,65.830574 31.875595,69.228287 31.875595,73.554253  C30.563459,72.398857 30.028196,72.063705 29.671417,71.593216  C22.798084,62.529270 26.230907,50.123062 36.850655,45.365486  C39.658077,44.107780 43.220943,43.915871 43.857868,39.645134  C44.827877,33.141006 48.736507,28.318781 54.905392,26.711372  C61.303562,25.044220 68.092499,25.058596 73.042778,30.892323  C75.655090,33.970844 78.177010,33.326168 81.226646,31.431835  C77.141373,24.014318 70.877846,20.473303 62.263176,19.060066 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#E56060",
        opacity: "1.000000",
        stroke: "none",
        d: " M62.693012,19.088871  C70.877846,20.473303 77.141373,24.014318 81.226646,31.431835  C78.177010,33.326168 75.655090,33.970844 73.042778,30.892323  C68.092499,25.058596 61.303562,25.044220 54.905392,26.711372  C48.736507,28.318781 44.827877,33.141006 43.857868,39.645134  C43.220943,43.915871 39.658077,44.107780 36.850655,45.365486  C26.230907,50.123062 22.798084,62.529270 29.671417,71.593216  C30.028196,72.063705 30.563459,72.398857 31.875595,73.554253  C31.875595,69.228287 31.819893,65.830574 31.886557,62.435261  C32.053486,53.933083 37.440773,50.068432 45.790779,50.009647  C49.996651,49.980045 55.084240,47.400028 58.192295,44.358093  C65.991173,36.725124 74.934387,36.869381 84.230858,39.029640  C94.254456,41.358860 101.507645,50.430080 102.005142,60.097221  C102.544991,70.587334 96.678192,79.641167 87.023216,83.868111  C85.176079,84.676788 83.302124,86.479515 82.437683,88.297714  C78.349434,96.896553 71.656143,101.905991 62.318932,102.654411  C53.364048,103.372185 46.222862,99.533493 41.063553,92.216919  C41.192898,91.693680 41.322243,91.170441 41.451588,90.647202  C44.484413,91.440361 47.960659,91.540611 50.472446,93.147980  C60.734417,99.714951 73.641945,95.456734 77.013176,83.756348  C77.959923,80.470528 79.439178,78.981842 82.747787,78.246613  C88.920235,76.874992 93.452408,72.825928 94.653046,66.727623  C95.770119,61.053692 96.250122,54.823402 90.007256,49.725838  C90.007256,53.905312 90.087982,57.311523 89.990685,60.712646  C89.779495,68.094574 85.075142,72.913742 77.720123,72.948860  C70.984940,72.981033 65.522552,75.703156 60.596325,79.992630  C55.707760,84.249313 50.326443,87.143219 43.491947,86.014969  C33.360901,84.342522 22.861870,77.956520 20.272135,66.484962  C17.890841,55.936722 23.188688,44.751854 32.982101,40.200188  C35.857670,38.863720 37.638844,37.406521 38.773026,34.221611  C42.247055,24.466097 50.996426,19.075516 62.693012,19.088871 M83.824944,56.293854  C83.821907,53.635612 83.976067,50.963406 83.741730,48.325714  C83.642090,47.204105 82.797951,45.259941 82.174835,45.211914  C76.359108,44.763695 70.118729,42.530880 65.076790,47.276245  C59.155472,52.849270 52.615253,56.469597 44.212204,56.320381  C40.653618,56.257191 38.137321,58.196499 38.040661,62.073360  C37.913185,67.186157 38.009319,72.304527 38.009319,77.448776  C45.517998,80.035103 51.614822,79.032494 57.772171,74.282555  C61.946938,71.062035 67.295502,67.884392 72.307640,67.554817  C81.082947,66.977783 83.710907,65.678894 83.824944,56.293854 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4E9E7",
        opacity: "1.000000",
        stroke: "none",
        d: " M83.824799,56.751064  C83.710907,65.678894 81.082947,66.977783 72.307640,67.554817  C67.295502,67.884392 61.946938,71.062035 57.772171,74.282555  C51.614822,79.032494 45.517998,80.035103 38.009319,77.448776  C38.009319,72.304527 37.913185,67.186157 38.040661,62.073360  C38.137321,58.196499 40.653618,56.257191 44.212204,56.320381  C52.615253,56.469597 59.155472,52.849270 65.076790,47.276245  C70.118729,42.530880 76.359108,44.763695 82.174835,45.211914  C82.797951,45.259941 83.642090,47.204105 83.741730,48.325714  C83.976067,50.963406 83.821907,53.635612 83.824799,56.751064 z"
    }));
};





const $72f402f3422f4e5e$export$bd28886795da63ae = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        width: "32",
        height: "32",
        viewBox: "0 0 120 120",
        enableBackground: "new 0 0 120 120",
        xmlSpace: "preserve"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4EAE8",
        opacity: "1.000000",
        stroke: "none",
        d: " M76.000000,121.000000  C50.666668,121.000000 25.833334,121.000000 1.000000,121.000000  C1.000000,81.000000 1.000000,41.000000 1.000000,1.000000  C41.000000,1.000000 81.000000,1.000000 121.000000,1.000000  C121.000000,41.000000 121.000000,81.000000 121.000000,121.000000  C106.166664,121.000000 91.333336,121.000000 76.000000,121.000000 M62.263176,19.060066  C50.996426,19.075516 42.247055,24.466097 38.773026,34.221611  C37.638844,37.406521 35.857670,38.863720 32.982101,40.200188  C23.188688,44.751854 17.890841,55.936722 20.272135,66.484962  C22.861870,77.956520 33.360901,84.342522 43.491947,86.014969  C50.326443,87.143219 55.707760,84.249313 60.596325,79.992630  C65.522552,75.703156 70.984940,72.981033 77.720123,72.948860  C85.075142,72.913742 89.779495,68.094574 89.990685,60.712646  C90.087982,57.311523 90.007256,53.905312 90.007256,49.725838  C96.250122,54.823402 95.770119,61.053692 94.653046,66.727623  C93.452408,72.825928 88.920235,76.874992 82.747787,78.246613  C79.439178,78.981842 77.959923,80.470528 77.013176,83.756348  C73.641945,95.456734 60.734417,99.714951 50.472446,93.147980  C47.960659,91.540611 44.484413,91.440361 41.451588,90.647202  C41.322243,91.170441 41.192898,91.693680 41.063553,92.216919  C46.222862,99.533493 53.364048,103.372185 62.318932,102.654411  C71.656143,101.905991 78.349434,96.896553 82.437683,88.297714  C83.302124,86.479515 85.176079,84.676788 87.023216,83.868111  C96.678192,79.641167 102.544991,70.587334 102.005142,60.097221  C101.507645,50.430080 94.254456,41.358860 84.230858,39.029640  C74.934387,36.869381 65.991173,36.725124 58.192295,44.358093  C55.084240,47.400028 49.996651,49.980045 45.790779,50.009647  C37.440773,50.068432 32.053486,53.933083 31.886557,62.435261  C31.819893,65.830574 31.875595,69.228287 31.875595,73.554253  C30.563459,72.398857 30.028196,72.063705 29.671417,71.593216  C22.798084,62.529270 26.230907,50.123062 36.850655,45.365486  C39.658077,44.107780 43.220943,43.915871 43.857868,39.645134  C44.827877,33.141006 48.736507,28.318781 54.905392,26.711372  C61.303562,25.044220 68.092499,25.058596 73.042778,30.892323  C75.655090,33.970844 78.177010,33.326168 81.226646,31.431835  C77.141373,24.014318 70.877846,20.473303 62.263176,19.060066 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#E56060",
        opacity: "1.000000",
        stroke: "none",
        d: " M62.693012,19.088871  C70.877846,20.473303 77.141373,24.014318 81.226646,31.431835  C78.177010,33.326168 75.655090,33.970844 73.042778,30.892323  C68.092499,25.058596 61.303562,25.044220 54.905392,26.711372  C48.736507,28.318781 44.827877,33.141006 43.857868,39.645134  C43.220943,43.915871 39.658077,44.107780 36.850655,45.365486  C26.230907,50.123062 22.798084,62.529270 29.671417,71.593216  C30.028196,72.063705 30.563459,72.398857 31.875595,73.554253  C31.875595,69.228287 31.819893,65.830574 31.886557,62.435261  C32.053486,53.933083 37.440773,50.068432 45.790779,50.009647  C49.996651,49.980045 55.084240,47.400028 58.192295,44.358093  C65.991173,36.725124 74.934387,36.869381 84.230858,39.029640  C94.254456,41.358860 101.507645,50.430080 102.005142,60.097221  C102.544991,70.587334 96.678192,79.641167 87.023216,83.868111  C85.176079,84.676788 83.302124,86.479515 82.437683,88.297714  C78.349434,96.896553 71.656143,101.905991 62.318932,102.654411  C53.364048,103.372185 46.222862,99.533493 41.063553,92.216919  C41.192898,91.693680 41.322243,91.170441 41.451588,90.647202  C44.484413,91.440361 47.960659,91.540611 50.472446,93.147980  C60.734417,99.714951 73.641945,95.456734 77.013176,83.756348  C77.959923,80.470528 79.439178,78.981842 82.747787,78.246613  C88.920235,76.874992 93.452408,72.825928 94.653046,66.727623  C95.770119,61.053692 96.250122,54.823402 90.007256,49.725838  C90.007256,53.905312 90.087982,57.311523 89.990685,60.712646  C89.779495,68.094574 85.075142,72.913742 77.720123,72.948860  C70.984940,72.981033 65.522552,75.703156 60.596325,79.992630  C55.707760,84.249313 50.326443,87.143219 43.491947,86.014969  C33.360901,84.342522 22.861870,77.956520 20.272135,66.484962  C17.890841,55.936722 23.188688,44.751854 32.982101,40.200188  C35.857670,38.863720 37.638844,37.406521 38.773026,34.221611  C42.247055,24.466097 50.996426,19.075516 62.693012,19.088871 M83.824944,56.293854  C83.821907,53.635612 83.976067,50.963406 83.741730,48.325714  C83.642090,47.204105 82.797951,45.259941 82.174835,45.211914  C76.359108,44.763695 70.118729,42.530880 65.076790,47.276245  C59.155472,52.849270 52.615253,56.469597 44.212204,56.320381  C40.653618,56.257191 38.137321,58.196499 38.040661,62.073360  C37.913185,67.186157 38.009319,72.304527 38.009319,77.448776  C45.517998,80.035103 51.614822,79.032494 57.772171,74.282555  C61.946938,71.062035 67.295502,67.884392 72.307640,67.554817  C81.082947,66.977783 83.710907,65.678894 83.824944,56.293854 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4E9E7",
        opacity: "1.000000",
        stroke: "none",
        d: " M83.824799,56.751064  C83.710907,65.678894 81.082947,66.977783 72.307640,67.554817  C67.295502,67.884392 61.946938,71.062035 57.772171,74.282555  C51.614822,79.032494 45.517998,80.035103 38.009319,77.448776  C38.009319,72.304527 37.913185,67.186157 38.040661,62.073360  C38.137321,58.196499 40.653618,56.257191 44.212204,56.320381  C52.615253,56.469597 59.155472,52.849270 65.076790,47.276245  C70.118729,42.530880 76.359108,44.763695 82.174835,45.211914  C82.797951,45.259941 83.642090,47.204105 83.741730,48.325714  C83.976067,50.963406 83.821907,53.635612 83.824799,56.751064 z"
    }));
};


const $d4918d535d8429c3$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    resourceType: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $f4de9135588d44e0$export$31bc4bf573db3488), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $72f402f3422f4e5e$export$bd28886795da63ae), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

















const $efb4af28103c9e72$export$31bc4bf573db3488 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        width: "24",
        height: "24",
        viewBox: "0 0 120 120",
        enableBackground: "new 0 0 120 120",
        xmlSpace: "preserve"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4EAE8",
        opacity: "1.000000",
        stroke: "none",
        d: " M76.000000,121.000000 C50.666668,121.000000 25.833334,121.000000 1.000000,121.000000 C1.000000,81.000000 1.000000,41.000000 1.000000,1.000000 C41.000000,1.000000 81.000000,1.000000 121.000000,1.000000 C121.000000,41.000000 121.000000,81.000000 121.000000,121.000000 C106.166664,121.000000 91.333336,121.000000 76.000000,121.000000 M62.263176,19.060066 C50.996426,19.075516 42.247055,24.466097 38.773026,34.221611 C37.638844,37.406521 35.857670,38.863720 32.982101,40.200188 C23.188688,44.751854 17.890841,55.936722 20.272135,66.484962 C22.861870,77.956520 33.360901,84.342522 43.491947,86.014969 C50.326443,87.143219 55.707760,84.249313 60.596325,79.992630 C65.522552,75.703156 70.984940,72.981033 77.720123,72.948860 C85.075142,72.913742 89.779495,68.094574 89.990685,60.712646 C90.087982,57.311523 90.007256,53.905312 90.007256,49.725838 C96.250122,54.823402 95.770119,61.053692 94.653046,66.727623 C93.452408,72.825928 88.920235,76.874992 82.747787,78.246613 C79.439178,78.981842 77.959923,80.470528 77.013176,83.756348 C73.641945,95.456734 60.734417,99.714951 50.472446,93.147980 C47.960659,91.540611 44.484413,91.440361 41.451588,90.647202 C41.322243,91.170441 41.192898,91.693680 41.063553,92.216919 C46.222862,99.533493 53.364048,103.372185 62.318932,102.654411 C71.656143,101.905991 78.349434,96.896553 82.437683,88.297714 C83.302124,86.479515 85.176079,84.676788 87.023216,83.868111 C96.678192,79.641167 102.544991,70.587334 102.005142,60.097221 C101.507645,50.430080 94.254456,41.358860 84.230858,39.029640 C74.934387,36.869381 65.991173,36.725124 58.192295,44.358093 C55.084240,47.400028 49.996651,49.980045 45.790779,50.009647 C37.440773,50.068432 32.053486,53.933083 31.886557,62.435261 C31.819893,65.830574 31.875595,69.228287 31.875595,73.554253 C30.563459,72.398857 30.028196,72.063705 29.671417,71.593216 C22.798084,62.529270 26.230907,50.123062 36.850655,45.365486 C39.658077,44.107780 43.220943,43.915871 43.857868,39.645134 C44.827877,33.141006 48.736507,28.318781 54.905392,26.711372 C61.303562,25.044220 68.092499,25.058596 73.042778,30.892323 C75.655090,33.970844 78.177010,33.326168 81.226646,31.431835 C77.141373,24.014318 70.877846,20.473303 62.263176,19.060066 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#E56060",
        opacity: "1.000000",
        stroke: "none",
        d: " M62.693012,19.088871 C70.877846,20.473303 77.141373,24.014318 81.226646,31.431835 C78.177010,33.326168 75.655090,33.970844 73.042778,30.892323 C68.092499,25.058596 61.303562,25.044220 54.905392,26.711372 C48.736507,28.318781 44.827877,33.141006 43.857868,39.645134 C43.220943,43.915871 39.658077,44.107780 36.850655,45.365486 C26.230907,50.123062 22.798084,62.529270 29.671417,71.593216 C30.028196,72.063705 30.563459,72.398857 31.875595,73.554253 C31.875595,69.228287 31.819893,65.830574 31.886557,62.435261 C32.053486,53.933083 37.440773,50.068432 45.790779,50.009647 C49.996651,49.980045 55.084240,47.400028 58.192295,44.358093 C65.991173,36.725124 74.934387,36.869381 84.230858,39.029640 C94.254456,41.358860 101.507645,50.430080 102.005142,60.097221 C102.544991,70.587334 96.678192,79.641167 87.023216,83.868111 C85.176079,84.676788 83.302124,86.479515 82.437683,88.297714 C78.349434,96.896553 71.656143,101.905991 62.318932,102.654411 C53.364048,103.372185 46.222862,99.533493 41.063553,92.216919 C41.192898,91.693680 41.322243,91.170441 41.451588,90.647202 C44.484413,91.440361 47.960659,91.540611 50.472446,93.147980 C60.734417,99.714951 73.641945,95.456734 77.013176,83.756348 C77.959923,80.470528 79.439178,78.981842 82.747787,78.246613 C88.920235,76.874992 93.452408,72.825928 94.653046,66.727623 C95.770119,61.053692 96.250122,54.823402 90.007256,49.725838 C90.007256,53.905312 90.087982,57.311523 89.990685,60.712646 C89.779495,68.094574 85.075142,72.913742 77.720123,72.948860 C70.984940,72.981033 65.522552,75.703156 60.596325,79.992630 C55.707760,84.249313 50.326443,87.143219 43.491947,86.014969 C33.360901,84.342522 22.861870,77.956520 20.272135,66.484962 C17.890841,55.936722 23.188688,44.751854 32.982101,40.200188 C35.857670,38.863720 37.638844,37.406521 38.773026,34.221611 C42.247055,24.466097 50.996426,19.075516 62.693012,19.088871 M83.824944,56.293854 C83.821907,53.635612 83.976067,50.963406 83.741730,48.325714 C83.642090,47.204105 82.797951,45.259941 82.174835,45.211914 C76.359108,44.763695 70.118729,42.530880 65.076790,47.276245 C59.155472,52.849270 52.615253,56.469597 44.212204,56.320381 C40.653618,56.257191 38.137321,58.196499 38.040661,62.073360 C37.913185,67.186157 38.009319,72.304527 38.009319,77.448776 C45.517998,80.035103 51.614822,79.032494 57.772171,74.282555 C61.946938,71.062035 67.295502,67.884392 72.307640,67.554817 C81.082947,66.977783 83.710907,65.678894 83.824944,56.293854 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4E9E7",
        opacity: "1.000000",
        stroke: "none",
        d: " M83.824799,56.751064 C83.710907,65.678894 81.082947,66.977783 72.307640,67.554817 C67.295502,67.884392 61.946938,71.062035 57.772171,74.282555 C51.614822,79.032494 45.517998,80.035103 38.009319,77.448776 C38.009319,72.304527 37.913185,67.186157 38.040661,62.073360 C38.137321,58.196499 40.653618,56.257191 44.212204,56.320381 C52.615253,56.469597 59.155472,52.849270 65.076790,47.276245 C70.118729,42.530880 76.359108,44.763695 82.174835,45.211914 C82.797951,45.259941 83.642090,47.204105 83.741730,48.325714 C83.976067,50.963406 83.821907,53.635612 83.824799,56.751064 z"
    }));
};





const $23bfde0e31240e4a$export$bd28886795da63ae = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        width: "32",
        height: "32",
        viewBox: "0 0 120 120",
        enableBackground: "new 0 0 120 120",
        xmlSpace: "preserve"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4EAE8",
        opacity: "1.000000",
        stroke: "none",
        d: " M76.000000,121.000000 C50.666668,121.000000 25.833334,121.000000 1.000000,121.000000 C1.000000,81.000000 1.000000,41.000000 1.000000,1.000000 C41.000000,1.000000 81.000000,1.000000 121.000000,1.000000 C121.000000,41.000000 121.000000,81.000000 121.000000,121.000000 C106.166664,121.000000 91.333336,121.000000 76.000000,121.000000 M62.263176,19.060066 C50.996426,19.075516 42.247055,24.466097 38.773026,34.221611 C37.638844,37.406521 35.857670,38.863720 32.982101,40.200188 C23.188688,44.751854 17.890841,55.936722 20.272135,66.484962 C22.861870,77.956520 33.360901,84.342522 43.491947,86.014969 C50.326443,87.143219 55.707760,84.249313 60.596325,79.992630 C65.522552,75.703156 70.984940,72.981033 77.720123,72.948860 C85.075142,72.913742 89.779495,68.094574 89.990685,60.712646 C90.087982,57.311523 90.007256,53.905312 90.007256,49.725838 C96.250122,54.823402 95.770119,61.053692 94.653046,66.727623 C93.452408,72.825928 88.920235,76.874992 82.747787,78.246613 C79.439178,78.981842 77.959923,80.470528 77.013176,83.756348 C73.641945,95.456734 60.734417,99.714951 50.472446,93.147980 C47.960659,91.540611 44.484413,91.440361 41.451588,90.647202 C41.322243,91.170441 41.192898,91.693680 41.063553,92.216919 C46.222862,99.533493 53.364048,103.372185 62.318932,102.654411 C71.656143,101.905991 78.349434,96.896553 82.437683,88.297714 C83.302124,86.479515 85.176079,84.676788 87.023216,83.868111 C96.678192,79.641167 102.544991,70.587334 102.005142,60.097221 C101.507645,50.430080 94.254456,41.358860 84.230858,39.029640 C74.934387,36.869381 65.991173,36.725124 58.192295,44.358093 C55.084240,47.400028 49.996651,49.980045 45.790779,50.009647 C37.440773,50.068432 32.053486,53.933083 31.886557,62.435261 C31.819893,65.830574 31.875595,69.228287 31.875595,73.554253 C30.563459,72.398857 30.028196,72.063705 29.671417,71.593216 C22.798084,62.529270 26.230907,50.123062 36.850655,45.365486 C39.658077,44.107780 43.220943,43.915871 43.857868,39.645134 C44.827877,33.141006 48.736507,28.318781 54.905392,26.711372 C61.303562,25.044220 68.092499,25.058596 73.042778,30.892323 C75.655090,33.970844 78.177010,33.326168 81.226646,31.431835 C77.141373,24.014318 70.877846,20.473303 62.263176,19.060066 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#E56060",
        opacity: "1.000000",
        stroke: "none",
        d: " M62.693012,19.088871 C70.877846,20.473303 77.141373,24.014318 81.226646,31.431835 C78.177010,33.326168 75.655090,33.970844 73.042778,30.892323 C68.092499,25.058596 61.303562,25.044220 54.905392,26.711372 C48.736507,28.318781 44.827877,33.141006 43.857868,39.645134 C43.220943,43.915871 39.658077,44.107780 36.850655,45.365486 C26.230907,50.123062 22.798084,62.529270 29.671417,71.593216 C30.028196,72.063705 30.563459,72.398857 31.875595,73.554253 C31.875595,69.228287 31.819893,65.830574 31.886557,62.435261 C32.053486,53.933083 37.440773,50.068432 45.790779,50.009647 C49.996651,49.980045 55.084240,47.400028 58.192295,44.358093 C65.991173,36.725124 74.934387,36.869381 84.230858,39.029640 C94.254456,41.358860 101.507645,50.430080 102.005142,60.097221 C102.544991,70.587334 96.678192,79.641167 87.023216,83.868111 C85.176079,84.676788 83.302124,86.479515 82.437683,88.297714 C78.349434,96.896553 71.656143,101.905991 62.318932,102.654411 C53.364048,103.372185 46.222862,99.533493 41.063553,92.216919 C41.192898,91.693680 41.322243,91.170441 41.451588,90.647202 C44.484413,91.440361 47.960659,91.540611 50.472446,93.147980 C60.734417,99.714951 73.641945,95.456734 77.013176,83.756348 C77.959923,80.470528 79.439178,78.981842 82.747787,78.246613 C88.920235,76.874992 93.452408,72.825928 94.653046,66.727623 C95.770119,61.053692 96.250122,54.823402 90.007256,49.725838 C90.007256,53.905312 90.087982,57.311523 89.990685,60.712646 C89.779495,68.094574 85.075142,72.913742 77.720123,72.948860 C70.984940,72.981033 65.522552,75.703156 60.596325,79.992630 C55.707760,84.249313 50.326443,87.143219 43.491947,86.014969 C33.360901,84.342522 22.861870,77.956520 20.272135,66.484962 C17.890841,55.936722 23.188688,44.751854 32.982101,40.200188 C35.857670,38.863720 37.638844,37.406521 38.773026,34.221611 C42.247055,24.466097 50.996426,19.075516 62.693012,19.088871 M83.824944,56.293854 C83.821907,53.635612 83.976067,50.963406 83.741730,48.325714 C83.642090,47.204105 82.797951,45.259941 82.174835,45.211914 C76.359108,44.763695 70.118729,42.530880 65.076790,47.276245 C59.155472,52.849270 52.615253,56.469597 44.212204,56.320381 C40.653618,56.257191 38.137321,58.196499 38.040661,62.073360 C37.913185,67.186157 38.009319,72.304527 38.009319,77.448776 C45.517998,80.035103 51.614822,79.032494 57.772171,74.282555 C61.946938,71.062035 67.295502,67.884392 72.307640,67.554817 C81.082947,66.977783 83.710907,65.678894 83.824944,56.293854 z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F4E9E7",
        opacity: "1.000000",
        stroke: "none",
        d: " M83.824799,56.751064 C83.710907,65.678894 81.082947,66.977783 72.307640,67.554817 C67.295502,67.884392 61.946938,71.062035 57.772171,74.282555 C51.614822,79.032494 45.517998,80.035103 38.009319,77.448776 C38.009319,72.304527 37.913185,67.186157 38.040661,62.073360 C38.137321,58.196499 40.653618,56.257191 44.212204,56.320381 C52.615253,56.469597 59.155472,52.849270 65.076790,47.276245 C70.118729,42.530880 76.359108,44.763695 82.174835,45.211914 C82.797951,45.259941 83.642090,47.204105 83.741730,48.325714 C83.976067,50.963406 83.821907,53.635612 83.824799,56.751064 z"
    }));
};


const $cd4d710ff220ed00$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    resourceType: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $efb4af28103c9e72$export$31bc4bf573db3488), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $23bfde0e31240e4a$export$bd28886795da63ae), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};



var $kllKt = parcelRequire("kllKt");





var $fRYrB = parcelRequire("fRYrB");


var $c8e62 = parcelRequire("c8e62");








var $7sFsr = parcelRequire("7sFsr");





var $lgIW7 = parcelRequire("lgIW7");


var $e8tw2 = parcelRequire("e8tw2");


var $i6s7M = parcelRequire("i6s7M");








var $11scr = parcelRequire("11scr");


var $3q5AZ = parcelRequire("3q5AZ");








var $aVIh8 = parcelRequire("aVIh8");













const $fd1b0db75be1fefe$export$d25ddeed4ba7332 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24",
        rx: "6",
        ry: "6",
        fill: "#1a174d"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "24",
        rx: "7",
        ry: "5",
        fill: "url(#glowGradient)",
        opacity: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "11",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "21",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "13",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "19",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "17",
        rx: "3",
        ry: "5",
        fill: "url(#bodyGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "10",
        rx: "2",
        ry: "2",
        fill: "url(#headGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.2 8.5 Q14.2 7.5 15 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.8 8.5 Q17.8 7.5 17 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "23",
        rx: "4",
        ry: "5",
        fill: "url(#bulbGradient)",
        filter: "url(#glow)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15.2",
        y: "20",
        width: "1.6",
        height: "2",
        rx: "0.5",
        fill: "#f7c873"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "bulbGradient",
        cx: "50%",
        cy: "50%",
        r: "70%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "60%",
        stopColor: "#ffe066"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "glowGradient",
        cx: "50%",
        cy: "60%",
        r: "80%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0",
        stopOpacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "80%",
        stopColor: "#ffe066",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "bodyGradient",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "headGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#b2b7ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#e0e7ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient2",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#d1d8ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#f0f4ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "glow",
        x: "-50%",
        y: "-50%",
        width: "200%",
        height: "200%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: "1.2",
        result: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMerge", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "SourceGraphic"
    })))));
};





const $757048c474ed40a6$export$5a35b3e4364deaaf = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0",
        y: "0",
        width: "32",
        height: "32",
        rx: "6",
        ry: "6",
        fill: "#1a174d"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "24",
        rx: "7",
        ry: "5",
        fill: "url(#glowGradient)",
        opacity: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "11",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "21",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "13",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "19",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "17",
        rx: "3",
        ry: "5",
        fill: "url(#bodyGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "10",
        rx: "2",
        ry: "2",
        fill: "url(#headGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.2 8.5 Q14.2 7.5 15 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.8 8.5 Q17.8 7.5 17 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "23",
        rx: "4",
        ry: "5",
        fill: "url(#bulbGradient)",
        filter: "url(#glow)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15.2",
        y: "20",
        width: "1.6",
        height: "2",
        rx: "0.5",
        fill: "#f7c873"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "bulbGradient",
        cx: "50%",
        cy: "50%",
        r: "70%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "60%",
        stopColor: "#ffe066"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "glowGradient",
        cx: "50%",
        cy: "60%",
        r: "80%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0",
        stopOpacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "80%",
        stopColor: "#ffe066",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "bodyGradient",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "headGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#b2b7ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#e0e7ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient2",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#d1d8ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#f0f4ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "glow",
        x: "-50%",
        y: "-50%",
        width: "200%",
        height: "200%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: "1.2",
        result: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMerge", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "SourceGraphic"
    })))));
};


const $b2c9c6b294411a0f$export$c0c8ceeb88dd1e08 = {
    displayName: 'Forge GDrive Eugene Test Staging',
    id: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    resourceType: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    icon: (0, $9yyKc.get3PLogo)((0, $fd1b0db75be1fefe$export$d25ddeed4ba7332), 'ForgeGdriveEugeneTestDev', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $757048c474ed40a6$export$5a35b3e4364deaaf), 'ForgeGdriveEugeneTestDev', 'large'),
    integrationAri: 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $7e0d5a5c41da35c6$export$1fba1a4a4b5390fe = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24",
        rx: "6",
        ry: "6",
        fill: "#1a174d"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "24",
        rx: "7",
        ry: "5",
        fill: "url(#glowGradient)",
        opacity: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "11",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "21",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "13",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "19",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "17",
        rx: "3",
        ry: "5",
        fill: "url(#bodyGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "10",
        rx: "2",
        ry: "2",
        fill: "url(#headGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.2 8.5 Q14.2 7.5 15 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.8 8.5 Q17.8 7.5 17 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "23",
        rx: "4",
        ry: "5",
        fill: "url(#bulbGradient)",
        filter: "url(#glow)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15.2",
        y: "20",
        width: "1.6",
        height: "2",
        rx: "0.5",
        fill: "#f7c873"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "bulbGradient",
        cx: "50%",
        cy: "50%",
        r: "70%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "60%",
        stopColor: "#ffe066"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "glowGradient",
        cx: "50%",
        cy: "60%",
        r: "80%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0",
        stopOpacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "80%",
        stopColor: "#ffe066",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "bodyGradient",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "headGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#b2b7ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#e0e7ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient2",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#d1d8ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#f0f4ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "glow",
        x: "-50%",
        y: "-50%",
        width: "200%",
        height: "200%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: "1.2",
        result: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMerge", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "SourceGraphic"
    })))));
};





const $5fe30864eeafc7ee$export$1821b5c60d4d13ba = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0",
        y: "0",
        width: "32",
        height: "32",
        rx: "6",
        ry: "6",
        fill: "#1a174d"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "24",
        rx: "7",
        ry: "5",
        fill: "url(#glowGradient)",
        opacity: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "11",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "21",
        cy: "15",
        rx: "6",
        ry: "3",
        fill: "url(#wingGradient)",
        opacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "13",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "19",
        cy: "13",
        rx: "4",
        ry: "1.5",
        fill: "url(#wingGradient2)",
        opacity: "0.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "17",
        rx: "3",
        ry: "5",
        fill: "url(#bodyGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "10",
        rx: "2",
        ry: "2",
        fill: "url(#headGradient)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.2 8.5 Q14.2 7.5 15 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.8 8.5 Q17.8 7.5 17 6.5",
        stroke: "#b2b7ff",
        strokeWidth: "0.4",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ellipse", {
        cx: "16",
        cy: "23",
        rx: "4",
        ry: "5",
        fill: "url(#bulbGradient)",
        filter: "url(#glow)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "15.2",
        y: "20",
        width: "1.6",
        height: "2",
        rx: "0.5",
        fill: "#f7c873"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "bulbGradient",
        cx: "50%",
        cy: "50%",
        r: "70%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "60%",
        stopColor: "#ffe066"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "glowGradient",
        cx: "50%",
        cy: "60%",
        r: "80%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#fffbe0",
        stopOpacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "80%",
        stopColor: "#ffe066",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#ffb347",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "bodyGradient",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "headGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#6c63ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#3f3d56"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#b2b7ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#e0e7ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "wingGradient2",
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0%",
        stopColor: "#d1d8ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "100%",
        stopColor: "#f0f4ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "glow",
        x: "-50%",
        y: "-50%",
        width: "200%",
        height: "200%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: "1.2",
        result: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMerge", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "coloredBlur"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMergeNode", {
        in: "SourceGraphic"
    })))));
};


const $f0b9e0606494d0f5$export$a3dc73add88484a8 = {
    displayName: 'Forge GDrive Eugene Test PROD',
    id: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    resourceType: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    icon: (0, $9yyKc.get3PLogo)((0, $7e0d5a5c41da35c6$export$1fba1a4a4b5390fe), 'ForgeGdriveEugeneTestProd', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5fe30864eeafc7ee$export$1821b5c60d4d13ba), 'ForgeGdriveEugeneTestProd', 'large'),
    integrationAri: 'ari:cloud:platform::integration/bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};





























const $7134a0049c286e5a$export$317be388f2737846 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 144 144",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M115.9,13.3c1.8,0,3.5,1,4.3,2.7c1-0.8,2.6-0.5,3.3,0.7c0.3,0.4,0.4,0.9,0.4,1.2c1.7,0.2,3.1,1.6,3.3,3.3v0.3      c0,1.5-1.7,3-3.7,3h-10.9c-2.1,0-3.7-1.5-3.7-3v-0.3c0.1-1.4,1-2.6,2.4-3.2V18C111.3,15.4,113.4,13.3,115.9,13.3L115.9,13.3",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M75,130.4h-9.6c-14.9,0-27.1-10.8-27.1-23.9V29.3c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v77.2      c0,7.8,7.7,14.2,17.3,14.2h9.5c9.6,0,17.3-6.4,17.3-14.2V89c0.1-2.7,2.4-4.8,5.1-4.7c2.6,0.1,4.6,2.1,4.7,4.7v17.6      C102,119.7,89.9,130.4,75,130.4z",
        fill: "#58595B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M71.5,18.6c2.8,0,5.4,1.6,6.5,4.2c0.6-0.4,1.3-0.7,2-0.7c1.9,0,3.5,1.5,3.6,3.5c2.7,0.3,4.8,2.5,5,5.1v0.5      c0,2.3-2.5,4.7-5.7,4.7H66.3c-3.1,0-5.7-2.4-5.7-4.7v-0.5c0.1-2.2,1.5-4.1,3.6-4.9c0-0.1,0-0.1,0-0.2C64.3,21.7,67.5,18.6,71.5,18.6      L71.5,18.6",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M89.8,66.2c-0.5,0-1.1-0.2-1.5-0.6l-6-5.9c-0.4-0.4-0.7-1-0.7-1.6s0.3-1.2,0.7-1.6l6-5.4       c0.9-0.8,2.3-0.7,3.1,0.2c0.8,0.9,0.7,2.3-0.2,3.1L87,58.2l4.3,4.3c0.9,0.9,0.9,2.2,0,3.1C91,66,90.4,66.2,89.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M104.8,66.2c-0.6,0-1.1-0.2-1.6-0.7c-0.9-0.9-0.9-2.2,0-3.1l4.3-4.3l-4.3-3.8c-0.9-0.8-1-2.2-0.2-3.1       c0.8-0.9,2.2-1,3.1-0.2l6,5.4c0.4,0.4,0.7,1,0.7,1.6s-0.2,1.2-0.7,1.6l-6,5.9C105.9,66,105.3,66.2,104.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M95,69.7c-0.2,0-0.4,0-0.5-0.1c-1.2-0.3-1.9-1.5-1.6-2.7l4.8-18.5c0.3-1.2,1.5-1.9,2.7-1.6       c1.2,0.3,1.9,1.5,1.6,2.7L97.1,68C96.9,69.1,96,69.7,95,69.7z",
        fill: "#FF8300"
    })));
};





const $5c23f86e222e1c58$export$62ea9658fc6624da = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 144 144",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M115.9,13.3c1.8,0,3.5,1,4.3,2.7c1-0.8,2.6-0.5,3.3,0.7c0.3,0.4,0.4,0.9,0.4,1.2c1.7,0.2,3.1,1.6,3.3,3.3v0.3      c0,1.5-1.7,3-3.7,3h-10.9c-2.1,0-3.7-1.5-3.7-3v-0.3c0.1-1.4,1-2.6,2.4-3.2V18C111.3,15.4,113.4,13.3,115.9,13.3L115.9,13.3",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M75,130.4h-9.6c-14.9,0-27.1-10.8-27.1-23.9V29.3c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v77.2      c0,7.8,7.7,14.2,17.3,14.2h9.5c9.6,0,17.3-6.4,17.3-14.2V89c0.1-2.7,2.4-4.8,5.1-4.7c2.6,0.1,4.6,2.1,4.7,4.7v17.6      C102,119.7,89.9,130.4,75,130.4z",
        fill: "#58595B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M71.5,18.6c2.8,0,5.4,1.6,6.5,4.2c0.6-0.4,1.3-0.7,2-0.7c1.9,0,3.5,1.5,3.6,3.5c2.7,0.3,4.8,2.5,5,5.1v0.5      c0,2.3-2.5,4.7-5.7,4.7H66.3c-3.1,0-5.7-2.4-5.7-4.7v-0.5c0.1-2.2,1.5-4.1,3.6-4.9c0-0.1,0-0.1,0-0.2C64.3,21.7,67.5,18.6,71.5,18.6      L71.5,18.6",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M89.8,66.2c-0.5,0-1.1-0.2-1.5-0.6l-6-5.9c-0.4-0.4-0.7-1-0.7-1.6s0.3-1.2,0.7-1.6l6-5.4       c0.9-0.8,2.3-0.7,3.1,0.2c0.8,0.9,0.7,2.3-0.2,3.1L87,58.2l4.3,4.3c0.9,0.9,0.9,2.2,0,3.1C91,66,90.4,66.2,89.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M104.8,66.2c-0.6,0-1.1-0.2-1.6-0.7c-0.9-0.9-0.9-2.2,0-3.1l4.3-4.3l-4.3-3.8c-0.9-0.8-1-2.2-0.2-3.1       c0.8-0.9,2.2-1,3.1-0.2l6,5.4c0.4,0.4,0.7,1,0.7,1.6s-0.2,1.2-0.7,1.6l-6,5.9C105.9,66,105.3,66.2,104.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M95,69.7c-0.2,0-0.4,0-0.5-0.1c-1.2-0.3-1.9-1.5-1.6-2.7l4.8-18.5c0.3-1.2,1.5-1.9,2.7-1.6       c1.2,0.3,1.9,1.5,1.6,2.7L97.1,68C96.9,69.1,96,69.7,95,69.7z",
        fill: "#FF8300"
    })));
};


const $11a96c0845c60708$export$6bbd9bc3bcb111b9 = {
    displayName: 'Scroll Sites by k15t',
    id: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    resourceType: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $7134a0049c286e5a$export$317be388f2737846), 'ForgeK15tScrollSites', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5c23f86e222e1c58$export$62ea9658fc6624da), 'ForgeK15tScrollSites', 'large'),
    integrationAri: 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};





























const $c727787778fb0ffa$export$317be388f2737846 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 144 144",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M115.9,13.3c1.8,0,3.5,1,4.3,2.7c1-0.8,2.6-0.5,3.3,0.7c0.3,0.4,0.4,0.9,0.4,1.2c1.7,0.2,3.1,1.6,3.3,3.3v0.3      c0,1.5-1.7,3-3.7,3h-10.9c-2.1,0-3.7-1.5-3.7-3v-0.3c0.1-1.4,1-2.6,2.4-3.2V18C111.3,15.4,113.4,13.3,115.9,13.3L115.9,13.3",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M75,130.4h-9.6c-14.9,0-27.1-10.8-27.1-23.9V29.3c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v77.2      c0,7.8,7.7,14.2,17.3,14.2h9.5c9.6,0,17.3-6.4,17.3-14.2V89c0.1-2.7,2.4-4.8,5.1-4.7c2.6,0.1,4.6,2.1,4.7,4.7v17.6      C102,119.7,89.9,130.4,75,130.4z",
        fill: "#58595B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M71.5,18.6c2.8,0,5.4,1.6,6.5,4.2c0.6-0.4,1.3-0.7,2-0.7c1.9,0,3.5,1.5,3.6,3.5c2.7,0.3,4.8,2.5,5,5.1v0.5      c0,2.3-2.5,4.7-5.7,4.7H66.3c-3.1,0-5.7-2.4-5.7-4.7v-0.5c0.1-2.2,1.5-4.1,3.6-4.9c0-0.1,0-0.1,0-0.2C64.3,21.7,67.5,18.6,71.5,18.6      L71.5,18.6",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M89.8,66.2c-0.5,0-1.1-0.2-1.5-0.6l-6-5.9c-0.4-0.4-0.7-1-0.7-1.6s0.3-1.2,0.7-1.6l6-5.4       c0.9-0.8,2.3-0.7,3.1,0.2c0.8,0.9,0.7,2.3-0.2,3.1L87,58.2l4.3,4.3c0.9,0.9,0.9,2.2,0,3.1C91,66,90.4,66.2,89.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M104.8,66.2c-0.6,0-1.1-0.2-1.6-0.7c-0.9-0.9-0.9-2.2,0-3.1l4.3-4.3l-4.3-3.8c-0.9-0.8-1-2.2-0.2-3.1       c0.8-0.9,2.2-1,3.1-0.2l6,5.4c0.4,0.4,0.7,1,0.7,1.6s-0.2,1.2-0.7,1.6l-6,5.9C105.9,66,105.3,66.2,104.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M95,69.7c-0.2,0-0.4,0-0.5-0.1c-1.2-0.3-1.9-1.5-1.6-2.7l4.8-18.5c0.3-1.2,1.5-1.9,2.7-1.6       c1.2,0.3,1.9,1.5,1.6,2.7L97.1,68C96.9,69.1,96,69.7,95,69.7z",
        fill: "#FF8300"
    })));
};





const $650bdf45a34c51e4$export$62ea9658fc6624da = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 144 144",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M115.9,13.3c1.8,0,3.5,1,4.3,2.7c1-0.8,2.6-0.5,3.3,0.7c0.3,0.4,0.4,0.9,0.4,1.2c1.7,0.2,3.1,1.6,3.3,3.3v0.3      c0,1.5-1.7,3-3.7,3h-10.9c-2.1,0-3.7-1.5-3.7-3v-0.3c0.1-1.4,1-2.6,2.4-3.2V18C111.3,15.4,113.4,13.3,115.9,13.3L115.9,13.3",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M75,130.4h-9.6c-14.9,0-27.1-10.8-27.1-23.9V29.3c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v77.2      c0,7.8,7.7,14.2,17.3,14.2h9.5c9.6,0,17.3-6.4,17.3-14.2V89c0.1-2.7,2.4-4.8,5.1-4.7c2.6,0.1,4.6,2.1,4.7,4.7v17.6      C102,119.7,89.9,130.4,75,130.4z",
        fill: "#58595B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M71.5,18.6c2.8,0,5.4,1.6,6.5,4.2c0.6-0.4,1.3-0.7,2-0.7c1.9,0,3.5,1.5,3.6,3.5c2.7,0.3,4.8,2.5,5,5.1v0.5      c0,2.3-2.5,4.7-5.7,4.7H66.3c-3.1,0-5.7-2.4-5.7-4.7v-0.5c0.1-2.2,1.5-4.1,3.6-4.9c0-0.1,0-0.1,0-0.2C64.3,21.7,67.5,18.6,71.5,18.6      L71.5,18.6",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M89.8,66.2c-0.5,0-1.1-0.2-1.5-0.6l-6-5.9c-0.4-0.4-0.7-1-0.7-1.6s0.3-1.2,0.7-1.6l6-5.4       c0.9-0.8,2.3-0.7,3.1,0.2c0.8,0.9,0.7,2.3-0.2,3.1L87,58.2l4.3,4.3c0.9,0.9,0.9,2.2,0,3.1C91,66,90.4,66.2,89.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M104.8,66.2c-0.6,0-1.1-0.2-1.6-0.7c-0.9-0.9-0.9-2.2,0-3.1l4.3-4.3l-4.3-3.8c-0.9-0.8-1-2.2-0.2-3.1       c0.8-0.9,2.2-1,3.1-0.2l6,5.4c0.4,0.4,0.7,1,0.7,1.6s-0.2,1.2-0.7,1.6l-6,5.9C105.9,66,105.3,66.2,104.8,66.2z",
        fill: "#FF8300"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M95,69.7c-0.2,0-0.4,0-0.5-0.1c-1.2-0.3-1.9-1.5-1.6-2.7l4.8-18.5c0.3-1.2,1.5-1.9,2.7-1.6       c1.2,0.3,1.9,1.5,1.6,2.7L97.1,68C96.9,69.1,96,69.7,95,69.7z",
        fill: "#FF8300"
    })));
};


const $e5b28c857fdf0c5c$export$6bbd9bc3bcb111b9 = {
    displayName: 'Scroll Sites by k15t',
    id: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    resourceType: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $c727787778fb0ffa$export$317be388f2737846), 'ForgeK15tScrollSites', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $650bdf45a34c51e4$export$62ea9658fc6624da), 'ForgeK15tScrollSites', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};


























const $0f61633f2fa75621$export$9a2f1d62325d249c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 80 80",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture-BG/64/Storage",
        fill: "#7AA116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "80",
        height: "80"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
        transform: "translate(12.999900, 11.999600)",
        fill: "#FFFFFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
        id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
    }))));
};





const $44abd307ec376fb8$export$e391bf4e4f614708 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 80 80",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture-BG/64/Storage",
        fill: "#7AA116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "80",
        height: "80"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
        transform: "translate(12.999900, 11.999600)",
        fill: "#FFFFFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
        id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
    }))));
};


const $8574ba056db51465$export$7fa480c37589b20 = {
    displayName: 'AWS by Pio',
    id: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    resourceType: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $0f61633f2fa75621$export$9a2f1d62325d249c), 'ForgePioAws', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $44abd307ec376fb8$export$e391bf4e4f614708), 'ForgePioAws', 'large'),
    integrationAri: 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};


























const $9a821397e9d592d9$export$9a2f1d62325d249c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 80 80",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture-BG/64/Storage",
        fill: "#7AA116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "80",
        height: "80"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
        transform: "translate(12.999900, 11.999600)",
        fill: "#FFFFFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
        id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
    }))));
};





const $51a6f00958dae8e3$export$e391bf4e4f614708 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 80 80",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Architecture-BG/64/Storage",
        fill: "#7AA116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "80",
        height: "80"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
        transform: "translate(12.999900, 11.999600)",
        fill: "#FFFFFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
        id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
    }))));
};


const $fd66089ec0974887$export$7fa480c37589b20 = {
    displayName: 'AWS by Pio',
    id: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    resourceType: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $9a821397e9d592d9$export$9a2f1d62325d249c), 'ForgePioAws', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $51a6f00958dae8e3$export$e391bf4e4f614708), 'ForgePioAws', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mRcqWRwqkUd4JwapGkvGHUViyySX9MVy',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $900e96bb281beab6$export$836fbefaf37221f1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 12.0837L3.90283 10.074C5.18752 11.8776 6.54357 12.7278 8.04237 12.7278C9.54117 12.7278 10.8734 11.9034 12.0867 10.0998L14.5372 12.058C12.7767 14.6345 10.5879 16 8.04237 16C5.52059 16 3.30807 14.6345 1.5 12.0837Z",
        fill: "#6686FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.01858 4.01833L3.5572 7.70378L1.5 5.3974L8.04337 0L14.5372 5.3974L12.4552 7.68L8.01858 4.01833Z",
        fill: "#FF6479"
    }));
};





const $bc8657f34a8bbda9$export$83043b67e00ef5ec = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 12.0837L3.90283 10.074C5.18752 11.8776 6.54357 12.7278 8.04237 12.7278C9.54117 12.7278 10.8734 11.9034 12.0867 10.0998L14.5372 12.058C12.7767 14.6345 10.5879 16 8.04237 16C5.52059 16 3.30807 14.6345 1.5 12.0837Z",
        fill: "#6686FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.01858 4.01833L3.5572 7.70378L1.5 5.3974L8.04337 0L14.5372 5.3974L12.4552 7.68L8.01858 4.01833Z",
        fill: "#FF6479"
    }));
};


const $7c05b0db3016cbad$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    resourceType: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $900e96bb281beab6$export$836fbefaf37221f1), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bc8657f34a8bbda9$export$83043b67e00ef5ec), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $9cabd6e7b41cef08$export$836fbefaf37221f1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 12.0837L3.90283 10.074C5.18752 11.8776 6.54357 12.7278 8.04237 12.7278C9.54117 12.7278 10.8734 11.9034 12.0867 10.0998L14.5372 12.058C12.7767 14.6345 10.5879 16 8.04237 16C5.52059 16 3.30807 14.6345 1.5 12.0837Z",
        fill: "#6686FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.01858 4.01833L3.5572 7.70378L1.5 5.3974L8.04337 0L14.5372 5.3974L12.4552 7.68L8.01858 4.01833Z",
        fill: "#FF6479"
    }));
};





const $90c3154088f0db29$export$83043b67e00ef5ec = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 12.0837L3.90283 10.074C5.18752 11.8776 6.54357 12.7278 8.04237 12.7278C9.54117 12.7278 10.8734 11.9034 12.0867 10.0998L14.5372 12.058C12.7767 14.6345 10.5879 16 8.04237 16C5.52059 16 3.30807 14.6345 1.5 12.0837Z",
        fill: "#6686FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.01858 4.01833L3.5572 7.70378L1.5 5.3974L8.04337 0L14.5372 5.3974L12.4552 7.68L8.01858 4.01833Z",
        fill: "#FF6479"
    }));
};


const $d75d90fb37537f14$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    resourceType: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $9cabd6e7b41cef08$export$836fbefaf37221f1), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $90c3154088f0db29$export$83043b67e00ef5ec), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

















const $2f591817767919b4$export$39f7ff8bf3e8ca0a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0314 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.23561C37.0888 4.43703 35.5243 3.53774 33.8078 3.53841C32.0912 3.53908 30.5275 4.43959 27.4 6.24061L10.2293 16.1287C10.102 16.202 10.0384 16.2386 9.97907 16.2733C4.1137 19.7069 0.489885 25.9755 0.441431 32.7718C0.440941 32.8405 0.440941 32.9139 0.440941 33.0608C0.440941 33.2075 0.440941 33.2808 0.44143 33.3494C0.489777 40.1381 4.10551 46.4008 9.96043 49.8371C10.0196 49.8719 10.0831 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8105 30.3668 61.6197 33.8081 61.6209C37.2493 61.6221 40.3842 59.8149 46.6539 56.2006L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5213C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1683 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3999 34.6643 43.8488 33.8072 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6449 11.9301 33.0497 11.6548 33.7244C11.5341 34.0204 11.5365 34.4754 11.5414 35.3855C11.545 36.0556 11.5468 36.3906 11.6094 36.6987C11.7497 37.3888 12.1127 38.0137 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.7499 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5458 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4417 42.9844 58.0493 43.2107 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1908 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92911 34.7912 5.92911 34.762 5.92911 34.7035V31.7889C5.92911 29.6526 7.06688 27.6781 8.91512 26.6068C10.5483 25.6601 12.5628 25.6582 14.1977 26.6019L27.3964 34.2196Z",
        fill: "#181C1F"
    }));
};





const $afb198cd36d93a6c$export$6de477beffd11496 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0314 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.23561C37.0888 4.43703 35.5243 3.53774 33.8078 3.53841C32.0912 3.53908 30.5275 4.43959 27.4 6.24061L10.2293 16.1287C10.102 16.202 10.0384 16.2386 9.97907 16.2733C4.1137 19.7069 0.489885 25.9755 0.441431 32.7718C0.440941 32.8405 0.440941 32.9139 0.440941 33.0608C0.440941 33.2075 0.440941 33.2808 0.44143 33.3494C0.489777 40.1381 4.10551 46.4008 9.96043 49.8371C10.0196 49.8719 10.0831 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8105 30.3668 61.6197 33.8081 61.6209C37.2493 61.6221 40.3842 59.8149 46.6539 56.2006L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5213C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1683 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3999 34.6643 43.8488 33.8072 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6449 11.9301 33.0497 11.6548 33.7244C11.5341 34.0204 11.5365 34.4754 11.5414 35.3855C11.545 36.0556 11.5468 36.3906 11.6094 36.6987C11.7497 37.3888 12.1127 38.0137 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.7499 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5458 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4417 42.9844 58.0493 43.2107 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1908 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92911 34.7912 5.92911 34.762 5.92911 34.7035V31.7889C5.92911 29.6526 7.06688 27.6781 8.91512 26.6068C10.5483 25.6601 12.5628 25.6582 14.1977 26.6019L27.3964 34.2196Z",
        fill: "#181C1F"
    }));
};


const $322696b3593a33f6$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    resourceType: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $2f591817767919b4$export$39f7ff8bf3e8ca0a), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $afb198cd36d93a6c$export$6de477beffd11496), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

















const $df137abff4a46348$export$39f7ff8bf3e8ca0a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0314 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.23561C37.0888 4.43703 35.5243 3.53774 33.8078 3.53841C32.0912 3.53908 30.5275 4.43959 27.4 6.24061L10.2293 16.1287C10.102 16.202 10.0384 16.2386 9.97907 16.2733C4.1137 19.7069 0.489885 25.9755 0.441431 32.7718C0.440941 32.8405 0.440941 32.9139 0.440941 33.0608C0.440941 33.2075 0.440941 33.2808 0.44143 33.3494C0.489777 40.1381 4.10551 46.4008 9.96043 49.8371C10.0196 49.8719 10.0831 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8105 30.3668 61.6197 33.8081 61.6209C37.2493 61.6221 40.3842 59.8149 46.6539 56.2006L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5213C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1683 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3999 34.6643 43.8488 33.8072 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6449 11.9301 33.0497 11.6548 33.7244C11.5341 34.0204 11.5365 34.4754 11.5414 35.3855C11.545 36.0556 11.5468 36.3906 11.6094 36.6987C11.7497 37.3888 12.1127 38.0137 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.7499 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5458 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4417 42.9844 58.0493 43.2107 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1908 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92911 34.7912 5.92911 34.762 5.92911 34.7035V31.7889C5.92911 29.6526 7.06688 27.6781 8.91512 26.6068C10.5483 25.6601 12.5628 25.6582 14.1977 26.6019L27.3964 34.2196Z",
        fill: "#181C1F"
    }));
};





const $0e3d920c34da17d6$export$6de477beffd11496 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0314 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.23561C37.0888 4.43703 35.5243 3.53774 33.8078 3.53841C32.0912 3.53908 30.5275 4.43959 27.4 6.24061L10.2293 16.1287C10.102 16.202 10.0384 16.2386 9.97907 16.2733C4.1137 19.7069 0.489885 25.9755 0.441431 32.7718C0.440941 32.8405 0.440941 32.9139 0.440941 33.0608C0.440941 33.2075 0.440941 33.2808 0.44143 33.3494C0.489777 40.1381 4.10551 46.4008 9.96043 49.8371C10.0196 49.8719 10.0831 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8105 30.3668 61.6197 33.8081 61.6209C37.2493 61.6221 40.3842 59.8149 46.6539 56.2006L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5213C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1683 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3999 34.6643 43.8488 33.8072 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6449 11.9301 33.0497 11.6548 33.7244C11.5341 34.0204 11.5365 34.4754 11.5414 35.3855C11.545 36.0556 11.5468 36.3906 11.6094 36.6987C11.7497 37.3888 12.1127 38.0137 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.7499 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5458 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4417 42.9844 58.0493 43.2107 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1908 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92911 34.7912 5.92911 34.762 5.92911 34.7035V31.7889C5.92911 29.6526 7.06688 27.6781 8.91512 26.6068C10.5483 25.6601 12.5628 25.6582 14.1977 26.6019L27.3964 34.2196Z",
        fill: "#181C1F"
    }));
};


const $ab402eddd6e59c45$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    resourceType: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $df137abff4a46348$export$39f7ff8bf3e8ca0a), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $0e3d920c34da17d6$export$6de477beffd11496), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};





























const $c7dbdba20349f3c6$export$f1d7e8d930f0538e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
        fill: "white"
    }));
};





const $28083848ba532891$export$f318f463f9328f3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
        fill: "white"
    }));
};


const $8417fb119938ebc2$export$dd7854123286bd26 = {
    displayName: 'Github by Pio',
    id: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    resourceType: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $c7dbdba20349f3c6$export$f1d7e8d930f0538e), 'ForgePioGithub', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $28083848ba532891$export$f318f463f9328f3f), 'ForgePioGithub', 'large'),
    integrationAri: 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus',
        'repository'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};



























var $k1cFs = parcelRequire("k1cFs");




const $527eebb042ced0a1$export$f318f463f9328f3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#24292E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 11h16v10H8V11z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11 13h10v1.33H11V13zm0 2.67h10v1.33H11v-1.33zm0 2.66h8v1.34H11v-1.34z",
        fill: "#24292E"
    }));
};


const $94f61214f8fa15d6$export$dd7854123286bd26 = {
    displayName: 'Github by Pio',
    id: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    resourceType: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $k1cFs.ForgePioGithubIcon), 'ForgePioGithub', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $527eebb042ced0a1$export$f318f463f9328f3f), 'ForgePioGithub', 'large'),
    integrationAri: 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus',
        'repository'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};





























const $9dd54d619052e30b$export$ccbc2eb39f3b36a7 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 380 380"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822-21.19899-55.30908c-.4236-1.08359-1.18542-1.99642-2.17699-2.62689-.98837-.63373-2.14749-.93253-3.32305-.87014-1.1689.06239-2.29195.48925-3.20809,1.21821-.90957.73554-1.56629,1.73047-1.87493,2.85346l-14.31327,43.80662h-57.90965l-14.31327-43.80662c-.30864-1.12299-.96536-2.11791-1.87493-2.85346-.91614-.72895-2.03911-1.15582-3.20809-1.21821-1.17548-.06239-2.33468.23641-3.32297.87014-.99166.63047-1.75348,1.5433-2.17707,2.62689l-21.19891,55.31237-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392,15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024,32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#e24329"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822c-10.5174,2.16062-20.20405,6.6099-28.49844,12.81593-.1346.0985-25.20497,19.05805-46.55171,35.19699,15.84998,11.98517,29.6477,22.40405,29.6477,22.40405l32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#fc6d26"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M160.34962,244.23117l15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024s-13.79772-10.41888-29.6477-22.40405c-15.85327,11.98517-29.65099,22.40405-29.65099,22.40405Z",
        fill: "#fca326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M143.44561,186.63014c-8.29111-6.20274-17.97446-10.65531-28.49507-12.81264l-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392s13.79772-10.41888,29.65099-22.40405c-21.34673-16.13894-46.42031-35.09848-46.55499-35.19699Z",
        fill: "#fc6d26"
    }));
};





const $32d28697445ce5b7$export$31ecffbb988c6a26 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 380 380"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822-21.19899-55.30908c-.4236-1.08359-1.18542-1.99642-2.17699-2.62689-.98837-.63373-2.14749-.93253-3.32305-.87014-1.1689.06239-2.29195.48925-3.20809,1.21821-.90957.73554-1.56629,1.73047-1.87493,2.85346l-14.31327,43.80662h-57.90965l-14.31327-43.80662c-.30864-1.12299-.96536-2.11791-1.87493-2.85346-.91614-.72895-2.03911-1.15582-3.20809-1.21821-1.17548-.06239-2.33468.23641-3.32297.87014-.99166.63047-1.75348,1.5433-2.17707,2.62689l-21.19891,55.31237-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392,15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024,32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#e24329"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822c-10.5174,2.16062-20.20405,6.6099-28.49844,12.81593-.1346.0985-25.20497,19.05805-46.55171,35.19699,15.84998,11.98517,29.6477,22.40405,29.6477,22.40405l32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#fc6d26"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M160.34962,244.23117l15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024s-13.79772-10.41888-29.6477-22.40405c-15.85327,11.98517-29.65099,22.40405-29.65099,22.40405Z",
        fill: "#fca326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M143.44561,186.63014c-8.29111-6.20274-17.97446-10.65531-28.49507-12.81264l-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392s13.79772-10.41888,29.65099-22.40405c-21.34673-16.13894-46.42031-35.09848-46.55499-35.19699Z",
        fill: "#fc6d26"
    }));
};


const $f3ad305cda1b73d2$export$8d71df70076b5c6 = {
    displayName: 'Gitlab by Pio',
    id: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    resourceType: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $9dd54d619052e30b$export$ccbc2eb39f3b36a7), 'ForgePioGitlab', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $32d28697445ce5b7$export$31ecffbb988c6a26), 'ForgePioGitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/psr1wBkasRuKCwsvwi4aTJNhjmlVFebC',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};





























const $2ad02bc4a9f276ff$export$ccbc2eb39f3b36a7 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 380 380"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822-21.19899-55.30908c-.4236-1.08359-1.18542-1.99642-2.17699-2.62689-.98837-.63373-2.14749-.93253-3.32305-.87014-1.1689.06239-2.29195.48925-3.20809,1.21821-.90957.73554-1.56629,1.73047-1.87493,2.85346l-14.31327,43.80662h-57.90965l-14.31327-43.80662c-.30864-1.12299-.96536-2.11791-1.87493-2.85346-.91614-.72895-2.03911-1.15582-3.20809-1.21821-1.17548-.06239-2.33468.23641-3.32297.87014-.99166.63047-1.75348,1.5433-2.17707,2.62689l-21.19891,55.31237-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392,15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024,32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#e24329"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822c-10.5174,2.16062-20.20405,6.6099-28.49844,12.81593-.1346.0985-25.20497,19.05805-46.55171,35.19699,15.84998,11.98517,29.6477,22.40405,29.6477,22.40405l32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#fc6d26"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M160.34962,244.23117l15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024s-13.79772-10.41888-29.6477-22.40405c-15.85327,11.98517-29.65099,22.40405-29.65099,22.40405Z",
        fill: "#fca326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M143.44561,186.63014c-8.29111-6.20274-17.97446-10.65531-28.49507-12.81264l-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392s13.79772-10.41888,29.65099-22.40405c-21.34673-16.13894-46.42031-35.09848-46.55499-35.19699Z",
        fill: "#fc6d26"
    }));
};





const $9db9799c8e836ec8$export$31ecffbb988c6a26 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 380 380"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822-21.19899-55.30908c-.4236-1.08359-1.18542-1.99642-2.17699-2.62689-.98837-.63373-2.14749-.93253-3.32305-.87014-1.1689.06239-2.29195.48925-3.20809,1.21821-.90957.73554-1.56629,1.73047-1.87493,2.85346l-14.31327,43.80662h-57.90965l-14.31327-43.80662c-.30864-1.12299-.96536-2.11791-1.87493-2.85346-.91614-.72895-2.03911-1.15582-3.20809-1.21821-1.17548-.06239-2.33468.23641-3.32297.87014-.99166.63047-1.75348,1.5433-2.17707,2.62689l-21.19891,55.31237-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392,15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024,32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#e24329"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M265.26416,174.37243l-.2134-.55822c-10.5174,2.16062-20.20405,6.6099-28.49844,12.81593-.1346.0985-25.20497,19.05805-46.55171,35.19699,15.84998,11.98517,29.6477,22.40405,29.6477,22.40405l32.48142-24.31511c.02958-.02299.05588-.04269.08538-.06568,13.97834-10.57977,19.32735-29.09604,13.04905-45.47796Z",
        fill: "#fc6d26"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M160.34962,244.23117l15.97151,12.09024,9.71951,7.34871c2.34117,1.77316,5.57877,1.77316,7.92002,0l9.71943-7.34871,15.96822-12.09024s-13.79772-10.41888-29.6477-22.40405c-15.85327,11.98517-29.65099,22.40405-29.65099,22.40405Z",
        fill: "#fca326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M143.44561,186.63014c-8.29111-6.20274-17.97446-10.65531-28.49507-12.81264l-.21348.55493c-6.28158,16.38521-.92929,34.90803,13.05891,45.48782.02621.01641.04922.03611.07552.05582l.18719.14119,32.29094,24.17392s13.79772-10.41888,29.65099-22.40405c-21.34673-16.13894-46.42031-35.09848-46.55499-35.19699Z",
        fill: "#fc6d26"
    }));
};


const $95f44baa24f08dad$export$8d71df70076b5c6 = {
    displayName: 'Gitlab by Pio',
    id: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    resourceType: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $2ad02bc4a9f276ff$export$ccbc2eb39f3b36a7), 'ForgePioGitlab', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $9db9799c8e836ec8$export$31ecffbb988c6a26), 'ForgePioGitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'pullRequestStatus'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

















const $1fbdeac8eb86d9af$export$a1f95679f652d1ae = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19249)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19249"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "14.6667",
        fill: "white"
    }))));
};





const $85159b162dd07a36$export$4bae7f77a341daa0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19249)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19249"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "14.6667",
        fill: "white"
    }))));
};


const $73dff8b516e2691d$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    resourceType: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $1fbdeac8eb86d9af$export$a1f95679f652d1ae), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $85159b162dd07a36$export$4bae7f77a341daa0), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

















const $4fbdee7e132e135f$export$a1f95679f652d1ae = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19249)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19249"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "14.6667",
        fill: "white"
    }))));
};





const $23cc97147dd42711$export$4bae7f77a341daa0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19249)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19249"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "14.6667",
        fill: "white"
    }))));
};


const $a65de7a9e1b52c9e$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    resourceType: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $4fbdee7e132e135f$export$a1f95679f652d1ae), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $23cc97147dd42711$export$4bae7f77a341daa0), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

















const $c12c8f034b0ae0bc$export$f1cafab080b3bd5c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 162.31 162.01"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.28,96.29c.57,20.21-8.19,35.32-25.42,45C113,154.76,87.31,162.83,59.56,162c-15.64-.5-28.15-8-36.35-21.09C7.51,115.82-.94,88.36.08,58.64.62,43,8.69,30.76,21.86,22.7,46.67,7.52,73.69-.9,103,.08c15.87.53,28.12,8.75,36.46,22.05C153.65,44.77,160.28,69.86,162.28,96.29Z",
        fill: "#000"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M92.34,111.57a31.72,31.72,0,0,1-18.88,1.08c-14.71-4-25.39-17.48-25.39-32.16a32.54,32.54,0,0,1,9.68-23.73,33,33,0,0,1,22.66-9.57h.31c15.52.17,25.36,11.89,25.44,12a3.86,3.86,0,0,0,6-4.87c-.49-.6-12.13-14.64-31.35-14.85a40.58,40.58,0,0,0-40.46,41c0,18.11,13.08,34.78,31.11,39.62a36.5,36.5,0,0,0,9.5,1.22,41,41,0,0,0,14-2.51c11.88-4.34,23.47-15.76,23.05-29a79,79,0,0,1-8.47,5.32C107.25,102.44,100,108.78,92.34,111.57Z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M121.5,71.35a61.28,61.28,0,0,1-8.35,7.21c-5.16-5-13.38-7.42-19.33-7.42-4.86,0-8.59,1.28-11.07,3.79a10.21,10.21,0,0,0-2.91,7.49c.08,5.25,3.85,10.93,14.16,11.16,5.75.14,11.37-1.72,16.29-4.24a54,54,0,0,0,7-4.27,67.35,67.35,0,0,0,9.87-8.47,3.86,3.86,0,0,0-5.67-5.25ZM94.17,85.86c-3-.07-6.56-.74-6.61-3.56a2.55,2.55,0,0,1,.69-2c.55-.56,2-1.49,5.57-1.49a23.07,23.07,0,0,1,12.33,4A26.05,26.05,0,0,1,94.17,85.86Z",
        fill: "#fff"
    }))));
};





const $747380536d18b68e$export$b49ff31395265951 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 162.31 162.01"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.28,96.29c.57,20.21-8.19,35.32-25.42,45C113,154.76,87.31,162.83,59.56,162c-15.64-.5-28.15-8-36.35-21.09C7.51,115.82-.94,88.36.08,58.64.62,43,8.69,30.76,21.86,22.7,46.67,7.52,73.69-.9,103,.08c15.87.53,28.12,8.75,36.46,22.05C153.65,44.77,160.28,69.86,162.28,96.29Z",
        fill: "#000"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M92.34,111.57a31.72,31.72,0,0,1-18.88,1.08c-14.71-4-25.39-17.48-25.39-32.16a32.54,32.54,0,0,1,9.68-23.73,33,33,0,0,1,22.66-9.57h.31c15.52.17,25.36,11.89,25.44,12a3.86,3.86,0,0,0,6-4.87c-.49-.6-12.13-14.64-31.35-14.85a40.58,40.58,0,0,0-40.46,41c0,18.11,13.08,34.78,31.11,39.62a36.5,36.5,0,0,0,9.5,1.22,41,41,0,0,0,14-2.51c11.88-4.34,23.47-15.76,23.05-29a79,79,0,0,1-8.47,5.32C107.25,102.44,100,108.78,92.34,111.57Z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M121.5,71.35a61.28,61.28,0,0,1-8.35,7.21c-5.16-5-13.38-7.42-19.33-7.42-4.86,0-8.59,1.28-11.07,3.79a10.21,10.21,0,0,0-2.91,7.49c.08,5.25,3.85,10.93,14.16,11.16,5.75.14,11.37-1.72,16.29-4.24a54,54,0,0,0,7-4.27,67.35,67.35,0,0,0,9.87-8.47,3.86,3.86,0,0,0-5.67-5.25ZM94.17,85.86c-3-.07-6.56-.74-6.61-3.56a2.55,2.55,0,0,1,.69-2c.55-.56,2-1.49,5.57-1.49a23.07,23.07,0,0,1,12.33,4A26.05,26.05,0,0,1,94.17,85.86Z",
        fill: "#fff"
    }))));
};


const $4ed33cc7fc6a574f$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    resourceType: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $c12c8f034b0ae0bc$export$f1cafab080b3bd5c), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $747380536d18b68e$export$b49ff31395265951), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

















const $946ae47f18260645$export$f1cafab080b3bd5c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 162.31 162.01"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.28,96.29c.57,20.21-8.19,35.32-25.42,45C113,154.76,87.31,162.83,59.56,162c-15.64-.5-28.15-8-36.35-21.09C7.51,115.82-.94,88.36.08,58.64.62,43,8.69,30.76,21.86,22.7,46.67,7.52,73.69-.9,103,.08c15.87.53,28.12,8.75,36.46,22.05C153.65,44.77,160.28,69.86,162.28,96.29Z",
        fill: "#000"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M92.34,111.57a31.72,31.72,0,0,1-18.88,1.08c-14.71-4-25.39-17.48-25.39-32.16a32.54,32.54,0,0,1,9.68-23.73,33,33,0,0,1,22.66-9.57h.31c15.52.17,25.36,11.89,25.44,12a3.86,3.86,0,0,0,6-4.87c-.49-.6-12.13-14.64-31.35-14.85a40.58,40.58,0,0,0-40.46,41c0,18.11,13.08,34.78,31.11,39.62a36.5,36.5,0,0,0,9.5,1.22,41,41,0,0,0,14-2.51c11.88-4.34,23.47-15.76,23.05-29a79,79,0,0,1-8.47,5.32C107.25,102.44,100,108.78,92.34,111.57Z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M121.5,71.35a61.28,61.28,0,0,1-8.35,7.21c-5.16-5-13.38-7.42-19.33-7.42-4.86,0-8.59,1.28-11.07,3.79a10.21,10.21,0,0,0-2.91,7.49c.08,5.25,3.85,10.93,14.16,11.16,5.75.14,11.37-1.72,16.29-4.24a54,54,0,0,0,7-4.27,67.35,67.35,0,0,0,9.87-8.47,3.86,3.86,0,0,0-5.67-5.25ZM94.17,85.86c-3-.07-6.56-.74-6.61-3.56a2.55,2.55,0,0,1,.69-2c.55-.56,2-1.49,5.57-1.49a23.07,23.07,0,0,1,12.33,4A26.05,26.05,0,0,1,94.17,85.86Z",
        fill: "#fff"
    }))));
};





const $afce7d5e0814155a$export$b49ff31395265951 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 162.31 162.01"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.28,96.29c.57,20.21-8.19,35.32-25.42,45C113,154.76,87.31,162.83,59.56,162c-15.64-.5-28.15-8-36.35-21.09C7.51,115.82-.94,88.36.08,58.64.62,43,8.69,30.76,21.86,22.7,46.67,7.52,73.69-.9,103,.08c15.87.53,28.12,8.75,36.46,22.05C153.65,44.77,160.28,69.86,162.28,96.29Z",
        fill: "#000"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M92.34,111.57a31.72,31.72,0,0,1-18.88,1.08c-14.71-4-25.39-17.48-25.39-32.16a32.54,32.54,0,0,1,9.68-23.73,33,33,0,0,1,22.66-9.57h.31c15.52.17,25.36,11.89,25.44,12a3.86,3.86,0,0,0,6-4.87c-.49-.6-12.13-14.64-31.35-14.85a40.58,40.58,0,0,0-40.46,41c0,18.11,13.08,34.78,31.11,39.62a36.5,36.5,0,0,0,9.5,1.22,41,41,0,0,0,14-2.51c11.88-4.34,23.47-15.76,23.05-29a79,79,0,0,1-8.47,5.32C107.25,102.44,100,108.78,92.34,111.57Z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M121.5,71.35a61.28,61.28,0,0,1-8.35,7.21c-5.16-5-13.38-7.42-19.33-7.42-4.86,0-8.59,1.28-11.07,3.79a10.21,10.21,0,0,0-2.91,7.49c.08,5.25,3.85,10.93,14.16,11.16,5.75.14,11.37-1.72,16.29-4.24a54,54,0,0,0,7-4.27,67.35,67.35,0,0,0,9.87-8.47,3.86,3.86,0,0,0-5.67-5.25ZM94.17,85.86c-3-.07-6.56-.74-6.61-3.56a2.55,2.55,0,0,1,.69-2c.55-.56,2-1.49,5.57-1.49a23.07,23.07,0,0,1,12.33,4A26.05,26.05,0,0,1,94.17,85.86Z",
        fill: "#fff"
    }))));
};


const $9a4ee06822418e28$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    resourceType: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $946ae47f18260645$export$f1cafab080b3bd5c), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $afce7d5e0814155a$export$b49ff31395265951), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};














const $aa1802475e84838d$export$7640ce31f2af22a2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 108 108",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54.2,38.2c0,0,10.9,14.3,10.9,20.5c0,6.1-5,11.1-11.1,11.1s-11.1-5-11.1-11.1C42.9,52.5,54.2,38.2,54.2,38.2z",
        fill: "#5DA3D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54,2.7C25.7,2.7,2.7,25.7,2.7,54s23,51.3,51.3,51.3s51.3-23,51.3-51.3S82.3,2.7,54,2.7z M71.3,12.1       c11.1,4.6,20,13.5,24.6,24.6l-10.4,4.3c-3.5-8.4-10.1-15.1-18.5-18.5L71.3,12.1z M36.7,12.1l4.3,10.4c-8.4,3.5-15.1,10.1-18.5,18.5       l-10.4-4.3C16.7,25.5,25.5,16.7,36.7,12.1z M36.7,95.9c-11.1-4.6-20-13.5-24.6-24.6l10.4-4.3c3.5,8.4,10.1,15.1,18.5,18.5       L36.7,95.9z M25.9,54c0-15.5,12.6-28.1,28.1-28.1S82.1,38.5,82.1,54S69.5,82.1,54,82.1S25.9,69.5,25.9,54z M71.3,95.9l-4.3-10.4       c8.4-3.5,15.1-10.1,18.5-18.5l10.4,4.3C91.3,82.5,82.5,91.3,71.3,95.9z",
        fill: "#5DA3D9"
    })));
};





const $bb5834a81ac68acf$export$2782a2dcd42b923c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 108 108",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54.2,38.2c0,0,10.9,14.3,10.9,20.5c0,6.1-5,11.1-11.1,11.1s-11.1-5-11.1-11.1C42.9,52.5,54.2,38.2,54.2,38.2z",
        fill: "#5DA3D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54,2.7C25.7,2.7,2.7,25.7,2.7,54s23,51.3,51.3,51.3s51.3-23,51.3-51.3S82.3,2.7,54,2.7z M71.3,12.1       c11.1,4.6,20,13.5,24.6,24.6l-10.4,4.3c-3.5-8.4-10.1-15.1-18.5-18.5L71.3,12.1z M36.7,12.1l4.3,10.4c-8.4,3.5-15.1,10.1-18.5,18.5       l-10.4-4.3C16.7,25.5,25.5,16.7,36.7,12.1z M36.7,95.9c-11.1-4.6-20-13.5-24.6-24.6l10.4-4.3c3.5,8.4,10.1,15.1,18.5,18.5       L36.7,95.9z M25.9,54c0-15.5,12.6-28.1,28.1-28.1S82.1,38.5,82.1,54S69.5,82.1,54,82.1S25.9,69.5,25.9,54z M71.3,95.9l-4.3-10.4       c8.4-3.5,15.1-10.1,18.5-18.5l10.4,4.3C91.3,82.5,82.5,91.3,71.3,95.9z",
        fill: "#5DA3D9"
    })));
};


const $e4de17f58f86b9a7$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    resourceType: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $aa1802475e84838d$export$7640ce31f2af22a2), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bb5834a81ac68acf$export$2782a2dcd42b923c), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};














const $b8ae887abfcc8436$export$7640ce31f2af22a2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 108 108",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54.2,38.2c0,0,10.9,14.3,10.9,20.5c0,6.1-5,11.1-11.1,11.1s-11.1-5-11.1-11.1C42.9,52.5,54.2,38.2,54.2,38.2z",
        fill: "#5DA3D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54,2.7C25.7,2.7,2.7,25.7,2.7,54s23,51.3,51.3,51.3s51.3-23,51.3-51.3S82.3,2.7,54,2.7z M71.3,12.1       c11.1,4.6,20,13.5,24.6,24.6l-10.4,4.3c-3.5-8.4-10.1-15.1-18.5-18.5L71.3,12.1z M36.7,12.1l4.3,10.4c-8.4,3.5-15.1,10.1-18.5,18.5       l-10.4-4.3C16.7,25.5,25.5,16.7,36.7,12.1z M36.7,95.9c-11.1-4.6-20-13.5-24.6-24.6l10.4-4.3c3.5,8.4,10.1,15.1,18.5,18.5       L36.7,95.9z M25.9,54c0-15.5,12.6-28.1,28.1-28.1S82.1,38.5,82.1,54S69.5,82.1,54,82.1S25.9,69.5,25.9,54z M71.3,95.9l-4.3-10.4       c8.4-3.5,15.1-10.1,18.5-18.5l10.4,4.3C91.3,82.5,82.5,91.3,71.3,95.9z",
        fill: "#5DA3D9"
    })));
};





const $f82f137b64228d79$export$2782a2dcd42b923c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 108 108",
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54.2,38.2c0,0,10.9,14.3,10.9,20.5c0,6.1-5,11.1-11.1,11.1s-11.1-5-11.1-11.1C42.9,52.5,54.2,38.2,54.2,38.2z",
        fill: "#5DA3D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M54,2.7C25.7,2.7,2.7,25.7,2.7,54s23,51.3,51.3,51.3s51.3-23,51.3-51.3S82.3,2.7,54,2.7z M71.3,12.1       c11.1,4.6,20,13.5,24.6,24.6l-10.4,4.3c-3.5-8.4-10.1-15.1-18.5-18.5L71.3,12.1z M36.7,12.1l4.3,10.4c-8.4,3.5-15.1,10.1-18.5,18.5       l-10.4-4.3C16.7,25.5,25.5,16.7,36.7,12.1z M36.7,95.9c-11.1-4.6-20-13.5-24.6-24.6l10.4-4.3c3.5,8.4,10.1,15.1,18.5,18.5       L36.7,95.9z M25.9,54c0-15.5,12.6-28.1,28.1-28.1S82.1,38.5,82.1,54S69.5,82.1,54,82.1S25.9,69.5,25.9,54z M71.3,95.9l-4.3-10.4       c8.4-3.5,15.1-10.1,18.5-18.5l10.4,4.3C91.3,82.5,82.5,91.3,71.3,95.9z",
        fill: "#5DA3D9"
    })));
};


const $36175e0dbbb11525$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    resourceType: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $b8ae887abfcc8436$export$7640ce31f2af22a2), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $f82f137b64228d79$export$2782a2dcd42b923c), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $4093f4b1c5ac60ea$export$e87bb425fde16105 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "512",
        cy: "512",
        r: "512",
        fill: "#ff7a59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M623.8 624.94c-38.23 0-69.24-30.67-69.24-68.51s31-68.52 69.24-68.52 69.26 30.67 69.26 68.52-31 68.51-69.26 68.51m20.74-200.42v-61a46.83 46.83 0 0 0 27.33-42.29v-1.41c0-25.78-21.32-46.86-47.35-46.86h-1.43c-26 0-47.35 21.09-47.35 46.86v1.41a46.85 46.85 0 0 0 27.33 42.29v61a135.08 135.08 0 0 0-63.86 27.79l-169.1-130.17A52.49 52.49 0 0 0 372 309c0-29.21-23.89-52.92-53.4-53s-53.45 23.59-53.48 52.81 23.85 52.88 53.36 52.93a53.29 53.29 0 0 0 26.33-7.09l166.38 128.1a132.14 132.14 0 0 0 2.07 150.3l-50.62 50.1A43.42 43.42 0 1 0 450.1 768c24.24 0 43.9-19.46 43.9-43.45a42.24 42.24 0 0 0-2-12.42l50-49.52a135.28 135.28 0 0 0 81.8 27.47c74.61 0 135.06-59.83 135.06-133.65 0-66.82-49.62-122-114.33-131.91",
        fill: "#fff",
        fillRule: "evenodd"
    }));
};





const $43e9e11379030912$export$cc1026e3c5b549e1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "512",
        cy: "512",
        r: "512",
        fill: "#ff7a59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M623.8 624.94c-38.23 0-69.24-30.67-69.24-68.51s31-68.52 69.24-68.52 69.26 30.67 69.26 68.52-31 68.51-69.26 68.51m20.74-200.42v-61a46.83 46.83 0 0 0 27.33-42.29v-1.41c0-25.78-21.32-46.86-47.35-46.86h-1.43c-26 0-47.35 21.09-47.35 46.86v1.41a46.85 46.85 0 0 0 27.33 42.29v61a135.08 135.08 0 0 0-63.86 27.79l-169.1-130.17A52.49 52.49 0 0 0 372 309c0-29.21-23.89-52.92-53.4-53s-53.45 23.59-53.48 52.81 23.85 52.88 53.36 52.93a53.29 53.29 0 0 0 26.33-7.09l166.38 128.1a132.14 132.14 0 0 0 2.07 150.3l-50.62 50.1A43.42 43.42 0 1 0 450.1 768c24.24 0 43.9-19.46 43.9-43.45a42.24 42.24 0 0 0-2-12.42l50-49.52a135.28 135.28 0 0 0 81.8 27.47c74.61 0 135.06-59.83 135.06-133.65 0-66.82-49.62-122-114.33-131.91",
        fill: "#fff",
        fillRule: "evenodd"
    }));
};


const $ad617a1c23894f73$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    resourceType: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $4093f4b1c5ac60ea$export$e87bb425fde16105), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $43e9e11379030912$export$cc1026e3c5b549e1), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $dbe452eb3343bee0$export$e87bb425fde16105 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "512",
        cy: "512",
        r: "512",
        fill: "#ff7a59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M623.8 624.94c-38.23 0-69.24-30.67-69.24-68.51s31-68.52 69.24-68.52 69.26 30.67 69.26 68.52-31 68.51-69.26 68.51m20.74-200.42v-61a46.83 46.83 0 0 0 27.33-42.29v-1.41c0-25.78-21.32-46.86-47.35-46.86h-1.43c-26 0-47.35 21.09-47.35 46.86v1.41a46.85 46.85 0 0 0 27.33 42.29v61a135.08 135.08 0 0 0-63.86 27.79l-169.1-130.17A52.49 52.49 0 0 0 372 309c0-29.21-23.89-52.92-53.4-53s-53.45 23.59-53.48 52.81 23.85 52.88 53.36 52.93a53.29 53.29 0 0 0 26.33-7.09l166.38 128.1a132.14 132.14 0 0 0 2.07 150.3l-50.62 50.1A43.42 43.42 0 1 0 450.1 768c24.24 0 43.9-19.46 43.9-43.45a42.24 42.24 0 0 0-2-12.42l50-49.52a135.28 135.28 0 0 0 81.8 27.47c74.61 0 135.06-59.83 135.06-133.65 0-66.82-49.62-122-114.33-131.91",
        fill: "#fff",
        fillRule: "evenodd"
    }));
};





const $7c0da76a06daaad2$export$cc1026e3c5b549e1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "512",
        cy: "512",
        r: "512",
        fill: "#ff7a59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M623.8 624.94c-38.23 0-69.24-30.67-69.24-68.51s31-68.52 69.24-68.52 69.26 30.67 69.26 68.52-31 68.51-69.26 68.51m20.74-200.42v-61a46.83 46.83 0 0 0 27.33-42.29v-1.41c0-25.78-21.32-46.86-47.35-46.86h-1.43c-26 0-47.35 21.09-47.35 46.86v1.41a46.85 46.85 0 0 0 27.33 42.29v61a135.08 135.08 0 0 0-63.86 27.79l-169.1-130.17A52.49 52.49 0 0 0 372 309c0-29.21-23.89-52.92-53.4-53s-53.45 23.59-53.48 52.81 23.85 52.88 53.36 52.93a53.29 53.29 0 0 0 26.33-7.09l166.38 128.1a132.14 132.14 0 0 0 2.07 150.3l-50.62 50.1A43.42 43.42 0 1 0 450.1 768c24.24 0 43.9-19.46 43.9-43.45a42.24 42.24 0 0 0-2-12.42l50-49.52a135.28 135.28 0 0 0 81.8 27.47c74.61 0 135.06-59.83 135.06-133.65 0-66.82-49.62-122-114.33-131.91",
        fill: "#fff",
        fillRule: "evenodd"
    }));
};


const $36327b33f75a4db6$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    resourceType: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $dbe452eb3343bee0$export$e87bb425fde16105), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $7c0da76a06daaad2$export$cc1026e3c5b549e1), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $0a8d2b27064c6e0b$export$fd669dbaab8ebe1e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        version: "1.1",
        viewBox: "0 0 273 191",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Salesforce.com logo"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("desc", null, "A cloud computing company based in San Francisco, California, United States"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "a",
        d: "M0.06 0.5H272V190H0.06z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "b",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m113 21.3c8.78-9.14 21-14.8 34.5-14.8 18 0 33.6 10 42 24.9a58 58 0 0 1 23.7-5.05c32.4 0 58.7 26.5 58.7 59.2s-26.3 59.2-58.7 59.2c-3.96 0-7.82-0.398-11.6-1.15-7.35 13.1-21.4 22-37.4 22a42.7 42.7 0 0 1-18.8-4.32c-7.45 17.5-24.8 29.8-45 29.8-21.1 0-39-13.3-45.9-32a45.1 45.1 0 0 1-9.34 0.972c-25.1 0-45.4-20.6-45.4-45.9 0-17 9.14-31.8 22.7-39.8a52.6 52.6 0 0 1-4.35-21c0-29.2 23.7-52.8 52.9-52.8 17.1 0 32.4 8.15 42 20.8",
        fill: "#00A1E0",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m39.4 99.3c-0.171 0.446 0.061 0.539 0.116 0.618 0.511 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.92-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.26 0.799 7.09 1.81 0 0 0.542 0.35 0.739-0.173 0.107-0.283 1.04-2.78 1.14-3.06 0.106-0.293-0.08-0.514-0.271-0.628-2.1-1.28-5-2.15-8-2.15l-0.557 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.592 0.184c2.68 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.941 0-3.94-0.016-7.19-2.07-0.393-0.229-0.617-0.394-0.92-0.579-0.16-0.097-0.56-0.272-0.734 0.252l-1.1 3.06m81.7 0c-0.171 0.446 0.061 0.539 0.118 0.618 0.509 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.91-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.25 0.799 7.09 1.81 0 0 0.542 0.35 0.74-0.173 0.106-0.283 1.04-2.78 1.13-3.06 0.107-0.293-0.08-0.514-0.27-0.628-2.1-1.28-5-2.15-8-2.15l-0.558 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.591 0.184c2.69 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.943 0-3.95-0.016-7.19-2.07-0.393-0.229-0.623-0.387-0.921-0.579-0.101-0.064-0.572-0.248-0.733 0.252l-1.1 3.06m55.8-9.36c0 2.7-0.504 4.83-1.49 6.34-0.984 1.49-2.47 2.22-4.54 2.22s-3.55-0.724-4.52-2.21c-0.977-1.5-1.47-3.64-1.47-6.34 0-2.7 0.496-4.82 1.47-6.31 0.968-1.48 2.44-2.19 4.52-2.19s3.56 0.717 4.54 2.19c0.992 1.49 1.49 3.61 1.49 6.31m4.66-5.01c-0.459-1.55-1.17-2.91-2.12-4.05-0.951-1.14-2.15-2.06-3.58-2.72-1.42-0.665-3.1-1-5-1s-3.57 0.337-5 1c-1.42 0.664-2.63 1.58-3.58 2.72-0.948 1.14-1.66 2.5-2.12 4.05-0.455 1.54-0.686 3.22-0.686 5.01 0 1.79 0.231 3.47 0.686 5.01 0.457 1.55 1.17 2.91 2.12 4.05 0.951 1.14 2.16 2.05 3.58 2.7 1.43 0.648 3.11 0.978 5 0.978 1.89 0 3.57-0.33 4.99-0.978 1.42-0.648 2.63-1.56 3.58-2.7 0.949-1.14 1.66-2.5 2.12-4.05 0.454-1.54 0.685-3.22 0.685-5.01 0-1.78-0.231-3.47-0.685-5.01m38.3 12.8c-0.153-0.453-0.595-0.282-0.595-0.282-0.677 0.259-1.4 0.499-2.17 0.619-0.776 0.122-1.64 0.183-2.55 0.183-2.25 0-4.05-0.671-5.33-2-1.29-1.33-2.01-3.47-2-6.37 0.007-2.64 0.645-4.62 1.79-6.14 1.13-1.5 2.87-2.28 5.17-2.28 1.92 0 3.39 0.223 4.93 0.705 0 0 0.365 0.159 0.54-0.322 0.409-1.13 0.711-1.94 1.15-3.18 0.124-0.355-0.18-0.505-0.291-0.548-0.604-0.236-2.03-0.623-3.11-0.786-1.01-0.154-2.18-0.234-3.5-0.234-1.96 0-3.7 0.335-5.19 0.999-1.49 0.663-2.75 1.58-3.75 2.72-1 1.14-1.76 2.5-2.27 4.05-0.505 1.54-0.76 3.23-0.76 5.02 0 3.86 1.04 6.99 3.1 9.28 2.06 2.3 5.16 3.46 9.2 3.46 2.39 0 4.84-0.483 6.6-1.18 0 0 0.336-0.162 0.19-0.554l-1.15-3.16m8.15-10.4c0.223-1.5 0.634-2.75 1.28-3.72 0.967-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.65 0.975 0.934 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.397-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.959 1.16-1.68 2.53-2.14 4.1-0.46 1.55-0.692 3.25-0.692 5.03 0 1.82 0.241 3.51 0.715 5.04 0.479 1.54 1.25 2.89 2.29 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.52 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.175-0.098 0.34-0.267 0.134-0.754l-1.03-2.89c-0.158-0.431-0.594-0.275-0.594-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.45-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.471-6.79zm-142 3.3c0.223-1.5 0.635-2.75 1.28-3.72 0.968-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.649 0.975 0.933 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.396-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.957 1.16-1.68 2.53-2.14 4.1-0.459 1.55-0.69 3.25-0.69 5.03 0 1.82 0.239 3.51 0.716 5.04 0.478 1.54 1.25 2.89 2.28 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.51 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.174-0.098 0.34-0.267 0.133-0.754l-1.03-2.89c-0.159-0.431-0.595-0.275-0.595-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.44-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.472-6.79zm-49.8 13.6c-0.619-0.494-0.705-0.615-0.91-0.936-0.313-0.483-0.473-1.17-0.473-2.05 0-1.38 0.46-2.38 1.41-3.05-0.01 0.002 1.36-1.18 4.58-1.14a32 32 0 0 1 4.28 0.365v7.17h0.002s-2 0.431-4.26 0.567c-3.21 0.193-4.63-0.924-4.62-0.921zm6.28-11.1c-0.64-0.047-1.47-0.07-2.46-0.07-1.35 0-2.66 0.168-3.88 0.498-1.23 0.332-2.34 0.846-3.29 1.53a7.63 7.63 0 0 0-2.29 2.6c-0.559 1.04-0.844 2.26-0.844 3.64 0 1.4 0.243 2.61 0.723 3.6a6.54 6.54 0 0 0 2.06 2.47c0.877 0.638 1.96 1.11 3.21 1.39 1.24 0.283 2.64 0.426 4.18 0.426 1.62 0 3.23-0.136 4.79-0.399a95.1 95.1 0 0 0 3.97-0.772c0.526-0.121 1.11-0.28 1.11-0.28 0.39-0.099 0.36-0.516 0.36-0.516l-0.009-14.4c0-3.16-0.844-5.51-2.51-6.96-1.66-1.45-4.09-2.18-7.24-2.18-1.18 0-3.09 0.16-4.23 0.389 0 0-3.44 0.668-4.86 1.78 0 0-0.312 0.192-0.142 0.627l1.12 3c0.139 0.389 0.518 0.256 0.518 0.256s0.119-0.047 0.259-0.13c3.03-1.65 6.87-1.6 6.87-1.6 1.7 0 3.02 0.345 3.9 1.02 0.861 0.661 1.3 1.66 1.3 3.76v0.667c-1.35-0.196-2.6-0.309-2.6-0.309zm127-8.13a0.428 0.428 0 0 0-0.237-0.568c-0.269-0.102-1.61-0.385-2.64-0.449-1.98-0.124-3.08 0.21-4.07 0.654-0.978 0.441-2.06 1.15-2.66 1.97l-0.002-1.92c0-0.264-0.187-0.477-0.453-0.477h-4.04c-0.262 0-0.452 0.213-0.452 0.477v23.5a0.48 0.48 0 0 0 0.479 0.479h4.14a0.479 0.479 0 0 0 0.478-0.479v-11.8c0-1.58 0.174-3.15 0.521-4.14 0.342-0.979 0.807-1.76 1.38-2.32a4.79 4.79 0 0 1 1.95-1.17 7.68 7.68 0 0 1 2.12-0.298c0.825 0 1.73 0.212 1.73 0.212 0.304 0.034 0.473-0.152 0.576-0.426 0.271-0.721 1.04-2.88 1.19-3.31",
        fill: "#FFFFFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.201 67.548a13.258 13.258 0 0 0-1.559-.37 12.217 12.217 0 0 0-2.144-.166c-2.853 0-5.102.806-6.681 2.398-1.568 1.58-2.635 3.987-3.17 7.154l-.193 1.069h-3.581s-.437-.018-.529.459l-.588 3.28c-.041.314.094.51.514.508h3.486l-3.537 19.743c-.277 1.59-.594 2.898-.945 3.889-.346.978-.684 1.711-1.1 2.243-.403.515-.785.894-1.444 1.115-.544.183-1.17.267-1.856.267-.382 0-.89-.064-1.265-.139-.375-.074-.57-.158-.851-.276 0 0-.409-.156-.57.254-.131.335-1.06 2.89-1.17 3.206-.112.312.045.558.243.629.464.166.809.272 1.441.421.878.207 1.618.22 2.311.22 1.452 0 2.775-.204 3.872-.6 1.104-.399 2.065-1.094 2.915-2.035.919-1.015 1.497-2.078 2.05-3.528.547-1.437 1.013-3.221 1.386-5.3l3.554-20.109h5.196s.438.016.529-.459l.588-3.28c.041-.314-.093-.51-.515-.508h-5.043c.025-.114.254-1.888.833-3.558.247-.713.712-1.288 1.106-1.683a3.273 3.273 0 0 1 1.321-.822 5.48 5.48 0 0 1 1.693-.244c.475 0 .941.057 1.296.131.489.104.679.159.807.197.514.157.583.005.684-.244l1.206-3.312c.124-.356-.178-.506-.29-.55m-70.474 34.117c0 .264-.188.479-.452.479h-4.183c-.265 0-.453-.215-.453-.479V67.997c0-.263.188-.476.453-.476h4.183c.264 0 .452.213.452.476v33.668",
        fill: "#FFFFFE"
    })));
};





const $a37a9bac2677224f$export$ebba99402341b0c4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        version: "1.1",
        width: "32",
        height: "32",
        viewBox: "0 0 273 191",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Salesforce.com logo"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("desc", null, "A cloud computing company based in San Francisco, California, United States"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "a",
        d: "M0.06 0.5H272V190H0.06z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "b",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m113 21.3c8.78-9.14 21-14.8 34.5-14.8 18 0 33.6 10 42 24.9a58 58 0 0 1 23.7-5.05c32.4 0 58.7 26.5 58.7 59.2s-26.3 59.2-58.7 59.2c-3.96 0-7.82-0.398-11.6-1.15-7.35 13.1-21.4 22-37.4 22a42.7 42.7 0 0 1-18.8-4.32c-7.45 17.5-24.8 29.8-45 29.8-21.1 0-39-13.3-45.9-32a45.1 45.1 0 0 1-9.34 0.972c-25.1 0-45.4-20.6-45.4-45.9 0-17 9.14-31.8 22.7-39.8a52.6 52.6 0 0 1-4.35-21c0-29.2 23.7-52.8 52.9-52.8 17.1 0 32.4 8.15 42 20.8",
        fill: "#00A1E0",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m39.4 99.3c-0.171 0.446 0.061 0.539 0.116 0.618 0.511 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.92-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.26 0.799 7.09 1.81 0 0 0.542 0.35 0.739-0.173 0.107-0.283 1.04-2.78 1.14-3.06 0.106-0.293-0.08-0.514-0.271-0.628-2.1-1.28-5-2.15-8-2.15l-0.557 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.592 0.184c2.68 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.941 0-3.94-0.016-7.19-2.07-0.393-0.229-0.617-0.394-0.92-0.579-0.16-0.097-0.56-0.272-0.734 0.252l-1.1 3.06m81.7 0c-0.171 0.446 0.061 0.539 0.118 0.618 0.509 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.91-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.25 0.799 7.09 1.81 0 0 0.542 0.35 0.74-0.173 0.106-0.283 1.04-2.78 1.13-3.06 0.107-0.293-0.08-0.514-0.27-0.628-2.1-1.28-5-2.15-8-2.15l-0.558 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.591 0.184c2.69 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.943 0-3.95-0.016-7.19-2.07-0.393-0.229-0.623-0.387-0.921-0.579-0.101-0.064-0.572-0.248-0.733 0.252l-1.1 3.06m55.8-9.36c0 2.7-0.504 4.83-1.49 6.34-0.984 1.49-2.47 2.22-4.54 2.22s-3.55-0.724-4.52-2.21c-0.977-1.5-1.47-3.64-1.47-6.34 0-2.7 0.496-4.82 1.47-6.31 0.968-1.48 2.44-2.19 4.52-2.19s3.56 0.717 4.54 2.19c0.992 1.49 1.49 3.61 1.49 6.31m4.66-5.01c-0.459-1.55-1.17-2.91-2.12-4.05-0.951-1.14-2.15-2.06-3.58-2.72-1.42-0.665-3.1-1-5-1s-3.57 0.337-5 1c-1.42 0.664-2.63 1.58-3.58 2.72-0.948 1.14-1.66 2.5-2.12 4.05-0.455 1.54-0.686 3.22-0.686 5.01 0 1.79 0.231 3.47 0.686 5.01 0.457 1.55 1.17 2.91 2.12 4.05 0.951 1.14 2.16 2.05 3.58 2.7 1.43 0.648 3.11 0.978 5 0.978 1.89 0 3.57-0.33 4.99-0.978 1.42-0.648 2.63-1.56 3.58-2.7 0.949-1.14 1.66-2.5 2.12-4.05 0.454-1.54 0.685-3.22 0.685-5.01 0-1.78-0.231-3.47-0.685-5.01m38.3 12.8c-0.153-0.453-0.595-0.282-0.595-0.282-0.677 0.259-1.4 0.499-2.17 0.619-0.776 0.122-1.64 0.183-2.55 0.183-2.25 0-4.05-0.671-5.33-2-1.29-1.33-2.01-3.47-2-6.37 0.007-2.64 0.645-4.62 1.79-6.14 1.13-1.5 2.87-2.28 5.17-2.28 1.92 0 3.39 0.223 4.93 0.705 0 0 0.365 0.159 0.54-0.322 0.409-1.13 0.711-1.94 1.15-3.18 0.124-0.355-0.18-0.505-0.291-0.548-0.604-0.236-2.03-0.623-3.11-0.786-1.01-0.154-2.18-0.234-3.5-0.234-1.96 0-3.7 0.335-5.19 0.999-1.49 0.663-2.75 1.58-3.75 2.72-1 1.14-1.76 2.5-2.27 4.05-0.505 1.54-0.76 3.23-0.76 5.02 0 3.86 1.04 6.99 3.1 9.28 2.06 2.3 5.16 3.46 9.2 3.46 2.39 0 4.84-0.483 6.6-1.18 0 0 0.336-0.162 0.19-0.554l-1.15-3.16m8.15-10.4c0.223-1.5 0.634-2.75 1.28-3.72 0.967-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.65 0.975 0.934 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.397-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.959 1.16-1.68 2.53-2.14 4.1-0.46 1.55-0.692 3.25-0.692 5.03 0 1.82 0.241 3.51 0.715 5.04 0.479 1.54 1.25 2.89 2.29 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.52 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.175-0.098 0.34-0.267 0.134-0.754l-1.03-2.89c-0.158-0.431-0.594-0.275-0.594-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.45-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.471-6.79zm-142 3.3c0.223-1.5 0.635-2.75 1.28-3.72 0.968-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.649 0.975 0.933 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.396-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.957 1.16-1.68 2.53-2.14 4.1-0.459 1.55-0.69 3.25-0.69 5.03 0 1.82 0.239 3.51 0.716 5.04 0.478 1.54 1.25 2.89 2.28 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.51 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.174-0.098 0.34-0.267 0.133-0.754l-1.03-2.89c-0.159-0.431-0.595-0.275-0.595-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.44-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.472-6.79zm-49.8 13.6c-0.619-0.494-0.705-0.615-0.91-0.936-0.313-0.483-0.473-1.17-0.473-2.05 0-1.38 0.46-2.38 1.41-3.05-0.01 0.002 1.36-1.18 4.58-1.14a32 32 0 0 1 4.28 0.365v7.17h0.002s-2 0.431-4.26 0.567c-3.21 0.193-4.63-0.924-4.62-0.921zm6.28-11.1c-0.64-0.047-1.47-0.07-2.46-0.07-1.35 0-2.66 0.168-3.88 0.498-1.23 0.332-2.34 0.846-3.29 1.53a7.63 7.63 0 0 0-2.29 2.6c-0.559 1.04-0.844 2.26-0.844 3.64 0 1.4 0.243 2.61 0.723 3.6a6.54 6.54 0 0 0 2.06 2.47c0.877 0.638 1.96 1.11 3.21 1.39 1.24 0.283 2.64 0.426 4.18 0.426 1.62 0 3.23-0.136 4.79-0.399a95.1 95.1 0 0 0 3.97-0.772c0.526-0.121 1.11-0.28 1.11-0.28 0.39-0.099 0.36-0.516 0.36-0.516l-0.009-14.4c0-3.16-0.844-5.51-2.51-6.96-1.66-1.45-4.09-2.18-7.24-2.18-1.18 0-3.09 0.16-4.23 0.389 0 0-3.44 0.668-4.86 1.78 0 0-0.312 0.192-0.142 0.627l1.12 3c0.139 0.389 0.518 0.256 0.518 0.256s0.119-0.047 0.259-0.13c3.03-1.65 6.87-1.6 6.87-1.6 1.7 0 3.02 0.345 3.9 1.02 0.861 0.661 1.3 1.66 1.3 3.76v0.667c-1.35-0.196-2.6-0.309-2.6-0.309zm127-8.13a0.428 0.428 0 0 0-0.237-0.568c-0.269-0.102-1.61-0.385-2.64-0.449-1.98-0.124-3.08 0.21-4.07 0.654-0.978 0.441-2.06 1.15-2.66 1.97l-0.002-1.92c0-0.264-0.187-0.477-0.453-0.477h-4.04c-0.262 0-0.452 0.213-0.452 0.477v23.5a0.48 0.48 0 0 0 0.479 0.479h4.14a0.479 0.479 0 0 0 0.478-0.479v-11.8c0-1.58 0.174-3.15 0.521-4.14 0.342-0.979 0.807-1.76 1.38-2.32a4.79 4.79 0 0 1 1.95-1.17 7.68 7.68 0 0 1 2.12-0.298c0.825 0 1.73 0.212 1.73 0.212 0.304 0.034 0.473-0.152 0.576-0.426 0.271-0.721 1.04-2.88 1.19-3.31",
        fill: "#FFFFFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.201 67.548a13.258 13.258 0 0 0-1.559-.37 12.217 12.217 0 0 0-2.144-.166c-2.853 0-5.102.806-6.681 2.398-1.568 1.58-2.635 3.987-3.17 7.154l-.193 1.069h-3.581s-.437-.018-.529.459l-.588 3.28c-.041.314.094.51.514.508h3.486l-3.537 19.743c-.277 1.59-.594 2.898-.945 3.889-.346.978-.684 1.711-1.1 2.243-.403.515-.785.894-1.444 1.115-.544.183-1.17.267-1.856.267-.382 0-.89-.064-1.265-.139-.375-.074-.57-.158-.851-.276 0 0-.409-.156-.57.254-.131.335-1.06 2.89-1.17 3.206-.112.312.045.558.243.629.464.166.809.272 1.441.421.878.207 1.618.22 2.311.22 1.452 0 2.775-.204 3.872-.6 1.104-.399 2.065-1.094 2.915-2.035.919-1.015 1.497-2.078 2.05-3.528.547-1.437 1.013-3.221 1.386-5.3l3.554-20.109h5.196s.438.016.529-.459l.588-3.28c.041-.314-.093-.51-.515-.508h-5.043c.025-.114.254-1.888.833-3.558.247-.713.712-1.288 1.106-1.683a3.273 3.273 0 0 1 1.321-.822 5.48 5.48 0 0 1 1.693-.244c.475 0 .941.057 1.296.131.489.104.679.159.807.197.514.157.583.005.684-.244l1.206-3.312c.124-.356-.178-.506-.29-.55m-70.474 34.117c0 .264-.188.479-.452.479h-4.183c-.265 0-.453-.215-.453-.479V67.997c0-.263.188-.476.453-.476h4.183c.264 0 .452.213.452.476v33.668",
        fill: "#FFFFFE"
    })));
};


const $356b5f4444236554$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    resourceType: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $0a8d2b27064c6e0b$export$fd669dbaab8ebe1e), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $a37a9bac2677224f$export$ebba99402341b0c4), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $a728271d8d936a21$export$fd669dbaab8ebe1e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        version: "1.1",
        viewBox: "0 0 273 191",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Salesforce.com logo"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("desc", null, "A cloud computing company based in San Francisco, California, United States"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "a",
        d: "M0.06 0.5H272V190H0.06z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "b",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m113 21.3c8.78-9.14 21-14.8 34.5-14.8 18 0 33.6 10 42 24.9a58 58 0 0 1 23.7-5.05c32.4 0 58.7 26.5 58.7 59.2s-26.3 59.2-58.7 59.2c-3.96 0-7.82-0.398-11.6-1.15-7.35 13.1-21.4 22-37.4 22a42.7 42.7 0 0 1-18.8-4.32c-7.45 17.5-24.8 29.8-45 29.8-21.1 0-39-13.3-45.9-32a45.1 45.1 0 0 1-9.34 0.972c-25.1 0-45.4-20.6-45.4-45.9 0-17 9.14-31.8 22.7-39.8a52.6 52.6 0 0 1-4.35-21c0-29.2 23.7-52.8 52.9-52.8 17.1 0 32.4 8.15 42 20.8",
        fill: "#00A1E0",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m39.4 99.3c-0.171 0.446 0.061 0.539 0.116 0.618 0.511 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.92-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.26 0.799 7.09 1.81 0 0 0.542 0.35 0.739-0.173 0.107-0.283 1.04-2.78 1.14-3.06 0.106-0.293-0.08-0.514-0.271-0.628-2.1-1.28-5-2.15-8-2.15l-0.557 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.592 0.184c2.68 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.941 0-3.94-0.016-7.19-2.07-0.393-0.229-0.617-0.394-0.92-0.579-0.16-0.097-0.56-0.272-0.734 0.252l-1.1 3.06m81.7 0c-0.171 0.446 0.061 0.539 0.118 0.618 0.509 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.91-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.25 0.799 7.09 1.81 0 0 0.542 0.35 0.74-0.173 0.106-0.283 1.04-2.78 1.13-3.06 0.107-0.293-0.08-0.514-0.27-0.628-2.1-1.28-5-2.15-8-2.15l-0.558 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.591 0.184c2.69 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.943 0-3.95-0.016-7.19-2.07-0.393-0.229-0.623-0.387-0.921-0.579-0.101-0.064-0.572-0.248-0.733 0.252l-1.1 3.06m55.8-9.36c0 2.7-0.504 4.83-1.49 6.34-0.984 1.49-2.47 2.22-4.54 2.22s-3.55-0.724-4.52-2.21c-0.977-1.5-1.47-3.64-1.47-6.34 0-2.7 0.496-4.82 1.47-6.31 0.968-1.48 2.44-2.19 4.52-2.19s3.56 0.717 4.54 2.19c0.992 1.49 1.49 3.61 1.49 6.31m4.66-5.01c-0.459-1.55-1.17-2.91-2.12-4.05-0.951-1.14-2.15-2.06-3.58-2.72-1.42-0.665-3.1-1-5-1s-3.57 0.337-5 1c-1.42 0.664-2.63 1.58-3.58 2.72-0.948 1.14-1.66 2.5-2.12 4.05-0.455 1.54-0.686 3.22-0.686 5.01 0 1.79 0.231 3.47 0.686 5.01 0.457 1.55 1.17 2.91 2.12 4.05 0.951 1.14 2.16 2.05 3.58 2.7 1.43 0.648 3.11 0.978 5 0.978 1.89 0 3.57-0.33 4.99-0.978 1.42-0.648 2.63-1.56 3.58-2.7 0.949-1.14 1.66-2.5 2.12-4.05 0.454-1.54 0.685-3.22 0.685-5.01 0-1.78-0.231-3.47-0.685-5.01m38.3 12.8c-0.153-0.453-0.595-0.282-0.595-0.282-0.677 0.259-1.4 0.499-2.17 0.619-0.776 0.122-1.64 0.183-2.55 0.183-2.25 0-4.05-0.671-5.33-2-1.29-1.33-2.01-3.47-2-6.37 0.007-2.64 0.645-4.62 1.79-6.14 1.13-1.5 2.87-2.28 5.17-2.28 1.92 0 3.39 0.223 4.93 0.705 0 0 0.365 0.159 0.54-0.322 0.409-1.13 0.711-1.94 1.15-3.18 0.124-0.355-0.18-0.505-0.291-0.548-0.604-0.236-2.03-0.623-3.11-0.786-1.01-0.154-2.18-0.234-3.5-0.234-1.96 0-3.7 0.335-5.19 0.999-1.49 0.663-2.75 1.58-3.75 2.72-1 1.14-1.76 2.5-2.27 4.05-0.505 1.54-0.76 3.23-0.76 5.02 0 3.86 1.04 6.99 3.1 9.28 2.06 2.3 5.16 3.46 9.2 3.46 2.39 0 4.84-0.483 6.6-1.18 0 0 0.336-0.162 0.19-0.554l-1.15-3.16m8.15-10.4c0.223-1.5 0.634-2.75 1.28-3.72 0.967-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.65 0.975 0.934 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.397-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.959 1.16-1.68 2.53-2.14 4.1-0.46 1.55-0.692 3.25-0.692 5.03 0 1.82 0.241 3.51 0.715 5.04 0.479 1.54 1.25 2.89 2.29 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.52 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.175-0.098 0.34-0.267 0.134-0.754l-1.03-2.89c-0.158-0.431-0.594-0.275-0.594-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.45-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.471-6.79zm-142 3.3c0.223-1.5 0.635-2.75 1.28-3.72 0.968-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.649 0.975 0.933 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.396-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.957 1.16-1.68 2.53-2.14 4.1-0.459 1.55-0.69 3.25-0.69 5.03 0 1.82 0.239 3.51 0.716 5.04 0.478 1.54 1.25 2.89 2.28 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.51 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.174-0.098 0.34-0.267 0.133-0.754l-1.03-2.89c-0.159-0.431-0.595-0.275-0.595-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.44-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.472-6.79zm-49.8 13.6c-0.619-0.494-0.705-0.615-0.91-0.936-0.313-0.483-0.473-1.17-0.473-2.05 0-1.38 0.46-2.38 1.41-3.05-0.01 0.002 1.36-1.18 4.58-1.14a32 32 0 0 1 4.28 0.365v7.17h0.002s-2 0.431-4.26 0.567c-3.21 0.193-4.63-0.924-4.62-0.921zm6.28-11.1c-0.64-0.047-1.47-0.07-2.46-0.07-1.35 0-2.66 0.168-3.88 0.498-1.23 0.332-2.34 0.846-3.29 1.53a7.63 7.63 0 0 0-2.29 2.6c-0.559 1.04-0.844 2.26-0.844 3.64 0 1.4 0.243 2.61 0.723 3.6a6.54 6.54 0 0 0 2.06 2.47c0.877 0.638 1.96 1.11 3.21 1.39 1.24 0.283 2.64 0.426 4.18 0.426 1.62 0 3.23-0.136 4.79-0.399a95.1 95.1 0 0 0 3.97-0.772c0.526-0.121 1.11-0.28 1.11-0.28 0.39-0.099 0.36-0.516 0.36-0.516l-0.009-14.4c0-3.16-0.844-5.51-2.51-6.96-1.66-1.45-4.09-2.18-7.24-2.18-1.18 0-3.09 0.16-4.23 0.389 0 0-3.44 0.668-4.86 1.78 0 0-0.312 0.192-0.142 0.627l1.12 3c0.139 0.389 0.518 0.256 0.518 0.256s0.119-0.047 0.259-0.13c3.03-1.65 6.87-1.6 6.87-1.6 1.7 0 3.02 0.345 3.9 1.02 0.861 0.661 1.3 1.66 1.3 3.76v0.667c-1.35-0.196-2.6-0.309-2.6-0.309zm127-8.13a0.428 0.428 0 0 0-0.237-0.568c-0.269-0.102-1.61-0.385-2.64-0.449-1.98-0.124-3.08 0.21-4.07 0.654-0.978 0.441-2.06 1.15-2.66 1.97l-0.002-1.92c0-0.264-0.187-0.477-0.453-0.477h-4.04c-0.262 0-0.452 0.213-0.452 0.477v23.5a0.48 0.48 0 0 0 0.479 0.479h4.14a0.479 0.479 0 0 0 0.478-0.479v-11.8c0-1.58 0.174-3.15 0.521-4.14 0.342-0.979 0.807-1.76 1.38-2.32a4.79 4.79 0 0 1 1.95-1.17 7.68 7.68 0 0 1 2.12-0.298c0.825 0 1.73 0.212 1.73 0.212 0.304 0.034 0.473-0.152 0.576-0.426 0.271-0.721 1.04-2.88 1.19-3.31",
        fill: "#FFFFFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.201 67.548a13.258 13.258 0 0 0-1.559-.37 12.217 12.217 0 0 0-2.144-.166c-2.853 0-5.102.806-6.681 2.398-1.568 1.58-2.635 3.987-3.17 7.154l-.193 1.069h-3.581s-.437-.018-.529.459l-.588 3.28c-.041.314.094.51.514.508h3.486l-3.537 19.743c-.277 1.59-.594 2.898-.945 3.889-.346.978-.684 1.711-1.1 2.243-.403.515-.785.894-1.444 1.115-.544.183-1.17.267-1.856.267-.382 0-.89-.064-1.265-.139-.375-.074-.57-.158-.851-.276 0 0-.409-.156-.57.254-.131.335-1.06 2.89-1.17 3.206-.112.312.045.558.243.629.464.166.809.272 1.441.421.878.207 1.618.22 2.311.22 1.452 0 2.775-.204 3.872-.6 1.104-.399 2.065-1.094 2.915-2.035.919-1.015 1.497-2.078 2.05-3.528.547-1.437 1.013-3.221 1.386-5.3l3.554-20.109h5.196s.438.016.529-.459l.588-3.28c.041-.314-.093-.51-.515-.508h-5.043c.025-.114.254-1.888.833-3.558.247-.713.712-1.288 1.106-1.683a3.273 3.273 0 0 1 1.321-.822 5.48 5.48 0 0 1 1.693-.244c.475 0 .941.057 1.296.131.489.104.679.159.807.197.514.157.583.005.684-.244l1.206-3.312c.124-.356-.178-.506-.29-.55m-70.474 34.117c0 .264-.188.479-.452.479h-4.183c-.265 0-.453-.215-.453-.479V67.997c0-.263.188-.476.453-.476h4.183c.264 0 .452.213.452.476v33.668",
        fill: "#FFFFFE"
    })));
};





const $c282a6f3409a67fd$export$ebba99402341b0c4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        version: "1.1",
        width: "32",
        height: "32",
        viewBox: "0 0 273 191",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, "Salesforce.com logo"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("desc", null, "A cloud computing company based in San Francisco, California, United States"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "a",
        d: "M0.06 0.5H272V190H0.06z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "b",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#a"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m113 21.3c8.78-9.14 21-14.8 34.5-14.8 18 0 33.6 10 42 24.9a58 58 0 0 1 23.7-5.05c32.4 0 58.7 26.5 58.7 59.2s-26.3 59.2-58.7 59.2c-3.96 0-7.82-0.398-11.6-1.15-7.35 13.1-21.4 22-37.4 22a42.7 42.7 0 0 1-18.8-4.32c-7.45 17.5-24.8 29.8-45 29.8-21.1 0-39-13.3-45.9-32a45.1 45.1 0 0 1-9.34 0.972c-25.1 0-45.4-20.6-45.4-45.9 0-17 9.14-31.8 22.7-39.8a52.6 52.6 0 0 1-4.35-21c0-29.2 23.7-52.8 52.9-52.8 17.1 0 32.4 8.15 42 20.8",
        fill: "#00A1E0",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m39.4 99.3c-0.171 0.446 0.061 0.539 0.116 0.618 0.511 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.92-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.26 0.799 7.09 1.81 0 0 0.542 0.35 0.739-0.173 0.107-0.283 1.04-2.78 1.14-3.06 0.106-0.293-0.08-0.514-0.271-0.628-2.1-1.28-5-2.15-8-2.15l-0.557 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.592 0.184c2.68 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.941 0-3.94-0.016-7.19-2.07-0.393-0.229-0.617-0.394-0.92-0.579-0.16-0.097-0.56-0.272-0.734 0.252l-1.1 3.06m81.7 0c-0.171 0.446 0.061 0.539 0.118 0.618 0.509 0.37 1.03 0.638 1.55 0.939 2.78 1.47 5.4 1.9 8.14 1.9 5.58 0 9.05-2.97 9.05-7.75v-0.094c0-4.42-3.91-6.03-7.58-7.18l-0.479-0.155c-2.77-0.898-5.16-1.68-5.16-3.5v-0.093c0-1.56 1.4-2.71 3.56-2.71 2.4 0 5.25 0.799 7.09 1.81 0 0 0.542 0.35 0.74-0.173 0.106-0.283 1.04-2.78 1.13-3.06 0.107-0.293-0.08-0.514-0.27-0.628-2.1-1.28-5-2.15-8-2.15l-0.558 0.002c-5.11 0-8.68 3.09-8.68 7.51v0.095c0 4.66 3.94 6.18 7.62 7.23l0.591 0.184c2.69 0.824 5 1.54 5 3.42v0.094c0 1.73-1.51 3.02-3.93 3.02-0.943 0-3.95-0.016-7.19-2.07-0.393-0.229-0.623-0.387-0.921-0.579-0.101-0.064-0.572-0.248-0.733 0.252l-1.1 3.06m55.8-9.36c0 2.7-0.504 4.83-1.49 6.34-0.984 1.49-2.47 2.22-4.54 2.22s-3.55-0.724-4.52-2.21c-0.977-1.5-1.47-3.64-1.47-6.34 0-2.7 0.496-4.82 1.47-6.31 0.968-1.48 2.44-2.19 4.52-2.19s3.56 0.717 4.54 2.19c0.992 1.49 1.49 3.61 1.49 6.31m4.66-5.01c-0.459-1.55-1.17-2.91-2.12-4.05-0.951-1.14-2.15-2.06-3.58-2.72-1.42-0.665-3.1-1-5-1s-3.57 0.337-5 1c-1.42 0.664-2.63 1.58-3.58 2.72-0.948 1.14-1.66 2.5-2.12 4.05-0.455 1.54-0.686 3.22-0.686 5.01 0 1.79 0.231 3.47 0.686 5.01 0.457 1.55 1.17 2.91 2.12 4.05 0.951 1.14 2.16 2.05 3.58 2.7 1.43 0.648 3.11 0.978 5 0.978 1.89 0 3.57-0.33 4.99-0.978 1.42-0.648 2.63-1.56 3.58-2.7 0.949-1.14 1.66-2.5 2.12-4.05 0.454-1.54 0.685-3.22 0.685-5.01 0-1.78-0.231-3.47-0.685-5.01m38.3 12.8c-0.153-0.453-0.595-0.282-0.595-0.282-0.677 0.259-1.4 0.499-2.17 0.619-0.776 0.122-1.64 0.183-2.55 0.183-2.25 0-4.05-0.671-5.33-2-1.29-1.33-2.01-3.47-2-6.37 0.007-2.64 0.645-4.62 1.79-6.14 1.13-1.5 2.87-2.28 5.17-2.28 1.92 0 3.39 0.223 4.93 0.705 0 0 0.365 0.159 0.54-0.322 0.409-1.13 0.711-1.94 1.15-3.18 0.124-0.355-0.18-0.505-0.291-0.548-0.604-0.236-2.03-0.623-3.11-0.786-1.01-0.154-2.18-0.234-3.5-0.234-1.96 0-3.7 0.335-5.19 0.999-1.49 0.663-2.75 1.58-3.75 2.72-1 1.14-1.76 2.5-2.27 4.05-0.505 1.54-0.76 3.23-0.76 5.02 0 3.86 1.04 6.99 3.1 9.28 2.06 2.3 5.16 3.46 9.2 3.46 2.39 0 4.84-0.483 6.6-1.18 0 0 0.336-0.162 0.19-0.554l-1.15-3.16m8.15-10.4c0.223-1.5 0.634-2.75 1.28-3.72 0.967-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.65 0.975 0.934 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.397-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.959 1.16-1.68 2.53-2.14 4.1-0.46 1.55-0.692 3.25-0.692 5.03 0 1.82 0.241 3.51 0.715 5.04 0.479 1.54 1.25 2.89 2.29 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.52 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.175-0.098 0.34-0.267 0.134-0.754l-1.03-2.89c-0.158-0.431-0.594-0.275-0.594-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.45-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.471-6.79zm-142 3.3c0.223-1.5 0.635-2.75 1.28-3.72 0.968-1.48 2.44-2.29 4.51-2.29 2.07 0 3.44 0.814 4.42 2.29 0.649 0.975 0.933 2.27 1.04 3.72l-11.3-0.002zm15.7-3.3c-0.396-1.49-1.38-3-2.02-3.69-1.02-1.09-2.01-1.86-3-2.28a11.5 11.5 0 0 0-4.52-0.917c-1.97 0-3.76 0.333-5.21 1.01-1.45 0.682-2.67 1.61-3.63 2.77-0.957 1.16-1.68 2.53-2.14 4.1-0.459 1.55-0.69 3.25-0.69 5.03 0 1.82 0.239 3.51 0.716 5.04 0.478 1.54 1.25 2.89 2.28 4.01 1.04 1.13 2.37 2.01 3.97 2.63 1.59 0.615 3.51 0.934 5.73 0.927 4.56-0.015 6.96-1.03 7.94-1.58 0.174-0.098 0.34-0.267 0.133-0.754l-1.03-2.89c-0.159-0.431-0.595-0.275-0.595-0.275-1.13 0.422-2.73 1.18-6.48 1.17-2.44-0.004-4.26-0.727-5.4-1.86-1.16-1.16-1.74-2.85-1.83-5.25l15.8 0.012s0.416-0.004 0.459-0.41c0.017-0.168 0.541-3.24-0.472-6.79zm-49.8 13.6c-0.619-0.494-0.705-0.615-0.91-0.936-0.313-0.483-0.473-1.17-0.473-2.05 0-1.38 0.46-2.38 1.41-3.05-0.01 0.002 1.36-1.18 4.58-1.14a32 32 0 0 1 4.28 0.365v7.17h0.002s-2 0.431-4.26 0.567c-3.21 0.193-4.63-0.924-4.62-0.921zm6.28-11.1c-0.64-0.047-1.47-0.07-2.46-0.07-1.35 0-2.66 0.168-3.88 0.498-1.23 0.332-2.34 0.846-3.29 1.53a7.63 7.63 0 0 0-2.29 2.6c-0.559 1.04-0.844 2.26-0.844 3.64 0 1.4 0.243 2.61 0.723 3.6a6.54 6.54 0 0 0 2.06 2.47c0.877 0.638 1.96 1.11 3.21 1.39 1.24 0.283 2.64 0.426 4.18 0.426 1.62 0 3.23-0.136 4.79-0.399a95.1 95.1 0 0 0 3.97-0.772c0.526-0.121 1.11-0.28 1.11-0.28 0.39-0.099 0.36-0.516 0.36-0.516l-0.009-14.4c0-3.16-0.844-5.51-2.51-6.96-1.66-1.45-4.09-2.18-7.24-2.18-1.18 0-3.09 0.16-4.23 0.389 0 0-3.44 0.668-4.86 1.78 0 0-0.312 0.192-0.142 0.627l1.12 3c0.139 0.389 0.518 0.256 0.518 0.256s0.119-0.047 0.259-0.13c3.03-1.65 6.87-1.6 6.87-1.6 1.7 0 3.02 0.345 3.9 1.02 0.861 0.661 1.3 1.66 1.3 3.76v0.667c-1.35-0.196-2.6-0.309-2.6-0.309zm127-8.13a0.428 0.428 0 0 0-0.237-0.568c-0.269-0.102-1.61-0.385-2.64-0.449-1.98-0.124-3.08 0.21-4.07 0.654-0.978 0.441-2.06 1.15-2.66 1.97l-0.002-1.92c0-0.264-0.187-0.477-0.453-0.477h-4.04c-0.262 0-0.452 0.213-0.452 0.477v23.5a0.48 0.48 0 0 0 0.479 0.479h4.14a0.479 0.479 0 0 0 0.478-0.479v-11.8c0-1.58 0.174-3.15 0.521-4.14 0.342-0.979 0.807-1.76 1.38-2.32a4.79 4.79 0 0 1 1.95-1.17 7.68 7.68 0 0 1 2.12-0.298c0.825 0 1.73 0.212 1.73 0.212 0.304 0.034 0.473-0.152 0.576-0.426 0.271-0.721 1.04-2.88 1.19-3.31",
        fill: "#FFFFFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M162.201 67.548a13.258 13.258 0 0 0-1.559-.37 12.217 12.217 0 0 0-2.144-.166c-2.853 0-5.102.806-6.681 2.398-1.568 1.58-2.635 3.987-3.17 7.154l-.193 1.069h-3.581s-.437-.018-.529.459l-.588 3.28c-.041.314.094.51.514.508h3.486l-3.537 19.743c-.277 1.59-.594 2.898-.945 3.889-.346.978-.684 1.711-1.1 2.243-.403.515-.785.894-1.444 1.115-.544.183-1.17.267-1.856.267-.382 0-.89-.064-1.265-.139-.375-.074-.57-.158-.851-.276 0 0-.409-.156-.57.254-.131.335-1.06 2.89-1.17 3.206-.112.312.045.558.243.629.464.166.809.272 1.441.421.878.207 1.618.22 2.311.22 1.452 0 2.775-.204 3.872-.6 1.104-.399 2.065-1.094 2.915-2.035.919-1.015 1.497-2.078 2.05-3.528.547-1.437 1.013-3.221 1.386-5.3l3.554-20.109h5.196s.438.016.529-.459l.588-3.28c.041-.314-.093-.51-.515-.508h-5.043c.025-.114.254-1.888.833-3.558.247-.713.712-1.288 1.106-1.683a3.273 3.273 0 0 1 1.321-.822 5.48 5.48 0 0 1 1.693-.244c.475 0 .941.057 1.296.131.489.104.679.159.807.197.514.157.583.005.684-.244l1.206-3.312c.124-.356-.178-.506-.29-.55m-70.474 34.117c0 .264-.188.479-.452.479h-4.183c-.265 0-.453-.215-.453-.479V67.997c0-.263.188-.476.453-.476h4.183c.264 0 .452.213.452.476v33.668",
        fill: "#FFFFFE"
    })));
};


const $0bb2af70e93a0c27$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    resourceType: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $a728271d8d936a21$export$fd669dbaab8ebe1e), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $c282a6f3409a67fd$export$ebba99402341b0c4), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};














const $0cf6f52217957932$export$ecc35ba2a32c7e3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19237)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
        fill: "url(#paint0_linear_2230_19237)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_2230_19237",
        x1: "1.42208",
        y1: "3.26391",
        x2: "6.95471",
        y2: "12.6234",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#058F92"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5",
        stopColor: "#038489"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#026D71"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19237"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));
};





const $2b1579aafd6f1fde$export$ff73eba88c3a5de7 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19237)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
        fill: "url(#paint0_linear_2230_19237)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_2230_19237",
        x1: "1.42208",
        y1: "3.26391",
        x2: "6.95471",
        y2: "12.6234",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#058F92"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5",
        stopColor: "#038489"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#026D71"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19237"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));
};


const $f00421e2b7727ffe$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    resourceType: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $0cf6f52217957932$export$ecc35ba2a32c7e3f), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $2b1579aafd6f1fde$export$ff73eba88c3a5de7), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document,
                    (0, $2Znam.NounSubtypeKey).Pdf
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};














const $625c3750b0e83594$export$ecc35ba2a32c7e3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19237)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
        fill: "url(#paint0_linear_2230_19237)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_2230_19237",
        x1: "1.42208",
        y1: "3.26391",
        x2: "6.95471",
        y2: "12.6234",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#058F92"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5",
        stopColor: "#038489"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#026D71"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19237"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));
};





const $ed2f49903dccb791$export$ff73eba88c3a5de7 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19237)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
        fill: "url(#paint0_linear_2230_19237)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_2230_19237",
        x1: "1.42208",
        y1: "3.26391",
        x2: "6.95471",
        y2: "12.6234",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#058F92"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5",
        stopColor: "#038489"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#026D71"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19237"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));
};


const $d63cf58af6ba600f$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    resourceType: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $625c3750b0e83594$export$ecc35ba2a32c7e3f), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $ed2f49903dccb791$export$ff73eba88c3a5de7), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $e15b7637d9b86266$export$99bc27b78a6e71df = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 622 124"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1E1B1D",
        fillRule: "nonzero",
        d: "M142.7,76.742 L135.526,76.107 C129.895,75.654 127.716,73.383 127.716,69.568 C127.716,65.028 131.167,62.211 137.706,62.211 C142.338,62.211 146.424,63.302 149.606,65.754 L153.875,61.485 C149.875,58.216 144.156,56.673 137.8,56.673 C128.264,56.673 121.361,61.573 121.361,69.75 C121.361,77.106 125.994,81.011 134.712,81.738 L142.068,82.373 C147.244,82.828 149.515,85.007 149.515,88.912 C149.515,94.18 144.974,96.812 137.615,96.812 C132.074,96.812 127.261,95.359 123.715,91.635 L119.355,95.995 C124.26,100.717 130.163,102.443 137.701,102.443 C148.508,102.443 155.865,97.443 155.865,88.821 C155.865,80.463 150.506,77.468 142.695,76.74 L142.7,76.742 Z M198.613,56.671 C191.444,56.671 186.928,58.084 182.971,63.094 C182.917,63.163 187.261,67.386 187.261,67.386 C189.894,63.663 192.8,62.302 198.521,62.302 C206.695,62.302 209.965,65.571 209.965,72.109 L209.965,76.377 L196.527,76.377 C186.537,76.377 181.089,81.464 181.089,89.277 C180.984058,92.6262953 182.189462,95.884474 184.449,98.359 C187.265,101.266 190.897,102.446 197.072,102.446 C203.066,102.446 206.336,101.266 209.972,97.632 L209.972,101.9 L216.511,101.9 L216.511,71.565 C216.511,61.848 210.611,56.673 198.62,56.673 L198.613,56.671 Z M209.969,86.1 C209.969,89.825 209.242,92.368 207.698,93.82 C204.883,96.545 201.523,96.82 197.709,96.82 C190.625,96.82 187.445,94.367 187.445,89.19 C187.445,84.013 190.715,81.29 197.437,81.29 L209.969,81.29 L209.969,86.1 Z M242.118,62.489 C246.386,62.489 249.018,63.76 252.38,67.483 C252.38,67.483 256.758,63.228 256.722,63.19 C252.137,58.285 248.245,56.677 242.122,56.677 C230.86,56.677 222.322,64.305 222.322,79.562 C222.322,94.819 230.858,102.449 242.122,102.449 C248.297,102.449 252.202,100.813 256.834,95.819 L252.384,91.55 C249.024,95.274 246.39,96.636 242.122,96.636 C238.033212,96.7993765 234.138626,94.8861276 231.769,91.55 C229.68,88.644 228.863,85.193 228.863,79.562 C228.863,73.931 229.68,70.48 231.769,67.574 C234.138117,64.2373869 238.033165,62.3242873 242.122,62.489 L242.118,62.489 Z M298.122,57.155 L289.97,57.155 L269.71,76.875 L269.741,37.236 L263.2,37.236 L263.2,101.9 L269.74,101.9 L269.709,85.591 L277.64,77.632 L292.628,101.9 L300.71,101.9 L282.17,73.1 L298.122,57.155 Z M328.335,56.055 C321.635,56.055 317.108,58.666 314.322,61.625 C310.231,65.89 309.187,71.025 309.187,79.207 C309.187,87.475 310.231,92.607 314.322,96.876 C317.108,99.835 321.633,102.447 328.335,102.447 C335.037,102.447 339.651,99.835 342.435,96.876 C346.526,92.611 347.571,87.476 347.571,79.207 C347.571,71.026 346.526,65.89 342.435,61.625 C339.651,58.666 335.035,56.055 328.335,56.055 Z M333.645,90.261 C332.226419,91.6312106 330.305034,92.3548961 328.335,92.261 C326.391065,92.355011 324.496795,91.6295149 323.113,90.261 C320.762,87.911 320.502,83.908 320.502,79.207 C320.502,74.506 320.762,70.591 323.113,68.241 C324.49659,66.8721679 326.391005,66.1466163 328.335,66.241 C330.30511,66.1466229 332.226679,66.8703779 333.645,68.241 C335.994,70.591 336.256,74.507 336.256,79.207 C336.256,83.907 335.994,87.907 333.645,90.261 Z M377.7,56.575 L368.562,84.6 L359.336,56.573 L347.41,56.573 L364.123,101.92 L373,101.92 L389.623,56.573 L377.7,56.575 Z M408.873,56.053 C397.124,56.053 389.116,64.408 389.116,79.205 C389.116,97.571 399.387,102.445 410.092,102.445 C418.274,102.445 422.714,99.92 427.326,95.306 L420.451,88.606 C417.578,91.479 415.14,92.871 410.179,92.871 C403.825,92.871 400.257,88.606 400.257,82.771 L428.631,82.771 L428.631,77.726 C428.631,65.279 421.494,56.053 408.873,56.053 Z M400.257,75.027 C400.273614,73.3485451 400.629053,71.6907352 401.302,70.153 C402.728026,67.2748247 405.662422,65.4538855 408.8745,65.4538855 C412.086578,65.4538855 415.020974,67.2748247 416.447,70.153 C417.117747,71.6914042 417.472764,73.3488292 417.491,75.027 L400.257,75.027 Z M445.322,60.927 L445.322,56.575 L434.267,56.575 L434.267,101.922 L445.582,101.922 L445.582,74.593 C445.582,68.848 449.412,66.236 452.894,66.236 C455.1886,66.1567159 457.391459,67.1404382 458.864,68.902 L467.43,60.318 C464.296,57.184 461.163,56.053 456.724,56.053 C452.407599,56.0018792 448.269295,57.7711856 445.324,60.927 L445.322,60.927 Z M470.941,51.848 L470.941,101.876 L482.255,101.876 L482.255,66.122 L490.611,66.122 L490.611,57.506 L482.255,57.506 L482.255,52.545 C482.255,49.934 483.562,48.454 486.255,48.454 L490.607,48.454 L490.607,38.881 L484.167,38.881 C474.939,38.881 470.937,45.408 470.937,51.848 L470.941,51.848 Z M537.191,56.048 C530.491,56.048 525.963,58.659 523.178,61.618 C519.088,65.883 518.043,71.018 518.043,79.2 C518.043,87.468 519.088,92.6 523.178,96.869 C525.963,99.828 530.489,102.44 537.191,102.44 C543.893,102.44 548.507,99.828 551.291,96.869 C555.381,92.604 556.426,87.469 556.426,79.2 C556.426,71.019 555.381,65.883 551.291,61.618 C548.506,58.659 543.891,56.048 537.191,56.048 Z M542.501,90.254 C541.082419,91.6242106 539.161034,92.3478961 537.191,92.254 C535.247065,92.348011 533.352795,91.6225149 531.969,90.254 C529.619,87.904 529.358,83.901 529.358,79.2 C529.358,74.499 529.619,70.584 531.969,68.234 C533.35259,66.8651679 535.247005,66.1396163 537.191,66.234 C539.16111,66.1396229 541.082679,66.8633779 542.501,68.234 C544.85,70.584 545.112,74.5 545.112,79.2 C545.112,83.9 544.85,87.9 542.501,90.254 Z M609.883,56.57 L602.573,84.6 L593.26,56.575 L584.993,56.575 L575.765,84.6 L568.455,56.573 L556.444,56.573 L570.37,101.92 L579.683,101.92 L589.17,73.46 L598.657,101.92 L607.97,101.92 L621.809,56.573 L609.883,56.57 Z M507.3,88.257 L507.3,38.881 L495.989,38.881 L495.989,88.953 C495.989,95.394 499.907,101.922 509.219,101.922 L515.659,101.922 L515.659,92.347 L511.308,92.347 C508.436,92.347 507.308,90.955 507.308,88.257 L507.3,88.257 Z M174,64.246 L180.046,58.2 L167.666,58.2 L167.666,43.5 L161.127,43.5 L161.127,89.912 C161.127,96.541 164.941,101.9 172.57,101.9 L177.2,101.9 L177.2,96.269 L173.75,96.269 C169.573,96.269 167.666,93.816 167.666,89.73 L167.666,64.246 L174,64.246 Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("polygon", {
        fill: "#BBBBBB",
        points: "88 80 99 80 99 124 0 124 0 80 11 80 11 113 88 113"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F58025",
        fillRule: "nonzero",
        d: "M22.9878906,76.73 L77.0128906,88.085 L79.2838906,77.285 L25.2588906,65.925 L22.9878906,76.73 Z M30.1368906,50.861 L80.1828906,74.169 L84.8448906,64.16 L34.7978906,40.852 L30.1368906,50.861 Z M43.9848906,26.308 L86.4128906,61.639 L93.4788906,53.154 L51.0508906,17.824 L43.9848906,26.308 Z M71.3718906,0.192 L62.5118906,6.782 L95.4598906,51.082 L104.319891,44.493 L71.3718906,0.192 Z M22,102 L77,102 L77,91 L22,91 L22,102 Z"
    })));
};





const $26d921d08c76d828$export$9a30339a9bdbd3d6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 622 124"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1E1B1D",
        fillRule: "nonzero",
        d: "M142.7,76.742 L135.526,76.107 C129.895,75.654 127.716,73.383 127.716,69.568 C127.716,65.028 131.167,62.211 137.706,62.211 C142.338,62.211 146.424,63.302 149.606,65.754 L153.875,61.485 C149.875,58.216 144.156,56.673 137.8,56.673 C128.264,56.673 121.361,61.573 121.361,69.75 C121.361,77.106 125.994,81.011 134.712,81.738 L142.068,82.373 C147.244,82.828 149.515,85.007 149.515,88.912 C149.515,94.18 144.974,96.812 137.615,96.812 C132.074,96.812 127.261,95.359 123.715,91.635 L119.355,95.995 C124.26,100.717 130.163,102.443 137.701,102.443 C148.508,102.443 155.865,97.443 155.865,88.821 C155.865,80.463 150.506,77.468 142.695,76.74 L142.7,76.742 Z M198.613,56.671 C191.444,56.671 186.928,58.084 182.971,63.094 C182.917,63.163 187.261,67.386 187.261,67.386 C189.894,63.663 192.8,62.302 198.521,62.302 C206.695,62.302 209.965,65.571 209.965,72.109 L209.965,76.377 L196.527,76.377 C186.537,76.377 181.089,81.464 181.089,89.277 C180.984058,92.6262953 182.189462,95.884474 184.449,98.359 C187.265,101.266 190.897,102.446 197.072,102.446 C203.066,102.446 206.336,101.266 209.972,97.632 L209.972,101.9 L216.511,101.9 L216.511,71.565 C216.511,61.848 210.611,56.673 198.62,56.673 L198.613,56.671 Z M209.969,86.1 C209.969,89.825 209.242,92.368 207.698,93.82 C204.883,96.545 201.523,96.82 197.709,96.82 C190.625,96.82 187.445,94.367 187.445,89.19 C187.445,84.013 190.715,81.29 197.437,81.29 L209.969,81.29 L209.969,86.1 Z M242.118,62.489 C246.386,62.489 249.018,63.76 252.38,67.483 C252.38,67.483 256.758,63.228 256.722,63.19 C252.137,58.285 248.245,56.677 242.122,56.677 C230.86,56.677 222.322,64.305 222.322,79.562 C222.322,94.819 230.858,102.449 242.122,102.449 C248.297,102.449 252.202,100.813 256.834,95.819 L252.384,91.55 C249.024,95.274 246.39,96.636 242.122,96.636 C238.033212,96.7993765 234.138626,94.8861276 231.769,91.55 C229.68,88.644 228.863,85.193 228.863,79.562 C228.863,73.931 229.68,70.48 231.769,67.574 C234.138117,64.2373869 238.033165,62.3242873 242.122,62.489 L242.118,62.489 Z M298.122,57.155 L289.97,57.155 L269.71,76.875 L269.741,37.236 L263.2,37.236 L263.2,101.9 L269.74,101.9 L269.709,85.591 L277.64,77.632 L292.628,101.9 L300.71,101.9 L282.17,73.1 L298.122,57.155 Z M328.335,56.055 C321.635,56.055 317.108,58.666 314.322,61.625 C310.231,65.89 309.187,71.025 309.187,79.207 C309.187,87.475 310.231,92.607 314.322,96.876 C317.108,99.835 321.633,102.447 328.335,102.447 C335.037,102.447 339.651,99.835 342.435,96.876 C346.526,92.611 347.571,87.476 347.571,79.207 C347.571,71.026 346.526,65.89 342.435,61.625 C339.651,58.666 335.035,56.055 328.335,56.055 Z M333.645,90.261 C332.226419,91.6312106 330.305034,92.3548961 328.335,92.261 C326.391065,92.355011 324.496795,91.6295149 323.113,90.261 C320.762,87.911 320.502,83.908 320.502,79.207 C320.502,74.506 320.762,70.591 323.113,68.241 C324.49659,66.8721679 326.391005,66.1466163 328.335,66.241 C330.30511,66.1466229 332.226679,66.8703779 333.645,68.241 C335.994,70.591 336.256,74.507 336.256,79.207 C336.256,83.907 335.994,87.907 333.645,90.261 Z M377.7,56.575 L368.562,84.6 L359.336,56.573 L347.41,56.573 L364.123,101.92 L373,101.92 L389.623,56.573 L377.7,56.575 Z M408.873,56.053 C397.124,56.053 389.116,64.408 389.116,79.205 C389.116,97.571 399.387,102.445 410.092,102.445 C418.274,102.445 422.714,99.92 427.326,95.306 L420.451,88.606 C417.578,91.479 415.14,92.871 410.179,92.871 C403.825,92.871 400.257,88.606 400.257,82.771 L428.631,82.771 L428.631,77.726 C428.631,65.279 421.494,56.053 408.873,56.053 Z M400.257,75.027 C400.273614,73.3485451 400.629053,71.6907352 401.302,70.153 C402.728026,67.2748247 405.662422,65.4538855 408.8745,65.4538855 C412.086578,65.4538855 415.020974,67.2748247 416.447,70.153 C417.117747,71.6914042 417.472764,73.3488292 417.491,75.027 L400.257,75.027 Z M445.322,60.927 L445.322,56.575 L434.267,56.575 L434.267,101.922 L445.582,101.922 L445.582,74.593 C445.582,68.848 449.412,66.236 452.894,66.236 C455.1886,66.1567159 457.391459,67.1404382 458.864,68.902 L467.43,60.318 C464.296,57.184 461.163,56.053 456.724,56.053 C452.407599,56.0018792 448.269295,57.7711856 445.324,60.927 L445.322,60.927 Z M470.941,51.848 L470.941,101.876 L482.255,101.876 L482.255,66.122 L490.611,66.122 L490.611,57.506 L482.255,57.506 L482.255,52.545 C482.255,49.934 483.562,48.454 486.255,48.454 L490.607,48.454 L490.607,38.881 L484.167,38.881 C474.939,38.881 470.937,45.408 470.937,51.848 L470.941,51.848 Z M537.191,56.048 C530.491,56.048 525.963,58.659 523.178,61.618 C519.088,65.883 518.043,71.018 518.043,79.2 C518.043,87.468 519.088,92.6 523.178,96.869 C525.963,99.828 530.489,102.44 537.191,102.44 C543.893,102.44 548.507,99.828 551.291,96.869 C555.381,92.604 556.426,87.469 556.426,79.2 C556.426,71.019 555.381,65.883 551.291,61.618 C548.506,58.659 543.891,56.048 537.191,56.048 Z M542.501,90.254 C541.082419,91.6242106 539.161034,92.3478961 537.191,92.254 C535.247065,92.348011 533.352795,91.6225149 531.969,90.254 C529.619,87.904 529.358,83.901 529.358,79.2 C529.358,74.499 529.619,70.584 531.969,68.234 C533.35259,66.8651679 535.247005,66.1396163 537.191,66.234 C539.16111,66.1396229 541.082679,66.8633779 542.501,68.234 C544.85,70.584 545.112,74.5 545.112,79.2 C545.112,83.9 544.85,87.9 542.501,90.254 Z M609.883,56.57 L602.573,84.6 L593.26,56.575 L584.993,56.575 L575.765,84.6 L568.455,56.573 L556.444,56.573 L570.37,101.92 L579.683,101.92 L589.17,73.46 L598.657,101.92 L607.97,101.92 L621.809,56.573 L609.883,56.57 Z M507.3,88.257 L507.3,38.881 L495.989,38.881 L495.989,88.953 C495.989,95.394 499.907,101.922 509.219,101.922 L515.659,101.922 L515.659,92.347 L511.308,92.347 C508.436,92.347 507.308,90.955 507.308,88.257 L507.3,88.257 Z M174,64.246 L180.046,58.2 L167.666,58.2 L167.666,43.5 L161.127,43.5 L161.127,89.912 C161.127,96.541 164.941,101.9 172.57,101.9 L177.2,101.9 L177.2,96.269 L173.75,96.269 C169.573,96.269 167.666,93.816 167.666,89.73 L167.666,64.246 L174,64.246 Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("polygon", {
        fill: "#BBBBBB",
        points: "88 80 99 80 99 124 0 124 0 80 11 80 11 113 88 113"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F58025",
        fillRule: "nonzero",
        d: "M22.9878906,76.73 L77.0128906,88.085 L79.2838906,77.285 L25.2588906,65.925 L22.9878906,76.73 Z M30.1368906,50.861 L80.1828906,74.169 L84.8448906,64.16 L34.7978906,40.852 L30.1368906,50.861 Z M43.9848906,26.308 L86.4128906,61.639 L93.4788906,53.154 L51.0508906,17.824 L43.9848906,26.308 Z M71.3718906,0.192 L62.5118906,6.782 L95.4598906,51.082 L104.319891,44.493 L71.3718906,0.192 Z M22,102 L77,102 L77,91 L22,91 L22,102 Z"
    })));
};


const $0210a041b2970961$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    resourceType: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $e15b7637d9b86266$export$99bc27b78a6e71df), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $26d921d08c76d828$export$9a30339a9bdbd3d6), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




















const $68c3ac1df44c904a$export$99bc27b78a6e71df = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 622 124"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1E1B1D",
        fillRule: "nonzero",
        d: "M142.7,76.742 L135.526,76.107 C129.895,75.654 127.716,73.383 127.716,69.568 C127.716,65.028 131.167,62.211 137.706,62.211 C142.338,62.211 146.424,63.302 149.606,65.754 L153.875,61.485 C149.875,58.216 144.156,56.673 137.8,56.673 C128.264,56.673 121.361,61.573 121.361,69.75 C121.361,77.106 125.994,81.011 134.712,81.738 L142.068,82.373 C147.244,82.828 149.515,85.007 149.515,88.912 C149.515,94.18 144.974,96.812 137.615,96.812 C132.074,96.812 127.261,95.359 123.715,91.635 L119.355,95.995 C124.26,100.717 130.163,102.443 137.701,102.443 C148.508,102.443 155.865,97.443 155.865,88.821 C155.865,80.463 150.506,77.468 142.695,76.74 L142.7,76.742 Z M198.613,56.671 C191.444,56.671 186.928,58.084 182.971,63.094 C182.917,63.163 187.261,67.386 187.261,67.386 C189.894,63.663 192.8,62.302 198.521,62.302 C206.695,62.302 209.965,65.571 209.965,72.109 L209.965,76.377 L196.527,76.377 C186.537,76.377 181.089,81.464 181.089,89.277 C180.984058,92.6262953 182.189462,95.884474 184.449,98.359 C187.265,101.266 190.897,102.446 197.072,102.446 C203.066,102.446 206.336,101.266 209.972,97.632 L209.972,101.9 L216.511,101.9 L216.511,71.565 C216.511,61.848 210.611,56.673 198.62,56.673 L198.613,56.671 Z M209.969,86.1 C209.969,89.825 209.242,92.368 207.698,93.82 C204.883,96.545 201.523,96.82 197.709,96.82 C190.625,96.82 187.445,94.367 187.445,89.19 C187.445,84.013 190.715,81.29 197.437,81.29 L209.969,81.29 L209.969,86.1 Z M242.118,62.489 C246.386,62.489 249.018,63.76 252.38,67.483 C252.38,67.483 256.758,63.228 256.722,63.19 C252.137,58.285 248.245,56.677 242.122,56.677 C230.86,56.677 222.322,64.305 222.322,79.562 C222.322,94.819 230.858,102.449 242.122,102.449 C248.297,102.449 252.202,100.813 256.834,95.819 L252.384,91.55 C249.024,95.274 246.39,96.636 242.122,96.636 C238.033212,96.7993765 234.138626,94.8861276 231.769,91.55 C229.68,88.644 228.863,85.193 228.863,79.562 C228.863,73.931 229.68,70.48 231.769,67.574 C234.138117,64.2373869 238.033165,62.3242873 242.122,62.489 L242.118,62.489 Z M298.122,57.155 L289.97,57.155 L269.71,76.875 L269.741,37.236 L263.2,37.236 L263.2,101.9 L269.74,101.9 L269.709,85.591 L277.64,77.632 L292.628,101.9 L300.71,101.9 L282.17,73.1 L298.122,57.155 Z M328.335,56.055 C321.635,56.055 317.108,58.666 314.322,61.625 C310.231,65.89 309.187,71.025 309.187,79.207 C309.187,87.475 310.231,92.607 314.322,96.876 C317.108,99.835 321.633,102.447 328.335,102.447 C335.037,102.447 339.651,99.835 342.435,96.876 C346.526,92.611 347.571,87.476 347.571,79.207 C347.571,71.026 346.526,65.89 342.435,61.625 C339.651,58.666 335.035,56.055 328.335,56.055 Z M333.645,90.261 C332.226419,91.6312106 330.305034,92.3548961 328.335,92.261 C326.391065,92.355011 324.496795,91.6295149 323.113,90.261 C320.762,87.911 320.502,83.908 320.502,79.207 C320.502,74.506 320.762,70.591 323.113,68.241 C324.49659,66.8721679 326.391005,66.1466163 328.335,66.241 C330.30511,66.1466229 332.226679,66.8703779 333.645,68.241 C335.994,70.591 336.256,74.507 336.256,79.207 C336.256,83.907 335.994,87.907 333.645,90.261 Z M377.7,56.575 L368.562,84.6 L359.336,56.573 L347.41,56.573 L364.123,101.92 L373,101.92 L389.623,56.573 L377.7,56.575 Z M408.873,56.053 C397.124,56.053 389.116,64.408 389.116,79.205 C389.116,97.571 399.387,102.445 410.092,102.445 C418.274,102.445 422.714,99.92 427.326,95.306 L420.451,88.606 C417.578,91.479 415.14,92.871 410.179,92.871 C403.825,92.871 400.257,88.606 400.257,82.771 L428.631,82.771 L428.631,77.726 C428.631,65.279 421.494,56.053 408.873,56.053 Z M400.257,75.027 C400.273614,73.3485451 400.629053,71.6907352 401.302,70.153 C402.728026,67.2748247 405.662422,65.4538855 408.8745,65.4538855 C412.086578,65.4538855 415.020974,67.2748247 416.447,70.153 C417.117747,71.6914042 417.472764,73.3488292 417.491,75.027 L400.257,75.027 Z M445.322,60.927 L445.322,56.575 L434.267,56.575 L434.267,101.922 L445.582,101.922 L445.582,74.593 C445.582,68.848 449.412,66.236 452.894,66.236 C455.1886,66.1567159 457.391459,67.1404382 458.864,68.902 L467.43,60.318 C464.296,57.184 461.163,56.053 456.724,56.053 C452.407599,56.0018792 448.269295,57.7711856 445.324,60.927 L445.322,60.927 Z M470.941,51.848 L470.941,101.876 L482.255,101.876 L482.255,66.122 L490.611,66.122 L490.611,57.506 L482.255,57.506 L482.255,52.545 C482.255,49.934 483.562,48.454 486.255,48.454 L490.607,48.454 L490.607,38.881 L484.167,38.881 C474.939,38.881 470.937,45.408 470.937,51.848 L470.941,51.848 Z M537.191,56.048 C530.491,56.048 525.963,58.659 523.178,61.618 C519.088,65.883 518.043,71.018 518.043,79.2 C518.043,87.468 519.088,92.6 523.178,96.869 C525.963,99.828 530.489,102.44 537.191,102.44 C543.893,102.44 548.507,99.828 551.291,96.869 C555.381,92.604 556.426,87.469 556.426,79.2 C556.426,71.019 555.381,65.883 551.291,61.618 C548.506,58.659 543.891,56.048 537.191,56.048 Z M542.501,90.254 C541.082419,91.6242106 539.161034,92.3478961 537.191,92.254 C535.247065,92.348011 533.352795,91.6225149 531.969,90.254 C529.619,87.904 529.358,83.901 529.358,79.2 C529.358,74.499 529.619,70.584 531.969,68.234 C533.35259,66.8651679 535.247005,66.1396163 537.191,66.234 C539.16111,66.1396229 541.082679,66.8633779 542.501,68.234 C544.85,70.584 545.112,74.5 545.112,79.2 C545.112,83.9 544.85,87.9 542.501,90.254 Z M609.883,56.57 L602.573,84.6 L593.26,56.575 L584.993,56.575 L575.765,84.6 L568.455,56.573 L556.444,56.573 L570.37,101.92 L579.683,101.92 L589.17,73.46 L598.657,101.92 L607.97,101.92 L621.809,56.573 L609.883,56.57 Z M507.3,88.257 L507.3,38.881 L495.989,38.881 L495.989,88.953 C495.989,95.394 499.907,101.922 509.219,101.922 L515.659,101.922 L515.659,92.347 L511.308,92.347 C508.436,92.347 507.308,90.955 507.308,88.257 L507.3,88.257 Z M174,64.246 L180.046,58.2 L167.666,58.2 L167.666,43.5 L161.127,43.5 L161.127,89.912 C161.127,96.541 164.941,101.9 172.57,101.9 L177.2,101.9 L177.2,96.269 L173.75,96.269 C169.573,96.269 167.666,93.816 167.666,89.73 L167.666,64.246 L174,64.246 Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("polygon", {
        fill: "#BBBBBB",
        points: "88 80 99 80 99 124 0 124 0 80 11 80 11 113 88 113"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F58025",
        fillRule: "nonzero",
        d: "M22.9878906,76.73 L77.0128906,88.085 L79.2838906,77.285 L25.2588906,65.925 L22.9878906,76.73 Z M30.1368906,50.861 L80.1828906,74.169 L84.8448906,64.16 L34.7978906,40.852 L30.1368906,50.861 Z M43.9848906,26.308 L86.4128906,61.639 L93.4788906,53.154 L51.0508906,17.824 L43.9848906,26.308 Z M71.3718906,0.192 L62.5118906,6.782 L95.4598906,51.082 L104.319891,44.493 L71.3718906,0.192 Z M22,102 L77,102 L77,91 L22,91 L22,102 Z"
    })));
};





const $487f5b2e0097073f$export$9a30339a9bdbd3d6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 622 124"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1E1B1D",
        fillRule: "nonzero",
        d: "M142.7,76.742 L135.526,76.107 C129.895,75.654 127.716,73.383 127.716,69.568 C127.716,65.028 131.167,62.211 137.706,62.211 C142.338,62.211 146.424,63.302 149.606,65.754 L153.875,61.485 C149.875,58.216 144.156,56.673 137.8,56.673 C128.264,56.673 121.361,61.573 121.361,69.75 C121.361,77.106 125.994,81.011 134.712,81.738 L142.068,82.373 C147.244,82.828 149.515,85.007 149.515,88.912 C149.515,94.18 144.974,96.812 137.615,96.812 C132.074,96.812 127.261,95.359 123.715,91.635 L119.355,95.995 C124.26,100.717 130.163,102.443 137.701,102.443 C148.508,102.443 155.865,97.443 155.865,88.821 C155.865,80.463 150.506,77.468 142.695,76.74 L142.7,76.742 Z M198.613,56.671 C191.444,56.671 186.928,58.084 182.971,63.094 C182.917,63.163 187.261,67.386 187.261,67.386 C189.894,63.663 192.8,62.302 198.521,62.302 C206.695,62.302 209.965,65.571 209.965,72.109 L209.965,76.377 L196.527,76.377 C186.537,76.377 181.089,81.464 181.089,89.277 C180.984058,92.6262953 182.189462,95.884474 184.449,98.359 C187.265,101.266 190.897,102.446 197.072,102.446 C203.066,102.446 206.336,101.266 209.972,97.632 L209.972,101.9 L216.511,101.9 L216.511,71.565 C216.511,61.848 210.611,56.673 198.62,56.673 L198.613,56.671 Z M209.969,86.1 C209.969,89.825 209.242,92.368 207.698,93.82 C204.883,96.545 201.523,96.82 197.709,96.82 C190.625,96.82 187.445,94.367 187.445,89.19 C187.445,84.013 190.715,81.29 197.437,81.29 L209.969,81.29 L209.969,86.1 Z M242.118,62.489 C246.386,62.489 249.018,63.76 252.38,67.483 C252.38,67.483 256.758,63.228 256.722,63.19 C252.137,58.285 248.245,56.677 242.122,56.677 C230.86,56.677 222.322,64.305 222.322,79.562 C222.322,94.819 230.858,102.449 242.122,102.449 C248.297,102.449 252.202,100.813 256.834,95.819 L252.384,91.55 C249.024,95.274 246.39,96.636 242.122,96.636 C238.033212,96.7993765 234.138626,94.8861276 231.769,91.55 C229.68,88.644 228.863,85.193 228.863,79.562 C228.863,73.931 229.68,70.48 231.769,67.574 C234.138117,64.2373869 238.033165,62.3242873 242.122,62.489 L242.118,62.489 Z M298.122,57.155 L289.97,57.155 L269.71,76.875 L269.741,37.236 L263.2,37.236 L263.2,101.9 L269.74,101.9 L269.709,85.591 L277.64,77.632 L292.628,101.9 L300.71,101.9 L282.17,73.1 L298.122,57.155 Z M328.335,56.055 C321.635,56.055 317.108,58.666 314.322,61.625 C310.231,65.89 309.187,71.025 309.187,79.207 C309.187,87.475 310.231,92.607 314.322,96.876 C317.108,99.835 321.633,102.447 328.335,102.447 C335.037,102.447 339.651,99.835 342.435,96.876 C346.526,92.611 347.571,87.476 347.571,79.207 C347.571,71.026 346.526,65.89 342.435,61.625 C339.651,58.666 335.035,56.055 328.335,56.055 Z M333.645,90.261 C332.226419,91.6312106 330.305034,92.3548961 328.335,92.261 C326.391065,92.355011 324.496795,91.6295149 323.113,90.261 C320.762,87.911 320.502,83.908 320.502,79.207 C320.502,74.506 320.762,70.591 323.113,68.241 C324.49659,66.8721679 326.391005,66.1466163 328.335,66.241 C330.30511,66.1466229 332.226679,66.8703779 333.645,68.241 C335.994,70.591 336.256,74.507 336.256,79.207 C336.256,83.907 335.994,87.907 333.645,90.261 Z M377.7,56.575 L368.562,84.6 L359.336,56.573 L347.41,56.573 L364.123,101.92 L373,101.92 L389.623,56.573 L377.7,56.575 Z M408.873,56.053 C397.124,56.053 389.116,64.408 389.116,79.205 C389.116,97.571 399.387,102.445 410.092,102.445 C418.274,102.445 422.714,99.92 427.326,95.306 L420.451,88.606 C417.578,91.479 415.14,92.871 410.179,92.871 C403.825,92.871 400.257,88.606 400.257,82.771 L428.631,82.771 L428.631,77.726 C428.631,65.279 421.494,56.053 408.873,56.053 Z M400.257,75.027 C400.273614,73.3485451 400.629053,71.6907352 401.302,70.153 C402.728026,67.2748247 405.662422,65.4538855 408.8745,65.4538855 C412.086578,65.4538855 415.020974,67.2748247 416.447,70.153 C417.117747,71.6914042 417.472764,73.3488292 417.491,75.027 L400.257,75.027 Z M445.322,60.927 L445.322,56.575 L434.267,56.575 L434.267,101.922 L445.582,101.922 L445.582,74.593 C445.582,68.848 449.412,66.236 452.894,66.236 C455.1886,66.1567159 457.391459,67.1404382 458.864,68.902 L467.43,60.318 C464.296,57.184 461.163,56.053 456.724,56.053 C452.407599,56.0018792 448.269295,57.7711856 445.324,60.927 L445.322,60.927 Z M470.941,51.848 L470.941,101.876 L482.255,101.876 L482.255,66.122 L490.611,66.122 L490.611,57.506 L482.255,57.506 L482.255,52.545 C482.255,49.934 483.562,48.454 486.255,48.454 L490.607,48.454 L490.607,38.881 L484.167,38.881 C474.939,38.881 470.937,45.408 470.937,51.848 L470.941,51.848 Z M537.191,56.048 C530.491,56.048 525.963,58.659 523.178,61.618 C519.088,65.883 518.043,71.018 518.043,79.2 C518.043,87.468 519.088,92.6 523.178,96.869 C525.963,99.828 530.489,102.44 537.191,102.44 C543.893,102.44 548.507,99.828 551.291,96.869 C555.381,92.604 556.426,87.469 556.426,79.2 C556.426,71.019 555.381,65.883 551.291,61.618 C548.506,58.659 543.891,56.048 537.191,56.048 Z M542.501,90.254 C541.082419,91.6242106 539.161034,92.3478961 537.191,92.254 C535.247065,92.348011 533.352795,91.6225149 531.969,90.254 C529.619,87.904 529.358,83.901 529.358,79.2 C529.358,74.499 529.619,70.584 531.969,68.234 C533.35259,66.8651679 535.247005,66.1396163 537.191,66.234 C539.16111,66.1396229 541.082679,66.8633779 542.501,68.234 C544.85,70.584 545.112,74.5 545.112,79.2 C545.112,83.9 544.85,87.9 542.501,90.254 Z M609.883,56.57 L602.573,84.6 L593.26,56.575 L584.993,56.575 L575.765,84.6 L568.455,56.573 L556.444,56.573 L570.37,101.92 L579.683,101.92 L589.17,73.46 L598.657,101.92 L607.97,101.92 L621.809,56.573 L609.883,56.57 Z M507.3,88.257 L507.3,38.881 L495.989,38.881 L495.989,88.953 C495.989,95.394 499.907,101.922 509.219,101.922 L515.659,101.922 L515.659,92.347 L511.308,92.347 C508.436,92.347 507.308,90.955 507.308,88.257 L507.3,88.257 Z M174,64.246 L180.046,58.2 L167.666,58.2 L167.666,43.5 L161.127,43.5 L161.127,89.912 C161.127,96.541 164.941,101.9 172.57,101.9 L177.2,101.9 L177.2,96.269 L173.75,96.269 C169.573,96.269 167.666,93.816 167.666,89.73 L167.666,64.246 L174,64.246 Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("polygon", {
        fill: "#BBBBBB",
        points: "88 80 99 80 99 124 0 124 0 80 11 80 11 113 88 113"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F58025",
        fillRule: "nonzero",
        d: "M22.9878906,76.73 L77.0128906,88.085 L79.2838906,77.285 L25.2588906,65.925 L22.9878906,76.73 Z M30.1368906,50.861 L80.1828906,74.169 L84.8448906,64.16 L34.7978906,40.852 L30.1368906,50.861 Z M43.9848906,26.308 L86.4128906,61.639 L93.4788906,53.154 L51.0508906,17.824 L43.9848906,26.308 Z M71.3718906,0.192 L62.5118906,6.782 L95.4598906,51.082 L104.319891,44.493 L71.3718906,0.192 Z M22,102 L77,102 L77,91 L22,91 L22,102 Z"
    })));
};


const $983d12c3230f9057$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    resourceType: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $68c3ac1df44c904a$export$99bc27b78a6e71df), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $487f5b2e0097073f$export$9a30339a9bdbd3d6), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $947fa6ad1fd0f104$export$84e4ab153a34ad7e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_452)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.6504 16.0587C19.2481 16.0587 17.3008 18.0603 17.3008 20.5294C17.3008 22.9984 19.2481 25 21.6504 25C24.0527 25 26 22.9984 26 20.5294C26 18.0603 24.0527 16.0587 21.6504 16.0587ZM10.3496 16.0591C7.94742 16.0591 6 18.0603 6 20.5294C6 22.9984 7.94742 25 10.3496 25C12.752 25 14.6995 22.9984 14.6995 20.5294C14.6995 18.0603 12.752 16.0591 10.3496 16.0591ZM20.3496 10.4704C20.3496 12.9396 18.4022 14.9414 16 14.9414C13.5977 14.9414 11.6504 12.9396 11.6504 10.4704C11.6504 8.00174 13.5977 6 16 6C18.4022 6 20.3496 8.00174 20.3496 10.4704Z",
        fill: "#F06A6A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_452"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $24c23a5a425ed39a$export$cd30ec5cd19c805 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_452)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.6504 16.0587C19.2481 16.0587 17.3008 18.0603 17.3008 20.5294C17.3008 22.9984 19.2481 25 21.6504 25C24.0527 25 26 22.9984 26 20.5294C26 18.0603 24.0527 16.0587 21.6504 16.0587ZM10.3496 16.0591C7.94742 16.0591 6 18.0603 6 20.5294C6 22.9984 7.94742 25 10.3496 25C12.752 25 14.6995 22.9984 14.6995 20.5294C14.6995 18.0603 12.752 16.0591 10.3496 16.0591ZM20.3496 10.4704C20.3496 12.9396 18.4022 14.9414 16 14.9414C13.5977 14.9414 11.6504 12.9396 11.6504 10.4704C11.6504 8.00174 13.5977 6 16 6C18.4022 6 20.3496 8.00174 20.3496 10.4704Z",
        fill: "#F06A6A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_452"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $6fe983ab4249955d$export$802c434914cc51cb = {
    displayName: 'Asana by Unito',
    id: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    resourceType: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    icon: (0, $9yyKc.get3PLogo)((0, $947fa6ad1fd0f104$export$84e4ab153a34ad7e), 'ForgeUnitoAsana', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $24c23a5a425ed39a$export$cd30ec5cd19c805), 'ForgeUnitoAsana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/6wHDDwNbam77WvGwMKYMGDiTWP8pza54',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $a25ac8991c5fc5e0$export$df888f4c8633dd6a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_452)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.6504 16.0587C19.2481 16.0587 17.3008 18.0603 17.3008 20.5294C17.3008 22.9984 19.2481 25 21.6504 25C24.0527 25 26 22.9984 26 20.5294C26 18.0603 24.0527 16.0587 21.6504 16.0587ZM10.3496 16.0591C7.94742 16.0591 6 18.0603 6 20.5294C6 22.9984 7.94742 25 10.3496 25C12.752 25 14.6995 22.9984 14.6995 20.5294C14.6995 18.0603 12.752 16.0591 10.3496 16.0591ZM20.3496 10.4704C20.3496 12.9396 18.4022 14.9414 16 14.9414C13.5977 14.9414 11.6504 12.9396 11.6504 10.4704C11.6504 8.00174 13.5977 6 16 6C18.4022 6 20.3496 8.00174 20.3496 10.4704Z",
        fill: "#F06A6A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_452"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $5b235f14158f256c$export$b7301999a3358df4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_452)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.6504 16.0587C19.2481 16.0587 17.3008 18.0603 17.3008 20.5294C17.3008 22.9984 19.2481 25 21.6504 25C24.0527 25 26 22.9984 26 20.5294C26 18.0603 24.0527 16.0587 21.6504 16.0587ZM10.3496 16.0591C7.94742 16.0591 6 18.0603 6 20.5294C6 22.9984 7.94742 25 10.3496 25C12.752 25 14.6995 22.9984 14.6995 20.5294C14.6995 18.0603 12.752 16.0591 10.3496 16.0591ZM20.3496 10.4704C20.3496 12.9396 18.4022 14.9414 16 14.9414C13.5977 14.9414 11.6504 12.9396 11.6504 10.4704C11.6504 8.00174 13.5977 6 16 6C18.4022 6 20.3496 8.00174 20.3496 10.4704Z",
        fill: "#F06A6A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_452"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $70465f2afd60f039$export$802c434914cc51cb = {
    displayName: 'Asana by Unito',
    id: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    resourceType: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    icon: (0, $9yyKc.get3PLogo)((0, $a25ac8991c5fc5e0$export$df888f4c8633dd6a), 'ForgeUnitoAsana', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5b235f14158f256c$export$b7301999a3358df4), 'ForgeUnitoAsana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $704ba21c4cc655e8$export$ed9e7ffb4c370ac = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_525)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2953 11.736C8.82655 13.4826 7.95963 15.5936 7.61947 16.981C7.50938 17.4301 7.06314 17.7031 6.62276 17.5908C6.18239 17.4786 5.91464 17.0236 6.02473 16.5745C6.41517 14.982 7.38385 12.6232 9.04746 10.6449C10.7226 8.65292 13.1482 7 16.4111 7C19.8078 7 22.1045 9.36684 23.561 12.0407C25.023 14.7246 25.7581 17.9121 25.9947 20.0355C26.0172 20.2372 25.9672 20.4403 25.8539 20.6072C24.8868 22.0316 21.8457 24.6 16.959 24.6C12.0723 24.6 9.03122 22.0316 8.06413 20.6072C7.93172 20.4122 7.88655 20.1691 7.93983 19.9382C8.14531 19.0477 8.66141 17.7821 9.26433 16.737C9.56684 16.2126 9.91298 15.7052 10.2813 15.3174C10.612 14.9691 11.1222 14.5429 11.7536 14.5429C13.0088 14.5429 13.8372 15.354 14.3555 15.9338C14.4824 16.0758 14.5826 16.1935 14.6702 16.2965C14.7928 16.4405 14.8909 16.5558 15.0034 16.6684C15.0277 16.6926 15.0488 16.7126 15.067 16.729C15.105 16.6984 15.1571 16.6513 15.2237 16.5791C15.4273 16.3583 15.659 16.0191 15.9103 15.5842C16.2806 14.943 16.6337 14.2029 16.9654 13.5074C17.0864 13.2537 17.2046 13.006 17.3197 12.7712C17.5227 12.3572 18.0164 12.1894 18.4224 12.3964C18.8284 12.6034 18.993 13.1068 18.79 13.5208C18.6916 13.7215 18.5845 13.9462 18.4706 14.185C18.1319 14.8952 17.7334 15.7308 17.3266 16.4349C17.0534 16.9079 16.749 17.3719 16.4213 17.7273C16.1235 18.0502 15.6528 18.454 15.0412 18.454C14.4794 18.454 14.0709 18.0836 13.8523 17.865C13.7016 17.7143 13.5222 17.5049 13.3615 17.3174C13.2812 17.2238 13.2057 17.1357 13.1407 17.063C12.6691 16.5355 12.2709 16.2308 11.782 16.2194C11.7723 16.2263 11.6666 16.2681 11.4622 16.4834C11.2197 16.7387 10.9495 17.1218 10.6812 17.5868C10.2315 18.3664 9.84854 19.2682 9.64137 19.9478C10.5611 21.0375 13.0256 22.9238 16.959 22.9238C20.958 22.9238 23.4387 20.974 24.3213 19.894C24.0645 17.9304 23.3796 15.1597 22.124 12.8546C20.7906 10.4067 18.9321 8.67619 16.4111 8.67619C13.7561 8.67619 11.7526 10.0032 10.2953 11.736Z",
        fill: "#1D2D35"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_525"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $01c21700cdaf46cf$export$a77ad170c76187c6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_525)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2953 11.736C8.82655 13.4826 7.95963 15.5936 7.61947 16.981C7.50938 17.4301 7.06314 17.7031 6.62276 17.5908C6.18239 17.4786 5.91464 17.0236 6.02473 16.5745C6.41517 14.982 7.38385 12.6232 9.04746 10.6449C10.7226 8.65292 13.1482 7 16.4111 7C19.8078 7 22.1045 9.36684 23.561 12.0407C25.023 14.7246 25.7581 17.9121 25.9947 20.0355C26.0172 20.2372 25.9672 20.4403 25.8539 20.6072C24.8868 22.0316 21.8457 24.6 16.959 24.6C12.0723 24.6 9.03122 22.0316 8.06413 20.6072C7.93172 20.4122 7.88655 20.1691 7.93983 19.9382C8.14531 19.0477 8.66141 17.7821 9.26433 16.737C9.56684 16.2126 9.91298 15.7052 10.2813 15.3174C10.612 14.9691 11.1222 14.5429 11.7536 14.5429C13.0088 14.5429 13.8372 15.354 14.3555 15.9338C14.4824 16.0758 14.5826 16.1935 14.6702 16.2965C14.7928 16.4405 14.8909 16.5558 15.0034 16.6684C15.0277 16.6926 15.0488 16.7126 15.067 16.729C15.105 16.6984 15.1571 16.6513 15.2237 16.5791C15.4273 16.3583 15.659 16.0191 15.9103 15.5842C16.2806 14.943 16.6337 14.2029 16.9654 13.5074C17.0864 13.2537 17.2046 13.006 17.3197 12.7712C17.5227 12.3572 18.0164 12.1894 18.4224 12.3964C18.8284 12.6034 18.993 13.1068 18.79 13.5208C18.6916 13.7215 18.5845 13.9462 18.4706 14.185C18.1319 14.8952 17.7334 15.7308 17.3266 16.4349C17.0534 16.9079 16.749 17.3719 16.4213 17.7273C16.1235 18.0502 15.6528 18.454 15.0412 18.454C14.4794 18.454 14.0709 18.0836 13.8523 17.865C13.7016 17.7143 13.5222 17.5049 13.3615 17.3174C13.2812 17.2238 13.2057 17.1357 13.1407 17.063C12.6691 16.5355 12.2709 16.2308 11.782 16.2194C11.7723 16.2263 11.6666 16.2681 11.4622 16.4834C11.2197 16.7387 10.9495 17.1218 10.6812 17.5868C10.2315 18.3664 9.84854 19.2682 9.64137 19.9478C10.5611 21.0375 13.0256 22.9238 16.959 22.9238C20.958 22.9238 23.4387 20.974 24.3213 19.894C24.0645 17.9304 23.3796 15.1597 22.124 12.8546C20.7906 10.4067 18.9321 8.67619 16.4111 8.67619C13.7561 8.67619 11.7526 10.0032 10.2953 11.736Z",
        fill: "#1D2D35"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_525"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $c4dfad9919f6c2ce$export$6cacedfbd2e2676a = {
    displayName: 'Basecamp by Unito',
    id: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    resourceType: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    icon: (0, $9yyKc.get3PLogo)((0, $704ba21c4cc655e8$export$ed9e7ffb4c370ac), 'ForgeUnitoBasecamp', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $01c21700cdaf46cf$export$a77ad170c76187c6), 'ForgeUnitoBasecamp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/nImlCTNLZUCtQzFsthpnlYJL0B981lMH',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $b8aa44c8f329b320$export$e7d4885dcb83a937 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_525)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2953 11.736C8.82655 13.4826 7.95963 15.5936 7.61947 16.981C7.50938 17.4301 7.06314 17.7031 6.62276 17.5908C6.18239 17.4786 5.91464 17.0236 6.02473 16.5745C6.41517 14.982 7.38385 12.6232 9.04746 10.6449C10.7226 8.65292 13.1482 7 16.4111 7C19.8078 7 22.1045 9.36684 23.561 12.0407C25.023 14.7246 25.7581 17.9121 25.9947 20.0355C26.0172 20.2372 25.9672 20.4403 25.8539 20.6072C24.8868 22.0316 21.8457 24.6 16.959 24.6C12.0723 24.6 9.03122 22.0316 8.06413 20.6072C7.93172 20.4122 7.88655 20.1691 7.93983 19.9382C8.14531 19.0477 8.66141 17.7821 9.26433 16.737C9.56684 16.2126 9.91298 15.7052 10.2813 15.3174C10.612 14.9691 11.1222 14.5429 11.7536 14.5429C13.0088 14.5429 13.8372 15.354 14.3555 15.9338C14.4824 16.0758 14.5826 16.1935 14.6702 16.2965C14.7928 16.4405 14.8909 16.5558 15.0034 16.6684C15.0277 16.6926 15.0488 16.7126 15.067 16.729C15.105 16.6984 15.1571 16.6513 15.2237 16.5791C15.4273 16.3583 15.659 16.0191 15.9103 15.5842C16.2806 14.943 16.6337 14.2029 16.9654 13.5074C17.0864 13.2537 17.2046 13.006 17.3197 12.7712C17.5227 12.3572 18.0164 12.1894 18.4224 12.3964C18.8284 12.6034 18.993 13.1068 18.79 13.5208C18.6916 13.7215 18.5845 13.9462 18.4706 14.185C18.1319 14.8952 17.7334 15.7308 17.3266 16.4349C17.0534 16.9079 16.749 17.3719 16.4213 17.7273C16.1235 18.0502 15.6528 18.454 15.0412 18.454C14.4794 18.454 14.0709 18.0836 13.8523 17.865C13.7016 17.7143 13.5222 17.5049 13.3615 17.3174C13.2812 17.2238 13.2057 17.1357 13.1407 17.063C12.6691 16.5355 12.2709 16.2308 11.782 16.2194C11.7723 16.2263 11.6666 16.2681 11.4622 16.4834C11.2197 16.7387 10.9495 17.1218 10.6812 17.5868C10.2315 18.3664 9.84854 19.2682 9.64137 19.9478C10.5611 21.0375 13.0256 22.9238 16.959 22.9238C20.958 22.9238 23.4387 20.974 24.3213 19.894C24.0645 17.9304 23.3796 15.1597 22.124 12.8546C20.7906 10.4067 18.9321 8.67619 16.4111 8.67619C13.7561 8.67619 11.7526 10.0032 10.2953 11.736Z",
        fill: "#1D2D35"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_525"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $45de75cc9e8c1c90$export$db9a338191bfb0c2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_525)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2953 11.736C8.82655 13.4826 7.95963 15.5936 7.61947 16.981C7.50938 17.4301 7.06314 17.7031 6.62276 17.5908C6.18239 17.4786 5.91464 17.0236 6.02473 16.5745C6.41517 14.982 7.38385 12.6232 9.04746 10.6449C10.7226 8.65292 13.1482 7 16.4111 7C19.8078 7 22.1045 9.36684 23.561 12.0407C25.023 14.7246 25.7581 17.9121 25.9947 20.0355C26.0172 20.2372 25.9672 20.4403 25.8539 20.6072C24.8868 22.0316 21.8457 24.6 16.959 24.6C12.0723 24.6 9.03122 22.0316 8.06413 20.6072C7.93172 20.4122 7.88655 20.1691 7.93983 19.9382C8.14531 19.0477 8.66141 17.7821 9.26433 16.737C9.56684 16.2126 9.91298 15.7052 10.2813 15.3174C10.612 14.9691 11.1222 14.5429 11.7536 14.5429C13.0088 14.5429 13.8372 15.354 14.3555 15.9338C14.4824 16.0758 14.5826 16.1935 14.6702 16.2965C14.7928 16.4405 14.8909 16.5558 15.0034 16.6684C15.0277 16.6926 15.0488 16.7126 15.067 16.729C15.105 16.6984 15.1571 16.6513 15.2237 16.5791C15.4273 16.3583 15.659 16.0191 15.9103 15.5842C16.2806 14.943 16.6337 14.2029 16.9654 13.5074C17.0864 13.2537 17.2046 13.006 17.3197 12.7712C17.5227 12.3572 18.0164 12.1894 18.4224 12.3964C18.8284 12.6034 18.993 13.1068 18.79 13.5208C18.6916 13.7215 18.5845 13.9462 18.4706 14.185C18.1319 14.8952 17.7334 15.7308 17.3266 16.4349C17.0534 16.9079 16.749 17.3719 16.4213 17.7273C16.1235 18.0502 15.6528 18.454 15.0412 18.454C14.4794 18.454 14.0709 18.0836 13.8523 17.865C13.7016 17.7143 13.5222 17.5049 13.3615 17.3174C13.2812 17.2238 13.2057 17.1357 13.1407 17.063C12.6691 16.5355 12.2709 16.2308 11.782 16.2194C11.7723 16.2263 11.6666 16.2681 11.4622 16.4834C11.2197 16.7387 10.9495 17.1218 10.6812 17.5868C10.2315 18.3664 9.84854 19.2682 9.64137 19.9478C10.5611 21.0375 13.0256 22.9238 16.959 22.9238C20.958 22.9238 23.4387 20.974 24.3213 19.894C24.0645 17.9304 23.3796 15.1597 22.124 12.8546C20.7906 10.4067 18.9321 8.67619 16.4111 8.67619C13.7561 8.67619 11.7526 10.0032 10.2953 11.736Z",
        fill: "#1D2D35"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_525"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $e362080c656f4431$export$6cacedfbd2e2676a = {
    displayName: 'Basecamp by Unito',
    id: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    resourceType: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    icon: (0, $9yyKc.get3PLogo)((0, $b8aa44c8f329b320$export$e7d4885dcb83a937), 'ForgeUnitoBasecamp', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $45de75cc9e8c1c90$export$db9a338191bfb0c2), 'ForgeUnitoBasecamp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $7e94be740b42c2f3$export$8104e2df0f916abb = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_475)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.1551 10.3793C14.8646 9.64006 15.8524 9.18157 16.9449 9.18157C18.3971 9.18157 19.6642 9.99137 20.3389 11.1935C20.9252 10.9315 21.5743 10.7858 22.2572 10.7858C24.8765 10.7858 27 12.9278 27 15.57C27 18.2125 24.8765 20.3546 22.2572 20.3546C21.9375 20.3546 21.625 20.3226 21.3229 20.2615C20.7287 21.3214 19.5965 22.0375 18.2968 22.0375C17.7528 22.0375 17.2382 21.9118 16.78 21.6883C16.1777 23.1052 14.7743 24.0986 13.1387 24.0986C11.4355 24.0986 9.98385 23.0209 9.42664 21.5094C9.18313 21.5611 8.93085 21.5881 8.67199 21.5881C6.64405 21.5881 5 19.9271 5 17.8778C5 16.5046 5.73866 15.3055 6.83615 14.664C6.6102 14.1441 6.48453 13.5703 6.48453 12.967C6.48453 10.6103 8.39778 8.69989 10.7576 8.69989C12.1431 8.69989 13.3744 9.35863 14.1551 10.3793Z",
        fill: "#00A1E0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.1868 16.6519C8.17301 16.6879 8.19181 16.6954 8.1962 16.7017C8.23756 16.7318 8.27956 16.7534 8.32187 16.7775C8.54625 16.8966 8.75811 16.9314 8.97967 16.9314C9.43096 16.9314 9.71113 16.6913 9.71113 16.3049V16.2974C9.71113 15.9401 9.39492 15.8104 9.09813 15.7167L9.05959 15.7042C8.83583 15.6315 8.64278 15.5688 8.64278 15.4215V15.4136C8.64278 15.2877 8.7556 15.1949 8.93047 15.1949C9.12477 15.1949 9.35543 15.2595 9.50398 15.3416C9.50398 15.3416 9.54754 15.3698 9.56352 15.3275C9.57229 15.3049 9.64751 15.1025 9.65534 15.0805C9.6638 15.0567 9.64876 15.0391 9.63341 15.0297C9.46386 14.9266 9.22945 14.8561 8.98688 14.8561L8.94175 14.8564C8.5287 14.8564 8.24039 15.1059 8.24039 15.4635V15.471C8.24039 15.848 8.55848 15.9702 8.85651 16.0555L8.90446 16.0702C9.12164 16.137 9.30873 16.1943 9.30873 16.3472V16.3548C9.30873 16.4945 9.18714 16.5986 8.99096 16.5986C8.9148 16.5986 8.67192 16.597 8.40962 16.4312C8.37796 16.4127 8.35947 16.3993 8.33503 16.3845C8.32218 16.3764 8.2899 16.3623 8.2758 16.4049L8.1868 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.7928 16.6519C14.779 16.6879 14.7978 16.6954 14.8022 16.7017C14.8436 16.7318 14.8856 16.7534 14.9279 16.7775C15.1523 16.8966 15.3641 16.9314 15.5857 16.9314C16.037 16.9314 16.3171 16.6913 16.3171 16.3049V16.2974C16.3171 15.9401 16.0009 15.8104 15.7041 15.7167L15.6656 15.7042C15.4418 15.6315 15.2488 15.5688 15.2488 15.4215V15.4136C15.2488 15.2877 15.3616 15.1949 15.5365 15.1949C15.7308 15.1949 15.9614 15.2595 16.11 15.3416C16.11 15.3416 16.1535 15.3698 16.1695 15.3275C16.1783 15.3049 16.2535 15.1025 16.2613 15.0805C16.2698 15.0567 16.2548 15.0391 16.2394 15.0297C16.0699 14.9266 15.8354 14.8561 15.5929 14.8561L15.5478 14.8564C15.1347 14.8564 14.8464 15.1059 14.8464 15.4635V15.471C14.8464 15.848 15.1645 15.9702 15.4625 16.0555L15.5105 16.0702C15.7276 16.137 15.915 16.1943 15.915 16.3472V16.3548C15.915 16.4945 15.7931 16.5986 15.597 16.5986C15.5208 16.5986 15.2779 16.597 15.0156 16.4312C14.984 16.4127 14.9652 16.3999 14.9413 16.3845C14.9332 16.3792 14.895 16.3645 14.8818 16.4049L14.7928 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.3038 15.8954C19.3038 16.1138 19.263 16.2859 19.1828 16.4075C19.1035 16.5278 18.9835 16.5864 18.8161 16.5864C18.6485 16.5864 18.5291 16.5281 18.451 16.4075C18.3721 16.2862 18.332 16.1138 18.332 15.8954C18.332 15.6773 18.3721 15.5055 18.451 15.3852C18.5291 15.2661 18.6485 15.2081 18.8161 15.2081C18.9835 15.2081 19.1035 15.2661 19.1831 15.3852C19.263 15.5055 19.3038 15.6773 19.3038 15.8954ZM19.6805 15.4905C19.6435 15.3654 19.5858 15.2551 19.509 15.1633C19.4323 15.0712 19.3351 14.9972 19.2198 14.9433C19.1048 14.8897 18.9688 14.8625 18.8161 14.8625C18.6632 14.8625 18.5272 14.8897 18.4122 14.9433C18.2969 14.9972 18.1997 15.0712 18.1226 15.1633C18.0461 15.2554 17.9885 15.3658 17.9512 15.4905C17.9145 15.6149 17.896 15.7509 17.896 15.8954C17.896 16.0399 17.9145 16.1762 17.9512 16.3003C17.9885 16.425 18.0458 16.5353 18.1229 16.6275C18.1997 16.7196 18.2972 16.7933 18.4122 16.8456C18.5275 16.8979 18.6632 16.9246 18.8161 16.9246C18.9688 16.9246 19.1045 16.8979 19.2198 16.8456C19.3348 16.7933 19.4323 16.7196 19.509 16.6275C19.5858 16.5356 19.6435 16.4253 19.6805 16.3003C19.7175 16.1759 19.7359 16.0395 19.7359 15.8954C19.7359 15.7512 19.7175 15.6149 19.6805 15.4905Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.773 16.5281C22.7605 16.4914 22.7251 16.5052 22.7251 16.5052C22.6702 16.5262 22.6119 16.5456 22.5499 16.5554C22.4869 16.5651 22.4176 16.5701 22.3434 16.5701C22.161 16.5701 22.0162 16.5159 21.9125 16.4087C21.8084 16.3015 21.7501 16.1282 21.7507 15.8938C21.7514 15.6804 21.8028 15.5199 21.8952 15.3977C21.987 15.2761 22.1268 15.2137 22.3133 15.2137C22.4687 15.2137 22.5872 15.2316 22.7113 15.2708C22.7113 15.2708 22.7411 15.2836 22.7552 15.2448C22.7881 15.1532 22.8125 15.0877 22.8476 14.9871C22.8576 14.9586 22.8332 14.9464 22.8244 14.943C22.7755 14.9238 22.6602 14.8928 22.5731 14.8797C22.4916 14.8671 22.3963 14.8605 22.2904 14.8605C22.1321 14.8605 21.9911 14.8875 21.8705 14.9414C21.7501 14.995 21.648 15.0689 21.5671 15.1611C21.4862 15.2532 21.4248 15.3635 21.3838 15.4883C21.343 15.6127 21.3223 15.7493 21.3223 15.8938C21.3223 16.2062 21.4066 16.4588 21.5731 16.6437C21.7398 16.8293 21.9902 16.9236 22.3167 16.9236C22.5098 16.9236 22.7078 16.8844 22.8501 16.8283C22.8501 16.8283 22.8774 16.8152 22.8655 16.7835L22.773 16.5281Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.433 15.6861C23.4508 15.5648 23.4844 15.4639 23.5361 15.3852C23.6141 15.2658 23.7332 15.2003 23.9005 15.2003C24.0679 15.2003 24.1785 15.2661 24.2578 15.3852C24.3105 15.4639 24.3333 15.5692 24.3424 15.6861H23.433ZM24.7013 15.4194C24.6693 15.2987 24.59 15.1768 24.538 15.121C24.4559 15.0327 24.3756 14.9709 24.296 14.9365C24.192 14.892 24.0673 14.8625 23.9306 14.8625C23.7714 14.8625 23.627 14.8891 23.5097 14.9443C23.3922 14.9995 23.2935 15.0747 23.2161 15.1684C23.1387 15.2618 23.0804 15.373 23.0434 15.4993C23.0061 15.625 22.9873 15.7619 22.9873 15.9064C22.9873 16.0534 23.0067 16.1903 23.0453 16.3135C23.0842 16.4376 23.1462 16.547 23.2302 16.6375C23.3139 16.7287 23.4217 16.8002 23.5508 16.85C23.679 16.8995 23.8347 16.9252 24.0137 16.9249C24.3819 16.9237 24.5759 16.8416 24.6558 16.7974C24.6699 16.7895 24.6834 16.7758 24.6665 16.7363L24.5831 16.5028C24.5706 16.468 24.5352 16.4809 24.5352 16.4809C24.444 16.5147 24.3142 16.5755 24.0118 16.5749C23.814 16.5746 23.6674 16.5163 23.5756 16.4251C23.4812 16.3317 23.4352 16.1944 23.427 16.0007L24.7022 16.002C24.7022 16.002 24.7357 16.0014 24.7392 15.9688C24.7404 15.955 24.783 15.7068 24.7013 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.2198 15.6861C13.2379 15.5648 13.2711 15.4639 13.3229 15.3852C13.4009 15.2658 13.52 15.2003 13.6873 15.2003C13.8547 15.2003 13.9653 15.2661 14.0449 15.3852C14.0972 15.4639 14.1201 15.5692 14.1292 15.6861H13.2198ZM14.4877 15.4194C14.4558 15.2987 14.3768 15.1768 14.3248 15.121C14.2427 15.0327 14.1624 14.9709 14.0828 14.9365C13.9788 14.892 13.8541 14.8625 13.7174 14.8625C13.5585 14.8625 13.4137 14.8891 13.2965 14.9443C13.179 14.9995 13.0803 15.0747 13.0029 15.1684C12.9255 15.2618 12.8672 15.373 12.8302 15.4993C12.7932 15.625 12.7741 15.7619 12.7741 15.9064C12.7741 16.0534 12.7935 16.1903 12.8321 16.3135C12.8709 16.4376 12.933 16.547 13.017 16.6375C13.1007 16.7287 13.2085 16.8002 13.3376 16.85C13.4658 16.8995 13.6215 16.9252 13.8005 16.9249C14.1687 16.9237 14.3627 16.8416 14.4426 16.7974C14.4567 16.7895 14.4702 16.7758 14.4533 16.7363L14.3702 16.5028C14.3574 16.468 14.3219 16.4809 14.3219 16.4809C14.2307 16.5147 14.1013 16.5755 13.7983 16.5749C13.6008 16.5746 13.4542 16.5163 13.3623 16.4251C13.268 16.3317 13.2219 16.1944 13.2138 16.0007L14.489 16.002C14.489 16.002 14.5225 16.0014 14.526 15.9688C14.5272 15.955 14.5698 15.7068 14.4877 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.4639 16.5209C10.414 16.4811 10.4071 16.4711 10.3902 16.4454C10.3651 16.4062 10.3523 16.3504 10.3523 16.2796C10.3523 16.1674 10.3893 16.0869 10.4661 16.0327C10.4651 16.033 10.5757 15.9371 10.8359 15.9405C11.0186 15.943 11.1818 15.97 11.1818 15.97V16.5497H11.1822C11.1822 16.5497 11.0201 16.5845 10.8377 16.5955C10.5783 16.6112 10.4629 16.5206 10.4639 16.5209ZM10.9712 15.6249C10.9195 15.6212 10.8525 15.619 10.7722 15.619C10.6629 15.619 10.5573 15.6328 10.4582 15.6594C10.3586 15.686 10.2689 15.7277 10.1918 15.7829C10.1144 15.8383 10.0521 15.9092 10.0069 15.9932C9.96181 16.0772 9.93893 16.1762 9.93893 16.2871C9.93893 16.3999 9.95836 16.498 9.99722 16.5783C10.0361 16.6588 10.0922 16.7259 10.1636 16.7776C10.2345 16.8293 10.3219 16.8672 10.4234 16.8901C10.5234 16.913 10.6369 16.9246 10.761 16.9246C10.8916 16.9246 11.022 16.9139 11.1483 16.8923C11.2734 16.871 11.4269 16.8399 11.4695 16.8302C11.5118 16.8202 11.5588 16.8074 11.5588 16.8074C11.5905 16.7995 11.588 16.7657 11.588 16.7657L11.5874 15.5995C11.5874 15.3438 11.519 15.1542 11.3846 15.0367C11.2508 14.9195 11.0537 14.8603 10.7989 14.8603C10.7033 14.8603 10.5494 14.8734 10.4573 14.8919C10.4573 14.8919 10.1787 14.9458 10.064 15.0354C10.064 15.0354 10.0389 15.0511 10.0527 15.0862L10.143 15.3288C10.1542 15.3601 10.1846 15.3495 10.1846 15.3495C10.1846 15.3495 10.1943 15.3457 10.2056 15.3391C10.451 15.2056 10.7613 15.2097 10.7613 15.2097C10.8992 15.2097 11.0051 15.2373 11.0765 15.2921C11.1461 15.3454 11.1815 15.4259 11.1815 15.5958V15.6497C11.0718 15.634 10.9712 15.6249 10.9712 15.6249Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.2559 14.9678C21.2656 14.939 21.2452 14.9252 21.2368 14.9221C21.2151 14.9136 21.1067 14.8907 21.023 14.8854C20.8629 14.8757 20.7739 14.9026 20.6943 14.9383C20.6153 14.9741 20.5276 15.0317 20.4787 15.0972V14.9421C20.4787 14.9205 20.4633 14.9032 20.442 14.9032H20.1151C20.0938 14.9032 20.0785 14.9205 20.0785 14.9421V16.8441C20.0785 16.8654 20.096 16.8829 20.1173 16.8829H20.4524C20.4737 16.8829 20.4909 16.8654 20.4909 16.8441V15.8939C20.4909 15.7663 20.505 15.6391 20.5332 15.5592C20.5608 15.4802 20.5984 15.4169 20.6448 15.3715C20.6915 15.3263 20.7444 15.2947 20.8024 15.2768C20.8616 15.2586 20.9271 15.2527 20.9735 15.2527C21.0403 15.2527 21.1136 15.2699 21.1136 15.2699C21.1381 15.2727 21.1518 15.2577 21.16 15.2354C21.1819 15.1772 21.244 15.0026 21.2559 14.9678Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.1111 14.0865C18.0703 14.0739 18.0334 14.0655 17.9851 14.0564C17.9362 14.0476 17.8779 14.0432 17.8118 14.0432C17.5811 14.0432 17.3994 14.1084 17.2718 14.2369C17.1449 14.3647 17.0587 14.5594 17.0155 14.8154L16.9998 14.9016H16.7102C16.7102 14.9016 16.6751 14.9003 16.6676 14.9386L16.6203 15.204C16.6168 15.2291 16.6278 15.2451 16.6617 15.2451H16.9434L16.6576 16.8408C16.6353 16.9693 16.6096 17.0749 16.5811 17.1552C16.5532 17.2341 16.526 17.2934 16.4921 17.3366C16.4595 17.378 16.4288 17.4087 16.3755 17.4266C16.3317 17.4413 16.2809 17.4482 16.2254 17.4482C16.1947 17.4482 16.1537 17.4432 16.1233 17.4369C16.0932 17.431 16.0772 17.4244 16.0543 17.4147C16.0543 17.4147 16.0214 17.4021 16.0082 17.435C15.9979 17.4623 15.9227 17.6688 15.9136 17.6942C15.9048 17.7196 15.9174 17.7393 15.9333 17.7453C15.9709 17.7584 15.9988 17.7672 16.0499 17.7794C16.1207 17.7961 16.1806 17.797 16.2367 17.797C16.3539 17.797 16.4611 17.7804 16.5498 17.7484C16.6388 17.7161 16.7165 17.66 16.7854 17.5842C16.8597 17.5021 16.9064 17.4162 16.9509 17.2987C16.9951 17.1828 17.033 17.0386 17.0631 16.8706L17.3505 15.2451H17.7704C17.7704 15.2451 17.8058 15.2463 17.8131 15.2078L17.8607 14.9426C17.8638 14.9173 17.8532 14.9016 17.819 14.9016H17.4113C17.4135 14.8925 17.432 14.749 17.4787 14.6139C17.4987 14.5565 17.5363 14.5098 17.568 14.4779C17.5993 14.4465 17.6354 14.4243 17.6748 14.4114C17.7153 14.3983 17.7613 14.392 17.8118 14.392C17.85 14.392 17.888 14.3964 17.9165 14.4024C17.956 14.4108 17.9713 14.4152 17.9817 14.4183C18.0233 14.4309 18.029 14.4186 18.0371 14.3986L18.1346 14.131C18.1446 14.1021 18.1199 14.0899 18.1111 14.0865Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.415 16.8444C12.415 16.8657 12.3997 16.8829 12.3784 16.8829H12.0402C12.0189 16.8829 12.0039 16.8657 12.0039 16.8444V14.1229C12.0039 14.1016 12.0189 14.0844 12.0402 14.0844H12.3784C12.3997 14.0844 12.415 14.1016 12.415 14.1229V16.8444Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_475"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $324acb8086d93e14$export$ed1cdf10de7cf033 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_475)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.1551 10.3793C14.8646 9.64006 15.8524 9.18157 16.9449 9.18157C18.3971 9.18157 19.6642 9.99137 20.3389 11.1935C20.9252 10.9315 21.5743 10.7858 22.2572 10.7858C24.8765 10.7858 27 12.9278 27 15.57C27 18.2125 24.8765 20.3546 22.2572 20.3546C21.9375 20.3546 21.625 20.3226 21.3229 20.2615C20.7287 21.3214 19.5965 22.0375 18.2968 22.0375C17.7528 22.0375 17.2382 21.9118 16.78 21.6883C16.1777 23.1052 14.7743 24.0986 13.1387 24.0986C11.4355 24.0986 9.98385 23.0209 9.42664 21.5094C9.18313 21.5611 8.93085 21.5881 8.67199 21.5881C6.64405 21.5881 5 19.9271 5 17.8778C5 16.5046 5.73866 15.3055 6.83615 14.664C6.6102 14.1441 6.48453 13.5703 6.48453 12.967C6.48453 10.6103 8.39778 8.69989 10.7576 8.69989C12.1431 8.69989 13.3744 9.35863 14.1551 10.3793Z",
        fill: "#00A1E0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.1868 16.6519C8.17301 16.6879 8.19181 16.6954 8.1962 16.7017C8.23756 16.7318 8.27956 16.7534 8.32187 16.7775C8.54625 16.8966 8.75811 16.9314 8.97967 16.9314C9.43096 16.9314 9.71113 16.6913 9.71113 16.3049V16.2974C9.71113 15.9401 9.39492 15.8104 9.09813 15.7167L9.05959 15.7042C8.83583 15.6315 8.64278 15.5688 8.64278 15.4215V15.4136C8.64278 15.2877 8.7556 15.1949 8.93047 15.1949C9.12477 15.1949 9.35543 15.2595 9.50398 15.3416C9.50398 15.3416 9.54754 15.3698 9.56352 15.3275C9.57229 15.3049 9.64751 15.1025 9.65534 15.0805C9.6638 15.0567 9.64876 15.0391 9.63341 15.0297C9.46386 14.9266 9.22945 14.8561 8.98688 14.8561L8.94175 14.8564C8.5287 14.8564 8.24039 15.1059 8.24039 15.4635V15.471C8.24039 15.848 8.55848 15.9702 8.85651 16.0555L8.90446 16.0702C9.12164 16.137 9.30873 16.1943 9.30873 16.3472V16.3548C9.30873 16.4945 9.18714 16.5986 8.99096 16.5986C8.9148 16.5986 8.67192 16.597 8.40962 16.4312C8.37796 16.4127 8.35947 16.3993 8.33503 16.3845C8.32218 16.3764 8.2899 16.3623 8.2758 16.4049L8.1868 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.7928 16.6519C14.779 16.6879 14.7978 16.6954 14.8022 16.7017C14.8436 16.7318 14.8856 16.7534 14.9279 16.7775C15.1523 16.8966 15.3641 16.9314 15.5857 16.9314C16.037 16.9314 16.3171 16.6913 16.3171 16.3049V16.2974C16.3171 15.9401 16.0009 15.8104 15.7041 15.7167L15.6656 15.7042C15.4418 15.6315 15.2488 15.5688 15.2488 15.4215V15.4136C15.2488 15.2877 15.3616 15.1949 15.5365 15.1949C15.7308 15.1949 15.9614 15.2595 16.11 15.3416C16.11 15.3416 16.1535 15.3698 16.1695 15.3275C16.1783 15.3049 16.2535 15.1025 16.2613 15.0805C16.2698 15.0567 16.2548 15.0391 16.2394 15.0297C16.0699 14.9266 15.8354 14.8561 15.5929 14.8561L15.5478 14.8564C15.1347 14.8564 14.8464 15.1059 14.8464 15.4635V15.471C14.8464 15.848 15.1645 15.9702 15.4625 16.0555L15.5105 16.0702C15.7276 16.137 15.915 16.1943 15.915 16.3472V16.3548C15.915 16.4945 15.7931 16.5986 15.597 16.5986C15.5208 16.5986 15.2779 16.597 15.0156 16.4312C14.984 16.4127 14.9652 16.3999 14.9413 16.3845C14.9332 16.3792 14.895 16.3645 14.8818 16.4049L14.7928 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.3038 15.8954C19.3038 16.1138 19.263 16.2859 19.1828 16.4075C19.1035 16.5278 18.9835 16.5864 18.8161 16.5864C18.6485 16.5864 18.5291 16.5281 18.451 16.4075C18.3721 16.2862 18.332 16.1138 18.332 15.8954C18.332 15.6773 18.3721 15.5055 18.451 15.3852C18.5291 15.2661 18.6485 15.2081 18.8161 15.2081C18.9835 15.2081 19.1035 15.2661 19.1831 15.3852C19.263 15.5055 19.3038 15.6773 19.3038 15.8954ZM19.6805 15.4905C19.6435 15.3654 19.5858 15.2551 19.509 15.1633C19.4323 15.0712 19.3351 14.9972 19.2198 14.9433C19.1048 14.8897 18.9688 14.8625 18.8161 14.8625C18.6632 14.8625 18.5272 14.8897 18.4122 14.9433C18.2969 14.9972 18.1997 15.0712 18.1226 15.1633C18.0461 15.2554 17.9885 15.3658 17.9512 15.4905C17.9145 15.6149 17.896 15.7509 17.896 15.8954C17.896 16.0399 17.9145 16.1762 17.9512 16.3003C17.9885 16.425 18.0458 16.5353 18.1229 16.6275C18.1997 16.7196 18.2972 16.7933 18.4122 16.8456C18.5275 16.8979 18.6632 16.9246 18.8161 16.9246C18.9688 16.9246 19.1045 16.8979 19.2198 16.8456C19.3348 16.7933 19.4323 16.7196 19.509 16.6275C19.5858 16.5356 19.6435 16.4253 19.6805 16.3003C19.7175 16.1759 19.7359 16.0395 19.7359 15.8954C19.7359 15.7512 19.7175 15.6149 19.6805 15.4905Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.773 16.5281C22.7605 16.4914 22.7251 16.5052 22.7251 16.5052C22.6702 16.5262 22.6119 16.5456 22.5499 16.5554C22.4869 16.5651 22.4176 16.5701 22.3434 16.5701C22.161 16.5701 22.0162 16.5159 21.9125 16.4087C21.8084 16.3015 21.7501 16.1282 21.7507 15.8938C21.7514 15.6804 21.8028 15.5199 21.8952 15.3977C21.987 15.2761 22.1268 15.2137 22.3133 15.2137C22.4687 15.2137 22.5872 15.2316 22.7113 15.2708C22.7113 15.2708 22.7411 15.2836 22.7552 15.2448C22.7881 15.1532 22.8125 15.0877 22.8476 14.9871C22.8576 14.9586 22.8332 14.9464 22.8244 14.943C22.7755 14.9238 22.6602 14.8928 22.5731 14.8797C22.4916 14.8671 22.3963 14.8605 22.2904 14.8605C22.1321 14.8605 21.9911 14.8875 21.8705 14.9414C21.7501 14.995 21.648 15.0689 21.5671 15.1611C21.4862 15.2532 21.4248 15.3635 21.3838 15.4883C21.343 15.6127 21.3223 15.7493 21.3223 15.8938C21.3223 16.2062 21.4066 16.4588 21.5731 16.6437C21.7398 16.8293 21.9902 16.9236 22.3167 16.9236C22.5098 16.9236 22.7078 16.8844 22.8501 16.8283C22.8501 16.8283 22.8774 16.8152 22.8655 16.7835L22.773 16.5281Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.433 15.6861C23.4508 15.5648 23.4844 15.4639 23.5361 15.3852C23.6141 15.2658 23.7332 15.2003 23.9005 15.2003C24.0679 15.2003 24.1785 15.2661 24.2578 15.3852C24.3105 15.4639 24.3333 15.5692 24.3424 15.6861H23.433ZM24.7013 15.4194C24.6693 15.2987 24.59 15.1768 24.538 15.121C24.4559 15.0327 24.3756 14.9709 24.296 14.9365C24.192 14.892 24.0673 14.8625 23.9306 14.8625C23.7714 14.8625 23.627 14.8891 23.5097 14.9443C23.3922 14.9995 23.2935 15.0747 23.2161 15.1684C23.1387 15.2618 23.0804 15.373 23.0434 15.4993C23.0061 15.625 22.9873 15.7619 22.9873 15.9064C22.9873 16.0534 23.0067 16.1903 23.0453 16.3135C23.0842 16.4376 23.1462 16.547 23.2302 16.6375C23.3139 16.7287 23.4217 16.8002 23.5508 16.85C23.679 16.8995 23.8347 16.9252 24.0137 16.9249C24.3819 16.9237 24.5759 16.8416 24.6558 16.7974C24.6699 16.7895 24.6834 16.7758 24.6665 16.7363L24.5831 16.5028C24.5706 16.468 24.5352 16.4809 24.5352 16.4809C24.444 16.5147 24.3142 16.5755 24.0118 16.5749C23.814 16.5746 23.6674 16.5163 23.5756 16.4251C23.4812 16.3317 23.4352 16.1944 23.427 16.0007L24.7022 16.002C24.7022 16.002 24.7357 16.0014 24.7392 15.9688C24.7404 15.955 24.783 15.7068 24.7013 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.2198 15.6861C13.2379 15.5648 13.2711 15.4639 13.3229 15.3852C13.4009 15.2658 13.52 15.2003 13.6873 15.2003C13.8547 15.2003 13.9653 15.2661 14.0449 15.3852C14.0972 15.4639 14.1201 15.5692 14.1292 15.6861H13.2198ZM14.4877 15.4194C14.4558 15.2987 14.3768 15.1768 14.3248 15.121C14.2427 15.0327 14.1624 14.9709 14.0828 14.9365C13.9788 14.892 13.8541 14.8625 13.7174 14.8625C13.5585 14.8625 13.4137 14.8891 13.2965 14.9443C13.179 14.9995 13.0803 15.0747 13.0029 15.1684C12.9255 15.2618 12.8672 15.373 12.8302 15.4993C12.7932 15.625 12.7741 15.7619 12.7741 15.9064C12.7741 16.0534 12.7935 16.1903 12.8321 16.3135C12.8709 16.4376 12.933 16.547 13.017 16.6375C13.1007 16.7287 13.2085 16.8002 13.3376 16.85C13.4658 16.8995 13.6215 16.9252 13.8005 16.9249C14.1687 16.9237 14.3627 16.8416 14.4426 16.7974C14.4567 16.7895 14.4702 16.7758 14.4533 16.7363L14.3702 16.5028C14.3574 16.468 14.3219 16.4809 14.3219 16.4809C14.2307 16.5147 14.1013 16.5755 13.7983 16.5749C13.6008 16.5746 13.4542 16.5163 13.3623 16.4251C13.268 16.3317 13.2219 16.1944 13.2138 16.0007L14.489 16.002C14.489 16.002 14.5225 16.0014 14.526 15.9688C14.5272 15.955 14.5698 15.7068 14.4877 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.4639 16.5209C10.414 16.4811 10.4071 16.4711 10.3902 16.4454C10.3651 16.4062 10.3523 16.3504 10.3523 16.2796C10.3523 16.1674 10.3893 16.0869 10.4661 16.0327C10.4651 16.033 10.5757 15.9371 10.8359 15.9405C11.0186 15.943 11.1818 15.97 11.1818 15.97V16.5497H11.1822C11.1822 16.5497 11.0201 16.5845 10.8377 16.5955C10.5783 16.6112 10.4629 16.5206 10.4639 16.5209ZM10.9712 15.6249C10.9195 15.6212 10.8525 15.619 10.7722 15.619C10.6629 15.619 10.5573 15.6328 10.4582 15.6594C10.3586 15.686 10.2689 15.7277 10.1918 15.7829C10.1144 15.8383 10.0521 15.9092 10.0069 15.9932C9.96181 16.0772 9.93893 16.1762 9.93893 16.2871C9.93893 16.3999 9.95836 16.498 9.99722 16.5783C10.0361 16.6588 10.0922 16.7259 10.1636 16.7776C10.2345 16.8293 10.3219 16.8672 10.4234 16.8901C10.5234 16.913 10.6369 16.9246 10.761 16.9246C10.8916 16.9246 11.022 16.9139 11.1483 16.8923C11.2734 16.871 11.4269 16.8399 11.4695 16.8302C11.5118 16.8202 11.5588 16.8074 11.5588 16.8074C11.5905 16.7995 11.588 16.7657 11.588 16.7657L11.5874 15.5995C11.5874 15.3438 11.519 15.1542 11.3846 15.0367C11.2508 14.9195 11.0537 14.8603 10.7989 14.8603C10.7033 14.8603 10.5494 14.8734 10.4573 14.8919C10.4573 14.8919 10.1787 14.9458 10.064 15.0354C10.064 15.0354 10.0389 15.0511 10.0527 15.0862L10.143 15.3288C10.1542 15.3601 10.1846 15.3495 10.1846 15.3495C10.1846 15.3495 10.1943 15.3457 10.2056 15.3391C10.451 15.2056 10.7613 15.2097 10.7613 15.2097C10.8992 15.2097 11.0051 15.2373 11.0765 15.2921C11.1461 15.3454 11.1815 15.4259 11.1815 15.5958V15.6497C11.0718 15.634 10.9712 15.6249 10.9712 15.6249Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.2559 14.9678C21.2656 14.939 21.2452 14.9252 21.2368 14.9221C21.2151 14.9136 21.1067 14.8907 21.023 14.8854C20.8629 14.8757 20.7739 14.9026 20.6943 14.9383C20.6153 14.9741 20.5276 15.0317 20.4787 15.0972V14.9421C20.4787 14.9205 20.4633 14.9032 20.442 14.9032H20.1151C20.0938 14.9032 20.0785 14.9205 20.0785 14.9421V16.8441C20.0785 16.8654 20.096 16.8829 20.1173 16.8829H20.4524C20.4737 16.8829 20.4909 16.8654 20.4909 16.8441V15.8939C20.4909 15.7663 20.505 15.6391 20.5332 15.5592C20.5608 15.4802 20.5984 15.4169 20.6448 15.3715C20.6915 15.3263 20.7444 15.2947 20.8024 15.2768C20.8616 15.2586 20.9271 15.2527 20.9735 15.2527C21.0403 15.2527 21.1136 15.2699 21.1136 15.2699C21.1381 15.2727 21.1518 15.2577 21.16 15.2354C21.1819 15.1772 21.244 15.0026 21.2559 14.9678Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.1111 14.0865C18.0703 14.0739 18.0334 14.0655 17.9851 14.0564C17.9362 14.0476 17.8779 14.0432 17.8118 14.0432C17.5811 14.0432 17.3994 14.1084 17.2718 14.2369C17.1449 14.3647 17.0587 14.5594 17.0155 14.8154L16.9998 14.9016H16.7102C16.7102 14.9016 16.6751 14.9003 16.6676 14.9386L16.6203 15.204C16.6168 15.2291 16.6278 15.2451 16.6617 15.2451H16.9434L16.6576 16.8408C16.6353 16.9693 16.6096 17.0749 16.5811 17.1552C16.5532 17.2341 16.526 17.2934 16.4921 17.3366C16.4595 17.378 16.4288 17.4087 16.3755 17.4266C16.3317 17.4413 16.2809 17.4482 16.2254 17.4482C16.1947 17.4482 16.1537 17.4432 16.1233 17.4369C16.0932 17.431 16.0772 17.4244 16.0543 17.4147C16.0543 17.4147 16.0214 17.4021 16.0082 17.435C15.9979 17.4623 15.9227 17.6688 15.9136 17.6942C15.9048 17.7196 15.9174 17.7393 15.9333 17.7453C15.9709 17.7584 15.9988 17.7672 16.0499 17.7794C16.1207 17.7961 16.1806 17.797 16.2367 17.797C16.3539 17.797 16.4611 17.7804 16.5498 17.7484C16.6388 17.7161 16.7165 17.66 16.7854 17.5842C16.8597 17.5021 16.9064 17.4162 16.9509 17.2987C16.9951 17.1828 17.033 17.0386 17.0631 16.8706L17.3505 15.2451H17.7704C17.7704 15.2451 17.8058 15.2463 17.8131 15.2078L17.8607 14.9426C17.8638 14.9173 17.8532 14.9016 17.819 14.9016H17.4113C17.4135 14.8925 17.432 14.749 17.4787 14.6139C17.4987 14.5565 17.5363 14.5098 17.568 14.4779C17.5993 14.4465 17.6354 14.4243 17.6748 14.4114C17.7153 14.3983 17.7613 14.392 17.8118 14.392C17.85 14.392 17.888 14.3964 17.9165 14.4024C17.956 14.4108 17.9713 14.4152 17.9817 14.4183C18.0233 14.4309 18.029 14.4186 18.0371 14.3986L18.1346 14.131C18.1446 14.1021 18.1199 14.0899 18.1111 14.0865Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.415 16.8444C12.415 16.8657 12.3997 16.8829 12.3784 16.8829H12.0402C12.0189 16.8829 12.0039 16.8657 12.0039 16.8444V14.1229C12.0039 14.1016 12.0189 14.0844 12.0402 14.0844H12.3784C12.3997 14.0844 12.415 14.1016 12.415 14.1229V16.8444Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_475"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $e7c488eb86051bc5$export$fa2bcc689ce846fa = {
    displayName: 'Salesforce by Unito',
    id: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    resourceType: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    icon: (0, $9yyKc.get3PLogo)((0, $7e94be740b42c2f3$export$8104e2df0f916abb), 'ForgeUnitoSalesforce', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $324acb8086d93e14$export$ed1cdf10de7cf033), 'ForgeUnitoSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $aa4087558dbc5acd$export$343dc2b8e291afb2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_475)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.1551 10.3793C14.8646 9.64006 15.8524 9.18157 16.9449 9.18157C18.3971 9.18157 19.6642 9.99137 20.3389 11.1935C20.9252 10.9315 21.5743 10.7858 22.2572 10.7858C24.8765 10.7858 27 12.9278 27 15.57C27 18.2125 24.8765 20.3546 22.2572 20.3546C21.9375 20.3546 21.625 20.3226 21.3229 20.2615C20.7287 21.3214 19.5965 22.0375 18.2968 22.0375C17.7528 22.0375 17.2382 21.9118 16.78 21.6883C16.1777 23.1052 14.7743 24.0986 13.1387 24.0986C11.4355 24.0986 9.98385 23.0209 9.42664 21.5094C9.18313 21.5611 8.93085 21.5881 8.67199 21.5881C6.64405 21.5881 5 19.9271 5 17.8778C5 16.5046 5.73866 15.3055 6.83615 14.664C6.6102 14.1441 6.48453 13.5703 6.48453 12.967C6.48453 10.6103 8.39778 8.69989 10.7576 8.69989C12.1431 8.69989 13.3744 9.35863 14.1551 10.3793Z",
        fill: "#00A1E0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.1868 16.6519C8.17301 16.6879 8.19181 16.6954 8.1962 16.7017C8.23756 16.7318 8.27956 16.7534 8.32187 16.7775C8.54625 16.8966 8.75811 16.9314 8.97967 16.9314C9.43096 16.9314 9.71113 16.6913 9.71113 16.3049V16.2974C9.71113 15.9401 9.39492 15.8104 9.09813 15.7167L9.05959 15.7042C8.83583 15.6315 8.64278 15.5688 8.64278 15.4215V15.4136C8.64278 15.2877 8.7556 15.1949 8.93047 15.1949C9.12477 15.1949 9.35543 15.2595 9.50398 15.3416C9.50398 15.3416 9.54754 15.3698 9.56352 15.3275C9.57229 15.3049 9.64751 15.1025 9.65534 15.0805C9.6638 15.0567 9.64876 15.0391 9.63341 15.0297C9.46386 14.9266 9.22945 14.8561 8.98688 14.8561L8.94175 14.8564C8.5287 14.8564 8.24039 15.1059 8.24039 15.4635V15.471C8.24039 15.848 8.55848 15.9702 8.85651 16.0555L8.90446 16.0702C9.12164 16.137 9.30873 16.1943 9.30873 16.3472V16.3548C9.30873 16.4945 9.18714 16.5986 8.99096 16.5986C8.9148 16.5986 8.67192 16.597 8.40962 16.4312C8.37796 16.4127 8.35947 16.3993 8.33503 16.3845C8.32218 16.3764 8.2899 16.3623 8.2758 16.4049L8.1868 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.7928 16.6519C14.779 16.6879 14.7978 16.6954 14.8022 16.7017C14.8436 16.7318 14.8856 16.7534 14.9279 16.7775C15.1523 16.8966 15.3641 16.9314 15.5857 16.9314C16.037 16.9314 16.3171 16.6913 16.3171 16.3049V16.2974C16.3171 15.9401 16.0009 15.8104 15.7041 15.7167L15.6656 15.7042C15.4418 15.6315 15.2488 15.5688 15.2488 15.4215V15.4136C15.2488 15.2877 15.3616 15.1949 15.5365 15.1949C15.7308 15.1949 15.9614 15.2595 16.11 15.3416C16.11 15.3416 16.1535 15.3698 16.1695 15.3275C16.1783 15.3049 16.2535 15.1025 16.2613 15.0805C16.2698 15.0567 16.2548 15.0391 16.2394 15.0297C16.0699 14.9266 15.8354 14.8561 15.5929 14.8561L15.5478 14.8564C15.1347 14.8564 14.8464 15.1059 14.8464 15.4635V15.471C14.8464 15.848 15.1645 15.9702 15.4625 16.0555L15.5105 16.0702C15.7276 16.137 15.915 16.1943 15.915 16.3472V16.3548C15.915 16.4945 15.7931 16.5986 15.597 16.5986C15.5208 16.5986 15.2779 16.597 15.0156 16.4312C14.984 16.4127 14.9652 16.3999 14.9413 16.3845C14.9332 16.3792 14.895 16.3645 14.8818 16.4049L14.7928 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.3038 15.8954C19.3038 16.1138 19.263 16.2859 19.1828 16.4075C19.1035 16.5278 18.9835 16.5864 18.8161 16.5864C18.6485 16.5864 18.5291 16.5281 18.451 16.4075C18.3721 16.2862 18.332 16.1138 18.332 15.8954C18.332 15.6773 18.3721 15.5055 18.451 15.3852C18.5291 15.2661 18.6485 15.2081 18.8161 15.2081C18.9835 15.2081 19.1035 15.2661 19.1831 15.3852C19.263 15.5055 19.3038 15.6773 19.3038 15.8954ZM19.6805 15.4905C19.6435 15.3654 19.5858 15.2551 19.509 15.1633C19.4323 15.0712 19.3351 14.9972 19.2198 14.9433C19.1048 14.8897 18.9688 14.8625 18.8161 14.8625C18.6632 14.8625 18.5272 14.8897 18.4122 14.9433C18.2969 14.9972 18.1997 15.0712 18.1226 15.1633C18.0461 15.2554 17.9885 15.3658 17.9512 15.4905C17.9145 15.6149 17.896 15.7509 17.896 15.8954C17.896 16.0399 17.9145 16.1762 17.9512 16.3003C17.9885 16.425 18.0458 16.5353 18.1229 16.6275C18.1997 16.7196 18.2972 16.7933 18.4122 16.8456C18.5275 16.8979 18.6632 16.9246 18.8161 16.9246C18.9688 16.9246 19.1045 16.8979 19.2198 16.8456C19.3348 16.7933 19.4323 16.7196 19.509 16.6275C19.5858 16.5356 19.6435 16.4253 19.6805 16.3003C19.7175 16.1759 19.7359 16.0395 19.7359 15.8954C19.7359 15.7512 19.7175 15.6149 19.6805 15.4905Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.773 16.5281C22.7605 16.4914 22.7251 16.5052 22.7251 16.5052C22.6702 16.5262 22.6119 16.5456 22.5499 16.5554C22.4869 16.5651 22.4176 16.5701 22.3434 16.5701C22.161 16.5701 22.0162 16.5159 21.9125 16.4087C21.8084 16.3015 21.7501 16.1282 21.7507 15.8938C21.7514 15.6804 21.8028 15.5199 21.8952 15.3977C21.987 15.2761 22.1268 15.2137 22.3133 15.2137C22.4687 15.2137 22.5872 15.2316 22.7113 15.2708C22.7113 15.2708 22.7411 15.2836 22.7552 15.2448C22.7881 15.1532 22.8125 15.0877 22.8476 14.9871C22.8576 14.9586 22.8332 14.9464 22.8244 14.943C22.7755 14.9238 22.6602 14.8928 22.5731 14.8797C22.4916 14.8671 22.3963 14.8605 22.2904 14.8605C22.1321 14.8605 21.9911 14.8875 21.8705 14.9414C21.7501 14.995 21.648 15.0689 21.5671 15.1611C21.4862 15.2532 21.4248 15.3635 21.3838 15.4883C21.343 15.6127 21.3223 15.7493 21.3223 15.8938C21.3223 16.2062 21.4066 16.4588 21.5731 16.6437C21.7398 16.8293 21.9902 16.9236 22.3167 16.9236C22.5098 16.9236 22.7078 16.8844 22.8501 16.8283C22.8501 16.8283 22.8774 16.8152 22.8655 16.7835L22.773 16.5281Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.433 15.6861C23.4508 15.5648 23.4844 15.4639 23.5361 15.3852C23.6141 15.2658 23.7332 15.2003 23.9005 15.2003C24.0679 15.2003 24.1785 15.2661 24.2578 15.3852C24.3105 15.4639 24.3333 15.5692 24.3424 15.6861H23.433ZM24.7013 15.4194C24.6693 15.2987 24.59 15.1768 24.538 15.121C24.4559 15.0327 24.3756 14.9709 24.296 14.9365C24.192 14.892 24.0673 14.8625 23.9306 14.8625C23.7714 14.8625 23.627 14.8891 23.5097 14.9443C23.3922 14.9995 23.2935 15.0747 23.2161 15.1684C23.1387 15.2618 23.0804 15.373 23.0434 15.4993C23.0061 15.625 22.9873 15.7619 22.9873 15.9064C22.9873 16.0534 23.0067 16.1903 23.0453 16.3135C23.0842 16.4376 23.1462 16.547 23.2302 16.6375C23.3139 16.7287 23.4217 16.8002 23.5508 16.85C23.679 16.8995 23.8347 16.9252 24.0137 16.9249C24.3819 16.9237 24.5759 16.8416 24.6558 16.7974C24.6699 16.7895 24.6834 16.7758 24.6665 16.7363L24.5831 16.5028C24.5706 16.468 24.5352 16.4809 24.5352 16.4809C24.444 16.5147 24.3142 16.5755 24.0118 16.5749C23.814 16.5746 23.6674 16.5163 23.5756 16.4251C23.4812 16.3317 23.4352 16.1944 23.427 16.0007L24.7022 16.002C24.7022 16.002 24.7357 16.0014 24.7392 15.9688C24.7404 15.955 24.783 15.7068 24.7013 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.2198 15.6861C13.2379 15.5648 13.2711 15.4639 13.3229 15.3852C13.4009 15.2658 13.52 15.2003 13.6873 15.2003C13.8547 15.2003 13.9653 15.2661 14.0449 15.3852C14.0972 15.4639 14.1201 15.5692 14.1292 15.6861H13.2198ZM14.4877 15.4194C14.4558 15.2987 14.3768 15.1768 14.3248 15.121C14.2427 15.0327 14.1624 14.9709 14.0828 14.9365C13.9788 14.892 13.8541 14.8625 13.7174 14.8625C13.5585 14.8625 13.4137 14.8891 13.2965 14.9443C13.179 14.9995 13.0803 15.0747 13.0029 15.1684C12.9255 15.2618 12.8672 15.373 12.8302 15.4993C12.7932 15.625 12.7741 15.7619 12.7741 15.9064C12.7741 16.0534 12.7935 16.1903 12.8321 16.3135C12.8709 16.4376 12.933 16.547 13.017 16.6375C13.1007 16.7287 13.2085 16.8002 13.3376 16.85C13.4658 16.8995 13.6215 16.9252 13.8005 16.9249C14.1687 16.9237 14.3627 16.8416 14.4426 16.7974C14.4567 16.7895 14.4702 16.7758 14.4533 16.7363L14.3702 16.5028C14.3574 16.468 14.3219 16.4809 14.3219 16.4809C14.2307 16.5147 14.1013 16.5755 13.7983 16.5749C13.6008 16.5746 13.4542 16.5163 13.3623 16.4251C13.268 16.3317 13.2219 16.1944 13.2138 16.0007L14.489 16.002C14.489 16.002 14.5225 16.0014 14.526 15.9688C14.5272 15.955 14.5698 15.7068 14.4877 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.4639 16.5209C10.414 16.4811 10.4071 16.4711 10.3902 16.4454C10.3651 16.4062 10.3523 16.3504 10.3523 16.2796C10.3523 16.1674 10.3893 16.0869 10.4661 16.0327C10.4651 16.033 10.5757 15.9371 10.8359 15.9405C11.0186 15.943 11.1818 15.97 11.1818 15.97V16.5497H11.1822C11.1822 16.5497 11.0201 16.5845 10.8377 16.5955C10.5783 16.6112 10.4629 16.5206 10.4639 16.5209ZM10.9712 15.6249C10.9195 15.6212 10.8525 15.619 10.7722 15.619C10.6629 15.619 10.5573 15.6328 10.4582 15.6594C10.3586 15.686 10.2689 15.7277 10.1918 15.7829C10.1144 15.8383 10.0521 15.9092 10.0069 15.9932C9.96181 16.0772 9.93893 16.1762 9.93893 16.2871C9.93893 16.3999 9.95836 16.498 9.99722 16.5783C10.0361 16.6588 10.0922 16.7259 10.1636 16.7776C10.2345 16.8293 10.3219 16.8672 10.4234 16.8901C10.5234 16.913 10.6369 16.9246 10.761 16.9246C10.8916 16.9246 11.022 16.9139 11.1483 16.8923C11.2734 16.871 11.4269 16.8399 11.4695 16.8302C11.5118 16.8202 11.5588 16.8074 11.5588 16.8074C11.5905 16.7995 11.588 16.7657 11.588 16.7657L11.5874 15.5995C11.5874 15.3438 11.519 15.1542 11.3846 15.0367C11.2508 14.9195 11.0537 14.8603 10.7989 14.8603C10.7033 14.8603 10.5494 14.8734 10.4573 14.8919C10.4573 14.8919 10.1787 14.9458 10.064 15.0354C10.064 15.0354 10.0389 15.0511 10.0527 15.0862L10.143 15.3288C10.1542 15.3601 10.1846 15.3495 10.1846 15.3495C10.1846 15.3495 10.1943 15.3457 10.2056 15.3391C10.451 15.2056 10.7613 15.2097 10.7613 15.2097C10.8992 15.2097 11.0051 15.2373 11.0765 15.2921C11.1461 15.3454 11.1815 15.4259 11.1815 15.5958V15.6497C11.0718 15.634 10.9712 15.6249 10.9712 15.6249Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.2559 14.9678C21.2656 14.939 21.2452 14.9252 21.2368 14.9221C21.2151 14.9136 21.1067 14.8907 21.023 14.8854C20.8629 14.8757 20.7739 14.9026 20.6943 14.9383C20.6153 14.9741 20.5276 15.0317 20.4787 15.0972V14.9421C20.4787 14.9205 20.4633 14.9032 20.442 14.9032H20.1151C20.0938 14.9032 20.0785 14.9205 20.0785 14.9421V16.8441C20.0785 16.8654 20.096 16.8829 20.1173 16.8829H20.4524C20.4737 16.8829 20.4909 16.8654 20.4909 16.8441V15.8939C20.4909 15.7663 20.505 15.6391 20.5332 15.5592C20.5608 15.4802 20.5984 15.4169 20.6448 15.3715C20.6915 15.3263 20.7444 15.2947 20.8024 15.2768C20.8616 15.2586 20.9271 15.2527 20.9735 15.2527C21.0403 15.2527 21.1136 15.2699 21.1136 15.2699C21.1381 15.2727 21.1518 15.2577 21.16 15.2354C21.1819 15.1772 21.244 15.0026 21.2559 14.9678Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.1111 14.0865C18.0703 14.0739 18.0334 14.0655 17.9851 14.0564C17.9362 14.0476 17.8779 14.0432 17.8118 14.0432C17.5811 14.0432 17.3994 14.1084 17.2718 14.2369C17.1449 14.3647 17.0587 14.5594 17.0155 14.8154L16.9998 14.9016H16.7102C16.7102 14.9016 16.6751 14.9003 16.6676 14.9386L16.6203 15.204C16.6168 15.2291 16.6278 15.2451 16.6617 15.2451H16.9434L16.6576 16.8408C16.6353 16.9693 16.6096 17.0749 16.5811 17.1552C16.5532 17.2341 16.526 17.2934 16.4921 17.3366C16.4595 17.378 16.4288 17.4087 16.3755 17.4266C16.3317 17.4413 16.2809 17.4482 16.2254 17.4482C16.1947 17.4482 16.1537 17.4432 16.1233 17.4369C16.0932 17.431 16.0772 17.4244 16.0543 17.4147C16.0543 17.4147 16.0214 17.4021 16.0082 17.435C15.9979 17.4623 15.9227 17.6688 15.9136 17.6942C15.9048 17.7196 15.9174 17.7393 15.9333 17.7453C15.9709 17.7584 15.9988 17.7672 16.0499 17.7794C16.1207 17.7961 16.1806 17.797 16.2367 17.797C16.3539 17.797 16.4611 17.7804 16.5498 17.7484C16.6388 17.7161 16.7165 17.66 16.7854 17.5842C16.8597 17.5021 16.9064 17.4162 16.9509 17.2987C16.9951 17.1828 17.033 17.0386 17.0631 16.8706L17.3505 15.2451H17.7704C17.7704 15.2451 17.8058 15.2463 17.8131 15.2078L17.8607 14.9426C17.8638 14.9173 17.8532 14.9016 17.819 14.9016H17.4113C17.4135 14.8925 17.432 14.749 17.4787 14.6139C17.4987 14.5565 17.5363 14.5098 17.568 14.4779C17.5993 14.4465 17.6354 14.4243 17.6748 14.4114C17.7153 14.3983 17.7613 14.392 17.8118 14.392C17.85 14.392 17.888 14.3964 17.9165 14.4024C17.956 14.4108 17.9713 14.4152 17.9817 14.4183C18.0233 14.4309 18.029 14.4186 18.0371 14.3986L18.1346 14.131C18.1446 14.1021 18.1199 14.0899 18.1111 14.0865Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.415 16.8444C12.415 16.8657 12.3997 16.8829 12.3784 16.8829H12.0402C12.0189 16.8829 12.0039 16.8657 12.0039 16.8444V14.1229C12.0039 14.1016 12.0189 14.0844 12.0402 14.0844H12.3784C12.3997 14.0844 12.415 14.1016 12.415 14.1229V16.8444Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_475"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $efff66e7cbbfc1ad$export$25516afb15bfa187 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_475)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.1551 10.3793C14.8646 9.64006 15.8524 9.18157 16.9449 9.18157C18.3971 9.18157 19.6642 9.99137 20.3389 11.1935C20.9252 10.9315 21.5743 10.7858 22.2572 10.7858C24.8765 10.7858 27 12.9278 27 15.57C27 18.2125 24.8765 20.3546 22.2572 20.3546C21.9375 20.3546 21.625 20.3226 21.3229 20.2615C20.7287 21.3214 19.5965 22.0375 18.2968 22.0375C17.7528 22.0375 17.2382 21.9118 16.78 21.6883C16.1777 23.1052 14.7743 24.0986 13.1387 24.0986C11.4355 24.0986 9.98385 23.0209 9.42664 21.5094C9.18313 21.5611 8.93085 21.5881 8.67199 21.5881C6.64405 21.5881 5 19.9271 5 17.8778C5 16.5046 5.73866 15.3055 6.83615 14.664C6.6102 14.1441 6.48453 13.5703 6.48453 12.967C6.48453 10.6103 8.39778 8.69989 10.7576 8.69989C12.1431 8.69989 13.3744 9.35863 14.1551 10.3793Z",
        fill: "#00A1E0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.1868 16.6519C8.17301 16.6879 8.19181 16.6954 8.1962 16.7017C8.23756 16.7318 8.27956 16.7534 8.32187 16.7775C8.54625 16.8966 8.75811 16.9314 8.97967 16.9314C9.43096 16.9314 9.71113 16.6913 9.71113 16.3049V16.2974C9.71113 15.9401 9.39492 15.8104 9.09813 15.7167L9.05959 15.7042C8.83583 15.6315 8.64278 15.5688 8.64278 15.4215V15.4136C8.64278 15.2877 8.7556 15.1949 8.93047 15.1949C9.12477 15.1949 9.35543 15.2595 9.50398 15.3416C9.50398 15.3416 9.54754 15.3698 9.56352 15.3275C9.57229 15.3049 9.64751 15.1025 9.65534 15.0805C9.6638 15.0567 9.64876 15.0391 9.63341 15.0297C9.46386 14.9266 9.22945 14.8561 8.98688 14.8561L8.94175 14.8564C8.5287 14.8564 8.24039 15.1059 8.24039 15.4635V15.471C8.24039 15.848 8.55848 15.9702 8.85651 16.0555L8.90446 16.0702C9.12164 16.137 9.30873 16.1943 9.30873 16.3472V16.3548C9.30873 16.4945 9.18714 16.5986 8.99096 16.5986C8.9148 16.5986 8.67192 16.597 8.40962 16.4312C8.37796 16.4127 8.35947 16.3993 8.33503 16.3845C8.32218 16.3764 8.2899 16.3623 8.2758 16.4049L8.1868 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.7928 16.6519C14.779 16.6879 14.7978 16.6954 14.8022 16.7017C14.8436 16.7318 14.8856 16.7534 14.9279 16.7775C15.1523 16.8966 15.3641 16.9314 15.5857 16.9314C16.037 16.9314 16.3171 16.6913 16.3171 16.3049V16.2974C16.3171 15.9401 16.0009 15.8104 15.7041 15.7167L15.6656 15.7042C15.4418 15.6315 15.2488 15.5688 15.2488 15.4215V15.4136C15.2488 15.2877 15.3616 15.1949 15.5365 15.1949C15.7308 15.1949 15.9614 15.2595 16.11 15.3416C16.11 15.3416 16.1535 15.3698 16.1695 15.3275C16.1783 15.3049 16.2535 15.1025 16.2613 15.0805C16.2698 15.0567 16.2548 15.0391 16.2394 15.0297C16.0699 14.9266 15.8354 14.8561 15.5929 14.8561L15.5478 14.8564C15.1347 14.8564 14.8464 15.1059 14.8464 15.4635V15.471C14.8464 15.848 15.1645 15.9702 15.4625 16.0555L15.5105 16.0702C15.7276 16.137 15.915 16.1943 15.915 16.3472V16.3548C15.915 16.4945 15.7931 16.5986 15.597 16.5986C15.5208 16.5986 15.2779 16.597 15.0156 16.4312C14.984 16.4127 14.9652 16.3999 14.9413 16.3845C14.9332 16.3792 14.895 16.3645 14.8818 16.4049L14.7928 16.6519Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.3038 15.8954C19.3038 16.1138 19.263 16.2859 19.1828 16.4075C19.1035 16.5278 18.9835 16.5864 18.8161 16.5864C18.6485 16.5864 18.5291 16.5281 18.451 16.4075C18.3721 16.2862 18.332 16.1138 18.332 15.8954C18.332 15.6773 18.3721 15.5055 18.451 15.3852C18.5291 15.2661 18.6485 15.2081 18.8161 15.2081C18.9835 15.2081 19.1035 15.2661 19.1831 15.3852C19.263 15.5055 19.3038 15.6773 19.3038 15.8954ZM19.6805 15.4905C19.6435 15.3654 19.5858 15.2551 19.509 15.1633C19.4323 15.0712 19.3351 14.9972 19.2198 14.9433C19.1048 14.8897 18.9688 14.8625 18.8161 14.8625C18.6632 14.8625 18.5272 14.8897 18.4122 14.9433C18.2969 14.9972 18.1997 15.0712 18.1226 15.1633C18.0461 15.2554 17.9885 15.3658 17.9512 15.4905C17.9145 15.6149 17.896 15.7509 17.896 15.8954C17.896 16.0399 17.9145 16.1762 17.9512 16.3003C17.9885 16.425 18.0458 16.5353 18.1229 16.6275C18.1997 16.7196 18.2972 16.7933 18.4122 16.8456C18.5275 16.8979 18.6632 16.9246 18.8161 16.9246C18.9688 16.9246 19.1045 16.8979 19.2198 16.8456C19.3348 16.7933 19.4323 16.7196 19.509 16.6275C19.5858 16.5356 19.6435 16.4253 19.6805 16.3003C19.7175 16.1759 19.7359 16.0395 19.7359 15.8954C19.7359 15.7512 19.7175 15.6149 19.6805 15.4905Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.773 16.5281C22.7605 16.4914 22.7251 16.5052 22.7251 16.5052C22.6702 16.5262 22.6119 16.5456 22.5499 16.5554C22.4869 16.5651 22.4176 16.5701 22.3434 16.5701C22.161 16.5701 22.0162 16.5159 21.9125 16.4087C21.8084 16.3015 21.7501 16.1282 21.7507 15.8938C21.7514 15.6804 21.8028 15.5199 21.8952 15.3977C21.987 15.2761 22.1268 15.2137 22.3133 15.2137C22.4687 15.2137 22.5872 15.2316 22.7113 15.2708C22.7113 15.2708 22.7411 15.2836 22.7552 15.2448C22.7881 15.1532 22.8125 15.0877 22.8476 14.9871C22.8576 14.9586 22.8332 14.9464 22.8244 14.943C22.7755 14.9238 22.6602 14.8928 22.5731 14.8797C22.4916 14.8671 22.3963 14.8605 22.2904 14.8605C22.1321 14.8605 21.9911 14.8875 21.8705 14.9414C21.7501 14.995 21.648 15.0689 21.5671 15.1611C21.4862 15.2532 21.4248 15.3635 21.3838 15.4883C21.343 15.6127 21.3223 15.7493 21.3223 15.8938C21.3223 16.2062 21.4066 16.4588 21.5731 16.6437C21.7398 16.8293 21.9902 16.9236 22.3167 16.9236C22.5098 16.9236 22.7078 16.8844 22.8501 16.8283C22.8501 16.8283 22.8774 16.8152 22.8655 16.7835L22.773 16.5281Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.433 15.6861C23.4508 15.5648 23.4844 15.4639 23.5361 15.3852C23.6141 15.2658 23.7332 15.2003 23.9005 15.2003C24.0679 15.2003 24.1785 15.2661 24.2578 15.3852C24.3105 15.4639 24.3333 15.5692 24.3424 15.6861H23.433ZM24.7013 15.4194C24.6693 15.2987 24.59 15.1768 24.538 15.121C24.4559 15.0327 24.3756 14.9709 24.296 14.9365C24.192 14.892 24.0673 14.8625 23.9306 14.8625C23.7714 14.8625 23.627 14.8891 23.5097 14.9443C23.3922 14.9995 23.2935 15.0747 23.2161 15.1684C23.1387 15.2618 23.0804 15.373 23.0434 15.4993C23.0061 15.625 22.9873 15.7619 22.9873 15.9064C22.9873 16.0534 23.0067 16.1903 23.0453 16.3135C23.0842 16.4376 23.1462 16.547 23.2302 16.6375C23.3139 16.7287 23.4217 16.8002 23.5508 16.85C23.679 16.8995 23.8347 16.9252 24.0137 16.9249C24.3819 16.9237 24.5759 16.8416 24.6558 16.7974C24.6699 16.7895 24.6834 16.7758 24.6665 16.7363L24.5831 16.5028C24.5706 16.468 24.5352 16.4809 24.5352 16.4809C24.444 16.5147 24.3142 16.5755 24.0118 16.5749C23.814 16.5746 23.6674 16.5163 23.5756 16.4251C23.4812 16.3317 23.4352 16.1944 23.427 16.0007L24.7022 16.002C24.7022 16.002 24.7357 16.0014 24.7392 15.9688C24.7404 15.955 24.783 15.7068 24.7013 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.2198 15.6861C13.2379 15.5648 13.2711 15.4639 13.3229 15.3852C13.4009 15.2658 13.52 15.2003 13.6873 15.2003C13.8547 15.2003 13.9653 15.2661 14.0449 15.3852C14.0972 15.4639 14.1201 15.5692 14.1292 15.6861H13.2198ZM14.4877 15.4194C14.4558 15.2987 14.3768 15.1768 14.3248 15.121C14.2427 15.0327 14.1624 14.9709 14.0828 14.9365C13.9788 14.892 13.8541 14.8625 13.7174 14.8625C13.5585 14.8625 13.4137 14.8891 13.2965 14.9443C13.179 14.9995 13.0803 15.0747 13.0029 15.1684C12.9255 15.2618 12.8672 15.373 12.8302 15.4993C12.7932 15.625 12.7741 15.7619 12.7741 15.9064C12.7741 16.0534 12.7935 16.1903 12.8321 16.3135C12.8709 16.4376 12.933 16.547 13.017 16.6375C13.1007 16.7287 13.2085 16.8002 13.3376 16.85C13.4658 16.8995 13.6215 16.9252 13.8005 16.9249C14.1687 16.9237 14.3627 16.8416 14.4426 16.7974C14.4567 16.7895 14.4702 16.7758 14.4533 16.7363L14.3702 16.5028C14.3574 16.468 14.3219 16.4809 14.3219 16.4809C14.2307 16.5147 14.1013 16.5755 13.7983 16.5749C13.6008 16.5746 13.4542 16.5163 13.3623 16.4251C13.268 16.3317 13.2219 16.1944 13.2138 16.0007L14.489 16.002C14.489 16.002 14.5225 16.0014 14.526 15.9688C14.5272 15.955 14.5698 15.7068 14.4877 15.4194Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.4639 16.5209C10.414 16.4811 10.4071 16.4711 10.3902 16.4454C10.3651 16.4062 10.3523 16.3504 10.3523 16.2796C10.3523 16.1674 10.3893 16.0869 10.4661 16.0327C10.4651 16.033 10.5757 15.9371 10.8359 15.9405C11.0186 15.943 11.1818 15.97 11.1818 15.97V16.5497H11.1822C11.1822 16.5497 11.0201 16.5845 10.8377 16.5955C10.5783 16.6112 10.4629 16.5206 10.4639 16.5209ZM10.9712 15.6249C10.9195 15.6212 10.8525 15.619 10.7722 15.619C10.6629 15.619 10.5573 15.6328 10.4582 15.6594C10.3586 15.686 10.2689 15.7277 10.1918 15.7829C10.1144 15.8383 10.0521 15.9092 10.0069 15.9932C9.96181 16.0772 9.93893 16.1762 9.93893 16.2871C9.93893 16.3999 9.95836 16.498 9.99722 16.5783C10.0361 16.6588 10.0922 16.7259 10.1636 16.7776C10.2345 16.8293 10.3219 16.8672 10.4234 16.8901C10.5234 16.913 10.6369 16.9246 10.761 16.9246C10.8916 16.9246 11.022 16.9139 11.1483 16.8923C11.2734 16.871 11.4269 16.8399 11.4695 16.8302C11.5118 16.8202 11.5588 16.8074 11.5588 16.8074C11.5905 16.7995 11.588 16.7657 11.588 16.7657L11.5874 15.5995C11.5874 15.3438 11.519 15.1542 11.3846 15.0367C11.2508 14.9195 11.0537 14.8603 10.7989 14.8603C10.7033 14.8603 10.5494 14.8734 10.4573 14.8919C10.4573 14.8919 10.1787 14.9458 10.064 15.0354C10.064 15.0354 10.0389 15.0511 10.0527 15.0862L10.143 15.3288C10.1542 15.3601 10.1846 15.3495 10.1846 15.3495C10.1846 15.3495 10.1943 15.3457 10.2056 15.3391C10.451 15.2056 10.7613 15.2097 10.7613 15.2097C10.8992 15.2097 11.0051 15.2373 11.0765 15.2921C11.1461 15.3454 11.1815 15.4259 11.1815 15.5958V15.6497C11.0718 15.634 10.9712 15.6249 10.9712 15.6249Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.2559 14.9678C21.2656 14.939 21.2452 14.9252 21.2368 14.9221C21.2151 14.9136 21.1067 14.8907 21.023 14.8854C20.8629 14.8757 20.7739 14.9026 20.6943 14.9383C20.6153 14.9741 20.5276 15.0317 20.4787 15.0972V14.9421C20.4787 14.9205 20.4633 14.9032 20.442 14.9032H20.1151C20.0938 14.9032 20.0785 14.9205 20.0785 14.9421V16.8441C20.0785 16.8654 20.096 16.8829 20.1173 16.8829H20.4524C20.4737 16.8829 20.4909 16.8654 20.4909 16.8441V15.8939C20.4909 15.7663 20.505 15.6391 20.5332 15.5592C20.5608 15.4802 20.5984 15.4169 20.6448 15.3715C20.6915 15.3263 20.7444 15.2947 20.8024 15.2768C20.8616 15.2586 20.9271 15.2527 20.9735 15.2527C21.0403 15.2527 21.1136 15.2699 21.1136 15.2699C21.1381 15.2727 21.1518 15.2577 21.16 15.2354C21.1819 15.1772 21.244 15.0026 21.2559 14.9678Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.1111 14.0865C18.0703 14.0739 18.0334 14.0655 17.9851 14.0564C17.9362 14.0476 17.8779 14.0432 17.8118 14.0432C17.5811 14.0432 17.3994 14.1084 17.2718 14.2369C17.1449 14.3647 17.0587 14.5594 17.0155 14.8154L16.9998 14.9016H16.7102C16.7102 14.9016 16.6751 14.9003 16.6676 14.9386L16.6203 15.204C16.6168 15.2291 16.6278 15.2451 16.6617 15.2451H16.9434L16.6576 16.8408C16.6353 16.9693 16.6096 17.0749 16.5811 17.1552C16.5532 17.2341 16.526 17.2934 16.4921 17.3366C16.4595 17.378 16.4288 17.4087 16.3755 17.4266C16.3317 17.4413 16.2809 17.4482 16.2254 17.4482C16.1947 17.4482 16.1537 17.4432 16.1233 17.4369C16.0932 17.431 16.0772 17.4244 16.0543 17.4147C16.0543 17.4147 16.0214 17.4021 16.0082 17.435C15.9979 17.4623 15.9227 17.6688 15.9136 17.6942C15.9048 17.7196 15.9174 17.7393 15.9333 17.7453C15.9709 17.7584 15.9988 17.7672 16.0499 17.7794C16.1207 17.7961 16.1806 17.797 16.2367 17.797C16.3539 17.797 16.4611 17.7804 16.5498 17.7484C16.6388 17.7161 16.7165 17.66 16.7854 17.5842C16.8597 17.5021 16.9064 17.4162 16.9509 17.2987C16.9951 17.1828 17.033 17.0386 17.0631 16.8706L17.3505 15.2451H17.7704C17.7704 15.2451 17.8058 15.2463 17.8131 15.2078L17.8607 14.9426C17.8638 14.9173 17.8532 14.9016 17.819 14.9016H17.4113C17.4135 14.8925 17.432 14.749 17.4787 14.6139C17.4987 14.5565 17.5363 14.5098 17.568 14.4779C17.5993 14.4465 17.6354 14.4243 17.6748 14.4114C17.7153 14.3983 17.7613 14.392 17.8118 14.392C17.85 14.392 17.888 14.3964 17.9165 14.4024C17.956 14.4108 17.9713 14.4152 17.9817 14.4183C18.0233 14.4309 18.029 14.4186 18.0371 14.3986L18.1346 14.131C18.1446 14.1021 18.1199 14.0899 18.1111 14.0865Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.415 16.8444C12.415 16.8657 12.3997 16.8829 12.3784 16.8829H12.0402C12.0189 16.8829 12.0039 16.8657 12.0039 16.8444V14.1229C12.0039 14.1016 12.0189 14.0844 12.0402 14.0844H12.3784C12.3997 14.0844 12.415 14.1016 12.415 14.1229V16.8444Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_475"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $acc22c66e1b86d64$export$fa2bcc689ce846fa = {
    displayName: 'Salesforce by Unito',
    id: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    resourceType: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    icon: (0, $9yyKc.get3PLogo)((0, $aa4087558dbc5acd$export$343dc2b8e291afb2), 'ForgeUnitoSalesforce', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $efff66e7cbbfc1ad$export$25516afb15bfa187), 'ForgeUnitoSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $1424f3f9ff2382a8$export$9d41b3d14b7278ba = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0589 6.66663C10.5048 6.66663 6 11.3442 6 17.1176C6 20.0044 7.12618 22.7842 9.1482 24.7621C9.86486 25.4571 10.9399 25.5372 11.7333 24.8958C14.2672 22.9178 17.7482 22.9178 20.2821 24.8958C21.0755 25.5105 22.1761 25.4571 22.8672 24.7354C26.8856 20.7528 27.0648 14.124 23.2511 9.90083C21.3571 7.86943 18.772 6.69335 16.0589 6.66663ZM16.0077 22.3832C13.3202 22.4634 11.0934 20.2449 11.0167 17.4384C11.0167 17.3582 11.0167 17.2513 11.0167 17.1711C11.0167 14.2844 13.2434 11.959 16.0077 11.959C18.772 11.959 20.9988 14.2844 20.9988 17.1711C21.0755 19.9776 18.9511 22.303 16.2637 22.3832C16.1613 22.3832 16.0845 22.3832 16.0077 22.3832Z",
        fill: "#62D84E"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(6 6)"
    }))));
};





const $ac2d00d0fcb01275$export$aa41257056ffa0f6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0589 6.66663C10.5048 6.66663 6 11.3442 6 17.1176C6 20.0044 7.12618 22.7842 9.1482 24.7621C9.86486 25.4571 10.9399 25.5372 11.7333 24.8958C14.2672 22.9178 17.7482 22.9178 20.2821 24.8958C21.0755 25.5105 22.1761 25.4571 22.8672 24.7354C26.8856 20.7528 27.0648 14.124 23.2511 9.90083C21.3571 7.86943 18.772 6.69335 16.0589 6.66663ZM16.0077 22.3832C13.3202 22.4634 11.0934 20.2449 11.0167 17.4384C11.0167 17.3582 11.0167 17.2513 11.0167 17.1711C11.0167 14.2844 13.2434 11.959 16.0077 11.959C18.772 11.959 20.9988 14.2844 20.9988 17.1711C21.0755 19.9776 18.9511 22.303 16.2637 22.3832C16.1613 22.3832 16.0845 22.3832 16.0077 22.3832Z",
        fill: "#62D84E"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(6 6)"
    }))));
};


const $9820ecdaa7bfd1f0$export$da42ac6c929f2d1 = {
    displayName: 'ServiceNow by Unito',
    id: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    resourceType: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    icon: (0, $9yyKc.get3PLogo)((0, $1424f3f9ff2382a8$export$9d41b3d14b7278ba), 'ForgeUnitoServicenow', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $ac2d00d0fcb01275$export$aa41257056ffa0f6), 'ForgeUnitoServicenow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $d5d2e5b5c7f33a28$export$4492fca47bdf8f21 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0589 6.66663C10.5048 6.66663 6 11.3442 6 17.1176C6 20.0044 7.12618 22.7842 9.1482 24.7621C9.86486 25.4571 10.9399 25.5372 11.7333 24.8958C14.2672 22.9178 17.7482 22.9178 20.2821 24.8958C21.0755 25.5105 22.1761 25.4571 22.8672 24.7354C26.8856 20.7528 27.0648 14.124 23.2511 9.90083C21.3571 7.86943 18.772 6.69335 16.0589 6.66663ZM16.0077 22.3832C13.3202 22.4634 11.0934 20.2449 11.0167 17.4384C11.0167 17.3582 11.0167 17.2513 11.0167 17.1711C11.0167 14.2844 13.2434 11.959 16.0077 11.959C18.772 11.959 20.9988 14.2844 20.9988 17.1711C21.0755 19.9776 18.9511 22.303 16.2637 22.3832C16.1613 22.3832 16.0845 22.3832 16.0077 22.3832Z",
        fill: "#62D84E"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(6 6)"
    }))));
};





const $bf2693a97a7aed81$export$47ccbbbcbef66311 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_3059_463)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0589 6.66663C10.5048 6.66663 6 11.3442 6 17.1176C6 20.0044 7.12618 22.7842 9.1482 24.7621C9.86486 25.4571 10.9399 25.5372 11.7333 24.8958C14.2672 22.9178 17.7482 22.9178 20.2821 24.8958C21.0755 25.5105 22.1761 25.4571 22.8672 24.7354C26.8856 20.7528 27.0648 14.124 23.2511 9.90083C21.3571 7.86943 18.772 6.69335 16.0589 6.66663ZM16.0077 22.3832C13.3202 22.4634 11.0934 20.2449 11.0167 17.4384C11.0167 17.3582 11.0167 17.2513 11.0167 17.1711C11.0167 14.2844 13.2434 11.959 16.0077 11.959C18.772 11.959 20.9988 14.2844 20.9988 17.1711C21.0755 19.9776 18.9511 22.303 16.2637 22.3832C16.1613 22.3832 16.0845 22.3832 16.0077 22.3832Z",
        fill: "#62D84E"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_3059_463"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(6 6)"
    }))));
};


const $87ba42c6e861e3ad$export$da42ac6c929f2d1 = {
    displayName: 'ServiceNow by Unito',
    id: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    resourceType: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    icon: (0, $9yyKc.get3PLogo)((0, $d5d2e5b5c7f33a28$export$4492fca47bdf8f21), 'ForgeUnitoServicenow', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bf2693a97a7aed81$export$47ccbbbcbef66311), 'ForgeUnitoServicenow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RzFogW4EQLcXYmYpKkItRUhLAn3jETMq',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $bdb292e3d4fa461a$export$17dc9d80eebdf65c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_499)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.2195 13.9276C11.297 13.9276 11.8047 14.1194 12.585 14.8749L16.7708 18.9274C16.8946 19.0473 16.9194 19.0952 16.9441 19.1673C16.9565 19.1912 16.9565 19.2272 16.9565 19.2511C16.9565 19.2751 16.9565 19.311 16.9441 19.3351C16.9194 19.407 16.8946 19.4549 16.7708 19.5749L13.9101 22.3565C13.7862 22.4764 13.7366 22.5004 13.6624 22.5243C13.6376 22.5363 13.6005 22.5363 13.5756 22.5363C13.5509 22.5363 13.5137 22.5363 13.489 22.5243C13.4146 22.5004 13.3651 22.4764 13.2413 22.3565L5.12954 14.5031C4.89431 14.2753 4.98095 13.9276 5.3772 13.9276H10.2195Z",
        fill: "#08CF65"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.7804 8.66663C20.703 8.66663 20.1952 8.86938 19.415 9.66792L15.2291 13.9515C15.1052 14.0783 15.0806 14.1289 15.0557 14.2051C15.0434 14.2304 15.0434 14.2684 15.0434 14.2937C15.0434 14.319 15.0434 14.3572 15.0557 14.3825C15.0806 14.4585 15.1052 14.5091 15.2291 14.6359L18.0899 17.5635C18.2138 17.6903 18.2633 17.7156 18.3376 17.7409C18.3624 17.7536 18.3995 17.7536 18.4244 17.7536C18.449 17.7536 18.4861 17.7536 18.511 17.7409C18.5854 17.7156 18.6349 17.6903 18.7587 17.5635L26.8704 9.26224C27.1057 9.02149 27.019 8.66663 26.6228 8.66663H21.7804Z",
        fill: "#08CF65"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_499"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $bdf89cf5f2a700ba$export$f4934c6437de6183 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_499)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.2195 13.9276C11.297 13.9276 11.8047 14.1194 12.585 14.8749L16.7708 18.9274C16.8946 19.0473 16.9194 19.0952 16.9441 19.1673C16.9565 19.1912 16.9565 19.2272 16.9565 19.2511C16.9565 19.2751 16.9565 19.311 16.9441 19.3351C16.9194 19.407 16.8946 19.4549 16.7708 19.5749L13.9101 22.3565C13.7862 22.4764 13.7366 22.5004 13.6624 22.5243C13.6376 22.5363 13.6005 22.5363 13.5756 22.5363C13.5509 22.5363 13.5137 22.5363 13.489 22.5243C13.4146 22.5004 13.3651 22.4764 13.2413 22.3565L5.12954 14.5031C4.89431 14.2753 4.98095 13.9276 5.3772 13.9276H10.2195Z",
        fill: "#08CF65"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.7804 8.66663C20.703 8.66663 20.1952 8.86938 19.415 9.66792L15.2291 13.9515C15.1052 14.0783 15.0806 14.1289 15.0557 14.2051C15.0434 14.2304 15.0434 14.2684 15.0434 14.2937C15.0434 14.319 15.0434 14.3572 15.0557 14.3825C15.0806 14.4585 15.1052 14.5091 15.2291 14.6359L18.0899 17.5635C18.2138 17.6903 18.2633 17.7156 18.3376 17.7409C18.3624 17.7536 18.3995 17.7536 18.4244 17.7536C18.449 17.7536 18.4861 17.7536 18.511 17.7409C18.5854 17.7156 18.6349 17.6903 18.7587 17.5635L26.8704 9.26224C27.1057 9.02149 27.019 8.66663 26.6228 8.66663H21.7804Z",
        fill: "#08CF65"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_499"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $a3d2c49216bc55d4$export$b2bafc74c57288f3 = {
    displayName: 'Wrike by Unito',
    id: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    resourceType: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    icon: (0, $9yyKc.get3PLogo)((0, $bdb292e3d4fa461a$export$17dc9d80eebdf65c), 'ForgeUnitoWrike', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bdf89cf5f2a700ba$export$f4934c6437de6183), 'ForgeUnitoWrike', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};




































































const $0310afd1dbfad3d6$export$518d4767160867f3 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_499)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.2195 13.9276C11.297 13.9276 11.8047 14.1194 12.585 14.8749L16.7708 18.9274C16.8946 19.0473 16.9194 19.0952 16.9441 19.1673C16.9565 19.1912 16.9565 19.2272 16.9565 19.2511C16.9565 19.2751 16.9565 19.311 16.9441 19.3351C16.9194 19.407 16.8946 19.4549 16.7708 19.5749L13.9101 22.3565C13.7862 22.4764 13.7366 22.5004 13.6624 22.5243C13.6376 22.5363 13.6005 22.5363 13.5756 22.5363C13.5509 22.5363 13.5137 22.5363 13.489 22.5243C13.4146 22.5004 13.3651 22.4764 13.2413 22.3565L5.12954 14.5031C4.89431 14.2753 4.98095 13.9276 5.3772 13.9276H10.2195Z",
        fill: "#08CF65"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.7804 8.66663C20.703 8.66663 20.1952 8.86938 19.415 9.66792L15.2291 13.9515C15.1052 14.0783 15.0806 14.1289 15.0557 14.2051C15.0434 14.2304 15.0434 14.2684 15.0434 14.2937C15.0434 14.319 15.0434 14.3572 15.0557 14.3825C15.0806 14.4585 15.1052 14.5091 15.2291 14.6359L18.0899 17.5635C18.2138 17.6903 18.2633 17.7156 18.3376 17.7409C18.3624 17.7536 18.3995 17.7536 18.4244 17.7536C18.449 17.7536 18.4861 17.7536 18.511 17.7409C18.5854 17.7156 18.6349 17.6903 18.7587 17.5635L26.8704 9.26224C27.1057 9.02149 27.019 8.66663 26.6228 8.66663H21.7804Z",
        fill: "#08CF65"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_499"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};





const $51291269fdf3db62$export$13cc65e658693d1e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_3059_499)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.2195 13.9276C11.297 13.9276 11.8047 14.1194 12.585 14.8749L16.7708 18.9274C16.8946 19.0473 16.9194 19.0952 16.9441 19.1673C16.9565 19.1912 16.9565 19.2272 16.9565 19.2511C16.9565 19.2751 16.9565 19.311 16.9441 19.3351C16.9194 19.407 16.8946 19.4549 16.7708 19.5749L13.9101 22.3565C13.7862 22.4764 13.7366 22.5004 13.6624 22.5243C13.6376 22.5363 13.6005 22.5363 13.5756 22.5363C13.5509 22.5363 13.5137 22.5363 13.489 22.5243C13.4146 22.5004 13.3651 22.4764 13.2413 22.3565L5.12954 14.5031C4.89431 14.2753 4.98095 13.9276 5.3772 13.9276H10.2195Z",
        fill: "#08CF65"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.7804 8.66663C20.703 8.66663 20.1952 8.86938 19.415 9.66792L15.2291 13.9515C15.1052 14.0783 15.0806 14.1289 15.0557 14.2051C15.0434 14.2304 15.0434 14.2684 15.0434 14.2937C15.0434 14.319 15.0434 14.3572 15.0557 14.3825C15.0806 14.4585 15.1052 14.5091 15.2291 14.6359L18.0899 17.5635C18.2138 17.6903 18.2633 17.7156 18.3376 17.7409C18.3624 17.7536 18.3995 17.7536 18.4244 17.7536C18.449 17.7536 18.4861 17.7536 18.511 17.7409C18.5854 17.7156 18.6349 17.6903 18.7587 17.5635L26.8704 9.26224C27.1057 9.02149 27.019 8.66663 26.6228 8.66663H21.7804Z",
        fill: "#08CF65"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_3059_499"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};


const $ebe4c25a222bb830$export$b2bafc74c57288f3 = {
    displayName: 'Wrike by Unito',
    id: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    resourceType: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    icon: (0, $9yyKc.get3PLogo)((0, $0310afd1dbfad3d6$export$518d4767160867f3), 'ForgeUnitoWrike', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $51291269fdf3db62$export$13cc65e658693d1e), 'ForgeUnitoWrike', 'large'),
    integrationAri: 'ari:cloud:platform::integration/390XhSnH4YgwqVgmyqYOujxVoL3IOUcM',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Space,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $aIjYQ.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $hLHb5.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};














const $ea7811d75073a663$export$fc1920df99f3d560 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0313 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.2356C37.0888 4.43701 35.5243 3.53772 33.8078 3.53839C32.0912 3.53906 30.5275 4.43957 27.4 6.24059L10.2293 16.1286C10.102 16.2019 10.0384 16.2386 9.97908 16.2733C4.11371 19.7069 0.489892 25.9755 0.441438 32.7718C0.440948 32.8405 0.440948 32.9139 0.440948 33.0608C0.440948 33.2074 0.440948 33.2808 0.441437 33.3494C0.489785 40.1381 4.10552 46.4008 9.96044 49.8371C10.0196 49.8718 10.0832 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8104 30.3668 61.6197 33.8081 61.6209C37.2493 61.622 40.3842 59.8149 46.6539 56.2005L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5212C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1684 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3998 34.6643 43.8488 33.8073 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6448 11.9301 33.0497 11.6548 33.7244C11.5341 34.0203 11.5365 34.4754 11.5414 35.3855C11.545 36.0555 11.5468 36.3905 11.6094 36.6987C11.7497 37.3888 12.1127 38.0136 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.75 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5457 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4418 42.9844 58.0493 43.2106 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1907 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92912 34.7912 5.92912 34.762 5.92912 34.7035V31.7889C5.92912 29.6526 7.06689 27.678 8.91513 26.6067C10.5483 25.6601 12.5628 25.6582 14.1977 26.6018L27.3964 34.2196Z",
        fill: "#F2F7F7"
    }));
};





const $c05f78ad8ba2f105$export$41e46c9b83e3cfe1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0313 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.2356C37.0888 4.43701 35.5243 3.53772 33.8078 3.53839C32.0912 3.53906 30.5275 4.43957 27.4 6.24059L10.2293 16.1286C10.102 16.2019 10.0384 16.2386 9.97908 16.2733C4.11371 19.7069 0.489892 25.9755 0.441438 32.7718C0.440948 32.8405 0.440948 32.9139 0.440948 33.0608C0.440948 33.2074 0.440948 33.2808 0.441437 33.3494C0.489785 40.1381 4.10552 46.4008 9.96044 49.8371C10.0196 49.8718 10.0832 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8104 30.3668 61.6197 33.8081 61.6209C37.2493 61.622 40.3842 59.8149 46.6539 56.2005L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5212C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1684 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3998 34.6643 43.8488 33.8073 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6448 11.9301 33.0497 11.6548 33.7244C11.5341 34.0203 11.5365 34.4754 11.5414 35.3855C11.545 36.0555 11.5468 36.3905 11.6094 36.6987C11.7497 37.3888 12.1127 38.0136 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.75 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5457 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4418 42.9844 58.0493 43.2106 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1907 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92912 34.7912 5.92912 34.762 5.92912 34.7035V31.7889C5.92912 29.6526 7.06689 27.678 8.91513 26.6067C10.5483 25.6601 12.5628 25.6582 14.1977 26.6018L27.3964 34.2196Z",
        fill: "#F2F7F7"
    }));
};


const $26d56bdd5cac71a1$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    resourceType: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $ea7811d75073a663$export$fc1920df99f3d560), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $c05f78ad8ba2f105$export$41e46c9b83e3cfe1), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};














const $cddc5da30408dd03$export$fc1920df99f3d560 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0313 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.2356C37.0888 4.43701 35.5243 3.53772 33.8078 3.53839C32.0912 3.53906 30.5275 4.43957 27.4 6.24059L10.2293 16.1286C10.102 16.2019 10.0384 16.2386 9.97908 16.2733C4.11371 19.7069 0.489892 25.9755 0.441438 32.7718C0.440948 32.8405 0.440948 32.9139 0.440948 33.0608C0.440948 33.2074 0.440948 33.2808 0.441437 33.3494C0.489785 40.1381 4.10552 46.4008 9.96044 49.8371C10.0196 49.8718 10.0832 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8104 30.3668 61.6197 33.8081 61.6209C37.2493 61.622 40.3842 59.8149 46.6539 56.2005L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5212C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1684 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3998 34.6643 43.8488 33.8073 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6448 11.9301 33.0497 11.6548 33.7244C11.5341 34.0203 11.5365 34.4754 11.5414 35.3855C11.545 36.0555 11.5468 36.3905 11.6094 36.6987C11.7497 37.3888 12.1127 38.0136 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.75 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5457 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4418 42.9844 58.0493 43.2106 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1907 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92912 34.7912 5.92912 34.762 5.92912 34.7035V31.7889C5.92912 29.6526 7.06689 27.678 8.91513 26.6067C10.5483 25.6601 12.5628 25.6582 14.1977 26.6018L27.3964 34.2196Z",
        fill: "#F2F7F7"
    }));
};





const $0060961109a2b7eb$export$41e46c9b83e3cfe1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 65 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3964 34.2196C30.5255 36.0256 32.09 36.9286 33.8083 36.9301C35.5265 36.9316 37.0926 36.0313 40.2249 34.2308L60.1914 22.7535C61.0927 22.2354 61.6484 21.275 61.6484 20.2353C61.6484 19.1956 61.0927 18.2352 60.1914 17.7171L40.2177 6.2356C37.0888 4.43701 35.5243 3.53772 33.8078 3.53839C32.0912 3.53906 30.5275 4.43957 27.4 6.24059L10.2293 16.1286C10.102 16.2019 10.0384 16.2386 9.97908 16.2733C4.11371 19.7069 0.489892 25.9755 0.441438 32.7718C0.440948 32.8405 0.440948 32.9139 0.440948 33.0608C0.440948 33.2074 0.440948 33.2808 0.441437 33.3494C0.489785 40.1381 4.10552 46.4008 9.96044 49.8371C10.0196 49.8718 10.0832 49.9085 10.2102 49.9819L20.9659 56.1919C27.2332 59.8104 30.3668 61.6197 33.8081 61.6209C37.2493 61.622 40.3842 59.8149 46.6539 56.2005L58.008 49.6552C61.1474 47.8454 62.7171 46.9406 63.579 45.4488C64.4409 43.957 64.4409 42.1452 64.4409 38.5215V31.5212C64.4409 30.516 63.8965 29.5896 63.0182 29.1004C62.1684 28.6271 61.1325 28.6341 60.2891 29.1189L37.0074 42.5019C35.4454 43.3998 34.6643 43.8488 33.8073 43.8491C32.9502 43.8493 32.1689 43.4008 30.6063 42.5039L14.8487 33.4587C14.0594 33.0056 13.6647 32.779 13.3477 32.7381C12.625 32.6448 11.9301 33.0497 11.6548 33.7244C11.5341 34.0203 11.5365 34.4754 11.5414 35.3855C11.545 36.0555 11.5468 36.3905 11.6094 36.6987C11.7497 37.3888 12.1127 38.0136 12.6428 38.4772C12.8795 38.6842 13.1696 38.8517 13.75 39.1866L30.5974 48.9103C32.1641 49.8145 32.9474 50.2666 33.8075 50.2669C34.6677 50.2671 35.4513 49.8154 37.0184 48.9121L57.6684 37.0086C58.2037 36.7 58.4714 36.5457 58.6721 36.6617C58.8727 36.7777 58.8727 37.0866 58.8727 37.7045V40.8796C58.8727 41.7856 58.8727 42.2385 58.6572 42.6115C58.4418 42.9844 58.0493 43.2106 57.2644 43.6631L40.2322 53.4811C37.0966 55.2886 35.5288 56.1923 33.8079 56.1915C32.0869 56.1907 30.5199 55.2856 27.386 53.4752L11.4509 44.2702C11.4003 44.2409 11.375 44.2263 11.3514 44.2125C8.01023 42.2601 5.94859 38.6883 5.92925 34.8185C5.92912 34.7912 5.92912 34.762 5.92912 34.7035V31.7889C5.92912 29.6526 7.06689 27.678 8.91513 26.6067C10.5483 25.6601 12.5628 25.6582 14.1977 26.6018L27.3964 34.2196Z",
        fill: "#F2F7F7"
    }));
};


const $51fb83881f35013e$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    resourceType: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $cddc5da30408dd03$export$fc1920df99f3d560), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $0060961109a2b7eb$export$41e46c9b83e3cfe1), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};














const $c56e7422e28191c0$export$327de5bc0476c8b8 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#09C6FA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.6954 4.25008C15.7025 4.25008 16.7099 4.25338 17.7183 4.25008C18.2271 4.24619 18.6802 4.38244 19.0651 4.72054C19.4877 5.09067 19.7328 5.55604 19.7349 6.11783C19.7436 8.16046 19.767 10.2037 19.7289 12.2454C19.6945 14.0838 19.0364 15.7066 17.8236 17.091C16.5561 18.5389 14.9606 19.4014 13.0546 19.6709C11.5776 19.8805 10.1533 19.6736 8.79837 19.0498C6.90652 18.179 5.57016 16.7631 4.79229 14.8358C4.32449 13.676 4.16198 12.4628 4.29456 11.2138C4.46875 9.57492 5.09668 8.1346 6.17833 6.89283C7.22587 5.69708 8.52271 4.90171 10.0581 4.49714C10.7129 4.32786 11.3871 4.2451 12.0634 4.25098C12.9401 4.25158 13.8175 4.25128 14.6954 4.25008ZM13.1971 11.1482C12.6063 11.1482 12.0155 11.1464 11.4247 11.15C11.322 11.15 11.2897 11.1323 11.3274 11.0221C11.4729 10.5945 11.6099 10.1642 11.7503 9.73443C11.895 9.29243 12.0394 8.85042 12.1837 8.40841C12.2211 8.29372 12.1837 8.20089 12.084 8.14459C11.9844 8.08829 11.8838 8.10895 11.8087 8.20268C11.7668 8.25509 11.7291 8.31079 11.689 8.36529C11.0002 9.32517 10.3118 10.2847 9.62382 11.244C9.34987 11.6257 9.07501 12.0067 8.79926 12.3868C8.76505 12.4287 8.74371 12.4796 8.73781 12.5334C8.73192 12.5872 8.74172 12.6415 8.76604 12.6898C8.81722 12.8 8.9115 12.842 9.02673 12.8464C9.07581 12.8482 9.1252 12.8479 9.17428 12.8479H12.5042C12.7054 12.8479 12.709 12.8479 12.6449 13.0456C12.3744 13.8747 12.1026 14.7032 11.8296 15.5311C11.7802 15.6809 11.8036 15.7737 11.9113 15.8336C12.0191 15.8935 12.1128 15.8677 12.2106 15.7437C12.2247 15.7264 12.2376 15.7081 12.2507 15.6898C13.2284 14.3369 14.2055 12.9839 15.182 11.6309C15.2554 11.5294 15.2919 11.4237 15.2299 11.3063C15.168 11.1889 15.0626 11.1461 14.9288 11.1467C14.3518 11.1503 13.7745 11.1482 13.1971 11.1482Z",
        fill: "white"
    }));
};





const $6d29efead71cf8c0$export$afb7a1d2b1e9186c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#09C6FA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5937 5.66673C20.9365 5.66673 22.2798 5.67113 23.6242 5.66673C24.3026 5.66154 24.9068 5.84322 25.42 6.29401C25.9835 6.78752 26.3103 7.40801 26.3131 8.15706C26.3247 10.8806 26.3558 13.6049 26.3051 16.3272C26.2592 18.7784 25.3817 20.9421 23.7647 22.788C22.0746 24.7185 19.9473 25.8685 17.406 26.2278C15.4367 26.5073 13.5375 26.2314 11.731 25.3997C9.20853 24.2386 7.42672 22.3508 6.38956 19.781C5.76583 18.2346 5.54914 16.6171 5.72592 14.9517C5.95817 12.7665 6.7954 10.8461 8.23761 9.19041C9.63432 7.59607 11.3635 6.53557 13.4106 5.99614C14.2837 5.77043 15.1826 5.66009 16.0843 5.66793C17.2533 5.66873 18.4231 5.66833 19.5937 5.66673ZM17.596 14.8642C16.8082 14.8642 16.0205 14.8618 15.2328 14.8666C15.0959 14.8666 15.0528 14.8431 15.1031 14.6961C15.297 14.1259 15.4798 13.5522 15.6669 12.9792C15.8598 12.3899 16.0524 11.8005 16.2448 11.2112C16.2947 11.0583 16.2448 10.9345 16.1119 10.8594C15.979 10.7843 15.8449 10.8119 15.7447 10.9369C15.6889 11.0067 15.6386 11.081 15.5851 11.1537C14.6667 12.4335 13.7489 13.7129 12.8316 14.992C12.4663 15.5009 12.0999 16.0088 11.7322 16.5156C11.6866 16.5715 11.6581 16.6394 11.6503 16.7111C11.6424 16.7828 11.6555 16.8553 11.6879 16.9197C11.7561 17.0667 11.8818 17.1226 12.0355 17.1285C12.1009 17.1309 12.1668 17.1305 12.2322 17.1305H16.6722C16.9403 17.1305 16.9451 17.1305 16.8597 17.3941C16.499 18.4996 16.1366 19.6042 15.7727 20.7081C15.7068 20.9078 15.738 21.0315 15.8816 21.1114C16.0253 21.1913 16.1502 21.1569 16.2807 20.9916C16.2994 20.9685 16.3166 20.9441 16.3342 20.9197C17.6378 19.1158 18.9406 17.3118 20.2426 15.5079C20.3403 15.3725 20.389 15.2316 20.3064 15.075C20.2238 14.9185 20.0833 14.8614 19.905 14.8622C19.1356 14.867 18.3658 14.8642 17.596 14.8642Z",
        fill: "white"
    }));
};


const $4e05e26811c637e9$export$8120804698f632ae = {
    displayName: 'Freshservice',
    id: 'freshservice',
    icon: (0, $9yyKc.get3PLogo)((0, $c56e7422e28191c0$export$327de5bc0476c8b8), 'Freshservice', 'medium'),
    resourceType: 'freshservice-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $6d29efead71cf8c0$export$afb7a1d2b1e9186c), 'Freshservice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/freshservice',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $4f39dbbcd3d9b471$export$6da1c7984975c183 = ()=>// eslint-disable-next-line @atlassian/a11y/role-img-alt
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        fill: "var(--ds-icon, #292A2E)",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
    }));





const $8577bbb24d570958$export$65b356f251826206 = ()=>// eslint-disable-next-line @atlassian/a11y/role-img-alt
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        fill: "var(--ds-icon, #292A2E)",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
    }));


const $16fc7b862509cb0a$export$49c4b548f63d5a90 = {
    displayName: 'GitBook',
    id: 'gitbook',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $4f39dbbcd3d9b471$export$6da1c7984975c183), 'GitBook'),
    resourceType: 'gitbook-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $8577bbb24d570958$export$65b356f251826206), 'GitBook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    userNeedsOAuth: false,
    // This will only be enabled on the demo instance
    isEnabled: ()=>true
};
































const $b28fd47f0e7211c2$export$e8e65f186ccd8749 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
        fill: "white"
    }));
};





const $8013d871d4b453d5$export$fa0f141eb732d2d7 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 5.33337C10.1097 5.33337 5.33325 10.2298 5.33325 16.2701C5.33325 21.1022 8.3896 25.2018 12.6278 26.6479C13.1609 26.7492 13.3566 26.4107 13.3566 26.1218C13.3566 25.861 13.3467 24.9995 13.3422 24.0856C10.3746 24.7472 9.74847 22.7952 9.74847 22.7952C9.26325 21.5311 8.56412 21.1949 8.56412 21.1949C7.59632 20.5162 8.63707 20.5301 8.63707 20.5301C9.70819 20.6073 10.2722 21.6571 10.2722 21.6571C11.2236 23.3291 12.7675 22.8457 13.3762 22.5663C13.472 21.8594 13.7484 21.377 14.0535 21.1039C11.6842 20.8273 9.19365 19.8895 9.19365 15.6989C9.19365 14.5048 9.61034 13.5292 10.2927 12.7633C10.1819 12.4878 9.81683 11.3755 10.396 9.86903C10.396 9.86903 11.2917 9.57509 13.3301 10.9901C14.181 10.7478 15.0935 10.6262 16 10.6221C16.9065 10.6262 17.8197 10.7478 18.6722 10.9901C20.7081 9.57509 21.6026 9.86903 21.6026 9.86903C22.1832 11.3755 21.8179 12.4878 21.7071 12.7633C22.3911 13.5292 22.8049 14.5048 22.8049 15.6989C22.8049 19.8995 20.3096 20.8244 17.9344 21.0952C18.317 21.4346 18.6579 22.1001 18.6579 23.1205C18.6579 24.5838 18.6455 25.7616 18.6455 26.1218C18.6455 26.4128 18.8375 26.7539 19.3782 26.6465C23.6141 25.1987 26.6666 21.1006 26.6666 16.2701C26.6666 10.2298 21.8909 5.33337 16 5.33337Z",
        fill: "white"
    }));
};


const $90d5c696e3fdd30c$var$getGithubTypeFilterConfig = ()=>{
    const config = new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $lgIW7.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $e8tw2.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).DevopsWorkItem,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]);
    if ((0, $dh538.fg)('rovo_github_code_search')) config.set((0, $2Znam.TypeFilterValueKey).Document, {
        entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $90d5c696e3fdd30c$export$71c63cb45707eee = {
    displayName: 'GitHub',
    id: 'github',
    resourceType: 'github-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $b28fd47f0e7211c2$export$e8e65f186ccd8749), 'Github', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $8013d871d4b453d5$export$fa0f141eb732d2d7), 'Github', 'large'),
    integrationAri: 'ari:cloud:platform::integration/github',
    get typeFilterConfig () {
        return $90d5c696e3fdd30c$var$getGithubTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'pullRequestStatus',
        'repository'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $5fd4b746d8633c4e$export$8b4e5326778cce0f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.7331 10.3948L19.7115 10.3373L17.5339 4.65705C17.4898 4.54552 17.4114 4.4509 17.31 4.3869C17.2343 4.33846 17.1483 4.30842 17.059 4.29919C16.9696 4.28996 16.8793 4.30179 16.7953 4.33375C16.7113 4.3657 16.636 4.41688 16.5754 4.4832C16.5147 4.54951 16.4705 4.6291 16.4461 4.7156L14.9763 9.21564H9.02381L7.55392 4.7156C7.5294 4.62923 7.48504 4.54979 7.42438 4.4836C7.36371 4.41742 7.28842 4.36632 7.20451 4.3344C7.1206 4.30247 7.03039 4.29059 6.94107 4.2997C6.85175 4.30882 6.7658 4.33868 6.69007 4.3869C6.58865 4.4509 6.51022 4.54552 6.46615 4.65705L4.28957 10.3383L4.26697 10.3948C3.95361 11.2138 3.91501 12.1125 4.15698 12.9553C4.39895 13.7981 4.90838 14.5394 5.60846 15.0674L5.61668 15.0736L5.63517 15.088L8.94779 17.5706L10.5913 18.8125L11.5897 19.5675C11.7068 19.656 11.8496 19.7038 11.9964 19.7038C12.1432 19.7038 12.2861 19.656 12.4032 19.5675L13.4016 18.8125L15.0451 17.5706L18.3813 15.0736L18.3906 15.0664C19.0906 14.5386 19.6001 13.7975 19.8423 12.9549C20.0844 12.1123 20.0461 11.2138 19.7331 10.3948Z",
        fill: "#E24329"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.7329 10.3948L19.7114 10.3373C18.6504 10.555 17.6507 11.0047 16.7839 11.6541L12.0024 15.2698L15.047 17.5706L18.3832 15.0736L18.3925 15.0664C19.0922 14.5383 19.6012 13.7971 19.843 12.9545C20.0848 12.1119 20.0462 11.2135 19.7329 10.3948Z",
        fill: "#FC6D26"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.94775 17.5708L10.5912 18.8126L11.5896 19.5676C11.7068 19.6561 11.8496 19.7039 11.9964 19.7039C12.1432 19.7039 12.286 19.6561 12.4032 19.5676L13.4016 18.8126L15.045 17.5708L12.0005 15.2699L8.94775 17.5708Z",
        fill: "#FCA326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.21598 11.6541C6.34952 11.005 5.35016 10.5556 4.28957 10.3383L4.26697 10.3948C3.95361 11.2137 3.91501 12.1124 4.15698 12.9552C4.39895 13.798 4.90838 14.5393 5.60846 15.0674L5.61668 15.0735L5.63517 15.0879L8.94779 17.5706L11.9944 15.2697L7.21598 11.6541Z",
        fill: "#FC6D26"
    }));
};





const $24c3b7ddf21cb46a$export$7e0d364467f49036 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.7331 6.09869L15.7115 6.04117L13.5339 0.360908C13.4898 0.249375 13.4114 0.15476 13.31 0.0907616C13.2343 0.042317 13.1483 0.0122753 13.059 0.00304387C12.9696 -0.00618758 12.8793 0.0056484 12.7953 0.0376029C12.7113 0.0695574 12.636 0.120742 12.5754 0.187053C12.5147 0.253365 12.4705 0.332959 12.4461 0.419457L10.9763 4.91949H5.02381L3.55392 0.419457C3.5294 0.333089 3.48504 0.253644 3.42438 0.187459C3.36371 0.121275 3.28842 0.070181 3.20451 0.0382526C3.1206 0.00632414 3.03039 -0.00555559 2.94107 0.00356109C2.85175 0.0126778 2.7658 0.0425382 2.69007 0.0907616C2.58865 0.15476 2.51023 0.249375 2.46615 0.360908L0.289573 6.04219L0.266975 6.09869C-0.0463882 6.91766 -0.0849934 7.81631 0.156979 8.65914C0.398952 9.50196 0.908385 10.2433 1.60846 10.7713L1.61668 10.7775L1.63517 10.7918L4.9478 13.2745L6.59127 14.5164L7.58968 15.2713C7.70683 15.3598 7.84963 15.4077 7.99644 15.4077C8.14325 15.4077 8.28606 15.3598 8.4032 15.2713L9.40161 14.5164L11.0451 13.2745L14.3813 10.7775L14.3906 10.7703C15.0906 10.2424 15.6001 9.50137 15.8423 8.65875C16.0844 7.81613 16.0461 6.91763 15.7331 6.09869Z",
        fill: "#E24329"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.7331 6.09867L15.7115 6.04115C14.6505 6.25887 13.6508 6.70855 12.784 7.35799L8.00256 10.9736L11.0471 13.2745L14.3833 10.7774L14.3926 10.7703C15.0923 10.2422 15.6014 9.50097 15.8431 8.65836C16.0849 7.81576 16.0463 6.91741 15.7331 6.09867Z",
        fill: "#FC6D26"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.94781 13.2745L6.59129 14.5163L7.5897 15.2713C7.70685 15.3598 7.84965 15.4077 7.99646 15.4077C8.14327 15.4077 8.28607 15.3598 8.40322 15.2713L9.40163 14.5163L11.0451 13.2745L8.00057 10.9736L4.94781 13.2745Z",
        fill: "#FCA326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.21598 7.358C2.34952 6.7089 1.35016 6.25955 0.289573 6.0422L0.266975 6.09869C-0.0463882 6.91766 -0.0849934 7.81631 0.156979 8.65914C0.398952 9.50197 0.908384 10.2433 1.60846 10.7713L1.61668 10.7775L1.63517 10.7918L4.9478 13.2745L7.99439 10.9736L3.21598 7.358Z",
        fill: "#FC6D26"
    }));





const $39fd142ba4916877$export$b828123bc19648f9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "#F5F5F5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.3107 13.8597L26.2819 13.783L23.3785 6.20936C23.3197 6.06065 23.2151 5.9345 23.0799 5.84916C22.979 5.78457 22.8644 5.74452 22.7452 5.73221C22.626 5.7199 22.5056 5.73568 22.3937 5.77829C22.2817 5.82089 22.1813 5.88914 22.1004 5.97755C22.0196 6.06597 21.9606 6.1721 21.9281 6.28743L19.9683 12.2875H12.0317L10.0718 6.28743C10.0391 6.17227 9.97998 6.06634 9.89909 5.9781C9.8182 5.88985 9.71782 5.82172 9.60593 5.77915C9.49405 5.73658 9.37377 5.72074 9.25468 5.7329C9.13559 5.74505 9.02099 5.78487 8.92002 5.84916C8.78479 5.9345 8.68022 6.06065 8.62145 6.20936L5.71935 13.7844L5.68922 13.8597C5.2714 14.9517 5.21993 16.1499 5.54256 17.2737C5.86519 18.3974 6.54443 19.3858 7.47787 20.0899L7.48882 20.0981L7.51348 20.1173L11.9303 23.4275L14.1216 25.0833L15.4528 26.0899C15.609 26.2079 15.7994 26.2717 15.9952 26.2717C16.1909 26.2717 16.3813 26.2079 16.5375 26.0899L17.8687 25.0833L20.06 23.4275L24.5084 20.0981L24.5207 20.0885C25.4541 19.3847 26.1334 18.3966 26.4563 17.2732C26.7791 16.1497 26.728 14.9517 26.3107 13.8597Z",
        fill: "#E24329"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.3105 13.8598L26.2817 13.7831C24.8671 14.0734 23.5342 14.6729 22.3785 15.5389L16.0032 20.3597L20.0626 23.4275L24.5109 20.0981L24.5232 20.0885C25.4561 19.3844 26.1349 18.3962 26.4573 17.2727C26.7796 16.1492 26.7281 14.9514 26.3105 13.8598Z",
        fill: "#FC6D26"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9302 23.4277L14.1215 25.0835L15.4527 26.0901C15.6089 26.2081 15.7993 26.2719 15.995 26.2719C16.1908 26.2719 16.3812 26.2081 16.5374 26.0901L17.8686 25.0835L20.0599 23.4277L16.0005 20.3599L11.9302 23.4277Z",
        fill: "#FCA326"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.62123 15.5387C8.46595 14.6732 7.13347 14.0741 5.71935 13.7843L5.68922 13.8596C5.2714 14.9516 5.21993 16.1498 5.54256 17.2736C5.86519 18.3973 6.54443 19.3857 7.47787 20.0898L7.48882 20.098L7.51348 20.1172L11.9303 23.4274L15.9924 20.3596L9.62123 15.5387Z",
        fill: "#FC6D26"
    }));
};


const $04e57759b6e32a8a$export$72758f81cc2e21e1 = {
    displayName: 'Gitlab',
    id: 'gitlab',
    resourceType: 'gitlab-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $5fd4b746d8633c4e$export$8b4e5326778cce0f), 'Gitlab', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $24c3b7ddf21cb46a$export$7e0d364467f49036), 'Gitlab', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $39fd142ba4916877$export$b828123bc19648f9), 'Gitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gitlab',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Repository,
                    (0, $2Znam.NounSubtypeKey).Project
                ]
            }
        ]
    ]),
    filters: [
        'pullRequestStatus'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};



var $idpYy = parcelRequire("idpYy");










const $ff58957b80382e85$export$856bad9032bbc5ed = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.52273 17.625H7.90909V11.8295L4.5 9.27271V16.6023C4.5 17.1682 4.95852 17.625 5.52273 17.625Z",
        fill: "#4285F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.0908 17.625H18.4772C19.0431 17.625 19.4999 17.1665 19.4999 16.6023V9.27271L16.0908 11.8295",
        fill: "#34A853"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.0908 7.3977V11.8295L19.4999 9.2727V7.90906C19.4999 6.64429 18.0562 5.92327 17.0454 6.68179",
        fill: "#FBBC04"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.90918 11.8295V7.39771L12.0001 10.4659L16.091 7.39771V11.8295L12.0001 14.8977",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.5 7.90931V9.27294L7.90909 11.8298V7.39794L6.95455 6.68203C5.94205 5.92351 4.5 6.64453 4.5 7.90931Z",
        fill: "#C5221F"
    })));
};





const $3979502ce2da8f33$export$60f25f99f40f37f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19362)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.954545 11.25H3.18182V5.84089L0 3.45453V10.2954C0 10.8236 0.427955 11.25 0.954545 11.25Z",
        fill: "#4285F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.8182 11.25H13.0454C13.5736 11.25 14 10.822 14 10.2954V3.45453L10.8182 5.84089",
        fill: "#34A853"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.8182 1.70457V5.84093L14 3.45457V2.18184C14 1.00139 12.6525 0.328431 11.7091 1.03639",
        fill: "#FBBC04"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.18182 5.84089V1.70453L7.00001 4.56817L10.8182 1.70453V5.84089L7.00001 8.70453",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 2.18184V3.45457L3.18182 5.84093V1.70457L2.29091 1.03639C1.34591 0.328431 0 1.00139 0 2.18184Z",
        fill: "#C5221F"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19362"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "14",
        height: "10.5",
        fill: "white",
        transform: "translate(0 0.75)"
    }))));





const $67e458088a703c36$export$5abf8db8f9fa0429 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.36364 23.8302H10.5455V16.1029L6 12.6938V22.4665C6 23.2211 6.61136 23.8302 7.36364 23.8302Z",
        fill: "#4285F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.4546 23.8302H24.6364C25.391 23.8302 26 23.2188 26 22.4665V12.6938L21.4546 16.1029",
        fill: "#34A853"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.4546 10.1939V16.103L26 12.6939V10.8757C26 9.18931 24.075 8.22795 22.7273 9.23931",
        fill: "#FBBC04"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.5454 16.1029V10.1938L16 14.2848L21.4545 10.1938V16.1029L16 20.1938",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6 10.876V12.6942L10.5455 16.1033V10.1942L9.27273 9.23968C7.92273 8.22832 6 9.18968 6 10.876Z",
        fill: "#C5221F"
    })));
};


const $6897f2334c0e7a05$export$c771ac380e225e02 = {
    displayName: 'Gmail',
    id: 'gmail',
    resourceType: 'gmail-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $ff58957b80382e85$export$856bad9032bbc5ed), 'Gmail', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $3979502ce2da8f33$export$60f25f99f40f37f6), 'Gmail', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $67e458088a703c36$export$5abf8db8f9fa0429), 'Gmail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $idpYy.FEDERATED_GOOGLE_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    isEnabled: ()=>true,
    isFederated: true
};























const $068e81d162c29380$export$e16bd899bb4eebf9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.20962 17.0782L5.91523 18.2907C6.06186 18.546 6.27262 18.7466 6.52005 18.8925L9.04009 14.5529H4C4 14.8355 4.07331 15.1181 4.21993 15.3734L5.20962 17.0782Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12 9.44751L9.47995 5.10791C9.23253 5.25378 9.02176 5.45435 8.87514 5.70962L4.21993 13.7324C4.07601 13.9822 4.00019 14.265 4 14.5529H9.04009L12 9.44751Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.4799 18.8925C17.7273 18.7466 17.9381 18.546 18.0847 18.2907L18.3779 17.7893L19.78 15.3734C19.9266 15.1181 19.9999 14.8355 19.9999 14.5529H14.9595L16.032 16.6497L17.4799 18.8925Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12 9.4475L14.5201 5.1079C14.2726 4.96203 13.9886 4.8891 13.6953 4.8891H10.3047C10.0115 4.8891 9.7274 4.97115 9.47998 5.1079L12 9.4475Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.9594 14.5529H9.03958L6.51953 18.8925C6.76695 19.0383 7.05103 19.1113 7.34427 19.1113H16.6547C16.9479 19.1113 17.232 19.0292 17.4794 18.8925L14.9594 14.5529Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.4525 9.72101L15.1249 5.70962C14.9782 5.45435 14.7675 5.25378 14.52 5.10791L12 9.44751L14.9599 14.5529H19.9908C19.9908 14.2703 19.9175 13.9877 19.7709 13.7324L17.4525 9.72101Z",
        fill: "#FFBA00"
    })));
};





const $5069d2c177813c3b$export$1f3b452b60b13122 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19249)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19249"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "14.6667",
        fill: "white"
    }))));





const $3be53feab8966d09$export$99050685a064f8e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.94608 22.7709L7.8869 24.3877C8.08239 24.728 8.36342 24.9955 8.69331 25.1899L12.0534 19.4038H5.33325C5.33325 19.7806 5.431 20.1575 5.62649 20.4978L6.94608 22.7709Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.9999 12.5966L12.6399 6.81049C12.31 7.00498 12.0289 7.2724 11.8334 7.61276L5.62649 18.3098C5.43459 18.6428 5.33351 19.02 5.33325 19.4038H12.0534L15.9999 12.5966Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.3066 25.1899C23.6365 24.9955 23.9175 24.728 24.113 24.3877L24.504 23.7191L26.3734 20.4978C26.5689 20.1575 26.6667 19.7806 26.6667 19.4038H19.946L21.3761 22.1996L23.3066 25.1899Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16 12.5967L19.36 6.81054C19.0301 6.61604 18.6513 6.5188 18.2604 6.5188H13.7395C13.3486 6.5188 12.9698 6.6282 12.6399 6.81054L16 12.5967Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.9463 19.4038H12.0532L8.69312 25.1899C9.02301 25.3844 9.40178 25.4817 9.79277 25.4817H22.2067C22.5977 25.4817 22.9764 25.3723 23.3063 25.1899L19.9463 19.4038Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.2697 12.9613L20.1662 7.61276C19.9707 7.2724 19.6897 7.00498 19.3598 6.81049L15.9998 12.5966L19.9463 19.4038H26.6542C26.6542 19.027 26.5565 18.6502 26.361 18.3098L23.2697 12.9613Z",
        fill: "#FFBA00"
    })));
};


const $6f79a547f5811124$var$getGoogleDriveTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $2Znam.TypeFilterValueKey).Document, {
        entities3P: [
            ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: (0, $dh538.fg)('rovo_fps_enable_google_drive_new_types_filter') ? [
            (0, $2Znam.NounSubtypeKey).Document,
            (0, $2Znam.NounSubtypeKey).Pdf,
            (0, $2Znam.NounSubtypeKey).Page,
            (0, $2Znam.NounSubtypeKey).Blogpost
        ] : [
            (0, $2Znam.NounSubtypeKey).Document,
            (0, $2Znam.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $2Znam.TypeFilterValueKey).Spreadsheet, {
        entities3P: [
            ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $2Znam.TypeFilterValueKey).Presentation, {
        entities3P: [
            ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Presentation
        ]
    });
    if ((0, $dh538.fg)('rovo_fps_enable_video_noun_filter')) config.set((0, $2Znam.TypeFilterValueKey).Video, {
        entities3P: [
            ...(0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Video
        ]
    });
    if ((0, $dh538.fg)('rovo_fps_enable_google_drive_new_types_filter')) {
        config.set((0, $2Znam.TypeFilterValueKey).Image, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Image
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Folder, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Folder
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Audio, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Audio
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Pdf, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Pdf
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Code, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Code
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Form, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Form
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Notebook, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Notebook
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).WebPage, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).WebPage,
                (0, $2Znam.NounSubtypeKey).Shortcut
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Other, {
            entities3P: [
                ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
            ],
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Other,
                (0, $2Znam.NounSubtypeKey).Archive
            ]
        });
    }
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats Google Drive comment matches as documents rather than standalone comments.
    if ((0, $dh538.fg)('enable_3p_embedded_comments_search')) config.set((0, $2Znam.TypeFilterValueKey).Comment, {
        entities3P: [
            ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    return config;
};
const $6f79a547f5811124$export$6634ddcb22ed69a = {
    displayName: 'Google Drive',
    id: 'drive',
    resourceType: 'google-drive-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $068e81d162c29380$export$e16bd899bb4eebf9), 'Google Drive', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $5069d2c177813c3b$export$1f3b452b60b13122), 'Google Drive', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $3be53feab8966d09$export$99050685a064f8e), 'Google Drive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    // Use a getter to evaluate lazily so that it's evaluated when accessed, not at module load.
    // This allows for feature gate mocks in tests to work correctly
    get typeFilterConfig () {
        return $6f79a547f5811124$var$getGoogleDriveTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch'
        ];
        if ((0, $dh538.fg)('rovo_fps_enable_gdrive_space_filter')) baseFilters.push('space');
        if ((0, $dh538.fg)('rovo_fps_enable_gdrive_content_filter')) baseFilters.push('content');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};














const $61ad3ffe7b1940bf$export$5d128e0a6ffc0558 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.8208 8.17936L12.3822 7.7973L8.17949 8.17936L7.79736 12.0001L8.17942 15.8207L12.0001 16.2983L15.8208 15.8207L16.2029 11.9046L15.8208 8.17936Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.74654 14.1071C9.46096 13.9142 9.26322 13.6324 9.15527 13.2599L9.81819 12.9867C9.87837 13.216 9.98341 13.3936 10.1334 13.5197C10.2824 13.6458 10.4639 13.7079 10.6759 13.7079C10.8928 13.7079 11.079 13.642 11.2347 13.5101C11.3903 13.3783 11.4687 13.2102 11.4687 13.0068C11.4687 12.7986 11.3866 12.6285 11.2223 12.4967C11.058 12.365 10.8517 12.299 10.6052 12.299H10.2222V11.6428H10.566C10.7781 11.6428 10.9567 11.5856 11.1019 11.4709C11.2471 11.3563 11.3197 11.1997 11.3197 11C11.3197 10.8224 11.2547 10.681 11.1249 10.575C10.995 10.469 10.8306 10.4155 10.631 10.4155C10.4362 10.4155 10.2814 10.4671 10.1668 10.5712C10.0522 10.6753 9.96904 10.8033 9.91655 10.9542L9.26039 10.681C9.34728 10.4346 9.50684 10.2168 9.74081 10.0287C9.97484 9.8405 10.2738 9.74591 10.6367 9.74591C10.9051 9.74591 11.1468 9.79752 11.3608 9.90162C11.5747 10.0057 11.7428 10.15 11.8641 10.3333C11.9854 10.5176 12.0456 10.724 12.0456 10.9532C12.0456 11.1872 11.9893 11.3849 11.8766 11.5473C11.7638 11.7097 11.6253 11.8338 11.461 11.9208V11.9599C11.6779 12.0507 11.8546 12.1892 11.994 12.3754C12.1325 12.5617 12.2022 12.7843 12.2022 13.0441C12.2022 13.3039 12.1363 13.536 12.0045 13.7394C11.8726 13.9429 11.6902 14.1034 11.4591 14.2199C11.227 14.3364 10.9662 14.3956 10.6768 14.3956C10.3416 14.3966 10.0321 14.3001 9.74654 14.1071Z",
        fill: "#1A73E8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.8145 10.8175L13.0905 11.3438L12.7266 10.7917L14.0323 9.84991H14.5328V14.2924H13.8145V10.8175Z",
        fill: "#1A73E8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.8208 19.2592L19.2593 15.8206L17.54 15.0565L15.8208 15.8206L15.0566 17.5399L15.8208 19.2592Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.41504 17.54L8.17915 19.2593H15.8205V15.8207H8.17915L7.41504 17.54Z",
        fill: "#34A853"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.88689 4.74078C5.25366 4.74078 4.74072 5.25372 4.74072 5.88695V15.8207L6.46001 16.5848L8.17929 15.8207V8.17935H15.8206L16.5847 6.46007L15.8207 4.74078H5.88689Z",
        fill: "#4285F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.74072 15.8207V18.1131C4.74072 18.7464 5.25366 19.2593 5.88689 19.2593H8.17929V15.8207H4.74072Z",
        fill: "#188038"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.8203 8.17945V15.8208H19.2589V8.17945L17.5396 7.41534L15.8203 8.17945Z",
        fill: "#FBBC04"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.2589 8.17929V5.88689C19.2589 5.25359 18.7459 4.74072 18.1127 4.74072H15.8203V8.17929H19.2589Z",
        fill: "#1967D2"
    })));
};
var $61ad3ffe7b1940bf$export$2e2bcd8739ae039 = $61ad3ffe7b1940bf$export$5d128e0a6ffc0558;





const $8f89ce68e5ba78e0$export$dc8e328f8eb98139 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19095)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.2106 3.78945L8.42113 3.36841L3.78953 3.78945L3.36841 8.00001L3.78945 12.2106L8.00001 12.7369L12.2106 12.2106L12.6316 7.89481L12.2106 3.78945Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.5169 10.3221C5.20218 10.1095 4.98426 9.79899 4.8653 9.38843L5.59586 9.08739C5.66218 9.34003 5.77794 9.53579 5.94322 9.67475C6.10746 9.81371 6.30746 9.88211 6.54114 9.88211C6.7801 9.88211 6.98538 9.80947 7.1569 9.66419C7.32842 9.51891 7.41481 9.33363 7.41481 9.10947C7.41481 8.88003 7.32426 8.69259 7.14322 8.54739C6.96218 8.40219 6.73482 8.32947 6.46322 8.32947H6.04114V7.60635H6.42002C6.6537 7.60635 6.85058 7.54323 7.01058 7.41691C7.17058 7.29059 7.25058 7.11795 7.25058 6.89795C7.25058 6.70219 7.17898 6.54635 7.03586 6.42955C6.89274 6.31275 6.71161 6.25379 6.49161 6.25379C6.27689 6.25379 6.10634 6.31067 5.98002 6.42539C5.8537 6.54011 5.7621 6.68115 5.70426 6.84747L4.98114 6.54643C5.0769 6.27483 5.25274 6.03483 5.51058 5.82747C5.7685 5.62011 6.09794 5.51587 6.49794 5.51587C6.7937 5.51587 7.06001 5.57275 7.29586 5.68747C7.53162 5.80219 7.7169 5.96115 7.85058 6.16323C7.98426 6.36635 8.05058 6.59379 8.05058 6.84635C8.05058 7.10427 7.9885 7.32211 7.86426 7.50107C7.74002 7.68003 7.58738 7.81683 7.40634 7.91267V7.95579C7.6453 8.05579 7.84001 8.20843 7.9937 8.41371C8.14633 8.61899 8.22314 8.86427 8.22314 9.15059C8.22314 9.43691 8.1505 9.69267 8.00522 9.91691C7.85994 10.1411 7.6589 10.3179 7.40418 10.4463C7.14842 10.5747 6.86106 10.64 6.5421 10.64C6.17266 10.6411 5.83162 10.5347 5.5169 10.3221Z",
        fill: "#1A73E8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.99974 6.69687L9.20182 7.27687L8.80078 6.66847L10.2397 5.63055H10.7913V10.5263H9.99974V6.69687Z",
        fill: "#1A73E8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.2105 16L16 12.2105L14.1053 11.3685L12.2105 12.2105L11.3685 14.1053L12.2105 16Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M2.94739 14.1053L3.78947 16H12.2105V12.2106H3.78947L2.94739 14.1053Z",
        fill: "#34A853"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.26312 0C0.56528 0 0 0.56528 0 1.26312V12.2105L1.89472 13.0526L3.78944 12.2105V3.78944H12.2105L13.0526 1.89472L12.2106 0H1.26312Z",
        fill: "#4285F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 12.2106V14.7369C0 15.4348 0.56528 16 1.26312 16H3.78944V12.2106H0Z",
        fill: "#188038"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.2103 3.78953V12.2106H15.9997V3.78953L14.105 2.94745L12.2103 3.78953Z",
        fill: "#FBBC04"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.9997 3.78944V1.26312C15.9997 0.5652 15.4344 0 14.7366 0H12.2103V3.78944H15.9997Z",
        fill: "#1967D2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19095"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));





const $1c53c24dc9ffba88$export$aed283b8fb73a449 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.0942 10.8996L16.5094 10.3902L10.9057 10.8996L10.3962 15.9939L10.9056 21.0881L15.9999 21.7249L21.0942 21.0881L21.6036 15.8666L21.0942 10.8996Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.9956 18.8033C12.6149 18.546 12.3512 18.1704 12.2073 17.6737L13.0912 17.3094C13.1714 17.6151 13.3115 17.8519 13.5114 18.0201C13.7101 18.1882 13.9521 18.271 14.2348 18.271C14.5239 18.271 14.7723 18.1831 14.9798 18.0073C15.1873 17.8315 15.2919 17.6074 15.2919 17.3362C15.2919 17.0586 15.1823 16.8318 14.9633 16.6561C14.7442 16.4804 14.4692 16.3925 14.1406 16.3925H13.6299V15.5176H14.0883C14.371 15.5176 14.6092 15.4412 14.8028 15.2884C14.9964 15.1355 15.0932 14.9267 15.0932 14.6605C15.0932 14.4236 15.0065 14.2351 14.8334 14.0938C14.6602 13.9525 14.4411 13.8811 14.1749 13.8811C13.9151 13.8811 13.7088 13.95 13.5559 14.0887C13.4031 14.2275 13.2923 14.3982 13.2223 14.5994L12.3474 14.2352C12.4633 13.9066 12.676 13.6162 12.988 13.3653C13.3 13.1145 13.6986 12.9883 14.1826 12.9883C14.5404 12.9883 14.8626 13.0572 15.148 13.196C15.4332 13.3348 15.6574 13.5271 15.8191 13.7716C15.9808 14.0173 16.0611 14.2925 16.0611 14.5981C16.0611 14.9101 15.986 15.1737 15.8356 15.3902C15.6853 15.6067 15.5007 15.7722 15.2816 15.8882V15.9403C15.5707 16.0613 15.8063 16.246 15.9923 16.4944C16.1769 16.7427 16.2698 17.0395 16.2698 17.3859C16.2698 17.7323 16.182 18.0418 16.0062 18.3131C15.8304 18.5844 15.5872 18.7983 15.279 18.9536C14.9696 19.109 14.6219 19.1879 14.236 19.1879C13.789 19.1892 13.3764 19.0606 12.9956 18.8033Z",
        fill: "#1A73E8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.4191 14.4171L17.4537 15.1189L16.9685 14.3828L18.7095 13.127H19.3768V19.0503H18.4191V14.4171Z",
        fill: "#1A73E8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.0943 25.6728L25.679 21.088L23.3866 20.0692L21.0943 21.088L20.0754 23.3804L21.0943 25.6728Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.88672 23.3805L10.9055 25.6729H21.094V21.0881H10.9055L9.88672 23.3805Z",
        fill: "#34A853"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.84902 6.31488C7.00472 6.31488 6.3208 6.9988 6.3208 7.8431V21.0881L8.61318 22.1069L10.9056 21.0881V10.8996H21.094L22.1128 8.60726L21.0941 6.31488H7.84902Z",
        fill: "#4285F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.3208 21.0881V24.1447C6.3208 24.9891 7.00472 25.6729 7.84902 25.6729H10.9056V21.0881H6.3208Z",
        fill: "#188038"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.0938 10.8997V21.0882H25.6785V10.8997L23.3861 9.88092L21.0938 10.8997Z",
        fill: "#FBBC04"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M25.6785 10.8996V7.84304C25.6785 6.99864 24.9946 6.31482 24.1503 6.31482H21.0938V10.8996H25.6785Z",
        fill: "#1967D2"
    })));
};


const $d55193f0e88e1ac8$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: 'google-calendar-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $61ad3ffe7b1940bf$export$5d128e0a6ffc0558), 'Google Calendar', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $8f89ce68e5ba78e0$export$dc8e328f8eb98139), 'Google Calendar', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $1c53c24dc9ffba88$export$aed283b8fb73a449), 'Google Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    isEnabled: ()=>true
};




















const $d8abffbc9011bd03$export$bee6964e6c60da93 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#FF5C35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
        fill: "white"
    }));
};





const $ddf40ae0a235f4dc$export$c9a6a66ee7acc43a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#FF5C35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.7267 9.81495V12.354C24.1316 12.7088 26.0529 14.4518 26.5457 16.726C27.0386 19.0003 25.9994 21.3274 23.9391 22.5635C21.8788 23.7995 19.2307 23.6843 17.2968 22.2746L15.1343 24.3383C15.1904 24.5057 15.2201 24.6801 15.2227 24.8558C15.2227 25.5882 14.7603 26.2486 14.0513 26.5288C13.3422 26.8091 12.5261 26.6542 11.9834 26.1363C11.4407 25.6184 11.2784 24.8395 11.5721 24.1629C11.8658 23.4863 12.5577 23.045 13.3251 23.045C13.5093 23.0476 13.692 23.076 13.8675 23.1293L16.0534 21.0432C14.6752 19.1722 14.6396 16.6862 15.9637 14.7799L8.78076 9.44358C8.4342 9.63626 8.04058 9.73846 7.63949 9.73989C6.3644 9.73843 5.33197 8.75082 5.3335 7.53399C5.33502 6.31718 6.36992 5.33192 7.64501 5.33338C8.9201 5.33483 9.95253 6.32244 9.95101 7.53927C9.94803 7.72494 9.92021 7.90949 9.86821 8.08843L17.1739 13.513C17.9709 12.9014 18.9231 12.5016 19.934 12.354V9.81495C19.2163 9.49505 18.7563 8.80883 18.7527 8.05287V7.99361C18.7557 6.91618 19.6702 6.04347 20.7993 6.04058H20.8613C21.9904 6.04347 22.9049 6.91618 22.9079 7.99361V8.05287C22.9044 8.80883 22.4444 9.49505 21.7267 9.81495ZM17.8387 17.8509C17.8387 19.4277 19.1782 20.706 20.8306 20.706C22.483 20.706 23.8225 19.4277 23.8225 17.8509C23.8225 16.274 22.483 14.9957 20.8306 14.9957C19.1782 14.9957 17.8387 16.274 17.8387 17.8509Z",
        fill: "white"
    }));
};


const $6501c29a91901a05$export$ba5f4c654d743419 = {
    displayName: 'HubSpot',
    id: 'hubspot',
    resourceType: 'hubspot-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $d8abffbc9011bd03$export$bee6964e6c60da93), 'HubSpot', 'medium'),
    searchResultIcon: (0, $9yyKc.RovoLogoFromGlyph)((0, $ddf40ae0a235f4dc$export$c9a6a66ee7acc43a), 'HubSpot'),
    integrationAri: 'ari:cloud:platform::integration/hubspot',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
























var $fl27B = parcelRequire("fl27B");

const $266323abfb0e99be$export$7441620f71b01d27 = {
    displayName: 'Jira Data Center',
    id: 'jira-dc',
    resourceType: 'jira-dc-connector',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraIcon), 'Jira Data Center'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $fl27B.JiraSearchResultIcon), 'Jira Data Center', 'large'),
    integrationAri: 'ari:cloud:platform::integration/jira-dc',
    containerTypes: [
        'software',
        'business',
        'project'
    ],
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Software,
                    (0, $2Znam.NounSubtypeKey).Business,
                    (0, $2Znam.NounSubtypeKey).ServiceDesk,
                    (0, $2Znam.NounSubtypeKey).Project
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Issue,
            {
                entities3P: [
                    ...(0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Issue
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'project',
        'assignee'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true,
    fanOutConnectorSources: true,
    // For jira DC, we want to filter by integrationId and providerId for each datasource
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>{
        return {
            ...existingFilters,
            thirdPartyProduct: {
                ...existingFilters?.thirdPartyProduct,
                integrationId: datasource?.integrationAri,
                providerId: datasource?.providerId
            }
        };
    }
};
























var $bj3ok = parcelRequire("bj3ok");

const $cf5bf5c6930cbca7$export$1bc88db204558364 = {
    displayName: 'JSM Data Center',
    id: 'jsm-dc',
    resourceType: 'jsm-dc-connector',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraServiceManagementIcon), 'JSM Data Center'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bj3ok.JiraServiceManagementSearchResultIcon), 'JSM Data Center', 'large'),
    integrationAri: 'ari:cloud:platform::integration/jira-dc',
    containerTypes: [
        'service_desk'
    ],
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).ServiceDesk
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Issue,
            {
                entities3P: [
                    ...(0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Issue
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'project',
        'assignee'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    // For JSM DC, we want to filter by integrationId and providerId for each datasource
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>{
        return {
            ...existingFilters,
            thirdPartyProduct: {
                ...existingFilters?.thirdPartyProduct,
                integrationId: datasource?.integrationAri,
                providerId: datasource?.providerId
            }
        };
    }
};














const $0c8cf6610d5ad1f2$export$68470e68dec0bc46 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.0232 12.0808C20.0002 12.2346 19.9148 12.3512 19.8075 12.4584C17.3508 14.9147 14.895 17.3719 12.4389 19.8288C12.4116 19.8561 12.3853 19.8845 12.3562 19.9098C12.2424 20.0088 12.113 20.0247 11.9781 19.9655C11.845 19.9072 11.7732 19.798 11.7632 19.6539C11.7574 19.5702 11.7891 19.4944 11.8388 19.4264C11.9362 19.2931 12.0329 19.1593 12.13 19.0257C12.7486 18.1738 13.3672 17.3218 13.9859 16.47C14.3904 15.913 14.795 15.3562 15.1995 14.7994C15.3066 14.6519 15.4141 14.5047 15.5208 14.357C15.5315 14.3423 15.5483 14.3295 15.5454 14.3065C15.5243 14.3004 15.5082 14.3131 15.4912 14.32C14.8996 14.5611 14.308 14.8024 13.7166 15.0438C13.2263 15.2439 12.7362 15.4442 12.246 15.6446C11.1843 16.0784 10.1224 16.5119 9.06106 16.9467C8.97552 16.9817 8.88978 17.0024 8.79819 16.9813C8.65305 16.9479 8.54691 16.8331 8.52155 16.684C8.49883 16.5505 8.56326 16.4093 8.68877 16.3339C8.9313 16.1881 9.17582 16.0455 9.41951 15.9016C10.289 15.3879 11.1584 14.8742 12.028 14.3607C12.7979 13.9061 13.568 13.4519 14.338 12.9974C14.3655 12.9812 14.3924 12.9642 14.4339 12.9389C14.3588 12.9323 14.2988 12.9253 14.2387 12.922C13.9713 12.9073 13.7038 12.894 13.4363 12.8793C13.2181 12.8673 13 12.8547 12.7819 12.8415C12.5296 12.8261 12.2774 12.8095 12.0251 12.7943C11.9225 12.788 11.8197 12.7846 11.717 12.7786C11.5224 12.7673 11.3279 12.7548 11.1333 12.7432C11.0542 12.7385 10.975 12.7358 10.8959 12.7303C10.7057 12.7172 10.515 12.711 10.3246 12.6999C10.0723 12.6852 9.82012 12.6679 9.56774 12.6531C9.48432 12.6482 9.40084 12.6449 9.31742 12.6397C9.0523 12.6232 8.78686 12.6112 8.52161 12.5966C8.29917 12.5844 8.07679 12.5711 7.85434 12.5583C7.62765 12.5453 7.40082 12.5335 7.17426 12.519C6.95188 12.5048 6.72956 12.4913 6.50699 12.4805C6.28229 12.4696 6.05785 12.4551 5.83328 12.4422C5.61083 12.4294 5.38845 12.4166 5.166 12.4038C4.94356 12.391 4.72111 12.3791 4.49873 12.3648C4.43675 12.3608 4.37431 12.3592 4.31284 12.3523C4.16358 12.3353 4.05918 12.256 4.00602 12.1135C3.99707 12.0894 3.99243 12.0637 3.97705 12.0422V11.9393C3.99733 11.9207 3.99932 11.8936 4.0091 11.8701C4.06504 11.736 4.16332 11.6549 4.30917 11.6409C4.4307 11.6293 4.5528 11.6239 4.67464 11.6167C4.89921 11.6034 5.12378 11.5908 5.34835 11.5778C5.5708 11.565 5.79318 11.5517 6.01569 11.5395C6.28312 11.5249 6.55069 11.513 6.818 11.4964C6.89929 11.4914 6.98058 11.4877 7.06188 11.483C7.24364 11.4725 7.42528 11.4591 7.60705 11.4487C7.79532 11.438 7.98384 11.432 8.17185 11.4184C8.25315 11.4125 8.33451 11.4106 8.4158 11.4056C8.60606 11.3938 8.79639 11.3816 8.98672 11.3705C9.08938 11.3644 9.19223 11.3612 9.2949 11.355C9.54721 11.3397 9.79945 11.3229 10.0518 11.3077C10.2741 11.2942 10.4967 11.282 10.7191 11.2693C10.9458 11.2563 11.1726 11.2433 11.3993 11.2303C11.6196 11.2176 11.8398 11.2048 12.0602 11.1922C12.2847 11.1792 12.5093 11.1658 12.7339 11.1535C13.0014 11.1389 13.2689 11.127 13.5362 11.1105C13.6175 11.1055 13.6988 11.1016 13.7801 11.0971C13.9812 11.0858 14.1821 11.0732 14.3832 11.0609C14.3985 11.0599 14.4156 11.0646 14.4308 11.0529C14.4137 11.033 14.3934 11.0251 14.3751 11.0143C13.5146 10.5062 12.654 9.99844 11.7936 9.49047C10.898 8.96178 10.0024 8.43308 9.10689 7.90432C8.96837 7.82258 8.82909 7.74206 8.69192 7.65813C8.56776 7.58211 8.50449 7.44392 8.52374 7.31442C8.55817 7.0829 8.80701 6.93975 9.02933 7.03359C9.54483 7.25121 10.0641 7.45969 10.5821 7.67152C11.5167 8.05372 12.4516 8.43553 13.3863 8.81767C14.0887 9.10486 14.7912 9.39225 15.4938 9.679C15.5099 9.68556 15.5262 9.70217 15.5467 9.68743C15.5473 9.66503 15.5315 9.65177 15.5205 9.63665C15.1123 9.07442 14.7037 8.51251 14.2954 7.95041C13.7824 7.24426 13.2698 6.53792 12.7569 5.8317C12.4532 5.41352 12.1522 4.99341 11.8443 4.57832C11.679 4.35536 11.8105 4.07621 12.0167 4.01719C12.031 4.01313 12.0443 4.00579 12.0581 4C12.101 4 12.1439 4 12.1868 4C12.282 4.02349 12.354 4.08136 12.4221 4.14939C14.8857 6.61367 17.3497 9.07744 19.8147 11.5404C19.9208 11.6464 20.0037 11.7613 20.0233 11.9138V12.081L20.0232 12.0808Z",
        fill: "white"
    }));
};





const $44f00290f9c6b84b$export$66f000bb4bcf5fcd = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.6976 16.1078C26.667 16.3129 26.5531 16.4683 26.41 16.6113C23.1344 19.8863 19.86 23.1625 16.5853 26.4384C16.5489 26.4748 16.5137 26.5127 16.4749 26.5464C16.3232 26.6784 16.1507 26.6996 15.9708 26.6207C15.7934 26.543 15.6976 26.3974 15.6843 26.2053C15.6766 26.0937 15.7188 25.9925 15.7851 25.9019C15.9149 25.7242 16.0439 25.5457 16.1733 25.3676C16.9981 24.2317 17.823 23.0958 18.6479 21.96C19.1872 21.2174 19.7266 20.475 20.266 19.7325C20.4088 19.5359 20.5521 19.3397 20.6944 19.1427C20.7087 19.123 20.7311 19.1061 20.7272 19.0754C20.6991 19.0672 20.6776 19.0842 20.6549 19.0933C19.8661 19.4148 19.0774 19.7366 18.2888 20.0585C17.6351 20.3253 16.9816 20.5924 16.328 20.8594C14.9124 21.4379 13.4966 22.016 12.0814 22.5956C11.9674 22.6423 11.853 22.6699 11.7309 22.6418C11.5374 22.5972 11.3959 22.4442 11.3621 22.2454C11.3318 22.0674 11.4177 21.8792 11.585 21.7786C11.9084 21.5842 12.2344 21.394 12.5593 21.2021C13.7187 20.5173 14.8779 19.8323 16.0374 19.1477C17.0639 18.5415 18.0907 17.9359 19.1173 17.3299C19.1539 17.3083 19.1899 17.2856 19.2452 17.2519C19.145 17.2431 19.0651 17.2338 18.9849 17.2294C18.6284 17.2098 18.2717 17.192 17.9151 17.1724C17.6242 17.1565 17.3333 17.1397 17.0426 17.122C16.7062 17.1016 16.3699 17.0794 16.0335 17.0591C15.8966 17.0507 15.7596 17.0462 15.6227 17.0382C15.3633 17.0231 15.1038 17.0064 14.8444 16.991C14.7389 16.9847 14.6333 16.9811 14.5278 16.9738C14.2742 16.9563 14.02 16.948 13.7661 16.9333C13.4297 16.9137 13.0935 16.8905 12.757 16.8708C12.6458 16.8643 12.5345 16.8599 12.4232 16.8529C12.0697 16.831 11.7158 16.8149 11.3622 16.7955C11.0656 16.7792 10.7691 16.7614 10.4725 16.7445C10.1702 16.7271 9.86777 16.7114 9.56568 16.6921C9.26917 16.6731 8.97275 16.6551 8.67598 16.6407C8.37638 16.6262 8.07713 16.6069 7.7777 16.5896C7.48111 16.5726 7.1846 16.5555 6.888 16.5384C6.59141 16.5213 6.29482 16.5054 5.99831 16.4864C5.91566 16.4811 5.83242 16.479 5.75046 16.4697C5.55144 16.4471 5.41224 16.3414 5.34135 16.1513C5.32942 16.1193 5.32325 16.0849 5.30273 16.0563V15.9191C5.32977 15.8943 5.33243 15.8582 5.34547 15.8269C5.42005 15.6481 5.5511 15.5399 5.74557 15.5213C5.90759 15.5057 6.0704 15.4986 6.23285 15.489C6.53228 15.4712 6.83171 15.4544 7.13113 15.4372C7.42773 15.4201 7.72424 15.4023 8.02092 15.3861C8.3775 15.3666 8.73425 15.3506 9.09066 15.3286C9.19906 15.3219 9.30745 15.317 9.41584 15.3107C9.65819 15.2967 9.90038 15.2789 10.1427 15.265C10.3938 15.2507 10.6451 15.2428 10.8958 15.2246C11.0042 15.2167 11.1127 15.2142 11.2211 15.2075C11.4747 15.1918 11.7285 15.1755 11.9823 15.1606C12.1192 15.1526 12.2563 15.1484 12.3932 15.14C12.7296 15.1197 13.0659 15.0973 13.4024 15.077C13.6989 15.059 13.9955 15.0427 14.2921 15.0257C14.5944 15.0084 14.8967 14.9911 15.199 14.9737C15.4928 14.9568 15.7864 14.9398 16.0802 14.9229C16.3796 14.9057 16.6791 14.8877 16.9786 14.8714C17.3352 14.8519 17.6919 14.836 18.0483 14.814C18.1567 14.8073 18.2651 14.8022 18.3735 14.7962C18.6416 14.7811 18.9095 14.7643 19.1775 14.7478C19.198 14.7466 19.2208 14.7528 19.241 14.7372C19.2183 14.7107 19.1912 14.7001 19.1668 14.6857C18.0195 14.0083 16.8721 13.3313 15.7247 12.654C14.5306 11.9491 13.3365 11.2442 12.1425 10.5391C11.9578 10.4301 11.7721 10.3228 11.5892 10.2109C11.4237 10.1095 11.3393 9.92527 11.365 9.7526C11.4109 9.4439 11.7427 9.25304 12.0391 9.37816C12.7264 9.66832 13.4188 9.94629 14.1094 10.2287C15.3556 10.7383 16.6021 11.2474 17.8484 11.7569C18.785 12.1399 19.7216 12.523 20.6585 12.9054C20.6798 12.9141 20.7016 12.9363 20.7289 12.9166C20.7297 12.8867 20.7087 12.8691 20.6941 12.8489C20.1497 12.0993 19.6049 11.3501 19.0605 10.6006C18.3766 9.65905 17.693 8.71726 17.0092 7.77564C16.6043 7.21807 16.2029 6.65792 15.7924 6.10447C15.572 5.80719 15.7473 5.43499 16.0223 5.35629C16.0413 5.35088 16.0591 5.3411 16.0775 5.33337C16.1346 5.33337 16.1919 5.33337 16.249 5.33337C16.3759 5.3647 16.4721 5.44185 16.5628 5.53256C19.8475 8.81827 23.1329 12.1033 26.4196 15.3872C26.5611 15.5286 26.6716 15.6818 26.6977 15.885V16.1081L26.6976 16.1078Z",
        fill: "white"
    }));
};


const $e4be4a4ef13ff8c3$export$e45ddd51efe4cb0c = {
    displayName: 'LaunchDarkly',
    id: 'launchdarkly',
    resourceType: 'smartlinks-connector-launchdarkly',
    icon: (0, $9yyKc.get3PLogo)((0, $0c8cf6610d5ad1f2$export$68470e68dec0bc46), 'LaunchDarkly', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $44f00290f9c6b84b$export$66f000bb4bcf5fcd), 'LaunchDarkly', 'large'),
    integrationAri: 'ari:cloud:platform::integration/launchdarkly',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $e9f18d11ddbc0577$export$9cb908560d4a0a78 = {
    displayName: 'Loom',
    id: 'loom',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.LoomIcon), 'small'),
    searchResultIcon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.LoomIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/loom',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};

















const $11402a5a2444f870$export$8664694e1d7db2a0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
        fill: "white"
    }));
};





const $9919f1014ce9e785$export$6daa097ac5ffeb2c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.0143 18.1416C8.0143 15.4564 8.02145 12.772 8.00572 10.0868C8.00358 9.70682 8.11652 9.49577 8.45677 9.30326C10.6727 8.0491 12.8737 6.76856 15.0796 5.49657C15.5192 5.24274 15.5414 5.25415 15.5414 5.75039C15.5414 11.0487 15.5414 16.347 15.5414 21.646C15.5414 21.7529 15.5485 21.8606 15.5407 21.9668C15.5214 22.2363 15.6164 22.2813 15.8459 22.1465C16.5336 21.7437 17.2262 21.3487 17.9167 20.9508C19.4629 20.0596 21.0091 19.1676 22.5559 18.2771C22.9226 18.066 22.9641 18.0895 22.9641 18.5216C22.9655 21.0043 22.9655 23.4876 22.9641 25.9703C22.9641 26.4309 22.9369 26.4573 22.4802 26.458C20.2885 26.4616 18.0969 26.4566 15.9059 26.4723C15.5507 26.4751 15.4263 26.3739 15.4334 26.0088C15.4549 24.9636 15.442 23.9183 15.4406 22.8723C15.4406 22.4994 15.4334 22.4923 15.1053 22.6812C12.8872 23.9561 10.6713 25.2352 8.45248 26.5093C8.33525 26.5764 8.21588 26.7304 8.07291 26.6377C7.95568 26.5621 8.01501 26.3945 8.01501 26.2683C8.01287 23.5597 8.01287 20.851 8.01287 18.1423L8.0143 18.1416Z",
        fill: "white"
    }));
};


const $230e1285d2217578$export$3cac442956139a7e = {
    displayName: 'Lucid',
    id: 'lucid',
    resourceType: 'lucid-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $11402a5a2444f870$export$8664694e1d7db2a0), 'Lucid', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $9919f1014ce9e785$export$6daa097ac5ffeb2c), 'Lucid', 'large'),
    integrationAri: 'ari:cloud:platform::integration/lucid',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};

















const $75c08139eedf0275$export$38410c1d5582587e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#FFDD33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0122 5.5H13.1097L14.6951 8.28547L11.2073 5.5H9.30491L11.0488 8.90456L7.40244 5.5H5.5L7.40244 9.83362L5.5 18.5H7.40244L11.0488 9.21453L9.30491 18.5H11.2073L14.6951 8.59544L13.1097 18.5H15.0122L18.5 7.6664L15.0122 5.5Z",
        fill: "black"
    }));
};





const $36e837d8ce70b432$export$c22696a011659024 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#FFDD33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.0164 7.33325H17.4798L19.5936 11.0472L14.9432 7.33325H12.4067L14.7319 11.8727L9.87008 7.33325H7.3335L9.87008 13.1114L7.3335 24.6666H9.87008L14.7319 12.286L12.4067 24.6666H14.9432L19.5936 11.4605L17.4798 24.6666H20.0164L24.6668 10.2218L20.0164 7.33325Z",
        fill: "black"
    }));
};


const $3a411c179a98e5e7$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: 'miro-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $75c08139eedf0275$export$38410c1d5582587e), 'Miro', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $36e837d8ce70b432$export$c22696a011659024), 'Miro', 'large'),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $iUN2Z.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $2f8439e55801bd17$export$37b4104f63b2f4bd = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.375",
        y: "0.375",
        width: "23.25",
        height: "23.25",
        rx: "5.625",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.36594 16.7731C6.03435 16.7738 5.70851 16.6807 5.42172 16.5032C5.13492 16.3257 4.89744 16.0701 4.73354 15.7627C4.57214 15.4574 4.49165 15.111 4.50068 14.7606C4.50972 14.4103 4.60793 14.0691 4.78482 13.7738L8.14648 8.14287C8.31854 7.84024 8.56281 7.59175 8.85436 7.42277C9.14592 7.2538 9.47429 7.1704 9.80595 7.18109C10.1373 7.18956 10.4607 7.2918 10.7429 7.47734C11.0251 7.66289 11.256 7.92507 11.412 8.23707C11.7254 8.86914 11.6862 9.6296 11.3109 10.2229L7.95133 15.8538C7.78097 16.137 7.54634 16.3697 7.2692 16.5304C6.99206 16.6911 6.68137 16.7746 6.36594 16.7731Z",
        fill: "#F62B54"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1321 16.7728C11.454 16.7728 10.8301 16.3861 10.5025 15.7647C10.3415 15.4602 10.2612 15.1148 10.2702 14.7653C10.2793 14.4159 10.3773 14.0756 10.5538 13.7811L13.9091 8.16313C14.0786 7.85625 14.322 7.60333 14.614 7.43061C14.9061 7.25789 15.2361 7.17165 15.5699 7.18084C16.2537 7.19679 16.8733 7.60475 17.1867 8.2429C17.4979 8.88105 17.4523 9.64607 17.0656 10.2379L13.7111 15.8559C13.5412 16.1378 13.3075 16.3696 13.0316 16.5299C12.7556 16.6901 12.4463 16.7737 12.1321 16.7728Z",
        fill: "#FFCC00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.7693 16.82C18.7251 16.82 19.4999 16.0108 19.4999 15.0126C19.4999 14.0145 18.7251 13.2053 17.7693 13.2053C16.8134 13.2053 16.0386 14.0145 16.0386 15.0126C16.0386 16.0108 16.8134 16.82 17.7693 16.82Z",
        fill: "#00CA72"
    }));
};





const $ecad8a8b8bf2b790$export$43da0494a61d1337 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "11",
        viewBox: "0 0 16 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.99034 9.99041C1.63664 9.99118 1.28909 9.89805 0.983166 9.72053C0.677247 9.54302 0.423934 9.28747 0.249105 8.98001C0.0769521 8.67471 -0.0089051 8.32833 0.00073037 7.97798C0.0103658 7.62762 0.115131 7.28648 0.303804 6.99111L3.88959 1.36021C4.07311 1.05759 4.33368 0.809094 4.64467 0.64012C4.95566 0.471145 5.30592 0.387744 5.65969 0.398435C6.01319 0.406906 6.35809 0.509145 6.6591 0.694688C6.9601 0.880232 7.20641 1.14242 7.37281 1.45442C7.70708 2.08649 7.6653 2.84695 7.26494 3.44027L3.68143 9.07117C3.49971 9.35435 3.24944 9.58706 2.95382 9.74775C2.6582 9.90844 2.3268 9.99191 1.99034 9.99041Z",
        fill: "#F62B54"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.14089 9.99022C7.41766 9.99022 6.75216 9.60353 6.4027 8.9821C6.23093 8.67764 6.14527 8.33216 6.15491 7.98272C6.16454 7.63328 6.26911 7.29306 6.4574 6.99852L10.0363 1.38054C10.2172 1.07366 10.4768 0.820738 10.7883 0.648015C11.0998 0.475293 11.4519 0.389055 11.808 0.398248C12.5373 0.414202 13.1982 0.822161 13.5325 1.46031C13.8645 2.09846 13.8159 2.86347 13.4033 3.45528L9.82515 9.07326C9.64398 9.35523 9.39473 9.58704 9.10037 9.74729C8.80602 9.90755 8.47604 9.99109 8.14089 9.99022Z",
        fill: "#FFCC00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.154 10.0374C15.1736 10.0374 16.0001 9.22818 16.0001 8.23003C16.0001 7.23187 15.1736 6.4227 14.154 6.4227C13.1344 6.4227 12.3079 7.23187 12.3079 8.23003C12.3079 9.22818 13.1344 10.0374 14.154 10.0374Z",
        fill: "#00CA72"
    }));





const $0cb52f295315cac1$export$bf10d2e61430fb53 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "31",
        height: "31",
        rx: "7.5",
        stroke: "#0B1228",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.48792 22.364C8.0458 22.365 7.61135 22.2409 7.22895 22.0042C6.84656 21.7675 6.52992 21.4268 6.31138 21.0168C6.09619 20.6097 5.98887 20.1479 6.00091 19.6808C6.01296 19.2136 6.14391 18.7588 6.37975 18.3649L10.862 10.8571C11.0914 10.4536 11.4171 10.1222 11.8058 9.89695C12.1946 9.67165 12.6324 9.56045 13.0746 9.5747C13.5165 9.586 13.9476 9.72232 14.3238 9.96971C14.7001 10.2171 15.008 10.5667 15.216 10.9827C15.6338 11.8254 15.5816 12.8394 15.0811 13.6305L10.6018 21.1384C10.3746 21.5159 10.0618 21.8262 9.69227 22.0405C9.32275 22.2547 8.9085 22.366 8.48792 22.364Z",
        fill: "#F62B54"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.176 22.3638C15.272 22.3638 14.4401 21.8482 14.0033 21.0196C13.7886 20.6137 13.6815 20.153 13.6935 19.6871C13.7056 19.2212 13.8363 18.7676 14.0717 18.3749L18.5453 10.8842C18.7714 10.475 19.0959 10.1378 19.4853 9.90752C19.8747 9.67722 20.3148 9.56224 20.7598 9.5745C21.6715 9.59577 22.4977 10.1397 22.9155 10.9906C23.3305 11.8414 23.2697 12.8615 22.7541 13.6505L18.2813 21.1412C18.0549 21.5171 17.7433 21.8262 17.3754 22.0399C17.0074 22.2536 16.595 22.365 16.176 22.3638Z",
        fill: "#FFCC00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.6923 22.4266C24.9668 22.4266 25.9999 21.3477 25.9999 20.0168C25.9999 18.6859 24.9668 17.6071 23.6923 17.6071C22.4179 17.6071 21.3848 18.6859 21.3848 20.0168C21.3848 21.3477 22.4179 22.4266 23.6923 22.4266Z",
        fill: "#00CA72"
    }));
};


const $0a1292f152f9fefd$export$49283b8341865631 = {
    displayName: 'Monday',
    id: 'monday',
    resourceType: 'monday-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $2f8439e55801bd17$export$37b4104f63b2f4bd), 'Monday', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $ecad8a8b8bf2b790$export$43da0494a61d1337), 'Monday', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $0cb52f295315cac1$export$bf10d2e61430fb53), 'Monday', 'large'),
    integrationAri: 'ari:cloud:platform::integration/monday',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $49b59ae3bd4569eb$export$807a21e0dcf114c4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.385264",
        y: "0.385264",
        width: "23.2295",
        height: "23.2295",
        rx: "5.61474",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.770528"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.6754 16.1763C12.6757 14.0134 12.6843 11.8504 12.6739 9.68758C12.6654 7.94483 13.8929 6.44038 15.5576 6.08234C15.8132 6.02736 16.0709 5.99181 16.3335 6.00416C16.3754 6.06652 16.3699 6.13777 16.3701 6.20736C16.3708 6.83713 16.371 7.46704 16.3698 8.09681C16.3696 8.17062 16.3803 8.24819 16.3276 8.31236C15.8848 8.32742 15.5243 8.50576 15.2565 8.86034C15.089 9.08221 14.9992 9.3339 14.9928 9.61332C14.9914 9.67342 14.9908 9.73352 14.9908 9.79377C14.9908 11.8638 14.9908 13.9339 14.9905 16.0039C14.9905 16.0639 14.9863 16.1238 14.9842 16.1839C14.9391 16.2353 14.8769 16.2339 14.8176 16.2342C14.1625 16.2368 13.5073 16.2368 12.8522 16.2342C12.7888 16.2339 12.7197 16.2401 12.6755 16.1763H12.6754Z",
        fill: "#00843F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.9958 9.66997C19.997 9.7251 19.9991 9.78023 19.9991 9.83536C19.9992 12.6608 19.9994 15.4861 19.9988 18.3115C19.9988 18.5251 20.0262 18.4962 19.8174 18.4965C19.1651 18.4977 18.5127 18.497 17.8602 18.497C17.8251 18.497 17.7899 18.4955 17.7548 18.497C17.7016 18.4992 17.684 18.4709 17.6862 18.4226C17.6871 18.4025 17.6862 18.3825 17.6862 18.3623C17.6865 15.4716 17.6867 12.5811 17.687 9.69046C17.687 9.68548 17.6874 9.68036 17.6876 9.67539C17.7236 9.6043 17.7918 9.60324 17.8563 9.60294C18.5111 9.59948 19.1658 9.59963 19.8206 9.60249C19.8869 9.60279 19.9509 9.61213 19.9956 9.66982L19.9958 9.66997Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.31589 9.65845C6.31815 9.71343 6.32222 9.76841 6.32222 9.82339C6.32252 12.6568 6.32267 15.4902 6.32222 18.3237C6.32222 18.5291 6.34511 18.5007 6.1493 18.501C5.48729 18.502 4.82529 18.502 4.16344 18.5002C4.11208 18.5002 4.05183 18.5251 4.01025 18.4692C4.02758 18.4151 4.01538 18.3598 4.01538 18.3053C4.01628 15.4761 4.01613 12.6469 4.01613 9.81781C4.01613 9.61688 4.02682 9.60212 4.22535 9.60121C4.85738 9.5985 5.4894 9.59941 6.12143 9.60106C6.19072 9.60121 6.26407 9.59579 6.31604 9.65845H6.31589Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.3296 18.485C11.282 18.508 11.2309 18.499 11.1813 18.4991C10.5242 18.5006 9.86683 18.5014 9.20965 18.5021C9.1845 18.5021 9.15949 18.5029 9.13434 18.502C9.06545 18.4995 9.02985 18.4615 9.02754 18.3881C9.02709 18.373 9.02754 18.358 9.02754 18.3429C9.02754 15.4932 9.02754 12.6434 9.02769 9.79368C9.02769 9.74864 9.03101 9.70361 9.03282 9.65842C9.08463 9.59651 9.15738 9.60103 9.22667 9.60073C9.86141 9.59907 10.4961 9.59907 11.1309 9.60073C11.2003 9.60088 11.2728 9.59711 11.3247 9.65857C11.3267 9.72364 11.3305 9.78871 11.3305 9.85378C11.3308 11.899 11.3306 13.9442 11.3311 15.9892C11.3311 16.0542 11.3234 16.1197 11.3409 16.1837C11.3704 16.2444 11.3702 16.3096 11.3702 16.3748C11.3704 17.0109 11.371 17.647 11.3696 18.283C11.3696 18.3521 11.3782 18.4246 11.3296 18.4847V18.485Z",
        fill: "#5887FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.3247 9.65883C10.5607 9.65883 9.79675 9.65883 9.03263 9.65868C9.00822 9.44901 8.97343 9.24296 8.87477 9.05166C8.60861 8.53577 8.0406 8.24174 7.47124 8.32896C6.89584 8.41707 6.43884 8.87166 6.34515 9.45007C6.33401 9.5192 6.32557 9.58879 6.31593 9.65823C5.60302 9.65823 4.89011 9.65793 4.17719 9.65778C4.15716 9.65778 4.13682 9.65944 4.11694 9.65763C4.04795 9.65145 4.01226 9.67751 4.01753 9.75132C4.02039 9.79123 4.01783 9.8316 4.01783 9.87182C4.01783 12.6882 4.01783 15.5048 4.01753 18.3212C4.01753 18.3709 4.01286 18.4206 4.01015 18.4697C3.99267 18.4307 4.00307 18.3902 4.00307 18.351C4.00231 15.501 4.00201 12.6509 4.00277 9.80087C4.00277 9.28513 4.06874 8.77888 4.27389 8.30139C4.8172 7.03749 5.76675 6.26101 7.12404 6.04561C9.03022 5.74301 10.8088 6.97166 11.247 8.85389C11.3084 9.11794 11.3462 9.38605 11.3246 9.65883H11.3247Z",
        fill: "#FF4B4B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
        fill: "#FC83FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.3295 18.4854C11.3295 17.7731 11.3295 17.0608 11.3299 16.3486C11.3299 16.2938 11.3216 16.2382 11.3408 16.1844C11.7857 16.1819 12.2307 16.1793 12.6756 16.1768C12.7253 16.1795 12.7752 16.1844 12.8249 16.1844C13.5447 16.1849 14.2644 16.1846 14.9843 16.1844C14.9865 16.2343 14.9909 16.2843 14.9909 16.3342C14.9913 16.9954 14.9912 17.6568 14.9912 18.3181C14.9912 18.3532 14.99 18.3883 14.9909 18.4232C14.9921 18.4723 14.9705 18.4981 14.9201 18.4975C14.885 18.4972 14.8499 18.4982 14.8149 18.4982C13.7077 18.4982 12.6006 18.4982 11.4933 18.4981C11.4385 18.4981 11.3829 18.5051 11.3296 18.4853L11.3295 18.4854Z",
        fill: "#FFAA00"
    }));
};





const $e191128846fa30ad$export$f2b3c9d5e4a9191a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "13",
        viewBox: "0 0 16 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.67562 10.1764C8.67592 8.01353 8.68451 5.85054 8.67412 3.6877C8.66568 1.94495 9.89313 0.440498 11.5579 0.0824596C11.8135 0.027481 12.0712 -0.00806677 12.3337 0.00428458C12.3756 0.0666438 12.3702 0.13789 12.3703 0.207479C12.3711 0.837247 12.3712 1.46717 12.37 2.09693C12.3699 2.17074 12.3806 2.24831 12.3279 2.31248C11.885 2.32754 11.5246 2.50588 11.2568 2.86046C11.0893 3.08233 10.9995 3.33403 10.993 3.61344C10.9916 3.67354 10.991 3.73364 10.991 3.79389C10.991 5.86394 10.991 7.934 10.9907 10.0041C10.9907 10.064 10.9865 10.124 10.9844 10.1841C10.9394 10.2354 10.8772 10.2341 10.8178 10.2344C10.1628 10.2369 9.50753 10.2369 8.85246 10.2344C8.78904 10.2341 8.71991 10.2402 8.67577 10.1764H8.67562Z",
        fill: "#00843F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.9958 3.67021C15.997 3.72534 15.9991 3.78047 15.9991 3.8356C15.9992 6.66105 15.9994 9.48634 15.9988 12.3118C15.9988 12.5254 16.0262 12.4965 15.8174 12.4968C15.1651 12.498 14.5127 12.4972 13.8602 12.4972C13.8251 12.4972 13.7899 12.4957 13.7548 12.4972C13.7016 12.4995 13.684 12.4712 13.6862 12.4228C13.6871 12.4028 13.6862 12.3827 13.6862 12.3625C13.6865 9.47188 13.6867 6.58137 13.687 3.6907C13.687 3.68573 13.6874 3.68061 13.6876 3.67564C13.7236 3.60454 13.7918 3.60349 13.8563 3.60319C14.5111 3.59972 15.1658 3.59987 15.8206 3.60273C15.8869 3.60303 15.9509 3.61237 15.9956 3.67006L15.9958 3.67021Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M2.31589 3.65869C2.31815 3.71367 2.32222 3.76865 2.32222 3.82363C2.32252 6.65706 2.32267 9.49049 2.32222 12.3239C2.32222 12.5294 2.34511 12.5009 2.1493 12.5012C1.48729 12.5023 0.825292 12.5023 0.163441 12.5005C0.112077 12.5005 0.0518267 12.5253 0.0102539 12.4694C0.0275759 12.4153 0.0153752 12.3601 0.0153752 12.3055C0.016279 9.47633 0.0161283 6.64712 0.0161283 3.81806C0.0161283 3.61712 0.0268228 3.60236 0.225348 3.60146C0.857376 3.59875 1.4894 3.59965 2.12143 3.60131C2.19072 3.60146 2.26407 3.59603 2.31604 3.65869H2.31589Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.32932 12.4852C7.28172 12.5083 7.23066 12.4992 7.1811 12.4994C6.52392 12.5009 5.86659 12.5016 5.20941 12.5024C5.18425 12.5024 5.15925 12.5031 5.13409 12.5022C5.06521 12.4997 5.02961 12.4618 5.0273 12.3884C5.02685 12.3733 5.0273 12.3582 5.0273 12.3432C5.0273 9.49347 5.0273 6.64362 5.02745 3.79393C5.02745 3.74889 5.03076 3.70385 5.03257 3.65866C5.08439 3.59676 5.15714 3.60128 5.22643 3.60097C5.86117 3.59932 6.49591 3.59932 7.13064 3.60097C7.20008 3.60112 7.27253 3.59736 7.3245 3.65881C7.32646 3.72389 7.33022 3.78896 7.33022 3.85403C7.33052 5.89923 7.33037 7.94443 7.33083 9.98948C7.33083 10.0544 7.32314 10.1199 7.34062 10.1839C7.37014 10.2446 7.36999 10.3099 7.36999 10.3751C7.37014 11.0112 7.37074 11.6473 7.36939 12.2832C7.36939 12.3524 7.37797 12.4248 7.32932 12.4849V12.4852Z",
        fill: "#5887FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.32471 3.65896C6.56073 3.65896 5.79675 3.65896 5.03263 3.65881C5.00822 3.44913 4.97343 3.24308 4.87477 3.05178C4.60861 2.53589 4.0406 2.24187 3.47124 2.32908C2.89584 2.41719 2.43884 2.87178 2.34515 3.45019C2.33401 3.51933 2.32557 3.58891 2.31593 3.65835C1.60302 3.65835 0.890106 3.65805 0.177192 3.6579C0.157158 3.6579 0.136824 3.65956 0.116941 3.65775C0.0479545 3.65158 0.0122561 3.67763 0.017528 3.75144C0.0203899 3.79136 0.0178293 3.83172 0.0178293 3.87194C0.0178293 6.68835 0.0178293 9.50491 0.017528 12.3213C0.017528 12.371 0.0128586 12.4207 0.0101473 12.4698C-0.00732531 12.4308 0.00306789 12.3903 0.00306789 12.3511C0.00231476 9.50114 0.00201351 6.65099 0.00276664 3.801C0.00276664 3.28525 0.0687409 2.779 0.273894 2.30151C0.817202 1.03761 1.76675 0.261131 3.12404 0.0457358C5.03022 -0.256872 6.80881 0.971785 7.24698 2.85401C7.30844 3.11806 7.34624 3.38617 7.32455 3.65896H7.32471Z",
        fill: "#FF4B4B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.9958 3.67086C15.816 3.6689 15.6361 3.66543 15.4563 3.66513C14.9213 3.66438 14.3864 3.66468 13.8514 3.66513C13.7967 3.66513 13.7413 3.65941 13.6878 3.67658C13.6785 3.52701 13.6637 3.37954 13.6171 3.23479C13.4522 2.72221 12.9529 2.33104 12.4019 2.3214C12.377 2.32094 12.3523 2.31612 12.3276 2.31326C12.3303 2.28344 12.3353 2.25361 12.3353 2.22379C12.335 1.48406 12.3343 0.74449 12.3337 0.00491601C14.3515 -0.0202386 16.0257 1.66918 15.9958 3.67101V3.67086Z",
        fill: "#FC83FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.32934 12.4855C7.32934 11.7732 7.32934 11.0609 7.32979 10.3487C7.32979 10.2939 7.3215 10.2383 7.34063 10.1846C7.78558 10.182 8.23053 10.1794 8.67548 10.1769C8.72519 10.1796 8.77505 10.1846 8.82475 10.1846C9.5446 10.185 10.2643 10.1847 10.9841 10.1846C10.9864 10.2344 10.9908 10.2844 10.9908 10.3343C10.9912 10.9955 10.9911 11.6569 10.9911 12.3182C10.9911 12.3533 10.9899 12.3884 10.9908 12.4233C10.992 12.4724 10.9704 12.4982 10.92 12.4976C10.8849 12.4973 10.8498 12.4983 10.8148 12.4983C9.70757 12.4983 8.60047 12.4983 7.49322 12.4982C7.43839 12.4982 7.38281 12.5053 7.32949 12.4854L7.32934 12.4855Z",
        fill: "#FFAA00"
    }));





const $4062cde1516d61dd$export$930cc976c0fd31d6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.513685",
        y: "0.513685",
        width: "30.9726",
        height: "30.9726",
        rx: "7.48631",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.02737"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.9007 21.5684C16.9012 18.6846 16.9126 15.8006 16.8987 12.9168C16.8875 10.5931 18.5241 8.58721 20.7437 8.10982C21.0845 8.03652 21.4282 7.98912 21.7782 8.00559C21.8341 8.08874 21.8268 8.18373 21.827 8.27652C21.828 9.11621 21.8282 9.9561 21.8266 10.7958C21.8264 10.8942 21.8407 10.9976 21.7704 11.0832C21.1799 11.1033 20.6993 11.3411 20.3423 11.8138C20.1189 12.1097 19.9992 12.4452 19.9906 12.8178C19.9888 12.8979 19.988 12.9781 19.988 13.0584C19.988 15.8185 19.988 18.5785 19.9876 21.3386C19.9876 21.4186 19.982 21.4985 19.9791 21.5786C19.9191 21.6471 19.8361 21.6453 19.757 21.6457C18.8836 21.6491 18.01 21.6491 17.1365 21.6457C17.052 21.6453 16.9598 21.6535 16.9009 21.5684H16.9007Z",
        fill: "#00843F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.661 12.8934C26.6626 12.9669 26.6654 13.0404 26.6654 13.1139C26.6656 16.8812 26.6658 20.6482 26.665 24.4155C26.665 24.7003 26.7015 24.6617 26.4232 24.6621C25.5533 24.6637 24.6835 24.6627 23.8135 24.6627C23.7667 24.6627 23.7197 24.6607 23.6729 24.6627C23.602 24.6657 23.5785 24.628 23.5816 24.5635C23.5828 24.5368 23.5816 24.5101 23.5816 24.4832C23.582 20.6289 23.5822 16.7749 23.5826 12.9207C23.5826 12.9141 23.5832 12.9072 23.5834 12.9006C23.6314 12.8058 23.7223 12.8044 23.8083 12.804C24.6813 12.7994 25.5544 12.7996 26.4274 12.8034C26.5157 12.8038 26.6011 12.8163 26.6608 12.8932L26.661 12.8934Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.4211 12.8779C8.42412 12.9512 8.42954 13.0245 8.42954 13.0978C8.42994 16.8758 8.43014 20.6537 8.42954 24.4316C8.42954 24.7055 8.46007 24.6675 8.19898 24.6679C7.31631 24.6694 6.43364 24.6694 5.55117 24.6669C5.48269 24.6669 5.40235 24.7001 5.34692 24.6256C5.37002 24.5535 5.35375 24.4798 5.35375 24.4071C5.35496 20.6348 5.35476 16.8625 5.35476 13.0904C5.35476 12.8225 5.36902 12.8028 5.63372 12.8016C6.47642 12.798 7.31912 12.7992 8.16183 12.8014C8.25421 12.8016 8.35202 12.7944 8.42131 12.8779H8.4211Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.1058 24.6466C15.0423 24.6773 14.9742 24.6653 14.9081 24.6655C14.0319 24.6675 13.1555 24.6685 12.2792 24.6695C12.2457 24.6695 12.2123 24.6705 12.1788 24.6693C12.0869 24.666 12.0395 24.6154 12.0364 24.5175C12.0358 24.4974 12.0364 24.4773 12.0364 24.4572C12.0364 20.6576 12.0364 16.8578 12.0366 13.0582C12.0366 12.9982 12.041 12.9381 12.0434 12.8779C12.1125 12.7953 12.2095 12.8014 12.3019 12.801C13.1482 12.7988 13.9945 12.7988 14.8409 12.801C14.9334 12.8012 15.03 12.7962 15.0993 12.8781C15.1019 12.9649 15.107 13.0516 15.107 13.1384C15.1074 15.8653 15.1072 18.5922 15.1078 21.319C15.1078 21.4055 15.0975 21.4929 15.1208 21.5783C15.1602 21.6592 15.16 21.7462 15.16 21.8331C15.1602 22.6812 15.161 23.5294 15.1592 24.3773C15.1592 24.4695 15.1706 24.5661 15.1058 24.6462V24.6466Z",
        fill: "#5887FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.0995 12.8785C14.0809 12.8785 13.0623 12.8785 12.0434 12.8783C12.0109 12.5987 11.9645 12.324 11.8329 12.0689C11.4781 11.3811 10.7207 10.989 9.96157 11.1053C9.19438 11.2228 8.58504 11.8289 8.46012 12.6001C8.44526 12.6923 8.43402 12.7851 8.42116 12.8777C7.47061 12.8777 6.52006 12.8773 5.56951 12.8771C5.5428 12.8771 5.51568 12.8793 5.48917 12.8769C5.39719 12.8686 5.34959 12.9034 5.35662 13.0018C5.36044 13.055 5.35702 13.1088 5.35702 13.1625C5.35702 16.9177 5.35702 20.6731 5.35662 24.4283C5.35662 24.4946 5.3504 24.5609 5.34678 24.6263C5.32348 24.5743 5.33734 24.5203 5.33734 24.4681C5.33634 20.6681 5.33594 16.8679 5.33694 13.0679C5.33694 12.3802 5.42491 11.7052 5.69844 11.0686C6.42286 9.38336 7.68892 8.34805 9.49864 8.06086C12.0402 7.65738 14.4117 9.29559 14.9959 11.8052C15.0778 12.1573 15.1282 12.5148 15.0993 12.8785H15.0995Z",
        fill: "#FF4B4B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.6612 12.8944C26.4214 12.8918 26.1816 12.8872 25.9418 12.8868C25.2284 12.8858 24.5153 12.8862 23.8019 12.8868C23.729 12.8868 23.6551 12.8791 23.5838 12.902C23.5714 12.7026 23.5517 12.506 23.4896 12.313C23.2697 11.6295 22.6039 11.108 21.8693 11.0951C21.8361 11.0945 21.8032 11.0881 21.7703 11.0843C21.7739 11.0445 21.7805 11.0047 21.7805 10.965C21.7801 9.97867 21.7791 8.99257 21.7783 8.00647C24.4687 7.97293 26.701 10.2255 26.6612 12.8946V12.8944Z",
        fill: "#FC83FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.1058 24.6473C15.1058 23.6975 15.1058 22.7478 15.1064 21.7982C15.1064 21.7251 15.0953 21.651 15.1208 21.5793C15.7141 21.5759 16.3074 21.5725 16.9006 21.5691C16.9669 21.5727 17.0334 21.5793 17.0997 21.5793C18.0595 21.5799 19.019 21.5795 19.9788 21.5793C19.9819 21.6458 19.9877 21.7125 19.9877 21.779C19.9883 22.6606 19.9881 23.5425 19.9881 24.4242C19.9881 24.471 19.9865 24.5177 19.9877 24.5643C19.9893 24.6298 19.9606 24.6642 19.8933 24.6634C19.8465 24.663 19.7997 24.6644 19.7531 24.6644C18.2768 24.6644 16.8006 24.6644 15.3243 24.6642C15.2512 24.6642 15.1771 24.6736 15.106 24.6471L15.1058 24.6473Z",
        fill: "#FFAA00"
    }));
};


const $91e418846a9395a7$export$8855f5ba0dd32fb9 = {
    displayName: 'Mural',
    id: 'mural',
    resourceType: 'smartlinks-connector-mural',
    icon: (0, $9yyKc.get3PLogo)((0, $49b59ae3bd4569eb$export$807a21e0dcf114c4), 'Mural', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $e191128846fa30ad$export$f2b3c9d5e4a9191a), 'Mural', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $4062cde1516d61dd$export$930cc976c0fd31d6), 'Mural', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mural',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $0f79891f03378486$export$694ff710b1e20299 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.375",
        y: "0.375",
        width: "23.25",
        height: "23.25",
        rx: "5.625",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.72382 5.14736L14.0236 4.53432C15.0431 4.44687 15.305 4.50582 15.9461 4.97186L18.5955 6.83828C19.0325 7.15927 19.178 7.24672 19.178 7.59621V17.8325C19.178 18.474 18.945 18.8535 18.1295 18.9114L8.49127 19.4952C7.87928 19.5241 7.58784 19.4367 7.26729 19.0282L5.31628 16.4912C4.96634 16.0243 4.82129 15.6748 4.82129 15.2662V6.16734C4.82129 5.6428 5.05423 5.20541 5.72382 5.14736Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.0236 4.53447L5.72382 5.14751C5.05423 5.20541 4.82129 5.64295 4.82129 6.16734V15.2662C4.82129 15.6746 4.96634 16.0241 5.31628 16.4912L7.26729 19.0281C7.58784 19.4365 7.87928 19.5241 8.49127 19.495L18.1296 18.9115C18.9446 18.8535 19.1781 18.474 19.1781 17.8326V7.59636C19.1781 7.26487 19.0472 7.16932 18.6617 6.88643L15.9461 4.97186C15.3052 4.50582 15.0431 4.44687 14.0236 4.53432V4.53447ZM8.70921 7.42882C7.92218 7.48177 7.74368 7.49377 7.29669 7.13032L6.16031 6.22644C6.04482 6.10944 6.10286 5.96349 6.39386 5.9344L14.3727 5.35136C15.0427 5.29286 15.3916 5.5264 15.6536 5.7304L17.0221 6.72188C17.0806 6.75143 17.2261 6.92588 17.051 6.92588L8.81121 7.42192L8.70921 7.42882ZM7.79168 17.7452V9.05539C7.79168 8.67589 7.90823 8.50085 8.25712 8.47145L17.721 7.91736C18.042 7.88841 18.1871 8.0924 18.1871 8.4713V17.1032C18.1871 17.4827 18.1286 17.8037 17.6046 17.8326L8.54827 18.3576C8.02433 18.3866 7.79183 18.2121 7.79183 17.7452H7.79168ZM16.7315 9.52128C16.7896 9.78377 16.7315 10.0463 16.469 10.0763L16.0325 10.1628V16.5786C15.6535 16.7826 15.3046 16.8992 15.013 16.8992C14.547 16.8992 14.4306 16.7532 14.0815 16.3161L11.2271 11.8252V16.1702L12.13 16.3746C12.13 16.3746 12.13 16.8996 11.4015 16.8996L9.39305 17.0162C9.33455 16.8992 9.39305 16.6077 9.5966 16.5497L10.1211 16.4042V10.6593L9.3932 10.6004C9.3347 10.3379 9.4802 9.95882 9.88819 9.92942L12.0432 9.78437L15.0131 14.3333V10.3089L14.2561 10.2219C14.1976 9.90047 14.4306 9.66692 14.7215 9.63842L16.7315 9.52128Z",
        fill: "#292A2E"
    }));
};





const $3743ee9d643393be$export$5b5388c6f4e608dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.880101 0.631033L8.97361 0.0332313C9.9678 -0.0520436 10.2232 0.00544013 10.8483 0.459898L13.4319 2.27992C13.858 2.59294 13.9999 2.67822 13.9999 3.01902V13.0009C13.9999 13.6265 13.7727 13.9965 12.9774 14.053L3.57877 14.6223C2.98199 14.6505 2.69779 14.5652 2.38521 14.1669L0.482688 11.6929C0.141442 11.2376 0 10.8968 0 10.4983V1.62566C0 1.11416 0.227156 0.687639 0.880101 0.631033Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.97361 0.0333775L0.880101 0.631179C0.227156 0.687639 0 1.11431 0 1.62566V10.4983C0 10.8966 0.141442 11.2374 0.482688 11.6929L2.38521 14.1668C2.69779 14.5651 2.98199 14.6505 3.57877 14.6221L12.9776 14.0531C13.7723 13.9965 14 13.6265 14 13.001V3.01917C14 2.69591 13.8723 2.60274 13.4964 2.32688L10.8483 0.459898C10.2233 0.00544013 9.9678 -0.0520436 8.97361 0.0332313V0.0333775ZM3.7913 2.85579C3.02382 2.90742 2.84976 2.91912 2.41388 2.56471L1.30574 1.68329C1.19312 1.5692 1.24972 1.42688 1.53349 1.39851L9.31398 0.829959C9.96736 0.772914 10.3076 1.00066 10.5631 1.19958L11.8975 2.16642C11.9546 2.19524 12.0965 2.36535 11.9258 2.36535L3.89076 2.84906L3.7913 2.85579ZM2.89657 12.9157V4.44193C2.89657 4.07187 3.01022 3.90117 3.35044 3.8725L12.5791 3.33218C12.8922 3.30395 13.0336 3.50288 13.0336 3.87236V12.2897C13.0336 12.6598 12.9766 12.9728 12.4656 13.001L3.63435 13.513C3.12343 13.5412 2.89671 13.3711 2.89671 12.9157H2.89657ZM11.6142 4.89624C11.6708 5.15221 11.6142 5.40818 11.3582 5.43744L10.9326 5.52183V11.7782C10.563 11.9771 10.2227 12.0908 9.9384 12.0908C9.48394 12.0908 9.37044 11.9485 9.03007 11.5222L6.24657 7.14293V11.3799L7.12711 11.5793C7.12711 11.5793 7.12711 12.0912 6.41668 12.0912L4.45814 12.2049C4.40109 12.0908 4.45814 11.8066 4.65662 11.75L5.16813 11.6081V6.00598L4.45828 5.9485C4.40124 5.69253 4.54312 5.32291 4.94097 5.29424L7.04242 5.1528L9.93855 9.5887V5.6643L9.20033 5.57946C9.14328 5.26601 9.37044 5.03827 9.6542 5.01048L11.6142 4.89624Z",
        fill: "black"
    }));





const $a2d13c30f30cd7d0$export$7dd377a68ecb1d9f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "31",
        height: "31",
        rx: "7.5",
        stroke: "#0B1228",
        strokeOpacity: "0.14"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.63209 6.86307L18.6985 6.04568C20.0578 5.92908 20.407 6.00768 21.2618 6.62907L24.7944 9.11762C25.3769 9.54561 25.5709 9.66221 25.5709 10.1282V23.7765C25.5709 24.6319 25.2604 25.1379 24.173 25.2151L11.322 25.9935C10.506 26.0321 10.1174 25.9155 9.69005 25.3709L7.0887 21.9882C6.62211 21.3656 6.42871 20.8996 6.42871 20.3548V8.22304C6.42871 7.52365 6.7393 6.94046 7.63209 6.86307Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6985 6.04588L7.63209 6.86327C6.7393 6.94046 6.42871 7.52385 6.42871 8.22304V20.3548C6.42871 20.8994 6.62211 21.3654 7.0887 21.9882L9.69005 25.3707C10.1174 25.9153 10.506 26.0321 11.322 25.9933L24.1732 25.2153C25.2597 25.1379 25.5711 24.6319 25.5711 23.7767V10.1284C25.5711 9.68641 25.3965 9.55901 24.8826 9.18182L21.2618 6.62907C20.4072 6.00768 20.0578 5.92908 18.6985 6.04568V6.04588ZM11.6126 9.90501C10.5632 9.97561 10.3252 9.99161 9.72925 9.50701L8.21408 8.30184C8.06008 8.14584 8.13748 7.95125 8.52547 7.91245L19.1639 7.13506C20.0572 7.05706 20.5224 7.36846 20.8718 7.64045L22.6964 8.96243C22.7744 9.00182 22.9684 9.23442 22.735 9.23442L11.7486 9.89581L11.6126 9.90501ZM10.3892 23.6601V12.0738C10.3892 11.5678 10.5446 11.3344 11.0098 11.2952L23.6284 10.5564C24.0564 10.5178 24.2498 10.7898 24.2498 11.295V22.8042C24.2498 23.3101 24.1718 23.7381 23.4732 23.7767L11.398 24.4767C10.6994 24.5153 10.3894 24.2827 10.3894 23.6601H10.3892ZM22.309 12.695C22.3864 13.0449 22.309 13.3949 21.959 13.4349L21.377 13.5503V22.1048C20.8716 22.3768 20.4064 22.5322 20.0176 22.5322C19.3963 22.5322 19.2411 22.3376 18.7757 21.7548L14.9697 15.7669V21.5602L16.1737 21.8328C16.1737 21.8328 16.1737 22.5328 15.2023 22.5328L12.5244 22.6882C12.4464 22.5322 12.5244 22.1436 12.7958 22.0662L13.4952 21.8722V14.2123L12.5246 14.1337C12.4466 13.7837 12.6406 13.2783 13.1846 13.2391L16.0579 13.0457L20.0178 19.111V13.7451L19.0085 13.6291C18.9305 13.2005 19.2411 12.8892 19.6291 12.8512L22.309 12.695Z",
        fill: "#292A2E"
    }));
};


const $a642a047af5c5832$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: 'notion-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $0f79891f03378486$export$694ff710b1e20299), 'Notion', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $3743ee9d643393be$export$5b5388c6f4e608dd), 'Notion', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $a2d13c30f30cd7d0$export$7dd377a68ecb1d9f), 'Notion', 'large'),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $fd00bcb624b7f12e$export$44884401d09e251c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.0419 9.65028L10.042 9.64971L13.5059 11.7245L15.5699 10.8559C15.9893 10.6746 16.4415 10.5816 16.8985 10.5821C16.9746 10.5821 17.0499 10.5855 17.1247 10.5905C16.8766 9.62289 16.3527 8.74817 15.6168 8.07266C14.8809 7.39715 13.9646 6.94992 12.9794 6.78533C11.9941 6.62073 10.9822 6.74586 10.0667 7.1455C9.15118 7.54513 8.37146 8.20208 7.82227 9.0365C7.83991 9.03628 7.85729 9.03517 7.87497 9.03517C8.6405 9.03414 9.39106 9.24719 10.0419 9.65028Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.0421 9.64982L10.0419 9.65039C9.39112 9.2473 8.64056 9.03425 7.87503 9.03528C7.85734 9.03528 7.83994 9.03639 7.82232 9.03661C7.07306 9.04589 6.34049 9.25916 5.70334 9.65351C5.06618 10.0479 4.54853 10.6084 4.20601 11.2748C3.86349 11.9413 3.70904 12.6885 3.75928 13.4361C3.80951 14.1837 4.06252 14.9035 4.49112 15.5182L7.54571 14.2327L8.90358 13.6613L11.927 12.389L13.5059 11.7246L10.0421 9.64982Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.1247 10.5906C17.0499 10.5856 16.9746 10.5822 16.8985 10.5822C16.4416 10.5817 15.9894 10.675 15.57 10.8564L13.5059 11.7246L14.1044 12.0831L16.0663 13.2583L16.9223 13.771L19.8492 15.5242C20.1151 15.0305 20.253 14.4779 20.25 13.9171C20.2471 13.3564 20.1035 12.8053 19.8324 12.3144C19.5613 11.8235 19.1714 11.4084 18.6983 11.1073C18.2253 10.8061 17.6842 10.6285 17.1247 10.5906Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.9219 13.771L16.066 13.2582L14.104 12.0831L13.5055 11.7245L11.9266 12.389L8.90317 13.6613L7.54531 14.2327L4.49072 15.5181C4.87031 16.0639 5.37634 16.5096 5.9656 16.8174C6.55486 17.1251 7.20985 17.2856 7.87462 17.2853H16.8981C17.5031 17.2855 18.0969 17.1218 18.6164 16.8118C19.1359 16.5017 19.5618 16.0567 19.8488 15.5241L16.9219 13.771Z",
        fill: "#28A8EA"
    }));
};





const $0f6f4369a417f4c4$export$9b1a95f6ce5942a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "18",
        height: "12",
        viewBox: "0 0 18 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.86388 3.20227L6.86406 3.20165L10.6427 5.46503L12.8944 4.51749C13.3519 4.31969 13.8453 4.21826 14.3438 4.21875C14.4268 4.21875 14.5089 4.22252 14.5906 4.22797C14.3199 3.17239 13.7484 2.21816 12.9456 1.48125C12.1428 0.744328 11.1432 0.256448 10.0684 0.0768914C8.99354 -0.102665 7.88968 0.0338335 6.89095 0.469799C5.89222 0.905765 5.04162 1.62243 4.4425 2.5327C4.46175 2.53246 4.48071 2.53125 4.5 2.53125C5.33512 2.53012 6.15391 2.76254 6.86388 3.20227Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.86405 3.20165L6.86388 3.20227C6.15391 2.76255 5.33511 2.53012 4.5 2.53125C4.48071 2.53125 4.46172 2.53246 4.4425 2.53271C3.62513 2.54282 2.82597 2.77548 2.1309 3.20568C1.43582 3.63587 0.871116 4.24734 0.497459 4.97437C0.123801 5.7014 -0.0446795 6.51651 0.0101211 7.3321C0.0649218 8.14769 0.340932 8.93293 0.808492 9.60344L4.14074 8.20117L5.62204 7.57781L8.92028 6.18987L10.6427 5.46503L6.86405 3.20165Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.5905 4.22797C14.5089 4.22252 14.4268 4.21875 14.3437 4.21875C13.8453 4.21827 13.352 4.32007 12.8944 4.51788L10.6427 5.46503L11.2956 5.85613L13.4359 7.13813L14.3697 7.69747L17.5626 9.61C17.8528 9.07142 18.0031 8.46864 17.9999 7.85689C17.9967 7.24515 17.8401 6.64398 17.5444 6.10845C17.2486 5.57292 16.8232 5.12016 16.3072 4.79162C15.7911 4.46309 15.2009 4.26928 14.5905 4.22797Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.3697 7.69745L13.4359 7.13812L11.2956 5.85612L10.6427 5.46503L8.92026 6.18985L5.62202 7.5778L4.14072 8.20116L0.808472 9.60342C1.22256 10.1988 1.77459 10.6851 2.41742 11.0208C3.06024 11.3565 3.77477 11.5316 4.49997 11.5312H14.3437C15.0037 11.5314 15.6515 11.3529 16.2182 11.0147C16.785 10.6764 17.2495 10.191 17.5626 9.60999L14.3697 7.69745Z",
        fill: "#28A8EA"
    }));





const $93e6be9a540c3c0f$export$f2ab3f3a9966c07c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.3891 12.867L13.3894 12.8662L18.0077 15.6326L20.7598 14.4745C21.319 14.2327 21.922 14.1088 22.5312 14.1094C22.6327 14.1094 22.733 14.114 22.8329 14.1206C22.502 12.8305 21.8035 11.6642 20.8223 10.7635C19.8411 9.86286 18.6195 9.26656 17.3058 9.0471C15.9921 8.82765 14.6429 8.99448 13.4222 9.52732C12.2016 10.0602 11.1619 10.9361 10.4297 12.0486C10.4532 12.0484 10.4764 12.0469 10.5 12.0469C11.5207 12.0455 12.5214 12.3296 13.3891 12.867Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.3894 12.8664L13.3892 12.8671C12.5214 12.3297 11.5207 12.0456 10.5 12.047C10.4764 12.047 10.4532 12.0485 10.4297 12.0488C9.43071 12.0611 8.45396 12.3455 7.60443 12.8713C6.75489 13.3971 6.0647 14.1444 5.608 15.033C5.15131 15.9216 4.94539 16.9179 5.01237 17.9147C5.07935 18.9115 5.41669 19.8713 5.98816 20.6908L10.0609 18.9769L11.8714 18.215L15.9026 16.5186L18.0078 15.6327L13.3894 12.8664Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.8327 14.1208C22.7329 14.1141 22.6325 14.1095 22.531 14.1095C21.9218 14.1089 21.3189 14.2333 20.7597 14.4751L18.0076 15.6327L18.8056 16.1107L21.4215 17.6776L22.5628 18.3613L26.4653 20.6988C26.8199 20.0405 27.0036 19.3038 26.9997 18.5561C26.9958 17.8084 26.8044 17.0737 26.4429 16.4191C26.0815 15.7646 25.5616 15.2112 24.9308 14.8097C24.3001 14.4081 23.5787 14.1713 22.8327 14.1208Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.5626 18.3612L21.4213 17.6776L18.8054 16.1107L18.0074 15.6327L15.9022 16.5186L11.871 18.215L10.0605 18.9768L5.98779 20.6907C6.49391 21.4184 7.16861 22.0127 7.95428 22.4231C8.73996 22.8334 9.61327 23.0474 10.4996 23.0469H22.5309C23.3376 23.0472 24.1292 22.829 24.8219 22.4156C25.5146 22.0021 26.0824 21.4089 26.4651 20.6988L22.5626 18.3612Z",
        fill: "#28A8EA"
    }));
};


const $2998c4f2928fc744$export$b3b3a7aaf94fe09 = {
    displayName: 'OneDrive',
    id: 'onedrive',
    resourceType: 'onedrive-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $fd00bcb624b7f12e$export$44884401d09e251c), 'OneDrive', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $0f6f4369a417f4c4$export$9b1a95f6ce5942a8), 'OneDrive', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $93e6be9a540c3c0f$export$f2ab3f3a9966c07c), 'OneDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document,
                    (0, $2Znam.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $7af70a3b25535c1d$export$62b570fbaf793397 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
        fill: "#064A8C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
        fill: "#0A2767",
        fillOpacity: "0.498039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
        fill: "black",
        fillOpacity: "0.047059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
        fill: "black",
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
        fill: "white"
    }));
};





const $33e705703f3f6fe8$export$dd150ae24aa9e16a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.2971 1H5.70166C5.31657 1 4.99969 1.31687 4.99969 1.70196V2.49985L9.84435 3.99985L14.999 2.49985V1.70196C14.999 1.31687 14.6822 1 14.2971 1Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.824 8.70203C15.8972 8.47184 15.9557 8.23723 15.9989 7.99955C15.999 7.88064 15.9354 7.77046 15.8325 7.71104L15.826 7.70755L15.824 7.70661L10.4053 4.61977C10.3819 4.60464 10.3577 4.59075 10.3328 4.57824C10.123 4.47424 9.87617 4.47424 9.66635 4.57824C9.64148 4.59075 9.61726 4.60457 9.59384 4.61977L4.17523 7.70661L4.17319 7.70755L4.16664 7.71104C4.06374 7.77046 4.00017 7.88064 4.00024 7.99955C4.04352 8.23723 4.10199 8.47184 4.17523 8.70203L9.92083 12.9042L15.824 8.70203Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9993 2.49982H8.49949L7.48901 3.99982L8.49949 5.49967L11.9993 8.49945H14.9991V5.49967L11.9993 2.49982Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.99969 2.49982H8.49948V5.4996H4.99969V2.49982Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9993 2.49982H14.9991V5.4996H11.9993V2.49982Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9993 8.49948L8.49948 5.49969H4.99969V8.49948L8.49948 11.4993L13.9151 12.3833L11.9993 8.49948Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.49951 5.49969H11.9993V8.49948H8.49951V5.49969Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.99969 8.49951H8.49948V11.4993H4.99969V8.49951Z",
        fill: "#064A8C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9993 8.49951H14.9991V11.4993H11.9993V8.49951Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.0949 12.6083L4.19824 8.30859L4.44522 7.87411C4.44522 7.87411 9.81737 10.9339 9.89933 10.9799C9.96726 11.0072 10.0436 11.005 10.1099 10.9739C10.1863 10.9309 15.5755 7.85913 15.5755 7.85913L15.8235 8.2936L10.0949 12.6083Z",
        fill: "#0A2767",
        fillOpacity: "0.498039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.8325 8.28813L15.826 8.29213L15.8245 8.29315L10.4059 11.38C10.1872 11.5209 9.9103 11.5382 9.6759 11.4254L11.5632 13.9558L15.69 14.8542V14.8563C15.8846 14.7156 16 14.4894 16 14.2493V7.99969C16 8.11853 15.9364 8.22879 15.8335 8.28813H15.8325Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.999 14.2492V13.8803L11.0078 11.0364L10.4053 11.3794C10.1868 11.5204 9.90982 11.5377 9.67542 11.4249L11.5628 13.9553L15.6895 14.8537V14.8557C15.8841 14.7149 15.9995 14.4889 15.9995 14.2487L15.999 14.2492Z",
        fill: "black",
        fillOpacity: "0.047059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.974 14.4407L10.5028 11.3239L10.4053 11.3794C10.1868 11.5203 9.90982 11.5377 9.67542 11.4249L11.5628 13.9553L15.6895 14.8537V14.8557C15.8295 14.7542 15.9303 14.6073 15.9745 14.4402L15.974 14.4407Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.17469 8.29468V8.28966H4.16974L4.15469 8.2797C4.05767 8.21999 3.99876 8.11359 3.99971 7.99969V14.2503C3.99971 14.6612 4.33781 14.9993 4.74872 14.9993H15.2491C15.3115 14.9986 15.3737 14.9902 15.434 14.9742C15.4654 14.9688 15.4957 14.9587 15.5241 14.9443C15.5347 14.9432 15.5449 14.9398 15.554 14.9342C15.5949 14.9175 15.6336 14.8957 15.669 14.8692L15.689 14.8542L4.17469 8.29468Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.9994 12.3329V4.16696C8.99831 3.80172 8.69817 3.50158 8.33293 3.50049H5.01519V7.2282L4.17468 7.70718L4.17271 7.7082L4.16624 7.71169C4.06326 7.77118 3.99969 7.88136 3.99969 8.00012V13.0014V12.9993H8.33293C8.69817 12.9983 8.99831 12.6981 8.9994 12.3329Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.49948 12.8328V4.66684C8.49839 4.30168 8.19817 4.00153 7.833 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V13.5013V13.4993H7.833C8.19817 13.4982 8.49839 13.198 8.49948 12.8328ZM8.49948 11.8329V4.66684C8.49839 4.30168 8.19817 4.00153 7.833 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V12.5013V12.4993H7.833C8.19817 12.4983 8.49839 12.1981 8.49948 11.8329ZM7.99948 11.8329V4.66684C7.99839 4.30168 7.69824 4.00153 7.33308 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V12.5013V12.4993H7.33308C7.69824 12.4983 7.99839 12.1981 7.99948 11.8329Z",
        fill: "black",
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.666473 3.99988H7.33251C7.69811 3.99988 7.99898 4.30068 7.99898 4.66628V11.3324C7.99898 11.698 7.69811 11.9989 7.33251 11.9989H0.666473C0.300873 11.9989 0 11.698 0 11.3324V4.66628C0 4.30068 0.300873 3.99988 0.666473 3.99988Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.93338 6.7337C2.11047 6.35632 2.39644 6.04047 2.75433 5.82679C3.15091 5.59974 3.60247 5.48665 4.05927 5.49981C4.48233 5.4905 4.89993 5.59777 5.26618 5.80977C5.61084 6.01501 5.88844 6.3161 6.06509 6.67625C6.25753 7.07305 6.35353 7.5097 6.34509 7.95065C6.35447 8.41152 6.25564 8.86825 6.05666 9.2841C5.87608 9.65697 5.59011 9.9689 5.23418 10.181C4.85367 10.3997 4.42051 10.5099 3.98175 10.4995C3.54953 10.5098 3.12269 10.4013 2.74786 10.186C2.40051 9.98039 2.11957 9.67901 1.93891 9.31807C1.74524 8.92694 1.64815 8.49501 1.65593 8.05865C1.64735 7.6017 1.7424 7.14876 1.93389 6.7337H1.93338ZM2.80829 8.86257C2.90277 9.10119 3.06298 9.30825 3.27033 9.45952C3.48131 9.6073 3.73426 9.68352 3.99171 9.67705C4.26604 9.68788 4.53651 9.60926 4.76218 9.45305C4.96698 9.30177 5.12298 9.09363 5.21069 8.85457C5.30931 8.5881 5.35789 8.3057 5.35418 8.02163C5.35724 7.73508 5.31157 7.44999 5.2192 7.17872C5.13775 6.9345 4.98735 6.71894 4.78618 6.55828C4.56647 6.39421 4.29673 6.31087 4.02277 6.32228C3.75971 6.31545 3.50109 6.3921 3.28429 6.54127C3.07309 6.69305 2.90931 6.90185 2.81229 7.14323C2.59775 7.69588 2.59651 8.30912 2.8088 8.86257H2.80829Z",
        fill: "white"
    }));





const $bb93716e5602aa73$export$c93fd0887f18cc87 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.9285 7.74731H12.8944C12.4449 7.74731 12.075 8.11336 12.075 8.55822V9.47993L17.7305 11.2127L23.7479 9.47993V8.55822C23.7479 8.11336 23.378 7.74731 22.9285 7.74731Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.7109 16.6444C24.7964 16.3785 24.8647 16.1075 24.9152 15.8329C24.9153 15.6955 24.8411 15.5683 24.7208 15.4996L24.7133 15.4956L24.7109 15.4945L18.3853 11.9286C18.358 11.9111 18.3297 11.8951 18.3007 11.8806C18.0558 11.7605 17.7676 11.7605 17.5227 11.8806C17.4936 11.8951 17.4654 11.911 17.438 11.9286L11.1125 15.4945L11.1101 15.4956L11.1025 15.4996C10.9823 15.5683 10.9081 15.6955 10.9082 15.8329C10.9587 16.1075 11.027 16.3785 11.1125 16.6444L17.8197 21.4987L24.7109 16.6444Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.2461 9.47986H16.1606L14.981 11.2126L16.1606 12.9453L20.2461 16.4106H23.748V12.9453L20.2461 9.47986Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.075 9.47992H16.1605V12.9452H12.075V9.47992Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2461 9.47992H23.748V12.9452H20.2461V9.47992Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.2461 16.4106L16.1605 12.9453H12.075V16.4106L16.1605 19.876L22.4826 20.8972L20.2461 16.4106Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.1606 12.9453H20.2462V16.4106H16.1606V12.9453Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.075 16.4109H16.1605V19.8762H12.075V16.4109Z",
        fill: "#064A8C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2461 16.4109H23.748V19.8762H20.2461V16.4109Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.0228 21.1571L11.1392 16.1901L11.4275 15.6882C11.4275 15.6882 17.6988 19.2228 17.7945 19.276C17.8738 19.3075 17.9629 19.305 18.0403 19.269C18.1295 19.2194 24.4207 15.6709 24.4207 15.6709L24.7102 16.1728L18.0228 21.1571Z",
        fill: "#0A2767",
        fillOpacity: "0.498039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.7207 16.1663L24.7132 16.1709L24.7114 16.1721L18.3858 19.738C18.1306 19.9008 17.8073 19.9207 17.5337 19.7905L19.7369 22.7135L24.5544 23.7514V23.7538C24.7815 23.5912 24.9163 23.33 24.9163 23.0526V15.8331C24.9163 15.9704 24.8421 16.0978 24.7219 16.1663H24.7207Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.9149 23.0525V22.6263L19.0883 19.3411L18.385 19.7373C18.1299 19.9002 17.8066 19.9202 17.533 19.7898L19.7362 22.7129L24.5537 23.7508V23.7531C24.7808 23.5905 24.9155 23.3294 24.9155 23.0519L24.9149 23.0525Z",
        fill: "black",
        fillOpacity: "0.047059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.8858 23.274L18.4989 19.6735L18.385 19.7376C18.1299 19.9004 17.8066 19.9204 17.533 19.7901L19.7362 22.7132L24.5537 23.7511V23.7534C24.7171 23.6361 24.8347 23.4665 24.8863 23.2734L24.8858 23.274Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.1118 16.1739V16.1681H11.106L11.0884 16.1566C10.9751 16.0876 10.9064 15.9647 10.9075 15.8331V23.0538C10.9075 23.5284 11.3022 23.919 11.7819 23.919H24.0397C24.1126 23.9182 24.1852 23.9086 24.2556 23.8901C24.2922 23.8838 24.3276 23.8721 24.3607 23.8555C24.3731 23.8542 24.385 23.8502 24.3957 23.8439C24.4434 23.8245 24.4886 23.7993 24.5299 23.7688L24.5533 23.7514L11.1118 16.1739Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.744 20.8389V11.4056C16.7427 10.9837 16.3924 10.637 15.966 10.6357H12.0929V14.942L11.1117 15.4953L11.1094 15.4965L11.1019 15.5005C10.9817 15.5692 10.9075 15.6965 10.9075 15.8337V21.6111V21.6087H15.966C16.3924 21.6075 16.7427 21.2607 16.744 20.8389Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.1604 21.4162V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V22.1884V22.1861H15.3824C15.8087 22.1848 16.1591 21.8381 16.1604 21.4162ZM16.1604 20.2611V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H15.3824C15.8087 21.0297 16.1591 20.683 16.1604 20.2611ZM15.5767 20.2611V11.9829C15.5754 11.5611 15.2251 11.2144 14.7988 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H14.7988C15.2251 21.0297 15.5754 20.683 15.5767 20.2611Z",
        fill: "black",
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.0163 11.2128H14.7981C15.2249 11.2128 15.5761 11.5603 15.5761 11.9826V19.6832C15.5761 20.1056 15.2249 20.4531 14.7981 20.4531H7.0163C6.58951 20.4531 6.23828 20.1056 6.23828 19.6832V11.9826C6.23828 11.5603 6.58951 11.2128 7.0163 11.2128Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.49517 14.3708C8.7019 13.9348 9.03573 13.57 9.45352 13.3231C9.91648 13.0608 10.4436 12.9302 10.9769 12.9454C11.4707 12.9347 11.9582 13.0586 12.3858 13.3035C12.7881 13.5406 13.1122 13.8884 13.3184 14.3044C13.5431 14.7628 13.6551 15.2672 13.6453 15.7766C13.6562 16.309 13.5409 16.8366 13.3086 17.317C13.0978 17.7477 12.7639 18.1081 12.3484 18.3531C11.9042 18.6058 11.3986 18.733 10.8864 18.721C10.3818 18.7329 9.88354 18.6076 9.44597 18.3588C9.04048 18.1213 8.71252 17.7732 8.50162 17.3562C8.27553 16.9044 8.16219 16.4054 8.17128 15.9014C8.16126 15.3735 8.27222 14.8503 8.49577 14.3708H8.49517ZM9.51652 16.83C9.6268 17.1057 9.81384 17.3449 10.0559 17.5196C10.3022 17.6903 10.5975 17.7784 10.898 17.7709C11.2183 17.7834 11.534 17.6926 11.7974 17.5122C12.0365 17.3374 12.2186 17.097 12.321 16.8208C12.4361 16.513 12.4929 16.1867 12.4885 15.8586C12.4921 15.5276 12.4388 15.1982 12.331 14.8849C12.2359 14.6027 12.0603 14.3537 11.8255 14.1681C11.569 13.9786 11.2541 13.8823 10.9343 13.8955C10.6272 13.8876 10.3253 13.9762 10.0722 14.1485C9.82564 14.3238 9.63444 14.565 9.52119 14.8439C9.27073 15.4823 9.26929 16.1907 9.51711 16.83H9.51652Z",
        fill: "white"
    }));
};


const $a54cb566eb58c8e6$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: 'outlook-calendar-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $7af70a3b25535c1d$export$62b570fbaf793397), 'Outlook Calendar', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $33e705703f3f6fe8$export$dd150ae24aa9e16a), 'Outlook Calendar', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bb93716e5602aa73$export$c93fd0887f18cc87), 'Outlook Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $kllKt.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $273f22d99aaf729c$export$d905606eb58fea64 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
        fill: "#064A8C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
        fill: "#0A2767",
        fillOpacity: "0.498039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
        fill: "black",
        fillOpacity: "0.047059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
        fill: "black",
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
        fill: "white"
    }));
};





const $aacc646fbc81dd86$export$c828641fbf8ac5e9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.2971 1H5.70166C5.31657 1 4.99969 1.31687 4.99969 1.70196V2.49985L9.84435 3.99985L14.999 2.49985V1.70196C14.999 1.31687 14.6822 1 14.2971 1Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.824 8.70203C15.8972 8.47184 15.9557 8.23723 15.9989 7.99955C15.999 7.88064 15.9354 7.77046 15.8325 7.71104L15.826 7.70755L15.824 7.70661L10.4053 4.61977C10.3819 4.60464 10.3577 4.59075 10.3328 4.57824C10.123 4.47424 9.87617 4.47424 9.66635 4.57824C9.64148 4.59075 9.61726 4.60457 9.59384 4.61977L4.17523 7.70661L4.17319 7.70755L4.16664 7.71104C4.06374 7.77046 4.00017 7.88064 4.00024 7.99955C4.04352 8.23723 4.10199 8.47184 4.17523 8.70203L9.92083 12.9042L15.824 8.70203Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9993 2.49982H8.49949L7.48901 3.99982L8.49949 5.49967L11.9993 8.49945H14.9991V5.49967L11.9993 2.49982Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.99969 2.49982H8.49948V5.4996H4.99969V2.49982Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9993 2.49982H14.9991V5.4996H11.9993V2.49982Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9993 8.49948L8.49948 5.49969H4.99969V8.49948L8.49948 11.4993L13.9151 12.3833L11.9993 8.49948Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.49951 5.49969H11.9993V8.49948H8.49951V5.49969Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.99969 8.49951H8.49948V11.4993H4.99969V8.49951Z",
        fill: "#064A8C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9993 8.49951H14.9991V11.4993H11.9993V8.49951Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.0949 12.6083L4.19824 8.30859L4.44522 7.87411C4.44522 7.87411 9.81737 10.9339 9.89933 10.9799C9.96726 11.0072 10.0436 11.005 10.1099 10.9739C10.1863 10.9309 15.5755 7.85913 15.5755 7.85913L15.8235 8.2936L10.0949 12.6083Z",
        fill: "#0A2767",
        fillOpacity: "0.498039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.8325 8.28813L15.826 8.29213L15.8245 8.29315L10.4059 11.38C10.1872 11.5209 9.9103 11.5382 9.6759 11.4254L11.5632 13.9558L15.69 14.8542V14.8563C15.8846 14.7156 16 14.4894 16 14.2493V7.99969C16 8.11853 15.9364 8.22879 15.8335 8.28813H15.8325Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.999 14.2492V13.8803L11.0078 11.0364L10.4053 11.3794C10.1868 11.5204 9.90982 11.5377 9.67542 11.4249L11.5628 13.9553L15.6895 14.8537V14.8557C15.8841 14.7149 15.9995 14.4889 15.9995 14.2487L15.999 14.2492Z",
        fill: "black",
        fillOpacity: "0.047059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.974 14.4407L10.5028 11.3239L10.4053 11.3794C10.1868 11.5203 9.90982 11.5377 9.67542 11.4249L11.5628 13.9553L15.6895 14.8537V14.8557C15.8295 14.7542 15.9303 14.6073 15.9745 14.4402L15.974 14.4407Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.17469 8.29468V8.28966H4.16974L4.15469 8.2797C4.05767 8.21999 3.99876 8.11359 3.99971 7.99969V14.2503C3.99971 14.6612 4.33781 14.9993 4.74872 14.9993H15.2491C15.3115 14.9986 15.3737 14.9902 15.434 14.9742C15.4654 14.9688 15.4957 14.9587 15.5241 14.9443C15.5347 14.9432 15.5449 14.9398 15.554 14.9342C15.5949 14.9175 15.6336 14.8957 15.669 14.8692L15.689 14.8542L4.17469 8.29468Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.9994 12.3329V4.16696C8.99831 3.80172 8.69817 3.50158 8.33293 3.50049H5.01519V7.2282L4.17468 7.70718L4.17271 7.7082L4.16624 7.71169C4.06326 7.77118 3.99969 7.88136 3.99969 8.00012V13.0014V12.9993H8.33293C8.69817 12.9983 8.99831 12.6981 8.9994 12.3329Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.49948 12.8328V4.66684C8.49839 4.30168 8.19817 4.00153 7.833 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V13.5013V13.4993H7.833C8.19817 13.4982 8.49839 13.198 8.49948 12.8328ZM8.49948 11.8329V4.66684C8.49839 4.30168 8.19817 4.00153 7.833 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V12.5013V12.4993H7.833C8.19817 12.4983 8.49839 12.1981 8.49948 11.8329ZM7.99948 11.8329V4.66684C7.99839 4.30168 7.69824 4.00153 7.33308 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V12.5013V12.4993H7.33308C7.69824 12.4983 7.99839 12.1981 7.99948 11.8329Z",
        fill: "black",
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.666473 3.99988H7.33251C7.69811 3.99988 7.99898 4.30068 7.99898 4.66628V11.3324C7.99898 11.698 7.69811 11.9989 7.33251 11.9989H0.666473C0.300873 11.9989 0 11.698 0 11.3324V4.66628C0 4.30068 0.300873 3.99988 0.666473 3.99988Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.93338 6.7337C2.11047 6.35632 2.39644 6.04047 2.75433 5.82679C3.15091 5.59974 3.60247 5.48665 4.05927 5.49981C4.48233 5.4905 4.89993 5.59777 5.26618 5.80977C5.61084 6.01501 5.88844 6.3161 6.06509 6.67625C6.25753 7.07305 6.35353 7.5097 6.34509 7.95065C6.35447 8.41152 6.25564 8.86825 6.05666 9.2841C5.87608 9.65697 5.59011 9.9689 5.23418 10.181C4.85367 10.3997 4.42051 10.5099 3.98175 10.4995C3.54953 10.5098 3.12269 10.4013 2.74786 10.186C2.40051 9.98039 2.11957 9.67901 1.93891 9.31807C1.74524 8.92694 1.64815 8.49501 1.65593 8.05865C1.64735 7.6017 1.7424 7.14876 1.93389 6.7337H1.93338ZM2.80829 8.86257C2.90277 9.10119 3.06298 9.30825 3.27033 9.45952C3.48131 9.6073 3.73426 9.68352 3.99171 9.67705C4.26604 9.68788 4.53651 9.60926 4.76218 9.45305C4.96698 9.30177 5.12298 9.09363 5.21069 8.85457C5.30931 8.5881 5.35789 8.3057 5.35418 8.02163C5.35724 7.73508 5.31157 7.44999 5.2192 7.17872C5.13775 6.9345 4.98735 6.71894 4.78618 6.55828C4.56647 6.39421 4.29673 6.31087 4.02277 6.32228C3.75971 6.31545 3.50109 6.3921 3.28429 6.54127C3.07309 6.69305 2.90931 6.90185 2.81229 7.14323C2.59775 7.69588 2.59651 8.30912 2.8088 8.86257H2.80829Z",
        fill: "white"
    }));





const $86cacec70bf484b1$export$f819ae7cc5008c40 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.9285 7.74731H12.8944C12.4449 7.74731 12.075 8.11336 12.075 8.55822V9.47993L17.7305 11.2127L23.7479 9.47993V8.55822C23.7479 8.11336 23.378 7.74731 22.9285 7.74731Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.7109 16.6444C24.7964 16.3785 24.8647 16.1075 24.9152 15.8329C24.9153 15.6955 24.8411 15.5683 24.7208 15.4996L24.7133 15.4956L24.7109 15.4945L18.3853 11.9286C18.358 11.9111 18.3297 11.8951 18.3007 11.8806C18.0558 11.7605 17.7676 11.7605 17.5227 11.8806C17.4936 11.8951 17.4654 11.911 17.438 11.9286L11.1125 15.4945L11.1101 15.4956L11.1025 15.4996C10.9823 15.5683 10.9081 15.6955 10.9082 15.8329C10.9587 16.1075 11.027 16.3785 11.1125 16.6444L17.8197 21.4987L24.7109 16.6444Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.2461 9.47986H16.1606L14.981 11.2126L16.1606 12.9453L20.2461 16.4106H23.748V12.9453L20.2461 9.47986Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.075 9.47992H16.1605V12.9452H12.075V9.47992Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2461 9.47992H23.748V12.9452H20.2461V9.47992Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.2461 16.4106L16.1605 12.9453H12.075V16.4106L16.1605 19.876L22.4826 20.8972L20.2461 16.4106Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.1606 12.9453H20.2462V16.4106H16.1606V12.9453Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.075 16.4109H16.1605V19.8762H12.075V16.4109Z",
        fill: "#064A8C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2461 16.4109H23.748V19.8762H20.2461V16.4109Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.0228 21.1571L11.1392 16.1901L11.4275 15.6882C11.4275 15.6882 17.6988 19.2228 17.7945 19.276C17.8738 19.3075 17.9629 19.305 18.0403 19.269C18.1295 19.2194 24.4207 15.6709 24.4207 15.6709L24.7102 16.1728L18.0228 21.1571Z",
        fill: "#0A2767",
        fillOpacity: "0.498039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.7207 16.1663L24.7132 16.1709L24.7114 16.1721L18.3858 19.738C18.1306 19.9008 17.8073 19.9207 17.5337 19.7905L19.7369 22.7135L24.5544 23.7514V23.7538C24.7815 23.5912 24.9163 23.33 24.9163 23.0526V15.8331C24.9163 15.9704 24.8421 16.0978 24.7219 16.1663H24.7207Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.9149 23.0525V22.6263L19.0883 19.3411L18.385 19.7373C18.1299 19.9002 17.8066 19.9202 17.533 19.7898L19.7362 22.7129L24.5537 23.7508V23.7531C24.7808 23.5905 24.9155 23.3294 24.9155 23.0519L24.9149 23.0525Z",
        fill: "black",
        fillOpacity: "0.047059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24.8858 23.274L18.4989 19.6735L18.385 19.7376C18.1299 19.9004 17.8066 19.9204 17.533 19.7901L19.7362 22.7132L24.5537 23.7511V23.7534C24.7171 23.6361 24.8347 23.4665 24.8863 23.2734L24.8858 23.274Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.1118 16.1739V16.1681H11.106L11.0884 16.1566C10.9751 16.0876 10.9064 15.9647 10.9075 15.8331V23.0538C10.9075 23.5284 11.3022 23.919 11.7819 23.919H24.0397C24.1126 23.9182 24.1852 23.9086 24.2556 23.8901C24.2922 23.8838 24.3276 23.8721 24.3607 23.8555C24.3731 23.8542 24.385 23.8502 24.3957 23.8439C24.4434 23.8245 24.4886 23.7993 24.5299 23.7688L24.5533 23.7514L11.1118 16.1739Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.744 20.8389V11.4056C16.7427 10.9837 16.3924 10.637 15.966 10.6357H12.0929V14.942L11.1117 15.4953L11.1094 15.4965L11.1019 15.5005C10.9817 15.5692 10.9075 15.6965 10.9075 15.8337V21.6111V21.6087H15.966C16.3924 21.6075 16.7427 21.2607 16.744 20.8389Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.1604 21.4162V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V22.1884V22.1861H15.3824C15.8087 22.1848 16.1591 21.8381 16.1604 21.4162ZM16.1604 20.2611V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H15.3824C15.8087 21.0297 16.1591 20.683 16.1604 20.2611ZM15.5767 20.2611V11.9829C15.5754 11.5611 15.2251 11.2144 14.7988 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H14.7988C15.2251 21.0297 15.5754 20.683 15.5767 20.2611Z",
        fill: "black",
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.0163 11.2128H14.7981C15.2249 11.2128 15.5761 11.5603 15.5761 11.9826V19.6832C15.5761 20.1056 15.2249 20.4531 14.7981 20.4531H7.0163C6.58951 20.4531 6.23828 20.1056 6.23828 19.6832V11.9826C6.23828 11.5603 6.58951 11.2128 7.0163 11.2128Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.49517 14.3708C8.7019 13.9348 9.03573 13.57 9.45352 13.3231C9.91648 13.0608 10.4436 12.9302 10.9769 12.9454C11.4707 12.9347 11.9582 13.0586 12.3858 13.3035C12.7881 13.5406 13.1122 13.8884 13.3184 14.3044C13.5431 14.7628 13.6551 15.2672 13.6453 15.7766C13.6562 16.309 13.5409 16.8366 13.3086 17.317C13.0978 17.7477 12.7639 18.1081 12.3484 18.3531C11.9042 18.6058 11.3986 18.733 10.8864 18.721C10.3818 18.7329 9.88354 18.6076 9.44597 18.3588C9.04048 18.1213 8.71252 17.7732 8.50162 17.3562C8.27553 16.9044 8.16219 16.4054 8.17128 15.9014C8.16126 15.3735 8.27222 14.8503 8.49577 14.3708H8.49517ZM9.51652 16.83C9.6268 17.1057 9.81384 17.3449 10.0559 17.5196C10.3022 17.6903 10.5975 17.7784 10.898 17.7709C11.2183 17.7834 11.534 17.6926 11.7974 17.5122C12.0365 17.3374 12.2186 17.097 12.321 16.8208C12.4361 16.513 12.4929 16.1867 12.4885 15.8586C12.4921 15.5276 12.4388 15.1982 12.331 14.8849C12.2359 14.6027 12.0603 14.3537 11.8255 14.1681C11.569 13.9786 11.2541 13.8823 10.9343 13.8955C10.6272 13.8876 10.3253 13.9762 10.0722 14.1485C9.82564 14.3238 9.63444 14.565 9.52119 14.8439C9.27073 15.4823 9.26929 16.1907 9.51711 16.83H9.51652Z",
        fill: "white"
    }));
};


const $b7918401159d3e2e$export$31104d47075e6dfd = {
    displayName: 'Outlook Mail',
    id: 'outlook-mail',
    resourceType: 'outlook-mail-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $273f22d99aaf729c$export$d905606eb58fea64), 'Outlook Mail', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $aacc646fbc81dd86$export$c828641fbf8ac5e9), 'Outlook Mail', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $86cacec70bf484b1$export$f819ae7cc5008c40), 'Outlook Mail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $idpYy.FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    isEnabled: ()=>true,
    isFederated: true
};














const $5543f2cb76bcbb1f$export$e9a3fd43f9d4bddc = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#04AB38"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.33974 9.0588C7.33988 9.05866 7.33996 9.05847 7.33996 9.05827C7.33996 7.60876 7.34084 6.15925 7.3382 4.70974C7.3382 4.5796 7.33644 4.4987 7.51495 4.50002C9.30876 4.51057 11.1026 4.49738 12.8964 4.51892C13.9116 4.53123 14.8801 4.77262 15.7546 5.30858C16.8256 5.96414 17.4222 6.94066 17.6117 8.16868C17.8148 9.48551 17.6012 10.7206 16.7918 11.8057C16.1033 12.7294 15.1439 13.2175 14.0285 13.4329C13.3347 13.567 12.6326 13.5846 11.9309 13.5899C10.4668 13.6013 9.00231 13.5912 7.53781 13.5991C7.36414 13.6 7.33557 13.5411 7.33645 13.3859C7.34172 11.9438 7.33952 10.5014 7.33952 9.05933C7.33952 9.05913 7.3396 9.05894 7.33974 9.0588Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.35232 17.4818C7.35232 16.8821 7.35539 16.2819 7.34968 15.6822C7.34836 15.5516 7.36463 15.4905 7.52246 15.4931C8.14414 15.5037 8.76626 15.5024 9.38794 15.4931C9.53215 15.4909 9.55281 15.5415 9.55237 15.6681C9.54798 16.89 9.5471 18.1118 9.55325 19.3333C9.55413 19.4753 9.50841 19.5003 9.37959 19.499C8.75791 19.4929 8.13579 19.4911 7.51411 19.4999C7.3699 19.5021 7.34836 19.452 7.34968 19.3249C7.35583 18.7102 7.35232 18.096 7.35232 17.4813V17.4818Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.54312 8.99636C9.54312 8.1834 9.54488 7.37088 9.54093 6.55791C9.54049 6.43788 9.55148 6.37589 9.70184 6.37677C10.7051 6.38424 11.7084 6.36446 12.7113 6.38776C13.2833 6.40095 13.8408 6.53021 14.3464 6.81996C15.0103 7.20028 15.3295 7.79604 15.3967 8.54042C15.4464 9.09221 15.4223 9.63697 15.1853 10.1514C14.8072 10.9723 14.1037 11.3416 13.2675 11.521C12.8942 11.601 12.5143 11.6195 12.1332 11.6195C11.3422 11.619 10.5513 11.612 9.76075 11.6247C9.56818 11.6278 9.53697 11.565 9.53917 11.3913C9.5484 10.5933 9.54312 9.79481 9.54312 8.9968V8.99636Z",
        fill: "#04AB38"
    }));
};





const $243dba8c72a6f28f$export$494d5ec19d75a736 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#04AB38"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.78616 12.0784C9.78635 12.0782 9.78645 12.078 9.78645 12.0777C9.78645 10.145 9.78763 8.21234 9.78411 6.27966C9.78411 6.10613 9.78176 5.99826 10.0198 6.00002C12.4115 6.01409 14.8033 5.9965 17.195 6.02523C18.5486 6.04164 19.84 6.36349 21.006 7.07811C22.434 7.95219 23.2295 9.25421 23.4821 10.8916C23.753 12.6473 23.4681 14.2941 22.3889 15.7409C21.4708 16.9726 20.1917 17.6233 18.7045 17.9106C17.7795 18.0894 16.8433 18.1128 15.9077 18.1199C13.9556 18.1351 12.0029 18.1216 10.0502 18.1322C9.8187 18.1333 9.78059 18.0548 9.78176 17.8478C9.7888 15.9251 9.78587 14.0018 9.78587 12.0791C9.78587 12.0788 9.78597 12.0786 9.78616 12.0784Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.80268 23.3091C9.80268 22.5095 9.80678 21.7093 9.79916 20.9097C9.79741 20.7356 9.81909 20.6541 10.0295 20.6576C10.8584 20.6716 11.6879 20.6699 12.5168 20.6576C12.7091 20.6546 12.7367 20.7221 12.7361 20.8909C12.7302 22.5201 12.7291 24.1492 12.7373 25.7778C12.7384 25.9671 12.6775 26.0005 12.5057 25.9988C11.6768 25.9906 10.8473 25.9882 10.0184 25.9999C9.82613 26.0029 9.79741 25.936 9.79916 25.7666C9.80737 24.9471 9.80268 24.1281 9.80268 23.3085V23.3091Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.7242 11.9952C12.7242 10.9112 12.7265 9.82788 12.7212 8.74393C12.7206 8.58388 12.7353 8.50123 12.9358 8.5024C14.2735 8.51236 15.6113 8.48598 16.9484 8.51705C17.7111 8.53464 18.4544 8.70699 19.1285 9.09332C20.0137 9.60042 20.4393 10.3948 20.529 11.3873C20.5952 12.123 20.563 12.8493 20.247 13.5352C19.7429 14.6297 18.8049 15.1222 17.69 15.3614C17.1923 15.468 16.6858 15.4927 16.1775 15.4927C15.1229 15.4921 14.0684 15.4827 13.0143 15.4997C12.7576 15.5038 12.716 15.42 12.7189 15.1884C12.7312 14.1244 12.7242 13.0598 12.7242 11.9958V11.9952Z",
        fill: "#04AB38"
    }));
};


const $b44f483df20185b6$export$cc8a555111f14137 = {
    displayName: 'PagerDuty',
    id: 'pagerduty',
    resourceType: 'smartlinks-connector-pagerduty',
    icon: (0, $9yyKc.get3PLogo)((0, $5543f2cb76bcbb1f$export$e9a3fd43f9d4bddc), 'PagerDuty', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $243dba8c72a6f28f$export$494d5ec19d75a736), 'PagerDuty', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pagerduty',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $3d42e42f367dc3a5$export$e66a8d6ac96d6ba1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#017737"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.2336 10.1635C10.2336 11.5838 10.9541 13.1159 12.5396 13.1159C13.7154 13.1159 14.9043 12.198 14.9043 10.1427C14.9043 8.34075 13.9697 7.13106 12.5787 7.13106C11.4453 7.13106 10.2336 7.92728 10.2336 10.1635ZM13.1373 4.5C15.9802 4.5 17.8917 6.75159 17.8917 10.1032C17.8917 13.4022 15.878 15.7053 12.9993 15.7053C11.6268 15.7053 10.7476 15.1175 10.2879 14.6919C10.2912 14.7928 10.2933 14.9058 10.2933 15.0264V19.5H7.34834V7.58072C7.34834 7.40743 7.29292 7.3526 7.12122 7.3526H6.1084V4.74238H8.5796C9.71739 4.74238 10.0086 5.32145 10.0641 5.76782C10.5259 5.25017 11.4833 4.5 13.1373 4.5Z",
        fill: "white"
    }));
};





const $136b66fff4ecef3e$export$18970dea61783916 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#017737"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.7389 13.5678C13.7389 15.4746 14.7062 17.5315 16.8349 17.5315C18.4135 17.5315 20.0096 16.2991 20.0096 13.5398C20.0096 11.1206 18.7549 9.49657 16.8874 9.49657C15.3657 9.49657 13.7389 10.5655 13.7389 13.5678ZM17.6373 5.96423C21.454 5.96423 24.0203 8.98711 24.0203 13.4868C24.0203 17.9158 21.3169 21.0079 17.452 21.0079C15.6093 21.0079 14.429 20.2187 13.8119 19.6474C13.8163 19.7829 13.8192 19.9345 13.8192 20.0965V26.1025H9.86537V10.1003C9.86537 9.86761 9.79096 9.79399 9.56045 9.79399H8.20068V6.28964H11.5184C13.0459 6.28964 13.4369 7.06707 13.5113 7.66635C14.1314 6.97137 15.4168 5.96423 17.6373 5.96423Z",
        fill: "white"
    }));
};


const $fd9a483df954975f$export$9441b0ee1f92e710 = {
    displayName: 'Pipedrive',
    id: 'pipedrive',
    resourceType: 'smartlinks-connector-pipedrive',
    icon: (0, $9yyKc.get3PLogo)((0, $3d42e42f367dc3a5$export$e66a8d6ac96d6ba1), 'Pipedrive', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $136b66fff4ecef3e$export$18970dea61783916), 'Pipedrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pipedrive',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $4f8f46a558397ff4$export$8a27e4cfebfdcb7 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.4031 4H13.1618C12.7971 4 12.5015 4.29563 12.5015 4.66032V19.3397C12.5015 19.7044 12.7971 20 13.1618 20H17.4031C17.7677 20 18.0634 19.7044 18.0634 19.3397V4.66032C18.0634 4.29563 17.7677 4 17.4031 4Z",
        fill: "#B25400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
        fill: "#DE9800"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5619 19.3394V19.9998H6.66032C6.29562 19.9998 6 19.7041 6 19.3394V12.6601C6 12.2954 6.29562 11.9998 6.66032 11.9998H10.9016C11.2663 11.9998 11.5619 12.2954 11.5619 12.6601V19.3394Z",
        fill: "#F3CD32"
    }));
};





const $ebe52692143880fe$export$77c3c6e8d16b3669 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4031 0H9.16178C8.7971 0 8.50146 0.295634 8.50146 0.660317V15.3397C8.50146 15.7044 8.7971 16 9.16178 16H13.4031C13.7677 16 14.0634 15.7044 14.0634 15.3397V0.660317C14.0634 0.295634 13.7677 0 13.4031 0Z",
        fill: "#B25400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.787 15.3395V15.9998H5.88542C5.52072 15.9998 5.2251 15.7042 5.2251 15.3395V4.64744C5.2251 4.28274 5.52072 3.98712 5.88542 3.98712H10.1267C10.4914 3.98712 10.787 4.28274 10.787 4.64744V15.3395Z",
        fill: "#DE9800"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.787 15.3395V15.9998H5.88542C5.52072 15.9998 5.2251 15.7042 5.2251 15.3395V4.64744C5.2251 4.28274 5.52072 3.98712 5.88542 3.98712H10.1267C10.4914 3.98712 10.787 4.28274 10.787 4.64744V15.3395Z",
        fill: "#DE9800"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5619 15.3396V15.9999H2.66032C2.29562 15.9999 2 15.7043 2 15.3396V8.6602C2 8.2955 2.29562 7.99988 2.66032 7.99988H6.90159C7.26629 7.99988 7.5619 8.2955 7.5619 8.6602V15.3396Z",
        fill: "#F3CD32"
    }));





const $81a121caf3e5ea88$export$66bbf4ebbd8bb09 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.2042 5.3335H17.5491C17.0629 5.3335 16.6687 5.72768 16.6687 6.21392V25.7864C16.6687 26.2727 17.0629 26.6668 17.5491 26.6668H23.2042C23.6904 26.6668 24.0846 26.2727 24.0846 25.7864V6.21392C24.0846 5.72768 23.6904 5.3335 23.2042 5.3335Z",
        fill: "#B25400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7162 25.7862V26.6666H13.1807C12.6945 26.6666 12.3003 26.2724 12.3003 25.7862V11.5301C12.3003 11.0438 12.6945 10.6497 13.1807 10.6497H18.8357C19.322 10.6497 19.7162 11.0438 19.7162 11.5301V25.7862Z",
        fill: "#DE9800"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7162 25.7862V26.6666H13.1807C12.6945 26.6666 12.3003 26.2724 12.3003 25.7862V11.5301C12.3003 11.0438 12.6945 10.6497 13.1807 10.6497H18.8357C19.322 10.6497 19.7162 11.0438 19.7162 11.5301V25.7862Z",
        fill: "#DE9800"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.4159 25.7862V26.6667H8.88042C8.39416 26.6667 8 26.2725 8 25.7862V16.8804C8 16.3942 8.39416 16 8.88042 16H14.5354C15.0217 16 15.4159 16.3942 15.4159 16.8804V25.7862Z",
        fill: "#F3CD32"
    }));
};


const $221343bdf65748f1$export$b883b80d867cc715 = {
    displayName: 'PowerBI',
    id: 'power-bi',
    resourceType: 'smartlinks-connector-power-bi',
    icon: (0, $9yyKc.get3PLogo)((0, $4f8f46a558397ff4$export$8a27e4cfebfdcb7), 'PowerBI', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $ebe52692143880fe$export$77c3c6e8d16b3669), 'PowerBI', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $81a121caf3e5ea88$export$66bbf4ebbd8bb09), 'PowerBI', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};



var $hdfeV = parcelRequire("hdfeV");










const $dd87d9abaea6cdea$export$89e1f2a7c57f2a4d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.385264",
        y: "0.385264",
        width: "23.2295",
        height: "23.2295",
        rx: "5.61474",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.770528"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "mask0_719_13847",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "5",
        width: "18",
        height: "14"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3 5.71326H21V18.2868H3V5.71326Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        mask: "url(#mask0_719_13847)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4738 7.08983C11.0548 6.48497 11.8635 6.11041 12.7569 6.11041C13.9481 6.11041 14.9804 6.77218 15.5363 7.75821C16.0297 7.53763 16.5642 7.42374 17.1047 7.42402C19.2488 7.42402 20.9892 9.17769 20.9892 11.3417C20.9892 13.5056 19.2488 15.2593 17.1047 15.2593C16.8426 15.2593 16.5872 15.233 16.337 15.1832C15.8506 16.0501 14.9209 16.6391 13.862 16.6391C13.431 16.6399 13.0054 16.5422 12.6179 16.3532C12.1249 17.5113 10.9767 18.3253 9.63998 18.3253C8.24366 18.3253 7.0591 17.4451 6.60248 16.2076C6.39925 16.2505 6.1921 16.2721 5.98439 16.2719C4.32336 16.2719 2.97998 14.9087 2.97998 13.2344C2.97998 12.1094 3.58483 11.13 4.48219 10.6006C4.29181 10.1621 4.19382 9.689 4.19432 9.21091C4.19432 7.27856 5.7627 5.7168 7.69505 5.7168C8.82667 5.7168 9.83917 6.25614 10.4745 7.09327",
        fill: "#00A1E0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.6037 12.2516C5.59239 12.2812 5.60774 12.2873 5.61138 12.2925C5.64519 12.317 5.67954 12.3348 5.71395 12.3547C5.89792 12.452 6.07131 12.4804 6.25263 12.4804C6.62189 12.4804 6.85153 12.2839 6.85153 11.9675V11.9613C6.85153 11.6688 6.59211 11.5623 6.34991 11.4862L6.31821 11.4759C6.1349 11.4165 5.97674 11.3647 5.97674 11.2443V11.2381C5.97674 11.1349 6.06939 11.0588 6.21233 11.0588C6.37115 11.0588 6.56042 11.1117 6.68152 11.1786C6.68152 11.1786 6.71739 11.2018 6.73042 11.1671C6.7375 11.1484 6.79925 10.9832 6.80586 10.9646C6.81288 10.9453 6.80057 10.9306 6.78793 10.9231C6.64896 10.8384 6.45705 10.7808 6.25852 10.7808L6.22166 10.7809C5.8835 10.7809 5.64725 10.9854 5.64725 11.2779V11.2842C5.64725 11.5926 5.90798 11.6932 6.15151 11.7627L6.19069 11.7748C6.36804 11.8294 6.52157 11.8768 6.52157 12.0012V12.0074C6.52157 12.1219 6.42164 12.2072 6.2615 12.2072C6.19922 12.2072 6.00076 12.2062 5.78569 12.0703C5.75968 12.0551 5.74486 12.0442 5.72481 12.0319C5.71422 12.0255 5.68775 12.0139 5.67623 12.0486L5.60344 12.2511M11.0101 12.2511C10.9987 12.2806 11.0141 12.2868 11.0179 12.292C11.0515 12.3165 11.086 12.3342 11.1204 12.3541C11.3044 12.4514 11.4778 12.4799 11.6591 12.4799C12.0284 12.4799 12.258 12.2833 12.258 11.967V11.9608C12.258 11.6683 11.9993 11.5618 11.7564 11.4856L11.7247 11.4754C11.5414 11.416 11.3832 11.3642 11.3832 11.2438V11.2376C11.3832 11.1344 11.4759 11.0583 11.6188 11.0583C11.7776 11.0583 11.9662 11.1112 12.088 11.1781C12.088 11.1781 12.1239 11.2012 12.137 11.1666C12.144 11.1479 12.2058 10.9826 12.2118 10.9641C12.2188 10.9447 12.2065 10.9301 12.1939 10.9226C12.0549 10.8378 11.863 10.7803 11.6645 10.7803L11.6275 10.7804C11.2894 10.7804 11.0531 10.9849 11.0531 11.2774V11.2837C11.0531 11.5921 11.3139 11.6926 11.5574 11.7621L11.5965 11.7743C11.7745 11.8288 11.9274 11.8762 11.9274 12.0006V12.0069C11.9274 12.1213 11.8275 12.2067 11.6673 12.2067C11.6049 12.2067 11.4059 12.2056 11.1915 12.0697C11.1655 12.0546 11.1503 12.0441 11.1306 12.0314C11.1239 12.0272 11.0927 12.015 11.0821 12.0481L11.0093 12.2506M14.7019 11.6312C14.7019 11.8098 14.6686 11.9508 14.6033 12.0507C14.5382 12.1493 14.4398 12.1976 14.3029 12.1976C14.1659 12.1976 14.0679 12.1497 14.0037 12.0514C13.9391 11.9521 13.9065 11.8105 13.9065 11.6318C13.9065 11.4532 13.9393 11.3129 14.0037 11.2143C14.0678 11.1163 14.1652 11.0693 14.3029 11.0693C14.4405 11.0693 14.5385 11.1168 14.6033 11.2143C14.669 11.3129 14.7019 11.4532 14.7019 11.6318M15.0103 11.3003C14.9799 11.1977 14.9329 11.1077 14.87 11.0323C14.8071 10.9568 14.7277 10.8959 14.6331 10.8523C14.5391 10.8083 14.4279 10.7861 14.3022 10.7861C14.1765 10.7861 14.066 10.8084 13.9713 10.8523C13.8773 10.8962 13.7973 10.9568 13.7344 11.0323C13.6717 11.1077 13.6246 11.1977 13.5941 11.3003C13.564 11.4022 13.5487 11.5134 13.5487 11.6318C13.5487 11.7503 13.564 11.8615 13.5941 11.9634C13.6244 12.0659 13.6715 12.1559 13.7344 12.2314C13.7973 12.3068 13.8773 12.3671 13.9713 12.4101C14.066 12.4529 14.1771 12.4748 14.3022 12.4748C14.4273 12.4748 14.5385 12.4529 14.6324 12.4101C14.7264 12.3672 14.8065 12.3068 14.8693 12.2314C14.9321 12.1559 14.9792 12.0659 15.0096 11.9634C15.0397 11.8615 15.055 11.7503 15.055 11.6318C15.055 11.514 15.0397 11.4022 15.0096 11.3003M17.5442 12.1473C17.5341 12.1174 17.5048 12.1287 17.5048 12.1287C17.46 12.1458 17.4122 12.1617 17.3612 12.1696C17.3099 12.1777 17.2527 12.1818 17.1925 12.1818C17.0436 12.1818 16.9244 12.1374 16.8397 12.0494C16.7544 11.9614 16.7067 11.8198 16.7074 11.6279C16.7078 11.4532 16.7501 11.3221 16.8258 11.2215C16.9006 11.1223 17.0158 11.0707 17.168 11.0707C17.295 11.0707 17.3923 11.0854 17.4942 11.1173C17.4942 11.1173 17.5184 11.1278 17.53 11.096C17.557 11.0212 17.577 10.9676 17.6061 10.8856C17.6143 10.8621 17.5942 10.8521 17.5868 10.8493C17.5468 10.8337 17.4525 10.8081 17.381 10.7973C17.3142 10.7871 17.2367 10.7818 17.1494 10.7818C17.0197 10.7818 16.9045 10.804 16.8059 10.8479C16.7073 10.8918 16.6239 10.9525 16.5578 11.0279C16.4916 11.1033 16.4413 11.1933 16.4075 11.2959C16.3741 11.3978 16.3572 11.5097 16.3572 11.6281C16.3572 11.8836 16.4261 12.0907 16.5624 12.2422C16.6987 12.3944 16.9039 12.4712 17.1712 12.4712C17.3294 12.4712 17.4915 12.4393 17.608 12.3931C17.608 12.3931 17.6302 12.3824 17.6206 12.3565L17.5445 12.1473M18.0838 11.4591C18.0985 11.3598 18.1257 11.2771 18.1685 11.2129C18.2325 11.115 18.33 11.0614 18.467 11.0614C18.6039 11.0614 18.6946 11.1153 18.7595 11.2129C18.8025 11.2775 18.8213 11.3632 18.8283 11.4591L18.0805 11.459L18.0838 11.4591ZM19.1228 11.2407C19.0965 11.1421 19.0314 11.0422 18.9891 10.9965C18.9216 10.9244 18.8561 10.8734 18.7906 10.8457C18.696 10.8054 18.5942 10.7848 18.4914 10.785C18.3611 10.785 18.2426 10.807 18.1467 10.8518C18.0507 10.8969 17.97 10.9584 17.9064 11.0351C17.843 11.1119 17.7953 11.2025 17.7648 11.3064C17.7344 11.409 17.719 11.5215 17.719 11.6393C17.719 11.7598 17.735 11.8716 17.7663 11.9728C17.798 12.0748 17.8491 12.1641 17.9179 12.2382C17.9867 12.313 18.0747 12.3712 18.1806 12.4123C18.2858 12.4529 18.4135 12.4741 18.5598 12.4736C18.8616 12.4726 19.0204 12.4054 19.0852 12.369C19.0968 12.3626 19.1077 12.3514 19.0941 12.3191L19.0259 12.1279C19.0155 12.0994 18.9866 12.1097 18.9866 12.1097C18.9119 12.1376 18.806 12.1878 18.5578 12.1871C18.3957 12.1869 18.2759 12.139 18.2005 12.064C18.1237 11.9873 18.0853 11.8754 18.0794 11.7166L19.1249 11.7174C19.1249 11.7174 19.1525 11.7171 19.1553 11.6903C19.1564 11.6791 19.1911 11.4759 19.1242 11.2409L19.1228 11.2407ZM9.7257 11.4591C9.74046 11.3598 9.76772 11.2771 9.81041 11.2129C9.87447 11.115 9.97188 11.0614 10.1089 11.0614C10.2458 11.0614 10.3365 11.1153 10.4014 11.2129C10.4443 11.2775 10.4631 11.3632 10.4702 11.4591L9.72239 11.459L9.7257 11.4591ZM10.7647 11.2407C10.7385 11.1421 10.6733 11.0422 10.631 10.9965C10.5635 10.9244 10.498 10.8734 10.4325 10.8457C10.3379 10.8054 10.2361 10.7848 10.1333 10.785C10.003 10.785 9.88453 10.807 9.78857 10.8518C9.69261 10.8969 9.61188 10.9584 9.54835 11.0351C9.48502 11.1119 9.43717 11.2025 9.40673 11.3064C9.37636 11.409 9.36107 11.5215 9.36107 11.6393C9.36107 11.7598 9.37689 11.8716 9.40845 11.9728C9.44008 12.0748 9.49117 12.1641 9.55933 12.2382C9.62816 12.313 9.71617 12.3712 9.82206 12.4123C9.92728 12.4529 10.0543 12.4741 10.2012 12.4736C10.503 12.4726 10.6618 12.4054 10.7267 12.369C10.7382 12.3626 10.7492 12.3514 10.7355 12.3191L10.6673 12.1279C10.6568 12.0994 10.628 12.1097 10.628 12.1097C10.5532 12.1376 10.4473 12.1878 10.1991 12.1871C10.0377 12.1869 9.91722 12.139 9.84178 12.064C9.76501 11.9873 9.72663 11.8754 9.72067 11.7166L10.7663 11.7174C10.7663 11.7174 10.7938 11.7171 10.7966 11.6903C10.7978 11.6791 10.8324 11.4759 10.7654 11.2409L10.7647 11.2407ZM7.46908 12.1407C7.42812 12.108 7.42243 12.1 7.40886 12.0788C7.38815 12.0468 7.37756 12.0014 7.37756 11.9431C7.37756 11.8518 7.408 11.7856 7.47087 11.7413C7.47021 11.7414 7.56087 11.6632 7.77396 11.6658C7.86881 11.6675 7.96343 11.6756 8.05719 11.69V12.1645H8.05733C8.05733 12.1645 7.92497 12.193 7.77542 12.202C7.56299 12.2148 7.46902 12.1409 7.46968 12.1411L7.46908 12.1407ZM7.88467 11.4062C7.84232 11.4031 7.78739 11.4015 7.72188 11.4015C7.63254 11.4015 7.54585 11.4127 7.46511 11.4345C7.38372 11.4565 7.31026 11.4905 7.24739 11.5357C7.18435 11.5807 7.1325 11.6396 7.09585 11.7078C7.05886 11.7766 7.04 11.8574 7.04 11.9487C7.04 12.0413 7.05608 12.1214 7.08784 12.1869C7.11897 12.2519 7.16583 12.3081 7.22417 12.3504C7.2822 12.3926 7.35387 12.4238 7.43659 12.4424C7.51865 12.4611 7.6113 12.4706 7.71321 12.4706C7.82042 12.4706 7.92696 12.4616 8.03019 12.4441C8.11812 12.429 8.20571 12.4119 8.29292 12.3931C8.32772 12.3851 8.36637 12.3745 8.36637 12.3745C8.39218 12.368 8.3902 12.3404 8.3902 12.3404L8.3896 11.3874C8.3896 11.1783 8.33375 11.0228 8.2235 10.9269C8.11364 10.8309 7.95283 10.7826 7.74438 10.7826C7.66629 10.7826 7.53989 10.7932 7.46445 10.8083C7.46445 10.8083 7.23681 10.8525 7.14283 10.9261C7.14283 10.9261 7.12219 10.9388 7.13344 10.9676L7.20756 11.1661C7.21675 11.1919 7.24183 11.1831 7.24183 11.1831C7.24183 11.1831 7.24971 11.18 7.25897 11.1745C7.45949 11.0653 7.71361 11.0686 7.71361 11.0686C7.82611 11.0686 7.91346 11.0914 7.97169 11.1361C8.02867 11.1798 8.05772 11.246 8.05772 11.3849V11.4291C7.96839 11.4161 7.88567 11.4086 7.88567 11.4086L7.88467 11.4062ZM16.2891 10.8682C16.2906 10.8647 16.2914 10.8609 16.2914 10.8571C16.2914 10.8533 16.2907 10.8495 16.2892 10.846C16.2878 10.8425 16.2856 10.8394 16.2829 10.8367C16.2802 10.834 16.2769 10.832 16.2734 10.8306C16.2556 10.8238 16.1669 10.8051 16.0987 10.8009C15.9677 10.7926 15.8949 10.8148 15.8294 10.8441C15.7646 10.8733 15.693 10.9202 15.6533 10.9745L15.6532 10.8474C15.6532 10.83 15.6408 10.8159 15.6232 10.8159H15.3559C15.3385 10.8159 15.326 10.83 15.326 10.8474V12.4026C15.326 12.411 15.3293 12.419 15.3353 12.425C15.3412 12.4309 15.3492 12.4343 15.3577 12.4343H15.6316C15.64 12.4343 15.6481 12.4309 15.654 12.425C15.6599 12.419 15.6633 12.411 15.6633 12.4026V11.6217C15.6633 11.5171 15.6748 11.4133 15.6977 11.3477C15.7204 11.2829 15.7511 11.2313 15.7891 11.1942C15.8252 11.1584 15.8695 11.1319 15.9181 11.1168C15.9637 11.1037 16.0109 11.0971 16.0584 11.0971C16.113 11.0971 16.1729 11.1111 16.1729 11.1111C16.193 11.1133 16.2042 11.101 16.211 11.0829C16.2289 11.0352 16.2798 10.8923 16.2897 10.8639",
        fill: "#FFFFFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7299 10.1503C13.6961 10.14 13.6616 10.1319 13.6267 10.1258C13.5799 10.118 13.5324 10.1143 13.4849 10.1148C13.2961 10.1148 13.1472 10.1681 13.0427 10.2735C12.939 10.378 12.8684 10.5373 12.833 10.7469L12.8202 10.8177H12.5832C12.5832 10.8177 12.5543 10.8165 12.5482 10.848L12.5093 11.0651C12.5066 11.0859 12.5155 11.0988 12.5433 11.0987H12.774L12.5399 12.4052C12.5216 12.5104 12.5006 12.597 12.4774 12.6626C12.4545 12.7273 12.4321 12.7758 12.4046 12.811C12.3779 12.8451 12.3527 12.8702 12.309 12.8848C12.273 12.8969 12.2316 12.9025 12.1862 12.9025C12.1609 12.9025 12.1273 12.8982 12.1025 12.8933C12.0777 12.8884 12.0648 12.8828 12.0462 12.875C12.0462 12.875 12.0191 12.8647 12.0085 12.8918C11.9998 12.914 11.9383 13.0831 11.931 13.104C11.9236 13.1246 11.934 13.1409 11.9471 13.1456C11.9778 13.1566 12.0007 13.1636 12.0425 13.1735C12.1006 13.1872 12.1496 13.188 12.1954 13.188C12.2915 13.188 12.3791 13.1745 12.4517 13.1483C12.5247 13.1219 12.5883 13.0759 12.6446 13.0137C12.7054 12.9465 12.7436 12.8761 12.7802 12.7802C12.8164 12.6851 12.8473 12.567 12.8719 12.4294L13.1071 11.0987H13.451C13.451 11.0987 13.48 11.0998 13.486 11.0683L13.5249 10.8513C13.5276 10.8305 13.5187 10.8175 13.4908 10.8177H13.1571C13.1587 10.8101 13.1739 10.6927 13.2122 10.5822C13.2286 10.535 13.2593 10.497 13.2854 10.4708C13.3098 10.4459 13.3397 10.4273 13.3728 10.4164C13.4091 10.4052 13.4469 10.3998 13.4849 10.4003C13.5163 10.4003 13.5471 10.4041 13.5706 10.4089C13.603 10.4158 13.6156 10.4195 13.624 10.422C13.6581 10.4324 13.6626 10.4223 13.6693 10.4058L13.7491 10.1867C13.7573 10.1631 13.7373 10.1532 13.7299 10.1503ZM9.0662 12.408C9.0662 12.4255 9.05376 12.4397 9.03629 12.4397H8.75947C8.74193 12.4397 8.72949 12.4255 8.72949 12.408V10.18C8.72949 10.1626 8.74193 10.1485 8.75947 10.1485H9.03629C9.05376 10.1485 9.0662 10.1626 9.0662 10.18V12.408Z",
        fill: "#FFFFFE"
    }));
};





const $a8c0e1cc392a74ef$export$2ca8c87c1acb4a50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "18",
        height: "13",
        viewBox: "0 0 18 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "mask0_2230_19132",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "18",
        height: "13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 0H18V12.5735H0V0Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        mask: "url(#mask0_2230_19132)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.47399 1.37639C8.05502 0.771533 8.86369 0.396975 9.75708 0.396975C10.9483 0.396975 11.9806 1.05874 12.5365 2.04477C13.0299 1.82419 13.5644 1.7103 14.1049 1.71058C16.249 1.71058 17.9894 3.46425 17.9894 5.62822C17.9894 7.79219 16.249 9.54587 14.1049 9.54587C13.8428 9.54587 13.5874 9.51953 13.3372 9.46977C12.8508 10.3367 11.921 10.9256 10.8622 10.9256C10.4311 10.9265 10.0056 10.8287 9.6181 10.6398C9.12509 11.7979 7.97693 12.6118 6.64016 12.6118C5.24384 12.6118 4.05928 11.7317 3.60266 10.4942C3.39943 10.5371 3.19228 10.5586 2.98458 10.5585C1.32355 10.5585 -0.0198364 9.19527 -0.0198364 7.521C-0.0198364 6.396 0.585016 5.41659 1.48237 4.88718C1.292 4.44863 1.194 3.97556 1.1945 3.49747C1.1945 1.56512 2.76288 0.00335693 4.69524 0.00335693C5.82686 0.00335693 6.83935 0.542695 7.47465 1.37983",
        fill: "#00A1E0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.6034 6.53826C2.59208 6.56778 2.60743 6.57393 2.61107 6.57916C2.64489 6.60364 2.67924 6.62138 2.71365 6.6413C2.89762 6.73858 3.071 6.76703 3.25232 6.76703C3.62159 6.76703 3.85122 6.57049 3.85122 6.25417V6.24795C3.85122 5.95545 3.59181 5.8489 3.3496 5.7728L3.3179 5.76254C3.1346 5.70312 2.97643 5.65137 2.97643 5.53092V5.52477C2.97643 5.42153 3.06908 5.34543 3.21202 5.34543C3.37085 5.34543 3.56011 5.39831 3.68121 5.46521C3.68121 5.46521 3.71708 5.48837 3.73012 5.45376C3.7372 5.43503 3.79894 5.26979 3.80556 5.25126C3.81257 5.23187 3.80026 5.21725 3.78762 5.2097C3.64865 5.125 3.45674 5.06742 3.25821 5.06742L3.22135 5.06756C2.88319 5.06756 2.64694 5.27204 2.64694 5.56454V5.57083C2.64694 5.87921 2.90768 5.9798 3.15121 6.04928L3.19038 6.06146C3.36774 6.11599 3.52126 6.16337 3.52126 6.28778V6.294C3.52126 6.40849 3.42134 6.49386 3.26119 6.49386C3.19892 6.49386 3.00046 6.4928 2.78538 6.35687C2.75937 6.34172 2.74455 6.3308 2.7245 6.31856C2.71391 6.31214 2.68744 6.30056 2.67593 6.33523L2.60313 6.53773M8.00975 6.53773C7.99843 6.56725 8.01379 6.5734 8.01756 6.57863C8.05124 6.60312 8.08572 6.62085 8.12013 6.64077C8.3041 6.73805 8.47749 6.7665 8.65881 6.7665C9.02807 6.7665 9.25771 6.56996 9.25771 6.25364V6.24742C9.25771 5.95492 8.99896 5.84837 8.75609 5.77227L8.72439 5.76201C8.54108 5.70259 8.38292 5.65084 8.38292 5.53039V5.52424C8.38292 5.421 8.47557 5.3449 8.61851 5.3449C8.77733 5.3449 8.96593 5.39778 9.0877 5.46468C9.0877 5.46468 9.12357 5.48784 9.13667 5.45323C9.14368 5.4345 9.20549 5.26926 9.21145 5.25073C9.21853 5.23134 9.20615 5.21672 9.19358 5.20917C9.05461 5.12447 8.8627 5.06689 8.66417 5.06689L8.62724 5.06703C8.28908 5.06703 8.05283 5.27151 8.05283 5.56401V5.5703C8.05283 5.87868 8.31357 5.97927 8.5571 6.04875L8.59621 6.06093C8.77422 6.11546 8.92709 6.16284 8.92709 6.28725V6.29348C8.92709 6.40796 8.82716 6.49333 8.66701 6.49333C8.60461 6.49333 8.40562 6.49227 8.19121 6.35634C8.1652 6.34119 8.14998 6.33073 8.13026 6.31803C8.12357 6.31379 8.0924 6.30161 8.08175 6.3347L8.00896 6.5372M11.7016 5.91779C11.7016 6.09647 11.6683 6.23742 11.603 6.33735C11.5379 6.43595 11.4395 6.48426 11.3026 6.48426C11.1656 6.48426 11.0676 6.43635 11.0034 6.33801C10.9388 6.23875 10.9062 6.09713 10.9062 5.91845C10.9062 5.73978 10.939 5.59948 11.0034 5.50088C11.0675 5.40294 11.1649 5.35595 11.3026 5.35595C11.4402 5.35595 11.5381 5.4034 11.603 5.50088C11.6686 5.59948 11.7016 5.73978 11.7016 5.91845M12.01 5.58691C11.9796 5.48434 11.9326 5.39434 11.8697 5.31889C11.8068 5.24345 11.7274 5.18257 11.6328 5.13889C11.5388 5.09489 11.4276 5.07272 11.3019 5.07272C11.1762 5.07272 11.0656 5.09502 10.971 5.13889C10.877 5.18284 10.797 5.24345 10.7341 5.31889C10.6714 5.39434 10.6242 5.48434 10.5938 5.58691C10.5637 5.68882 10.5484 5.8 10.5484 5.91845C10.5484 6.03691 10.5637 6.14809 10.5938 6.25C10.6241 6.35257 10.6712 6.44257 10.7341 6.51801C10.797 6.59345 10.877 6.65367 10.971 6.69669C11.0656 6.73957 11.1768 6.76141 11.3019 6.76141C11.427 6.76141 11.5381 6.73957 11.6321 6.69669C11.7261 6.65381 11.8062 6.59345 11.869 6.51801C11.9318 6.44257 11.9789 6.35257 12.0093 6.25C12.0394 6.14809 12.0547 6.03691 12.0547 5.91845C12.0547 5.80066 12.0394 5.68882 12.0093 5.58691M14.5439 6.43397C14.5338 6.40399 14.5045 6.41531 14.5045 6.41531C14.4597 6.43245 14.4119 6.44833 14.3609 6.45627C14.3096 6.46434 14.2524 6.46838 14.1922 6.46838C14.0433 6.46838 13.9241 6.42398 13.8394 6.33603C13.7541 6.24801 13.7064 6.10639 13.7071 5.91448C13.7075 5.73978 13.7498 5.60875 13.8255 5.50816C13.9003 5.40889 14.0155 5.35728 14.1677 5.35728C14.2947 5.35728 14.392 5.37203 14.4939 5.40393C14.4939 5.40393 14.5181 5.41445 14.5297 5.38262C14.5567 5.30784 14.5767 5.25424 14.6058 5.17218C14.614 5.14869 14.5938 5.13876 14.5865 5.13592C14.5465 5.1203 14.4522 5.09469 14.3807 5.0839C14.3139 5.07371 14.2364 5.06842 14.1491 5.06842C14.0194 5.06842 13.9042 5.09059 13.8056 5.13453C13.707 5.1784 13.6236 5.23909 13.5575 5.31453C13.4913 5.38997 13.441 5.47997 13.4072 5.58254C13.3738 5.68445 13.3569 5.79629 13.3569 5.91475C13.3569 6.17019 13.4258 6.37732 13.5621 6.52886C13.6984 6.68107 13.9036 6.75784 14.1709 6.75784C14.3291 6.75784 14.4912 6.72587 14.6077 6.67975C14.6077 6.67975 14.6299 6.66903 14.6203 6.64309L14.5441 6.43397M15.0835 5.74573C15.0982 5.64647 15.1254 5.56375 15.1682 5.49956C15.2322 5.40161 15.3297 5.34801 15.4666 5.34801C15.6036 5.34801 15.6943 5.40188 15.7591 5.49956C15.8022 5.56408 15.821 5.64978 15.828 5.74573L15.0802 5.7456L15.0835 5.74573ZM16.1225 5.52735C16.0962 5.42875 16.0311 5.32882 15.9888 5.28316C15.9213 5.21103 15.8558 5.16007 15.7903 5.13228C15.6957 5.09206 15.5939 5.07141 15.4911 5.07159C15.3608 5.07159 15.2423 5.09363 15.1464 5.13843C15.0504 5.18356 14.9697 5.24498 14.9061 5.32174C14.8427 5.3985 14.795 5.48917 14.7645 5.59306C14.7341 5.69564 14.7187 5.80814 14.7187 5.92593C14.7187 6.04637 14.7347 6.15821 14.766 6.25946C14.7977 6.36137 14.8488 6.45071 14.9176 6.52483C14.9864 6.59961 15.0744 6.65784 15.1803 6.69887C15.2855 6.73957 15.4132 6.76068 15.5595 6.76022C15.8613 6.75923 16.0201 6.69206 16.0849 6.65566C16.0965 6.64917 16.1074 6.63799 16.0938 6.60576L16.0256 6.41451C16.0152 6.38599 15.9863 6.39631 15.9863 6.39631C15.9116 6.42424 15.8057 6.4744 15.5575 6.47374C15.3954 6.47347 15.2756 6.42563 15.2002 6.35065C15.1234 6.27389 15.085 6.16205 15.0791 6.00322L16.1246 6.00402C16.1246 6.00402 16.1522 6.00375 16.155 5.97689C16.1561 5.96577 16.1908 5.76248 16.1238 5.52755L16.1225 5.52735ZM6.7254 5.74573C6.74015 5.64647 6.76742 5.56375 6.8101 5.49956C6.87416 5.40161 6.97157 5.34801 7.10856 5.34801C7.24554 5.34801 7.33621 5.40188 7.40106 5.49956C7.44401 5.56408 7.4628 5.64978 7.46988 5.74573L6.72209 5.7456L6.7254 5.74573ZM7.76437 5.52735C7.73816 5.42875 7.67304 5.32882 7.63069 5.28316C7.56319 5.21103 7.49768 5.16007 7.43216 5.13228C7.33758 5.09206 7.23582 5.07141 7.13304 5.07159C7.00268 5.07159 6.88422 5.09363 6.78826 5.13843C6.69231 5.18356 6.61157 5.24498 6.54804 5.32174C6.48471 5.3985 6.43687 5.48917 6.40643 5.59306C6.37605 5.69564 6.36076 5.80814 6.36076 5.92593C6.36076 6.04637 6.37658 6.15821 6.40815 6.25946C6.43978 6.36137 6.49087 6.45071 6.55903 6.52483C6.62785 6.59961 6.71587 6.65784 6.82175 6.69887C6.92697 6.73957 7.05403 6.76068 7.20094 6.76022C7.50271 6.75923 7.66153 6.69206 7.72638 6.65566C7.7379 6.64917 7.74888 6.63799 7.73518 6.60576L7.66702 6.41451C7.6565 6.38599 7.62765 6.39631 7.62765 6.39631C7.55287 6.42424 7.44699 6.4744 7.19882 6.47374C7.03735 6.47347 6.91691 6.42563 6.84147 6.35065C6.76471 6.27389 6.72632 6.16205 6.72037 6.00322L7.76596 6.00402C7.76596 6.00402 7.79349 6.00375 7.79633 5.97689C7.79746 5.96577 7.83213 5.76248 7.7651 5.52755L7.76437 5.52735ZM4.46878 6.42735C4.42782 6.39466 4.42213 6.38665 4.40856 6.36541C4.38785 6.33345 4.37726 6.28798 4.37726 6.22975C4.37726 6.13842 4.4077 6.07225 4.47057 6.02791C4.4699 6.02804 4.56057 5.94982 4.77365 5.95247C4.8685 5.95417 4.96313 5.96224 5.05689 5.97662V6.45111H5.05702C5.05702 6.45111 4.92467 6.47963 4.77511 6.48863C4.56268 6.5014 4.46871 6.42748 4.46938 6.42768L4.46878 6.42735ZM4.88437 5.69279C4.84201 5.68968 4.78709 5.68816 4.72157 5.68816C4.63224 5.68816 4.54554 5.69928 4.46481 5.72112C4.38341 5.74309 4.30996 5.7771 4.24709 5.82237C4.18405 5.86734 4.1322 5.92621 4.09554 5.99442C4.05855 6.06325 4.03969 6.14398 4.03969 6.23531C4.03969 6.32795 4.05577 6.40803 4.08754 6.47354C4.11866 6.53852 4.16552 6.59471 4.22386 6.637C4.2819 6.67922 4.35357 6.71045 4.43629 6.72898C4.51835 6.74771 4.61099 6.75717 4.7129 6.75717C4.82011 6.75717 4.92665 6.74817 5.02989 6.73077C5.11782 6.7156 5.20541 6.69857 5.29261 6.67968C5.32742 6.67167 5.36607 6.66115 5.36607 6.66115C5.39188 6.6546 5.38989 6.627 5.38989 6.627L5.38929 5.67406C5.38929 5.46495 5.33344 5.30943 5.22319 5.21348C5.11334 5.11752 4.95253 5.06921 4.74407 5.06921C4.66599 5.06921 4.53959 5.0798 4.46415 5.09495C4.46415 5.09495 4.2365 5.13916 4.14253 5.21275C4.14253 5.21275 4.12188 5.22545 4.13313 5.25424L4.20725 5.45277C4.21645 5.47851 4.24153 5.46971 4.24153 5.46971C4.24153 5.46971 4.2494 5.4666 4.25867 5.46111C4.45918 5.35192 4.7133 5.35523 4.7133 5.35523C4.8258 5.35523 4.91315 5.37806 4.97139 5.42273C5.02837 5.46647 5.05742 5.53258 5.05742 5.67155V5.71569C4.96808 5.70272 4.88536 5.69524 4.88536 5.69524L4.88437 5.69279ZM13.2888 5.15478C13.2903 5.15129 13.2911 5.14753 13.2911 5.14373C13.2911 5.13993 13.2904 5.13616 13.2889 5.13266C13.2874 5.12915 13.2853 5.12597 13.2826 5.12331C13.2799 5.12066 13.2766 5.11857 13.2731 5.11719C13.2553 5.11044 13.1666 5.09171 13.0984 5.08748C12.9674 5.07927 12.8946 5.10137 12.8291 5.13075C12.7643 5.15994 12.6927 5.20686 12.653 5.26112L12.6529 5.13406C12.6529 5.11659 12.6405 5.1025 12.6229 5.1025H12.3556C12.3382 5.1025 12.3256 5.11659 12.3256 5.13406V6.68921C12.3257 6.69761 12.329 6.70566 12.335 6.71161C12.3409 6.71755 12.3489 6.72089 12.3573 6.72091H12.6313C12.6397 6.72089 12.6478 6.71754 12.6537 6.7116C12.6596 6.70566 12.6629 6.69761 12.6629 6.68921V5.90833C12.6629 5.80377 12.6745 5.69987 12.6974 5.63436C12.7201 5.56957 12.7508 5.51789 12.7888 5.48083C12.8249 5.44503 12.8692 5.41848 12.9178 5.4034C12.9634 5.39031 13.0106 5.38367 13.0581 5.38368C13.1127 5.38368 13.1726 5.39771 13.1726 5.39771C13.1927 5.39996 13.2039 5.38765 13.2107 5.36952C13.2286 5.32181 13.2795 5.17893 13.2894 5.15048",
        fill: "#FFFFFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7299 4.43702C10.6961 4.42679 10.6616 4.41861 10.6267 4.41254C10.5799 4.40471 10.5324 4.40104 10.4849 4.40155C10.2961 4.40155 10.1472 4.45489 10.0427 4.56024C9.93898 4.6648 9.86837 4.82409 9.83296 5.03367L9.82019 5.10441H9.58321C9.58321 5.10441 9.55429 5.10322 9.5482 5.13479L9.50929 5.35185C9.50658 5.37263 9.51551 5.3856 9.54331 5.38546H9.774L9.53993 6.69199C9.5216 6.79721 9.50062 6.88377 9.4774 6.94935C9.4545 7.01407 9.43213 7.06257 9.4046 7.09778C9.37793 7.13186 9.35265 7.15694 9.30904 7.17157C9.27304 7.18368 9.23162 7.18924 9.18622 7.18924C9.16094 7.18924 9.12732 7.185 9.10251 7.18004C9.07769 7.17514 9.06479 7.16958 9.04619 7.16177C9.04619 7.16177 9.01912 7.15145 9.00847 7.17858C8.9998 7.20075 8.93832 7.36983 8.93104 7.39074C8.92363 7.41139 8.93402 7.42767 8.94712 7.43237C8.97783 7.44335 9.00066 7.45037 9.04248 7.46023C9.10059 7.47393 9.14956 7.47479 9.19542 7.47479C9.29151 7.47479 9.37906 7.46129 9.45165 7.43508C9.52471 7.40868 9.58831 7.36268 9.64456 7.30041C9.70537 7.23324 9.74362 7.1629 9.78022 7.06694C9.81642 6.97185 9.84726 6.85379 9.87194 6.71621L10.1071 5.38546H10.451C10.451 5.38546 10.48 5.38652 10.486 5.35509L10.5249 5.13803C10.5276 5.11725 10.5187 5.10428 10.4908 5.10441H10.1571C10.1587 5.09687 10.1739 4.97947 10.2122 4.86896C10.2286 4.82177 10.2593 4.78372 10.2854 4.75758C10.3098 4.73269 10.3397 4.71403 10.3728 4.70318C10.4091 4.69197 10.4469 4.68652 10.4849 4.68704C10.5163 4.68704 10.5471 4.69081 10.5706 4.69571C10.603 4.70259 10.6156 4.70623 10.624 4.70874C10.6581 4.71913 10.6626 4.70907 10.6693 4.6926L10.7491 4.47342C10.7573 4.44986 10.7373 4.43993 10.7299 4.43702ZM6.0662 6.69477C6.0662 6.71224 6.05376 6.72646 6.03629 6.72646H5.75947C5.74193 6.72646 5.72949 6.71224 5.72949 6.69477V4.46674C5.72949 4.44933 5.74193 4.43524 5.75947 4.43524H6.03629C6.05376 4.43524 6.0662 4.44933 6.0662 4.46674V6.69477Z",
        fill: "#FFFFFE"
    }));





const $1174195b34229da6$export$1c85788b02a4bdef = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.513685",
        y: "0.513685",
        width: "30.9726",
        height: "30.9726",
        rx: "7.48631",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.02737"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.965 9.45256C14.7397 8.64602 15.8181 8.14657 17.0093 8.14657C18.5977 8.14657 19.9743 9.02899 20.7155 10.3438C21.3735 10.0497 22.0862 9.89782 22.8069 9.89818C25.6659 9.89818 27.9867 12.2366 27.9867 15.1221C27.9867 18.0077 25.6659 20.3461 22.8069 20.3461C22.4574 20.3461 22.1168 20.311 21.7833 20.2446C21.1347 21.4006 19.8949 22.1859 18.483 22.1859C17.9082 22.1871 17.3407 22.0567 16.824 21.8047C16.1666 23.349 14.6356 24.4343 12.8531 24.4343C10.9912 24.4343 9.41167 23.2607 8.8028 21.6106C8.53181 21.6678 8.25558 21.6965 7.97862 21.6964C5.76373 21.6964 3.97241 19.8786 3.97241 17.646C3.97241 16.1459 4.77895 14.8399 5.97551 14.134C5.72166 13.5492 5.591 12.9184 5.59166 12.2809C5.59166 9.70422 7.683 7.6217 10.2597 7.6217C11.7686 7.6217 13.1187 8.34088 13.9659 9.45715",
        fill: "#00A1E0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.47055 16.3355C7.45546 16.3749 7.47593 16.3831 7.48078 16.39C7.52587 16.4227 7.57167 16.4463 7.61756 16.4729C7.86287 16.6026 8.09407 16.6406 8.33585 16.6406C8.82824 16.6406 9.13444 16.3785 9.13444 15.9567V15.9484C9.13444 15.5584 8.78853 15.4163 8.46557 15.3148L8.4233 15.3011C8.17887 15.2219 7.96797 15.1529 7.96797 14.9923V14.9841C7.96797 14.8464 8.09151 14.7449 8.28211 14.7449C8.49389 14.7449 8.74627 14.8155 8.90775 14.9047C8.90775 14.9047 8.95558 14.9356 8.97296 14.8894C8.9824 14.8644 9.06473 14.6441 9.07356 14.6194C9.08291 14.5935 9.0665 14.574 9.04964 14.564C8.86433 14.451 8.60843 14.3742 8.3437 14.3742L8.29455 14.3744C7.84363 14.3744 7.52861 14.6471 7.52861 15.0371V15.0455C7.52861 15.4567 7.87628 15.5908 8.20102 15.6835L8.25326 15.6997C8.48974 15.7724 8.69447 15.8356 8.69447 16.0015V16.0098C8.69447 16.1625 8.56122 16.2763 8.34767 16.2763C8.26464 16.2763 8 16.2749 7.71321 16.0936C7.67853 16.0734 7.65877 16.0589 7.63203 16.0426C7.61791 16.034 7.58261 16.0185 7.56726 16.0648L7.47019 16.3348M14.6796 16.3348C14.6645 16.3742 14.685 16.3824 14.69 16.3893C14.7349 16.422 14.7809 16.4456 14.8268 16.4722C15.0721 16.6019 15.3033 16.6399 15.5451 16.6399C16.0375 16.6399 16.3437 16.3778 16.3437 15.956V15.9477C16.3437 15.5577 15.9986 15.4156 15.6748 15.3141L15.6325 15.3004C15.3881 15.2212 15.1772 15.1522 15.1772 14.9916V14.9834C15.1772 14.8457 15.3007 14.7442 15.4913 14.7442C15.7031 14.7442 15.9546 14.8147 16.117 14.904C16.117 14.904 16.1648 14.9348 16.1823 14.8887C16.1916 14.8637 16.274 14.6434 16.282 14.6187C16.2914 14.5928 16.2749 14.5733 16.2582 14.5633C16.0729 14.4503 15.8169 14.3735 15.5522 14.3735L15.503 14.3737C15.0521 14.3737 14.737 14.6464 14.737 15.0364V15.0448C14.737 15.456 15.0847 15.5901 15.4094 15.6828L15.4616 15.699C15.699 15.7717 15.9028 15.8349 15.9028 16.0008V16.0091C15.9028 16.1618 15.7696 16.2756 15.556 16.2756C15.4728 16.2756 15.2075 16.2742 14.9216 16.0929C14.8869 16.0727 14.8666 16.0588 14.8403 16.0418C14.8314 16.0362 14.7898 16.02 14.7756 16.0641L14.6785 16.3341M19.6025 15.5082C19.6025 15.7464 19.558 15.9344 19.471 16.0676C19.3841 16.1991 19.253 16.2635 19.0704 16.2635C18.8877 16.2635 18.7571 16.1996 18.6715 16.0685C18.5853 15.9361 18.5418 15.7473 18.5418 15.509C18.5418 15.2708 18.5856 15.0837 18.6715 14.9522C18.7569 14.8216 18.8868 14.759 19.0704 14.759C19.2539 14.759 19.3845 14.8222 19.471 14.9522C19.5585 15.0837 19.6025 15.2708 19.6025 15.509M20.0137 15.0669C19.9732 14.9302 19.9104 14.8102 19.8266 14.7096C19.7427 14.609 19.6369 14.5278 19.5107 14.4695C19.3854 14.4109 19.2371 14.3813 19.0695 14.3813C18.9018 14.3813 18.7544 14.411 18.6283 14.4695C18.503 14.5281 18.3962 14.609 18.3124 14.7096C18.2287 14.8102 18.1659 14.9302 18.1253 15.0669C18.0851 15.2028 18.0647 15.3511 18.0647 15.509C18.0647 15.667 18.0851 15.8152 18.1253 15.9511C18.1656 16.0879 18.2285 16.2079 18.3124 16.3085C18.3963 16.4091 18.503 16.4894 18.6283 16.5468C18.7544 16.6039 18.9027 16.6331 19.0695 16.6331C19.2363 16.6331 19.3845 16.6039 19.5098 16.5468C19.6351 16.4896 19.7419 16.4091 19.8257 16.3085C19.9095 16.2079 19.9722 16.0879 20.0128 15.9511C20.0528 15.8152 20.0732 15.667 20.0732 15.509C20.0732 15.352 20.0528 15.2028 20.0128 15.0669M23.3925 16.1964C23.379 16.1565 23.34 16.1716 23.34 16.1716C23.2802 16.1944 23.2164 16.2156 23.1485 16.2262C23.08 16.2369 23.0038 16.2423 22.9235 16.2423C22.7249 16.2423 22.5661 16.1831 22.4531 16.0658C22.3393 15.9485 22.2758 15.7596 22.2766 15.5037C22.2773 15.2708 22.3336 15.0961 22.4346 14.9619C22.5343 14.8296 22.6879 14.7607 22.8908 14.7607C23.0602 14.7607 23.19 14.7804 23.3258 14.823C23.3258 14.823 23.3581 14.837 23.3735 14.7945C23.4096 14.6948 23.4362 14.6233 23.475 14.5139C23.4859 14.4826 23.4591 14.4694 23.4493 14.4656C23.396 14.4447 23.2702 14.4106 23.1749 14.3962C23.0857 14.3826 22.9825 14.3756 22.866 14.3756C22.6931 14.3756 22.5395 14.4051 22.408 14.4637C22.2766 14.5222 22.1654 14.6031 22.0771 14.7037C21.9889 14.8043 21.9218 14.9243 21.8768 15.0611C21.8323 15.197 21.8098 15.3461 21.8098 15.5041C21.8098 15.8447 21.9015 16.1209 22.0833 16.323C22.2651 16.5259 22.5386 16.6283 22.8951 16.6283C23.106 16.6283 23.3222 16.5857 23.4775 16.5242C23.4775 16.5242 23.5072 16.5099 23.4943 16.4753L23.3928 16.1964M24.112 15.2787C24.1317 15.1464 24.1679 15.0361 24.2249 14.9505C24.3103 14.8199 24.4403 14.7484 24.6229 14.7484C24.8056 14.7484 24.9265 14.8202 25.013 14.9505C25.0703 15.0365 25.0954 15.1508 25.1047 15.2787L24.1076 15.2785L24.112 15.2787ZM25.4974 14.9875C25.4624 14.856 25.3756 14.7228 25.3192 14.6619C25.2291 14.5657 25.1418 14.4978 25.0544 14.4607C24.9283 14.4071 24.7926 14.3796 24.6556 14.3798C24.4817 14.3798 24.3238 14.4092 24.1958 14.4689C24.0679 14.5291 23.9602 14.611 23.8755 14.7134C23.7909 14.8157 23.7273 14.9366 23.6867 15.0751C23.6461 15.2119 23.6256 15.3619 23.6256 15.519C23.6256 15.6796 23.6469 15.8287 23.6887 15.9638C23.731 16.0996 23.799 16.2188 23.8908 16.3176C23.9825 16.4173 24.0999 16.495 24.2411 16.5497C24.3814 16.6039 24.5517 16.6321 24.7467 16.6315C25.1491 16.6302 25.3609 16.5406 25.4474 16.4921C25.4628 16.4834 25.4774 16.4685 25.4592 16.4255L25.3683 16.1705C25.3544 16.1325 25.3159 16.1462 25.3159 16.1462C25.2162 16.1835 25.075 16.2504 24.7441 16.2495C24.5279 16.2491 24.3682 16.1853 24.2676 16.0853C24.1652 15.983 24.114 15.8339 24.1061 15.6221L25.5003 15.6231C25.5003 15.6231 25.537 15.6228 25.5408 15.587C25.5423 15.5721 25.5886 15.3011 25.4993 14.9878L25.4974 14.9875ZM12.967 15.2787C12.9867 15.1464 13.023 15.0361 13.0799 14.9505C13.1654 14.8199 13.2952 14.7484 13.4779 14.7484C13.6606 14.7484 13.7815 14.8202 13.8679 14.9505C13.9252 15.0365 13.9503 15.1508 13.9597 15.2787L12.9626 15.2785L12.967 15.2787ZM14.3524 14.9875C14.3174 14.856 14.2306 14.7228 14.1741 14.6619C14.0841 14.5657 13.9968 14.4978 13.9094 14.4607C13.7833 14.4071 13.6476 14.3796 13.5106 14.3798C13.3367 14.3798 13.1788 14.4092 13.0508 14.4689C12.9229 14.5291 12.8152 14.611 12.7305 14.7134C12.646 14.8157 12.5822 14.9366 12.5417 15.0751C12.5012 15.2119 12.4808 15.3619 12.4808 15.519C12.4808 15.6796 12.5019 15.8287 12.544 15.9638C12.5861 16.0996 12.6543 16.2188 12.7451 16.3176C12.8369 16.4173 12.9543 16.495 13.0955 16.5497C13.2358 16.6039 13.4052 16.6321 13.6011 16.6315C14.0035 16.6302 14.2153 16.5406 14.3017 16.4921C14.3171 16.4834 14.3317 16.4685 14.3135 16.4255L14.2226 16.1705C14.2086 16.1325 14.1701 16.1462 14.1701 16.1462C14.0704 16.1835 13.9292 16.2504 13.5983 16.2495C13.383 16.2491 13.2224 16.1853 13.1218 16.0853C13.0194 15.983 12.9682 15.8339 12.9603 15.6221L14.3545 15.6231C14.3545 15.6231 14.3912 15.6228 14.395 15.587C14.3965 15.5721 14.4428 15.3011 14.3534 14.9878L14.3524 14.9875ZM9.95792 16.1876C9.9033 16.144 9.89571 16.1334 9.87762 16.105C9.85 16.0624 9.83588 16.0018 9.83588 15.9241C9.83588 15.8024 9.87647 15.7141 9.9603 15.655C9.95942 15.6552 10.0803 15.5509 10.3645 15.5544C10.4909 15.5567 10.6171 15.5674 10.7421 15.5866V16.2193H10.7423C10.7423 16.2193 10.5658 16.2573 10.3664 16.2693C10.0831 16.2864 9.95783 16.1878 9.95872 16.1881L9.95792 16.1876ZM10.5121 15.2081C10.4556 15.204 10.3824 15.202 10.295 15.202C10.1759 15.202 10.0603 15.2168 9.95263 15.2459C9.84409 15.2752 9.74614 15.3206 9.66231 15.3809C9.57825 15.4409 9.50911 15.5194 9.46023 15.6103C9.41091 15.7021 9.38576 15.8098 9.38576 15.9315C9.38576 16.0551 9.4072 16.1619 9.44956 16.2492C9.49106 16.3359 9.55354 16.4108 9.63134 16.4672C9.70872 16.5235 9.80429 16.5651 9.91459 16.5898C10.024 16.6148 10.1476 16.6274 10.2834 16.6274C10.4264 16.6274 10.5685 16.6154 10.7061 16.5922C10.8234 16.572 10.9402 16.5493 11.0565 16.5241C11.1029 16.5134 11.1544 16.4994 11.1544 16.4994C11.1888 16.4906 11.1862 16.4538 11.1862 16.4538L11.1854 15.1832C11.1854 14.9043 11.1109 14.6969 10.9639 14.569C10.8174 14.441 10.603 14.3766 10.325 14.3766C10.2209 14.3766 10.0523 14.3907 9.95174 14.4109C9.95174 14.4109 9.64819 14.4699 9.52289 14.568C9.52289 14.568 9.49535 14.585 9.51036 14.6233L9.60919 14.8881C9.62145 14.9224 9.6549 14.9107 9.6549 14.9107C9.6549 14.9107 9.6654 14.9065 9.67775 14.8992C9.94513 14.7536 10.284 14.758 10.284 14.758C10.434 14.758 10.5505 14.7885 10.6281 14.848C10.7041 14.9063 10.7428 14.9945 10.7428 15.1798V15.2387C10.6237 15.2214 10.5134 15.2114 10.5134 15.2114L10.5121 15.2081ZM21.7189 14.4907C21.7209 14.4861 21.7219 14.4811 21.722 14.476C21.722 14.4709 21.721 14.4659 21.719 14.4612C21.7171 14.4565 21.7142 14.4523 21.7106 14.4488C21.707 14.4452 21.7027 14.4424 21.698 14.4406C21.6742 14.4316 21.5559 14.4066 21.465 14.401C21.2903 14.39 21.1932 14.4195 21.1058 14.4587C21.0195 14.4976 20.9241 14.5602 20.8711 14.6325L20.8709 14.4631C20.8709 14.4398 20.8544 14.421 20.831 14.421H20.4745C20.4514 14.421 20.4346 14.4398 20.4346 14.4631V16.5368C20.4346 16.548 20.4391 16.5587 20.447 16.5667C20.4549 16.5746 20.4657 16.579 20.4769 16.5791H20.8422C20.8534 16.579 20.8641 16.5746 20.872 16.5667C20.8799 16.5587 20.8844 16.548 20.8844 16.5368V15.4955C20.8844 15.3561 20.8997 15.2176 20.9303 15.1302C20.9605 15.0438 21.0015 14.9749 21.0521 14.9255C21.1003 14.8778 21.1594 14.8424 21.2242 14.8222C21.285 14.8048 21.348 14.7959 21.4113 14.796C21.4841 14.796 21.5639 14.8147 21.5639 14.8147C21.5907 14.8177 21.6057 14.8012 21.6147 14.7771C21.6387 14.7134 21.7065 14.5229 21.7197 14.485",
        fill: "#FFFFFE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.3067 13.5334C18.2615 13.5198 18.2156 13.5089 18.1691 13.5008C18.1066 13.4904 18.0433 13.4855 17.9799 13.4861C17.7282 13.4861 17.5297 13.5573 17.3904 13.6978C17.252 13.8372 17.1579 14.0496 17.1106 14.329L17.0936 14.4234H16.7776C16.7776 14.4234 16.7391 14.4218 16.7309 14.4639L16.6791 14.7533C16.6754 14.781 16.6874 14.7983 16.7244 14.7981H17.032L16.7199 16.5403C16.6955 16.6806 16.6675 16.796 16.6365 16.8835C16.606 16.9698 16.5762 17.0345 16.5395 17.0814C16.5039 17.1269 16.4702 17.1603 16.412 17.1798C16.364 17.1959 16.3088 17.2034 16.2483 17.2034C16.2145 17.2034 16.1697 17.1977 16.1366 17.1911C16.1035 17.1846 16.0863 17.1771 16.0615 17.1667C16.0615 17.1667 16.0254 17.153 16.0112 17.1891C15.9997 17.2187 15.9177 17.4442 15.908 17.4721C15.8981 17.4996 15.912 17.5213 15.9294 17.5276C15.9704 17.5422 16.0008 17.5516 16.0566 17.5647C16.1341 17.583 16.1994 17.5841 16.2605 17.5841C16.3886 17.5841 16.5054 17.5661 16.6022 17.5312C16.6996 17.496 16.7844 17.4346 16.8594 17.3516C16.9405 17.262 16.9915 17.1682 17.0403 17.0403C17.0886 16.9135 17.1297 16.7561 17.1626 16.5726L17.4762 14.7981H17.9347C17.9347 14.7981 17.9734 14.7995 17.9814 14.7576L18.0333 14.4682C18.0369 14.4405 18.0251 14.4232 17.9879 14.4234H17.5429C17.5451 14.4133 17.5653 14.2568 17.6164 14.1094C17.6382 14.0465 17.6792 13.9957 17.714 13.9609C17.7464 13.9277 17.7864 13.9028 17.8305 13.8884C17.8789 13.8734 17.9293 13.8661 17.9799 13.8668C18.0218 13.8668 18.063 13.8719 18.0943 13.8784C18.1374 13.8876 18.1542 13.8924 18.1655 13.8958C18.2109 13.9096 18.2169 13.8962 18.2259 13.8742L18.3323 13.582C18.3432 13.5506 18.3166 13.5373 18.3067 13.5334ZM12.0879 16.544C12.0879 16.5673 12.0713 16.5863 12.048 16.5863H11.6789C11.6555 16.5863 11.6389 16.5673 11.6389 16.544V13.5731C11.6389 13.5499 11.6555 13.5311 11.6789 13.5311H12.048C12.0713 13.5311 12.0879 13.5499 12.0879 13.5731V16.544Z",
        fill: "#FFFFFE"
    }));
};






var $k8S4l = parcelRequire("k8S4l");


var $gtIrp = parcelRequire("gtIrp");


var $hahVW = parcelRequire("hahVW");













const $b812d38ebb638264$export$a4d5e19d058175e7 = ()=>{
    const config = new Map();
    // Entries are ordered alphabetically by display label.
    if ((0, $dh538.fg)('rovo-fps-3p-ux-salesforce-campaign-noun')) config.set((0, $2Znam.TypeFilterValueKey).Campaign, {
        entities3P: [
            ...(0, $k8S4l.DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    if ((0, $dh538.fg)('rovo-fps-3p-ux-salesforce-case-noun')) config.set((0, $2Znam.TypeFilterValueKey).Case, {
        entities3P: [
            ...(0, $gtIrp.DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $2Znam.TypeFilterValueKey).CustomerContact, {
        entities3P: [
            ...(0, $hahVW.DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $2Znam.TypeFilterValueKey).CustomerOrg, {
        entities3P: (0, $c8e62.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $2Znam.TypeFilterValueKey).Deal, {
        entities3P: [
            ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
            ...(0, $7sFsr.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Deal
        ]
    });
    return config;
};


const $5ce640630a674ea4$export$68b7906270c63e2d = {
    displayName: 'Salesforce',
    id: 'salesforce',
    resourceType: 'salesforce-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $dd87d9abaea6cdea$export$89e1f2a7c57f2a4d), 'Salesforce', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $a8c0e1cc392a74ef$export$2ca8c87c1acb4a50), 'Salesforce', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $1174195b34229da6$export$1c85788b02a4bdef), 'Salesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/salesforce',
    // Use a getter to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
    // This allows for feature gate mocks in tests to work correctly.
    // NOTE: Must be kept in sync with getSalesforce3PTypeFilterConfig() in
    // ThirdPartyConfigs, which drives Type filter pills via getTypeMapping().
    // This getter additionally controls entity ATI request shaping in filters/index.ts
    // when a specific type is selected.
    get typeFilterConfig () {
        return (0, $b812d38ebb638264$export$a4d5e19d058175e7)();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch',
            'lastUpdatedBy',
            'createdBy'
        ];
        baseFilters.push('owner');
        baseFilters.push('opportunityStatus');
        baseFilters.push('closeDate');
        if ((0, $dh538.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) baseFilters.push('salesforceStage');
        if ((0, $dh538.fg)('rovo-fps-3p-ux-sf-campaign-status-filter')) baseFilters.push('campaignStatus');
        baseFilters.push('caseStatus');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};














const $48f15a0ebfeae12d$export$ddeafef64c08610e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.2634 5.12647C13.1313 4.90729 12.9448 4.72597 12.722 4.6001C12.4992 4.47423 12.2477 4.40808 11.9918 4.40808C11.7359 4.40808 11.4844 4.47423 11.2616 4.6001C11.0388 4.72597 10.8523 4.90729 10.7202 5.12647L8.62849 8.70913C10.2265 9.50694 11.588 10.7089 12.5779 12.1956C13.5677 13.6823 14.1514 15.4021 14.2711 17.1842H12.8024C12.683 15.6566 12.1667 14.1867 11.3047 12.9199C10.4427 11.6531 9.26492 10.6334 7.8878 9.96162L5.95183 13.309C6.726 13.6562 7.40046 14.1925 7.91318 14.8686C8.4259 15.5446 8.76042 16.3387 8.88598 17.1778H5.51314C5.47313 17.175 5.43447 17.1622 5.40062 17.1407C5.36677 17.1192 5.33881 17.0896 5.31926 17.0546C5.2997 17.0196 5.28917 16.9803 5.28861 16.9402C5.28805 16.9001 5.29747 16.8605 5.31604 16.8249L6.25065 15.2355C5.93401 14.9713 5.57212 14.7667 5.18253 14.6315L4.25746 16.2209C4.16115 16.3861 4.09863 16.5688 4.07353 16.7584C4.04842 16.9479 4.06124 17.1406 4.11122 17.3251C4.16121 17.5097 4.24737 17.6825 4.3647 17.8335C4.48203 17.9844 4.62819 18.1106 4.7947 18.2046C5.01407 18.3282 5.26134 18.3938 5.51314 18.3953H10.1321C10.2179 17.3368 10.0289 16.274 9.58332 15.3099C9.13777 14.3459 8.45081 13.5132 7.58898 12.8926L8.32331 11.621C9.41096 12.3681 10.285 13.3858 10.8592 14.5738C11.4334 15.7618 11.6879 17.0789 11.5976 18.3953H15.5109C15.602 16.4012 15.1682 14.418 14.2528 12.6441C13.3373 10.8701 11.9724 9.36748 10.2943 8.28633L11.7788 5.74318C11.8119 5.68775 11.8655 5.64764 11.928 5.63156C11.9906 5.61549 12.0569 5.62476 12.1126 5.65735C12.2811 5.74954 18.5627 16.7105 18.6803 16.8377C18.701 16.8748 18.7115 16.9168 18.7108 16.9593C18.7101 17.0019 18.6982 17.0435 18.6763 17.0799C18.6543 17.1164 18.6232 17.1464 18.5859 17.1669C18.5487 17.1874 18.5066 17.1978 18.4641 17.1969H16.9509C16.97 17.6017 16.97 18.0054 16.9509 18.4081H18.4705C18.6634 18.4093 18.8547 18.3723 19.0333 18.2991C19.2118 18.226 19.3741 18.1181 19.5107 17.9818C19.6473 17.8455 19.7554 17.6835 19.829 17.5051C19.9025 17.3267 19.94 17.1355 19.9391 16.9426C19.9393 16.6877 19.8713 16.4374 19.742 16.2178L13.2634 5.12647Z",
        fill: "white"
    }));
};





const $f59a247ac1201a93$export$18b7ca5aa35613ec = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.6843 6.83529C17.5082 6.54305 17.2596 6.30129 16.9626 6.13346C16.6655 5.96563 16.3301 5.87744 15.9889 5.87744C15.6477 5.87744 15.3123 5.96563 15.0153 6.13346C14.7182 6.30129 14.4696 6.54305 14.2935 6.83529L11.5045 11.6122C13.6352 12.6759 15.4505 14.2785 16.7703 16.2608C18.0901 18.2431 18.8684 20.5361 19.028 22.9122H17.0697C16.9105 20.8755 16.2221 18.9156 15.0728 17.2265C13.9235 15.5375 12.3531 14.1779 10.5169 13.2822L7.93561 17.7454C8.96784 18.2083 9.86712 18.9234 10.5507 19.8247C11.2344 20.7261 11.6804 21.7849 11.8478 22.9037H7.35068C7.29735 22.9 7.24579 22.883 7.20066 22.8543C7.15553 22.8256 7.11825 22.7862 7.09218 22.7395C7.06611 22.6928 7.05206 22.6404 7.05131 22.5869C7.05056 22.5335 7.06314 22.4806 7.08789 22.4333L8.33403 20.314C7.91184 19.9617 7.42933 19.6889 6.90987 19.5086L5.67645 21.6279C5.54804 21.8482 5.46468 22.0917 5.43121 22.3445C5.39774 22.5972 5.41482 22.8541 5.48147 23.1002C5.54811 23.3463 5.66299 23.5766 5.81944 23.7779C5.97588 23.9792 6.17076 24.1475 6.39277 24.2728C6.68527 24.4376 7.01495 24.5251 7.35068 24.5271H13.5093C13.6237 23.1157 13.3717 21.6987 12.7776 20.4132C12.1835 19.1278 11.2676 18.0176 10.1185 17.1901L11.0976 15.4947C12.5478 16.4907 13.7132 17.8477 14.4788 19.4317C15.2444 21.0157 15.5837 22.7719 15.4633 24.5271H20.681C20.8025 21.8682 20.2241 19.2241 19.0035 16.8588C17.7829 14.4935 15.963 12.49 13.7255 11.0484L15.7049 7.65757C15.749 7.58367 15.8205 7.53018 15.9039 7.50875C15.9872 7.48732 16.0757 7.49967 16.15 7.54313C16.3746 7.66605 24.75 22.2807 24.9069 22.4502C24.9345 22.4997 24.9486 22.5557 24.9476 22.6124C24.9467 22.6691 24.9308 22.7246 24.9015 22.7732C24.8723 22.8218 24.8307 22.8618 24.7811 22.8892C24.7314 22.9166 24.6754 22.9304 24.6187 22.9292H22.6011C22.6265 23.4689 22.6265 24.0072 22.6011 24.5441H24.6271C24.8844 24.5458 25.1394 24.4964 25.3775 24.3988C25.6156 24.3013 25.8319 24.1575 26.0141 23.9758C26.1962 23.794 26.3404 23.578 26.4385 23.3402C26.5366 23.1023 26.5865 22.8474 26.5854 22.5901C26.5856 22.2503 26.4949 21.9166 26.3226 21.6237L17.6843 6.83529Z",
        fill: "white"
    }));
};


const $b1c1bb33fa733897$export$6c52693ff10aea16 = {
    displayName: 'Sentry',
    id: 'sentry',
    resourceType: 'smartlinks-connector-sentry',
    icon: (0, $9yyKc.get3PLogo)((0, $48f15a0ebfeae12d$export$ddeafef64c08610e), 'Sentry', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $f59a247ac1201a93$export$18b7ca5aa35613ec), 'Sentry', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sentry',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};


























const $97fd8ac63b70acdf$export$829928eabc615ce1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0473 4.00178C10.4382 3.99842 8.86528 4.4785 7.53234 5.37978C6.19941 6.28105 5.16796 7.56197 4.57171 9.05646C3.97546 10.5509 3.84191 12.1901 4.18837 13.7614C4.53483 15.3327 5.34532 16.7637 6.51478 17.8688C6.78908 18.13 7.14782 18.2844 7.52608 18.3041C7.90434 18.3237 8.27713 18.2073 8.57701 17.9759C9.56641 17.2396 10.7668 16.842 12.0001 16.842C13.2334 16.842 14.4339 17.2396 15.4233 17.9759C15.726 18.2078 16.1021 18.3232 16.4828 18.301C16.8635 18.2788 17.2236 18.1205 17.4973 17.8549C18.6576 16.7539 19.4626 15.3314 19.8092 13.7698C20.1558 12.2082 20.0282 10.5787 19.4426 9.09017C18.8571 7.60161 17.8404 6.32184 16.5228 5.41488C15.2052 4.50793 13.6467 4.01512 12.0473 3.99963M12.0001 16.0379C11.4713 16.0522 10.9451 15.9586 10.4536 15.7628C9.96216 15.567 9.51573 15.2731 9.1416 14.8991C8.76746 14.525 8.47347 14.0787 8.27754 13.5873C8.08161 13.0959 7.98787 12.5697 8.00202 12.0408C8.00202 10.9805 8.42326 9.96353 9.17305 9.21374C9.92284 8.46395 10.9398 8.04272 12.0001 8.04272C13.0605 8.04272 14.0774 8.46395 14.8272 9.21374C15.577 9.96353 15.9983 10.9805 15.9983 12.0408C16.0124 12.5697 15.9187 13.0959 15.7227 13.5873C15.5268 14.0787 15.2328 14.525 14.8587 14.8991C14.4846 15.2731 14.0381 15.567 13.5467 15.7628C13.0552 15.9586 12.529 16.0522 12.0001 16.0379Z",
        fill: "#62D84E"
    }));
};





const $34e1b84dac95dcfd$export$4b2cdd8d303d18d0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0629 5.33574C13.9175 5.33126 11.8203 5.97137 10.043 7.17308C8.2658 8.37478 6.89053 10.0827 6.09553 12.0753C5.30054 14.068 5.12247 16.2535 5.58441 18.3486C6.04636 20.4436 7.12701 22.3516 8.68629 23.8252C9.05202 24.1734 9.53035 24.3793 10.0347 24.4054C10.539 24.4316 11.0361 24.2764 11.4359 23.9679C12.7551 22.9862 14.3557 22.456 16.0001 22.456C17.6445 22.456 19.2451 22.9862 20.5643 23.9679C20.968 24.2771 21.4693 24.431 21.9769 24.4013C22.4846 24.3717 22.9647 24.1606 23.3296 23.8066C24.8767 22.3385 25.9501 20.4419 26.4122 18.3598C26.8743 16.2777 26.7041 14.105 25.9234 12.1203C25.1427 10.1355 23.7871 8.42916 22.0303 7.21988C20.2735 6.01061 18.1956 5.35353 16.0629 5.33289M16.0001 21.3839C15.295 21.4029 14.5934 21.2781 13.9381 21.0171C13.2828 20.756 12.6876 20.3642 12.1887 19.8655C11.6899 19.3668 11.2979 18.7716 11.0366 18.1164C10.7754 17.4612 10.6504 16.7596 10.6693 16.0545C10.6693 14.6407 11.2309 13.2848 12.2306 12.285C13.2304 11.2853 14.5863 10.7237 16.0001 10.7237C17.4139 10.7237 18.7698 11.2853 19.7696 12.285C20.7693 13.2848 21.3309 14.6407 21.3309 16.0545C21.3498 16.7596 21.2248 17.4612 20.9636 18.1164C20.7023 18.7716 20.3103 19.3668 19.8115 19.8655C19.3127 20.3642 18.7174 20.756 18.0621 21.0171C17.4068 21.2781 16.7052 21.4029 16.0001 21.3839Z",
        fill: "#62D84E"
    }));
};


const $d3c7cad46ab257e1$var$getServiceNowTypeFilterConfig = ()=>{
    const config = new Map();
    if ((0, $dh538.fg)('rovo_fps_servicenow_type_filter_subtypes')) {
        config.set((0, $2Znam.TypeFilterValueKey).Incident, {
            entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Incident
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).CatalogItem, {
            entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).CatalogItem
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).RequestedItem, {
            entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).RequestedItem
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Epic, {
            entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Epic
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).KnowledgeArticle, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).KnowledgeArticle
            ]
        });
    } else config.set((0, $2Znam.TypeFilterValueKey).WorkItem, {
        entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $dh538.fg)('rovo_search_document_filter_enable_for_servicenow')) config.set((0, $2Znam.TypeFilterValueKey).Document, {
        entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Document,
            (0, $2Znam.NounSubtypeKey).Article,
            (0, $2Znam.NounSubtypeKey).NewsArticle
        ]
    });
    if ((0, $dh538.fg)('enable_rovo_search_comment_filter_for_servicenow')) config.set((0, $2Znam.TypeFilterValueKey).Comment, {
        entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $dh538.fg)('enable_rovo_search_project_filter_for_servicenow')) {
        config.set((0, $2Znam.TypeFilterValueKey).Project, {
            entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Project
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Demand, {
            entities3P: (0, $3q5AZ.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Demand
            ]
        });
    }
    return config;
};
const $d3c7cad46ab257e1$export$d60233309c5c50ab = {
    displayName: 'ServiceNow',
    id: 'servicenow',
    icon: (0, $9yyKc.get3PLogo)((0, $97fd8ac63b70acdf$export$829928eabc615ce1), 'ServiceNow', 'medium'),
    resourceType: 'servicenow-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $34e1b84dac95dcfd$export$4b2cdd8d303d18d0), 'ServiceNow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/servicenow',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    get typeFilterConfig () {
        return $d3c7cad46ab257e1$var$getServiceNowTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};




















const $77d5e1f6fdebef0b$export$53d8bcde0f28cd56 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1863 13.1429C14.6523 13.1429 16.6514 11.0962 16.6514 8.57143C16.6514 6.0467 14.6523 4 12.1863 4C9.72029 4 7.72119 6.0467 7.72119 8.57143C7.72119 11.0962 9.72029 13.1429 12.1863 13.1429Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.907 16.9525C18.1675 16.9525 20 15.0763 20 12.762C20 10.4477 18.1675 8.57153 15.907 8.57153C13.6465 8.57153 11.814 10.4477 11.814 12.762C11.814 15.0763 13.6465 16.9525 15.907 16.9525Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.7443 20.0001C14.4911 20.0001 15.9071 18.5504 15.9071 16.762C15.9071 14.9737 14.4911 13.5239 12.7443 13.5239C10.9976 13.5239 9.58154 14.9737 9.58154 16.762C9.58154 18.5504 10.9976 20.0001 12.7443 20.0001Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M12.9302 8.12585V16.2554C12.9283 16.5379 12.7611 16.7916 12.506 16.8992C12.4248 16.9344 12.3374 16.9525 12.2492 16.9525H9.58506C9.58134 16.8878 9.58134 16.8268 9.58134 16.762C9.5801 16.6984 9.58258 16.6348 9.58878 16.5716C9.65688 15.3538 10.3896 14.2794 11.4827 13.7944V13.0858C9.04996 12.6911 7.39032 10.3521 7.77583 7.86137C7.77851 7.84412 7.78127 7.82688 7.78414 7.80966C7.80266 7.68118 7.82876 7.55396 7.86228 7.42871H12.2493C12.6247 7.43017 12.9287 7.74144 12.9302 8.12585Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.8772 7.80957H7.78421C7.37074 10.2958 9.00415 12.6544 11.4325 13.0777C11.5061 13.0906 11.5799 13.1015 11.654 13.1105C10.5005 13.6705 9.65993 15.261 9.58849 16.5715C9.5823 16.6348 9.57981 16.6984 9.58104 16.7619C9.58104 16.8267 9.58104 16.8877 9.58476 16.9524C9.59147 17.0805 9.60765 17.2078 9.63313 17.3334H11.8769C12.1528 17.3315 12.4006 17.1603 12.5057 16.8991C12.54 16.8159 12.5578 16.7265 12.5578 16.6362V8.50671C12.5564 8.12245 12.2526 7.81125 11.8772 7.80957Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.8772 7.80957H7.78418C7.37079 10.296 9.00445 12.6548 11.4331 13.078C11.4828 13.0867 11.5326 13.0945 11.5825 13.1014C10.4662 13.7018 9.65879 15.2884 9.58883 16.5715H11.8772C12.2521 16.5686 12.5553 16.2581 12.5581 15.8743V8.50671C12.5567 8.1223 12.2527 7.81103 11.8772 7.80957Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.505 7.80957H7.78405C7.39371 10.1568 8.8303 12.4172 11.0845 13.0027C10.231 14.0012 9.70744 15.2502 9.58871 16.5715H11.505C11.8805 16.57 12.1845 16.2587 12.1859 15.8743V8.50671C12.1857 8.12178 11.881 7.80978 11.505 7.80957Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.68205 7.80957H11.504C11.8807 7.80957 12.186 8.1222 12.186 8.50786V15.4922C12.186 15.8779 11.8807 16.1905 11.504 16.1905H4.68205C4.30536 16.1905 4 15.8779 4 15.4922V8.50786C4 8.1222 4.30536 7.80957 4.68205 7.80957Z",
        fill: "#026D71"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.04621 11.9147C6.88638 11.8062 6.75286 11.6617 6.65588 11.4922C6.56192 11.3151 6.51508 11.1158 6.52007 10.9143C6.5117 10.6415 6.60162 10.3751 6.77272 10.1658C6.95251 9.95618 7.1849 9.80099 7.44472 9.717C7.74082 9.61722 8.05096 9.56805 8.36267 9.57148C8.77258 9.55614 9.18193 9.61482 9.57197 9.74481V10.621C9.40249 10.5159 9.21791 10.4388 9.02499 10.3924C8.81567 10.3399 8.60088 10.3135 8.38536 10.314C8.15809 10.3054 7.93227 10.3544 7.72787 10.4564C7.57007 10.5261 7.46774 10.6851 7.46741 10.861C7.46677 10.9677 7.50682 11.0705 7.57904 11.1475C7.66434 11.2382 7.76525 11.3121 7.87672 11.3654C8.00074 11.4286 8.18679 11.5127 8.43485 11.6176C8.46217 11.6264 8.48879 11.6374 8.51448 11.6504C8.75862 11.748 8.99415 11.867 9.21848 12.0058C9.38837 12.113 9.53095 12.26 9.63449 12.4347C9.74064 12.6328 9.79209 12.8566 9.78332 13.0824C9.79544 13.3624 9.71174 13.6381 9.54667 13.8618C9.38213 14.0674 9.16216 14.219 8.91411 14.2976C8.62236 14.3912 8.31786 14.4365 8.01215 14.4317C7.73787 14.433 7.46399 14.41 7.19355 14.3631C6.96521 14.3249 6.74237 14.2578 6.53011 14.1635V13.2397C6.733 13.388 6.95967 13.4989 7.19988 13.5673C7.43928 13.6437 7.68814 13.6845 7.93886 13.6884C8.17091 13.7035 8.40255 13.6532 8.60863 13.5429C8.75299 13.4595 8.84079 13.3015 8.83709 13.1319C8.83806 13.0138 8.79244 12.9004 8.71058 12.8172C8.60879 12.7149 8.49093 12.6308 8.36194 12.5684C8.2131 12.4922 7.99393 12.3918 7.70445 12.2671C7.47415 12.1723 7.25365 12.0543 7.04621 11.9147Z",
        fill: "white"
    })));
};





const $1a38defd9262901b$export$a0d18fc9cea4f40e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19237)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
        fill: "url(#paint0_linear_2230_19237)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_2230_19237",
        x1: "1.42208",
        y1: "3.26391",
        x2: "6.95471",
        y2: "12.6234",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#058F92"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5",
        stopColor: "#038489"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#026D71"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19237"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));





const $200bd2d79addba31$export$65b9e0ddb04a51a1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.2482 17.5237C19.5362 17.5237 22.2017 14.7948 22.2017 11.4285C22.2017 8.06218 19.5362 5.33325 16.2482 5.33325C12.9601 5.33325 10.2947 8.06218 10.2947 11.4285C10.2947 14.7948 12.9601 17.5237 16.2482 17.5237Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.2091 22.6031C24.2231 22.6031 26.6664 20.1016 26.6664 17.0158C26.6664 13.93 24.2231 11.4285 21.2091 11.4285C18.1951 11.4285 15.7517 13.93 15.7517 17.0158C15.7517 20.1016 18.1951 22.6031 21.2091 22.6031Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.9922 26.6667C19.3212 26.6667 21.2093 24.7337 21.2093 22.3492C21.2093 19.9647 19.3212 18.0317 16.9922 18.0317C14.6632 18.0317 12.7751 19.9647 12.7751 22.3492C12.7751 24.7337 14.6632 26.6667 16.9922 26.6667Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M17.2403 10.8343V21.6737C17.2379 22.0503 17.0149 22.3887 16.6747 22.5321C16.5664 22.579 16.45 22.6032 16.3324 22.6032H12.7802C12.7752 22.5168 12.7752 22.4356 12.7752 22.3492C12.7736 22.2644 12.7769 22.1796 12.7851 22.0953C12.8759 20.4716 13.8529 19.0391 15.3104 18.3924V17.4476C12.0667 16.9214 9.85383 13.8026 10.3679 10.4817C10.3714 10.4587 10.3751 10.4357 10.3789 10.4127C10.4036 10.2414 10.4384 10.0718 10.4831 9.90479H16.3324C16.833 9.90674 17.2384 10.3218 17.2403 10.8343Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M15.8362 10.4126H10.3788C9.82749 13.7276 12.0054 16.8724 15.2432 17.4368C15.3413 17.4539 15.4397 17.4685 15.5385 17.4805C14.0005 18.2272 12.8797 20.3478 12.7845 22.0951C12.7762 22.1795 12.7729 22.2643 12.7746 22.3491C12.7746 22.4355 12.7746 22.5167 12.7795 22.6031C12.7885 22.7738 12.81 22.9436 12.844 23.111H15.8356C16.2035 23.1085 16.534 22.8802 16.6741 22.532C16.7199 22.4211 16.7435 22.3019 16.7435 22.1815V11.3421C16.7417 10.8298 16.3366 10.4148 15.8362 10.4126Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M15.8364 10.4126H10.379C9.8278 13.7279 12.006 16.8729 15.2442 17.4372C15.3104 17.4487 15.3768 17.4591 15.4434 17.4684C13.9551 18.2689 12.8785 20.3844 12.7852 22.0951H15.8364C16.3362 22.0913 16.7405 21.6774 16.7443 21.1656V11.3421C16.7424 10.8296 16.337 10.4145 15.8364 10.4126Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M15.3401 10.4126H10.3788C9.85836 13.5422 11.7738 16.5561 14.7794 17.3368C13.6414 18.668 12.9433 20.3335 12.785 22.0951H15.3401C15.8407 22.0932 16.2461 21.6782 16.248 21.1656V11.3421C16.2477 10.8289 15.8414 10.4129 15.3401 10.4126Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.24265 10.4126H15.3386C15.8408 10.4126 16.248 10.8294 16.248 11.3436V20.6561C16.248 21.1704 15.8408 21.5872 15.3386 21.5872H6.24265C5.7404 21.5872 5.33325 21.1704 5.33325 20.6561V11.3436C5.33325 10.8294 5.7404 10.4126 6.24265 10.4126Z",
        fill: "#026D71"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.39487 15.886C9.18175 15.7413 9.00374 15.5487 8.87443 15.3227C8.74914 15.0866 8.68669 14.8209 8.69334 14.5522C8.68218 14.1884 8.80208 13.8332 9.03021 13.5541C9.26993 13.2747 9.57979 13.0677 9.92621 12.9558C10.321 12.8227 10.7345 12.7572 11.1501 12.7617C11.6967 12.7413 12.2425 12.8195 12.7625 12.9928V14.1611C12.5366 14.021 12.2905 13.9181 12.0332 13.8563C11.7541 13.7863 11.4678 13.7511 11.1804 13.7517C10.8774 13.7403 10.5763 13.8056 10.3037 13.9417C10.0933 14.0346 9.95691 14.2465 9.95647 14.4811C9.95561 14.6234 10.009 14.7604 10.1053 14.8631C10.219 14.9841 10.3536 15.0826 10.5022 15.1536C10.6676 15.2379 10.9156 15.35 11.2464 15.4899C11.2828 15.5017 11.3183 15.5163 11.3526 15.5336C11.6781 15.6638 11.9921 15.8224 12.2912 16.0075C12.5177 16.1504 12.7078 16.3465 12.8459 16.5794C12.9874 16.8434 13.056 17.1419 13.0443 17.4429C13.0605 17.8163 12.9489 18.1839 12.7288 18.4821C12.5094 18.7563 12.2161 18.9584 11.8854 19.0632C11.4964 19.188 11.0904 19.2484 10.6828 19.242C10.3171 19.2437 9.9519 19.2131 9.59132 19.1506C9.28686 19.0996 8.98974 19.0102 8.70674 18.8844V17.6527C8.97726 17.8505 9.27948 17.9983 9.59976 18.0895C9.91896 18.1913 10.2508 18.2457 10.5851 18.251C10.8945 18.2711 11.2033 18.204 11.4781 18.057C11.6706 17.9458 11.7876 17.7351 11.7827 17.5089C11.784 17.3515 11.7232 17.2002 11.614 17.0894C11.4783 16.9529 11.3212 16.8408 11.1492 16.7577C10.9507 16.6561 10.6585 16.5222 10.2725 16.3559C9.96545 16.2295 9.67145 16.0721 9.39487 15.886Z",
        fill: "white"
    })));
};


const $85cf9dcc986f9ef7$var$getSharePointTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $2Znam.TypeFilterValueKey).Document, {
        entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: (0, $dh538.fg)('rovo_fps_enable_sharepoint_new_types_filter') ? [
            (0, $2Znam.NounSubtypeKey).Document,
            (0, $2Znam.NounSubtypeKey).Pdf,
            (0, $2Znam.NounSubtypeKey).Page,
            (0, $2Znam.NounSubtypeKey).Blogpost
        ] : [
            (0, $2Znam.NounSubtypeKey).Document,
            (0, $2Znam.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $2Znam.TypeFilterValueKey).Spreadsheet, {
        entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $2Znam.TypeFilterValueKey).Presentation, {
        entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Presentation
        ]
    });
    if ((0, $dh538.fg)('rovo_fps_sharepoint_enable_video_noun_filter')) config.set((0, $2Znam.TypeFilterValueKey).Video, {
        entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
        subTypes3P: [
            (0, $2Znam.NounSubtypeKey).Video
        ]
    });
    if ((0, $dh538.fg)('rovo_fps_enable_sharepoint_new_types_filter')) {
        config.set((0, $2Znam.TypeFilterValueKey).Image, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Image
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Folder, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Folder,
                (0, $2Znam.NounSubtypeKey).Drive
            ]
        });
        // Document -> video fallback (only when video noun filter is OFF)
        if (!(0, $dh538.fg)('rovo_fps_sharepoint_enable_video_noun_filter')) config.set((0, $2Znam.TypeFilterValueKey).Video, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Video
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Pdf, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Pdf
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Notebook, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Notebook
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).WebPage, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).WebPage,
                (0, $2Znam.NounSubtypeKey).Shortcut
            ]
        });
        config.set((0, $2Znam.TypeFilterValueKey).Other, {
            entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Other,
                (0, $2Znam.NounSubtypeKey).Archive
            ]
        });
    }
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats SharePoint comment matches as documents rather than standalone comments.
    // SharePoint embedded comments are gated behind a SharePoint-specific flag (independent of the
    // shared 3p flag used for Google Drive) so we can enable/disable SharePoint comment support
    // independently of other 3p products.
    if ((0, $dh538.fg)('rovo_fps_sharepoint_embedded_comments')) config.set((0, $2Znam.TypeFilterValueKey).Comment, {
        entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $85cf9dcc986f9ef7$export$eb46bb6c4f0e628c = {
    displayName: 'Microsoft SharePoint',
    id: 'sharepoint',
    resourceType: 'sharepoint-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $77d5e1f6fdebef0b$export$53d8bcde0f28cd56), 'Sharepoint', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $1a38defd9262901b$export$a0d18fc9cea4f40e), 'Sharepoint', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $200bd2d79addba31$export$65b9e0ddb04a51a1), 'Sharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    // Use a getter to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
    get typeFilterConfig () {
        return $85cf9dcc986f9ef7$var$getSharePointTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch'
        ];
        if ((0, $dh538.fg)('rovo_fps_enable_sharepoint_space_filter')) baseFilters.push('space');
        if ((0, $dh538.fg)('rovo_fps_enable_sharepoint_content_filter')) baseFilters.push('content');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};






var $8RFAN = parcelRequire("8RFAN");
















const $11de0cfb1be9779f$export$b33fb54b08bb6422 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.770528"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
        fill: "#ECB22E"
    })));
};





const $84ad4016fb4ab129$export$359ca796b415372 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.86632 0C4.98186 0.000652395 4.26606 0.716982 4.26671 1.59967C4.26606 2.48236 4.98251 3.19869 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0V0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78649e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46666H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9999 5.86634C16.0005 4.98365 15.2841 4.26732 14.3996 4.26667C13.5151 4.26732 12.7987 4.98365 12.7993 5.86634V7.46667H14.3996C15.2841 7.46601 16.0005 6.74968 15.9999 5.86634ZM11.7331 5.86634V1.59967C11.7338 0.717635 11.018 0.00130479 10.1335 0C9.24907 0.000652395 8.53261 0.716983 8.53327 1.59967V5.86634C8.53196 6.74903 9.24842 7.46536 10.1329 7.46667C11.0173 7.46601 11.7338 6.74968 11.7331 5.86634Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.133 15.9998C11.0174 15.9992 11.7339 15.2829 11.7333 14.4002C11.7339 13.5175 11.0174 12.8011 10.133 12.8005H8.53272V14.4002C8.53206 15.2822 9.24852 15.9985 10.133 15.9998ZM10.133 11.7325H14.3997C15.2842 11.7319 16.0006 11.0155 16 10.1328C16.0013 9.25014 15.2848 8.53381 14.4004 8.5325H10.1336C9.24917 8.53315 8.53272 9.24949 8.53337 10.1322C8.53272 11.0155 9.24852 11.7319 10.133 11.7325Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.000122517 10.1334C-0.000531185 11.0161 0.715927 11.7325 1.60039 11.7331C2.48485 11.7325 3.2013 11.0161 3.20065 10.1334V8.53375H1.60039C0.715927 8.5344 -0.000531185 9.25074 0.000122517 10.1334ZM4.26684 10.1334V14.4001C4.26553 15.2828 4.98199 15.9991 5.86645 16.0004C6.75091 15.9998 7.46737 15.2835 7.46672 14.4008V10.1347C7.46802 9.25204 6.75156 8.53571 5.86711 8.5344C4.98199 8.5344 4.26619 9.25074 4.26684 10.1334C4.26684 10.1341 4.26684 10.1334 4.26684 10.1334Z",
        fill: "#E01E5A"
    }));





const $6921c71c4bb6686b$export$9e3ecebaf98513b9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.513685 8C0.513685 3.86542 3.86542 0.513685 8 0.513685H24C28.1346 0.513685 31.4863 3.86542 31.4863 8V24C31.4863 28.1346 28.1346 31.4863 24 31.4863H8C3.86542 31.4863 0.513685 28.1346 0.513685 24V8Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.02737"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.6616 18.5983C10.6616 19.7479 9.7325 20.677 8.58289 20.677C7.43328 20.677 6.50415 19.7479 6.50415 18.5983C6.50415 17.4487 7.43328 16.5195 8.58289 16.5195H10.6616V18.5983ZM11.701 18.5983C11.701 17.4487 12.6301 16.5195 13.7797 16.5195C14.9293 16.5195 15.8585 17.4487 15.8585 18.5983V23.7951C15.8585 24.9447 14.9293 25.8739 13.7797 25.8739C12.6301 25.8739 11.701 24.9447 11.701 23.7951V18.5983Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.7796 10.2517C12.63 10.2517 11.7009 9.32258 11.7009 8.17298C11.7009 7.02337 12.63 6.09424 13.7796 6.09424C14.9292 6.09424 15.8584 7.02337 15.8584 8.17298V10.2517H13.7796ZM13.7796 11.3068C14.9292 11.3068 15.8584 12.236 15.8584 13.3856C15.8584 14.5352 14.9292 15.4643 13.7796 15.4643H8.56702C7.41742 15.4643 6.48828 14.5352 6.48828 13.3856C6.48828 12.236 7.41742 11.3068 8.56702 11.3068H13.7796Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.1104 13.3856C22.1104 12.236 23.0396 11.3068 24.1892 11.3068C25.3388 11.3068 26.2679 12.236 26.2679 13.3856C26.2679 14.5352 25.3388 15.4643 24.1892 15.4643H22.1104V13.3856ZM21.0711 13.3856C21.0711 14.5352 20.1419 15.4643 18.9923 15.4643C17.8427 15.4643 16.9136 14.5352 16.9136 13.3856V8.17298C16.9136 7.02337 17.8427 6.09424 18.9923 6.09424C20.1419 6.09424 21.0711 7.02337 21.0711 8.17298V13.3856Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.9923 21.7164C20.1419 21.7164 21.0711 22.6455 21.0711 23.7951C21.0711 24.9447 20.1419 25.8739 18.9923 25.8739C17.8427 25.8739 16.9136 24.9447 16.9136 23.7951V21.7164H18.9923ZM18.9923 20.677C17.8427 20.677 16.9136 19.7479 16.9136 18.5983C16.9136 17.4487 17.8427 16.5195 18.9923 16.5195H24.2049C25.3545 16.5195 26.2837 17.4487 26.2837 18.5983C26.2837 19.7479 25.3545 20.677 24.2049 20.677H18.9923Z",
        fill: "#ECB22E"
    })));
};


const $d0d3a158a2299a2c$var$getSlackTypeFilterConfig = ()=>{
    const typeFilter = new Map();
    // Always include Message
    typeFilter.set((0, $2Znam.TypeFilterValueKey).Message, {
        entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    // Include Conversation (when federated search is disabled OR slack channel search is enabled)
    if (!(0, $8RFAN.serveFederatedSlackExperiment)() || (0, $dh538.fg)('ai_3p_slack_channel_search_enabled')) typeFilter.set((0, $2Znam.TypeFilterValueKey).Conversation, {
        entities3P: (0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
        subTypes3P: []
    });
    return typeFilter;
};
const $d0d3a158a2299a2c$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: 'slack-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $11de0cfb1be9779f$export$b33fb54b08bb6422), 'Slack', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $84ad4016fb4ab129$export$359ca796b415372), 'Slack', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $6921c71c4bb6686b$export$9e3ecebaf98513b9), 'Slack', 'large'),
    integrationAri: 'ari:cloud:platform::integration/slack',
    get typeFilterConfig () {
        return $d0d3a158a2299a2c$var$getSlackTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'slackChannel'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

















const $5e10fcbb718a2514$export$dd0ad7bd8a5794f4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.2708 12.9524C12.0781 12.5707 11.8938 12.2011 11.6762 11.8499C11.4003 11.4042 11.1009 10.9773 10.6919 10.6414C10.3847 10.3891 10.0444 10.2293 9.63382 10.2899C9.27961 10.3422 8.99393 10.5287 8.73676 10.7652C8.60099 10.8901 8.47697 11.0271 8.36318 11.1923C8.42475 11.2006 8.47588 11.2054 8.52636 11.2146C8.8921 11.2813 9.17343 11.4943 9.4269 11.7487C9.85292 12.1767 10.1699 12.6838 10.4539 13.2121C11.0905 14.3964 11.5574 15.6505 11.9569 16.9316C11.9608 16.944 11.9643 16.9564 11.9732 16.9859C13.5754 13.1534 15.383 9.45358 17.8734 6.12915L17.9021 6.13874C17.9021 6.22486 17.9021 6.31098 17.9021 6.39688C17.9021 9.19064 17.9052 11.9844 17.9002 14.7784C17.8986 15.6202 17.8858 16.4624 17.8233 17.3027C17.8027 17.5811 17.7742 17.8593 17.6754 18.1242C17.5601 18.4333 17.3395 18.5127 17.0594 18.338C16.8218 18.1898 16.6373 17.9825 16.4822 17.754C16.1504 17.2654 15.831 16.7687 15.6093 16.2167C15.5952 16.1814 15.5917 16.1009 15.5142 16.1761C15.009 16.6673 14.4222 17.0471 13.8187 17.4003C12.0839 18.4152 10.2293 19.1317 8.28355 19.6187C7.58535 19.7934 6.88193 19.9416 6.1735 20.0672C6.10497 20.0794 6.08734 20.0753 6.10192 19.997C6.19656 19.4857 6.23986 18.9697 6.23986 18.449C6.23856 14.0349 6.23964 9.6208 6.23638 5.20669C6.23638 5.09615 6.26314 5.07239 6.37128 5.07239C10.1708 5.07544 13.9701 5.075 17.7696 5.075H17.9017C15.5708 7.38279 13.6026 9.93061 12.2715 12.9526L12.2708 12.9524Z",
        fill: "white"
    }));
};





const $6fa817de366fe86e$export$3b8c4380ae1ed96d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.3609 17.2699C16.1039 16.7609 15.8582 16.2682 15.5681 15.7998C15.2003 15.2056 14.8011 14.6365 14.2557 14.1885C13.8461 13.8522 13.3923 13.6391 12.8449 13.7199C12.3726 13.7897 11.9917 14.0382 11.6488 14.3536C11.4678 14.5202 11.3025 14.7027 11.1507 14.9231C11.2328 14.9341 11.301 14.9405 11.3683 14.9527C11.856 15.0417 12.2311 15.3257 12.569 15.665C13.1371 16.2356 13.5597 16.9118 13.9383 17.6161C14.7871 19.1952 15.4097 20.8673 15.9423 22.5754C15.9476 22.592 15.9522 22.6086 15.9641 22.6478C18.1004 17.5379 20.5105 12.6048 23.831 8.1722L23.8693 8.18499C23.8693 8.29981 23.8693 8.41464 23.8693 8.52918C23.8693 12.2542 23.8734 15.9792 23.8667 19.7045C23.8647 20.8269 23.8476 21.9499 23.7643 23.0702C23.7367 23.4414 23.6987 23.8124 23.567 24.1656C23.4133 24.5778 23.1191 24.6836 22.7458 24.4507C22.429 24.2531 22.183 23.9766 21.9761 23.6719C21.5337 23.0205 21.1079 22.3583 20.8122 21.6222C20.7934 21.5751 20.7887 21.4679 20.6855 21.5682C20.0119 22.2231 19.2295 22.7295 18.4247 23.2004C16.1117 24.5536 13.6389 25.5089 11.0446 26.1583C10.1136 26.3911 9.17574 26.5888 8.23117 26.7563C8.13979 26.7725 8.11629 26.767 8.13573 26.6627C8.26192 25.981 8.31965 25.2929 8.31965 24.5987C8.31791 18.7132 8.31936 12.8277 8.31501 6.94225C8.31501 6.79487 8.35069 6.76318 8.49487 6.76318C13.5609 6.76725 18.6266 6.76667 23.6926 6.76667H23.8687C20.7609 9.84371 18.1366 13.2408 16.3618 17.2702L16.3609 17.2699Z",
        fill: "white"
    }));
};


const $a489cce30842ec41$export$aad10bcf647ef696 = {
    displayName: 'Smartsheet',
    id: 'smartsheet',
    resourceType: 'smartsheet-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $5e10fcbb718a2514$export$dd0ad7bd8a5794f4), 'Smartsheet', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $6fa817de366fe86e$export$3b8c4380ae1ed96d), 'Smartsheet', 'large'),
    integrationAri: 'ari:cloud:platform::integration/smartsheet',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $ec2be8ec238b2ddb$export$86ab8f6f2448222e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#635BFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.0639 9.32966C11.0639 8.76566 11.5259 8.54366 12.2939 8.54366C13.3979 8.54366 14.7899 8.87966 15.8939 9.47366V6.06566C14.6879 5.58566 13.4999 5.39966 12.2999 5.39966C9.35395 5.39966 7.39795 6.93566 7.39795 9.50366C7.39795 13.5057 12.9119 12.8697 12.9119 14.5977C12.9119 15.2637 12.3299 15.4797 11.5199 15.4797C10.3139 15.4797 8.77795 14.9877 7.55995 14.3217V17.7717C8.90995 18.3537 10.2719 18.5997 11.5199 18.5997C14.5379 18.5997 16.6139 17.1057 16.6139 14.5077C16.5899 10.1877 11.0639 10.9557 11.0639 9.32966Z",
        fill: "white"
    }));
};





const $4814a0e19522a55b$export$efbbc3acb0731d93 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#635BFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.752 12.4395C14.752 11.6875 15.368 11.3915 16.392 11.3915C17.864 11.3915 19.72 11.8395 21.192 12.6315V8.08746C19.584 7.44746 18 7.19946 16.4 7.19946C12.472 7.19946 9.86401 9.24746 9.86401 12.6715C9.86401 18.0075 17.216 17.1595 17.216 19.4635C17.216 20.3515 16.44 20.6395 15.36 20.6395C13.752 20.6395 11.704 19.9835 10.08 19.0955V23.6955C11.88 24.4715 13.696 24.7995 15.36 24.7995C19.384 24.7995 22.152 22.8075 22.152 19.3435C22.12 13.5835 14.752 14.6075 14.752 12.4395Z",
        fill: "white"
    }));
};


const $2ad7cc2fc111e558$export$3be693d67bbce82 = {
    displayName: 'Stripe',
    id: 'stripe',
    resourceType: 'smartlinks-connector-stripe',
    icon: (0, $9yyKc.get3PLogo)((0, $ec2be8ec238b2ddb$export$86ab8f6f2448222e), 'Stripe', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $4814a0e19522a55b$export$efbbc3acb0731d93), 'Stripe', 'large'),
    integrationAri: 'ari:cloud:platform::integration/stripe',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Invoice,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Invoice
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
























var $1RDRl = parcelRequire("1RDRl");




const $a708d9d961342b04$export$1b2996b1dd1cd142 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.7652 4.97366H13.3814C13.7231 4.97366 14 5.25572 14 5.60366V8.95822C14 10.237 12.9821 11.2736 11.7265 11.2736H11.7157C10.4601 11.2738 9.44208 10.2373 9.44189 8.95855C9.44189 8.95844 9.44189 8.95833 9.44189 8.95821V5.30292C9.4419 5.12108 9.58665 4.97366 9.7652 4.97366Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.2091 4.31048C13.0183 4.31048 13.6742 3.64245 13.6742 2.81839C13.6742 1.99433 13.0183 1.32629 12.2091 1.32629C11.4 1.32629 10.744 1.99433 10.744 2.81839C10.744 3.64245 11.4 4.31048 12.2091 4.31048Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.65112 4.3105C8.8199 4.3105 9.76739 3.34556 9.76739 2.15525C9.76739 0.964938 8.8199 0 7.65112 0C6.48234 0 5.53485 0.964938 5.53485 2.15525C5.53485 3.34556 6.48234 4.3105 7.65112 4.3105Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.473 4.97366H4.5038C4.16623 4.98217 3.89919 5.26748 3.90702 5.61129V9.43735C3.85988 11.5005 5.46262 13.2126 7.48839 13.2631C9.51417 13.2126 11.1169 11.5005 11.0698 9.43735V5.61129C11.0776 5.26748 10.8106 4.98217 10.473 4.97366Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M7.81386 4.97366V10.3353C7.81224 10.5811 7.66594 10.802 7.4427 10.8956C7.37162 10.9262 7.29523 10.942 7.21805 10.942H4.19342C4.1511 10.8326 4.11203 10.7232 4.07947 10.6105C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.81386Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.48829 4.97366V10.6668C7.48827 10.7454 7.47277 10.8232 7.4427 10.8956C7.35078 11.123 7.1339 11.272 6.89248 11.2736H4.34644C4.29109 11.1642 4.239 11.0548 4.19342 10.942C4.14784 10.8293 4.11203 10.7232 4.07947 10.6105C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.48829Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.48828 4.97366V10.0037C7.4858 10.3378 7.2205 10.6079 6.89247 10.6105H4.07947C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.48828Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.1627 4.97366V10.0037C7.16021 10.3378 6.89491 10.6079 6.56689 10.6105H4.07947C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.1627Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M7.81402 3.25928V4.30374C7.75867 4.30706 7.70658 4.31038 7.65123 4.31038C7.59588 4.31038 7.54379 4.30706 7.48844 4.30374C7.37854 4.29631 7.26955 4.27856 7.16286 4.25069C6.50356 4.09168 5.95887 3.62079 5.69775 2.98407C5.65282 2.87715 5.61794 2.76612 5.59357 2.6525H7.21821C7.54675 2.65376 7.81277 2.92468 7.81402 3.25928Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.48819 3.59097V4.30386C7.3783 4.29644 7.2693 4.27868 7.16262 4.25081C6.50331 4.0918 5.95863 3.62091 5.69751 2.98419H6.89238C7.22092 2.98546 7.48694 3.25638 7.48819 3.59097Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.48819 3.59097V4.30386C7.3783 4.29644 7.2693 4.27868 7.16262 4.25081C6.50331 4.0918 5.95863 3.62091 5.69751 2.98419H6.89238C7.22092 2.98546 7.48694 3.25638 7.48819 3.59097Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.16262 3.59098V4.25081C6.50332 4.0918 5.95863 3.62091 5.69751 2.98419H6.56681C6.89535 2.98546 7.16137 3.25639 7.16262 3.59098Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.596783 2.98419H6.56595C6.89555 2.98419 7.16273 3.25631 7.16273 3.59197V9.67109C7.16273 10.0068 6.89554 10.2789 6.56595 10.2789H0.596783C0.267186 10.2789 0 10.0068 0 9.67109V3.59197C0 3.25631 0.267193 2.98419 0.596783 2.98419Z",
        fill: "url(#paint0_linear_2230_19259)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.15193 5.29794H3.95868V8.60707H3.19846V5.29794H2.01074V4.65601H5.15193V5.29794Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_2230_19259",
        x1: "1.24431",
        y1: "2.50928",
        x2: "6.04757",
        y2: "10.6779",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#5A62C3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5",
        stopColor: "#4D55BD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#3940AB"
    }))));





const $bbff60bddcb94f62$export$fa291efbf00e84d3 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.2836 13.7715H24.4497C24.9377 13.7715 25.3334 14.1744 25.3334 14.6715V19.4637C25.3334 21.2905 23.8792 22.7714 22.0855 22.7714H22.0701C20.2764 22.7717 18.822 21.291 18.8218 19.4642C18.8218 19.464 18.8218 19.4639 18.8218 19.4637V14.2419C18.8218 13.9821 19.0286 13.7715 19.2836 13.7715Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.7749 12.8244C23.9308 12.8244 24.8679 11.8701 24.8679 10.6928C24.8679 9.51561 23.9308 8.56128 22.7749 8.56128C21.619 8.56128 20.6819 9.51561 20.6819 10.6928C20.6819 11.8701 21.619 12.8244 22.7749 12.8244Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.2635 12.8244C17.9332 12.8244 19.2867 11.4459 19.2867 9.74543C19.2867 8.04499 17.9332 6.6665 16.2635 6.6665C14.5938 6.6665 13.2402 8.04499 13.2402 9.74543C13.2402 11.4459 14.5938 12.8244 16.2635 12.8244Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.2947 13.7715H11.7673C11.2851 13.7836 10.9036 14.1912 10.9148 14.6824V20.1482C10.8474 23.0955 13.1371 25.5414 16.031 25.6135C18.925 25.5414 21.2146 23.0955 21.1473 20.1482V14.6824C21.1584 14.1912 20.777 13.7836 20.2947 13.7715Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M16.4959 13.7715V21.4309C16.4936 21.7821 16.2846 22.0977 15.9657 22.2314C15.8641 22.2752 15.755 22.2977 15.6448 22.2977H11.3239C11.2634 22.1414 11.2076 21.9851 11.1611 21.8241C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H16.4959Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M16.0308 13.7715V21.9046C16.0308 22.0169 16.0086 22.128 15.9657 22.2314C15.8344 22.5562 15.5245 22.7691 15.1796 22.7714H11.5425C11.4634 22.6151 11.389 22.4588 11.3239 22.2977C11.2587 22.1367 11.2076 21.9851 11.1611 21.8241C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H16.0308Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M16.0308 13.7715V20.9572C16.0272 21.4345 15.6482 21.8205 15.1796 21.8241H11.1611C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H16.0308Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M15.5657 13.7715V20.9572C15.5621 21.4345 15.1831 21.8205 14.7145 21.8241H11.1611C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H15.5657Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M16.4963 11.3226V12.8147C16.4172 12.8195 16.3428 12.8242 16.2637 12.8242C16.1847 12.8242 16.1102 12.8195 16.0312 12.8147C15.8742 12.8041 15.7185 12.7788 15.5661 12.7389C14.6242 12.5118 13.8461 11.8391 13.4731 10.9295C13.4089 10.7767 13.359 10.6181 13.3242 10.4558H15.6451C16.1145 10.4576 16.4945 10.8446 16.4963 11.3226Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M16.0308 11.7965V12.8149C15.8738 12.8043 15.7181 12.779 15.5657 12.7391C14.6238 12.512 13.8457 11.8393 13.4727 10.9297H15.1796C15.649 10.9315 16.029 11.3185 16.0308 11.7965Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M16.0308 11.7965V12.8149C15.8738 12.8043 15.7181 12.779 15.5657 12.7391C14.6238 12.512 13.8457 11.8393 13.4727 10.9297H15.1796C15.649 10.9315 16.029 11.3185 16.0308 11.7965Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M15.5657 11.7965V12.7391C14.6238 12.512 13.8457 11.8393 13.4727 10.9297H14.7145C15.1839 10.9315 15.5639 11.3185 15.5657 11.7965Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.1858 10.9297H14.7132C15.184 10.9297 15.5657 11.3184 15.5657 11.7979V20.4824C15.5657 20.9619 15.184 21.3507 14.7132 21.3507H6.1858C5.71495 21.3507 5.33325 20.9619 5.33325 20.4824V11.7979C5.33325 11.3184 5.71496 10.9297 6.1858 10.9297Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.693 14.2347H10.9883V18.962H9.9023V14.2347H8.20557V13.3176H12.693V14.2347Z",
        fill: "white"
    }));
};


const $1dbab2ec75609d68$var$getTeamsTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $2Znam.TypeFilterValueKey).Conversation, {
        entities3P: [
            ...(0, $fRYrB.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
            ...(0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: []
    });
    config.set((0, $2Znam.TypeFilterValueKey).Message, {
        entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $dh538.fg)('rovo_fps_enable_ms_teams_meeting_type_filter')) config.set((0, $2Znam.TypeFilterValueKey).Video, {
        entities3P: (0, $aVIh8.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $dh538.fg)('rovo_fps_enable_ms_teams_attachment_type_filter')) config.set((0, $2Znam.TypeFilterValueKey).Attachment, {
        entities3P: (0, $11scr.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $1dbab2ec75609d68$export$a579e078acf13bef = {
    displayName: 'Microsoft Teams',
    id: 'teams',
    resourceType: 'microsoft-teams-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $1RDRl.TeamsIcon), 'Teams', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $a708d9d961342b04$export$1b2996b1dd1cd142), 'Teams', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bbff60bddcb94f62$export$fa291efbf00e84d3), 'Teams', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    get typeFilterConfig () {
        return $1dbab2ec75609d68$var$getTeamsTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'hasAttachment'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $20ca8932c8f35f66$export$e5f255e151507cba = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#DE483A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.7653 5.01575H7.2667C6.03236 5.01575 5.03174 6.01638 5.03174 7.25072V16.7493C5.03174 17.9837 6.03236 18.9843 7.2667 18.9843H16.7653C17.9996 18.9843 19.0002 17.9837 19.0002 16.7493V7.25072C19.0002 6.01638 17.9996 5.01575 16.7653 5.01575Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.98402 11.5604L10.7664 9.9593L10.7699 9.95712L13.6369 8.30708C13.7578 8.23724 13.7635 8.02335 13.6282 7.94565L13.5334 7.89152C13.3951 7.81295 13.2161 7.7108 13.1397 7.66628C13.0728 7.62983 12.9976 7.61118 12.9214 7.61209C12.8452 7.61301 12.7705 7.63347 12.7045 7.67151C12.6368 7.7108 8.12065 10.3072 7.96961 10.3932C7.88062 10.4441 7.77988 10.4708 7.67737 10.4708C7.57485 10.4708 7.47412 10.4441 7.38512 10.3932L5 9.00726V10.1854L5.02444 10.1994C5.61985 10.5464 7.02892 11.3671 7.37377 11.5613C7.58286 11.6792 7.78278 11.6766 7.98402 11.5604Z",
        fill: "#DE483A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.98402 13.9142L10.7629 12.3148L10.7734 12.3087L13.6369 10.6608C13.7578 10.591 13.7635 10.3767 13.6282 10.2994L13.5334 10.2453C13.3955 10.1667 13.2161 10.0646 13.1397 10.02C13.0728 9.98359 12.9976 9.96494 12.9214 9.96585C12.8452 9.96677 12.7705 9.98723 12.7045 10.0253C12.6368 10.0641 8.12065 12.661 7.96961 12.7465C7.88062 12.7974 7.77988 12.8242 7.67737 12.8242C7.57485 12.8242 7.47412 12.7974 7.38512 12.7465C7.24282 12.6645 5 11.361 5 11.361V12.5387L5.02444 12.5531C5.62029 12.9002 7.02892 13.7204 7.37377 13.9151C7.58286 14.0329 7.78278 14.0303 7.98402 13.9142Z",
        fill: "#DE483A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.7668 14.6663L7.98402 16.2679C7.78279 16.384 7.58242 16.3866 7.37377 16.2688C7.02892 16.0741 5.62029 15.2539 5.02444 14.9069L5 14.8924V13.7147L7.38512 15.1002C7.5654 15.2046 7.7889 15.2032 7.96961 15.1002C8.12065 15.0147 12.6368 12.4178 12.7045 12.3785C12.7705 12.3405 12.8452 12.32 12.9214 12.3191C12.9976 12.3182 13.0728 12.3369 13.1397 12.3733C13.3022 12.4673 13.4652 12.5604 13.6286 12.6527C13.7639 12.7304 13.7578 12.9447 13.6369 13.0146L10.7668 14.6663Z",
        fill: "#DE483A"
    }));
};





const $51916241e8b21132$export$c7baa9df7dbe4b13 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "#DE483A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.3534 6.68774H9.68868C8.04291 6.68774 6.70874 8.02192 6.70874 9.6677V22.3325C6.70874 23.9783 8.04291 25.3125 9.68868 25.3125H22.3534C23.9992 25.3125 25.3334 23.9783 25.3334 22.3325V9.6677C25.3334 8.02192 23.9992 6.68774 22.3534 6.68774Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.6452 15.4139L14.355 13.2791L14.3596 13.2762L18.1824 11.0761C18.3436 10.983 18.3511 10.6978 18.1707 10.5942L18.0444 10.522C17.8599 10.4173 17.6213 10.2811 17.5194 10.2217C17.4302 10.1731 17.33 10.1482 17.2284 10.1495C17.1268 10.1507 17.0272 10.178 16.9392 10.2287C16.849 10.2811 10.8274 13.7429 10.626 13.8576C10.5073 13.9254 10.373 13.9611 10.2363 13.9611C10.0996 13.9611 9.96533 13.9254 9.84666 13.8576L6.6665 12.0097V13.5806L6.6991 13.5992C7.49297 14.0619 9.37173 15.1561 9.83153 15.4151C10.1103 15.5722 10.3769 15.5687 10.6452 15.4139Z",
        fill: "#DE483A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.6452 18.5522L14.3503 16.4197L14.3643 16.4116L18.1824 14.2144C18.3436 14.1213 18.3511 13.8355 18.1707 13.7325L18.0444 13.6603C17.8605 13.5556 17.6213 13.4194 17.5194 13.36C17.4302 13.3114 17.33 13.2865 17.2284 13.2878C17.1268 13.289 17.0272 13.3163 16.9392 13.367C16.849 13.4188 10.8274 16.8812 10.626 16.9953C10.5073 17.0632 10.373 17.0988 10.2363 17.0988C10.0996 17.0988 9.96533 17.0632 9.84666 16.9953C9.65692 16.8859 6.6665 15.148 6.6665 15.148V16.7183L6.6991 16.7375C7.49355 17.2002 9.37173 18.2938 9.83153 18.5534C10.1103 18.7105 10.3769 18.7071 10.6452 18.5522Z",
        fill: "#DE483A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.3556 19.5552L10.6452 21.6906C10.3769 21.8455 10.1097 21.8489 9.83153 21.6918C9.37174 21.4322 7.49356 20.3386 6.6991 19.8759L6.6665 19.8567V18.2864L9.84666 20.1337C10.087 20.2728 10.385 20.2711 10.626 20.1337C10.8274 20.0196 16.849 16.5572 16.9392 16.5048C17.0272 16.4541 17.1268 16.4268 17.2284 16.4256C17.33 16.4244 17.4302 16.4492 17.5194 16.4978C17.7361 16.6231 17.9534 16.7473 18.1713 16.8703C18.3517 16.9739 18.3436 17.2597 18.1824 17.3528L14.3556 19.5552Z",
        fill: "#DE483A"
    }));
};


const $e5dc71fed4aef9e5$export$2ece5664272d405b = {
    displayName: 'Todoist',
    id: 'todoist',
    resourceType: 'smartlinks-connector-todoist',
    icon: (0, $9yyKc.get3PLogo)((0, $20ca8932c8f35f66$export$e5f255e151507cba), 'Todoist', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $51916241e8b21132$export$c7baa9df7dbe4b13), 'Todoist', 'large'),
    integrationAri: 'ari:cloud:platform::integration/todoist',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};














const $756b739c78aa76b5$export$4079343fb47e7f0d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "mask0_719_13847",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "6",
        width: "18",
        height: "13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.5 6.177H3.5V18.551H20.5V6.177Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        mask: "url(#mask0_719_13847)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.77473 18.5019C5.62694 18.5019 4.55554 14.5209 4.31548 13.7465C3.71261 11.8018 3.52935 10.05 3.50994 9.86618C3.39799 8.80539 4.24877 8.06718 5.18252 8.06718C5.8895 8.06718 6.71005 8.49041 6.81877 9.51726C6.83761 9.68995 6.98136 11.1795 7.48984 12.8026C8.02049 14.4964 8.58341 15.1479 8.98879 15.1479C9.64347 15.1479 10.0429 13.4664 10.396 11.8653C10.6562 10.6857 10.9374 9.49712 11.4926 8.44128C12.4585 6.60445 13.9181 6.177 15.1791 6.177C17.944 6.177 19.3278 9.38049 19.3278 10.2105C19.3278 11.5975 18.1965 11.9513 17.7062 11.9513C16.6338 11.9513 16.2703 11.2327 15.9643 10.6029C15.689 10.0363 15.4016 9.56515 15.0299 9.56515C14.9078 9.56515 14.7946 9.62698 14.69 9.73341C13.7662 10.6723 13.4565 15.584 11.6095 17.4612C10.5856 18.5019 9.47152 18.5019 8.77473 18.5019Z",
        fill: "#00BBFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.8181 8.06718C18.6934 8.06718 18.5681 8.07894 18.4451 8.1032C19.0296 8.94596 19.3221 9.82891 19.3221 10.2104C19.3221 11.5975 18.1907 11.9512 17.7004 11.9512C17.3178 11.9512 17.0254 11.8597 16.7937 11.7134C16.7916 11.7221 16.7895 11.7307 16.7873 11.7394C16.7184 12.0147 16.664 12.3159 16.5698 12.6092C16.3888 13.1729 16.1446 13.8168 15.8839 14.3151C15.6028 14.8523 15.3246 15.1666 14.9929 15.1501C14.6157 15.1314 14.3099 14.6452 13.9298 13.2711C13.8072 12.8281 13.6937 12.3423 13.5885 11.8653C13.3276 10.6822 13.0074 9.49254 12.4598 8.44128C11.5653 6.72426 10.0396 6.177 8.82156 6.177C7.69192 6.177 6.84795 6.71182 6.18495 7.3857C6.00175 7.57192 5.80158 7.82283 5.60059 8.11766C6.17886 8.25694 6.72565 8.69224 6.81293 9.51716C6.83015 9.67444 6.95085 10.9237 7.35628 12.3714C7.4726 12.0084 7.64222 11.4709 8.03625 10.6029C8.22939 10.2054 8.40369 9.94325 8.56092 9.78348C8.70514 9.63686 8.83499 9.57634 8.95193 9.57634C9.07804 9.57634 9.50861 9.69177 9.92778 11.1628C10.4477 12.9869 10.8346 15.8898 12.3086 17.4312C12.9587 18.1111 13.8685 18.551 15.1294 18.551C16.2358 18.551 17.1582 18.0637 17.8159 17.3859C18.8973 16.2712 19.4898 14.4284 19.7011 13.7465C20.3026 11.8064 20.4711 10.0518 20.4907 9.86618C20.6026 8.80539 19.709 8.06718 18.8181 8.06718Z",
        fill: "#316AFF"
    })));
};





const $8e0d7d0baf335a4d$export$92866e6fe777cbf9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "mask0_2004_10796",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "2",
        width: "16",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16 2H0V13.6461H16V2Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        mask: "url(#mask0_2004_10796)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.96446 13.5999C2.00182 13.5999 0.993451 9.85312 0.767509 9.12424C0.200106 7.29392 0.0276198 5.64517 0.00935866 5.47216C-0.0960054 4.47378 0.704727 3.77899 1.58355 3.77899C2.24894 3.77899 3.02122 4.17733 3.12355 5.14378C3.14128 5.3063 3.27657 6.70827 3.75514 8.23583C4.25458 9.83005 4.78439 10.4432 5.16592 10.4432C5.78209 10.4432 6.15799 8.86061 6.49035 7.35373C6.73522 6.24351 6.99988 5.12482 7.52243 4.13109C8.43152 2.4023 9.80527 2 10.9921 2C13.5944 2 14.8968 5.01505 14.8968 5.79624C14.8968 7.10166 13.832 7.43465 13.3706 7.43465C12.3612 7.43465 12.0191 6.75833 11.7311 6.16553C11.472 5.63224 11.2015 5.18884 10.8517 5.18884C10.7368 5.18884 10.6303 5.24703 10.5318 5.34721C9.66234 6.23082 9.37084 10.8536 7.6325 12.6205C6.6688 13.5999 5.62025 13.5999 4.96446 13.5999Z",
        fill: "#00BBFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.4171 3.77905C14.2997 3.77905 14.1817 3.79012 14.066 3.81295C14.6161 4.60614 14.8914 5.43715 14.8914 5.7962C14.8914 7.10167 13.8266 7.43461 13.3651 7.43461C13.005 7.43461 12.7299 7.3485 12.5118 7.2108C12.5097 7.21899 12.5078 7.22707 12.5057 7.23525C12.4409 7.49432 12.3897 7.77789 12.3011 8.05386C12.1307 8.58441 11.9009 9.19048 11.6555 9.65945C11.3909 10.1651 11.129 10.4609 10.8169 10.4453C10.4619 10.4277 10.174 9.97011 9.81631 8.67684C9.70095 8.25989 9.59412 7.80268 9.49512 7.35379C9.24957 6.24029 8.94812 5.12057 8.43277 4.13115C7.59093 2.51513 6.15497 2.00006 5.00856 2.00006C3.94536 2.00006 3.15104 2.50342 2.52704 3.13766C2.35462 3.31292 2.16623 3.54907 1.97705 3.82657C2.52131 3.95765 3.03593 4.36735 3.11808 5.14374C3.13429 5.29177 3.24788 6.46753 3.62947 7.83006C3.73895 7.48844 3.89859 6.98254 4.26944 6.16559C4.45122 5.7915 4.61527 5.54477 4.76325 5.39439C4.89898 5.2564 5.02119 5.19943 5.13126 5.19943C5.24995 5.19943 5.65519 5.30808 6.04971 6.69256C6.539 8.40934 6.90315 11.1416 8.29047 12.5922C8.90232 13.2321 9.75861 13.6461 10.9454 13.6461C11.9867 13.6461 12.8548 13.1875 13.4738 12.5496C14.4916 11.5005 15.0492 9.76609 15.2482 9.12431C15.8142 7.29834 15.9728 5.64695 15.9913 5.47223C16.0966 4.47384 15.2555 3.77905 14.4171 3.77905Z",
        fill: "#316AFF"
    })));





const $dfa5ceb7e6facbec$export$37506c98e5c4eabb = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.508324",
        y: "0.508324",
        width: "30.9834",
        height: "30.9834",
        rx: "7.49168",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.01665"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "mask0_719_13847",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "4",
        y: "8",
        width: "24",
        height: "17"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M27.3332 8.23584H4.6665V24.7345H27.3332V8.23584Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        mask: "url(#mask0_719_13847)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.6995 24.6691C7.50242 24.6691 6.07389 19.3611 5.75381 18.3285C4.94999 15.7356 4.70563 13.3998 4.67976 13.1547C4.5305 11.7404 5.66487 10.7561 6.90986 10.7561C7.85251 10.7561 8.94657 11.3204 9.09153 12.6895C9.11665 12.9198 9.30832 14.9059 9.98629 17.0699C10.6938 19.3284 11.4444 20.197 11.9849 20.197C12.8578 20.197 13.3903 17.955 13.8612 15.8203C14.2081 14.2475 14.583 12.6627 15.3233 11.2549C16.6112 8.80577 18.5573 8.23584 20.2386 8.23584C23.9252 8.23584 25.7703 12.5072 25.7703 13.6138C25.7703 15.4632 24.2619 15.9349 23.6081 15.9349C22.1783 15.9349 21.6936 14.9768 21.2855 14.137C20.9186 13.3815 20.5353 12.7534 20.0398 12.7534C19.877 12.7534 19.726 12.8358 19.5865 12.9777C18.3548 14.2295 17.9419 20.7785 15.4792 23.2815C14.114 24.6691 12.6285 24.6691 11.6995 24.6691Z",
        fill: "#00BBFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M25.0906 10.7561C24.9244 10.7561 24.7573 10.7718 24.5934 10.8041C25.3726 11.9278 25.7626 13.1051 25.7626 13.6137C25.7626 15.4631 24.2542 15.9348 23.6004 15.9348C23.0902 15.9348 22.7004 15.8128 22.3915 15.6177C22.3886 15.6293 22.3858 15.6408 22.3829 15.6524C22.291 16.0194 22.2185 16.4211 22.093 16.8121C21.8516 17.5637 21.526 18.4223 21.1784 19.0866C20.8036 19.8029 20.4326 20.222 19.9904 20.2C19.4874 20.175 19.0797 19.5267 18.5729 17.6946C18.4095 17.1039 18.2581 16.4562 18.1179 15.8203C17.77 14.2428 17.343 12.6566 16.6129 11.2549C15.4203 8.96551 13.386 8.23584 11.7619 8.23584C10.2557 8.23584 9.13044 8.94893 8.24644 9.84744C8.00217 10.0957 7.73528 10.4303 7.46729 10.8234C8.23832 11.0091 8.96737 11.5895 9.08374 12.6894C9.10671 12.8991 9.26763 14.5647 9.80821 16.495C9.9633 16.0111 10.1895 15.2944 10.7148 14.137C10.9724 13.607 11.2048 13.2575 11.4144 13.0445C11.6067 12.849 11.7798 12.7683 11.9358 12.7683C12.1039 12.7683 12.678 12.9222 13.2369 14.8835C13.9301 17.3157 14.4459 21.1863 16.4113 23.2414C17.2781 24.1479 18.4912 24.7345 20.1724 24.7345C21.6476 24.7345 22.8775 24.0847 23.7544 23.181C25.1962 21.6948 25.9862 19.2377 26.268 18.3285C27.0699 15.7417 27.2946 13.4023 27.3207 13.1547C27.4699 11.7404 26.2784 10.7561 25.0906 10.7561Z",
        fill: "#316AFF"
    })));
};


const $a861cf12095eaed4$export$57d2eef9725d4993 = {
    displayName: 'Webex',
    id: 'webex',
    resourceType: 'smartlinks-connector-webex',
    icon: (0, $9yyKc.get3PLogo)((0, $756b739c78aa76b5$export$4079343fb47e7f0d), 'Webex', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $8e0d7d0baf335a4d$export$92866e6fe777cbf9), 'Webex', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $dfa5ceb7e6facbec$export$37506c98e5c4eabb), 'Webex', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cisco',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};




















const $9743e3ee64230db8$export$9969d63eaadfddf7 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "#03363D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.6092 9.34881V17.3365H4.99316L11.6092 9.34881ZM11.6092 6.48242C11.6092 7.35976 11.2607 8.20117 10.6403 8.82155C10.0199 9.44192 9.17853 9.79044 8.30119 9.79044C7.42384 9.79044 6.58244 9.44192 5.96206 8.82155C5.34169 8.20117 4.99316 7.35976 4.99316 6.48242H11.6092ZM12.6991 17.3372C12.6991 16.4598 13.0477 15.6184 13.668 14.9981C14.2884 14.3777 15.1298 14.0292 16.0072 14.0292C16.8845 14.0292 17.7259 14.3777 18.3463 14.9981C18.9667 15.6184 19.3152 16.4598 19.3152 17.3372H12.6991ZM12.6991 14.4708V6.48242H19.3166L12.6991 14.4701V14.4708Z",
        fill: "white"
    }));
};





const $c00cbe8baf3d28b2$export$439dd6b525db0f9a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "8",
        fill: "#03363D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.4789 12.465V23.1153H6.65747L15.4789 12.465ZM15.4789 8.64319C15.4789 9.81298 15.0142 10.9349 14.187 11.762C13.3598 12.5892 12.238 13.0539 11.0682 13.0539C9.89838 13.0539 8.7765 12.5892 7.94933 11.762C7.12217 10.9349 6.65747 9.81298 6.65747 8.64319H15.4789ZM16.9321 23.1162C16.9321 21.9464 17.3968 20.8245 18.224 19.9974C19.0511 19.1702 20.173 18.7055 21.3428 18.7055C22.5126 18.7055 23.6345 19.1702 24.4616 19.9974C25.2888 20.8245 25.7535 21.9464 25.7535 23.1162H16.9321ZM16.9321 19.2943V8.64319H25.7554L16.9321 19.2934V19.2943Z",
        fill: "white"
    }));
};


const $dbe307790c376c63$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $9yyKc.get3PLogo)((0, $9743e3ee64230db8$export$9969d63eaadfddf7), 'Zendesk', 'medium'),
    resourceType: 'zendesk-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $c00cbe8baf3d28b2$export$439dd6b525db0f9a), 'Zendesk', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Ticket,
            {
                entities3P: (0, $dD8Tu.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Post,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Post
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Article,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Article
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $3ZVQ6.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};














const $98b84a63f383b652$export$81c909fcf490b72b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.770528"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
        fill: "#FDBD39"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
        fill: "#F69833"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
        fill: "#FECF33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
        fill: "#EE6723"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
        fill: "#F69833"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
        fill: "#FDBD39"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
        fill: "#EE6723"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
        fill: "#EE6723"
    }));
};





const $1f54589f7f1233b9$export$d013f8d99ccc63fb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.77432 9.58215L1.83263 9.91452L1.78223 12.6201L5.0417 11.4703C3.92361 11.1075 3.10732 10.4691 2.77432 9.58215Z",
        fill: "#FDBD39"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.26698 6.72028L0 7.87298L1.83299 9.91442L2.77438 9.58205C2.44228 8.69767 2.64688 7.69825 3.26698 6.72028Z",
        fill: "#F69833"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.76532 2.81617C4.60465 4.28414 1.92237 7.31341 2.77436 9.58231L17.8406 4.26618C16.9886 1.99727 12.9257 1.34819 8.76532 2.81617Z",
        fill: "#FECF33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.8499 11.0322C16.0103 9.56393 18.6973 6.54829 17.8408 4.26605L2.77405 9.58219C3.63084 11.8644 7.68921 12.5002 11.8499 11.0322Z",
        fill: "#EE6723"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.8408 4.26605L2.77405 9.58219C3.06895 10.368 4.19424 10.7552 5.77253 10.7552C7.31152 10.7552 9.2816 10.3875 11.3354 9.66274C15.4958 8.19476 18.4228 5.81777 17.8402 4.26605",
        fill: "#F69833"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.842 3.09308C13.3031 3.09308 11.333 3.4608 9.27918 4.18551C5.11881 5.65349 2.19173 8.03019 2.77433 9.5822L17.8405 4.26607C17.5456 3.48021 16.4206 3.09308 14.842 3.09308Z",
        fill: "#FDBD39"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.0099 12.7637C13.5665 12.7637 12.9128 12.3769 12.0659 11.6142C11.0648 10.7118 9.91765 9.39021 8.83585 7.89238C7.75436 6.39513 6.86547 4.89789 6.33327 3.6768C5.75368 2.34617 5.67088 1.52815 6.08757 1.24504C6.17907 1.18303 6.28917 1.15173 6.41517 1.15173C6.75417 1.15173 7.41476 1.39543 8.63606 2.55712L8.66306 2.58233L8.65916 2.61855C8.65076 2.70201 8.64326 2.78633 8.63636 2.86891L8.62286 3.03293L8.50286 2.91644C7.18677 1.63565 6.60747 1.49743 6.41937 1.49743C6.36567 1.49743 6.32307 1.50786 6.29247 1.52873C6.11157 1.6513 6.09987 2.25228 6.66207 3.54205C7.18497 4.74141 8.06066 6.21577 9.12805 7.69389C10.196 9.1723 11.3255 10.4745 12.3092 11.3606C13.3697 12.3163 13.8476 12.4195 14.0042 12.4195C14.0582 12.4195 14.1017 12.4085 14.1344 12.3861C14.3249 12.2569 14.3252 11.613 13.6982 10.2245L13.6694 10.161L13.7324 10.1277C13.7954 10.0943 13.8566 10.0616 13.9136 10.0303L13.9892 9.98887L14.024 10.0657C14.4683 11.0494 14.8838 12.2998 14.339 12.6698C14.2472 12.7321 14.1365 12.7637 14.0099 12.7637Z",
        fill: "#EE6723"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9507 10.9907L11.9447 11.0661C11.8394 12.3234 11.5622 13.8345 10.8401 13.896C10.8257 13.8971 10.8107 13.8977 10.7957 13.8977C10.3049 13.8977 9.84084 13.2188 9.41634 11.88C9.01434 10.6131 8.70235 8.91277 8.53825 7.09098C8.37385 5.27006 8.37625 3.54245 8.54515 2.22718C8.72905 0.793682 9.07944 0.0452042 9.58644 0.00202839C9.60144 0.000869312 9.61704 0 9.63234 0C9.98814 0 10.5245 0.389452 11.0735 2.20226L10.715 2.2689C10.5317 1.66328 10.3319 1.17067 10.1336 0.831642C9.95004 0.51869 9.77184 0.346276 9.63144 0.346276C9.62664 0.346276 9.62214 0.346276 9.61734 0.346856C9.39774 0.365401 9.07764 0.880323 8.89945 2.26977C8.73355 3.56157 8.73145 5.26311 8.89345 7.06084C9.05604 8.85887 9.36264 10.5343 9.75744 11.7783C9.93414 12.3352 10.1279 12.7945 10.3181 13.106C10.4933 13.3935 10.6628 13.5517 10.7954 13.5517C10.7999 13.5517 10.8044 13.5517 10.8092 13.5511C11.0192 13.5335 11.4155 12.9977 11.5823 11.1127L11.9507 10.9907Z",
        fill: "#EE6723"
    }));





const $f4f5211a6674d99c$export$e3736b5ffc9fcc9e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.513685 8C0.513685 3.86542 3.86542 0.513685 8 0.513685H24C28.1346 0.513685 31.4863 3.86542 31.4863 8V24C31.4863 28.1346 28.1346 31.4863 24 31.4863H8C3.86542 31.4863 0.513685 28.1346 0.513685 24V8Z",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.02737"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.69901 19.4429L6.44342 19.886L6.37622 23.4935L10.7222 21.9604C9.2314 21.4767 8.14301 20.6255 7.69901 19.4429Z",
        fill: "#FDBD39"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.35597 15.6271L4 17.164L6.44398 19.8859L7.69917 19.4428C7.25638 18.2636 7.52918 16.931 8.35597 15.6271Z",
        fill: "#F69833"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6872 10.4215C10.1396 12.3788 6.56324 16.4178 7.69923 19.443L27.7875 12.3549C26.6515 9.32966 21.2343 8.46421 15.6872 10.4215Z",
        fill: "#FECF33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7998 21.3764C25.347 19.4187 28.9298 15.3978 27.7878 12.3549L7.69873 19.443C8.84112 22.486 14.2523 23.3337 19.7998 21.3764Z",
        fill: "#EE6723"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.7878 12.3549L7.69873 19.443C8.09193 20.4908 9.59232 21.007 11.6967 21.007C13.7487 21.007 16.3755 20.5167 19.1138 19.5504C24.661 17.5931 28.5638 14.4238 27.787 12.3549",
        fill: "#F69833"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.7894 10.7908C21.7374 10.7908 19.1106 11.2811 16.3722 12.2474C10.8251 14.2047 6.92231 17.3736 7.6991 19.4429L27.7874 12.3548C27.3942 11.3069 25.8942 10.7908 23.7894 10.7908Z",
        fill: "#FDBD39"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.6798 23.685C22.0886 23.685 21.217 23.1692 20.0878 22.1523C18.753 20.9492 17.2234 19.187 15.7811 17.1899C14.3391 15.1936 13.1539 13.1973 12.4443 11.5691C11.6715 9.79497 11.5611 8.70428 12.1167 8.3268C12.2387 8.24412 12.3855 8.20239 12.5535 8.20239C13.0055 8.20239 13.8863 8.52732 15.5147 10.0762L15.5507 10.1099L15.5455 10.1582C15.5343 10.2694 15.5243 10.3819 15.5151 10.492L15.4971 10.7106L15.3371 10.5553C13.5823 8.84762 12.8099 8.66332 12.5591 8.66332C12.4875 8.66332 12.4307 8.67723 12.3899 8.70505C12.1487 8.86848 12.1331 9.66979 12.8827 11.3895C13.5799 12.9886 14.7475 14.9544 16.1707 16.9253C17.5946 18.8965 19.1006 20.6328 20.4122 21.8143C21.8262 23.0885 22.4634 23.226 22.6722 23.226C22.7442 23.226 22.8022 23.2114 22.8458 23.1816C23.0998 23.0093 23.1002 22.1508 22.2642 20.2994L22.2258 20.2147L22.3098 20.1703C22.3938 20.1259 22.4754 20.0822 22.5514 20.0405L22.6522 19.9852L22.6986 20.0876C23.291 21.3993 23.845 23.0665 23.1186 23.5599C22.9962 23.6429 22.8486 23.685 22.6798 23.685Z",
        fill: "#EE6723"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.9342 21.3212L19.9262 21.4216C19.7858 23.098 19.4162 25.1129 18.4534 25.1948C18.4342 25.1964 18.4142 25.1971 18.3942 25.1971C17.7398 25.1971 17.121 24.2919 16.555 22.5069C16.019 20.8177 15.603 18.5506 15.3842 16.1215C15.1651 13.6936 15.1683 11.3901 15.3934 9.63644C15.6386 7.72511 16.1058 6.72714 16.7818 6.66957C16.8018 6.66803 16.8226 6.66687 16.843 6.66687C17.3174 6.66687 18.0326 7.18614 18.7646 9.60321L18.2866 9.69208C18.0422 8.88458 17.7758 8.22777 17.5114 7.77573C17.2666 7.35846 17.029 7.12857 16.8418 7.12857C16.8354 7.12857 16.8294 7.12857 16.823 7.12934C16.5302 7.15407 16.1034 7.84063 15.8658 9.69324C15.6446 11.4156 15.6418 13.6843 15.8578 16.0813C16.0746 18.4787 16.4834 20.7126 17.0098 22.3713C17.2454 23.1139 17.5038 23.7263 17.7574 24.1416C17.991 24.5249 18.217 24.7358 18.3938 24.7358C18.3998 24.7358 18.4058 24.7358 18.4122 24.735C18.6922 24.7115 19.2206 23.9971 19.443 21.4838L19.9342 21.3212Z",
        fill: "#EE6723"
    }));
};


const $ceae4f087f7be6ed$export$d198c255b2b88327 = {
    displayName: 'Zeplin',
    id: 'zeplin',
    resourceType: 'smartlinks-connector-zeplin',
    icon: (0, $9yyKc.get3PLogo)((0, $98b84a63f383b652$export$81c909fcf490b72b), 'Zeplin', 'medium'),
    iconBorderless: (0, $9yyKc.get3PLogo)((0, $1f54589f7f1233b9$export$d013f8d99ccc63fb), 'Zeplin', 'small'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $f4f5211a6674d99c$export$e3736b5ffc9fcc9e), 'Zeplin', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zeplin',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $6aYi6.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};


const $4c19e47379f12858$export$f7937c5f282f2571 = new Map([
    [
        (0, $hdfeV.ProductKeys3P).AtlassianWebCrawler,
        (0, $9zZIW.atlassianWebCrawlerConfig)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Figma,
        (0, $ae51f698a2238858$export$e821d8af66e3adab)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Github,
        (0, $90d5c696e3fdd30c$export$71c63cb45707eee)
    ],
    [
        (0, $hdfeV.ProductKeys3P).GoogleDrive,
        (0, $6f79a547f5811124$export$6634ddcb22ed69a)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Sharepoint,
        (0, $85cf9dcc986f9ef7$export$eb46bb6c4f0e628c)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Loom,
        (0, $e9f18d11ddbc0577$export$9cb908560d4a0a78)
    ],
    [
        (0, $hdfeV.ProductKeys3P).OneDrive,
        (0, $2998c4f2928fc744$export$b3b3a7aaf94fe09)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Dropbox,
        (0, $736ae5964b52ab76$export$4a63cdb15a145936)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Slack,
        (0, $d0d3a158a2299a2c$export$c33894e475506863)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Teams,
        (0, $1dbab2ec75609d68$export$a579e078acf13bef)
    ],
    [
        (0, $hdfeV.ProductKeys3P).GoogleCalendar,
        (0, $d55193f0e88e1ac8$export$be326f2f9a08a3a4)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Gmail,
        (0, $6897f2334c0e7a05$export$c771ac380e225e02)
    ],
    [
        (0, $hdfeV.ProductKeys3P).OutlookCalendar,
        (0, $a54cb566eb58c8e6$export$3e5044818f2e9ef3)
    ],
    [
        (0, $hdfeV.ProductKeys3P).OutlookMail,
        (0, $b7918401159d3e2e$export$31104d47075e6dfd)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Asana,
        (0, $52e926522dd1141c$export$72c8845a87b8934e)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Zendesk,
        (0, $dbe307790c376c63$export$74a2db0a5eb2da3f)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Airtable,
        (0, $a840f57b79db2ae9$export$962b0679c5bd2c33)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Smartsheet,
        (0, $a489cce30842ec41$export$aad10bcf647ef696)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Notion,
        (0, $a642a047af5c5832$export$ddf7404f556e473a)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Miro,
        (0, $3a411c179a98e5e7$export$b11bada05d439596)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Docusign,
        (0, $8939dbaf0b2ff159$export$cee55280cabc1aa1)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Lucid,
        (0, $230e1285d2217578$export$3cac442956139a7e)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Monday,
        (0, $0a1292f152f9fefd$export$49283b8341865631)
    ],
    [
        (0, $hdfeV.ProductKeys3P).AzureDevops,
        (0, $952a8dcaa64c7f0f$export$f324080d91cfb196)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Gitlab,
        (0, $04e57759b6e32a8a$export$72758f81cc2e21e1)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ConfluenceDC,
        (0, $85a80012baeabd4e$export$3dab4b73b27a9d7e)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Canva,
        (0, $77752e716bcbf673$export$75e56657ffc0207b)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Box,
        (0, $f9ec6128a54edafb$export$3e7603f097ea326e)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Zeplin,
        (0, $ceae4f087f7be6ed$export$d198c255b2b88327)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ServiceNow,
        (0, $d3c7cad46ab257e1$export$d60233309c5c50ab)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Freshservice,
        (0, $4e05e26811c637e9$export$8120804698f632ae)
    ],
    [
        (0, $hdfeV.ProductKeys3P).PowerBI,
        (0, $221343bdf65748f1$export$b883b80d867cc715)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ClickUp,
        (0, $c046599e1123811b$export$7ef79ba9bf00ce19)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Amplitude,
        (0, $0fca80b1ee670a5c$export$a0702b571a9392d4)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Stripe,
        (0, $2ad7cc2fc111e558$export$3be693d67bbce82)
    ],
    [
        (0, $hdfeV.ProductKeys3P).AdobeXD,
        (0, $550d38c9b57936f7$export$e69f90b2aa757835)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Aha,
        (0, $f55ccfed6e002ce8$export$ad976bfe08240460)
    ],
    [
        (0, $hdfeV.ProductKeys3P).AdobeSign,
        (0, $66e851fe802529fd$export$8130889f372e8ca5)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Mural,
        (0, $91e418846a9395a7$export$8855f5ba0dd32fb9)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Webex,
        (0, $a861cf12095eaed4$export$57d2eef9725d4993)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Todoist,
        (0, $e5dc71fed4aef9e5$export$2ece5664272d405b)
    ],
    [
        (0, $hdfeV.ProductKeys3P).PagerDuty,
        (0, $b44f483df20185b6$export$cc8a555111f14137)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Pipedrive,
        (0, $fd9a483df954975f$export$9441b0ee1f92e710)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Hubspot,
        (0, $6501c29a91901a05$export$ba5f4c654d743419)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Dovetail,
        (0, $b03eb7cb3646ea18$export$74bb7abed969b4a3)
    ],
    [
        (0, $hdfeV.ProductKeys3P).LaunchDarkly,
        (0, $e4be4a4ef13ff8c3$export$e45ddd51efe4cb0c)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Salesforce,
        (0, $5ce640630a674ea4$export$68b7906270c63e2d)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Sentry,
        (0, $b1c1bb33fa733897$export$6c52693ff10aea16)
    ],
    [
        (0, $hdfeV.ProductKeys3P).JiraDC,
        (0, $266323abfb0e99be$export$7441620f71b01d27)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Gitbook,
        (0, $16fc7b862509cb0a$export$49c4b548f63d5a90)
    ],
    [
        (0, $hdfeV.ProductKeys3P).AWSS3,
        (0, $7c234a4c5938682d$export$7a257877f5f8c5de)
    ],
    [
        (0, $hdfeV.ProductKeys3P).Databricks,
        (0, $900640e2493d0e9d$export$a9b5a82aefd10fde)
    ],
    [
        (0, $hdfeV.ProductKeys3P).JsmDC,
        (0, $cf5bf5c6930cbca7$export$1bc88db204558364)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $d4918d535d8429c3$export$208b563484d68ba9)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $cd4d710ff220ed00$export$208b563484d68ba9)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $11a96c0845c60708$export$6bbd9bc3bcb111b9)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $e5b28c857fdf0c5c$export$6bbd9bc3bcb111b9)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioAwsDev,
        (0, $8574ba056db51465$export$7fa480c37589b20)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioAwsProd,
        (0, $fd66089ec0974887$export$7fa480c37589b20)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioClickupDev,
        (0, $7c05b0db3016cbad$export$1e9db6975f6a70ae)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioClickupProd,
        (0, $d75d90fb37537f14$export$1e9db6975f6a70ae)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGitbookDev,
        (0, $322696b3593a33f6$export$a10b5ae888bd2541)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGitbookProd,
        (0, $ab402eddd6e59c45$export$a10b5ae888bd2541)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGithubDev,
        (0, $8417fb119938ebc2$export$dd7854123286bd26)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGithubProd,
        (0, $94f61214f8fa15d6$export$dd7854123286bd26)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGitlabDev,
        (0, $f3ad305cda1b73d2$export$8d71df70076b5c6)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGitlabProd,
        (0, $95f44baa24f08dad$export$8d71df70076b5c6)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $73dff8b516e2691d$export$7b3aebc675da1806)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $a65de7a9e1b52c9e$export$7b3aebc675da1806)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGuruDev,
        (0, $4ed33cc7fc6a574f$export$528a99587bc9b40e)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioGuruProd,
        (0, $9a4ee06822418e28$export$528a99587bc9b40e)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $e4de17f58f86b9a7$export$a612366ee7742bc4)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $36175e0dbbb11525$export$a612366ee7742bc4)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioHubspotDev,
        (0, $ad617a1c23894f73$export$2bb44bd2479444f9)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioHubspotProd,
        (0, $36327b33f75a4db6$export$2bb44bd2479444f9)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioSalesforceDev,
        (0, $356b5f4444236554$export$6ab686f8808b6986)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioSalesforceProd,
        (0, $0bb2af70e93a0c27$export$6ab686f8808b6986)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioSharepointDev,
        (0, $f00421e2b7727ffe$export$a62192356b6384ff)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioSharepointProd,
        (0, $d63cf58af6ba600f$export$a62192356b6384ff)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $0210a041b2970961$export$cc9a98fbdf14b1ba)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $983d12c3230f9057$export$cc9a98fbdf14b1ba)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $26d56bdd5cac71a1$export$1c8bdcf28097f33d)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $51fb83881f35013e$export$1c8bdcf28097f33d)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $b2c9c6b294411a0f$export$c0c8ceeb88dd1e08)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $f0b9e0606494d0f5$export$a3dc73add88484a8)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $e7c488eb86051bc5$export$fa2bcc689ce846fa)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $acc22c66e1b86d64$export$fa2bcc689ce846fa)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $9820ecdaa7bfd1f0$export$da42ac6c929f2d1)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $87ba42c6e861e3ad$export$da42ac6c929f2d1)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $a3d2c49216bc55d4$export$b2bafc74c57288f3)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $ebe4c25a222bb830$export$b2bafc74c57288f3)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $6fe983ab4249955d$export$802c434914cc51cb)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $70465f2afd60f039$export$802c434914cc51cb)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $c4dfad9919f6c2ce$export$6cacedfbd2e2676a)
    ],
    [
        (0, $hdfeV.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $e362080c656f4431$export$6cacedfbd2e2676a)
    ]
]);
const $4c19e47379f12858$export$37755e2ec7a40bc1 = ()=>{
    return (0, $dh538.fg)('platform_search_3p_config_consolidation') ? (0, $a5RR2.ThirdPartyConfigsSync) : $4c19e47379f12858$export$f7937c5f282f2571;
};
module.exports["getThirdPartyConfigs"] = $4c19e47379f12858$export$37755e2ec7a40bc1;

});

parcelRegister("2Znam", function(module, exports) {
const $1bd00f711ef18555$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Ask: 'ask',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article'
};
const $1bd00f711ef18555$export$e01073b80ff953d5 = Object.values($1bd00f711ef18555$export$49f6cbb853d30562);
const $1bd00f711ef18555$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
module.exports["TypeFilterValueKey"] = $1bd00f711ef18555$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $1bd00f711ef18555$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $1bd00f711ef18555$export$1f2db89e0caa00c9;

});

parcelRegister("9yyKc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * A RovoLogo is a subset API that works for both @atlaskit/logo and @atlaskit/icon
 * We use one or the other depending on 1P or 3P and need a consistent API internall
 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");





var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $b9faf8c762554e25$var$t25IconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $ecnYn.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $b9faf8c762554e25$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $b9faf8c762554e25$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $b9faf8c762554e25$var$t25IconContainerStyles[size],
            $b9faf8c762554e25$var$iconStyles
        ],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SVG, null));
};


const $a72f5a493e80638f$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $a72f5a493e80638f$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $a72f5a493e80638f$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $a72f5a493e80638f$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const mappedSize = size && $a72f5a493e80638f$var$isCorrectableRovoSize(size) ? $a72f5a493e80638f$var$correctedSize[size] : defaultSize;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $gMc0m.default)([
                $a72f5a493e80638f$var$sizeStyles[mappedSize]
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $a72f5a493e80638f$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9faf8c762554e25$export$1776e6671850176d), {
            label: label,
            glyph: glyph,
            size: size && $a72f5a493e80638f$var$isCorrectableRovoSize(size) ? $a72f5a493e80638f$var$correctedSize[size] : 'medium'
        });
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $a72f5a493e80638f$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $a72f5a493e80638f$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            ...props,
            shouldUseNewLogoDesign: true
        });
}
function $a72f5a493e80638f$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $a72f5a493e80638f$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $a72f5a493e80638f$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $a72f5a493e80638f$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _5ral1f51"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $a72f5a493e80638f$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $a72f5a493e80638f$export$dae027fade2c6d1d($a72f5a493e80638f$export$f9f7178f66750cba(iconUrl), iconLabel, size);
}
module.exports["RovoLogoFromGlyph"] = $a72f5a493e80638f$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $a72f5a493e80638f$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $a72f5a493e80638f$export$32db889b380fa03c;
module.exports["get3PLogo"] = $a72f5a493e80638f$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $a72f5a493e80638f$export$97ac28be52c9e29f;

});

parcelRegister("dD8Tu", function(module, exports) {
const $d1f25f75a8ad75f6$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $d1f25f75a8ad75f6$export$d810eae89914369b;

});

parcelRegister("9zZIW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $buthI = parcelRequire("buthI");


var $1A1pg = parcelRequire("1A1pg");


var $2Znam = parcelRequire("2Znam");


var $9yyKc = parcelRequire("9yyKc");




const $f79943a87d92fb5b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});





const $96cf123f24fa5c68$export$b16288f56aa4a879 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5428 12.0273H8.26521C8.33797 10.243 8.6684 8.61411 9.18567 7.36406C9.26662 7.16841 9.35328 6.97932 9.44572 6.79843C7.34499 7.69706 5.81358 9.67046 5.5428 12.0273ZM12 4.77734C7.58172 4.77734 4 8.35907 4 12.7773C4 17.1956 7.58172 20.7773 12 20.7773C16.4183 20.7773 20 17.1956 20 12.7773C20 8.35907 16.4183 4.77734 12 4.77734ZM12 6.27734C11.849 6.27734 11.6359 6.34815 11.3684 6.62157C11.0985 6.89748 10.8208 7.3355 10.5717 7.93758C10.1403 8.98016 9.83856 10.4072 9.76656 12.0273H14.2334C14.1614 10.4072 13.8597 8.98016 13.4283 7.93758C13.1792 7.3355 12.9015 6.89748 12.6316 6.62157C12.3641 6.34815 12.151 6.27734 12 6.27734ZM15.7348 12.0273C15.662 10.243 15.3316 8.61411 14.8143 7.36406C14.7334 7.16841 14.6467 6.97931 14.5543 6.79843C16.655 7.69706 18.1864 9.67046 18.4572 12.0273H15.7348ZM14.2334 13.5273H9.76656C9.83856 15.1475 10.1403 16.5745 10.5717 17.6171C10.8208 18.2192 11.0985 18.6572 11.3684 18.9331C11.6359 19.2065 11.849 19.2773 12 19.2773C12.151 19.2773 12.3641 19.2065 12.6316 18.9331C12.9015 18.6572 13.1792 18.2192 13.4283 17.6171C13.8597 16.5745 14.1614 15.1475 14.2334 13.5273ZM14.5543 18.7563C14.6467 18.5754 14.7334 18.3863 14.8143 18.1906C15.3316 16.9406 15.662 15.3117 15.7348 13.5273H18.4572C18.1864 15.8842 16.655 17.8576 14.5543 18.7563ZM9.44572 18.7563C9.35328 18.5754 9.26662 18.3863 9.18567 18.1906C8.6684 16.9406 8.33797 15.3117 8.26521 13.5273H5.5428C5.81358 15.8842 7.34499 17.8576 9.44572 18.7563Z",
        fill: "currentColor"
    }));


const $d81337e880eeaf11$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $f79943a87d92fb5b$export$defe85febe8b728c)['atlassian-web-crawler']),
    id: 'atlassian-web-crawler',
    resourceType: 'webcrawler-connector',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), 'Atlassian Web Crawler'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $96cf123f24fa5c68$export$b16288f56aa4a879), 'Atlassian Web Crawler', 'large'),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    // For web crawler, we want to filter by the domain of each datasource
    // This returns top-level filters (additionalTexts) - no product filters needed
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>{
        return {
            ...existingFilters,
            additionalTexts: [
                ...existingFilters?.additionalTexts || [],
                ...datasource?.workspaceUrl ? [
                    datasource.workspaceUrl
                ] : []
            ]
        };
    }
};
module.exports["atlassianWebCrawlerConfig"] = $d81337e880eeaf11$export$fbd198cf40195606;

});

parcelRegister("7YJRT", function(module, exports) {
const $d5857497b441ad7f$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $d5857497b441ad7f$export$c28231fcae6448eb;

});

parcelRegister("i6s7M", function(module, exports) {
const $162ae7fe4b241de7$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $162ae7fe4b241de7$export$3268f1527392e5ac;

});

parcelRegister("k1cFs", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d465d6c672befb46$export$f1d7e8d930f0538e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
        fill: "white"
    }));
};
module.exports["ForgePioGithubIcon"] = $d465d6c672befb46$export$f1d7e8d930f0538e;

});

parcelRegister("idpYy", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1OY0Y = parcelRequire("1OY0Y");


var $hCmMX = parcelRequire("hCmMX");


var $6PclE = parcelRequire("6PclE");


var $kO4OQ = parcelRequire("kO4OQ");

























const $d26db4dd231f5f64$export$a2818d866ea09b15 = 'ati:cloud:passionfruit:ask';
const $d26db4dd231f5f64$export$e105364f000374dd = ()=>[
        ...(0, $6PclE.DEFAULT_MERCURY_ENTITY_ATI),
        ...(0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled') ? [
            $d26db4dd231f5f64$export$a2818d866ea09b15
        ] : []
    ];
const $d26db4dd231f5f64$export$2113db8105db1e2f = 'ati:cloud:confluence:';
const $d26db4dd231f5f64$export$fd9583608bfd5225 = 'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';
const $d26db4dd231f5f64$export$842fc5f4c9a103cc = 'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';
const $d26db4dd231f5f64$export$85fae06d428ca65d = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $d26db4dd231f5f64$export$de533c0a50cfcba1 = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $d26db4dd231f5f64$export$bcdd6265f8049b41 = 'confluence.ac:com.gliffy.integration.confluence:gliffy-diagram';
const $d26db4dd231f5f64$export$4fb210ecd60bcccb = 'ati:cloud:jira:issue';
const $d26db4dd231f5f64$export$2d84b48cf0a2eca6 = 'ati:cloud:jira:project';
const $d26db4dd231f5f64$export$68f33db8fcc8984d = 'ati:cloud:jira:filter';
const $d26db4dd231f5f64$export$1f91fc8e40b54c58 = 'ati:cloud:jira:dashboard';
const $d26db4dd231f5f64$export$b1c20fb509d2d550 = 'ati:cloud:jira:board';
const $d26db4dd231f5f64$export$fdd5ab530ffed95b = 'ati:cloud:jira:plan';
const $d26db4dd231f5f64$export$b4a7e1c18385196d = [
    $d26db4dd231f5f64$export$2d84b48cf0a2eca6,
    $d26db4dd231f5f64$export$4fb210ecd60bcccb,
    $d26db4dd231f5f64$export$68f33db8fcc8984d,
    $d26db4dd231f5f64$export$1f91fc8e40b54c58,
    $d26db4dd231f5f64$export$b1c20fb509d2d550,
    $d26db4dd231f5f64$export$fdd5ab530ffed95b
];
const $d26db4dd231f5f64$export$6ec0530ffade9ab0 = 'ati:third-party:google:email';
const $d26db4dd231f5f64$export$dfd3b612305212b4 = 'ati:third-party:microsoft:email';
const $d26db4dd231f5f64$export$50adf3273cb5cdeb = [
    $d26db4dd231f5f64$export$6ec0530ffade9ab0,
    $d26db4dd231f5f64$export$dfd3b612305212b4
];
const $d26db4dd231f5f64$export$46827d4f79048f80 = ()=>[
        ...(0, $1OY0Y.DEFAULT_ATLAS_ENTITY_ATI),
        ...(0, $hCmMX.DEFAULT_CONFLUENCE_ENTITY_ATI),
        ...$d26db4dd231f5f64$export$b4a7e1c18385196d,
        ...$d26db4dd231f5f64$export$e105364f000374dd(),
        ...(0, $kO4OQ.DEFAULT_TALENT_ENTITY_ATI)
    ];
const $d26db4dd231f5f64$export$423da9b1dcd76b7 = 15;
const $d26db4dd231f5f64$export$405ff9c6ee9ee7de = 30;
module.exports["CONFLUENCE_CALENDAR_ENTITY_ATI"] = $d26db4dd231f5f64$export$fd9583608bfd5225;
module.exports["CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI"] = $d26db4dd231f5f64$export$842fc5f4c9a103cc;
module.exports["CONFLUENCE_ANSWER_ENTITY_ATI"] = $d26db4dd231f5f64$export$85fae06d428ca65d;
module.exports["CONFLUENCE_QUESTION_ENTITY_ATI"] = $d26db4dd231f5f64$export$de533c0a50cfcba1;
module.exports["CONFLUENCE_GLIFFY_ENTITY_ATI"] = $d26db4dd231f5f64$export$bcdd6265f8049b41;
module.exports["JIRA_ISSUE_ENTITY_ATI"] = $d26db4dd231f5f64$export$4fb210ecd60bcccb;
module.exports["JIRA_PROJECT_ENTITY_ATI"] = $d26db4dd231f5f64$export$2d84b48cf0a2eca6;
module.exports["JIRA_FILTER_ENTITY_ATI"] = $d26db4dd231f5f64$export$68f33db8fcc8984d;
module.exports["JIRA_DASHBOARD_ENTITY_ATI"] = $d26db4dd231f5f64$export$1f91fc8e40b54c58;
module.exports["JIRA_BOARD_ENTITY_ATI"] = $d26db4dd231f5f64$export$b1c20fb509d2d550;
module.exports["JIRA_PLAN_ENTITY_ATI"] = $d26db4dd231f5f64$export$fdd5ab530ffed95b;
module.exports["FEDERATED_GOOGLE_EMAIL_ENTITY_ATI"] = $d26db4dd231f5f64$export$6ec0530ffade9ab0;
module.exports["FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI"] = $d26db4dd231f5f64$export$dfd3b612305212b4;
module.exports["getDefaultEntityAti"] = $d26db4dd231f5f64$export$46827d4f79048f80;
module.exports["RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS"] = $d26db4dd231f5f64$export$423da9b1dcd76b7;
module.exports["RESULT_LIMIT_FOR_SINGLE_PRODUCT"] = $d26db4dd231f5f64$export$405ff9c6ee9ee7de;

});

parcelRegister("8RFAN", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $cMqgY = parcelRequire("cMqgY");


const $13b046720457c115$export$fe26802d293c7c86 = (selectedProduct, selectedProducts, options = {
    fireExperimentExposure: false
}, thirdPartyConfigs)=>{
    // Determine effective selected product:
    // - If selectedProducts array is provided and non-empty, use it to determine the product
    // - Otherwise fall back to selectedProduct
    const effectiveSelectedProduct = selectedProducts && selectedProducts.length > 0 ? selectedProducts.includes('slack') ? 'slack' : selectedProducts[0] : selectedProduct;
    // Only serve the experiment when user is under all product search or Slack product search
    const isSlackOrAllProducts = !effectiveSelectedProduct || effectiveSelectedProduct === 'slack';
    if (!isSlackOrAllProducts) return false;
    // Return false if Slack is not authorized (skip check if thirdPartyConfigs not provided)
    if (thirdPartyConfigs) {
        const isSlackAuthorized = thirdPartyConfigs.slack?.userNeedsOAuth === false;
        if (!isSlackAuthorized) return false;
    }
    // When the connector status transition FF is enabled, use the actual connector sync type
    // to determine if Slack should use federated search behavior
    if ((0, $dh538.fg)('ai_3p_slack_connector_status_transition_enabled')) return (0, $cMqgY.isSlackFederatedByConnectorSyncType)(thirdPartyConfigs);
    // Fallback to legacy experiment and feature flag logic
    const experimentValue = (0, $c6GJD.default).getExperimentValue('ai-3p-slack-federated-search-analysis', 'expValue', 'legacy', options);
    return experimentValue === 'fed' || experimentValue === 'fed-optimized' || (0, $dh538.fg)('ai_3p_slack_federated_search_enabled');
};
module.exports["serveFederatedSlackExperiment"] = $13b046720457c115$export$fe26802d293c7c86;

});

parcelRegister("1RDRl", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a02e3255dc763cd4$export$1bcbc9c337da86da = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "0.381243",
        y: "0.381243",
        width: "23.2375",
        height: "23.2375",
        rx: "5.61876",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "0.762486"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
        fill: "white"
    }));
};
module.exports["TeamsIcon"] = $a02e3255dc763cd4$export$1bcbc9c337da86da;

});

parcelRegister("fuGkE", function(module, exports) {
// Pure product key constants imported from product-keys.ts (source of truth).
// Re-exported below so existing consumers continue to work.

var $b4tvS = parcelRequire("b4tvS");

const $abb7ab79dbd0cf75$export$ee811373b5708646 = (key)=>!Object.values((0, $b4tvS.ProductKeys1PForAnalytics)).includes(key);
module.exports["is3pProductKeyForAnalytics"] = $abb7ab79dbd0cf75$export$ee811373b5708646;

});

parcelRegister("9rRKJ", function(module, exports) {
const $b8ac34854d5d5114$export$81f65d0c79fe28b4 = {
    QUICK_FIND: 'quick-find',
    SEARCH_PAGE: 'search-page'
};
module.exports["SearchExperience"] = $b8ac34854d5d5114$export$81f65d0c79fe28b4;

});

parcelRegister("7WbA8", function(module, exports) {

var $42omo = parcelRequire("42omo");

// This function is used to override the values of an object with the values of another object.
// Unless the value is null or undefined, the value from the source object will be used.
function $0776efa54b822e10$export$8b58be045bf06082(target, source) {
    const result = {
        ...target
    };
    for(const key in source)if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
    return result;
}



var $aN48i = parcelRequire("aN48i");


var $iXZ54 = parcelRequire("iXZ54");

const $801eb453cbafb488$export$554c849e7e3a0f1 = {
    mapUserIdToProfileUrl: ()=>null,
    generateSearchUrl: (0, $aN48i.defaultGenerateSearchUrl),
    getFeatureGate: ()=>false,
    getFrontendExperiment: ()=>({
            abTestId: '',
            cohort: '',
            serveExperiment: false
        }),
    queryParams: {},
    onNavigate: (0, $iXZ54.defaultOnNavigate),
    isNav4Enabled: false,
    isAdminHubAIEnabled: false,
    isRovoLLMEnabled: false
};
/**
 * Provides information about the host application that can't be stored in a state store,
 * e.g. a function.
 */ const $801eb453cbafb488$var$AppContext = /*#__PURE__*/ (0, $42omo.createContext)($801eb453cbafb488$export$554c849e7e3a0f1);
const $801eb453cbafb488$export$fdc397e486fa83e7 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($801eb453cbafb488$var$AppContext);
const $801eb453cbafb488$export$20d2b7652facc723 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($801eb453cbafb488$var$AppContext.Provider, {
        value: (0, $0776efa54b822e10$export$8b58be045bf06082)($801eb453cbafb488$export$554c849e7e3a0f1, props)
    }, children);
module.exports["useAppContext"] = $801eb453cbafb488$export$fdc397e486fa83e7;
module.exports["AppContextProvider"] = $801eb453cbafb488$export$20d2b7652facc723;

});

parcelRegister("aN48i", function(module, exports) {
function $774faa0859b100e2$export$3c0cdf0037f37eca(queryParams) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
        else searchParams.delete(key);
    });
    url.search = searchParams.toString();
    return url.href;
}
module.exports["defaultGenerateSearchUrl"] = $774faa0859b100e2$export$3c0cdf0037f37eca;

});

parcelRegister("iXZ54", function(module, exports) {
const $821d0deb1923daa8$export$bd386de500a3324b = {
    callback: (url)=>{
        window.location.href = url;
    },
    options: {
        alwaysUseOnLinkClick: false
    }
};
module.exports["defaultOnNavigate"] = $821d0deb1923daa8$export$bd386de500a3324b;

});

parcelRegister("2lmJQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $hcty8 = parcelRequire("hcty8");






























const $3c2ea2bb832e7694$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6JMMA"));
        case 'da':
            return (parcelRequire("7SFxt"));
        case 'de':
            return (parcelRequire("iG4FS"));
        case 'en':
            return (parcelRequire("10hdm"));
        case 'en_GB':
            return (parcelRequire("hqwTK"));
        case 'en_ZZ':
            return (parcelRequire("48gEg"));
        case 'es':
            return (parcelRequire("3ggR2"));
        case 'fi':
            return (parcelRequire("9kNdt"));
        case 'fr':
            return (parcelRequire("6of6C"));
        case 'hr':
            return (parcelRequire("gFJ5o"));
        case 'hu':
            return (parcelRequire("k9sQX"));
        case 'it':
            return (parcelRequire("7AG2g"));
        case 'ja':
            return (parcelRequire("17jtA"));
        case 'ko':
            return (parcelRequire("3sG8V"));
        case 'nb':
            return (parcelRequire("3wwJC"));
        case 'nl':
            return (parcelRequire("115hq"));
        case 'pl':
            return (parcelRequire("chAaE"));
        case 'pt_BR':
            return (parcelRequire("7yG1I"));
        case 'ru':
            return (parcelRequire("15Txp"));
        case 'sl':
            return (parcelRequire("8fmsn"));
        case 'sr_RS':
            return (parcelRequire("cGi9X"));
        case 'sr_YR':
            return (parcelRequire("95rIQ"));
        case 'sv':
            return (parcelRequire("6IgfV"));
        case 'th':
            return (parcelRequire("5cgH8"));
        case 'tr':
            return (parcelRequire("kZgWD"));
        case 'uk':
            return (parcelRequire("a9O5n"));
        case 'vi':
            return (parcelRequire("1Yvyf"));
        case 'zh':
            return (parcelRequire("bKS5F"));
        case 'zh_TW':
            return (parcelRequire("38PKm"));
    }
};































const $6b58d18b8a9fe990$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("1uiyk"));
        case 'da':
            return (parcelRequire("dwWyj"));
        case 'de':
            return (parcelRequire("7ahd4"));
        case 'en':
            return (parcelRequire("6dBQl"));
        case 'en_GB':
            return (parcelRequire("2v8Gz"));
        case 'en_ZZ':
            return (parcelRequire("g7B9r"));
        case 'es':
            return (parcelRequire("kQel5"));
        case 'fi':
            return (parcelRequire("jfXoT"));
        case 'fr':
            return (parcelRequire("1RWPz"));
        case 'hr':
            return (parcelRequire("hnggZ"));
        case 'hu':
            return (parcelRequire("bpipP"));
        case 'it':
            return (parcelRequire("1nlci"));
        case 'ja':
            return (parcelRequire("7xBft"));
        case 'ko':
            return (parcelRequire("bVHQO"));
        case 'nb':
            return (parcelRequire("3kdAT"));
        case 'nl':
            return (parcelRequire("hgkdN"));
        case 'pl':
            return (parcelRequire("cHN0H"));
        case 'pt_BR':
            return (parcelRequire("5oUTu"));
        case 'ru':
            return (parcelRequire("agank"));
        case 'sl':
            return (parcelRequire("kqPpj"));
        case 'sr_RS':
            return (parcelRequire("1glw4"));
        case 'sr_YR':
            return (parcelRequire("bXCJU"));
        case 'sv':
            return (parcelRequire("inmxY"));
        case 'th':
            return (parcelRequire("8AA5B"));
        case 'tr':
            return (parcelRequire("l8rBv"));
        case 'uk':
            return (parcelRequire("9VCF3"));
        case 'vi':
            return (parcelRequire("aMD9S"));
        case 'zh':
            return (parcelRequire("jyIFt"));
        case 'zh_TW':
            return (parcelRequire("jq2Ox"));
    }
};































const $649ceacdb34b6a63$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("b0Quq"));
        case 'da':
            return (parcelRequire("gHqSP"));
        case 'de':
            return (parcelRequire("kDZ63"));
        case 'en':
            return (parcelRequire("2ZJxd"));
        case 'en_GB':
            return (parcelRequire("lIvrR"));
        case 'en_ZZ':
            return (parcelRequire("1kUhq"));
        case 'es':
            return (parcelRequire("59IhA"));
        case 'fi':
            return (parcelRequire("kkRV8"));
        case 'fr':
            return (parcelRequire("5dGG6"));
        case 'hr':
            return (parcelRequire("67rtf"));
        case 'hu':
            return (parcelRequire("bbmuy"));
        case 'it':
            return (parcelRequire("5pwE4"));
        case 'ja':
            return (parcelRequire("lb7B1"));
        case 'ko':
            return (parcelRequire("2ahus"));
        case 'nb':
            return (parcelRequire("a9LHZ"));
        case 'nl':
            return (parcelRequire("2K8Ox"));
        case 'pl':
            return (parcelRequire("huUQh"));
        case 'pt_BR':
            return (parcelRequire("85sK0"));
        case 'ru':
            return (parcelRequire("7cPnf"));
        case 'sl':
            return (parcelRequire("574v7"));
        case 'sr_RS':
            return (parcelRequire("iR7QZ"));
        case 'sr_YR':
            return (parcelRequire("5tHnM"));
        case 'sv':
            return (parcelRequire("eqt1i"));
        case 'th':
            return (parcelRequire("hAHoU"));
        case 'tr':
            return (parcelRequire("4LhxM"));
        case 'uk':
            return (parcelRequire("fz4HK"));
        case 'vi':
            return (parcelRequire("36F2C"));
        case 'zh':
            return (parcelRequire("1swrg"));
        case 'zh_TW':
            return (parcelRequire("ezqXT"));
    }
};
































const $a9027c6ac5c6310c$export$417b577dd0ae3221 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("9dO3Q"));
        case 'da':
            return (parcelRequire("22YHR"));
        case 'de':
            return (parcelRequire("5Meno"));
        case 'en':
            return Promise.resolve((parcelRequire("hcty8")));
        case 'en_GB':
            return (parcelRequire("6qVkf"));
        case 'en_ZZ':
            return (parcelRequire("73KJL"));
        case 'es':
            return (parcelRequire("eqUDU"));
        case 'fi':
            return (parcelRequire("7qIaH"));
        case 'fr':
            return (parcelRequire("cqTPI"));
        case 'hr':
            return (parcelRequire("emO7i"));
        case 'hu':
            return (parcelRequire("aFdnn"));
        case 'it':
            return (parcelRequire("a5l2v"));
        case 'ja':
            return (parcelRequire("8rhoO"));
        case 'ko':
            return (parcelRequire("eqZ4Q"));
        case 'nb':
            return (parcelRequire("bAo9R"));
        case 'nl':
            return (parcelRequire("10owv"));
        case 'pl':
            return (parcelRequire("k4VqY"));
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("geYJd"));
        case 'ru':
            return (parcelRequire("1zmTJ"));
        case 'sl':
            return (parcelRequire("4CvUL"));
        case 'sr_RS':
            return (parcelRequire("5hr1F"));
        case 'sr_YR':
            return (parcelRequire("6lyxH"));
        case 'sv':
            return (parcelRequire("bUrkL"));
        case 'th':
            return (parcelRequire("1ZvsH"));
        case 'tr':
            return (parcelRequire("1t44X"));
        case 'uk':
            return (parcelRequire("f9p83"));
        case 'vi':
            return (parcelRequire("lxyXQ"));
        case 'zh_TW':
            return (parcelRequire("eqEPm"));
        case 'zh':
            return (parcelRequire("89Znr"));
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$417b577dd0ae3221(fragments[0]);
                else return Promise.resolve((parcelRequire("hcty8")));
            }
    }
};
const $a9027c6ac5c6310c$export$bb2dfe5d62b737e9 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$bb2dfe5d62b737e9(fragments[0]);
                else return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $a9027c6ac5c6310c$export$622f604e3a034452 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$622f604e3a034452(fragments[0]);
                else return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $a9027c6ac5c6310c$export$97d82de8c43f5d55 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$97d82de8c43f5d55(fragments[0]);
                else return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en');
            }
    }
};
function $a9027c6ac5c6310c$export$6e4716e192dd76c5(locale) {
    return Promise.allSettled([
        $a9027c6ac5c6310c$export$417b577dd0ae3221(locale),
        $a9027c6ac5c6310c$export$bb2dfe5d62b737e9(locale),
        $a9027c6ac5c6310c$export$622f604e3a034452(locale),
        $a9027c6ac5c6310c$export$97d82de8c43f5d55(locale)
    ]).then((results)=>{
        const accumulatedMessages = results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                ...acc,
                ...result.value.default
            };
            return acc;
        }, {});
        return accumulatedMessages;
    });
}


const $7ba69f2ba95f1501$var$useI18n = (locale, source)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState((0, $hcty8.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages((0, $hcty8.default));
        (0, $a9027c6ac5c6310c$export$6e4716e192dd76c5)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'i18n_messages_load_error',
                    source: source,
                    attributes: {
                        locale: locale,
                        error: error.message
                    }
                }
            }).fire();
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale,
        source,
        createAnalyticsEvent
    ]);
    return messages;
};
const $7ba69f2ba95f1501$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $aXWIB.useIntl)();
    const messages = $7ba69f2ba95f1501$var$useI18n(intl.locale, props.experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $7ba69f2ba95f1501$export$2e2bcd8739ae039 = $7ba69f2ba95f1501$var$MessagesIntlProvider;
module.exports["default"] = $7ba69f2ba95f1501$export$2e2bcd8739ae039;

});

parcelRegister("hcty8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6b9649fc867121cb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3c312875d27f019c$export$2e2bcd8739ae039 = {
    '3p-result-labeling.knowledge_article.label': 'Knowledge article',
    'advanced-search.labels.filter.no.text': 'Start typing to search for a label',
    'ai-summary-label': 'Summarize',
    'archive.label': 'Archive',
    'assets-app-message-banner-available-soon': '<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.',
    'assets-app-message-banner-dismiss-message': 'Dismiss',
    attachment_type: 'Attachment',
    'audio.label': 'Audio',
    avatar: 'Avatar',
    'blogpost.label': 'Blogpost',
    blogpost_type: 'Blogpost',
    'branch.label': 'Branch',
    'channel.label': 'Channel',
    'code.label': 'Code',
    'comment-result.label': 'Comment',
    comment_type: 'Comment',
    'commit.label': 'Commit',
    connect_third_party_product_description: 'Connect your account to see missing results',
    connect_third_party_product_title: 'Your admin has added {product}!',
    connect_third_party_product_title_alternate: '{product} is now available!',
    'copied-link-tooltip-label': 'Copied!',
    'copy-content-link-label': 'Copy link',
    'copy-link-button-label': 'Copy Link',
    'copy-link-success-icon-label': 'Success icon',
    'copy-link-tooltip-label': 'Copy link',
    createdNewest: 'Created (newest)',
    createdOldest: 'Created (oldest)',
    'customer-org.label': 'Customer Org',
    'dashboard.label': 'Dashboard',
    'database.label': 'Database',
    'date.filter.after.label': 'after',
    'date.filter.any.time': 'Anytime',
    'date.filter.before.label': 'before',
    'date.filter.custom': 'Custom',
    'date.filter.custom.invalid.after.end': 'The From date has to be before the To date',
    'date.filter.custom.invalid.after.today': "The From date can\u2019t be in the future",
    'date.filter.custom.invalid.to.after.today': "The To date can\u2019t be in the future",
    'date.filter.from.label': 'Choose start date to filter',
    'date.filter.from.title': 'From',
    'date.filter.input.placeholder': 'Choose a date',
    'date.filter.last.month': 'Past 30 days',
    'date.filter.last.week': 'Past 7 days',
    'date.filter.last.year': 'Past year',
    'date.filter.title': 'Last updated',
    'date.filter.to.label': 'Choose end date to filter',
    'date.filter.to.range': 'to',
    'date.filter.to.title': 'To',
    'date.filter.today': 'Today',
    'date.filter.update.button': 'Update',
    'date.filter.yesterday': 'Yesterday',
    'deal.label': 'Deal',
    'design-search-result.label': 'Design',
    'design.label': 'Design',
    'document-search-result.google-docs-label': 'Docs',
    'document-search-result.google-sheets-label': 'Sheets',
    'document-search-result.google-slides-label': 'Slides',
    'document-search-result.ms-excel-label': 'Excel',
    'document-search-result.ms-powerpoint-label': 'PowerPoint',
    'document-search-result.ms-word-label': 'Word',
    'document.label': 'Document',
    draft_label: 'Draft',
    dropdown_generate_answer: 'Generate answer',
    dropdown_recent_icon_label: 'Recent',
    dropdown_search: 'Search',
    dropdown_search_icon_label: 'Search',
    'error-boundary.code': 'The code associated with this error: {code}',
    'error-boundary.description': 'The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:',
    'error-boundary.description.support-link': 'Atlassian Support',
    'error-boundary.reload-page': 'Refresh page',
    'error-boundary.support-link-text': 'our support team',
    'error-boundary.title': "We've hit a snag",
    'error-boundary.url': 'The URL of this page',
    error_primary: "We're having trouble searching",
    error_secondary: 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
    externalPeopleLabel: 'External people #{channelName}',
    externalPersonLabel: 'External person',
    'file.label': 'File',
    filter: 'Filter icon',
    give_feedback_text: 'Give feedback',
    'image.label': 'Image',
    'inline-app-selector.1p-3p-app-tooltip': 'Open a full page search for this term filtered by {productName} results',
    'inline-app-selector.additional-products': '+ {count}',
    'inline-app-selector.all-apps-tooltip': 'Open a full page search for this term searching all apps',
    'inline-product-filters.external-link-icon.label': 'External Link Icon',
    'inline-product-filters.more-filters.label': 'More',
    'inline-product-filters.more-filters.tooltip': 'Open a full page search with more filter options for {product}',
    input_aria_label: 'Search, press enter to navigate to advanced search with your text query',
    input_clear_icon_label: 'Clear search',
    input_copy_link_icon_label: 'Copy link',
    input_placeholder: 'Search',
    input_placeholder_default: 'Search for anything',
    input_placeholder_ghost_text_kpi_acronym: 'Search any acronym, like "KPI"',
    input_placeholder_ghost_text_mention_teammates: '@mention a teammate to see their work',
    input_placeholder_ghost_text_search_across: 'Search across {products}, and more',
    input_placeholder_ghost_text_search_teammate: 'Search the name of a teammate',
    input_placeholder_ghost_text_submit_expense: 'Ask a question like "How do I submit an expense?"',
    input_placeholder_nav3: 'Search',
    input_placeholder_with_atlassian_intelligence: 'Search or ask anything',
    input_placeholder_with_rovo: 'Search or ask Rovo',
    input_search_icon_label: 'Search',
    'invoice.label': 'Invoice',
    'issue.label': 'Issue',
    issue_type: 'Work item',
    jira_advanced_search: 'Search Jira for work items',
    jira_single_site_boards: 'Boards',
    jira_single_site_filters: 'Filters',
    jira_single_site_label: 'Go to all:',
    jira_single_site_people: 'Teams',
    jira_single_site_plans: 'Plans',
    jira_single_site_projects: 'Projects',
    jira_single_site_spaces: 'Spaces',
    jira_single_site_work_items_jql: 'Work items (JQL)',
    landing_primary: 'Seek and you shall find',
    landing_secondary: "Search for what you're looking for in your Atlassian and connected apps",
    landing_secondary_rovo: "Search or ask Rovo what you're looking for in your Atlassian and connected apps",
    landing_secondary_unified_with_sain: 'Search or ask anything across your Atlassian apps',
    landing_secondary_unified_without_sain: 'Search for anything across your Atlassian apps',
    landing_secondary_with_atlassian_intelligence: "Search or ask what you're looking for in your Atlassian and connected apps",
    'leap-query.title.related-search': 'Related searches',
    'leap-query.title.teammates-also-ask': 'Your teammates also ask',
    'link-attachments.button.label': '{count, plural, one {# link} other {# links}}',
    live_doc_type: 'Live Doc',
    'more-actions-label': 'More Actions',
    'more-label': 'More',
    'new-product-message-banner-dismiss-message-button': 'Dismiss',
    'new-product-message-banner-text': "{product} was only recently added and we're still tweaking the results.",
    noOptions: 'No options',
    no_results_clear_filters: 'Clear filters',
    no_results_content_cleared_by_space_change: 'No results - the selected folder may have been moved or deleted.',
    no_results_primary: "We couldn't find anything matching your search",
    no_results_search_all_drives: 'Search all Drives',
    no_results_search_all_sites: 'Search all Sites',
    no_results_secondary_no_filters: 'Try again with a different term.',
    no_results_secondary_some_filters_applied: 'Looks like you have some filters applied. You could try clearing them.',
    'oauth-banner.acknowledgement.success-flag-action': 'Understood',
    'oauth-banner.authorization-fail': 'Failed to connect to {product}.',
    'oauth-banner.authorization-success': 'Account connected to {product}.',
    'oauth-banner.oauth-social-proof-message.connect': 'Connect to {product}',
    'oauth-banner.oauth-social-proof-message.dismiss': 'Dismiss',
    'oauth-banner.oauth-social-proof-message.github.description': 'Expand your search results to include GitHub PRs, issues, and repos.',
    'oauth-banner.oauth-social-proof-message.github.success-flag-description': 'You can now find and action on PRs, commits, and repos in Rovo Search and Chat.',
    'oauth-banner.oauth-social-proof-message.github.success-flag-title': '{product} connected',
    'oauth-banner.oauth-social-proof-message.image-alt': 'Animated preview of {product} search results',
    'oauth-banner.oauth-social-proof-message.title-high-adoption': '{percentage}% of your team has connected apps like {product}',
    'oauth-banner.oauth-social-proof-message.title-low-adoption': 'Your team connected {product}',
    'oauth-message-connect': 'Connect',
    'oauth-message-dismiss': 'Dismiss',
    'other.label': 'Other',
    'page.label': 'Page',
    page_type: 'Page',
    'pdf.label': 'PDF',
    'presentation.label': 'Presentation',
    'project.label': 'Project',
    'pull-request.label': 'Pull Request',
    'quick-find-filters.filter-by-icon-label': 'Filter by Icon',
    'quick-find.assets.filter.assets-schema.icon.label': 'Assets schema filter',
    'quick-find.assets.filter.assets-schema.label.selected': 'Selected',
    'quick-find.assets.filter.assets-schema.label.unselected': 'Suggested',
    'quick-find.assets.filter.assets-schema.placeholder': 'Find schemas',
    'quick-find.assets.filter.assets-type.icon.label': 'Object type filter',
    'quick-find.assets.filter.assets-type.label.selected': 'Selected',
    'quick-find.assets.filter.assets-type.label.unselected': 'Suggested',
    'quick-find.assets.filter.assets-type.placeholder': 'Find object types',
    'quick-find.confluence.filter.contributor.placeholder': 'Find people',
    'quick-find.confluence.filter.label.selected': 'Selected',
    'quick-find.confluence.filter.label.unselected': 'Suggested',
    'quick-find.filter.type.label.selected': 'Selected',
    'quick-find.filter.type.label.unselected': 'Available',
    'quick-find.filter.type.placeholder': 'Find type',
    'quick-find.filters.clear-filters-button-label': 'Clear filters',
    'quick-find.filters.names.assets-schema': 'Schema',
    'quick-find.filters.names.assets-type': 'Object type',
    'quick-find.filters.names.assignee': 'Assignee',
    'quick-find.filters.names.contributor': 'Contributor',
    'quick-find.filters.names.project': 'Project',
    'quick-find.filters.names.spaces': 'Space',
    'quick-find.filters.names.type': 'Type',
    'quick-find.ghost-text.3p-multiple': 'Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps',
    'quick-find.ghost-text.3p.github': 'Search your GitHub repos, commits and PRs',
    'quick-find.ghost-text.3p.google-drive': 'Search your Google Drive Docs, Sheets and Slides',
    'quick-find.ghost-text.3p.onedrive': 'Search your OneDrive documents and files',
    'quick-find.ghost-text.3p.sharepoint': 'Search your SharePoint documents and files',
    'quick-find.ghost-text.3p.slack': 'Search your Slack DMs and messages',
    'quick-find.ghost-text.3p.teams': 'Search your Microsoft Teams chats and messages',
    'quick-find.ghost-text.control': 'Search',
    'quick-find.ghost-text.default-3p': 'Search across all your apps',
    'quick-find.ghost-text.mixed-apps': 'Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps',
    'quick-find.ghost-text.sain': 'Ask me anything or search...',
    'quick-find.ghost-text.sain.benefits': 'Try any question, like "Where can I see my benefits?"',
    'quick-find.ghost-text.sain.it-support': 'Try any question, like "How do I contact IT support?"',
    'quick-find.ghost-text.sain.meeting-room': 'Try any question, like "How do I book a meeting room?"',
    'quick-find.ghost-text.sain.notifications': 'Try any question, like "How do I change my notification settings?"',
    'quick-find.ghost-text.sain.reset-password': 'Try any question, like "How do I reset my password?"',
    'quick-find.ghost-text.sain.time-off': 'Try any question, like "How do I request time off?"',
    'quick-find.ghost-text.two-apps': 'Search {firstPartyApp}, {thirdPartyApp1} and other apps',
    'quick-find.jira.filter.assignee.placeholder': 'Find people',
    'quick-find.jira.filter.assignee.selected': 'Selected',
    'quick-find.jira.filter.assignee.unselected': 'Suggested',
    'quick-find.jira.filter.project.placeholder': 'Find projects',
    'quick-find.jira.filter.project.selected': 'Selected',
    'quick-find.jira.filter.project.unselected': 'Suggested',
    'quick-find.jira.filter.spaces.placeholder': 'Find spaces',
    'quick-find.jira.filter.spaces.selected': 'Selected',
    'quick-find.jira.filter.spaces.unselected': 'Suggested',
    'quick-find.mercury.focus-area-status-update.title': 'Update for {focusAreaName}',
    'quick-find.talent.position.external-position-key': 'External key {positionKey}',
    'quick-find.talent.position.title': '{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
    quick_find_connect_apps_button_aria_label: 'Open app connections',
    quick_find_connect_apps_label: 'Connect apps',
    'recentWork.eventTypeMessage.absolute.commented': 'You commented on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.created': 'You created on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.edited': 'You edited on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.published': 'You published on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.updated': 'You updated on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.viewed': 'You viewed on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.workedOn': 'You worked on {absoluteTime}',
    'recentWork.eventTypeMessage.commented': 'You commented',
    'recentWork.eventTypeMessage.created': 'You created',
    'recentWork.eventTypeMessage.edited': 'You edited',
    'recentWork.eventTypeMessage.multi.absolute.commented': 'Commented on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.created': 'Created on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.edited': 'Edited on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.published': 'Published on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.updated': 'Updated on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.viewed': 'Viewed on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.workedOn': 'Worked on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.commented': 'Commented',
    'recentWork.eventTypeMessage.multi.created': 'Created',
    'recentWork.eventTypeMessage.multi.dateTime.workedOn': 'Worked on {relativeTime}',
    'recentWork.eventTypeMessage.multi.edited': 'Edited',
    'recentWork.eventTypeMessage.multi.published': 'Published',
    'recentWork.eventTypeMessage.multi.relative.commented': 'Commented {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.created': 'Created {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.edited': 'Edited {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.published': 'Published {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.updated': 'Updated {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.viewed': 'Viewed {relativeTime}',
    'recentWork.eventTypeMessage.multi.updated': 'Updated',
    'recentWork.eventTypeMessage.multi.viewed': 'Viewed',
    'recentWork.eventTypeMessage.multi.workedOn': 'Worked on',
    'recentWork.eventTypeMessage.published': 'You published',
    'recentWork.eventTypeMessage.relative.commented': 'You commented {relativeTime}',
    'recentWork.eventTypeMessage.relative.created': 'You created {relativeTime}',
    'recentWork.eventTypeMessage.relative.edited': 'You edited {relativeTime}',
    'recentWork.eventTypeMessage.relative.published': 'You published {relativeTime}',
    'recentWork.eventTypeMessage.relative.updated': 'You updated {relativeTime}',
    'recentWork.eventTypeMessage.relative.viewed': 'You viewed {relativeTime}',
    'recentWork.eventTypeMessage.relative.workedOn': 'You worked on {relativeTime}',
    'recentWork.eventTypeMessage.updated': 'You updated',
    'recentWork.eventTypeMessage.viewed': 'You viewed',
    'recentWork.eventTypeMessage.workedOn': 'You worked on',
    recents_heading: 'Search Results',
    'recommended.collaborator': 'Collaborator',
    'recommended.eventTypeMessage.absolute.clicked': '{collaborator} clicked on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.commented': '{collaborator} commented on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.created': '{collaborator} created on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.edited': '{collaborator} edited on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.interacted': '{collaborator} interacted on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.reacted': '{collaborator} reacted on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.read': '{collaborator} read on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.shared': '{collaborator} shared on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.viewed': '{collaborator} viewed on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.wereMentioned': '{collaborator} were mentioned on {absoluteTime}',
    'recommended.eventTypeMessage.clicked': '{collaborator} clicked',
    'recommended.eventTypeMessage.commented': '{collaborator} commented',
    'recommended.eventTypeMessage.created': '{collaborator} created',
    'recommended.eventTypeMessage.edited': '{collaborator} edited',
    'recommended.eventTypeMessage.icu.absolute.clicked': '{actor, select, you {You clicked on {absoluteTime}} collaborator {Collaborator clicked on {absoluteTime}} other {{username} clicked on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.commented': '{actor, select, you {You commented on {absoluteTime}} collaborator {Collaborator commented on {absoluteTime}} other {{username} commented on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.created': '{actor, select, you {You created on {absoluteTime}} collaborator {Collaborator created on {absoluteTime}} other {{username} created on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.edited': '{actor, select, you {You edited on {absoluteTime}} collaborator {Collaborator edited on {absoluteTime}} other {{username} edited on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.interacted': '{actor, select, you {You interacted on {absoluteTime}} collaborator {Collaborator interacted on {absoluteTime}} other {{username} interacted on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.mentioned': '{actor, select, you {You were mentioned on {absoluteTime}} collaborator {Collaborator was mentioned on {absoluteTime}} other {{username} was mentioned on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.reacted': '{actor, select, you {You reacted on {absoluteTime}} collaborator {Collaborator reacted on {absoluteTime}} other {{username} reacted on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.read': '{actor, select, you {You read on {absoluteTime}} collaborator {Collaborator read on {absoluteTime}} other {{username} read on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.shared': '{actor, select, you {You shared on {absoluteTime}} collaborator {Collaborator shared on {absoluteTime}} other {{username} shared on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.viewed': '{actor, select, you {You viewed on {absoluteTime}} collaborator {Collaborator viewed on {absoluteTime}} other {{username} viewed on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.clicked': '{actor, select, you {You clicked} collaborator {Collaborator clicked} other {{username} clicked}}',
    'recommended.eventTypeMessage.icu.commented': '{actor, select, you {You commented} collaborator {Collaborator commented} other {{username} commented}}',
    'recommended.eventTypeMessage.icu.created': '{actor, select, you {You created} collaborator {Collaborator created} other {{username} created}}',
    'recommended.eventTypeMessage.icu.edited': '{actor, select, you {You edited} collaborator {Collaborator edited} other {{username} edited}}',
    'recommended.eventTypeMessage.icu.interacted': '{actor, select, you {You interacted} collaborator {Collaborator interacted} other {{username} interacted}}',
    'recommended.eventTypeMessage.icu.mentioned': '{actor, select, you {You were mentioned} collaborator {Collaborator was mentioned} other {{username} was mentioned}}',
    'recommended.eventTypeMessage.icu.reacted': '{actor, select, you {You reacted} collaborator {Collaborator reacted} other {{username} reacted}}',
    'recommended.eventTypeMessage.icu.read': '{actor, select, you {You read} collaborator {Collaborator read} other {{username} read}}',
    'recommended.eventTypeMessage.icu.relative.clicked': '{actor, select, you {You clicked {relativeTime}} collaborator {Collaborator clicked {relativeTime}} other {{username} clicked {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.commented': '{actor, select, you {You commented {relativeTime}} collaborator {Collaborator commented {relativeTime}} other {{username} commented {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.created': '{actor, select, you {You created {relativeTime}} collaborator {Collaborator created {relativeTime}} other {{username} created {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.edited': '{actor, select, you {You edited {relativeTime}} collaborator {Collaborator edited {relativeTime}} other {{username} edited {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.interacted': '{actor, select, you {You interacted {relativeTime}} collaborator {Collaborator interacted {relativeTime}} other {{username} interacted {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.mentioned': '{actor, select, you {You were mentioned {relativeTime}} collaborator {Collaborator was mentioned {relativeTime}} other {{username} was mentioned {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.reacted': '{actor, select, you {You reacted {relativeTime}} collaborator {Collaborator reacted {relativeTime}} other {{username} reacted {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.read': '{actor, select, you {You read {relativeTime}} collaborator {Collaborator read {relativeTime}} other {{username} read {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.shared': '{actor, select, you {You shared {relativeTime}} collaborator {Collaborator shared {relativeTime}} other {{username} shared {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.viewed': '{actor, select, you {You viewed {relativeTime}} collaborator {Collaborator viewed {relativeTime}} other {{username} viewed {relativeTime}}}',
    'recommended.eventTypeMessage.icu.shared': '{actor, select, you {You shared} collaborator {Collaborator shared} other {{username} shared}}',
    'recommended.eventTypeMessage.icu.viewed': '{actor, select, you {You viewed} collaborator {Collaborator viewed} other {{username} viewed}}',
    'recommended.eventTypeMessage.interacted': '{collaborator} interacted',
    'recommended.eventTypeMessage.reacted': '{collaborator} reacted',
    'recommended.eventTypeMessage.read': '{collaborator} read',
    'recommended.eventTypeMessage.relative.clicked': '{collaborator} clicked {relativeTime}',
    'recommended.eventTypeMessage.relative.commented': '{collaborator} commented {relativeTime}',
    'recommended.eventTypeMessage.relative.created': '{collaborator} created {relativeTime}',
    'recommended.eventTypeMessage.relative.edited': '{collaborator} edited {relativeTime}',
    'recommended.eventTypeMessage.relative.interacted': '{collaborator} interacted {relativeTime}',
    'recommended.eventTypeMessage.relative.reacted': '{collaborator} reacted {relativeTime}',
    'recommended.eventTypeMessage.relative.read': '{collaborator} read {relativeTime}',
    'recommended.eventTypeMessage.relative.shared': '{collaborator} shared {relativeTime}',
    'recommended.eventTypeMessage.relative.viewed': '{collaborator} viewed {relativeTime}',
    'recommended.eventTypeMessage.relative.wereMentioned': '{collaborator} were mentioned {relativeTime}',
    'recommended.eventTypeMessage.shared': '{collaborator} shared',
    'recommended.eventTypeMessage.viewed': '{collaborator} viewed',
    'recommended.eventTypeMessage.wereMentioned': '{collaborator} were mentioned',
    'recommended.you': 'You',
    'relay.jira-dc-work-item.issue-label': 'Issue',
    'relay.jira-dc-work-item.work-item.work-item-label': 'Work item',
    'relay.jira-dc.comment-result.label': 'Comment',
    'relay.jira-dc.issue-result.label': 'Work item',
    'relay.jira-dc.project-result.label': 'Project',
    'relay.jira-dc.space-result.label': 'Space',
    'relay.jira-dc.work-item-assignee.assigned': '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
    'relay.jira-dc.work-item-creator.created': '{created, select, internal {{firstName} created} other {External person created}}',
    'relay.jira-dc.work-item-status.for': '{statusLozenge} for {dateLozenge}',
    'relay.search-page.results.product-results.third-party.conversation-search-result.tabs-label': 'Tabs',
    'relay.search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label': '{count, plural, one {# attachment} other {# attachments}}',
    'relay.search-page.results.product-results.third-party.message-search-result.member-count': '{count, plural, one {# member} other {# members}}',
    'relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label': '{count, plural, one {# link} other {# links}}',
    'relay.search-result.attachment-label': 'Attachment',
    'relay.search-result.attachments.attached-date.label': 'Attached {formattedDate}',
    'relay.search-result.attachments.audio-label': 'Audio',
    'relay.search-result.attachments.expand.label': 'Expand',
    'relay.search-result.attachments.image-label': 'Image',
    'relay.search-result.attachments.pdf-label': 'PDF',
    'relay.search-result.attachments.video-label': 'Video',
    'relay.search-result.message-last-active': 'Last active {formattedDate}',
    'relay.search-result.message-type-label': 'Message',
    'relay.search-result.private-channel-label': 'Private Channel',
    'relay.search-result.thread-type-label': 'Thread',
    relevance: 'Relevance',
    'repository.label': 'Repository',
    'results-sort.createdDate.selected': 'Sort by created (newest)',
    'results-sort.createdDateASC': 'Created (oldest)',
    'results-sort.createdDateASCSelected.selected': 'Sort by created (oldest)',
    'results-sort.createdDateDESC': 'Created (newest)',
    'results-sort.latestModifiedDateASC': 'Updated (oldest)',
    'results-sort.latestModifiedDateASC.selected': 'Sort by updated (oldest)',
    'results-sort.latestModifiedDateDESC': 'Updated (newest)',
    'results-sort.latestModifiedDateDESC.selected': 'Sort by updated (newest)',
    'results-sort.relevanceDESC': 'Relevance',
    'results-sort.relevanceDESC.selected': 'Sort by relevance',
    'results-sort.sort-options.label': 'Change list sorting',
    'rovo-onboarding-got-it': 'Got it',
    'rovo-onboarding-step-1-description': 'Choose an app to get more relevant results and filters. For example, filter by Space in Confluence.',
    'rovo-onboarding-step-1-heading': 'Search across company apps',
    'rovo-search.assets.filter.icon.label': 'Assets filter',
    'rovo-search.confluence.filter.icon.label': 'Confluence filter',
    'rovo-search.jira.filter.icon.label': 'Jira filter',
    'rovo-search.talent.filter.icon.label': 'Talent filter',
    'seaech-page.townsquare.api.goal-state.archived': 'Archived',
    'seaech-page.townsquare.api.goal-state.at-risk': 'At risk',
    'seaech-page.townsquare.api.goal-state.cancelled': 'Canceled',
    'seaech-page.townsquare.api.goal-state.completed': 'Completed',
    'seaech-page.townsquare.api.goal-state.off-track': 'Off track',
    'seaech-page.townsquare.api.goal-state.on-track': 'On track',
    'seaech-page.townsquare.api.goal-state.paused': 'Paused',
    'seaech-page.townsquare.api.goal-state.pending': 'Pending',
    'search-branch-result.label': 'Branch',
    'search-commit-result.committed': 'Committed {formattedDate}',
    'search-commit-result.label': 'Commit',
    'search-federated-result.email.label': 'Email',
    'search-federated-result.external-person.label': 'External person',
    'search-federated-result.forwarded.label': '{person} forwarded',
    'search-federated-result.inbox.label': 'Inbox',
    'search-federated-result.sent.label': '{person} sent',
    'search-federated-result.timestamp.label': '{formattedDate}',
    'search-filters.filter-by-icon': 'Filter by icon',
    'search-filters.names.contributor': 'Contributor',
    'search-filters.names.type': 'Type',
    'search-git-build-status.failed': '{failed} of {total} failed',
    'search-git-build-status.failed-generic': 'Build failed',
    'search-git-build-status.icon-label': 'Build status',
    'search-git-build-status.passed': '{passed} of {total} passed',
    'search-git-build-status.passed-generic': 'Build passed',
    'search-git-build-status.paused': 'Build paused',
    'search-git-build-status.pending': 'Build pending',
    'search-git-build-status.running': 'Build in progress',
    'search-git-build-status.stopped': 'Build stopped',
    'search-git-build-status.unknown': 'Build status unknown',
    'search-graph-calendar.calendar-label': 'Calendar',
    'search-graph-calendar.created.placeholder': '{person} created',
    'search-graph-calendar.external-person': 'External person',
    'search-graph-calendar.join-meeting-link': 'Join meeting',
    'search-graph-calendar.meeting-link': 'Meeting link',
    'search-graph-calendar.meeting-link-icon': 'Join meeting',
    'search-graph-calendar.past-events-button': 'Past events',
    'search-graph-calendar.recurring-event-icon': 'Recurring event',
    'search-graph-calendar.recurring-event-label': 'Recurring',
    'search-graph-calendar.upcoming-events-button': 'Upcoming events',
    'search-graph-campaign.campaign-label': 'Campaign',
    'search-graph-campaign.ended-on': 'Ended on {date}',
    'search-graph-campaign.ends-on': 'Ends on {date}',
    'search-graph-case.case-label': 'Case',
    'search-graph-case.closed-on': 'Closed on {date}',
    'search-graph-case.closes-on': 'Closes on {date}',
    'search-graph-confluence-dc.document.attachmentLabel': 'Attachment',
    'search-graph-confluence-dc.document.blogpostLabel': 'Blog Post',
    'search-graph-confluence-dc.document.commentLabel': 'Comment',
    'search-graph-confluence-dc.document.pageLabel': 'Page',
    'search-graph-confluence-dc.document.spaceLabel': 'Space',
    'search-graph-customer-contact.customer-contact-label': 'Customer Contact',
    'search-graph-customer-org.customer-org-label': 'Customer Organization',
    'search-graph-dashboard.dashboard-label': 'Dashboard',
    'search-graph-data-table.data-table-label': 'Data table',
    'search-graph-deal.closed-on': 'Closed on {date}',
    'search-graph-deal.closes-on': 'Closes on {date}',
    'search-graph-deal.deal-label': 'Deal',
    'search-graph-default.dashboard.label': 'Dashboard',
    'search-graph-default.deal.label': 'Deal',
    'search-graph-default.design.label': 'Design',
    'search-graph-default.invoice.label': 'Invoice',
    'search-graph-default.task.label': 'Task',
    'search-graph-jira-dc.comment-result.label': 'Comment',
    'search-graph-jira-dc.issue-result.label': 'Work item',
    'search-graph-jira-dc.project-result.label': 'Project',
    'search-graph-jira-dc.space-result.label': 'Space',
    'search-graph-video.dropdown-message': '{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
    'search-graph-video.duration.hours': '{hours} hour {minutes} min',
    'search-graph-video.duration.minutes': '{minutes} min',
    'search-graph-video.duration.seconds': '{seconds} sec',
    'search-graph-video.past-meetings': 'Past meetings',
    'search-graph-video.past-meetings-updated': 'Updated {relativeTime}',
    'search-graph-video.see-all': 'See all',
    'search-graph-video.video-icon-label': 'video icon',
    'search-graph-video.video-thumbnail-alt-text': 'Video thumbnail',
    'search-graph-video.video-type': 'Video',
    'search-graph-work-item.approval': 'Approval',
    'search-graph-work-item.bug.label': 'Bug',
    'search-graph-work-item.catalog_item': 'Catalog item',
    'search-graph-work-item.epic.label': 'Epic',
    'search-graph-work-item.incident': 'Incident',
    'search-graph-work-item.issue': 'Issue',
    'search-graph-work-item.label': 'Work item',
    'search-graph-work-item.milestone.label': 'Milestone',
    'search-graph-work-item.problem': 'Problem',
    'search-graph-work-item.question': 'Question',
    'search-graph-work-item.requested_item': 'Requested item',
    'search-graph-work-item.section': 'Section',
    'search-graph-work-item.story.label': 'Story',
    'search-graph-work-item.task.label': 'Task',
    'search-graph-work-item.ticket': 'Ticket',
    'search-page-relay.filters.product-filters.slack-channel.label': 'Channel',
    'search-page-relay.filters.product-filters.slack-channel.placeholder': 'Filter by channel',
    'search-page-relay.filters.product-filters.slack-channel.selected-label': 'Selected',
    'search-page-relay.filters.product-filters.slack-channel.suggested-label': 'Channels',
    'search-page-relay.results.product-results.third-party.conversation-search-result.label': 'Channel',
    'search-page-relay.results.product-results.third-party.conversation-search-result.member-count': '{count, plural, one {# member} other {# members}}',
    'search-page-relay.results.product-results.third-party.conversation-search-result.private-channel': 'Private channel',
    'search-page-relay.results.product-results.third-party.conversation-search-result.time-since-label': 'Last active {formattedDate}',
    'search-page-relay.results.product-results.third-party.conversation-search-result.unknown-channel': 'unknown-channel',
    'search-page.ai-mode.ai-mode': 'AI Mode',
    'search-page.ai-mode.results': 'Results',
    'search-page.app-filter-sidebar.all': 'All',
    'search-page.app-filter-sidebar.connect-apps-description': 'Get better answers and more results across Search and Chat.',
    'search-page.app-filter-sidebar.connect-apps-header': 'Connect apps',
    'search-page.app-filter-sidebar.connected-apps-header': 'Filter results',
    'search-page.app-filter-sidebar.filter-menu.menu-item.hide': 'Hide app',
    'search-page.app-filter-sidebar.filter-menu.trigger': 'Show more options',
    'search-page.app-filter-sidebar.group': 'Filter search by app',
    'search-page.app-filter-sidebar.improve-search': 'Improve search',
    'search-page.app-filter-sidebar.no-matching-results-tooltip': 'No matching results in {product}',
    'search-page.app-filter-sidebar.product-timeout-button-text': 'See only {product} results',
    'search-page.app-filter-sidebar.product-timeout-primary-text': '{product} results took too long to show',
    'search-page.app-filter-sidebar.product-timeout-secondary-text': 'Try again by filtering just for {product}.',
    'search-page.app-filter-sidebar.product-timeout-tooltip': '{product} results were too slow to show',
    'search-page.app-filter-sidebar.show-all-apps.button.label': 'Show all apps',
    'search-page.app-filter-sidebar.show-more.button.label': 'Show more',
    'search-page.app-filter-sidebar.show-more.filter.placeholder': 'Find apps',
    'search-page.assets.filter.assets-schema.icon.label': 'Assets schema filter',
    'search-page.assets.filter.assets-schema.label.selected': 'Selected',
    'search-page.assets.filter.assets-schema.label.unselected': 'Suggested',
    'search-page.assets.filter.assets-schema.placeholder': 'Find schemas',
    'search-page.assets.filter.assets-type.icon.label': 'Object type filter',
    'search-page.assets.filter.assets-type.label.selected': 'Selected',
    'search-page.assets.filter.assets-type.label.unselected': 'Suggested',
    'search-page.assets.filter.assets-type.placeholder': 'Find object types',
    'search-page.atlas.for': 'for',
    'search-page.atlas.goal.for': 'for',
    'search-page.auto-correction.did-you-mean': 'Did you mean {suggestedQuery}',
    'search-page.auto-correction.search-instead-for': 'Search instead for {originalQuery}',
    'search-page.auto-correction.showing-results-for': 'Showing results for {replacementQuery}',
    'search-page.browser-extension-banner.close-button-label': 'Close browser extension banner',
    'search-page.browser-extension-banner.link-text': 'Get the browser extension',
    'search-page.browser-extension-banner.title': 'Use Rovo wherever you are',
    'search-page.close-date-filter.date-label': 'Select date',
    'search-page.close-date-filter.date-placeholder': 'Select a date',
    'search-page.close-date-filter.label': 'Close date',
    'search-page.close-date-filter.update-button': 'Apply',
    'search-page.comment-icon-label': 'Comment',
    'search-page.common.graph-work-item-status.closed': 'Closed',
    'search-page.common.graph-work-item-status.open': 'Open',
    'search-page.common.status-target-date-display.for': 'for',
    'search-page.common.ui.clear-filter-button.label': 'Clear filter',
    'search-page.common.ui.quick-find.search-dialog-announcer.availableOptions': '{count} options available',
    'search-page.confluence.filter.content.placeholder': 'Find content',
    'search-page.confluence.filter.content.selected': 'Selected',
    'search-page.confluence.filter.content.unselected': 'Suggested',
    'search-page.confluence.filter.contributor.label.selected': 'Selected',
    'search-page.confluence.filter.contributor.label.unselected': 'Suggested',
    'search-page.confluence.filter.contributor.placeholder': 'Find people',
    'search-page.confluence.filter.creator.placeholder': 'Find people',
    'search-page.confluence.filter.creator.selected': 'Selected',
    'search-page.confluence.filter.creator.unselected': 'Suggested',
    'search-page.confluence.filter.icon.label': 'Confluence filter',
    'search-page.confluence.filter.label.selected': 'Selected',
    'search-page.confluence.filter.label.unselected': 'Suggested',
    'search-page.confluence.filter.labels.placeholder': 'Find labels',
    'search-page.confluence.filter.space.icon': 'Space Icon',
    'search-page.confluence.filter.space.placeholder': 'Find spaces',
    'search-page.dropdown.search-suggestions': 'Search Suggestions Dropdown',
    'search-page.embedded-comments.comment-header-prefix': 'Re: {label}',
    'search-page.filter.app-select.all': 'All',
    'search-page.filter.app-select.label.selected': 'Selected',
    'search-page.filter.app-select.label.unselected': 'Suggested',
    'search-page.filter.app-select.placeholder': 'Find app',
    'search-page.filter.app-select.tooltip.redirect': 'Open a full page search filtered by {appLabel} results',
    'search-page.filter.clear.filter.label': 'Clear filter',
    'search-page.filter.close.date.anytime': 'Anytime',
    'search-page.filter.close.date.custom': 'Specific date',
    'search-page.filter.close.date.last30days': 'Last 30 days',
    'search-page.filter.close.date.last365days': 'Last 365 days',
    'search-page.filter.close.date.last7days': 'Last 7 days',
    'search-page.filter.close.date.last90days': 'Last 90 days',
    'search-page.filter.close.date.next30days': 'Next 30 days',
    'search-page.filter.close.date.next365days': 'Next 365 days',
    'search-page.filter.close.date.next7days': 'Next 7 days',
    'search-page.filter.close.date.next90days': 'Next 90 days',
    'search-page.filter.close.date.today': 'Today',
    'search-page.filter.last.updated.anytime': 'Anytime',
    'search-page.filter.last.updated.custom': 'Custom',
    'search-page.filter.last.updated.past30Days': 'Past 30 days',
    'search-page.filter.last.updated.past7Days': 'Past 7 days',
    'search-page.filter.last.updated.pastYear': 'Past year',
    'search-page.filter.last.updated.today': 'Today',
    'search-page.filter.last.updated.yesterday': 'Yesterday',
    'search-page.filter.opportunityStatus.all': 'Any',
    'search-page.filter.opportunityStatus.closed': 'Closed',
    'search-page.filter.opportunityStatus.open': 'Open',
    'search-page.filter.pageStatus.all': 'All',
    'search-page.filter.pageStatus.inProgress': 'In progress',
    'search-page.filter.pageStatus.readyForReview': 'Ready for review',
    'search-page.filter.pageStatus.roughDraft': 'Rough draft',
    'search-page.filter.pageStatus.verified': 'Verified',
    'search-page.filter.pull-request-status.declined': 'Declined',
    'search-page.filter.pull-request-status.draft': 'Draft',
    'search-page.filter.pull-request-status.merged': 'Merged',
    'search-page.filter.pull-request-status.open': 'Open',
    'search-page.filter.pull-request-status.unknown': 'Unknown',
    'search-page.filter.status.done': 'Done',
    'search-page.filter.status.indeterminate': 'In Progress (Open)',
    'search-page.filter.status.new': 'To Do (Open)',
    'search-page.filter.status.open': 'Open',
    'search-page.filter.status.undefined': 'Other',
    'search-page.filter.suggested.options.section': 'Suggested',
    'search-page.filter.type.Story': 'Story',
    'search-page.filter.type.all': 'All',
    'search-page.filter.type.answer': 'Answers',
    'search-page.filter.type.archive': 'Archive',
    'search-page.filter.type.article': 'Articles',
    'search-page.filter.type.ask': 'Asks',
    'search-page.filter.type.attachment': 'Attachments',
    'search-page.filter.type.audio': 'Audio',
    'search-page.filter.type.blogpost': 'Blog posts',
    'search-page.filter.type.board': 'Boards',
    'search-page.filter.type.branch': 'Branches',
    'search-page.filter.type.bug': 'Bug',
    'search-page.filter.type.calendar': 'Calendars',
    'search-page.filter.type.campaign': 'Campaigns',
    'search-page.filter.type.card': 'Cards',
    'search-page.filter.type.case': 'Cases',
    'search-page.filter.type.catalog-item': 'Catalog items',
    'search-page.filter.type.code': 'Code',
    'search-page.filter.type.comment': 'Comments',
    'search-page.filter.type.commit': 'Commits',
    'search-page.filter.type.component': 'Components',
    'search-page.filter.type.conversation': 'Channels',
    'search-page.filter.type.customer-contact': 'Customer Contacts',
    'search-page.filter.type.customer-org': 'Customer Organizations',
    'search-page.filter.type.dashboard': 'Dashboards',
    'search-page.filter.type.data-table': 'Data tables',
    'search-page.filter.type.database': 'Databases',
    'search-page.filter.type.deal': 'Deals',
    'search-page.filter.type.design': 'Designs',
    'search-page.filter.type.devops-work-item': 'Issues',
    'search-page.filter.type.documents': 'Documents',
    'search-page.filter.type.embed': 'Smart Links',
    'search-page.filter.type.epic': 'Epic',
    'search-page.filter.type.filter': 'Filters',
    'search-page.filter.type.focus-area': 'Focus areas',
    'search-page.filter.type.folder': 'Folders',
    'search-page.filter.type.form': 'Form',
    'search-page.filter.type.gliffy': 'Gliffy Diagrams',
    'search-page.filter.type.goal': 'Goals',
    'search-page.filter.type.image': 'Images',
    'search-page.filter.type.incident': 'Incidents',
    'search-page.filter.type.invoice': 'Invoices',
    'search-page.filter.type.jira-work-item': 'Work items',
    'search-page.filter.type.knowledge-article': 'Knowledge articles',
    'search-page.filter.type.message': 'Messages',
    'search-page.filter.type.notebook': 'Notebook',
    'search-page.filter.type.object': 'Objects',
    'search-page.filter.type.other': 'Other',
    'search-page.filter.type.page': 'Pages',
    'search-page.filter.type.pageAndLiveDoc': 'Pages and Live Docs',
    'search-page.filter.type.pdf': 'PDF',
    'search-page.filter.type.placeholder': 'Find type',
    'search-page.filter.type.plan': 'Plans',
    'search-page.filter.type.position': 'Positions',
    'search-page.filter.type.post': 'Posts',
    'search-page.filter.type.presentation': 'Presentations',
    'search-page.filter.type.project': 'Projects',
    'search-page.filter.type.pull-request': 'Pull requests',
    'search-page.filter.type.question': 'Questions',
    'search-page.filter.type.repository': 'Repositories',
    'search-page.filter.type.requested-item': 'Requested items',
    'search-page.filter.type.schema': 'Schemas',
    'search-page.filter.type.shortcut': 'Shortcut',
    'search-page.filter.type.slide': 'Slides',
    'search-page.filter.type.space': 'Spaces',
    'search-page.filter.type.space-calendar': 'Space calendars',
    'search-page.filter.type.spreadsheet': 'Spreadsheets',
    'search-page.filter.type.subtask': 'Subtask',
    'search-page.filter.type.tag': 'Tags',
    'search-page.filter.type.task': 'Task',
    'search-page.filter.type.ticket': 'Tickets',
    'search-page.filter.type.type': 'Object types',
    'search-page.filter.type.video': 'Videos',
    'search-page.filter.type.web-page': 'Web pages',
    'search-page.filter.type.whiteboard': 'Whiteboards',
    'search-page.filter.type.work-item': 'Tasks',
    'search-page.filters.clear-filters-button-label': 'Clear filters',
    'search-page.filters.dropdown.button': 'More filters',
    'search-page.filters.dropdown.clear-filters': 'Clear filters',
    'search-page.filters.names.app-select': 'App',
    'search-page.filters.names.archived': 'Show archived content',
    'search-page.filters.names.archivedAndPendingComponents': 'Show archived/pending components',
    'search-page.filters.names.assets-schema': 'Schema',
    'search-page.filters.names.assets-type': 'Object type',
    'search-page.filters.names.assignee': 'Assignee',
    'search-page.filters.names.closeDate': 'Close date',
    'search-page.filters.names.content': 'Content under',
    'search-page.filters.names.contributor': 'Contributor',
    'search-page.filters.names.createdBy': 'Created by',
    'search-page.filters.names.drive': 'Drive',
    'search-page.filters.names.focusAreaType': 'Focus area type',
    'search-page.filters.names.focusAreaUnder': 'Focus area under',
    'search-page.filters.names.labels': 'Label',
    'search-page.filters.names.lastUpdated': 'Last updated',
    'search-page.filters.names.lastUpdatedBy': 'Last updated by',
    'search-page.filters.names.owner': 'Owner',
    'search-page.filters.names.pageStatus': 'Status',
    'search-page.filters.names.position-status-filter': 'Filled status',
    'search-page.filters.names.positionEmploymentType': 'Employment type',
    'search-page.filters.names.positionFocusArea': 'Focus area',
    'search-page.filters.names.positionJobFamily': 'Job family',
    'search-page.filters.names.positionTeam': 'Team',
    'search-page.filters.names.project': 'Project',
    'search-page.filters.names.pull-request-status': 'PR status',
    'search-page.filters.names.reporter': 'Reporter',
    'search-page.filters.names.site': 'Site',
    'search-page.filters.names.space': 'Space',
    'search-page.filters.names.spaces': 'Space',
    'search-page.filters.names.status': 'Status',
    'search-page.filters.names.titleMatchOnly': 'Search title only',
    'search-page.filters.names.type': 'Type',
    'search-page.filters.names.verified': 'Verified',
    'search-page.filters.names.work-commented-on': "Work I've commented on",
    'search-page.filters.names.work-watching': "Work I\u2019m watching",
    'search-page.filters.suggested-filters-section-label': 'Suggested',
    'search-page.google-drive.filter.drive.placeholder': 'Find drives',
    'search-page.jira-assignee.assignee': 'Assignee: {assigneeName}',
    'search-page.jira-assignee.unassigned': 'Unassigned',
    'search-page.jira.filter.assignee.placeholder': 'Find people',
    'search-page.jira.filter.assignee.selected': 'Selected',
    'search-page.jira.filter.assignee.unselected': 'Suggested',
    'search-page.jira.filter.project.placeholder': 'Find projects',
    'search-page.jira.filter.project.selected': 'Selected',
    'search-page.jira.filter.project.unselected': 'Suggested',
    'search-page.jira.filter.reporter.placeholder': 'Find people',
    'search-page.jira.filter.reporter.selected': 'Selected',
    'search-page.jira.filter.reporter.unselected': 'Suggested',
    'search-page.jira.filter.spaces.placeholder': 'Find spaces',
    'search-page.jira.filter.spaces.selected': 'Selected',
    'search-page.jira.filter.spaces.unselected': 'Suggested',
    'search-page.linked-pull-requests.expand-label': '{count}{hasMore, select, true {+} other {}} {count, plural, one {Pull request} other {Pull requests}}',
    'search-page.linked-pull-requests.last-updated': 'Updated {relativeTime}',
    'search-page.linked-pull-requests.metadata-label': 'Pull Request',
    'search-page.linked-pull-requests.pull-request-id': 'ID# {prId}',
    'search-page.linked-pull-requests.reviewer-count': '{count, plural, =0 {No reviewers} one {# reviewer} other {# reviewers}}',
    'search-page.linked-pull-requests.status-declined': 'Declined',
    'search-page.linked-pull-requests.status-draft': 'Draft',
    'search-page.linked-pull-requests.status-merged': 'Merged',
    'search-page.linked-pull-requests.status-open': 'Open',
    'search-page.linked-pull-requests.status-unknown': 'Unknown',
    'search-page.linked-results.comments': 'Comments',
    'search-page.linked-results.external-link': 'External link',
    'search-page.linked-results.found-in': 'Found in',
    'search-page.linked-results.mentioned-in': 'Mentioned in',
    'search-page.linked-results.related': 'Related links',
    'search-page.linked-results.related-pages': 'Related pages',
    'search-page.linked-results.see-all': 'See all',
    'search-page.linked-results.show-more': 'Show {count} more',
    'search-page.linked-results.similar': '{count} similar',
    'search-page.mercury.filter.content.placeholder': 'Find focus areas',
    'search-page.mercury.filter.content.selected': 'Selected',
    'search-page.mercury.filter.content.unselected': 'Suggested',
    'search-page.mercury.filter.focusAreaType.label.selected': 'Selected',
    'search-page.mercury.filter.focusAreaType.label.unselected': 'Suggested',
    'search-page.mercury.filter.focusAreaType.placeholder': 'Find focus area types',
    'search-page.mercury.focus-area-update.title': 'Update for {focusAreaName}',
    'search-page.navigation.search.work-items': 'Search work items',
    'search-page.nouns.goal': 'Goal',
    'search-page.nouns.goals': 'Goals',
    'search-page.nouns.project': 'Project',
    'search-page.nouns.projects': 'Projects',
    'search-page.nouns.tag': 'Tag',
    'search-page.nouns.tags': 'Tags',
    'search-page.products.custom-website': 'Web page',
    'search-page.products.custom-websites': 'Web pages',
    'search-page.profile-avatar.label': 'Person Avatar',
    'search-page.quick-find.dialog.banners.github-tip.dismissBannerLabel': 'Dismiss GitHub tip',
    'search-page.quick-find.dialog.banners.github-tip.oauthFailFlagTitle': 'Could not connect to GitHub',
    'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagDescription': 'You can now find and action on PRs, commits, and repos in Rovo Search and Chat.',
    'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagTitle': 'GitHub connected',
    'search-page.quick-find.dialog.banners.github-tip.tipBanner': '<b>Tip:</b> <connectLink>Connect GitHub</connectLink> to find and action on PRs, issues, and repos in your search results.',
    'search-page.relay.compass.owner-name': 'Owned by {ownerName}',
    'search-page.relay.compass.tier': 'Tier {tier}',
    'search-page.results.private-result-label': 'Private',
    'search-page.results.private-result-tooltip': 'Only visible to you',
    'search-page.results.product-results.third-party.channel-member-count': '{memberCount, plural, one {# member} other {# members}}',
    'search-page.results.product-results.third-party.channel-type-label': 'Channel',
    'search-page.results.product-results.third-party.external-people-label': 'External people',
    'search-page.results.product-results.third-party.external-person-label': 'External person',
    'search-page.results.product-results.third-party.last-active': 'Last active {relativeDate}',
    'search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip': 'Restricted - Only specific people can see this result',
    'search-page.results.product-results.third-party.message-type-label': 'Message',
    'search-page.results.product-results.third-party.no-contributors-label': 'External people in #{channelName}',
    'search-page.results.product-results.third-party.private-conversation-text': '{users} in a private conversation',
    'search-page.results.product-results.third-party.thread-type-label': 'Thread',
    'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
    'search-page.results.product-results.third-party.title-with-remaining-contributors': '{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}',
    'search-page.results.restricted-result-label': 'Restricted',
    'search-page.results.restricted-result-tooltip': 'Only visible to specific people',
    'search-page.salesforce.filter.campaignStatus': 'Campaign status',
    'search-page.salesforce.filter.campaignStatus.no-options': 'No statuses available',
    'search-page.salesforce.filter.caseStatus': 'Case status',
    'search-page.salesforce.filter.caseStatus.no-options': 'No statuses available',
    'search-page.salesforce.filter.dealStatus': 'Deal status',
    'search-page.salesforce.filter.stage': 'Deal stage',
    'search-page.salesforce.filter.stage.closed-lost-send-survey': 'Closed Lost (Send Survey)',
    'search-page.salesforce.filter.stage.closed-won': 'Closed Won',
    'search-page.salesforce.filter.stage.closed-won-auto-linked': 'Closed Won (Auto Linked)',
    'search-page.salesforce.filter.stage.develop-opportunity': 'Develop Opportunity',
    'search-page.salesforce.filter.stage.invalid-opp': 'Invalid Opp',
    'search-page.salesforce.filter.stage.lost': 'Lost',
    'search-page.salesforce.filter.stage.new': 'New',
    'search-page.salesforce.filter.stage.no-opportunity': 'No Opportunity',
    'search-page.salesforce.filter.stage.no-options': 'No stages available',
    'search-page.salesforce.filter.stage.qualify-opportunity': 'Qualify Opportunity',
    'search-page.search-link.label': 'Search Link',
    'search-page.search-page-header.search-results': 'Search results',
    'search-page.sharepoint.filter.site.placeholder': 'Find sites',
    'search-page.show-more-breadcrumbs-button-label': 'Show more breadcrumbs',
    'search-page.tab-filter.accessible-more-dropdown-label': 'Filter by more apps',
    'search-page.tab-filter.all-filter-accessible-label': 'Filter by all apps',
    'search-page.tab-filter.all-filter-visual-label': 'All',
    'search-page.tab-filter.more-dropdown-label': 'More',
    'search-page.talent.filter.focus-area.content.placeholder': 'Find focus areas',
    'search-page.talent.filter.focus-area.content.selected': 'Selected',
    'search-page.talent.filter.focus-area.content.unselected': 'Suggested',
    'search-page.talent.filter.position-employment-type.content.placeholder': 'Find employment types',
    'search-page.talent.filter.position-employment-type.content.selected': 'Selected',
    'search-page.talent.filter.position-employment-type.content.unselected': 'Suggested',
    'search-page.talent.filter.position-job-family.content.placeholder': 'Find job families',
    'search-page.talent.filter.position-job-family.content.selected': 'Selected',
    'search-page.talent.filter.position-job-family.content.unselected': 'Suggested',
    'search-page.talent.filter.position-status-filter.content.placeholder': 'Find filled status',
    'search-page.talent.filter.position-status-filter.content.selected': 'Selected',
    'search-page.talent.filter.position-status-filter.content.unselected': 'Suggested',
    'search-page.talent.filter.position-team.content.placeholder': 'Find teams',
    'search-page.talent.filter.position-team.content.selected': 'Selected',
    'search-page.talent.filter.position-team.content.unselected': 'Suggested',
    'search-page.verified-icon-label': 'Verified',
    'search-page.verified-icon-tooltip-message': 'This page has been verified by an owner or admin.',
    'search-pull-request-result.comments-label': '{count} {count, plural, one {comment} other {comments}}',
    'search-pull-request-result.label': 'Pull request',
    'search-pull-request-result.status.declined': 'Declined',
    'search-pull-request-result.status.draft': 'Draft',
    'search-pull-request-result.status.merged': 'Merged',
    'search-pull-request-result.status.open': 'Open',
    'search-pull-request-result.status.unknown': 'Unknown',
    'search-respository-result.label': 'Repository',
    'search-result.direct-message-single-user': '{name1} and 1 other',
    'search-result.direct-message-two-users': '{name1} and {name2}',
    'search-result.federated-group-direct-message': '{knownNamesCount, plural, =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2} and {name3}} =4 {{name1}, {name2}, {name3} and {name4}} other {{name1}, {name2}, {name3} and {name4}} }',
    'search-result.federated-group-direct-message-with-multiple-others': '{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} others} =2 {{name1}, {name2} and {totalOthersCount} others} =3 {{name1}, {name2}, {name3} and {totalOthersCount} others} =4 {{name1}, {name2}, {name3}, {name4} and {totalOthersCount} others} other {{name1}, {name2}, {name3}, {name4} and {totalOthersCount} others} }',
    'search-result.federated-group-direct-message-with-one-other': '{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} other} =2 {{name1}, {name2} and {totalOthersCount} other} =3 {{name1}, {name2}, {name3} and {totalOthersCount} other} =4 {{name1}, {name2}, {name3}, {name4} and {totalOthersCount} other} other {{name1}, {name2}, {name3}, {name4} and {totalOthersCount} other} }',
    'search-result.group-chat-title': '{contributorCount, plural, =0 {Group message with external users} =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other} other {{name1}, {name2}, {name3}, and {overflowContributorCount} others} }',
    'search-result.group-direct-message-unknown-names': '{totalPeopleCount} people',
    'search-result.group-meeting-title': '{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }{channelName}',
    'search-result.last-modified': 'Updated {formattedDate}',
    'search-result.private-channel-label': 'Private Channel',
    'search-result.remove-recent-search': 'Remove recent search icon',
    'search-result.remove-recent-search-result-subheading': 'Recent search',
    'search-result.thread-title-with-others-and-channel-name': '{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }#{channelName}',
    'search-result.unknown-channel-in-thread': 'unknown-channel',
    'search-result.user-mention.external-person': 'External person',
    'search.quickFind.intentRouter.allApps': 'All apps',
    'search.quickFind.intentRouter.jiraWorkItemsJql': 'Jira work items (JQL)',
    'search.quickFind.intentRouter.searchForAllApps': 'Search for all apps',
    'search.quickFind.intentRouter.searchForJiraWorkItems': 'Search for Jira work items',
    'searchDialog.apply.suggested.filter': 'Apply filter',
    'searchDialog.suggested.filter': 'Suggested filter',
    'searchDialog.suggestedFilter.filterName.assignee': 'assignee',
    'searchDialog.suggestedFilter.filterName.product': 'app',
    'searchDialog.suggestedFilter.filterName.project': 'project',
    'searchDialog.suggestedFilter.icon.label': 'Suggestion search',
    search_dialog_aria_label: 'Search Dialog',
    search_dialog_assets_unavailable_message: '<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>.',
    search_dialog_autocomplete_suggestion: 'Suggestion',
    search_dialog_dismiss_banner_label: 'Dismiss banner',
    search_dialog_error_search_body: 'It might just be a hiccup. Please try refreshing the page or <button>try again</button>.',
    search_dialog_error_search_heading: "We're having trouble loading your recently viewed content.",
    search_dialog_feedback_footer: 'Help us improve search',
    search_dialog_no_content_body: "Search for what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_body_default: 'Search for anything across your Atlassian apps',
    search_dialog_no_content_body_with_ai: "Search or ask what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_body_with_atlassian_intelligence: 'Search or ask anything across your Atlassian apps',
    search_dialog_no_content_body_with_rovo: "Search or ask Rovo what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_heading: 'Seek and you shall find',
    search_dialog_no_results_heading: "We couldn't find any results with that title",
    search_dialog_no_results_search_body: '<link>Search all content across your organization</link> or try again with a different term.',
    search_dialog_recent_search: 'Recent search',
    search_dialog_recents_heading: 'Recent',
    search_dialog_recommendations_heading: 'Recommendations',
    search_dialog_recommended_heading: 'Recommended',
    search_dialog_remove_recent_search_label: 'Remove recent search',
    search_dialog_rovo_banner_message: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer",
    search_dialog_rovo_tip: 'Rovo tip:',
    search_dialog_search_across_products: 'Search all apps',
    'search_dialog_search_across_products.more': 'more',
    'search_dialog_search_across_products.more-apps': '+ {more}',
    'search_dialog_search_across_products.more-apps-count': '+{count}',
    search_dialog_search_change_message: 'Why has search changed?',
    search_dialog_team: 'Team',
    search_dialog_zero_query: 'Suggestion',
    search_dialog_zero_query_collaborator_profile_suggestion: "{personAvatar} {name}'s profile",
    search_dialog_zero_query_confluence_pages_created_30_days_suggestion: '{productIcon} Confluence pages I created in the {dateIcon} last 30 days',
    search_dialog_zero_query_confluence_pages_created_7_days_suggestion: '{productIcon} Confluence pages I created in the {dateIcon} last 7 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_7_days_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 7 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_last_30_days_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 30 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name}',
    search_dialog_zero_query_confluence_pages_created_suggestion: '{productIcon} Confluence pages I created',
    search_dialog_zero_query_icon_label: 'Suggestion search',
    search_dialog_zero_query_issues_assigned_to_me_in_the_past_7_days_suggestion: 'Issues assigned to me in the past 7 days',
    search_dialog_zero_query_issues_i_created_in_the_last_month_suggestion: 'Issues I created in the last month',
    search_dialog_zero_query_jira_my_work_items_suggestion: 'Show my {productIcon} work items',
    search_dialog_zero_query_jira_nlq_collaborator_suggestion: 'Recent open items assigned to {name}',
    search_dialog_zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion: 'Progress for epics created by me',
    search_dialog_zero_query_jira_tickets_assigned_collaborator_suggestion: '{productIcon} tickets assigned to {personAvatar} {name}',
    search_dialog_zero_query_jira_tickets_assigned_suggestion: '{productIcon} Jira tickets assigned to me',
    search_dialog_zero_query_jira_tickets_created_collaborator_suggestion: '{productIcon} Jira tickets created by {personAvatar} {name}',
    search_dialog_zero_query_jira_tickets_created_suggestion: '{productIcon} Jira tickets I created',
    search_dialog_zero_query_recent_tickets_created_by_me_suggestion: 'Recent tickets created by me',
    search_dialog_zero_query_show_all_the_bugs_assigned_to_me_suggestion: 'Show all the bugs assigned to me',
    search_dialog_zero_query_show_high_priority_tickets_assigned_to_me_suggestion: 'Show high priority tickets assigned to me',
    search_dialog_zero_query_show_me_all_of_my_in_progress_work_items_suggestion: 'Show me all of my in-progress work items',
    search_dialog_zero_query_show_tickets_due_this_week_suggestion: 'Show tickets due this week',
    search_dialog_zero_query_third_party_google_collaborator_docs_suggestion: '{productIcon} Google docs from {personAvatar} {name}',
    search_dialog_zero_query_third_party_google_my_docs_suggestion: 'My {productIcon} Google Drive docs',
    search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion: '{productIcon} SharePoint docs from {personAvatar} {name}',
    search_dialog_zero_query_third_party_sharepoint_my_docs_suggestion: 'My {productIcon} SharePoint documents',
    search_dialog_zero_query_third_party_slack_collaborator_messages_suggestion: '{productIcon} Slack messages from {personAvatar} {name}',
    search_dialog_zero_query_third_party_slack_my_messages_suggestion: 'My {productIcon} Slack messages',
    search_dialog_zero_query_what_are_my_open_tickets_suggestion: 'What are my open tickets?',
    search_dialog_zero_query_who_is_suggestion: 'Who is {name}?',
    'search_filters.more': 'more',
    'search_filters.more-apps-search': 'Open full page search for this term searching all apps',
    'search_page.lite_app_filter_bar.all': 'All',
    'search_page.lite_app_filter_bar.all_apps': 'All apps',
    'search_page.lite_app_filter_bar.connect': 'Connect',
    'search_page.lite_app_filter_bar.connect_app_aria': 'Connect {app}',
    'search_page.lite_app_filter_bar.connect_apps': 'Connect apps',
    'search_page.lite_header.feedback_button_label': 'Feedback',
    search_result_skeleton_loading_result: 'Loading result',
    search_result_type_answer: 'Answer',
    search_result_type_ask: 'Ask',
    search_result_type_attachment: 'Attachment',
    search_result_type_blogpost: 'Blog Post',
    search_result_type_board: 'Board',
    search_result_type_branch: 'Branch',
    search_result_type_bug: 'Bug',
    search_result_type_calendar: 'Calendar',
    search_result_type_card: 'Card',
    search_result_type_change: 'Change',
    search_result_type_channel: 'Channel',
    search_result_type_comment: 'Comment',
    search_result_type_commit: 'Commit',
    search_result_type_component: 'Component',
    search_result_type_customer_contact: 'Customer contact',
    search_result_type_customer_org: 'Customer Organization',
    search_result_type_dashboard: 'Dashboard',
    search_result_type_data_table: 'Data table',
    search_result_type_database: 'Database',
    search_result_type_deal: 'Deal',
    search_result_type_document: 'Document',
    search_result_type_email: 'Email',
    search_result_type_embed: 'Smart Link',
    search_result_type_epic: 'Epic',
    search_result_type_file: 'File',
    search_result_type_filter: 'Filter',
    search_result_type_focus_area: 'Focus area',
    search_result_type_focus_area_status_update: 'Focus area update',
    search_result_type_folder: 'Folder',
    search_result_type_gliffy: 'Gliffy Diagram',
    search_result_type_goal: 'Goal',
    search_result_type_improvement: 'Improvement',
    search_result_type_incident: 'Incident',
    search_result_type_issue: 'Work item',
    search_result_type_learning: 'Learning',
    search_result_type_message: 'Message',
    search_result_type_new_feature: 'New feature',
    search_result_type_object: 'Object',
    search_result_type_page: 'Page',
    search_result_type_plan: 'Plan',
    search_result_type_position: 'Position',
    search_result_type_presentation: 'Presentation',
    search_result_type_problem: 'Problem',
    search_result_type_project: 'Project',
    search_result_type_pull_request: 'Pull Request',
    search_result_type_question: 'Question',
    search_result_type_repository: 'Repository',
    search_result_type_schema: 'Schema',
    search_result_type_service_request: 'Service request',
    search_result_type_sharepoint_document: 'Sharepoint Document',
    search_result_type_slide: 'Slides',
    search_result_type_space: 'Space',
    search_result_type_space_calendar: 'Space calendar',
    search_result_type_spreadsheet: 'Spreadsheet',
    search_result_type_story: 'Story',
    search_result_type_sub_task: 'Sub-task',
    search_result_type_subtask: 'Sub-task',
    search_result_type_tag: 'Tag',
    search_result_type_task: 'Task',
    search_result_type_type: 'Object type',
    search_result_type_unrecognised: 'Unrecognised',
    search_result_type_video: 'Video',
    search_result_type_whiteboard: 'Whiteboard',
    search_result_type_work_item: 'Work Item',
    search_results_lite_issue_table_header_assignee: 'Assignee',
    search_results_lite_issue_table_header_labels: 'Labels',
    search_results_lite_issue_table_header_priority: 'Priority',
    search_results_lite_issue_table_header_status: 'Status',
    search_results_lite_issue_table_header_work: 'Work',
    search_results_lite_project_table_header_category: 'Category',
    search_results_lite_project_table_header_key: 'Key',
    search_results_lite_project_table_header_lead: 'Lead',
    search_results_lite_project_table_header_spaceUrl: 'Space URL',
    search_results_lite_project_table_header_spaces: 'Spaces',
    search_results_lite_project_table_header_type: 'Type',
    'search_talent_position.external_position_key': 'External key {positionExternalKey}',
    'search_talent_position.position_title': '{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
    'sidebar-authorize_connect_third_party_product': 'Your admin has added <strong>{product}!</strong>{br} Connect your account to see missing results, including documents only you have access to.',
    'sidebar-authorize_connect_third_party_product_alternate_msg': '<strong>{product} is now available!</strong>{br} Connect your account to see missing results, including content only you have access to.',
    'sidebar-oauth-warning-authorize': 'Authorize',
    'sidebar-oauth-warning-dismiss': 'Dismiss',
    'sidebar-oauth-warning.app-filter-tooltip-content': 'Connect your account to see missing results, including documents only you have access to.',
    'sidebar-oauth-warning.app-filter-tooltip-content-alternate': 'Connect your account to see missing results, including content only you have access to.',
    'sidebar-oauth-warning.authorization-fail': 'Failed to connect to {product}.',
    'sidebar-oauth-warning.authorization-success': 'Successfully connected to {product}.',
    'sidebar-oauth-warning.connect': 'Connect',
    'sidebar-oauth-warning.not-now': 'Not now',
    'space.label': 'Space',
    'spreadsheet.label': 'Spreadsheet',
    suggestion: 'See all results for "{inputQuery}" across apps',
    'summarize-in-chat-button-text': 'Summarize',
    'summarize-in-chat-label': 'Summarize',
    'task.label': 'Task',
    team: 'Team',
    'third-party-query-suggestion.dismiss': 'Dismiss',
    'third-party-query-suggestion.title': 'Do smarter searches with {product}',
    updatedNewest: 'Updated (newest)',
    updatedOldest: 'Updated (oldest)',
    'video.label': 'Video',
    'web-page.label': 'Web Page',
    whiteboard_type: 'Whiteboard',
    'work-item-assignee.assigned': '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
    'work-item-creator.created': '{created, select, internal {{firstName} created} other {External person created}}',
    'work-item-status.for': '{statusLozenge} for {dateLozenge}',
    'work-item.label': 'Work Item',
    work_item: 'Work item',
    your_recent_results_heading: 'Your recent results'
};


var $6b9649fc867121cb$export$2e2bcd8739ae039 = (0, $3c312875d27f019c$export$2e2bcd8739ae039);

});

parcelRegister("6JMMA", function(module, exports) {

let $4e7cc93dda848f3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e7cc93dda848f3b$var$load("ipx3Q").then(()=>parcelRequire('eYbiR'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7SFxt", function(module, exports) {

let $5bcdcc4a9d15718a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bcdcc4a9d15718a$var$load("jXMUM").then(()=>parcelRequire('gaER3'));

});

parcelRegister("iG4FS", function(module, exports) {

let $d98fc67ba6d57d84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d98fc67ba6d57d84$var$load("idV8v").then(()=>parcelRequire('53G40'));

});

parcelRegister("10hdm", function(module, exports) {

let $0bb324f86a9053f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bb324f86a9053f2$var$load("kBQ9k").then(()=>parcelRequire('lba8D'));

});

parcelRegister("hqwTK", function(module, exports) {

let $03462ae01f1d9d22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03462ae01f1d9d22$var$load("birQa").then(()=>parcelRequire('jShwN'));

});

parcelRegister("48gEg", function(module, exports) {

let $3024d2cd3b4a7121$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3024d2cd3b4a7121$var$load("01Ull").then(()=>parcelRequire('bQ8q0'));

});

parcelRegister("3ggR2", function(module, exports) {

let $25fff0b07fb99e67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25fff0b07fb99e67$var$load("iyrsM").then(()=>parcelRequire('duFs7'));

});

parcelRegister("9kNdt", function(module, exports) {

let $6cbc28a4e9b946ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cbc28a4e9b946ca$var$load("hPFdF").then(()=>parcelRequire('6lV5D'));

});

parcelRegister("6of6C", function(module, exports) {

let $4a70b3a51fda55ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a70b3a51fda55ea$var$load("k7AqX").then(()=>parcelRequire('2Ktmn'));

});

parcelRegister("gFJ5o", function(module, exports) {

let $c23372d38e32e554$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c23372d38e32e554$var$load("8sFBs").then(()=>parcelRequire('aBN5I'));

});

parcelRegister("k9sQX", function(module, exports) {

let $eabb0786d5dc9459$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eabb0786d5dc9459$var$load("iULA4").then(()=>parcelRequire('eLHIJ'));

});

parcelRegister("7AG2g", function(module, exports) {

let $586c8095331e2971$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $586c8095331e2971$var$load("gJ4Zj").then(()=>parcelRequire('7jApd'));

});

parcelRegister("17jtA", function(module, exports) {

let $0d058d763f852b42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d058d763f852b42$var$load("fvcGb").then(()=>parcelRequire('kAnOM'));

});

parcelRegister("3sG8V", function(module, exports) {

let $2854ad562d0c406c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2854ad562d0c406c$var$load("30u08").then(()=>parcelRequire('bTqAy'));

});

parcelRegister("3wwJC", function(module, exports) {

let $290dc0b22e8edaa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $290dc0b22e8edaa1$var$load("bEohT").then(()=>parcelRequire('1KXQd'));

});

parcelRegister("115hq", function(module, exports) {

let $0bd9faeee4f22628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bd9faeee4f22628$var$load("4TfaY").then(()=>parcelRequire('fICFY'));

});

parcelRegister("chAaE", function(module, exports) {

let $8f132150cfa01d05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f132150cfa01d05$var$load("7TRKR").then(()=>parcelRequire('feBfk'));

});

parcelRegister("7yG1I", function(module, exports) {

let $580c4f05ef6bb8b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $580c4f05ef6bb8b6$var$load("gfmgP").then(()=>parcelRequire('8NaIX'));

});

parcelRegister("15Txp", function(module, exports) {

let $0cc156bf565075f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cc156bf565075f6$var$load("8rjqC").then(()=>parcelRequire('4Lyyx'));

});

parcelRegister("8fmsn", function(module, exports) {

let $601124dea6226b2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $601124dea6226b2f$var$load("c1meM").then(()=>parcelRequire('76EPm'));

});

parcelRegister("cGi9X", function(module, exports) {

let $93b77e6824d5d3d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93b77e6824d5d3d6$var$load("hnoAT").then(()=>parcelRequire('6ZHgv'));

});

parcelRegister("95rIQ", function(module, exports) {

let $69da15bd4d10a1f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69da15bd4d10a1f3$var$load("h2yiB").then(()=>parcelRequire('ffVcI'));

});

parcelRegister("6IgfV", function(module, exports) {

let $4e3376305010918c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e3376305010918c$var$load("7t9jv").then(()=>parcelRequire('9Cgjy'));

});

parcelRegister("5cgH8", function(module, exports) {

let $3c8b05f7461dc730$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c8b05f7461dc730$var$load("02wkF").then(()=>parcelRequire('k3N88'));

});

parcelRegister("kZgWD", function(module, exports) {

let $f476a601f5a5179c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f476a601f5a5179c$var$load("f9I75").then(()=>parcelRequire('gVxyq'));

});

parcelRegister("a9O5n", function(module, exports) {

let $7651989b8976896d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7651989b8976896d$var$load("2ArFg").then(()=>parcelRequire('bEtBH'));

});

parcelRegister("1Yvyf", function(module, exports) {

let $1703de806dc28a72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1703de806dc28a72$var$load("a0qFU").then(()=>parcelRequire('4qCpI'));

});

parcelRegister("bKS5F", function(module, exports) {

let $88edf2ca5ce08964$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88edf2ca5ce08964$var$load("3aliZ").then(()=>parcelRequire('121eu'));

});

parcelRegister("38PKm", function(module, exports) {

let $249a4243d610f87b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $249a4243d610f87b$var$load("k4Fbc").then(()=>parcelRequire('4mIHV'));

});

parcelRegister("1uiyk", function(module, exports) {

let $1156fbf5734fffc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1156fbf5734fffc0$var$load("aMWDh").then(()=>parcelRequire('8pfQd'));

});

parcelRegister("dwWyj", function(module, exports) {

let $9d9baecb2c2e214a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d9baecb2c2e214a$var$load("2Nhk7").then(()=>parcelRequire('frmvq'));

});

parcelRegister("7ahd4", function(module, exports) {

let $5376d113c4c6d637$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5376d113c4c6d637$var$load("5GgLt").then(()=>parcelRequire('l1TrV'));

});

parcelRegister("6dBQl", function(module, exports) {

let $48714fdaf6e1f7d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48714fdaf6e1f7d8$var$load("aeBaj").then(()=>parcelRequire('98mG9'));

});

parcelRegister("2v8Gz", function(module, exports) {

let $1d2536ca680228a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d2536ca680228a6$var$load("icI5m").then(()=>parcelRequire('3Fipj'));

});

parcelRegister("g7B9r", function(module, exports) {

let $bbca1e42fd1786af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bbca1e42fd1786af$var$load("56ebG").then(()=>parcelRequire('ZePYR'));

});

parcelRegister("kQel5", function(module, exports) {

let $f2c3c96681b53a0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2c3c96681b53a0e$var$load("bpm6H").then(()=>parcelRequire('56K08'));

});

parcelRegister("jfXoT", function(module, exports) {

let $e04d7ec2c3f45686$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e04d7ec2c3f45686$var$load("lQBW4").then(()=>parcelRequire('dhb2r'));

});

parcelRegister("1RWPz", function(module, exports) {

let $15c860455cb64527$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15c860455cb64527$var$load("d3Pby").then(()=>parcelRequire('3jBpL'));

});

parcelRegister("hnggZ", function(module, exports) {

let $ca61351d725fb4d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca61351d725fb4d7$var$load("i3KTR").then(()=>parcelRequire('3lSRV'));

});

parcelRegister("bpipP", function(module, exports) {

let $84e05076b6a9ac37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $84e05076b6a9ac37$var$load("jQsR5").then(()=>parcelRequire('hkrs8'));

});

parcelRegister("1nlci", function(module, exports) {

let $100861ccafaf2cfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $100861ccafaf2cfd$var$load("buYUs").then(()=>parcelRequire('kjY3o'));

});

parcelRegister("7xBft", function(module, exports) {

let $57d88247e0753c55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57d88247e0753c55$var$load("6JyvA").then(()=>parcelRequire('3iKYt'));

});

parcelRegister("bVHQO", function(module, exports) {

let $023dca7582168c9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $023dca7582168c9a$var$load("6j4E0").then(()=>parcelRequire('7TbNk'));

});

parcelRegister("3kdAT", function(module, exports) {

let $26bdc8d9155a2afa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26bdc8d9155a2afa$var$load("dx2gW").then(()=>parcelRequire('1a2R6'));

});

parcelRegister("hgkdN", function(module, exports) {

let $c9139dd72d99548e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9139dd72d99548e$var$load("kRxC0").then(()=>parcelRequire('5aoCz'));

});

parcelRegister("cHN0H", function(module, exports) {

let $93ff849fb6339afb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93ff849fb6339afb$var$load("6VYUF").then(()=>parcelRequire('jRotk'));

});

parcelRegister("5oUTu", function(module, exports) {

let $3eeb5399523d2931$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3eeb5399523d2931$var$load("iTCSz").then(()=>parcelRequire('1AIxH'));

});

parcelRegister("agank", function(module, exports) {

let $7783724eb6b1ebb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7783724eb6b1ebb9$var$load("9vlOp").then(()=>parcelRequire('19wre'));

});

parcelRegister("kqPpj", function(module, exports) {

let $edfe1cca38752f3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $edfe1cca38752f3f$var$load("9fdZA").then(()=>parcelRequire('aoQCd'));

});

parcelRegister("1glw4", function(module, exports) {

let $0eb7f9b9f0893ad0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0eb7f9b9f0893ad0$var$load("c1Rfq").then(()=>parcelRequire('9xJII'));

});

parcelRegister("bXCJU", function(module, exports) {

let $023f473ef8848a36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $023f473ef8848a36$var$load("b4t5O").then(()=>parcelRequire('ix8pw'));

});

parcelRegister("inmxY", function(module, exports) {

let $d60bdd5bc04d8548$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d60bdd5bc04d8548$var$load("lPFUB").then(()=>parcelRequire('lFkoK'));

});

parcelRegister("8AA5B", function(module, exports) {

let $640dae1818e8ec84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $640dae1818e8ec84$var$load("cCO7Q").then(()=>parcelRequire('bN4cF'));

});

parcelRegister("l8rBv", function(module, exports) {

let $f62fc1e6ddfe9861$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f62fc1e6ddfe9861$var$load("eGYFX").then(()=>parcelRequire('2F5a9'));

});

parcelRegister("9VCF3", function(module, exports) {

let $73a76d3b9572851f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73a76d3b9572851f$var$load("e0Zpf").then(()=>parcelRequire('kmRRg'));

});

parcelRegister("aMD9S", function(module, exports) {

let $7d9cc316e842b8df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d9cc316e842b8df$var$load("3mO4w").then(()=>parcelRequire('kebSA'));

});

parcelRegister("jyIFt", function(module, exports) {

let $e3d3d769f429c96f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3d3d769f429c96f$var$load("fJV8L").then(()=>parcelRequire('hn9Es'));

});

parcelRegister("jq2Ox", function(module, exports) {

let $e232a0ddfbbf4bbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e232a0ddfbbf4bbf$var$load("aFaOB").then(()=>parcelRequire('3bY7C'));

});

parcelRegister("b0Quq", function(module, exports) {

let $8048692bb880fc15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8048692bb880fc15$var$load("c243Q").then(()=>parcelRequire('amfAy'));

});

parcelRegister("gHqSP", function(module, exports) {

let $c28583faa68729fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c28583faa68729fc$var$load("9pwoj").then(()=>parcelRequire('jE8NI'));

});

parcelRegister("kDZ63", function(module, exports) {

let $f076d7ab8746cca8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f076d7ab8746cca8$var$load("jbmlj").then(()=>parcelRequire('gQzYt'));

});

parcelRegister("2ZJxd", function(module, exports) {

let $22e49988b987c520$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22e49988b987c520$var$load("2YMwz").then(()=>parcelRequire('eXryL'));

});

parcelRegister("lIvrR", function(module, exports) {

let $fcf61a0388512b69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcf61a0388512b69$var$load("apc1e").then(()=>parcelRequire('032ju'));

});

parcelRegister("1kUhq", function(module, exports) {

let $0f9350ba6478536c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f9350ba6478536c$var$load("hSszq").then(()=>parcelRequire('3Zq6F'));

});

parcelRegister("59IhA", function(module, exports) {

let $3c1024a4be3cc7dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c1024a4be3cc7dd$var$load("hMErM").then(()=>parcelRequire('ly2jc'));

});

parcelRegister("kkRV8", function(module, exports) {

let $ecdf8068510ccdc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ecdf8068510ccdc3$var$load("4mauf").then(()=>parcelRequire('9UaNh'));

});

parcelRegister("5dGG6", function(module, exports) {

let $3ccf459a424bedfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ccf459a424bedfb$var$load("cV78a").then(()=>parcelRequire('6jtTg'));

});

parcelRegister("67rtf", function(module, exports) {

let $0126557e69c77c6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0126557e69c77c6d$var$load("a5JUA").then(()=>parcelRequire('cB3yu'));

});

parcelRegister("bbmuy", function(module, exports) {

let $82422b366a4f84a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82422b366a4f84a3$var$load("1MwbL").then(()=>parcelRequire('3omfl'));

});

parcelRegister("5pwE4", function(module, exports) {

let $3f089c336808afdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f089c336808afdd$var$load("4ep0R").then(()=>parcelRequire('BiK8L'));

});

parcelRegister("lb7B1", function(module, exports) {

let $f6b0847aa0adc9db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6b0847aa0adc9db$var$load("6cdZj").then(()=>parcelRequire('hwGtw'));

});

parcelRegister("2ahus", function(module, exports) {

let $193a151fd8c3b175$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $193a151fd8c3b175$var$load("aUGH0").then(()=>parcelRequire('duV9U'));

});

parcelRegister("a9LHZ", function(module, exports) {

let $764fc08cf8699a36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $764fc08cf8699a36$var$load("bc9H8").then(()=>parcelRequire('lXbGR'));

});

parcelRegister("2K8Ox", function(module, exports) {

let $1ff6b6f3c319048d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ff6b6f3c319048d$var$load("jiPaz").then(()=>parcelRequire('g4jIK'));

});

parcelRegister("huUQh", function(module, exports) {

let $cbd154b05f4fc884$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cbd154b05f4fc884$var$load("7LXV4").then(()=>parcelRequire('jkFMn'));

});

parcelRegister("85sK0", function(module, exports) {

let $5e3515bf476a32ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e3515bf476a32ce$var$load("dIeeW").then(()=>parcelRequire('6i9PT'));

});

parcelRegister("7cPnf", function(module, exports) {

let $53f181353a07194b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53f181353a07194b$var$load("1NSIC").then(()=>parcelRequire('3QONf'));

});

parcelRegister("574v7", function(module, exports) {

let $3b9118feb49cdcc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b9118feb49cdcc9$var$load("iNY4f").then(()=>parcelRequire('lHPaj'));

});

parcelRegister("iR7QZ", function(module, exports) {

let $dba344d4c10a5bd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dba344d4c10a5bd2$var$load("isQJH").then(()=>parcelRequire('ctZZ9'));

});

parcelRegister("5tHnM", function(module, exports) {

let $3fd1500fefe9f586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fd1500fefe9f586$var$load("a60ql").then(()=>parcelRequire('aNi5L'));

});

parcelRegister("eqt1i", function(module, exports) {

let $a80a01292bb8166c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a80a01292bb8166c$var$load("4V1qv").then(()=>parcelRequire('1ziCa'));

});

parcelRegister("hAHoU", function(module, exports) {

let $cce776f44b968fda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cce776f44b968fda$var$load("8vbSC").then(()=>parcelRequire('hdYZj'));

});

parcelRegister("4LhxM", function(module, exports) {

let $3779290c3d413b4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3779290c3d413b4c$var$load("iwJOJ").then(()=>parcelRequire('jRbUf'));

});

parcelRegister("fz4HK", function(module, exports) {

let $b54dc628a13e9d66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b54dc628a13e9d66$var$load("dlPIZ").then(()=>parcelRequire('flBBu'));

});

parcelRegister("36F2C", function(module, exports) {

let $2431c48ee3929286$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2431c48ee3929286$var$load("4Gbtc").then(()=>parcelRequire('8Dj2h'));

});

parcelRegister("1swrg", function(module, exports) {

let $1101919db5f57e5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1101919db5f57e5e$var$load("eqiYF").then(()=>parcelRequire('MvF9E'));

});

parcelRegister("ezqXT", function(module, exports) {

let $a9b94040894180c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9b94040894180c2$var$load("43BOc").then(()=>parcelRequire('gHeq1'));

});

parcelRegister("9dO3Q", function(module, exports) {

let $6b6c2903bbce7646$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b6c2903bbce7646$var$load("gD9D1").then(()=>parcelRequire('fwLkx'));

});

parcelRegister("22YHR", function(module, exports) {

let $17dadbb881b57b56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17dadbb881b57b56$var$load("lpFHz").then(()=>parcelRequire('cZQvj'));

});

parcelRegister("5Meno", function(module, exports) {

let $434c964261df2cff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $434c964261df2cff$var$load("fYKge").then(()=>parcelRequire('iukR2'));

});

parcelRegister("6qVkf", function(module, exports) {

let $4af1a37610892460$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4af1a37610892460$var$load("4Wlui").then(()=>parcelRequire('2RrDc'));

});

parcelRegister("73KJL", function(module, exports) {

let $523d1142fc2fd996$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $523d1142fc2fd996$var$load("69mwC").then(()=>parcelRequire('i7ntw'));

});

parcelRegister("eqUDU", function(module, exports) {

let $a81f6e6e9982805f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a81f6e6e9982805f$var$load("7rN2h").then(()=>parcelRequire('l4eWW'));

});

parcelRegister("7qIaH", function(module, exports) {

let $568d39ac4f240296$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $568d39ac4f240296$var$load("9Y8tZ").then(()=>parcelRequire('dsm1a'));

});

parcelRegister("cqTPI", function(module, exports) {

let $0255fcca73e09e98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0255fcca73e09e98$var$load("jjh1v").then(()=>parcelRequire('2TL59'));

});

parcelRegister("emO7i", function(module, exports) {

let $a759fee81567df29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a759fee81567df29$var$load("23sVT").then(()=>parcelRequire('8Sn5a'));

});

parcelRegister("aFdnn", function(module, exports) {

let $7c381beae7bb8a37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c381beae7bb8a37$var$load("eO6VH").then(()=>parcelRequire('9Refg'));

});

parcelRegister("a5l2v", function(module, exports) {

let $757ab10100b5bd1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $757ab10100b5bd1e$var$load("8rFvt").then(()=>parcelRequire('82BKR'));

});

parcelRegister("8rhoO", function(module, exports) {

let $624e57784acd019c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $624e57784acd019c$var$load("lK8aI").then(()=>parcelRequire('5O8im'));

});

parcelRegister("eqZ4Q", function(module, exports) {

let $a822df0f4e1a857f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a822df0f4e1a857f$var$load("5j4Hn").then(()=>parcelRequire('cw0UK'));

});

parcelRegister("bAo9R", function(module, exports) {

let $86f5cbce63fed6b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86f5cbce63fed6b9$var$load("2Jfx0").then(()=>parcelRequire('5QYDh'));

});

parcelRegister("10owv", function(module, exports) {

let $0bb8d056e87483a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bb8d056e87483a6$var$load("c119j").then(()=>parcelRequire('aRdOD'));

});

parcelRegister("k4VqY", function(module, exports) {

let $e9e0bb96113f4f57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9e0bb96113f4f57$var$load("lgdNv").then(()=>parcelRequire('e9ZyH'));

});

parcelRegister("geYJd", function(module, exports) {

let $bd2d0f845fa6b4ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd2d0f845fa6b4ae$var$load("dKIhk").then(()=>parcelRequire('78gTm'));

});

parcelRegister("1zmTJ", function(module, exports) {

let $124ad25e9404f30a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $124ad25e9404f30a$var$load("dwqTf").then(()=>parcelRequire('5VFOo'));

});

parcelRegister("4CvUL", function(module, exports) {

let $35d37798f8551259$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35d37798f8551259$var$load("fbezn").then(()=>parcelRequire('iLiRR'));

});

parcelRegister("5hr1F", function(module, exports) {

let $3d83811519289e1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d83811519289e1d$var$load("3HAPT").then(()=>parcelRequire('7BQ4p'));

});

parcelRegister("6lyxH", function(module, exports) {

let $49ef7fa67851e99b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49ef7fa67851e99b$var$load("2GH4w").then(()=>parcelRequire('ieueA'));

});

parcelRegister("bUrkL", function(module, exports) {

let $8aba20977b41a025$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8aba20977b41a025$var$load("7Qzqz").then(()=>parcelRequire('bYC4R'));

});

parcelRegister("1ZvsH", function(module, exports) {

let $1733e4a262526709$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1733e4a262526709$var$load("gt8Kd").then(()=>parcelRequire('dpTRJ'));

});

parcelRegister("1t44X", function(module, exports) {

let $111ba9daa7801166$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $111ba9daa7801166$var$load("eVDdh").then(()=>parcelRequire('kBAV5'));

});

parcelRegister("f9p83", function(module, exports) {

let $b07b305c14ee1d6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b07b305c14ee1d6b$var$load("hLIwJ").then(()=>parcelRequire('jjmz0'));

});

parcelRegister("lxyXQ", function(module, exports) {

let $fae7cd35fac1b26d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fae7cd35fac1b26d$var$load("wnH66").then(()=>parcelRequire('gj4bv'));

});

parcelRegister("eqEPm", function(module, exports) {

let $a81329da9bcd8516$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a81329da9bcd8516$var$load("5oeby").then(()=>parcelRequire('Yq9bP'));

});

parcelRegister("89Znr", function(module, exports) {

let $5f0ec633d8bea23b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f0ec633d8bea23b$var$load("2shw0").then(()=>parcelRequire('26Elb'));

});

parcelRegister("86ob4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $c34df63e628fa432$var$WidthObserverContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $c34df63e628fa432$export$75f7910544138d14 = ({ children: children })=>{
    const [elements, setElements] = (0, $42omo.useState)({});
    const [callbacks, setCallbacks] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        const handleResize = (entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('data-width-observer-id');
                if (id && callbacks[id]) {
                    const width = entry.contentRect.width;
                    callbacks[id].forEach((callback)=>callback(width));
                }
            });
        };
        const observer = new ResizeObserver(handleResize);
        Object.values(elements).forEach((element)=>observer.observe(element));
        return ()=>{
            observer.disconnect();
        };
    }, [
        elements,
        callbacks
    ]);
    const registerElement = (0, $42omo.useCallback)((id, element)=>{
        setElements((prev)=>({
                ...prev,
                [id]: element
            }));
    }, [
        setElements
    ]);
    const unregisterElement = (0, $42omo.useCallback)((id)=>{
        setElements((prev)=>{
            const newElements = {
                ...prev
            };
            delete newElements[id];
            return newElements;
        });
    }, [
        setElements
    ]);
    const subscribe = (0, $42omo.useCallback)((id, callback)=>{
        setCallbacks((prev)=>({
                ...prev,
                [id]: [
                    ...prev[id] || [],
                    callback
                ]
            }));
        return ()=>{
            setCallbacks((prev)=>({
                    ...prev,
                    [id]: (prev[id] || []).filter((cb)=>cb !== callback)
                }));
        };
    }, [
        setCallbacks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c34df63e628fa432$var$WidthObserverContext.Provider, {
        value: {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        }
    }, children);
};
const $c34df63e628fa432$export$b78842cb7cd02769 = ()=>{
    const context = (0, $42omo.useContext)($c34df63e628fa432$var$WidthObserverContext);
    if (!context) throw new Error('useWidthObserver must be used within a WidthObserverProvider');
    return context;
};
const $c34df63e628fa432$export$ad8c32a8eb05ab3d = (id, ref)=>{
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $c34df63e628fa432$export$b78842cb7cd02769();
    (0, $42omo.useEffect)(()=>{
        const element = ref.current;
        if (element) {
            element.setAttribute('data-width-observer-id', id);
            registerElement(id, element);
        }
        return ()=>{
            unregisterElement(id);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        ref,
        ref.current,
        // This is required as the useEffect is not triggered when ref.current becomes defined
        registerElement,
        unregisterElement
    ]);
};
const $c34df63e628fa432$export$f8586f54f6b8f867 = ({ id: id, children: children })=>{
    const elementRef = (0, $42omo.useRef)(null);
    $c34df63e628fa432$export$ad8c32a8eb05ab3d(id, elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: elementRef
    }, children);
};
const $c34df63e628fa432$export$1217913212f99c7 = (id)=>{
    const { subscribe: subscribe } = $c34df63e628fa432$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe(id, setWidth);
        return ()=>{
            unsubscribe();
        };
    }, [
        id,
        subscribe
    ]);
    return width;
};
const $c34df63e628fa432$export$f29cb180c1a7eb72 = ({ target: id, children: children })=>{
    const width = $c34df63e628fa432$export$1217913212f99c7(id);
    if (width === 0) return null;
    return children(width);
};
const $c34df63e628fa432$var$breakpoints = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1768
};
const $c34df63e628fa432$export$c44b7f69e7aa026 = ({ width: width, above: above, below: below })=>{
    return above && width > $c34df63e628fa432$var$breakpoints[above] || below && width < $c34df63e628fa432$var$breakpoints[below] || false;
};
const $c34df63e628fa432$export$f6a3d19be20f5819 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c34df63e628fa432$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($c34df63e628fa432$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    });
};
const $c34df63e628fa432$export$bed28288a051538 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c34df63e628fa432$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($c34df63e628fa432$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    });
};
module.exports["WidthObserverProvider"] = $c34df63e628fa432$export$75f7910544138d14;
module.exports["useWidthObserverRegistration"] = $c34df63e628fa432$export$ad8c32a8eb05ab3d;
module.exports["WidthObserverElement"] = $c34df63e628fa432$export$f8586f54f6b8f867;
module.exports["useElementWidth"] = $c34df63e628fa432$export$1217913212f99c7;
module.exports["Hide"] = $c34df63e628fa432$export$bed28288a051538;

});

parcelRegister("26jni", function(module, exports) {
/*
 * Minimize imports in this entrypoint to avoid increasing the product bundle size.
 */ 
var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $iA4lt = parcelRequire("iA4lt");


var $55aR8 = parcelRequire("55aR8");

const $955db7dbc0f43185$var$JIRA_PRODUCT_NAME = 'jira';
// This is referencing KnowledgeDiscoveryJiraIntentDetectionModel.GNIN_HEURISTIC from @atlassian/search-client package
// Do not import @atlassian/search-client package as it will increase the NIN bundle size. A unit test is associated to this reference.
// Update DEFAULT_MODEL_ID if the default model ID for intent detection changes
const $955db7dbc0f43185$var$DEFAULT_MODEL_ID = 'GNIN_HEURISTIC';
const $955db7dbc0f43185$var$navigationCtaVariants = [
    'control',
    'tabs',
    'button',
    'icons'
];
const $955db7dbc0f43185$export$2e05ac0a6fbb40c7 = (cohortValue)=>{
    return Boolean($955db7dbc0f43185$var$navigationCtaVariants.find((variant)=>cohortValue === variant));
};
const $955db7dbc0f43185$var$isEnglishLocale = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return Boolean(locale?.toLowerCase().startsWith('en'));
};
const $955db7dbc0f43185$export$f2e8952d10c578ba = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $955db7dbc0f43185$var$JIRA_PRODUCT_NAME) return undefined;
    // cohortForIntentDetectionExperiment AKA Experiment 2
    const intentDetectionExperiment = $955db7dbc0f43185$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: // Exposure should only be fired when intent detection has occured on Quick Find
        locale
    });
    const cohortForIntentDetectionExperiment = intentDetectionExperiment?.uiFeatures.navigationCTA;
    // Intent detection experiment takes priority on what CTA is used.
    // For example: If the Jira NIN FPS navigation experiment is decided and we start experiment 2, we still want to be able to set
    // different navigation CTAs in case we want to test different CTA variants in experiment 2.
    if (cohortForIntentDetectionExperiment) return {
        cohort: cohortForIntentDetectionExperiment,
        hideNavigationCTAOnGNIN: intentDetectionExperiment?.uiFeatures?.hideNavigationCTAOnGNIN,
        showQueryInHeader: intentDetectionExperiment?.uiFeatures?.showQueryInHeader
    };
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $dh538.fg)('rovo_jira_ui_experience_audience_gate')) return undefined;
    const layer = (0, $iA4lt.getMutuallyExclusiveUIExperiment)('rovo_jira_nin_fps_navigation_exp', 'rovo_jira_ui_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    // cohortForNinFpsExperiment AKA Experiment 1
    const cohortForNinFpsExperiment = layer?.get('cohort', undefined, $955db7dbc0f43185$export$2e05ac0a6fbb40c7);
    return {
        cohort: cohortForNinFpsExperiment,
        hideNavigationCTAOnGNIN: undefined,
        showQueryInHeader: undefined
    };
};
const $955db7dbc0f43185$export$cd09c61ec4486079 = {
    navigationCTA: 'button',
    hideFilterSuggestions: true,
    hideNavigationCTAOnGNIN: false,
    showMatchingWorkItem: true,
    showQueryInHeader: true,
    maxRecentQueryCountWhenNoSuggestions: 1
};
const $955db7dbc0f43185$var$variants = [
    'control',
    'test'
];
const $955db7dbc0f43185$var$serveJiraNINFpsNLQNavigationUserBased = ({ primaryProduct: primaryProduct, locale: locale } = {})=>{
    if (primaryProduct !== $955db7dbc0f43185$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $dh538.fg)('rovo_jira_intent_detection_audience_gate')) return undefined;
    if ($955db7dbc0f43185$var$isEnglishLocale(locale)) return {
        cohort: 'test',
        uiFeatures: $955db7dbc0f43185$export$cd09c61ec4486079,
        modelId: $955db7dbc0f43185$var$DEFAULT_MODEL_ID
    };
    // If not an english user, do not show intent detection
    return;
};
const $955db7dbc0f43185$var$serveMultiLangIntentDetection = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $955db7dbc0f43185$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $dh538.fg)('jira_fps_intent_classifier_fg') || $955db7dbc0f43185$var$isEnglishLocale(locale)) return;
    const experiment = (0, $c6GJD.default).getExperiment('rovo_jira_nin_fps_nlq_navigation_non_english_exp', {
        fireExperimentExposure: fireLayerExposure
    });
    const cohort = experiment?.get('cohort', undefined, (cohortValue)=>{
        return Boolean($955db7dbc0f43185$var$variants.find((variant)=>cohortValue === variant));
    });
    const uiFeaturesFromStatsig = experiment?.get('uiFeatures', {}, (uiFeaturesValue)=>{
        if (!uiFeaturesValue || typeof uiFeaturesValue !== 'object') return false;
        const isEnableControlIntentDetectionAnalyticsValid = 'enableControlIntentDetectionAnalytics' in uiFeaturesValue ? (0, $55aR8.jiraNINFpsNLQBooleanValidator)(uiFeaturesValue.enableControlIntentDetectionAnalytics) : true; // Undefined values are valid
        return isEnableControlIntentDetectionAnalyticsValid;
    }) ?? {};
    const modelId = experiment?.get('modelId', $955db7dbc0f43185$var$DEFAULT_MODEL_ID, (modelIdValue)=>typeof modelIdValue === 'string' && modelIdValue.length > 0) ?? $955db7dbc0f43185$var$DEFAULT_MODEL_ID;
    const uiFeaturesWithDefaults = {
        ...uiFeaturesFromStatsig,
        ...$955db7dbc0f43185$export$cd09c61ec4486079
    };
    return {
        cohort: cohort,
        uiFeatures: uiFeaturesWithDefaults,
        modelId: modelId
    };
};
const $955db7dbc0f43185$export$678dc8b37f93853d = (props = {})=>{
    // Holdout gate for the Carillon release (Jira's 3x/year rollout). Users in this holdout group
    // are opted out of intent detection, allowing different models to be tested against the holdout.
    if ((0, $dh538.fg)('rovo_jira_intent_detection_holdout')) // This is where the future intent detection experiments will live
    return undefined;
    const serveUserBasedExp = $955db7dbc0f43185$var$serveJiraNINFpsNLQNavigationUserBased(props);
    if (serveUserBasedExp) return serveUserBasedExp;
    return $955db7dbc0f43185$var$serveMultiLangIntentDetection(props);
};
const $955db7dbc0f43185$export$bf4748641fc251b9 = (primaryProduct, locale)=>{
    const experiment = $955db7dbc0f43185$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: locale
    });
    return experiment?.cohort === 'test' || experiment?.cohort === 'control' && (experiment?.uiFeatures.enableControlIntentDetectionAnalytics ?? false);
};
module.exports["serveJiraNinFpsNavigation"] = $955db7dbc0f43185$export$f2e8952d10c578ba;
module.exports["serveJiraNINFpsNLQNavigation"] = $955db7dbc0f43185$export$678dc8b37f93853d;
module.exports["isIntentDetectionTriggeredForExperiment"] = $955db7dbc0f43185$export$bf4748641fc251b9;

});

parcelRegister("RWXHe", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Shares a detached DOM node that the placement is portaled into.
 * PlacementSlot moves this node into the results list when it mounts.
 */ const $9d66e2ee6cb60186$var$PlacementPortalContainerContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $9d66e2ee6cb60186$export$a1158697c36e3e9e = ()=>(0, $42omo.useContext)($9d66e2ee6cb60186$var$PlacementPortalContainerContext);
const $9d66e2ee6cb60186$export$bdd60c847fd6f319 = $9d66e2ee6cb60186$var$PlacementPortalContainerContext.Provider;
const $9d66e2ee6cb60186$export$e2f7832e35c3b25 = ({ trackImpressionOnMount: trackImpressionOnMount } = {})=>{
    const slotRef = (0, $42omo.useRef)(null);
    const placementContainer = $9d66e2ee6cb60186$export$a1158697c36e3e9e();
    const trackImpression = $9d66e2ee6cb60186$export$28e9482e7fdec750();
    (0, $42omo.useLayoutEffect)(()=>{
        const slot = slotRef.current;
        if (slot && placementContainer) {
            placementContainer.style.display = '';
            slot.appendChild(placementContainer);
        }
        return ()=>{
            if (placementContainer) {
                placementContainer.style.display = 'none';
                placementContainer.remove();
            }
        };
    }, [
        placementContainer
    ]);
    (0, $42omo.useEffect)(()=>{
        if (trackImpressionOnMount) trackImpression?.();
    }, [
        trackImpressionOnMount,
        trackImpression
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: slotRef
    });
};
/**
 * Shares the trackImpression callback captured from the PostOffice placement's onMessageViewed.
 * This allows OAuthContainer to trigger the "viewed" event when the banner becomes visible.
 */ const $9d66e2ee6cb60186$var$TrackImpressionContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $9d66e2ee6cb60186$export$28e9482e7fdec750 = ()=>(0, $42omo.useContext)($9d66e2ee6cb60186$var$TrackImpressionContext);
const $9d66e2ee6cb60186$export$4a7d74782d15578 = $9d66e2ee6cb60186$var$TrackImpressionContext.Provider;
module.exports["usePlacementPortalContainer"] = $9d66e2ee6cb60186$export$a1158697c36e3e9e;
module.exports["PlacementPortalContainerProvider"] = $9d66e2ee6cb60186$export$bdd60c847fd6f319;
module.exports["PlacementSlot"] = $9d66e2ee6cb60186$export$e2f7832e35c3b25;
module.exports["TrackImpressionProvider"] = $9d66e2ee6cb60186$export$4a7d74782d15578;

});

parcelRegister("4mft4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $def8z = parcelRequire("def8z");

// Code taken from: platform/packages/ai-mate/conversation-assistant-utils/src/common/hooks/usePostOfficePlacement.ts




const $3b40788e1fe81951$export$b9e056b3d42aef4 = ()=>{
    const [PostOfficePlacement, setPostOfficePlacement] = (0, $42omo.useState)(null);
    const [isMounted, setIsMounted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            let isComponentMounted = true;
            // Check for mock in test environments (set by VR test)
            const mockModule = window.__mockPostOfficePlacement__;
            if (mockModule) {
                setPostOfficePlacement(()=>mockModule);
                setIsMounted(true);
                return;
            }
            (parcelRequire("8ACZc")).then((module)=>{
                if (isComponentMounted) {
                    setPostOfficePlacement(()=>module.Placement);
                    setIsMounted(true);
                }
            }).catch(()=>{
                // Silently fail if import fails - PostOfficePlacement will remain null
                // This prevents the component from being stuck in a loading state
                if (isComponentMounted) setIsMounted(true);
            });
            return ()=>{
                isComponentMounted = false;
            };
        }
    }, []);
    return {
        PostOfficePlacement: PostOfficePlacement,
        isMounted: isMounted
    };
};


const $9eb6b8b0a2d39d01$export$d6ffb4087f856769 = (configs, availableProductsOrder)=>{
    const ordered = {};
    for (const productKey of availableProductsOrder){
        const config = configs[productKey];
        if (config) ordered[productKey] = config;
    }
    return ordered;
};
const $9eb6b8b0a2d39d01$export$9c15322f536ac91d = (configs)=>{
    const entries = Object.entries(configs).filter((entry)=>{
        const [productKey, config] = entry;
        return (0, $b4tvS.is3pProductKey)(productKey) && config != null && config.outboundAuthUrl != null;
    });
    return entries.map(([productKey, config], index)=>{
        const isSmartlink = (0, $def8z.isProductSmartlink)({
            productKey: productKey,
            thirdPartyConfigs: configs
        });
        const connectorName = typeof config.displayName === 'string' ? config.displayName : '';
        return {
            connectorId: config.id,
            connectorIndex: index,
            connectorMode: isSmartlink ? (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE),
            connectorName: connectorName,
            connectorProductKey: productKey,
            icon: config.icon,
            oAuthUrl: config.outboundAuthUrl,
            userNeedsOAuth: config.userNeedsOAuth ?? false
        };
    });
};
const $9eb6b8b0a2d39d01$export$a26b2af93a17c1d9 = ({ placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, onMessageViewed: onMessageViewed })=>{
    const { PostOfficePlacement: PostOfficePlacement, isMounted: isMounted } = (0, $3b40788e1fe81951$export$b9e056b3d42aef4)();
    const orderedConfigs = (0, $42omo.useMemo)(()=>$9eb6b8b0a2d39d01$export$d6ffb4087f856769(thirdPartyConfigs, availableProductsOrder), [
        thirdPartyConfigs,
        availableProductsOrder
    ]);
    const availableConnectors = (0, $42omo.useMemo)(()=>$9eb6b8b0a2d39d01$export$9c15322f536ac91d(orderedConfigs), [
        orderedConfigs
    ]);
    // the props passed into the placement
    const placementProps = {
        availableConnectors: availableConnectors,
        useOAuthHandlers: useOAuthHandlers,
        onMessageViewed: onMessageViewed
    };
    if (!isMounted || !PostOfficePlacement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PostOfficePlacement, {
        placementId: placementId,
        placementProps: placementProps
    });
};
module.exports["orderConfigByProductOrder"] = $9eb6b8b0a2d39d01$export$d6ffb4087f856769;
module.exports["mapToAvailableConnectors"] = $9eb6b8b0a2d39d01$export$9c15322f536ac91d;
module.exports["BannerPlacement"] = $9eb6b8b0a2d39d01$export$a26b2af93a17c1d9;

});

parcelRegister("def8z", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $7151e4ce5e9c0a19$export$a3e2d74740ffbb74 = (productKey, thirdPartyConfigs)=>{
    if (!productKey) return true;
    const productConfig = thirdPartyConfigs[productKey];
    if (!productConfig) return true;
    return productConfig.datasources?.some((ds)=>!ds?.userNeedsOAuth) ?? false;
};
const $7151e4ce5e9c0a19$export$edde6dcae8734ece = ({ productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    const product3PConfig = productKey && (0, $b4tvS.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
    return product3PConfig?.connectorSources?.length === 1 && product3PConfig.connectorSources[0] === (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE);
};
const $7151e4ce5e9c0a19$export$e531e035689745ad = (thirdPartyConfigs)=>{
    if (!thirdPartyConfigs) return false;
    return Object.values(thirdPartyConfigs).some((config)=>!!config && !config.userNeedsOAuth && (config.connectorSources?.includes((0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE)) ?? false));
};
module.exports["isProductConnected"] = $7151e4ce5e9c0a19$export$a3e2d74740ffbb74;
module.exports["isProductSmartlink"] = $7151e4ce5e9c0a19$export$edde6dcae8734ece;
module.exports["hasAuthorisedSmartLinkConnector"] = $7151e4ce5e9c0a19$export$e531e035689745ad;

});

parcelRegister("8ACZc", function(module, exports) {

let $640fed52cf80e05e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $640fed52cf80e05e$var$load("cRtGo"),
    $640fed52cf80e05e$var$load("4qv8R"),
    $640fed52cf80e05e$var$load("6XaQi")
]).then(()=>parcelRequire('hWyCW'));

});

parcelRegister("gGFxq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dpPtd = parcelRequire("dpPtd");


var $cvXh8 = parcelRequire("cvXh8");


var $a3fRD = parcelRequire("a3fRD");


var $3uVVG = parcelRequire("3uVVG");


var $dh538 = parcelRequire("dh538");


var $7GE7t = parcelRequire("7GE7t");


var $johDC = parcelRequire("johDC");


var $flR86 = parcelRequire("flR86");


var $7YExv = parcelRequire("7YExv");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $7WbA8 = parcelRequire("7WbA8");


var $1ks6T = parcelRequire("1ks6T");


var $dnIVK = parcelRequire("dnIVK");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $djVCD = parcelRequire("djVCD");




const $68cc9d8799ebe4b1$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    understoodAction: {
        id: "oauth-banner.acknowledgement.success-flag-action",
        defaultMessage: "Understood"
    }
});


/**
 * Updates the in-memory bootstrap configs synchronously (for immediate UI feedback)
 * and asynchronously updates the combined-config promiseCache so that both the
 * in-memory cache and localStorage stay consistent for subsequent page loads.
 *
 * This always produces updated configs with userNeedsOAuth=false.
 */ const $b53784fc0aedebc4$var$refreshCombinedOAuthCache = (product, userId, cloudId, thirdPartyConfigs, datasourceId)=>{
    const newThirdPartyConfigs = {
        ...thirdPartyConfigs
    };
    const productKey = product;
    const existingConfig = newThirdPartyConfigs[productKey];
    if (existingConfig) {
        if (datasourceId) newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            datasources: existingConfig.datasources?.map((ds)=>ds.datasourceId === datasourceId ? {
                    ...ds,
                    userNeedsOAuth: false
                } : ds)
        };
        else newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            userNeedsOAuth: false
        };
    }
    const thirdPartyTypes = (0, $1ks6T.getThirdPartyTypes)();
    (0, $7GE7t.updateCombinedConfigCacheEntry)(userId, cloudId, (config)=>({
            ...config,
            thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                if (datasourceId) {
                    if (entry.datasourceId === datasourceId) return {
                        ...entry,
                        isUserOAuthed: true
                    };
                } else if (thirdPartyTypes[entry.name] === product) return {
                    ...entry,
                    isUserOAuthed: true
                };
                return entry;
            })
        }));
    return newThirdPartyConfigs;
};
const $b53784fc0aedebc4$export$4de3515a937b03f6 = ({ product: product, connectorSource: connectorSource, successFlagTitle: successFlagTitle, successFlagDescription: successFlagDescription, showUnderstoodButton: showUnderstoodButton = false, failFlagTitle: failFlagTitle, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction = ()=>{}, onDismissAction: onDismissAction = ()=>{}, onFailAction: onFailAction = ()=>{}, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, query: query = '', datasourceId: datasourceId, extraAttributes: extraAttributes })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [user] = (0, $j4ply.useUser)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const setThirdPartyConfigs = (0, $j4ply.useSetThirdPartyConfigs)();
    const onOAuthSuccess = (0, $j4ply.useOnOAuthSuccess)();
    // Keep a ref to the latest thirdPartyConfigs so that the onSuccess closure
    // (which fires asynchronously after the auth popup closes) always reads the
    // current store value instead of a stale captured snapshot.
    const thirdPartyConfigsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(thirdPartyConfigs);
    thirdPartyConfigsRef.current = thirdPartyConfigs;
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $djVCD.useSearchActions)();
    const { showFlag: showFlag, hideFlag: hideFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const oAuthAnalyticsProps = {
        product: product || '',
        connectorSource: connectorSource,
        cloudId: cloudId || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs,
        extraAttributes: extraAttributes
    };
    const fireOAuthStartedEvent = (0, $dnIVK.useFireOAuthStarted)(oAuthAnalyticsProps);
    const fireOAuthCompletedEvent = (0, $dnIVK.useFireOAuthCompleted)(oAuthAnalyticsProps);
    const fireOAuthFailedEvent = (0, $dnIVK.useFireOAuthFailed)(oAuthAnalyticsProps);
    const onSuccess = (oAuthSource)=>{
        fireOAuthCompletedEvent(oAuthSource);
        if (product === 'slack') (0, $flR86.sendSlackAuthSuccessRequest)({
            cloudId: cloudId
        });
        if (product === 'teams' && (0, $dh538.fg)('ai_3p_is_teams_platform_connector_enabled')) (0, $7YExv.sendTeamsAuthSuccessRequest)({
            cloudId: cloudId
        });
        onCompletedAction();
        const successFlagId = `oauth-success-flag-${product ?? 'unknown'}-${Date.now()}`;
        showFlag({
            id: successFlagId,
            title: successFlagTitle,
            ...successFlagDescription !== undefined && {
                description: successFlagDescription
            },
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            isAutoDismiss: true,
            ...showUnderstoodButton && {
                actions: [
                    {
                        content: formatMessage((0, $68cc9d8799ebe4b1$export$defe85febe8b728c).understoodAction),
                        onClick: ()=>hideFlag(successFlagId)
                    }
                ]
            }
        });
        if (onOAuthSuccess && (0, $dh538.fg)('rovo_fps_use_rovo_config')) onOAuthSuccess({
            product: product,
            datasourceId: datasourceId
        });
        else {
            const newOutboundAuthConfigs = $b53784fc0aedebc4$var$refreshCombinedOAuthCache(product, userId || '', cloudId || '', // Read from ref to get the latest store value, not the stale closure snapshot.
            thirdPartyConfigsRef.current || {}, datasourceId);
            setThirdPartyConfigs(newOutboundAuthConfigs);
        }
        (0, $johDC.searchPageQueryCache).clear();
        retrySearch();
        if (!isBulkConnect && isOnSearchDialog) {
            setQuickFindOpen(false);
            /* TODO: use onNavigate callback once bootstrap store is lifted. Details in https://hello.atlassian.net/wiki/spaces/CASE/pages/4670854655/3P+Discoverability+Bug
      const onNavigateCallback =
      	typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
      onNavigateCallback(
      	generateSearchUrl({
      		...queryParams,
      		text: query,
      		product: product,
      	}),
      	'push',
      );
      */ const searchUrl = generateSearchUrl({
                ...queryParams,
                text: query,
                product: product
            });
            window.location.href = searchUrl;
        }
    };
    //eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onFail = (oAuthSource, error)=>{
        fireOAuthFailedEvent(oAuthSource);
        onFailAction();
        showFlag({
            title: failFlagTitle,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            isAutoDismiss: true
        });
    };
    const onAuthorize = (oAuthSource)=>{
        fireOAuthStartedEvent(oAuthSource);
        (0, $3uVVG.auth)(outboundAuthUrl).then(()=>onSuccess(oAuthSource)).catch((error)=>onFail(oAuthSource, error));
    };
    const onDismiss = ()=>{
        onDismissAction();
    };
    return {
        onAuthorize: onAuthorize,
        onDismiss: onDismiss,
        onSuccess: onSuccess,
        onFail: onFail
    };
};
const $b53784fc0aedebc4$export$e90b3746b95097c9 = (productKey, selectedDatasourceId)=>{
    const [thirdPartyConfigsValue] = (0, $j4ply.useThirdPartyConfigs)();
    return $b53784fc0aedebc4$export$3515cf7f98d16dad(productKey, thirdPartyConfigsValue, selectedDatasourceId);
};
const $b53784fc0aedebc4$export$3515cf7f98d16dad = (productKey, thirdPartyConfigs, selectedDatasourceId)=>{
    let userNeedsOAuth, outboundAuthUrl;
    // Handle Forge connectors first (they're not in is3pProductKey)
    if (productKey && (0, $9d9t8.isForgeConnectorProductKey)(productKey)) {
        const productOutboundAuthConfig = thirdPartyConfigs[productKey];
        if (!productOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    if (!productKey || !(0, $b4tvS.is3pProductKey)(productKey)) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    // If datasource is provided, check specific datasource config
    if (selectedDatasourceId) {
        const datasourceOutboundAuthConfig = thirdPartyConfigs[productKey]?.datasources?.find((datasource)=>datasource.datasourceId === selectedDatasourceId);
        if (!datasourceOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = datasourceOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = datasourceOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    // If no datasource provided, check base product config
    const productOutboundAuthConfig = thirdPartyConfigs[productKey];
    if (!productOutboundAuthConfig) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
    outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
    return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
};
module.exports["useOAuthHandlers"] = $b53784fc0aedebc4$export$4de3515a937b03f6;
module.exports["useIsUserOAuthed"] = $b53784fc0aedebc4$export$e90b3746b95097c9;
module.exports["isUserOAuthed"] = $b53784fc0aedebc4$export$3515cf7f98d16dad;

});

parcelRegister("flR86", function(module, exports) {
const $d6887d0799a850df$export$e5c324cf2a7795e0 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeSlackUrl = `/gateway/api/third-party-user-auth/slack/user-authed`;
    const baseUrl = absoluteUrl || relativeSlackUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
module.exports["sendSlackAuthSuccessRequest"] = $d6887d0799a850df$export$e5c324cf2a7795e0;

});

parcelRegister("7YExv", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';
const $4d0ef623e71fa6bc$var$cache = (0, $hw4j5.inMemoryCache)();
const $4d0ef623e71fa6bc$export$a4f9b7f788f9e71f = (request)=>{
    const keyObj = {
        teamIds: request.teamIds.sort()
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
const $4d0ef623e71fa6bc$export$eb16261a2bb165d4 = async (request, onError)=>{
    return $4d0ef623e71fa6bc$var$cache.inMemoryDecorator($4d0ef623e71fa6bc$export$a4f9b7f788f9e71f(request), ()=>fetch($4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(request)
        }).then((response)=>{
            if (response.ok) return response.json();
            const errorMessage = `Unable to fetch ${$4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL}. ${response.statusText}`;
            onError?.(errorMessage);
            return Promise.reject({
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            });
        }).catch((error)=>{
            const errorMessage = `Unable to fetch ${$4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL}. ${error.message}`;
            onError?.(errorMessage);
            return {
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            };
        }));
};
const $4d0ef623e71fa6bc$export$5a635a8efc086412 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeTeamsUrl = `/gateway/api/third-party-user-auth/teams/user-authed`;
    const baseUrl = absoluteUrl || relativeTeamsUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
module.exports["fetchTeamsBulk"] = $4d0ef623e71fa6bc$export$eb16261a2bb165d4;
module.exports["sendTeamsAuthSuccessRequest"] = $4d0ef623e71fa6bc$export$5a635a8efc086412;

});

parcelRegister("ckkm9", function(module, exports) {

var $6yNqK = parcelRequire("6yNqK");

const $07e03f86f3cec1e3$export$caa1a4a1a0abbf91 = {
    quickFindFilter: 'quick-find-filter',
    quickFindOAuthBanner: 'quick-find-oauth-banner',
    quickFindBulkConnect: 'quick-find-bulk-connect',
    quickFindGithubTipBanner: 'quick-find-github-tip-banner',
    searchPageFilter: 'search-page-filter',
    searchPageOAuthBanner: 'search-page-oauth-banner',
    searchPageBulkConnect: 'search-page-bulk-connect',
    sainThirdPartyBanner: 'sain-third-party-banner'
};
const $07e03f86f3cec1e3$export$54863d2084195ac7 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'clicked',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $07e03f86f3cec1e3$export$1caeb8956b6720dc = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'completed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $07e03f86f3cec1e3$export$50898fe380812840 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'failed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $07e03f86f3cec1e3$export$b6f5ff07ced3e735 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'hovered',
        actionSubject: 'thirdPartyOAuth',
        actionSubjectId: 'thirdPartyOAuthConnectButton',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'ui'
    };
};
module.exports["OAuthSource"] = $07e03f86f3cec1e3$export$caa1a4a1a0abbf91;
module.exports["onOAuthStarted"] = $07e03f86f3cec1e3$export$54863d2084195ac7;
module.exports["onOAuthCompleted"] = $07e03f86f3cec1e3$export$1caeb8956b6720dc;
module.exports["onOAuthFailed"] = $07e03f86f3cec1e3$export$50898fe380812840;
module.exports["onOAuthConnectHovered"] = $07e03f86f3cec1e3$export$b6f5ff07ced3e735;

});

parcelRegister("6yNqK", function(module, exports) {
const $f8b501d0c94c20b2$export$e8d1ded05852e864 = {
    source: 'source'
};
const $f8b501d0c94c20b2$export$d1fe2a1199482e6d = {
    release: 'release',
    product: 'product',
    cloudId: 'cloudId',
    userId: 'userId',
    primaryProduct: 'primaryProduct',
    primaryProductFilterString: 'primaryProductFilterString',
    experimentId: 'experimentId',
    experimentLayers: 'experimentLayers',
    frontendExperiments: 'frontendExperiments',
    abTestId: 'abTestId',
    isHello: 'isHello',
    version: 'version',
    mode: 'mode',
    requestId: 'requestId',
    traceId: 'traceId'
};
const $f8b501d0c94c20b2$export$ed78826c06dd24e3 = 'fabric-elements';
const $f8b501d0c94c20b2$export$ad44d4a0591d8dba = 'advancedSearchScreen';
const $f8b501d0c94c20b2$export$1111f6e73bd7b1d8 = 'searchDialog';
const $f8b501d0c94c20b2$export$98bd2afc08f981ef = 'searchPage';
var $f8b501d0c94c20b2$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    return OptionIds;
}({});
const $f8b501d0c94c20b2$export$eed19b551669af14 = 'CURRENT';
const $f8b501d0c94c20b2$export$c936349447a77fe0 = 'ARCHIVED';
const $f8b501d0c94c20b2$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $f8b501d0c94c20b2$export$2be5c31192ba8783 = 'all';
const $f8b501d0c94c20b2$export$cabdc1d3c523c88 = 'fullPageSearchErrorScreen';
var $f8b501d0c94c20b2$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["PREQUERY"] = "PreQuery";
    return QueryState;
}({});
module.exports["DEFAULT_GAS_CHANNEL"] = $f8b501d0c94c20b2$export$ed78826c06dd24e3;
module.exports["EVENT_SOURCE"] = $f8b501d0c94c20b2$export$ad44d4a0591d8dba;
module.exports["SEARCH_DIALOG_EVENT_SOURCE"] = $f8b501d0c94c20b2$export$1111f6e73bd7b1d8;
module.exports["ACTION_SUBJECT_PREFIX"] = $f8b501d0c94c20b2$export$98bd2afc08f981ef;
module.exports["OptionIds"] = $f8b501d0c94c20b2$export$1118b8908e5d0501;
module.exports["CURRENT"] = $f8b501d0c94c20b2$export$eed19b551669af14;
module.exports["ARCHIVED"] = $f8b501d0c94c20b2$export$c936349447a77fe0;
module.exports["CROSSPRODUCT_SEARCH_API"] = $f8b501d0c94c20b2$export$a4c5cde0daa9b961;
module.exports["ALL_PRODUCTS_STRING"] = $f8b501d0c94c20b2$export$2be5c31192ba8783;
module.exports["ERROR_SCREEN_NAME"] = $f8b501d0c94c20b2$export$cabdc1d3c523c88;
module.exports["QueryState"] = $f8b501d0c94c20b2$export$15029b2eda44c6a7;

});

parcelRegister("gRvZB", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");

const $3f5a7948fe0e6fa1$export$b4d0899ce57e542f = (product, thirdPartyConfigs)=>{
    return !!(product && (0, $b4tvS.is3pProductKey)(product) ? thirdPartyConfigs[product]?.impersonationEnabled : false);
};
module.exports["isProductImpersonated"] = $3f5a7948fe0e6fa1$export$b4d0899ce57e542f;

});

parcelRegister("1ymk3", function(module, exports) {

var $4xBBd = parcelRequire("4xBBd");


var $6jKOp = parcelRequire("6jKOp");


var $gZjCQ = parcelRequire("gZjCQ");


var $atY36 = parcelRequire("atY36");


var $20r3r = parcelRequire("20r3r");

/**
 * Extracts the gateway object from the latest captured Relay extensions
 * for the given query type.
 */ const $42635ff5f86f7d1d$var$getLatestGateway = (isCQL)=>{
    const extensions = (0, $4xBBd.getExtensions)(isCQL ? (0, $atY36.default).operation.name : (0, $gZjCQ.default).operation.name)?.slice(-1)[0];
    return extensions?.gateway;
};
function $42635ff5f86f7d1d$export$4fff3ed4eba4f4ee(isCQL) {
    const gateway = $42635ff5f86f7d1d$var$getLatestGateway(isCQL);
    const traceId = gateway?.['trace_id'];
    const queryUpdatedAgo = (0, $20r3r.getQueryUpdatedTime)();
    return {
        traceId: traceId,
        queryUpdatedAgo: queryUpdatedAgo
    };
}
function $42635ff5f86f7d1d$export$7a619f7611b5a09e(isCQL) {
    const gateway = $42635ff5f86f7d1d$var$getLatestGateway(isCQL);
    if (!gateway) return undefined;
    return (0, $6jKOp.extractTraceInfoFromResponse)({
        extensions: {
            gateway: gateway
        }
    });
}
module.exports["getExtensionData"] = $42635ff5f86f7d1d$export$4fff3ed4eba4f4ee;
module.exports["getRelayNetworkTraceInfo"] = $42635ff5f86f7d1d$export$7a619f7611b5a09e;

});

parcelRegister("gZjCQ", function(module, exports) {
/**
 * @generated SignedSource<<02fb889fdd9e2c78738c3cbec0f2e51c>>
 * @relayHash ba2697f68f28654af56be27d88829658
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31b0d3ae9906b90be01c3dc54194ada330a65b0cd918c66f0d4cdbf7ee52d25d

var $5SuoG = parcelRequire("5SuoG");


var $aqtD4 = parcelRequire("aqtD4");


var $4PNBt = parcelRequire("4PNBt");


var $iLuVY = parcelRequire("iLuVY");

const $b96117069722906e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "expectResult"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAssigneeField"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeGithubCode"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeIconUrl"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraLiteModeFields"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeReactionsAndCommentCount"
    }, v22 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v33 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v34 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v35 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v36 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "expectResult",
            "variableName": "expectResult"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "locations.0",
                            "variableName": "cloudIdARI"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v37 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v38 = {
        "kind": "ScalarField",
        "name": "id"
    }, v39 = {
        "kind": "ScalarField",
        "name": "description"
    }, v40 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v41 = {
        "kind": "ScalarField",
        "name": "title"
    }, v42 = {
        "kind": "ScalarField",
        "name": "url"
    }, v43 = {
        "kind": "ScalarField",
        "name": "type"
    }, v44 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v45 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v46 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v47 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "value"
    }, v49 = {
        "kind": "ScalarField",
        "name": "label"
    }, v50 = [
        v49 /*: any*/ 
    ], v51 = {
        "kind": "ScalarField",
        "name": "key"
    }, v52 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v53 = [
        v52 /*: any*/ 
    ], v54 = {
        "condition": "includeIconUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": v53 /*: any*/ 
    }, v55 = {
        "kind": "ScalarField",
        "name": "name"
    }, v56 = [
        v55 /*: any*/ 
    ], v57 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v58 = {
        "kind": "ScalarField",
        "name": "total"
    }, v59 = {
        "kind": "ScalarField",
        "name": "count"
    }, v60 = [
        v38 /*: any*/ 
    ], v61 = {
        "kind": "InlineFragment",
        "selections": v60 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v62 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v63 = {
        "kind": "ScalarField",
        "name": "email"
    }, v64 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v65 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v55 /*: any*/ ,
                    v62 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v63 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v64 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v38 /*: any*/ 
                ]
            }
        ]
    }, v66 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v56 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v61 /*: any*/ 
        ]
    }, v67 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v68 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v67 /*: any*/ ,
                    v42 /*: any*/ ,
                    v45 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v61 /*: any*/ 
        ]
    }, v69 = [
        {
            "kind": "ScalarField",
            "name": "reactionType"
        },
        v58 /*: any*/ 
    ], v70 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v71 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v72 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": [
                    v55 /*: any*/ ,
                    v63 /*: any*/ ,
                    v62 /*: any*/ ,
                    v70 /*: any*/ ,
                    v71 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ]
    }, v73 = [
        v37 /*: any*/ ,
        v55 /*: any*/ ,
        v62 /*: any*/ ,
        v38 /*: any*/ 
    ], v74 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v73 /*: any*/ 
    }, v75 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v76 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v37 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v70 /*: any*/ ,
                                            v55 /*: any*/ ,
                                            v75 /*: any*/ ,
                                            v63 /*: any*/ ,
                                            v62 /*: any*/ ,
                                            v71 /*: any*/ ,
                                            v38 /*: any*/ 
                                        ],
                                        "type": "ThirdPartyUser"
                                    },
                                    v61 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v67 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v38 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v78 = [
        v38 /*: any*/ ,
        v55 /*: any*/ ,
        v63 /*: any*/ ,
        v62 /*: any*/ ,
        v70 /*: any*/ ,
        v71 /*: any*/ 
    ], v79 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v78 /*: any*/ 
            },
            {
                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                "kind": "LinkedField",
                "name": "linkedUsers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v37 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v55 /*: any*/ ,
                                            v62 /*: any*/ ,
                                            v38 /*: any*/ 
                                        ],
                                        "type": "AtlassianAccountUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v60 /*: any*/ ,
                                        "type": "AppUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v60 /*: any*/ ,
                                        "type": "CustomerUser"
                                    }
                                ]
                            },
                            v38 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v80 = [
        v38 /*: any*/ ,
        v55 /*: any*/ 
    ], v81 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v80 /*: any*/ 
    }, v82 = [
        v81 /*: any*/ 
    ], v83 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v82 /*: any*/ 
    }, v84 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v85 = {
        "kind": "ScalarField",
        "name": "status"
    }, v86 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v87 = [
        v55 /*: any*/ ,
        v38 /*: any*/ 
    ], v88 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v87 /*: any*/ 
    }, v89 = [
        v88 /*: any*/ 
    ], v90 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": v89 /*: any*/ 
    }, v91 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v89 /*: any*/ 
    }, v92 = [
        v37 /*: any*/ ,
        v55 /*: any*/ ,
        v38 /*: any*/ 
    ], v93 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v92 /*: any*/ 
    }, v94 = [
        v37 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v38 /*: any*/ ,
                v67 /*: any*/ 
            ],
            "type": "ExternalCustomerOrg"
        },
        v61 /*: any*/ 
    ], v95 = [
        v90 /*: any*/ 
    ], v96 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": v94 /*: any*/ 
    }, v97 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v98 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v82 /*: any*/ 
    }, v99 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v82 /*: any*/ 
    }, v100 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v101 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v102 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v103 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v104 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v105 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v106 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v55 /*: any*/ ,
            v75 /*: any*/ ,
            v63 /*: any*/ ,
            v62 /*: any*/ ,
            v70 /*: any*/ ,
            v71 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v107 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v108 = [
        v44 /*: any*/ ,
        v52 /*: any*/ 
    ], v109 = [
        {
            "kind": "ScalarField",
            "name": "targetDate"
        },
        {
            "kind": "ScalarField",
            "name": "targetDateType"
        }
    ], v110 = [
        v44 /*: any*/ 
    ], v111 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v112 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": v87 /*: any*/ 
    }, v113 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v114 = [
        v51 /*: any*/ ,
        v38 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeAssigneeField",
                            "variableName": "includeAssigneeField"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeGithubCode",
                            "variableName": "includeGithubCode"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeIconUrl",
                            "variableName": "includeIconUrl"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraLiteModeFields",
                            "variableName": "includeJiraLiteModeFields"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeReactionsAndCommentCount",
                            "variableName": "includeReactionsAndCommentCount"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v26 /*: any*/ ,
                v2 /*: any*/ ,
                v34 /*: any*/ ,
                v24 /*: any*/ ,
                v8 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v23 /*: any*/ ,
                v1 /*: any*/ ,
                v25 /*: any*/ ,
                v33 /*: any*/ ,
                v4 /*: any*/ ,
                v35 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v11 /*: any*/ ,
                v30 /*: any*/ ,
                v12 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v9 /*: any*/ ,
                v16 /*: any*/ ,
                v20 /*: any*/ ,
                v14 /*: any*/ ,
                v22 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v17 /*: any*/ ,
                v15 /*: any*/ ,
                v21 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "search",
                            "args": v36 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "asyncSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCachedResult"
                                },
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v37 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "concreteType": "SearchLinkedResult",
                                                    "kind": "LinkedField",
                                                    "name": "linkedResults",
                                                    "plural": true,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        v40 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v47 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isSearchResult"
                                                },
                                                v41 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "goal",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareLocalizationField",
                                                                            "kind": "LinkedField",
                                                                            "name": "localizedLabel",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "messageId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v48 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v50 /*: any*/ 
                                                                },
                                                                v38 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        v54 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasGoal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPrivate"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "dueDate",
                                                                    "plural": false,
                                                                    "selections": v50 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareProjectState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        v48 /*: any*/ 
                                                                    ]
                                                                },
                                                                v38 /*: any*/ ,
                                                                v51 /*: any*/ 
                                                            ]
                                                        },
                                                        v54 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "SearchFederatedEmailUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "sender",
                                                                            "plural": false,
                                                                            "selections": v56 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "SearchFederatedEmailEntity"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultFederated"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tier"
                                                        },
                                                        {
                                                            "concreteType": "CompassComponent",
                                                            "kind": "LinkedField",
                                                            "name": "component",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                v38 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ownerId"
                                                        }
                                                    ],
                                                    "type": "SearchResultCompassComponent"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v57 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        {
                                                            "concreteType": "SearchConfluenceResultSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUiLink"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceCommentCountSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "commentCountSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceLikesSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "likesSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v59 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                v61 /*: any*/ 
                                                            ]
                                                        },
                                                        v65 /*: any*/ ,
                                                        v54 /*: any*/ ,
                                                        {
                                                            "condition": "includeNavBoostScore",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "navBoostScore"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v57 /*: any*/ ,
                                                        v54 /*: any*/ 
                                                    ],
                                                    "type": "SearchConfluenceSpace"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v47 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "permissionLevel"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v55 /*: any*/ ,
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalBranch"
                                                                },
                                                                v61 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v68 /*: any*/ ,
                                                                        {
                                                                            "condition": "includeReactionsAndCommentCount",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalReaction",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reactionsV2",
                                                                                    "plural": true,
                                                                                    "selections": v69 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        v72 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v74 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCommit"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v67 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalSpace"
                                                                                },
                                                                                v61 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalReaction",
                                                                            "kind": "LinkedField",
                                                                            "name": "reactions",
                                                                            "plural": true,
                                                                            "selections": v69 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDocumentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "type",
                                                                            "plural": false,
                                                                            "selections": v53 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalLargeContent",
                                                                            "kind": "LinkedField",
                                                                            "name": "nonIndexableContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaThumbnailUrl"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "parent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v67 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalDocument"
                                                                                },
                                                                                v61 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeThirdPartyId",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "thirdPartyId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeReactionsAndCommentCount",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v70 /*: any*/ ,
                                                                        v76 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalAttachment",
                                                                            "kind": "LinkedField",
                                                                            "name": "attachments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mimeType"
                                                                                },
                                                                                v42 /*: any*/ ,
                                                                                v77 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v79 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v67 /*: any*/ ,
                                                                                        v83 /*: any*/ ,
                                                                                        v43 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v84 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "membershipType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "ExternalConversation"
                                                                                },
                                                                                v61 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastActive"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "reactionCount"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalMessage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v84 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v37 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalConversation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v85 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        },
                                                                        v86 /*: any*/ ,
                                                                        v90 /*: any*/ ,
                                                                        v91 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCampaign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayNumber"
                                                                        },
                                                                        v85 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "closedAt"
                                                                        },
                                                                        v86 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "owners",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v88 /*: any*/ ,
                                                                                v93 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v91 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": v94 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v67 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "contributors",
                                                                                    "plural": true,
                                                                                    "selections": v82 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v95 /*: any*/ 
                                                                        },
                                                                        v96 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalCustomerOrgLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "customerOrgLastActivity",
                                                                            "plural": false,
                                                                            "selections": v97 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerOrg"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "stage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "dealClosedAt"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDealLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "lastActivity",
                                                                            "plural": false,
                                                                            "selections": v97 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v95 /*: any*/ 
                                                                        },
                                                                        v96 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDeal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v68 /*: any*/ ,
                                                                        v98 /*: any*/ ,
                                                                        v99 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        v85 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v68 /*: any*/ ,
                                                                        v98 /*: any*/ ,
                                                                        v99 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v85 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "team"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalWorkItemProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "workItemProject",
                                                                            "plural": false,
                                                                            "selections": v80 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": v56 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalWorkItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v41 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pullRequestId"
                                                                        },
                                                                        {
                                                                            "alias": "pullRequestStatus",
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "durationInSeconds"
                                                                        },
                                                                        v77 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalChapter",
                                                                            "kind": "LinkedField",
                                                                            "name": "chapters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "startTimeInSeconds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "createdBy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v81 /*: any*/ ,
                                                                                v93 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        v101 /*: any*/ ,
                                                                        v90 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDashboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataTableType",
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v101 /*: any*/ ,
                                                                        v90 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDataTable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountName"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "contactUser",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartyUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "thirdPartyUser",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v55 /*: any*/ ,
                                                                                        v71 /*: any*/ ,
                                                                                        v38 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerContact"
                                                                }
                                                            ]
                                                        },
                                                        v102 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v99 /*: any*/ ,
                                                                        v103 /*: any*/ ,
                                                                        v104 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "recurringEventId"
                                                                        },
                                                                        v105 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCalendarEvent"
                                                                },
                                                                v61 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalThumbnail",
                                                                            "kind": "LinkedField",
                                                                            "name": "thumbnail",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDesign"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphDocument",
                                                            "kind": "LinkedField",
                                                            "name": "linkedEntities",
                                                            "plural": true,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v104 /*: any*/ ,
                                                                                v103 /*: any*/ ,
                                                                                v105 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalCalendarEvent"
                                                                        },
                                                                        v61 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v67 /*: any*/ ,
                                                                                v72 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v79 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "container",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v37 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v83 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ],
                                                                                            "type": "ExternalConversation"
                                                                                        },
                                                                                        v61 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v70 /*: any*/ ,
                                                                                v76 /*: any*/ ,
                                                                                v39 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalMessage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v39 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalConversation"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parentId"
                                                                },
                                                                v102 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ThirdPartyUser",
                                                                    "kind": "LinkedField",
                                                                    "name": "initialContributors",
                                                                    "plural": true,
                                                                    "selections": v78 /*: any*/ 
                                                                },
                                                                v46 /*: any*/ ,
                                                                v106 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "initialContributors",
                                                            "plural": true,
                                                            "selections": [
                                                                v55 /*: any*/ ,
                                                                v62 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v63 /*: any*/ ,
                                                                v70 /*: any*/ ,
                                                                v71 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphTab",
                                                            "kind": "LinkedField",
                                                            "name": "tabs",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tabId"
                                                                },
                                                                v41 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v101 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphAttachment",
                                                            "kind": "LinkedField",
                                                            "name": "attachments",
                                                            "plural": true,
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileType"
                                                                },
                                                                v42 /*: any*/ ,
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "containerName"
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "allContributors",
                                                            "plural": true,
                                                            "selections": v80 /*: any*/ 
                                                        },
                                                        v106 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "links"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkedEntitiesType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorProduct"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SearchSlackReaction",
                                                                    "kind": "LinkedField",
                                                                    "name": "topReaction",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "emojiName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "emojiUrl"
                                                                        },
                                                                        v59 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultGraphDocument"
                                                },
                                                {
                                                    "condition": "includeGithubCode",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "path"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "language"
                                                                },
                                                                v44 /*: any*/ ,
                                                                {
                                                                    "concreteType": "SearchResultCodeRepository",
                                                                    "kind": "LinkedField",
                                                                    "name": "repository",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v55 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "namespace"
                                                                        },
                                                                        v42 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultGraphCode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        v52 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeAvatarUrl"
                                                                },
                                                                v107 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v87 /*: any*/ 
                                                                        },
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "project"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v37 /*: any*/ ,
                                                                                        v55 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": v80 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v38 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                                                },
                                                                {
                                                                    "condition": "includeAssigneeField",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                            "kind": "LinkedField",
                                                                            "name": "assigneeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v74 /*: any*/ ,
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraPriorityField",
                                                                            "kind": "LinkedField",
                                                                            "name": "priorityField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v52 /*: any*/ ,
                                                                                        v55 /*: any*/ ,
                                                                                        v38 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraLabelsField",
                                                                            "kind": "LinkedField",
                                                                            "name": "labelsField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 5
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v56 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:5)"
                                                                                },
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectKey"
                                                        },
                                                        v44 /*: any*/ ,
                                                        v52 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v107 /*: any*/ ,
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "lead",
                                                                            "plural": false,
                                                                            "selections": v73 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectStyle"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectType"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraProjectCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "category",
                                                                            "plural": false,
                                                                            "selections": v87 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v38 /*: any*/ 
                                                            ]
                                                        },
                                                        v65 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultJiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "SearchResultJiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        v52 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraBoard",
                                                            "kind": "LinkedField",
                                                            "name": "board",
                                                            "plural": false,
                                                            "selections": [
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardFrontendUrl"
                                                                },
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "SearchResultJiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "SearchResultJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v51 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                    "kind": "LinkedField",
                                                                    "name": "health",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v51 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "color"
                                                                        },
                                                                        v67 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v109 /*: any*/ 
                                                                },
                                                                v38 /*: any*/ ,
                                                                v55 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryFocusAreaType",
                                                                    "kind": "LinkedField",
                                                                    "name": "focusAreaType",
                                                                    "plural": false,
                                                                    "selections": v80 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "owner",
                                                                    "plural": false,
                                                                    "selections": v92 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v44 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultMercuryFocusArea"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": v87 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "SearchResultMercuryFocusAreaStatusUpdate"
                                                },
                                                {
                                                    "condition": "includePassionfruitAsk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SpfAsk",
                                                                    "kind": "LinkedField",
                                                                    "name": "ask",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v85 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "SpfAskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v109 /*: any*/ 
                                                                        },
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                },
                                                                v44 /*: any*/ 
                                                            ],
                                                            "type": "SearchResultSpfAsk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v110 /*: any*/ ,
                                                    "type": "SearchResultTrelloBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v110 /*: any*/ ,
                                                    "type": "SearchResultTrelloCard"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsSchema",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectSchemaEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v111 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectSchema"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v112 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObjectType",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectTypeEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsIcon",
                                                                            "kind": "LinkedField",
                                                                            "name": "icon",
                                                                            "plural": false,
                                                                            "selections": v113 /*: any*/ 
                                                                        },
                                                                        v111 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectType"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v112 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": v113 /*: any*/ 
                                                                        },
                                                                        v111 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObject"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePositions",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "RadarPosition",
                                                                    "kind": "LinkedField",
                                                                    "name": "position",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RadarWorker",
                                                                            "kind": "LinkedField",
                                                                            "name": "worker",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "preferredName"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v37 /*: any*/ ,
                                                                                        v62 /*: any*/ ,
                                                                                        v38 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "fieldIdIsIn",
                                                                                    "value": [
                                                                                        "positionId",
                                                                                        "positionStatus",
                                                                                        "positionJobTitle",
                                                                                        "positionPositionTitle",
                                                                                        "positionKey",
                                                                                        "positionExternalPositionKey",
                                                                                        "positionWorker",
                                                                                        "focusArea"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "RadarFieldValueIdPair",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldValues",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldValue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v37 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "stringValue",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarStringFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "value",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "status",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v114 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "health",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v114 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "MercuryFocusArea"
                                                                                                        },
                                                                                                        v61 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarAriFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                                                        },
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultTalentPosition"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "traceId"
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "search",
                            "args": v36 /*: any*/ ,
                            "filters": [
                                "experience",
                                "enableHighlighting",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "expectResult",
                                "filters",
                                "analytics",
                                "experimentContext"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsAsyncPagination__search",
                            "kind": "LinkedHandle",
                            "name": "asyncSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "31b0d3ae9906b90be01c3dc54194ada330a65b0cd918c66f0d4cdbf7ee52d25d",
            "metadata": {},
            "name": "searchResultsAsyncQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $5SuoG.default),
                "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": (0, $aqtD4.default),
                "__relay_internal__pv__isdealownersenabledrelayprovider": (0, $4PNBt.default),
                "__relay_internal__pv__isslacktopreactionenabledrelayprovider": (0, $iLuVY.default)
            }
        }
    };
}();
$b96117069722906e$var$node.hash = "2743c8b60771ada5da19c7fa873fb168";
var $b96117069722906e$export$2e2bcd8739ae039 = $b96117069722906e$var$node;
module.exports["default"] = $b96117069722906e$export$2e2bcd8739ae039;

});

parcelRegister("5SuoG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a80efe5f48387681$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $a80efe5f48387681$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dh538.fg)('assets_rovo_search_all');
    }
};

});

parcelRegister("aqtD4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f237de69fbda33b3$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var // https://switcheroo.atlassian.com/ui/gates/6eab30ba-7a4d-456d-988a-2cd59bb9f4b1/key/is_customer_org_owners_enabled_in_ui
$f237de69fbda33b3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dh538.fg)('is_customer_org_owners_enabled_in_ui');
    }
};

});

parcelRegister("4PNBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cc92f2b68d213c5$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var //https://switcheroo.atlassian.com/ui/gates/30d75a94-370c-43aa-8931-79253af61396/key/is_deal_owners_enabled_in_ui
$3cc92f2b68d213c5$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dh538.fg)('is_deal_owners_enabled_in_ui');
    }
};

});

parcelRegister("iLuVY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1e92f0dfdeab4f2$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $d1e92f0dfdeab4f2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dh538.fg)('rovo_fps_show_slack_top_reaction_in_search');
    }
};

});

parcelRegister("atY36", function(module, exports) {
/**
 * @generated SignedSource<<df625124f44b47885d669da37cf29f51>>
 * @relayHash 68a75d183b7539fe986ed18773f1120a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76
const $e7a5cc53246246d5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v4 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v5 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        v4 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResultsCql_AtlassianSearchPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                            "kind": "LinkedField",
                                                            "name": "links",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webui"
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModified"
                                        },
                                        {
                                            "concreteType": "LinksContextBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "base"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "filters": [
                        "cql"
                    ],
                    "handle": "connection",
                    "key": "SearchResultsCQLPagination__confluence_search",
                    "kind": "LinkedHandle",
                    "name": "confluence_search"
                }
            ]
        },
        "params": {
            "id": "b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76",
            "metadata": {},
            "name": "searchResultsCqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e7a5cc53246246d5$var$node.hash = "8714af4459ffedbd0699977be49d7cf7";
var $e7a5cc53246246d5$export$2e2bcd8739ae039 = $e7a5cc53246246d5$var$node;
module.exports["default"] = $e7a5cc53246246d5$export$2e2bcd8739ae039;

});

parcelRegister("20r3r", function(module, exports) {

var $fXT59 = parcelRequire("fXT59");

const $4566ff69e3b9602b$export$fa81019546daea36 = (0, $fXT59.disposableValue)();
const $4566ff69e3b9602b$export$821c81800cc5b1e1 = ()=>{
    return $4566ff69e3b9602b$export$fa81019546daea36.value() || undefined;
};
const $4566ff69e3b9602b$export$c3c881dbbb056bcd = ()=>{
    $4566ff69e3b9602b$export$fa81019546daea36.update(Date.now());
};
const $4566ff69e3b9602b$export$99f330c261037d6f = ()=>{
    $4566ff69e3b9602b$export$fa81019546daea36.dispose();
};
module.exports["getQueryUpdatedTime"] = $4566ff69e3b9602b$export$821c81800cc5b1e1;
module.exports["setQueryUpdatedTime"] = $4566ff69e3b9602b$export$c3c881dbbb056bcd;
module.exports["disposeQueryUpdatedTime"] = $4566ff69e3b9602b$export$99f330c261037d6f;

});

parcelRegister("3CshZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6yNqK = parcelRequire("6yNqK");


var $9rRKJ = parcelRequire("9rRKJ");


var $7WbA8 = parcelRequire("7WbA8");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");





var $b4tvS = parcelRequire("b4tvS");


var $731W9 = parcelRequire("731W9");

const $727cf3a51c81de07$export$fe94072fee8a6976 = ({ searchSessionId: searchSessionId, requestId: requestId, searchQuery: searchQuery, inputQuery: inputQuery, filters: filters, queryUpdatedTime: queryUpdatedTime, productSelected: productSelected, availableProducts: availableProducts, sort: sort, experimentConfig: experimentConfig, applicationMode: applicationMode, productEdition: productEdition, isCQL: isCQL, isLiteMode: isLiteMode })=>{
    const { filterSelections: filterSelections, filters: filterCategories } = filters;
    const has3pProducts = !!availableProducts.find((product)=>(0, $b4tvS.is3pProductKey)(product));
    const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
    const is3pSearch = !!(has3pProducts && !productSelected || productSelected && (0, $b4tvS.is3pProductKey)(productSelected));
    const archivedStatus = filterSelections.some((selection)=>selection.value === (0, $6yNqK.OptionIds).ARCHIVED) ? [
        (0, $6yNqK.CURRENT),
        (0, $6yNqK.ARCHIVED)
    ] : [
        (0, $6yNqK.CURRENT)
    ];
    const commonAttributes = {
        searchSessionId: searchSessionId,
        traceId: requestId,
        productSelected: productSelected || (0, $6yNqK.ALL_PRODUCTS_STRING),
        availableProducts: availableProducts,
        mode: applicationMode,
        has3pProducts: has3pProducts,
        is3pSearch: is3pSearch,
        numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
        queryLength: searchQuery.length,
        inputQueryLength: inputQuery.length,
        queryHash: (0, $731W9.sha256Hash)(searchQuery),
        filters: filterCategories,
        filterSelections: filterSelections,
        containerStatuses: archivedStatus,
        contentStatuses: archivedStatus,
        productEdition: productEdition,
        frontendExperiments: {
            activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
            ...frontendExperiments
        },
        combinedExperiment: experimentConfig.combinedExperiment,
        version: 2,
        api: (0, $6yNqK.CROSSPRODUCT_SEARCH_API),
        wordCount: (searchQuery.match(/\w+/g) || []).length,
        isCQL: isCQL ?? false,
        queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
        sort: sort,
        isSearchPageRelay: true,
        isLiteMode: isLiteMode ?? false
    };
    const nonPrivacySafeAttributes = {
        query: searchQuery,
        inputQuery: inputQuery
    };
    return {
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};


const $484f7910e7f707a3$export$e955abb82869dc84 = (props = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // analytics attributes passed in from the product
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const [searchExperience] = (0, $djVCD.useSearchExperience)();
    const experiencePayload = (0, $42omo.useMemo)(()=>{
        // determine experience payload for analytics attributes, defaulting to store value if not provided
        const experience = props.experience || searchExperience;
        const isQuickFind = experience === (0, $9rRKJ.SearchExperience).QUICK_FIND;
        const isFullPageSearch = experience === (0, $9rRKJ.SearchExperience).SEARCH_PAGE;
        return {
            isFullPageSearch: isFullPageSearch,
            isQuickFind: isQuickFind
        };
    }, [
        props.experience,
        searchExperience
    ]);
    // use this hook to fire UI, track, and operational event types
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || (0, $6yNqK.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    // use this hook to fire screen event types
    const fireAnalyticsScreenEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: (0, $6yNqK.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $484f7910e7f707a3$export$58bac47385d8e8f4 = ()=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestId] = (0, $djVCD.useResultsRequestId)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $djVCD.useQueryUpdatedTime)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [sort] = (0, $djVCD.useResultsSort)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const filters = (0, $djVCD.useFilterAttributesForTracking)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    const cqlState = (0, $djVCD.useCQL)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [features] = (0, $j4ply.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    return (0, $727cf3a51c81de07$export$fe94072fee8a6976)({
        searchSessionId: searchSessionId,
        requestId: requestId,
        searchQuery: searchQuery,
        inputQuery: inputQuery,
        filters: filters,
        queryUpdatedTime: queryUpdatedTime,
        productSelected: productSelected,
        availableProducts: availableProducts,
        sort: sort,
        experimentConfig: experimentConfig,
        applicationMode: applicationMode,
        productEdition: productEdition,
        isCQL: !!cqlState,
        isLiteMode: isLiteMode,
        primaryProduct: primaryProduct,
        queryParams: queryParams
    });
};
module.exports["useAnalytics"] = $484f7910e7f707a3$export$e955abb82869dc84;
module.exports["useCommonAndPrivateAttributes"] = $484f7910e7f707a3$export$58bac47385d8e8f4;

});

parcelRegister("j4ply", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $5d9b4 = parcelRequire("5d9b4");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $cUcZ5 = parcelRequire("cUcZ5");


var $hm6w9 = parcelRequire("hm6w9");


var $9vOy1 = parcelRequire("9vOy1");


var $aaNIP = parcelRequire("aaNIP");


var $4cq9O = parcelRequire("4cq9O");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $8l0cM = parcelRequire("8l0cM");


var $2OtFZ = parcelRequire("2OtFZ");


var $c2HNo = parcelRequire("c2HNo");


var $2x777 = parcelRequire("2x777");


var $5XpfZ = parcelRequire("5XpfZ");


var $lIbf3 = parcelRequire("lIbf3");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");










parcelRequire("1yEFx");












var $lgPOO = parcelRequire("lgPOO");


var $32Kiv = parcelRequire("32Kiv");

const $66b8e22ddb9e6b9d$export$a607044ff61ed35a = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    // Unused, clean up when removing rovo-search-remove-rss-bootstrap-fg
    // Here due to type strictness on BootstrapState
    const unusedProps = {
        prevQueryParams: {},
        initialSpaceARIs: []
    };
    // `dynamicContext.thirdPartyConfigs` is only populated when
    // `rovo_fps_use_rovo_config` is ON. When the gate is OFF the dynamic
    // context value is `undefined`, and a naive `{ ...dynamicContext }` spread
    // would overwrite the populated `thirdPartyConfigs` coming from the
    // static context — breaking every consumer that destructures it from
    // `useBootstrap()` (e.g. universal-type filter resolution in the search
    // pipeline). Pick the dynamic value only when it's actually defined.
    // Remove this when rovo_fps_use_rovo_config is cleaned up
    const { thirdPartyConfigs: dynamicThirdPartyConfigs, ...dynamicContextRest } = dynamicContext;
    const mergedThirdPartyConfigs = dynamicThirdPartyConfigs ?? staticContext.thirdPartyConfigs;
    return [
        {
            ...unusedProps,
            ...staticContext,
            ...dynamicContextRest,
            thirdPartyConfigs: mergedThirdPartyConfigs
        }
    ];
};
const $66b8e22ddb9e6b9d$export$3129106711858d9e = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.applicationMode);
const $66b8e22ddb9e6b9d$export$8d72fbb40ea96b11 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.linkedCloudARIs);
const $66b8e22ddb9e6b9d$export$42159b7c323c1456 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.initialTextQueryParam);
const $66b8e22ddb9e6b9d$export$8b362261a7637697 = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.referrer;
};
const $66b8e22ddb9e6b9d$export$f84f93bb6857e6bf = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>{
        const primaryProduct = ctx.primaryProduct;
        if (!primaryProduct) return false;
        return primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).Atlas;
    });
/**
 * Retrieve third party configs from the static bootstrap store (legacy path).
 *
 * Used by `useThirdPartyConfigsContext` when `rovo_fps_use_rovo_config` is OFF.
 * On the FG-OFF path the value is seeded from `useFetchConfigLegacy` and only
 * mutated by `setThirdPartyConfigs` from the legacy OAuth handler.
 */ const $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromStaticContext = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.thirdPartyConfigs);
/**
 * Retrieve third party configs from the dynamic bootstrap context (FG-ON path).
 *
 * Under `rovo_fps_use_rovo_config`, `BootstrapContextProvider` routes
 * `thirdPartyConfigs` into dynamic context so reference changes from
 * `useRovoConfig.onOAuthSuccess` propagate via React's normal context
 * broadcast. Falls back to the static-context default if (somehow) the
 * dynamic value is undefined.
 */ const $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromDynamicContext = ()=>{
    const dynamic = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamic?.thirdPartyConfigs ?? $66b8e22ddb9e6b9d$var$defaultStaticContextThirdPartyConfigs;
};
const $66b8e22ddb9e6b9d$var$defaultStaticContextThirdPartyConfigs = {};
const $66b8e22ddb9e6b9d$export$e2860ebe87e62f0d = ()=>{
    // The dispatch below intentionally calls one of two hooks based on a
    // stable feature-gate value. Per `rovo_fps_use_rovo_config` rollout
    // semantics the gate result does not flip within a session, so the
    // hook call order is stable across renders for a given user — but
    // the react-hooks rule cannot statically prove this, so we disable
    // `rules-of-hooks` for both call sites in the ternary.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $dh538.fg)('rovo_fps_use_rovo_config') ? $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromDynamicContext() : $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromStaticContext();
/* eslint-enable react-hooks/rules-of-hooks */ };
const $66b8e22ddb9e6b9d$export$682b612810461522 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.productEdition);
const $66b8e22ddb9e6b9d$export$b238e8fc41384c76 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>!!ctx.rovoFeatures?.scas);
const $66b8e22ddb9e6b9d$export$120ac1729f38deb6 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.intercomHmac);
const $66b8e22ddb9e6b9d$export$db066d8e499b7f58 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentConfig);
const $66b8e22ddb9e6b9d$export$414e9503f60ee463 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.multiSiteSearchInRovo);
const $66b8e22ddb9e6b9d$export$a20db2e6915ac3c5 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.isHello);
const $66b8e22ddb9e6b9d$export$c3427a530f474eaf = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.searchSessionId;
};
const $66b8e22ddb9e6b9d$export$5abfe064a9321e1 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.nouns);
const $66b8e22ddb9e6b9d$export$aa1a270414bf62e1 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.products);
const $66b8e22ddb9e6b9d$export$da4da5285a2fd344 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.analyticsAttributes);
const $66b8e22ddb9e6b9d$export$f1c90440d6c09079 = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.smartLinkUsage;
};
const $66b8e22ddb9e6b9d$export$cf6799908f05fea7 = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.smartLinkUsageAndTopApps;
};
const $66b8e22ddb9e6b9d$export$4c06a80ce19ae7c8 = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return staticContext.isConfigLoaded;
};
const $66b8e22ddb9e6b9d$export$b79f482a36aed45 = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return (0, $42omo.useMemo)(()=>{
        return staticContext.products != null && staticContext.products.length > 0;
    }, [
        staticContext.products
    ]);
};
const $66b8e22ddb9e6b9d$export$c8d3ac176f5c521c = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return staticContext.experimentConfig.frontendExperiments;
};
const $66b8e22ddb9e6b9d$export$284401669662f77b = (args)=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    const { experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, experience: experience, cloudId: cloudId, isJiraIssueIndexed: isJiraIssueIndexed, isHello: isHello } = staticContext;
    return (0, $42omo.useMemo)(()=>{
        return (0, $hm6w9.getBackendExperiment)({
            experimentConfig: experimentConfig,
            entities: args.entities,
            productEdition: productEdition,
            isHello: isHello,
            productDataRegions: productDataRegions,
            experience: experience,
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }, [
        experimentConfig,
        productEdition,
        cloudId,
        productDataRegions,
        experience,
        isJiraIssueIndexed,
        args.entities,
        args.thirdPartyFilters,
        isHello
    ]);
};
const $66b8e22ddb9e6b9d$export$ce2438226fe8a866 = ()=>{
    const { onSearchCompleted: onSearchCompleted } = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return onSearchCompleted;
};
const $66b8e22ddb9e6b9d$export$de591553328a258f = ()=>{
    const { onOAuthSuccess: onOAuthSuccess } = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return onOAuthSuccess;
};
/**
 * Retrieve BootstrapVariables (with applied callback) from context.
 * Merges static and dynamic context, then applies the callback transformation.
 */ const $66b8e22ddb9e6b9d$var$_useBootstrapStateContextWithSelector = (cb)=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    const store = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext));
    // Select each field individually so Object.is comparison works on primitives/stable refs.
    // This ensures we only re-render when a field useQueryPlan reads actually changes.
    const cloudId = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.cloudId);
    const primaryProduct = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.primaryProduct);
    const primarySubProduct = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.primarySubProduct);
    // Under `rovo_fps_use_rovo_config`, `thirdPartyConfigs` is routed through
    // dynamic context (see `BootstrapContextProvider`). Pick the appropriate
    // source so that downstream consumers (e.g. useQueryPlan, analytics) see
    // post-OAuth reference changes without depending on the static-lock hack.
    const thirdPartyConfigsFromStatic = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.thirdPartyConfigs);
    const thirdPartyConfigs = (0, $dh538.fg)('rovo_fps_use_rovo_config') ? dynamicContext?.thirdPartyConfigs ?? $66b8e22ddb9e6b9d$var$defaultStaticContextThirdPartyConfigs : thirdPartyConfigsFromStatic;
    const experimentConfig = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.experimentConfig);
    const experimentLayers = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.experimentLayers);
    const products = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.products);
    const allFilterExcludedProducts = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.allFilterExcludedProducts);
    const productEdition = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.productEdition);
    const productDataRegions = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.productDataRegions);
    const isJiraIssueIndexed = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.isJiraIssueIndexed);
    const isRovoEnabled = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.isRovoEnabled);
    const user = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.user);
    const nouns = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.nouns);
    const overrides = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.overrides);
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const context = (0, $42omo.useMemo)(()=>{
        return cb({
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            thirdPartyConfigs: thirdPartyConfigs,
            searchSessionId: dynamicContext?.searchSessionId,
            experimentConfig: experimentConfig,
            experimentLayers: experimentLayers,
            products: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isRovoEnabled: isRovoEnabled,
            user: user,
            nouns: nouns,
            referrer: dynamicContext?.referrer,
            ...enableRovoSearchOverrides && {
                overrides: overrides
            }
        });
    }, [
        cloudId,
        primaryProduct,
        primarySubProduct,
        thirdPartyConfigs,
        experimentConfig,
        experimentLayers,
        products,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        isJiraIssueIndexed,
        isRovoEnabled,
        user,
        nouns,
        overrides,
        enableRovoSearchOverrides,
        dynamicContext?.searchSessionId,
        dynamicContext?.referrer,
        cb
    ]);
    return context;
};
const $66b8e22ddb9e6b9d$export$f58a6d0fc9e4868e = $66b8e22ddb9e6b9d$var$_useBootstrapStateContextWithSelector;
const $66b8e22ddb9e6b9d$export$38c566c0640fb69a = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.features);
const $66b8e22ddb9e6b9d$export$4fcccae6c9e96003 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.cloudId);
const $66b8e22ddb9e6b9d$export$76d8dfaa701293d9 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.orgId);
const $66b8e22ddb9e6b9d$export$742cda9929e8b50c = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.primaryProduct);
const $66b8e22ddb9e6b9d$export$e0c045bdef566c47 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.primarySubProduct);
const $66b8e22ddb9e6b9d$export$8bff48fd870f30 = ()=>{
    return []; // no longer used, remove when cleaning up fg rovo-search-remove-rss-bootstrap-fg
};
const $66b8e22ddb9e6b9d$export$87c54b525b914dab = ()=>(0, $2x777.getUser)((0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.user));
const $66b8e22ddb9e6b9d$export$c7a275b1a627c5f0 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.SAINHostName);
const $66b8e22ddb9e6b9d$export$6f099dbd230ba66f = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.hasEditOrViewPlanPermission ?? false);
const $66b8e22ddb9e6b9d$export$9df89e94884205e9 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.isRovoEnabled ?? false);
const $66b8e22ddb9e6b9d$export$803daaa2f0fbbc6e = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentLayers ?? []);
const $66b8e22ddb9e6b9d$export$eac498b27b856e7c = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.user?.id);
const $66b8e22ddb9e6b9d$export$b69f9d68446c9dad = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    const { products: products, primaryProduct: primaryProduct, isRovoEnabled: isRovoEnabled } = staticContext;
    const { product: currentSelectedProduct, cql: currentCql } = dynamicContext.queryParams;
    const applicationMode = (0, $c2HNo.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    });
    const primaryProductToSelect = (0, $8l0cM.productKeySchema).safeParse(primaryProduct);
    const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $9vOy1.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $b4tvS.ProductKeys).Atlas;
    if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
    else return null;
};
const $66b8e22ddb9e6b9d$export$e3421d27ae244aa = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.queryParams?.type === (0, $2Znam.TypeFilterValueKey).Incident;
};
const $66b8e22ddb9e6b9d$export$25662b49e6b8f72d = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.queryParams;
};
const $66b8e22ddb9e6b9d$export$7061561fd19f7ef1 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.aggregatorHostName);
const $66b8e22ddb9e6b9d$export$5ff79b6adc9830a0 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.aggAbsoluteUrl);
const $66b8e22ddb9e6b9d$export$bc37b6cf798ce4a = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.allFilterExcludedProducts);
const $66b8e22ddb9e6b9d$export$b3275ad39f44e473 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.productDataRegions);
const $66b8e22ddb9e6b9d$export$7b21d1d3f4e52ac8 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.isJiraIssueIndexed);














const $952088699c3cc644$export$ae43642c556804c9 = (queryParams)=>{
    const hostProductSetQueryParamsCallback = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.queryParamsCallback);
    const setQueryParamsCallback = (0, $42omo.useCallback)((newParams)=>{
        const areEqualQueryParams = (0, $lIbf3.areAllEqualQueryParams)(newParams, queryParams ?? {});
        if (areEqualQueryParams) return;
        const rawQueryParams = (0, $lIbf3.toQueryParamsRaw)(newParams);
        hostProductSetQueryParamsCallback(rawQueryParams);
    }, [
        queryParams,
        hostProductSetQueryParamsCallback
    ]);
    return setQueryParamsCallback;
};
const $952088699c3cc644$export$8eb026c9237da68b = ()=>{
    const refreshSearchSessionId = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.refreshSearchSessionId);
    return refreshSearchSessionId;
};
const $952088699c3cc644$export$6372fdd1070e00df = ()=>{
    const clearReferrer = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.clearReferrer);
    return clearReferrer;
};
const $952088699c3cc644$export$b2cdbc1165101e18 = ()=>{
    const setThirdPartyConfigs = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.setThirdPartyConfigs);
    return setThirdPartyConfigs;
};



var $gSaNw = parcelRequire("gSaNw");

const $ee8d6df68f0b570c$export$e324594224ef24da = {
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setThirdPartyConfigs = useSetThirdPartyConfigs()`
   */ setThirdPartyConfigs: (configs)=>({ setState: setState })=>{
            setState({
                thirdPartyConfigs: configs
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setQueryParams = useSetQueryParams()`
   */ setQueryParams: (queryParam)=>({}, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            const areEqualQueryParams = (0, $lIbf3.areAllEqualQueryParams)(queryParam, (0, $lIbf3.parseQueryParams)(queryParams ?? {}));
            if (areEqualQueryParams) return;
            queryParamsCallback((0, $lIbf3.toQueryParamsRaw)(queryParam));
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   *
   * You should not ever need to call this directly. Open a thread in #help-search-plex and tag @rwasher, @sogrady, @jquach, if you find you need to!
   */ syncQueryParams: ()=>({ setState: setState, getState: getState }, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            // queryParams is the query params coming from the URL or React Router in this case
            const { prevQueryParams: prevQueryParams, // Previously saved query params - this is to prevent infinitely updating queryParams
            queryParams: diffQueryParamsState // The 'internal' query params state
             } = getState();
            const queryParamsURL = (0, $lIbf3.parseQueryParams)(queryParams ?? {});
            const prevQueryParamsString = (0, $lIbf3.toQueryString)(prevQueryParams);
            const diffQueryParamsURLString = (0, $lIbf3.toQueryString)(queryParamsURL);
            const diffQueryParamsStateString = (0, $lIbf3.toQueryString)(diffQueryParamsState);
            const allQueryParamsAreEqual = (0, $lIbf3.areAllEqualQueryParams)(queryParamsURL, prevQueryParams, diffQueryParamsState);
            if (allQueryParamsAreEqual) return;
            // Any changes from the url takes the highest precedence
            const hasURLQueryParams = !!queryParams;
            if (hasURLQueryParams && prevQueryParamsString !== diffQueryParamsURLString) {
                setState({
                    prevQueryParams: queryParamsURL,
                    queryParams: queryParamsURL
                });
                return;
            }
            if (prevQueryParamsString !== diffQueryParamsStateString) {
                //  NOTE: If you are running the callback and you don't see the query params being updated,
                //  the callback might be sanitising the query parameters. This is the case for Confluence.
                queryParamsCallback((0, $lIbf3.toQueryParamsRaw)(diffQueryParamsState));
                setState({
                    prevQueryParams: diffQueryParamsState,
                    queryParams: diffQueryParamsState
                });
                return;
            }
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const refreshSearchSessionId = useRefreshSearchSessionId()`
   */ refreshSearchSessionId: ()=>({ setState: setState })=>{
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            setState({
                searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const clearReferrer = useClearReferrer()`
   */ clearReferrer: ()=>({ setState: setState })=>{
            setState({
                referrer: undefined
            });
        }
};
const $ee8d6df68f0b570c$var$buildProducts = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
// Keep store private and use hooks to access state and actions
const $ee8d6df68f0b570c$var$Store = (0, $1P1Tu.createStore)({
    initialState: $aaNIP.initialState,
    actions: $ee8d6df68f0b570c$export$e324594224ef24da,
    name: 'bootstrap'
});
const $ee8d6df68f0b570c$export$543309f9b943a423 = {
    onInit: ()=>({ getState: getState, setState: setState }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $lIbf3.parseQueryParams)(queryParams);
            setState({
                ...getState(),
                ...initialProps,
                ...queryParams && {
                    queryParams: parsedQueryParams
                },
                referrer: parsedQueryParams?.referrer,
                initialTextQueryParam: parsedQueryParams?.text,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                searchSessionId: initialProps.searchSessionId || (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $lIbf3.parseQueryParams)(queryParams);
            const currentState = getState();
            const products = $ee8d6df68f0b570c$var$buildProducts(currentState.products, initialProps?.products ?? []);
            // Merge thirdPartyConfigs so that OAuth-updated entries (set via
            // setThirdPartyConfigs with userNeedsOAuth: false) are not
            // overwritten by the stale consumer-provided value on re-renders,
            // while still picking up new/updated entries from the host app.
            //
            // IMPORTANT: We only create a new object when an actual override is
            // needed. If nothing changed, we preserve the incoming reference to
            // avoid unnecessary re-renders in RSS store subscribers (e.g.
            // useFetchResultsProps depends on thirdPartyConfigs by reference).
            const incomingThirdPartyConfigs = initialProps?.thirdPartyConfigs;
            const currentThirdPartyConfigs = currentState.thirdPartyConfigs;
            let mergedThirdPartyConfigs = incomingThirdPartyConfigs;
            if (incomingThirdPartyConfigs && currentThirdPartyConfigs) {
                // Check whether any entries need to be preserved from the current store
                let hasOverrides = false;
                for (const key of Object.keys(currentThirdPartyConfigs)){
                    const currentEntry = currentThirdPartyConfigs[key];
                    const incomingEntry = incomingThirdPartyConfigs[key];
                    if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) {
                        hasOverrides = true;
                        break;
                    }
                }
                // Only create a new object if we actually need to override something
                if (hasOverrides) {
                    mergedThirdPartyConfigs = {
                        ...incomingThirdPartyConfigs
                    };
                    for (const key of Object.keys(currentThirdPartyConfigs)){
                        const currentEntry = currentThirdPartyConfigs[key];
                        const incomingEntry = mergedThirdPartyConfigs[key];
                        if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) mergedThirdPartyConfigs[key] = currentEntry;
                    }
                }
            }
            setState({
                ...currentState,
                ...initialProps,
                ...mergedThirdPartyConfigs !== undefined && {
                    thirdPartyConfigs: mergedThirdPartyConfigs
                },
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess,
                products: products,
                referrer: parsedQueryParams?.referrer
            });
            dispatch($ee8d6df68f0b570c$export$e324594224ef24da.syncQueryParams());
        }
};
const $ee8d6df68f0b570c$export$557bf45c8d0f5bd = (0, $FOT9i.createContainer)($ee8d6df68f0b570c$var$Store, $ee8d6df68f0b570c$export$543309f9b943a423);
const $ee8d6df68f0b570c$export$cf715ed8590c209b = (0, $9zUhf.createActionsHook)($ee8d6df68f0b570c$var$Store);
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * This is being actively migrated away from in QS-9194
 *
 * Instead use specific per-value accessors from this file, including for actions if they are present
 *
 * e.g. const [{ useCloudId, useQueryParams }, { useSetQueryParams }] = useBootstrap()
 * -> const [cloudId] = useCloudId();
 * -> const [queryParams] = useQueryParams();
 * -> const setQueryParams = useSetQueryParams();
 */ const $ee8d6df68f0b570c$var$useBootstrapStore = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store);
const $ee8d6df68f0b570c$export$9ba1f1f28043c5bf = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $66b8e22ddb9e6b9d$export$a607044ff61ed35a)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$useBootstrapStore()[0]
    ];
};
const $ee8d6df68f0b570c$export$9ec3accb60f929bc = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $ee8d6df68f0b570c$export$610b442bd2bdbce2 = (cb)=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$f58a6d0fc9e4868e)(cb) : $ee8d6df68f0b570c$export$9ec3accb60f929bc(cb);
};
const $ee8d6df68f0b570c$export$9d56bc2341757114 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.analyticsAttributes
});
const $ee8d6df68f0b570c$export$1fd8522aeddaccda = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$da4da5285a2fd344)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$9d56bc2341757114()[0]
    ];
};
const $ee8d6df68f0b570c$export$7ea98f64fcaf4bba = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products
});
const $ee8d6df68f0b570c$export$5afbfe6edea8e998 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$aa1a270414bf62e1)() : $ee8d6df68f0b570c$export$7ea98f64fcaf4bba();
};
const $ee8d6df68f0b570c$export$eac7f1ebb1342f3d = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.nouns
});
const $ee8d6df68f0b570c$export$6019aa9111ebc3a2 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$5abfe064a9321e1)() : $ee8d6df68f0b570c$export$eac7f1ebb1342f3d();
};
const $ee8d6df68f0b570c$export$5668414148ce6645 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products && state.products.length > 0
});
const $ee8d6df68f0b570c$export$9e9836415b9aa240 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$b79f482a36aed45)() : $ee8d6df68f0b570c$export$5668414148ce6645();
};
const $ee8d6df68f0b570c$export$38f7f3dced53e226 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products.length === 0
});
const $ee8d6df68f0b570c$export$f7c6299b3492081c = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        !(0, $66b8e22ddb9e6b9d$export$b79f482a36aed45)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$38f7f3dced53e226()[0]
    ];
};
const $ee8d6df68f0b570c$export$740fb20e7075dfd2 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.primaryProduct
});
const $ee8d6df68f0b570c$export$92c6f3c7c09f3247 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$742cda9929e8b50c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$740fb20e7075dfd2()[0]
    ];
};
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * Instead use usePrimarySubProduct in bootstrap/index.tsx
 */ const $ee8d6df68f0b570c$var$usePrimarySubProductStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.primarySubProduct
});
const $ee8d6df68f0b570c$export$baffb23dea1bbe6d = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$e0c045bdef566c47)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$usePrimarySubProductStore()
    ];
};
const $ee8d6df68f0b570c$export$85911a18814719bc = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.searchSessionId
});
const $ee8d6df68f0b570c$export$e1e7a4797df1a656 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$c3427a530f474eaf)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$85911a18814719bc()[0]
    ];
};
const $ee8d6df68f0b570c$export$ecbe89dec8c82f9a = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>(0, $5XpfZ.isHello)(state.cloudId)
});
const $ee8d6df68f0b570c$export$1a0be923fb1117e4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$a20db2e6915ac3c5)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$ecbe89dec8c82f9a()[0]
    ];
};
const $ee8d6df68f0b570c$export$ecc663167952d044 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.features
});
const $ee8d6df68f0b570c$export$4a39035bacc4ed76 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$38c566c0640fb69a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$ecc663167952d044()[0]
    ];
};
const $ee8d6df68f0b570c$export$766d82ac8f8b178e = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state, args)=>{
        return (0, $hm6w9.getBackendExperiment)({
            experimentConfig: state.experimentConfig,
            entities: args.entities,
            productEdition: state.productEdition,
            isHello: (0, $5XpfZ.isHello)(state.cloudId),
            productDataRegions: state.productDataRegions,
            experience: (0, $4cq9O.SEARCH_PAGE),
            tenantId: state.cloudId,
            isJiraIssueIndexed: state.isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }
});
const $ee8d6df68f0b570c$export$9e89c81d9ff2c758 = (args)=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$284401669662f77b)(args)
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$766d82ac8f8b178e(args)[0]
    ];
};
const $ee8d6df68f0b570c$export$76b3461be06c4ce4 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentConfig.frontendExperiments
});
const $ee8d6df68f0b570c$export$d2c28b106f1bf70b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$c8d3ac176f5c521c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$76b3461be06c4ce4()[0]
    ];
};
const $ee8d6df68f0b570c$export$3e826cc2f34e3f9f = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.smartLinkUsage
});
const $ee8d6df68f0b570c$export$61c62393cc326189 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$f1c90440d6c09079)() : $ee8d6df68f0b570c$export$3e826cc2f34e3f9f();
};
const $ee8d6df68f0b570c$export$c0ee253dbeb5b16e = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.smartLinkUsageAndTopApps
});
const $ee8d6df68f0b570c$export$88d4bb46312ff031 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$cf6799908f05fea7)() : $ee8d6df68f0b570c$export$c0ee253dbeb5b16e();
};
const $ee8d6df68f0b570c$export$89824387636c5038 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>(0, $2OtFZ.getMultiSiteSearchInRovo)(state.experimentConfig)
});
const $ee8d6df68f0b570c$export$1e668811222ead9b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$414e9503f60ee463)() : $ee8d6df68f0b570c$export$89824387636c5038();
};
const $ee8d6df68f0b570c$export$5ecdff6d23ea5c41 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.user?.id
});
const $ee8d6df68f0b570c$export$761b9f1acd811a4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$eac498b27b856e7c)() : $ee8d6df68f0b570c$export$5ecdff6d23ea5c41();
};
const $ee8d6df68f0b570c$export$7bafc36c74b1b9af = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentConfig
});
const $ee8d6df68f0b570c$export$b9e6179ff71a6122 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$db066d8e499b7f58)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$7bafc36c74b1b9af()[0]
    ];
};
const $ee8d6df68f0b570c$export$f0fa22420f7c521e = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.intercomHmac
});
const $ee8d6df68f0b570c$export$8ab143228c6f49a2 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$120ac1729f38deb6)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$f0fa22420f7c521e()[0]
    ];
};
/**
 * @deprecated
 * https://hello.atlassian.net/wiki/x/bKRdZAE
 */ const $ee8d6df68f0b570c$var$useApplicationModeStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.isRovoEnabled
    ], (isRovoEnabled)=>(0, $c2HNo.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        }))
});
const $ee8d6df68f0b570c$export$150d84149ef86e81 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$3129106711858d9e)() : $ee8d6df68f0b570c$var$useApplicationModeStore();
};
const $ee8d6df68f0b570c$export$ac142617c8f07aa9 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $66b8e22ddb9e6b9d$export$8d72fbb40ea96b11)()
    ] : [
        $ee8d6df68f0b570c$export$6fa68bea98f6275f()[0]
    ];
};
const $ee8d6df68f0b570c$export$84529f276bb721c4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$42159b7c323c1456)() : $ee8d6df68f0b570c$export$5b08efe445210431();
};
const $ee8d6df68f0b570c$export$e99d08753f6dce85 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $66b8e22ddb9e6b9d$export$8b362261a7637697)()
    ] : [
        $ee8d6df68f0b570c$export$956b416c80bdc23b()[0]
    ];
};
const $ee8d6df68f0b570c$export$cc885caaa8b7ab4e = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>{
        const user = state.user;
        return (0, $2x777.getUser)(user);
    }
});
const $ee8d6df68f0b570c$export$23bbbc4533528f03 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$87c54b525b914dab)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$cc885caaa8b7ab4e()[0]
    ];
};
const $ee8d6df68f0b570c$export$956b416c80bdc23b = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.referrer
});
const $ee8d6df68f0b570c$export$5b08efe445210431 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.initialTextQueryParam
});
const $ee8d6df68f0b570c$export$aef5773142a94889 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.orgId
});
const $ee8d6df68f0b570c$export$52a03a3207af3687 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$76d8dfaa701293d9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$aef5773142a94889()[0]
    ];
};
const $ee8d6df68f0b570c$export$d875bd9731f2aec2 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.cloudId
    ], (cloudId)=>cloudId)
});
const $ee8d6df68f0b570c$export$9da0f7c65f28ed16 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$4fcccae6c9e96003)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$d875bd9731f2aec2()[0]
    ];
};
const $ee8d6df68f0b570c$export$6fa68bea98f6275f = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.linkedCloudARIs
});
const $ee8d6df68f0b570c$export$4e035a5c2351d2e5 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.products,
        (state)=>state.primaryProduct,
        (state)=>state.isRovoEnabled,
        (state)=>state.queryParams.product,
        (state)=>state.queryParams.cql
    ], (products, primaryProduct, isRovoEnabled, currentSelectedProduct, currentCql)=>{
        const applicationMode = (0, $c2HNo.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        });
        const primaryProductToSelect = (0, $8l0cM.productKeySchema).safeParse(primaryProduct);
        const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $9vOy1.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $b4tvS.ProductKeys).Atlas;
        if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
        else return null;
    })
});
const $ee8d6df68f0b570c$export$c7f4a8f2f4902c5b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$b69f9d68446c9dad)() : $ee8d6df68f0b570c$export$4e035a5c2351d2e5();
};
const $ee8d6df68f0b570c$export$cfec170a04b8b09e = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.isConfigLoaded
    ], (isConfigLoaded)=>isConfigLoaded)
});
const $ee8d6df68f0b570c$export$dfc6af34d0b0a7e1 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$4c06a80ce19ae7c8)() : $ee8d6df68f0b570c$export$cfec170a04b8b09e();
};
const $ee8d6df68f0b570c$export$826527619b7a782d = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>!!state.rovoFeatures?.scas
});
const $ee8d6df68f0b570c$export$27738d748ac05943 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$b238e8fc41384c76)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$826527619b7a782d()[0]
    ];
};
const $ee8d6df68f0b570c$export$479cadf76e337ced = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.productEdition
});
const $ee8d6df68f0b570c$export$83e4de12d3240f53 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$682b612810461522)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$479cadf76e337ced()[0]
    ];
};
const $ee8d6df68f0b570c$export$7c7bef429afbfd0f = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.queryParams?.type === (0, $2Znam.TypeFilterValueKey).Incident
});
const $ee8d6df68f0b570c$export$98a75a8d27d2d106 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$e3421d27ae244aa)() : $ee8d6df68f0b570c$export$7c7bef429afbfd0f();
};
const $ee8d6df68f0b570c$export$d37ccf8bdc15c61 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.thirdPartyConfigs
});
const $ee8d6df68f0b570c$export$a66178d9c618d6dc = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$e2860ebe87e62f0d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$d37ccf8bdc15c61()[0]
    ];
};
const $ee8d6df68f0b570c$export$4470b3b80d2a1efd = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>{
        const primaryProduct = state.primaryProduct;
        if (!primaryProduct) return false;
        return primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).Atlas;
    }
});
const $ee8d6df68f0b570c$export$12942aa91b162c95 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $66b8e22ddb9e6b9d$export$f84f93bb6857e6bf)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    $ee8d6df68f0b570c$export$4470b3b80d2a1efd();
};
const $ee8d6df68f0b570c$export$fa705064035366ce = (queryParams)=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { setQueryParams: setQueryParamsStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const setQueryParamsContext = (0, $952088699c3cc644$export$ae43642c556804c9)(queryParams);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsStore;
};
const $ee8d6df68f0b570c$export$3b183e08127f60ee = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { refreshSearchSessionId: refreshSearchSessionIdStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const refreshSearchSessionIdContext = (0, $952088699c3cc644$export$8eb026c9237da68b)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdStore;
};
const $ee8d6df68f0b570c$export$c6dd687c49bf782b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { clearReferrer: clearReferrerStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const clearReferrerContext = (0, $952088699c3cc644$export$6372fdd1070e00df)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerStore;
};
const $ee8d6df68f0b570c$export$556790c5329d7a06 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { setThirdPartyConfigs: setThirdPartyConfigsStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const setThirdPartyConfigsContext = (0, $952088699c3cc644$export$b2cdbc1165101e18)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsStore;
};
const $ee8d6df68f0b570c$export$9145e6ed5e8754d7 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.onSearchCompleted
});
const $ee8d6df68f0b570c$export$b9665757e0cd2a7 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const onSearchCompletedStore = $ee8d6df68f0b570c$export$9145e6ed5e8754d7();
    const onSearchCompletedContext = (0, $66b8e22ddb9e6b9d$export$ce2438226fe8a866)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedStore ?? (()=>{});
};
const $ee8d6df68f0b570c$export$8dbc380ce96047bb = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.onOAuthSuccess
});
const $ee8d6df68f0b570c$export$d5e98fc55a6be8ab = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const onOAuthSuccessStore = $ee8d6df68f0b570c$export$8dbc380ce96047bb();
    const onOAuthSuccessContext = (0, $66b8e22ddb9e6b9d$export$de591553328a258f)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessStore;
};
const $ee8d6df68f0b570c$export$94c4fbf6686bd545 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.queryParams
});
const $ee8d6df68f0b570c$export$b37ee0d76c6d2fbc = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$25662b49e6b8f72d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$94c4fbf6686bd545()
    ];
};
const $ee8d6df68f0b570c$export$6a2137557a0d64b6 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.aggregatorHostName
});
const $ee8d6df68f0b570c$export$ee782f3c04c9ae8b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$7061561fd19f7ef1)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$6a2137557a0d64b6()
    ];
};
const $ee8d6df68f0b570c$export$c9561269f12847d9 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.aggAbsoluteUrl
});
const $ee8d6df68f0b570c$export$c61c0a9ee44eb20d = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$5ff79b6adc9830a0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$c9561269f12847d9()
    ];
};
const $ee8d6df68f0b570c$export$a622d298cd701527 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $ee8d6df68f0b570c$export$5f38673942a99ffe = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$bc37b6cf798ce4a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$a622d298cd701527()
    ];
};
const $ee8d6df68f0b570c$export$46b088d1cfd71b45 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.productDataRegions
});
const $ee8d6df68f0b570c$export$7b2a84178d2593d6 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$b3275ad39f44e473)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$46b088d1cfd71b45()
    ];
};
const $ee8d6df68f0b570c$export$34ca8c3e8a50a02f = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.isJiraIssueIndexed
});
const $ee8d6df68f0b570c$export$fbf3e851fc33b7ac = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$7b21d1d3f4e52ac8)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$34ca8c3e8a50a02f()
    ];
};
const $ee8d6df68f0b570c$export$81f625b5a645837d = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.initialSpaceARIs
});
const $ee8d6df68f0b570c$export$dbfb675a6b71c171 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$8bff48fd870f30)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$81f625b5a645837d()
    ];
};
const $ee8d6df68f0b570c$export$9f206c50663dec0 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.SAINHostName
});
const $ee8d6df68f0b570c$export$3a6ef70862d81412 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$c7a275b1a627c5f0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$9f206c50663dec0()
    ];
};
const $ee8d6df68f0b570c$export$9f9ac629bd95fe42 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.hasEditOrViewPlanPermission
});
const $ee8d6df68f0b570c$export$ef5d8e24d9af554f = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$6f099dbd230ba66f)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$9f9ac629bd95fe42() ?? false
    ];
};
const $ee8d6df68f0b570c$var$useIsRovoEnabledStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.isRovoEnabled
});
const $ee8d6df68f0b570c$export$1deffd91058f2ec4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$9df89e94884205e9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$useIsRovoEnabledStore()
    ];
};
const $ee8d6df68f0b570c$var$useExperimentLayersStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentLayers
});
const $ee8d6df68f0b570c$export$e157d3c129f2f296 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$803daaa2f0fbbc6e)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$useExperimentLayersStore()
    ];
};
module.exports["BootstrapStoreContainer"] = $ee8d6df68f0b570c$export$557bf45c8d0f5bd;
module.exports["useBootstrap"] = $ee8d6df68f0b570c$export$9ba1f1f28043c5bf;
module.exports["useBootstrapState"] = $ee8d6df68f0b570c$export$610b442bd2bdbce2;
module.exports["useAnalyticsAttributes"] = $ee8d6df68f0b570c$export$1fd8522aeddaccda;
module.exports["useAvailableProducts"] = $ee8d6df68f0b570c$export$5afbfe6edea8e998;
module.exports["useAvailableNouns"] = $ee8d6df68f0b570c$export$6019aa9111ebc3a2;
module.exports["useBootstrapLoading"] = $ee8d6df68f0b570c$export$f7c6299b3492081c;
module.exports["usePrimaryProduct"] = $ee8d6df68f0b570c$export$92c6f3c7c09f3247;
module.exports["usePrimarySubProduct"] = $ee8d6df68f0b570c$export$baffb23dea1bbe6d;
module.exports["useSearchSessionId"] = $ee8d6df68f0b570c$export$e1e7a4797df1a656;
module.exports["useIsHello"] = $ee8d6df68f0b570c$export$1a0be923fb1117e4;
module.exports["useFeatures"] = $ee8d6df68f0b570c$export$4a39035bacc4ed76;
module.exports["useSmartLinkUsage"] = $ee8d6df68f0b570c$export$61c62393cc326189;
module.exports["useSmartLinkUsageAndTopApps"] = $ee8d6df68f0b570c$export$88d4bb46312ff031;
module.exports["useCurrentUserId"] = $ee8d6df68f0b570c$export$761b9f1acd811a4;
module.exports["useExperimentConfig"] = $ee8d6df68f0b570c$export$b9e6179ff71a6122;
module.exports["useIntercomHmac"] = $ee8d6df68f0b570c$export$8ab143228c6f49a2;
module.exports["useApplicationMode"] = $ee8d6df68f0b570c$export$150d84149ef86e81;
module.exports["useReferrer"] = $ee8d6df68f0b570c$export$e99d08753f6dce85;
module.exports["useUser"] = $ee8d6df68f0b570c$export$23bbbc4533528f03;
module.exports["useOrgId"] = $ee8d6df68f0b570c$export$52a03a3207af3687;
module.exports["useCloudId"] = $ee8d6df68f0b570c$export$9da0f7c65f28ed16;
module.exports["useAutoSelectPrimaryProduct"] = $ee8d6df68f0b570c$export$c7f4a8f2f4902c5b;
module.exports["useIsConfigLoaded"] = $ee8d6df68f0b570c$export$dfc6af34d0b0a7e1;
module.exports["useProductEdition"] = $ee8d6df68f0b570c$export$83e4de12d3240f53;
module.exports["useIsTypeFilteredToIncident"] = $ee8d6df68f0b570c$export$98a75a8d27d2d106;
module.exports["useThirdPartyConfigs"] = $ee8d6df68f0b570c$export$a66178d9c618d6dc;
module.exports["useFiltersDiscoverability2Enabled"] = $ee8d6df68f0b570c$export$12942aa91b162c95;
module.exports["useSetQueryParams"] = $ee8d6df68f0b570c$export$fa705064035366ce;
module.exports["useRefreshSearchSessionId"] = $ee8d6df68f0b570c$export$3b183e08127f60ee;
module.exports["useClearReferrer"] = $ee8d6df68f0b570c$export$c6dd687c49bf782b;
module.exports["useSetThirdPartyConfigs"] = $ee8d6df68f0b570c$export$556790c5329d7a06;
module.exports["useOnSearchCompleted"] = $ee8d6df68f0b570c$export$b9665757e0cd2a7;
module.exports["useOnOAuthSuccess"] = $ee8d6df68f0b570c$export$d5e98fc55a6be8ab;
module.exports["useQueryParams"] = $ee8d6df68f0b570c$export$b37ee0d76c6d2fbc;
module.exports["useAggAbsoluteUrl"] = $ee8d6df68f0b570c$export$c61c0a9ee44eb20d;
module.exports["useAllFilterExcludedProducts"] = $ee8d6df68f0b570c$export$5f38673942a99ffe;
module.exports["useProductDataRegions"] = $ee8d6df68f0b570c$export$7b2a84178d2593d6;
module.exports["useIsJiraIssueIndexed"] = $ee8d6df68f0b570c$export$fbf3e851fc33b7ac;
module.exports["useInitialSpaceARIs"] = $ee8d6df68f0b570c$export$dbfb675a6b71c171;
module.exports["useExperimentLayers"] = $ee8d6df68f0b570c$export$e157d3c129f2f296;

});

parcelRegister("9vOy1", function(module, exports) {
const $b77a737dcc9ce237$export$f1263520d5e0f007 = {
    Unified: 'unified',
    Rovo: 'rovo'
};
module.exports["ApplicationModes"] = $b77a737dcc9ce237$export$f1263520d5e0f007;

});

parcelRegister("aaNIP", function(module, exports) {
const $30eb242a9c2a82fe$export$d4c72bab9d6cc13a = {
    products: [],
    nouns: [],
    allFilterExcludedProducts: [],
    thirdPartyConfigs: {},
    searchSessionId: '',
    queryParams: {},
    prevQueryParams: {},
    overrides: undefined,
    initialSpaceARIs: [],
    experimentConfig: {
        backendExperiment: undefined,
        frontendExperiments: undefined,
        dynamicExperiments: undefined,
        combinedExperiment: undefined
    },
    experimentLayers: [],
    isRovoEnabled: false,
    isConfigLoaded: false,
    rovoFeatures: {},
    isJiraIssueIndexed: false,
    productEdition: undefined,
    productDataRegions: undefined,
    linkedCloudARIs: undefined,
    analyticsAttributes: undefined,
    aggAbsoluteUrl: undefined,
    cloudId: undefined,
    aggregatorHostName: undefined,
    SAINHostName: undefined,
    user: undefined,
    primaryProduct: undefined,
    primarySubProduct: undefined,
    orgId: undefined,
    intercomHmac: undefined,
    referrer: undefined,
    initialTextQueryParam: undefined,
    features: undefined,
    hasEditOrViewPlanPermission: false,
    onSearchCompleted: undefined,
    onOAuthSuccess: undefined,
    smartLinkUsage: undefined,
    smartLinkUsageAndTopApps: undefined
};
module.exports["initialState"] = $30eb242a9c2a82fe$export$d4c72bab9d6cc13a;

});

parcelRegister("4cq9O", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $9acf3b09df50dcf8$export$944168d706dc6466 = 'search-page';
module.exports["SEARCH_PAGE"] = $9acf3b09df50dcf8$export$944168d706dc6466;

});

parcelRegister("c2HNo", function(module, exports) {

var $9vOy1 = parcelRequire("9vOy1");

const $756ce5dc2839a0b3$export$daea4e28213a211a = ({ isRovoEnabled: isRovoEnabled })=>{
    if (isRovoEnabled) return (0, $9vOy1.ApplicationModes).Rovo;
    return (0, $9vOy1.ApplicationModes).Unified;
};
module.exports["getApplicationMode"] = $756ce5dc2839a0b3$export$daea4e28213a211a;

});

parcelRegister("2x777", function(module, exports) {

var $lwP5K = parcelRequire("lwP5K");

const $5f9d799009d34522$export$7cbf767827cd68ba = (user)=>{
    if (!user || !user.id) return {
        status: (0, $lwP5K.UserStatus).Unauthenticated,
        id: null,
        name: null,
        email: null
    };
    if (user.id === 'unidentified') return {
        status: (0, $lwP5K.UserStatus).Anonymous,
        ...user
    };
    return {
        status: (0, $lwP5K.UserStatus).Authenticated,
        ...user
    };
};
module.exports["getUser"] = $5f9d799009d34522$export$7cbf767827cd68ba;

});

parcelRegister("lwP5K", function(module, exports) {
var $049f30ab6612ce17$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Unauthenticated"] = "unauthenticated";
    UserStatus["Anonymous"] = "anonymous";
    UserStatus["Authenticated"] = "authenticated";
    return UserStatus;
}({});
var $049f30ab6612ce17$export$b259bb7f1faab8ee = /*#__PURE__*/ function(LinkDocContentType) {
    LinkDocContentType["extractedLink"] = "extractedLink";
    LinkDocContentType["boostedLink"] = "boostedLink";
    return LinkDocContentType;
}({});
module.exports["UserStatus"] = $049f30ab6612ce17$export$a82073022ded66e8;
module.exports["LinkDocContentType"] = $049f30ab6612ce17$export$b259bb7f1faab8ee;

});

parcelRegister("5XpfZ", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $26280c05cdeea98c$export$cbfae22cc278acfc = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $26280c05cdeea98c$export$8e3fc93123f96c19 = (cloudId)=>cloudId === $26280c05cdeea98c$export$cbfae22cc278acfc;
module.exports["isHello"] = $26280c05cdeea98c$export$8e3fc93123f96c19;

});

parcelRegister("gkXKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $dbl1i = parcelRequire("dbl1i");


var $4OGlb = parcelRequire("4OGlb");


var $hm6w9 = parcelRequire("hm6w9");


var $iA4lt = parcelRequire("iA4lt");

const $ddee69ce44809421$export$fd4704975f80304e = (layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    try {
        if (!layerName) return {
            frontendExperiment: undefined,
            backendExperiment: (0, $hm6w9.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
        const layer = (0, $c6GJD.default).getLayer(layerName, {
            fireLayerExposure: false
        });
        const frontendExperimentName = layer.get('frontendExperimentName', '');
        if (frontendExperimentName) return {
            frontendExperiment: (0, $iA4lt.getFrontendExperiment)({
                abTestId: frontendExperimentName,
                onError: (error)=>onErrorFn?.(error)
            }),
            backendExperiment: (0, $4OGlb.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
        };
        return {
            frontendExperiment: undefined,
            backendExperiment: (0, $hm6w9.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return {
        frontendExperiment: undefined,
        backendExperiment: (0, $4OGlb.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
    };
};
const $ddee69ce44809421$export$42e21c9a86f72c4f = (overrides, layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    // We should only evaluate the backend experiment here if we are using search experiment overrides functionality
    // backend experiments outside of rovo v rovo are evaluated at request time instead
    const shouldUseSearchExperimentOverrides = (0, $dh538.fg)('search-experiment-overrides-backend');
    const shouldNotGetBackendExperimentsForOverrides = shouldUseSearchExperimentOverrides ? false : shouldNotGetBackendExperiment;
    // If the feature gate is enabled or no overrides are provided, return the default experiment.
    if (!shouldUseSearchExperimentOverrides || !overrides || overrides.length === 0) return $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Filter for backend experiment from the overrides. only allowing them for now
    const backendOverrideExperiments = overrides.filter((override)=>override.location === 'backend' && override.type === 'experiment');
    if (!backendOverrideExperiments.length) return $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Get the base user's experiments from layers.
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    if (backendExperiment && 'experimentLayers' in backendExperiment) backendExperiment.experimentLayers = backendExperiment?.experimentLayers.map((layer)=>{
        const layerToOverride = backendOverrideExperiments.find((exp)=>{
            return exp.layer && layer.name?.includes(exp.layer === 'qr' ? 'query_expansion' : exp.layer);
        });
        if (!layerToOverride) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        const statsigOverrideExperiment = (0, $c6GJD.default).getExperiment(layerToOverride?.name);
        // handle case where experiment didnt add testId - for older experiments should be on new ones
        if (!statsigOverrideExperiment.get('testId', null)) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        return {
            name: layer.name,
            layerId: statsigOverrideExperiment.get('testId', null),
            shadowId: statsigOverrideExperiment.get('shadowId', null),
            // The below values might not be sent to the backend, but we can still track them in the frontend.
            controlId: statsigOverrideExperiment.get('controlId', null),
            abTestId: statsigOverrideExperiment.get('abTestId', null)
        };
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiment: frontendExperiment
    };
};
const $ddee69ce44809421$export$dd0548ef3fdfe45a = ({ combinedExperimentLayer: combinedExperimentLayer, experimentLayers: experimentLayers, primaryProduct: primaryProduct, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError, getLayerValuesFn: getLayerValuesFn })=>{
    // If combinedExperimentLayer isn't explicitly provided, derive it from primaryProduct.
    // This avoids callers having to duplicate the product-to-layer mapping logic.
    const resolvedLayer = combinedExperimentLayer ?? (primaryProduct === 'jira' ? [
        (0, $4OGlb.STATSIG_SEARCH_PLATFORM_JIRA_LAYER_TENANTS_BASED),
        (0, $4OGlb.STATSIG_SEARCH_PLATFORM_JIRA_LAYER)
    ] : undefined);
    let combinedExperiment;
    if (Array.isArray(resolvedLayer)) // Check layers in sequence and stop at the first enabled layer.
    // This ensures we only expose to the layer that's actually needed.
    for (const layer of resolvedLayer){
        const layerData = (0, $hm6w9.getCombinedLayerValues)(layer, onError);
        if (layerData?.enabled) {
            combinedExperiment = layerData;
            break;
        }
    }
    else if (resolvedLayer) combinedExperiment = (0, $hm6w9.getCombinedLayerValues)(resolvedLayer, onError);
    const { frontendExperiment: frontendExperiment, backendExperiment: backendExperiment } = $ddee69ce44809421$export$42e21c9a86f72c4f(sideBySideExperiment, statsigLayer, onError, true, getLayerValuesFn);
    const exampleFrontendExperiment = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'fe_search_experiment',
        onError: onError
    });
    // This experiment can be alternated between mutually exclusive or not.
    const multiSiteSearchInRovoExperiment = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    });
    return {
        backendExperiment: backendExperiment,
        combinedExperiment: combinedExperiment,
        frontendExperiments: {
            // the frontend experiment that's mutually exclusive to other BE and FE experiments
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            // NOTE: these aren't mutually exclusive to other BE or FE experiments
            [exampleFrontendExperiment.abTestId]: exampleFrontendExperiment,
            [multiSiteSearchInRovoExperiment.abTestId]: multiSiteSearchInRovoExperiment
        },
        dynamicExperiments: (0, $dbl1i.dynamicExperimentsSchema).safeParse(experimentLayers ?? []).data
    };
};
const $ddee69ce44809421$export$b9e6179ff71a6122 = ({ combinedExperimentLayer: combinedExperimentLayer, experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError })=>{
    return (0, $42omo.useMemo)(()=>$ddee69ce44809421$export$dd0548ef3fdfe45a({
            combinedExperimentLayer: combinedExperimentLayer,
            experimentLayers: experimentLayers,
            sideBySideExperiment: sideBySideExperiment,
            statsigLayer: statsigLayer,
            onError: onError
        }), [
        experimentLayers,
        sideBySideExperiment,
        onError,
        statsigLayer,
        combinedExperimentLayer
    ]);
};
module.exports["getMutuallyExclusiveExperiment"] = $ddee69ce44809421$export$fd4704975f80304e;
module.exports["getExperimentConfig"] = $ddee69ce44809421$export$dd0548ef3fdfe45a;
module.exports["useExperimentConfig"] = $ddee69ce44809421$export$b9e6179ff71a6122;

});

parcelRegister("5iakG", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");

const $6a0cb6a98d99c2c1$export$62fed45313a13eff = 'universalTypeFilter';
const $6a0cb6a98d99c2c1$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    $6a0cb6a98d99c2c1$export$62fed45313a13eff,
    'contributor',
    'space',
    'createdBy',
    'lastUpdatedBy',
    'owner',
    'opportunityStatus',
    'campaignStatus',
    'caseStatus',
    'closeDate',
    'focusAreaType',
    'focusAreaUnder',
    'assignee',
    'reporter',
    'project',
    'content',
    'label',
    'pageStatus',
    'verified',
    'onlyTitleMatch',
    'archived',
    'statusFilter',
    'compassArchived',
    'assetsSchema',
    'assetsType',
    'watchedByMe',
    'positionFocusArea',
    'positionStatus',
    'positionJobFamily',
    'positionTeam',
    'commentedByMe',
    'positionEmploymentType',
    'salesforceStage',
    'repository',
    'pullRequestStatus',
    'slackChannel',
    'hasAttachment'
];
const $6a0cb6a98d99c2c1$export$1fd3303b0f1dd4fb = ()=>{
    return $6a0cb6a98d99c2c1$export$64f2f70bb9f8e772.filter((filterId)=>{
        if (filterId === 'repository' && !(0, $dh538.fg)('rovo_fps_show_repository_filter')) return false;
        if (filterId === 'hasAttachment' && !(0, $dh538.fg)('rovo_fps_show_has_attachment_filter')) return false;
        return true;
    });
};
const $6a0cb6a98d99c2c1$export$2c1f2e526d05c6ca = 'search-page-hidden-filters-v2';
const $6a0cb6a98d99c2c1$export$b6072f70c84313e0 = ()=>{
    return $6a0cb6a98d99c2c1$export$2c1f2e526d05c6ca;
};
const $6a0cb6a98d99c2c1$export$657c4ea1fb8d25dd = [
    (0, $b4tvS.ProductKeys).Trello,
    (0, $b4tvS.ProductKeys).Gmail,
    (0, $b4tvS.ProductKeys).OutlookMail
];
module.exports["universalTypeFilterId"] = $6a0cb6a98d99c2c1$export$62fed45313a13eff;
module.exports["getFilterIdOrdering"] = $6a0cb6a98d99c2c1$export$1fd3303b0f1dd4fb;
module.exports["getSearchPageFilterConfigKey"] = $6a0cb6a98d99c2c1$export$b6072f70c84313e0;
module.exports["ALL_FILTER_EXCLUDED_PRODUCTS"] = $6a0cb6a98d99c2c1$export$657c4ea1fb8d25dd;

});

parcelRegister("7Evbj", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $ffd07bcdf31e3a99$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $ffd07bcdf31e3a99$export$ea77880e3935182d = 'unknown';
const $ffd07bcdf31e3a99$export$d60e93659f587f71 = {
    search: true // Used to filter out errors that are not from search projects
};


// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ // @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $eb9263707673332f$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;



var $joFH5 = parcelRequire("joFH5");


let $d7518b5a9314f4be$var$Sentry;
const $d7518b5a9314f4be$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from search projects
    if (!event.tags?.search) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $d7518b5a9314f4be$export$f553e8b08ef59d31 = async ()=>{
    if (!$d7518b5a9314f4be$var$Sentry) {
        if ((0, $joFH5.getEnvironment)() === 'development') return;
        $d7518b5a9314f4be$var$Sentry = Promise.resolve((parcelRequire("7hGsm"))).then((SentryModule)=>{
            SentryModule.init({
                dsn: (0, $ffd07bcdf31e3a99$export$6faa4a850bc4d0ce),
                attachStacktrace: true,
                release: (0, $eb9263707673332f$export$668f31ea3127f48f) || (0, $ffd07bcdf31e3a99$export$ea77880e3935182d),
                environment: (0, $joFH5.getEnvironment)(),
                beforeSend: $d7518b5a9314f4be$var$beforeSend
            });
            return SentryModule;
        }).catch(()=>{
        // TODO: Retry mechanism for chunk loading failures?
        });
    }
    return $d7518b5a9314f4be$var$Sentry;
};


const $1fcda106a24f1974$export$f86b2a1a2ce291b3 = async (error, userId, primaryProduct)=>{
    try {
        const SentryClient = await (0, $d7518b5a9314f4be$export$f553e8b08ef59d31)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $ffd07bcdf31e3a99$export$d60e93659f587f71)))scope.setTag(key, value);
            scope.setUser({
                id: userId || (0, $ffd07bcdf31e3a99$export$ea77880e3935182d)
            });
            scope.setTag('product', primaryProduct || (0, $ffd07bcdf31e3a99$export$ea77880e3935182d));
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
module.exports["logException"] = $1fcda106a24f1974$export$f86b2a1a2ce291b3;

});

parcelRegister("joFH5", function(module, exports) {
const $c8f5d06fde7473a8$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $c8f5d06fde7473a8$export$57570b1603cf6adb;

});

parcelRegister("djVCD", function(module, exports) {

var $hL7bb = parcelRequire("hL7bb");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $b8N8h = parcelRequire("b8N8h");


var $8LSUr = parcelRequire("8LSUr");


var $2zuvB = parcelRequire("2zuvB");


var $6yNqK = parcelRequire("6yNqK");


var $5iakG = parcelRequire("5iakG");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $fZ3l2 = parcelRequire("fZ3l2");


var $9d9t8 = parcelRequire("9d9t8");


var $9rRKJ = parcelRequire("9rRKJ");


var $2OtFZ = parcelRequire("2OtFZ");


var $4JaUT = parcelRequire("4JaUT");

class $ff3b77c829810981$export$8ba86dff7c04c14c extends (0, $4JaUT.ResultsFetchError) {
    constructor(){
        super('No entities provided to fetch results');
        this.name = 'EmptyEntitiesError';
    }
}


// Import directly from the product-keys source file (not the re-exporting `../products`
// barrel) to avoid a circular import that leaves ProductKeys3PValues undefined when this
// module is loaded via certain quick-find code paths.






const $68751eb12091b8db$export$94d61914de4d5edf = [
    {
        selectedProduct: (0, $b4tvS.ProductKeys3P).Slack,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Conversation
            ]
        ],
        hiddenFilters: [
            'lastUpdated',
            'contributor'
        ]
    }
];


// Import directly from the product-keys source file (not the re-exporting `../products`
// barrel) to avoid a circular import that leaves ProductKeys3PValues undefined when this
// module is loaded via certain quick-find code paths.






const $26dc42aea9abee59$export$5a7e3222966d6cdd = [
    {
        selectedProduct: (0, $b4tvS.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Deal
            ]
        ],
        shownFilters: [
            'salesforceStage',
            'opportunityStatus'
        ]
    },
    {
        selectedProduct: (0, $b4tvS.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Case
            ]
        ],
        shownFilters: [
            'caseStatus'
        ]
    },
    {
        selectedProduct: (0, $b4tvS.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Campaign
            ]
        ],
        shownFilters: [
            'campaignStatus'
        ]
    }
];


/**
 * Extracts the selected values for a given filter from the store's filters map.
 * Select filters store values as `value: string[]`; boolean and other filter
 * types are not expected to appear in rules and return an empty array.
 */ const $08c2ec3bf9b8f8f3$var$getFilterValues = (filters, filterId)=>{
    const filter = filters[filterId];
    if (filter && 'value' in filter && Array.isArray(filter.value)) return filter.value;
    return [];
};
const $08c2ec3bf9b8f8f3$export$8848759bd942e213 = (selectedProduct, filters, exclusionRules = (0, $68751eb12091b8db$export$94d61914de4d5edf), inclusionRules = (0, $26dc42aea9abee59$export$5a7e3222966d6cdd))=>{
    const excluded = new Set();
    // ── Exclusion rules: hide filters when conditions ARE met ──
    for (const rule of exclusionRules){
        // Check product condition (if specified)
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        // Check all filter selection conditions (AND logic — all must match)
        const allFiltersMatch = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $08c2ec3bf9b8f8f3$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allFiltersMatch) rule.hiddenFilters.forEach((f)=>{
            // Never hide a filter that currently has active selections — the user
            // may have chosen a value before the exclusion rule activated and the
            // selection is still valid.
            const filterValues = $08c2ec3bf9b8f8f3$var$getFilterValues(filters, f);
            if (filterValues.length === 0) excluded.add(f);
        });
    }
    // ── Inclusion rules: hide filters when conditions are NOT met ──
    // Step 1: Collect all filter IDs managed by inclusion rules and track which
    // condition filter IDs each managed filter depends on.
    const managedFilters = new Set();
    const satisfiedFilters = new Set();
    const conditionFiltersPerManaged = new Map();
    for (const rule of inclusionRules){
        // Check product condition first — skip rules for other products entirely
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        rule.shownFilters.forEach((f)=>{
            managedFilters.add(f);
            if (!conditionFiltersPerManaged.has(f)) conditionFiltersPerManaged.set(f, new Set());
            rule.selectedFilters.forEach(([filterId])=>conditionFiltersPerManaged.get(f).add(filterId));
        });
        // Check if this rule's conditions are all met
        const allConditionsMet = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $08c2ec3bf9b8f8f3$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allConditionsMet) rule.shownFilters.forEach((f)=>satisfiedFilters.add(f));
    }
    // Step 2: For each inclusion-managed filter, hide it if:
    // - No inclusion rule matched (filter not satisfied), AND
    // - At least one condition filter has an active selection (the user has made
    //   a choice that makes the filter irrelevant). If no condition filter has a
    //   value yet (e.g. "All" mode), leave the filter visible — don't hide it
    //   prematurely before the user has picked a type.
    for (const filterId of managedFilters)if (!satisfiedFilters.has(filterId)) {
        const conditionFilterIds = conditionFiltersPerManaged.get(filterId) ?? new Set();
        const anyConditionFilterHasValue = [
            ...conditionFilterIds
        ].some((cfId)=>$08c2ec3bf9b8f8f3$var$getFilterValues(filters, cfId).length > 0);
        if (anyConditionFilterHasValue) // A condition filter has a selection but it doesn't match any rule —
        // hide the managed filter. Unlike exclusion rules, inclusion rules hide
        // even when the managed filter has active selections — the store-level
        // `setSearchStoreState` will clear those selections separately so the
        // store stays in sync with what is applied.
        excluded.add(filterId);
    }
    return excluded;
};



var $b4tDU = parcelRequire("b4tDU");


var $lIbf3 = parcelRequire("lIbf3");


var $fUcm0 = parcelRequire("fUcm0");


var $d151M = parcelRequire("d151M");


var $6l1Qf = parcelRequire("6l1Qf");


var $jyecU = parcelRequire("jyecU");

const $674906c2a738886a$export$d4c72bab9d6cc13a = {
    abTest: undefined,
    cql: undefined,
    autoCorrection: undefined,
    product: undefined,
    requestId: undefined,
    traceId: undefined,
    // Search Input states
    inputQuery: '',
    searchQuery: '',
    originalQuery: undefined,
    // Product States
    primaryProduct: null,
    // Filter States
    filters: {},
    filterSelectionOrder: [],
    selectedProducts: [],
    selectedDatasource: undefined,
    availableProducts: [],
    allFilterExcludedProducts: [],
    jsmIncidentFilterIds: [],
    // Rest of store states
    resultsSort: {
        field: 'relevance',
        order: 'DESC'
    },
    retryCount: 0,
    queryVersion: 0,
    queryUpdatedTime: undefined,
    isLoading: false,
    isJiraHydrationLoading: false,
    isCompassTeamsLoading: false,
    shownCount: 0,
    results: undefined,
    resultError: undefined,
    productResultCountMap: null,
    paginationTokens: [],
    isLoadingMore: false,
    leapQuery: {
        loading: false,
        candidates: [],
        titleIndex: 0
    },
    requestedBackendExperiments: undefined,
    filterDropdownOpenByQueryParam: false,
    experience: (0, $9rRKJ.SearchExperience).SEARCH_PAGE,
    wasContentClearedBySpaceChange: false
};
const $674906c2a738886a$var$getUpdatedFilterSelectionOrder = (previousOrder, newFilterId, selected)=>{
    let filterSelectionOrder = new Set([
        ...previousOrder,
        newFilterId
    ]);
    if (!selected) filterSelectionOrder.delete(newFilterId);
    return [
        ...filterSelectionOrder
    ];
};
const $674906c2a738886a$var$isFiltersDiscoverability2Enabled = (primaryProduct)=>{
    if (!primaryProduct) return false;
    return primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira;
};
/**
 * Only these keys can get set before the updateQueryParams loop when updateQueryParams=true in setSearchStoreState
 */ const $674906c2a738886a$var$safeStateKeys = [
    'filterSelectionOrder',
    'resultsSort',
    'retryCount',
    'selectedDatasource',
    'wasContentClearedBySpaceChange'
];
/**
 * Please use setSearchStoreState instead of setState within the Search Store controller.
 *
 * This is because we treat the URL as the source of truth for some state. Filter value states are set in the URL directly and then we listen to URL state changs to represent them in our state.
 *
 * @param newState - state properties to set
 * @param {boolean} options.updateQueryParams - [false] Whether a setState call should trigger an URL update
 *
 * Notes on updateQueryParams:
 *
 * When false, this function acts like a standard setState
 * When true, this function will allow only the {safeStateKeys} to be set and will then use the provided query/filter etc state to set the URL directly, relying on the URL observer to complete the loop
 *
 * Non-url updates should NEVER trigger the setQueryParams callback. Otherwise, this will cause infinite loops or extra render cycles.
 **/ const $674906c2a738886a$var$setSearchStoreState = (newState, options)=>({ getState: getState, setState: setState }, { setQueryParams: setQueryParams, allFilters: allFilters, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, queryParams: currentQueryParams })=>{
        // TODO future refactoring: we should instead query the newState object for any URL-state changes, then clean up the setState we perform, then update the URL. Then a consumer of this function will not need to care about any of this and can simply pass `newState` as expected
        if (!options?.updateQueryParams) {
            setState({
                ...newState,
                availableProducts: availableProducts
            });
            return;
        }
        // We still want to set variables in state that do NOT participate in the URL
        // Initially we'll allow-list this set, as the set of filters (the disallow set) will grow over time
        const safeNewState = Object.fromEntries(Object.entries(newState).filter(([key])=>$674906c2a738886a$var$safeStateKeys.includes(key)));
        if (Object.keys(safeNewState).length > 0) setState(safeNewState);
        const { searchQuery: newSearchQuery, inputQuery: newInputQuery, filterDropdownOpenByQueryParam: filterDropdownOpenByQueryParam } = newState;
        const { inputQuery: oldInputQuery } = getState();
        const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: allFilterStates } = {
            ...getState(),
            ...newState
        };
        // Compute excluded filters via FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES (e.g.
        // salesforceStage when type≠deal). Excluded filters do NOT contribute to URL params
        // or the GraphQL query. This is the single source of truth for filter visibility;
        // UI selectors (useFiltersToDisplay, useSelectedFilterCount) apply the same exclusion.
        const excludedFilterIds = (0, $08c2ec3bf9b8f8f3$export$8848759bd942e213)(selectedProducts[0], allFilterStates);
        const staticFilters = Object.values(allFilters).filter((f)=>{
            if (excludedFilterIds.has(f.id)) return false;
            const filterState = f.getInitialState(config).getState();
            const isSuggestedFilter = f.isSuggestedFilter?.(primaryProduct);
            return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? filterState.universal || isSuggestedFilter // When there are no selected products, only universal and suggested filters are persisted in state
             : // Forge connectors are registered dynamically and not in filterState.products, so check them separately
            filterState.universal && selectedProducts.some((0, $9d9t8.isForgeConnectorProductKey)) || filterState.products.some((product)=>selectedProducts.includes(product));
        });
        const filterQueryParamValues = staticFilters.map((staticFilter)=>{
            const filterState = allFilterStates[staticFilter.id];
            if (!staticFilter.isCompatible(filterState?.id)) return {};
            return staticFilter.withState(filterState, config).queryParams.get();
        });
        const filterQueryParams = Object.assign({}, ...filterQueryParamValues);
        const text = [
            newSearchQuery,
            newInputQuery,
            oldInputQuery
        ].find(Boolean);
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        // If overrides is already an object (parsed), convert it back to JSON string for parseQueryParams
        const overridesToPreserve = currentQueryParams?.overrides && enableRovoSearchOverrides ? typeof currentQueryParams.overrides === 'string' ? currentQueryParams.overrides : encodeURIComponent(JSON.stringify(currentQueryParams.overrides)) : undefined;
        const paramsToPassToParse = {
            product: selectedProducts[0],
            datasource: selectedDatasource?.datasourceId,
            text: text !== '' ? text : undefined,
            ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                filterDropdownOpen: filterDropdownOpenByQueryParam || undefined
            },
            ...filterQueryParams,
            // Preserve overrides from current query params if enable-rovo_search_overrides is enabled
            ...overridesToPreserve && {
                overrides: overridesToPreserve
            }
        };
        const parsedQueryParams = (0, $lIbf3.parseQueryParams)(paramsToPassToParse, {
            commaSeparatedValues: true
        });
        setQueryParams(parsedQueryParams);
    };
const $674906c2a738886a$export$f14fed79ef571627 = $674906c2a738886a$var$setSearchStoreState;
const $674906c2a738886a$var$privateStoreActions = {
    initialiseStore: ()=>async ({ dispatch: dispatch }, { allFilters: allFilters, queryParams: queryParams, config: config, setQueryParams: setQueryParams, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct, isMissingProductSelection: isMissingProductSelection } = (0, $6l1Qf.FilterUtils)(allFilters, {});
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            if (isMissingProductSelection(queryParams)) {
                setQueryParams({
                    ...queryParams,
                    product: selectedProducts[0]
                });
                return;
            }
            const { staticFilterValues: staticFiltersByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                return staticFilter.getInitialState(config).queryParams.set((0, $lIbf3.convertQueryParamsToStringArray)(queryParams, queryParamsKeys));
            }));
            const filterStatesByProduct = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: filterStates } = (0, $6l1Qf.FilterUtils)(staticFiltersByProduct, filterStatesByProduct);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: filterStates,
                selectedProducts: selectedProducts,
                selectedDatasource: (0, $lIbf3.getDatasourceFromId)(queryParams.datasource?.toString(), selectedProducts[0], thirdPartyConfigs),
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen)
                },
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts,
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            }, {
                updateQueryParams: false // onInit should not update the query params
            }));
        },
    updateStore: ()=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, queryParams: queryParams, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { filters: filterStates } = getState();
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct } = (0, $6l1Qf.FilterUtils)(allFilters, filterStates);
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            const { staticFilterValues: staticFiltersByProduct, filterStates: filterStatesByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const filterState = filterStatesByProduct[staticFilter.id];
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                const queryParamStringArray = (0, $lIbf3.convertQueryParamsToStringArray)(queryParams, queryParamsKeys);
                if (!staticFilter.isCompatible(filterState?.id)) return staticFilter.getInitialState(config).queryParams.set(queryParamStringArray);
                return staticFilter.withState(filterState, config).queryParams.set(queryParamStringArray);
            }));
            const fullfilledFilterStates = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: resolvedFilterStates } = (0, $6l1Qf.FilterUtils)(staticFiltersByProduct, fullfilledFilterStates);
            // In order, ensure all filters with values are added to selection
            // Ensures filters enter selection order from resume-from-url
            // TODO: this should be done with the global ordering, but we don't have that in constants yet
            let { filterSelectionOrder: filterSelectionOrder } = getState();
            const { getFiltersWithSelection: getFiltersWithSelection } = (0, $6l1Qf.FilterUtils)(staticFiltersByProduct, resolvedFilterStates);
            getFiltersWithSelection().forEach((filterId)=>{
                filterSelectionOrder = $674906c2a738886a$var$getUpdatedFilterSelectionOrder(filterSelectionOrder, filterId, resolvedFilterStates[filterId]?.hasSelection);
            });
            const querySelectedProducts = getSelectedProducts(queryParams);
            const selectedDatasource = (0, $lIbf3.getDatasourceFromId)(queryParams.datasource?.toString(), querySelectedProducts[0], thirdPartyConfigs);
            const nextStateSync = {
                filters: resolvedFilterStates,
                selectedProducts: querySelectedProducts,
                selectedDatasource: selectedDatasource,
                filterSelectionOrder: filterSelectionOrder,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen)
                },
                availableProducts: availableProducts,
                paginationTokens: [],
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            };
            const stateBeforeSync = getState();
            const prevStateSyncComparable = {
                filters: stateBeforeSync.filters,
                selectedProducts: stateBeforeSync.selectedProducts,
                selectedDatasource: stateBeforeSync.selectedDatasource,
                filterSelectionOrder: stateBeforeSync.filterSelectionOrder,
                inputQuery: stateBeforeSync.inputQuery,
                searchQuery: stateBeforeSync.searchQuery,
                originalQuery: stateBeforeSync.originalQuery,
                ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: stateBeforeSync.filterDropdownOpenByQueryParam
                },
                availableProducts: stateBeforeSync.availableProducts,
                paginationTokens: stateBeforeSync.paginationTokens,
                cql: stateBeforeSync.cql,
                primaryProduct: stateBeforeSync.primaryProduct,
                experience: stateBeforeSync.experience
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(prevStateSyncComparable, nextStateSync)) dispatch($674906c2a738886a$var$setSearchStoreState(nextStateSync, {
                updateQueryParams: false
            } // onUpdate lifecycle should never update the query params
            ));
        },
    setFilter: (state, options)=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, config: config })=>{
            // Get the static filter definition
            const staticFilter = allFilters[state.id];
            const { filters: allFiltersState } = getState();
            if (!staticFilter.isCompatible(staticFilter.id)) return;
            const filterWithState = staticFilter.withState(state, config).getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: {
                    ...allFiltersState,
                    [staticFilter.id]: filterWithState
                },
                ...options?.setSelectedProduct ? {
                    selectedProducts: [
                        options?.setSelectedProduct
                    ]
                } : {}
            }, {
                updateQueryParams: options?.shouldSetQueryParams
            }));
        },
    updateFilterSelectionOrder: (filterId, selected)=>async ({ dispatch: dispatch, getState: getState })=>{
            const { filterSelectionOrder: oldSelectionOrder } = getState();
            const newFilterSelectionOrder = $674906c2a738886a$var$getUpdatedFilterSelectionOrder(oldSelectionOrder, filterId, selected);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filterSelectionOrder: newFilterSelectionOrder
            }));
        },
    setNewFilterStates: (newFilterStates, setSelectedProduct, filterSelectionOrder)=>async ({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: newFilterStates,
                ...setSelectedProduct !== undefined && {
                    selectedProducts: [
                        setSelectedProduct
                    ]
                },
                ...filterSelectionOrder && {
                    filterSelectionOrder: filterSelectionOrder
                }
            }, {
                updateQueryParams: false
            }));
            dispatch($674906c2a738886a$var$setSearchStoreState({}, {
                updateQueryParams: true
            }));
        }
};
function $674906c2a738886a$var$hasLoadInitialOptions(filter) {
    return typeof filter === 'object' && filter !== null && 'loadInitialOptions' in filter && typeof filter.loadInitialOptions === 'function' && 'getState' in filter && typeof filter.getState === 'function';
}
const $674906c2a738886a$export$e324594224ef24da = {
    loadInitialSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config, thirdPartyConfigs: thirdPartyConfigs })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: stateSelectedDatasource, selectedProducts: selectedProducts } = getState();
            // When selectedDatasource is not set (e.g. no `datasource=` URL param was present),
            // derive it from thirdPartyConfigs using the selected product. This allows filters
            // that need a datasourceId (e.g. salesforceStage dynamic stage options) to fetch
            // correctly even when the datasource was not explicitly set via URL.
            //
            // Some dynamic 3P filters (those declaring `requiresTopLevel3PDatasource: true` —
            // today: salesforceStage, campaignStatus, caseStatus) read from the top-level
            // thirdPartyConfigs entry directly because it always carries a datasourceId, whereas
            // .datasources?.[0] may only be populated in multi-domain configurations.
            const shouldUseTopLevel3PDatasource = 'requiresTopLevel3PDatasource' in staticSelectFilter && !!staticSelectFilter.requiresTopLevel3PDatasource;
            const selectedDatasource = stateSelectedDatasource ?? (selectedProducts[0] ? shouldUseTopLevel3PDatasource ? thirdPartyConfigs?.[selectedProducts[0]] : thirdPartyConfigs?.[selectedProducts[0]]?.datasources?.[0] : undefined);
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            // Race-condition guard: dynamic 3P filters require a resolved datasource to
            // fetch their option list. If the bootstrap config hasn't loaded yet,
            // `thirdPartyConfigs` is empty and `selectedDatasource` is undefined — in
            // which case calling `loadInitialOptions` would set `didMount = true` with
            // an empty result and the filter would never retry. Skip the call so the
            // caller (UI effect) can re-trigger once the datasource arrives.
            // Eagerly evaluate the gate so test runners (ffTest) can detect that it
            // was consulted, even when the && chain below short-circuits.
            const shouldRetryOnConfigLoad = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
            if (shouldUseTopLevel3PDatasource && !selectedDatasource && shouldRetryOnConfigLoad) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                // overriding the intl in config to fix a race condition with initial options and outdated translation messages
                intl: props.intl,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const newFilter = staticSelectFilter.withState(filterState, extendedConfig);
            if ($674906c2a738886a$var$hasLoadInitialOptions(newFilter)) await newFilter.loadInitialOptions((stateChange)=>{
                dispatch($674906c2a738886a$var$privateStoreActions.setFilter(stateChange));
            });
        },
    clearSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).clear().getState();
            dispatch($674906c2a738886a$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true
            }));
            dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    /**
   * Sets a select filter option.
   *
   * @param validateDependentFilterId - If provided, validates if the dependent filter's containerARI
   *                                    is still in the new selection values and clears it if not.
   */ setSelectFilterOption: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            const filterWithState = staticSelectFilter.withState(filterState, config);
            if (!('setOption' in filterWithState)) return;
            const newFilterState = filterWithState.setOption(props.optionChange, props.options?.customValue).getState();
            if ((0, $2OtFZ.serveWebPagesInTypeFilter)() && props.filterId === (0, $5iakG.universalTypeFilterId)) {
                const { selectedProducts: selectedProducts } = getState();
                const hasWebPageSelected = newFilterState.hasSelection && newFilterState.value?.includes((0, $2Znam.TypeFilterValueKey).WebPage);
                if (hasWebPageSelected) {
                    // When web-page type is selected, use the same logic as clicking the noun in the right panel to select the product = AtlassianWebCrawler
                    dispatch($674906c2a738886a$export$e324594224ef24da.unsafe_setWebPageType());
                    return;
                }
                if (!newFilterState.hasSelection && selectedProducts?.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler)) {
                    // Clear the product since type filter has been cleared. This will also clear the type filter
                    // and update filter selection order through selectProductFilter's existing logic
                    dispatch($674906c2a738886a$var$setSearchStoreState({
                        productResultCountMap: null
                    }));
                    dispatch($674906c2a738886a$export$e324594224ef24da.selectProductFilter());
                    return;
                }
            }
            // When the contributor selection changes, the cached `initialOptions` (suggested values
            // shown when a dependent dropdown is opened without typing) on contributor-scoped
            // filters becomes stale: the base select filter short-circuits `loadInitialOptions`
            // when `state.didMount` is `true`, so the dropdown keeps showing pre-contributor
            // suggestions until the user actually types. Reset `didMount` /
            // `didMountPerProducts` and clear `initialOptions.options` on each contributor-scoped
            // dependent filter so the next dropdown open re-fetches with the new contributor
            // scope. Behind the same FG that controls the rest of the contributor scoping logic.
            if (props.filterId === 'contributor' && (0, $dh538.fg)('rovo_fps_scope_3p_typeahead_by_contributor')) {
                const previousValue = Array.isArray(filterState?.value) ? filterState.value : [];
                const nextValue = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                const contributorSelectionChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))([
                    ...previousValue
                ].sort(), [
                    ...nextValue
                ].sort());
                if (contributorSelectionChanged) {
                    const contributorScopedDependents = [
                        'content'
                    ];
                    contributorScopedDependents.forEach((dependentId)=>{
                        const dependentStaticFilter = allFilters[dependentId];
                        const dependentFilterState = allFiltersState[dependentId];
                        if (!dependentStaticFilter || !dependentStaticFilter.isCompatible(dependentFilterState?.id) || !(0, $d151M.isSelectFilter)(dependentStaticFilter.type)) return;
                        const dependentSelectFilterState = dependentFilterState;
                        if (!dependentSelectFilterState) return;
                        const resetDependentState = {
                            ...dependentSelectFilterState,
                            didMount: false,
                            didMountPerProducts: {},
                            initialOptions: {
                                ...dependentSelectFilterState.initialOptions,
                                options: [],
                                isLoading: false
                            }
                        };
                        dispatch($674906c2a738886a$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                    });
                }
            }
            // Validate dependent filter if specified (e.g., clear content filter when space changes)
            const dependentFilterId = props.options?.validateDependentFilterId;
            let wasContentCleared = false;
            if (dependentFilterId) {
                const dependentStaticFilter = allFilters[dependentFilterId];
                const dependentFilterState = allFiltersState[dependentFilterId];
                if (dependentStaticFilter?.isCompatible(dependentFilterState?.id) && (0, $d151M.isSelectFilter)(dependentStaticFilter.type)) {
                    // Get new values from the updated filter state
                    const newValues = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                    // Clear the dependent filter whenever the primary filter is explicitly set to a
                    // non-empty selection. Reset didMount and clear cached initialOptions so the next
                    // dropdown open re-fetches dependent suggestions scoped to the new primary selection
                    // instead of showing stale options from the previous selection.
                    if (newValues.length > 0) {
                        const clearedDependentState = dependentStaticFilter.withState(dependentFilterState, config).clear().getState();
                        const dependentSelectFilterState = dependentFilterState;
                        const resetDependentState = dependentSelectFilterState ? {
                            ...clearedDependentState,
                            didMount: false,
                            didMountPerProducts: {},
                            initialOptions: {
                                ...dependentSelectFilterState.initialOptions,
                                options: [],
                                isLoading: false
                            },
                            // Reset lookup so stale typeahead results (from typing in the
                            // filter dropdown before space change) don't persist alongside
                            // new space-scoped suggestions when the content dropdown reopens.
                            lookup: {
                                ...dependentSelectFilterState.lookup,
                                options: [],
                                lookupResultOptions: [],
                                input: '',
                                isLoading: false,
                                isActive: false
                            }
                        } : clearedDependentState;
                        dispatch($674906c2a738886a$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                        dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(dependentFilterId, false));
                        wasContentCleared = true;
                    }
                }
            }
            dispatch($674906c2a738886a$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            // NOTE: Inclusion-rule-driven filters (e.g. salesforceStage when type≠deal) are
            // handled as a derived projection in setSearchStoreState (URL/GraphQL builder),
            // useFiltersToDisplay (UI), and useSelectedFilterCount (badge). Stale selections
            // for excluded filters are cleared by setSearchStoreState in the same write so
            // the store stays in sync with what is visible/applied. No imperative clear is
            // needed here.
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null,
                wasContentClearedBySpaceChange: wasContentCleared
            }));
        },
    setAutoFilters: (filters)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const newFilterStates = {};
            await Promise.all(filters.map(async (filterConfig)=>{
                const staticSelectFilter = allFilters[filterConfig.filterId];
                const filterState = allFilterStates[filterConfig.filterId];
                // We should not automatically apply the filter if it has already been selected
                if (filterState?.hasSelection) return;
                if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
                const filterWithState = staticSelectFilter.withState(filterState, config);
                if (!('setOption' in filterWithState)) return;
                const optionsToChange = Array.isArray(filterConfig.optionChange) ? filterConfig.optionChange : [
                    filterConfig.optionChange
                ];
                const selectedOptions = optionsToChange.filter((o)=>o.isSelected);
                if (selectedOptions.length === 0) return;
                // Build query params object with the filter's key
                const queryParamsKey = staticSelectFilter.queryParams.key;
                const queryParams = {
                    [queryParamsKey]: selectedOptions.map((o)=>o.value)
                };
                // Add custom value fields if provided
                if (filterConfig.options?.customValue) Object.entries(filterConfig.options.customValue).forEach(([key, value])=>{
                    queryParams[key] = [
                        value
                    ];
                });
                // Use queryParams.set which handles option hydration via fetcher
                const hydratedFilter = await filterWithState.queryParams.set(queryParams);
                newFilterStates[filterConfig.filterId] = hydratedFilter.getState();
            }));
            if (Object.keys(newFilterStates).length > 0) {
                const { filterSelectionOrder: currentOrder } = getState();
                // Add new auto-applied filters to the order
                const updatedOrder = Object.keys(newFilterStates).reduce((order, filterId)=>$674906c2a738886a$var$getUpdatedFilterSelectionOrder(order, filterId, newFilterStates[filterId]?.hasSelection), currentOrder);
                dispatch($674906c2a738886a$var$privateStoreActions.setNewFilterStates({
                    ...allFilterStates,
                    ...newFilterStates
                }, undefined, updatedOrder));
            }
        },
    setSelectFilterLookupInput: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: selectedDatasource } = getState();
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const filterWithState = staticSelectFilter.withState(filterState, extendedConfig);
            if ('setLookupInput' in filterWithState) await filterWithState.setLookupInput(props.query, (stateChange)=>{
                dispatch($674906c2a738886a$var$privateStoreActions.setFilter(stateChange));
            });
        },
    setBooleanFilterValue: (props, privateActions = $674906c2a738886a$var$privateStoreActions)=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticBooleanFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticBooleanFilter.isCompatible(filterState?.id)) return;
            if (staticBooleanFilter.type !== 'boolean') return;
            const newBooleanFilterState = staticBooleanFilter.withState(filterState, config).setValue(props.value).getState();
            dispatch(privateActions.setFilter(newBooleanFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch(privateActions.updateFilterSelectionOrder(props.filterId, newBooleanFilterState.hasSelection));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    clearAllFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const staticFilters = Object.values(allFilters);
            const clearedFilters = $674906c2a738886a$var$clearFilters(allFilterStates, staticFilters, config);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: clearedFilters,
                selectedProducts: [],
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    clearAllAvailableFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticFilters = Object.values(allFilters);
            const { filters: allFilterStates } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: $674906c2a738886a$var$clearFilters(allFilterStates, staticFilters, config),
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    // Product filter actions
    selectProductFilter: (productKey, datasource)=>({ getState: getState, dispatch: dispatch }, { thirdPartyConfigs: thirdPartyConfigs, allFilters: allFilters, config: config })=>{
            const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: filters, filterSelectionOrder: filterSelectionOrder } = getState();
            // Convert string datasource to object if needed for consistency
            const datasourceObject = typeof datasource === 'string' ? (0, $lIbf3.getDatasourceFromId)(datasource, productKey, thirdPartyConfigs) : datasource;
            // Only return early if both product and datasource are the same
            if (productKey && selectedProducts.includes(productKey) && datasourceObject?.datasourceId === selectedDatasource?.datasourceId) return;
            const persistedFilters = {};
            // Persist selected universal filters if they are relevant to the selected product
            for (const [id, filter] of Object.entries(filters)){
                if (!filter) continue;
                if (filter.universal && filter.hasSelection && (!productKey || productKey && filter.products.includes(productKey) || // Universal filters should always be persisted for forge connectors
                productKey && (0, $9d9t8.isForgeConnectorProductKey)(productKey))) persistedFilters[id] = filter;
            }
            // Type is a universal filter, but type needs to be cleared if we're filtering away from Atlas
            // This is because selecting a global noun sets product AND type values
            if (selectedProducts.includes((0, $b4tvS.ProductKeys).Atlas)) delete persistedFilters[0, $5iakG.universalTypeFilterId];
            const newSelectedProducts = productKey ? [
                productKey
            ] : [];
            // Clear web-page type filter when navigating away from Web Pages
            if ((0, $2OtFZ.serveWebPagesInTypeFilter)()) {
                const currentTypeFilter = filters[0, $5iakG.universalTypeFilterId];
                const isWebPageTypeSelected = currentTypeFilter?.type === 'single-select' && currentTypeFilter?.value?.includes((0, $2Znam.TypeFilterValueKey).WebPage);
                if (isWebPageTypeSelected) // When user clicks "All" or selects any product, clear the web-page type
                delete persistedFilters[0, $5iakG.universalTypeFilterId];
            }
            // Universal filters being persisted also retain their ordering
            const newFilterSelectionOrder = filterSelectionOrder.filter((f)=>{
                return Object.keys(persistedFilters).includes(f);
            });
            dispatch($674906c2a738886a$var$setSearchStoreState({
                selectedProducts: newSelectedProducts,
                selectedDatasource: datasourceObject,
                filterSelectionOrder: newFilterSelectionOrder,
                filters: persistedFilters,
                resultsSort: $674906c2a738886a$export$d4c72bab9d6cc13a.resultsSort,
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    unselectProductFilter: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$export$e324594224ef24da.selectProductFilter(undefined));
        },
    // Search Input Actions
    setInputQuery: (inputQuery)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                inputQuery: inputQuery.trim()
            }));
        },
    setSearchQuery: (searchQuery)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                searchQuery: searchQuery.trim()
            }, {
                updateQueryParams: true
            }));
        },
    triggerSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { inputQuery: inputQuery, searchQuery: searchQuery, retryCount: retryCount, productResultCountMap: productResultCountMap } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: searchQuery === inputQuery ? productResultCountMap : null,
                wasContentClearedBySpaceChange: false
            }));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                searchQuery: inputQuery,
                retryCount: searchQuery === inputQuery ? retryCount + 1 : 0
            }, {
                updateQueryParams: true
            }));
        },
    retrySearch: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                retryCount: getState().retryCount + 1
            }));
        },
    // Sorting actions
    setSortField: (sortField)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    field: sortField
                },
                paginationTokens: []
            }));
        },
    setSortOrder: (sortOrder)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    order: sortOrder
                },
                paginationTokens: []
            }));
        },
    resetSort: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: $674906c2a738886a$export$d4c72bab9d6cc13a.resultsSort,
                paginationTokens: []
            }));
        },
    // Rest of Search Actions
    setQueryUpdatedTime: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                queryUpdatedTime: Date.now()
            }));
        },
    resetQueryVersion: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                queryVersion: 0
            }));
        },
    incrementQueryVersion: ()=>({ getState: getState, setState: setState })=>{
            const { queryVersion: queryVersion } = getState();
            setState({
                queryVersion: queryVersion + 1
            });
        },
    setIsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: isLoading
            }));
        },
    // Results actions
    setResults: (results, error, requestId, traceId)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: false,
                results: results,
                resultError: error,
                requestId: requestId,
                traceId: traceId,
                wasContentClearedBySpaceChange: false
            }));
        },
    appendMoreResults: (results)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: currentResults } = getState();
            if (!currentResults || !results) return;
            const currentEdges = currentResults.edges;
            const newEdges = results.edges;
            const newResults = {
                ...currentResults,
                edges: currentEdges.concat(newEdges),
                pageInfo: results?.pageInfo
            };
            dispatch($674906c2a738886a$var$setSearchStoreState({
                results: newResults,
                isLoadingMore: false
            }));
        },
    setFetchFromCursor: (cursor)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                paginationTokens: [
                    {
                        cursor: cursor
                    }
                ]
            }));
        },
    setIsLoadingMore: (isLoadingMore)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoadingMore: isLoadingMore
            }));
        },
    setJiraIssueFieldsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isJiraHydrationLoading: isLoading
            }));
        },
    setJiraIssueDetails: (issueData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let hydratedResults = [];
            if (results?.edges && results.edges.length > 0 && issueData.length > 0) {
                // TODO: fix colorName being passed twice with inconsistent values, see the unit test for context
                hydratedResults = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $8LSUr.isSearchResultJiraIssue)(edge.node)) {
                        const id = edge.node.id;
                        const hydratedIssue = issueData.find((issue)=>issue.id === id);
                        if (edge.node.status && hydratedIssue) {
                            edge.node.status.name = hydratedIssue.statusField.status.name;
                            edge.node.status.colorName = hydratedIssue.statusField.status.statusCategory?.colorName;
                        }
                    }
                    return edge;
                });
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: hydratedResults
                    }
                }));
            }
        },
    setCompassTeamsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isCompassTeamsLoading: isLoading
            }));
        },
    setCompassTeams: (teamData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let resultsWithTeamNames = [];
            if (results?.edges && results.edges.length > 0 && teamData.length > 0) {
                resultsWithTeamNames = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $b8N8h.isSearchCompassPartial)(edge.node)) {
                        const teamId = (0, $fUcm0.getTeamId)(edge.node.ownerId);
                        const team = teamData.find((team)=>team.id === teamId);
                        edge.node.ownerName = team?.displayName;
                    }
                    return edge;
                });
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: resultsWithTeamNames
                    }
                }));
            }
        },
    resetResults: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: false,
                shownCount: 0,
                results: undefined,
                resultError: undefined,
                requestId: undefined,
                wasContentClearedBySpaceChange: false
            }));
        },
    setAutoCorrection: (autoCorrection)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                autoCorrection: autoCorrection
            }));
        },
    setLeapQuery: ({ candidates: candidates, titleIndex: titleIndex, loading: loading })=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                leapQuery: {
                    loading: loading,
                    candidates: candidates,
                    titleIndex: titleIndex
                }
            }));
        },
    setProductResultCount: (totalCounts)=>({ dispatch: dispatch, getState: getState })=>{
            if (totalCounts === undefined) {
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    productResultCountMap: null
                }));
                return;
            }
            const { filters: filterStates, availableProducts: availableProducts, productResultCountMap: oldProductResultCountMap } = getState();
            const filtersWithSelection = Object.values(filterStates).filter((filter)=>filter?.hasSelection);
            const productsCorrespondingToAllSelectedFilters = filtersWithSelection.length ? availableProducts.filter((product)=>filtersWithSelection.every((filter)=>filter?.products?.includes(product))) : availableProducts;
            const resultsCountsAdjustedForSelectedFilters = totalCounts.map((resultCount)=>{
                if (productsCorrespondingToAllSelectedFilters.includes(resultCount.product)) return resultCount;
                else return {
                    ...resultCount,
                    count: 0
                };
            });
            const productResultCountMap = resultsCountsAdjustedForSelectedFilters.reduce((acc, { product: product, count: count })=>{
                if (product) acc[product] = count;
                return acc;
            }, {});
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: {
                    ...oldProductResultCountMap,
                    ...productResultCountMap
                }
            }));
        },
    // For backwards compatibility
    clearHybridFilters: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$export$e324594224ef24da.clearAllFilters());
        },
    /**
   * TODO: QS-9329: Persist auto-applied filters when selecting
   * * Projects (type=project & product=townsquare)
   * * Goals (type=goal & product=townsquare)
   * in the right rail.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Considered unsafe since it's using queryParams to change the state.
   * Ideally we should set it directly in the state, but that requires introducing a new action.
   * This is because the cooresponding "Type" filter that this selects isn't available or easy to set from outside
   * The product=townsquare&type=project will correctly hydrate the filter from the URL after params are set though!
   *
   * We hope to improve Atlassian Home / global noun handling after GA
   *
   * The last modified and contributors filters are explicitly kept in the query params because they are universal.
   * Type is also a universal filter, but we couple the type with the product to determine which Townsquare results to show.
   *
   * @param value: a noun to be set
   */ unsafe_setAtlasNouns: (value)=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
            if (!value) {
                const { product: _, type: __, ...queryParamsWithResetNounFilter } = queryParams;
                setQueryParams({
                    ...queryParamsWithResetNounFilter
                });
            } else {
                const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
                // We explicitly only keep text, last modified and contributors
                setQueryParams({
                    product: (0, $b4tvS.ProductKeys).Atlas,
                    type: value,
                    text: text,
                    originalQuery: originalQuery,
                    lastModified: lastModified,
                    contributors: contributors
                });
            }
        },
    /**
   * * TODO: QS-9329: Persist auto-applied filters when selecting
   * Web Pages (type=web-page & product=atlassian-web-crawler) in the right rail
   * or type=web-page in horizontal filters.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Similar to unsafe_setAtlasNouns, this directly manipulates URL query params
   * to set the Type filter to "web-page".
   */ unsafe_setWebPageType: ()=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            if (!(0, $2OtFZ.serveWebPagesInTypeFilter)()) {
                // Control cohort: use the old behavior by selecting AtlassianWebCrawler product
                dispatch($674906c2a738886a$export$e324594224ef24da.selectProductFilter((0, $b4tvS.ProductKeys).AtlassianWebCrawler));
                return;
            }
            // Test cohort: use the new behavior by setting type = 'web-page' in the URL
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
            const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
            setQueryParams({
                product: (0, $b4tvS.ProductKeys).AtlassianWebCrawler,
                type: (0, $2Znam.TypeFilterValueKey).WebPage,
                text: text,
                originalQuery: originalQuery,
                lastModified: lastModified,
                contributors: contributors
            });
        },
    setRequestedBackendExperiments: (requestedBackendExperiments)=>({ setState: setState })=>{
            const experimentLayers = requestedBackendExperiments?.experimentLayers?.map((layer)=>{
                const { analyticsDefinitions: analyticsDefinitions, ...rest } = layer;
                return {
                    ...rest,
                    definitions: analyticsDefinitions
                };
            });
            setState({
                requestedBackendExperiments: {
                    experimentLayers: experimentLayers
                }
            });
        },
    setJsmIncidentFilterIds: (jsmIncidentFilterIds)=>({ getState: getState, setState: setState })=>{
            if (getState().jsmIncidentFilterIds === jsmIncidentFilterIds) return;
            setState({
                jsmIncidentFilterIds: jsmIncidentFilterIds
            });
        },
    /*
   * This action is only triggered by QF but the value of filterDropdownOpen is only used by FPS
   * This means we need to update query param to make it available to FPS
   * That's why updateQueryParams is set to 'true'
   *
   * We only call it for clearing and the "set" value would be handled by onNavigate
   * */ unsetFilterDropdownOpen: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filterDropdownOpenByQueryParam: false
            }, {
                updateQueryParams: true
            }));
        }
};
const $674906c2a738886a$var$clearFilters = (allFilterStates, filters, config)=>{
    const clearedFilters = filters.map((filter)=>{
        const filterState = allFilterStates[filter.id];
        if (!filter.isCompatible(filterState?.id)) return [];
        return [
            filter.id,
            filter.withState(filterState, config).clear().getState()
        ];
    });
    return Object.fromEntries(clearedFilters);
};
// Keep store private and use hooks to access state and actions
const $674906c2a738886a$var$Store = (0, $1P1Tu.createStore)({
    initialState: $674906c2a738886a$export$d4c72bab9d6cc13a,
    actions: $674906c2a738886a$export$e324594224ef24da,
    name: 'search'
});
const $674906c2a738886a$export$b8f9c0e048639dd4 = (0, $9zUhf.createActionsHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$bf072992274c9fb = (0, $FOT9i.createContainer)($674906c2a738886a$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$privateStoreActions.initialiseStore());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$privateStoreActions.updateStore());
        },
    onCleanup: ()=>({ setState: setState })=>{
            setState($674906c2a738886a$export$d4c72bab9d6cc13a);
        }
});
const $674906c2a738886a$export$bd221a7c56b93941 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$c5a5afdff2ff0385 = (0, $9zUhf.createActionsHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$5fd14fa624074d55 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $674906c2a738886a$export$973ca22476b0e05f = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.filters
});
const $674906c2a738886a$export$da992673b1309795 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.inputQuery
});
const $674906c2a738886a$export$59d1399255ff1d16 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.experience
});
const $674906c2a738886a$export$e985158d10c27e34 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.searchQuery
});
const $674906c2a738886a$export$c2380c4d76e63cc4 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.originalQuery
});
const $674906c2a738886a$export$ba2ad669c5b27bca = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.autoCorrection
});
const $674906c2a738886a$export$140d37088821fcb1 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.retryCount
});
const $674906c2a738886a$export$275c72361969d62c = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.productResultCountMap
});
const $674906c2a738886a$export$14279a3fbdb52451 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.abTest
});
const $674906c2a738886a$export$34418e307d9100b4 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.queryInfo
});
const $674906c2a738886a$export$8a4c65ea4f241b48 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.searchQuery ? (0, $6yNqK.QueryState).POSTQUERY : (0, $6yNqK.QueryState).PREQUERY
});
const $674906c2a738886a$export$a2b38489a4538322 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.queryUpdatedTime
});
const $674906c2a738886a$export$bda9ac73817ceec3 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results
});
const $674906c2a738886a$export$1c9622ace43d770d = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.resultError
});
const $674906c2a738886a$export$49f5dec896c355cd = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.requestId
});
const $674906c2a738886a$export$944245f24d4ef0b6 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.traceId
});
const $674906c2a738886a$export$4dface15d86304a4 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isLoading
});
const $674906c2a738886a$export$f59185497e80e274 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.resultsSort
});
const $674906c2a738886a$export$e2d0c00df99a687c = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.queryVersion
});
const $674906c2a738886a$export$5f38673942a99ffe = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $674906c2a738886a$export$3bc2682926916b14 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.wasContentClearedBySpaceChange
});
const $674906c2a738886a$export$1e51d2073b60bd88 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.results,
        (state)=>state.isLoading,
        (state)=>state.resultError
    ], (results, isLoading, resultError)=>$674906c2a738886a$export$71923aa45c7aa566({
            results: results,
            isLoading: isLoading,
            resultError: resultError
        }))
});
const $674906c2a738886a$export$71923aa45c7aa566 = ({ results: results, isLoading: isLoading, resultError: resultError })=>{
    if (isLoading) return (0, $fZ3l2.ResultsStates).IS_LOADING;
    if (results && results.edges && results.edges.length > 0) return (0, $fZ3l2.ResultsStates).RESULTS;
    // If there are no entities for a query, an error will throw
    // when no entities for query is equivalent to no results
    if (resultError instanceof (0, $ff3b77c829810981$export$8ba86dff7c04c14c) || results && (results.edges ?? []).length === 0) return (0, $fZ3l2.ResultsStates).NO_RESULTS;
    if (resultError) return (0, $fZ3l2.ResultsStates).ERROR;
    if (!results) return (0, $fZ3l2.ResultsStates).INITIAL;
    return (0, $fZ3l2.ResultsStates).ERROR;
};
const $674906c2a738886a$export$826bdf756a8bf13a = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedProducts
});
const $674906c2a738886a$export$387e1da2bc9c93cc = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedProducts[0]
});
const $674906c2a738886a$export$e87eda20cc6e50c2 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedDatasource
});
const $674906c2a738886a$export$8c11ef422551818 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isJiraHydrationLoading
});
const $674906c2a738886a$export$795623048d841bf2 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isCompassTeamsLoading
});
const $674906c2a738886a$export$8dc083eb9766b48 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.availableProducts && state.availableProducts.length > 0
});
const $674906c2a738886a$export$e80788222dba30a3 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.pageInfo?.endCursor
});
const $674906c2a738886a$export$bedf78a7ab879711 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.paginationTokens[0]?.cursor
});
const $674906c2a738886a$export$f258398dab7c75ba = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isLoadingMore
});
const $674906c2a738886a$export$964e8498268f0fe3 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.selectedProducts,
        (state)=>state.availableProducts
    ], (selectedProducts, availableProducts)=>{
        return {
            selectedProduct: selectedProducts[0],
            filteredProducts: selectedProducts[0] ? [
                selectedProducts[0]
            ] : availableProducts,
            availableProducts: availableProducts
        };
    })
});
const $674906c2a738886a$export$59086fbf0d8f8d2a = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.availableProducts,
        (state)=>state.selectedProducts,
        (state)=>state.allFilterExcludedProducts,
        (state)=>state.filters[0, $5iakG.universalTypeFilterId],
        (_, props)=>props
    ], (availableProducts, selectedProducts, allFilterExcludedProducts, typeFilter, props)=>{
        const { thirdPartyConfigs: thirdPartyConfigs } = props;
        // Filter out excluded products from "All" filter
        const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
        const productsToSearch = selectedProducts[0] ? [
            selectedProducts[0]
        ] : allFilterIncludedProducts;
        return (0, $jyecU.getUniversalTypeEntities)(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts);
    })
});
const $674906c2a738886a$export$aad641f503e4b4a8 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (!(filter.type === 'multi-select' || filter.type === 'single-select')) throw new Error('Not a select filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            availableProducts: state.availableProducts,
            allFilterExcludedProducts: state.allFilterExcludedProducts,
            primaryProduct: state.primaryProduct,
            experience: state.experience
        };
    }
});
const $674906c2a738886a$export$c724ec2cbd2fedce = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (filter?.type !== 'boolean') throw new Error('Not a boolean filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            primaryProduct: state.primaryProduct
        };
    }
});
const $674906c2a738886a$export$1c5018e1c1ce99ae = (filters)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.universal ? [
            filter
        ] : [];
    });
};
const $674906c2a738886a$export$546f6564ce5d0a17 = (filters, primaryProduct)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.products.find((relevantProductFilter)=>relevantProductFilter === primaryProduct) ? [
            filter
        ] : [];
    });
};
const $674906c2a738886a$export$a8734449e402b6ca = (filters, selectedProducts)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        // Universal filters should always be shown for forge connectors
        // This is needed because forge connectors are dynamically loaded and not in the static products list
        if (filter && filter.universal && selectedProducts.some((0, $9d9t8.isForgeConnectorProductKey))) return [
            filter
        ];
        if (filter && f === 'content' && selectedProducts.includes((0, $b4tvS.ProductKeys).ConfluenceDC)) return (0, $dh538.fg)('confluence-dc-content-filter') ? [
            filter
        ] : [];
        else return filter && selectedProducts.some((product)=>filter?.products.includes(product)) ? [
            filter
        ] : [];
    });
};
/**
 * All available filters in the initial ordering
 * Configurable based on the primary product - this is the case for QF filters
 */ const $674906c2a738886a$var$getAllAvailableFilters = (filters, selectedProducts, config)=>{
    if (config?.basedOnPrimaryProduct && config?.primaryProduct) return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? $674906c2a738886a$export$546f6564ce5d0a17(filters, config?.primaryProduct) : $674906c2a738886a$export$a8734449e402b6ca(filters, selectedProducts);
    return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? $674906c2a738886a$export$1c5018e1c1ce99ae(filters) : $674906c2a738886a$export$a8734449e402b6ca(filters, selectedProducts);
};
/**
 * All available filters are always returned for inline, but the ordering depends on selection
 * The caller UI is responsible for deciding how many can be rendered by available width
 */ const $674906c2a738886a$var$getFilterIdsForInline = (filters, selectedProducts, filterSelectionOrder, config)=>{
    const allAvailableFilterIds = $674906c2a738886a$var$getAllAvailableFilters(filters, selectedProducts, config).map((a)=>a.id);
    // using the selection order, filter from the available (removes any invalid filters to show)
    const filtersForInline = filterSelectionOrder.filter((f)=>allAvailableFilterIds.includes(f));
    // Filters with no selections can also be prioritised based on the props
    const filtersPrioritised = config?.prioritisedFilterIds?.filter((f)=>allAvailableFilterIds.includes(f)) ?? [];
    // then simply add the rest back (with a set for deduplication)
    return [
        ...new Set([
            ...filtersForInline,
            ...filtersPrioritised,
            ...allAvailableFilterIds
        ])
    ];
};
const $674906c2a738886a$export$94c94f88577d66b2 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: ({ filters: filters, selectedProducts: selectedProducts, filterSelectionOrder: filterSelectionOrder }, config)=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters are hidden from both the inline filter row and the dropdown list.
        // setSearchStoreState clears their underlying selection in the same write so the store
        // stays in sync with what is visible/applied to URL/GraphQL/badge count.
        const excludedFilterIds = (0, $08c2ec3bf9b8f8f3$export$8848759bd942e213)(selectedProducts[0], filters);
        const isExcluded = (id)=>excludedFilterIds.has(id);
        // All filters always show in the dropdown, in order (minus excluded)
        const filtersInDropdown = $674906c2a738886a$var$getAllAvailableFilters(filters, selectedProducts, config).map((f)=>f.id).filter((id)=>!isExcluded(id));
        const filtersInLine = $674906c2a738886a$var$getFilterIdsForInline(filters, selectedProducts, filterSelectionOrder, config).filter((id)=>!isExcluded(id));
        return {
            filtersInDropdown: filtersInDropdown,
            filtersInLine: filtersInLine,
            filterSelectionOrder: filterSelectionOrder
        };
    }
});
const $674906c2a738886a$export$754cc306c2d9241e = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, resultsSort: resultsSort })=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters do not contribute to the badge count. setSearchStoreState
        // clears their underlying selection so the store stays in sync.
        const excludedFilterIds = (0, $08c2ec3bf9b8f8f3$export$8848759bd942e213)(selectedProducts[0], filters);
        const selectedFilters = Object.values(filters).filter((filter)=>filter?.hasSelection).filter((filter)=>filter && !excludedFilterIds.has(filter.id)).filter((filter)=>{
            const isAtlasSelected = selectedProducts.includes((0, $b4tvS.ProductKeys).Atlas);
            const isTypeFilter = filter?.id === (0, $5iakG.universalTypeFilterId);
            if ((0, $2OtFZ.serveWebPagesInTypeFilter)()) // Subtract 1 from selectedFilterCount when Atlas OR WebCrawler is selected as one of the
            // filters won't be displayed to the user
            return !isTypeFilter ? true : !selectedProducts.includes((0, $b4tvS.ProductKeys).Atlas) && !selectedProducts.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler);
            return isAtlasSelected ? !isTypeFilter : true;
        });
        const { field: field } = resultsSort;
        const isNotSortedByDefault = field !== (0, $2zuvB.SORT_FIELD_KEY).RELEVANCE;
        return {
            selectedFilterCount: selectedFilters.length + (isNotSortedByDefault ? 1 : 0)
        };
    }
});
const $674906c2a738886a$export$a63314038bf0cbf9 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ filters: filters })=>{
        const filterAttributes = Object.values(filters).flatMap((filter)=>{
            return filter ? [
                filter
            ] : [];
        }).map((filter)=>{
            const filterType = filter.type;
            switch(filterType){
                case 'boolean':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.value ? [
                            {
                                value: String(filter.value),
                                isSmartDefault: false,
                                filterId: filter.id
                            }
                        ] : []
                    };
                case 'multi-select':
                case 'single-select':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.options.filter((filterOption)=>filterOption.isSelected).map((filterOption)=>({
                                value: filterOption.trackingKey || filterOption.value,
                                isSmartDefault: filterOption.isSuggested,
                                filterId: filter.id
                            }))
                    };
                default:
                    return filterType;
            }
        }).filter((attributes)=>attributes.filterSelections.length).reduce((acc, curr)=>{
            return {
                filters: [
                    ...acc.filters,
                    ...curr.filters
                ],
                filterSelections: [
                    ...acc.filterSelections,
                    ...curr.filterSelections
                ]
            };
        }, {
            filters: [],
            filterSelections: []
        });
        return filterAttributes;
    }
});
const $674906c2a738886a$export$33ca33de08a5b6bb = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ cql: cql })=>cql
});
const $674906c2a738886a$export$210935c1afa2c65c = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters }, props = {
        includeSelectedProduct: true
    })=>{
        const hasSelectedProduct = selectedProducts[0];
        if (hasSelectedProduct && props.includeSelectedProduct) return true;
        return Object.values(filters).some((filter)=>filter?.hasSelection);
    }
});
const $674906c2a738886a$export$1f88edaa1bb97b87 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ leapQuery: leapQuery })=>leapQuery
});
const $674906c2a738886a$export$64ea42df9468ccc0 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>({
            backendExperiments: state.requestedBackendExperiments
        })
});
const $674906c2a738886a$export$5ce42807c47ad171 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.jsmIncidentFilterIds
});
const $674906c2a738886a$export$fce7b0e4e0dda8ee = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>{
        return state.filterDropdownOpenByQueryParam;
    }
});
module.exports["initialState"] = $674906c2a738886a$export$d4c72bab9d6cc13a;
module.exports["SearchStoreContainer"] = $674906c2a738886a$export$bf072992274c9fb;
module.exports["useSearch"] = $674906c2a738886a$export$bd221a7c56b93941;
module.exports["useSearchActions"] = $674906c2a738886a$export$c5a5afdff2ff0385;
module.exports["useSearchState"] = $674906c2a738886a$export$5fd14fa624074d55;
module.exports["useFilters"] = $674906c2a738886a$export$973ca22476b0e05f;
module.exports["useInputQuery"] = $674906c2a738886a$export$da992673b1309795;
module.exports["useSearchExperience"] = $674906c2a738886a$export$59d1399255ff1d16;
module.exports["useSearchQuery"] = $674906c2a738886a$export$e985158d10c27e34;
module.exports["useRetryCount"] = $674906c2a738886a$export$140d37088821fcb1;
module.exports["useQueryUpdatedTime"] = $674906c2a738886a$export$a2b38489a4538322;
module.exports["useResults"] = $674906c2a738886a$export$bda9ac73817ceec3;
module.exports["useResultsError"] = $674906c2a738886a$export$1c9622ace43d770d;
module.exports["useResultsRequestId"] = $674906c2a738886a$export$49f5dec896c355cd;
module.exports["useIsLoading"] = $674906c2a738886a$export$4dface15d86304a4;
module.exports["useResultsSort"] = $674906c2a738886a$export$f59185497e80e274;
module.exports["useQueryVersion"] = $674906c2a738886a$export$e2d0c00df99a687c;
module.exports["useWasContentClearedBySpaceChange"] = $674906c2a738886a$export$3bc2682926916b14;
module.exports["useResultsState"] = $674906c2a738886a$export$1e51d2073b60bd88;
module.exports["useSelectedProducts"] = $674906c2a738886a$export$826bdf756a8bf13a;
module.exports["useSelectedProduct"] = $674906c2a738886a$export$387e1da2bc9c93cc;
module.exports["useSelectedDatasource"] = $674906c2a738886a$export$e87eda20cc6e50c2;
module.exports["useIsJiraHydrationLoading"] = $674906c2a738886a$export$8c11ef422551818;
module.exports["useIsSearchReady"] = $674906c2a738886a$export$8dc083eb9766b48;
module.exports["useTypeEntities"] = $674906c2a738886a$export$59086fbf0d8f8d2a;
module.exports["useSelectFilterStore"] = $674906c2a738886a$export$aad641f503e4b4a8;
module.exports["useBooleanFilterStore"] = $674906c2a738886a$export$c724ec2cbd2fedce;
module.exports["useFiltersToDisplay"] = $674906c2a738886a$export$94c94f88577d66b2;
module.exports["useSelectedFilterCount"] = $674906c2a738886a$export$754cc306c2d9241e;
module.exports["useFilterAttributesForTracking"] = $674906c2a738886a$export$a63314038bf0cbf9;
module.exports["useCQL"] = $674906c2a738886a$export$33ca33de08a5b6bb;
module.exports["useAnyFilterSelected"] = $674906c2a738886a$export$210935c1afa2c65c;
module.exports["useRequestedBackendExperiments"] = $674906c2a738886a$export$64ea42df9468ccc0;
module.exports["useJsmIncidentFilterIds"] = $674906c2a738886a$export$5ce42807c47ad171;
module.exports["useFilterDropdownOpenByQueryParam"] = $674906c2a738886a$export$fce7b0e4e0dda8ee;

});

parcelRegister("2zuvB", function(module, exports) {
const $46c1a866454c924b$export$fdf34174678f07b6 = {
    RELEVANCE: 'relevance',
    LAST_MODIFIED_DATE: 'latestModifiedDate',
    CREATED_DATE: 'createdDate'
};
const $46c1a866454c924b$export$d33cb9b119034d29 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.RELEVANCE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC = `${$46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.ASC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC = `${$46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.ASC}`;
const $46c1a866454c924b$export$6b492fdcc7e8d1f4 = {
    [$46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.RELEVANCE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC}Selected`,
        drawerOrder: 0
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC}Selected`,
        drawerOrder: 1
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.ASC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC}Selected`,
        drawerOrder: 2
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC}Selected`,
        drawerOrder: 3
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.ASC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC}Selected`,
        drawerOrder: 4
    }
};
const $46c1a866454c924b$export$76673e1b214c1378 = Object.values($46c1a866454c924b$export$6b492fdcc7e8d1f4).sort((a, b)=>a.drawerOrder - b.drawerOrder);
const $46c1a866454c924b$export$d3cbda30e53df6f6 = (field, order)=>`${field}${order}`;
module.exports["SORT_FIELD_KEY"] = $46c1a866454c924b$export$fdf34174678f07b6;
module.exports["SORT_ORDER"] = $46c1a866454c924b$export$d33cb9b119034d29;
module.exports["RESULTS_SORT_FIELDS"] = $46c1a866454c924b$export$6b492fdcc7e8d1f4;

});

parcelRegister("fZ3l2", function(module, exports) {
const $c3268331ff3eb240$export$cdcda2a8fcb980fa = {
    NO_RESULTS: 'noResults',
    INITIAL: 'initial',
    RESULTS: 'results',
    ERROR: 'error',
    IS_LOADING: 'isLoading'
};
module.exports["ResultsStates"] = $c3268331ff3eb240$export$cdcda2a8fcb980fa;

});

parcelRegister("fUcm0", function(module, exports) {

var $eMqrF = parcelRequire("eMqrF");


var $iBY5n = parcelRequire("iBY5n");

const $5c084a67f28eba8a$export$e8eac31981efe1fb = (ari)=>{
    let teamId = null;
    if (!ari) return teamId;
    const isTeamsAri = (0, $iBY5n.TeamsTeamAri).check(ari);
    const isIdentityTeamsAri = (0, $eMqrF.IdentityTeamAri).check(ari);
    if (isTeamsAri) teamId = (0, $iBY5n.TeamsTeamAri).parse(ari).teamId;
    else if (isIdentityTeamsAri) teamId = (0, $eMqrF.IdentityTeamAri).parse(ari).teamId;
    if (teamId === 'unidentified') teamId = null;
    return teamId;
};
module.exports["getTeamId"] = $5c084a67f28eba8a$export$e8eac31981efe1fb;

});

parcelRegister("dOOW1", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $dh538 = parcelRequire("dh538");


var $dcbm4 = parcelRequire("dcbm4");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $7oQyb = parcelRequire("7oQyb");


var $2OtFZ = parcelRequire("2OtFZ");

/**
 * Gets 3P products that support a given filter, using ThirdPartyConfigs.
 *
 * This is intentionally in a separate file from filters/index.ts to avoid
 * pulling ThirdPartyConfigs (and its 66 icon-laden config files) into the
 * generateSearchInputs bundle. This file is only imported by UI filter
 * components, not by the generateSearchInputs call path.
 */ 
var $hB77E = parcelRequire("hB77E");

const $779a23dd67a96bae$export$ef6dfb919b1d7267 = (filterId)=>{
    const productsForFilter = [];
    (0, $hB77E.getThirdPartyConfigs)().forEach((config, productKey3P)=>{
        // The search-page `FilterId` is a superset of the `rovo-connectors-config` `FilterId`
        // used by `config.filters`. If `filterId` is not one of the connector-supported filters
        // the `includes` check simply returns false, which is the desired behaviour.
        // Remove casting when cleaning up platform_search_3p_config_consolidation FG.
        if (config.filters?.includes(filterId)) productsForFilter.push(productKey3P);
    });
    return productsForFilter;
};


/**
 * Static integration ARI mapping extracted for SSR bundle isolation.
 * No icon, config, or React imports — just pure string constants.
 *
 * This replaces the dynamic getIntegrationARIsFromConfig() function which
 * iterated ThirdPartyConfigs (pulling in 66 icon-laden config files).
 *
 * The baseIntegrationARIs map is the single source of truth for
 * ProductKey → integration ARI mappings. filters/index.ts imports and
 * re-exports from here.
 */ 


// 3P Integration ARIs
const $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $62eb2e94deff5767$var$WEB_CRAWLER_INTEGRATION_ARI = 'ari:cloud:platform::integration/atlassian-web-crawler';
const $62eb2e94deff5767$var$GITHUB_INTEGRATION_ARI = 'ari:cloud:platform::integration/github';
const $62eb2e94deff5767$var$FIGMA_INTEGRATION_ARI = 'ari:cloud:platform::integration/figma';
const $62eb2e94deff5767$var$LOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/loom';
const $62eb2e94deff5767$var$DROPBOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/dropbox';
const $62eb2e94deff5767$var$AIRTABLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/airtable';
const $62eb2e94deff5767$var$SMARTSHEET_INTEGRATION_ARI = 'ari:cloud:platform::integration/smartsheet';
const $62eb2e94deff5767$var$BITBUCKET_INTEGRATION_ARI = 'ari:cloud:platform::integration/bitbucket';
const $62eb2e94deff5767$var$NOTION_INTEGRATION_ARI = 'ari:cloud:platform::integration/notion';
const $62eb2e94deff5767$var$MIRO_INTEGRATION_ARI = 'ari:cloud:platform::integration/miro';
const $62eb2e94deff5767$var$ZENDESK_INTEGRATION_ARI = 'ari:cloud:platform::integration/zendesk';
const $62eb2e94deff5767$var$DOCUSIGN_INTEGRATION_ARI = 'ari:cloud:platform::integration/docusign';
const $62eb2e94deff5767$var$LUCID_INTEGRATION_ARI = 'ari:cloud:platform::integration/lucid';
const $62eb2e94deff5767$var$MONDAY_INTEGRATION_ARI = 'ari:cloud:platform::integration/monday';
const $62eb2e94deff5767$var$AZURE_DEVOPS_INTEGRATION_ARI = 'ari:cloud:platform::integration/azure-devops';
const $62eb2e94deff5767$var$GITLAB_INTEGRATION_ARI = 'ari:cloud:platform::integration/gitlab';
const $62eb2e94deff5767$var$CONFLUENCE_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/confluence-dc';
const $62eb2e94deff5767$var$CANVA_INTEGRATION_ARI = 'ari:cloud:platform::integration/canva';
const $62eb2e94deff5767$var$ASANA_INTEGRATION_ARI = 'ari:cloud:platform::integration/asana';
const $62eb2e94deff5767$var$BOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/box';
const $62eb2e94deff5767$var$ZEPLIN_INTEGRATION_ARI = 'ari:cloud:platform::integration/zeplin';
const $62eb2e94deff5767$var$SERVICENOW_INTEGRATION_ARI = 'ari:cloud:platform::integration/servicenow';
const $62eb2e94deff5767$var$FRESHSERVICE_INTEGRATION_ARI = 'ari:cloud:platform::integration/freshservice';
const $62eb2e94deff5767$var$CLICKUP_INTEGRATION_ARI = 'ari:cloud:platform::integration/clickup';
const $62eb2e94deff5767$var$AMPLITUDE_INTEGRATION_ARI = 'ari:cloud:platform::integration/amplitude';
const $62eb2e94deff5767$var$STRIPE_INTEGRATION_ARI = 'ari:cloud:platform::integration/stripe';
const $62eb2e94deff5767$var$ADOBE_INTEGRATION_ARI = 'ari:cloud:platform::integration/adobe';
const $62eb2e94deff5767$var$AHA_INTEGRATION_ARI = 'ari:cloud:platform::integration/aha';
const $62eb2e94deff5767$var$MURAL_INTEGRATION_ARI = 'ari:cloud:platform::integration/mural';
const $62eb2e94deff5767$var$WEBEX_INTEGRATION_ARI = 'ari:cloud:platform::integration/cisco';
const $62eb2e94deff5767$var$TODOIST_INTEGRATION_ARI = 'ari:cloud:platform::integration/todoist';
const $62eb2e94deff5767$var$PAGERDUTY_INTEGRATION_ARI = 'ari:cloud:platform::integration/pagerduty';
const $62eb2e94deff5767$var$PIPEDRIVE_INTEGRATION_ARI = 'ari:cloud:platform::integration/pipedrive';
const $62eb2e94deff5767$var$HUBSPOT_INTEGRATION_ARI = 'ari:cloud:platform::integration/hubspot';
const $62eb2e94deff5767$var$DOVETAIL_INTEGRATION_ARI = 'ari:cloud:platform::integration/dovetail';
const $62eb2e94deff5767$var$LAUNCHDARKLY_INTEGRATION_ARI = 'ari:cloud:platform::integration/launchdarkly';
const $62eb2e94deff5767$var$SALESFORCE_INTEGRATION_ARI = 'ari:cloud:platform::integration/salesforce';
const $62eb2e94deff5767$var$SENTRY_INTEGRATION_ARI = 'ari:cloud:platform::integration/sentry';
const $62eb2e94deff5767$var$JIRA_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/jira-dc';
const $62eb2e94deff5767$var$GITBOOK_INTEGRATION_ARI = 'ari:cloud:platform::integration/graph-test-app';
const $62eb2e94deff5767$var$DATABRICKS_INTEGRATION_ARI = 'ari:cloud:platform::integration/databricks';
// Forge Integration ARIs
const $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z';
const $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93';
const $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy';
const $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO';
const $62eb2e94deff5767$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL';
const $62eb2e94deff5767$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mRcqWRwqkUd4JwapGkvGHUViyySX9MVy';
const $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY';
const $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K';
const $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi';
const $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u';
const $62eb2e94deff5767$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j';
const $62eb2e94deff5767$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI';
const $62eb2e94deff5767$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/psr1wBkasRuKCwsvwi4aTJNhjmlVFebC';
const $62eb2e94deff5767$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL';
const $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq';
const $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo';
const $62eb2e94deff5767$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5';
const $62eb2e94deff5767$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29';
const $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC';
const $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP';
const $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF';
const $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J';
const $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo';
const $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb';
const $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0';
const $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G';
const $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3';
const $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5';
const $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua';
const $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf';
const $62eb2e94deff5767$export$d82a82f2333502ad = {
    [(0, $7oQyb.ProductKey).GoogleDrive]: $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Sharepoint]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AtlassianWebCrawler]: $62eb2e94deff5767$var$WEB_CRAWLER_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Teams]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Figma]: $62eb2e94deff5767$var$FIGMA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Gitbook]: $62eb2e94deff5767$var$GITBOOK_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Loom]: $62eb2e94deff5767$var$LOOM_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).OneDrive]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Github]: $62eb2e94deff5767$var$GITHUB_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Bitbucket]: $62eb2e94deff5767$var$BITBUCKET_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Airtable]: $62eb2e94deff5767$var$AIRTABLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Smartsheet]: $62eb2e94deff5767$var$SMARTSHEET_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Notion]: $62eb2e94deff5767$var$NOTION_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Miro]: $62eb2e94deff5767$var$MIRO_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Zendesk]: $62eb2e94deff5767$var$ZENDESK_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Docusign]: $62eb2e94deff5767$var$DOCUSIGN_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Lucid]: $62eb2e94deff5767$var$LUCID_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Monday]: $62eb2e94deff5767$var$MONDAY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AzureDevops]: $62eb2e94deff5767$var$AZURE_DEVOPS_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Gitlab]: $62eb2e94deff5767$var$GITLAB_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ConfluenceDC]: $62eb2e94deff5767$var$CONFLUENCE_DC_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Canva]: $62eb2e94deff5767$var$CANVA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).OutlookCalendar]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Asana]: $62eb2e94deff5767$var$ASANA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Zeplin]: $62eb2e94deff5767$var$ZEPLIN_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ServiceNow]: $62eb2e94deff5767$var$SERVICENOW_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Freshservice]: $62eb2e94deff5767$var$FRESHSERVICE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).PowerBI]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ClickUp]: $62eb2e94deff5767$var$CLICKUP_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Amplitude]: $62eb2e94deff5767$var$AMPLITUDE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Stripe]: $62eb2e94deff5767$var$STRIPE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AdobeXD]: $62eb2e94deff5767$var$ADOBE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Aha]: $62eb2e94deff5767$var$AHA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AdobeSign]: $62eb2e94deff5767$var$ADOBE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Mural]: $62eb2e94deff5767$var$MURAL_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Webex]: $62eb2e94deff5767$var$WEBEX_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Todoist]: $62eb2e94deff5767$var$TODOIST_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).PagerDuty]: $62eb2e94deff5767$var$PAGERDUTY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Pipedrive]: $62eb2e94deff5767$var$PIPEDRIVE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Hubspot]: $62eb2e94deff5767$var$HUBSPOT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Dovetail]: $62eb2e94deff5767$var$DOVETAIL_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).LaunchDarkly]: $62eb2e94deff5767$var$LAUNCHDARKLY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Salesforce]: $62eb2e94deff5767$var$SALESFORCE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Sentry]: $62eb2e94deff5767$var$SENTRY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).JiraDC]: $62eb2e94deff5767$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).JsmDC]: $62eb2e94deff5767$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Box]: $62eb2e94deff5767$var$BOX_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Dropbox]: $62eb2e94deff5767$var$DROPBOX_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).GoogleCalendar]: $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Gmail]: $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Databricks]: $62eb2e94deff5767$var$DATABRICKS_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AWSS3]: $62eb2e94deff5767$var$GITBOOK_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).OutlookMail]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Slack]: 'ari:cloud:platform::integration/slack',
    // Forge Products - Dev and Prod versions
    [(0, $7oQyb.ProductKey).ForgeAdamVitareqDev]: $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeAdamVitareqProd]: $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeK15tScrollSitesDev]: $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeK15tScrollSitesProd]: $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioAwsDev]: $62eb2e94deff5767$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioAwsProd]: $62eb2e94deff5767$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioClickupDev]: $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioClickupProd]: $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitbookDev]: $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitbookProd]: $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGithubDev]: $62eb2e94deff5767$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGithubProd]: $62eb2e94deff5767$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitlabDev]: $62eb2e94deff5767$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitlabProd]: $62eb2e94deff5767$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGoogleDriveDev]: $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGoogleDriveProd]: $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGuruDev]: $62eb2e94deff5767$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGuruProd]: $62eb2e94deff5767$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHelpjuiceDev]: $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHelpjuiceProd]: $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHubspotDev]: $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHubspotProd]: $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSalesforceDev]: $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSalesforceProd]: $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSharepointDev]: $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSharepointProd]: $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioStackOverflowDev]: $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioStackOverflowProd]: $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeUtoolityGitbookDev]: $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeUtoolityGitbookProd]: $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeGdriveEugeneTestDev]: $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeGdriveEugeneTestProd]: $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI
};
const $62eb2e94deff5767$var$FORGE_CONNECTOR_PREFIX = 'forge-connector-';
const $62eb2e94deff5767$export$530d1d49b6479256 = (productKey)=>{
    if (!productKey.startsWith($62eb2e94deff5767$var$FORGE_CONNECTOR_PREFIX)) return undefined;
    const withoutPrefix = productKey.slice($62eb2e94deff5767$var$FORGE_CONNECTOR_PREFIX.length);
    // Hash is everything before the first hyphen after the prefix
    const hyphenIndex = withoutPrefix.indexOf('-');
    if (hyphenIndex === -1) return undefined;
    const hash = withoutPrefix.slice(0, hyphenIndex);
    return `ari:cloud:platform::integration/${hash}`;
};
const $62eb2e94deff5767$export$3be99390ed5e95e2 = (productKey)=>{
    // Check static mapping first
    const staticAri = $62eb2e94deff5767$export$d82a82f2333502ad[productKey];
    if (staticAri !== undefined) return staticAri;
    // Fall back to Forge connector derivation
    return $62eb2e94deff5767$export$530d1d49b6479256(productKey);
};






const $a113941c76257cbc$var$DEFAULT_ENTITY_SUBTYPES = {
    [(0, $2Znam.TypeFilterValueKey).Document]: [
        (0, $2Znam.NounSubtypeKey).Document,
        (0, $2Znam.NounSubtypeKey).Pdf
    ],
    [(0, $2Znam.TypeFilterValueKey).Spreadsheet]: [
        (0, $2Znam.NounSubtypeKey).Spreadsheet
    ],
    [(0, $2Znam.TypeFilterValueKey).Presentation]: [
        (0, $2Znam.NounSubtypeKey).Presentation
    ],
    [(0, $2Znam.TypeFilterValueKey).Video]: [
        (0, $2Znam.NounSubtypeKey).Video
    ],
    [(0, $2Znam.TypeFilterValueKey).Design]: [
        (0, $2Znam.NounSubtypeKey).Design
    ],
    [(0, $2Znam.TypeFilterValueKey).Conversation]: [],
    [(0, $2Znam.TypeFilterValueKey).Message]: [],
    // Comment filter should map to the comment subtype to avoid returning unrelated results
    // (e.g. web pages) for products that don't have an explicit typeFilterConfig for comments
    [(0, $2Znam.TypeFilterValueKey).Comment]: [
        (0, $2Znam.NounSubtypeKey).Comment
    ],
    [(0, $2Znam.TypeFilterValueKey).Image]: [
        (0, $2Znam.NounSubtypeKey).Image
    ],
    [(0, $2Znam.TypeFilterValueKey).Audio]: [
        (0, $2Znam.NounSubtypeKey).Audio
    ],
    [(0, $2Znam.TypeFilterValueKey).Pdf]: [
        (0, $2Znam.NounSubtypeKey).Pdf
    ],
    [(0, $2Znam.TypeFilterValueKey).Code]: [
        (0, $2Znam.NounSubtypeKey).Code
    ],
    [(0, $2Znam.TypeFilterValueKey).Archive]: [
        (0, $2Znam.NounSubtypeKey).Archive
    ],
    [(0, $2Znam.TypeFilterValueKey).Folder]: [
        (0, $2Znam.NounSubtypeKey).Folder
    ],
    [(0, $2Znam.TypeFilterValueKey).Shortcut]: [
        (0, $2Znam.NounSubtypeKey).Shortcut
    ],
    [(0, $2Znam.TypeFilterValueKey).Form]: [
        (0, $2Znam.NounSubtypeKey).Form
    ],
    [(0, $2Znam.TypeFilterValueKey).Notebook]: [
        (0, $2Znam.NounSubtypeKey).Notebook
    ],
    [(0, $2Znam.TypeFilterValueKey).Other]: [
        (0, $2Znam.NounSubtypeKey).Other
    ],
    [(0, $2Znam.TypeFilterValueKey).WebPage]: [
        (0, $2Znam.NounSubtypeKey).WebPage
    ],
    [(0, $2Znam.TypeFilterValueKey).Dashboard]: [
        (0, $2Znam.NounSubtypeKey).Dashboard
    ],
    [(0, $2Znam.TypeFilterValueKey).Database]: [
        (0, $2Znam.NounSubtypeKey).Database
    ]
};
const $a113941c76257cbc$export$b7b676578c62639d = ()=>({
        commonFilters: {},
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: false,
            contentStatuses: [],
            containerStatus: []
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: []
            },
            objectTypeFilter: {
                typeARIs: []
            }
        },
        jiraFilters: {
            issueFilter: {
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                projectARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: {
            owners: [],
            focusAreaTypeIds: [],
            ancestorIds: []
        },
        talentFilters: {
            owners: [],
            employmentTypes: [],
            focusAreas: [],
            jobFamilies: [],
            statuses: [],
            teams: []
        },
        compassFilters: {
            componentFilter: {
                componentStates: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: [],
            integrations: [],
            createdBy: [],
            lastUpdatedBy: [],
            assignees: [],
            labels: []
        },
        sortFilters: []
    });
const $a113941c76257cbc$var$DATE_RANGE_PRESETS = [
    {
        name: 'today',
        fromOffset: 0,
        toOffset: 0
    },
    {
        name: 'yesterday',
        fromOffset: 1,
        toOffset: 1
    },
    {
        name: 'past7Days',
        fromOffset: 7,
        toOffset: 0
    },
    {
        name: 'past30Days',
        fromOffset: 30,
        toOffset: 0
    },
    {
        name: 'pastYear',
        fromOffset: 365,
        toOffset: 0
    }
];
/**
 * Gets a UTC date string (YYYY-MM-DD) for a given number of days ago.
 * Uses UTC timezone to match backend date calculations.
 */ const $a113941c76257cbc$var$getUTCDateString = (daysAgo)=>{
    const now = new Date();
    const utcDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - daysAgo));
    return utcDate.toISOString().split('T')[0];
};
const $a113941c76257cbc$export$64e54565c5bfc685 = (dateRange)=>{
    if (!dateRange || !dateRange.gt && !dateRange.lt) return 'anytime';
    if (!dateRange.gt) return 'custom';
    const inputGtDate = dateRange.gt.split('T')[0];
    const inputLtDate = dateRange.lt?.split('T')[0];
    for (const preset of $a113941c76257cbc$var$DATE_RANGE_PRESETS){
        const presetGtDate = $a113941c76257cbc$var$getUTCDateString(preset.fromOffset);
        const presetLtDate = $a113941c76257cbc$var$getUTCDateString(preset.toOffset);
        if (inputGtDate === presetGtDate) {
            // If BE has also provided lt, it must match the preset's lt for this to be the preset.
            // E.g. gt='2026-02-01', lt='2026-02-03' is a custom range (Feb 1–3), not past7Days
            if (inputLtDate != null && inputLtDate !== presetLtDate) continue;
            return preset.name;
        }
    }
    return 'custom';
};
const $a113941c76257cbc$var$isSupportedParticipant = (participant)=>{
    const { users: users, combination: combination, type: type } = participant;
    if (type !== 'PRESENCE') return false;
    if (users.length > 1 && combination === 'AND') return false;
    return true;
};
const $a113941c76257cbc$export$ae993d8ff9dd28 = (participants)=>{
    const { items: items, combination: combination } = participants;
    if (items.length > 1 && combination === 'AND') return [];
    if (!items.every($a113941c76257cbc$var$isSupportedParticipant)) return [];
    return Array.from(new Set(items.flatMap(({ users: users })=>users)));
};
const $a113941c76257cbc$export$2703353a19002efe = ()=>{
    return {
        ...(0, $62eb2e94deff5767$export$d82a82f2333502ad)
    };
};
/**
 * Checks the product-specific feature gate for video noun filtering.
 * - Google Drive: controlled by 'rovo_fps_enable_video_noun_filter'
 * - SharePoint: controlled by 'rovo_fps_sharepoint_enable_video_noun_filter'
 * - Other products: returns false (not supported)
 */ const $a113941c76257cbc$var$isVideoNounFilterEnabled = (product)=>{
    if (product === (0, $7oQyb.ProductKey).GoogleDrive) return (0, $dh538.fg)('rovo_fps_enable_video_noun_filter');
    if (product === (0, $7oQyb.ProductKey).Sharepoint) return (0, $dh538.fg)('rovo_fps_sharepoint_enable_video_noun_filter');
    return false;
};
const $a113941c76257cbc$var$buildGitFilters = (pullRequestStatus, repoName)=>{
    if (!pullRequestStatus?.length && !repoName?.length) return undefined;
    return {
        gitFilters: {
            ...pullRequestStatus?.length && {
                pullRequestStatus: pullRequestStatus
            },
            ...repoName?.length && {
                repoName: repoName
            }
        }
    };
};
/**
 * Build MS Teams (`teamsFilters`) wire payload. The AGG field is `hasAttachment` (boolean) which
 * scopes Teams results to messages with attachments. Returns `undefined` when no Teams filter is
 * set so the caller can spread the result without sending an empty object.
 */ const $a113941c76257cbc$var$buildTeamsFilters = (hasAttachment)=>{
    if (!hasAttachment) return undefined;
    return {
        teamsFilters: {
            hasAttachment: true
        }
    };
};
const $a113941c76257cbc$var$filterConnectorSources = (product, isAllProductSearch, thirdPartyConfigs, connectorSources)=>{
    if (product === (0, $7oQyb.ProductKey).Slack && (0, $2OtFZ.removeFedSlackFromAllProductSearch)(thirdPartyConfigs, isAllProductSearch)) // When a federated Slack connector exists in all-product search,
    // exclude both 'federated' and 'smartlinks' connector sources so that
    // only the federated connector serves results in that context.
    return connectorSources?.filter((s)=>s !== (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE) && (!(0, $dh538.fg)('ai_3p_slack_smartlinks_federated_connector_enabled') || s !== (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE)));
    return connectorSources;
};
const $a113941c76257cbc$var$hasConnectorSources = (product, isAllProductSearch, thirdPartyConfigs)=>{
    const connectorSources = thirdPartyConfigs[product]?.connectorSources;
    const filteredConnectorSources = $a113941c76257cbc$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, connectorSources);
    return (filteredConnectorSources?.length ?? 0) > 0;
};
const $a113941c76257cbc$export$3766c9ce0c94452 = (products, titleMatchValue, // entities is the frontend filtered, already selected values
entities, thirdPartyConfigs, isAllProductSearch = true, range, assignees, containerAris, createdBy, lastUpdatedBy, ancestorAris, labels, additionalTexts, selectedDatasource, salesforceOwners, salesforceStage, salesforceCloseDate, opportunityStatus, pullRequestStatus, repoName, campaignStatuses, caseStatuses, slackChannels, hasAttachment)=>{
    if (!products.length || products.some((p)=>(0, $b4tvS.is3pProductKey)(p) || (0, $9d9t8.isForgeConnectorProductKey)(p) || p === (0, $7oQyb.ProductKey).Bitbucket)) {
        // Conditionally create the dynamic integration ARIs based on the config
        const integrationARIsFromConfig = $a113941c76257cbc$export$2703353a19002efe();
        // Combine static and dynamic integration ARIs
        let productToIntegrationARIMap = integrationARIsFromConfig;
        // Add Forge connector integration ARIs from thirdPartyConfigs
        products.forEach((product)=>{
            if ((0, $9d9t8.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]) {
                const integrationAri = thirdPartyConfigs[product]?.integrationAri;
                productToIntegrationARIMap[product] = integrationAri;
            }
        });
        // Note: Bitbucket integration ARI is already included in baseIntegrationARIs
        // get the subtypes by looking at each type's subcategories
        let allSubtypes = [];
        let allContainerTypes = [];
        let thirdPartyProducts = [];
        const filteredProducts = products.filter((product)=>((0, $b4tvS.is3pProductKey)(product) || (0, $9d9t8.isForgeConnectorProductKey)(product)) && thirdPartyConfigs[product] !== undefined && (!thirdPartyConfigs[product]?.userNeedsOAuth || $a113941c76257cbc$export$9c38ca92ec6e6d40(product, thirdPartyConfigs)) && !thirdPartyConfigs[product]?.isFederated && $a113941c76257cbc$var$hasConnectorSources(product, isAllProductSearch, thirdPartyConfigs)).filter((product)=>{
            return thirdPartyConfigs[product]?.isEnabled?.();
        });
        // Products that support embedded comments (comments are returned as linkedEntities within documents)
        const productsWithEmbeddedComments = [
            (0, $7oQyb.ProductKey).GoogleDrive,
            (0, $7oQyb.ProductKey).Sharepoint
        ];
        // Skip code search (Document entity) unless GitHub is the only selected product. Aligned
        // with `includeGithubCode` in services/search-query-generator/index.ts so the entities payload
        // and the Relay `@include(if: $includeGithubCode)` directive can't diverge.
        const isOnlyGithubSelected = products.length === 1 && (0, $b4tvS.GITHUB_PRODUCT_KEYS).includes(products[0]);
        for (let product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig) continue;
            const isGithubProduct = (0, $b4tvS.GITHUB_PRODUCT_KEYS).includes(product);
            const shouldSkipDocumentForGithub = isGithubProduct && !isOnlyGithubSelected;
            let localSubtypes = [];
            let productEntities = [];
            let connectionIds;
            let linkedEntityGranularity;
            // Check if Comment filter is selected for a product that supports embedded comments.
            // Each product is gated behind its own feature flag so support can be toggled
            // independently:
            //   - Google Drive: enable_3p_embedded_comments_search
            //   - SharePoint:   rovo_fps_sharepoint_embedded_comments
            const isCommentFilterSelected = entities.includes((0, $2Znam.TypeFilterValueKey).Comment);
            const isEmbeddedCommentsEnabledForProduct = product === (0, $7oQyb.ProductKey).GoogleDrive && (0, $dh538.fg)('enable_3p_embedded_comments_search') || product === (0, $7oQyb.ProductKey).Sharepoint && (0, $dh538.fg)('rovo_fps_sharepoint_embedded_comments');
            const supportsEmbeddedComments = productsWithEmbeddedComments.includes(product);
            if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct) // Use ONLY_LINKED_ENTITIES to force match only on comments.
            // Note: linkedEntities input is deprecated and ignored by the aggregator —
            // linkedEntityGranularity alone controls this behaviour.
            linkedEntityGranularity = 'ONLY_LINKED_ENTITIES';
            // Check if the product has specific typeFilterConfig for the requested entities
            let hasMatchingTypeConfig = false;
            thirdPartyConfig.typeFilterConfig?.forEach((entitiesConfig, entityValue)=>{
                if (entities.includes(entityValue)) {
                    localSubtypes = [
                        ...localSubtypes,
                        ...entitiesConfig.subTypes3P
                    ];
                    hasMatchingTypeConfig = true;
                }
            });
            if ((0, $dh538.fg)('rovo-search-dynamic-forge-config')) {
                // Extract all entities from typeFilterConfig for this product
                if (thirdPartyConfig.typeFilterConfig) {
                    thirdPartyConfig.typeFilterConfig.forEach((entitiesConfig, entityValue)=>{
                        if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct && entityValue === (0, $2Znam.TypeFilterValueKey).Comment) return;
                        if (shouldSkipDocumentForGithub && entityValue === (0, $2Znam.TypeFilterValueKey).Document) return;
                        const shouldFilterByType = $a113941c76257cbc$var$isVideoNounFilterEnabled(product) && // entities.length > 0 ensures we only filter when specific types are selected;
                        // when "All" is selected, entities is empty and we fall through to the else branch
                        entities.length > 0;
                        if (shouldFilterByType) {
                            if (entities.includes(entityValue)) productEntities = [
                                ...productEntities,
                                ...entitiesConfig.entities3P
                            ];
                        } else // When entities is empty (All selected), include all entities from the config
                        productEntities = [
                            ...productEntities,
                            ...entitiesConfig.entities3P
                        ];
                    });
                    productEntities = [
                        ...new Set(productEntities)
                    ];
                }
                // Capture connectionId when present (dynamic Forge connectors)
                if (thirdPartyConfig.connectionId) connectionIds = [
                    thirdPartyConfig.connectionId
                ];
            } else if (thirdPartyConfig.typeFilterConfig && $a113941c76257cbc$var$isVideoNounFilterEnabled(product)) {
                // For Google Drive and SharePoint: only include entities from type filter configs that match selected entities
                // This ensures entity ATI is only included when the corresponding type is selected
                thirdPartyConfig.typeFilterConfig.forEach((entitiesConfig, entityValue)=>{
                    if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct && entityValue === (0, $2Znam.TypeFilterValueKey).Comment) return;
                    if (shouldSkipDocumentForGithub && entityValue === (0, $2Znam.TypeFilterValueKey).Document) return;
                    // Only include entities from type filter configs that match the selected entities
                    if (entities.includes(entityValue)) productEntities = [
                        ...productEntities,
                        ...entitiesConfig.entities3P
                    ];
                });
                productEntities = [
                    ...new Set(productEntities)
                ];
            }
            // If no specific typeFilterConfig matched, use default subtypes for the entities
            if (!hasMatchingTypeConfig && entities.length > 0) entities.forEach((entity)=>{
                const defaultSubtypes = $a113941c76257cbc$var$DEFAULT_ENTITY_SUBTYPES[entity] ?? [];
                if (defaultSubtypes.length > 0) localSubtypes = [
                    ...localSubtypes,
                    ...defaultSubtypes
                ];
            });
            // Add local subtypes to the global subtypes array and remove duplicates
            allSubtypes = [
                ...new Set([
                    ...allSubtypes,
                    ...localSubtypes
                ])
            ];
            const integrationId = thirdPartyConfig.integrationAri;
            const providerId = thirdPartyConfig.providerId;
            const connectorSources = $a113941c76257cbc$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, thirdPartyConfig.connectorSources);
            const datasourceId = thirdPartyConfig.datasourceId;
            product = product === (0, $7oQyb.ProductKey).JsmDC ? (0, $7oQyb.ProductKey).JiraDC : product;
            // Only fan out per-datasource when a specific datasource is selected, OR when
            // getFiltersForSelectedDatasources affects thirdPartyProduct routing (e.g. Jira DC
            // sets a per-instance integrationId/providerId). For webcrawler, when "All" is
            // selected, all datasource entries would be identical (same integrationId, same
            // filters) — causing N duplicate requests to the search backend. Instead, fall
            // through to the single-entry else branch below.
            const shouldFanOut = thirdPartyConfig.datasources && thirdPartyConfig.fanOutConnectorSources && (!!selectedDatasource || product !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler);
            if (shouldFanOut && thirdPartyConfig.datasources) {
                const datasourcesForQuery = selectedDatasource ? thirdPartyConfig.datasources.filter((ds)=>ds.datasourceId === selectedDatasource) : thirdPartyConfig.datasources;
                for (const datasourceConfig of datasourcesForQuery){
                    const datasourceContainerTypes = datasourceConfig.containerTypes || [];
                    allContainerTypes = [
                        ...new Set([
                            ...allContainerTypes,
                            ...datasourceContainerTypes
                        ])
                    ];
                    const thirdPartyProductFilterForThisProduct = {
                        integrationId: integrationId,
                        subtypes: localSubtypes,
                        providerId: providerId,
                        product: product,
                        connectorSources: connectorSources,
                        ...(0, $dh538.fg)('add_datasourceid_to_search_graphql') && {
                            datasourceId: datasourceId
                        },
                        ...productEntities.length > 0 && {
                            entities: productEntities
                        },
                        ...connectionIds && {
                            connectionIds: connectionIds
                        },
                        ...linkedEntityGranularity && {
                            linkedEntityGranularity: linkedEntityGranularity
                        }
                    };
                    // For webcrawler (flag ON), getFiltersForSelectedDatasources returns only { additionalTexts }
                    // with no thirdPartyProduct key, so allFilters?.thirdPartyProduct is always undefined for
                    // webcrawler — the else branch always runs and additionalTexts is discarded here.
                    // The webcrawler's additionalTexts is correctly accumulated in the datasourceFilters loop below,
                    // making this call a no-op for webcrawler. Only thirdPartyProduct is consumed in this code path.
                    const allFilters = product !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler || (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled') ? thirdPartyConfig.getFiltersForSelectedDatasources?.(datasourceConfig, {}) : undefined;
                    if (allFilters?.thirdPartyProduct) thirdPartyProducts.push({
                        ...thirdPartyProductFilterForThisProduct,
                        ...allFilters.thirdPartyProduct
                    });
                    else thirdPartyProducts.push(thirdPartyProductFilterForThisProduct);
                }
            } else thirdPartyProducts.push({
                integrationId: integrationId,
                subtypes: localSubtypes,
                providerId: providerId,
                product: product,
                connectorSources: connectorSources,
                ...(0, $dh538.fg)('add_datasourceid_to_search_graphql') && {
                    datasourceId: datasourceId
                },
                ...productEntities.length > 0 && {
                    entities: productEntities
                },
                ...connectionIds && {
                    connectionIds: connectionIds
                },
                ...linkedEntityGranularity && {
                    linkedEntityGranularity: linkedEntityGranularity
                }
            });
        }
        if (thirdPartyProducts) {
            // Add Loom and Bitbucket to the thirdPartyProducts filter
            const firstPartyProductsFor3pFilters = [
                (0, $7oQyb.ProductKey).Loom,
                (0, $7oQyb.ProductKey).Bitbucket
            ];
            const result = firstPartyProductsFor3pFilters.filter((product)=>products.includes(product) && !thirdPartyProducts?.some((p)=>p.product === product)).map((product)=>({
                    integrationId: productToIntegrationARIMap[product] || '',
                    subtypes: allSubtypes,
                    product: product,
                    connectorSources: [
                        (0, $9d9t8.FULL_CONNECTOR_SOURCE)
                    ]
                }));
            thirdPartyProducts = thirdPartyProducts.concat(result);
        }
        // Slack channels filter — Slack is a federated product, so it is excluded from the
        // `filteredProducts` loop above (federated products are filtered out). To pass selected
        // Slack channels to the aggregator, we attach them to a Slack `thirdPartyProducts` entry
        // here, either by mutating an existing entry (non-federated case) or by adding a new entry.
        if (slackChannels?.length) {
            const slackConfig = thirdPartyConfigs[(0, $7oQyb.ProductKey).Slack];
            if (slackConfig) {
                const existingSlackEntry = thirdPartyProducts.find((p)=>p.product === (0, $7oQyb.ProductKey).Slack);
                if (existingSlackEntry) existingSlackEntry.channels = slackChannels;
                else thirdPartyProducts.push({
                    integrationId: slackConfig.integrationAri || '',
                    subtypes: [],
                    providerId: slackConfig.providerId,
                    product: (0, $7oQyb.ProductKey).Slack,
                    connectorSources: $a113941c76257cbc$var$filterConnectorSources((0, $7oQyb.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs, slackConfig.connectorSources || []),
                    channels: slackChannels
                });
            }
        }
        const createdByFilterField = {
            createdBy: createdBy || []
        };
        const lastUpdatedByFilterField = {
            lastUpdatedBy: lastUpdatedBy || []
        };
        const labelsFilterField = (0, $dh538.fg)('enable_labels_filter_confluence_dc_search') ? {
            labels: labels || []
        } : {};
        const containerTypes = thirdPartyProducts.length !== 1 ? [] : allContainerTypes;
        const excludeSubtypes = [];
        const isTeamsProduct = products.includes((0, $b4tvS.ProductKeys).Teams);
        const isAttachmentTypeSelected = entities.includes((0, $2Znam.TypeFilterValueKey).Attachment) && (0, $dh538.fg)('rovo_fps_enable_ms_teams_attachment_type_filter');
        const teamsFilters = $a113941c76257cbc$var$buildTeamsFilters(isTeamsProduct && (isAttachmentTypeSelected || hasAttachment))?.teamsFilters;
        let datasourceFilters = {
            additionalTexts: additionalTexts || []
        };
        if (selectedDatasource) for (const product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig?.getFiltersForSelectedDatasources || !thirdPartyConfig.fanOutConnectorSources) continue;
            if (thirdPartyConfig.datasources) {
                const datasourceForQuery = thirdPartyConfig.datasources.find((ds)=>ds.datasourceId === selectedDatasource);
                if (datasourceForQuery) {
                    if (product !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler || (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled')) datasourceFilters = thirdPartyConfig.getFiltersForSelectedDatasources(datasourceForQuery, datasourceFilters) ?? datasourceFilters;
                }
            }
        }
        const { additionalTexts: mergedAdditionalTexts = [], ...otherDatasourceFilters } = datasourceFilters;
        if (Object.keys(productToIntegrationARIMap).length !== 0) {
            const integrationARIs = products.filter((product)=>// Non-3P products pass through
                !(0, $b4tvS.is3pProductKey)(product) && !(0, $9d9t8.isForgeConnectorProductKey)(product) || // 3P products must be enabled and not require OAuth (or have impersonation)
                thirdPartyConfigs[product]?.isEnabled?.() !== false && (!thirdPartyConfigs[product]?.userNeedsOAuth || $a113941c76257cbc$export$9c38ca92ec6e6d40(product, thirdPartyConfigs))).map((product)=>productToIntegrationARIMap[product]).filter((ari)=>!!ari)// remove duplicates (eg sharepoint, teams)
            .filter((ari, pos, arr)=>{
                return arr.indexOf(ari) === pos;
            })// Include Slack integration ARI only when Slack has at least one connector source (after filtering)
            .filter((ari)=>ari !== productToIntegrationARIMap[(0, $7oQyb.ProductKey).Slack] || $a113941c76257cbc$var$hasConnectorSources((0, $7oQyb.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs));
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $dcbm4.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: integrationARIs,
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$a113941c76257cbc$var$buildGitFilters(pullRequestStatus, repoName),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        } else {
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $dcbm4.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: [],
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$a113941c76257cbc$var$buildGitFilters(pullRequestStatus, repoName),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        }
    }
    return {
        titleMatchOnly: false,
        subtypes: [],
        integrations: []
    };
};
var $a113941c76257cbc$export$b367612b2293421c = /*#__PURE__*/ function(DateRangeError) {
    DateRangeError["FROM_AFTER_TO_ERROR"] = "fromAfterToError";
    DateRangeError["FROM_IN_FUTURE_ERROR"] = "fromInFutureError";
    DateRangeError["TO_IN_FUTURE_ERROR"] = "toInFutureError";
    return DateRangeError;
}({});
const $a113941c76257cbc$export$d3eb8baea7b2ff96 = (from, to)=>{
    if (!from && !to) return null;
    const dateFrom = new Date(`${from}${from ? 'T00:00:00' : ''}`);
    const dateTo = new Date(`${to}${to ? 'T00:00:00' : ''}`);
    const now = new Date();
    if (dateFrom > now) return "fromInFutureError";
    if (dateFrom > dateTo) return "fromAfterToError";
    if (dateTo > now) return "toInFutureError";
    return null;
};
const $a113941c76257cbc$export$ef6dfb919b1d7267 = (0, $779a23dd67a96bae$export$ef6dfb919b1d7267);
const $a113941c76257cbc$export$b29ea735dcfba3c1 = (value)=>{
    return value !== null && value !== undefined;
};
const $a113941c76257cbc$export$9c38ca92ec6e6d40 = (product, thirdPartyConfigs)=>{
    const impersonationEnabled = thirdPartyConfigs[product]?.impersonationEnabled;
    return !!(impersonationEnabled && (product === (0, $7oQyb.ProductKey).GoogleDrive && (0, $2OtFZ.serveWeakLinkExpWithoutExposure)() || product === (0, $7oQyb.ProductKey).Github && (0, $dh538.fg)('weaklink-github-fg')));
};
module.exports["getEmptySelectedFilters"] = $a113941c76257cbc$export$b7b676578c62639d;
module.exports["getThirdPartyFilters"] = $a113941c76257cbc$export$3766c9ce0c94452;
module.exports["isImpersonationEnabled"] = $a113941c76257cbc$export$9c38ca92ec6e6d40;
module.exports["DateRangeError"] = $a113941c76257cbc$export$b367612b2293421c;
module.exports["getInvalidDateRange"] = $a113941c76257cbc$export$d3eb8baea7b2ff96;
module.exports["getProducts3PFromConfigForFilter"] = $a113941c76257cbc$export$ef6dfb919b1d7267;
module.exports["notEmpty"] = $a113941c76257cbc$export$b29ea735dcfba3c1;

});

parcelRegister("3JX0d", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $efKMM = parcelRequire("efKMM");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");


var $dOOW1 = parcelRequire("dOOW1");


var $1xk5k = parcelRequire("1xk5k");


var $21S1F = parcelRequire("21S1F");


var $66big = parcelRequire("66big");


var $3fLdC = parcelRequire("3fLdC");


var $jN0EV = parcelRequire("jN0EV");


var $7jUYs = parcelRequire("7jUYs");

/** Slides type filter + slide ATI require env rollout and cc-mui-slides-experiment (same as Quick Find supported entities). */ function $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled() {
    return (0, $efKMM.isContentTypeEnabledInCurrentEnv)('slide') && (0, $c6GJD.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false, {
        fireExperimentExposure: true
    }) === true;
}
const $17f4c3b31de02ed7$export$860193da8e7fe3cd = ()=>(0, $2Znam.allTypeFilterValueKeys).filter((key)=>key !== (0, $2Znam.TypeFilterValueKey).Slide || $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled());
const $17f4c3b31de02ed7$export$cf63d35399eb18ae = (query, config)=>{
    const allOptions = $17f4c3b31de02ed7$export$b220eb3fbdd854af(config);
    const matchingOptions = allOptions.filter((option)=>(0, $jN0EV.lookupMatches)(query, option.label)).map((option)=>({
            label: option.label,
            trackingKey: option.value,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
    return matchingOptions;
};
const $17f4c3b31de02ed7$var$combineEntitiesForResultsCountQuery = (selectedEntities, unselectedEntities)=>{
    const entitiesToExclude = [
        'ati:cloud:trello:card',
        ...(0, $1xk5k.CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES)
    ];
    return Array.from([
        ...new Set([
            ...selectedEntities,
            ...unselectedEntities
        ])
    ]).filter((entity)=>!entitiesToExclude.includes(entity)).sort();
};
const $17f4c3b31de02ed7$export$e085e94f90daa6c8 = (products, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    const selectedTypesFiltered = selectedTypes.filter((t)=>t !== (0, $2Znam.TypeFilterValueKey).Slide || $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled());
    if ((0, $dh538.fg)('confluence_performance_improve_search_query')) return $17f4c3b31de02ed7$export$d9f0dc47e74a61d2({
        products: products,
        selectedTypes: selectedTypesFiltered,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts,
        selectedProducts: selectedProducts
    });
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    // Expand types to include all when:
    // 1. No types are selected (show all results), OR
    // 2. Bug fix is enabled AND specific noun product+type combos are selected:
    //    - Atlas + (project OR goal)
    //    - WebCrawler + web-page
    // because despite type being selected (which would usually mean only showing result counts for that type),
    // we want to show all result counts on the right panel to make nouns more consistent with other apps.
    const shouldIncludeAllTypes = selectedTypesFiltered.length === 0 || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Project) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Goal) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).WebPage) && selectedProducts?.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler);
    const types = shouldIncludeAllTypes ? $17f4c3b31de02ed7$export$860193da8e7fe3cd() : selectedTypesFiltered;
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    types.forEach((type)=>{
        const productToEntityMap = typeMapping[type].entities;
        products.forEach((product)=>{
            if ((0, $3fLdC.isProductEntitiesIncluded)(products, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                // Logic specific to Atlas product to ensure projects and goals are not shown together
                // in the search query results since they both belong to the same product, Townsquare
                if (product === (0, $b4tvS.ProductKeys).Atlas && selectedTypesFiltered.length > 0 && !selectedTypesFiltered.includes(type)) {
                    // Add other entities under the same product to unselected so they appear in right panel counts
                    unselectedEntities.add(ati);
                    return;
                }
                if ((0, $66big.isEntityEnabled)(ati, selectedTypesFiltered, selectedProducts)) selectedEntities.add(ati);
            });
        });
        // collect unselected entities
        otherProducts.forEach((product)=>{
            if ((0, $3fLdC.isProductEntitiesIncluded)(otherProducts, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            });
        });
    });
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = $17f4c3b31de02ed7$var$combineEntitiesForResultsCountQuery(selectedEntities, unselectedEntities);
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    if (types.includes('customer-contact') && !(0, $dh538.fg)('afm_customer_contact_search_type')) selectedEntities.delete('ati:cloud:graph:customer-contact');
    if (!$17f4c3b31de02ed7$var$isSlideTypeFilterEnabled()) selectedEntities.delete('ati:cloud:confluence:slide');
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $17f4c3b31de02ed7$var$isProductEntitiesIncludedSimplified = (availableProducts, product, thirdPartyConfigs)=>{
    // Main change from the original code
    if ((0, $b4tvS.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $dOOW1.isImpersonationEnabled)(product, thirdPartyConfigs));
    return availableProducts.includes(product);
};
const $17f4c3b31de02ed7$var$getProductsWithEntities = (products, thirdPartyConfigs)=>{
    return products.reduce((acc, product)=>{
        if ($17f4c3b31de02ed7$var$isProductEntitiesIncludedSimplified(products, product, thirdPartyConfigs)) acc.push(product);
        return acc;
    }, []);
};
const $17f4c3b31de02ed7$export$d9f0dc47e74a61d2 = ({ products: products, selectedTypes: selectedTypes, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, selectedProducts: selectedProducts })=>{
    const selectedTypesFiltered = selectedTypes.filter((t)=>t !== (0, $2Znam.TypeFilterValueKey).Slide || $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled());
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    const productsWithEntities = $17f4c3b31de02ed7$var$getProductsWithEntities(products, thirdPartyConfigs);
    const otherProductsWithEntities = otherProducts.reduce((acc, otherProduct)=>{
        if ((0, $3fLdC.isProductEntitiesIncluded)(otherProducts, otherProduct, thirdPartyConfigs)) acc.push(otherProduct);
        return acc;
    }, []);
    // Stuff that we can't be cached that easy
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    // Expand types to include all when:
    // 1. No types are selected (show all results), OR
    // 2. Bug fix is enabled AND specific noun product+type combos are selected:
    //    - Atlas + (project OR goal)
    //    - WebCrawler + web-page
    // because despite type being selected (which would usually mean only showing result counts for that type),
    // we want to show all result counts on the right panel to make nouns more consistent with other apps.
    const shouldIncludeAllTypes = selectedTypesFiltered.length === 0 || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Project) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Goal) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).WebPage) && selectedProducts?.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler);
    const types = shouldIncludeAllTypes ? $17f4c3b31de02ed7$export$860193da8e7fe3cd() : selectedTypesFiltered;
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    // Using normal-loop to reduce overhead and improve performance
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const productToEntityMap = typeMapping[type].entities;
        for(let h = 0; h < productsWithEntities.length; h++){
            const product = productsWithEntities[h];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                // Logic specific to Atlas product to ensure projects and goals are not shown together
                // in the search query results since they both belong to the same product, Townsquare
                if (product === (0, $b4tvS.ProductKeys).Atlas && selectedTypesFiltered.length > 0 && !selectedTypesFiltered.includes(type)) {
                    // Add other entities under the same product to unselected so they appear in right panel counts
                    unselectedEntities.add(ati);
                    continue;
                }
                if ((0, $66big.isEntityEnabled)(ati, selectedTypesFiltered, selectedProducts)) selectedEntities.add(ati);
            }
        }
        for(let j = 0; j < otherProductsWithEntities.length; j++){
            const product = otherProductsWithEntities[j];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            }
        }
    }
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = $17f4c3b31de02ed7$var$combineEntitiesForResultsCountQuery(selectedEntities, unselectedEntities);
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    if (!$17f4c3b31de02ed7$var$isSlideTypeFilterEnabled()) selectedEntities.delete('ati:cloud:confluence:slide');
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $17f4c3b31de02ed7$export$b220eb3fbdd854af = (config)=>{
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const allOption = {
        products: [],
        label: config.intl?.formatMessage((0, $7jUYs.typeLabels)['all']) || '',
        value: 'all',
        trackingKey: 'all',
        queryParamValue: (0, $fKv9F.ContentType)['All'],
        isDefault: true,
        product: config.product
    };
    const typeOptions = $17f4c3b31de02ed7$export$860193da8e7fe3cd().filter((type)=>type !== 'customer-contact' || type === 'customer-contact' && (0, $dh538.fg)('afm_customer_contact_search_type')).map((type)=>{
        let messageKey = (0, $21S1F.getTypeOptionMessageKey)(type);
        return {
            products: typeMapping[type].products,
            value: type,
            trackingKey: type,
            queryParamValue: type,
            isDefault: false,
            label: config.intl?.formatMessage((0, $7jUYs.typeLabels)[messageKey]) || '',
            product: config.product
        };
    });
    return [
        allOption,
        ...typeOptions
    ];
};
module.exports["getAllTypeFilterKeysForSearch"] = $17f4c3b31de02ed7$export$860193da8e7fe3cd;
module.exports["lookupOptions"] = $17f4c3b31de02ed7$export$cf63d35399eb18ae;
module.exports["getAllTypeOptions"] = $17f4c3b31de02ed7$export$b220eb3fbdd854af;
module.exports["getEntitiesForQuery"] = $17f4c3b31de02ed7$export$e085e94f90daa6c8;

});

parcelRegister("1xk5k", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $hB77E = parcelRequire("hB77E");


var $idpYy = parcelRequire("idpYy");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");

/**
 * A mapping between 1P Products
 * - ProductKey1P e.g. 'confluence'
 *
 * UI values for the type filter
 * - TypeFilterKey e.g. 'Spreadsheet'
 *
 * and entities to request from Aggregator
 *
 * - ATIString[] e.g. ['ati:cloud:confluence:blogpost']
 */ const $b7f1b9f5c8cf1139$var$typeFilter1PMapping = new Map([
    [
        (0, $b4tvS.ProductKeys).Confluence,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Document,
                [
                    'ati:cloud:confluence:blogpost',
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Page,
                [
                    'ati:cloud:confluence:page'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Blogpost,
                [
                    'ati:cloud:confluence:blogpost'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Attachment,
                [
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    'ati:cloud:confluence:space'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Comment,
                [
                    'ati:cloud:confluence:comment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Whiteboard,
                [
                    'ati:cloud:confluence:whiteboard'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Slide,
                [
                    'ati:cloud:confluence:slide'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Database,
                [
                    'ati:cloud:confluence:database'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Embed,
                [
                    'ati:cloud:confluence:embed'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Folder,
                [
                    'ati:cloud:confluence:folder'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Calendar,
                [
                    (0, $idpYy.CONFLUENCE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).SpaceCalendar,
                [
                    (0, $idpYy.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Question,
                [
                    (0, $idpYy.CONFLUENCE_QUESTION_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Answer,
                [
                    (0, $idpYy.CONFLUENCE_ANSWER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Gliffy,
                [
                    (0, $idpYy.CONFLUENCE_GLIFFY_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Jira,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Epic,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Bug,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Story,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Task,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Subtask,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Filter,
                [
                    (0, $idpYy.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Plan,
                [
                    (0, $idpYy.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Board,
                [
                    (0, $idpYy.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Dashboard,
                [
                    (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Filter,
                [
                    (0, $idpYy.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Plan,
                [
                    (0, $idpYy.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Board,
                [
                    (0, $idpYy.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Dashboard,
                [
                    (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).JiraServiceManagement,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Incident,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Filter,
                [
                    (0, $idpYy.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Plan,
                [
                    (0, $idpYy.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Board,
                [
                    (0, $idpYy.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Dashboard,
                [
                    (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Compass,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Component,
                [
                    'ati:cloud:compass:component'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Focus,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).FocusArea,
                [
                    'ati:cloud:mercury:focus-area',
                    'ati:cloud:mercury:focus-area-status-update'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Talent,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Position,
                [
                    'ati:cloud:radar:position'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Trello,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Card,
                [
                    'ati:cloud:trello:card'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Atlas,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Project,
                [
                    'ati:cloud:townsquare:project'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Goal,
                [
                    'ati:cloud:townsquare:goal'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Tag,
                [
                    'ati:cloud:townsquare:tag'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Bitbucket,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Commit,
                [
                    'ati:cloud:graph:commit'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).PullRequest,
                [
                    'ati:cloud:graph:pull-request'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Repository,
                [
                    'ati:cloud:graph:repository'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Branch,
                [
                    'ati:cloud:graph:branch'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Assets,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).AssetsObject,
                [
                    'ati:cloud:cmdb:object'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Schema,
                [
                    'ati:cloud:cmdb:schema'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Type,
                [
                    'ati:cloud:cmdb:type'
                ]
            ]
        ])
    ]
]);
const $b7f1b9f5c8cf1139$export$a185da63aca613f3 = [
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:attachment'
];
const $b7f1b9f5c8cf1139$export$598e74d591895feb = ()=>[
        ...$b7f1b9f5c8cf1139$export$a185da63aca613f3
    ];
let $b7f1b9f5c8cf1139$export$1a2d7de20763c66f;
const $b7f1b9f5c8cf1139$export$4b1ab8c60d2ecbf1 = ()=>{
    $b7f1b9f5c8cf1139$export$1a2d7de20763c66f = undefined; // Reset cache
};
const $b7f1b9f5c8cf1139$export$a7663ee59d66492f = ()=>{
    if ($b7f1b9f5c8cf1139$export$1a2d7de20763c66f) return $b7f1b9f5c8cf1139$export$1a2d7de20763c66f;
    const mappings = Object.fromEntries((0, $2Znam.allTypeFilterValueKeys).map((TypeFilterValueKey)=>{
        const baseMapping = {
            entities: {},
            products: [],
            subCategories: []
        };
        return [
            TypeFilterValueKey,
            baseMapping
        ];
    }));
    // Add all the 1P products
    $b7f1b9f5c8cf1139$var$typeFilter1PMapping.forEach((_, productKey1P)=>{
        $b7f1b9f5c8cf1139$var$typeFilter1PMapping.get(productKey1P)?.forEach((_, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey1P);
            mappings[typeFilterValueKey].entities[productKey1P] = $b7f1b9f5c8cf1139$var$typeFilter1PMapping.get(productKey1P)?.get(typeFilterValueKey);
        });
    });
    // Conditionally add passionfruit Ask type for Focus product
    if ((0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled')) {
        mappings[(0, $2Znam.TypeFilterValueKey).Ask].products.push((0, $b4tvS.ProductKeys).Focus);
        mappings[(0, $2Znam.TypeFilterValueKey).Ask].entities[(0, $b4tvS.ProductKeys).Focus] = [
            'ati:cloud:passionfruit:ask'
        ];
    }
    // Add all the 3P products
    (0, $hB77E.getThirdPartyConfigs)().forEach((thirdPartyConfig, productKey3P)=>{
        const typeFilterConfigs = thirdPartyConfig?.typeFilterConfig;
        if (!typeFilterConfigs) return;
        typeFilterConfigs.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey3P);
            mappings[typeFilterValueKey].entities[productKey3P] = typeFilterValue3PEntities.entities3P;
            mappings[typeFilterValueKey].subCategories = [
                ...mappings[typeFilterValueKey].subCategories,
                ...typeFilterValue3PEntities.subTypes3P
            ];
            mappings[typeFilterValueKey].subCategories = [
                ...new Set(mappings[typeFilterValueKey].subCategories)
            ]; // dedupe
        });
    });
    $b7f1b9f5c8cf1139$export$1a2d7de20763c66f = mappings;
    return mappings;
};
const $b7f1b9f5c8cf1139$export$525857063443efa8 = (productKey, typeFilterConfig)=>{
    // Ensure cache is initialized before updating it
    if (!$b7f1b9f5c8cf1139$export$1a2d7de20763c66f) $b7f1b9f5c8cf1139$export$a7663ee59d66492f();
    if (!typeFilterConfig || typeFilterConfig.size === 0) return;
    typeFilterConfig.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
        // Type guard: only process if it's a valid TypeFilterValueKey in our mapping
        if (!(typeFilterValueKey in $b7f1b9f5c8cf1139$export$1a2d7de20763c66f)) return;
        // Only add if not already present
        if (!$b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].products.includes(productKey)) $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].products.push(productKey);
        $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].entities[productKey] = typeFilterValue3PEntities.entities3P;
        $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...$b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories,
            ...typeFilterValue3PEntities.subTypes3P
        ];
        $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...new Set($b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories)
        ]; // dedupe
    });
};
module.exports["CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES"] = $b7f1b9f5c8cf1139$export$a185da63aca613f3;
module.exports["notRequestedATIsInAllSearch"] = $b7f1b9f5c8cf1139$export$598e74d591895feb;
module.exports["getTypeMapping"] = $b7f1b9f5c8cf1139$export$a7663ee59d66492f;
module.exports["registerForgeConnectorTypeMapping"] = $b7f1b9f5c8cf1139$export$525857063443efa8;

});

parcelRegister("731W9", function(module, exports) {

var $7azCD = parcelRequire("7azCD");

const $f17e6b432d346cfd$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
module.exports["sha256Hash"] = $f17e6b432d346cfd$export$e9131c78c1110376;

});

parcelRegister("4VmlX", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $3dbdec4d6deb14f5$export$d4c72bab9d6cc13a = {
    quickFindOpen: false,
    quickFindQuery: '',
    isFeedbackModalOpen: false,
    retryCount: 0,
    updateRecentQueries: undefined,
    updateZeroQueries: undefined,
    selectedQueryFilters: [],
    openHoverCardId: null,
    searchErrors: []
};
const $3dbdec4d6deb14f5$var$actions = {
    setQuickFindOpen: (quickFindOpen)=>({ setState: setState })=>{
            setState({
                quickFindOpen: quickFindOpen
            });
        },
    setQuickFindQuery: (quickFindQuery)=>({ setState: setState })=>{
            setState({
                quickFindQuery: quickFindQuery
            });
        },
    setContent: (content)=>({ setState: setState })=>{
            setState({
                content: content
            });
        },
    setIsFeedbackModalOpen: (isFeedbackModalOpen)=>({ setState: setState })=>{
            setState({
                isFeedbackModalOpen: isFeedbackModalOpen
            });
        },
    setRetryCount: (retryCount)=>({ setState: setState })=>{
            setState({
                retryCount: retryCount
            });
        },
    setFetchSpacesRequestId: (fetchSpacesRequestId)=>({ setState: setState })=>{
            setState({
                fetchSpacesRequestId: fetchSpacesRequestId
            });
        },
    setFetchEntitiesRequestId: (fetchEntitiesRequestId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesRequestId: fetchEntitiesRequestId
            });
        },
    setFetchEntitiesTraceId: (fetchEntitiesTraceId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesTraceId: fetchEntitiesTraceId
            });
        },
    setSearchErrors: (searchErrors)=>({ setState: setState })=>{
            setState({
                searchErrors: searchErrors
            });
        },
    setUpdateRecentQueries: (updateRecentQueries)=>({ setState: setState })=>{
            setState({
                updateRecentQueries: updateRecentQueries
            });
        },
    setUpdateZeroQueries: (updateZeroQueries)=>({ setState: setState })=>{
            setState({
                updateZeroQueries: updateZeroQueries
            });
        },
    addSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const duplicate = selectedQueryFilters.find((currentQueryFilter)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            if (!duplicate) setState({
                selectedQueryFilters: [
                    ...selectedQueryFilters,
                    queryFilter
                ]
            });
        },
    deleteSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const newSelectedQueryFilters = selectedQueryFilters.filter((currentQueryFilter)=>!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            setState({
                selectedQueryFilters: newSelectedQueryFilters
            });
        },
    resetSelectedQueryFilters: ()=>({ setState: setState })=>{
            setState({
                selectedQueryFilters: []
            });
        },
    setCurrentQueryFilter: (currentQueryFilter)=>({ setState: setState })=>{
            setState({
                currentQueryFilter: currentQueryFilter
            });
        },
    setHoverCardOpen: (itemId, isOpen)=>({ setState: setState, getState: getState })=>{
            const { openHoverCardId: openHoverCardId } = getState();
            if (isOpen) setState({
                openHoverCardId: itemId
            });
            else if (openHoverCardId === itemId) setState({
                openHoverCardId: null
            });
        }
};
const $3dbdec4d6deb14f5$var$Store = (0, $1P1Tu.createStore)({
    initialState: $3dbdec4d6deb14f5$export$d4c72bab9d6cc13a,
    actions: $3dbdec4d6deb14f5$var$actions,
    name: 'quick-find'
});
const $3dbdec4d6deb14f5$export$5125bb5a97b0c344 = (0, $9zUhf.createActionsHook)($3dbdec4d6deb14f5$var$Store);
const $3dbdec4d6deb14f5$export$6f7ec6ed84e85154 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.quickFindOpen
});
const $3dbdec4d6deb14f5$export$db9af4f90ab0e536 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.quickFindQuery
});
const $3dbdec4d6deb14f5$export$ee83783e2ce4cc63 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.content
});
const $3dbdec4d6deb14f5$export$5bdbafc4abc135c7 = (0, $9zUhf.createHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.isFeedbackModalOpen
});
const $3dbdec4d6deb14f5$export$140d37088821fcb1 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.retryCount
});
const $3dbdec4d6deb14f5$export$e260c85752b77e7c = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchSpacesRequestId
});
const $3dbdec4d6deb14f5$export$8d6bc416cb50c4b8 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchEntitiesRequestId
});
const $3dbdec4d6deb14f5$export$83bd9ae2aed68ab4 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchEntitiesTraceId
});
const $3dbdec4d6deb14f5$export$65391f387dac24a5 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.updateRecentQueries
});
const $3dbdec4d6deb14f5$export$4c5c5c3d8a37ed5d = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.updateZeroQueries
});
const $3dbdec4d6deb14f5$export$285abcbc8aa402a2 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.selectedQueryFilters
});
const $3dbdec4d6deb14f5$export$31b21a5d8580f4a9 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.currentQueryFilter
});
const $3dbdec4d6deb14f5$export$d25011725d5aa3a6 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.searchErrors || []
});
const $3dbdec4d6deb14f5$export$3e5bb5570cf53089 = (0, $FOT9i.createContainer)($3dbdec4d6deb14f5$var$Store);
module.exports["useQuickFindActions"] = $3dbdec4d6deb14f5$export$5125bb5a97b0c344;
module.exports["useQuickFindOpen"] = $3dbdec4d6deb14f5$export$6f7ec6ed84e85154;
module.exports["useQuickFindQuery"] = $3dbdec4d6deb14f5$export$db9af4f90ab0e536;
module.exports["useContent"] = $3dbdec4d6deb14f5$export$ee83783e2ce4cc63;
module.exports["useIsFeedbackModalOpen"] = $3dbdec4d6deb14f5$export$5bdbafc4abc135c7;
module.exports["useFetchSpacesRequestId"] = $3dbdec4d6deb14f5$export$e260c85752b77e7c;
module.exports["useFetchEntitiesRequestId"] = $3dbdec4d6deb14f5$export$8d6bc416cb50c4b8;
module.exports["useFetchEntitiesTraceId"] = $3dbdec4d6deb14f5$export$83bd9ae2aed68ab4;
module.exports["useUpdateRecentQueries"] = $3dbdec4d6deb14f5$export$65391f387dac24a5;
module.exports["useUpdateZeroQueries"] = $3dbdec4d6deb14f5$export$4c5c5c3d8a37ed5d;
module.exports["useSelectedQueryFilters"] = $3dbdec4d6deb14f5$export$285abcbc8aa402a2;
module.exports["useCurrentQueryFilter"] = $3dbdec4d6deb14f5$export$31b21a5d8580f4a9;
module.exports["useSearchErrors"] = $3dbdec4d6deb14f5$export$d25011725d5aa3a6;
module.exports["QuickFindStoreContainer"] = $3dbdec4d6deb14f5$export$3e5bb5570cf53089;

});

parcelRegister("6RGiC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dZJhp = parcelRequire("dZJhp");


var $2OtFZ = parcelRequire("2OtFZ");

function $14c4c6592d363aae$export$865a2f088c837665() {
    const { canAnimate: canAnimate } = (0, $dZJhp.useConnectAppsCooldown)();
    const isConnectAppsPillEnabled = (0, $2OtFZ.serveSearchSettingsModalExperiment)({
        fireExperimentExposure: false
    });
    const suppressAtMount = (0, $42omo.useRef)(isConnectAppsPillEnabled && canAnimate());
    return suppressAtMount.current;
}
module.exports["useShouldSuppressBannerForAnimation"] = $14c4c6592d363aae$export$865a2f088c837665;

});

parcelRegister("eO6NY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $dQN1U = parcelRequire("dQN1U");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $5A2fk = parcelRequire("5A2fk");


var $6yNqK = parcelRequire("6yNqK");


var $9rRKJ = parcelRequire("9rRKJ");

const $6bc35c1d306bd8b4$export$6244fd8f3fa9025d = ({ cloudId: cloudId, experience: experience, productCount: productCount, usages: usages })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                productCount: productCount,
                usages: usages ? JSON.stringify(usages) : undefined
            }
        }
    };
};
const $6bc35c1d306bd8b4$export$973cdfe8c0b26a2b = ({ cloudId: cloudId, experience: experience, reason: reason })=>{
    return {
        action: 'taskFail',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                reason: reason
            }
        }
    };
};



var $2OtFZ = parcelRequire("2OtFZ");


var $hB77E = parcelRequire("hB77E");







const $852be0f093bb3acb$export$98ca9e3e34f377b = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    let productOrder = [];
    if (isOnSearchDialog) // TODO: we should consolidate the behaviour of banners between FPS and QF (both order and what products are shown).
    // See https://atlassian.slack.com/archives/C0A8GKLU6PQ/p1770850523754429
    productOrder = [
        (0, $b4tvS.ProductKeys3P).GoogleDrive,
        (0, $b4tvS.ProductKeys3P).Sharepoint,
        (0, $b4tvS.ProductKeys3P).Slack,
        (0, $b4tvS.ProductKeys3P).Teams,
        (0, $b4tvS.ProductKeys3P).Github,
        (0, $b4tvS.ProductKeys3P).Figma,
        (0, $b4tvS.ProductKeys3P).Gitbook
    ];
    else {
        const requiredProducts = [];
        (0, $hB77E.getThirdPartyConfigs)().forEach((_, productKey3P)=>{
            if ((0, $hB77E.getThirdPartyConfigs)().get(productKey3P)?.requiresOauth) requiredProducts.push(productKey3P);
        });
        // Filter and order static products based on PRODUCTS_ORDER
        const staticProducts = (0, $b4tvS.PRODUCTS_ORDER).filter((product)=>requiredProducts.includes(product));
        // Add Forge connectors that need OAuth (ordered after static products)
        const forgeConnectors = availableProducts.filter((product)=>(0, $9d9t8.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]?.userNeedsOAuth && thirdPartyConfigs[product]?.outboundAuthUrl);
        productOrder = [
            ...staticProducts,
            ...forgeConnectors
        ];
    }
    return productOrder.filter((product)=>availableProducts.includes(product));
};



var $3CshZ = parcelRequire("3CshZ");


var $j4ply = parcelRequire("j4ply");




const $77eea1065ff0fa88$export$ce0553f0f2dae7c8 = {
    'widely-adopted': 25,
    'mid-adoption': 15,
    niche: 10
};
const $77eea1065ff0fa88$export$b64145217f45680a = {
    'widely-adopted': new Set([
        (0, $b4tvS.ProductKeys3P).GoogleDrive,
        (0, $b4tvS.ProductKeys3P).Slack,
        (0, $b4tvS.ProductKeys3P).Github,
        (0, $b4tvS.ProductKeys3P).Figma,
        (0, $b4tvS.ProductKeys3P).OneDrive,
        (0, $b4tvS.ProductKeys3P).Gitlab,
        (0, $b4tvS.ProductKeys3P).AzureDevops,
        (0, $b4tvS.ProductKeys3P).Sentry,
        (0, $b4tvS.ProductKeys3P).Miro,
        (0, $b4tvS.ProductKeys3P).Salesforce,
        (0, $b4tvS.ProductKeys3P).Notion,
        (0, $b4tvS.ProductKeys3P).Sharepoint
    ]),
    'mid-adoption': new Set([
        (0, $b4tvS.ProductKeys3P).Pipedrive,
        (0, $b4tvS.ProductKeys3P).Box,
        (0, $b4tvS.ProductKeys3P).ClickUp,
        (0, $b4tvS.ProductKeys3P).Hubspot,
        (0, $b4tvS.ProductKeys3P).Asana
    ]),
    niche: new Set([
        (0, $b4tvS.ProductKeys3P).Todoist,
        (0, $b4tvS.ProductKeys3P).Zeplin,
        (0, $b4tvS.ProductKeys3P).Dropbox,
        (0, $b4tvS.ProductKeys3P).Lucid,
        (0, $b4tvS.ProductKeys3P).Amplitude,
        (0, $b4tvS.ProductKeys3P).Mural,
        (0, $b4tvS.ProductKeys3P).Airtable,
        (0, $b4tvS.ProductKeys3P).LaunchDarkly,
        (0, $b4tvS.ProductKeys3P).Stripe,
        (0, $b4tvS.ProductKeys3P).Smartsheet,
        (0, $b4tvS.ProductKeys3P).Docusign,
        (0, $b4tvS.ProductKeys3P).PagerDuty,
        (0, $b4tvS.ProductKeys3P).Teams,
        (0, $b4tvS.ProductKeys3P).Dovetail,
        (0, $b4tvS.ProductKeys3P).Webex
    ])
};
// Reverse lookup for quicker/easier product → tier resolution.
const $77eea1065ff0fa88$var$CONNECTOR_TO_TIER = new Map(Object.entries($77eea1065ff0fa88$export$b64145217f45680a).flatMap(([tier, products])=>[
        ...products
    ].map((product)=>[
            product,
            tier
        ])));
const $77eea1065ff0fa88$export$bcc396963ce06343 = (product)=>{
    return $77eea1065ff0fa88$var$CONNECTOR_TO_TIER.get(product) ?? 'niche';
};
const $77eea1065ff0fa88$export$fb50a930cc5288bf = (product)=>{
    return $77eea1065ff0fa88$export$ce0553f0f2dae7c8[$77eea1065ff0fa88$export$bcc396963ce06343(product)];
};
const $77eea1065ff0fa88$export$835ec42bc9d6e801 = (product, usagePercent)=>{
    if (usagePercent === undefined) return true;
    const threshold = $77eea1065ff0fa88$export$fb50a930cc5288bf(product);
    return usagePercent >= threshold;
};


const $70a27aa1b7fe8948$export$8e364fc6aecba9a9 = (experience, cloudId)=>{
    const [smartLinkUsage, setSmartLinkUsage] = (0, $42omo.useState)(undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)({
        experience: experience
    });
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled.
    const bannerTargetingCohort = (0, $2OtFZ.serveImproveBannerTargetingExperiment)({
        fireExperimentExposure: false
    });
    (0, $42omo.useEffect)(()=>{
        if (bannerTargetingCohort === 'usage-threshold' && cloudId) (0, $dQN1U.getTenantSmartlinkUsage)({
            siteId: cloudId
        }).then((usageData)=>{
            setSmartLinkUsage(usageData);
            fireAnalyticsEvent((0, $6bc35c1d306bd8b4$export$6244fd8f3fa9025d)({
                cloudId: cloudId,
                experience: experience,
                productCount: Object.keys(usageData).length,
                usages: usageData
            }));
        }).catch((error)=>{
            fireAnalyticsEvent((0, $6bc35c1d306bd8b4$export$973cdfe8c0b26a2b)({
                cloudId: cloudId,
                experience: experience,
                reason: error instanceof Error ? error.message : String(error)
            }));
        });
    }, [
        bannerTargetingCohort,
        cloudId,
        experience,
        fireAnalyticsEvent
    ]);
    return smartLinkUsage;
};
const $70a27aa1b7fe8948$export$7e6da2e188a2a79d = ({ products: products, thirdPartyConfigs: thirdPartyConfigs })=>{
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled.
    const cohort = (0, $2OtFZ.serveImproveBannerTargetingExperiment)({
        fireExperimentExposure: false
    });
    const isUsageThresholdCohort = cohort === 'usage-threshold';
    const isBannerOptedOut = (0, $dh538.fg)('rovo_search_3p_banner_opt_out');
    const isActive = isUsageThresholdCohort && !isBannerOptedOut;
    const usageData = (0, $j4ply.useSmartLinkUsage)();
    return (0, $42omo.useMemo)(()=>{
        if (!isActive || !usageData) return products;
        return products.filter((product)=>{
            const config = thirdPartyConfigs[product];
            const isSmartlinksOnly = config?.connectorSources?.includes((0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE)) && !config?.connectorSources?.includes((0, $9d9t8.FULL_CONNECTOR_SOURCE));
            // The logic to hide banners based on usage is only applicable to smart-link connectors
            // and only if there's no full-connector for the same product.
            if (!isSmartlinksOnly) return true;
            return (0, $77eea1065ff0fa88$export$835ec42bc9d6e801)(product, usageData[product]);
        });
    }, [
        isActive,
        usageData,
        products,
        thirdPartyConfigs
    ]);
};
const $70a27aa1b7fe8948$export$51f63d7c1c9ec5d4 = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    const bannerTargetingCohort = (0, $2OtFZ.serveImproveBannerTargetingExperiment)();
    const orderedAvailableProducts = (0, $42omo.useMemo)(()=>(0, $852be0f093bb3acb$export$98ca9e3e34f377b)({
            isOnSearchDialog: isOnSearchDialog,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts
        }), [
        isOnSearchDialog,
        thirdPartyConfigs,
        availableProducts
    ]);
    const productsWithSufficientUsage = $70a27aa1b7fe8948$export$7e6da2e188a2a79d({
        products: orderedAvailableProducts,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const orderedAvailableProductsAfterUsageFilter = (0, $42omo.useMemo)(()=>{
        if (bannerTargetingCohort === 'usage-threshold' && productsWithSufficientUsage?.length) return orderedAvailableProducts.filter((p)=>productsWithSufficientUsage.includes(p));
        return orderedAvailableProducts;
    }, [
        orderedAvailableProducts,
        bannerTargetingCohort,
        productsWithSufficientUsage
    ]);
    if (!isOnSearchDialog && availableProducts.includes((0, $b4tvS.ProductKeys).Github) && (0, $2OtFZ.serveFPSGitHubAuthBannerPromo)({
        thirdPartyConfigs: thirdPartyConfigs
    })) return (0, $5A2fk.isProductSnoozed)((0, $b4tvS.ProductKeys).Github) ? [] : [
        (0, $b4tvS.ProductKeys).Github
    ];
    const enforceMaxDismissals = true;
    return orderedAvailableProductsAfterUsageFilter.filter((product)=>(0, $5A2fk.shouldShowOAuthBanner)(product, enforceMaxDismissals));
};
module.exports["useFetchSmartLinkUsage"] = $70a27aa1b7fe8948$export$8e364fc6aecba9a9;
module.exports["useBannerEligibleProductsOrder"] = $70a27aa1b7fe8948$export$51f63d7c1c9ec5d4;

});

parcelRegister("dQN1U", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $i1nCm = parcelRequire("i1nCm");


var $78yNl = parcelRequire("78yNl");

const { refreshOnAccessDecorator: $3ce7a2ca8bed97b9$var$refreshOnAccessDecoratorSmartlink, get: $3ce7a2ca8bed97b9$var$getSmartlinkCache, clear: $3ce7a2ca8bed97b9$var$clearSmartlinkCache } = (0, $jnPv4.promiseCache)({
    name: (0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY),
    expiration: (0, $i1nCm.SEVEN_DAY_MS_TTL)
});
const $3ce7a2ca8bed97b9$var$fetchSiteSmartlinkService = async (siteId)=>{
    const requestUrl = (0, $78yNl.getSmartlinkSiteTraitsUrl)(siteId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $3ce7a2ca8bed97b9$var$fetchSmartlinkProductUsageRate = async ({ siteId: siteId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $2qzBQ.generateHash)(`${(0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY)}|${siteId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $3ce7a2ca8bed97b9$var$fetchSiteSmartlinkService(siteId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === (0, $i1nCm.SMARTLINK_APP_EXPOSURE_RATE_TRAIT));
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $3Tbc2.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise().catch(async (e)=>{
            // On degrade/timeout, re-set cache entry to resolved undefined with ONE_HOUR_TTL
            // so callers won't hammer the service for the next hour, but will retry after.
            // Since we're in supplier, we can't directly set here without re-entrant complexity.
            // Instead, throw and let refreshOnAccessDecorator store this rejecting promise; after this call,
            // callers should rely on our external code path to clear or retry as needed.
            throw e;
        });
    };
    const existing = $3ce7a2ca8bed97b9$var$getSmartlinkCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    // We cannot know the outcome until supplier resolves/rejects; so we approximate:
    //   if no existing value, we assume empty path (ONE_HOUR_MS_TTL) to avoid hammering
    //   then, within supplier, we adjust by re-setting the cache on rejection with ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $i1nCm.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $3ce7a2ca8bed97b9$var$refreshOnAccessDecoratorSmartlink({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $3ce7a2ca8bed97b9$var$refreshOnAccessDecoratorSmartlink({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $i1nCm.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $i1nCm.ONE_DAY_MS_TTL));
                return result;
            } catch  {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $i1nCm.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $3ce7a2ca8bed97b9$export$a618d8f3094322c9 = (key)=>$3ce7a2ca8bed97b9$var$clearSmartlinkCache(key);
const $3ce7a2ca8bed97b9$export$f0ea64eab9ebcb2f = (trait)=>{
    if (trait?.name === (0, $i1nCm.SMARTLINK_APP_EXPOSURE_RATE_TRAIT) && typeof trait?.value === 'string') {
        const result = {};
        const pairs = trait.value.split(',').map((s)=>s.trim());
        for (const pair of pairs){
            const [app, rateStr] = pair.split(':').map((s)=>s.trim());
            if (app && rateStr) {
                const rate = parseInt(rateStr, 10);
                if (!isNaN(rate)) result[app] = rate;
            }
        }
        return result;
    }
    return {};
};
const $3ce7a2ca8bed97b9$export$b95bec45d0bca567 = async ({ siteId: siteId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!siteId) return {};
    const trait = await $3ce7a2ca8bed97b9$var$fetchSmartlinkProductUsageRate({
        siteId: siteId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'rovo-search-smartlink-usage'
    });
    return $3ce7a2ca8bed97b9$export$f0ea64eab9ebcb2f(trait);
};
module.exports["getTenantSmartlinkUsage"] = $3ce7a2ca8bed97b9$export$b95bec45d0bca567;

});

parcelRegister("i1nCm", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $8a8890853317d663$export$34e8837a1913e572 = 'search-personalization-site-user';
const $8a8890853317d663$export$f80bd7d8a13f050a = 604800000; // 7 days
const $8a8890853317d663$export$18406d9c8318a338 = 86400000; // 1 day
const $8a8890853317d663$export$2383b9b3bc711073 = 3600000; // 1 hour
const $8a8890853317d663$export$d0bbd8e7f2e797 = 'search_user_3p_recommendations_right_panel_v1';
const $8a8890853317d663$export$330c7df40d69ab27 = 'search-personalization-smartlink-site';
const $8a8890853317d663$export$15fc832cc21ada61 = 'smartlink_app_exposure_rate';
const $8a8890853317d663$export$c25c73d04a24471b = 'search-personalization-smartlink-usage-and-top-apps-site';
const $8a8890853317d663$export$7b7ea824b946adee = 'rovo_nudge_end_user_rendered_smartlinks_percent_and_most_used_apps';
module.exports["SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY"] = $8a8890853317d663$export$34e8837a1913e572;
module.exports["SEVEN_DAY_MS_TTL"] = $8a8890853317d663$export$f80bd7d8a13f050a;
module.exports["ONE_DAY_MS_TTL"] = $8a8890853317d663$export$18406d9c8318a338;
module.exports["ONE_HOUR_MS_TTL"] = $8a8890853317d663$export$2383b9b3bc711073;
module.exports["RIGHT_PANEL_TRAIT"] = $8a8890853317d663$export$d0bbd8e7f2e797;
module.exports["SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY"] = $8a8890853317d663$export$330c7df40d69ab27;
module.exports["SMARTLINK_APP_EXPOSURE_RATE_TRAIT"] = $8a8890853317d663$export$15fc832cc21ada61;
module.exports["SEARCH_PERSONALIZATION_SMARTLINK_USAGE_AND_TOP_APPS_SITE_CACHE_KEY"] = $8a8890853317d663$export$c25c73d04a24471b;
module.exports["SMARTLINK_USAGE_AND_TOP_APPS_TRAIT"] = $8a8890853317d663$export$7b7ea824b946adee;

});

parcelRegister("UXqiP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9Wtw1 = parcelRequire("9Wtw1");


var $4mft4 = parcelRequire("4mft4");

/* headless-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $lnMCl = parcelRequire("lnMCl");


var $eakyO = parcelRequire("eakyO");


var $ckkm9 = parcelRequire("ckkm9");

const $23625ae7e2d43e43$var$SNOOZE_DAYS = [
    1,
    1,
    1,
    90
];
const $23625ae7e2d43e43$var$SHORT_SNOOZE_MINUTES = [
    1,
    2,
    3,
    4
];
const $23625ae7e2d43e43$var$messages = (0, $aXWIB.defineMessages)({
    connect: {
        id: "rovo.search.quick-find-3p.connect",
        defaultMessage: "Connect {connectorName}"
    },
    dismiss: {
        id: "rovo.search.quick-find-3p.dismiss",
        defaultMessage: "Dismiss"
    },
    authorizationFail: {
        id: "rovo.search.quick-find-authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "rovo.search.quick-find.authorization-success",
        defaultMessage: "Account connected to {product}."
    },
    fullConnectorAdminBlessedMissingResultsHeading: {
        id: "rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading-v2",
        defaultMessage: "Your admin added {connectorName}. "
    },
    fullConnectorAdminBlessedMissingResultsBody: {
        id: "rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body",
        defaultMessage: "Connect to see missing results"
    },
    fullConnectorSocialProofHighHeading: {
        id: "rovo.search.quick-find-3p.full-connector.social-proof-high.heading-v2",
        defaultMessage: "{teamConnectAppPercentage}% of your team have connected apps"
    },
    smartLinkSocialProofLowHeading: {
        id: "rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading-v2",
        defaultMessage: "{connectorName} is now available!"
    },
    smartLinkSocialProofLowBody: {
        id: "rovo.search.quick-find-3p.smart-link-connector.social-proof-low.body",
        defaultMessage: "Connect your account to see missing results"
    },
    smartLinkSocialProofHighHeading: {
        id: "rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading-v3",
        defaultMessage: "{teamConnectAppPercentage}% of your team have connected apps"
    }
});
const $23625ae7e2d43e43$var$variantMessages = {
    'full-connector': {
        'admin-blessed-missing-results': {
            heading: $23625ae7e2d43e43$var$messages.fullConnectorAdminBlessedMissingResultsHeading,
            body: $23625ae7e2d43e43$var$messages.fullConnectorAdminBlessedMissingResultsBody
        },
        'social-proof-high': {
            heading: $23625ae7e2d43e43$var$messages.fullConnectorSocialProofHighHeading
        }
    },
    smartlinks: {
        'social-proof-low': {
            heading: $23625ae7e2d43e43$var$messages.smartLinkSocialProofLowHeading,
            body: $23625ae7e2d43e43$var$messages.smartLinkSocialProofLowBody
        },
        'social-proof-high': {
            heading: $23625ae7e2d43e43$var$messages.smartLinkSocialProofHighHeading
        }
    }
};
const $23625ae7e2d43e43$var$styles = {
    container: "_n3td12x7 _19bvu2gc _u5f3u2gc",
    banner: "_2rko1mok _1rjcu2gc _18zrutpp"
};
const $23625ae7e2d43e43$var$selectConnectorForBanner = (availableConnectors, lastDismissed3P)=>{
    if (!lastDismissed3P) return availableConnectors.find((c)=>c.userNeedsOAuth) ?? null;
    const lastIndex = availableConnectors.findIndex((c)=>c.connectorId === lastDismissed3P); // If Post Office references a connector that is no longer configured, restart the rotation.
    const candidates = lastIndex >= 0 ? availableConnectors.slice(lastIndex + 1) : availableConnectors;
    return candidates.find((c)=>c.userNeedsOAuth) ?? null;
};
const $23625ae7e2d43e43$var$getVariantMessages = (mode, variant)=>{
    if (mode === (0, $eakyO.ConnectorSources).Smartlinks) return variant in $23625ae7e2d43e43$var$variantMessages.smartlinks ? $23625ae7e2d43e43$var$variantMessages.smartlinks[variant] : undefined;
    return variant in $23625ae7e2d43e43$var$variantMessages['full-connector'] ? $23625ae7e2d43e43$var$variantMessages['full-connector'][variant] : undefined;
};
const $23625ae7e2d43e43$var$QuickFindHeadlessBanner = ({ messageInstanceId: messageInstanceId, connector: connector, connectorMode: connectorMode, variant: variant, variantMsgs: variantMsgs, teamConnectAppPercentage: teamConnectAppPercentage, onAuthorize: onAuthorize, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const connectorNameToUse = connector.connectorProductKey === 'sharepoint' ? 'SharePoint' : connector.connectorName;
    const headingText = formatMessage(variantMsgs.heading, {
        connectorName: connectorNameToUse,
        teamConnectAppPercentage: teamConnectAppPercentage
    });
    const bodyText = variantMsgs.body ? formatMessage(variantMsgs.body, {
        connectorName: connectorNameToUse,
        teamConnectAppPercentage: teamConnectAppPercentage
    }) : undefined;
    const connectText = formatMessage($23625ae7e2d43e43$var$messages.connect, {
        connectorName: connectorNameToUse
    });
    const dismissLabel = formatMessage($23625ae7e2d43e43$var$messages.dismiss);
    const ConnectorIcon = connector.icon;
    const headingId = `rovo-search-page-quick-find-3p-${messageInstanceId}-${connector.connectorId}-${connectorMode}-${variant}-heading`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $23625ae7e2d43e43$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        "aria-labelledby": headingId,
        backgroundColor: "color.background.accent.blue.subtlest",
        xcss: $23625ae7e2d43e43$var$styles.banner,
        testId: "rovo-search-page-quick-find-3p-connector-pre-auth-nudge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, ConnectorIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConnectorIcon, {
        size: "small",
        label: connectorNameToUse
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        id: headingId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold"
    }, headingText), bodyText ? ` ${bodyText}` : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: ()=>onAuthorize((0, $ckkm9.OAuthSource).quickFindOAuthBanner),
        testId: "rovo-search-page-quick-find-3p-connect"
    }, connectText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: dismissLabel,
        onClick: onDismiss,
        testId: "rovo-search-page-quick-find-3p-dismiss"
    })))));
};
const $23625ae7e2d43e43$var$QuickFindHeadlessMessage = ({ messageInstanceId: messageInstanceId, messageContext: messageContext, connector: connector, connectorMode: connectorMode, variant: variant, variantMsgs: variantMsgs, useOAuthHandlers: useOAuthHandlers, dismiss: dismiss })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $lnMCl.useMessageInstanceEvent)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { productSource: productSource, dismissalCount: dismissalCount, teamConnectAppPercentage: teamConnectAppPercentage } = messageContext;
    const { connectorId: connectorId } = connector;
    const { onAuthorize: onAuthorize } = useOAuthHandlers({
        product: connector.connectorProductKey,
        connectorSource: connector.connectorMode,
        successFlagTitle: formatMessage($23625ae7e2d43e43$var$messages.authorizationSuccess, {
            product: connector.connectorName
        }),
        failFlagTitle: formatMessage($23625ae7e2d43e43$var$messages.authorizationFail, {
            product: connector.connectorName
        }),
        outboundAuthUrl: connector.oAuthUrl,
        isOnSearchDialog: true,
        extraAttributes: {
            connectorId: connectorId,
            variant: variant
        }
    });
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        (async ()=>{
            const useShortSnooze = (0, $dh538.fg)('po_enable_rovo-quick-find-3p-short-snooze-test');
            const snoozeDuration = useShortSnooze ? $23625ae7e2d43e43$var$SHORT_SNOOZE_MINUTES[dismissalCount] ?? $23625ae7e2d43e43$var$SHORT_SNOOZE_MINUTES[0] : $23625ae7e2d43e43$var$SNOOZE_DAYS[dismissalCount] ?? $23625ae7e2d43e43$var$SNOOZE_DAYS[0];
            try {
                await messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: 'dismiss-3p-banner',
                        clickedElement: 'button',
                        buttonType: 'secondary'
                    },
                    action: {
                        actionType: 'snooze',
                        snoozeDuration: snoozeDuration
                    },
                    additionalMetadataFromFrontend: {
                        actionReason: 'dismiss',
                        dismissedConnectorId: connector.connectorId,
                        dismissedVariant: variant,
                        variant: variant,
                        productSource: productSource,
                        connectorSource: connector.connectorMode,
                        ...useShortSnooze ? {
                            snoozeUnit: 'minutes'
                        } : {}
                    }
                });
            } catch  {
            // decide this failure needs product-level observability.
            } finally{
                dismiss();
            }
        })();
    }, [
        messageInstanceClicked,
        dismiss,
        dismissalCount,
        connector,
        productSource,
        variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23625ae7e2d43e43$var$QuickFindHeadlessBanner, {
        messageInstanceId: messageInstanceId,
        connector: connector,
        connectorMode: connectorMode,
        variant: variant,
        variantMsgs: variantMsgs,
        teamConnectAppPercentage: teamConnectAppPercentage,
        onAuthorize: onAuthorize,
        onDismiss: handleDismiss
    });
};
const $23625ae7e2d43e43$export$2f021065f040195e = ({ message: message, availableConnectors: availableConnectors, useOAuthHandlers: useOAuthHandlers, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance })=>{
    const { productSource: productSource, lastDismissed3P: lastDismissed3P, dismissalCount: dismissalCount, fullConnectorVariant: fullConnectorVariant, smartLinkVariant: smartLinkVariant, teamConnectAppPercentage: teamConnectAppPercentage } = message.context;
    const connector = $23625ae7e2d43e43$var$selectConnectorForBanner(availableConnectors, lastDismissed3P);
    const dismiss = (0, $42omo.useCallback)(()=>dismissMessage(message.messageInstanceId), [
        dismissMessage,
        message.messageInstanceId
    ]);
    if (!connector) return null;
    const variant = connector.connectorMode === (0, $eakyO.ConnectorSources).Smartlinks ? smartLinkVariant : fullConnectorVariant;
    const connectorModeToUse = connector.connectorMode === (0, $eakyO.ConnectorSources).Smartlinks ? (0, $eakyO.ConnectorSources).Smartlinks : (0, $eakyO.ConnectorSources).Full;
    const variantMsgs = $23625ae7e2d43e43$var$getVariantMessages(connectorModeToUse, variant);
    if (!variantMsgs) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PostOfficeMessageInstance, {
        messageInstanceId: message.messageInstanceId
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23625ae7e2d43e43$var$QuickFindHeadlessMessage, {
            messageInstanceId: message.messageInstanceId,
            messageContext: {
                productSource: productSource,
                dismissalCount: dismissalCount,
                fullConnectorVariant: fullConnectorVariant,
                smartLinkVariant: smartLinkVariant,
                teamConnectAppPercentage: teamConnectAppPercentage
            },
            connector: connector,
            connectorMode: connectorModeToUse,
            variant: variant,
            variantMsgs: variantMsgs,
            useOAuthHandlers: useOAuthHandlers,
            dismiss: dismiss
        }));
};


const $a295deffd24a91d3$export$5b496c438700a088 = 'rovo-search-page-quick-find-3p-connector-pre-auth-nudge';


const $4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $4fb011b1c09bb25d$export$f021c2a95c252193 = ({ placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, children: children })=>{
    const { messages: messages, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = (0, $9Wtw1.useMessageInstances)({
        placementId: placementId,
        messageTemplateId: (0, $a295deffd24a91d3$export$5b496c438700a088)
    });
    const orderedConfigs = (0, $42omo.useMemo)(()=>(0, $4mft4.orderConfigByProductOrder)(thirdPartyConfigs, availableProductsOrder), [
        thirdPartyConfigs,
        availableProductsOrder
    ]);
    const availableConnectors = (0, $42omo.useMemo)(()=>(0, $4mft4.mapToAvailableConnectors)(orderedConfigs), [
        orderedConfigs
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            messages: messages,
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            dismissMessage: dismissMessage,
            PostOfficeMessageInstance: PostOfficeMessageInstance
        }), [
        messages,
        availableConnectors,
        useOAuthHandlers,
        dismissMessage,
        PostOfficeMessageInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext.Provider, {
        value: value
    }, children);
};
const $4fb011b1c09bb25d$export$10bc17e539691718 = ()=>{
    const placement = (0, $42omo.useContext)($4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext);
    if (!placement) return null;
    const { messages: messages, availableConnectors: availableConnectors, useOAuthHandlers: useOAuthHandlers, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = placement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, messages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23625ae7e2d43e43$export$2f021065f040195e), {
            key: message.messageInstanceId,
            message: message,
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            dismissMessage: dismissMessage,
            PostOfficeMessageInstance: PostOfficeMessageInstance
        })));
};
module.exports["QuickFindHeadlessPlacementDataProvider"] = $4fb011b1c09bb25d$export$f021c2a95c252193;
module.exports["QuickFindHeadlessVisiblePlacement"] = $4fb011b1c09bb25d$export$10bc17e539691718;

});

parcelRegister("jwO5V", function(module, exports) {
function $ed96d079e7dec7ba$export$2066b2fdce449999({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return JSON.stringify(atlAttributionHeader);
}
function $ed96d079e7dec7ba$export$dbbc0a36865f0300({ cloudId: cloudId, product: product = 'platform', activationId: activationId }) {
    if (!cloudId) return undefined;
    const atlWorkspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : undefined;
    const headerValue = $ed96d079e7dec7ba$export$2066b2fdce449999({
        ...atlWorkspaceId ? {
            atlWorkspaceId: atlWorkspaceId
        } : {},
        tenantId: cloudId,
        product: product
    });
    return {
        'atl-attribution': headerValue
    };
}
module.exports["createAtlAttributionHeaderValue"] = $ed96d079e7dec7ba$export$2066b2fdce449999;
module.exports["buildAtlAttributionHeaders"] = $ed96d079e7dec7ba$export$dbbc0a36865f0300;

});

parcelRegister("czt8s", function(module, exports) {
$parcel$export(module.exports, "CancelError", () => (parcelRequire("4bi4T")).CancelError);

var $4bi4T = parcelRequire("4bi4T");

const $2bc9549dae34d364$var$CANCEL_ERROR = new (0, $4bi4T.CancelError)('Promise is cancelled');
class $2bc9549dae34d364$export$5782acf08706f13d {
    static from(promise) {
        return new $2bc9549dae34d364$export$5782acf08706f13d(promise);
    }
    constructor(promise){
        this.cancellablePromiseInternal = void 0;
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($2bc9549dae34d364$var$CANCEL_ERROR);
            })
        ]);
    }
}
module.exports["CancellablePromise"] = $2bc9549dae34d364$export$5782acf08706f13d;

});

parcelRegister("4bi4T", function(module, exports) {
class $664df2097e831b6a$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args);
        this.isCancelled = true;
    }
}
module.exports["CancelError"] = $664df2097e831b6a$export$d7f5e52d091a66db;

});

parcelRegister("dmTG5", function(module, exports) {
const $8edbe48163a779a2$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};
module.exports["onDegradedDependency"] = $8edbe48163a779a2$export$e98932ab9e22c265;

});

parcelRegister("cFN1h", function(module, exports) {
const $d17b2d1acf87bd34$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId,
                ...moreContext || {}
            }
        }
    };
};
module.exports["onFailedDependency"] = $d17b2d1acf87bd34$export$7199f2d13e6ae9f7;

});

parcelRegister("PVo4u", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");

const $051fa6ddf2f4f010$export$ad9e8f9d9536c33d = ()=>{
    // The key is defined in packages/atlassian-analytics-pipeline/analytics-web-client/src/sessionTracking.ts.
    const LOCAL_STORAGE_KEY = 'awc.session.id';
    try {
        return (0, $5G9KX.getLocalStorageItemAsString)(LOCAL_STORAGE_KEY) ?? undefined;
    } catch (error) {
        return undefined;
    }
};
module.exports["getSessionIdFromLocalStorage"] = $051fa6ddf2f4f010$export$ad9e8f9d9536c33d;

});

parcelRegister("3htW4", function(module, exports) {
const $5c6286f004754d19$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};
module.exports["onRequestCacheAccess"] = $5c6286f004754d19$export$786813d6840571a0;

});

parcelRegister("31eSD", function(module, exports) {
const $7ee20f32daead583$export$5e8268eaa81797f5 = {
    SEARCH_PAGE_FIRST_PARTY_CONFIG_UX: 'search-page/first-party-config-ux',
    SEARCH_PAGE_FIRST_PARTY_CONFIG_NETWORK: 'search-page/first-party-config-network',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_UX: 'search-page/third-party-config-ux',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_NETWORK: 'search-page/third-party-config-network',
    SEARCH_PAGE_COMBINED_CONFIG_UX: 'search-page/combined-config-ux',
    SEARCH_PAGE_COMBINED_CONFIG_NETWORK: 'search-page/combined-config-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX: 'search-page/full-page-search-results-ux',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK: 'search-page/full-page-search-results-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS: 'search-page/full-page-search-async-search-results',
    QUICK_FIND_RECENT_ACTIVITIES_UX: 'quick-find/recent-activities-ux',
    QUICK_FIND_RECENT_ACTIVITIES_NETWORK: 'quick-find/recent-activities-network',
    QUICK_FIND_PRE_QUERY_RESULTS: 'quick-find/prequery-search-results-ux',
    QUICK_FIND_POST_QUERY_UX: 'quick-find/postquery-search-results-ux',
    QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK: 'quick-find/confluence-entities-network',
    QUICK_FIND_CONFLUENCE_SPACES_NETWORK: 'quick-find/confluence-spaces-network',
    QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK: 'quick-find/jira-issues-and-types-network',
    QUICK_FIND_JIRA_ENTITIES_NETWORK: 'quick-find/jira-entities-network',
    QUICK_FIND_ATLAS_ENTITIES_NETWORK: 'quick-find/atlas-entities-network',
    QUICK_FIND_MERCURY_ENTITIES_NETWORK: 'quick-find/mercury-entities-network',
    QUICK_FIND_TALENT_ENTITIES_NETWORK: 'quick-find/talent-entities-network',
    QUICK_FIND_ASSETS_ENTITIES_NETWORK: 'quick-find/assets-entities-network',
    QUICK_FIND_INTENT_DETECTION_NETWORK: 'quick-find/intent-detection-network',
    QUICK_FIND_INTENT_DETECTION_UX: 'quick-find/intent-detection-ux'
};
module.exports["TASK_NAMES"] = $7ee20f32daead583$export$5e8268eaa81797f5;

});

parcelRegister("bQSQw", function(module, exports) {


const $0672f58113131b34$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: window.location.hostname,
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $0672f58113131b34$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $0672f58113131b34$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $0672f58113131b34$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $0672f58113131b34$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["onTaskStart"] = $0672f58113131b34$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $0672f58113131b34$export$3e9761d670712e50;
module.exports["onTaskFail"] = $0672f58113131b34$export$2e311f5a2c70a936;
module.exports["onTaskAbort"] = $0672f58113131b34$export$807d68038784dd59;

});

parcelRegister("jjjIy", function(module, exports) {
// Modified from platform/packages/search/product-search-dialog/src/extensible/product-router/product/result-provider/faster-search-helpers.ts

var $bloXB = parcelRequire("bloXB");


var $lsW5D = parcelRequire("lsW5D");

function $f4ae55a82e2fef50$export$399f177751711473(searchResults, query, numberOfResultItems = 3, negateTitleHighlight) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $bloXB.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result,
                    highlightedTitle: negateTitleHighlight ? negatedHighlightedTitle : highlightedTitle
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0).slice(0, numberOfResultItems);
    return filteredResults;
}
function $f4ae55a82e2fef50$export$18f3758fc3685a84(searchResults, query) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { score: score = 0 } = (0, $bloXB.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0);
    return filteredResults;
}
function $f4ae55a82e2fef50$export$bf5c34de39b9bf13(recentActivities, query) {
    const normalizedQuery = (0, $lsW5D.normalizeWorkItemKey)(query);
    // Search by both the normalized key and the literal query, deduplicating by id
    const byNormalized = normalizedQuery && query !== normalizedQuery ? $f4ae55a82e2fef50$export$18f3758fc3685a84(recentActivities, normalizedQuery) : [];
    const byLiteral = $f4ae55a82e2fef50$export$18f3758fc3685a84(recentActivities, query);
    const seen = new Set(byNormalized.map((r)=>r.id));
    return [
        ...byNormalized,
        ...byLiteral.filter((r)=>!seen.has(r.id))
    ];
}
module.exports["filterSearchResultsWithHighlighting"] = $f4ae55a82e2fef50$export$399f177751711473;
module.exports["filterSearchResults"] = $f4ae55a82e2fef50$export$18f3758fc3685a84;
module.exports["filterRecentActivities"] = $f4ae55a82e2fef50$export$bf5c34de39b9bf13;

});

parcelRegister("bloXB", function(module, exports) {
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $6609f2e7706baea1$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $6609f2e7706baea1$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $6609f2e7706baea1$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $6609f2e7706baea1$var$CONSECUTIVE_START_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`, 'g');
const $6609f2e7706baea1$var$CONSECUTIVE_END_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`, 'g');
const $6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`, 'g');
const $6609f2e7706baea1$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $6609f2e7706baea1$var$cleanStartRegex = new RegExp($6609f2e7706baea1$var$HIGHLIGHT_START_TAG, 'g');
const $6609f2e7706baea1$var$cleanEndRegex = new RegExp($6609f2e7706baea1$var$HIGHLIGHT_END_TAG, 'g');
const $6609f2e7706baea1$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($6609f2e7706baea1$var$cleanStartRegex, '').replace($6609f2e7706baea1$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($6609f2e7706baea1$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($6609f2e7706baea1$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}|${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}$1${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`]: `${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`,
                [`${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`]: `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`.replace($6609f2e7706baea1$var$CONSECUTIVE_START_REGEX, `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_END_REGEX, `${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${word}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};
module.exports["highlightMatchedText"] = $6609f2e7706baea1$export$9f4c92a576b56d82;

});

parcelRegister("lsW5D", function(module, exports) {
/**
 * Normalizes an issue key query by removing hyphens and spaces so that
 * queries like "AAA34", "AAA 34", and "AAA-34" all match the canonical key "AAA-34".
 * Returns undefined if the value does not look like an issue key.
 */ const $36dfe9a646cd7d4d$export$2c6ff4235668ce91 = (value)=>{
    const normalized = value.replace(/^([a-zA-Z]+)[\s-]?(\d+)$/, '$1-$2').toLowerCase();
    return normalized !== value.toLowerCase() || /^[a-zA-Z]+-\d+$/.test(value) ? normalized : undefined;
};
module.exports["normalizeWorkItemKey"] = $36dfe9a646cd7d4d$export$2c6ff4235668ce91;

});

parcelRegister("4tgkZ", function(module, exports) {

var $8AgZb = parcelRequire("8AgZb");


var $fXT59 = parcelRequire("fXT59");

const $fa792d959dc8194b$export$3d3f5f86906a7f73 = (0, $8AgZb.KnowledgeDiscoveryJiraSearchClassification);
const $fa792d959dc8194b$export$928cec68d7595d16 = (0, $fXT59.disposableValue)(null);
const $fa792d959dc8194b$export$3d750f4e9f4d0fc8 = {
    Jql: 'JQL'
};
const $fa792d959dc8194b$export$5cd976a4b4b84eb3 = (currentQuery)=>{
    const stored = $fa792d959dc8194b$export$928cec68d7595d16.value();
    if (!stored || stored.patternType !== $fa792d959dc8194b$export$3d750f4e9f4d0fc8.Jql) return false;
    return stored.query.trim() === currentQuery.trim();
};
module.exports["IntentMode"] = $fa792d959dc8194b$export$3d3f5f86906a7f73;
module.exports["INTENT_DETECTION"] = $fa792d959dc8194b$export$928cec68d7595d16;
module.exports["PatternType"] = $fa792d959dc8194b$export$3d750f4e9f4d0fc8;
module.exports["isJqlQueryDetected"] = $fa792d959dc8194b$export$5cd976a4b4b84eb3;

});

parcelRegister("8AgZb", function(module, exports) {
const $17298238d3880205$export$52027d47033ea8ad = {
    GNIN: 'GNIN',
    FPS: 'FPS'
};
module.exports["KnowledgeDiscoveryJiraSearchClassification"] = $17298238d3880205$export$52027d47033ea8ad;

});

parcelRegister("9wmQG", function(module, exports) {
/**
 * This file provides the necessary wrappers and utility functions to provide
 * analytics data for Quick Find result positions. Quick Find analytics contains
 * data such as the number of results, the number of sections, and the
 * position / section of a selected result.
 *
 * It does this by using the DOM as the source of truth rather than having to
 * maintain section objects and indexes in the code. This allows rendering
 * display components to be simplified and could prove to be more robust, e.g.
 * if a search result doesn't render due to an error and subsequently hits
 * its error boundary, section and results count remain correct.
 *
 * There is however the requirement that all heading and results components
 * are siblings in the DOM tree.
 */ /* eslint-disable @atlaskit/platform/no-direct-document-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $42omo = parcelRequire("42omo");


var $d6omw = parcelRequire("d6omw");

var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");

var $c5fb920fb7e7d9be$require$differenceInMinutes = $d6omw.default;
var $c5fb920fb7e7d9be$require$parseISO = $da71s.default;
var $c5fb920fb7e7d9be$require$isValid = $cFEpk.default;
const $c5fb920fb7e7d9be$export$e7b6022782937b95 = 'search-dialog-heading';
const $c5fb920fb7e7d9be$export$926357658a80ff2a = 'search-dialog-result';
const $c5fb920fb7e7d9be$export$f8cbabfc03558964 = 'bulk-connect-banner';
const $c5fb920fb7e7d9be$var$resultTypes = [
    'peopleAndTeams',
    'recentQueries',
    'recentActivities',
    'queryFilters',
    'searchResults',
    'zeroQueries',
    'autocompleteSuggestions',
    'filterSuggestions',
    'intentRouter',
    'recommendations',
    'intentRouterWorkItem'
];
const $c5fb920fb7e7d9be$export$8814e97d826fd90d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, id: id, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: $c5fb920fb7e7d9be$export$e7b6022782937b95,
        "data-section-id": id,
        "data-testid": "search-dialog-heading-analytics-wrapper",
        ref: ref,
        ...rest
    }, children));
});
const $c5fb920fb7e7d9be$export$e01f22447ddebe43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, resultType: resultType, product: product, id: id, connectorType: connectorType, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, recentActivityEventType: recentActivityEventType, zeroQueryType: zeroQueryType, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // Ignoring this check as class is not being used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $c5fb920fb7e7d9be$export$926357658a80ff2a,
        "data-result-type": resultType,
        "data-product": product,
        "data-id": id,
        "data-connector-type": connectorType,
        "data-since-activity-timestamp": minutesSinceActivityTimestamp,
        "data-recent-activity-event-type": recentActivityEventType,
        "data-zero-query-type": zeroQueryType,
        ref: ref,
        ...rest
    }, children);
});
const $c5fb920fb7e7d9be$export$75fc08fd8853e1c3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: $c5fb920fb7e7d9be$export$f8cbabfc03558964,
        ref: ref,
        ...rest
    }, children));
});
const $c5fb920fb7e7d9be$export$1be6c28d5e945bdf = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const counts = {};
    for(let i = 0; i < resultNodes.length; i++){
        const product = resultNodes[i].getAttribute('data-product');
        if (!product) continue;
        counts[product] = (counts[product] ?? 0) + 1;
    }
    return counts;
};
const $c5fb920fb7e7d9be$export$e21758a6ca606f0a = ()=>{
    return Object.keys($c5fb920fb7e7d9be$export$1be6c28d5e945bdf());
};
const $c5fb920fb7e7d9be$export$a9cb3c6c659d9dfe = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const productSet = new Set();
    for(let i = 0; i < resultNodes.length; i++){
        if (resultNodes[i].getAttribute('data-result-type') !== 'recommendations') continue;
        const product = resultNodes[i].getAttribute('data-product');
        product && productSet.add(product);
    }
    return Array.from(productSet);
};
const $c5fb920fb7e7d9be$export$d812a070b2ee9d66 = ()=>{
    const bannerNode = document.querySelector(`.${$c5fb920fb7e7d9be$export$f8cbabfc03558964}`);
    return bannerNode !== null;
};
const $c5fb920fb7e7d9be$var$isNotRecentQuery = (product)=>{
    return Boolean(product);
};
function $c5fb920fb7e7d9be$export$4e2371c785c39b57(compareWithTimeInMs) {
    try {
        if (typeof compareWithTimeInMs !== 'string') return null;
        const startTime = $c5fb920fb7e7d9be$require$parseISO(compareWithTimeInMs);
        if (!$c5fb920fb7e7d9be$require$isValid(startTime)) return null;
        const difference = $c5fb920fb7e7d9be$require$differenceInMinutes(new Date(), startTime, 'floor');
        return difference >= 0 ? difference : null;
    } catch  {
        // Swallowing error, bad timestamp should not throw error
        return null;
    }
}
/**
 * Maps each result's data-id to its sectionId by walking sibling heading/result
 * nodes, mirroring how `ItemsAnalyticsProvider.getItemIndexes` resolves sectionId.
 */ const $c5fb920fb7e7d9be$var$buildResultSectionIdMap = ()=>{
    const map = new Map();
    let allNodes;
    try {
        allNodes = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults().allNodes;
    } catch  {
        return map;
    }
    let currentSectionId = null;
    for (const node of allNodes){
        if ($c5fb920fb7e7d9be$var$isHeading(node)) currentSectionId = node.getAttribute('data-section-id');
        else if ($c5fb920fb7e7d9be$var$isResult(node)) {
            const resultId = node.getAttribute('data-id');
            if (resultId) map.set(resultId, currentSectionId);
        }
    }
    return map;
};
const $c5fb920fb7e7d9be$export$8841f6f549512fc2 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const sectionIdMap = $c5fb920fb7e7d9be$var$buildResultSectionIdMap();
    const resultList = [];
    for(let i = 0; i < resultNodes.length; i++){
        const id = resultNodes[i].getAttribute('data-id');
        const product = resultNodes[i].getAttribute('data-product');
        const connectorType = resultNodes[i].getAttribute('data-connector-type');
        const resultType = resultNodes[i].getAttribute('data-result-type');
        const rawMinutesSinceActivityTimestamp = parseInt(resultNodes[i].getAttribute('data-since-activity-timestamp') || '', 10);
        const minutesSinceActivityTimestamp = isNaN(rawMinutesSinceActivityTimestamp) ? null : rawMinutesSinceActivityTimestamp;
        // Missing attribute -> explicit `null` (mirrors `minutesSinceActivityTimestamp`).
        const recentActivityEventType = resultNodes[i].getAttribute('data-recent-activity-event-type') || null;
        if (id && $c5fb920fb7e7d9be$var$isNotRecentQuery(product)) {
            const resultShown = {
                id: id,
                product: product,
                position: i,
                metadata: {
                    minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
                    ...connectorType && {
                        connectorType: connectorType
                    },
                    resultType: resultType,
                    sectionId: sectionIdMap.get(id) ?? null,
                    recentActivityEventType: recentActivityEventType
                }
            };
            resultList.push(resultShown);
        }
    }
    return resultList;
};
const $c5fb920fb7e7d9be$export$837a07087631b7e0 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const zeroQueryNodes = resultNodes.filter((node)=>node.getAttribute('data-result-type') === 'zeroQueries');
    return zeroQueryNodes.map((node, idx)=>({
            zeroQueryType: node.getAttribute('data-zero-query-type') ?? '',
            zeroQueryPosition: idx
        }));
};
const $c5fb920fb7e7d9be$export$334c5c15d40bbec1 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    return $c5fb920fb7e7d9be$var$resultTypes.reduce((o, resultType)=>{
        o[resultType] = resultNodes.filter((node)=>node.getAttribute('data-result-type') === resultType).length || 0;
        return o;
    }, {});
};
const $c5fb920fb7e7d9be$var$getAllHeadingsAndResults = ()=>{
    const headingNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$e7b6022782937b95));
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    if (!headingNodes.length || !resultNodes.length) return {
        allNodes: [],
        headingNodes: [],
        resultNodes: []
    };
    const parentNode = headingNodes.length ? headingNodes[0].parentNode : resultNodes.length ? resultNodes[0].parentNode : undefined;
    if (!parentNode) throw new Error('Could not find a parent node for headings and results');
    const allNodes = Array.from(parentNode.children).filter((e)=>$c5fb920fb7e7d9be$var$isHeading(e) || $c5fb920fb7e7d9be$var$isResult(e));
    return {
        allNodes: allNodes,
        headingNodes: headingNodes,
        resultNodes: resultNodes
    };
};
const $c5fb920fb7e7d9be$var$isHeading = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$e7b6022782937b95);
};
const $c5fb920fb7e7d9be$var$isResult = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$926357658a80ff2a) || e.querySelector(`.${$c5fb920fb7e7d9be$export$926357658a80ff2a}`) !== null;
};
const $c5fb920fb7e7d9be$export$e9dac44129e02fa9 = ()=>{
    try {
        const { allNodes: allNodes, headingNodes: headingNodes, resultNodes: resultNodes } = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults();
        // If the first node is a result, then we count it as a section
        const sectionCount = allNodes.length ? headingNodes.length + ($c5fb920fb7e7d9be$var$isResult(allNodes[0]) ? 1 : 0) : 0;
        return {
            sectionCount: sectionCount,
            resultCount: resultNodes.length
        };
    } catch  {
        return {};
    }
};
module.exports["SearchDialogHeaderAnalyticsWrapper"] = $c5fb920fb7e7d9be$export$8814e97d826fd90d;
module.exports["SearchDialogResultAnalyticsWrapper"] = $c5fb920fb7e7d9be$export$e01f22447ddebe43;
module.exports["getProductResultCounts"] = $c5fb920fb7e7d9be$export$1be6c28d5e945bdf;
module.exports["getProductsInResults"] = $c5fb920fb7e7d9be$export$e21758a6ca606f0a;
module.exports["getProductsInRecommendations"] = $c5fb920fb7e7d9be$export$a9cb3c6c659d9dfe;
module.exports["getIsBulkConnectBannerShown"] = $c5fb920fb7e7d9be$export$d812a070b2ee9d66;
module.exports["calculateMinuteDifference"] = $c5fb920fb7e7d9be$export$4e2371c785c39b57;
module.exports["getResultsShown"] = $c5fb920fb7e7d9be$export$8841f6f549512fc2;
module.exports["getShownZeroQueries"] = $c5fb920fb7e7d9be$export$837a07087631b7e0;
module.exports["getResultTypeCounts"] = $c5fb920fb7e7d9be$export$334c5c15d40bbec1;
module.exports["getSectionsAndResultsCount"] = $c5fb920fb7e7d9be$export$e9dac44129e02fa9;

});

parcelRegister("kQT7c", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $eakyO = parcelRequire("eakyO");


var $3E8x9 = parcelRequire("3E8x9");


var $def8z = parcelRequire("def8z");


const $6e55f7e6ca9a4561$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $6e55f7e6ca9a4561$export$e6a288d5cd4cda6 = (partial)=>partial.__typename === 'SearchResultGoogleDocument' || $6e55f7e6ca9a4561$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $6e55f7e6ca9a4561$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'document';
const $6e55f7e6ca9a4561$export$34ee1a2c0a1a45b7 = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $6e55f7e6ca9a4561$var$SMART_LINK_ENTITY_REGEX = /^ari:.*::remote-link/;
const $6e55f7e6ca9a4561$export$8cc78980eb89e95d = (resultAri)=>$6e55f7e6ca9a4561$var$SMART_LINK_ENTITY_REGEX.test(resultAri);
const $6e55f7e6ca9a4561$export$c5fdbcc9e7462013 = ({ connectorType: connectorType, resultAri: resultAri, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>connectorType === (0, $eakyO.ConnectorSources).Smartlinks || $6e55f7e6ca9a4561$export$8cc78980eb89e95d(resultAri) || (0, $def8z.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    }) || eventType === (0, $3E8x9.VIEWED_EVENT).SL_VIEWED || eventType === (0, $3E8x9.VIEWED_EVENT).SL_CLICKED && (0, $dh538.fg)('rovo_fps_is_result_smart_link_sl_clicked');
const $6e55f7e6ca9a4561$var$getProduct3PConfig = (productKey, thirdPartyConfigs)=>{
    return productKey && (0, $b4tvS.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
};
const $6e55f7e6ca9a4561$export$15ebd9395cf27aef = ({ connectorType: connectorType, resultNodeId: resultNodeId, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    // Return the connectorType if it's already valid
    if ((0, $9d9t8.isConnectorSource)(connectorType)) return connectorType;
    // connectorType will not exist for the following cases:
    // * when search GraphQL response returns null for connectorType
    // * when the given API doesn't return a connectorType. E.g. user documents.
    // as a result, we use fallback logic to determine the connectorType.
    if ($6e55f7e6ca9a4561$export$c5fdbcc9e7462013({
        connectorType: connectorType,
        resultAri: resultNodeId,
        eventType: eventType,
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    })) return (0, $eakyO.ConnectorSources).Smartlinks;
    const config = $6e55f7e6ca9a4561$var$getProduct3PConfig(productKey, thirdPartyConfigs);
    // No config found for the product
    if (!config) return undefined;
    if (config.isFederated) return (0, $eakyO.ConnectorSources).Federated;
    // Return the single connector source if it's valid
    if (config.connectorSources?.length === 1) {
        const source = config.connectorSources[0];
        if ((0, $9d9t8.isConnectorSource)(source)) return source;
    }
    // Default to Full for any other case where config exists
    return (0, $eakyO.ConnectorSources).Full;
};
module.exports["isResultSmartLink"] = $6e55f7e6ca9a4561$export$c5fdbcc9e7462013;
module.exports["getResultConnectorSource"] = $6e55f7e6ca9a4561$export$15ebd9395cf27aef;

});

parcelRegister("3E8x9", function(module, exports) {
// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/eventTypeMessage.tsx
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $42omo = parcelRequire("42omo");


var $dlSEv = parcelRequire("dlSEv");


var $dhNqt = parcelRequire("dhNqt");


var $6gF1I = parcelRequire("6gF1I");


var $aXWIB = parcelRequire("aXWIB");


var $5mJ0F = parcelRequire("5mJ0F");

var $Lyrmh = parcelRequire("Lyrmh");

var $38e9d08a360f6294$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SL_CLICKED"] = "sl-clicked";
    VIEWED_EVENT["CLICKED"] = "clicked";
    return VIEWED_EVENT;
}({});
var $38e9d08a360f6294$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    WORKED_EVENT["SHARED"] = "shared";
    return WORKED_EVENT;
}({});
function $38e9d08a360f6294$export$e873c799b137eec4(date) {
    return (0, $dlSEv.default)(new Date(date), $38e9d08a360f6294$var$startOfOneWeekAgo());
}
function $38e9d08a360f6294$var$startOfOneWeekAgo() {
    return (0, $dhNqt.default)((0, $6gF1I.default)(new Date(), 1));
}
const $38e9d08a360f6294$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData })=>{
    const isAbsolute = $38e9d08a360f6294$export$e873c799b137eec4(timestamp);
    const message = (0, $Lyrmh.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedRelativeTime), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...message,
        values: values
    });
};
module.exports["VIEWED_EVENT"] = $38e9d08a360f6294$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $38e9d08a360f6294$export$eb4e9f525aef1cc3;
module.exports["isMoreThanOneWeekAgo"] = $38e9d08a360f6294$export$e873c799b137eec4;
module.exports["EventTypeMessage"] = $38e9d08a360f6294$export$9e4fb3fb50a3c754;

});

parcelRegister("JQd0k", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $e31678cde9628b17$export$e70e6da722faba05 = (callback, debounceTime)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $42omo.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(func, debounceTime);
    }, [
        debounceTime
    ]);
    return debouncedCallback;
};
module.exports["useDebouncedCallback"] = $e31678cde9628b17$export$e70e6da722faba05;

});

parcelRegister("gzcCN", function(module, exports) {
var $78275d0f42176934$export$fb160374438e1cd7 = /*#__PURE__*/ function(SearchConfluenceSubtype) {
    SearchConfluenceSubtype["LIVE"] = "LIVE";
    return SearchConfluenceSubtype;
}({});
module.exports["SearchConfluenceSubtype"] = $78275d0f42176934$export$fb160374438e1cd7;

});

parcelRegister("icWhS", function(module, exports) {

var $aU479 = parcelRequire("aU479");

const $2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR = '---';
const $2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR = '___';
const $2ffa685ce1f1083f$export$ce6d1d009c92f1be = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${$2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR}${(0, $aU479.hashData)(query)}`);
    if (additionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${$2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR}${value}`);
    });
    if (events.length === 0) return urlObject.toString();
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join($2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR));
    urlObject.searchParams.set('additional_analytics', analyticsFormattedForUrlParsing);
    return urlObject.toString();
};
const $2ffa685ce1f1083f$export$2e67c54459604a9 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split($2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR);
    events.forEach((event)=>{
        const formattedEvent = event?.split($2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $2ffa685ce1f1083f$export$b780bd7096d811c5 = ({ url: url, searchSessionId: searchSessionId, resultId: resultId, projectId: projectId })=>{
    const jiraResultARIPattern = /^ari:cloud:jira:[a-z0-9-]+:[a-z]+\/[0-9]+$/;
    if (!resultId.match(jiraResultARIPattern)) return url;
    const jiraProjectARIPattern = /^ari:cloud:jira:[a-z0-9-]+:project\/[0-9]+$/;
    if (projectId && !projectId.match(jiraProjectARIPattern)) return url;
    const urlObject = new URL(url);
    urlObject.searchParams.set('searchSessionId', searchSessionId);
    const searchObjectId = resultId.split('/').pop();
    searchObjectId && urlObject.searchParams.set('searchObjectId', searchObjectId);
    const searchContentType = resultId.split('/')[0].split(':').pop();
    searchContentType && urlObject.searchParams.set('searchContentType', searchContentType);
    const searchContainerId = projectId?.split('/').pop();
    searchContainerId && urlObject.searchParams.set('searchContainerId', searchContainerId);
    return urlObject.toString();
};
const $2ffa685ce1f1083f$export$a5abc05a86b8de68 = ({ url: url, searchSessionId: searchSessionId, customParams: customParams = new Map([]) })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    customParams.forEach((value, key)=>{
        urlObject.searchParams.set(key || '', value || '');
    });
    return urlObject.toString();
};
module.exports["getConfluenceUrlWithAnalyticsQueryParams"] = $2ffa685ce1f1083f$export$ce6d1d009c92f1be;
module.exports["getJiraUrlWithAnalyticsQueryParams"] = $2ffa685ce1f1083f$export$b780bd7096d811c5;
module.exports["getGenericUrlWithAnalyticsQueryParams"] = $2ffa685ce1f1083f$export$a5abc05a86b8de68;

});

parcelRegister("aU479", function(module, exports) {

var $7azCD = parcelRequire("7azCD");


var $1HJbl = parcelRequire("1HJbl");


var $ipWWT = parcelRequire("ipWWT");


var $5e5BE = parcelRequire("5e5BE");

// copied over from @confluence/hash
const $d5e09354796e09eb$var$hash = (data, asBytes = false)=>{
    const hash = (0, $7azCD.sha256).create();
    hash.update(data);
    if (asBytes) return hash.array();
    return hash.hex();
};
const $d5e09354796e09eb$export$5fdf8c875acfc1b3 = (data)=>{
    return $d5e09354796e09eb$var$hash(data, true);
};
const $d5e09354796e09eb$export$7904c6256691057a = (data)=>{
    return $d5e09354796e09eb$var$hash(data);
};
module.exports["hashData"] = $d5e09354796e09eb$export$7904c6256691057a;

});

parcelRegister("1HJbl", function(module, exports) {
/**
 * Strip highlight markers from text
 */ const $cf5e87116ee7c968$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["cleanExcerpt"] = $cf5e87116ee7c968$export$7512fe8206a7f75b;

});

parcelRegister("ipWWT", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ay6Zz = parcelRequire("ay6Zz");

const $dba528931595cd79$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'home'
    }).href : `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
module.exports["getUserPath"] = $dba528931595cd79$export$451f7a1e7c934f54;

});

parcelRegister("5e5BE", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ay6Zz = parcelRequire("ay6Zz");

const $1c9cc7f1c0db61db$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId
    }).href : `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};
module.exports["getTeamPath"] = $1c9cc7f1c0db61db$export$9456a8e088bfede1;

});

parcelRegister("9kYXz", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7ZetK = parcelRequire("7ZetK");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $aXWIB = parcelRequire("aXWIB");

const $09a4f345db91ad30$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    branchLabel: {
        id: "branch.label",
        defaultMessage: "Branch"
    },
    commitLabel: {
        id: "commit.label",
        defaultMessage: "Commit"
    },
    pullRequestLabel: {
        id: "pull-request.label",
        defaultMessage: "Pull Request"
    },
    workItemLabel: {
        id: "work-item.label",
        defaultMessage: "Work Item"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    channelLabel: {
        id: "channel.label",
        defaultMessage: "Channel"
    },
    knowledgeArticleLabel: {
        id: "3p-result-labeling.knowledge_article.label",
        defaultMessage: "Knowledge article"
    },
    newsArticleLabel: {
        id: "3p-result-labeling.news_article.label",
        defaultMessage: "News article"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});


const $a9e61b13b0839871$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $09a4f345db91ad30$export$defe85febe8b728c).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $09a4f345db91ad30$export$defe85febe8b728c).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $09a4f345db91ad30$export$defe85febe8b728c).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $09a4f345db91ad30$export$defe85febe8b728c).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $09a4f345db91ad30$export$defe85febe8b728c).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $09a4f345db91ad30$export$defe85febe8b728c).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $b4tvS.ProductKeys).Sharepoint || product === (0, $b4tvS.ProductKeys).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $b4tvS.ProductKeys).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    else if (product.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler) && // QF returns subtype with underscores, f.e. 'WEB_PAGE', so we need to support both
    subtype.replace('_', '-') === (0, $2Znam.NounSubtypeKey).WebPage) label = (0, $09a4f345db91ad30$export$defe85febe8b728c).webPageLabel;
    else if (subtype === (0, $2Znam.NounSubtypeKey).KnowledgeArticle || // QF returns subtype in uppercase (e.g. 'KNOWLEDGE_ARTICLE'), so we support both casings
    normalizedSubtype === 'KNOWLEDGE_ARTICLE') label = (0, $09a4f345db91ad30$export$defe85febe8b728c).knowledgeArticleLabel;
    else if (subtype === (0, $2Znam.NounSubtypeKey).NewsArticle || // QF returns subtype in uppercase (e.g. 'NEWS_ARTICLE'), so we support both casings
    normalizedSubtype === 'NEWS_ARTICLE') label = (0, $09a4f345db91ad30$export$defe85febe8b728c).newsArticleLabel;
    return label;
};
// Provider-aware label so that e.g. GitHub work items render as "Issue"
// rather than the generic "Work item". Mirrors the providerDefaultLabelMap
// in the full search results page work-item renderer.
const $a9e61b13b0839871$var$providerDefaultLabelMap = {
    [(0, $b4tvS.ProductKeys).Github]: (0, $09a4f345db91ad30$export$defe85febe8b728c).issueLabel
};
const $a9e61b13b0839871$export$67bc9d7952cf216d = ({ product: product, subtype: subtype, resourceType: resourceType })=>{
    const documentLabel = $a9e61b13b0839871$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    if (documentLabel) return documentLabel;
    if (!resourceType) return;
    if (resourceType === (0, $7ZetK.ResourceType).VIDEO) return (0, $09a4f345db91ad30$export$defe85febe8b728c).videoLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).REPOSITORY) return (0, $09a4f345db91ad30$export$defe85febe8b728c).repositoryLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).PULL_REQUEST) return (0, $09a4f345db91ad30$export$defe85febe8b728c).pullRequestLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).BRANCH) return (0, $09a4f345db91ad30$export$defe85febe8b728c).branchLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).COMMIT) return (0, $09a4f345db91ad30$export$defe85febe8b728c).commitLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).WORK_ITEM) {
        if (product && $a9e61b13b0839871$var$providerDefaultLabelMap[product] && (0, $dh538.fg)('qf_github_labels_in_search_results')) return $a9e61b13b0839871$var$providerDefaultLabelMap[product];
        return (0, $09a4f345db91ad30$export$defe85febe8b728c).workItemLabel;
    }
    return undefined;
};
const $a9e61b13b0839871$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $09a4f345db91ad30$export$defe85febe8b728c)) return (0, $09a4f345db91ad30$export$defe85febe8b728c)[labelKey];
    else return (0, $09a4f345db91ad30$export$defe85febe8b728c).otherLabel;
};
module.exports["getDocumentSubtypeLabel"] = $a9e61b13b0839871$export$a47c0c6de01249fd;
module.exports["getSubtypeLabel"] = $a9e61b13b0839871$export$67bc9d7952cf216d;
module.exports["getRemoteLinkSubtypeLabel"] = $a9e61b13b0839871$export$19dc2415a5fa9123;

});

parcelRegister("i6Ooe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");




const $4851d5766ba33563$export$373c576b545d33cb = (0, $aXWIB.defineMessages)({
    open: {
        id: "search-page.common.graph-work-item-status.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.common.graph-work-item-status.closed",
        defaultMessage: "Closed"
    }
});


/**
 * Map a third-party **work-item** status (e.g. GitHub issue states) onto the
 * appropriate Atlaskit Lozenge appearance.
 *
 * Only the two canonical GitHub work-item states (`OPEN`, `CLOSED`) are
 * supported. Inputs are case-insensitive — callers may pass the value as it
 * comes from the API (`"open"`, `"OPEN"`, …). Anything else falls back to
 * `'neutral'`.
 *
 * Kept separate from `getPullRequestStatusAppearance` so the two domains stay
 * decoupled and additions to either map can't accidentally affect the other.
 */ const $c051f5e53e3ba6ed$var$workItemStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    CLOSED: 'success' // green
};
const $c051f5e53e3ba6ed$var$getAppearance = (status)=>(status ? $c051f5e53e3ba6ed$var$workItemStatusToLozengeMap[status.toUpperCase()] : undefined) ?? 'neutral';
const $c051f5e53e3ba6ed$export$c8ca8b382bc642d1 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!status) return null;
    const message = (0, $4851d5766ba33563$export$373c576b545d33cb)[status.toLowerCase()];
    const label = message ? formatMessage(message) : status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: $c051f5e53e3ba6ed$var$getAppearance(status),
        testId: "graph-work-item-status-lozenge-test-id"
    }, label);
};
module.exports["GraphWorkItemStatusLozenge"] = $c051f5e53e3ba6ed$export$c8ca8b382bc642d1;

});

parcelRegister("2waBy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $g5QRf = parcelRequire("g5QRf");


var $fwXBL = parcelRequire("fwXBL");


var $eiXsV = parcelRequire("eiXsV");


var $226KS = parcelRequire("226KS");


var $hbYDZ = parcelRequire("hbYDZ");


var $9lz2c = parcelRequire("9lz2c");


var $5aaqS = parcelRequire("5aaqS");


var $1yB28 = parcelRequire("1yB28");


var $4ayWZ = parcelRequire("4ayWZ");


var $4AkKf = parcelRequire("4AkKf");


var $eG1e2 = parcelRequire("eG1e2");


var $gJsgh = parcelRequire("gJsgh");


var $5LN4K = parcelRequire("5LN4K");


var $bVHZY = parcelRequire("bVHZY");


var $f6IRL = parcelRequire("f6IRL");


var $99wB5 = parcelRequire("99wB5");


var $2qVkt = parcelRequire("2qVkt");


var $gj7hi = parcelRequire("gj7hi");


var $6iY4P = parcelRequire("6iY4P");


var $5tnQQ = parcelRequire("5tnQQ");


var $57Wda = parcelRequire("57Wda");


var $8hhCV = parcelRequire("8hhCV");


var $66dpz = parcelRequire("66dpz");


var $6atSO = parcelRequire("6atSO");


var $eQfRp = parcelRequire("eQfRp");


var $i7jPX = parcelRequire("i7jPX");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $aRSt4 = parcelRequire("aRSt4");

const $5a4ea6f059d19d35$var$isImageDataUrl = (str)=>/^data:image\/[^;]+;base64,/.test(str); /**
                                                                                 * Returns the appropriate icon for a Jira item based on the provided parameters.
                                                                                 *
                                                                                 * @param {string | null | undefined} iconUrl - The URL of the icon image.
                                                                                 * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
                                                                                 * @param {boolean} isIssue - Flag indicating if the item is an issue.
                                                                                 * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
                                                                                 * @returns {React.JSX.Element} The JSX element representing the icon.
                                                                                 */ 
const $5a4ea6f059d19d35$export$348a13c9e1254ce4 = ({ iconUrl: iconUrl, type: type, isIssue: isIssue, size: size = 'small' })=>{
    const imageSize = size === 'medium' ? 22 : 16; // Use the iconUrl if available
    if (iconUrl) {
        if (isIssue) // wrapper is only needed for issues. Other types don't need the background and padding with iconUrl.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "Work item icon",
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: "Work item icon",
            testId: "jira-entity-icon",
            width: imageSize,
            height: imageSize,
            src: iconUrl
        }));
        return(// The image covers up the whole wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: `${type} icon`,
            testId: "jira-entity-icon",
            src: iconUrl
        })));
    }
    if (isIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "Work item icon",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
        spacing: "none",
        size: size,
        label: "work-item-icon"
    }));
    let icon;
    switch(type){
        case 'board':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5aaqS))), {
                spacing: "none",
                size: size,
                label: "board-icon"
            });
            break;
        case 'plan':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6IRL))), {
                spacing: "none",
                size: size,
                label: "plan-icon"
            });
            break;
        case 'filter':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                spacing: "none",
                size: size,
                label: "filter-icon"
            });
            break;
        case 'dashboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ayWZ))), {
                spacing: "none",
                size: size,
                label: "dashboard-icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                spacing: "none",
                size: size,
                label: "space-icon"
            });
            break;
        case 'incident':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))), {
                spacing: "none",
                size: size,
                label: "incident-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                size: size,
                product: (0, $b4tvS.ProductKeys).Jira
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $5a4ea6f059d19d35$export$e375917bfb190d26 = ({ iconUrl: iconUrl, type: type, size: size = 'small', isLiveDoc: isLiveDoc = false })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Confluence entities is usually an absolute URL
        // We only use custom iconUrl for Spaces
        if (type === 'space' && iconUrl && ($5a4ea6f059d19d35$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: iconUrl
        }));
    } catch  {} /*
              ** For finding all the Confluence entities look at platform/packages/search/search-page/src/common/utils/filters/constants.ts -> typeFilter1PMapping
              * */ 
    let icon;
    switch(type){
        case 'space':
            // spaces usually have an iconUrl, but if not we fall back to the project icon
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                size: size,
                label: "space icon"
            });
            break;
        case 'page':
            if (isLiveDoc) icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66dpz.default), {
                size: size,
                label: "live page icon"
            });
            else icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                size: size,
                label: "page icon"
            });
            break;
        case 'blogpost':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iY4P.default), {
                size: size,
                label: "blogpost icon"
            });
            break;
        case 'attachment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
                spacing: "none",
                size: size,
                label: "attachment icon"
            });
            break;
        case 'comment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                spacing: "none",
                size: size,
                label: "comment icon"
            });
            break;
        case 'whiteboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eQfRp.default), {
                size: size,
                label: "whiteboard icon"
            });
            break;
        case 'slide':
            // CNS-25852: render the slide icon for slides search results so
            // they no longer fall back to the generic Confluence product icon.
            // Imported directly from icon-lab rather than @atlaskit/object
            // because the object codegen entry doesn't exist yet.
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))), {
                spacing: "none",
                size: size,
                label: "slide icon",
                color: "var(--ds-icon-accent-green, #22A06B)"
            });
            break;
        case 'database':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57Wda.default), {
                size: size,
                label: "database icon"
            });
            break;
        case 'question':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6atSO.default), {
                size: size,
                label: "question icon"
            });
            break;
        case 'calendar':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tnQQ.default), {
                size: size,
                label: "calendar icon"
            });
            break;
        case 'embed':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99wB5))), {
                spacing: "none",
                size: size,
                label: "embed icon"
            });
            break;
        case 'folder':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                spacing: "none",
                size: size,
                label: "folder icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                label: "confluence icon",
                size: size,
                product: (0, $b4tvS.ProductKeys).Confluence
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $5a4ea6f059d19d35$export$397605bdd85a2f89 = ({ iconUrl: iconUrl, type: type, size: size = 'small' })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Atlas entities is usually an absolute URL
        if (iconUrl && ($5a4ea6f059d19d35$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: iconUrl
        }));
    } catch  {}
    let icon;
    switch(type){
        case 'goal':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gJsgh))), {
                size: size,
                label: "goal icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                size: size,
                label: "project icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                label: "Atlas icon",
                size: size,
                product: (0, $b4tvS.ProductKeys).Atlas
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
}; /**
    * Returns the appropriate icon for a Jira item based on the provided parameters.
    *
    * @param {string | null | undefined} iconUrl - The URL of the icon image.
    * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
    * @param {boolean} isIssue - Flag indicating if the item is an issue.
    * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
    * @returns {React.JSX.Element} The JSX element representing the icon.
    */ 
const $5a4ea6f059d19d35$export$fbba347fb6ffa903 = ({ iconUrl: iconUrl, type: type, size: size = 'small' })=>{
    // Use the iconUrl if available
    if (iconUrl) return(// The image covers up the whole wrapper
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        testId: "assets-entity-icon",
        src: iconUrl
    })));
    let icon;
    switch(type){
        case 'schema':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                spacing: "none",
                size: size,
                label: "schema-icon"
            });
            break;
        case 'type':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eiXsV))), {
                spacing: "none",
                size: size,
                label: "type-icon"
            });
            break;
        case 'object':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwXBL))), {
                spacing: "none",
                size: size,
                label: "object-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                size: size,
                product: (0, $b4tvS.ProductKeys).Assets
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
module.exports["getJiraEntityIcon"] = $5a4ea6f059d19d35$export$348a13c9e1254ce4;
module.exports["getConfluenceEntityIcon"] = $5a4ea6f059d19d35$export$e375917bfb190d26;
module.exports["getAtlasEntityIcon"] = $5a4ea6f059d19d35$export$397605bdd85a2f89;
module.exports["getAssetsEntityIcon"] = $5a4ea6f059d19d35$export$fbba347fb6ffa903;

});

parcelRegister("eiXsV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0aca1d30928709a7afbf0b04d0a092a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6a0dfbc8274aeb4$var$_react = $a6a0dfbc8274aeb4$var$_interopRequireDefault((parcelRequire("42omo")));

var $a6a0dfbc8274aeb4$var$_baseNew = $a6a0dfbc8274aeb4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a6a0dfbc8274aeb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObjectType".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing object types in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6a0dfbc8274aeb4$var$AssetsObjectTypeIcon = (props)=>/*#__PURE__*/ $a6a0dfbc8274aeb4$var$_react.default.createElement($a6a0dfbc8274aeb4$var$_baseNew.default, Object.assign({
        name: "AssetsObjectTypeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 14.5h3.5V11H11zm-5.5-11a2 2 0 1 0-4 0 2 2 0 0 0 4 0M16 14.625c0 .76-.616 1.375-1.375 1.375h-3.75c-.76 0-1.375-.616-1.375-1.375v-3.75c0-.76.616-1.375 1.375-1.375h3.75c.76 0 1.375.616 1.375 1.375zM7 3.5a3.5 3.5 0 0 1-2.75 3.418V11.5a.5.5 0 0 0 .5.5H8v1.5H4.75a2 2 0 0 1-2-2V6.918A3.5 3.5 0 1 1 7 3.5"/>`
    }, props));
$a6a0dfbc8274aeb4$var$AssetsObjectTypeIcon.displayName = 'AssetsObjectTypeIcon';
var $a6a0dfbc8274aeb4$var$_default = module.exports.default = $a6a0dfbc8274aeb4$var$AssetsObjectTypeIcon;

});

parcelRegister("aRSt4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $tvI67 = parcelRequire("tvI67");


var $9VJDA = parcelRequire("9VJDA");


var $4EMbH = parcelRequire("4EMbH");


var $1yEFx = parcelRequire("1yEFx");


var $9d9t8 = parcelRequire("9d9t8");


var $2OtFZ = parcelRequire("2OtFZ");

const $6ae4bffafe6abebf$export$1a199e029d5e93d6 = ({ product: product, size: size = 'large', isSelected: isSelected = false, useSearchResultIcon: useSearchResultIcon = false, ...props })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    if (product) {
        // First check if it's a Forge connector - prioritize dynamic API icons
        if ((0, $9d9t8.isForgeConnectorProductKey)(product)) {
            const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(product);
            if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
            return forgeIcon({
                ...props,
                size: size
            });
        }
        // Fallback to static products map (covers hardcoded Forge connectors and all other products)
        const config = products[product];
        if (config) {
            const Icon = useSearchResultIcon && config.SearchResultIcon || config.Icon;
            if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...props,
                size: size,
                shouldUseNewLogoDesign: true
            });
        }
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
const $6ae4bffafe6abebf$export$f73e324780005aef = ({ isShowMore: isShowMore, productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    if (isShowMore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "",
        size: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
    return $6ae4bffafe6abebf$export$fe03eddc92730a5c({
        productOrNounKey: productOrNounKey,
        size: size,
        isSelected: isSelected,
        ...props
    });
};
const $6ae4bffafe6abebf$export$fe03eddc92730a5c = ({ productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    let Icon;
    if (productOrNounKey) {
        const isNounFilter = (0, $4EMbH.isNounKey)(productOrNounKey);
        if (isNounFilter) Icon = (0, $4EMbH.nouns)[productOrNounKey].Icon;
        else {
            // First check if it's a Forge connector - prioritize dynamic API icons
            if ((0, $9d9t8.isForgeConnectorProductKey)(productOrNounKey)) {
                const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(productOrNounKey);
                if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
                return forgeIcon({
                    ...props,
                    size: size
                });
            }
            // Fallback to static products map (covers hardcoded Forge connectors and all other products)
            const productConfig = products[productOrNounKey];
            if (productConfig?.Icon) Icon = productConfig.Icon;
        }
        if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            ...props,
            size: size
        });
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        size: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
module.exports["ProductIcon"] = $6ae4bffafe6abebf$export$1a199e029d5e93d6;
module.exports["IconDecider"] = $6ae4bffafe6abebf$export$f73e324780005aef;
module.exports["ProductOrNounIcon"] = $6ae4bffafe6abebf$export$fe03eddc92730a5c;

});

parcelRegister("4EMbH", function(module, exports) {

var $lAFHW = parcelRequire("lAFHW");


var $9yyKc = parcelRequire("9yyKc");

/* custom-link-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $i7jPX = parcelRequire("i7jPX");

function $0ee2752244ba67e0$export$5efe8561ca252843({ size: size = 'medium', label: label = '', testId: testId }) {
    return(// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    /*#__PURE__*/ $42omo.createElement((0, $i7jPX.default), {
        label: label,
        size: size,
        isInset: false,
        backgroundColor: "white",
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        fill: "#dddee1",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#101214",
        fillRule: "evenodd",
        d: "M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75",
        clipRule: "evenodd"
    }))));
}



var $aXWIB = parcelRequire("aXWIB");

const $40bcb23b548b87bc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    webPage: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    },
    webPages: {
        id: "search-page.products.custom-websites",
        defaultMessage: "Web pages"
    },
    project: {
        id: "search-page.nouns.project",
        defaultMessage: "Project"
    },
    projects: {
        id: "search-page.nouns.projects",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.nouns.goal",
        defaultMessage: "Goal"
    },
    goals: {
        id: "search-page.nouns.goals",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.nouns.tag",
        defaultMessage: "Tag"
    },
    tags: {
        id: "search-page.nouns.tags",
        defaultMessage: "Tags"
    }
});


const $518be078bbe36df5$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    // tag: 'tag',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $518be078bbe36df5$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($518be078bbe36df5$export$a93cddd79e3ea530).includes(key);
};
const $518be078bbe36df5$export$5cb7c19fcb84c9cd = {
    [$518be078bbe36df5$export$a93cddd79e3ea530.project]: {
        displayName: (0, $40bcb23b548b87bc$export$defe85febe8b728c).project,
        displayNamePlural: (0, $40bcb23b548b87bc$export$defe85febe8b728c).projects,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ProjectsIcon), 'Project')
    },
    [$518be078bbe36df5$export$a93cddd79e3ea530.goal]: {
        displayName: (0, $40bcb23b548b87bc$export$defe85febe8b728c).goal,
        displayNamePlural: (0, $40bcb23b548b87bc$export$defe85febe8b728c).goals,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.GoalsIcon), 'Goal')
    },
    //Tag Noun has been omitted because it is not currently implemented in FPS and risks visual degradation with the t25 icon update
    //Discussion here: https://atlassian.slack.com/archives/C08HFJLM7J5/p1742856483784089
    // [NounKeys.tag]: {
    // 	displayName: messages.tag,
    // 	displayNamePlural: messages.tags,
    // 	Icon: RovoLogoFromLogo(HashtagIcon, 'Tag'),
    // },
    [$518be078bbe36df5$export$a93cddd79e3ea530.AtlassianWebCrawler]: {
        displayName: (0, $40bcb23b548b87bc$export$defe85febe8b728c).webPage,
        displayNamePlural: (0, $40bcb23b548b87bc$export$defe85febe8b728c).webPages,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $0ee2752244ba67e0$export$5efe8561ca252843), 'Atlassian Web Crawler')
    }
};
const $518be078bbe36df5$export$341b1567666c2663 = [
    $518be078bbe36df5$export$a93cddd79e3ea530.project,
    $518be078bbe36df5$export$a93cddd79e3ea530.goal,
    // NounKeys.tag,
    $518be078bbe36df5$export$a93cddd79e3ea530.AtlassianWebCrawler // Web Crawler is not a noun, we should improve this
];
module.exports["NounKeys"] = $518be078bbe36df5$export$a93cddd79e3ea530;
module.exports["isNounKey"] = $518be078bbe36df5$export$cc6a3ce6b37346b2;
module.exports["nouns"] = $518be078bbe36df5$export$5cb7c19fcb84c9cd;
module.exports["NOUNS_ORDER"] = $518be078bbe36df5$export$341b1567666c2663;

});

parcelRegister("9lW6K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $d2d3be1d2699235a$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $d2d3be1d2699235a$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $d2d3be1d2699235a$var$highlightRE = new RegExp(`${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}(.*?)${$d2d3be1d2699235a$var$HIGHLIGHT_END_TAG}.*`);
const $d2d3be1d2699235a$var$openingTagRE = new RegExp(`(.*?)${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}`);
const $d2d3be1d2699235a$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($d2d3be1d2699235a$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($d2d3be1d2699235a$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($d2d3be1d2699235a$var$highlightRE) || [];
        title = title.replace(`${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}${highlightText}${$d2d3be1d2699235a$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "strong",
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                as: "span",
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};
module.exports["enrichResultTitle"] = $d2d3be1d2699235a$export$c43ff622b37ceaa9;

});

parcelRegister("1VHLw", function(module, exports) {
/**
 * Returns true for middle-clicks (button === 1). Right-clicks are excluded to avoid
 * double-counting with onContextMenu.
 */ const $9456440de0859bb4$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};
module.exports["isAuxClick"] = $9456440de0859bb4$export$15213acd7ac7d39a;

});

parcelRegister("46mBC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");

/**
 * Explicitly OPT IN a non-1P product to cross-product URL wrapping.
 *
 * Use sparingly — most products that should be wrapped are expressible via
 * the 1P default rule. Typed loosely as `Record<string, true>` because, by
 * definition, these keys are not in {@link ProductKeys1P}.
 */ const $ffa8421a28e6e843$var$ADDITIONAL_WRAPPABLE_PRODUCTS = {
    goals: true,
    projects: true,
    loom: true,
    teams: true
};
/**
 * Explicitly OPT OUT a 1P product from cross-product URL wrapping.
 *
 * Typed against {@link ProductKeys1P} so a stale entry (e.g. after a 1P key
 * is removed from the master `ProductKeys1P` constant) fails the build.
 */ const $ffa8421a28e6e843$var$NON_WRAPPABLE_1P = {
};
const $ffa8421a28e6e843$export$4cf40959dee0db9c = (resultProduct)=>{
    if (resultProduct in $ffa8421a28e6e843$var$NON_WRAPPABLE_1P) return false;
    if (resultProduct in $ffa8421a28e6e843$var$ADDITIONAL_WRAPPABLE_PRODUCTS) return true;
    return (0, $b4tvS.is1pProductKey)(resultProduct);
};
const $ffa8421a28e6e843$export$8e7034cb7abd8b0f = {
    ADDITIONAL_WRAPPABLE_PRODUCTS: $ffa8421a28e6e843$var$ADDITIONAL_WRAPPABLE_PRODUCTS,
    NON_WRAPPABLE_1P: $ffa8421a28e6e843$var$NON_WRAPPABLE_1P
};
const $ffa8421a28e6e843$export$2a57f89490774c5c = (args)=>{
    const { bridge: bridge, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct } = args;
    // `useCrossProductUrlWrapper` requires a non-empty `product` string. When
    // `primaryProduct` is undefined the outer guard below short-circuits and
    // the wrapper is never invoked, so this fallback is only there to keep
    // the hook call legal.
    const wrapUrl = (0, $39XmP.default)({
        bridge: bridge,
        product: primaryProduct ?? 'unknown',
        subProduct: primarySubProduct || undefined
    });
    const isEnabled = (0, $dh538.fg)('rovo_search_cross_product_url_wrapping');
    return (0, $42omo.useMemo)(()=>(url, resultProduct)=>{
            if (!isEnabled || !url || !primaryProduct || !resultProduct) return url;
            if (!$ffa8421a28e6e843$export$4cf40959dee0db9c(resultProduct)) return url;
            if (resultProduct === primaryProduct) return url;
            return wrapUrl(url);
        }, [
        wrapUrl,
        primaryProduct,
        isEnabled
    ]);
};
module.exports["useSearchCrossProductUrlWrapper"] = $ffa8421a28e6e843$export$2a57f89490774c5c;

});

parcelRegister("jAenQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fpGTa = parcelRequire("fpGTa");


var $7WbA8 = parcelRequire("7WbA8");

const $5c2811b97c7b9fe1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { onNavigate: onNavigate } = (0, $7WbA8.useAppContext)();
    const { href: href, onClick: originalOnClick } = props;
    const onClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        originalOnClick?.(event, analyticsEvent);
        // Use onNavigate if
        // - alwaysUseOnLinkClick is true
        // - navigating to the same site and not new tab/window
        const metaPressed = event.ctrlKey || event.metaKey || event.shiftKey;
        const sameOrigin = window.location.origin === new URL(href).origin;
        const onNavigateOverride = typeof onNavigate === 'object' ? onNavigate.options.alwaysUseOnLinkClick : false;
        const useOnNavigate = onNavigateOverride || sameOrigin && !metaPressed;
        if (useOnNavigate) {
            event.preventDefault();
            // Handles SPA navigation if consumer provides their own onNavigate
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(href, 'push');
        }
    }, [
        href,
        onNavigate,
        originalOnClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        ref: ref,
        ...props,
        onClick: onClick
    });
});
module.exports["Link"] = $5c2811b97c7b9fe1$export$a6c7ac8248d6e38a;

});

parcelRegister("a7nUd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $1yEFx = parcelRequire("1yEFx");


var $gpC9w = parcelRequire("gpC9w");


var $h7sRY = parcelRequire("h7sRY");


var $mdlgz = parcelRequire("mdlgz");


var $gCEkV = parcelRequire("gCEkV");

const $d8124c60cf01e764$var$socialMetadataStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050'
});
const $d8124c60cf01e764$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $d8124c60cf01e764$var$subheadingLeftAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden'
});
const $d8124c60cf01e764$var$inlineStyles = (0, $ecnYn.xcss)({
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$hiddenReferenceInlineStyles = (0, $ecnYn.xcss)({
    flex: '1 0 auto',
    visibility: 'hidden',
    position: 'relative',
    zIndex: '1',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$metadataItemStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
        key: key
    }, value, spacer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $mdlgz.Spacer), null));
};
const $d8124c60cf01e764$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $d8124c60cf01e764$var$renderSocialMetadata = (defaultSocialParts)=>{
    const socialSignalIndex = defaultSocialParts.findIndex((item)=>Array.isArray(item) && item[1] === 'social-signal');
    const hasBreadcrumb = socialSignalIndex !== -1;
    const parts = defaultSocialParts.filter((_, index)=>index !== socialSignalIndex).filter($d8124c60cf01e764$var$filterPart);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        xcss: $d8124c60cf01e764$var$socialMetadataStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, parts?.map((m)=>$d8124c60cf01e764$var$renderParts(m, false)))), hasBreadcrumb && defaultSocialParts[defaultSocialParts.length - 1]);
};
const $d8124c60cf01e764$var$SearchMetadataWithOverflowObserver = ({ metadataItems: metadataItems, searchResultId: searchResultId, containerRef: containerRef })=>{
    const headerMetadataWithIds = metadataItems.map((item, index)=>{
        const prefix = searchResultId || 'default';
        return {
            id: `metadata-${prefix}-${index}`,
            content: item
        };
    });
    const headerMetadataRefs = (0, $42omo.useRef)([]);
    headerMetadataRefs.current = headerMetadataWithIds.map((_, i)=>headerMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    const visibleItems = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: headerMetadataRefs,
        itemIds: headerMetadataWithIds.map((item)=>item.id)
    });
    const hasHiddenItems = headerMetadataWithIds.length > visibleItems.length;
    const processVisibleItems = ()=>{
        const visibleMetadata = headerMetadataWithIds.filter((item)=>visibleItems.includes(item.id));
        // If we have hidden items, remove spacer from last visible item
        if (hasHiddenItems && visibleMetadata.length > 0) {
            const lastIndex = visibleMetadata.length - 1;
            visibleMetadata[lastIndex] = {
                ...visibleMetadata[lastIndex],
                content: (0, $gpC9w.filterSpacer)(visibleMetadata[lastIndex].content)
            };
        }
        return visibleMetadata;
    };
    const processedVisibleItems = processVisibleItems();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $d8124c60cf01e764$var$subheadingLeftAreaStyles,
            $d8124c60cf01e764$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: [
            $d8124c60cf01e764$var$hiddenReferenceInlineStyles
        ],
        testId: "search-page-result-metadata-hidden"
    }, headerMetadataWithIds.map((item, index)=>{
        const elementId = `reference:${item.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            key: elementId,
            id: elementId,
            ref: headerMetadataRefs.current[index],
            xcss: $d8124c60cf01e764$var$metadataItemStyles
        }, item.content);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: [
            $d8124c60cf01e764$var$inlineStyles
        ],
        testId: "search-page-result-metadata-visible"
    }, processedVisibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            key: `visible-${item.id}`,
            xcss: $d8124c60cf01e764$var$metadataItemStyles
        }, item.content)), hasHiddenItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h7sRY.MetadataPopupButton), {
        metadata: headerMetadataWithIds.filter((item)=>!visibleItems.includes(item.id)).map((item)=>item.content),
        isFirstElement: processedVisibleItems.length === 0
    })));
};
const $d8124c60cf01e764$export$8e7fb1f8fe599124 = ({ searchResultId: searchResultId, product: product, productSelected: productSelected, parts: defaultParts = [], socialParts: defaultSocialParts = [], displaySpacer: displaySpacer = true, containerRef: containerRef })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    // TODO: Shouldn't need to cast here, need to clean up the stack above this to not pass string around as product
    // Product name is hidden when productSelected=true (i.e. a specific app is selected)
    const productDisplayName = !product || productSelected ? '' : products[product]?.displayName || '';
    const parts = defaultParts.filter($d8124c60cf01e764$var$filterPart);
    const hasSocialParts = defaultSocialParts.filter($d8124c60cf01e764$var$filterPart).length > 0;
    if (hasSocialParts) parts.push([
        'social-metadata',
        $d8124c60cf01e764$var$renderSocialMetadata(defaultSocialParts)
    ]);
    if (productDisplayName) parts.unshift([
        'product-display-name',
        productDisplayName
    ]);
    const metadataItems = parts.map((m, i)=>$d8124c60cf01e764$var$renderParts(m, displaySpacer && i < parts.length - 1));
    // If we don't have a containerRef, we don't want to use the overflow observer
    return containerRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8124c60cf01e764$var$SearchMetadataWithOverflowObserver, {
        metadataItems: metadataItems,
        searchResultId: searchResultId,
        containerRef: containerRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, metadataItems);
};
module.exports["SearchMetadata"] = $d8124c60cf01e764$export$8e7fb1f8fe599124;

});

parcelRegister("gpC9w", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $42omo = parcelRequire("42omo");

const $99c74e00bcd0e3ac$export$325faed136549eaf = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return node;
    // Check if element is a Spacer component
    if (typeof node.type === 'function' && node.type.IS_METADATA_SPACER) return null;
    // If the element has children, filter out spacers
    if (node.props.children) {
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(node.props.children);
        const filteredChildren = children.filter((child)=>!/*#__PURE__*/ ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) && typeof child.type === 'function' && child.type.IS_METADATA_SPACER));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(node, node.props, ...filteredChildren);
    }
    return node;
};
module.exports["filterSpacer"] = $99c74e00bcd0e3ac$export$325faed136549eaf;

});

parcelRegister("h7sRY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $gpC9w = parcelRequire("gpC9w");

const $7ee3c09784cf4e4a$var$popupContentContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    padding: 'space.200',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'space.100',
    borderRadius: 'radius.small',
    background: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $7ee3c09784cf4e4a$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $7ee3c09784cf4e4a$var$iconButtonContainerStyles = (0, $ecnYn.xcss)({
    margin: 'space.025',
    marginLeft: 'space.075',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $7ee3c09784cf4e4a$var$iconButtonContainerIsFirstElementStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025'
});
const $7ee3c09784cf4e4a$export$b31e3e19fb9e4d37 = ({ metadata: metadata, isFirstElement: isFirstElement })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $7ee3c09784cf4e4a$var$popupContentContainerStyles,
                    $7ee3c09784cf4e4a$var$subheadingStyles
                ]
            }, metadata.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    key: index
                }, (0, $gpC9w.filterSpacer)(item)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $7ee3c09784cf4e4a$var$iconButtonContainerStyles,
                    isFirstElement && $7ee3c09784cf4e4a$var$iconButtonContainerIsFirstElementStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: "More"
            }))
    });
};
module.exports["MetadataPopupButton"] = $7ee3c09784cf4e4a$export$b31e3e19fb9e4d37;

});

parcelRegister("mdlgz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $20801d48939844b3$var$metadataSpacerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $20801d48939844b3$export$d7a54cba636a8cd6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "span",
        xcss: $20801d48939844b3$var$metadataSpacerStyles
    }, "\u2022");
$20801d48939844b3$export$d7a54cba636a8cd6.IS_METADATA_SPACER = true;
module.exports["Spacer"] = $20801d48939844b3$export$d7a54cba636a8cd6;

});

parcelRegister("gCEkV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $36ce85b8deff1c0a$export$c376cfef3a1f950d = ({ containerRef: containerRef, itemRefs: itemRefs, itemIds: itemIds, alwaysVisibleRef: alwaysVisibleRef })=>{
    const observerRef = (0, $42omo.useRef)(null);
    const [visibleItems, setVisibleItems] = (0, $42omo.useState)(itemIds);
    const rightNavWidth = alwaysVisibleRef ? alwaysVisibleRef.current?.offsetWidth ?? 80 : 0;
    const rootMargin = `0px -${rightNavWidth}px 0px 0px`;
    (0, $42omo.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                const targetId = target.getAttribute('id');
                const isReferenceElement = targetId?.startsWith('reference:');
                if (isReferenceElement && targetId) {
                    const elementId = targetId.split('reference:')[1];
                    // Set visibility for corresponding target element from reference element id
                    if (entry.isIntersecting) setVisibleItems((prev)=>[
                            ...prev.filter((id)=>id !== elementId),
                            elementId
                        ]);
                    else setVisibleItems((prev)=>prev.filter((id)=>id !== elementId));
                }
            });
        }, {
            root: containerRef.current,
            rootMargin: rootMargin,
            threshold: 0.99
        });
        observerRef.current = observer;
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        rootMargin
    ]);
    (0, $42omo.useEffect)(()=>{
        const observer = observerRef.current;
        if (!observer) return;
        itemRefs.current.forEach((itemRef)=>{
            if (itemRef?.current) observer.observe(itemRef.current);
        });
    }, [
        itemRefs,
        itemIds
    ]);
    return visibleItems;
};
module.exports["useOverflowObserver"] = $36ce85b8deff1c0a$export$c376cfef3a1f950d;

});

parcelRegister("kXlQy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $gzcCN = parcelRequire("gzcCN");


var $cORSX = parcelRequire("cORSX");

const $5966da29ebb2ee73$export$95cacd63dfd98bee = ({ type: type, defaultMessage: defaultMessage = null, subtype: subtype })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const message = (0, $cORSX.messages)[type];
    const isLiveDoc = subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    if (!message) return defaultMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isLiveDoc ? formatMessage((0, $cORSX.messages).liveDoc) : formatMessage(message));
};
const $5966da29ebb2ee73$export$446974e6d8045139 = (type)=>{
    if (!type || !(0, $cORSX.messages)[type]) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5966da29ebb2ee73$export$95cacd63dfd98bee, {
        type: type
    });
};
module.exports["SearchResultType"] = $5966da29ebb2ee73$export$95cacd63dfd98bee;
module.exports["getSearchResultType"] = $5966da29ebb2ee73$export$446974e6d8045139;

});

parcelRegister("cORSX", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $166784a2a3778ef6$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "search_result_type_page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "search_result_type_blogpost",
        defaultMessage: "Blog Post"
    },
    whiteboard: {
        id: "search_result_type_whiteboard",
        defaultMessage: "Whiteboard"
    },
    slide: {
        id: "search_result_type_slide",
        defaultMessage: "Slides"
    },
    database: {
        id: "search_result_type_database",
        defaultMessage: "Database"
    },
    space: {
        id: "search_result_type_space",
        defaultMessage: "Space"
    },
    attachment: {
        id: "search_result_type_attachment",
        defaultMessage: "Attachment"
    },
    comment: {
        id: "search_result_type_comment",
        defaultMessage: "Comment"
    },
    folder: {
        id: "search_result_type_folder",
        defaultMessage: "Folder"
    },
    calendar: {
        id: "search_result_type_calendar",
        defaultMessage: "Calendar"
    },
    space_calendar: {
        // snake_case returned by the API
        id: "search_result_type_space_calendar",
        defaultMessage: "Space calendar"
    },
    question: {
        id: "search_result_type_question",
        defaultMessage: "Question"
    },
    answer: {
        id: "search_result_type_answer",
        defaultMessage: "Answer"
    },
    embed: {
        id: "search_result_type_embed",
        defaultMessage: "Smart Link"
    },
    board: {
        id: "search_result_type_board",
        defaultMessage: "Board"
    },
    dashboard: {
        id: "search_result_type_dashboard",
        defaultMessage: "Dashboard"
    },
    filter: {
        id: "search_result_type_filter",
        defaultMessage: "Filter"
    },
    issue: {
        id: "search_result_type_issue",
        defaultMessage: "Work item"
    },
    plan: {
        id: "search_result_type_plan",
        defaultMessage: "Plan"
    },
    project: {
        id: "search_result_type_project",
        defaultMessage: "Project"
    },
    goal: {
        id: "search_result_type_goal",
        defaultMessage: "Goal"
    },
    tag: {
        id: "search_result_type_tag",
        defaultMessage: "Tag"
    },
    learning: {
        id: "search_result_type_learning",
        defaultMessage: "Learning"
    },
    unrecognised: {
        id: "search_result_type_unrecognised",
        defaultMessage: "Unrecognised"
    },
    document: {
        id: "search_result_type_document",
        defaultMessage: "Document"
    },
    spreadsheet: {
        id: "search_result_type_spreadsheet",
        defaultMessage: "Spreadsheet"
    },
    presentation: {
        id: "search_result_type_presentation",
        defaultMessage: "Presentation"
    },
    'sharepoint-document': {
        id: "search_result_type_sharepoint_document",
        defaultMessage: "Sharepoint Document"
    },
    message: {
        id: "search_result_type_message",
        defaultMessage: "Message"
    },
    repository: {
        id: "search_result_type_repository",
        defaultMessage: "Repository"
    },
    'pull-request': {
        id: "search_result_type_pull_request",
        defaultMessage: "Pull Request"
    },
    commit: {
        id: "search_result_type_commit",
        defaultMessage: "Commit"
    },
    branch: {
        id: "search_result_type_branch",
        defaultMessage: "Branch"
    },
    file: {
        id: "search_result_type_file",
        defaultMessage: "File"
    },
    channel: {
        id: "search_result_type_channel",
        defaultMessage: "Channel"
    },
    component: {
        id: "search_result_type_component",
        defaultMessage: "Component"
    },
    'work-item': {
        id: "search_result_type_work_item",
        defaultMessage: "Work Item"
    },
    card: {
        id: "search_result_type_card",
        defaultMessage: "Card"
    },
    incident: {
        id: "search_result_type_incident",
        defaultMessage: "Incident"
    },
    focus_area: {
        id: "search_result_type_focus_area",
        defaultMessage: "Focus area"
    },
    focus_area_status_update: {
        id: "search_result_type_focus_area_status_update",
        defaultMessage: "Focus area update"
    },
    ask: {
        id: "search_result_type_ask",
        defaultMessage: "Ask"
    },
    email: {
        id: "search_result_type_email",
        defaultMessage: "Email"
    },
    gliffy: {
        id: "search_result_type_gliffy",
        defaultMessage: "Gliffy Diagram"
    },
    deal: {
        id: "search_result_type_deal",
        defaultMessage: "Deal"
    },
    'customer-org': {
        id: "search_result_type_customer_org",
        defaultMessage: "Customer Organization"
    },
    'data-table': {
        id: "search_result_type_data_table",
        defaultMessage: "Data table"
    },
    'customer-contact': {
        id: "search_result_type_customer_contact",
        defaultMessage: "Customer contact"
    },
    object: {
        id: "search_result_type_object",
        defaultMessage: "Object"
    },
    schema: {
        id: "search_result_type_schema",
        defaultMessage: "Schema"
    },
    type: {
        id: "search_result_type_type",
        defaultMessage: "Object type"
    },
    position: {
        id: "search_result_type_position",
        defaultMessage: "Position"
    },
    video: {
        id: "search_result_type_video",
        defaultMessage: "Video"
    },
    task: {
        id: "search_result_type_task",
        defaultMessage: "Task"
    },
    epic: {
        id: "search_result_type_epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search_result_type_bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search_result_type_story",
        defaultMessage: "Story"
    },
    'sub-task': {
        id: "search_result_type_sub_task",
        defaultMessage: "Sub-task"
    },
    subtask: {
        id: "search_result_type_subtask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "search_result_type_improvement",
        defaultMessage: "Improvement"
    },
    'new feature': {
        id: "search_result_type_new_feature",
        defaultMessage: "New feature"
    },
    change: {
        id: "search_result_type_change",
        defaultMessage: "Change"
    },
    problem: {
        id: "search_result_type_problem",
        defaultMessage: "Problem"
    },
    'service request': {
        id: "search_result_type_service_request",
        defaultMessage: "Service request"
    }
});
module.exports["messages"] = $166784a2a3778ef6$export$defe85febe8b728c;

});

parcelRegister("4Chrd", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $a109b171cfb70082$export$b697429ad83cc9eb = (thirdPartyConfigs, providerId)=>{
    if (!thirdPartyConfigs || !providerId) return undefined;
    // Find by providerId (dynamic API adds this field to configs, even for static Forge connectors)
    const [product] = Object.entries(thirdPartyConfigs).find(([, config])=>config?.providerId === providerId) || [];
    // Ensure the product is in our defined set or is a Forge connector so we can cast it safely
    if (product && !(0, $b4tvS.all3pProductKeys).includes(product) && !(0, $9d9t8.isForgeConnectorProductKey)(product)) return undefined;
    return product ? product : undefined;
};
module.exports["getProductFromProviderId"] = $a109b171cfb70082$export$b697429ad83cc9eb;

});

parcelRegister("2vU0F", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8f7cbfaf49d968e0$var$pullRequestStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    MERGED: 'success',
    // green
    DECLINED: 'danger',
    // red
    DRAFT: 'neutral' // grey
};
const $8f7cbfaf49d968e0$export$2e2105095afb1fad = (status)=>$8f7cbfaf49d968e0$var$pullRequestStatusToLozengeMap[status] ?? 'neutral';
const $8f7cbfaf49d968e0$export$43932e794c008e49 = (0, $aXWIB.defineMessages)({
    status_open: {
        id: "search-pull-request-result.status.open",
        defaultMessage: "Open"
    },
    status_merged: {
        id: "search-pull-request-result.status.merged",
        defaultMessage: "Merged"
    },
    status_declined: {
        id: "search-pull-request-result.status.declined",
        defaultMessage: "Declined"
    },
    status_draft: {
        id: "search-pull-request-result.status.draft",
        defaultMessage: "Draft"
    },
    status_unknown: {
        id: "search-pull-request-result.status.unknown",
        defaultMessage: "Unknown"
    }
});
const $8f7cbfaf49d968e0$export$d8a08f59b3eb7920 = {
    OPEN: $8f7cbfaf49d968e0$export$43932e794c008e49.status_open,
    MERGED: $8f7cbfaf49d968e0$export$43932e794c008e49.status_merged,
    DECLINED: $8f7cbfaf49d968e0$export$43932e794c008e49.status_declined,
    DRAFT: $8f7cbfaf49d968e0$export$43932e794c008e49.status_draft,
    UNKNOWN: $8f7cbfaf49d968e0$export$43932e794c008e49.status_unknown
};
const $8f7cbfaf49d968e0$export$348ea44fc966c8f3 = (status)=>(status && $8f7cbfaf49d968e0$export$d8a08f59b3eb7920[status]) ?? $8f7cbfaf49d968e0$export$43932e794c008e49.status_unknown;
module.exports["getPullRequestStatusAppearance"] = $8f7cbfaf49d968e0$export$2e2105095afb1fad;
module.exports["pullRequestStatusMessages"] = $8f7cbfaf49d968e0$export$43932e794c008e49;
module.exports["getPullRequestStatusMessage"] = $8f7cbfaf49d968e0$export$348ea44fc966c8f3;

});

parcelRegister("1nJM3", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $bg4YX = parcelRequire("bg4YX");

const $ee0af2ae8a3f715b$export$2804e03de329c539 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, failSection: failSection })=>{
    return {
        eventType: 'track',
        source: failSection,
        actionSubject: 'searchPageErrorBoundary',
        action: 'failed',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};



var $3CshZ = parcelRequire("3CshZ");


var $f8oYd = parcelRequire("f8oYd");


const $58d4b2eeaa52f5f4$export$e926676385687eaf = ({ children: children, fallback: fallback, renderWithErrorInfo: renderWithErrorInfo, section: section, onException: customOnException, setErrorBoundaryResetCb: setErrorBoundaryResetCb })=>{
    const logException = (0, $f8oYd.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const onException = (0, $42omo.useCallback)((error)=>{
        fireAnalyticsEvent((0, $ee0af2ae8a3f715b$export$2804e03de329c539)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            failSection: section
        }));
        logException(error);
        // Call custom handler if provided
        customOnException?.(error);
    }, [
        logException,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        section,
        customOnException
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bg4YX.ErrorBoundary), {
        fallback: fallback,
        renderWithErrorInfo: renderWithErrorInfo,
        onException: onException,
        setErrorBoundaryResetCb: setErrorBoundaryResetCb
    }, children);
};
module.exports["ErrorBoundary"] = $58d4b2eeaa52f5f4$export$e926676385687eaf;

});

parcelRegister("f8oYd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j4ply = parcelRequire("j4ply");


var $7Evbj = parcelRequire("7Evbj");

const $ef865eddba22b4a1$export$67ff3bc9583d7c16 = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    // Store data required for logging exceptions in refs to prevent re-renders
    return (0, $42omo.useCallback)(async (error)=>await (0, $7Evbj.logException)(error, user?.id, primaryProduct), [
        primaryProduct,
        user?.id
    ]);
};
module.exports["useLogException"] = $ef865eddba22b4a1$export$67ff3bc9583d7c16;

});

parcelRegister("4VkIo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9rRKJ = parcelRequire("9rRKJ");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $8uOED = parcelRequire("8uOED");

const $9dfab17f37eb0047$export$e90e90fddddd8154 = ({ experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE })=>{
    const [search] = (0, $djVCD.useSearch)();
    const [selectedDatasource] = (0, $djVCD.useSelectedDatasource)();
    const [{ products: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const currentUserId = (0, $j4ply.useCurrentUserId)();
    const { filters: filters, selectedProducts: selectedProducts, jsmIncidentFilterIds: jsmIncidentFilterIds } = search;
    return (0, $42omo.useMemo)(()=>{
        return (0, $8uOED.getSelectedFilters)({
            filters: filters,
            selectedProducts: selectedProducts,
            selectedDatasource: selectedDatasource,
            availableProducts: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            thirdPartyConfigs: thirdPartyConfigs,
            jsmIncidentFilterIds: jsmIncidentFilterIds,
            experience: experience,
            currentUserId: currentUserId
        });
    }, [
        filters,
        selectedProducts,
        selectedDatasource,
        products,
        allFilterExcludedProducts,
        thirdPartyConfigs,
        jsmIncidentFilterIds,
        experience,
        currentUserId
    ]);
};
module.exports["useSelectedFilters"] = $9dfab17f37eb0047$export$e90e90fddddd8154;

});

parcelRegister("8uOED", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gHaxX = parcelRequire("gHaxX");


var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");


var $dOOW1 = parcelRequire("dOOW1");

const $e43dba4dbad73dd8$export$68a801b7b3c0bfaa = ({ selectedProducts: selectedProducts, availableProducts: availableProducts })=>{
    const selectedProduct = selectedProducts?.[0];
    const filteredProducts = selectedProduct ? [
        selectedProduct
    ] : availableProducts;
    return {
        selectedProduct: selectedProduct,
        filteredProducts: filteredProducts,
        availableProducts: availableProducts
    };
};



var $b4tDU = parcelRequire("b4tDU");


var $922yL = parcelRequire("922yL");

var $dWCFT = parcelRequire("dWCFT");

var $ksiqf = parcelRequire("ksiqf");

/**
 * Calendar date in the user's local timezone as YYYY-MM-DD (matches backend
 * {@code ContentSearcherQueryHelper#buildSalesforceCloseDateQuery} contract).
 */ function $b37f0c8d7075360a$var$toYmdLocal(d) {
    return (0, $dWCFT.default)(d, 'yyyy-MM-dd');
}
function $b37f0c8d7075360a$var$startOfTodayLocal() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}
const $b37f0c8d7075360a$var$ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function $b37f0c8d7075360a$export$63976aebd4b36830(selectedOption, customIsoDate) {
    if (!selectedOption || selectedOption === 'anytime') return undefined;
    if (selectedOption === 'custom') {
        if (!customIsoDate || !$b37f0c8d7075360a$var$ISO_DATE.test(customIsoDate)) return undefined;
        return customIsoDate;
    }
    const today = $b37f0c8d7075360a$var$startOfTodayLocal();
    const tomorrow = (0, $922yL.default)(today, 1);
    switch(selectedOption){
        case 'today':
            return $b37f0c8d7075360a$var$toYmdLocal(today);
        case 'last7days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 6))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'last30days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 29))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'last90days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 89))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'last365days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 364))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'next7days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 7))}`;
        case 'next30days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 30))}`;
        case 'next90days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 90))}`;
        case 'next365days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 365))}`;
        default:
            // Already-resolved ISO single date or range (e.g. restored from URL)
            if ($b37f0c8d7075360a$var$ISO_DATE.test(selectedOption)) return selectedOption;
            if (/^\d{4}-\d{2}-\d{2}:\d{4}-\d{2}-\d{2}$/.test(selectedOption)) return selectedOption;
            return undefined;
    }
}


/**
 * Lightweight filter ID constants extracted from individual filter modules.
 *
 * These are simple string constants with zero transitive dependencies.
 * Use these instead of importing from the filter barrel file (index.tsx)
 * when you only need the filter ID for keying into a filters record.
 *
 * QS-9423: Breaking the dependency chain that dragged react-sweet-state
 * into the SSR bundle via filter barrel → filter controllers → search store.
 */ const $73b3163876151519$export$741d3c5ff1600fc4 = 'archived';
const $73b3163876151519$export$98981f5c8dc7607d = 'compassArchived';
const $73b3163876151519$export$798f70d5ba74d109 = 'assetsSchema';
const $73b3163876151519$export$51661d1a93f29640 = 'assetsType';
const $73b3163876151519$export$9c1e246329cdf939 = 'assignee';
const $73b3163876151519$export$e32111e9166eaf89 = 'closeDate';
const $73b3163876151519$export$9af0987cf592f533 = 'commentedByMe';
const $73b3163876151519$export$6a3fc832c5c25c7d = 'content';
const $73b3163876151519$export$e03d97f0eaa66910 = 'contributor';
const $73b3163876151519$export$9ab819519540cfb4 = 'createdBy';
const $73b3163876151519$export$cd646dbb07979a8d = 'focusAreaType';
const $73b3163876151519$export$2678e5eb1f9db396 = 'focusAreaUnder';
const $73b3163876151519$export$623d400c5f880682 = 'label';
const $73b3163876151519$export$7ecf570078da6b1c = 'lastUpdatedBy';
const $73b3163876151519$export$11e1218ac07ed03e = 'lastUpdated';
const $73b3163876151519$export$68c1310fa8b7db62 = 'campaignStatus';
const $73b3163876151519$export$6598f3f01335d547 = 'caseStatus';
const $73b3163876151519$export$4febaaf9b7a72ca9 = 'opportunityStatus';
const $73b3163876151519$export$c21586a37554cc74 = 'pullRequestStatus';
const $73b3163876151519$export$2e6de80282206ac4 = 'repository';
const $73b3163876151519$export$f42198825b45f0bf = 'owner';
const $73b3163876151519$export$bcfaf48394705893 = 'pageStatus';
const $73b3163876151519$export$713c4dadb56593e7 = 'positionEmploymentType';
const $73b3163876151519$export$d87a0f934d4a8c3c = 'positionFocusArea';
const $73b3163876151519$export$19dab386a6b200ee = 'positionJobFamily';
const $73b3163876151519$export$f75b5006a4fc44bc = 'positionStatus';
const $73b3163876151519$export$4c1df8b2cfbc878 = 'positionTeam';
const $73b3163876151519$export$9e360b05ef07f438 = 'project';
const $73b3163876151519$export$58bc8a3e7def8aea = 'reporter';
const $73b3163876151519$export$3515d33a163cbcb3 = 'salesforceStage';
const $73b3163876151519$export$4f9240015ff0684c = 'sort';
const $73b3163876151519$export$3a6305d8320c16a4 = 'space';
const $73b3163876151519$export$2a46d5fba7ab443f = 'statusFilter';
const $73b3163876151519$export$89b94a9f6bd9eece = 'onlyTitleMatch';
const $73b3163876151519$export$b698e15dd0654a6b = 'verified';
const $73b3163876151519$export$883e178bcc42a97b = 'watchedByMe';
const $73b3163876151519$export$26517625dab3ad98 = 'slackChannel';
const $73b3163876151519$export$4d0145e3d3f3e249 = 'hasAttachment';



var $5iakG = parcelRequire("5iakG");


var $jyecU = parcelRequire("jyecU");

const $a24d078566cd43b5$export$a50dff3bb8b597ca = ({ availableProducts: availableProducts, filters: filters, selectedProducts: selectedProducts, allFilterExcludedProducts: allFilterExcludedProducts }, { thirdPartyConfigs: thirdPartyConfigs })=>{
    // Filter out excluded products from "All" filter
    const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
    const productsToSearch = selectedProducts[0] ? [
        selectedProducts[0]
    ] : allFilterIncludedProducts;
    const typeFilter = filters[0, $5iakG.universalTypeFilterId];
    return (0, $jyecU.getUniversalTypeEntities)(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts);
};



var $gY9AU = parcelRequire("gY9AU");

const $5f15807d66c8b2dc$export$f6546bb98204a0ca = ({ filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, availableProducts: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds, experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE })=>{
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $e43dba4dbad73dd8$export$68a801b7b3c0bfaa)({
        selectedProducts: selectedProducts,
        availableProducts: products
    });
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedTypes: selectedTypes } = (0, $a24d078566cd43b5$export$a50dff3bb8b597ca)({
        availableProducts: availableProducts,
        filters: filters,
        selectedProducts: selectedProducts,
        allFilterExcludedProducts: allFilterExcludedProducts
    }, {
        thirdPartyConfigs: thirdPartyConfigs
    });
    const watchedByMeValue = (0, $gY9AU.getBooleanFilterValue)(filters[0, $73b3163876151519$export$883e178bcc42a97b]);
    const titleMatchValue = (0, $gY9AU.getBooleanFilterValue)(filters[0, $73b3163876151519$export$89b94a9f6bd9eece]);
    const selectedDateRange = (0, $gY9AU.getSelectedDateRange)(filters[0, $73b3163876151519$export$11e1218ac07ed03e]);
    const filterDateRange = (0, $gY9AU.getFilterDateRange)(filters[0, $73b3163876151519$export$11e1218ac07ed03e]);
    const commonContributors = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$e03d97f0eaa66910]).length ? (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$e03d97f0eaa66910]) : undefined;
    const pageStatusValue = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$bcfaf48394705893])[0];
    const assigneeARIValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$9c1e246329cdf939]).map((assigneeId)=>{
        return `ari:cloud:identity::user/${assigneeId}`;
    });
    const reporterARIValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$58bc8a3e7def8aea]).map((reporterId)=>{
        return `ari:cloud:identity::user/${reporterId}`;
    });
    const watcherARIValues = (watchedByMeValue && currentUserId ? [
        currentUserId
    ] : []).map((watcherId)=>{
        return `ari:cloud:identity::user/${watcherId}`;
    });
    const commenterARIValues = (0, $gY9AU.getBooleanFilterValue)(filters[0, $73b3163876151519$export$9af0987cf592f533]) && currentUserId ? [
        `ari:cloud:identity::user/${currentUserId}`
    ] : [];
    const assignee3PValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$9c1e246329cdf939]).map((assigneeId)=>{
        if (assigneeId.startsWith('ari:cloud:')) return (0, $gHaxX.IdentityUserAri).parse(assigneeId).resourceId;
        return assigneeId;
    });
    const isSelectedThirdPartyProduct = !!selectedProduct && (0, $b4tvS.is3pProductKey)(selectedProduct);
    const selectedSpaceValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$3a6305d8320c16a4]);
    const selectedContentValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$6a3fc832c5c25c7d]);
    const confluenceOnlyValues = (values)=>isSelectedThirdPartyProduct ? [] : values;
    const thirdPartySpaceValues = selectedProduct === (0, $b4tvS.ProductKeys).GoogleDrive || selectedProduct === (0, $b4tvS.ProductKeys).Sharepoint ? selectedSpaceValues : [];
    const thirdPartyContentValues = isSelectedThirdPartyProduct ? selectedContentValues : [];
    const containerAris = [
        ...(0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$9e360b05ef07f438])
    ];
    const createdByValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$9ab819519540cfb4]);
    const labelsValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$623d400c5f880682]);
    const lastUpdatedByValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$7ecf570078da6b1c]);
    // When both the primary (space) and dependent (contentUnder) filters are selected, the backend
    // treats ancestorAris with OR logic, which would incorrectly broaden results.
    // Prefer the dependent filter when present since it is more specific; otherwise fall back to
    // the primary filter. The store handles the reverse: when the primary filter is selected after
    // the dependent, it clears the dependent so only the primary is sent.
    const ancestorAris = thirdPartyContentValues.length > 0 ? thirdPartyContentValues : thirdPartySpaceValues;
    const ownerValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$f42198825b45f0bf]);
    const opportunityStatusValue = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$4febaaf9b7a72ca9])[0];
    const pullRequestStatusValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$c21586a37554cc74]);
    const repositoryValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$2e6de80282206ac4]);
    const campaignStatusValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$68c1310fa8b7db62]);
    const caseStatusValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$6598f3f01335d547]);
    const salesforceStageValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$3515d33a163cbcb3]);
    const slackChannelValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$26517625dab3ad98]);
    const hasAttachmentValue = (0, $gY9AU.getBooleanFilterValue)(filters[0, $73b3163876151519$export$4d0145e3d3f3e249]);
    const sortFilters = (0, $gY9AU.getSortFilters)(filters[0, $73b3163876151519$export$4f9240015ff0684c]);
    // Get close date value for Salesforce filter
    const closeDateFilterState = filters[0, $73b3163876151519$export$e32111e9166eaf89];
    const closeDateSelectedOption = (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$e32111e9166eaf89])[0];
    const closeDateCustomValue = closeDateFilterState && 'customValue' in closeDateFilterState && closeDateFilterState.customValue ? closeDateFilterState.customValue.closeDateVal : undefined;
    const salesforceCloseDate = (0, $b37f0c8d7075360a$export$63976aebd4b36830)(closeDateSelectedOption, closeDateSelectedOption === 'custom' ? closeDateCustomValue : undefined);
    const isAllProductsSelected = (0, $b4tDU.isAllProductSearch)(selectedProducts);
    const selectedFilters = {
        commonFilters: {
            range: {
                lastModified: selectedDateRange
            },
            contributorsFilter: commonContributors
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$9e360b05ef07f438]), selectedProduct),
                watcherARIs: (0, $gY9AU.omitNonJiraFilterValues)(watcherARIValues, selectedProduct),
                assigneeARIs: (0, $gY9AU.omitNonJiraFilterValues)(assigneeARIValues, selectedProduct),
                issueTypeIDs: jsmIncidentFilterIds,
                issueLabels: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$623d400c5f880682]), selectedProduct),
                statusCategories: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getJiraIssueStatusFilterOptions)(filters[0, $73b3163876151519$export$2a46d5fba7ab443f]), selectedProduct),
                reporterARIs: (0, $gY9AU.omitNonJiraFilterValues)(reporterARIValues, selectedProduct),
                commenterARIs: (0, $gY9AU.omitNonJiraFilterValues)(commenterARIValues, selectedProduct),
                ...(0, $dh538.fg)('rovo_jira_work_type') ? {
                    issueTypes: (0, $gY9AU.getSelectedJiraWorkType)(selectedTypes, selectedProduct)
                } : {}
            },
            projectFilter: {
                projectTypes: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? [] : (0, $gY9AU.getJiraProjectFilter)(selectedProduct)
            }
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: (0, $dh538.fg)('assets_rovo_search_all') ? (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$798f70d5ba74d109]) : []
            },
            objectTypeFilter: {
                typeARIs: (0, $dh538.fg)('assets_rovo_search_all') ? (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$51661d1a93f29640]) : []
            }
        },
        confluenceFilters: {
            spacesFilter: confluenceOnlyValues(selectedSpaceValues),
            isVerified: (0, $gY9AU.getBooleanFilterValue)(filters[0, $73b3163876151519$export$b698e15dd0654a6b]) || undefined,
            contributorsFilter: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$e03d97f0eaa66910]),
            ancestorIdsFilter: confluenceOnlyValues(selectedContentValues),
            range: selectedProduct !== (0, $b4tvS.ProductKeys).Confluence ? filterDateRange : [],
            owners: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$f42198825b45f0bf]),
            labelsFilter: selectedProduct === (0, $b4tvS.ProductKeys).Confluence ? (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$623d400c5f880682]) : [],
            titleMatchOnly: titleMatchValue,
            ...pageStatusValue ? {
                pageStatus: [
                    pageStatusValue
                ]
            } : {},
            contentStatuses: selectedProduct === (0, $b4tvS.ProductKeys).Confluence ? (0, $gY9AU.getContentStatusValue)(filters[0, $73b3163876151519$export$741d3c5ff1600fc4]) : [],
            containerStatus: selectedProduct === (0, $b4tvS.ProductKeys).Confluence ? (0, $gY9AU.getContainerStatusValue)(filters[0, $73b3163876151519$export$741d3c5ff1600fc4]) : []
        },
        mercuryFilters: {
            owners: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$f42198825b45f0bf]),
            focusAreaTypeIds: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$cd646dbb07979a8d]),
            ancestorIds: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$2678e5eb1f9db396])
        },
        ...(0, $dh538.fg)('talent_global_search') ? {
            talentFilters: {
                owners: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$f42198825b45f0bf]),
                employmentTypes: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$713c4dadb56593e7]).map((value)=>decodeURIComponent(value)),
                focusAreas: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$d87a0f934d4a8c3c]),
                jobFamilies: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$19dab386a6b200ee]).map((value)=>decodeURIComponent(value)),
                statuses: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$f75b5006a4fc44bc]).map((value)=>decodeURIComponent(value)),
                teams: (0, $gY9AU.getSelectFilterValue)(filters[0, $73b3163876151519$export$4c1df8b2cfbc878])
            }
        } : {},
        compassFilters: {
            componentFilter: {
                componentStates: (0, $gY9AU.getArchivedAndPendingComponentsValue)(filters[0, $73b3163876151519$export$98981f5c8dc7607d])
            }
        },
        thirdPartyFilters: (0, $dOOW1.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, assignee3PValues, containerAris, createdByValues, lastUpdatedByValues, ancestorAris, labelsValues, undefined, selectedDatasource?.datasourceId, ownerValues, salesforceStageValues, salesforceCloseDate, opportunityStatusValue, pullRequestStatusValues, repositoryValues, campaignStatusValues, caseStatusValues, slackChannelValues, hasAttachmentValue),
        sortFilters: sortFilters
    };
    const unselectedProductsThirdPartyFilters = (0, $dOOW1.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, assetsFilters: assetsFilters, talentFilters: talentFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && !commonFilters.contributorsFilter && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && !confluenceFilters.titleMatchOnly && confluenceFilters.contentStatuses.length === 0 && confluenceFilters.containerStatus.length === 0 && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && (!confluenceFilters.pageStatus || confluenceFilters.pageStatus.length === 0) && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && jiraFilters.issueFilter.statusCategories.length === 0 && jiraFilters.issueFilter.reporterARIs.length === 0 && jiraFilters.issueFilter.commenterARIs.length === 0 && mercuryFilters.owners.length === 0 && jiraFilters.issueFilter.issueLabels.length === 0 && // When cleaning up rovo_jira_work_type change this to jiraFilters.issueFilter.issueTypes.length === 0
    (!jiraFilters.issueFilter.issueTypes || jiraFilters.issueFilter.issueTypes?.length === 0) && mercuryFilters.owners.length === 0 && mercuryFilters.focusAreaTypeIds.length === 0 && mercuryFilters.ancestorIds.length === 0 && compassFilters.componentFilter.componentStates.length === 0 && ((0, $dh538.fg)('talent_global_search') ? talentFilters?.owners.length === 0 && talentFilters?.employmentTypes.length === 0 && talentFilters?.focusAreas.length === 0 && talentFilters?.jobFamilies.length === 0 && talentFilters?.statuses.length === 0 && talentFilters?.teams.length === 0 : true) && ((0, $dh538.fg)('assets_rovo_search_all') ? assetsFilters.objectSchemaFilter.schemaARIs.length === 0 && assetsFilters.objectTypeFilter.typeARIs.length === 0 : true) && (!thirdPartyFilters.range || Object.keys(thirdPartyFilters.range).length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0 && (!thirdPartyFilters.assignees || thirdPartyFilters.assignees?.length === 0) && (!thirdPartyFilters.lastUpdatedBy || thirdPartyFilters.lastUpdatedBy?.length === 0) && (!thirdPartyFilters.createdBy || thirdPartyFilters.createdBy?.length === 0) && (!thirdPartyFilters.ancestorAris || thirdPartyFilters.ancestorAris?.length === 0) && (!thirdPartyFilters.containerAris || thirdPartyFilters.containerAris?.length === 0) && (!thirdPartyFilters.salesforceFilters?.stage || thirdPartyFilters.salesforceFilters.stage.length === 0) && (!thirdPartyFilters.salesforceFilters?.owners || thirdPartyFilters.salesforceFilters.owners.length === 0) && !thirdPartyFilters.salesforceFilters?.closeDate && (!thirdPartyFilters.salesforceFilters?.campaignStatuses || thirdPartyFilters.salesforceFilters.campaignStatuses.length === 0) && (!thirdPartyFilters.salesforceFilters?.caseStatuses || thirdPartyFilters.salesforceFilters.caseStatuses.length === 0) && (!thirdPartyFilters.gitFilters?.pullRequestStatus || thirdPartyFilters.gitFilters.pullRequestStatus.length === 0) && (!thirdPartyFilters.gitFilters?.repoName || thirdPartyFilters.gitFilters.repoName.length === 0) && !thirdPartyFilters.teamsFilters?.hasAttachment && !thirdPartyFilters.thirdPartyProducts?.some((p)=>p.product === 'slack' && p.channels && p.channels.length > 0);
    return {
        selectedFilters: selectedFilters,
        unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
        selectedEntities: selectedEntities,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        entities: entitiesForQuery,
        hasFiltersSelected: !isEmpty
    };
};
module.exports["getSelectedFilters"] = $5f15807d66c8b2dc$export$f6546bb98204a0ca;

});

parcelRegister("gY9AU", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $brNow = parcelRequire("brNow");


var $7iBhV = parcelRequire("7iBhV");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $gW8Zi = parcelRequire("gW8Zi");


var $eMDCS = parcelRequire("eMDCS");


var $4tTFP = parcelRequire("4tTFP");


var $d151M = parcelRequire("d151M");


var $aXWIB = parcelRequire("aXWIB");

const $ff70e75a80572c21$export$c054401256af44b9 = '[System] Incident';
const $ff70e75a80572c21$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    incident: {
        id: "search-client.jira.issue.incident.label",
        defaultMessage: "[System] Incident"
    }
});


const $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT'
    ]
};
const $397b5a5e3acc8878$export$7069271803c33dc3 = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT',
        'DRAFT'
    ]
};
const $397b5a5e3acc8878$export$a240a4826113d43 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $397b5a5e3acc8878$export$7069271803c33dc3['showArchived'] : $397b5a5e3acc8878$export$7069271803c33dc3['showCurrent'];
};
const $397b5a5e3acc8878$export$b934b4f495e2c091 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a['showArchived'] : $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a['showCurrent'];
};
const $397b5a5e3acc8878$export$fa0dcd7cda441845 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? [
        'ACTIVE',
        'PENDING',
        'ARCHIVED'
    ] : [];
};
const $397b5a5e3acc8878$export$ba6044efb2e123e9 = {
    [(0, $b4tvS.ProductKeys).Jira]: [
        'software',
        'business'
    ],
    [(0, $b4tvS.ProductKeys).JiraProductDiscovery]: [
        'product_discovery'
    ],
    [(0, $b4tvS.ProductKeys).JiraServiceManagement]: [
        'service_desk'
    ]
};
const $397b5a5e3acc8878$export$e1f376159111dbe6 = (filterValues, selectedProduct)=>{
    // when all products are searched
    if (!selectedProduct) // don't return any values in all product selected mode for assignee and project filters
    return [];
    switch(selectedProduct){
        case (0, $b4tvS.ProductKeys).Jira:
        case (0, $b4tvS.ProductKeys).JiraProductDiscovery:
        case (0, $b4tvS.ProductKeys).JiraServiceManagement:
            return filterValues;
    }
    return [];
};
const $397b5a5e3acc8878$export$5c4691ac7ffb1183 = 'DUMMY_JIRA_ISSUE_TYPE_ID';
const $397b5a5e3acc8878$export$4df832a1d124a3d4 = async (cloudId, intl, issueType, activationId, primaryProduct)=>{
    if (!cloudId) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const searchString = intl.formatMessage((0, $ff70e75a80572c21$export$defe85febe8b728c)[issueType]);
    const issueTypes = await (0, $brNow.jiraIssueTypeJQLQuery)(cloudId, searchString, headers);
    const ids = issueTypes?.data?.jira.jqlBuilder.fieldValues.edges;
    if (!ids || ids.length === 0) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    if (ids.length > 1) {
        const issueTypeNode = ids.find((id)=>id.node?.displayName === searchString);
        if (!issueTypeNode) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
        const issueType = issueTypeNode.node?.issueTypes[0];
        return issueType && issueType.issueTypeId ? issueType.issueTypeId : $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    } else {
        const node = ids[0].node;
        if (!node) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
        return node.issueTypes[0].issueTypeId || $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    }
};
const $397b5a5e3acc8878$export$75ec3b8bb22cb14f = (filter)=>{
    return (0, $d151M.isSelectFilter)(filter?.type) ? filter.value : [];
};
const $397b5a5e3acc8878$export$1800e9d06ef0f63b = (filter)=>{
    return (0, $d151M.isSelectFilter)(filter?.type) ? filter.customValue : {};
};
const $397b5a5e3acc8878$export$49b41db8fadc5da = (filter)=>{
    return filter?.type === 'boolean' ? filter.value : false;
};
const $397b5a5e3acc8878$export$7efdc6b7aa39e72a = (filter)=>{
    const selectedDateOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $7iBhV.CUSTOM_OPTION_VALUE)) return (0, $4tTFP.convertLastUpdatedToDateRange)(selectedDateOption);
    else if (selectedDateOption === (0, $7iBhV.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $397b5a5e3acc8878$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from || customDateRange?.to) return (0, $gW8Zi.convertCustomDateToRange)(customDateRange.from, customDateRange.to);
    }
    return;
};
const $397b5a5e3acc8878$export$9ec55eff3923c72 = (filter)=>{
    const selectedDateOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $7iBhV.CUSTOM_OPTION_VALUE)) return [
        (0, $4tTFP.getConfluenceDateOptionValues)(selectedDateOption)
    ];
    else if (selectedDateOption === (0, $7iBhV.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $397b5a5e3acc8878$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from && customDateRange?.to) return [
            (0, $4tTFP.getConfluenceDateOptionFromCustomDates)(customDateRange.from, customDateRange.to)
        ];
    }
    return [];
};
const $397b5a5e3acc8878$export$ac0baabacf9504ae = (selectedProduct)=>{
    if (!selectedProduct) return []; // In the BE, it will target all Jira products if the array is empty
    switch(selectedProduct){
        case (0, $b4tvS.ProductKeys).Jira:
        case (0, $b4tvS.ProductKeys).JiraProductDiscovery:
        case (0, $b4tvS.ProductKeys).JiraServiceManagement:
            return $397b5a5e3acc8878$export$ba6044efb2e123e9[selectedProduct];
    }
    return [];
};
const $397b5a5e3acc8878$export$b8e499230f5115d8 = {
    [(0, $2Znam.TypeFilterValueKey).Epic]: 'Epic',
    [(0, $2Znam.TypeFilterValueKey).Bug]: 'Bug',
    [(0, $2Znam.TypeFilterValueKey).Story]: 'Story',
    [(0, $2Znam.TypeFilterValueKey).Task]: 'Task',
    [(0, $2Znam.TypeFilterValueKey).Subtask]: 'Subtask'
};
const $397b5a5e3acc8878$export$f548e13b50401f80 = (selectedType, selectedProduct)=>{
    const hasSelectedProductThatIsNotJira = Boolean(selectedProduct) && selectedProduct !== (0, $b4tvS.ProductKeys).Jira;
    if (hasSelectedProductThatIsNotJira || selectedType.length === 0) return [];
    return selectedType.flatMap((typeOption)=>{
        const workType = $397b5a5e3acc8878$export$b8e499230f5115d8[typeOption];
        return workType ? [
            workType
        ] : [];
    });
};
const $397b5a5e3acc8878$export$7dcf1656cd04caad = [
    'OPEN',
    'NEW',
    'INDETERMINATE',
    'DONE',
    'UNDEFINED'
];
const $397b5a5e3acc8878$export$5f47ad4f5e0267c4 = (filter)=>{
    const filterValues = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter);
    const appliedFilterOptions = filterValues.flatMap((filtervalue)=>{
        const filterOptions = $397b5a5e3acc8878$export$7dcf1656cd04caad.filter((status)=>{
            if (!(0, $dh538.fg)('rovo_search_in_jira_granular_status_filters')) return status === 'OPEN' || status === 'DONE';
            else return status !== 'OPEN';
        }).find((allowedValue)=>filtervalue === allowedValue);
        return filterOptions ? [
            filterOptions
        ] : [];
    });
    return appliedFilterOptions;
};
const $397b5a5e3acc8878$export$97dd8d7ab50aafbd = (filter)=>{
    const selectedSortOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter)[0];
    return (0, $eMDCS.convertSortToFilter)(selectedSortOption);
};
module.exports["getContentStatusValue"] = $397b5a5e3acc8878$export$a240a4826113d43;
module.exports["getBooleanFilterValue"] = $397b5a5e3acc8878$export$49b41db8fadc5da;
module.exports["getContainerStatusValue"] = $397b5a5e3acc8878$export$b934b4f495e2c091;
module.exports["getArchivedAndPendingComponentsValue"] = $397b5a5e3acc8878$export$fa0dcd7cda441845;
module.exports["JiraProductProjectFilterKey"] = $397b5a5e3acc8878$export$ba6044efb2e123e9;
module.exports["omitNonJiraFilterValues"] = $397b5a5e3acc8878$export$e1f376159111dbe6;
module.exports["getJiraIssueTypesFilter"] = $397b5a5e3acc8878$export$4df832a1d124a3d4;
module.exports["getSelectFilterValue"] = $397b5a5e3acc8878$export$75ec3b8bb22cb14f;
module.exports["getSelectedDateRange"] = $397b5a5e3acc8878$export$7efdc6b7aa39e72a;
module.exports["getFilterDateRange"] = $397b5a5e3acc8878$export$9ec55eff3923c72;
module.exports["getJiraProjectFilter"] = $397b5a5e3acc8878$export$ac0baabacf9504ae;
module.exports["jiraWorkTypesForRequest"] = $397b5a5e3acc8878$export$b8e499230f5115d8;
module.exports["getSelectedJiraWorkType"] = $397b5a5e3acc8878$export$f548e13b50401f80;
module.exports["allowedJiraIssueStatuses"] = $397b5a5e3acc8878$export$7dcf1656cd04caad;
module.exports["getJiraIssueStatusFilterOptions"] = $397b5a5e3acc8878$export$5f47ad4f5e0267c4;
module.exports["getSortFilters"] = $397b5a5e3acc8878$export$97dd8d7ab50aafbd;

});

parcelRegister("brNow", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME = 'SearchPageJiraIssueTypeQuery';
const $c2ce3ac8cb311ba1$var$jqlIssueTypeQueryString = `query ${$c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME}(
	$cloudId: ID!,
	$first: Int = 10,
	$jqlTerm: String!,
	$jql: String!,
	$searchString: String!) {
		jira {
			jqlBuilder(cloudId: $cloudId) {
				fieldValues (
					first: $first
					jqlTerm: $jqlTerm
					jqlContext: $jql
					searchString: $searchString
				) {
					edges {
						node {
							displayName
							... on JiraJqlIssueTypeFieldValue {
								issueTypes {
									issueTypeId
								}
							}
						}
					}
          		}
			}
		}
	}`;
const $c2ce3ac8cb311ba1$export$bd7a9ccdb07f26a6 = (0, $hw4j5.inMemoryCache)();
const $c2ce3ac8cb311ba1$export$299504e13b0b41d4 = async (cloudId, searchString, headers)=>{
    return $c2ce3ac8cb311ba1$export$bd7a9ccdb07f26a6.inMemoryDecorator(`${cloudId}-${searchString}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $c2ce3ac8cb311ba1$var$jqlIssueTypeQueryString,
            variables: {
                cloudId: cloudId,
                jqlTerm: 'type',
                searchString: searchString,
                jql: ''
            },
            operationName: $c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'JiraJqlBuilder',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["jiraIssueTypeJQLQuery"] = $c2ce3ac8cb311ba1$export$299504e13b0b41d4;

});

parcelRegister("7iBhV", function(module, exports) {
const $ec40d4e0b09453d5$export$5ef321009a5b450c = 'custom';
const $ec40d4e0b09453d5$export$62fed45313a13eff = 'universalTypeFilter';
module.exports["CUSTOM_OPTION_VALUE"] = $ec40d4e0b09453d5$export$5ef321009a5b450c;
module.exports["universalTypeFilterId"] = $ec40d4e0b09453d5$export$62fed45313a13eff;

});

parcelRegister("inrbX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $c6GJD = parcelRequire("c6GJD");


var $6yNqK = parcelRequire("6yNqK");


var $731W9 = parcelRequire("731W9");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $djVCD = parcelRequire("djVCD");

const $3a401808d4c266ad$export$82052fbad762998f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: 'searchDialog'
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsScreenEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: 'searchDialog'
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $3a401808d4c266ad$export$380f10e960af9b57 = ()=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const fetchEntitiesRequestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    const fetchSpacesRequestId = (0, $4VmlX.useFetchSpacesRequestId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $djVCD.useQueryUpdatedTime)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryVersion] = (0, $djVCD.useQueryVersion)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const filters = (0, $djVCD.useFilterAttributesForTracking)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    return (0, $42omo.useMemo)(()=>{
        const { frontendExperiments: frontendExperiments = {}, combinedExperiment: combinedExperiment = {} } = experimentConfig;
        const { filterSelections: filterSelections, filters: filterCategories } = filters;
        const quickFind3pExperiment = (0, $c6GJD.default).getExperiment('quick_find_3p_search_results_experiment', {
            fireExperimentExposure: false
        });
        const commonAttributes = {
            productEdition: productEdition,
            frontendExperiments: {
                activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                ...frontendExperiments,
                quick_find_3p_search_results_experiment: {
                    abTestId: 'quick_find_3p_search_results_experiment',
                    ...quickFind3pExperiment.value
                }
            },
            combinedExperiment: combinedExperiment,
            ...$3a401808d4c266ad$export$e44a494bf5ca923a(quickFindQuery),
            queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
            queryVersion: queryVersion,
            searchSessionId: searchSessionId,
            fetchEntitiesTraceId: fetchEntitiesRequestId,
            fetchSpacesTraceId: fetchSpacesRequestId,
            isQuickFind: true,
            mode: applicationMode,
            productSelected: productSelected || (0, $6yNqK.ALL_PRODUCTS_STRING),
            filters: filterCategories,
            filterSelections: filterSelections,
            ...analyticsAttributes
        };
        const nonPrivacySafeAttributes = {
            query: quickFindQuery
        };
        return {
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        };
    }, [
        analyticsAttributes,
        applicationMode,
        experimentConfig,
        fetchEntitiesRequestId,
        fetchSpacesRequestId,
        filters,
        productEdition,
        productSelected,
        queryUpdatedTime,
        queryVersion,
        quickFindQuery,
        searchSessionId
    ]);
};
const $3a401808d4c266ad$export$dba3e2bcdbd49da4 = (query)=>(query.match(/\w+/g) || []).length;
const $3a401808d4c266ad$export$e44a494bf5ca923a = (query)=>{
    const wordCount = $3a401808d4c266ad$export$dba3e2bcdbd49da4(query);
    return {
        numberOfTerms: wordCount,
        queryHash: (0, $731W9.sha256Hash)(query),
        queryHashSHA256: (0, $731W9.sha256Hash)(query),
        queryLength: query.length,
        wordCount: wordCount
    };
};
module.exports["useQuickFindAnalytics"] = $3a401808d4c266ad$export$82052fbad762998f;
module.exports["useQuickFindAttributes"] = $3a401808d4c266ad$export$380f10e960af9b57;
module.exports["getCommonQueryAttributes"] = $3a401808d4c266ad$export$e44a494bf5ca923a;
module.exports["getWordCount"] = $3a401808d4c266ad$export$dba3e2bcdbd49da4;

});

parcelRegister("lGfXC", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6jKOp = parcelRequire("6jKOp");


var $bQSQw = parcelRequire("bQSQw");

const $65a45d81c286798a$export$b551db3ea2671aa7 = (taskId, taskName, searchSessionId, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName,
        searchSessionId: searchSessionId
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};
module.exports["createVitalStatsNetworkCallbacks"] = $65a45d81c286798a$export$b551db3ea2671aa7;

});

parcelRegister("ja8yA", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $6jKOp = parcelRequire("6jKOp");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $f525b3f0ba3d21ed$export$6635638df40163e1 = 'quick-find-recent-activities';


/* eslint-disable @atlaskit/platform/no-module-level-eval */ 
var $dh538 = parcelRequire("dh538");

const $96bd0be78eb47b74$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $96bd0be78eb47b74$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $96bd0be78eb47b74$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
		issue @include(if: $includeJiraIssueMetadata) {
			projectField {
				project {
					name
				}
			}
			issueTypeField {
				issueType {
					name
				}
			}
		}
  }
`;
const $96bd0be78eb47b74$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    statusCategory {
      name,
      colorName
    }
    issueType {
      avatar {
        small
      }
    }
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$96bd0be78eb47b74$var$JiraSingleIssueLineTextFieldFragment}
`;
const $96bd0be78eb47b74$var$GraphDocumentFragment = `
  fragment GraphDocumentFragment on ExternalDocument {
    id
    type {
        category
    }
    displayName
    parent @optIn(to: "ExternalDataDepotQueryV2"){
        ... on ExternalDocument {
            displayName
        }
    }
    url
    provider {
        providerId
    }
  }
`;
const $96bd0be78eb47b74$var$GraphRemoteLinkFragment = `
  fragment GraphRemoteLinkFragment on ExternalRemoteLink {
	  id
		displayName
		category @optIn(to: "ExternalDataDepotQueryV2")
		url
    provider {
			providerId
		}
  }
`;
const $96bd0be78eb47b74$var$LoomVideoFragment = `
  fragment LoomVideoFragment on LoomVideo {
    name
    loomUrl: url
  }
`;
const $96bd0be78eb47b74$var$ExternalPullRequestFragment = `
  fragment ExternalPullRequestFragment on ExternalPullRequest {
    id
    displayName
    url
    status
    provider {
      providerId
    }
  }
`;
const $96bd0be78eb47b74$var$ExternalWorkItemFragment = `
  fragment ExternalWorkItemFragment on ExternalWorkItem {
    id
    displayName
    url
    workItemStatus: status
    provider {
      providerId
    }
  }
`;
const $96bd0be78eb47b74$var$AssetsObjectFragment = `
  fragment AssetsObjectFragment on AssetsObject {
    id
		displayTypename @optIn(to: "AssetsApFields")
    links {
      web
    }
    assetsLabel: label
    objectKey
    assetsIcon: avatar {
      url48
    }
    objectType {
      schema {
        name
      }
    }
  }
`;
const $96bd0be78eb47b74$var$AssetsObjectTypeFragment = `
fragment AssetsObjectTypeFragment on AssetsObjectType {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
	assetsIcon: icon {
		url48
	}
	schema {
		assetsSchemaName: name
	}
}
`;
const $96bd0be78eb47b74$var$AssetsSchemaFragment = `
fragment AssetsSchemaFragment on AssetsSchema {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
}
`;
const $96bd0be78eb47b74$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $96bd0be78eb47b74$export$8a781e50bcd90a75 = `
  query ${$96bd0be78eb47b74$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $filteredEventTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
    $after: String
    $includeJiraIssueMetadata: Boolean = false
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
              eventTypes: $filteredEventTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
          after: $after
        ) {
          __typename
          edges {
            cursor
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                  ...GraphDocumentFragment
									...GraphRemoteLinkFragment
									...LoomVideoFragment
									...ExternalPullRequestFragment
									...ExternalWorkItemFragment
                  ${(0, $dh538.fg)('assets_rovo_search_all') ? `...AssetsObjectFragment` : ''}
									${(0, $dh538.fg)('assets_rovo_search_all') ? `...AssetsObjectTypeFragment` : ''}
									${(0, $dh538.fg)('assets_rovo_search_all') ? `...AssetsSchemaFragment` : ''}
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$96bd0be78eb47b74$var$ConfluencePageFragment}
  ${$96bd0be78eb47b74$var$ConfluenceBlogPostFragment}
  ${$96bd0be78eb47b74$var$ConfluenceWhiteboardFragment}
  ${$96bd0be78eb47b74$var$AtlasProjectFragment}
  ${$96bd0be78eb47b74$var$AtlasGoalFragment}
  ${$96bd0be78eb47b74$var$JiraIssueFragment}
  ${$96bd0be78eb47b74$var$GraphDocumentFragment}
	${$96bd0be78eb47b74$var$GraphRemoteLinkFragment}
	${$96bd0be78eb47b74$var$LoomVideoFragment}
	${$96bd0be78eb47b74$var$ExternalPullRequestFragment}
	${$96bd0be78eb47b74$var$ExternalWorkItemFragment}
  ${(0, $dh538.fg)('assets_rovo_search_all') ? $96bd0be78eb47b74$var$AssetsObjectFragment : ''}
	${(0, $dh538.fg)('assets_rovo_search_all') ? $96bd0be78eb47b74$var$AssetsObjectTypeFragment : ''}
	${(0, $dh538.fg)('assets_rovo_search_all') ? $96bd0be78eb47b74$var$AssetsSchemaFragment : ''}
`;


const $8055f1273433c91e$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, networkCallbacks: networkCallbacks })=>{
    networkCallbacks?.onStart();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $96bd0be78eb47b74$export$8a781e50bcd90a75),
        operationName: $96bd0be78eb47b74$export$5db520940cf00715,
        headers: headers
    }).then((result)=>{
        const traceInfo = (0, $6jKOp.extractTraceInfoFromResponse)(result);
        networkCallbacks?.onSuccess(traceInfo);
        return result;
    }, (error)=>{
        networkCallbacks?.onError(error?.name || 'UnknownError', error?.message || 'An unknown error occurred');
        throw error;
    });
};
const { refreshOnAccessDecorator: $8055f1273433c91e$var$refreshOnAccessDecoratorRecentActivities, clear: $8055f1273433c91e$var$clearRecentActivitiesCache } = (0, $jnPv4.promiseCache)({
    name: (0, $f525b3f0ba3d21ed$export$6635638df40163e1)
});
const $8055f1273433c91e$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $8055f1273433c91e$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $8055f1273433c91e$export$ffce414fbab0f879 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks })=>{
    const cacheKey = (0, $2qzBQ.generateHash)(`${(0, $f525b3f0ba3d21ed$export$6635638df40163e1)}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $8055f1273433c91e$var$refreshOnAccessDecoratorRecentActivities({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $8055f1273433c91e$var$refreshOnAccessDecoratorRecentActivities({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await (0, $4qT1X.fetchAgg)({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    graphQuery: (0, $96bd0be78eb47b74$export$8a781e50bcd90a75),
                    operationName: $96bd0be78eb47b74$export$5db520940cf00715,
                    headers: headers
                });
                writeBackWithTTL(result, $8055f1273433c91e$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $8055f1273433c91e$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired,
        analyticsCallback: analyticsCallback,
        networkCallbacks: networkCallbacks
    });
};
const $8055f1273433c91e$export$b0de6826751f4fe0 = ({ variables: variables, graphQuery: graphQuery, aggAbsoluteUrl: aggAbsoluteUrl, operationName: operationName, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: operationName,
        headers: headers
    });
};
const $8055f1273433c91e$export$a13e8bf43a8d56c7 = (key)=>$8055f1273433c91e$var$clearRecentActivitiesCache(key);
module.exports["recentActivitiesQuery"] = $8055f1273433c91e$export$ba6bff93c920ff4a;
module.exports["cachedRecentActivitiesQuery"] = $8055f1273433c91e$export$ffce414fbab0f879;
module.exports["fetchJiraIssuesQuery"] = $8055f1273433c91e$export$b0de6826751f4fe0;

});

parcelRegister("3R0ts", function(module, exports) {

var $6Gsan = parcelRequire("6Gsan");

const $979dcbe39352dbbd$export$194e5f2c2ebfcf47 = 'quick-find-dialog';
const $979dcbe39352dbbd$export$954ad19cca7aaecd = 'quick-find-open';
const $979dcbe39352dbbd$export$d73367afdae3e8ef = 'quick-find-close';
const $979dcbe39352dbbd$export$529299d30909140a = 'quick-find-post-query';
const $979dcbe39352dbbd$export$b1255d59856835f2 = 'quick-find-loading';
const $979dcbe39352dbbd$export$90774abdf51eb445 = [
    (0, $6Gsan.PrimaryProductKeys).Confluence,
    (0, $6Gsan.PrimaryProductKeys).Jira,
    (0, $6Gsan.PrimaryProductKeys).Assets,
    (0, $6Gsan.PrimaryProductKeys).RovoExtension,
    (0, $6Gsan.PrimaryProductKeys).Talent
];
const $979dcbe39352dbbd$export$4551c7df8148d8af = 'atlassian.search-dialog.ai-dialog.referrer';
const $979dcbe39352dbbd$export$fffb71ae1a2b6d2f = 2;
module.exports["SEARCH_DIALOG_WIDTH_OBSERVER_ID"] = $979dcbe39352dbbd$export$194e5f2c2ebfcf47;
module.exports["QUICK_FIND_OPEN_INTERACTION"] = $979dcbe39352dbbd$export$954ad19cca7aaecd;
module.exports["QUICK_FIND_CLOSE_INTERACTION"] = $979dcbe39352dbbd$export$d73367afdae3e8ef;
module.exports["QUICK_FIND_POST_QUERY_INTERACTION"] = $979dcbe39352dbbd$export$529299d30909140a;
module.exports["QUICK_FIND_LOADING_HOLD"] = $979dcbe39352dbbd$export$b1255d59856835f2;
module.exports["PRODUCTS_WITH_INLINE_FILTERS"] = $979dcbe39352dbbd$export$90774abdf51eb445;
module.exports["SEARCH_DIALOG_AI_DIALOG_REFERER_KEY"] = $979dcbe39352dbbd$export$4551c7df8148d8af;
module.exports["DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT"] = $979dcbe39352dbbd$export$fffb71ae1a2b6d2f;

});

parcelRegister("lHqdD", function(module, exports) {
/**
 * Generic builder for the `ml_lens` envelope that lets the ML Lens transformer
 * split a single GASv3 event into one metric per logical dimension (e.g. one
 * metric per product/connector).
 *
 * See: https://hello.atlassian.net/wiki/spaces/~93171358/pages/6820686403/
 *   GASv3+Events+Transformation+for+ML+Lens+Metrics+Schema
 *
 * This module is intentionally domain-agnostic: callers provide the namespace,
 * the metric-set base tags and the list of metrics. Surface-specific helpers
 * (e.g. Quick Find post-query, Full Page Search results) live alongside this
 * file and delegate to {@link buildMlLensEnvelope}.
 */ const $93e272fdd2ffb3d6$export$aaa5dab2f0c84de8 = ({ namespace: namespace, baseTags: baseTags, metrics: metrics })=>({
        version: '1',
        metric_sets: [
            {
                namespace: namespace,
                tags: {
                    ...baseTags
                },
                metrics: metrics
            }
        ]
    });
module.exports["buildMlLensEnvelope"] = $93e272fdd2ffb3d6$export$aaa5dab2f0c84de8;

});

parcelRegister("chwej", function(module, exports) {
const $8c8fb827b5015331$export$52f97816f69502ce = 'atl-edge-region-hint';
function $8c8fb827b5015331$export$ef0639c0600b3b26(primaryProduct, productDataRegions) {
    const primaryProductDataRegion = primaryProduct ? productDataRegions[primaryProduct]?.[0] : undefined;
    const confluenceDataRegion = productDataRegions['confluence']?.[0];
    const jiraDataRegion = productDataRegions['jira']?.[0];
    const firstDataRegion = Object.entries(productDataRegions)[0]?.[0];
    return primaryProductDataRegion ?? confluenceDataRegion ?? jiraDataRegion ?? firstDataRegion;
}
module.exports["EDGE_REGION_HINT_HEADER"] = $8c8fb827b5015331$export$52f97816f69502ce;
module.exports["getEdgeRegionHint"] = $8c8fb827b5015331$export$ef0639c0600b3b26;

});

parcelRegister("1SV4e", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");

const $8ca6facece17d017$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $8ca6facece17d017$export$c1b7badf23670c19 = 50;
const $8ca6facece17d017$export$98712b4e855f892c = (item)=>typeof item === 'string' ? {
        query: item
    } : item;
const $8ca6facece17d017$export$74e99d9695eabee6 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $5G9KX.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[productId]) userSearches[productId] = [];
    let productSearches = userSearches[productId];
    // Normalize the value: if it's a string, trim it; if it's an object, trim the query
    const normalizedValue = typeof value === 'string' ? value.trim() : {
        ...value,
        query: value.query.trim()
    };
    // Pop the last value of the array if it is too long
    if (productSearches.length === $8ca6facece17d017$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate (based on query), remove it from the array
    const { query: normalizedQuery } = $8ca6facece17d017$export$98712b4e855f892c(normalizedValue);
    productSearches = productSearches.filter((v)=>$8ca6facece17d017$export$98712b4e855f892c(v).query !== normalizedQuery);
    productSearches.unshift(normalizedValue);
    recentSearches[userId][productId] = productSearches;
    (0, $5G9KX.setLocalStorageItem)(key, JSON.stringify(recentSearches));
};
const $8ca6facece17d017$export$1216255791599668 = ({ userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $5G9KX.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[productId] || [];
};
const $8ca6facece17d017$export$6adb2cc1366d1e30 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $5G9KX.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][productId]) return [];
    const { query: queryToRemove } = $8ca6facece17d017$export$98712b4e855f892c(value);
    recentSearches[userId][productId] = recentSearches[userId][productId].filter((v)=>$8ca6facece17d017$export$98712b4e855f892c(v).query !== queryToRemove);
    (0, $5G9KX.setLocalStorageItem)(key, JSON.stringify(recentSearches));
    return recentSearches[userId][productId];
};
module.exports["RECENT_SEARCH_KEY"] = $8ca6facece17d017$export$ec4722d39a5031c0;
module.exports["getRecentQueryObject"] = $8ca6facece17d017$export$98712b4e855f892c;
module.exports["addRecentSearch"] = $8ca6facece17d017$export$74e99d9695eabee6;
module.exports["getRecentSearches"] = $8ca6facece17d017$export$1216255791599668;
module.exports["removeRecentSearch"] = $8ca6facece17d017$export$6adb2cc1366d1e30;

});

parcelRegister("8aC7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $24d120d5a9177b55$export$2e2bcd8739ae039);
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $iA4lt = parcelRequire("iA4lt");


var $gkXKl = parcelRequire("gkXKl");


var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");



var $9rRKJ = parcelRequire("9rRKJ");


var $2OtFZ = parcelRequire("2OtFZ");


var $1ikWy = parcelRequire("1ikWy");


var $eO6NY = parcelRequire("eO6NY");





var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $i1nCm = parcelRequire("i1nCm");


var $78yNl = parcelRequire("78yNl");

const { refreshOnAccessDecorator: $565d370b0f69fbc8$var$refreshOnAccessDecoratorSmartlinkUsageAndTopApps, get: $565d370b0f69fbc8$var$getSmartlinkUsageAndTopAppsCache, clear: $565d370b0f69fbc8$var$clearSmartlinkUsageAndTopAppsCache } = (0, $jnPv4.promiseCache)({
    name: (0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_USAGE_AND_TOP_APPS_SITE_CACHE_KEY),
    expiration: (0, $i1nCm.SEVEN_DAY_MS_TTL)
});
const $565d370b0f69fbc8$var$fetchSiteSmartlinkUsageAndTopAppsService = async (siteId)=>{
    // Re-uses the existing TAP-delivery site traits endpoint that smartlink uses;
    // every site-scoped TAP trait is returned in the same `attributes` bag.
    const requestUrl = (0, $78yNl.getSmartlinkSiteTraitsUrl)(siteId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $565d370b0f69fbc8$var$fetchSmartlinkUsageAndTopAppsTrait = async ({ siteId: siteId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $2qzBQ.generateHash)(`${(0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_USAGE_AND_TOP_APPS_SITE_CACHE_KEY)}|${siteId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $565d370b0f69fbc8$var$fetchSiteSmartlinkUsageAndTopAppsService(siteId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === (0, $i1nCm.SMARTLINK_USAGE_AND_TOP_APPS_TRAIT));
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $3Tbc2.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise();
    };
    const existing = $565d370b0f69fbc8$var$getSmartlinkUsageAndTopAppsCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $i1nCm.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $565d370b0f69fbc8$var$refreshOnAccessDecoratorSmartlinkUsageAndTopApps({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $565d370b0f69fbc8$var$refreshOnAccessDecoratorSmartlinkUsageAndTopApps({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $i1nCm.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $i1nCm.ONE_DAY_MS_TTL));
                return result;
            } catch  {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $i1nCm.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $565d370b0f69fbc8$export$c51adaa111ad7984 = (key)=>$565d370b0f69fbc8$var$clearSmartlinkUsageAndTopAppsCache(key);
const $565d370b0f69fbc8$export$efe206f958294f9e = (trait)=>{
    if (trait?.name !== (0, $i1nCm.SMARTLINK_USAGE_AND_TOP_APPS_TRAIT) || typeof trait?.value !== 'string') return undefined;
    const segments = trait.value.split(',');
    const [first, ...rest] = segments;
    const percentage = parseInt((first ?? '').trim(), 10);
    if (Number.isNaN(percentage)) return undefined;
    const mostUsedApps = rest.map((s)=>s.trim()).filter(Boolean);
    return {
        percentage: percentage,
        mostUsedApps: mostUsedApps
    };
};
const $565d370b0f69fbc8$export$9f0f423d6c87a84a = async ({ siteId: siteId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!siteId) return undefined;
    const trait = await $565d370b0f69fbc8$var$fetchSmartlinkUsageAndTopAppsTrait({
        siteId: siteId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'rovo-search-smartlink-usage-and-top-apps'
    });
    return $565d370b0f69fbc8$export$efe206f958294f9e(trait);
};






var $6yNqK = parcelRequire("6yNqK");




const $97a7f23b507766a3$export$817a2282565e7f38 = ({ cloudId: cloudId, experience: experience, percentage: percentage })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'smartLinkUsageAndTopAppsFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                percentage: percentage
            }
        }
    };
};
const $97a7f23b507766a3$export$eeb9c73de731d022 = ({ cloudId: cloudId, experience: experience, reason: reason })=>{
    return {
        action: 'taskFail',
        actionSubject: 'smartLinkUsageAndTopAppsFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                reason: reason
            }
        }
    };
};






var $3CshZ = parcelRequire("3CshZ");

/**
 * Tenant editions covered by the underlying TAP site trait
 * (`rovo_nudge_end_user_rendered_smartlinks_percent_and_most_used_apps`).
 * The trait is only computed for MAU customers on paid editions; calling the
 * endpoint for tenants outside this set just returns an empty payload, so we
 * skip the fetch entirely.
 */ const $8801996e88559d75$var$COVERED_EDITIONS = new Set([
    'STANDARD',
    'PREMIUM',
    'ENTERPRISE'
]);
const $8801996e88559d75$var$isPrimaryProductCovered = (primaryProduct, productEdition)=>{
    const edition = productEdition?.[primaryProduct];
    return !!edition && $8801996e88559d75$var$COVERED_EDITIONS.has(edition.toUpperCase());
};
const $8801996e88559d75$export$bb9929b0c526b28f = (experience, primaryProduct, cloudId, thirdPartyConfigs, productEdition)=>{
    const [smartLinkUsageAndTopApps, setSmartLinkUsageAndTopApps] = (0, $42omo.useState)(undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)({
        experience: experience
    });
    // Ensure we only ever trigger the fetch once per mount, even if
    // `thirdPartyConfigs` / `productEdition` (and therefore
    // `isFPSGitHubSocialProofBannerEnabled` / `isCoveredTenant`) later change —
    // the trait is site-scoped and doesn't change within a session.
    const hasFetchedRef = (0, $42omo.useRef)(false);
    // The only consumer of this value is `BulkConnectBanner` on the Full Page
    // Search surface (via `useSmartLinkUsageAndTopApps()` → `OAuthBanner`'s
    // `teamConnectedPercentage`). Quick Find does not read it, so skip the
    // fetch (and the analytics event) entirely when running inside Quick Find.
    const isQuickFind = experience === (0, $9rRKJ.SearchExperience).QUICK_FIND;
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled
    // or the user is not eligible.
    const isFPSGitHubSocialProofBannerEnabled = (0, $2OtFZ.serveFPSGitHubSocialProofBannerExperiment)({
        thirdPartyConfigs: thirdPartyConfigs
    }, {
        fireExperimentExposure: false
    });
    const isCoveredTenant = $8801996e88559d75$var$isPrimaryProductCovered(primaryProduct, productEdition);
    (0, $42omo.useEffect)(()=>{
        if (!isQuickFind && isFPSGitHubSocialProofBannerEnabled && isCoveredTenant && cloudId && !hasFetchedRef.current) {
            hasFetchedRef.current = true;
            (0, $565d370b0f69fbc8$export$9f0f423d6c87a84a)({
                siteId: cloudId
            }).then((data)=>{
                setSmartLinkUsageAndTopApps(data);
                if (data) fireAnalyticsEvent((0, $97a7f23b507766a3$export$817a2282565e7f38)({
                    cloudId: cloudId,
                    experience: experience,
                    percentage: data.percentage
                }));
            }).catch((error)=>{
                fireAnalyticsEvent((0, $97a7f23b507766a3$export$eeb9c73de731d022)({
                    cloudId: cloudId,
                    experience: experience,
                    reason: error instanceof Error ? error.message : String(error)
                }));
            });
        }
    }, [
        isQuickFind,
        isFPSGitHubSocialProofBannerEnabled,
        isCoveredTenant,
        cloudId,
        experience,
        fireAnalyticsEvent
    ]);
    return smartLinkUsageAndTopApps;
};






var $dh538 = parcelRequire("dh538");


var $8yIwZ = parcelRequire("8yIwZ");


var $jwO5V = parcelRequire("jwO5V");


var $7GE7t = parcelRequire("7GE7t");


var $johDC = parcelRequire("johDC");





var $4EMbH = parcelRequire("4EMbH");

parcelRequire("1yEFx");
var $1yEFx = parcelRequire("1yEFx");


var $dmTG5 = parcelRequire("dmTG5");


var $cFN1h = parcelRequire("cFN1h");


var $3htW4 = parcelRequire("3htW4");


var $31eSD = parcelRequire("31eSD");


var $bQSQw = parcelRequire("bQSQw");





var $1xk5k = parcelRequire("1xk5k");


var $lGfXC = parcelRequire("lGfXC");





var $f8oYd = parcelRequire("f8oYd");


var $j4ply = parcelRequire("j4ply");

const $de054ade02a2d419$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $de054ade02a2d419$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $de054ade02a2d419$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $de054ade02a2d419$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $de054ade02a2d419$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $de054ade02a2d419$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $de054ade02a2d419$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $de054ade02a2d419$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $de054ade02a2d419$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            intercomHmac: configuration.intercomHmac || '',
            siteMetadata: $de054ade02a2d419$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $de054ade02a2d419$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};


/**
 * Site-metadata helper functions used by `useFetchConfig`.
 *
 * These helpers each have **two implementations**, switched by the
 * `rovo_fps_use_rovo_config` feature gate:
 *
 * - **On** — delegate to the canonical implementation in
 *   `@atlassian/rovo-connectors-config/utils/site-metadata-helpers`. This is
 *   the path that will become the sole implementation once the gate is
 *   fully ramped and `useFetchConfig` is replaced by `useRovoConfig`.
 * - **Off** — run the original inline logic. Preserves verbatim behaviour
 *   for everyone not on the gate.
 *
 * Both branches must return identical results for any given input — see
 * `__tests__/site-metadata-helpers-equivalence.test.ts` for the `ffTest.both`
 * coverage that enforces this.
 *
 * **Not exported from the package.** Lives at
 * `controllers/config/site-metadata-helpers.ts` and is intentionally absent
 * from `package.json` `"exports"`. External consumers should keep going
 * through the `./use-fetch-config` subpath.
 */ 



var $lT617 = parcelRequire("lT617");

/** Matches `ari:cloud:<product>::<resource-type>/<cloudId>` and captures the cloudId. */ const $46834f5e82f1cd55$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $46834f5e82f1cd55$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getFirstCloudId)(firstPartyResponse);
    const match = firstPartyResponse.resources[0]?.id.match($46834f5e82f1cd55$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $46834f5e82f1cd55$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.isRovoEnabledForSite)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $46834f5e82f1cd55$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $46834f5e82f1cd55$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getProductEdition)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $46834f5e82f1cd55$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getProductDataRegions)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $46834f5e82f1cd55$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getRovoFeatures)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};


/**
 * Helper functions to parse the search combined config response. Ideally
 * this file should exist in the search-client package, however there are
 * too many 3P types defined in search-page.
 */ 







parcelRequire("1yEFx");










var $hB77E = parcelRequire("hB77E");


var $9yyKc = parcelRequire("9yyKc");





var $9d9t8 = parcelRequire("9d9t8");


var $2Znam = parcelRequire("2Znam");

/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b390fff55a169820$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': (0, $2Znam.TypeFilterValueKey).Document,
    'ati:cloud:graph:message': (0, $2Znam.TypeFilterValueKey).Message,
    'ati:cloud:graph:conversation': (0, $2Znam.TypeFilterValueKey).Conversation,
    'ati:cloud:graph:design': (0, $2Znam.TypeFilterValueKey).Design,
    'ati:cloud:graph:video': (0, $2Znam.TypeFilterValueKey).Video,
    'ati:cloud:graph:space': (0, $2Znam.TypeFilterValueKey).Space,
    'ati:cloud:graph:comment': (0, $2Znam.TypeFilterValueKey).Comment,
    'ati:cloud:graph:repository': (0, $2Znam.TypeFilterValueKey).Repository,
    'ati:cloud:graph:pull-request': (0, $2Znam.TypeFilterValueKey).PullRequest,
    'ati:cloud:graph:commit': (0, $2Znam.TypeFilterValueKey).Commit,
    'ati:cloud:graph:branch': (0, $2Znam.TypeFilterValueKey).Branch,
    'ati:cloud:graph:calendar-event': (0, $2Znam.TypeFilterValueKey).Calendar,
    'ati:cloud:graph:work-item': (0, $2Znam.TypeFilterValueKey).WorkItem,
    'ati:cloud:graph:project': (0, $2Znam.TypeFilterValueKey).Project,
    'ati:cloud:graph:deal': (0, $2Znam.TypeFilterValueKey).Deal,
    'ati:cloud:graph:customer-org': (0, $2Znam.TypeFilterValueKey).CustomerOrg,
    'ati:cloud:graph:dashboard': (0, $2Znam.TypeFilterValueKey).Dashboard,
    'ati:cloud:graph:data-table': (0, $2Znam.TypeFilterValueKey).DataTable
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b390fff55a169820$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b390fff55a169820$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b390fff55a169820$var$isCloudGraphAti(ati)) {
        const typeKey = $b390fff55a169820$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: []
    });
    return typeFilterConfig;
}






var $1ks6T = parcelRequire("1ks6T");

const $d6310552730441ce$var$mapForgeConnectorToThirdPartyConfig = (forgeConnector)=>{
    // Validate required fields
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $9yyKc.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $9yyKc.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    // Register the icon in the registry so ProductOrNounIcon can access it without props
    (0, $9d9t8.registerForgeConnectorIcon)(productKey, icon);
    // Build type filter config
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $b390fff55a169820$export$770175465f396551)(forgeConnector.entityTypes) : new Map();
    // Register the type mapping in the cache so universal type filter can use it
    if ((0, $dh538.fg)('rovo-search-dynamic-forge-config')) (0, $1xk5k.registerForgeConnectorTypeMapping)(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.environmentType ? `${forgeConnector.workspaceName} (${forgeConnector.environmentType})` : forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $9d9t8.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
const $d6310552730441ce$export$4cb8ef4a677c563c = (resources)=>{
    const THIRD_PARTY_TYPES = (0, $1ks6T.getThirdPartyTypes)();
    // Use a map to track connector sources for each providerId
    // This is useful for deduping search results for providers that are hybrid smartlink and full connectors
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        // Handle Forge connectors first (if feature flag enabled)
        if ((0, $9d9t8.isForgeConnectorProductKey)(resource.type) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) {
            const config = $d6310552730441ce$var$mapForgeConnectorToThirdPartyConfig(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return; // Early return for Forge connectors
        }
        // Handle hardcoded connectors (existing logic)
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $hB77E.getThirdPartyConfigs)().get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = (0, $dh538.fg)('ai_3p_slack_connector_status_transition_enabled') && productKey === 'slack';
            let sourceType;
            if (resource.type.startsWith((0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $9d9t8.LITE_CONNECTOR_SOURCE))) sourceType = (0, $9d9t8.LITE_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $9d9t8.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $9d9t8.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                connectorCreatedAt: resource.connectorCreatedAt
            };
            const datasourceList = [];
            // Add the main config without the nested datasources
            // eslint-disable-next-line no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            // TODO: Leave config level logic at the root of the datasource itself and datasource specific logic in the datasources -> https://hello.jira.atlassian.cloud/browse/DCCNT-1386
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                userNeedsOAuth: !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            // Add third-party configs, also without the nested datasources
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            // Assign the cleaned datasourceList back to the main config
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    // Note: Only filter hardcoded product keys, Forge connectors use their own type as product key
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $9d9t8.isForgeConnectorProductKey)(productKey)) return true; // Forge connectors are always valid
        // For hardcoded 3P connectors, check if they're in allProductKeys
        return (0, $b4tvS.getAllProductKeys)().includes(productKey);
    });
    // Deduplicate product keys.
    // Multiple raw resources can map to the same product key (e.g. smartlinks-connector-gdrive
    // and google-drive-connector both map to 'drive'). While thirdPartyConfigs is an object
    // and naturally deduplicates, productKeys is an array that accumulates duplicates.
    // Without dedup, SSR produces different query variables than SPA (which accidentally
    // deduplicates via buildProducts in the bootstrap store's onUpdate handler).
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};


const $bed1ea961f397265$export$fc6c3173f0bc0482 = ({ configuration: configuration })=>{
    if (configuration.firstPartyProducts) {
        const firstPartyProducts = configuration.firstPartyProducts.map((product)=>product.name);
        const accessibleNouns = firstPartyProducts.filter((product)=>product in (0, $4EMbH.nouns));
        return accessibleNouns;
    } else return [];
};
const $bed1ea961f397265$export$b38c0215344366f7 = ({ configuration: configuration, primaryProduct: primaryProduct, cloudId: cloudId })=>{
    let accessibleProducts = [];
    // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    const { thirdPartyConfig: thirdPartyConfig } = (0, $de054ade02a2d419$export$160fbca21b53d78a)(configuration, cloudId);
    // Add first party products to the array (deduplicated — multiple resource ARIs
    // can map to the same product key, e.g. bitbucket::site and bitbucket::workspace)
    if (configuration.firstPartyProducts) {
        const knownProductKeys = (0, $b4tvS.getAllProductKeys)();
        const firstPartyProducts = [
            ...new Set(configuration.firstPartyProducts.map((product)=>product.name).filter((product)=>knownProductKeys.includes(product)))
        ];
        accessibleProducts.push(...firstPartyProducts);
    }
    // Add Atlas to the array if there is more than one accessible noun
    const accessibleNouns = $bed1ea961f397265$export$fc6c3173f0bc0482({
        configuration: configuration,
        primaryProduct: primaryProduct,
        cloudId: cloudId
    });
    if (accessibleNouns.length > 1) accessibleProducts.push((0, $b4tvS.ProductKeys).Atlas);
    // Add third party products to the array
    if (configuration?.siteMetadata?.isRovoEnabled) {
        const { productKeys: thirdPartyProductKeys } = (0, $d6310552730441ce$export$4cb8ef4a677c563c)(thirdPartyConfig);
        accessibleProducts.push(...thirdPartyProductKeys);
    }
    // When the patch FG is enabled, always ensure primary product is in the list.
    // When the patch FG is disabled (future cleaned-up state), only insert primary
    // product as a last-resort fallback when the list would otherwise be empty.
    // TODO: Remove the fg() branch when rovo-search-patch-primary-product is cleaned up.
    if ((0, $dh538.fg)('rovo-search-patch-primary-product')) {
        if (!accessibleProducts.includes(primaryProduct)) accessibleProducts.unshift(primaryProduct);
    } else if (accessibleProducts.length === 0) accessibleProducts.unshift(primaryProduct);
    return accessibleProducts;
};
const $bed1ea961f397265$export$c635d3296555e2da = ({ configuration: configuration })=>{
    if (configuration?.siteMetadata?.productInfo?.length) {
        const entries = configuration.siteMetadata.productInfo.reduce((acc, product)=>{
            if (product.name) {
                const dataRegion = Array.isArray(product.dataRegion) ? product.dataRegion : typeof product.dataRegion === 'string' ? [
                    product.dataRegion
                ] : [];
                acc.push([
                    product.name,
                    dataRegion
                ]);
            }
            return acc;
        }, []);
        return Object.fromEntries(entries);
    } else return undefined;
};
const $bed1ea961f397265$export$53e066a63a960439 = ({ configuration: configuration })=>{
    const productEdition = configuration?.siteMetadata?.productEdition;
    if (typeof productEdition === 'string' && productEdition) return {
        confluence: productEdition
    };
    else return undefined;
};
const $bed1ea961f397265$export$37755e2ec7a40bc1 = ({ configuration: configuration, cloudId: cloudId })=>{
    if (configuration?.siteMetadata?.isRovoEnabled) // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    return (0, $d6310552730441ce$export$4cb8ef4a677c563c)((0, $de054ade02a2d419$export$160fbca21b53d78a)(configuration, cloudId).thirdPartyConfig).thirdPartyConfigs;
    else return {};
};
const $bed1ea961f397265$export$5a5f668a90736418 = (args)=>{
    const { configuration: configuration } = args;
    const accessibleProducts = $bed1ea961f397265$export$b38c0215344366f7(args);
    return {
        accessibleNouns: $bed1ea961f397265$export$fc6c3173f0bc0482(args),
        accessibleProducts: accessibleProducts,
        intercomHmac: configuration?.intercomHmac ?? undefined,
        isJiraIssueIndexed: Boolean(configuration?.siteMetadata?.isJiraIssueIndexed),
        isRovoEnabled: Boolean(configuration?.siteMetadata?.isRovoEnabled),
        productDataRegions: $bed1ea961f397265$export$c635d3296555e2da(args),
        productEdition: $bed1ea961f397265$export$53e066a63a960439(args),
        rovoFeatures: undefined,
        thirdPartyConfigs: $bed1ea961f397265$export$37755e2ec7a40bc1(args),
        supportedAccessibleProducts: (0, $1ikWy.getAccessibleProducts)({
            supportedProducts: (0, $b4tvS.getAllProductKeys)(),
            accessibleProducts: accessibleProducts
        })
    };
};



const $79c4d57fc1792dc7$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $79c4d57fc1792dc7$var$EMPTY_RESPONSE = [];
const $79c4d57fc1792dc7$export$2b0ac18f7cd43e19 = (props)=>{
    // These return the same type and are like for like replacements, this is the easiest way to safely FG without generating extra network calls.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $dh538.fg)('rovo_fps_use_rovo_config') ? $79c4d57fc1792dc7$export$d8e38f995daf9dc5(props) : $79c4d57fc1792dc7$export$757ae11853c85282(props);
/* eslint-enable react-hooks/rules-of-hooks */ };
const $79c4d57fc1792dc7$export$757ae11853c85282 = ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, activationId: activationId, preloadDataProvider: preloadDataProvider })=>{
    const supportedProducts = (0, $1yEFx.useProductConfigs)();
    // Unnecessary, should be removed to save react cycles
    const [firstPartyResponse, setFirstPartyResponse] = (0, $42omo.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $42omo.useState)(false);
    // Unnecessary, should be removed to save react cycles
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $42omo.useState)({});
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $42omo.useState)(undefined);
    // Combined Config Response
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $42omo.useState)();
    // Unnecessary, should be removed to save react cycles
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $42omo.useState)({
        nouns: []
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)({
        experience: experience
    });
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const logException = (0, $f8oYd.useLogException)();
    const firstCloudId = (0, $42omo.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $46834f5e82f1cd55$export$c1871fdf674a03c4)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = combinedThirdPartyResponse;
    const atlAttributionHeaders = (0, $42omo.useMemo)(()=>(0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: cloudIdProp,
            activationId: activationId,
            product: primaryProduct
        }), [
        cloudIdProp,
        activationId,
        primaryProduct
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $42omo.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $johDC.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: atlAttributionHeaders
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            // Move current cloudId to index 0 if it exists and isn't already there
            // This is a temporary solution for multiple site search in rovo with correct CloudIdARIs sequence
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                // Remove from current position and add to beginning
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl,
        atlAttributionHeaders
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            /**
       * Combined config caching strategy shared across both:
       * - network fetch path (`getCombinedSearchConfig`)
       * - SSR-preloaded network seed path (`seedCombinedConfigCacheEntry`)
       *
       * Strategy:
       * - refresh only when cached data is expired
       * - return cached value even if expired
       */ const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = {
                    searchSessionId: searchSessionId,
                    taskId: uxTaskId,
                    task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX
                };
                // DegradedDependency may not be visible to the end-user due to request caching. This is a health metric for our BE
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $dmTG5.onDegradedDependency)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: (0, $6yNqK.EVENT_SOURCE)
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3htW4.onRequestCacheAccess)({
                        requestName: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: (0, $6yNqK.EVENT_SOURCE)
                    }));
                };
                // Create network callbacks for tracking network requests
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $lGfXC.createVitalStatsNetworkCallbacks)(configNetworkTaskId, (0, $31eSD.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_NETWORK, searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    userId: userId,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks,
                    headers: atlAttributionHeaders
                };
                // Fire task start for UX tracking
                fireAnalyticsEvent((0, $bQSQw.onTaskStart)(baseUXVitalStatsParams));
                (0, $7GE7t.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $de054ade02a2d419$export$160fbca21b53d78a)(configuration, cloudIdProp);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse((0, $d6310552730441ce$export$4cb8ef4a677c563c)(thirdPartyConfig));
                    // Fire user experience metric - user got data (success from UX perspective)
                    fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    logException(error);
                    // FailedDependency is visible to the end-user. This is a health metric for our UX
                    fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        source: (0, $6yNqK.EVENT_SOURCE)
                    }));
                    // Fire user experience metric - user did not get data (failure from UX perspective)
                    fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $79c4d57fc1792dc7$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // We skip trying to access the config from the preload provider if
            // the preload came from Quick Find. The reason for this is that the
            // combined config call will have already been cached in memory and
            // there's no reason to pipe it through the preload provider.
            let isPreloadFromQuickFind = false;
            if ((0, $2OtFZ.isQuickFindAsyncPreloadEnabled)()) try {
                const preloadedSearch = preloadDataProvider?.getPreloadedSearch({
                    cloudId: cloudIdProp
                });
                isPreloadFromQuickFind = Boolean(preloadedSearch && preloadedSearch.source === 'quick-find');
            } catch  {
            // Reading the preload provider should never throw, but be defensive
            // — a bad lookup must not block config loading.
            }
            if (preloadDataProvider && !isPreloadFromQuickFind) {
                try {
                    const preloadedSearch = preloadDataProvider.getPreloadedSearch({
                        cloudId: cloudIdProp
                    });
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = {
                            searchSessionId: searchSessionId,
                            taskId: preloadUxTaskId,
                            task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX,
                            moreContext: preloadMoreContext
                        };
                        fireAnalyticsEvent((0, $bQSQw.onTaskStart)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $de054ade02a2d419$export$160fbca21b53d78a)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $d6310552730441ce$export$4cb8ef4a677c563c)(thirdPartyConfig));
                            if (!preloadedSearch.isConfigFromCache) (0, $7GE7t.seedCombinedConfigCacheEntry)({
                                cloudId: cloudIdProp,
                                userId: userId,
                                config: preloadedSearch.config,
                                expiration: combinedConfigTTL
                            }).catch((seedError)=>{
                                logException(seedError);
                            });
                            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            if (preloadedSearch.isConfigFromCache) // Preload gives immediate UI data, but we still run the normal combined-config
                            // path so cache TTL rules can trigger a network refresh when the entry is expired.
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        } catch (error) {
                            logException(error);
                            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                        dependency: 'search-config-ssr',
                        searchSessionId: searchSessionId,
                        source: (0, $6yNqK.EVENT_SOURCE),
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    logException(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        userId,
        aggAbsoluteUrl,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        atlAttributionHeaders,
        preloadDataProvider
    ]);
    (0, $42omo.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($79c4d57fc1792dc7$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2 && match[1] in supportedProducts) return [
                        match[1]
                    ];
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) // Use the primary product if the 1P Search Config request fails
            allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            // Always ensure the primary product is in the list, even if the config
            // response doesn't include it (e.g. resources only contain other products).
            // This mirrors the error fallback behavior where the primary product is
            // always available so users can search within their hosting product.
            if (primaryProduct && !allAccessibleProducts.includes(primaryProduct) && (0, $dh538.fg)('rovo-search-patch-primary-product')) allAccessibleProducts.unshift(primaryProduct);
            // Goal and Project nouns are now returned via the first party product list in the combined config response.
            const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match($79c4d57fc1792dc7$var$EXTRACT_PRODUCT);
                if (match && match.length >= 2 && match[1] in (0, $4EMbH.nouns)) return [
                    match[1]
                ];
                return [];
            });
            // If nouns are available we also need to add Townsquare to the list of accessible products.
            // This way Projects will be fetched by default when no filters are selected.
            if (accessibleNouns.length > 0) allAccessibleProducts.push((0, $b4tvS.ProductKeys).Atlas);
            // with combined config, bitbucket is handled in the BE
            // Allow 3P products only if a user has Rovo enabled.
            // Long-term it won't be needed if the 3p-configuration check ensures Rovo eligibility.
            // See https://hello.atlassian.net/wiki/spaces/SEARCH/pages/4469899124.
            const doesUserHaveRovo = (0, $46834f5e82f1cd55$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products,
        supportedProducts
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const parsedConfigFromNewCombinedConfigParser = (0, $42omo.useMemo)(()=>{
        if (primaryProduct && cloudIdProp && combinedConfigResponse) {
            const parsedCombinedConfig = (0, $bed1ea961f397265$export$5a5f668a90736418)({
                configuration: combinedConfigResponse,
                primaryProduct: primaryProduct,
                cloudId: cloudIdProp
            });
            return {
                ...parsedCombinedConfig,
                firstCloudId: '',
                isConfigLoaded: // cloudId must always exist when using the combined endpoint, hence we don't infer one
                isConfigLoaded,
                linkedCloudARIs: linkedCloudARIs,
                onOAuthSuccess: undefined
            };
        }
        return null;
    }, [
        primaryProduct,
        cloudIdProp,
        combinedConfigResponse,
        isConfigLoaded,
        linkedCloudARIs
    ]);
    if (parsedConfigFromNewCombinedConfigParser) return parsedConfigFromNewCombinedConfigParser;
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isRovoEnabled: (0, $46834f5e82f1cd55$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $46834f5e82f1cd55$export$37c9c6a3ae5f363c)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $46834f5e82f1cd55$export$53e066a63a960439)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $46834f5e82f1cd55$export$c635d3296555e2da)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $46834f5e82f1cd55$export$2a1c0662041ee0a3)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs,
        onOAuthSuccess: undefined
    };
};
const $79c4d57fc1792dc7$export$d8e38f995daf9dc5 = ({ cloudId: cloudId, userId: userId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, preloadDataProvider: preloadDataProvider })=>{
    // TODO RAOC-22: these will being removed from the useRovoConfig API and handled internally to that package
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)({
        experience: experience
    });
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const logException = (0, $f8oYd.useLogException)();
    const rovoConfig = (0, $8yIwZ.useRovoConfig)({
        cloudId: cloudId,
        userId: userId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        // `SearchPreloadDataProvider` (search-page) is a structural
        // superset of `RovoConfigPreloadProvider`
        // (rovo-connectors-config). Both have the same
        // `getPreloadedSearch` / `clearPreloadedSearch` contract; the
        // search-page provider just exposes more fields on
        // `SearchPreloadData` than the narrow `RovoConfigPreloadData`
        // type references.
        preloadDataProvider: preloadDataProvider,
        shouldBypassPreloadProvider: (preloaded)=>(0, $2OtFZ.isQuickFindAsyncPreloadEnabled)() && preloaded?.source === 'quick-find',
        analytics: {
            fireAnalyticsEvent: fireAnalyticsEvent,
            logException: logException,
            searchSessionId: searchSessionId,
            source: (0, $6yNqK.EVENT_SOURCE)
        },
        onForgeConnectorTypeMapping: (0, $1xk5k.registerForgeConnectorTypeMapping)
    });
    return (0, $42omo.useMemo)(()=>{
        const { combinedConfigResponse: _ignored, accessibleProducts: accessibleProducts, ...rest } = rovoConfig;
        const list = accessibleProducts ?? [];
        /**
     * Primary product fallback logic:
     * - If `primaryProduct` is not set or config has not loaded, do nothing (return the list as-is, even if empty).
     * - If `rovo-search-patch-primary-product` is ON, ensure the primary product is in the list (add it if missing).
     * - If the FG is OFF, only add the primary product if the list is empty (legacy fallback behavior).
     */ if (!primaryProduct || !rest.isConfigLoaded) return {
            ...rest,
            accessibleProducts: accessibleProducts
        };
        if ((0, $dh538.fg)('rovo-search-patch-primary-product')) {
            if (list.includes(primaryProduct)) return {
                ...rest,
                accessibleProducts: list
            };
            return {
                ...rest,
                accessibleProducts: [
                    primaryProduct,
                    ...list
                ]
            };
        }
        // Legacy last-resort behaviour: only insert when the list is empty.
        if (list.length === 0) return {
            ...rest,
            accessibleProducts: [
                primaryProduct
            ]
        };
        return {
            ...rest,
            accessibleProducts: list
        };
    }, [
        rovoConfig,
        primaryProduct
    ]);
};






var $lgPOO = parcelRequire("lgPOO");





var $gSaNw = parcelRequire("gSaNw");

const $d178f4c20cce9572$export$8a525a626086c807 = ({ children: children, experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE, ...props })=>{
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, preloadDataProvider: preloadDataProvider, orgId: orgId, analyticsAttributes: analyticsAttributes, products: products, queryParams: queryParams, features: features, searchSessionId: searchSessionId, callbacks: callbacks, experimentLayers: experimentLayers, hasEditOrViewPlanPermission: hasEditOrViewPlanPermission } = props;
    const onError = (0, $f8oYd.useLogException)();
    const bootstrapProviderExp = (0, $gSaNw.serveBootstrapProviderExp)();
    const smartLinkUsage = (0, $eO6NY.useFetchSmartLinkUsage)(experience, cloudId);
    // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed in StaticContextProvider
    // via getExperimentConfig. We still call useExperimentConfig unconditionally (rules of hooks) but don't
    // pass the result through initialProps on the FG-on path.
    // Keep in sync with: bootstrap-context-provider/static-context-provider/index.tsx
    const experimentConfig = (0, $gkXKl.useExperimentConfig)({
        primaryProduct: primaryProduct,
        experimentLayers: experimentLayers ?? [],
        sideBySideExperiment: features?.sideBySide?.experiments,
        statsigLayer: undefined,
        onError: onError
    });
    // Compute multiSiteSearchInRovo independently for useFetchConfig.
    // Under FG-on, we avoid depending on experimentConfig for this value since experimentConfig
    // will be owned by StaticContextProvider. This direct Statsig call is pure and side-effect-free.
    const multiSiteSearchInRovo = (0, $gSaNw.serveBootstrapProviderExp)() ? (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    }).cohort === 'test' : (0, $2OtFZ.getMultiSiteSearchInRovo)(experimentConfig);
    const { accessibleProducts: accessibleProducts, accessibleNouns: accessibleNouns, thirdPartyConfigs: thirdPartyConfigs, firstCloudId: firstCloudId, intercomHmac: intercomHmac, isRovoEnabled: isRovoEnabled, isJiraIssueIndexed: isJiraIssueIndexed, productEdition: productEdition, productDataRegions: productDataRegions, rovoFeatures: rovoFeatures, isConfigLoaded: isConfigLoaded, linkedCloudARIs: linkedCloudARIs, onOAuthSuccess: onOAuthSuccess } = (0, $79c4d57fc1792dc7$export$2b0ac18f7cd43e19)({
        cloudId: cloudId,
        configFetchAbsoluteUrl: configFetchAbsoluteUrl,
        aggregatorHostName: aggregatorHostName,
        preloadDataProvider: preloadDataProvider,
        userId: user?.id,
        primaryProduct: primaryProduct,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        experience: experience,
        activationId: analyticsAttributes?.activationId
    });
    // Must be called after useFetchConfig so we have the resolved thirdPartyConfigs
    // and productEdition. Reading these from the bootstrap store here would be a
    // circular read.
    const smartLinkUsageAndTopApps = (0, $8801996e88559d75$export$bb9929b0c526b28f)(experience, primaryProduct, cloudId, thirdPartyConfigs, productEdition);
    const allFilterExcludedProducts = (0, $42omo.useMemo)(()=>[
            (0, $b4tvS.ProductKeys).Trello,
            (0, $b4tvS.ProductKeys).Gmail,
            (0, $b4tvS.ProductKeys).OutlookMail
        ], []);
    const getInitialProps = (0, $42omo.useCallback)(()=>{
        let storeContainerInitialProps = {
            cloudId: cloudId ?? firstCloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            SAINHostName: SAINHostName,
            aggregatorHostName: aggregatorHostName,
            user: user,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            orgId: orgId,
            analyticsAttributes: analyticsAttributes,
            features: features,
            // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed
            // in StaticContextProvider via getExperimentConfig instead of being passed through here.
            ...!(0, $gSaNw.serveBootstrapProviderExp)() && {
                experimentConfig: experimentConfig
            },
            experimentLayers: experimentLayers,
            intercomHmac: intercomHmac,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isConfigLoaded: isConfigLoaded,
            // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed
            // in StaticContextProvider instead of here. Pass raw products through.
            products: (0, $gSaNw.serveBootstrapProviderExp)() ? products : (0, $1ikWy.getAccessibleProducts)({
                supportedProducts: (0, $b4tvS.getAllProductKeys)(),
                products: products,
                accessibleProducts: accessibleProducts
            }),
            nouns: accessibleNouns,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            linkedCloudARIs: linkedCloudARIs,
            hasEditOrViewPlanPermission: hasEditOrViewPlanPermission,
            smartLinkUsage: smartLinkUsage,
            smartLinkUsageAndTopApps: smartLinkUsageAndTopApps
        };
        if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
        if (accessibleProducts) storeContainerInitialProps.thirdPartyConfigs = thirdPartyConfigs;
        return storeContainerInitialProps;
    }, [
        cloudId,
        firstCloudId,
        aggAbsoluteUrl,
        SAINHostName,
        aggregatorHostName,
        user,
        primaryProduct,
        primarySubProduct,
        orgId,
        analyticsAttributes,
        features,
        experimentConfig,
        intercomHmac,
        isRovoEnabled,
        isJiraIssueIndexed,
        isConfigLoaded,
        products,
        accessibleProducts,
        accessibleNouns,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        searchSessionId,
        thirdPartyConfigs,
        rovoFeatures,
        linkedCloudARIs,
        experimentLayers,
        hasEditOrViewPlanPermission,
        smartLinkUsage,
        smartLinkUsageAndTopApps
    ]);
    if (bootstrapProviderExp) {
        const initialProps = getInitialProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "bootstrap-context"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.BootstrapContextProvider), {
            initialProps: initialProps,
            queryParams: queryParams,
            queryParamsCallback: callbacks?.updateQueryParameters,
            getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
            onSearchCompleted: callbacks?.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess,
            experience: experience,
            accessibleProducts: accessibleProducts
        }, children));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "bootstrap-rss"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j4ply.BootstrapStoreContainer), {
        initialProps: getInitialProps(),
        queryParams: queryParams,
        queryParamsCallback: callbacks?.updateQueryParameters,
        getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
        onSearchCompleted: callbacks?.onSearchCompleted,
        onOAuthSuccess: onOAuthSuccess
    }, children));
};


var $24d120d5a9177b55$export$2e2bcd8739ae039 = (0, $d178f4c20cce9572$export$8a525a626086c807);

});

parcelRegister("bHLTK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $j4ply = parcelRequire("j4ply");


var $ehGUC = parcelRequire("ehGUC");


var $djVCD = parcelRequire("djVCD");

const $4622611068a1c461$export$3776ece9f99ed2df = ({ children: children, experience: experience = 'search-page' })=>{
    const [shouldAutoSelectPrimaryProduct, setShouldAutoSelectPrimaryProduct] = (0, $42omo.useState)(true);
    const intl = (0, $aXWIB.useIntl)();
    const [queryParams] = (0, $j4ply.useQueryParams)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [aggAbsoluteUrl] = (0, $j4ply.useAggAbsoluteUrl)();
    const [initialSpaceARIs] = (0, $j4ply.useInitialSpaceARIs)();
    const [user] = (0, $j4ply.useUser)();
    const products = (0, $j4ply.useAvailableProducts)();
    const [allFilterExcludedProducts] = (0, $j4ply.useAllFilterExcludedProducts)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    const [productDataRegions] = (0, $j4ply.useProductDataRegions)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const setQueryParams = (0, $j4ply.useSetQueryParams)(queryParams);
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const primaryProductToAutoSelect = (0, $j4ply.useAutoSelectPrimaryProduct)();
    const config = (0, $42omo.useMemo)(()=>({
            aggAbsoluteUrl: aggAbsoluteUrl,
            ari: '',
            cloudId: cloudId,
            experimentConfig: experimentConfig,
            initialSpaceARIs: initialSpaceARIs,
            // Default to an empty array so downstream `Array.isArray(config.contributorAccountIds)`
            // checks (in 3p Space / Content Under typeahead queries) succeed before any
            // contributor selection has been merged into the config by
            // loadInitialSelectFilterOptions / setSelectFilterLookupInput. The actions
            // downstream replace this with the live `allFiltersState.contributor.value` when a
            // contributor is selected.
            contributorAccountIds: [],
            intl: intl,
            productDataRegions: productDataRegions,
            productEdition: productEdition,
            userId: user?.id || '',
            product: queryParams?.product,
            primaryProduct: primaryProduct,
            orgId: orgId,
            thirdPartyConfigs: thirdPartyConfigs,
            activationId: analyticsAttributes?.activationId
        }), [
        aggAbsoluteUrl,
        cloudId,
        experimentConfig,
        initialSpaceARIs,
        intl,
        productDataRegions,
        productEdition,
        user?.id,
        queryParams?.product,
        primaryProduct,
        orgId,
        thirdPartyConfigs,
        analyticsAttributes?.activationId
    ]);
    const queryParamsInUse = (0, $42omo.useMemo)(()=>{
        const { lastModified_lt: _lastModified_lt, lastModified_gt: _lastModified_gt, ...queryParamsInUse } = queryParams;
        return queryParamsInUse;
    }, [
        queryParams
    ]);
    // primaryProductToAutoSelect will be set to the primary product if the user is in unified search
    // and no product is selected
    // This is to ensure that the primary product is selected by default for unified search
    (0, $42omo.useEffect)(()=>{
        if (products && products.length > 0) {
            if (shouldAutoSelectPrimaryProduct && primaryProductToAutoSelect) setQueryParams({
                ...queryParams,
                product: primaryProductToAutoSelect
            });
            setShouldAutoSelectPrimaryProduct(false);
        }
    }, [
        applicationMode,
        primaryProduct,
        primaryProductToAutoSelect,
        products,
        queryParams,
        setQueryParams,
        shouldAutoSelectPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djVCD.SearchStoreContainer), {
        queryParams: queryParamsInUse,
        allFilters: (0, $ehGUC.allFilters),
        config: config,
        setQueryParams: setQueryParams,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts,
        applicationMode: applicationMode,
        primaryProduct: primaryProduct,
        thirdPartyConfigs: thirdPartyConfigs,
        experience: experience
    }, children);
};
module.exports["SearchStoreProvider"] = $4622611068a1c461$export$3776ece9f99ed2df;

});

parcelRegister("ehGUC", function(module, exports) {
$parcel$export(module.exports, "assigneeFilter", () => (parcelRequire("5X4Ay")).filter);
$parcel$export(module.exports, "commentedByMeFilter", () => (parcelRequire("2a0ps")).filter);
$parcel$export(module.exports, "contributorFilter", () => (parcelRequire("aGXLL")).filter);
$parcel$export(module.exports, "projectFilter", () => (parcelRequire("gHwfH")).filter);
$parcel$export(module.exports, "spaceFilter", () => (parcelRequire("a97k3")).filter);
$parcel$export(module.exports, "watchedFilter", () => (parcelRequire("9DkM9")).filter);
$parcel$export(module.exports, "assetsSchemaFilter", () => (parcelRequire("lx1ar")).filter);
$parcel$export(module.exports, "assetsTypeFilter", () => (parcelRequire("iUihD")).filter);
$parcel$export(module.exports, "sortFilter", () => (parcelRequire("fJFyr")).filter);
$parcel$export(module.exports, "hasAttachmentFilter", () => (parcelRequire("lPWNq")).filter);
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $5iakG = parcelRequire("5iakG");


var $fw303 = parcelRequire("fw303");


var $k7ise = parcelRequire("k7ise");


var $lx1ar = parcelRequire("lx1ar");


var $iUihD = parcelRequire("iUihD");


var $5X4Ay = parcelRequire("5X4Ay");


var $5VnRb = parcelRequire("5VnRb");


var $F3Hv6 = parcelRequire("F3Hv6");


var $hHAPz = parcelRequire("hHAPz");


var $2a0ps = parcelRequire("2a0ps");


var $dQXZO = parcelRequire("dQXZO");


var $aGXLL = parcelRequire("aGXLL");


var $c5dmm = parcelRequire("c5dmm");


var $6jSbc = parcelRequire("6jSbc");


var $e7L4o = parcelRequire("e7L4o");


var $lPWNq = parcelRequire("lPWNq");


var $gwbWt = parcelRequire("gwbWt");


var $1uGSo = parcelRequire("1uGSo");


var $huubg = parcelRequire("huubg");


var $dFCIx = parcelRequire("dFCIx");


var $5ousX = parcelRequire("5ousX");


var $1sswv = parcelRequire("1sswv");


var $jqLa8 = parcelRequire("jqLa8");


var $fLju9 = parcelRequire("fLju9");


var $dXdDw = parcelRequire("dXdDw");


var $5eFo6 = parcelRequire("5eFo6");


var $aeffu = parcelRequire("aeffu");


var $gHwfH = parcelRequire("gHwfH");


var $3TPSi = parcelRequire("3TPSi");


var $f1JPm = parcelRequire("f1JPm");


var $dzNsR = parcelRequire("dzNsR");


var $720nW = parcelRequire("720nW");


var $iz3ta = parcelRequire("iz3ta");


var $fJFyr = parcelRequire("fJFyr");


var $a97k3 = parcelRequire("a97k3");


var $b6IhR = parcelRequire("b6IhR");


var $iaYRG = parcelRequire("iaYRG");


var $dUIpv = parcelRequire("dUIpv");


var $bF9JE = parcelRequire("bF9JE");


var $9DkM9 = parcelRequire("9DkM9");

const $7ad99be56c688d66$export$d8428ac7d93fb69a = Object.freeze({
    [(0, $1uGSo.filter).id]: (0, $1uGSo.filter),
    [(0, $aGXLL.filter).id]: (0, $aGXLL.filter),
    [(0, $a97k3.filter).id]: (0, $a97k3.filter),
    [(0, $9DkM9.filter).id]: (0, $9DkM9.filter),
    [(0, $bF9JE.filter).id]: (0, $bF9JE.filter),
    [(0, $5X4Ay.filter).id]: (0, $5X4Ay.filter),
    [(0, $f1JPm.filter).id]: (0, $f1JPm.filter),
    [(0, $2a0ps.filter).id]: (0, $2a0ps.filter),
    [(0, $gHwfH.filter).id]: (0, $gHwfH.filter),
    [(0, $5iakG.universalTypeFilterId)]: (0, $dUIpv.filter),
    [(0, $dQXZO.filter).id]: (0, $dQXZO.filter),
    [(0, $iaYRG.filter).id]: (0, $iaYRG.filter),
    [(0, $5ousX.filter).id]: (0, $5ousX.filter),
    [(0, $c5dmm.filter).id]: (0, $c5dmm.filter),
    [(0, $gwbWt.filter).id]: (0, $gwbWt.filter),
    [(0, $6jSbc.filter).id]: (0, $6jSbc.filter),
    [(0, $e7L4o.filter).id]: (0, $e7L4o.filter),
    [(0, $1sswv.filter).id]: (0, $1sswv.filter),
    [(0, $fw303.filter).id]: (0, $fw303.filter),
    [(0, $huubg.filter).id]: (0, $huubg.filter),
    [(0, $b6IhR.filter).id]: (0, $b6IhR.filter),
    [(0, $k7ise.filter).id]: (0, $k7ise.filter),
    [(0, $lx1ar.filter).id]: (0, $lx1ar.filter),
    [(0, $iUihD.filter).id]: (0, $iUihD.filter),
    [(0, $5eFo6.filter).id]: (0, $5eFo6.filter),
    [(0, $jqLa8.filter).id]: (0, $jqLa8.filter),
    [(0, $dXdDw.filter).id]: (0, $dXdDw.filter),
    [(0, $aeffu.filter).id]: (0, $aeffu.filter),
    [(0, $fLju9.filter).id]: (0, $fLju9.filter),
    [(0, $dFCIx.filter).id]: (0, $dFCIx.filter),
    [(0, $5VnRb.filter).id]: (0, $5VnRb.filter),
    [(0, $F3Hv6.filter).id]: (0, $F3Hv6.filter),
    [(0, $fJFyr.filter).id]: (0, $fJFyr.filter),
    [(0, $720nW.filter).id]: (0, $720nW.filter),
    [(0, $dzNsR.filter).id]: (0, $dzNsR.filter),
    [(0, $hHAPz.filter).id]: (0, $hHAPz.filter),
    [(0, $3TPSi.filter).id]: (0, $3TPSi.filter),
    [(0, $iz3ta.filter).id]: (0, $iz3ta.filter),
    [(0, $lPWNq.filter).id]: (0, $lPWNq.filter)
});
module.exports["allFilters"] = $7ad99be56c688d66$export$d8428ac7d93fb69a;

});

parcelRegister("lx1ar", function(module, exports) {

var $f6o22 = parcelRequire("f6o22");


var $jwO5V = parcelRequire("jwO5V");


var $lldrI = parcelRequire("lldrI");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

const $f0e9e4856ecf1749$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Assets
];
const $f0e9e4856ecf1749$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'assetsSchema',
    products: $f0e9e4856ecf1749$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsSchema',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allSchemas = await (0, $lldrI.assetsSchemasQuery)(queryParams, headers);
            const hydratedSchemaOptions = allSchemas.data?.assets_schemasByIds?.map((schema)=>{
                return {
                    trackingKey: schema.id,
                    value: schema.id,
                    queryParamValue: schema.id,
                    label: schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false
                };
            });
            return hydratedSchemaOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedSchemas = await (0, $f6o22.searchAssetsSchemas)();
            const recommendedSchemaOptions = suggestedSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: schema.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false
                };
            });
            return recommendedSchemaOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultSchemas = await (0, $f6o22.searchAssetsSchemas)(query);
            const searchSchemaOptions = resultSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false
                };
            });
            return searchSchemaOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Assets
});
module.exports["filter"] = $f0e9e4856ecf1749$export$3dea766d36a8935f;

});

parcelRegister("f6o22", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");

const $d45fe597670d508d$export$3317731fce42efc4 = 'assets-workspace-id';
const { refreshOnAccessDecorator: $d45fe597670d508d$var$refreshOnAccessDecoratorAssets } = (0, $jnPv4.promiseCache)({
    name: $d45fe597670d508d$export$3317731fce42efc4,
    expiration: 86400000 // 24 hours
});
async function $d45fe597670d508d$export$7397855f2e1b36a6() {
    const url = '/rest/servicedesk/cmdb/latest/workspace';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)($d45fe597670d508d$export$3317731fce42efc4);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    const response = await $d45fe597670d508d$var$refreshOnAccessDecoratorAssets({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false,
        onlyRefreshIfExpired: true
    });
    const ids = response.results ?? [];
    return ids.length ? ids[0].id : null;
}
async function $d45fe597670d508d$export$54126e20e262ab6a(query = '', maxResults = 3) {
    const workspaceId = await $d45fe597670d508d$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema/list?maxResults=${maxResults}&includeCounts=false${query ? `&query=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const schemas = responseData.values ?? [];
        const transformedSchemas = schemas.map((schema)=>({
                ...schema,
                schemaLabel: schema.name,
                ari: `ari:cloud:cmdb::schema/${workspaceId}/${schema.id}`
            }));
        return transformedSchemas;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
async function $d45fe597670d508d$export$ba9ddace9845bd14(query = '', maxResults = 3) {
    const workspaceId = await $d45fe597670d508d$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttype/all/list?pageSize=${maxResults}${query ? `&filterBy=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const types = responseData.data ?? [];
        const transformedTypes = types.map((type)=>({
                ...type,
                ari: `ari:cloud:cmdb::type/${workspaceId}/${type.id}`
            }));
        return transformedTypes;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
module.exports["searchAssetsSchemas"] = $d45fe597670d508d$export$54126e20e262ab6a;
module.exports["searchAssetsTypes"] = $d45fe597670d508d$export$ba9ddace9845bd14;

});

parcelRegister("lldrI", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $4019b67a14efb803$var$GQL_ASSETS_SCHEMAS_NAME = 'SearchPageAssetsSchemasQuery';
const $4019b67a14efb803$var$assetsSchemasQueryString = `query ${$4019b67a14efb803$var$GQL_ASSETS_SCHEMAS_NAME}(
	$schemaARIs: [ID!]!) {
		assets_schemasByIds(ids: $schemaARIs) {
    		id
    		key
    		name
    		sequentialId @optIn(to: "AssetsApFields")
  		}
	}`;
const $4019b67a14efb803$export$2ab52cbd1429b72b = (0, $hw4j5.inMemoryCache)();
const $4019b67a14efb803$export$3c3ad61134eb56ad = async (schemaARIs, headers)=>{
    return $4019b67a14efb803$export$2ab52cbd1429b72b.inMemoryDecorator(`${schemaARIs}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $4019b67a14efb803$var$assetsSchemasQueryString,
            variables: {
                schemaARIs: schemaARIs
            },
            headers: {
                'X-ExperimentalApi': 'AssetsSchemas',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsSchemasQuery"] = $4019b67a14efb803$export$3c3ad61134eb56ad;

});

parcelRegister("iUihD", function(module, exports) {

var $f6o22 = parcelRequire("f6o22");


var $jwO5V = parcelRequire("jwO5V");


var $cDIp4 = parcelRequire("cDIp4");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

const $3d6dea92f1cbe7be$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Assets
];
const $3d6dea92f1cbe7be$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'assetsType',
    products: $3d6dea92f1cbe7be$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsType',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allTypes = await (0, $cDIp4.assetsObjectTypesQuery)(queryParams, headers);
            const hydratedTypeOptions = allTypes.data?.assets_objectTypesByIds?.map((type)=>{
                return {
                    trackingKey: type.id,
                    value: type.id,
                    queryParamValue: type.id,
                    label: type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: type.schema.name
                    }
                };
            });
            return hydratedTypeOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedTypes = await (0, $f6o22.searchAssetsTypes)();
            const recommendedTypeOptions = suggestedTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: type.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: type.schemaLabel
                    }
                };
            });
            return recommendedTypeOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultTypes = await (0, $f6o22.searchAssetsTypes)(query);
            const searchTypeOptions = resultTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: type.schemaLabel
                    }
                };
            });
            return searchTypeOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Assets
});
module.exports["filter"] = $3d6dea92f1cbe7be$export$3dea766d36a8935f;

});

parcelRegister("cDIp4", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $12919923fb6e43fb$var$GQL_ASSETS_OBJECT_TYPES_NAME = 'SearchPageAssetsObjectTypesQuery';
const $12919923fb6e43fb$var$assetsObjectTypesQueryString = `query ${$12919923fb6e43fb$var$GQL_ASSETS_OBJECT_TYPES_NAME}(
	$objectTypeARIs: [ID!]!) {
		assets_objectTypesByIds(ids: $objectTypeARIs) {
    		id
    		name
    		sequentialId @optIn(to: "AssetsApFields")
    		icon {
      			url16
    		}
    		schema {
      			name
    		}
  		}
	}`;
const $12919923fb6e43fb$export$4b370fc8e83d008b = (0, $hw4j5.inMemoryCache)();
const $12919923fb6e43fb$export$b573ef4e7e3425c7 = async (objectTypeARIs, headers)=>{
    return $12919923fb6e43fb$export$4b370fc8e83d008b.inMemoryDecorator(`${objectTypeARIs}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $12919923fb6e43fb$var$assetsObjectTypesQueryString,
            variables: {
                objectTypeARIs: objectTypeARIs
            },
            operationName: $12919923fb6e43fb$var$GQL_ASSETS_OBJECT_TYPES_NAME,
            headers: {
                'X-ExperimentalApi': 'AssetsObjectTypes',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsObjectTypesQuery"] = $12919923fb6e43fb$export$b573ef4e7e3425c7;

});

parcelRegister("2CQZl", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $807072fc846be7b2$export$83f72e15d115a0e7 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'assignee',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getAssignees"] = $807072fc846be7b2$export$83f72e15d115a0e7;

});

parcelRegister("i8MOh", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $00597ab6f62a5638$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
const $00597ab6f62a5638$var$GQL_OPERATION_NAME = 'SearchPageUserQuery';
const $00597ab6f62a5638$var$getUserQuery = ()=>`
query ${$00597ab6f62a5638$var$GQL_OPERATION_NAME}($accountId: ID!) {
  user(accountId: $accountId) {
    id
    accountId
    name
    picture
  }
}
`;
const $00597ab6f62a5638$export$25f4d46d5dabadfc = (accountId, headers)=>{
    return $00597ab6f62a5638$export$69a3209f1a06c04d.inMemoryDecorator(accountId, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $00597ab6f62a5638$var$getUserQuery(),
            variables: {
                accountId: accountId
            },
            operationName: $00597ab6f62a5638$var$GQL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
const $00597ab6f62a5638$export$c3d7afa7f49d431e = (0, $hw4j5.inMemoryCache)();
const $00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME = 'SearchPageUsersQuery';
const $00597ab6f62a5638$var$getUsersQuery = ()=>`
query ${$00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    id
    name
    picture
    accountId
  }
}
`;
const $00597ab6f62a5638$export$ef7fb495aeba8901 = (accountIds, headers)=>{
    return $00597ab6f62a5638$export$c3d7afa7f49d431e.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per user id
    accountIds.join(','), async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $00597ab6f62a5638$var$getUsersQuery(),
            variables: {
                accountIds: accountIds
            },
            operationName: $00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["usersQuery"] = $00597ab6f62a5638$export$ef7fb495aeba8901;

});

parcelRegister("cxsgw", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $647d8a1794bbb565$var$operationName = 'FPSConfluenceSmartUsersQuery';
const $647d8a1794bbb565$var$SmartsRecommendedUserQuery = `
query ${$647d8a1794bbb565$var$operationName}($userId: String!, $tenantId: String!, $maxNumberOfResults: Int!) {
  smarts {
    results: recommendedUser(
      recommendationsQuery: {
        context: {
          userId: $userId
          tenantId: $tenantId
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search"
          experience: "CgUserNearbyUser"
        }
        requestingUserId: $userId
        maxNumberOfResults: $maxNumberOfResults
      }
    ) {
      id
      user {
        accountId
        name
        picture
      }
    }
  }
}
`;
const $647d8a1794bbb565$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $647d8a1794bbb565$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $647d8a1794bbb565$export$74adda2a74e06fa9 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$647d8a1794bbb565$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $647d8a1794bbb565$var$SmartsRecommendedUserQuery,
            operationName: $647d8a1794bbb565$var$operationName,
            headers: headers
        }), $647d8a1794bbb565$var$expireWhen);
module.exports["smartsRecommendedUserQuery"] = $647d8a1794bbb565$export$74adda2a74e06fa9;

});

parcelRegister("jXNWU", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");

const $873f5aaeb784a6a1$export$c5dfc39e7764783c = 'searchThirdPartyFilterOptions';
const $873f5aaeb784a6a1$export$417982613a1b9ae2 = `
query ${$873f5aaeb784a6a1$export$c5dfc39e7764783c}($cloudId: ID!, $datasourceId: String!, $orgId: String) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartyFilterOptions(datasourceId: $datasourceId, orgId: $orgId) {
        filters {
          name
          values {
            name
            label
          }
        }
      }
    }
  }
}`;
const $873f5aaeb784a6a1$export$cbfaf396d242dba9 = ()=>$873f5aaeb784a6a1$export$417982613a1b9ae2;


const $f10b449f037fa26e$export$cd224500ea4a2de1 = async ({ cloudId: cloudId, datasourceId: datasourceId, orgId: orgId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    try {
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: (0, $873f5aaeb784a6a1$export$cbfaf396d242dba9)(),
            variables: {
                cloudId: cloudId,
                datasourceId: datasourceId,
                orgId: orgId != null && orgId !== '' ? orgId : null
            },
            operationName: (0, $873f5aaeb784a6a1$export$c5dfc39e7764783c),
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const filterOptions = response.data?.search?.configuration?.thirdPartyFilterOptions ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $873f5aaeb784a6a1$export$c5dfc39e7764783c)}] GraphQL errors for datasource "${datasourceId}":`, response.errors);
            if (!filterOptions) throw new Error(`[${(0, $873f5aaeb784a6a1$export$c5dfc39e7764783c)}] GraphQL errors prevented loading third-party filter options for datasource "${datasourceId}"`);
        }
        return filterOptions;
    } catch (error) {
        console.error(`[${(0, $873f5aaeb784a6a1$export$c5dfc39e7764783c)}] Failed to fetch third-party filter options for datasource "${datasourceId}":`, error);
        throw error;
    }
};
module.exports["getThirdPartyFilterOptions"] = $f10b449f037fa26e$export$cd224500ea4a2de1;

});

parcelRegister("jxvxe", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $48a5c8423b40f47c$export$fe2cce9cc2f02a10 = (0, $hw4j5.inMemoryCache)();
const $48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME = 'SearchPageConfluencePagesQuery';
const $48a5c8423b40f47c$var$getConfluencePagesQuery = ()=>`
query ${$48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME}($pageIds: [ID]!) {
  confluence {
    pages(ids: $pageIds) {
      id
      title
      type
      links {
        base
      }
    }
  }
}
`;
const $48a5c8423b40f47c$export$eeab7469706cab80 = (pageIds, headers)=>{
    return $48a5c8423b40f47c$export$fe2cce9cc2f02a10.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    pageIds.join(','), async ()=>{
        if (pageIds.length === 0) return {
            data: {
                confluence: {
                    pages: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $48a5c8423b40f47c$var$getConfluencePagesQuery(),
            variables: {
                pageIds: pageIds
            },
            operationName: $48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluencePagesQuery"] = $48a5c8423b40f47c$export$eeab7469706cab80;

});

parcelRegister("i14PY", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $654994348c889f70$var$operationName = 'SearchEntitiesQuery';
const $654994348c889f70$var$getSearchEntitiesQuery = ({ includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>{
    const SearchConfluenceSpace = `
    ... on SearchConfluenceSpace {
      key
    }
  `;
    // containerId is available on ExternalDocument entity (3P documents like Google Drive folders)
    const ContainerIdFragment = `
    ... on SearchResultGraphDocument {
      entity {
        ... on ExternalDocument {
          containerId
        }
      }
    }
  `;
    return `
  query ${$654994348c889f70$var$operationName}(
		$experience: String!, 
		$query: String!, 
		$first: Int, 
		$filters: SearchFilterInput!
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
	) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $first
        filters: $filters
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
      ) {
        edges {
          node {
            id
            title
            type
            url
            iconUrl
            ${includeSpaceKey ? SearchConfluenceSpace : ``}
            ${includeContainerId ? ContainerIdFragment : ``}
          }
        }
      }
    }
  }
  `;
};
const $654994348c889f70$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $654994348c889f70$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $654994348c889f70$export$98f1867fd4cb2c65 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>$654994348c889f70$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: {
                first: 20,
                experience: '',
                ...variables
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $654994348c889f70$var$getSearchEntitiesQuery({
                includeSpaceKey: includeSpaceKey,
                includeContainerId: includeContainerId
            }),
            operationName: $654994348c889f70$var$operationName,
            headers: headers
        }), $654994348c889f70$var$expireWhen);
module.exports["searchEntitiesQuery"] = $654994348c889f70$export$98f1867fd4cb2c65;

});

parcelRegister("aGXLL", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $8RDn3 = parcelRequire("8RDn3");


var $i8MOh = parcelRequire("i8MOh");


var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");



var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $a7df8cf79771da11$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $a7df8cf79771da11$export$a4d01c087c4a6f1c = [
    '@',
    'contributor:'
];
// Filter out Trello for milestone 1 (QS-4733)
// Focus does not have contributor field
const $a7df8cf79771da11$var$productKeys1P = (0, $b4tvS.all1pProductKeys).filter((key)=>key !== (0, $b4tvS.ProductKeys).Trello && key !== (0, $b4tvS.ProductKeys).Focus && key !== (0, $b4tvS.ProductKeys).Talent);
// Figma doesn't support contributor
// https://atlassian.slack.com/archives/C07P3MD2U9Z/p1733868616441159?thread_ts=1733866616.102409&cid=C07P3MD2U9Z
const $a7df8cf79771da11$var$all3pProductKeysExceptFigma = (0, $b4tvS.all3pProductKeys).filter((key)=>key !== (0, $b4tvS.ProductKeys3P).Figma);
const $a7df8cf79771da11$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'contributor',
    // 1P only for now (excluding Trello)
    products: [
        ...$a7df8cf79771da11$var$productKeys1P,
        ...$a7df8cf79771da11$var$all3pProductKeysExceptFigma
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'contributors',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $i8MOh.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (0, $4bHQd.loadRecommendedUsers)(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            const response = await (0, $8RDn3.getContributors)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
                maxNumberOfResults: $a7df8cf79771da11$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((contributor)=>({
                    trackingKey: contributor.id,
                    value: contributor.id,
                    label: contributor.name,
                    avatarUrl: contributor.avatarUrl,
                    queryParamValue: contributor.id,
                    product: config.product
                }));
        }
    }
});
module.exports["filter"] = $a7df8cf79771da11$export$3dea766d36a8935f;

});

parcelRegister("8RDn3", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $ed0ac8d2f9bf46f2$export$f63f2da3517cdf9c = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'contributors',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getContributors"] = $ed0ac8d2f9bf46f2$export$f63f2da3517cdf9c;

});

parcelRegister("lEZ2M", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $f6e777910b6712c8$export$cc8468b84430954 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'createdBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getCreatedBy"] = $f6e777910b6712c8$export$cc8468b84430954;

});

parcelRegister("4yWWa", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $2c6215c9ce99d54a$export$fb16ff36c6030271 = (0, $hw4j5.inMemoryCache)();
const $2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME = 'FocusAreaTypes';
const $2c6215c9ce99d54a$var$mercuryFocusAreaTypesQueryString = `query ${$2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME}($cloudId: ID!) {
  mercury {
    focusAreaTypes(cloudId: $cloudId) @optIn(to: "Mercury") {
      id
      name
      hierarchyLevel
    }
  }
}`;
const $2c6215c9ce99d54a$export$780cc3f06f467bfe = (cloudId, headers)=>{
    return $2c6215c9ce99d54a$export$fb16ff36c6030271.inMemoryDecorator(cloudId, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreaTypes: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $2c6215c9ce99d54a$var$mercuryFocusAreaTypesQueryString,
            variables: {
                cloudId: cloudId
            },
            operationName: $2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreaTypesQuery"] = $2c6215c9ce99d54a$export$780cc3f06f467bfe;

});

parcelRegister("d95gt", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $7ddfceef9c6f7249$export$7e54d23e8f945514 = (0, $hw4j5.inMemoryCache)();
const $7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME = 'FocusAreas';
const $7ddfceef9c6f7249$var$mercuryFocusAreasQueryString = `query ${$7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME}($cloudId: ID!, $q: String, $first: Int, $sort: [MercuryFocusAreaSort]) {
  mercury {
    focusAreas(cloudId: $cloudId, q: $q, first: $first, sort: $sort) @optIn(to: "Mercury") {
      edges {
        node {
          id
          uuid
          name
          status {
		    key            
          }
          health {
            key
          }
          focusAreaType {
		  	name
            hierarchyLevel
          }
		  owner {
            name
          }
        }
      }
    }
  }
}`;
const $7ddfceef9c6f7249$var$MercuryFocusAreaSortField = {
    Budget: 'BUDGET',
    FocusAreaType: 'FOCUS_AREA_TYPE',
    HasParent: 'HAS_PARENT',
    HierarchyLevel: 'HIERARCHY_LEVEL',
    LastUpdated: 'LAST_UPDATED',
    Name: 'NAME',
    Spend: 'SPEND',
    Status: 'STATUS',
    TargetDate: 'TARGET_DATE',
    Watching: 'WATCHING'
};
const $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $7ddfceef9c6f7249$export$f9d9785ff9cc54a6 = (cloudId, q, first = 20, sort = [
    {
        field: $7ddfceef9c6f7249$var$MercuryFocusAreaSortField.FocusAreaType,
        order: $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder['ASC']
    },
    {
        field: $7ddfceef9c6f7249$var$MercuryFocusAreaSortField.Name,
        order: $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder['ASC']
    }
], headers)=>{
    return $7ddfceef9c6f7249$export$7e54d23e8f945514.inMemoryDecorator(`${cloudId}-${q}-${first}-${JSON.stringify(sort)}`, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreas: {
                        edges: []
                    }
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $7ddfceef9c6f7249$var$mercuryFocusAreasQueryString,
            variables: {
                cloudId: cloudId,
                q: q,
                first: first,
                sort: sort
            },
            operationName: $7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreasQuery"] = $7ddfceef9c6f7249$export$f9d9785ff9cc54a6;

});

parcelRegister("22zVp", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");

const $96bffdf1601f19c9$export$ecb101fddedffa32 = (product, includeDC = false)=>{
    const jiraProducts = includeDC ? [
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraDC,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ] : [
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ];
    return Boolean(jiraProducts.find((jiraProduct)=>jiraProduct === product));
};
module.exports["isJiraProduct"] = $96bffdf1601f19c9$export$ecb101fddedffa32;

});

parcelRegister("1tvnk", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $d787c8d425cdec7f$export$a8f449a3d81f3a4c = (0, $hw4j5.inMemoryCache)();
const $d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME = 'SearchLabelsQuery';
const $d787c8d425cdec7f$var$getConfluenceLabelsQuery = ()=>`
query ${$d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME}($cloudId: ID! $searchText: String!, $limit: Int) {
  confluence {
    searchLabels(cloudId: $cloudId, searchText: $searchText, limit: $limit) @optIn(to: "ConfluenceExperimentalSearchLabels") {
	  otherLabels {
        label
      }
      suggestedLabels {
        label
      }
    }
  }
}
`;
const $d787c8d425cdec7f$export$b9ea4761dac8a473 = (cloudId, searchText, limit, headers)=>{
    return $d787c8d425cdec7f$export$a8f449a3d81f3a4c.inMemoryDecorator(searchText, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $d787c8d425cdec7f$var$getConfluenceLabelsQuery(),
            variables: {
                cloudId: cloudId,
                searchText: searchText,
                limit: limit
            },
            operationName: $d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceLabelsQuery"] = $d787c8d425cdec7f$export$b9ea4761dac8a473;

});

parcelRegister("7uR1u", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");

const $9b493b78b0147f03$export$eddac1daa475a197 = async ({ query: query = '', absoluteUrl: absoluteUrl })=>{
    const options = {
        path: 'rest/api/1.0/labels/suggest',
        queryParams: {
            query: query
        },
        requestInit: {
            method: 'GET',
            headers: {
                accept: 'application/json',
                'x-atlassian-capability': 'ROVO_FULL_PAGE_SEARCH'
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: absoluteUrl
    }, options);
};
module.exports["getSuggestedJiraLabels"] = $9b493b78b0147f03$export$eddac1daa475a197;

});

parcelRegister("98IoL", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $c7b96c55ef1af949$export$5fc95d9e84e12fd3 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'lastUpdatedBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getLastUpdatedBy"] = $c7b96c55ef1af949$export$5fc95d9e84e12fd3;

});

parcelRegister("3Pbzb", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $04a21b2c3e4676ff$export$148de59b68ce26ae = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'owners',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getOwners"] = $04a21b2c3e4676ff$export$148de59b68ce26ae;

});

parcelRegister("1APZs", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $341a3e7febf59a97$export$77f684104cbf1994 = (0, $hw4j5.inMemoryCache)();
const $341a3e7febf59a97$var$QUERY_NAME = 'PositionEmploymentTypes';
const $341a3e7febf59a97$var$positionEmploymentTypesQueryString = `query ${$341a3e7febf59a97$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $341a3e7febf59a97$export$66f27dc417575281 = (cloudId, rql, first = 20, after, headers)=>{
    const fieldId = 'positionEmploymentType';
    return $341a3e7febf59a97$export$77f684104cbf1994.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $341a3e7febf59a97$var$positionEmploymentTypesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $341a3e7febf59a97$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionEmploymentTypesQuery"] = $341a3e7febf59a97$export$66f27dc417575281;

});

parcelRegister("gkPq5", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $0ef59a00ea746990$export$5918017b3202b827 = (0, $hw4j5.inMemoryCache)();
const $0ef59a00ea746990$var$QUERY_NAME = 'PositionJobFamilies';
const $0ef59a00ea746990$var$positionJobFamiliesQueryString = `query ${$0ef59a00ea746990$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $0ef59a00ea746990$export$9573cb9936eb57f3 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionJobFamily';
    return $0ef59a00ea746990$export$5918017b3202b827.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $0ef59a00ea746990$var$positionJobFamiliesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $0ef59a00ea746990$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionJobFamiliesQuery"] = $0ef59a00ea746990$export$9573cb9936eb57f3;

});

parcelRegister("3FxSV", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $eeb9c275443983dc$export$9030a66c314dd4f9 = (0, $hw4j5.inMemoryCache)();
const $eeb9c275443983dc$var$QUERY_NAME = 'PositionStatuses';
const $eeb9c275443983dc$var$positionStatusesQueryString = `query ${$eeb9c275443983dc$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStatusFieldValue {
          __typename
          isRestricted
          statusValue: value
          statusDisplayValue: displayValue
          appearance
        }
      }
    }
  }
}`;
const $eeb9c275443983dc$export$edd0381f12f6ff4d = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionStatus';
    return $eeb9c275443983dc$export$9030a66c314dd4f9.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $eeb9c275443983dc$var$positionStatusesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $eeb9c275443983dc$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionStatusesQuery"] = $eeb9c275443983dc$export$edd0381f12f6ff4d;

});

parcelRegister("eDERK", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $c9b75add6fb06773$export$7e7f4c6c4a157b2d = (0, $hw4j5.inMemoryCache)();
const $c9b75add6fb06773$var$QUERY_NAME = 'PositionTeams';
const $c9b75add6fb06773$var$positionTeamsQueryString = `query ${$c9b75add6fb06773$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        __typename
        __isRadarFieldValue: __typename
        ... on RadarAriFieldValue {
          __typename
          isRestricted
          ari
          value {
            __typename
            ... on TeamV2 {
              __typename
              displayName
              id
              organizationId
              smallAvatarImageUrl
            }
          }
        }
      }
    }
  }
}`;
const $c9b75add6fb06773$export$ed23ff9c143a4269 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'team';
    return $c9b75add6fb06773$export$7e7f4c6c4a157b2d.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $c9b75add6fb06773$var$positionTeamsQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $c9b75add6fb06773$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionTeamsQuery"] = $c9b75add6fb06773$export$ed23ff9c143a4269;

});

parcelRegister("1WLN3", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $0ec6fc46fa2dbafd$export$56d694fb8fe349ab = (0, $hw4j5.inMemoryCache)();
const $0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME = 'SearchPageJiraProjectQuery';
const $0ec6fc46fa2dbafd$var$jiraProjectsQueryString = `query ${$0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME}($projectIds: [ID!]!) {
  jira {
    jiraProjects(ids: $projectIds) {
			projectId
      name
      avatar {
        small
      }
    }
  }
}`;
const $0ec6fc46fa2dbafd$export$fd1d4a933080bfe2 = (projectIds, headers)=>{
    return $0ec6fc46fa2dbafd$export$56d694fb8fe349ab.inMemoryDecorator(projectIds.join(','), async ()=>{
        if (projectIds.length === 0) return {
            data: {
                jira: {
                    jiraProjects: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $0ec6fc46fa2dbafd$var$jiraProjectsQueryString,
            variables: {
                projectIds: projectIds
            },
            operationName: $0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return $0ec6fc46fa2dbafd$var$filterProjectsWithoutId(response);
    });
};
const $0ec6fc46fa2dbafd$var$filterProjectsWithoutId = (response)=>{
    const filteredProjects = response.data?.jira.jiraProjects?.filter((project)=>project.projectId);
    return {
        ...response,
        data: {
            jira: {
                jiraProjects: filteredProjects
            }
        }
    };
};
module.exports["jiraProjectsQuery"] = $0ec6fc46fa2dbafd$export$fd1d4a933080bfe2;

});

parcelRegister("a97k3", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $8hQhN = parcelRequire("8hQhN");


var $i14PY = parcelRequire("i14PY");


var $4qT1X = parcelRequire("4qT1X");

const $4205d6666548c699$var$LOOM_SPACES_BY_IDS_OPERATION_NAME = 'LoomRovoSpacesByIdsQuery';
const $4205d6666548c699$var$loomSpacesByIdsQuery = `
	query ${$4205d6666548c699$var$LOOM_SPACES_BY_IDS_OPERATION_NAME}($ids: [ID!]!) {
		loom_spaces(ids: $ids) {
			id
			name
			url
		}
	}
`;
const $4205d6666548c699$export$d3c2717269e16428 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>(0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $4205d6666548c699$var$loomSpacesByIdsQuery,
        operationName: $4205d6666548c699$var$LOOM_SPACES_BY_IDS_OPERATION_NAME,
        headers: headers
    });





const $42a9c2d809b7880c$var$LOOM_SPACES_SEARCH_OPERATION_NAME = 'LoomRovoSpacesSearchQuery';
const $42a9c2d809b7880c$var$loomSpacesSearchQuery = `
	query ${$42a9c2d809b7880c$var$LOOM_SPACES_SEARCH_OPERATION_NAME}($siteId: ID!, $query: String) {
		loom_spacesSearch(siteId: $siteId, query: $query) {
			id
			name
			url
		}
	}
`;
const $42a9c2d809b7880c$var$trimToLimit = (result, limit)=>typeof limit === 'number' ? {
        ...result,
        data: result.data ? {
            ...result.data,
            loom_spacesSearch: result.data.loom_spacesSearch.slice(0, limit)
        } : result.data
    } : result;
const $42a9c2d809b7880c$export$79bd8211418f2310 = async ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const { siteId: siteId, query: query, limit: limit } = variables;
    const response = await (0, $4qT1X.fetchAgg)({
        variables: {
            siteId: siteId,
            query: query
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $42a9c2d809b7880c$var$loomSpacesSearchQuery,
        operationName: $42a9c2d809b7880c$var$LOOM_SPACES_SEARCH_OPERATION_NAME,
        headers: headers
    });
    return $42a9c2d809b7880c$var$trimToLimit(response, limit);
};



var $johDC = parcelRequire("johDC");


var $2XoKG = parcelRequire("2XoKG");


var $IpMWN = parcelRequire("IpMWN");


var $1HJbl = parcelRequire("1HJbl");


var $hm6w9 = parcelRequire("hm6w9");


var $hB77E = parcelRequire("hB77E");


var $k8y62 = parcelRequire("k8y62");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");

parcelRequire("1yEFx");



var $dOOW1 = parcelRequire("dOOW1");


var $5XpfZ = parcelRequire("5XpfZ");


var $6Ea6j = parcelRequire("6Ea6j");


var $cOUgi = parcelRequire("cOUgi");

// TODO: Add Loom in 1P product when backend is ready
const $f270dad94ab1fad4$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $f270dad94ab1fad4$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('space');
const $f270dad94ab1fad4$var$getProducts3PFromConfig = ()=>$f270dad94ab1fad4$var$products3PFromConfig;
const $f270dad94ab1fad4$var$LOOKUP_ENTITIES = [
    'ati:cloud:confluence:space'
];
const $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT = 15;
const $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT = 15;
const $f270dad94ab1fad4$var$isLoomSpaceProduct = (product)=>product === (0, $b4tvS.ProductKeys).Loom && (0, $dh538.fg)('loom-rovo-search');
const $f270dad94ab1fad4$var$isSingleSelectSpaceProduct = (product)=>(0, $b4tvS.is3pProductKey)(product ?? '') && !$f270dad94ab1fad4$var$isLoomSpaceProduct(product);
async function $f270dad94ab1fad4$var$searchDcSpaces(query, config) {
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    let spacesResponse = await (0, $johDC.confluenceDcSpaceFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
            limit: 5,
            entities: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: (0, $b4tvS.ProductKeys).ConfluenceDC
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            trackingKey: node.entity.id,
            value: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $1HJbl.cleanExcerpt)(node.entity.displayName),
            product: config.product
        })) ?? [];
}
async function $f270dad94ab1fad4$var$searchThirdPartySpaceOptions(config, query = '') {
    const cloudId = config.cloudId;
    const product = config.product;
    // Get integrationAri from the static ThirdPartyConfigs using the product key.
    // This avoids the dependency on selectedDatasource being populated in the store,
    // which was causing lookup/search to fail when selectedDatasource was undefined.
    const integrationAri = config.selectedDatasource?.integrationAri ?? (0, $hB77E.getThirdPartyConfigs)().get(product)?.integrationAri;
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const subtypes = product === (0, $b4tvS.ProductKeys).Sharepoint ? [
        (0, $2Znam.NounSubtypeKey).Site,
        (0, $2Znam.NounSubtypeKey).Subsite
    ] : [
        (0, $2Znam.NounSubtypeKey).Space
    ];
    let spacesResponse = await (0, $johDC.thirdPartySpaceFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
            limit: 15,
            entities: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: subtypes
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            value: node.entity.id,
            trackingKey: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $1HJbl.cleanExcerpt)(node.entity.displayName),
            product: product
        })) ?? [];
}
async function $f270dad94ab1fad4$var$fetchLoomSpaceOptions(config, { query: query = '', limit: limit = $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT } = {}) {
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const spacesResponse = await (0, $42a9c2d809b7880c$export$79bd8211418f2310)({
        variables: {
            query: query || undefined,
            siteId: cloudId,
            limit: limit
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.loom_spacesSearch?.map((space)=>({
            value: space.id,
            trackingKey: space.id,
            queryParamValue: space.id,
            avatarUrl: undefined,
            label: (0, $1HJbl.cleanExcerpt)(space.name),
            product: (0, $b4tvS.ProductKeys).Loom
        })) ?? [];
}
const $f270dad94ab1fad4$var$spaceFilterInitial = {
    id: 'space',
    products: [
        ...$f270dad94ab1fad4$var$productKeys1P,
        ...$f270dad94ab1fad4$var$getProducts3PFromConfig()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'spaces',
        fetcher: async (queryParams, config)=>{
            if ($f270dad94ab1fad4$var$isLoomSpaceProduct(config.product)) {
                const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $4205d6666548c699$export$d3c2717269e16428)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse?.data?.loom_spaces?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.name,
                        avatarUrl: undefined,
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return spacesOptions || [];
            }
            if (config.product === (0, $b4tvS.ProductKeys).ConfluenceDC || config.product === (0, $b4tvS.ProductKeys).GoogleDrive || config.product === (0, $b4tvS.ProductKeys).Sharepoint) {
                const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $johDC.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return spacesOptions || [];
            }
            const cloudId = config.cloudId;
            // Practically cloudId should always be present, but we need to satisfy the type checker
            if (!cloudId) return [];
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const response = await (0, $IpMWN.confluenceSpaceKeysToIdsQuery)({
                spaceKeys: queryParams,
                cloudId: cloudId,
                headers: headers
            });
            const spaceIds = response.data?.spaces?.nodes?.map((node)=>node?.id).filter((0, $dOOW1.notEmpty)) ?? [];
            const spaceARIs = spaceIds.map((id)=>`ari:cloud:confluence:${cloudId}:space/${id}`);
            const initialSpacesResponse = await (0, $2XoKG.confluenceSpacesQuery)(spaceARIs, headers);
            const allRecommendedSpaces = initialSpacesResponse.data?.confluence.spaces.map((space)=>({
                    key: space.key,
                    name: space.name,
                    ari: space.id,
                    avatarUrl: space.links?.base && space.icon?.path ? `${space.links.base}${space.icon.path}` : ''
                })) || [];
            return allRecommendedSpaces.map((space)=>({
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || '',
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            if ($f270dad94ab1fad4$var$isLoomSpaceProduct(config.product)) return $f270dad94ab1fad4$var$fetchLoomSpaceOptions(config, {
                limit: $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT
            });
            if (config.product === (0, $b4tvS.ProductKeys).ConfluenceDC) {
                const spaces = await $f270dad94ab1fad4$var$searchDcSpaces('', config);
                return spaces;
            }
            if (config.product === (0, $b4tvS.ProductKeys).GoogleDrive || config.product === (0, $b4tvS.ProductKeys).Sharepoint) return $f270dad94ab1fad4$var$searchThirdPartySpaceOptions(config);
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const recommendedSpacesResponse = await (0, $8hQhN.smartsRecommendedContainerQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    userId: config.userId || '',
                    tenantId: config.cloudId || ''
                },
                headers: headers
            });
            const allRecommendedSpaces = recommendedSpacesResponse.data?.smarts.results?.flatMap(({ container: container })=>{
                if (!(container && container.key)) return [];
                return [
                    {
                        key: container.key,
                        name: container.name,
                        ari: container.id,
                        avatarUrl: container.links?.base && container.icon?.path ? `${container.links.base}${container.icon.path}` : ''
                    }
                ];
            }) || [];
            const recommendedSpaceOptions = allRecommendedSpaces.map((space)=>{
                return {
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || '',
                    product: config.product
                };
            });
            return recommendedSpaceOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if ($f270dad94ab1fad4$var$isLoomSpaceProduct(config.product)) return $f270dad94ab1fad4$var$fetchLoomSpaceOptions(config, {
                query: query,
                limit: $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT
            });
            if (config.product === (0, $b4tvS.ProductKeys).ConfluenceDC) return $f270dad94ab1fad4$var$searchDcSpaces(query, config);
            if (config.product === (0, $b4tvS.ProductKeys).GoogleDrive || config.product === (0, $b4tvS.ProductKeys).Sharepoint) return $f270dad94ab1fad4$var$searchThirdPartySpaceOptions(config, query);
            const backendExperiment = config.experimentConfig && (0, $hm6w9.getBackendExperiment)({
                experimentConfig: config.experimentConfig,
                entities: $f270dad94ab1fad4$var$LOOKUP_ENTITIES,
                productEdition: config.productEdition,
                isHello: (0, $5XpfZ.isHello)(config.cloudId),
                productDataRegions: config.productDataRegions,
                experience: 'search-page-space-filter',
                tenantId: config.cloudId
            });
            const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const response = await (0, $i14PY.searchEntitiesQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    query: query,
                    first: 15,
                    filters: {
                        entities: [
                            'ati:cloud:confluence:space'
                        ],
                        locations: [
                            `ari:cloud:confluence::site/${config.cloudId}`
                        ]
                    },
                    experience: 'full-page-search-space-filter',
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        }))
                },
                includeSpaceKey: true,
                headers: headers
            });
            const { data: data } = response;
            if (!data) return [];
            return data.search?.results.edges.map(({ node: node })=>({
                    trackingKey: node.id || '',
                    value: node.key || '',
                    queryParamValue: node.key ?? '',
                    avatarUrl: node.iconUrl || undefined,
                    label: node.title,
                    product: config.product
                })) ?? [];
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Confluence
};
/**
 * Builds the raw (unwrapped) monad for the given state and config, choosing
 * SingleSelectFilter for 3P products and MultiSelectFilter for 1P. Used internally
 * so that withSelectTypeFilter can wrap exactly once — calling filter.withState would
 * double-wrap because filter.withState itself calls withSelectTypeFilter for 3P.
 */ const $f270dad94ab1fad4$var$buildSelectFilter = (state, config)=>{
    if ($f270dad94ab1fad4$var$isSingleSelectSpaceProduct(config.product)) return (0, $cOUgi.SingleSelectFilter)({
        initial: $f270dad94ab1fad4$var$spaceFilterInitial,
        state: {
            ...state,
            type: 'single-select'
        },
        config: config
    });
    return (0, $6Ea6j.MultiSelectFilter)({
        initial: $f270dad94ab1fad4$var$spaceFilterInitial,
        state: {
            ...state,
            type: 'multi-select'
        },
        config: config
    });
};
/**
 * Ensures every chained monad operation re-dispatches through buildSelectFilter so the
 * correct select type (SingleSelectFilter for 3P, MultiSelectFilter for 1P) is preserved
 * throughout the chain. Without this, base-select-filter operations (loadInitialOptions,
 * setQueryParams, etc.) return a plain SelectFilter monad that always uses multi-select
 * setOption. buildSelectFilter is used instead of filter.withState to avoid double-wrapping:
 * filter.withState for 3P already calls withSelectTypeFilter internally.
 */ const $f270dad94ab1fad4$var$withSelectTypeFilter = (spaceFilter, config)=>({
        ...spaceFilter,
        loadInitialOptions: async (onStateChange)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter((await spaceFilter.loadInitialOptions(onStateChange)).getState(), config), config),
        setOption: (option, customValue)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter(spaceFilter.setOption(option, customValue).getState(), config), config),
        clearOptions: ()=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter(spaceFilter.clearOptions().getState(), config), config),
        setLookupInput: async (query, onStateChange)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter((await spaceFilter.setLookupInput(query, onStateChange)).getState(), config), config),
        clear: ()=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter(spaceFilter.clear().getState(), config), config),
        queryParams: {
            ...spaceFilter.queryParams,
            set: async (queryParams, onStateChange)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter((await spaceFilter.queryParams.set(queryParams, onStateChange)).getState(), config), config)
        }
    });
// Used only for its static shape (id, type, products, queryParams.key, etc.) via the
// spread below. withState and getInitialState are overridden to dispatch per product.
const $f270dad94ab1fad4$var$baseFilter = (0, $6Ea6j.createMultiSelectFilter)($f270dad94ab1fad4$var$spaceFilterInitial);
const $f270dad94ab1fad4$export$3dea766d36a8935f = {
    ...$f270dad94ab1fad4$var$baseFilter,
    withState: (state, config)=>{
        // buildSelectFilter is the single source of truth for monad construction.
        // For 3P, wrap with withSelectTypeFilter to preserve single-select dispatch
        // through every chained operation; 1P uses MultiSelectFilter directly.
        const monad = $f270dad94ab1fad4$var$buildSelectFilter(state, config);
        return $f270dad94ab1fad4$var$isSingleSelectSpaceProduct(config.product) ? $f270dad94ab1fad4$var$withSelectTypeFilter(monad, config) : monad;
    },
    getInitialState: (config)=>{
        return $f270dad94ab1fad4$export$3dea766d36a8935f.withState($f270dad94ab1fad4$var$baseFilter.getInitialState(config).getState(), config);
    }
};
module.exports["filter"] = $f270dad94ab1fad4$export$3dea766d36a8935f;

});

parcelRegister("8hQhN", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $d33e20668d2d4273$var$operationName = 'SmartsRecommendedContainerQuery';
const $d33e20668d2d4273$var$SmartsRecommendedContainerQuery = `
query ${$d33e20668d2d4273$var$operationName}($userId: String!, $tenantId: String!) {
  smarts {
    results: recommendedContainer(
      recommendationsQuery: {
        context: {
          userId: $userId,
          tenantId: $tenantId,
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search",
          experience: "CgContainerNearbyUser"
        },
        requestingUserId: $userId
      }
    ) {
      id
      score
      container {
        createdDate
        id
        key
        name
        spaceId
        status
        type
        links {
          base
        }
        icon {
          path
        }
      }
    }
  }
}
`;
const $d33e20668d2d4273$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $d33e20668d2d4273$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $d33e20668d2d4273$export$9d6625cf80401405 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$d33e20668d2d4273$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $d33e20668d2d4273$var$SmartsRecommendedContainerQuery,
            operationName: $d33e20668d2d4273$var$operationName,
            headers: headers
        }), $d33e20668d2d4273$var$expireWhen);
module.exports["smartsRecommendedContainerQuery"] = $d33e20668d2d4273$export$9d6625cf80401405;

});

parcelRegister("2XoKG", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $85b6e230af4df339$export$f400862b5c7e6c62 = (0, $hw4j5.inMemoryCache)();
const $85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME = 'SearchPageConfluenceSpacesQuery';
const $85b6e230af4df339$var$getConfluenceSpacesQuery = ()=>`
query ${$85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME}($spaceIds: [ID]!) {
  confluence {
    spaces(ids: $spaceIds) {
      id
      spaceId
      name
      key
      links {
        base
      }
      icon {
        path
      }
    }
  }
}
`;
const $85b6e230af4df339$export$d8fbf668d55936f8 = (spaceIds, headers)=>{
    return $85b6e230af4df339$export$f400862b5c7e6c62.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    spaceIds.join(','), async ()=>{
        if (spaceIds.length === 0) return {
            data: {
                confluence: {
                    spaces: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $85b6e230af4df339$var$getConfluenceSpacesQuery(),
            variables: {
                spaceIds: spaceIds
            },
            operationName: $85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpacesQuery"] = $85b6e230af4df339$export$d8fbf668d55936f8;

});

parcelRegister("IpMWN", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $ea45c916174bba4e$var$spacesCache = (0, $hw4j5.inMemoryCache)();
const $ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME = 'ConfluenceSpaceKeysToIdsQuery';
const $ea45c916174bba4e$var$getConfluenceSpaceKeysToIdsQuery = ()=>`
query ${$ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME}($spaceKeys: [String]) {
  spaces(spaceKeys: $spaceKeys) {
    nodes {
      id
 	}
  }
}
`;
const $ea45c916174bba4e$export$726cc5bea9d2607e = ({ spaceKeys: spaceKeys, cloudId: cloudId, headers: headers })=>{
    return $ea45c916174bba4e$var$spacesCache.inMemoryDecorator(`${spaceKeys.join(',')}-${cloudId}`, async ()=>{
        // Technically fetchAgg is a util to fetch from AGG, but since we're overriding the URL it works with cc-graphql.
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $ea45c916174bba4e$var$getConfluenceSpaceKeysToIdsQuery(),
            variables: {
                spaceKeys: spaceKeys
            },
            operationName: $ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME,
            aggAbsoluteUrl: `/gateway/api/ex/confluence/${cloudId}/graphql`,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpaceKeysToIdsQuery"] = $ea45c916174bba4e$export$726cc5bea9d2607e;

});

parcelRegister("6CITI", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");


var $4Zqgi = parcelRequire("4Zqgi");

const $705af924ede424d6$var$PREFIX = '@atlassian.search-ai.';
const $705af924ede424d6$var$setString = (key, value)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)(`${$705af924ede424d6$var$PREFIX}${key}`, value);
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'setString'
        });
    }
};
const $705af924ede424d6$var$getString = (key)=>{
    return (0, $5G9KX.getLocalStorageItemAsString)(`${$705af924ede424d6$var$PREFIX}${key}`);
};
const $705af924ede424d6$export$74cea4b24a6bc9fa = {
    getString: $705af924ede424d6$var$getString,
    setString: $705af924ede424d6$var$setString
};
module.exports["localStore"] = $705af924ede424d6$export$74cea4b24a6bc9fa;

});

parcelRegister("kIdP4", function(module, exports) {
const $1c4bb92f3ae586c5$export$c9058316764c140e = (...refs)=>(node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(node);
            else if (ref != null) ref.current = node;
        });
    };
module.exports["mergeRefs"] = $1c4bb92f3ae586c5$export$c9058316764c140e;

});

parcelRegister("a5OFf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");





var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $cOrQJ = parcelRequire("cOrQJ");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");
var $1yEFx = parcelRequire("1yEFx");


var $9d9t8 = parcelRequire("9d9t8");


var $i2RLU = parcelRequire("i2RLU");


var $2zyFZ = parcelRequire("2zyFZ");


var $ckkm9 = parcelRequire("ckkm9");


var $2OtFZ = parcelRequire("2OtFZ");








var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");


var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");




var $2W0qg = parcelRequire("2W0qg");


var $5dK2X = parcelRequire("5dK2X");




const $1dfe068c1a1bfcd2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    dismiss: {
        id: "oauth-message-dismiss",
        defaultMessage: "Dismiss"
    }
});


const $52087ab64c3a7923$var$containerBaseStyles = (0, $ecnYn.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral'
});
const $52087ab64c3a7923$var$searchResultsContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $52087ab64c3a7923$var$searchDialogContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $52087ab64c3a7923$var$searchDialogContainerWithLeftPaddingStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $52087ab64c3a7923$var$connectPressableStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingInline: 'space.150',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    color: 'color.link',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    ':active': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    whiteSpace: 'nowrap' // so that "Connect" doesn't get broken up needlessly
});
const $52087ab64c3a7923$var$actionsContainer = (0, $ecnYn.xcss)({
    flexBasis: 'fit-content'
});
const $52087ab64c3a7923$export$1b25a7895791d4fc = (props)=>{
    const { content: content, onAuthorize: onAuthorize, onDismiss: onDismiss, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, testId: testId, oAuthSource: oAuthSource } = props;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const ctaButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: ()=>onAuthorize(oAuthSource),
        backgroundColor: "color.background.neutral.subtle",
        xcss: $52087ab64c3a7923$var$connectPressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "medium",
        size: "medium",
        color: "color.link"
    }, content.connectText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        alignItems: "center",
        templateColumns: isBulkConnect ? 'min-content auto 1fr auto' : 'min-content 1fr auto',
        columnGap: isBulkConnect && isOnSearchDialog ? 'space.075' : 'space.150',
        testId: testId,
        xcss: [
            $52087ab64c3a7923$var$containerBaseStyles,
            isOnSearchDialog ? content.iconNeedsPadding ? $52087ab64c3a7923$var$searchDialogContainerWithLeftPaddingStyles : $52087ab64c3a7923$var$searchDialogContainerStyles : $52087ab64c3a7923$var$searchResultsContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(content.MessageIcon, {
        size: 'small'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: !isBulkConnect && isOnSearchDialog ? 'space.025' : 'space.050',
        alignBlock: "center",
        shouldWrap: true
    }, isOnSearchDialog || isBulkConnect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium",
        as: isBulkConnect ? undefined : 'strong',
        weight: isBulkConnect ? 'medium' : undefined
    }, content.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small",
        as: "h3"
    }, content.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium",
        color: isOnSearchDialog ? 'color.text.subtle' : undefined
    }, content.description)), isBulkConnect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        testId: testId && `${testId}--actions-cta`,
        alignBlock: "center"
    }, ctaButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        testId: testId && `${testId}--actions`,
        space: "space.150",
        rowSpace: "space.0",
        alignBlock: "center",
        xcss: $52087ab64c3a7923$var$actionsContainer
    }, !isBulkConnect && ctaButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                label: "",
                color: "currentColor"
            }),
        onClick: onDismiss,
        label: formatMessage((0, $1dfe068c1a1bfcd2$export$defe85febe8b728c).dismiss),
        appearance: 'subtle',
        spacing: 'compact'
    })));
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");





var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");










parcelRequire("1yEFx");








const $5bb43d84305a44a8$export$a2731dd889a27eaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        "aria-hidden": "true",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "var(--ds-background-neutral-bold, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 5.33337C10.1097 5.33337 5.33325 10.2298 5.33325 16.2701C5.33325 21.1022 8.3896 25.2018 12.6278 26.6479C13.1609 26.7492 13.3566 26.4107 13.3566 26.1218C13.3566 25.861 13.3467 24.9995 13.3422 24.0856C10.3746 24.7472 9.74847 22.7952 9.74847 22.7952C9.26325 21.5311 8.56412 21.1949 8.56412 21.1949C7.59632 20.5162 8.63707 20.5301 8.63707 20.5301C9.70819 20.6073 10.2722 21.6571 10.2722 21.6571C11.2236 23.3291 12.7675 22.8457 13.3762 22.5663C13.472 21.8594 13.7484 21.377 14.0535 21.1039C11.6842 20.8273 9.19365 19.8895 9.19365 15.6989C9.19365 14.5048 9.61034 13.5292 10.2927 12.7633C10.1819 12.4878 9.81683 11.3755 10.396 9.86903C10.396 9.86903 11.2917 9.57509 13.3301 10.9901C14.181 10.7478 15.0935 10.6262 16 10.6221C16.9065 10.6262 17.8197 10.7478 18.6722 10.9901C20.7081 9.57509 21.6026 9.86903 21.6026 9.86903C22.1832 11.3755 21.8179 12.4878 21.7071 12.7633C22.3911 13.5292 22.8049 14.5048 22.8049 15.6989C22.8049 19.8995 20.3096 20.8244 17.9344 21.0952C18.317 21.4346 18.6579 22.1001 18.6579 23.1205C18.6579 24.5838 18.6455 25.7616 18.6455 26.1218C18.6455 26.4128 18.8375 26.7539 19.3782 26.6465C23.6141 25.1987 26.6666 21.1006 26.6666 16.2701C26.6666 10.2298 21.8909 5.33337 16 5.33337Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));


var $91de9746dbea2539$exports = {};
$91de9746dbea2539$exports = new URL("github_dark.35a1e263.gif", import.meta.url).toString();


var $500322ca0e641057$exports = {};
$500322ca0e641057$exports = new URL("github_light.9ae56730.gif", import.meta.url).toString();





const $9e845e8f0d3e92f5$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    description: {
        id: "oauth-banner.oauth-social-proof-message.github.description",
        defaultMessage: "Expand your search results to include GitHub PRs, issues, and repos."
    },
    successFlagTitle: {
        id: "oauth-banner.oauth-social-proof-message.github.success-flag-title",
        defaultMessage: "{product} connected"
    },
    successFlagDescription: {
        id: "oauth-banner.oauth-social-proof-message.github.success-flag-description",
        defaultMessage: "You can now find and action on PRs, commits, and repos in Rovo Search and Chat."
    }
});


const $63f6ad3f921e52cf$export$7a4f7369b5d6a78e = ({ colorMode: colorMode })=>{
    return {
        productIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5bb43d84305a44a8$export$a2731dd889a27eaf), null),
        description: (0, $9e845e8f0d3e92f5$export$defe85febe8b728c).description,
        successFlagTitle: (0, $9e845e8f0d3e92f5$export$defe85febe8b728c).successFlagTitle,
        successFlagDescription: (0, $9e845e8f0d3e92f5$export$defe85febe8b728c).successFlagDescription,
        // Use the dark GIF only when the theme is explicitly dark, default to the light GIF otherwise
        imageSrc: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($91de9746dbea2539$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($500322ca0e641057$exports)))
    };
};


const $0d23e5415599265a$var$contentRegistry = {
    [(0, $b4tvS.ProductKeys).Github]: (0, $63f6ad3f921e52cf$export$7a4f7369b5d6a78e)
};
const $0d23e5415599265a$export$defa06e894d14087 = (product, params)=>$0d23e5415599265a$var$contentRegistry[product](params);





const $ca59f813d2f1dff5$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    dismiss: {
        // NOTE: i18n `id`s are intentionally kept stable across the
        // OAuthMessageWithPreview → OAuthSocialProofMessage rename so existing
        // translations are not lost.
        id: "oauth-banner.oauth-social-proof-message.dismiss",
        defaultMessage: "Dismiss"
    },
    oauthSocialProofMessageTitleLowAdoption: {
        id: "oauth-banner.oauth-social-proof-message.title-low-adoption",
        defaultMessage: "Your team connected {product}"
    },
    oauthSocialProofMessageTitleHighAdoption: {
        id: "oauth-banner.oauth-social-proof-message.title-high-adoption",
        defaultMessage: "{percentage}% of your team has connected apps like {product}"
    },
    oauthSocialProofMessageConnect: {
        id: "oauth-banner.oauth-social-proof-message.connect",
        defaultMessage: "Connect to {product}"
    },
    oauthSocialProofMessageImageAlt: {
        id: "oauth-banner.oauth-social-proof-message.image-alt",
        defaultMessage: "Animated preview of {product} search results"
    }
});


const $a443a61fd09ae17f$var$styles = {
    container: "_zulp12x7 _1reo15vq _18m915vq _2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _kqswh2mm _1e0c1txw _4cvr1fhb _bfhkvuon _1bsb1osq _4t3i1lit",
    content: "_16jlkb7n _1o9zkb7n _i0dl1wug _1q51pxbi _85i5pxbi _bozgv47k _y4tiv47k _1ul9idpf _bfhk1bhr",
    productIcon: "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o",
    titleWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf",
    titleText: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    imageContainer: "_16jlidpf _1o9zidpf _i0dl1wug _1reo15vq _18m915vq _1bsb52fy _kqswh2mm _1e0c1txw _4cvr1fhb _1bah1fhb _bfhki8nm",
    bannerImage: "_1e0c1ule _1bsb1osq _4t3i1osq _5ral1dfr"
};
/**
 * Threshold above which we switch from the low-adoption title
 * ("Your team connected {product}") to the high-adoption title
 * ("{percentage}% of your team has connected apps like {product}").
 */ const $a443a61fd09ae17f$var$TEAM_CONNECTED_MID_TIER_MIN = 30;
const $a443a61fd09ae17f$export$a76ecc112fc9a0f6 = 'oauth-social-proof-message';
const $a443a61fd09ae17f$export$ebc4d6d9761342bc = ({ onAuthorize: onAuthorize, onDismiss: onDismiss, oAuthSource: oAuthSource, product: product, teamConnectedPercentage: teamConnectedPercentage = 0, hidePreviewImage: hidePreviewImage = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const products = (0, $1yEFx.useProductConfigs)();
    const { productIcon: productIcon, description: description, imageSrc: imageSrc } = (0, $0d23e5415599265a$export$defa06e894d14087)(product, {
        colorMode: colorMode
    });
    const { displayName: displayName } = products[product] || {};
    const productDisplayName = displayName && typeof displayName === 'string' ? displayName : product; // Pick the title variant based on what percentage of the user's team
    // has already connected — a "social proof" nudge.
    //   <30% → "Your team connected {product}"
    //   ≥30% → "{percentage}% of your team has connected apps like {product}"
    const titleMessage = teamConnectedPercentage >= $a443a61fd09ae17f$var$TEAM_CONNECTED_MID_TIER_MIN ? (0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageTitleHighAdoption : (0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageTitleLowAdoption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.container,
        testId: $a443a61fd09ae17f$export$a76ecc112fc9a0f6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, productIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.productIcon
    }, productIcon) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.titleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $a443a61fd09ae17f$var$styles.titleText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...titleMessage,
        values: {
            percentage: teamConnectedPercentage,
            product: productDisplayName
        }
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium",
        color: "color.text",
        maxLines: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: ()=>onAuthorize(oAuthSource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageConnect,
        values: {
            product: productDisplayName
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: onDismiss
    }, formatMessage((0, $ca59f813d2f1dff5$export$defe85febe8b728c).dismiss))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.imageContainer
    }, !hidePreviewImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "img",
        src: imageSrc,
        alt: formatMessage((0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageImageAlt, {
            product: productDisplayName
        }),
        xcss: $a443a61fd09ae17f$var$styles.bannerImage
    })));
};






const $270ff42eb089344c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    authorizationFail: {
        id: "oauth-banner.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "oauth-banner.authorization-success",
        defaultMessage: "Account connected to {product}."
    },
    connectThirdPartyProductTitle: {
        id: "connect_third_party_product_title",
        defaultMessage: "Your admin has added {product}!"
    },
    connectThirdPartyProductTitleAlternate: {
        id: "connect_third_party_product_title_alternate",
        defaultMessage: "{product} is now available!"
    },
    connectThirdPartyProductDescription: {
        id: "connect_third_party_product_description",
        defaultMessage: "Connect your account to see missing results"
    },
    connect: {
        id: "oauth-message-connect",
        defaultMessage: "Connect"
    }
});



var $5A2fk = parcelRequire("5A2fk");

const $627ae985e76305b5$var$oauthBannerContainerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $627ae985e76305b5$export$4177cdcc6454d6f2 = ({ product: product, outboundAuthUrl: outboundAuthUrl, isOnSearchDialog: isOnSearchDialog, isSmartlink: isSmartlink, useOAuthHandlers: useOAuthHandlers, fireAnalyticsEvent: fireAnalyticsEvent, thirdPartyConfigs: thirdPartyConfigs, teamConnectedPercentage: teamConnectedPercentage })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const products = (0, $1yEFx.useProductConfigs)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    const productString = product === 'sharepoint' ? 'SharePoint' : products[product]?.displayName || '';
    const Icon = products[product].Icon;
    const showAlternateConnectMessage = product === (0, $b4tvS.ProductKeys).Figma || isSmartlink;
    const connectorSource = isSmartlink ? (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE);
    const isFPSGithubBanner = !isOnSearchDialog && product === (0, $b4tvS.ProductKeys).Github;
    const showOAuthSocialProofMessage = isFPSGithubBanner && (0, $2OtFZ.serveFPSGitHubSocialProofBannerExperiment)({
        thirdPartyConfigs: thirdPartyConfigs
    });
    const isFPSGithubBannerPromo = isFPSGithubBanner && (0, $2OtFZ.serveFPSGitHubAuthBannerPromo)({
        thirdPartyConfigs: thirdPartyConfigs
    });
    // When the social-proof variant is shown, the connector-specific config
    // (e.g. `github/config.tsx`) owns the success-flag copy. We resolve it
    // here and pass the formatted strings through to `useOAuthHandlers` so
    // the controller stays connector-agnostic.
    const socialProofContent = showOAuthSocialProofMessage ? (0, $0d23e5415599265a$export$defa06e894d14087)((0, $b4tvS.ProductKeys).Github, {
        colorMode: colorMode
    }) : undefined;
    const successFlagTitle = socialProofContent?.successFlagTitle !== undefined ? formatMessage(socialProofContent.successFlagTitle, {
        product: productString
    }) : formatMessage((0, $270ff42eb089344c$export$defe85febe8b728c).authorizationSuccess, {
        product: productString
    });
    const successFlagDescription = socialProofContent?.successFlagDescription !== undefined ? formatMessage(socialProofContent.successFlagDescription) : undefined;
    const { onAuthorize: onAuthorize, onDismiss: onDismiss } = useOAuthHandlers({
        product: product,
        connectorSource: connectorSource,
        successFlagTitle: successFlagTitle,
        successFlagDescription: successFlagDescription,
        showUnderstoodButton: showOAuthSocialProofMessage,
        failFlagTitle: formatMessage((0, $270ff42eb089344c$export$defe85febe8b728c).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl,
        onCompletedAction: ()=>{
            setIsDismissed(true);
        },
        onDismissAction: ()=>{
            setIsDismissed(true);
            if (isFPSGithubBannerPromo) (0, $5A2fk.snoozeProduct)(product);
            else (0, $5A2fk.increaseProductDismissCount)(product);
        },
        isOnSearchDialog: isOnSearchDialog
    });
    $627ae985e76305b5$var$useBannerShownAnalytics({
        fireAnalyticsEvent: fireAnalyticsEvent,
        isOnSearchDialog: isOnSearchDialog,
        product: product,
        connectorSource: connectorSource
    });
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...showAlternateConnectMessage ? (0, $270ff42eb089344c$export$defe85febe8b728c).connectThirdPartyProductTitleAlternate : (0, $270ff42eb089344c$export$defe85febe8b728c).connectThirdPartyProductTitle,
        values: {
            product: productString
        }
    });
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $270ff42eb089344c$export$defe85febe8b728c).connectThirdPartyProductDescription);
    if (isDismissed) return null;
    const messageContent = {
        title: title,
        description: description,
        connectText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $270ff42eb089344c$export$defe85febe8b728c).connect),
        MessageIcon: Icon
    };
    const messageProps = {
        content: messageContent,
        onAuthorize: onAuthorize,
        onDismiss: ()=>{
            fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
                isOnSearchDialog: isOnSearchDialog,
                oAuthSource: isOnSearchDialog ? (0, $ckkm9.OAuthSource).quickFindOAuthBanner : (0, $ckkm9.OAuthSource).searchPageOAuthBanner,
                componentName: 'OAuthBanner',
                product: product,
                connectorSource: connectorSource
            }));
            return onDismiss();
        }
    };
    if (showOAuthSocialProofMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a443a61fd09ae17f$export$ebc4d6d9761342bc), {
        product: product,
        onAuthorize: onAuthorize,
        onDismiss: messageProps.onDismiss,
        oAuthSource: (0, $ckkm9.OAuthSource).searchPageOAuthBanner,
        teamConnectedPercentage: teamConnectedPercentage
    });
    return isOnSearchDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $627ae985e76305b5$var$oauthBannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52087ab64c3a7923$export$1b25a7895791d4fc), {
        ...messageProps,
        isOnSearchDialog: true,
        oAuthSource: (0, $ckkm9.OAuthSource).quickFindOAuthBanner
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52087ab64c3a7923$export$1b25a7895791d4fc), {
        ...messageProps,
        oAuthSource: (0, $ckkm9.OAuthSource).searchPageOAuthBanner
    });
};
const $627ae985e76305b5$var$useBannerShownAnalytics = ({ fireAnalyticsEvent: fireAnalyticsEvent, isOnSearchDialog: isOnSearchDialog, product: product, connectorSource: connectorSource })=>{
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $2zyFZ.onBannerShown)({
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: isOnSearchDialog ? (0, $ckkm9.OAuthSource).quickFindOAuthBanner : (0, $ckkm9.OAuthSource).searchPageOAuthBanner,
            componentName: 'OAuthBanner',
            product: product,
            connectorSource: connectorSource
        }));
    }, [
        fireAnalyticsEvent,
        isOnSearchDialog,
        product,
        connectorSource
    ]);
};



var $def8z = parcelRequire("def8z");





var $RWXHe = parcelRequire("RWXHe");


var $UXqiP = parcelRequire("UXqiP");


var $6RGiC = parcelRequire("6RGiC");

const $4d7a3d27ae0dfe35$export$83d3a14acfdb8d27 = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, eligibleProducts: eligibleProducts, useOAuthHandlers: useOAuthHandlers, fireAnalyticsEvent: fireAnalyticsEvent, teamConnectedPercentage: teamConnectedPercentage })=>{
    const suppressBanner = (0, $6RGiC.useShouldSuppressBannerForAnimation)();
    if ((0, $dh538.fg)('rovo_search_3p_banner_opt_out') || isOnSearchDialog && suppressBanner) return null;
    // First product that needs OAuth (eligibleProducts is already ordered + filtered at call site)
    const displayedProduct = eligibleProducts.find((product)=>thirdPartyConfigs[product]?.userNeedsOAuth);
    const displayedProduct3PConfig = displayedProduct ? thirdPartyConfigs[displayedProduct] : undefined;
    const outboundAuthUrl = displayedProduct3PConfig?.outboundAuthUrl;
    // a little redundant way of getting this value, but just making use of common function
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: displayedProduct,
        thirdPartyConfigs: thirdPartyConfigs
    });
    if (!displayedProduct || !outboundAuthUrl) return null;
    if (isOnSearchDialog && (0, $2OtFZ.serveQF3PBannerExperiment)()) {
        if ((0, $dh538.fg)('post-office_enable_search-quick-find-headless')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $UXqiP.QuickFindHeadlessVisiblePlacement), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $RWXHe.PlacementSlot), {
            trackImpressionOnMount: true
        });
    }
    const oauthBannerComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $627ae985e76305b5$export$4177cdcc6454d6f2), {
        product: displayedProduct,
        outboundAuthUrl: outboundAuthUrl,
        useOAuthHandlers: useOAuthHandlers,
        isSmartlink: isSmartlink,
        isOnSearchDialog: isOnSearchDialog,
        fireAnalyticsEvent: fireAnalyticsEvent,
        thirdPartyConfigs: thirdPartyConfigs,
        teamConnectedPercentage: teamConnectedPercentage
    });
    return isOnSearchDialog ? oauthBannerComponent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, oauthBannerComponent);
};
module.exports["OAuthContainer"] = $4d7a3d27ae0dfe35$export$83d3a14acfdb8d27;

});

parcelRegister("i2RLU", function(module, exports) {
// @ts-ignore - this is not a valid package entry point and cannot be resolved when using a modern Typescript 'moduleResolution' setting

var $6yNqK = parcelRequire("6yNqK");

const $414cef57e6aae72a$export$97e8379351820edc = ({ isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, componentName: componentName, product: product, connectorSource: connectorSource })=>({
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        actionSubject: 'button',
        action: 'clicked',
        actionSubjectId: 'searchBannerDismissed',
        attributes: {
            // The fireAnalytics function in useAnalytics requires attributes to be defined in additionalAttributes
            // The fireAnalytics function in useQuickFindAnalytics does not require attributes to be defined in additionalAttributes
            // We should consolidate analytics signatures between QF and FPS (https://product-fabric.atlassian.net/browse/QS-7746)
            ...isOnSearchDialog ? {
                componentName: componentName,
                oAuthSource: oAuthSource,
                product: product,
                connectorSource: connectorSource
            } : {
                additionalAttributes: {
                    componentName: componentName,
                    oAuthSource: oAuthSource,
                    product: product,
                    connectorSource: connectorSource
                }
            }
        }
    });
module.exports["onBannerDismissed"] = $414cef57e6aae72a$export$97e8379351820edc;

});

parcelRegister("2zyFZ", function(module, exports) {
// @ts-ignore - this is not a valid package entry point and cannot be resolved when using a modern Typescript 'moduleResolution' setting

var $6yNqK = parcelRequire("6yNqK");

const $a5eed839749b1cd0$export$7d1e74b831505b41 = ({ isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, componentName: componentName, product: product, connectorSource: connectorSource })=>({
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        eventType: 'track',
        actionSubject: 'searchBanner',
        action: 'shown',
        attributes: {
            // The fireAnalytics function in useAnalytics requires attributes to be defined in additionalAttributes
            // The fireAnalytics function in useQuickFindAnalytics does not require attributes to be defined in additionalAttributes
            // We should consolidate analytics signatures between QF and FPS (https://product-fabric.atlassian.net/browse/QS-7746)
            ...isOnSearchDialog ? {
                componentName: componentName,
                oAuthSource: oAuthSource,
                product: product,
                connectorSource: connectorSource
            } : {
                additionalAttributes: {
                    componentName: componentName,
                    oAuthSource: oAuthSource,
                    product: product,
                    connectorSource: connectorSource
                }
            }
        }
    });
module.exports["onBannerShown"] = $a5eed839749b1cd0$export$7d1e74b831505b41;

});

parcelRegister("dHZuf", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $371c7e1a4d1f86a2$export$e43472a3ada71740 = (query)=>/^[A-Z0-9]{2,}-\d+$/i.test(query.trim());
const $371c7e1a4d1f86a2$var$ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
const $371c7e1a4d1f86a2$var$buildJiraJqlUrl = (jql, query)=>`/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(query)}`;
const $371c7e1a4d1f86a2$var$buildJiraSearchUrl = (searchString, issueKeyLookup)=>{
    if (!issueKeyLookup && (0, $dh538.fg)('rovo_search_update_work_items_link')) {
        const clauseField = $371c7e1a4d1f86a2$export$e43472a3ada71740(searchString) ? 'issuekey' : 'textfields';
        return `/issues/?jql=${clauseField} ~ "${encodeURIComponent(searchString)}*"`;
    }
    return `/jira/search?${new URLSearchParams({
        searchString: searchString
    }).toString()}`;
};
const $371c7e1a4d1f86a2$export$772e48b507423c7c = (query, jql, issueKeyLookup)=>{
    const trimmedQuery = query.trim();
    if (jql) return $371c7e1a4d1f86a2$var$buildJiraJqlUrl(jql, query);
    if (trimmedQuery) return $371c7e1a4d1f86a2$var$buildJiraSearchUrl(trimmedQuery, issueKeyLookup);
    return $371c7e1a4d1f86a2$var$ISSUE_NAVIGATOR_URL;
};
const $371c7e1a4d1f86a2$var$buildRovoSearchUrl = (siteUrl)=>{
    const path = '/jira/rovo-search';
    if (!siteUrl) return path;
    return new URL(path, siteUrl || '').href;
};
const $371c7e1a4d1f86a2$export$48bdb02c221fe04 = (urlQueryParams, isSecondaryLink, customParams, issueKeyLookup = true)=>{
    const searchParams = new URLSearchParams(customParams || {});
    // This function assumes the text is in sync with JQL text field
    let queryString = searchParams.get('text') || urlQueryParams.text?.toString() || '';
    const jql = searchParams.get('jql') || !isSecondaryLink && urlQueryParams.jql?.toString() || '';
    // remove jql from params as it's already picked up
    searchParams.delete('jql');
    if (!isSecondaryLink) Object.entries(urlQueryParams).forEach(([key, value])=>{
        // add current params if they are not in custom search params
        if (value !== undefined && value !== null && !searchParams.has(key)) searchParams.set(key, String(value));
    });
    let url = isSecondaryLink ? $371c7e1a4d1f86a2$export$772e48b507423c7c(queryString, jql, issueKeyLookup) : $371c7e1a4d1f86a2$var$buildRovoSearchUrl();
    const params = searchParams.toString();
    if (params) url = url.concat(url.includes('?') ? '&' : '?').concat(params);
    return url;
};
module.exports["isQueryLikeWorkItemKey"] = $371c7e1a4d1f86a2$export$e43472a3ada71740;
module.exports["generateJiraSearchUrl"] = $371c7e1a4d1f86a2$export$48bdb02c221fe04;

});

parcelRegister("8UOsA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ecnYn = parcelRequire("ecnYn");


var $2W0qg = parcelRequire("2W0qg");




const $7ad591125a6bb6cf$export$e5220a1129d6e11c = (0, $aXWIB.defineMessages)({
    feedbackButton: {
        id: "search_common.feedback_button",
        defaultMessage: "Give feedback"
    }
});


const $db4f68a9c93392e4$var$feedbackButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.link',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $db4f68a9c93392e4$var$feedbackButtonSmallStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $db4f68a9c93392e4$export$116fedbe5e2e2bd8 = ({ onClick: onClick, size: size = 'medium' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: [
            $db4f68a9c93392e4$var$feedbackButtonStyles,
            size === 'small' && $db4f68a9c93392e4$var$feedbackButtonSmallStyles
        ],
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7ad591125a6bb6cf$export$e5220a1129d6e11c).feedbackButton));
module.exports["FeedbackButton"] = $db4f68a9c93392e4$export$116fedbe5e2e2bd8;

});

parcelRegister("7Yuqm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6uGcC = parcelRequire("6uGcC");


var $iLCTn = parcelRequire("iLCTn");


var $5XpfZ = parcelRequire("5XpfZ");

const $135f97f348b2ff15$var$packageName = "platform-pkg";
const $135f97f348b2ff15$var$packageVersion = "0.0.0-use.local";
const $135f97f348b2ff15$export$2db401a6b81eceee = `${$135f97f348b2ff15$var$packageName}@${$135f97f348b2ff15$var$packageVersion}`;
const $135f97f348b2ff15$export$25dc0a1e75f58d8f = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $135f97f348b2ff15$export$d04cd98bb7625919 = 'customfield_10047';
const $135f97f348b2ff15$export$83c8d7110915321e = 'search-page';


const $a7df8303f8002da0$export$e0fccaef47ee61b8 = (keys)=>{
    return JSON.stringify(keys);
};



const $2ed018b70d6fe5e9$export$67d3c3516a0ee4ec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $2ed018b70d6fe5e9$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $2ed018b70d6fe5e9$var$FeedbackCollector = ({ cloudId: cloudId, experimentConfig: experimentConfig, isOpen: isOpen, primaryProduct: primaryProduct, product: product, setIsOpen: setIsOpen, onSubmit: onSubmit, onCancel: onCancel, source: source, userId: userId, userName: userName, mode: mode, requestId: requestId, traceId: traceId })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2ed018b70d6fe5e9$export$67d3c3516a0ee4ec, {
        locale: locale,
        onClose: ()=>{
            onCancel?.();
            setIsOpen(false);
        },
        onSubmit: ()=>{
            onSubmit?.();
            setDisplayFlag(true);
            setIsOpen(false);
        },
        atlassianAccountId: userId,
        name: userName,
        entrypointId: (0, $135f97f348b2ff15$export$25dc0a1e75f58d8f),
        additionalFields: [
            {
                id: (0, $135f97f348b2ff15$export$d04cd98bb7625919),
                value: (0, $a7df8303f8002da0$export$e0fccaef47ee61b8)({
                    experimentLayers: experimentConfig.backendExperiment?.experimentLayers,
                    frontendExperiments: experimentConfig.frontendExperiments,
                    version: (0, $135f97f348b2ff15$export$2db401a6b81eceee),
                    release: (0, $iLCTn.getProductReleaseVersion)(primaryProduct),
                    source: source,
                    product: product,
                    primaryProduct: primaryProduct,
                    // JQL has an issue with "contains" search. Use this value to filter out JQL feedback.
                    primaryProductFilterString: `primaryProduct${primaryProduct}`,
                    cloudId: cloudId,
                    userId: userId,
                    isHello: (0, $5XpfZ.isHello)(cloudId),
                    mode: mode,
                    requestId: requestId,
                    traceId: traceId
                })
            }
        ]
    })), displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2ed018b70d6fe5e9$var$AkFeedbackFlag, {
        locale: locale
    }))));
};
var $2ed018b70d6fe5e9$export$2e2bcd8739ae039 = $2ed018b70d6fe5e9$var$FeedbackCollector;
module.exports["default"] = $2ed018b70d6fe5e9$export$2e2bcd8739ae039;

});

parcelRegister("iLCTn", function(module, exports) {
const $e71cbd5e593c3cac$var$memoizedQuerySelector = (selectors)=>{
    let element = null;
    return ()=>{
        if (!element) element = document.querySelector(selectors);
        return element;
    };
};
const $e71cbd5e593c3cac$export$d521605fb33b0dfd = (product)=>{
    switch(product?.toLowerCase()){
        case 'confluence':
            return window.__buildInfo?.FRONTEND_VERSION || 'noversion';
        case 'jira':
            return window.BUILD_KEY;
        // @ts-ignore - TS2872 TypeScript 5.9.2 upgrade
        case 'townsquare':
            const versionMeta = $e71cbd5e593c3cac$var$memoizedQuerySelector('meta[name="release-version"]');
            if (versionMeta instanceof HTMLMetaElement) return versionMeta.content;
    }
    return 'noversion';
};
module.exports["getProductReleaseVersion"] = $e71cbd5e593c3cac$export$d521605fb33b0dfd;

});

parcelRegister("6yoZS", function(module, exports) {

let $4c594eef01830b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c594eef01830b0b$var$load("hhss7"),
    $4c594eef01830b0b$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});

parcelRegister("eoZmS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $dpPtd = parcelRequire("dpPtd");


var $8tdj3 = parcelRequire("8tdj3");


var $eXmBZ = parcelRequire("eXmBZ");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $dnIVK = parcelRequire("dnIVK");


var $j4ply = parcelRequire("j4ply");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");
var $1yEFx = parcelRequire("1yEFx");


var $2OtFZ = parcelRequire("2OtFZ");


var $YqPsE = parcelRequire("YqPsE");




const $c62e19c9051d98ef$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    authorizeConnectThirdPartyProduct: {
        id: "sidebar-authorize_connect_third_party_product",
        defaultMessage: "Your admin has added <strong>{product}!</strong>{br}\n\t\t\tConnect your account to see missing results, including documents only you have access to.\n\t\t"
    },
    authorizeConnectThirdPartyProductAlternate: {
        id: "sidebar-authorize_connect_third_party_product_alternate_msg",
        defaultMessage: "<strong>{product} is now available!</strong>{br}\n\t\t\tConnect your account to see missing results, including content only you have access to.\n\t\t"
    },
    dismiss: {
        id: "sidebar-oauth-warning-dismiss",
        defaultMessage: "Dismiss"
    },
    authorize: {
        id: "sidebar-oauth-warning-authorize",
        defaultMessage: "Authorize"
    },
    authorizationFail: {
        id: "sidebar-oauth-warning.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "sidebar-oauth-warning.authorization-success",
        defaultMessage: "Successfully connected to {product}."
    },
    notNow: {
        id: "sidebar-oauth-warning.not-now",
        defaultMessage: "Not now"
    },
    connect: {
        id: "sidebar-oauth-warning.connect",
        defaultMessage: "Connect"
    },
    appFilterTooltipContent: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content",
        defaultMessage: "Connect your account to see missing results, including documents only you have access to."
    },
    appFilterTooltipContentAlternate: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content-alternate",
        defaultMessage: "Connect your account to see missing results, including content only you have access to."
    }
});


const $c151e079e3af8d1c$var$popupContentStyles = (0, $ecnYn.xcss)({
    width: '20rem',
    padding: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $c151e079e3af8d1c$var$buttonContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row'
});
const $c151e079e3af8d1c$var$buttonStyles = (0, $ecnYn.xcss)({
    margin: 'space.100'
});
const $c151e079e3af8d1c$var$infoIconStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    cursor: 'pointer'
});
const $c151e079e3af8d1c$var$popupTriggerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $c151e079e3af8d1c$var$connectButtonStyles = (0, $ecnYn.xcss)({
    marginLeft: 'auto',
    right: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $c151e079e3af8d1c$var$sidebarStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $c151e079e3af8d1c$var$connectTextStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $c151e079e3af8d1c$var$singleSelectConnectTextStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: 'font.body.small',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $c151e079e3af8d1c$export$14011507d36518b5 = ({ product: product, isSmartlink: isSmartlink, isInline: isInline, trigger: trigger, isOnSearchDialog: isOnSearchDialog, searchQuery: searchQuery, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, option: option, index: index, postAuthAction: postAuthAction, oAuthSource: oAuthSource, datasourceId: datasourceId, thirdPartyConfigs: thirdPartyConfigs, onAppFilterClick: onAppFilterClick })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { userNeedsOAuth: userNeedsOAuth, outboundAuthUrl: outboundAuthUrl } = useIsUserOAuthed(product, datasourceId);
    const fireOAuthHovered = (0, $dnIVK.useFireOAuthHovered)({
        cloudId: cloudId || '',
        product: product || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs || {}
    });
    // For Forge connectors, use workspaceName from thirdPartyConfigs
    const workspaceName = thirdPartyConfigs ? (0, $YqPsE.getWorkspaceNameFromProduct)(product, thirdPartyConfigs) : undefined;
    const productString = product && workspaceName || product && products[product]?.displayName || '';
    const { onAuthorize: onAuthorize, onDismiss: onDismiss } = useOAuthHandlers({
        product: product,
        successFlagTitle: formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizationSuccess, {
            product: productString
        }),
        failFlagTitle: formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl || '',
        onCompletedAction: ()=>{
            setIsPopupOpen(false);
            option?.showFilter();
            option?.onSelect();
            postAuthAction?.();
        },
        onDismissAction: ()=>{
            setIsPopupOpen(false);
        },
        isOnSearchDialog: isOnSearchDialog,
        query: searchQuery,
        datasourceId: datasourceId
    });
    const connectMessage = product === (0, $b4tvS.ProductKeys).Figma || isSmartlink ? (0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizeConnectThirdPartyProductAlternate : (0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizeConnectThirdPartyProduct;
    //This component is a functional wrapper that turns the trigger prop into a popup trigger.
    // if no warning is needed, we just render the trigger
    if (!product || !userNeedsOAuth || !outboundAuthUrl) return trigger({
        isDisabled: false
    });
    const handleClickConnect = ()=>{
        onAppFilterClick?.();
        // Skip popup and connect immediately if either of these experiments are enabled
        // serveOneClick3PConnectExperiment was a SHIP decision so this will always return true
        // We aren't cleaning this experiment up in the code since there is a growth holdout attached to it
        if ((0, $2OtFZ.serveOneClick3PConnectExperiment)() || (0, $2OtFZ.isInUnifiedSearch3PConnectImprovementsTestCohort)()) {
            onAuthorize(oAuthSource);
            return;
        }
        setIsPopupOpen(!isPopupOpen);
    };
    const handleConnectHover = ()=>{
        setTimeout(()=>{
            fireOAuthHovered(oAuthSource);
        }, 1000);
    };
    const connectButton = ()=>{
        const tooltipMessage = product === (0, $b4tvS.ProductKeys).Figma || isSmartlink ? (0, $c62e19c9051d98ef$export$defe85febe8b728c).appFilterTooltipContentAlternate : (0, $c62e19c9051d98ef$export$defe85febe8b728c).appFilterTooltipContent;
        switch((0, $2OtFZ.getUnifiedSearch3PConnectImprovementsCohort)()){
            case 'icon-and-tooltip':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    testId: "connect-button-tooltip",
                    content: formatMessage(tooltipMessage)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    testId: "connect-button-with-context",
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                    testId: "link-external-icon",
                    label: "link-external",
                    color: "var(--ds-icon-brand, #1868DB)",
                    size: "small"
                }))));
            case 'icon-only':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    testId: "connect-button-with-context",
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                    testId: "link-external-icon",
                    label: "link-external",
                    color: "var(--ds-icon-brand, #1868DB)",
                    size: "small"
                })));
            case 'tooltip-only':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    testId: "connect-button-tooltip",
                    content: formatMessage(tooltipMessage)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    testId: "connect-button-with-context",
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect))));
            // control
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)));
        }
    };
    const triggerComponent = (triggerProps)=>{
        const oAuthWarning = isInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $c151e079e3af8d1c$var$infoIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            label: "oauth warning",
            color: "var(--ds-icon-brand, #1868DB)",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, connectButton());
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onClick: handleClickConnect,
            onMouseEnter: handleConnectHover,
            xcss: [
                $c151e079e3af8d1c$var$popupTriggerStyles,
                !isInline && !isOnSearchDialog && $c151e079e3af8d1c$var$sidebarStyles
            ]
        }, trigger({
            oAuthWarning: oAuthWarning,
            isDisabled: true,
            triggerProps: triggerProps
        })));
    };
    const isFurtherDownThanFourth = index && index > 3;
    const rightRailPopupPlacement = isFurtherDownThanFourth ? 'left-end' : 'left-start';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: isOnSearchDialog || isInline ? 'bottom-start' : rightRailPopupPlacement,
        trigger: triggerComponent,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $c151e079e3af8d1c$var$popupContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(connectMessage, {
                product: productString,
                strong: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                        as: "strong"
                    }, text),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                xcss: $c151e079e3af8d1c$var$buttonContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                xcss: $c151e079e3af8d1c$var$buttonStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                onClick: onDismiss
            }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).notNow))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                xcss: $c151e079e3af8d1c$var$buttonStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                onClick: ()=>onAuthorize(oAuthSource),
                appearance: "primary"
            }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)))))
    });
};
const $c151e079e3af8d1c$export$3415e5401c1f1ae1 = (props)=>{
    return props.isOnSearchDialog || props.skipFlagsProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c151e079e3af8d1c$export$14011507d36518b5, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c151e079e3af8d1c$export$14011507d36518b5, props));
};
module.exports["OAuthWarningWrapper"] = $c151e079e3af8d1c$export$3415e5401c1f1ae1;

});

parcelRegister("YqPsE", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $7b8e63dc3b89f14f$export$ee0bd2121a6df2d5 = (product, thirdPartyConfigs)=>{
    let workspaceName;
    if (product && thirdPartyConfigs) {
        // Check if it's a 3P product or Forge connector
        const is3POrForge = (0, $b4tvS.is3pProductKey)(product) || (0, $9d9t8.isForgeConnectorProductKey)(product);
        if (is3POrForge) {
            const config = thirdPartyConfigs[product];
            const shouldDisplayWorkspaceName = config?.displayWorkspaceNameAsProductName;
            const shouldUseFanOutConnector = config?.fanOutConnectorSources;
            if (shouldDisplayWorkspaceName || shouldUseFanOutConnector) workspaceName = config?.workspaceName;
        }
    }
    return workspaceName;
};
module.exports["getWorkspaceNameFromProduct"] = $7b8e63dc3b89f14f$export$ee0bd2121a6df2d5;

});

parcelRegister("5xGHP", function(module, exports) {
const $00b64bc742da3325$export$abf7f7ce81b5b4bb = ({ action: action, actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: action,
        actionSubject: 'appSelector',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
module.exports["onAppFilterSelect"] = $00b64bc742da3325$export$abf7f7ce81b5b4bb;

});

parcelRegister("kRxMN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $bHjhd = parcelRequire("bHjhd");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $5iakG = parcelRequire("5iakG");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1Whri = parcelRequire("1Whri");


var $2g1PW = parcelRequire("2g1PW");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");




const $97d67a1241dac654$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    results: {
        id: "search-page.ai-mode.results",
        defaultMessage: "Results"
    },
    aiMode: {
        id: "search-page.ai-mode.ai-mode",
        defaultMessage: "AI Mode"
    }
});





const $9b3ba1f7e3fd9ab7$export$82eafebb825fc23f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_28_24028)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.85547 1.51562C8.12151 1.4809 9.35861 1.84767 10.3965 2.55078L8.6416 3.42871C8.13013 3.2267 7.58107 3.11916 7.02051 3.11914C5.84959 3.11914 4.7264 3.58415 3.89844 4.41211C3.07057 5.24006 2.60547 6.36334 2.60547 7.53418C2.6056 8.70484 3.07069 9.82744 3.89844 10.6553C4.7264 11.4832 5.84959 11.9482 7.02051 11.9482C8.19136 11.9482 9.31466 11.4832 10.1426 10.6553C10.6138 10.1839 10.9673 9.61692 11.1846 9H12.8584C12.6582 9.79708 12.2963 10.552 11.7852 11.2139L14.9482 14.4326C15.0899 14.5858 15.166 14.7885 15.1611 14.9971C15.1562 15.2056 15.0706 15.4045 14.9219 15.5508C14.7732 15.697 14.5728 15.7797 14.3643 15.7812C14.1557 15.7827 13.9545 15.7027 13.8037 15.5586L10.6426 12.3428C9.42299 13.2614 7.90008 13.6825 6.38184 13.5205C4.86341 13.3584 3.46313 12.6253 2.46484 11.4697C1.46662 10.3142 0.944698 8.82266 1.00488 7.29688C1.0651 5.77111 1.70293 4.32521 2.78906 3.25195C3.87532 2.17867 5.32899 1.55751 6.85547 1.51562Z",
        fill: "url(#pattern0_28_24028)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.3958 2.42259C11.4884 2.16884 11.7297 2 11.9998 2C12.2699 2 12.5116 2.16884 12.6042 2.42259L13.1316 3.86825L14.5774 4.39558C14.8311 4.48814 15 4.72946 15 4.99959C15 5.26972 14.8311 5.51144 14.5774 5.604L13.1316 6.13133L12.6042 7.57699C12.5116 7.83075 12.2703 7.99958 12.0002 7.99958C11.7301 7.99958 11.4884 7.83075 11.3958 7.57699L10.8684 6.13133L9.42263 5.604C9.16885 5.51144 9 5.27012 9 4.99999C9 4.72986 9.16885 4.48814 9.42263 4.39558L10.8684 3.86825L11.3958 2.42259Z",
        fill: "url(#pattern1_28_24028)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("pattern", {
        id: "pattern0_28_24028",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#image0_28_24028",
        transform: "matrix(0.00196772 0 0 0.00195312 -0.00373519 0)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("pattern", {
        id: "pattern1_28_24028",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#image0_28_24028",
        transform: "scale(0.00195312)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_28_24028"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("image", {
        id: "image0_28_24028",
        width: "512",
        height: "512",
        preserveAspectRatio: "none",
        href: "data:image/png;base64,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"
    })));


const $af57685ca39b004e$var$styles = {
    root: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1l7x _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _bfhk1j9a",
    tabOptionStyles: "_2rko12b0 _bfhk1j9a _19bv12x7 _u5f3u2gc _4t3iqslr",
    tabOptionLinkStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    tabOptionSelectedStyles: "_bfhk15s3",
    searchIconWrapperStyles: "_1bsb7vkz _4t3i7vkz"
};
const $af57685ca39b004e$export$e1e2cdfa7f3f030c = ({ query: query, tenantDomain: tenantDomain })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $af57685ca39b004e$var$styles.root
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.0"
    }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($af57685ca39b004e$var$styles.tabOptionStyles, $af57685ca39b004e$var$styles.tabOptionSelectedStyles)
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))), {
        color: "var(--ds-icon-selected, #1868DB)",
        label: ""
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.selected",
        weight: "medium"
    }, intl.formatMessage((0, $97d67a1241dac654$export$defe85febe8b728c).results)))), /*#__PURE__*/ $42omo.createElement((0, $auNCB.default), {
        xcss: (0, $1Whri.cx)($af57685ca39b004e$var$styles.tabOptionStyles, $af57685ca39b004e$var$styles.tabOptionLinkStyles),
        href: `${tenantDomain}/wiki/ai-search/?aiSearchQuery=${query}`
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $af57685ca39b004e$var$styles.searchIconWrapperStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $9b3ba1f7e3fd9ab7$export$82eafebb825fc23f), null)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "medium"
    }, intl.formatMessage((0, $97d67a1241dac654$export$defe85febe8b728c).aiMode))))));
};



var $gCEkV = parcelRequire("gCEkV");


var $86ob4 = parcelRequire("86ob4");


var $5eWut = parcelRequire("5eWut");


var $3CshZ = parcelRequire("3CshZ");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");

parcelRequire("ehGUC");
var $lx1ar = parcelRequire("lx1ar");
var $gHwfH = parcelRequire("gHwfH");
var $fJFyr = parcelRequire("fJFyr");
var $a97k3 = parcelRequire("a97k3");


var $fw303 = parcelRequire("fw303");


var $k7ise = parcelRequire("k7ise");





var $iUihD = parcelRequire("iUihD");


var $5X4Ay = parcelRequire("5X4Ay");


var $5VnRb = parcelRequire("5VnRb");


var $F3Hv6 = parcelRequire("F3Hv6");


var $hHAPz = parcelRequire("hHAPz");


var $2a0ps = parcelRequire("2a0ps");


var $dQXZO = parcelRequire("dQXZO");


var $aGXLL = parcelRequire("aGXLL");


var $c5dmm = parcelRequire("c5dmm");


var $6jSbc = parcelRequire("6jSbc");


var $e7L4o = parcelRequire("e7L4o");


var $lPWNq = parcelRequire("lPWNq");


var $gwbWt = parcelRequire("gwbWt");


var $1uGSo = parcelRequire("1uGSo");


var $huubg = parcelRequire("huubg");


var $dFCIx = parcelRequire("dFCIx");


var $5ousX = parcelRequire("5ousX");


var $1sswv = parcelRequire("1sswv");


var $fLju9 = parcelRequire("fLju9");


var $dXdDw = parcelRequire("dXdDw");


var $5eFo6 = parcelRequire("5eFo6");


var $aeffu = parcelRequire("aeffu");





var $3TPSi = parcelRequire("3TPSi");


var $f1JPm = parcelRequire("f1JPm");


var $dzNsR = parcelRequire("dzNsR");


var $720nW = parcelRequire("720nW");


var $iz3ta = parcelRequire("iz3ta");





var $b6IhR = parcelRequire("b6IhR");


var $iaYRG = parcelRequire("iaYRG");


var $bF9JE = parcelRequire("bF9JE");


var $9DkM9 = parcelRequire("9DkM9");


var $fSUtG = parcelRequire("fSUtG");


var $kC3Bu = parcelRequire("kC3Bu");


var $c4DtA = parcelRequire("c4DtA");


var $5XOrc = parcelRequire("5XOrc");








var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");










const $d833b8acd04d2361$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assetsSchema: {
        id: "search-page.filters.names.assets-schema",
        defaultMessage: "Schema"
    },
    assetsFilterAssetsSchemaPlaceholder: {
        id: "search-page.assets.filter.assets-schema.placeholder",
        defaultMessage: "Find schemas"
    },
    assetsFilterLabelSelected: {
        id: "search-page.assets.filter.assets-schema.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "search-page.assets.filter.assets-schema.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "search-page.assets.filter.assets-schema.icon.label",
        defaultMessage: "Assets schema filter"
    }
});


const $fe5cf55c35009aac$var$AssetsSchemaFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $lx1ar.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsSchema),
        placeholder: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsFilterAssetsSchemaPlaceholder),
        filterOrControlId: 'assetsSchema',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $lx1ar.filter).id
            });
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};
var $fe5cf55c35009aac$export$2e2bcd8739ae039 = $fe5cf55c35009aac$var$AssetsSchemaFilter;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eiXsV = parcelRequire("eiXsV");


var $226KS = parcelRequire("226KS");


var $gj7hi = parcelRequire("gj7hi");


var $1s5hv = parcelRequire("1s5hv");



var $eyWa4 = parcelRequire("eyWa4");


















const $9778a7b060ccfdbb$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assetsType: {
        id: "search-page.filters.names.assets-type",
        defaultMessage: "Object type"
    },
    assetsFilterAssetsTypePlaceholder: {
        id: "search-page.assets.filter.assets-type.placeholder",
        defaultMessage: "Find object types"
    },
    assetsFilterLabelSelected: {
        id: "search-page.assets.filter.assets-type.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "search-page.assets.filter.assets-type.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "search-page.assets.filter.assets-type.icon.label",
        defaultMessage: "Object type filter"
    }
});


const $672b5810e8d0600a$var$styles = {
    imageContainer: "_1bsb7vkz _4t3i7vkz"
};
const $672b5810e8d0600a$var$AssetsTypeFilter = ({ isFilterInDropdown: isFilterInDropdown, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $iUihD.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const formatOptionLabel = (data)=>{
        return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), null, /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
            src: data.avatarUrl,
            alt: data.label,
            className: (0, $gMc0m.default)([
                $672b5810e8d0600a$var$styles.imageContainer
            ])
        })), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            space: "space.025"
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, data.label), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
            label: "",
            size: "small",
            color: "var(--ds-text-subtlest)"
        }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, data.metadata.schemaName))));
    };
    const groupedOptions = [
        {
            label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ $42omo.createElement((0, $lBO0P.default), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsType),
        placeholder: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsFilterAssetsTypePlaceholder),
        filterOrControlId: 'assetsType',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $iUihD.filter).id
            });
        },
        iconBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eiXsV))), {
            label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsIconLabel),
            size: "medium"
        }),
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};
var $672b5810e8d0600a$export$2e2bcd8739ae039 = $672b5810e8d0600a$var$AssetsTypeFilter;



var $1a3HI = parcelRequire("1a3HI");


var $iK2jT = parcelRequire("iK2jT");


var $5rAmH = parcelRequire("5rAmH");


var $3IsTa = parcelRequire("3IsTa");


var $17vNL = parcelRequire("17vNL");


var $9wx2v = parcelRequire("9wx2v");


var $D9B8R = parcelRequire("D9B8R");


var $iKcwP = parcelRequire("iKcwP");


var $kGrYY = parcelRequire("kGrYY");


var $5KTta = parcelRequire("5KTta");


var $3hfXG = parcelRequire("3hfXG");


var $10wA9 = parcelRequire("10wA9");


var $6alnB = parcelRequire("6alnB");


var $aq7DS = parcelRequire("aq7DS");


var $iLJVZ = parcelRequire("iLJVZ");




const $e73ad23c671b68e3$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    clearFilters: {
        id: "search-page.filters.clear-filters-button-label",
        defaultMessage: "Clear filters"
    },
    suggestedFilters: {
        id: "search-page.filters.suggested-filters-section-label",
        defaultMessage: "Suggested"
    }
});



var $j8URb = parcelRequire("j8URb");


var $d2tOF = parcelRequire("d2tOF");


var $90exq = parcelRequire("90exq");


var $epJdx = parcelRequire("epJdx");


var $3xkiG = parcelRequire("3xkiG");


var $1zHCN = parcelRequire("1zHCN");


var $4VBuR = parcelRequire("4VBuR");


var $d8wvI = parcelRequire("d8wvI");


var $dHIx8 = parcelRequire("dHIx8");


var $5HYjQ = parcelRequire("5HYjQ");


var $kvgSJ = parcelRequire("kvgSJ");


var $dm37y = parcelRequire("dm37y");


var $2UnmY = parcelRequire("2UnmY");


var $1Ddz9 = parcelRequire("1Ddz9");


var $6YAWs = parcelRequire("6YAWs");


var $eCrxg = parcelRequire("eCrxg");


var $b7IiT = parcelRequire("b7IiT");


var $23zGK = parcelRequire("23zGK");


var $hTSDS = parcelRequire("hTSDS");


var $5773E = parcelRequire("5773E");

const $96015a04b79b5a40$export$82462a21aead86ed = {
    [(0, $fw303.filter).id]: (0, $c4DtA.default),
    [(0, $1uGSo.filter).id]: (0, $aq7DS.default),
    [(0, $5iakG.universalTypeFilterId)]: (0, $23zGK.default),
    [(0, $aGXLL.filter).id]: (0, $D9B8R.default),
    [(0, $a97k3.filter).id]: (0, $6YAWs.default),
    [(0, $6jSbc.filter).id]: (0, $5KTta.default),
    [(0, $e7L4o.filter).id]: (0, $3hfXG.default),
    [(0, $bF9JE.filter).id]: (0, $hTSDS.default),
    [(0, $9DkM9.filter).id]: (0, $5773E.default),
    [(0, $5X4Ay.filter).id]: (0, $1a3HI.default),
    [(0, $f1JPm.filter).id]: (0, $5HYjQ.default),
    [(0, $2a0ps.filter).id]: (0, $17vNL.default),
    [(0, $gHwfH.filter).id]: (0, $d8wvI.default),
    [(0, $dQXZO.filter).id]: (0, $9wx2v.default),
    [(0, $iaYRG.filter).id]: (0, $b7IiT.default),
    [(0, $5ousX.filter).id]: (0, $d2tOF.default),
    [(0, $c5dmm.filter).id]: (0, $iKcwP.default),
    [(0, $huubg.filter).id]: (0, $iLJVZ.default),
    [(0, $gwbWt.filter).id]: (0, $6alnB.default),
    [(0, $1sswv.filter).id]: (0, $90exq.default),
    [(0, $b6IhR.filter).id]: (0, $eCrxg.default),
    [(0, $k7ise.filter).id]: (0, $5XOrc.default),
    [(0, $lx1ar.filter).id]: (0, $fe5cf55c35009aac$export$2e2bcd8739ae039),
    [(0, $iUihD.filter).id]: (0, $672b5810e8d0600a$export$2e2bcd8739ae039),
    [(0, $5eFo6.filter).id]: (0, $1zHCN.default),
    [(0, $fLju9.filter).id]: (0, $epJdx.default),
    [(0, $dXdDw.filter).id]: (0, $3xkiG.default),
    [(0, $aeffu.filter).id]: (0, $4VBuR.default),
    [(0, $720nW.filter).id]: (0, $2UnmY.default),
    [(0, $hHAPz.filter).id]: (0, $3IsTa.default),
    [(0, $5VnRb.filter).id]: (0, $iK2jT.default),
    [(0, $F3Hv6.filter).id]: (0, $5rAmH.default),
    [(0, $dFCIx.filter).id]: (0, $j8URb.default),
    [(0, $3TPSi.filter).id]: (0, $dHIx8.default),
    [(0, $dzNsR.filter).id]: (0, $kvgSJ.default),
    [(0, $iz3ta.filter).id]: (0, $1Ddz9.default),
    [(0, $lPWNq.filter).id]: (0, $10wA9.default)
};
const $96015a04b79b5a40$var$inlineStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    padding: 'space.050',
    margin: 'space.negative.050',
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card'
});
const $96015a04b79b5a40$var$aiTabsStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    zIndex: 'card',
    padding: 'space.050',
    margin: 'space.negative.050'
});
const $96015a04b79b5a40$var$inlineWithAIModeTabsStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    padding: 'space.050',
    margin: 'space.negative.050',
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    marginInlineStart: '190px'
});
const $96015a04b79b5a40$var$hiddenReferenceInlineStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    padding: 'space.050',
    margin: 'space.negative.050',
    flex: '1 0 auto',
    visibility: 'hidden',
    position: 'relative',
    zIndex: '1'
});
const $96015a04b79b5a40$var$filterRowStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
});
const $96015a04b79b5a40$var$suggestedFiltersDividerStyles = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '29px',
    marginInline: 'space.150',
    width: '1px'
});
const $96015a04b79b5a40$var$appSelectorFiltersDividerStyles = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '29px',
    width: '1px',
    alignSelf: 'center'
});
const $96015a04b79b5a40$var$suggestedFilterStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    color: 'color.text.subtlest',
    display: 'flex',
    gap: 'space.100',
    width: 'max-content'
});
const $96015a04b79b5a40$export$506070318f3da67b = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        id: "clear-all-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onClear,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage((0, $e73ad23c671b68e3$export$a7357cdd1f0b0168).clearFilters))));
};
const $96015a04b79b5a40$var$SuggestedFilters = ({ primaryProduct: primaryProduct, onFilterChange: onFilterChange, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$suggestedFilterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$suggestedFiltersDividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, `${formatMessage((0, $e73ad23c671b68e3$export$a7357cdd1f0b0168).suggestedFilters)}:`), primaryProduct === (0, $b4tvS.ProductKeys).Confluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6YAWs.default), {
        showPrimaryProductIcon: true,
        onFilterChange: (change)=>onFilterChange?.((0, $a97k3.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions
    }), (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), {
        onFilterChange: (change)=>onFilterChange?.((0, $fJFyr.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions,
        showPrimaryProductIcon: true
    })), primaryProduct === (0, $b4tvS.ProductKeys).Assets && (0, $dh538.fg)('assets_rovo_search_all') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe5cf55c35009aac$export$2e2bcd8739ae039), {
        showPrimaryProductIcon: true,
        onFilterChange: (change)=>onFilterChange?.((0, $lx1ar.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions
    }), primaryProduct === (0, $b4tvS.ProductKeys).Jira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8wvI.default), {
        showPrimaryProductIcon: true,
        onFilterChange: (change)=>onFilterChange?.((0, $gHwfH.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions
    }), (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), {
        onFilterChange: (change)=>onFilterChange?.((0, $fJFyr.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions,
        showPrimaryProductIcon: true
    })));
};
const $96015a04b79b5a40$var$ProductFilters = ({ containerRef: containerRef })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [query] = (0, $djVCD.useSearchQuery)();
    const { data: tenantDomain } = (0, $bHjhd.useCloudIdToUrl)(cloudId || '');
    const [{ filtersInLine: filtersInLine }] = (0, $djVCD.useFiltersToDisplay)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const { resetSort: resetSort, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const isConfluence = productSelected === (0, $b4tvS.ProductKeys).Confluence;
    const isJira = productSelected === (0, $b4tvS.ProductKeys).Jira;
    const isCompass = productSelected === (0, $b4tvS.ProductKeys).Compass;
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [features] = (0, $j4ply.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    // Elements in the navbar that will never be hidden despite resizes
    const alwaysVisibleRef = (0, $42omo.useRef)();
    const dropdownRef = (0, $42omo.useRef)();
    const appSelectFilterRef = (0, $42omo.useRef)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalyticsCb = (0, $42omo.useCallback)((payload)=>{
        const { attributes: attributes, ...rest } = payload;
        fireAnalyticsEvent({
            ...rest,
            attributes: {
                // Search-page needs to have attributes within additionalAttributes or else it gets ommitted when
                // the event is emitted
                additionalAttributes: {
                    ...attributes
                }
            }
        });
    }, [
        fireAnalyticsEvent
    ]);
    const { onFilterChange: onFilterChange, onDropdownOpenChange: onDropdownOpenChange, onFilterClearAction: onFilterClearAction, onSingleFilterClearAction: onSingleFilterClearAction } = (0, $fSUtG.useFilterAnalytics)(fireAnalyticsCb, commonAttributes, (0, $9rRKJ.SearchExperience).SEARCH_PAGE);
    let filtersRendered = filtersInLine.filter((id)=>id !== (0, $5iakG.universalTypeFilterId) || productSelected !== (0, $b4tvS.ProductKeys).Atlas);
    // Hide content under filter from navbar QS-5384
    if (isConfluence) filtersRendered = filtersRendered.filter((id)=>id !== (0, $dQXZO.filter).id);
    else if (isCompass) filtersRendered = filtersRendered.filter((id)=>id !== (0, $k7ise.filter).id);
    else if (productSelected === (0, $b4tvS.ProductKeys).Assets && (0, $dh538.fg)('assets_rovo_search_all')) filtersRendered = filtersRendered.filter((id)=>id !== (0, $aGXLL.filter).id);
    else if (productSelected === (0, $b4tvS.ProductKeys).Salesforce) filtersRendered = filtersRendered.filter((id)=>id !== (0, $5ousX.filter).id);
    // Owner, Stage, and Close Date filters for Salesforce should only appear in the dropdown panel.
    if (productSelected === (0, $b4tvS.ProductKeys).Salesforce) filtersRendered = filtersRendered.filter((id)=>id !== (0, $5ousX.filter).id && id !== (0, $720nW.filter).id && id !== (0, $hHAPz.filter).id);
    if (// don't show assets filters on townsquare if the flag is set
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    primaryProduct === (0, $b4tvS.ProductKeys).Atlas && (0, $dh538.fg)('assets_rovo_search_all') && !(0, $dh538.fg)('rovo_search_show_assets_filters_in_townsquare')) filtersRendered = filtersRendered.filter((id)=>id !== (0, $lx1ar.filter).id && id !== (0, $iUihD.filter).id);
    // Note: filter visibility is centralised in `useFiltersToDisplay` which already applies
    // FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES via `getExcludedFilterIds`. The list
    // returned here (`filtersRendered`) is therefore already projected and we don't need to
    // re-apply the exclusion at the call site.
    const filterRefs = (0, $42omo.useRef)([]);
    filterRefs.current = filtersRendered.filter((id)=>$96015a04b79b5a40$export$82462a21aead86ed[id]).map((_, i)=>filterRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    const visibleFilters = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        alwaysVisibleRef: alwaysVisibleRef,
        itemRefs: filterRefs,
        itemIds: filtersRendered
    });
    const filtersRef = (0, $42omo.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)('filters', filtersRef);
    const displaySuggestedConfluenceFilters = primaryProduct === (0, $b4tvS.ProductKeys).Confluence && !isAnyFilterSelected;
    const displaySuggestedAssetsFilters = primaryProduct === (0, $b4tvS.ProductKeys).Assets && !isAnyFilterSelected && (0, $dh538.fg)('assets_rovo_search_all');
    const displaySuggestedJiraFilters = primaryProduct === (0, $b4tvS.ProductKeys).Jira && !isAnyFilterSelected && (0, $dh538.fg)('jira_fps_suggested_filter');
    const displaySuggestedFilters = displaySuggestedConfluenceFilters || displaySuggestedAssetsFilters || displaySuggestedJiraFilters;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$filterRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        xcss: $96015a04b79b5a40$var$hiddenReferenceInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        style: {
            width: dropdownRef.current?.offsetWidth ?? 40
        }
    }), filtersDiscoverability2Enabled && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        style: {
            width: appSelectFilterRef.current?.offsetWidth ?? 96
        }
    }), filtersRendered.map((id, index)=>{
        const Filter = $96015a04b79b5a40$export$82462a21aead86ed[id];
        if (!Filter) return null;
        const elementId = `reference:${id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: elementId
        }, index === 0 && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $96015a04b79b5a40$var$appSelectorFiltersDividerStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            id: elementId,
            ref: filterRefs.current[index]
        }, id === (0, $1uGSo.filter).id || id === (0, $5iakG.universalTypeFilterId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            testId: `ref-test-id-${id}`,
            onFilterChange: (change)=>onFilterChange(id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS),
            onClearOptions: onSingleFilterClearAction
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            onFilterChange: (change)=>onFilterChange(id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS),
            onClearOptions: onSingleFilterClearAction
        })));
    })), (0, $dh538.fg)('rovo_ai_mode_restore_toggle_search') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$aiTabsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af57685ca39b004e$export$e1e2cdfa7f3f030c), {
        query: query,
        tenantDomain: tenantDomain
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        xcss: (0, $dh538.fg)('rovo_ai_mode_restore_toggle_search') ? $96015a04b79b5a40$var$inlineWithAIModeTabsStyles : $96015a04b79b5a40$var$inlineStyles,
        ref: filtersRef,
        role: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        ref: dropdownRef,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGrYY.default), {
        onFiltersChange: onFilterChange,
        onDropdownOpenChange: onDropdownOpenChange,
        onClearOptions: onSingleFilterClearAction
    })), filtersDiscoverability2Enabled && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        ref: appSelectFilterRef,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kC3Bu.default), null)), filtersRendered.map((id, index)=>{
        const Filter = $96015a04b79b5a40$export$82462a21aead86ed[id];
        if (!visibleFilters.includes(id) || !Filter) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: id
        }, index === 0 && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $96015a04b79b5a40$var$appSelectorFiltersDividerStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            id: id,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            onFilterChange: (change)=>onFilterChange(id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS),
            onClearOptions: onSingleFilterClearAction
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        ref: alwaysVisibleRef,
        role: "listitem"
    }, (isConfluence || isJira) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), null), isAnyFilterSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($96015a04b79b5a40$export$506070318f3da67b, {
        onClear: ()=>{
            clearAllFilters();
            resetSort();
            onFilterClearAction('inline-search-page');
        }
    }) : null, displaySuggestedFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($96015a04b79b5a40$var$SuggestedFilters, {
        primaryProduct: primaryProduct,
        onFilterChange: onFilterChange,
        onClearOptions: onSingleFilterClearAction
    }))));
};
var $96015a04b79b5a40$export$2e2bcd8739ae039 = $96015a04b79b5a40$var$ProductFilters;
module.exports["filters"] = $96015a04b79b5a40$export$82462a21aead86ed;
module.exports["default"] = $96015a04b79b5a40$export$2e2bcd8739ae039;

});

parcelRegister("5eWut", function(module, exports) {
const $5f5be382d680405d$export$ba5ea5559df2d439 = {
    DROPDOWN: 'dropdown',
    INLINE: 'inline',
    DROPDOWN_FPS: 'dropdown-search-page',
    INLINE_FPS: 'inline-search-page',
    INLINE_FPS_SUGGESTION: 'inline-search-page-suggestion'
};
const $5f5be382d680405d$export$ef6638e4a0319a7a = ({ attributes: attributes, action: action, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $5f5be382d680405d$export$37ec8c521d184f25 = ({ attributes: attributes, action: action, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filterDropdown',
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
const $5f5be382d680405d$export$9c0c40377c27961c = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $5f5be382d680405d$export$5e2091b35b0526ca = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
module.exports["FILTER_CHANGE_LOCATION"] = $5f5be382d680405d$export$ba5ea5559df2d439;
module.exports["onFilterSelection"] = $5f5be382d680405d$export$ef6638e4a0319a7a;
module.exports["onFilterDropdown"] = $5f5be382d680405d$export$37ec8c521d184f25;
module.exports["onFilterClear"] = $5f5be382d680405d$export$9c0c40377c27961c;
module.exports["onSingleFilterClear"] = $5f5be382d680405d$export$5e2091b35b0526ca;

});

parcelRegister("fSUtG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9rRKJ = parcelRequire("9rRKJ");


var $5eWut = parcelRequire("5eWut");


const $77b89a57ceb0cc94$export$1b9951cfecf7ee51 = (fireAnalyticsEvent, commonAttributes, experience)=>{
    const onFilterChange = (0, $42omo.useCallback)((filterId, changes, location)=>{
        // Omitting these attrtibutes as there is a race condition here since the filter attributes
        // have not yet been applied in the store so it will always be one update behind.
        const { productSelected: _productSelected, filters: _filters, filterSelections: filterSelections, ...restAttributes } = commonAttributes;
        const change = (Array.isArray(changes) ? changes : [
            changes
        ])[0];
        if (!change) return; // This should never be executed
        fireAnalyticsEvent((0, $5eWut.onFilterSelection)({
            action: change.isSelected ? 'unselected' : 'selected',
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogFilter' : 'searchPageFilter',
            location: location,
            attributes: {
                ...restAttributes,
                filterId: filterId,
                location: location
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        fireAnalyticsEvent((0, $5eWut.onFilterDropdown)({
            action: isOpen ? 'open' : 'close',
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogDropdown' : 'searchPageDropdown',
            attributes: {
                ...commonAttributes
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    const onFilterClearAction = (0, $42omo.useCallback)((location)=>{
        fireAnalyticsEvent((0, $5eWut.onFilterClear)({
            location: location,
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogFilter' : 'searchPageFilter',
            attributes: {
                ...commonAttributes
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    const onSingleFilterClearAction = (0, $42omo.useCallback)(({ filterId: filterId })=>{
        const filters = [
            filterId
        ];
        const filterSelections = Array.isArray(commonAttributes?.filterSelections) ? commonAttributes?.filterSelections.filter((s)=>s?.filterId === filterId) : [];
        fireAnalyticsEvent((0, $5eWut.onSingleFilterClear)({
            location: filterId,
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogFilter' : 'searchPageFilter',
            attributes: {
                ...commonAttributes,
                filters: filters,
                filterSelections: filterSelections
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    return {
        onFilterChange: onFilterChange,
        onDropdownOpenChange: onDropdownOpenChange,
        onFilterClearAction: onFilterClearAction,
        onSingleFilterClearAction: onSingleFilterClearAction
    };
};
module.exports["useFilterAnalytics"] = $77b89a57ceb0cc94$export$1b9951cfecf7ee51;

});

parcelRegister("k5mzm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");

const $1ca63d475ea1e3a7$var$boxStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    boxSizing: 'border-box'
});
const $1ca63d475ea1e3a7$export$7a7fa4424cb20976 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.selectProps.isSearchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.100",
        paddingBlockStart: "space.100",
        xcss: $1ca63d475ea1e3a7$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Control, props)));
module.exports["Control"] = $1ca63d475ea1e3a7$export$7a7fa4424cb20976;

});

parcelRegister("ls6iZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");


var $euOzb = parcelRequire("euOzb");




const $fe1ccd918cb4fcd2$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    searchClearFilterLabel: {
        id: "search-page.filter.clear.filter.label",
        defaultMessage: "Clear filter"
    }
});


const $4c5bd174a9ae63a6$var$clearFilterOptionsButtonStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
const $4c5bd174a9ae63a6$var$ClearFilterOptionsButton = ({ onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: onClick,
        xcss: $4c5bd174a9ae63a6$var$clearFilterOptionsButtonStyles
    }, children);
};
const $4c5bd174a9ae63a6$var$menuFooterStyles = (0, $ecnYn.xcss)({
    borderTop: `${"var(--ds-border, #0B120E24)"} solid ${"var(--ds-border-width, 1px)"}`
});
const $4c5bd174a9ae63a6$export$383d5f7db11e21ca = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4c5bd174a9ae63a6$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c5bd174a9ae63a6$var$ClearFilterOptionsButton, {
        onClick: ()=>props.selectProps.onClearOptions()
    }, formatMessage((0, $fe1ccd918cb4fcd2$export$a7357cdd1f0b0168).searchClearFilterLabel))));
};
const $4c5bd174a9ae63a6$export$d1b6a8b216735e8c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4c5bd174a9ae63a6$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $euOzb.default), {
        onClick: ()=>props.selectProps.onClearOptions()
    })));
};
module.exports["MenuListWithClearFilterOptionLabel"] = $4c5bd174a9ae63a6$export$383d5f7db11e21ca;
module.exports["MenuListWithoutClearFilterOptionLabel"] = $4c5bd174a9ae63a6$export$d1b6a8b216735e8c;

});

parcelRegister("jQ2up", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $Y34Hw = parcelRequire("Y34Hw");

const $b87e75291ab80188$var$optionTextWrapperStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginLeft: 'space.100',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $b87e75291ab80188$var$renderOptionLabelText = (label)=>typeof label === 'string' ? (0, $Y34Hw.enrichExcerpt)(label) : label;
const $b87e75291ab80188$export$2cf7ef1e2dd6c6b1 = ({ option: option, state: state, children: children })=>{
    const renderedLabel = $b87e75291ab80188$var$renderOptionLabelText(option.label);
    if (state.context === 'menu' || state.context === 'value') {
        const spaces = {
            menu: 'space.050',
            value: undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: spaces[state.context]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center"
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $b87e75291ab80188$var$optionTextWrapperStyles
        }, renderedLabel)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b87e75291ab80188$var$optionTextWrapperStyles
    }, renderedLabel);
};
const $b87e75291ab80188$export$100d0de045bdee7c = (Component)=>(option, state)=>{
        const props = {
            option: option,
            state: state
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b87e75291ab80188$export$2cf7ef1e2dd6c6b1, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props));
    };
const $b87e75291ab80188$var$AvatarOptionLabel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: props.option.avatarUrl,
        appearance: "circle",
        size: "small",
        borderColor: "none"
    });
const $b87e75291ab80188$export$aaa1dc33930567f9 = $b87e75291ab80188$export$100d0de045bdee7c($b87e75291ab80188$var$AvatarOptionLabel);
module.exports["createOptionLabelFormatter"] = $b87e75291ab80188$export$100d0de045bdee7c;
module.exports["formatAvatarOptionLabel"] = $b87e75291ab80188$export$aaa1dc33930567f9;

});

parcelRegister("Y34Hw", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $67gKI = parcelRequire("67gKI");


var $4Chrd = parcelRequire("4Chrd");


var $j5Jtm = parcelRequire("j5Jtm");


var $iwLe7 = parcelRequire("iwLe7");


var $akQ4J = parcelRequire("akQ4J");


var $9ohv9 = parcelRequire("9ohv9");










const $74113bae213f2e9f$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH = 80;
const $74113bae213f2e9f$export$16c2ab98757b54d6 = (excerpt, noLeadingEllipsis, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $j5Jtm.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($74113bae213f2e9f$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipsis prefix if beginning of excerpt isn't a URL and excerpt length is greater than 80
    if (!noLeadingEllipsis && !beginsWithUrl && excerpt.length > $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH) excerpt = '...'.concat(excerpt);
    // Add ellipsis suffix if excerpt doesn't end with ending punctuation and if length is greater than 80
    if (excerpt.length > $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH && !excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with separators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $74113bae213f2e9f$export$b847312d69858d61(excerpt, prefix);
};
// Utility function to insert zero-width space every N characters
const $74113bae213f2e9f$var$insertZeroWidthSpace = (str, interval)=>{
    let result = '';
    for(let i = 0; i < str.length; i++){
        result += str[i];
        if ((i + 1) % interval === 0) result += '\u200B';
    }
    return result;
};
const $74113bae213f2e9f$export$ca7c2d622a259944 = (segment)=>{
    return segment.split(' ').map((word)=>{
        if (word.length > 20) return $74113bae213f2e9f$var$insertZeroWidthSpace(word, 5);
        return word;
    }).join(' ');
};
const $74113bae213f2e9f$export$b847312d69858d61 = (excerpt, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $j5Jtm.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                as: "span",
                key: excerpt
            }, $74113bae213f2e9f$export$ca7c2d622a259944(excerpt)));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            key: `pre-${i}`
        }, $74113bae213f2e9f$export$ca7c2d622a259944(pre)));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, $74113bae213f2e9f$export$ca7c2d622a259944(textMatch)));
        i++;
    }
    return(// NOTE: wrapping these in <div> previously broke focus rings
    // in search results
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, prefix, res));
};
const $74113bae213f2e9f$export$fdcae512e9fdc5ad = (timestamp)=>{
    return $74113bae213f2e9f$export$96e2a37e068d7fac($74113bae213f2e9f$export$7e0fd00186ff29c6(timestamp));
};
const $74113bae213f2e9f$export$7e0fd00186ff29c6 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const secondsPast = (0, $iwLe7.secondsSinceDate)(timestamp);
    const timeUnits = {
        seconds: secondsPast,
        minutes: secondsPast / 60,
        hours: secondsPast / 3600,
        days: secondsPast / 86400,
        months: secondsPast / 2592000,
        years: secondsPast / 31536000
    };
    return {
        seconds: Math.floor(timeUnits.seconds),
        minutes: Math.floor(timeUnits.minutes),
        hours: Math.floor(timeUnits.hours),
        days: Math.floor(timeUnits.days),
        months: Math.floor(timeUnits.months),
        years: Math.floor(timeUnits.years)
    };
};
const $74113bae213f2e9f$export$96e2a37e068d7fac = ({ seconds: seconds, minutes: minutes, hours: hours, days: days, months: months, years: years })=>{
    return $74113bae213f2e9f$export$3e6e07f5a5b9cd48(seconds, minutes, hours, days, months, years);
};
const $74113bae213f2e9f$export$3e6e07f5a5b9cd48 = (seconds, minutes, hours, days, months, years)=>{
    if (years > 0) return {
        unit: 'year',
        value: years
    };
    else if (months > 0) return {
        unit: 'month',
        value: months
    };
    else if (days > 0) return {
        unit: 'day',
        value: days
    };
    else if (hours > 0) return {
        unit: 'hour',
        value: hours
    };
    else if (minutes > 0) return {
        unit: 'minute',
        value: minutes
    };
    else return {
        unit: 'second',
        value: seconds
    };
};
const $74113bae213f2e9f$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'ari:cloud:platform::integration/slack';
    const isMsTeams = integrationId === 'ari:cloud:platform::integration/microsoft';
    if (isSlack) {
        const openDmUrl = $74113bae213f2e9f$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $74113bae213f2e9f$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'ms-teams',
            openDmUrl: openDmUrl
        };
    }
};
const $74113bae213f2e9f$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $74113bae213f2e9f$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
const $74113bae213f2e9f$export$3856aba7736e125f = 'microsoft';
const $74113bae213f2e9f$export$c60276faecd0e082 = (integrationKey, resourceType)=>{
    if (integrationKey !== $74113bae213f2e9f$export$3856aba7736e125f || !resourceType) return undefined;
    if ((0, $akQ4J.SHAREPOINT_RESOURCE_TYPES).includes(resourceType)) return 'sharepoint';
    if ((0, $9ohv9.TEAMS_RESOURCE_TYPES).includes(resourceType)) return 'teams';
    return undefined;
};
const $74113bae213f2e9f$export$42f00afbb84516be = ({ thirdPartyConfigs: thirdPartyConfigs, providerId: providerId, integrationId: integrationId, resourceType: resourceType })=>{
    const integrationKey = (0, $67gKI.getIntegrationKey)(integrationId);
    return(// Last-resort fallback: returns the raw integration key (e.g. 'slack', 'github').
    // For Microsoft products without a matching resourceType (e.g. OneDrive), this returns
    // 'microsoft' which has no displayName — intentional, as we can't disambiguate further.
    (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId) || $74113bae213f2e9f$export$c60276faecd0e082(integrationKey, resourceType) || integrationKey);
};
module.exports["processExcerpt"] = $74113bae213f2e9f$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $74113bae213f2e9f$export$b847312d69858d61;
module.exports["getRelativeTimeSince"] = $74113bae213f2e9f$export$fdcae512e9fdc5ad;
module.exports["getExternalMessageDmIntegrationInfo"] = $74113bae213f2e9f$export$596e547f4ce626bc;
module.exports["MICROSOFT_INTEGRATION_KEY"] = $74113bae213f2e9f$export$3856aba7736e125f;
module.exports["getProductFromMicrosoftResourceType"] = $74113bae213f2e9f$export$c60276faecd0e082;
module.exports["get3PProductFromProviderIdOrIntegrationId"] = $74113bae213f2e9f$export$42f00afbb84516be;

});

parcelRegister("67gKI", function(module, exports) {

var $1VCtc = parcelRequire("1VCtc");

const $35d29bc8359ee927$export$fb63ba58603395b8 = (integrationId)=>{
    try {
        const integrationKey = integrationId ? (0, $1VCtc.PlatformIntegrationAri).parse(integrationId).integrationKey : undefined;
        if (integrationKey === 'jira-dc-secondary' || integrationKey === 'jira-dc-tertiary') return 'jira-dc';
        return integrationKey;
    } catch  {
        // TODO QS-7368 log exception for invalid integration IDs
        return undefined;
    }
};
module.exports["getIntegrationKey"] = $35d29bc8359ee927$export$fb63ba58603395b8;

});

parcelRegister("1BldJ", function(module, exports) {
const $1452f19e089e8a7b$export$cfcac91fe687137b = (type)=>{
    if (type === 'project') return 'space';
    return type;
};
module.exports["getJiraSearchResultTypeMetadata"] = $1452f19e089e8a7b$export$cfcac91fe687137b;

});

parcelRegister("9ZAVx", function(module, exports) {
const $6a43e1949f0f5c36$export$e4f4cdacb4bd8fe7 = (a, b, productsOrder)=>{
    const indexA = productsOrder.indexOf(a);
    const indexB = productsOrder.indexOf(b);
    if (indexA === -1 || indexB === -1) return 0;
    else return indexA - indexB;
};
module.exports["getProductOrder"] = $6a43e1949f0f5c36$export$e4f4cdacb4bd8fe7;

});

parcelRegister("hrMXM", function(module, exports) {

var $6Gsan = parcelRequire("6Gsan");


var $b4tvS = parcelRequire("b4tvS");

const $ffb8a5ec19715038$export$67a9e61f14e838d2 = (primaryProduct)=>{
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets) return [
        (0, $b4tvS.ProductKeys).Assets,
        ...(0, $b4tvS.PRODUCTS_ORDER_WITH_3P_BY_POPULARITY)
    ];
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) {
        const jiraProducts = [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement
        ];
        // Bring all Jira products to the top
        return [
            ...jiraProducts,
            ...(0, $b4tvS.PRODUCTS_ORDER_WITH_3P_BY_POPULARITY).filter((key)=>!jiraProducts.includes(key))
        ];
    }
    return 0, $b4tvS.PRODUCTS_ORDER_WITH_3P_BY_POPULARITY;
};
module.exports["getProductsOrderByPrimaryProduct"] = $ffb8a5ec19715038$export$67a9e61f14e838d2;

});

parcelRegister("5cssW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $djVCD = parcelRequire("djVCD");


var $7jUYs = parcelRequire("7jUYs");


var $037Ux = parcelRequire("037Ux");





var $9rRKJ = parcelRequire("9rRKJ");

const $74feadaff115f70a$export$6d20082d2748aae3 = (params)=>{
    if (params.selectedProducts.length > 0) return params.selectedProducts;
    const primaryProduct = params.primaryProduct ?? '';
    const safePrimaryProduct = (0, $b4tvS.isProductKey)(primaryProduct) ? [
        primaryProduct
    ] : undefined;
    if (params.experience === (0, $9rRKJ.SearchExperience).QUICK_FIND) return safePrimaryProduct ?? params.availableProducts;
    return params.availableProducts;
};


const $ded31ca78b6b8828$export$ac822ab68badd883 = ({ filterId: filterId, optionValuesToExclude: optionValuesToExclude })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [state, storeActions] = (0, $djVCD.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option, customValue, setSelectedProduct, validateDependentFilterId)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            const productToSelect = (0, $037Ux.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                productToSet: setSelectedProduct,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            });
            const customOptions = {
                customValue: customValue,
                setSelectedProduct: productToSelect,
                validateDependentFilterId: validateDependentFilterId
            };
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                ...Object.values(customOptions).some((customOption)=>customOption !== undefined) ? {
                    options: customOptions
                } : {}
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                intl: intl,
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const filteredOptions = state.options.filter((option)=>{
        if (optionValuesToExclude) return !optionValuesToExclude.includes(option.value);
        return true;
    });
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const selectedOptionsCount = state.selectedOptions.length;
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: state.selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible,
        customValue: state.customValue,
        badgeLabel: selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined,
        firstSelectedOptionLabel: state.selectedOptions[0]?.label
    };
    return [
        viewState,
        viewActions
    ];
};
const $ded31ca78b6b8828$export$eb312ee1d3a7a748 = ({ filterId: filterId, optionsToProducts: optionsToProducts })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [state, storeActions] = (0, $djVCD.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            const productToSelect = (0, $037Ux.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            });
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                options: {
                    setSelectedProduct: productToSelect
                }
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId,
                intl: intl
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const productsNew = (0, $74feadaff115f70a$export$6d20082d2748aae3)({
        selectedProducts: state.selectedProducts,
        primaryProduct: state.primaryProduct ?? undefined,
        experience: state.experience,
        availableProducts: state.availableProducts
    });
    const products = productsNew;
    const filteredOptions = state.options.filter((option)=>option.isDefault || option.isSelected || optionsToProducts[option.value]?.some((product)=>products.includes(product)))// This is a temporary hack to filter out Atlas specific types, unless Atlas is the selected product
    .filter((option)=>!(state.selectedProducts[0] !== (0, $b4tvS.ProductKeys).Atlas && (option.value === 'goal' || option.value === 'tag')))// Filtering out all options that are tied exclusively to allFilterExcludedProducts for universal types
    .filter((option)=>!selectedProductsAvailable && optionsToProducts[option.value]?.length ? optionsToProducts[option.value].some((product)=>!state.allFilterExcludedProducts.includes(product)) : true);
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const selectedOptions = state.selectedOptions.map((option)=>({
            ...option
        }));
    if (products.length === 1 && products[0] === (0, $b4tvS.ProductKeys).ConfluenceDC && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in')) {
        const isPageOption = (option)=>option.value === (0, $2Znam.TypeFilterValueKey).Page;
        // Update both filtered and selected options that match Page type
        [
            filteredOptions,
            selectedOptions
        ].flatMap((options)=>options.filter(isPageOption)).forEach((option)=>{
            option.label = intl.formatMessage((0, $7jUYs.typeLabels).page);
        });
    }
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupDefined: state.lookup.isDefined,
        isLoading: // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        lookupInput: state.lookup.input,
        options: filteredOptions,
        // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: selectedOptions,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible
    };
    return [
        viewState,
        viewActions
    ];
};
module.exports["useSelectFilter"] = $ded31ca78b6b8828$export$ac822ab68badd883;
module.exports["useUniversalSelectFilter"] = $ded31ca78b6b8828$export$eb312ee1d3a7a748;

});

parcelRegister("3dgQu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lAFHW = parcelRequire("lAFHW");


var $6Gsan = parcelRequire("6Gsan");




const $2984110e254169a0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    confluenceIconLabel: {
        id: "rovo-search.confluence.filter.icon.label",
        defaultMessage: "Confluence filter"
    },
    jiraIconLabel: {
        id: "rovo-search.jira.filter.icon.label",
        defaultMessage: "Jira filter"
    },
    assetsIconLabel: {
        id: "rovo-search.assets.filter.icon.label",
        defaultMessage: "Assets filter"
    },
    talentIconLabel: {
        id: "rovo-search.talent.filter.icon.label",
        defaultMessage: "Talent filter"
    }
});


const $e1c3616515d2ed7a$export$5d27b8605be74adf = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { showPrimaryProductIcon: showPrimaryProductIcon, primaryProduct: primaryProduct } = props;
    if (!showPrimaryProductIcon || !primaryProduct) return null;
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).confluenceIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).jiraIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.AssetsIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).assetsIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Talent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.TalentIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).talentIconLabel),
        size: "xxsmall"
    });
    // Add more primary product icons here
    return null;
};
module.exports["FilterProductIcon"] = $e1c3616515d2ed7a$export$5d27b8605be74adf;

});

parcelRegister("kGrYY", function(module, exports) {
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c4sKh = parcelRequire("c4sKh");


var $ccHMk = parcelRequire("ccHMk");


var $52EPl = parcelRequire("52EPl");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $5iakG = parcelRequire("5iakG");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");


var $euOzb = parcelRequire("euOzb");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $5eWut = parcelRequire("5eWut");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");

parcelRequire("ehGUC");
var $9DkM9 = parcelRequire("9DkM9");


var $fw303 = parcelRequire("fw303");


var $k7ise = parcelRequire("k7ise");


var $5X4Ay = parcelRequire("5X4Ay");


var $5VnRb = parcelRequire("5VnRb");


var $F3Hv6 = parcelRequire("F3Hv6");


var $hHAPz = parcelRequire("hHAPz");


var $2a0ps = parcelRequire("2a0ps");


var $dQXZO = parcelRequire("dQXZO");


var $aGXLL = parcelRequire("aGXLL");


var $c5dmm = parcelRequire("c5dmm");


var $6jSbc = parcelRequire("6jSbc");


var $e7L4o = parcelRequire("e7L4o");


var $lPWNq = parcelRequire("lPWNq");


var $gwbWt = parcelRequire("gwbWt");


var $1uGSo = parcelRequire("1uGSo");


var $huubg = parcelRequire("huubg");


var $dFCIx = parcelRequire("dFCIx");


var $5ousX = parcelRequire("5ousX");


var $1sswv = parcelRequire("1sswv");


var $jqLa8 = parcelRequire("jqLa8");


var $fLju9 = parcelRequire("fLju9");


var $dXdDw = parcelRequire("dXdDw");


var $5eFo6 = parcelRequire("5eFo6");


var $aeffu = parcelRequire("aeffu");


var $gHwfH = parcelRequire("gHwfH");


var $3TPSi = parcelRequire("3TPSi");


var $f1JPm = parcelRequire("f1JPm");


var $dzNsR = parcelRequire("dzNsR");


var $720nW = parcelRequire("720nW");


var $iz3ta = parcelRequire("iz3ta");


var $a97k3 = parcelRequire("a97k3");


var $b6IhR = parcelRequire("b6IhR");


var $iaYRG = parcelRequire("iaYRG");


var $bF9JE = parcelRequire("bF9JE");





var $fJ1R6 = parcelRequire("fJ1R6");


var $kC3Bu = parcelRequire("kC3Bu");


var $c4DtA = parcelRequire("c4DtA");


var $5XOrc = parcelRequire("5XOrc");


var $1a3HI = parcelRequire("1a3HI");


var $iK2jT = parcelRequire("iK2jT");


var $5rAmH = parcelRequire("5rAmH");


var $3IsTa = parcelRequire("3IsTa");


var $17vNL = parcelRequire("17vNL");


var $9wx2v = parcelRequire("9wx2v");


var $D9B8R = parcelRequire("D9B8R");


var $iKcwP = parcelRequire("iKcwP");


var $5KTta = parcelRequire("5KTta");


var $3hfXG = parcelRequire("3hfXG");


var $10wA9 = parcelRequire("10wA9");


var $6alnB = parcelRequire("6alnB");


var $aq7DS = parcelRequire("aq7DS");


var $iLJVZ = parcelRequire("iLJVZ");


var $j8URb = parcelRequire("j8URb");


var $d2tOF = parcelRequire("d2tOF");


var $90exq = parcelRequire("90exq");








var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");










const $488fa3f84a08f0df$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterEmploymentTypeLabel: {
        id: "search-page.filters.names.positionEmploymentType",
        defaultMessage: "Employment type"
    },
    positionFilterEmploymentTypePlaceholder: {
        id: "search-page.talent.filter.position-employment-type.content.placeholder",
        defaultMessage: "Find employment types"
    },
    positionFilterEmploymentTypeLabelSelected: {
        id: "search-page.talent.filter.position-employment-type.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterEmploymentTypeLabelUnselected: {
        id: "search-page.talent.filter.position-employment-type.content.unselected",
        defaultMessage: "Suggested"
    }
});


const $3b25659dee9869d9$var$PositionEmploymentTypeFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $jqLa8.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypeLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypeLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypePlaceholder),
        filterOrControlId: 'positionEmploymentType',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $jqLa8.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $3b25659dee9869d9$export$2e2bcd8739ae039 = $3b25659dee9869d9$var$PositionEmploymentTypeFilter;



var $epJdx = parcelRequire("epJdx");


var $3xkiG = parcelRequire("3xkiG");


var $1zHCN = parcelRequire("1zHCN");


var $4VBuR = parcelRequire("4VBuR");


var $d8wvI = parcelRequire("d8wvI");


var $dHIx8 = parcelRequire("dHIx8");


var $5HYjQ = parcelRequire("5HYjQ");


var $kvgSJ = parcelRequire("kvgSJ");


var $dm37y = parcelRequire("dm37y");


var $2UnmY = parcelRequire("2UnmY");


var $1Ddz9 = parcelRequire("1Ddz9");


var $6YAWs = parcelRequire("6YAWs");


var $eCrxg = parcelRequire("eCrxg");


var $b7IiT = parcelRequire("b7IiT");


var $23zGK = parcelRequire("23zGK");


var $hTSDS = parcelRequire("hTSDS");


var $5773E = parcelRequire("5773E");




const $d8436d38d53a83ed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    clearFilters: {
        id: "search-page.filters.dropdown.clear-filters",
        defaultMessage: "Clear filters"
    },
    dropdownButtonLabel: {
        id: "search-page.filters.dropdown.button",
        defaultMessage: "More filters"
    }
});


const $b409c1590183c3bd$var$dropdownContainerStyles = (0, $ecnYn.xcss)({
    width: '312px'
});
const $b409c1590183c3bd$var$filtersContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.200'
});
const $b409c1590183c3bd$var$clearButtonStylesOld = (0, $ecnYn.xcss)({
    margin: 'space.200'
});
const $b409c1590183c3bd$var$clearButtonStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.200',
    paddingBlock: 'space.300'
});
const $b409c1590183c3bd$var$filters = {
    [(0, $5iakG.universalTypeFilterId)]: (0, $23zGK.default),
    [(0, $1uGSo.filter).id]: (0, $aq7DS.default),
    [(0, $c5dmm.filter).id]: (0, $iKcwP.default),
    [(0, $aGXLL.filter).id]: (0, $D9B8R.default),
    [(0, $huubg.filter).id]: (0, $iLJVZ.default),
    [(0, $5ousX.filter).id]: (0, $d2tOF.default),
    [(0, $1sswv.filter).id]: (0, $90exq.default),
    [(0, $a97k3.filter).id]: (0, $6YAWs.default),
    [(0, $6jSbc.filter).id]: (0, $5KTta.default),
    [(0, $e7L4o.filter).id]: (0, $3hfXG.default),
    [(0, $5X4Ay.filter).id]: (0, $1a3HI.default),
    [(0, $f1JPm.filter).id]: (0, $5HYjQ.default),
    [(0, $gHwfH.filter).id]: (0, $d8wvI.default),
    [(0, $dQXZO.filter).id]: (0, $9wx2v.default),
    [(0, $gwbWt.filter).id]: (0, $6alnB.default),
    [(0, $b6IhR.filter).id]: (0, $eCrxg.default),
    [(0, $5eFo6.filter).id]: (0, $1zHCN.default),
    [(0, $jqLa8.filter).id]: (0, $3b25659dee9869d9$export$2e2bcd8739ae039),
    [(0, $dXdDw.filter).id]: (0, $3xkiG.default),
    [(0, $aeffu.filter).id]: (0, $4VBuR.default),
    [(0, $fLju9.filter).id]: (0, $epJdx.default),
    [(0, $720nW.filter).id]: (0, $2UnmY.default),
    [(0, $5VnRb.filter).id]: (0, $iK2jT.default),
    [(0, $F3Hv6.filter).id]: (0, $5rAmH.default),
    [(0, $hHAPz.filter).id]: (0, $3IsTa.default),
    [(0, $dFCIx.filter).id]: (0, $j8URb.default),
    [(0, $3TPSi.filter).id]: (0, $dHIx8.default),
    [(0, $dzNsR.filter).id]: (0, $kvgSJ.default),
    [(0, $iz3ta.filter).id]: (0, $1Ddz9.default)
};
const $b409c1590183c3bd$var$checkboxFilters = {
    [(0, $9DkM9.filter).id]: (0, $5773E.default),
    [(0, $bF9JE.filter).id]: (0, $hTSDS.default),
    [(0, $iaYRG.filter).id]: (0, $b7IiT.default),
    [(0, $fw303.filter).id]: (0, $c4DtA.default),
    [(0, $k7ise.filter).id]: (0, $5XOrc.default),
    [(0, $2a0ps.filter).id]: (0, $17vNL.default),
    [(0, $lPWNq.filter).id]: (0, $10wA9.default)
};
const $b409c1590183c3bd$var$dividerStylesOld = (0, $ecnYn.xcss)({
    borderBottomWidth: 'border.width',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTop: 0,
    marginInline: 'space.200'
});
const $b409c1590183c3bd$var$dividerStyles = (0, $ecnYn.xcss)({
    borderBottomWidth: 'border.width',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTop: 0
});
const $b409c1590183c3bd$var$badgeStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex'
});
const $b409c1590183c3bd$var$DropdownFilter = ({ experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE, onFiltersChange: onFiltersChange, onDropdownOpenChange: onDropdownOpenChange, hideOnHoverOut: hideOnHoverOut = false, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [{ selectedFilterCount: selectedFilterCountWithoutProduct }] = (0, $djVCD.useSelectedFilterCount)();
    const { resetSort: resetSort, clearAllFilters: clearAllFilters, unsetFilterDropdownOpen: unsetFilterDropdownOpen } = (0, $djVCD.useSearchActions)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const isConfluence = selectedProduct === (0, $b4tvS.ProductKeys).Confluence;
    const isJira = selectedProduct === (0, $b4tvS.ProductKeys).Jira;
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [features] = (0, $j4ply.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    // `useFiltersToDisplay` centrally applies FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES
    // via `getExcludedFilterIds`, projecting both `filtersInLine` (consumed by ProductFilters)
    // and `filtersInDropdown` (consumed here). No further filtering is required at the call site.
    const [{ filtersInDropdown: filtersInDropdown }] = (0, $djVCD.useFiltersToDisplay)({
        basedOnPrimaryProduct: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND,
        primaryProduct: primaryProduct
    });
    // `useSelectedFilterCount` also applies FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES
    // centrally, so we only need to add 1 here for the selected-product chip (when visible).
    const selectedFilterCount = selectedProduct && filtersDiscoverability2Enabled && !isLiteMode ? selectedFilterCountWithoutProduct + 1 : selectedFilterCountWithoutProduct;
    const [filterDropdownOpenByQueryParam] = (0, $djVCD.useFilterDropdownOpenByQueryParam)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const handleDropdownOpenChange = (0, $42omo.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
        onDropdownOpenChange?.(isOpen);
        if (!isOpen && filterDropdownOpenByQueryParam) unsetFilterDropdownOpen();
    }, [
        onDropdownOpenChange,
        filterDropdownOpenByQueryParam,
        unsetFilterDropdownOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        enabled: hideOnHoverOut,
        callback: ()=>handleDropdownOpenChange({
                isOpen: false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        testId: "dropdown-filter-menu",
        ...filtersDiscoverability2Enabled && {
            isOpen: isDropdownOpen || filterDropdownOpenByQueryParam,
            onOpenChange: handleDropdownOpenChange
        },
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>filtersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ref: triggerRef,
                ...providedProps,
                isSelected: selectedFilterCount > 0 || isDropdownOpen,
                testId: "dropdown-filter-button",
                "aria-label": formatMessage((0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).dropdownButtonLabel),
                filterOrControlId: "dropdown",
                hasChevron: false,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, selectedFilterCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $b409c1590183c3bd$var$badgeStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "informationBold"
                }, selectedFilterCount)) : null)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                otherProps: {
                    ...providedProps,
                    ref: triggerRef
                },
                isSelected: selectedFilterCount > 0,
                filterOrControlId: "dropdown",
                selectionBadge: selectedFilterCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "informationBold"
                }, selectedFilterCount) : null,
                testId: "dropdown-filter-button",
                ariaLabel: formatMessage((0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).dropdownButtonLabel)
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b409c1590183c3bd$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b409c1590183c3bd$var$filtersContainerStyles,
        space: "space.200"
    }, filtersDiscoverability2Enabled && !isLiteMode && experience !== (0, $9rRKJ.SearchExperience).QUICK_FIND && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kC3Bu.default), {
        isFilterInDropdown: true
    }), experience === (0, $9rRKJ.SearchExperience).QUICK_FIND && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fJ1R6.AppSelector), {
        isFilterInDropdown: true
    }), filtersInDropdown.map((filterId)=>{
        // TODO: remove the typecast here
        // (was added so that product type filters didn't have to be included in the filters object)
        const Filter = $b409c1590183c3bd$var$filters[filterId];
        if (!Filter) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            key: filterId,
            isFilterInDropdown: true,
            // Filters inside the dropdown should not close when hovering out
            hideOnHoverOut: false,
            onFilterChange: (change)=>onFiltersChange?.(filterId, change, experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN : (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN_FPS),
            onClearOptions: onClearOptions
        });
    }), (isConfluence || isJira) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), {
        isFilterInDropdown: true
    }), filtersInDropdown.filter((id)=>{
        if (experience === (0, $9rRKJ.SearchExperience).QUICK_FIND) return id !== (0, $9DkM9.filter).id && id !== (0, $2a0ps.filter).id;
        else return true;
    }).map((filterId)=>{
        const Filter = $b409c1590183c3bd$var$checkboxFilters[filterId];
        if (!Filter) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            key: filterId,
            isFilterInDropdown: true,
            onFilterChange: (change)=>onFiltersChange?.(filterId, change, experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN : (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN_FPS),
            onClearOptions: onClearOptions
        });
    })), isAnyFilterSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, filtersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b409c1590183c3bd$var$dividerStyles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b409c1590183c3bd$var$dividerStylesOld
    }), filtersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $euOzb.default), {
        xcss: $b409c1590183c3bd$var$clearButtonStyles,
        text: (0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).clearFilters,
        onClick: ()=>{
            // TODO: Consolidate these clear filter functions
            // Should we use clearAllAvailableFilters or clearAllFilters?
            // https://product-fabric.atlassian.net/browse/QS-5911
            clearAllFilters();
            resetSort();
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b409c1590183c3bd$var$clearButtonStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: ()=>{
            // TODO: Consolidate these clear filter functions
            // Should we use clearAllAvailableFilters or clearAllFilters?
            // https://product-fabric.atlassian.net/browse/QS-5911
            clearAllFilters();
            resetSort();
        }
    }, formatMessage((0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).clearFilters)))))));
};
var $b409c1590183c3bd$export$2e2bcd8739ae039 = $b409c1590183c3bd$var$DropdownFilter;
module.exports["default"] = $b409c1590183c3bd$export$2e2bcd8739ae039;

});

parcelRegister("fJ1R6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8tdj3 = parcelRequire("8tdj3");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");


var $fLkRZ = parcelRequire("fLkRZ");


var $b4tvS = parcelRequire("b4tvS");

var $6Gsan = parcelRequire("6Gsan");
parcelRequire("1yEFx");
var $1yEFx = parcelRequire("1yEFx");


var $7WbA8 = parcelRequire("7WbA8");


var $lBO0P = parcelRequire("lBO0P");


var $9ZAVx = parcelRequire("9ZAVx");


var $hrMXM = parcelRequire("hrMXM");


var $YqPsE = parcelRequire("YqPsE");


var $5xGHP = parcelRequire("5xGHP");


var $3KrAM = parcelRequire("3KrAM");


var $gGFxq = parcelRequire("gGFxq");


var $inrbX = parcelRequire("inrbX");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $djVCD = parcelRequire("djVCD");




const $d39873dfddd4cec0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    app: {
        id: "search-page.filters.names.app-select",
        defaultMessage: "App"
    },
    all: {
        id: "search-page.filter.app-select.all",
        defaultMessage: "All"
    },
    appSelectPlaceholder: {
        id: "search-page.filter.app-select.placeholder",
        defaultMessage: "Find app"
    },
    appSelectLabelSelected: {
        id: "search-page.filter.app-select.label.selected",
        defaultMessage: "Selected"
    },
    appSelectLabelUnselected: {
        id: "search-page.filter.app-select.label.unselected",
        defaultMessage: "Suggested"
    },
    appRedirectTooltip: {
        id: "search-page.filter.app-select.tooltip.redirect",
        defaultMessage: "Open a full page search filtered by {appLabel} results"
    }
});




parcelRequire("1yEFx");





const $80e3da07755ed193$export$46bdcc80066cc764 = ({ existingOptionValues: existingOptionValues, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, hasGitHubConfig: hasGitHubConfig })=>{
    if (primaryProduct !== (0, $6Gsan.PrimaryProductKeys).Jira) return false;
    const isGitHubConnected = (0, $gGFxq.isUserOAuthed)((0, $b4tvS.ProductKeys).Github, thirdPartyConfigs ?? {}).userNeedsOAuth === false;
    if (!isGitHubConnected || !hasGitHubConfig) return false;
    const isGitHubAlreadyIncluded = existingOptionValues.includes((0, $b4tvS.ProductKeys).Github);
    if (isGitHubAlreadyIncluded) return false;
    return true;
};


const $6e769a1a76e8bc25$var$MAX_SUGGESTED_1P = 3; // This includes the primary product
const $6e769a1a76e8bc25$var$MAX_SUGGESTED_3P = 2;
const $6e769a1a76e8bc25$var$appOptionStyles = {
    default: "_zulp12x7 _1bsb1osq _1e0c11p5 _4cvr1h6o _yv0e1mfv"
};
const $6e769a1a76e8bc25$var$getOptionLabel = (productKey, productConfig, thirdPartyConfigs)=>{
    // Edge case: This is to get the name of Confluence DC sites
    const workspaceName = (0, $YqPsE.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
    if (workspaceName) return workspaceName;
    if (typeof productConfig.displayName === 'string') return productConfig.displayName;
     // In theory this we should not reach here as displayName is rendered as a string
    return '';
};
const $6e769a1a76e8bc25$export$ab67fd9b6bfc576 = ({ isFilterInDropdown: isFilterInDropdown, fit: fit })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onAppSelectEvent = (0, $42omo.useCallback)((props)=>{
        const { productKey: productKey, isRedirectedToFPS: isRedirectedToFPS } = props;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: false,
                isRedirectedToFPS: isRedirectedToFPS,
                source: isFilterInDropdown ? 'app-selector-dropdown' : 'app-selector-inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        isFilterInDropdown,
        nonPrivacySafeAttributes
    ]);
    const onSelectChange = (0, $42omo.useCallback)((value)=>{
        const selectedValue = Array.isArray(value) ? value[1] : value;
        const productKey = selectedValue.value;
        if (!(0, $b4tvS.isProductKey)(productKey)) return;
        if (productKey === primaryProduct) {
            selectProductFilter(productKey);
            onAppSelectEvent({
                productKey: productKey,
                isRedirectedToFPS: false
            });
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push');
        onAppSelectEvent({
            productKey: productKey,
            isRedirectedToFPS: true
        });
        clearAllFilters();
        setQuickFindOpen(false);
    }, [
        clearAllFilters,
        generateSearchUrl,
        onAppSelectEvent,
        onNavigate,
        primaryProduct,
        queryParams,
        quickFindQuery,
        selectProductFilter,
        setQuickFindOpen
    ]);
    const allAppOptions = (0, $42omo.useMemo)(()=>{
        const productsOrder = (0, $hrMXM.getProductsOrderByPrimaryProduct)(primaryProduct);
        const counts = {
            apps1P: 0,
            apps3P: 0
        };
        const baseAppOptions = availableProducts.filter((productKey)=>{
            // Always exclude Atlas
            if (productKey === (0, $b4tvS.ProductKeys).Atlas || productKey === (0, $b4tvS.ProductKeys).AtlassianWebCrawler) return false;
            return true;
        }).filter((productKey)=>{
            const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.isUserOAuthed)(productKey, thirdPartyConfigs); // For 3P products, undefined means not configured — filter out
            if ((0, $b4tvS.is3pProductKey)(productKey)) return userNeedsOAuth === false;
             // For 1P products, undefined is expected (no OAuth needed)
            return !userNeedsOAuth;
        }).filter((productKey)=>productConfigs[productKey]).sort((a, b)=>(0, $9ZAVx.getProductOrder)(a, b, productsOrder)).filter((productKey)=>{
            // Edge Case: Loom is considered as 1P only for the App selector
            if (productKey === (0, $b4tvS.ProductKeys).Loom) {
                if (counts.apps1P < $6e769a1a76e8bc25$var$MAX_SUGGESTED_1P) {
                    counts.apps1P += 1;
                    return true;
                }
                return false;
            }
            if ((0, $b4tvS.is1pProductKey)(productKey) && counts.apps1P < $6e769a1a76e8bc25$var$MAX_SUGGESTED_1P) {
                counts.apps1P += 1;
                return true;
            }
            if ((0, $b4tvS.is3pProductKey)(productKey) && counts.apps3P < $6e769a1a76e8bc25$var$MAX_SUGGESTED_3P) {
                counts.apps3P += 1;
                return true;
            }
            return false;
        }).map((productKey)=>{
            return {
                value: productKey,
                isSelected: productKey === selectedProduct,
                label: $6e769a1a76e8bc25$var$getOptionLabel(productKey, productConfigs[productKey], thirdPartyConfigs),
                isDefault: false,
                trackingKey: productKey,
                queryParamValue: productKey,
                isSuggested: false
            };
        });
        if ((0, $80e3da07755ed193$export$46bdcc80066cc764)({
            existingOptionValues: baseAppOptions.map((option)=>option.value),
            primaryProduct: primaryProduct,
            thirdPartyConfigs: thirdPartyConfigs,
            hasGitHubConfig: Boolean(productConfigs[(0, $b4tvS.ProductKeys).Github])
        })) baseAppOptions.push({
            value: (0, $b4tvS.ProductKeys).Github,
            isSelected: (0, $b4tvS.ProductKeys).Github === selectedProduct,
            label: $6e769a1a76e8bc25$var$getOptionLabel((0, $b4tvS.ProductKeys).Github, productConfigs[(0, $b4tvS.ProductKeys).Github], thirdPartyConfigs),
            isDefault: false,
            trackingKey: (0, $b4tvS.ProductKeys).Github,
            queryParamValue: (0, $b4tvS.ProductKeys).Github,
            isSuggested: false
        });
        return baseAppOptions;
    }, [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct,
        thirdPartyConfigs
    ]);
    const selectedOption = (0, $42omo.useMemo)(()=>{
        const singleSelectedOption = allAppOptions.filter((option)=>option.isSelected)[0];
        return singleSelectedOption ? [
            singleSelectedOption
        ] : [];
    }, [
        allAppOptions
    ]);
    const selectedStateIcon = (0, $42omo.useMemo)(()=>{
        if ((0, $b4tvS.isProductKey)(selectedProduct)) {
            const productConfig = productConfigs[selectedProduct];
            const Icon = productConfig.Icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                size: "xxsmall"
            });
        }
        if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLkRZ.JiraAppSelectorIconWithGithub), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null);
    }, [
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    const groupedOptions = [
        {
            label: formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).appSelectLabelUnselected),
            options: allAppOptions
        }
    ];
    const formatOptionLabel = (0, $42omo.useCallback)((data)=>{
        const productKey = data.value;
        const appLabel = data.label;
        if (typeof productKey !== 'string' || !(0, $b4tvS.isProductKey)(productKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        const productConfig = productConfigs[productKey];
        const Icon = productConfig.Icon;
        const AppOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                size: "small"
            }), appLabel, props.isRedirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                size: "small",
                label: ""
            }));
        if (productKey === primaryProduct) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $6e769a1a76e8bc25$var$appOptionStyles.default
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AppOption, {
            isRedirect: false
        }));
        const tooltipContent = formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).appRedirectTooltip, {
            appLabel: appLabel
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            testId: "qf-app-fps-redirect-tooltip",
            position: "right",
            content: tooltipContent
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                ...tooltipProps,
                xcss: $6e769a1a76e8bc25$var$appOptionStyles.default
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AppOption, {
                isRedirect: true
            })));
    }, [
        formatMessage,
        primaryProduct,
        productConfigs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        testId: "qf-app-selector",
        onSelectChange: onSelectChange,
        options: groupedOptions,
        selectedOptions: selectedOption,
        label: selectedOption.length === 0 ? formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).app) : '',
        placeholder: formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).appSelectPlaceholder),
        formatOptionLabel: formatOptionLabel,
        iconBefore: selectedStateIcon,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: true,
        canClearFilter: true,
        onClearOptions: unselectProductFilter,
        hideOnHoverOut: primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off')
    });
};
module.exports["AppSelector"] = $6e769a1a76e8bc25$export$ab67fd9b6bfc576;

});

parcelRegister("fLkRZ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $304abc6f6f5e7b0a$export$20d3ba059bd0c642 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "52",
        height: "16",
        viewBox: "0 0 52 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2023_10818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        rx: "4",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2023_10818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.5797 9.51003C9.1108 8.31624 8.38955 8.13786 7.34929 8.13786C6.12871 8.13786 5.08845 8.64556 4.15915 10.0726L4.00658 10.3059C3.88174 10.498 3.854 10.5666 3.854 10.6489C3.854 10.7313 3.89561 10.7999 4.04819 10.8959L5.61552 11.8702C5.69874 11.9251 5.76809 11.9525 5.83744 11.9525C5.92066 11.9525 5.97614 11.9113 6.05936 11.7878L6.30903 11.4036C6.69739 10.8136 7.04415 10.6215 7.48799 10.6215C7.87636 10.6215 8.33407 10.7313 8.90275 11.0057L10.5394 11.7741C10.7059 11.8564 10.8862 11.8153 10.9694 11.6232L11.7461 9.92168C11.8294 9.72958 11.7739 9.60608 11.5797 9.51003ZM4.38107 6.50497C6.84996 7.69876 7.57121 7.87714 8.61148 7.87714C9.83205 7.87714 10.8723 7.36944 11.8016 5.94238L11.9542 5.70911C12.079 5.517 12.1068 5.4484 12.1068 5.36607C12.1068 5.28373 12.0652 5.21513 11.9126 5.11907L10.3452 4.14483C10.262 4.08994 10.1927 4.0625 10.1233 4.0625C10.0401 4.0625 9.98462 4.10367 9.9014 4.22716L9.65174 4.61137C9.26338 5.2014 8.91662 5.39351 8.47277 5.39351C8.08441 5.39351 7.62669 5.28373 7.05802 5.0093L5.42133 4.24088C5.25489 4.15855 5.07458 4.19972 4.99136 4.39182L4.21463 6.09332C4.13141 6.28542 4.18689 6.40892 4.38107 6.50497Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18 4C18 1.79086 19.7909 0 22 0H30C32.2091 0 34 1.79086 34 4V12C34 14.2091 32.2091 16 30 16H22C19.7909 16 18 14.2091 18 12V4Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.9996 3.00003C23.2385 3.00003 20.9995 5.29523 20.9995 8.12662C20.9995 10.3917 22.4322 12.3133 24.4188 12.9912C24.6687 13.0387 24.7605 12.88 24.7605 12.7446C24.7605 12.6224 24.7558 12.2185 24.7537 11.7901C23.3627 12.1003 23.0691 11.1853 23.0691 11.1853C22.8417 10.5927 22.514 10.4351 22.514 10.4351C22.0603 10.117 22.5482 10.1235 22.5482 10.1235C23.0503 10.1597 23.3146 10.6518 23.3146 10.6518C23.7606 11.4355 24.4843 11.209 24.7697 11.078C24.8145 10.7466 24.9441 10.5205 25.0871 10.3924C23.9765 10.2628 22.8091 9.82323 22.8091 7.85886C22.8091 7.29915 23.0044 6.84183 23.3242 6.48281C23.2723 6.35369 23.1012 5.83227 23.3727 5.12612C23.3727 5.12612 23.7926 4.98834 24.7481 5.65161C25.1469 5.53803 25.5746 5.48106 25.9996 5.47911C26.4245 5.48106 26.8525 5.53803 27.2521 5.65161C28.2065 4.98834 28.6258 5.12612 28.6258 5.12612C28.8979 5.83227 28.7267 6.35369 28.6748 6.48281C28.9954 6.84183 29.1894 7.29915 29.1894 7.85886C29.1894 9.8279 28.0197 10.2614 26.9063 10.3884C27.0856 10.5475 27.2454 10.8594 27.2454 11.3377C27.2454 12.0237 27.2396 12.5757 27.2396 12.7446C27.2396 12.881 27.3296 13.0409 27.5831 12.9905C29.5687 12.3119 30.9995 10.3909 30.9995 8.12662C30.9995 5.29523 28.7609 3.00003 25.9996 3.00003Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "path-5-inside-1_2023_10818",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40 0V1H48V0V-1H40V0ZM52 4H51V12H52H53V4H52ZM48 16V15H40V16V17H48V16ZM36 12H37V4H36H35V12H36ZM40 16V15C38.3431 15 37 13.6569 37 12H36H35C35 14.7614 37.2386 17 40 17V16ZM52 12H51C51 13.6569 49.6569 15 48 15V16V17C50.7614 17 53 14.7614 53 12H52ZM48 0V1C49.6569 1 51 2.34315 51 4H52H53C53 1.23858 50.7614 -1 48 -1V0ZM40 0V-1C37.2386 -1 35 1.23858 35 4H36H37C37 2.34315 38.3431 1 40 1V0Z",
        fill: "#0B120E",
        fillOpacity: "0.14",
        mask: "url(#path-5-inside-1_2023_10818)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2023_10818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M39.4724 11.3855L39.9428 12.1939C40.0406 12.3641 40.1811 12.4978 40.346 12.595L42.0261 9.70197H38.666C38.666 9.89038 38.7149 10.0788 38.8126 10.249L39.4724 11.3855Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M43.9993 6.29837L42.3193 3.4053C42.1544 3.50255 42.0139 3.63626 41.9161 3.80644L38.8126 9.15497C38.7167 9.32148 38.6661 9.51005 38.666 9.70198H42.0261L43.9993 6.29837Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.6534 12.595C47.8184 12.4978 47.9589 12.3641 48.0566 12.1939L48.2521 11.8596L49.1868 10.249C49.2846 10.0788 49.3335 9.89038 49.3335 9.70197H45.9731L46.6882 11.0999L47.6534 12.595Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M43.9999 6.29846L45.6799 3.40539C45.5149 3.30814 45.3256 3.25952 45.1301 3.25952H42.8697C42.6742 3.25952 42.4848 3.31422 42.3198 3.40539L43.9999 6.29846Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M45.9723 9.70197H42.0257L40.3457 12.595C40.5107 12.6923 40.7 12.7409 40.8955 12.7409H47.1025C47.298 12.7409 47.4874 12.6862 47.6523 12.595L45.9723 9.70197Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.635 6.48071L46.0832 3.80644C45.9855 3.63626 45.845 3.50255 45.68 3.4053L44 6.29837L45.9733 9.70198H49.3272C49.3272 9.51357 49.2784 9.32515 49.1806 9.15497L47.635 6.48071Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2023_10818"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2023_10818"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(3.854 4.0625)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2023_10818"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "10.6667",
        height: "9.48148",
        fill: "white",
        transform: "translate(38.666 3.2594)"
    }))));
module.exports["JiraAppSelectorIconWithGithub"] = $304abc6f6f5e7b0a$export$20d3ba059bd0c642;

});

parcelRegister("3KrAM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $6Gsan = parcelRequire("6Gsan");
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");
var $1yEFx = parcelRequire("1yEFx");




var $j4ply = parcelRequire("j4ply");

const $23f4502b40886e8a$var$styles = {
    container: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    iconBox: "_1reo15vq _18m915vq _2rko12b0 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz _1o9zidpf"
}; /**
    * Renders a strip of 3 app icons: the primary 1P app icon (Confluence if Jira,
    * Jira otherwise) followed by static Google Drive and Slack icons.
    */ 
const $23f4502b40886e8a$export$a9ec35d044cf4cf = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const FirstPartyIcon = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? productConfigs[(0, $b4tvS.ProductKeys).Confluence]?.Icon : productConfigs[(0, $b4tvS.ProductKeys).Jira]?.Icon;
    const icons = [
        FirstPartyIcon,
        productConfigs[(0, $b4tvS.ProductKeys3P).GoogleDrive]?.Icon,
        productConfigs[(0, $b4tvS.ProductKeys3P).Slack]?.Icon
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        role: "presentation",
        "aria-hidden": "true",
        xcss: $23f4502b40886e8a$var$styles.container
    }, icons.map((Icon, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: index,
            xcss: $23f4502b40886e8a$var$styles.iconBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: "xxsmall"
        }))));
};
module.exports["AllAppsIcon"] = $23f4502b40886e8a$export$a9ec35d044cf4cf;

});

parcelRegister("3fzmz", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gHaxX = parcelRequire("gHaxX");


var $4bnNr = parcelRequire("4bnNr");


var $dHZuf = parcelRequire("dHZuf");

const $8e3820e3b87a8a9b$export$4e07a927e22bed0a = ({ query: query, projectARIs: projectARIs, accountARIs: accountARIs })=>{
    let text;
    if (query) {
        // If the query looks like an issue key, use issueKey instead of textfields
        if ((0, $dHZuf.isQueryLikeWorkItemKey)(query) && (0, $dh538.fg)('rovo_search_update_work_items_link')) text = `issuekey ~ "${encodeURIComponent(query)}*"`;
        else text = `textfields ~ "${encodeURIComponent(query)}*"`;
    }
    const projectIds = projectARIs.map($8e3820e3b87a8a9b$var$getProjectIdFromProjectAri).filter(Boolean);
    const projectJQL = projectARIs.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : undefined;
    const accountIds = accountARIs.map($8e3820e3b87a8a9b$var$getAccountIdFromUserAri).filter(Boolean);
    const assigneeClause = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : undefined;
    return [
        text,
        projectJQL,
        assigneeClause
    ].filter(Boolean).join(' AND ');
};
function $8e3820e3b87a8a9b$var$getProjectIdFromProjectAri(projectAri) {
    try {
        return projectAri ? (0, $4bnNr.JiraProjectAri).parse(projectAri).projectId : undefined;
    } catch  {
        return undefined;
    }
}
function $8e3820e3b87a8a9b$var$getAccountIdFromUserAri(userAri) {
    try {
        return userAri ? (0, $gHaxX.IdentityUserAri).parse(userAri).userId : undefined;
    } catch  {
        return undefined;
    }
}
const $8e3820e3b87a8a9b$export$23c957892b92c4a0 = ({ query: query, jiraFilters: jiraFilters, generateSearchUrl: generateSearchUrl, queryParams: queryParams = {}, issueKeyLookup: issueKeyLookup, isQueryJql: isQueryJql = false })=>{
    const trimmedQuery = query.trim();
    let jql;
    const typedJqlRoutingEnabled = (0, $dh538.fg)('rovo_fps_route_typed_jql_as_jql');
    if (typedJqlRoutingEnabled && isQueryJql) jql = trimmedQuery;
    else if (trimmedQuery !== '' && (jiraFilters.issueFilter.projectARIs.length !== 0 || jiraFilters.issueFilter.assigneeARIs.length !== 0)) /* If query is empty we don't need to build jql as it will be ignored by generateSearchUrl
		 ** Otherwise, we pass the JQL to be redirected to work items page */ jql = $8e3820e3b87a8a9b$export$4e07a927e22bed0a({
        query: trimmedQuery,
        accountARIs: jiraFilters.issueFilter.assigneeARIs,
        projectARIs: jiraFilters.issueFilter.projectARIs
    });
    /* generateSearchUrl takes care of navigating to a signle work item page in case the query is a work item key
	 * Otherwise, it'll take the user to work items page.
	 * */ return generateSearchUrl({
        ...queryParams,
        text: query,
        ...jql && {
            jql: jql
        }
    }, true, undefined, undefined, issueKeyLookup);
};
module.exports["buildJql"] = $8e3820e3b87a8a9b$export$4e07a927e22bed0a;
module.exports["getWorkItemPageUrl"] = $8e3820e3b87a8a9b$export$23c957892b92c4a0;

});

parcelRegister("aKt88", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nBzc = parcelRequire("5nBzc");

// This mapping is copied from Jira FE:
// https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/issue/status-theming/src/statusCategoryToThemeMap.tsx
//
// If you are going to change this, please check the Jira FE mapping first to make sure they are in sync.
//
// It uses the statusCategoryId field from GQL to map to the corresponding Atlaskit lozenge appearance.
// The category IDs follow the Jira FE mapping, while the values use the semantic ADS appearances.
const $a22683c399072c80$var$STATUS_APPEARANCE_NEUTRAL = 'neutral';
const $a22683c399072c80$var$STATUS_APPEARANCE_SUCCESS = 'success';
const $a22683c399072c80$var$STATUS_APPEARANCE_INFORMATION = 'information';
const $a22683c399072c80$export$d9e35f42afe1e488 = {
    '1': $a22683c399072c80$var$STATUS_APPEARANCE_NEUTRAL,
    '2': $a22683c399072c80$var$STATUS_APPEARANCE_NEUTRAL,
    '3': $a22683c399072c80$var$STATUS_APPEARANCE_SUCCESS,
    '4': $a22683c399072c80$var$STATUS_APPEARANCE_INFORMATION
};



var $kc79t = parcelRequire("kc79t");


var $1hlFx = parcelRequire("1hlFx");

const $6a5caf72f25c94c4$var$jiraIssueStatusToLozengeMap = {
    [(0, $kc79t.JiraStatusCategoryColor).Red]: 'danger',
    [(0, $kc79t.JiraStatusCategoryColor).Brown]: 'neutral',
    [(0, $kc79t.JiraStatusCategoryColor).Green]: 'success',
    [(0, $kc79t.JiraStatusCategoryColor).Yellow]: 'warning',
    [(0, $kc79t.JiraStatusCategoryColor).BlueGray]: 'information',
    [(0, $kc79t.JiraStatusCategoryColor).MediumGray]: 'neutral'
};
const $6a5caf72f25c94c4$var$STATUS_REGEX = /[\s-]+/g;
/**
 * Remove when visual refresh flag is removed
 */ const $6a5caf72f25c94c4$var$getAppearance = (name)=>{
    name = name.replace($6a5caf72f25c94c4$var$STATUS_REGEX, '').toLowerCase();
    switch(true){
        case [
            'todo',
            'unavailable',
            'minor',
            'notstarted'
        ].includes(name):
            return 'neutral';
        case [
            'available',
            'completed',
            'done',
            'approved',
            'resolved',
            'added',
            'closed'
        ].includes(name):
            return 'success';
        case [
            'error',
            'declined',
            'deleted',
            'failed',
            'rejected'
        ].includes(name):
            return 'danger';
        case [
            'inprogress',
            'open',
            'modified'
        ].includes(name):
            return 'information';
    }
    return 'neutral';
};
const $6a5caf72f25c94c4$export$b70265791d2079d4 = (name, statusInfo, isLoading)=>{
    if (name) {
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1hlFx.MetaDataItemSkeleton), null);
        let appearance;
        if (statusInfo?.statusCategoryId) appearance = (0, $a22683c399072c80$export$d9e35f42afe1e488)[statusInfo.statusCategoryId];
        else if (statusInfo?.color) appearance = $6a5caf72f25c94c4$var$jiraIssueStatusToLozengeMap[statusInfo.color];
        if (appearance) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            isBold: true,
            appearance: appearance,
            testId: "jira-status-lozenge-test-id"
        }, name);
        const fallbackAppearance = $6a5caf72f25c94c4$var$getAppearance(name);
        if (fallbackAppearance) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: fallbackAppearance,
            testId: "jira-status-lozenge-test-id"
        }, name);
    }
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1hlFx.MetaDataItemSkeleton), null);
    return null;
};
module.exports["getStatus"] = $6a5caf72f25c94c4$export$b70265791d2079d4;

});

parcelRegister("kc79t", function(module, exports) {
const $a91146fce116fa8b$export$539cfae207f2a8d6 = {
    MediumGray: 'MEDIUM_GRAY',
    Green: 'GREEN',
    Yellow: 'YELLOW',
    Brown: 'BROWN',
    Red: 'WARM_RED',
    BlueGray: 'BLUE_GRAY'
};
module.exports["JiraStatusCategoryColor"] = $a91146fce116fa8b$export$539cfae207f2a8d6;

});

parcelRegister("1hlFx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6F6hl = parcelRequire("6F6hl");


var $9WEcF = parcelRequire("9WEcF");

const $d0f7782f05ea6f67$var$messages = (0, $aXWIB.defineMessages)({
    loadingResult: {
        id: "search_result_skeleton_loading_result",
        defaultMessage: "Loading result"
    }
});
const $d0f7782f05ea6f67$var$commonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest'
});
const $d0f7782f05ea6f67$var$skeletonTextStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full'
});
const $d0f7782f05ea6f67$var$titleStyles = (0, $ecnYn.xcss)({
    width: '280px',
    height: "var(--ds-space-200, 16px)",
    marginBottom: 'space.050'
});
const $d0f7782f05ea6f67$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.400',
    height: 'size.400',
    borderRadius: 'radius.small'
});
const $d0f7782f05ea6f67$var$containerStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none'
});
const $d0f7782f05ea6f67$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'space.100'
});
const $d0f7782f05ea6f67$var$descriptionStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: "var(--ds-space-150, 12px)"
});
const $d0f7782f05ea6f67$var$metadataStyles = (0, $ecnYn.xcss)({
    width: '200px',
    height: "var(--ds-space-150, 12px)",
    marginBottom: 'space.050'
});
const $d0f7782f05ea6f67$var$metadataItemStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-150, 12px)",
    borderRadius: 'radius.large'
});
const $d0f7782f05ea6f67$var$narrowMetadataItemStyles = (0, $ecnYn.xcss)({
    width: '50px'
});
const $d0f7782f05ea6f67$var$wideMetadataItemStyles = (0, $ecnYn.xcss)({
    width: '100px'
});
const $d0f7782f05ea6f67$export$9ecbe061c4358be9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "metadata-item-skeleton",
        xcss: [
            $d0f7782f05ea6f67$var$commonStyles,
            $d0f7782f05ea6f67$var$metadataItemStyles,
            $d0f7782f05ea6f67$var$narrowMetadataItemStyles
        ]
    });
};
const $d0f7782f05ea6f67$export$a72c2188d2b05fba = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "metadata-item-skeleton-wide",
        xcss: [
            $d0f7782f05ea6f67$var$commonStyles,
            $d0f7782f05ea6f67$var$metadataItemStyles,
            $d0f7782f05ea6f67$var$wideMetadataItemStyles
        ]
    });
};
const $d0f7782f05ea6f67$export$dd3282b157ef6f7a = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d0f7782f05ea6f67$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9WEcF.SearchResult), {
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$descriptionContainerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$skeletonTextStyles,
                $d0f7782f05ea6f67$var$descriptionStyles
            ]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$skeletonTextStyles,
                $d0f7782f05ea6f67$var$descriptionStyles
            ]
        })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$iconStyles
            ]
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, formatMessage($d0f7782f05ea6f67$var$messages.loadingResult)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$skeletonTextStyles,
                $d0f7782f05ea6f67$var$titleStyles
            ]
        })),
        headerMetadataParts: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $d0f7782f05ea6f67$var$commonStyles,
                    $d0f7782f05ea6f67$var$skeletonTextStyles,
                    $d0f7782f05ea6f67$var$metadataStyles
                ]
            })
        ],
        // TODO: QS-7036 consolidate the logic of the loading state as it's now split between
        //  this component and the SearchResult component (hence the prop)
        isLoadingSkeleton: true
    }));
};
module.exports["MetaDataItemSkeleton"] = $d0f7782f05ea6f67$export$9ecbe061c4358be9;
module.exports["MetaDataItemSkeletonWide"] = $d0f7782f05ea6f67$export$a72c2188d2b05fba;
module.exports["SearchResultSkeleton"] = $d0f7782f05ea6f67$export$dd3282b157ef6f7a;

});

parcelRegister("9WEcF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9Q2dU = parcelRequire("9Q2dU");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $cwkWT = parcelRequire("cwkWT");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $2OtFZ = parcelRequire("2OtFZ");


var $46mBC = parcelRequire("46mBC");


var $7WbA8 = parcelRequire("7WbA8");








var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $cOQz3 = parcelRequire("cOQz3");


var $9VJDA = parcelRequire("9VJDA");


var $gdv5Z = parcelRequire("gdv5Z");


var $i25hX = parcelRequire("i25hX");




const $dec63c756dcbc0c4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link-label",
        defaultMessage: "Copy link"
    },
    aiSummaryLabel: {
        id: "ai-summary-label",
        defaultMessage: "Summarize"
    },
    moreActionsLabel: {
        id: "more-actions-label",
        defaultMessage: "More Actions"
    },
    summarizeInChatLabel: {
        id: "summarize-in-chat-label",
        defaultMessage: "Summarize"
    }
});


const $b6487e77d6f03314$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT = 700;
const $b6487e77d6f03314$var$SearchResultContextMenu = ({ url: url, hideSummarizeInChat: hideSummarizeInChat = false, isContextMenuOpen: isContextMenuOpen, containerWidth: containerWidth, setIsContextMenuOpen: setIsContextMenuOpen, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const divRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: formatMessage((0, $dec63c756dcbc0c4$export$defe85febe8b728c).moreActionsLabel),
                isTooltipDisabled: false,
                spacing: "compact",
                ref: triggerRef,
                onClick: (e)=>{
                    onClick?.(e);
                    onContextMenuButtonClicked?.();
                }
            }),
        placement: "right-start",
        testId: "search-result-context-menu",
        onOpenChange: ()=>setIsContextMenuOpen(!isContextMenuOpen),
        isOpen: isContextMenuOpen,
        returnFocusRef: divRef,
        zIndex: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        testId: "search-result-context-menu-dropdown"
    }, containerWidth < $b6487e77d6f03314$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT && !hideSummarizeInChat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onMouseDown: ()=>{
            setIsContextMenuOpen(false);
            onSummarizeInChatButtonClicked?.();
            if (!url) return;
            publish({
                type: 'browser-context-payload',
                source: 'search-result',
                data: {
                    context: {
                        browserUrl: url
                    }
                }
            });
            publish({
                type: 'chat-new',
                source: 'search-result',
                data: {
                    dialogues: [],
                    prompt: `Summarize ${url}`,
                    name: `Summarize ${url}`
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
            color: "currentColor",
            label: "summarize-in-chat-button",
            spacing: "spacious"
        }),
        testId: "context-menu-summarize-in-chat-button"
    }, formatMessage((0, $dec63c756dcbc0c4$export$defe85febe8b728c).summarizeInChatLabel)))));
};
var $b6487e77d6f03314$export$2e2bcd8739ae039 = $b6487e77d6f03314$var$SearchResultContextMenu;



var $a7nUd = parcelRequire("a7nUd");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $bUlM5 = parcelRequire("bUlM5");



var $dcJ7R = parcelRequire("dcJ7R");




var $9vOy1 = parcelRequire("9vOy1");


var $1VHLw = parcelRequire("1VHLw");





var $fm8DG = parcelRequire("fm8DG");


var $jAenQ = parcelRequire("jAenQ");


var $i1wpt = parcelRequire("i1wpt");


var $kqMUN = parcelRequire("kqMUN");


var $976IZ = parcelRequire("976IZ");

const $ab9ed5f36da1b106$var$summarizeButtonRevampTreatment = (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
    fireExperimentExposure: false
});
const $ab9ed5f36da1b106$var$isRevampTreatment = $ab9ed5f36da1b106$var$summarizeButtonRevampTreatment !== 'control';
const $ab9ed5f36da1b106$var$isBorderTreatment = $ab9ed5f36da1b106$var$summarizeButtonRevampTreatment === 'border';
const $ab9ed5f36da1b106$var$headingAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'heading',
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    minWidth: '476px'
});
const $ab9ed5f36da1b106$var$headingAreaRevampStyles = (0, $ecnYn.xcss)({
    gridArea: 'heading',
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    minWidth: '0px'
});
const $ab9ed5f36da1b106$var$titleStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    overflow: 'hidden'
});
const $ab9ed5f36da1b106$var$titleTextStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'inherit'
});
const $ab9ed5f36da1b106$var$titleTextLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    ':hover': {
        color: 'color.link'
    }
});
const $ab9ed5f36da1b106$var$visitedLinkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'none',
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    ':visited': {
        color: 'color.link.visited'
    }
});
const $ab9ed5f36da1b106$var$visitedLinkPatchStyles = (0, $ecnYn.xcss)({
    color: 'color.link.visited',
    ':active': {
        color: 'color.link.visited.pressed'
    }
});
const $ab9ed5f36da1b106$var$titleMetadataStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'end',
    height: "var(--ds-space-300, 24px)"
});
const $ab9ed5f36da1b106$export$9e8cf942b0ab74d9 = ({ id: id, title: title, url: url, isThirdParty: isThirdParty = false, appMode: appMode, isHovered: isHovered, titleMetadata: titleMetadata, showSummarizeInChatButton: showSummarizeInChatButton = false, hasRelatedLinks: hasRelatedLinks, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked })=>{
    const isRovoMode = appMode === (0, $9vOy1.ApplicationModes).Rovo; /**
                                                         * A dynamic search_id query param and queryHash is appended to the document URL for 1P search results.
                                                         * As a result we are unable to use the browser's visited links history to determine if a link has been visited.
                                                         * This is workaround until we have a better solution.
                                                         */ 
    const visitedLinks = (0, $976IZ.getVisitedLinks)();
    const isVisitedLink = id ? (0, $kqMUN.isVisited)(visitedLinks, id) : false;
    const onClick = ({ isAuxClick: isAuxClick = false, isSummarizeClick: isSummarizeClick = false, hasRelatedLinks: hasRelatedLinks = false } = {})=>{
        // Mark the link as visited, but only for normal clicks
        if (id && !isSummarizeClick) (0, $976IZ.addVisitedLink)(id);
        onResultClicked?.({
            hasRelatedLinks: hasRelatedLinks,
            isAuxClick: isAuxClick,
            isSummarizeClick: isSummarizeClick
        });
    };
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$isRevampTreatment ? $ab9ed5f36da1b106$var$headingAreaRevampStyles : $ab9ed5f36da1b106$var$headingAreaStyles,
        onClick: ()=>onClick({
                hasRelatedLinks: hasRelatedLinks
            }),
        onContextMenu: onResultContextMenu,
        onAuxClick: (e)=>{
            if ((0, $2OtFZ.serveEngagementTrackingImprovementsExperiment)() && (0, $1VHLw.isAuxClick)(e)) return onClick({
                isAuxClick: true,
                hasRelatedLinks: hasRelatedLinks
            });
        }
    }, id && url ? /*#__PURE__*/ $42omo.createElement((0, $cwkWT.default), {
        templateColumns: "minmax(50%, 1fr) min-content",
        gap: "space.400"
    }, /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $jAenQ.Link), {
        xcss: [
            $ab9ed5f36da1b106$var$visitedLinkStyles,
            isVisitedLink && $ab9ed5f36da1b106$var$visitedLinkPatchStyles,
            $ab9ed5f36da1b106$var$titleStyles
        ],
        rel: isThirdParty ? 'noreferrer' : '',
        target: isThirdParty ? '_blank' : undefined,
        href: url,
        testId: "search-page-result-link"
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: [
            $ab9ed5f36da1b106$var$titleTextStyles,
            $ab9ed5f36da1b106$var$titleTextLinkStyles,
            isVisitedLink && $ab9ed5f36da1b106$var$visitedLinkPatchStyles
        ],
        as: "h2"
    }, title)), isHovered && isRovoMode && /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $fm8DG.CopyLinkButton), {
        showSuccess: true,
        testId: id,
        fullResultUrl: url,
        onClick: onCopyLinkButtonClicked
    }), showSummarizeInChatButton && /*#__PURE__*/ $42omo.createElement((0, $i1wpt.SummarizeInChatButton), {
        ari: id,
        url: url,
        showGradientBorder: $ab9ed5f36da1b106$var$isBorderTreatment,
        onClick: ()=>{
            onSummarizeInChatButtonClicked?.();
            if ((0, $2OtFZ.serveEngagementTrackingImprovementsExperiment)()) onClick({
                isSummarizeClick: true
            });
        },
        testId: 'search-result-summarize-in-chat'
    }))), titleMetadata && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$titleMetadataStyles
    }, titleMetadata)) : /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$titleStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$titleTextStyles,
        as: "h2"
    }, title))));
};





const $35a6830d0984657f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    lastActive: {
        id: "search-page.results.product-results.third-party.last-active",
        defaultMessage: "Last active {relativeDate}"
    },
    threadTypeLabel: {
        id: "search-page.results.product-results.third-party.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "search-page.results.product-results.third-party.message-type-label",
        defaultMessage: "Message"
    },
    channelTypeLabel: {
        id: "search-page.results.product-results.third-party.channel-type-label",
        defaultMessage: "Channel"
    },
    channelMemberCount: {
        id: "search-page.results.product-results.third-party.channel-member-count",
        defaultMessage: "{memberCount, plural, one {# member} other {# members}}"
    },
    privateConversationText: {
        id: "search-page.results.product-results.third-party.private-conversation-text",
        defaultMessage: "{users} in a private conversation"
    },
    noContributorsText: {
        id: "search-page.results.product-results.third-party.no-contributors-label",
        defaultMessage: "External people in #{channelName}"
    },
    externalPeopleText: {
        id: "search-page.results.product-results.third-party.external-people-label",
        defaultMessage: "External people"
    },
    externalPersonText: {
        id: "search-page.results.product-results.third-party.external-person-label",
        defaultMessage: "External person"
    },
    titleWithRemainingContributors: {
        id: "search-page.results.product-results.third-party.title-with-remaining-contributors",
        defaultMessage: "{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}"
    },
    titleAndChannelName: {
        id: "search-page.results.product-results.third-party.title-and-channel-name",
        defaultMessage: "{title} in #{channelName}"
    },
    messageResultLockIconTooltip: {
        id: "search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip",
        defaultMessage: "Restricted - Only specific people can see this result"
    },
    privateChannelLabel: {
        id: "search-result.private-channel-label",
        defaultMessage: "Private Channel"
    }
});


const $caeb18e39a927b2a$var$isRevampTreatment = (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
    fireExperimentExposure: false
}) !== 'control';
const $caeb18e39a927b2a$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT = 700;
const $caeb18e39a927b2a$var$searchResultContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $caeb18e39a927b2a$var$iconAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'icon',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: "var(--ds-space-600, 48px)"
});
const $caeb18e39a927b2a$var$newIconStyles = (0, $ecnYn.xcss)({
    marginBlockStart: 'space.075'
});
const $caeb18e39a927b2a$var$headerRightAreaStylesInVisible = (0, $ecnYn.xcss)({
    opacity: 0
});
const $caeb18e39a927b2a$var$headerRightAreaStylesVisible = (0, $ecnYn.xcss)({
    opacity: 1
});
const $caeb18e39a927b2a$var$bodyAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'body',
    paddingTop: 'space.050',
    overflowWrap: 'break-word'
});
const $caeb18e39a927b2a$var$bodyAreaHiddenStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $caeb18e39a927b2a$var$footerAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'footer'
});
const $caeb18e39a927b2a$var$lockIconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginInlineEnd: 'space.075',
    paddingTop: 'space.025'
});
const $caeb18e39a927b2a$var$headerRightContainerStyles = (0, $ecnYn.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $caeb18e39a927b2a$export$a2def421b23768aa = ({ id: id, product: product, productSelected: productSelected, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, description: description, footer: footer, icon: icon, url: url, hideSummarizeInChat: hideSummarizeInChat = false, role: role = 'listitem', cloudId: cloudId, title: // required for AI Summaries
title, isThirdParty: isThirdParty, appMode: appMode, headerMetadataParts: headerMetadataParts, headerMetadataSocialParts: headerMetadataSocialParts, titleMetadata: titleMetadata, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isLoadingSkeleton: isLoadingSkeleton = false, isLinkedResult: isLinkedResult = false, isPrivate: isPrivate, hasRelatedLinks: hasRelatedLinks = false, mainContentWidth: mainContentWidth })=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const [isContextMenuOpen, setIsContextMenuOpen] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)(null);
    const isContextMenuVisible = !isLinkedResult && (isHovered || isFocused || isContextMenuOpen);
    const searchResultWidth = mainContentWidth || 0;
    const isRovoLLMCheckPassed = !(0, $dh538.fg)('kd_summarize_in_chat_rovo_llm_check') || isRovoLLMEnabled;
    const showSummarizeInChatByTitle = isRovoLLMCheckPassed && !hideSummarizeInChat && ($caeb18e39a927b2a$var$isRevampTreatment || searchResultWidth >= $caeb18e39a927b2a$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT);
    const [hasDescriptionContent, setHasDescriptionContent] = (0, $42omo.useState)(isLoadingSkeleton ? true : !!description);
    const descriptionRef = (0, $42omo.useCallback)((node)=>{
        // The loading skeleton intentionally renders a description made of empty
        // styled boxes (no text / media nodes). Skip the "is this empty?" heuristic
        // when rendering as a skeleton so the body row is preserved and the skeleton
        // keeps its full vertical height.
        if (isLoadingSkeleton) return;
        if (node) {
            const hasContent = (node.textContent?.trim().length ?? 0) > 0 || node.querySelector('img, svg, canvas, video') !== null;
            if (!hasContent) setHasDescriptionContent(false);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- only re-check when description identity or skeleton mode changes
    [
        description,
        isLoadingSkeleton
    ]);
    const wrapCrossProductUrl = (0, $46mBC.useSearchCrossProductUrlWrapper)({
        bridge: 'searchPage',
        primaryProduct: primaryProduct,
        primarySubProduct: primarySubProduct
    });
    const wrappedUrl = wrapCrossProductUrl(url, product);
    return /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        role: role,
        onMouseEnter: ()=>{
            setIsHovered(true);
            if (isRovoLLMCheckPassed && !hideSummarizeInChat) (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
                fireExperimentExposure: true
            });
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: isLoadingSkeleton ? 'search-page-result-skeleton' : 'search-page-result',
        ref: containerRef,
        xcss: $caeb18e39a927b2a$var$searchResultContainerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $cwkWT.default), {
        columnGap: "space.150",
        rowGap: "space.050",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            ...hasDescriptionContent || isLoadingSkeleton ? [
                'icon body body'
            ] : [],
            ...footer ? [
                'icon footer footer'
            ] : []
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$iconAreaStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$newIconStyles
    }, icon)), /*#__PURE__*/ $42omo.createElement((0, $ab9ed5f36da1b106$export$9e8cf942b0ab74d9), {
        id: id,
        title: title,
        url: wrappedUrl,
        isThirdParty: isThirdParty,
        appMode: appMode,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        isHovered: isHovered,
        titleMetadata: titleMetadata,
        showSummarizeInChatButton: showSummarizeInChatByTitle,
        hasRelatedLinks: hasRelatedLinks
    }), /*#__PURE__*/ $42omo.createElement((0, $a7nUd.SearchMetadata), {
        searchResultId: id,
        product: product,
        productSelected: productSelected,
        parts: headerMetadataParts,
        socialParts: headerMetadataSocialParts,
        containerRef: containerRef
    }), /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$headerRightContainerStyles
    }, isPrivate && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$lockIconStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: formatMessage((0, $35a6830d0984657f$export$defe85febe8b728c).messageResultLockIconTooltip)
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: formatMessage((0, $35a6830d0984657f$export$defe85febe8b728c).privateChannelLabel),
        color: "var(--ds-icon-accent-red, #C9372C)",
        size: "small"
    }))), !$caeb18e39a927b2a$var$isRevampTreatment && !isLoadingSkeleton && isRovoLLMCheckPassed && searchResultWidth <= $caeb18e39a927b2a$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT && !hideSummarizeInChat && // Context Menu should not be rendered when rendering as a loading skeleton
    /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: isContextMenuVisible ? $caeb18e39a927b2a$var$headerRightAreaStylesVisible : $caeb18e39a927b2a$var$headerRightAreaStylesInVisible,
        testId: "search-result-context-menu"
    }, /*#__PURE__*/ $42omo.createElement((0, $b6487e77d6f03314$export$2e2bcd8739ae039), {
        url: wrappedUrl,
        isContextMenuOpen: isContextMenuOpen,
        containerWidth: searchResultWidth,
        setIsContextMenuOpen: setIsContextMenuOpen,
        setIsFocused: setIsFocused,
        setIsHovered: setIsHovered,
        id: id || '',
        cloudId: cloudId,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        hideSummarizeInChat: hideSummarizeInChat,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked
    }))), description && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        ref: descriptionRef,
        xcss: [
            $caeb18e39a927b2a$var$bodyAreaStyles,
            !hasDescriptionContent && !isLoadingSkeleton && $caeb18e39a927b2a$var$bodyAreaHiddenStyles
        ]
    }, description), footer && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$footerAreaStyles
    }, footer)));
};
module.exports["SearchResult"] = $caeb18e39a927b2a$export$a2def421b23768aa;

});

parcelRegister("fm8DG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");




const $7c784569f8558ead$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    copyLinkTooltipLabel: {
        id: "copy-link-tooltip-label",
        defaultMessage: "Copy link"
    },
    copiedLinkTooltipLabel: {
        id: "copied-link-tooltip-label",
        defaultMessage: "Copied!"
    },
    successIconLabel: {
        id: "copy-link-success-icon-label",
        defaultMessage: "Success icon"
    },
    copyLinkButtonLabel: {
        id: "copy-link-button-label",
        defaultMessage: "Copy Link"
    }
});


const $4850c225b0c92f37$var$TIMEOUT_DELAY = 2500;
const $4850c225b0c92f37$var$cursorDisabledStyles = (0, $ecnYn.xcss)({
    cursor: 'default',
    border: 'none'
});
const $4850c225b0c92f37$var$buttonStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    height: `${24 / 14}em`,
    width: `${24 / 14}em`,
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral, #0515240F)"
    },
    ':active': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    ':disabled': {
        background: 'transparent'
    }
});
const $4850c225b0c92f37$var$borderStyles = (0, $ecnYn.xcss)({
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.small',
    boxSizing: 'border-box',
    paddingInline: 'space.050',
    paddingBlock: 'space.050',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '24px',
    width: '24px'
});
const $4850c225b0c92f37$export$534d10f1c5b9c7b3 = ({ showSuccess: showSuccess, fullResultUrl: fullResultUrl, isButton: isButton, testId: testId, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [tooltipLabel, setTooltipLabel] = (0, $42omo.useState)(formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copyLinkTooltipLabel));
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel
    ]);
    const copyToClipboard = async ()=>{
        // Call the onClick callback if it exists
        onClick?.();
        if (!fullResultUrl) return;
        await navigator.clipboard.writeText(typeof fullResultUrl === 'function' ? fullResultUrl() : fullResultUrl);
        if (showSuccess) {
            setIsCopied(true);
            setTooltipLabel(formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copiedLinkTooltipLabel));
            setTimeout(()=>{
                setIsCopied(false);
                setTooltipLabel(formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copyLinkTooltipLabel));
            }, $4850c225b0c92f37$var$TIMEOUT_DELAY);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        isDisabled: isCopied,
        onClick: copyToClipboard,
        testId: testId,
        "aria-label": formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copyLinkButtonLabel),
        backgroundColor: "color.background.neutral.subtle",
        xcss: [
            isButton ? $4850c225b0c92f37$var$buttonStyles : $4850c225b0c92f37$var$borderStyles,
            isCopied && $4850c225b0c92f37$var$cursorDisabledStyles
        ]
    }, isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).successIconLabel),
        color: "var(--ds-icon-accent-green, #22A06B)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        "aria-hidden": "true"
    })));
};
module.exports["CopyLinkButton"] = $4850c225b0c92f37$export$534d10f1c5b9c7b3;

});

parcelRegister("i1wpt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $cOQz3 = parcelRequire("cOQz3");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $i25hX = parcelRequire("i25hX");




const $191c632f5b8a9958$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    summarizeInChatButtonText: {
        id: "summarize-in-chat-button-text",
        defaultMessage: "Summarize"
    }
});


const $e573f3e1c068bc84$var$styles = {
    gradientBorderWrapper: "_2rko12b0 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y _1itkw4kx",
    customSummarizeButton: "_zulp1b66 _2rko12b0 _11c8fhey _1rjcv77o _18zrutpp _1dqoglyw _1e0c116y _4cvr1h6o _4t3iqslr _bfhkvuon _syazazsu _k48p1wq8 _o5721q9c _80omtlke _1ygbdfik _1ah3v77o _irr319i6 _1di613ro"
};
const $e573f3e1c068bc84$export$82e212324eddea91 = ({ url: url, ari: ari, testId: testId, onClick: onClick, showGradientBorder: showGradientBorder = false, spacing: spacing = 'compact' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const promptRovoChat = (e)=>{
        onClick?.();
        e.stopPropagation();
        if (!url) return;
        publish({
            type: 'browser-context-payload',
            source: 'search-result',
            data: {
                context: {
                    browserUrl: url
                }
            }
        });
        publish({
            type: 'chat-new',
            source: 'search-result',
            data: {
                dialogues: [],
                prompt: `Summarize ${url}`,
                name: `Summarize ${url}`,
                ...ari && (0, $dh538.fg)('read_fe_search_artifact_context') ? {
                    searchArtifact: {
                        url: url,
                        ari: ari
                    }
                } : {}
            }
        });
    };
    if (showGradientBorder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $e573f3e1c068bc84$var$styles.gradientBorderWrapper,
        testId: "summarize-in-chat-gradient-border"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $e573f3e1c068bc84$var$styles.customSummarizeButton,
        onClick: promptRovoChat,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
        label: ""
    }), formatMessage((0, $191c632f5b8a9958$export$a7357cdd1f0b0168).summarizeInChatButtonText)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))),
        spacing: spacing,
        onClick: promptRovoChat,
        testId: testId
    }, formatMessage((0, $191c632f5b8a9958$export$a7357cdd1f0b0168).summarizeInChatButtonText));
};
module.exports["SummarizeInChatButton"] = $e573f3e1c068bc84$export$82e212324eddea91;

});

parcelRegister("kqMUN", function(module, exports) {
const $4f66da019ad71cb5$export$df30b8dffa0e57a6 = (visitedLinks, id)=>{
    return visitedLinks.has(id);
};
module.exports["isVisited"] = $4f66da019ad71cb5$export$df30b8dffa0e57a6;

});

parcelRegister("976IZ", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");


const $5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY = 'atlassian.search-page.visited';
const $5de3908e70286a2a$export$5d8cdaf303406828 = (value)=>{
    (0, $5G9KX.setLocalStorageItem)($5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY, JSON.stringify([
        ...$5de3908e70286a2a$export$ea4ff4efe040153f(),
        value
    ]));
};
const $5de3908e70286a2a$export$ea4ff4efe040153f = ()=>{
    const visitedLinksRaw = (0, $5G9KX.getLocalStorageItemAsString)($5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY);
    return new Set(visitedLinksRaw ? JSON.parse(visitedLinksRaw) : []);
};
module.exports["addVisitedLink"] = $5de3908e70286a2a$export$5d8cdaf303406828;
module.exports["getVisitedLinks"] = $5de3908e70286a2a$export$ea4ff4efe040153f;

});

parcelRegister("cWRpe", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $esRft = parcelRequire("esRft");


var $brMqq = parcelRequire("brMqq");

const $b5c0067abfebc5a4$var$styles = {
    container: "_kqswh2mm _xpfz12b0 _1lck1bhr _ontxe4h9 _wh24nqa1 _jw4istnw _1if2idpf _1ffoidpf _1pww1crf _1lve1crf _nzgk1bhr",
    quickFind: "_1pww19bv _1lve19bv"
};
const $b5c0067abfebc5a4$export$ebd26aa8d8b5f39b = ({ src: src, isQuickFind: isQuickFind = false })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $b5c0067abfebc5a4$var$styles.container,
            isQuickFind && $b5c0067abfebc5a4$var$styles.quickFind
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        src: src
    }), /*#__PURE__*/ $42omo.createElement((0, $brMqq.TalentSearchResultIcon), null));
};
module.exports["TalentUserAvatar"] = $b5c0067abfebc5a4$export$ebd26aa8d8b5f39b;

});

parcelRegister("7loel", function(module, exports) {
/* TODO: Remove this when the backend stops sending dummy board URLs,
         as locationless boards will be handled by the backend and this check will no longer be needed.
 */ const $28d75649ec4ac5b0$export$45d5a01e88e241a6 = (url)=>Boolean(url?.endsWith('/browse/DummyJiraBoard'));
module.exports["isDummyBoardUrl"] = $28d75649ec4ac5b0$export$45d5a01e88e241a6;

});

parcelRegister("hMWMD", function(module, exports) {
/**
 * Normalize a third-party **work-item** status string (typically lower-snake or
 * kebab-case as returned by providers such as GitHub, e.g. `in_progress` or
 * `in-progress`) into a human-readable label suitable for display in the
 * work-item status lozenge (e.g. `In progress`).
 *
 * Shared between the Quick Find dialog (`product-entity`) and the full search
 * results page (`search-graph-work-item`) so both surfaces render work-item
 * status labels identically and stay in lockstep if the normalization rules
 * ever change.
 *
 * Behaviour:
 *   - Collapses any run of `-`/`_` separators into a single space.
 *   - Lower-cases the entire string.
 *   - Upper-cases only the first character of the resulting string.
 *
 * @example
 *   normalizeWorkItemStatusLabel('in_progress')   // 'In progress'
 *   normalizeWorkItemStatusLabel('IN-PROGRESS')   // 'In progress'
 *   normalizeWorkItemStatusLabel('open')          // 'Open'
 *   normalizeWorkItemStatusLabel('')              // ''
 */ const $5035bfc54f38737f$export$df6718c7f2af610f = (status)=>status.replace(/[-_]+/g, ' ').toLowerCase().replace(/^\w/, (c)=>c.toUpperCase());
module.exports["normalizeWorkItemStatusLabel"] = $5035bfc54f38737f$export$df6718c7f2af610f;

});

parcelRegister("92zSJ", function(module, exports) {

var $bOpS4 = parcelRequire("bOpS4");

const $3b640916832a713a$var$getContentString = (adf, level = 0)=>{
    let aggregatedString = '';
    if (adf.content) adf.content.forEach((node)=>{
        if (node.type === 'text') aggregatedString += node.text;
        else if (node.content && level < 15) aggregatedString += ' ' + $3b640916832a713a$var$getContentString(node, ++level);
    });
    return aggregatedString;
};
const $3b640916832a713a$export$c40fed6f44bda628 = (description, query)=>{
    /**
   * This description can be either a complicated JSON which is actually an ADF (Atlassian Document Format) schema of the entire content of the jira issue.
   * or it could be a simple excerpt. This uncertainity is due to the progressive development of the BE feature and rolling it out.
   */ try {
        const adf = JSON.parse(description);
        const text = $3b640916832a713a$var$getContentString(adf);
        return (0, $bOpS4.truncateTextWithQuery)(text, query);
    } catch (e) {
        return description.length > (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT) ? description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT)) + '...' : description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT));
    }
};
module.exports["getSummarizedAdfContent"] = $3b640916832a713a$export$c40fed6f44bda628;

});

parcelRegister("bOpS4", function(module, exports) {
const $93d9d061d8a03301$var$MAX_WORDS = 20;
const $93d9d061d8a03301$export$6e2b3cea5902982b = 250;
const $93d9d061d8a03301$export$91c2cc655c44ef69 = (text, query)=>{
    if (!text) return '';
    const lowerCaseQuery = query.toLowerCase();
    const words = text.split(' ');
    const indexOfQuery = words.findIndex((value)=>lowerCaseQuery === value.toLowerCase());
    if (indexOfQuery > $93d9d061d8a03301$var$MAX_WORDS) return [
        '...'
    ].concat(words.slice(indexOfQuery - $93d9d061d8a03301$var$MAX_WORDS, indexOfQuery + $93d9d061d8a03301$var$MAX_WORDS)).concat('...').join(' ');
    return words.slice(0, 2 * $93d9d061d8a03301$var$MAX_WORDS).join(' ').substring(0, $93d9d061d8a03301$export$6e2b3cea5902982b) + (text.length > $93d9d061d8a03301$export$6e2b3cea5902982b ? '...' : '');
};
module.exports["MAX_CHARACTERS_IN_EXCERPT"] = $93d9d061d8a03301$export$6e2b3cea5902982b;
module.exports["truncateTextWithQuery"] = $93d9d061d8a03301$export$91c2cc655c44ef69;

});

parcelRegister("7yVTH", function(module, exports) {
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $dh538 = parcelRequire("dh538");


var $chwej = parcelRequire("chwej");


var $idpYy = parcelRequire("idpYy");


var $5iakG = parcelRequire("5iakG");


var $b4tvS = parcelRequire("b4tvS");


var $2OtFZ = parcelRequire("2OtFZ");


var $2GQhu = parcelRequire("2GQhu");


var $5XpfZ = parcelRequire("5XpfZ");


var $22zVp = parcelRequire("22zVp");


var $gY9AU = parcelRequire("gY9AU");

const $389fa27b7e70fb9c$export$62c31c0f13603e08 = (jiraFilters, availableProducts)=>{
    const allAvailableJiraProductTypes = Object.keys((0, $gY9AU.JiraProductProjectFilterKey)).reduce((acc, productKey)=>{
        const jiraProductKey = productKey;
        if (!availableProducts || availableProducts.includes(jiraProductKey)) acc.push(...(0, $gY9AU.JiraProductProjectFilterKey)[jiraProductKey]);
        return acc;
    }, []);
    return {
        ...jiraFilters,
        projectFilter: {
            ...jiraFilters.projectFilter,
            projectTypes: allAvailableJiraProductTypes
        }
    };
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $lRrav = parcelRequire("lRrav");


// DJB2 hash function for JSON objects
function $8ec58c33150c42f9$var$hashJsonObjectDJB2(jsonObject) {
    // Convert the JSON object to a string
    const jsonString = JSON.stringify(jsonObject);
    // Initialize hash value
    let hash = 5381;
    // Iterate over each character in the string
    for(let i = 0; i < jsonString.length; i++){
        const char = jsonString.charCodeAt(i);
        hash = hash * 33 ^ char; // XOR and multiply by 33
    }
    // Ensure the hash is a positive 32-bit integer
    return (hash >>> 0).toString(16);
}
const $8ec58c33150c42f9$var$sessionIdsMap = new Map();
function $8ec58c33150c42f9$export$8b9832780ea0337b(variables) {
    if ($8ec58c33150c42f9$var$sessionIdsMap.size > 1000) $8ec58c33150c42f9$var$sessionIdsMap.clear();
    const { sessionId: sessionId, searchSessionId: searchSessionId, ...vars } = variables;
    const queryKey = $8ec58c33150c42f9$var$hashJsonObjectDJB2(vars);
    const existingSession = $8ec58c33150c42f9$var$sessionIdsMap.get(queryKey);
    if (existingSession) return existingSession;
    $8ec58c33150c42f9$var$sessionIdsMap.set(queryKey, [
        sessionId,
        searchSessionId
    ]);
    return [
        sessionId,
        searchSessionId
    ];
}
function $8ec58c33150c42f9$export$77a5fc99991cbb57() {
    $8ec58c33150c42f9$var$sessionIdsMap.clear();
}
const $8ec58c33150c42f9$export$966bb5e577b5d521 = (forceUpdate = false)=>{
    const sessionId = (0, $lRrav.SEARCH_SESSION_ID).value();
    if (!sessionId || forceUpdate) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    (0, $lRrav.SEARCH_SESSION_ID).update((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
};






var $hm6w9 = parcelRequire("hm6w9");


var $gkXKl = parcelRequire("gkXKl");


var $b4tDU = parcelRequire("b4tDU");

const $30a294c49652f998$export$f080ba31649d3794 = (selectedProducts)=>{
    const is3pGroupingEnabled = (0, $dh538.fg)('fps_3p_grouping_rollout_gate');
    if (is3pGroupingEnabled === false) return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? 'boosted-and-smartlinks' : undefined;
    return 'enable-v2';
};
const $30a294c49652f998$export$8c6fefe9b6b2ccd8 = (props)=>{
    const experimentConfig = (0, $gkXKl.getExperimentConfig)({
        primaryProduct: props.primaryProduct,
        experimentLayers: props.experimentLayers,
        sideBySideExperiment: undefined,
        statsigLayer: undefined,
        onError: props.onError,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: props.entities,
        productEdition: props.productEdition,
        isHello: props.isHello,
        productDataRegions: props.productDataRegions,
        experience: props.experienceLayer,
        tenantId: props.cloudId,
        isJiraIssueIndexed: props.isJiraIssueIndexed,
        thirdPartyFilters: props.thirdPartyFilters,
        backendExperimentOverrides: props.backendExperimentOverrides,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const fanoutExperimentCohort = $30a294c49652f998$export$f080ba31649d3794(props.selectedProducts);
    return {
        experimentId: experimentId,
        experimentLayers: experimentLayers,
        shadowExperimentId: shadowExperimentId,
        fanoutExperimentCohort: fanoutExperimentCohort,
        backendExperiment: backendExperiment
    };
};



var $8uOED = parcelRequire("8uOED");


var $74x1m = parcelRequire("74x1m");

const $46dd28b200fb61b5$export$8a04e6ddedd0bb29 = ({ queryParams: queryParams, cloudId: cloudId, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds })=>{
    const { filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource } = (0, $74x1m.getSearchConfig)({
        cloudId: cloudId,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const selectedFilters = (0, $8uOED.getSelectedFilters)({
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource,
        availableProducts: availableProducts,
        allFilterExcludedProducts: allFilterExcludedProducts,
        thirdPartyConfigs: thirdPartyConfigs,
        currentUserId: currentUserId,
        jsmIncidentFilterIds: jsmIncidentFilterIds
    });
    return {
        selectedProducts: selectedProducts,
        ...selectedFilters
    };
};


const $ee9a789ba0acc902$export$cd3c83311f418ff4 = ({ queryParams: queryParams })=>{
    if (!queryParams) return {
        searchQuery: '',
        originalQuery: undefined
    };
    const searchQuery = queryParams?.text ?? '';
    const originalQuery = queryParams?.originalQuery;
    return {
        searchQuery: searchQuery,
        originalQuery: originalQuery
    };
};


/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ /**
 * Utility for resolving the `__relay_internal__pv__*` provided variables
 * required by the search-results persisted query.
 *
 * Non-Relay callers (e.g. SSR preload helpers that POST persisted queries
 * directly to AGG) must include these variables in their request body to
 * satisfy the gateway's `Boolean!` NonNull declarations. Historically those
 * callers duplicated the keys as a static map, which silently drifts from
 * the live `.relayprovider` evaluations performed inside the Relay
 * environment.
 *
 * This module is the single source of truth for that resolution. It calls
 * each provider's `get()` at invocation time so feature-gate / experiment
 * results are picked up at runtime (including during SSR, on the
 * assumption that the underlying feature gates are SSR-evaluable). The
 * shape of the returned map is pinned to the generated query artifact by
 * `index.relay-provided-variables.test.ts`.
 *
 * SSR Safety: This function is synchronous, contains no React hooks, and
 * does not touch browser-only globals directly. Each provider's `get()`
 * implementation must uphold the same contract.
 */ 
var $5SuoG = parcelRequire("5SuoG");


var $aqtD4 = parcelRequire("aqtD4");


var $4PNBt = parcelRequire("4PNBt");


var $iLuVY = parcelRequire("iLuVY");

const $8a72a7af1eb7b223$export$722bffef5ff5d4b4 = ()=>({
        __relay_internal__pv__isassetsenabledrelayprovider: (0, $5SuoG.default).get(),
        __relay_internal__pv__iscustomerorgownersenabledrelayprovider: (0, $aqtD4.default).get(),
        __relay_internal__pv__isdealownersenabledrelayprovider: (0, $4PNBt.default).get(),
        __relay_internal__pv__isslacktopreactionenabledrelayprovider: (0, $iLuVY.default).get()
    });


const $dcbc1c19e076ebdf$export$b83d7680b0db727d = ({ backendExperimentOverrides: backendExperimentOverrides, cloudId: cloudId, experimentLayers: rawExperimentLayers, experience: experience, isJiraIssueIndexed: isJiraIssueIndexed, jsmIncidentFilterIds: jsmIncidentFilterIds, primaryProduct: primaryProduct, productDataRegions: productDataRegions, productEdition: productEdition, products: products, queryParams: queryParams, sessionId: rawSessionId, searchSessionId: rawSearchSessionId, thirdPartyConfigs: thirdPartyConfigs, user: user, onError: onError, getLayerValuesFn: getLayerValuesFn, expectResult: expectResult = true, isLiteMode: isLiteMode = false })=>{
    const { originalQuery: originalQuery, searchQuery: searchQuery } = (0, $ee9a789ba0acc902$export$cd3c83311f418ff4)({
        queryParams: queryParams
    });
    const searchableProducts = $dcbc1c19e076ebdf$var$getSearchableProducts(searchQuery, products);
    const { entities: entities, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedFilters: selectedFilters, selectedProducts: selectedProducts, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters } = (0, $46dd28b200fb61b5$export$8a04e6ddedd0bb29)({
        allFilterExcludedProducts: (0, $5iakG.ALL_FILTER_EXCLUDED_PRODUCTS),
        availableProducts: products,
        cloudId: cloudId,
        currentUserId: user?.id,
        jsmIncidentFilterIds: jsmIncidentFilterIds,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { assetsFilters: assetsFilters, commonFilters: commonFilters, compassFilters: compassFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, sortFilters: sortFilters, talentFilters: talentFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const { experimentId: experimentId, experimentLayers: experimentLayers, shadowExperimentId: shadowExperimentId, fanoutExperimentCohort: fanoutExperimentCohort, backendExperiment: backendExperiment } = (0, $30a294c49652f998$export$8c6fefe9b6b2ccd8)({
        backendExperimentOverrides: backendExperimentOverrides,
        cloudId: cloudId,
        entities: entities,
        experimentLayers: rawExperimentLayers,
        experienceLayer: experience,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        isJiraIssueIndexed: isJiraIssueIndexed,
        onError: onError,
        primaryProduct: primaryProduct,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        selectedProducts: products,
        thirdPartyFilters: selectedFilters.thirdPartyFilters,
        getLayerValuesFn: getLayerValuesFn
    });
    const requestHeaders = {
        [(0, $chwej.EDGE_REGION_HINT_HEADER)]: primaryProduct && productDataRegions ? (0, $chwej.getEdgeRegionHint)(primaryProduct, productDataRegions) : undefined
    };
    const sharedQueryVariables = {
        cloudIdARI: (0, $2GQhu.getCloudIdARI)(cloudId, primaryProduct),
        commonFilters: commonFilters,
        compassFilters: compassFilters,
        confluenceFilters: confluenceFilters,
        disableQueryReplacement: !!originalQuery,
        entities: entities,
        experience: experience,
        jiraFilters: jiraFilters,
        limit: $dcbc1c19e076ebdf$var$getLimit(entities),
        mercuryFilters: mercuryFilters,
        query: searchQuery,
        queryVersion: 1,
        searchSessionId: rawSearchSessionId,
        sessionId: rawSessionId,
        sort: sortFilters,
        sourceProduct: primaryProduct,
        tenantId: cloudId,
        thirdPartyFilters: thirdPartyFilters,
        ...(0, $dh538.fg)('assets_rovo_search_all') ? {
            assetsFilters: assetsFilters
        } : {},
        ...(0, $dh538.fg)('talent_global_search') ? {
            talentFilters: talentFilters
        } : {}
    };
    const searchResultsQueryVariables = {
        ...sharedQueryVariables,
        expectResult: expectResult,
        /**
		 * Highlighting is only useful for results
		 */ enableHighlighting: true,
        experimentId: /**
		 * Experimentation is only valid in results section. Note that experiments
		 * can differ based on selected entites/products, so if we include experiments
		 * in counts, the counts will change as filters change
		 */ experimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId,
                definitions: definitions
            })),
        fanoutExperimentCohort: fanoutExperimentCohort,
        includeAssigneeField: (0, $dh538.fg)('rovo_search_assignee_field_fps'),
        includeGithubCode: selectedProducts.length === 1 && (0, $b4tvS.GITHUB_PRODUCT_KEYS).includes(selectedProducts[0]) && (0, $dh538.fg)('rovo_github_code_search'),
        includeJiraLiteModeFields: isLiteMode && selectedProducts.some((product)=>(0, $22zVp.isJiraProduct)(product, true)),
        includeIconUrl: (0, $dh538.fg)('rovo_search_confluence_icons_fps'),
        includeNavBoostScore: (0, $dh538.fg)('kd_enable_nav_boost_score'),
        includePassionfruitAsk: (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled'),
        includePositions: (0, $dh538.fg)('talent_global_search'),
        includeThirdPartyId: (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
            fireExperimentExposure: false
        }),
        includeReactionsAndCommentCount: (0, $dh538.fg)('rovo_fps_graph_like_comment_count'),
        shadowExperimentId: shadowExperimentId,
        thirdPartyFilters: thirdPartyFilters
    };
    const rightPanelQueryVariables = {
        ...sharedQueryVariables,
        expectResult: expectResult,
        /**
		 * Counts searches for approx all entities (see getSelectedFilters for edge cases)
		 */ entities: entitiesForResultsCountQuery,
        /**
		 * We need to search for all Jira product types to support counts in Jira/JSM/JPD correctly
		 */ jiraFilters: (0, $389fa27b7e70fb9c$export$62c31c0f13603e08)(jiraFilters, searchableProducts),
        limit: 0,
        sort: [],
        thirdPartyFilters: unselectedProductsThirdPartyFilters
    };
    /**
	 * Relay uses the entire variables objects as a cache key. For this reason,
	 * when making the same search request, we need to ensure we retrieve the
	 * same sessionId and searchSessionId. We do this by caching these ids
	 * and retrieving them using the variables object excluding the ids as a cache key.
	 */ const [searchResultsQuerySessionId, searchResultsQuerySearchSessionId] = (0, $8ec58c33150c42f9$export$8b9832780ea0337b)(searchResultsQueryVariables);
    searchResultsQueryVariables.sessionId = searchResultsQuerySessionId;
    searchResultsQueryVariables.searchSessionId = searchResultsQuerySearchSessionId;
    const [rightPanelQuerySessionId, rightPanelQuerySearchSessionId] = (0, $8ec58c33150c42f9$export$8b9832780ea0337b)(rightPanelQueryVariables);
    rightPanelQueryVariables.sessionId = rightPanelQuerySessionId;
    rightPanelQueryVariables.searchSessionId = rightPanelQuerySearchSessionId;
    const searchResultsQueryRelayProvidedVariables = (0, $8a72a7af1eb7b223$export$722bffef5ff5d4b4)();
    return {
        backendExperiment: backendExperiment,
        requestHeaders: requestHeaders,
        rightPanelQueryVariables: rightPanelQueryVariables,
        searchResultsQueryRelayProvidedVariables: searchResultsQueryRelayProvidedVariables,
        searchResultsQueryVariables: searchResultsQueryVariables
    };
};
const $dcbc1c19e076ebdf$var$getLimit = (entities)=>{
    return entities.length === (0, $idpYy.getDefaultEntityAti)().length ? (0, $idpYy.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $idpYy.RESULT_LIMIT_FOR_SINGLE_PRODUCT);
};
const $dcbc1c19e076ebdf$var$getSearchableProducts = (searchQuery, products)=>{
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    return products.filter((product)=>!isEmptyQuery || (0, $b4tvS.productsSupportingEmptyQuery).includes(product));
};
module.exports["generateSearchInputs"] = $dcbc1c19e076ebdf$export$b83d7680b0db727d;

});

parcelRegister("lRrav", function(module, exports) {

var $fXT59 = parcelRequire("fXT59");

const $c845c336f40b6e62$export$e9ddc0ee913bbcbd = (0, $fXT59.disposableValue)();
module.exports["SEARCH_SESSION_ID"] = $c845c336f40b6e62$export$e9ddc0ee913bbcbd;

});

parcelRegister("74x1m", function(module, exports) {

var $lIbf3 = parcelRequire("lIbf3");

/**
 * Lightweight filter data for query generation.
 * Constructs minimal filter objects without importing filter definition files,
 * avoiding transitive deps on smart-user-picker, @atlaskit/select, react-dom etc.
 *
 *
 */ 
var $b4tvS = parcelRequire("b4tvS");

/**
 * Pure function to get 3P product keys for a given filter ID.
 * Uses pre-computed static mapping instead of ThirdPartyConfigs
 * to avoid importing React icon components.
 */ 
var $hdfeV = parcelRequire("hdfeV");

const $bf14b8f874413f2b$export$ef6dfb919b1d7267 = (filterId)=>{
    return (0, $hdfeV.thirdPartyFilterProducts)[filterId] ?? [];
};



var $cxQs0 = parcelRequire("cxQs0");


var $6Ea6j = parcelRequire("6Ea6j");


var $cOUgi = parcelRequire("cOUgi");


var $ILLS9 = parcelRequire("ILLS9");


var $jreQ3 = parcelRequire("jreQ3");


var $cSPiD = parcelRequire("cSPiD");


var $5jwMp = parcelRequire("5jwMp");

// Helper product arrays
const $e92713e1ce621101$var$confluenceProducts = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $e92713e1ce621101$var$jiraProducts = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $e92713e1ce621101$var$assetsProducts = [
    (0, $b4tvS.ProductKeys).Assets
];
const $e92713e1ce621101$var$mercuryProducts = [
    (0, $b4tvS.ProductKeys).Focus
];
const $e92713e1ce621101$var$talentProducts = [
    (0, $b4tvS.ProductKeys).Talent
];
const $e92713e1ce621101$var$contributorProducts = (0, $b4tvS.all1pProductKeys).filter((key)=>key !== (0, $b4tvS.ProductKeys).Trello && key !== (0, $b4tvS.ProductKeys).Focus && key !== (0, $b4tvS.ProductKeys).Talent);
const $e92713e1ce621101$var$contributor3P = (0, $b4tvS.all3pProductKeys).filter((key)=>key !== (0, $b4tvS.ProductKeys3P).Figma);
const $e92713e1ce621101$export$e8343e733de21ab3 = {
    lastUpdated: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'lastUpdated',
        products: [
            (0, $b4tvS.ProductKeys).Atlas,
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Focus,
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement,
            (0, $b4tvS.ProductKeys).Compass,
            (0, $b4tvS.ProductKeys).Trello,
            (0, $b4tvS.ProductKeys).Bitbucket,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('lastUpdated')
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'lastModified',
            generateQueryParamsGetState: (0, $ILLS9.generateQueryParamsGetState)
        }
    }),
    contributor: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'contributor',
        products: [
            ...$e92713e1ce621101$var$contributorProducts,
            ...$e92713e1ce621101$var$contributor3P
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'contributors'
        }
    }),
    space: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'space',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('space')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'spaces'
        }
    }),
    watchedByMe: (0, $cxQs0.createBooleanFilter)({
        id: 'watchedByMe',
        products: [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jWatchedByMe'
        }
    }),
    verified: (0, $cxQs0.createBooleanFilter)({
        id: 'verified',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('verified')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'verified'
        }
    }),
    assignee: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'assignee',
        products: [
            ...$e92713e1ce621101$var$jiraProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('assignee')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'jAssignee'
        }
    }),
    reporter: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'reporter',
        products: [
            ...$e92713e1ce621101$var$jiraProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('reporter')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'jReporter'
        }
    }),
    commentedByMe: (0, $cxQs0.createBooleanFilter)({
        id: 'commentedByMe',
        products: [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('commentedByMe')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jCommentedByMe'
        }
    }),
    project: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'project',
        products: [
            ...$e92713e1ce621101$var$jiraProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('project')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jProject',
            generateQueryParamsGetState: (0, $5jwMp.generateQueryParamsGetState)
        }
    }),
    universalTypeFilter: (0, $cOUgi.createSingleSelectFilter)({
        id: 'universalTypeFilter',
        products: [
            ...(0, $b4tvS.all1pProductKeys),
            ...(0, $b4tvS.all3pProductKeys)
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'type'
        }
    }),
    content: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'content',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('content')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'ancestor'
        }
    }),
    onlyTitleMatch: (0, $cxQs0.createBooleanFilter)({
        id: 'onlyTitleMatch',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('onlyTitleMatch')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'titleMatch'
        }
    }),
    owner: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'owner',
        products: [
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Focus,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('owner')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'owners'
        }
    }),
    createdBy: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'createdBy',
        products: [
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('createdBy')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'createdBy'
        }
    }),
    label: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'label',
        products: [
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'labels'
        }
    }),
    focusAreaType: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'focusAreaType',
        products: [
            ...$e92713e1ce621101$var$mercuryProducts
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'focusAreaTypes'
        }
    }),
    focusAreaUnder: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'focusAreaUnder',
        products: [
            ...$e92713e1ce621101$var$mercuryProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'focusAreaUnder'
        }
    }),
    pageStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'pageStatus',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'pageStatus',
            generateQueryParamsGetState: (0, $jreQ3.generateQueryParamsGetState)
        }
    }),
    archived: (0, $cxQs0.createBooleanFilter)({
        id: 'archived',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('archived')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'archived'
        }
    }),
    lastUpdatedBy: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'lastUpdatedBy',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce,
            (0, $b4tvS.ProductKeys).Hubspot
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'lastUpdatedBy'
        }
    }),
    statusFilter: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'statusFilter',
        products: [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('statusFilter')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'status'
        }
    }),
    compassArchived: (0, $cxQs0.createBooleanFilter)({
        id: 'compassArchived',
        products: [
            (0, $b4tvS.ProductKeys).Compass
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'compassArchived'
        }
    }),
    assetsSchema: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'assetsSchema',
        products: [
            ...$e92713e1ce621101$var$assetsProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'assetsSchema'
        }
    }),
    assetsType: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'assetsType',
        products: [
            ...$e92713e1ce621101$var$assetsProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'assetsType'
        }
    }),
    positionStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionStatus',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionStatuses'
        }
    }),
    positionEmploymentType: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionEmploymentType',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionEmploymentTypes'
        }
    }),
    positionJobFamily: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionJobFamily',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionJobFamilies'
        }
    }),
    positionTeam: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionTeam',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionTeams',
            generateQueryParamsGetState: (0, $cSPiD.generateQueryParamsGetState)
        }
    }),
    positionFocusArea: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionFocusArea',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionFocusAreas'
        }
    }),
    opportunityStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'opportunityStatus',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'opportunityStatus'
        }
    }),
    campaignStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'campaignStatus',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'campaignStatuses'
        }
    }),
    caseStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'caseStatus',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'caseStatuses'
        }
    }),
    sort: (0, $cOUgi.createSingleSelectFilter)({
        id: 'sort',
        products: [
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Jira
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'sort'
        }
    }),
    salesforceStage: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'salesforceStage',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'salesforceStages'
        }
    }),
    closeDate: (0, $cOUgi.createSingleSelectFilter)({
        id: 'closeDate',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'closeDate'
        }
    }),
    pullRequestStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'pullRequestStatus',
        products: [
            (0, $b4tvS.ProductKeys).Bitbucket,
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('pullRequestStatus')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'pullRequestStatus'
        }
    }),
    repository: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'repository',
        products: [
            ...(0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('repository')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'repository'
        }
    }),
    slackChannel: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'slackChannel',
        products: (0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('slackChannel'),
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'slackChannels'
        }
    }),
    hasAttachment: (0, $cxQs0.createBooleanFilter)({
        id: 'hasAttachment',
        products: (0, $bf14b8f874413f2b$export$ef6dfb919b1d7267)('hasAttachment'),
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'hasAttachment'
        }
    })
};



var $6l1Qf = parcelRequire("6l1Qf");

const $6a365e752c0347e7$export$2e9655e8b4177582 = ({ cloudId: cloudId, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs })=>{
    // Parse query params so they're typed more strongly
    const parsedQueryParams = (0, $lIbf3.parseQueryParams)(queryParams);
    const { lastModified_lt: _, lastModified_gt: __, ...parsedQueryParamsInUse } = parsedQueryParams;
    const queryParamsWithValuesAsStringArray = (0, $lIbf3.convertQueryParamsToStringArray)(parsedQueryParamsInUse, Object.keys(parsedQueryParams));
    // Get utilities for processing query params into filters
    const { getSelectedProducts: getSelectedProducts } = (0, $6l1Qf.FilterUtils)((0, $e92713e1ce621101$export$e8343e733de21ab3), {});
    // Get selected products from query params
    const selectedProducts = getSelectedProducts(queryParams);
    // Get minimal filters object containing selected values based on query params
    const filters = Object.fromEntries(Object.entries((0, $e92713e1ce621101$export$e8343e733de21ab3)).map(([filterId, filter])=>{
        return [
            filterId,
            filter.queryParams.getState(queryParamsWithValuesAsStringArray, cloudId)
        ];
    }));
    // Get selected datasource
    const selectedDatasource = (0, $lIbf3.getDatasourceFromId)(parsedQueryParams.datasource, selectedProducts[0], thirdPartyConfigs);
    return {
        cql: parsedQueryParams.cql,
        searchQuery: parsedQueryParams.text || '',
        originalQuery: parsedQueryParams.originalQuery,
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource
    };
};
module.exports["getSearchConfig"] = $6a365e752c0347e7$export$2e9655e8b4177582;

});

parcelRegister("gbTNF", function(module, exports) {
const $403fcd9fe22bce08$export$f09e972bbd9c2e = ({ cloudId: cloudId, primaryProduct: primaryProduct, activationId: activationId, locale: locale, orgId: orgId, query: query })=>{
    const product = primaryProduct || '';
    const siteId = primaryProduct === 'jira' ? `ari:cloud:jira-software::site/${cloudId}` : `ari:cloud:${product}::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : '';
    return {
        query: query,
        siteId: siteId,
        locale: locale,
        orgId: orgId ?? '',
        workspaceId: workspaceId,
        cloudId: cloudId,
        product: product
    };
};
module.exports["buildIntentDetectionVariables"] = $403fcd9fe22bce08$export$f09e972bbd9c2e;

});

parcelRegister("5w7WU", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");







function $b48bc080623d26d3$export$7542d9981bb876f9(query) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $f7lNm.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $f7lNm.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return {
        queryIntent: (0, $f7lNm.QueryIntent).AGENT,
        transformedQuery: query.replace(' agent', '').replace(' Agent', '')
    };
}





const $e8b8727e3edb8560$export$6c52de753cb858f8 = 'KnowledgeDiscoveryIntentDetectionQuery';
const $e8b8727e3edb8560$export$12788ba4bf4fbd92 = `
    ... on KnowledgeDiscoveryBookmarkIntent {
        __typename
        bookmark {
            id
            url
            title
            description
            keyPhrase
            bookmarkState
            lastModifierAccountId
            lastModifiedTimestamp
            parentAdminhubBookmarkId
        }
    }
`;
const $e8b8727e3edb8560$export$6f87cad788b6beba = `
	... on KnowledgeDiscoveryPersonIntent {
		__typename
		persons {
			accountId
			name
			email
			picture
			jobTitle
			department
			organization
			location
			zoneInfo
		}
	}
`;
const $e8b8727e3edb8560$export$5cc310960e46a388 = `
	... on KnowledgeDiscoveryNavContentIntent {
		__typename
		url
		title
		createdAt
	}
`;
const $e8b8727e3edb8560$export$8145deeb4e892b30 = ()=>`
	query KnowledgeDiscoveryIntentDetectionQuery(
		$siteId: String!
		$query: String!
		$locale: String!
		$orgId: String!
	) {
		knowledgeDiscovery {
			intentDetection(locale: $locale, orgId: $orgId, query: $query, siteId: $siteId) {
				... on KnowledgeDiscoveryIntentDetectionSuccess {
					__typename
					errors {
						errorType
						statusCode
					}
					detectionMetadata {
						cacheHit
						latencyMs
						method
						model
						timestamp
						entityMetadata {
							entityCount
							entityType
						}
					}
					intent {
						classification
						detectionType
						subTypes
						transformedQuery
						... on KnowledgeDiscoveryJiraIntent {
							__typename
						}
						... on KnowledgeDiscoveryKeywordOrAcronymIntent {
							__typename
						}
						... on KnowledgeDiscoveryNaturalLanguageIntent {
							__typename
						}
						... on KnowledgeDiscoveryNoneIntent {
							__typename
						}
						... on KnowledgeDiscoveryPersonIntent {
							__typename
						}
						... on KnowledgeDiscoveryTeamIntent {
							__typename
						}
						... on KnowledgeDiscoveryTopicIntent {
							__typename
						}
						... on KnowledgeDiscoveryNavigationalIntent {
							__typename
						}
						... on KnowledgeDiscoveryOrgChartIntent {
							__typename
						}
						${(0, $dh538.fg)('kd_enable_sain_hero_nav') ? $e8b8727e3edb8560$export$5cc310960e46a388 : ''}
						${(0, $dh538.fg)('kd_bookmark_query_intent') ? $e8b8727e3edb8560$export$12788ba4bf4fbd92 : ''}
						${(0, $dh538.fg)('kd_fe_persons_intent_detection_els') ? $e8b8727e3edb8560$export$6f87cad788b6beba : ''}
					}
				}
			}
		}
	}
`;


// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $8ad1f7056bd8c98a$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
const $8ad1f7056bd8c98a$export$c16051a8e758ff55 = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, setIntentData: setIntentData, setRequestId: setRequestId, setTraceId: setTraceId, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $f7lNm.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getQueryIntent: handleError'
        });
    };
    try {
        const frontendQueryIntent = (0, $b48bc080623d26d3$export$7542d9981bb876f9)(query);
        // Intent from the frontend has a higher priority than the BE
        // Add any experiment and gate exclusion logic in `getFrontendQueryIntent` to prevent messy conditionals in this function
        if (!!frontendQueryIntent) {
            setQueryIntent(frontendQueryIntent.queryIntent);
            setTransformedQuery(frontendQueryIntent.transformedQuery);
            return;
        }
        const aggResponse = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $e8b8727e3edb8560$export$8145deeb4e892b30)(),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $e8b8727e3edb8560$export$6c52de753cb858f8),
            // we're using the cache to make sure the number of calls remain the same
            // make sure the cache key format is different from the actual intent detection call
            cache: {
                ttl: 300000,
                key: `shadow-intent-detection-${query}`
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        // Trace / request IDs from the gateway HTTP response (for analytics and debugging).
        const gatewayTracingHeaders = aggResponse.gatewayTracingHeaders ?? {};
        const response = aggResponse?.data?.knowledgeDiscovery.intentDetection;
        if (!response || !aggResponse?.data || aggResponse?.errors && aggResponse?.errors.length > 0 || response?.errors && response?.errors.length > 0) {
            // errors show up at the top level or in the response
            let errorMessage = aggResponse?.errors?.[0]?.message;
            if (response?.errors && response?.errors.length > 0) errorMessage = response?.errors?.[0]?.message;
            const error = errorMessage ? new Error(errorMessage) : new Error('getQueryIntent error');
            handleError(error);
            return;
        }
        // Intent from the BE
        let queryIntent = response.intent?.classification;
        if (queryIntent === (0, $f7lNm.QueryIntent).VISUAL && !(0, $dh538.fg)('hybrid_orchestrator_enable_image_search')) queryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
        if (queryIntent === (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY && selectedProduct && !$8ad1f7056bd8c98a$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $dh538.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) queryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
        setQueryIntent(queryIntent);
        setTransformedQuery(response.intent?.transformedQuery);
        setIntentData?.(response.intent);
        setRequestId(gatewayTracingHeaders['atl-request-id'] ?? '');
        setTraceId?.(gatewayTracingHeaders['x-trace-id'] ?? '');
    } catch (error) {
        handleError(error);
    }
};
module.exports["getQueryIntent"] = $8ad1f7056bd8c98a$export$c16051a8e758ff55;

});

parcelRegister("3LDzU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $dPJCf = parcelRequire("dPJCf");

const $e1bacc011ec444be$export$b6ea13c37acfe578 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    // Immediate runtime guard for non-initial-load mode.
    const isTransitionRef = (0, $42omo.useRef)(isTransition);
    isTransitionRef.current = isTransition;
    // Sticky provider-local retirement flag for explicitly consumed preload data.
    const clearedRef = (0, $42omo.useRef)(false);
    return (0, $42omo.useMemo)(()=>({
            getPreloadedSearch: ({ cloudId: requestedCloudId })=>{
                // When rovo_search_preload_from_quick_find_using_async is on, we relax two
                // previously-strict guards so the preloaded payload can be reused to warm up
                // Quick Find:
                //   1. We no longer bail out during route transitions.
                //   2. We no longer prevent the payload from being returned after it has been
                //      explicitly consumed (the `clearedRef` flag). The consumer (search-page)
                //      is now responsible for clearing it at the right times.
                if (!(0, $6mKj3.expVal)('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false) && isTransitionRef.current) return null;
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                if (!preloadedSearch || preloadedSearch.cloudId !== requestedCloudId) return null;
                if (!(0, $6mKj3.expVal)('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false) && clearedRef.current) return null;
                return preloadedSearch;
            },
            clearPreloadedSearch: ({ cloudId: requestedCloudId })=>{
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                if (preloadedSearch?.cloudId === requestedCloudId) {
                    if ((0, $6mKj3.expVal)('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false)) window.__PRELOADED_SEARCH__ = undefined;
                    clearedRef.current = true;
                }
            }
        }), []);
};
module.exports["usePreloadDataProvider"] = $e1bacc011ec444be$export$b6ea13c37acfe578;

});

parcelRegister("fl27B", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8beafb504c666551$export$f68d29dbb4f2da82 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.7923 27.2286H11.0183C6.83464 27.2286 3.83331 24.666 3.83331 20.9137H18.749C19.5221 20.9137 20.0223 21.4628 20.0223 22.2407V37.25C16.2934 37.25 13.7923 34.2299 13.7923 30.0199V27.2286ZM21.1592 19.7697H18.3852C14.2015 19.7697 11.2002 17.2529 11.2002 13.5006H26.1159C26.889 13.5006 27.4347 14.0039 27.4347 14.7819V29.7911C23.7058 29.7911 21.1592 26.771 21.1592 22.5611V19.7697ZM28.5715 12.3566H25.7976C21.6139 12.3566 18.6126 9.79401 18.6126 6.04169H33.5283C34.3014 6.04169 34.8016 6.59081 34.8016 7.32297V22.3323C31.0727 22.3323 28.5715 19.3121 28.5715 15.1022V12.3566Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "30.9683",
        height: "31.2083",
        fill: "white",
        transform: "translate(3.83331 6.04169)"
    }))));
module.exports["JiraSearchResultIcon"] = $8beafb504c666551$export$f68d29dbb4f2da82;

});

parcelRegister("bj3ok", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfcfcba5660e06b1$export$ceeb1de9ca56c2f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.4886 16.3121H32.6441C34.0191 16.3121 34.4886 17.62 33.6502 18.6596L19.3301 36.3334C14.702 32.6444 15.138 26.809 18.5252 22.5499L23.4886 16.3121ZM16.4124 23.3547H7.2569C5.8819 23.3547 5.41238 22.0468 6.2508 21.0072L20.5709 3.3334C25.199 7.02243 24.6959 12.7907 21.3423 17.0834L16.4124 23.3547Z",
        fill: "#0C66E4"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "28.2341",
        height: "33",
        fill: "white",
        transform: "translate(5.83331 3.33334)"
    }))));
module.exports["JiraServiceManagementSearchResultIcon"] = $dfcfcba5660e06b1$export$ceeb1de9ca56c2f7;

});

parcelRegister("1A1pg", function(module, exports) {
const $1640c23772407797$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $1640c23772407797$export$d520529b4595d46c;

});

parcelRegister("1OY0Y", function(module, exports) {
const $e429436ebdc8254b$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
module.exports["DEFAULT_ATLAS_ENTITY_ATI"] = $e429436ebdc8254b$export$c87d62ed9387fa60;

});

parcelRegister("hCmMX", function(module, exports) {
const $25855452e6a3f72a$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard'
];
module.exports["DEFAULT_CONFLUENCE_ENTITY_ATI"] = $25855452e6a3f72a$export$c07a1c127052b557;

});

parcelRegister("6PclE", function(module, exports) {
const $1e6d2dee651e75e6$export$e5280e1b46081838 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
module.exports["DEFAULT_MERCURY_ENTITY_ATI"] = $1e6d2dee651e75e6$export$e5280e1b46081838;

});

parcelRegister("kO4OQ", function(module, exports) {
const $38dd6041711f0598$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];
module.exports["DEFAULT_TALENT_ENTITY_ATI"] = $38dd6041711f0598$export$368c06447ee18b39;

});

parcelRegister("11scr", function(module, exports) {
const $ea54211bc228c210$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $ea54211bc228c210$export$8bd7fa13a82672fe;

});

parcelRegister("fRYrB", function(module, exports) {
const $5f783b047c89af7e$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $5f783b047c89af7e$export$a752b216a5b9069f;

});

parcelRegister("iUN2Z", function(module, exports) {
const $7a5f79797f03d7b4$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $7a5f79797f03d7b4$export$9d37c36d8b43baee;

});

parcelRegister("aVIh8", function(module, exports) {
const $28de66e1dd019d10$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $28de66e1dd019d10$export$a3d7cddace4fe237;

});

parcelRegister("k8y62", function(module, exports) {
const $7a01bb01e0257cf1$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $7a01bb01e0257cf1$export$1e3b02869b42f77a;

});

parcelRegister("3ZVQ6", function(module, exports) {
const $74389bea3b69a3f2$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $74389bea3b69a3f2$export$4e0eae9edc1a8907;

});

parcelRegister("6aYi6", function(module, exports) {
const $a0e56874fd1462e4$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $a0e56874fd1462e4$export$1dc2d469fb044d48;

});

parcelRegister("kllKt", function(module, exports) {
const $b28ad32a2372c120$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $b28ad32a2372c120$export$733c2acb2513a07a;

});

parcelRegister("e8tw2", function(module, exports) {
const $db37f277307123b1$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $db37f277307123b1$export$3e5409bef2addb56;

});

parcelRegister("lgIW7", function(module, exports) {
const $886c652a64610792$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $886c652a64610792$export$7bf025ec33e76761;

});

parcelRegister("3q5AZ", function(module, exports) {
const $45b5441ccea21c41$export$3f89e5cd56d4a568 = [
    'ati:cloud:graph:project'
];
module.exports["DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI"] = $45b5441ccea21c41$export$3f89e5cd56d4a568;

});

parcelRegister("7sFsr", function(module, exports) {
const $a43ad3f4ba96be72$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $a43ad3f4ba96be72$export$13c55dcee8605c46;

});

parcelRegister("c8e62", function(module, exports) {
const $d18e062ce16cbe00$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $d18e062ce16cbe00$export$8dd471de1c2be682;

});

parcelRegister("aIjYQ", function(module, exports) {
const $0fe72986cdcce81d$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $0fe72986cdcce81d$export$5794851cbc8ee193;

});

parcelRegister("hLHb5", function(module, exports) {
const $04cdaf50b3ebafd8$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $04cdaf50b3ebafd8$export$f752f74515f17189;

});

parcelRegister("hahVW", function(module, exports) {
const $897f4c47f9705fd7$export$fedd20c53936ae44 = [
    'ati:cloud:graph:customer-contact'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI"] = $897f4c47f9705fd7$export$fedd20c53936ae44;

});

parcelRegister("k8S4l", function(module, exports) {
const $02cf94efd54591bf$export$2b1dc2787f647e40 = [
    'ati:cloud:graph:campaign'
];
module.exports["DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI"] = $02cf94efd54591bf$export$2b1dc2787f647e40;

});

parcelRegister("gtIrp", function(module, exports) {
const $56c6ba5c73f4d144$export$47853cd30a48f750 = [
    'ati:cloud:graph:case'
];
module.exports["DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI"] = $56c6ba5c73f4d144$export$47853cd30a48f750;

});

parcelRegister("cMqgY", function(module, exports) {

var $9d9t8 = parcelRequire("9d9t8");

const $b06d033aa144f952$export$79bcc0c5693292a1 = (thirdPartyConfigs)=>{
    return thirdPartyConfigs?.slack?.connectorSources?.includes((0, $9d9t8.FEDERATED_CONNECTOR_SOURCE)) ?? false;
};
module.exports["isSlackFederatedByConnectorSyncType"] = $b06d033aa144f952$export$79bcc0c5693292a1;

});

parcelRegister("55aR8", function(module, exports) {
const $4bbc408b7ad2b7dd$export$5f3101fcfc6eab72 = (value)=>{
    return typeof value === 'boolean';
};
module.exports["jiraNINFpsNLQBooleanValidator"] = $4bbc408b7ad2b7dd$export$5f3101fcfc6eab72;

});

parcelRegister("1ks6T", function(module, exports) {

var $hB77E = parcelRequire("hB77E");

const $599a9faff285cfe4$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        // add third party types for dual connectors
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    (0, $hB77E.getThirdPartyConfigs)().forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
module.exports["getThirdPartyTypes"] = $599a9faff285cfe4$export$6750011b01164bda;

});

parcelRegister("8l0cM", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $5db0f2e78f1b965f$export$1cbda5ccc2e23e06 = (0, $gLLcz.z).union([
    (0, $gLLcz.z).nativeEnum((0, $b4tvS.ProductKeys)),
    (0, $gLLcz.z).string().refine((0, $9d9t8.isForgeConnectorProductKey), (val)=>({
            message: `${val} is not a valid product key`
        }))
]);
module.exports["productKeySchema"] = $5db0f2e78f1b965f$export$1cbda5ccc2e23e06;

});

parcelRegister("ibEDi", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $793f2b8b65bcc568$export$7a844b7429919d2 = (0, $gLLcz.z).nativeEnum({
    All: 'all'
});
module.exports["allContentTypeSchema"] = $793f2b8b65bcc568$export$7a844b7429919d2;

});

parcelRegister("e9G7T", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $c499c41912d3ce5b$export$578ac6cc3cc5997a = (0, $gLLcz.z).nativeEnum({
    WorkItem: 'work-item'
});
module.exports["asanaContentTypeSchema"] = $c499c41912d3ce5b$export$578ac6cc3cc5997a;

});

parcelRegister("jg4n8", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $42d1cb8e16ae16eb$export$36d574e92bf2f0fc = (0, $gLLcz.z).nativeEnum({
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type'
});
module.exports["assetsContentTypeSchema"] = $42d1cb8e16ae16eb$export$36d574e92bf2f0fc;

});

parcelRegister("cRtk3", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $2e9594c1e5ebd349$export$ddfc756f87e8324d = (0, $gLLcz.z).nativeEnum({
    Goal: 'goal',
    Learning: 'learning',
    Project: 'project',
    Tag: 'tag'
});
module.exports["atlasContentTypeSchema"] = $2e9594c1e5ebd349$export$ddfc756f87e8324d;

});

parcelRegister("flB9e", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $dffbb087911423d3$export$ffa5bf38ea9a76ee = (0, $gLLcz.z).enum([
    'true',
    'false'
]).transform((x)=>x === 'true');
module.exports["booleanSchema"] = $dffbb087911423d3$export$ffa5bf38ea9a76ee;

});

parcelRegister("eXG0s", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $1ccf9b93f7e8cc4a$export$236bfa8a18b6097 = (0, $gLLcz.z).string().transform((x)=>x.split(','));
module.exports["commaSeparatedArraySchema"] = $1ccf9b93f7e8cc4a$export$236bfa8a18b6097;

});

parcelRegister("9zSTL", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $5c405ca808d5d6ee$export$e3c670f5c4b4df75 = (0, $gLLcz.z).nativeEnum({
    Component: 'component'
});
module.exports["compassContentTypeSchema"] = $5c405ca808d5d6ee$export$e3c670f5c4b4df75;

});

parcelRegister("jfGkT", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $8539f26873b64bee$export$d872f0aa011c3a9d = (0, $gLLcz.z).nativeEnum({
    Answer: 'answer',
    Attachment: 'attachment',
    Blogpost: 'blogpost',
    Calendar: 'calendar',
    Comment: 'comment',
    Database: 'database',
    Document: 'document',
    Embed: 'embed',
    Folder: 'folder',
    Gliffy: 'gliffy',
    Page: 'page',
    Question: 'question',
    Space: 'space',
    SpaceCalendar: 'space-calendar',
    Whiteboard: 'whiteboard',
    Slide: 'slide'
});
module.exports["confluenceContentTypeSchema"] = $8539f26873b64bee$export$d872f0aa011c3a9d;

});

parcelRegister("dgPAd", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $e83270b9b8d62051$export$374297d3e3f8ca0c = (0, $gLLcz.z).nativeEnum({
    Dashboard: 'dashboard',
    DataTable: 'data-table'
});
module.exports["databricksContentTypeSchema"] = $e83270b9b8d62051$export$374297d3e3f8ca0c;

});

parcelRegister("afn43", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $24afd219931dd9d1$export$dbec9fc36dbba98b = (0, $gLLcz.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
module.exports["dropboxContentTypeSchema"] = $24afd219931dd9d1$export$dbec9fc36dbba98b;

});

parcelRegister("2TmKt", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $439a54dfc84089f2$export$f4b8db47840ea062 = (0, $gLLcz.z).nativeEnum({
    Design: 'design'
});
module.exports["figmaContentTypeSchema"] = $439a54dfc84089f2$export$f4b8db47840ea062;

});

parcelRegister("967WU", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $61a21e9ab8678d40$export$3d532d345dacbf34 = (0, $gLLcz.z).nativeEnum({
    Repository: 'repository',
    PullRequest: 'pull-request',
    Commit: 'commit',
    Branch: 'branch',
    DevopsWorkItem: 'devops-work-item'
});
module.exports["githubContentTypeSchema"] = $61a21e9ab8678d40$export$3d532d345dacbf34;

});

parcelRegister("5Y8VG", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $f9cba7c8d85b9705$export$340da7d4450f4487 = (0, $gLLcz.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Video: 'video',
    Image: 'image',
    Folder: 'folder',
    Audio: 'audio',
    Pdf: 'pdf',
    Code: 'code',
    Form: 'form',
    Notebook: 'notebook',
    WebPage: 'web-page',
    Other: 'other'
});
module.exports["googleContentTypeSchema"] = $f9cba7c8d85b9705$export$340da7d4450f4487;

});

parcelRegister("8E3qI", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $9c17499beb5e97a9$export$f63d577c43feca48 = (0, $gLLcz.z).nativeEnum({
    Deal: 'deal',
    CustomerOrg: 'customer-org'
});
module.exports["hubspotContentTypeSchema"] = $9c17499beb5e97a9$export$f63d577c43feca48;

});

parcelRegister("deFq6", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $e8200df5dcda7e20$export$e31a67e5bb829f5c = (0, $gLLcz.z).nativeEnum({
    Project: 'project',
    Incident: 'incident',
    Issue: 'issue',
    Filter: 'filter',
    Dashboard: 'dashboard',
    Board: 'board',
    Plan: 'plan',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask'
});
module.exports["jiraContentTypeSchema"] = $e8200df5dcda7e20$export$e31a67e5bb829f5c;

});

parcelRegister("er8dU", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $004f2a9052539930$export$7c078c2ec2ab4e93 = (0, $gLLcz.z).nativeEnum({
    Anytime: 'anytime',
    Today: 'today',
    Yesterday: 'yesterday',
    Past7Days: 'past7Days',
    Past30Days: 'past30Days',
    PastYear: 'pastYear',
    Custom: 'custom'
});
module.exports["lastModifiedValueSchema"] = $004f2a9052539930$export$7c078c2ec2ab4e93;

});

parcelRegister("f8qqB", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $5c3b24010b15a536$export$915266ba4ee70164 = (0, $gLLcz.z).nativeEnum({
    Video: 'video'
});
module.exports["loomContentTypeSchema"] = $5c3b24010b15a536$export$915266ba4ee70164;

});

parcelRegister("fDjwt", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $082f9a1e7339c7ae$export$3f35493c0e1fe9ec = (0, $gLLcz.z).nativeEnum({
    FocusArea: 'focus-area',
    Ask: 'ask'
});
module.exports["mercuryContentTypeSchema"] = $082f9a1e7339c7ae$export$3f35493c0e1fe9ec;

});

parcelRegister("djv4w", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $d053ea00a2d62d39$export$2d13808294fd047f = (0, $gLLcz.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Image: 'image',
    Folder: 'folder',
    Video: 'video',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Archive: 'archive',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Notebook: 'notebook',
    Other: 'other'
});
module.exports["microsoftContentTypeSchema"] = $d053ea00a2d62d39$export$2d13808294fd047f;

});

parcelRegister("7oQyb", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");


var $b4tvS = parcelRequire("b4tvS");

const $8e6d11105fae89b3$export$f3a53bd43617a593 = (0, $gLLcz.z).nativeEnum((0, $b4tvS.ProductKeys)).enum;
module.exports["ProductKey"] = $8e6d11105fae89b3$export$f3a53bd43617a593;

});

parcelRegister("373KP", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $6215e98bc667ea14$export$e7eef498de91d92 = (0, $gLLcz.z).nativeEnum({
    Deal: 'deal',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Campaign: 'campaign',
    Case: 'case'
});
module.exports["salesforceContentTypeSchema"] = $6215e98bc667ea14$export$e7eef498de91d92;

});

parcelRegister("kFuPh", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $57913084a9b66b3b$export$2414dbe41633e9e4 = (0, $gLLcz.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Comment: 'comment',
    Incident: 'incident',
    Epic: 'epic',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Project: 'project',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article'
});
module.exports["servicenowContentTypeSchema"] = $57913084a9b66b3b$export$2414dbe41633e9e4;

});

parcelRegister("l9RY2", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $8a2b503f553630fa$export$78ff7f7a3ef7dca8 = (0, $gLLcz.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
module.exports["slackContentTypeSchema"] = $8a2b503f553630fa$export$78ff7f7a3ef7dca8;

});

parcelRegister("fB9ef", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $87c398ca5f5138ed$export$ff8ed9d399173456 = (0, $gLLcz.z).nativeEnum({
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal'
});
module.exports["smartLinksContentTypeSchema"] = $87c398ca5f5138ed$export$ff8ed9d399173456;

});

parcelRegister("kM8s6", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $d24e50ebca007c4a$export$c7be2dbb4ce58b0d = (0, $gLLcz.z).nativeEnum({
    Relevance: 'relevance',
    UpdatedNewest: 'updatedNewest',
    UpdatedOldest: 'updatedOldest',
    CreatedNewest: 'createdNewest',
    CreatedOldest: 'createdOldest'
});
module.exports["sortSchema"] = $d24e50ebca007c4a$export$c7be2dbb4ce58b0d;

});

parcelRegister("anS4K", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $bd760df9eddcc52c$export$78a2f7ec9c09bf3b = (0, $gLLcz.z).nativeEnum({
    Position: 'position'
});
module.exports["talentContentTypeSchema"] = $bd760df9eddcc52c$export$78a2f7ec9c09bf3b;

});

parcelRegister("jcLLN", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $5c2cc2ffd60ee75d$export$e362a3dbc1368cf2 = (0, $gLLcz.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation',
    Video: 'video',
    Attachment: 'attachment'
});
module.exports["teamsContentTypeSchema"] = $5c2cc2ffd60ee75d$export$e362a3dbc1368cf2;

});

parcelRegister("dZ9iJ", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $3358d9f0a0b83979$export$15f07c0375d70d62 = (0, $gLLcz.z).nativeEnum({
    Board: 'board',
    Card: 'card'
});
module.exports["trelloContentTypeSchema"] = $3358d9f0a0b83979$export$15f07c0375d70d62;

});

parcelRegister("1UZgG", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $600abdeefbdc7562$export$c30d3299c2899a1f = (0, $gLLcz.z).nativeEnum({
    WebPage: 'web-page'
});
module.exports["webPageContentTypeSchema"] = $600abdeefbdc7562$export$c30d3299c2899a1f;

});

parcelRegister("2OsdU", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $56f0cf8728506f87$export$8669b3074569e564 = (0, $gLLcz.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Comment: 'comment'
});
module.exports["zendeskContentTypeSchema"] = $56f0cf8728506f87$export$8669b3074569e564;

});

parcelRegister("4JaUT", function(module, exports) {
class $467e66f9b3647ad5$export$94cd2e6f39615373 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResultsFetchError';
    }
}
module.exports["ResultsFetchError"] = $467e66f9b3647ad5$export$94cd2e6f39615373;

});

parcelRegister("lIbf3", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");

const $d1c4c8d8da3b5693$export$17d9a81ce3c86a85 = (urlSearchParams)=>{
    const queryParamsObject = Array.from(urlSearchParams.entries()).reduce((paramsObject, [paramKey, value])=>{
        return {
            ...paramsObject,
            [paramKey]: value
        };
    }, {});
    return queryParamsObject;
};
const $d1c4c8d8da3b5693$export$67c4cee80a3410cd = (queryParams, options)=>{
    const filteredParsedQueryParamEntries = Object.entries((0, $fKv9F.searchQueryParamsBaseSchema).shape).map(([key, schema])=>{
        const queryParamValue = queryParams[key];
        const parsedRawValue = schema.safeParse(queryParamValue);
        if (parsedRawValue.success || !options?.commaSeparatedValues) return [
            key,
            parsedRawValue.data
        ];
        const commaSeparatedString = Array.isArray(queryParamValue) && queryParamValue.length ? queryParamValue.join(',') : undefined;
        const parsedString = schema.safeParse(commaSeparatedString);
        return [
            key,
            parsedString.success ? parsedString.data : null
        ];
    }).filter(([_, value])=>!(value === null || value === undefined));
    const parsedQueryParams = Object.fromEntries(filteredParsedQueryParamEntries);
    const validatedQueryParams = (0, $fKv9F.searchQueryParamsValidators).reduce((queryParams, validator)=>validator(queryParams), parsedQueryParams);
    // remove assets filters
    if ((0, $dh538.fg)('asset_rovo_search_remove_filters')) {
        if ((validatedQueryParams.product === (0, $b4tvS.ProductKeys).Assets || validatedQueryParams.assetsSchema || validatedQueryParams.assetsType) && !(0, $dh538.fg)('assets_rovo_search_all')) {
            if (validatedQueryParams.product === (0, $b4tvS.ProductKeys).Assets) validatedQueryParams.product = undefined;
            validatedQueryParams.assetsSchema = undefined;
            validatedQueryParams.assetsType = undefined;
        }
    }
    return validatedQueryParams;
};
const $d1c4c8d8da3b5693$export$60eb5b58f94d0071 = (oldQueryParams, newQueryParams)=>{
    const oldQueryParamEntries = Object.entries(oldQueryParams).filter(([_, value])=>!Array.isArray(value));
    const newQueryParamEntries = Object.entries(newQueryParams).filter(([_, value])=>!Array.isArray(value));
    const oldQueryParamArrayEntries = Object.entries(oldQueryParams).filter(([_, value])=>Array.isArray(value));
    const newQueryParamArrayEntries = Object.entries(newQueryParams).filter(([_, value])=>Array.isArray(value));
    const mergedQueryStringParamKeys = [
        ...new Set([
            ...oldQueryParamArrayEntries,
            ...newQueryParamArrayEntries
        ].map(([key])=>key))
    ];
    const mergedSearchQueryArrays = mergedQueryStringParamKeys.map((key)=>{
        return [
            key,
            [
                ...new Set([
                    ...oldQueryParams[key] ?? [],
                    ...newQueryParams[key] ?? []
                ])
            ]
        ];
    });
    return {
        ...Object.fromEntries(oldQueryParamEntries),
        ...Object.fromEntries(newQueryParamEntries),
        ...Object.fromEntries(mergedSearchQueryArrays)
    };
};
const $d1c4c8d8da3b5693$export$fc8e8d0c43c32316 = (queryParams)=>{
    return Object.entries(queryParams).flatMap((queryParam)=>{
        const [key, value] = queryParam;
        if (Array.isArray(value)) return [
            [
                key,
                value.join(',')
            ]
        ];
        return [
            [
                key,
                value
            ]
        ];
    });
};
const $d1c4c8d8da3b5693$export$17404cc52c459484 = (queryParams)=>{
    const queryParamRawEntries = Object.entries(queryParams).flatMap((queryParam)=>{
        const [paramKey, value] = queryParam;
        if (value instanceof Date) {
            const dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatOptions);
            const { month: month, day: day, year: year } = Object.fromEntries(dateFormatter.formatToParts(value).map((part)=>[
                    part.type,
                    part.value
                ]));
            return [
                [
                    paramKey,
                    `${year}-${month}-${day}`
                ]
            ];
        }
        if (value === false || value === true) return [
            [
                paramKey,
                String(value)
            ]
        ];
        if (Array.isArray(value)) return [
            [
                paramKey,
                value.join(',')
            ]
        ];
        // Some query params (e.g. `overrides`) are stored as structured objects in
        // `SearchQueryStringParams` (parsed via Zod). When converting back to raw query params /
        // query string, we must serialize them.
        if (value && typeof value === 'object') return [
            [
                paramKey,
                encodeURIComponent(JSON.stringify(value))
            ]
        ];
        return [
            [
                paramKey,
                value
            ]
        ];
    }).sort(([firstKey], [secondKey])=>firstKey < secondKey ? 1 : -1);
    return Object.fromEntries(queryParamRawEntries);
};
const $d1c4c8d8da3b5693$export$249cc09c933c4d7a = (queryParams)=>{
    const sanitizedQueryParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value])=>value !== undefined));
    return new URLSearchParams($d1c4c8d8da3b5693$export$fc8e8d0c43c32316($d1c4c8d8da3b5693$export$17404cc52c459484(sanitizedQueryParams))).toString();
};
const $d1c4c8d8da3b5693$export$f30b1e6bbcaec160 = (queryParams)=>{
    return Object.fromEntries($d1c4c8d8da3b5693$export$fc8e8d0c43c32316($d1c4c8d8da3b5693$export$17404cc52c459484(queryParams)));
};
const $d1c4c8d8da3b5693$export$e247f217269cd2eb = (...queryParamArray)=>{
    const queryParamStrings = queryParamArray.map((queryParams)=>$d1c4c8d8da3b5693$export$249cc09c933c4d7a(queryParams));
    const allQueryParamsAreEqual = new Set(queryParamStrings).size === 1;
    return allQueryParamsAreEqual;
};
const $d1c4c8d8da3b5693$export$11c3edcbebb03988 = (queryParams, keys)=>{
    return keys.reduce((acc, key)=>{
        if (queryParams[key] === undefined) return acc;
        if (Array.isArray(queryParams[key])) return {
            ...acc,
            [key]: queryParams[key]
        };
        if (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'boolean') return {
            ...acc,
            [key]: [
                queryParams[key].toString()
            ]
        };
        return acc;
    }, {});
};
const $d1c4c8d8da3b5693$export$ac30e2047efa6738 = (datasourceId, selectedProduct, thirdPartyConfigs)=>{
    if (!datasourceId || !selectedProduct || !thirdPartyConfigs) return undefined;
    const productConfig = thirdPartyConfigs[selectedProduct];
    if (!productConfig?.datasources) return undefined;
    return productConfig.datasources.find((ds)=>ds.datasourceId === datasourceId);
};
module.exports["parseQueryParams"] = $d1c4c8d8da3b5693$export$67c4cee80a3410cd;
module.exports["toQueryString"] = $d1c4c8d8da3b5693$export$249cc09c933c4d7a;
module.exports["toQueryParamsRaw"] = $d1c4c8d8da3b5693$export$f30b1e6bbcaec160;
module.exports["areAllEqualQueryParams"] = $d1c4c8d8da3b5693$export$e247f217269cd2eb;
module.exports["convertQueryParamsToStringArray"] = $d1c4c8d8da3b5693$export$11c3edcbebb03988;
module.exports["getDatasourceFromId"] = $d1c4c8d8da3b5693$export$ac30e2047efa6738;

});

parcelRegister("jyecU", function(module, exports) {

var $3JX0d = parcelRequire("3JX0d");

const $40ff74c200fc8302$export$6466dd1b74ba3dff = (productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    // This early return is to appease Typescript. The typeFilter is always defined and is always single select.
    if (!typeFilter || !(typeFilter.type === 'single-select')) return {
        selectedEntities: [],
        entitiesForQuery: [],
        entitiesForResultsCountQuery: [],
        selectedTypes: []
    };
    const defaultOptionValue = typeFilter.options?.find((option)=>option.isDefault)?.value;
    const selectedTypes = typeFilter.value.filter((value)=>value !== defaultOptionValue).filter(Boolean);
    const { entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $3JX0d.getEntitiesForQuery)(productsToSearch, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts);
    return {
        selectedEntities: selectedTypes,
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        selectedTypes: selectedTypes
    };
};
module.exports["getUniversalTypeEntities"] = $40ff74c200fc8302$export$6466dd1b74ba3dff;

});

parcelRegister("gW8Zi", function(module, exports) {
const $b3199a75d32b6583$export$79cd775d0d5c2a2 = (from, to)=>{
    const fromDate = from ? new Date(from) : new Date();
    const startOfTheFromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
    const toDate = to ? new Date(to) : new Date();
    const endOfTheToDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999);
    return {
        gt: from ? startOfTheFromDate.toISOString().split('Z')[0] : undefined,
        lt: to ? endOfTheToDate.toISOString().split('Z')[0] : undefined
    };
};
module.exports["convertCustomDateToRange"] = $b3199a75d32b6583$export$79cd775d0d5c2a2;

});

parcelRegister("3baWa", function(module, exports) {
// considering the user's locale-based definition of start OR end of day
const $a12915fd6eb90535$export$8db446d8af54b4b5 = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        gt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        lt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
module.exports["getUTCDateRange"] = $a12915fd6eb90535$export$8db446d8af54b4b5;

});

parcelRegister("4tTFP", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $gW8Zi = parcelRequire("gW8Zi");


var $3baWa = parcelRequire("3baWa");


const $8bf5c543098fb1e6$export$50da93f10cdc6a84 = (lastUpdated)=>{
    let dateRangeValues;
    switch(lastUpdated){
        case 'today':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(0, 0);
            break;
        case 'yesterday':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(1, 1);
            break;
        case 'past7Days':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(7, 0);
            break;
        case 'past30Days':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(30, 0);
            break;
        case 'pastYear':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(365, 0);
            break;
        default:
            dateRangeValues = {
                gt: '',
                lt: ''
            };
    }
    return dateRangeValues;
};
const $8bf5c543098fb1e6$export$e048252fb7949a77 = (from, to)=>{
    const { gt: gt, lt: lt } = (0, $gW8Zi.convertCustomDateToRange)(from, to);
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $8bf5c543098fb1e6$export$405f2efecb6f5de6 = (selectedDateOption)=>{
    const dateRangeValues = $8bf5c543098fb1e6$export$50da93f10cdc6a84(selectedDateOption);
    const { gt: gt, lt: lt } = dateRangeValues;
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
module.exports["convertLastUpdatedToDateRange"] = $8bf5c543098fb1e6$export$50da93f10cdc6a84;
module.exports["getConfluenceDateOptionFromCustomDates"] = $8bf5c543098fb1e6$export$e048252fb7949a77;
module.exports["getConfluenceDateOptionValues"] = $8bf5c543098fb1e6$export$405f2efecb6f5de6;

});

parcelRegister("fKv9F", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");


var $bxnmj = parcelRequire("bxnmj");


var $2Znam = parcelRequire("2Znam");


var $ibEDi = parcelRequire("ibEDi");


var $e9G7T = parcelRequire("e9G7T");


var $jg4n8 = parcelRequire("jg4n8");


var $cRtk3 = parcelRequire("cRtk3");


var $flB9e = parcelRequire("flB9e");


var $eXG0s = parcelRequire("eXG0s");


var $9zSTL = parcelRequire("9zSTL");


var $jfGkT = parcelRequire("jfGkT");


var $dgPAd = parcelRequire("dgPAd");


var $afn43 = parcelRequire("afn43");


var $2TmKt = parcelRequire("2TmKt");


var $967WU = parcelRequire("967WU");


var $5Y8VG = parcelRequire("5Y8VG");


var $8E3qI = parcelRequire("8E3qI");


var $deFq6 = parcelRequire("deFq6");


var $er8dU = parcelRequire("er8dU");


var $f8qqB = parcelRequire("f8qqB");


var $fDjwt = parcelRequire("fDjwt");


var $djv4w = parcelRequire("djv4w");


var $7oQyb = parcelRequire("7oQyb");


var $8l0cM = parcelRequire("8l0cM");


var $373KP = parcelRequire("373KP");


var $kFuPh = parcelRequire("kFuPh");


var $l9RY2 = parcelRequire("l9RY2");


var $fB9ef = parcelRequire("fB9ef");


var $kM8s6 = parcelRequire("kM8s6");


var $anS4K = parcelRequire("anS4K");


var $jcLLN = parcelRequire("jcLLN");


var $dZ9iJ = parcelRequire("dZ9iJ");


var $1UZgG = parcelRequire("1UZgG");


var $2OsdU = parcelRequire("2OsdU");

const $0c3c63d3552875fa$export$ec20ab1a5eb36014 = (0, $ibEDi.allContentTypeSchema).enum;
const $0c3c63d3552875fa$export$48b648eee115c3e5 = (0, $cRtk3.atlasContentTypeSchema).enum;
const $0c3c63d3552875fa$export$721015a6e24d06a0 = (0, $e9G7T.asanaContentTypeSchema).enum;
const $0c3c63d3552875fa$export$98ac9eece9e68319 = (0, $jfGkT.confluenceContentTypeSchema).enum;
const $0c3c63d3552875fa$export$bcc0874ed7743007 = (0, $5Y8VG.googleContentTypeSchema).enum;
const $0c3c63d3552875fa$export$847712e479ca402d = (0, $djv4w.microsoftContentTypeSchema).enum;
const $0c3c63d3552875fa$export$8c76eb96ebfefeac = (0, $afn43.dropboxContentTypeSchema).enum;
const $0c3c63d3552875fa$export$e3ddf72248eaf972 = (0, $deFq6.jiraContentTypeSchema).enum;
const $0c3c63d3552875fa$export$39271a5a1b74da02 = (0, $9zSTL.compassContentTypeSchema).enum;
const $0c3c63d3552875fa$export$145fdb32ff1a4acf = (0, $fDjwt.mercuryContentTypeSchema).enum;
const $0c3c63d3552875fa$export$d493ea6967abef56 = (0, $anS4K.talentContentTypeSchema).enum;
const $0c3c63d3552875fa$export$309520b897e0c0b = (0, $dZ9iJ.trelloContentTypeSchema).enum;
const $0c3c63d3552875fa$export$d51b5367809bb96 = (0, $l9RY2.slackContentTypeSchema).enum;
const $0c3c63d3552875fa$export$c69d59ad598aee72 = (0, $jcLLN.teamsContentTypeSchema).enum;
const $0c3c63d3552875fa$export$8de16d71f5b0d410 = (0, $967WU.githubContentTypeSchema).enum;
const $0c3c63d3552875fa$export$bf86d9f770860253 = (0, $1UZgG.webPageContentTypeSchema).enum;
const $0c3c63d3552875fa$export$66f84ff942de6e1f = (0, $2TmKt.figmaContentTypeSchema).enum;
const $0c3c63d3552875fa$export$56591a3ad34d704b = (0, $f8qqB.loomContentTypeSchema).enum;
const $0c3c63d3552875fa$export$fd3bdf5548c7bf84 = (0, $2OsdU.zendeskContentTypeSchema).enum;
const $0c3c63d3552875fa$export$6b45e4ca3151b046 = (0, $fB9ef.smartLinksContentTypeSchema).enum;
const $0c3c63d3552875fa$export$9325d29d4a9658a4 = (0, $373KP.salesforceContentTypeSchema).enum;
const $0c3c63d3552875fa$export$92229a634de6b0ae = (0, $dgPAd.databricksContentTypeSchema).enum;
const $0c3c63d3552875fa$export$7c597234a357d5f7 = (0, $8E3qI.hubspotContentTypeSchema).enum;
const $0c3c63d3552875fa$export$7f83273171d63901 = (0, $kFuPh.servicenowContentTypeSchema).enum;
const $0c3c63d3552875fa$export$a08d1bf234105c9c = (0, $jg4n8.assetsContentTypeSchema).enum;
const $0c3c63d3552875fa$export$593c74387f9db963 = (0, $gLLcz.z).nativeEnum({
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014,
    ...$0c3c63d3552875fa$export$721015a6e24d06a0,
    ...$0c3c63d3552875fa$export$48b648eee115c3e5,
    ...$0c3c63d3552875fa$export$98ac9eece9e68319,
    ...$0c3c63d3552875fa$export$bcc0874ed7743007,
    ...$0c3c63d3552875fa$export$847712e479ca402d,
    ...$0c3c63d3552875fa$export$e3ddf72248eaf972,
    ...$0c3c63d3552875fa$export$39271a5a1b74da02,
    ...$0c3c63d3552875fa$export$145fdb32ff1a4acf,
    ...$0c3c63d3552875fa$export$309520b897e0c0b,
    ...$0c3c63d3552875fa$export$d51b5367809bb96,
    ...$0c3c63d3552875fa$export$c69d59ad598aee72,
    ...$0c3c63d3552875fa$export$66f84ff942de6e1f,
    ...$0c3c63d3552875fa$export$8de16d71f5b0d410,
    ...$0c3c63d3552875fa$export$56591a3ad34d704b,
    ...$0c3c63d3552875fa$export$bf86d9f770860253,
    ...$0c3c63d3552875fa$export$8c76eb96ebfefeac,
    ...$0c3c63d3552875fa$export$fd3bdf5548c7bf84,
    ...$0c3c63d3552875fa$export$6b45e4ca3151b046,
    ...$0c3c63d3552875fa$export$9325d29d4a9658a4,
    ...$0c3c63d3552875fa$export$7c597234a357d5f7,
    ...$0c3c63d3552875fa$export$92229a634de6b0ae,
    ...$0c3c63d3552875fa$export$a08d1bf234105c9c,
    ...$0c3c63d3552875fa$export$d493ea6967abef56,
    ...$0c3c63d3552875fa$export$7f83273171d63901
});
const $0c3c63d3552875fa$export$4f29dba8e623c3d1 = (0, $gLLcz.z).nativeEnum({
    ...(0, $2Znam.TypeFilterValueKey),
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014
});
const $0c3c63d3552875fa$export$e2e108cbe2e4f865 = $0c3c63d3552875fa$export$4f29dba8e623c3d1.enum;
const $0c3c63d3552875fa$export$8a9f7fff0151f0f7 = (0, $gLLcz.z).nativeEnum({
    ...(0, $bxnmj.PageStatusFilterValueKey),
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014
});
const $0c3c63d3552875fa$export$e6747eee8f26f8c0 = (0, $er8dU.lastModifiedValueSchema).enum;
const $0c3c63d3552875fa$export$d43f91ac58cde147 = (0, $kM8s6.sortSchema).enum;
const $0c3c63d3552875fa$var$jsonEncodedSchema = (schema)=>(0, $gLLcz.z).preprocess((value)=>{
        // Expected format: URL encoded JSON string
        if (typeof value === 'string') {
            let decoded = value;
            try {
                decoded = decodeURIComponent(value);
            } catch  {
            // ignore decoding errors; schema will fail if JSON is invalid
            }
            try {
                return JSON.parse(decoded);
            } catch  {
                return value;
            }
        }
        return value;
    }, schema);
const $0c3c63d3552875fa$export$37bdef1e194c0e7e = $0c3c63d3552875fa$var$jsonEncodedSchema((0, $gLLcz.z).object({
    sourceProduct: (0, $gLLcz.z).string().min(1).optional(),
    frontendFeatureGates: (0, $gLLcz.z).array((0, $gLLcz.z).object({
        name: (0, $gLLcz.z).string().min(1),
        value: (0, $gLLcz.z).boolean()
    })).optional(),
    frontendExperiments: (0, $gLLcz.z).array((0, $gLLcz.z).object({
        name: (0, $gLLcz.z).string().min(1),
        value: (0, $gLLcz.z).record((0, $gLLcz.z).union([
            (0, $gLLcz.z).string(),
            (0, $gLLcz.z).boolean()
        ]))
    })).optional(),
    backendExperiments: (0, $gLLcz.z).array((0, $gLLcz.z).object({
        name: (0, $gLLcz.z).enum([
            'search_platform_layer_l1',
            'search_platform_layer_l2',
            'search_platform_layer_l3',
            'search_platform_layer_query_expansion'
        ]),
        analyticsDefinitions: (0, $gLLcz.z).array((0, $gLLcz.z).object({
            layerId: (0, $gLLcz.z).string().nullable().optional(),
            shadowId: (0, $gLLcz.z).string().nullable().optional(),
            entity: (0, $gLLcz.z).string().nullable().optional(),
            subEntity: (0, $gLLcz.z).string().nullable().optional(),
            abTestId: (0, $gLLcz.z).string().nullable(),
            controlId: (0, $gLLcz.z).string().nullable()
        }).passthrough()).optional()
    }).passthrough()).optional()
}).passthrough());
const $0c3c63d3552875fa$export$7b58b3b9a7b83d61 = (0, $gLLcz.z).object({
    text: (0, $gLLcz.z).optional((0, $gLLcz.z).string().max(200)),
    originalQuery: (0, $gLLcz.z).optional((0, $gLLcz.z).string().max(200)),
    product: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe((0, $8l0cM.productKeySchema))),
    datasource: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    type: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe($0c3c63d3552875fa$export$4f29dba8e623c3d1)),
    filterDropdownOpen: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema)),
    // Last Modified
    lastModified: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe((0, $er8dU.lastModifiedValueSchema))),
    lastModified_lt: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe((0, $gLLcz.z).coerce.date())),
    lastModified_gt: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe((0, $gLLcz.z).coerce.date())),
    from: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    to: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    sort: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe((0, $kM8s6.sortSchema))),
    titleMatch: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema)),
    // Confluence filters
    contributors: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    owners: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    ancestor: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    // Salesforce Filters
    campaignStatuses: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    caseStatuses: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    isAutoApplied: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    salesforceStages: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    spaces: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    verified: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema)),
    labels: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    pageStatus: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe($0c3c63d3552875fa$export$8a9f7fff0151f0f7)),
    archived: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema)),
    // Jira Filters
    jAssignee: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    jReporter: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    jCommentedByMe: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema)),
    jProject: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    jWatchedByMe: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema)),
    // Assets Filters
    assetsSchema: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    assetsType: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Mercury Filters
    focusAreaTypes: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    focusAreaUnder: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Talent Filters
    positionEmploymentTypes: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionFocusAreas: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionJobFamilies: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionStatuses: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionTeams: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Compass Filters
    compassArchived: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema)),
    createdBy: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    lastUpdatedBy: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Salesforce Close Date filter
    closeDate: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    closeDateVal: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    // Salesforce Opportunity Status filter
    opportunityStatus: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    referrer: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    /**
	 * URL encoded JSON string used to override feature gates/experiments for debugging.
	 */ overrides: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe($0c3c63d3552875fa$export$37bdef1e194c0e7e)),
    cql: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    status: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Pull Request Status filter (GitHub, Bitbucket, GitLab)
    pullRequestStatus: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Repository filter (GitHub)
    repository: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Slack Channel filter
    slackChannels: (0, $gLLcz.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // MS Teams Has Attachment filter
    hasAttachment: (0, $gLLcz.z).optional((0, $flB9e.booleanSchema))
});
const $0c3c63d3552875fa$export$f374b5430ac28f4c = $0c3c63d3552875fa$export$7b58b3b9a7b83d61.keyof().enum;
const $0c3c63d3552875fa$export$ff67c0a0b67bb249 = [
    (queryParams)=>{
        if (queryParams.lastModified !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    (queryParams)=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt } = queryParams;
        if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
            const { lastModified: _, lastModified_gt: __, lastModified_lt: ___, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    // If closeDate is not 'custom', strip out closeDateVal
    (queryParams)=>{
        if (queryParams.closeDate !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { closeDateVal: closeDateVal, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    }
];
const $0c3c63d3552875fa$export$83efce6e50d7c43b = (0, $gLLcz.z).nativeEnum({
    ...(0, $7oQyb.ProductKey),
    ...$0c3c63d3552875fa$export$e2e108cbe2e4f865,
    ...$0c3c63d3552875fa$export$e6747eee8f26f8c0,
    ...$0c3c63d3552875fa$export$f374b5430ac28f4c
});
const $0c3c63d3552875fa$export$3d21d7040623da50 = $0c3c63d3552875fa$export$83efce6e50d7c43b.enum;
module.exports["ContentType"] = $0c3c63d3552875fa$export$e2e108cbe2e4f865;
module.exports["LastModified"] = $0c3c63d3552875fa$export$e6747eee8f26f8c0;
module.exports["Sort"] = $0c3c63d3552875fa$export$d43f91ac58cde147;
module.exports["searchQueryParamsBaseSchema"] = $0c3c63d3552875fa$export$7b58b3b9a7b83d61;
module.exports["searchQueryParamsValidators"] = $0c3c63d3552875fa$export$ff67c0a0b67bb249;

});

parcelRegister("21S1F", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $a7136ae8b2d202d1$export$48804b5672e75138 = (type)=>{
    let messageKey = type;
    if (type === 'page' && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in')) messageKey = 'pageAndLiveDoc';
    return messageKey;
};
module.exports["getTypeOptionMessageKey"] = $a7136ae8b2d202d1$export$48804b5672e75138;

});

parcelRegister("66big", function(module, exports) {

var $1xk5k = parcelRequire("1xk5k");


var $b4tDU = parcelRequire("b4tDU");

const $894b216ca0441314$export$c0b4470d000520ff = (ati, selectedTypes, selectedProducts)=>{
    // In the "all products" and "all types" search, we drop some entities for relevance
    // If types are selected (e.g. "All products" + "Page") or a product is selected ("Confluence" + "all types"), we don't drop any entities
    if (selectedTypes.length === 0 && selectedProducts && (0, $b4tDU.isAllProductSearch)(selectedProducts)) return !(0, $1xk5k.notRequestedATIsInAllSearch)().includes(ati);
    return true;
};
module.exports["isEntityEnabled"] = $894b216ca0441314$export$c0b4470d000520ff;

});

parcelRegister("3fLdC", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");

const $108ae9f9e6bc58a3$export$521c196d70b6785e = (availableProducts, product, thirdPartyConfigs)=>{
    if ((0, $b4tvS.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $dOOW1.isImpersonationEnabled)(product, thirdPartyConfigs));
    else return availableProducts.includes(product);
};
module.exports["isProductEntitiesIncluded"] = $108ae9f9e6bc58a3$export$521c196d70b6785e;

});

parcelRegister("jN0EV", function(module, exports) {
const $8ae69ec250b43bf2$export$e902a1c7f3216533 = (query, label)=>{
    return label.toLowerCase().includes(query.toLowerCase());
};
module.exports["lookupMatches"] = $8ae69ec250b43bf2$export$e902a1c7f3216533;

});

parcelRegister("78yNl", function(module, exports) {
const $382a1369b7330672$export$3f8022b7bd277557 = (siteId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}`;
module.exports["getSmartlinkSiteTraitsUrl"] = $382a1369b7330672$export$3f8022b7bd277557;

});

parcelRegister("fXT59", function(module, exports) {
/**
 * Interface representing a disposable resource.
 */ function $e8684f0ed4469a79$export$e29d65b7eabdc6dd(value) {
    return typeof value === 'object' && value !== null && typeof value.dispose === 'function';
}
function $e8684f0ed4469a79$export$79eba17614bd018c(initialValue, optionsOrDisposeFn) {
    let currentValue = initialValue ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValue = ()=>{
        if (disposeFn) disposeFn(currentValue);
        else if ($e8684f0ed4469a79$export$e29d65b7eabdc6dd(currentValue)) currentValue.dispose();
    };
    return {
        update: (nextValue)=>{
            if (disposeOnUpdate) disposeCurrentValue();
            currentValue = nextValue;
        },
        value: ()=>currentValue,
        dispose: ()=>{
            disposeCurrentValue();
            currentValue = null;
        }
    };
}
function $e8684f0ed4469a79$export$bd7305966afe1e62(disposeFn, initialValue, disposeOnUpdate = true) {
    return $e8684f0ed4469a79$export$79eba17614bd018c(initialValue, {
        disposeFn: disposeFn,
        disposeOnUpdate: disposeOnUpdate
    });
}
function $e8684f0ed4469a79$export$c86c752d0542be0d(initialValues, optionsOrDisposeFn) {
    let currentValues = initialValues ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValues = ()=>{
        if (disposeFn) disposeFn(currentValues);
        else currentValues?.forEach((value)=>{
            if ($e8684f0ed4469a79$export$e29d65b7eabdc6dd(value)) value.dispose();
        });
    };
    return {
        update: (nextValues)=>{
            if (disposeOnUpdate) disposeCurrentValues();
            currentValues = nextValues;
        },
        value: ()=>currentValues,
        dispose: ()=>{
            disposeCurrentValues();
            currentValues = null;
        }
    };
}
module.exports["disposableValue"] = $e8684f0ed4469a79$export$79eba17614bd018c;

});

parcelRegister("b4tDU", function(module, exports) {
const $28f266d325652ecc$export$49b588d87f72a4a8 = (selectedProducts)=>selectedProducts.length === 0;
module.exports["isAllProductSearch"] = $28f266d325652ecc$export$49b588d87f72a4a8;

});

parcelRegister("eMDCS", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $2zuvB = parcelRequire("2zuvB");


var $fKv9F = parcelRequire("fKv9F");

const $56585d93a21bfd73$export$5b3e7019b3acc145 = (value)=>{
    switch(value){
        case (0, $fKv9F.Sort).Relevance:
            return [];
        case (0, $fKv9F.Sort).UpdatedNewest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).DESC
                }
            ];
        case (0, $fKv9F.Sort).UpdatedOldest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).ASC
                }
            ];
        case (0, $fKv9F.Sort).CreatedNewest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).DESC
                }
            ];
        case (0, $fKv9F.Sort).CreatedOldest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).ASC
                }
            ];
        default:
            return [];
    }
};
module.exports["convertSortToFilter"] = $56585d93a21bfd73$export$5b3e7019b3acc145;

});

parcelRegister("d151M", function(module, exports) {
const $1f5a7d8bdef7b5ba$export$8e6bea29334a2099 = (type)=>{
    return type === 'single-select' || type === 'multi-select';
};
module.exports["isSelectFilter"] = $1f5a7d8bdef7b5ba$export$8e6bea29334a2099;

});

parcelRegister("1ikWy", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $3diYj = parcelRequire("3diYj");


var $hB77E = parcelRequire("hB77E");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $9029dd6271750632$export$b38c0215344366f7 = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    // Facade: when rovo_fps_use_rovo_config is enabled, delegate to the
    // canonical implementation in @atlassian/rovo-connectors-config so that
    // search-page and other consumers share a single source of truth.
    // When disabled, fall through to the inline legacy implementation below.
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $3diYj.getSupportedAccessibleProducts)({
        supportedProducts: supportedProducts,
        products: products,
        accessibleProducts: accessibleProducts
    });
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $b4tvS.ProductKeys).Talent]: (0, $dh538.fg)('talent_global_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $hB77E.getThirdPartyConfigs)().forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.find((featureGatedProduct)=>featureGatedProduct === productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $9d9t8.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $b4tvS.ProductKeys).JiraServiceManagement) && (0, $dh538.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $dh538.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $b4tvS.ProductKeys).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};
module.exports["getAccessibleProducts"] = $9029dd6271750632$export$b38c0215344366f7;

});

parcelRegister("lgPOO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $lIbf3 = parcelRequire("lIbf3");


var $fHHuS = parcelRequire("fHHuS");


var $32Kiv = parcelRequire("32Kiv");


var $9opb6 = parcelRequire("9opb6");

const $54763063a77a852a$export$b676c7d6baea13e9 = ({ children: children, experience: experience, accessibleProducts: accessibleProducts, ...props })=>{
    const { thirdPartyConfigs: initialThirdPartyConfigsProp, searchSessionId: searchSessionIdProp, smartLinkUsage: smartLinkUsageProp, smartLinkUsageAndTopApps: smartLinkUsageAndTopAppsProp } = props.initialProps || {};
    const safeQueryParams = props.queryParams && (0, $lIbf3.parseQueryParams)(props.queryParams);
    /**
   * searchSessionId is generated on the client and does not change frequently, but can be refreshed with refreshSearchSessionId
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [searchSessionId, setSearchSessionId] = (0, $42omo.useState)(searchSessionIdProp ?? crypto.randomUUID());
    const refreshSearchSessionId = (0, $42omo.useCallback)(()=>{
        const newSearchSessionId = crypto.randomUUID();
        setSearchSessionId(newSearchSessionId);
    }, []);
    /**
   * Initial ?referrer=X paramater for analytics
   * Referrer is actually static for a single page load once, but is cleaned up after use so it isn't re-used in analytics events
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [referrer, setReferrer] = (0, $42omo.useState)(safeQueryParams?.referrer);
    const clearReferrer = (0, $42omo.useCallback)(()=>{
        setReferrer(undefined);
    }, []);
    /**
   * Initial ?text=X parameter for search store
   *
   * I think this is only used in search-page when checking referrer (not relay) and can be cleaned up with `search-page-relay`
   */ const [initialText] = (0, $42omo.useState)(safeQueryParams?.text);
    const staticProps = {
        refreshSearchSessionId: refreshSearchSessionId,
        clearReferrer: clearReferrer,
        initialText: initialText,
        initialThirdPartyConfigs: (0, $dh538.fg)('rovo_fps_use_rovo_config') ? {} : initialThirdPartyConfigsProp || {},
        experience: experience,
        accessibleProducts: accessibleProducts
    };
    const dynamicProps = {
        searchSessionId: searchSessionId,
        referrer: referrer,
        smartLinkUsage: smartLinkUsageProp,
        smartLinkUsageAndTopApps: smartLinkUsageAndTopAppsProp,
        ...(0, $dh538.fg)('rovo_fps_use_rovo_config') && {
            thirdPartyConfigs: initialThirdPartyConfigsProp || {}
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9opb6.StaticContextProvider), {
        ...props,
        ...staticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fHHuS.DynamicContextProvider), {
        ...props,
        ...dynamicProps
    }, children));
};
const $54763063a77a852a$export$dada99aabcba96f5 = /*#__PURE__*/ (0, $42omo.createContext)((0, $9opb6.defaultStaticContext));
const $54763063a77a852a$export$64067c351da2da1b = /*#__PURE__*/ (0, $42omo.createContext)((0, $32Kiv.createStaticBootstrapStore)((0, $9opb6.defaultStaticContext)));
const $54763063a77a852a$export$7925fbd6de082b5c = /*#__PURE__*/ (0, $42omo.createContext)((0, $fHHuS.defaultDynamicContext));
module.exports["BootstrapContextProvider"] = $54763063a77a852a$export$b676c7d6baea13e9;
module.exports["StaticBootstrapContext"] = $54763063a77a852a$export$dada99aabcba96f5;
module.exports["StaticBootstrapStoreContext"] = $54763063a77a852a$export$64067c351da2da1b;
module.exports["DynamicBootstrapContext"] = $54763063a77a852a$export$7925fbd6de082b5c;

});

parcelRegister("gSaNw", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $6c891647ea736fd7$export$1a5e9086021cdce5 = ()=>{
    // This FG is used to force enable the context store code path for e2e testing purposes
    if ((0, $dh538.fg)('rovo-search-remove-rss-bootstrap-fg')) return true;
    return (0, $c6GJD.default).getExperimentValue('rovo-search-remove-rss-bootstrap-exp', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
module.exports["serveBootstrapProviderExp"] = $6c891647ea736fd7$export$1a5e9086021cdce5;

});

parcelRegister("fw303", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $28f6a41f8eb2075f$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $28f6a41f8eb2075f$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('archived');
const $28f6a41f8eb2075f$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'archived',
    queryParams: {
        key: 'archived'
    },
    products: [
        ...$28f6a41f8eb2075f$var$productKeys1P,
        ...$28f6a41f8eb2075f$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $28f6a41f8eb2075f$export$3dea766d36a8935f;

});

parcelRegister("k7ise", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $cxQs0 = parcelRequire("cxQs0");

const $fd56dcb3e3750fa4$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Compass
];
const $fd56dcb3e3750fa4$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'compassArchived',
    queryParams: {
        key: 'compassArchived'
    },
    products: $fd56dcb3e3750fa4$var$productKeys1P,
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $fd56dcb3e3750fa4$export$3dea766d36a8935f;

});

parcelRegister("5X4Ay", function(module, exports) {

var $2CQZl = parcelRequire("2CQZl");


var $jwO5V = parcelRequire("jwO5V");


var $3paC4 = parcelRequire("3paC4");


var $iUYhn = parcelRequire("iUYhn");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $d4c3bf3cbd6e1760$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $d4c3bf3cbd6e1760$var$loadInitialOptions = async (config)=>{
    if (config.product === (0, $b4tvS.ProductKeys).JiraDC || config.product === (0, $b4tvS.ProductKeys).JsmDC) return (0, $4bHQd.loadRecommendedUsers)(config);
    return $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee('', config, {
        initialOptions: true
    });
};
const $d4c3bf3cbd6e1760$var$searchAssignee = async (query, config)=>{
    if (config.product === (0, $b4tvS.ProductKeys).JiraDC || config.product === (0, $b4tvS.ProductKeys).JsmDC) return $d4c3bf3cbd6e1760$var$searchAssignees3P(query, config);
    return $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee(query, config);
};
const $d4c3bf3cbd6e1760$var$searchAssignees3P = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $2CQZl.getAssignees)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $d4c3bf3cbd6e1760$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((assignee)=>({
            trackingKey: assignee.id,
            value: assignee.id,
            label: assignee.name,
            avatarUrl: assignee.avatarUrl,
            queryParamValue: assignee.id,
            product: config.product
        }));
};
const $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee = async (query, config, options)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $i8MOh.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchAssigneeQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).People
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchAssigneeReponse] = await Promise.all([
        initialUsersQuery,
        searchAssigneeQuery
    ]);
    const searchAssigneeResults = searchAssigneeReponse.response.rawData.scopes[0]?.results ?? [];
    const allAssignees = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchAssigneeResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return assigneeOptions;
};
const $d4c3bf3cbd6e1760$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $d4c3bf3cbd6e1760$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('assignee');
const $d4c3bf3cbd6e1760$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'assignee',
    products: [
        ...$d4c3bf3cbd6e1760$var$productKeys1P,
        ...$d4c3bf3cbd6e1760$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jAssignee',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allAssignees = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return assigneeOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $d4c3bf3cbd6e1760$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $d4c3bf3cbd6e1760$var$searchAssignee(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).JiraDC || primaryProduct === (0, $b4tvS.ProductKeys).JsmDC || primaryProduct === (0, $b4tvS.ProductKeys).JiraServiceManagement || primaryProduct === (0, $b4tvS.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $d4c3bf3cbd6e1760$export$3dea766d36a8935f;

});

parcelRegister("5VnRb", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $2zk4m = parcelRequire("2zk4m");

const $f74bec2327788b4f$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $f74bec2327788b4f$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('campaignStatus');
const $f74bec2327788b4f$var$fetchDynamicCampaignStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $2zk4m.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const campaignStatuses = result.filters.find((f)=>f.name === 'campaignStatuses');
        if (!campaignStatuses || campaignStatuses.values.length === 0) return [];
        return campaignStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
/**
 * Returns campaign status options — dynamic when the feature flag is on, and
 * an empty list when the feature flag is off (filter won't load options).
 */ const $f74bec2327788b4f$var$fetchCampaignStatusOptions = async (config)=>{
    if ((0, $dh538.fg)('rovo-fps-3p-ux-sf-campaign-status-filter')) return $f74bec2327788b4f$var$fetchDynamicCampaignStatusOptions(config);
    return [];
};
const $f74bec2327788b4f$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $f74bec2327788b4f$var$fetchCampaignStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $f74bec2327788b4f$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'campaignStatus',
    requiresTopLevel3PDatasource: true,
    products: [
        ...$f74bec2327788b4f$var$salesforceProducts,
        ...$f74bec2327788b4f$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'campaignStatuses',
        fetcher: async (queryParams, config)=>{
            return $f74bec2327788b4f$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $f74bec2327788b4f$var$fetchCampaignStatusOptions(config);
        }
    }
});
module.exports["filter"] = $f74bec2327788b4f$export$3dea766d36a8935f;

});

parcelRegister("F3Hv6", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $2zk4m = parcelRequire("2zk4m");

const $67cd3a959b07a560$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $67cd3a959b07a560$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('caseStatus');
const $67cd3a959b07a560$var$caseStatusProducts = Array.from(new Set([
    ...$67cd3a959b07a560$var$salesforceProducts,
    ...$67cd3a959b07a560$var$products3PFromConfig
]));
const $67cd3a959b07a560$var$fetchDynamicCaseStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $2zk4m.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const caseStatuses = result.filters.find((f)=>f.name === 'caseStatuses');
        if (!caseStatuses || caseStatuses.values.length === 0) return [];
        return caseStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
const $67cd3a959b07a560$var$fetchCaseStatusOptions = async (config)=>{
    return $67cd3a959b07a560$var$fetchDynamicCaseStatusOptions(config);
};
const $67cd3a959b07a560$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $67cd3a959b07a560$var$fetchCaseStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $67cd3a959b07a560$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'caseStatus',
    requiresTopLevel3PDatasource: true,
    products: $67cd3a959b07a560$var$caseStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'caseStatuses',
        fetcher: async (queryParams, config)=>{
            return $67cd3a959b07a560$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $67cd3a959b07a560$var$fetchCaseStatusOptions(config);
        }
    }
});
module.exports["filter"] = $67cd3a959b07a560$export$3dea766d36a8935f;

});

parcelRegister("hHAPz", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $7GRRM = parcelRequire("7GRRM");


var $aXWIB = parcelRequire("aXWIB");

const $d896105a0f4182b9$export$95ac8a541f7029bb = (0, $aXWIB.defineMessages)({
    anytime: {
        id: "search-page.filter.close.date.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.close.date.today",
        defaultMessage: "Today"
    },
    last7days: {
        id: "search-page.filter.close.date.last7days",
        defaultMessage: "Last 7 days"
    },
    last30days: {
        id: "search-page.filter.close.date.last30days",
        defaultMessage: "Last 30 days"
    },
    last90days: {
        id: "search-page.filter.close.date.last90days",
        defaultMessage: "Last 90 days"
    },
    last365days: {
        id: "search-page.filter.close.date.last365days",
        defaultMessage: "Last 365 days"
    },
    next7days: {
        id: "search-page.filter.close.date.next7days",
        defaultMessage: "Next 7 days"
    },
    next30days: {
        id: "search-page.filter.close.date.next30days",
        defaultMessage: "Next 30 days"
    },
    next90days: {
        id: "search-page.filter.close.date.next90days",
        defaultMessage: "Next 90 days"
    },
    next365days: {
        id: "search-page.filter.close.date.next365days",
        defaultMessage: "Next 365 days"
    },
    custom: {
        id: "search-page.filter.close.date.custom",
        defaultMessage: "Specific date"
    }
});


const $bb10e4510dc43103$var$CLOSE_DATE_VALUES = [
    'anytime',
    'today',
    'last7days',
    'last30days',
    'last90days',
    'last365days',
    'next7days',
    'next30days',
    'next90days',
    'next365days',
    'custom'
];
const $bb10e4510dc43103$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $bb10e4510dc43103$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $bb10e4510dc43103$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('closeDate');
const $bb10e4510dc43103$var$closeDateProducts = Array.from(new Set([
    ...$bb10e4510dc43103$var$salesforceProducts,
    ...$bb10e4510dc43103$var$products3PFromConfig
]));
const $bb10e4510dc43103$export$3dea766d36a8935f = (0, $7GRRM.createSingleWithCustomOptionSelectFilter)({
    id: 'closeDate',
    products: $bb10e4510dc43103$var$closeDateProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'closeDate',
        fetcher: async (values, config)=>{
            return $bb10e4510dc43103$var$CLOSE_DATE_VALUES.filter((value)=>values.includes(value)).map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value]) || (0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: (queryParams)=>{
            const { closeDateVal: closeDateVal } = queryParams;
            const isDateValid = $bb10e4510dc43103$var$isIsoDate(closeDateVal?.[0]);
            const dateVal = isDateValid && closeDateVal?.[0] ? closeDateVal[0] : '';
            if (dateVal) return {
                closeDateVal: dateVal
            };
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $bb10e4510dc43103$var$CLOSE_DATE_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value]) || (0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    customValueFields: [
        'closeDateVal'
    ]
});
module.exports["filter"] = $bb10e4510dc43103$export$3dea766d36a8935f;

});

parcelRegister("2a0ps", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $f26296303db33d56$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $f26296303db33d56$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('commentedByMe');
const $f26296303db33d56$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'commentedByMe',
    queryParams: {
        key: 'jCommentedByMe'
    },
    products: [
        ...$f26296303db33d56$var$productKeys1P,
        ...$f26296303db33d56$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $f26296303db33d56$export$3dea766d36a8935f;

});

parcelRegister("dQXZO", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $jxvxe = parcelRequire("jxvxe");


var $i14PY = parcelRequire("i14PY");


var $johDC = parcelRequire("johDC");


var $1HJbl = parcelRequire("1HJbl");


var $1A1pg = parcelRequire("1A1pg");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cOUgi = parcelRequire("cOUgi");

const $5955e72d8edc423d$var$getContentId = (ari)=>{
    const EXTRACT_ID = /ari:.*?:.*?:.*?:.*?\/(.*)?.*/;
    const matches = ari.match(EXTRACT_ID);
    // content id of the ari
    return matches && matches.length > 1 ? matches[1] : '';
};
const $5955e72d8edc423d$var$searchContent = async (query, config)=>{
    const location = `ari:cloud:confluence::site/${config.cloudId}`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const product = config.product;
    const selectedSpaceAris = $5955e72d8edc423d$var$getSelectedSpaceAris(config);
    if ($5955e72d8edc423d$var$isThirdPartyProductWithContentUnder(product)) {
        const selectedSpaceAri = selectedSpaceAris[0];
        const datasource = config.selectedDatasource ?? config.thirdPartyConfigs?.[product];
        if (!datasource?.integrationAri) return [];
        const spaceFilter = selectedSpaceAri ? {
            ancestorAris: [
                selectedSpaceAri
            ]
        } : {};
        const contributorAccountIds = (0, $dh538.fg)('rovo_fps_scope_3p_typeahead_by_contributor') ? $5955e72d8edc423d$var$getSelectedContributorAccountIds(config) : [];
        const commonFilters = contributorAccountIds.length > 0 ? {
            contributorsFilter: contributorAccountIds
        } : undefined;
        const response = await (0, $i14PY.searchEntitiesQuery)({
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            variables: {
                query: query,
                first: 10,
                experience: 'search-page',
                filters: {
                    entities: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    locations: [
                        location
                    ],
                    ...commonFilters && {
                        commonFilters: commonFilters
                    },
                    thirdPartyFilters: {
                        titleMatchOnly: true,
                        ...spaceFilter,
                        thirdPartyProducts: [
                            {
                                product: product,
                                integrationId: datasource.integrationAri,
                                subtypes: $5955e72d8edc423d$var$getThirdPartyContentUnderSubtypes(product)
                            }
                        ]
                    }
                }
            },
            headers: headers,
            includeContainerId: true
        });
        const results = response.data?.search?.results.edges.map((content)=>{
            // Access entity.containerId for cross-filter validation (folder belongs to which drive/space)
            const containerId = content.node.entity?.containerId;
            const option = {
                trackingKey: content.node.id,
                value: content.node.id,
                label: content.node.title,
                queryParamValue: content.node.id,
                product: config.product,
                ...containerId && {
                    metadata: {
                        containerARI: containerId
                    }
                }
            };
            return option;
        }) || [];
        return results;
    }
    let contentPagesResponse;
    if (product === (0, $b4tvS.ProductKeys).ConfluenceDC) {
        contentPagesResponse = await (0, $johDC.confluenceDcContentFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: location,
                limit: 10,
                entities: [
                    'ati:cloud:graph:document'
                ],
                product: product
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return contentPagesResponse.data?.search?.search?.edges.map((content)=>({
                trackingKey: content.node.id,
                value: content.node.id,
                label: (0, $1HJbl.cleanExcerpt)(content.node.title),
                queryParamValue: content.node.id,
                product: config.product
            })) || [];
    }
    contentPagesResponse = await (0, $i14PY.searchEntitiesQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            query: query,
            first: 10,
            filters: {
                entities: [
                    'ati:cloud:confluence:page'
                ],
                locations: [
                    location
                ]
            }
        },
        headers: headers
    });
    const allContentPages = contentPagesResponse.data?.search?.results.edges.map((content)=>({
            title: content.node.title,
            id: content.node.id
        })) || [];
    const contentOptions = allContentPages.map((content)=>{
        const contentId = $5955e72d8edc423d$var$getContentId(content.id);
        return {
            trackingKey: contentId,
            value: contentId,
            label: content.title,
            queryParamValue: contentId,
            product: config.product
        };
    });
    return contentOptions;
};
const $5955e72d8edc423d$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $5955e72d8edc423d$var$getProducts3PFromConfig = ()=>(0, $dOOW1.getProducts3PFromConfigForFilter)('content');
const $5955e72d8edc423d$var$getFilterProducts = ()=>[
        ...$5955e72d8edc423d$var$productKeys1P,
        ...$5955e72d8edc423d$var$getProducts3PFromConfig()
    ];
const $5955e72d8edc423d$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES = {
    [(0, $b4tvS.ProductKeys).GoogleDrive]: [
        (0, $2Znam.NounSubtypeKey).Folder
    ],
    [(0, $b4tvS.ProductKeys).Sharepoint]: [
        (0, $2Znam.NounSubtypeKey).Drive,
        (0, $2Znam.NounSubtypeKey).Folder
    ]
};
const $5955e72d8edc423d$var$isThirdPartyProductWithContentUnder = (product)=>!!product && product in $5955e72d8edc423d$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES && $5955e72d8edc423d$var$getProducts3PFromConfig().includes(product);
const $5955e72d8edc423d$var$getThirdPartyContentUnderSubtypes = (product)=>$5955e72d8edc423d$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES[product] ?? [];
const $5955e72d8edc423d$var$getSelectedSpaceAris = (config)=>Array.isArray(config.initialSpaceARIs) ? config.initialSpaceARIs.filter(Boolean) : [];
const $5955e72d8edc423d$var$getSelectedContributorAccountIds = (config)=>Array.isArray(config.contributorAccountIds) ? config.contributorAccountIds.filter(Boolean) : [];
const $5955e72d8edc423d$var$withCurrentProducts = (state)=>({
        ...state,
        products: $5955e72d8edc423d$var$getFilterProducts()
    });
const $5955e72d8edc423d$var$withCurrentProductsFilter = (filter)=>({
        ...filter,
        getState: ()=>$5955e72d8edc423d$var$withCurrentProducts(filter.getState()),
        queryParams: {
            ...filter.queryParams,
            set: async (queryParams, onStateChange)=>$5955e72d8edc423d$var$withCurrentProductsFilter(await filter.queryParams.set(queryParams, onStateChange && ((state)=>onStateChange($5955e72d8edc423d$var$withCurrentProducts(state)))))
        },
        loadInitialOptions: async (onStateChange)=>$5955e72d8edc423d$var$withCurrentProductsFilter(await filter.loadInitialOptions(onStateChange && ((state)=>onStateChange($5955e72d8edc423d$var$withCurrentProducts(state))))),
        setOption: (option, customValue)=>$5955e72d8edc423d$var$withCurrentProductsFilter(filter.setOption(option, customValue)),
        clearOptions: ()=>$5955e72d8edc423d$var$withCurrentProductsFilter(filter.clearOptions()),
        setLookupInput: async (query, onStateChange)=>$5955e72d8edc423d$var$withCurrentProductsFilter(await filter.setLookupInput(query, onStateChange && ((state)=>onStateChange($5955e72d8edc423d$var$withCurrentProducts(state))))),
        clear: ()=>$5955e72d8edc423d$var$withCurrentProductsFilter(filter.clear())
    });
const $5955e72d8edc423d$var$baseFilter = (0, $cOUgi.createSingleSelectFilter)({
    id: 'content',
    products: $5955e72d8edc423d$var$getFilterProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'ancestor',
        fetcher: async (queryParams, config)=>{
            const product = config.product;
            const location = `ari:cloud:confluence::site/${config.cloudId}`;
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            if ($5955e72d8edc423d$var$isThirdPartyProductWithContentUnder(product)) {
                const contentResponse = await (0, $johDC.documentARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product,
                        ...content.container?.id && {
                            metadata: {
                                containerARI: content.container.id
                            }
                        }
                    })) || [];
            }
            if (product === (0, $b4tvS.ProductKeys).ConfluenceDC) {
                const contentPagesResponse = await (0, $johDC.confluenceDcPagesQuery)({
                    variables: {
                        query: '',
                        cloudIdARI: location,
                        limit: 10,
                        entities: [
                            'ati:cloud:graph:document'
                        ],
                        product: product,
                        ancestorIds: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentPagesResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product
                    })) || [];
            }
            const initialContentARIs = queryParams.map((contentId)=>`ari:cloud:confluence:${config.cloudId}:page/${contentId}`);
            const initialContentResponse = await (0, $jxvxe.confluencePagesQuery)(initialContentARIs, headers);
            const allContentPages = initialContentResponse.data?.confluence.pages.map((page)=>({
                    title: page.title,
                    id: page.id
                })) || [];
            const contentOptions = allContentPages.map((content)=>{
                const contentId = $5955e72d8edc423d$var$getContentId(content.id);
                return {
                    trackingKey: contentId,
                    value: contentId,
                    label: content.title,
                    queryParamValue: contentId,
                    product: config.product
                };
            });
            return contentOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $5955e72d8edc423d$var$searchContent('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $5955e72d8edc423d$var$searchContent(query, config);
        }
    }
});
const $5955e72d8edc423d$export$3dea766d36a8935f = {
    ...$5955e72d8edc423d$var$baseFilter,
    queryParams: {
        ...$5955e72d8edc423d$var$baseFilter.queryParams,
        getState: (queryParams, cloudId)=>$5955e72d8edc423d$var$withCurrentProducts($5955e72d8edc423d$var$baseFilter.queryParams.getState(queryParams, cloudId))
    },
    get products () {
        return $5955e72d8edc423d$var$getFilterProducts();
    },
    withState: (state, config)=>$5955e72d8edc423d$var$withCurrentProductsFilter($5955e72d8edc423d$var$baseFilter.withState({
            ...state,
            products: $5955e72d8edc423d$var$getFilterProducts()
        }, config)),
    getInitialState: (config)=>$5955e72d8edc423d$var$withCurrentProductsFilter($5955e72d8edc423d$var$baseFilter.getInitialState(config))
};
module.exports["filter"] = $5955e72d8edc423d$export$3dea766d36a8935f;

});

parcelRegister("c5dmm", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $lEZ2M = parcelRequire("lEZ2M");


var $i8MOh = parcelRequire("i8MOh");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $8bdf2fa783a54336$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $8bdf2fa783a54336$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('createdBy');
const $8bdf2fa783a54336$var$loadInitialOptions = async (config)=>{
    return (0, $4bHQd.loadRecommendedUsers)(config);
};
const $8bdf2fa783a54336$var$searchCreatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $lEZ2M.getCreatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $8bdf2fa783a54336$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $8bdf2fa783a54336$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'createdBy',
    products: [
        ...$8bdf2fa783a54336$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'createdBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allCreatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const createdByOptions = allCreatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return createdByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8bdf2fa783a54336$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $8bdf2fa783a54336$var$searchCreatedBy(query, config);
        }
    }
});
module.exports["filter"] = $8bdf2fa783a54336$export$3dea766d36a8935f;

});

parcelRegister("6jSbc", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $4yWWa = parcelRequire("4yWWa");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

/**
 * Queries all focus area types from graphQL and returns all options as suggested but unselected
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getInitialOptions = async (config)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreaTypesResponse = await (0, $4yWWa.mercuryFocusAreaTypesQuery)(config.cloudId || '', headers);
    const focusAreaTypes = focusAreaTypesResponse.data?.mercury.focusAreaTypes ?? [];
    return focusAreaTypes.map((focusAreaType)=>({
            trackingKey: focusAreaType.id,
            label: focusAreaType.name,
            value: focusAreaType.id,
            queryParamValue: focusAreaType.id,
            product: config.product
        }));
};
/**
 * Queries all focus area types from graphQL and returns all options as suggested and query params are suggested
 * @param queryParams
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const focusAreaTypeOptions = await $9bc69c6e351ac6c8$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>queryParams.includes(option.value));
};
/**
 * Queries all focus area types from graphQL and filters out options that do not match the text query
 * @param query
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getOptionsFilteredByTextQuery = async (query, config)=>{
    const focusAreaTypeOptions = await $9bc69c6e351ac6c8$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>option.label.toLowerCase().includes(query.toLowerCase()));
};
const $9bc69c6e351ac6c8$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Focus
];
const $9bc69c6e351ac6c8$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'focusAreaType',
    products: $9bc69c6e351ac6c8$var$productKeys1P,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'focusAreaTypes',
        fetcher: $9bc69c6e351ac6c8$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: $9bc69c6e351ac6c8$var$getInitialOptions
    },
    lookup: {
        fetcher: $9bc69c6e351ac6c8$var$getOptionsFilteredByTextQuery
    }
});
module.exports["filter"] = $9bc69c6e351ac6c8$export$3dea766d36a8935f;

});

parcelRegister("e7L4o", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $d95gt = parcelRequire("d95gt");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $617022314357c679$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $617022314357c679$var$searchFocusAreas = async (query, config)=>{
    const mqlQuery = `(search LIKE '${query}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$617022314357c679$var$mapFocusAreaResult(focusArea, config.product));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $617022314357c679$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$617022314357c679$var$mapFocusAreaResult(focusArea, config.product));
};
const $617022314357c679$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Focus
];
const $617022314357c679$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'focusAreaUnder',
    products: $617022314357c679$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'focusAreaUnder',
        fetcher: $617022314357c679$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $617022314357c679$var$searchFocusAreas('', config);
        }
    },
    lookup: {
        fetcher: $617022314357c679$var$searchFocusAreas
    }
});
module.exports["filter"] = $617022314357c679$export$3dea766d36a8935f;

});

parcelRegister("lPWNq", function(module, exports) {

var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $0b6fdb4a13c32907$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('hasAttachment');
const $0b6fdb4a13c32907$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'hasAttachment',
    queryParams: {
        key: 'hasAttachment'
    },
    products: [
        ...$0b6fdb4a13c32907$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $0b6fdb4a13c32907$export$3dea766d36a8935f;

});

parcelRegister("gwbWt", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");



var $22zVp = parcelRequire("22zVp");


var $6Ea6j = parcelRequire("6Ea6j");


var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $1tvnk = parcelRequire("1tvnk");

parcelRequire("1yEFx");


const $1023844455dd110c$export$1825bdcb0c5952b8 = async (query, config)=>{
    if (!config.intl || config.cloudId === undefined) // base on existing interface, can only query contributors with intl
    return [];
    if ((0, $dh538.fg)('enable_labels_filter_confluence_dc_search')) {
        const product = config.product;
        if (product === (0, $b4tvS.ProductKeys).ConfluenceDC) return [
            {
                trackingKey: query,
                value: query,
                label: query,
                queryParamValue: query,
                product: config.product
            }
        ];
    }
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialLabelsResponse = await (0, $1tvnk.confluenceLabelsQuery)(config.cloudId, query, 10, headers);
    const suggestedLabels = initialLabelsResponse.data?.confluence.searchLabels.suggestedLabels || [];
    const otherLabels = initialLabelsResponse.data?.confluence.searchLabels.otherLabels || [];
    return [
        ...suggestedLabels,
        ...otherLabels
    ].map((label)=>({
            trackingKey: label.label || '',
            value: label.label || '',
            queryParamValue: label.label || '',
            label: label.label || '',
            product: config.product
        })) ?? [];
};
const $1023844455dd110c$export$ae59602b611675bf = async (queryParams)=>{
    return queryParams.map((label)=>({
            trackingKey: label,
            value: label,
            queryParamValue: label,
            label: label
        }));
};



var $7uR1u = parcelRequire("7uR1u");

const $552374ecba257bba$export$218f28c8d8799e97 = async (config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $7uR1u.getSuggestedJiraLabels)({
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: true,
            product: config.product
        }));
};
const $552374ecba257bba$export$9a3d32e397d14cdf = async (query, config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $7uR1u.getSuggestedJiraLabels)({
        query: query,
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: false,
            product: config.product
        }));
};
const $552374ecba257bba$export$eea6e8b7edaba18f = async (queryParams, config)=>{
    const options = queryParams.map((queryParam)=>({
            trackingKey: queryParam,
            value: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return options;
};


const $08baf0c4c2bfd1f5$var$getProducts1P = ()=>{
    return [
        (0, $b4tvS.ProductKeys).Confluence,
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ];
};
const $08baf0c4c2bfd1f5$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'label',
    products: [
        ...$08baf0c4c2bfd1f5$var$getProducts1P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'labels',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $b4tvS.ProductKeys).Confluence || config.product === (0, $b4tvS.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $b4tvS.ProductKeys).Confluence) return (0, $1023844455dd110c$export$ae59602b611675bf)(queryParams, config);
            const safePrimaryProduct = (0, $b4tvS.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $22zVp.isJiraProduct)(config.product) || (0, $22zVp.isJiraProduct)(safePrimaryProduct)) return (0, $552374ecba257bba$export$eea6e8b7edaba18f)(queryParams, config);
            // Not supported in other products
            return [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const safePrimaryProduct = (0, $b4tvS.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $22zVp.isJiraProduct)(config.product) || (0, $22zVp.isJiraProduct)(safePrimaryProduct)) return (0, $552374ecba257bba$export$218f28c8d8799e97)(config);
            return [];
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (config.product === (0, $b4tvS.ProductKeys).Confluence || config.product === (0, $b4tvS.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $b4tvS.ProductKeys).Confluence) return (0, $1023844455dd110c$export$1825bdcb0c5952b8)(query, config);
            const safePrimaryProduct = (0, $b4tvS.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $22zVp.isJiraProduct)(config.product) || (0, $22zVp.isJiraProduct)(safePrimaryProduct)) return (0, $552374ecba257bba$export$9a3d32e397d14cdf)(query, config);
            return [];
        }
    }
});
module.exports["filter"] = $08baf0c4c2bfd1f5$export$3dea766d36a8935f;

});

parcelRegister("1uGSo", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");


var $dOOW1 = parcelRequire("dOOW1");


var $7GRRM = parcelRequire("7GRRM");


var $aXWIB = parcelRequire("aXWIB");

const $a33c6cc099d6cfe5$export$3f164da8f895a853 = (0, $aXWIB.defineMessages)({
    anytime: {
        id: "search-page.filter.last.updated.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.last.updated.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "search-page.filter.last.updated.yesterday",
        defaultMessage: "Yesterday"
    },
    past7Days: {
        id: "search-page.filter.last.updated.past7Days",
        defaultMessage: "Past 7 days"
    },
    past30Days: {
        id: "search-page.filter.last.updated.past30Days",
        defaultMessage: "Past 30 days"
    },
    pastYear: {
        id: "search-page.filter.last.updated.pastYear",
        defaultMessage: "Past year"
    },
    custom: {
        id: "search-page.filter.last.updated.custom",
        defaultMessage: "Custom"
    }
});



var $ILLS9 = parcelRequire("ILLS9");

const $c804900efc0ed3cd$var$LAST_UPDATED_VALUES = [
    'today',
    'yesterday',
    'past7Days',
    'past30Days',
    'pastYear',
    'custom'
];
const $c804900efc0ed3cd$var$sortCompareFn = (a, b)=>{
    return $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.indexOf(a.value) - $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.indexOf(b.value);
};
const $c804900efc0ed3cd$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Atlas,
    (0, $b4tvS.ProductKeys).Confluence,
    (0, $b4tvS.ProductKeys).Focus,
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement,
    (0, $b4tvS.ProductKeys).Compass,
    (0, $b4tvS.ProductKeys).Trello,
    (0, $b4tvS.ProductKeys).Bitbucket
];
const $c804900efc0ed3cd$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('lastUpdated');
const $c804900efc0ed3cd$export$3dea766d36a8935f = (0, $7GRRM.createSingleWithCustomOptionSelectFilter)({
    id: 'lastUpdated',
    products: [
        ...$c804900efc0ed3cd$var$productKeys1P,
        ...$c804900efc0ed3cd$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'lastModified',
        fetcher: async (_, config)=>{
            return $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value]) || (0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: $ILLS9.customValueParser,
        generateQueryParamsGetState: $ILLS9.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: 'anytime',
                    label: config.intl?.formatMessage((0, $a33c6cc099d6cfe5$export$3f164da8f895a853)['anytime']) || (0, $a33c6cc099d6cfe5$export$3f164da8f895a853)['anytime'].defaultMessage,
                    value: 'anytime',
                    isDefault: true,
                    queryParamValue: (0, $fKv9F.LastModified).Anytime,
                    product: config.product
                },
                ...$c804900efc0ed3cd$var$LAST_UPDATED_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value]) || (0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $c804900efc0ed3cd$var$sortCompareFn,
    customValueFields: [
        'to',
        'from'
    ]
});
module.exports["filter"] = $c804900efc0ed3cd$export$3dea766d36a8935f;

});

parcelRegister("huubg", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $98IoL = parcelRequire("98IoL");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $602c33df522af7cd$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $602c33df522af7cd$var$loadInitialOptions = async (config)=>{
    return (0, $4bHQd.loadRecommendedUsers)(config);
};
const $602c33df522af7cd$var$searchlastUpdatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const productKey = (0, $ewGgp.getUrsProductKey)(config.primaryProduct);
    const response = await (0, $98IoL.getLastUpdatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: productKey,
        maxNumberOfResults: $602c33df522af7cd$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $602c33df522af7cd$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'lastUpdatedBy',
    products: [
        (0, $b4tvS.ProductKeys).Salesforce,
        (0, $b4tvS.ProductKeys).Hubspot
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'lastUpdatedBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allLastUpdatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const lastUpdatedByOptions = allLastUpdatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return lastUpdatedByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $602c33df522af7cd$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $602c33df522af7cd$var$searchlastUpdatedBy(query, config);
        }
    }
});
module.exports["filter"] = $602c33df522af7cd$export$3dea766d36a8935f;

});

parcelRegister("dFCIx", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cOUgi = parcelRequire("cOUgi");


var $dcbm4 = parcelRequire("dcbm4");


var $aXWIB = parcelRequire("aXWIB");

const $9944ee0bc1f3b08e$export$815fbd192b2af8a4 = (0, $aXWIB.defineMessages)({
    all: {
        id: "search-page.filter.opportunityStatus.all",
        defaultMessage: "Any"
    },
    open: {
        id: "search-page.filter.opportunityStatus.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.filter.opportunityStatus.closed",
        defaultMessage: "Closed"
    }
});


const $0f897612a5f47c57$export$2fbe3998cc101414 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $9944ee0bc1f3b08e$export$815fbd192b2af8a4)['all']) ?? '',
        product: config.product
    };
    const opportunityStatusOptions = (0, $dcbm4.allOpportunityStatusFilterValueKeys).map((key)=>({
            value: key,
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $9944ee0bc1f3b08e$export$815fbd192b2af8a4)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...opportunityStatusOptions
    ];
};


const $4da2f64cd04b4f35$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $4da2f64cd04b4f35$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('opportunityStatus');
const $4da2f64cd04b4f35$var$opportunityStatusProducts = Array.from(new Set([
    ...$4da2f64cd04b4f35$var$salesforceProducts,
    ...$4da2f64cd04b4f35$var$products3PFromConfig
]));
const $4da2f64cd04b4f35$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $0f897612a5f47c57$export$2fbe3998cc101414)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $4da2f64cd04b4f35$var$getInitialOptions = (config)=>{
    const allOptions = (0, $0f897612a5f47c57$export$2fbe3998cc101414)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $4da2f64cd04b4f35$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'opportunityStatus',
    products: $4da2f64cd04b4f35$var$opportunityStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'opportunityStatus',
        fetcher: async (queryParams, config)=>{
            return $4da2f64cd04b4f35$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $4da2f64cd04b4f35$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $4da2f64cd04b4f35$export$3dea766d36a8935f;

});

parcelRegister("5ousX", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $3Pbzb = parcelRequire("3Pbzb");


var $cxsgw = parcelRequire("cxsgw");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");

const $94bac5f8fcf7120c$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $94bac5f8fcf7120c$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $94bac5f8fcf7120c$var$loadRecommendedOwner = async (config)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = (0, $i8MOh.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : [] // The current user should always be the first recommended user
    ], headers);
    const recommendedUserQuery = (0, $cxsgw.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $94bac5f8fcf7120c$var$MAX_SMART_DEFAULT_OPTIONS
        },
        headers: headers
    });
    const [initialUsersResponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersResponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return recommendedUserOptions;
};
const $94bac5f8fcf7120c$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence,
    (0, $b4tvS.ProductKeys).Focus
];
const $94bac5f8fcf7120c$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('owner');
const $94bac5f8fcf7120c$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'owner',
    products: [
        ...$94bac5f8fcf7120c$var$productKeys1P,
        ...$94bac5f8fcf7120c$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'owners',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $i8MOh.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $94bac5f8fcf7120c$var$loadRecommendedOwner(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return [];
            const response = await (0, $3Pbzb.getOwners)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
                maxNumberOfResults: $94bac5f8fcf7120c$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((owner)=>({
                    trackingKey: owner.id,
                    value: owner.id,
                    label: owner.name,
                    avatarUrl: owner.avatarUrl,
                    queryParamValue: owner.id,
                    product: config.product
                }));
        }
    }
});
module.exports["filter"] = $94bac5f8fcf7120c$export$3dea766d36a8935f;

});

parcelRegister("1sswv", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cOUgi = parcelRequire("cOUgi");


var $jreQ3 = parcelRequire("jreQ3");


var $bxnmj = parcelRequire("bxnmj");


var $aXWIB = parcelRequire("aXWIB");

const $0e27a4402a5009a7$export$29ee4a15a943675b = (0, $aXWIB.defineMessages)({
    all: {
        id: "search-page.filter.pageStatus.all",
        defaultMessage: "All"
    },
    roughDraft: {
        id: "search-page.filter.pageStatus.roughDraft",
        defaultMessage: "Rough draft"
    },
    inProgress: {
        id: "search-page.filter.pageStatus.inProgress",
        defaultMessage: "In progress"
    },
    readyForReview: {
        id: "search-page.filter.pageStatus.readyForReview",
        defaultMessage: "Ready for review"
    },
    verified: {
        id: "search-page.filter.pageStatus.verified",
        defaultMessage: "Verified"
    }
});


const $d364917c170d648d$export$3195c4e56ca4af29 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $0e27a4402a5009a7$export$29ee4a15a943675b)['all']) ?? '',
        product: config.product
    };
    const pageStatusOptions = (0, $bxnmj.allPageStatusFilterValueKeys).map((key)=>({
            value: (0, $bxnmj.PageStatusFilterValue)[key],
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $0e27a4402a5009a7$export$29ee4a15a943675b)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...pageStatusOptions
    ];
};


const $eaf2688e5c2f5e7e$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $eaf2688e5c2f5e7e$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('pageStatus');
const $eaf2688e5c2f5e7e$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $d364917c170d648d$export$3195c4e56ca4af29)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $eaf2688e5c2f5e7e$var$getInitialOptions = (config)=>{
    const allOptions = (0, $d364917c170d648d$export$3195c4e56ca4af29)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $eaf2688e5c2f5e7e$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'pageStatus',
    products: [
        ...$eaf2688e5c2f5e7e$var$productKeys1P,
        ...$eaf2688e5c2f5e7e$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pageStatus',
        fetcher: async (queryParams, config)=>{
            return $eaf2688e5c2f5e7e$var$loadQueryParams(queryParams, config);
        },
        generateQueryParamsGetState: $jreQ3.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $eaf2688e5c2f5e7e$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $eaf2688e5c2f5e7e$export$3dea766d36a8935f;

});

parcelRegister("jqLa8", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $1APZs = parcelRequire("1APZs");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $944ef057a61db4ac$var$LIMIT = 20;
const $944ef057a61db4ac$var$EmploymentTypeMapping = {
    Contingent: 'contingent',
    Employee: 'employee',
    Contractor: 'contractor'
};
const $944ef057a61db4ac$var$ReverseEmploymentTypeMapping = Object.fromEntries(Object.entries($944ef057a61db4ac$var$EmploymentTypeMapping).map(([key, value])=>[
        value,
        key
    ]));
const $944ef057a61db4ac$export$3362d5a8d7ac6a7b = (positionEmploymentType, product)=>{
    const value = $944ef057a61db4ac$var$EmploymentTypeMapping[positionEmploymentType.node.stringValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionEmploymentType.node.stringValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position employment types by search term
 * @param query
 * @param config
 * @returns
 */ const $944ef057a61db4ac$var$searchPositionEmploymentTypes = async (query, config)=>{
    const rqlQuery = `employmentType ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionEmploymentTypesResponse = await (0, $1APZs.positionEmploymentTypesQuery)(config.cloudId || '', rqlQuery, $944ef057a61db4ac$var$LIMIT, undefined, headers);
    const positionEmploymentTypes = positionEmploymentTypesResponse.data?.radar_fieldValues.edges ?? [];
    return positionEmploymentTypes.map((positionEmploymentType)=>$944ef057a61db4ac$export$3362d5a8d7ac6a7b(positionEmploymentType, config.product));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $944ef057a61db4ac$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `employmentType in ('${queryParams.map((param)=>$944ef057a61db4ac$var$ReverseEmploymentTypeMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionEmploymentTypesResponse = await (0, $1APZs.positionEmploymentTypesQuery)(config.cloudId || '', rqlQuery, $944ef057a61db4ac$var$LIMIT, undefined, headers);
    const positionEmploymentTypes = positionEmploymentTypesResponse.data?.radar_fieldValues.edges ?? [];
    return positionEmploymentTypes.map((positionEmploymentType)=>$944ef057a61db4ac$export$3362d5a8d7ac6a7b(positionEmploymentType, config.product));
};
const $944ef057a61db4ac$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $944ef057a61db4ac$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionEmploymentType',
    products: $944ef057a61db4ac$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionEmploymentTypes',
        fetcher: $944ef057a61db4ac$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $944ef057a61db4ac$var$searchPositionEmploymentTypes('', config);
        }
    },
    lookup: {
        fetcher: $944ef057a61db4ac$var$searchPositionEmploymentTypes
    }
});
module.exports["filter"] = $944ef057a61db4ac$export$3dea766d36a8935f;

});

parcelRegister("fLju9", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $d95gt = parcelRequire("d95gt");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $4f1eaa790ab361d5$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $4f1eaa790ab361d5$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $4f1eaa790ab361d5$var$searchPositionFocusAreas = async (query, config)=>{
    const mqlQuery = `(search LIKE '${query}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $4f1eaa790ab361d5$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$4f1eaa790ab361d5$var$mapFocusAreaResult(focusArea, config.product));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $4f1eaa790ab361d5$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $4f1eaa790ab361d5$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$4f1eaa790ab361d5$var$mapFocusAreaResult(focusArea, config.product));
};
const $4f1eaa790ab361d5$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $4f1eaa790ab361d5$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionFocusArea',
    products: $4f1eaa790ab361d5$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionFocusAreas',
        fetcher: $4f1eaa790ab361d5$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $4f1eaa790ab361d5$var$searchPositionFocusAreas('', config);
        }
    },
    lookup: {
        fetcher: $4f1eaa790ab361d5$var$searchPositionFocusAreas
    }
});
module.exports["filter"] = $4f1eaa790ab361d5$export$3dea766d36a8935f;

});

parcelRegister("dXdDw", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $gkPq5 = parcelRequire("gkPq5");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $22d3362090d0f2e1$var$LIMIT = 20;
const $22d3362090d0f2e1$var$mapPositionJobFamilyResult = (positionJobFamily, product)=>{
    const encodedValue = encodeURIComponent(positionJobFamily.node.stringValue);
    return {
        trackingKey: encodedValue || '',
        label: positionJobFamily.node.stringValue || '',
        value: encodedValue || '',
        queryParamValue: encodedValue || '',
        product: product
    };
};
/**
 * Queries position job families by search term
 * @param query
 * @param config
 * @returns
 */ const $22d3362090d0f2e1$var$searchPositionJobFamilies = async (query, config)=>{
    const rqlQuery = `jobFamily ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionJobFamiliesResponse = await (0, $gkPq5.positionJobFamiliesQuery)(config.cloudId || '', $22d3362090d0f2e1$var$LIMIT, rqlQuery, undefined, headers);
    const positionJobFamilies = positionJobFamiliesResponse.data?.radar_fieldValues.edges ?? [];
    return positionJobFamilies.map((positionJobFamily)=>$22d3362090d0f2e1$var$mapPositionJobFamilyResult(positionJobFamily, config.product));
};
/**
 * Queries all selected job families by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $22d3362090d0f2e1$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `jobFamily in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionJobFamiliesResponse = await (0, $gkPq5.positionJobFamiliesQuery)(config.cloudId || '', $22d3362090d0f2e1$var$LIMIT, rqlQuery, undefined, headers);
    const positionJobFamilies = positionJobFamiliesResponse.data?.radar_fieldValues.edges ?? [];
    return positionJobFamilies.map((positionJobFamily)=>$22d3362090d0f2e1$var$mapPositionJobFamilyResult(positionJobFamily, config.product));
};
const $22d3362090d0f2e1$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $22d3362090d0f2e1$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionJobFamily',
    products: $22d3362090d0f2e1$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionJobFamilies',
        fetcher: $22d3362090d0f2e1$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $22d3362090d0f2e1$var$searchPositionJobFamilies('', config);
        }
    },
    lookup: {
        fetcher: $22d3362090d0f2e1$var$searchPositionJobFamilies
    }
});
module.exports["filter"] = $22d3362090d0f2e1$export$3dea766d36a8935f;

});

parcelRegister("5eFo6", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $3FxSV = parcelRequire("3FxSV");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $161993d68cbd0f2a$var$LIMIT = 20;
const $161993d68cbd0f2a$var$StatusMapping = {
    Filled: 'filled',
    'Not filled': 'unfilled'
};
const $161993d68cbd0f2a$var$ReverseStatusMapping = Object.fromEntries(Object.entries($161993d68cbd0f2a$var$StatusMapping).map(([key, value])=>[
        value,
        key
    ]));
const $161993d68cbd0f2a$export$aa60679002fe2884 = (positionStatus, product)=>{
    const value = $161993d68cbd0f2a$var$StatusMapping[positionStatus.node.statusValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionStatus.node.statusDisplayValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position statuses by search term
 * @param query
 * @param config
 * @returns
 */ const $161993d68cbd0f2a$var$searchPositionStatuses = async (query, config)=>{
    const rqlQuery = `status ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionStatusesResponse = await (0, $3FxSV.positionStatusesQuery)(config.cloudId || '', $161993d68cbd0f2a$var$LIMIT, rqlQuery, undefined, headers);
    const positionStatuses = positionStatusesResponse.data?.radar_fieldValues.edges ?? [];
    return positionStatuses.map((positionStatus)=>$161993d68cbd0f2a$export$aa60679002fe2884(positionStatus, config.product));
};
/**
 * Queries all selected position statuses by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $161993d68cbd0f2a$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `status in ('${queryParams.map((param)=>$161993d68cbd0f2a$var$ReverseStatusMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionStatusesResponse = await (0, $3FxSV.positionStatusesQuery)(config.cloudId || '', $161993d68cbd0f2a$var$LIMIT, rqlQuery, undefined, headers);
    const positionStatuses = positionStatusesResponse.data?.radar_fieldValues.edges ?? [];
    return positionStatuses.map((positionStatus)=>$161993d68cbd0f2a$export$aa60679002fe2884(positionStatus, config.product));
};
const $161993d68cbd0f2a$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $161993d68cbd0f2a$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionStatus',
    products: $161993d68cbd0f2a$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionStatuses',
        fetcher: $161993d68cbd0f2a$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $161993d68cbd0f2a$var$searchPositionStatuses('', config);
        }
    },
    lookup: {
        fetcher: $161993d68cbd0f2a$var$searchPositionStatuses
    }
});
module.exports["filter"] = $161993d68cbd0f2a$export$3dea766d36a8935f;

});

parcelRegister("aeffu", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $eDERK = parcelRequire("eDERK");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");


var $cSPiD = parcelRequire("cSPiD");

// Number of results returned in dropdown
const $1de5e305b3bb3af1$var$LIMIT = 20;
const $1de5e305b3bb3af1$var$mapPositionTeamResult = (positionTeam, product)=>{
    return {
        trackingKey: positionTeam.node.ari || '',
        label: positionTeam.node.value?.displayName || '',
        value: positionTeam.node.ari || '',
        queryParamValue: encodeURIComponent(positionTeam.node.ari) || '',
        product: product,
        avatarUrl: positionTeam.node.value?.smallAvatarImageUrl || ''
    };
};
/**
 * Queries position teams by search term
 * @param query
 * @param config
 * @returns
 */ const $1de5e305b3bb3af1$var$searchPositionTeams = async (query, config)=>{
    const rqlQuery = `team ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionTeamsResponse = await (0, $eDERK.positionTeamsQuery)(config.cloudId || '', $1de5e305b3bb3af1$var$LIMIT, rqlQuery, undefined, headers);
    const positionTeams = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];
    return positionTeams.map((positionTeam)=>$1de5e305b3bb3af1$var$mapPositionTeamResult(positionTeam, config.product));
};
/**
 * Queries all selected position teams by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $1de5e305b3bb3af1$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `team in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionTeamsResponse = await (0, $eDERK.positionTeamsQuery)(config.cloudId || '', $1de5e305b3bb3af1$var$LIMIT, rqlQuery, undefined, headers);
    const positionTeams = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];
    return positionTeams.map((positionTeam)=>$1de5e305b3bb3af1$var$mapPositionTeamResult(positionTeam, config.product));
};
const $1de5e305b3bb3af1$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $1de5e305b3bb3af1$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionTeam',
    products: $1de5e305b3bb3af1$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionTeams',
        fetcher: $1de5e305b3bb3af1$var$getOptionsWithSelectionsFromQueryParams,
        generateQueryParamsGetState: $cSPiD.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $1de5e305b3bb3af1$var$searchPositionTeams('', config);
        }
    },
    lookup: {
        fetcher: $1de5e305b3bb3af1$var$searchPositionTeams
    }
});
module.exports["filter"] = $1de5e305b3bb3af1$export$3dea766d36a8935f;

});

parcelRegister("gHwfH", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $3paC4 = parcelRequire("3paC4");


var $iUYhn = parcelRequire("iUYhn");


var $1WLN3 = parcelRequire("1WLN3");


var $johDC = parcelRequire("johDC");


var $hB77E = parcelRequire("hB77E");


var $k8y62 = parcelRequire("k8y62");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $5jwMp = parcelRequire("5jwMp");

const $42927da814457d11$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $42927da814457d11$export$c4acd5097f11a5c9 = ({ projectKey: projectKey, name: name })=>{
    if (!projectKey) return name;
    const key = `(${projectKey})`;
    if (name.toLowerCase().includes(key.toLowerCase())) return name;
    return `${name} ${key}`;
};
const $42927da814457d11$var$searchProject = async (query, config)=>{
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    let searchProjectsResponse, searchedProjects;
    const product = config.product;
    if (product === (0, $b4tvS.ProductKeys).JiraDC || product === (0, $b4tvS.ProductKeys).JsmDC) {
        const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: config.cloudId,
            activationId: config.activationId,
            product: config.primaryProduct
        });
        searchProjectsResponse = await (0, $johDC.jiraDcProjectFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
                limit: 5,
                entities: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                product: (0, $b4tvS.ProductKeys).JiraDC,
                integration: config.selectedDatasource?.integrationAri,
                containerTypes: (0, $hB77E.getThirdPartyConfigs)().get(product)?.containerTypes
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return searchProjectsResponse?.data?.search?.search?.edges?.map((edge)=>({
                trackingKey: edge.node.entity.id,
                value: edge.node.entity.id,
                label: $42927da814457d11$export$c4acd5097f11a5c9({
                    projectKey: edge.node.entity.key,
                    name: edge.node.entity.displayName
                }),
                avatarUrl: edge?.node?.entity?.icon?.url,
                queryParamValue: edge.node.entity.id,
                product: config.product
            })) || [];
    }
    searchProjectsResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).JiraProject
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    searchedProjects = searchProjectsResponse.response.rawData.scopes.length > 0 ? searchProjectsResponse.response.rawData.scopes[0].results.map((projectResult)=>({
            projectId: projectResult.id,
            name: projectResult.name,
            projectKey: projectResult.attributes.projectKey,
            avatar: {
                small: 'url' in projectResult.attributes.avatar ? projectResult.attributes.avatar.url : undefined
            }
        })) : [];
    return searchedProjects.map((project)=>({
            trackingKey: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
            value: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
            label: $42927da814457d11$export$c4acd5097f11a5c9(project),
            avatarUrl: project.avatar?.small,
            queryParamValue: project.projectId,
            product: config.product
        }));
};
const $42927da814457d11$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $42927da814457d11$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('project');
const $42927da814457d11$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'project',
    products: [
        ...$42927da814457d11$var$productKeys1P,
        ...$42927da814457d11$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'jProject',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $b4tvS.ProductKeys).JiraDC || config.product === (0, $b4tvS.ProductKeys).JsmDC) {
                const initialProjectsResponse = await (0, $johDC.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    }
                });
                const projectOptions = initialProjectsResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return projectOptions || [];
            } else {
                const initialProjectARIs = queryParams.map((projectId)=>$42927da814457d11$var$projectIdToARI(config.cloudId || '', projectId));
                const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const initialProjectsResponse = await (0, $1WLN3.jiraProjectsQuery)(initialProjectARIs, headers);
                const initialProjects = initialProjectsResponse.data?.jira.jiraProjects ?? [];
                const allProjects = initialProjects;
                const projectOptions = allProjects.map((project)=>({
                        trackingKey: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
                        value: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
                        label: project.name,
                        avatarUrl: project.avatar?.small,
                        queryParamValue: project.projectId,
                        product: config.product
                    }));
                return projectOptions;
            }
        },
        generateQueryParamsGetState: $5jwMp.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $42927da814457d11$var$searchProject('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $42927da814457d11$var$searchProject(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).JiraDC || primaryProduct === (0, $b4tvS.ProductKeys).JsmDC || primaryProduct === (0, $b4tvS.ProductKeys).JiraServiceManagement || primaryProduct === (0, $b4tvS.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $42927da814457d11$export$3dea766d36a8935f;

});

parcelRegister("3TPSi", function(module, exports) {

var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $aXWIB = parcelRequire("aXWIB");

const $7dbfdb36b7652279$export$9baa81d83dcf973 = [
    'open',
    'merged',
    'declined',
    'draft',
    'unknown'
];
const $7dbfdb36b7652279$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    open: {
        id: "search-page.filter.pull-request-status.open",
        defaultMessage: "Open"
    },
    merged: {
        id: "search-page.filter.pull-request-status.merged",
        defaultMessage: "Merged"
    },
    declined: {
        id: "search-page.filter.pull-request-status.declined",
        defaultMessage: "Declined"
    },
    draft: {
        id: "search-page.filter.pull-request-status.draft",
        defaultMessage: "Draft"
    },
    unknown: {
        id: "search-page.filter.pull-request-status.unknown",
        defaultMessage: "Unknown"
    }
});


const $0bfe3423d4c08986$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('pullRequestStatus');
const $0bfe3423d4c08986$var$getAllPullRequestStatusOptions = (config)=>{
    const options = (0, $7dbfdb36b7652279$export$9baa81d83dcf973).map((status)=>({
            value: status,
            trackingKey: status,
            queryParamValue: status,
            isDefault: false,
            label: config.intl?.formatMessage((0, $7dbfdb36b7652279$export$a7357cdd1f0b0168)[status]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $0bfe3423d4c08986$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $0bfe3423d4c08986$var$getAllPullRequestStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $0bfe3423d4c08986$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'pullRequestStatus',
    products: [
        'bitbucket',
        ...$0bfe3423d4c08986$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pullRequestStatus',
        fetcher: async (queryParams, config)=>{
            return $0bfe3423d4c08986$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $0bfe3423d4c08986$var$getAllPullRequestStatusOptions(config);
        }
    }
});
module.exports["filter"] = $0bfe3423d4c08986$export$3dea766d36a8935f;

});

parcelRegister("f1JPm", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $3paC4 = parcelRequire("3paC4");


var $iUYhn = parcelRequire("iUYhn");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");

const $ed1c3ef37a9fe673$var$searchJiraCloudReporter = async (query, config, options)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $i8MOh.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchReporterQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).People
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchReporterReponse] = await Promise.all([
        initialUsersQuery,
        searchReporterQuery
    ]);
    const searchReporterResults = searchReporterReponse.response.rawData.scopes[0]?.results ?? [];
    const allReporters = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchReporterResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
};
const $ed1c3ef37a9fe673$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $ed1c3ef37a9fe673$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('reporter');
const $ed1c3ef37a9fe673$var$getProducts = ()=>[
        ...$ed1c3ef37a9fe673$var$productKeys1P,
        ...$ed1c3ef37a9fe673$var$products3PFromConfig
    ];
const $ed1c3ef37a9fe673$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'reporter',
    products: $ed1c3ef37a9fe673$var$getProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jReporter',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allReporters = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $ed1c3ef37a9fe673$var$searchJiraCloudReporter('', config, {
                initialOptions: true
            });
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $ed1c3ef37a9fe673$var$searchJiraCloudReporter(query, config);
        }
    }
});
module.exports["filter"] = $ed1c3ef37a9fe673$export$3dea766d36a8935f;

});

parcelRegister("dzNsR", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $johDC = parcelRequire("johDC");


var $hB77E = parcelRequire("hB77E");


var $7YJRT = parcelRequire("7YJRT");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $2GQhu = parcelRequire("2GQhu");


var $6Ea6j = parcelRequire("6Ea6j");

const $0df868ad61a6ba7f$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('repository');
const $0df868ad61a6ba7f$var$FETCH_LIMIT = 30;
/**
 * Calls AGG to fetch the user's accessible repositories for the currently-selected 3P datasource.
 */ const $0df868ad61a6ba7f$var$fetchRepositoryOptions = async (config, query = '')=>{
    if (!(0, $dh538.fg)('rovo_fps_show_repository_filter')) return [];
    const { cloudId: cloudId, product: product, primaryProduct: primaryProduct, activationId: activationId } = config;
    const integrationAri = config.selectedDatasource?.integrationAri ?? (product && (0, $b4tvS.is3pProductKey)(product) ? (0, $hB77E.getThirdPartyConfigs)().get(product)?.integrationAri : undefined);
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const response = await (0, $johDC.thirdPartyRepositoryFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: (0, $2GQhu.getCloudIdARI)(cloudId, primaryProduct),
            limit: $0df868ad61a6ba7f$var$FETCH_LIMIT,
            entities: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: [
                (0, $2Znam.NounSubtypeKey).Repository
            ]
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return response?.data?.search?.search?.edges?.map(({ node: node })=>{
        const name = node.entity?.name;
        if (!name) return undefined;
        return {
            value: name,
            trackingKey: name,
            queryParamValue: name,
            label: name,
            product: config.product,
            isDefault: false,
            isSelected: false,
            isSuggested: false
        };
    }).filter((option)=>option !== undefined) ?? [];
};
/**
 * Initial / pre-query options shown when the filter dropdown is first opened.
 */ const $0df868ad61a6ba7f$var$getInitialOptions = async (config)=>$0df868ad61a6ba7f$var$fetchRepositoryOptions(config);
/**
 * URL-hydration fetch. Resolves `?repository=...` values into
 * `SelectFilterOption`.
 */ const $0df868ad61a6ba7f$var$fetchQueryParams = async (queryParams, config)=>{
    if (queryParams.length === 0 || !(0, $dh538.fg)('rovo_fps_show_repository_filter')) return [];
    const allOptions = await $0df868ad61a6ba7f$var$fetchRepositoryOptions(config, queryParams.join(' '));
    const matched = allOptions.filter((option)=>queryParams.some((queryParam)=>option.value === queryParam)).map((option)=>({
            ...option,
            isSelected: true
        }));
    if (matched.length === queryParams.length) return matched;
    const matchedValues = new Set(matched.map((option)=>option.value));
    const fallback = queryParams.filter((queryParam)=>!matchedValues.has(queryParam)).map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            product: config.product,
            isSelected: true,
            isSuggested: false
        }));
    return [
        ...matched,
        ...fallback
    ];
};
/**
 * Lookup (typeahead) fetcher.
 */ const $0df868ad61a6ba7f$var$fetchLookupOptions = async (input, config)=>{
    if (!(0, $dh538.fg)('rovo_fps_show_repository_filter') || !input) return [];
    return $0df868ad61a6ba7f$var$fetchRepositoryOptions(config, input);
};
const $0df868ad61a6ba7f$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'repository',
    products: $0df868ad61a6ba7f$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'repository',
        fetcher: $0df868ad61a6ba7f$var$fetchQueryParams
    },
    initialOptions: {
        fetcher: $0df868ad61a6ba7f$var$getInitialOptions
    },
    lookup: {
        fetcher: $0df868ad61a6ba7f$var$fetchLookupOptions
    }
});
module.exports["filter"] = $0df868ad61a6ba7f$export$3dea766d36a8935f;

});

parcelRegister("720nW", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $2zk4m = parcelRequire("2zk4m");

const $d50e01f0d3f87cf6$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $d50e01f0d3f87cf6$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('salesforceStage');
const $d50e01f0d3f87cf6$var$fetchDynamicStageOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $2zk4m.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const opportunityStages = result.filters.find((f)=>f.name === 'opportunityStages');
        if (!opportunityStages || opportunityStages.values.length === 0) return [];
        return opportunityStages.values.map((stage)=>({
                value: stage.name,
                trackingKey: stage.name,
                queryParamValue: stage.name,
                isDefault: false,
                label: stage.label ?? stage.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
/**
 * Returns stage options — dynamic when the feature flag is on, and
 * an empty list when the feature flag is off.
 */ const $d50e01f0d3f87cf6$var$getStageOptions = async (config)=>{
    if ((0, $dh538.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) return $d50e01f0d3f87cf6$var$fetchDynamicStageOptions(config);
    return [];
};
const $d50e01f0d3f87cf6$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $d50e01f0d3f87cf6$var$getStageOptions(config);
    const matched = allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
    // If the API fetch returned no options (e.g. datasource not yet initialised on
    // initial URL load), fall back to synthetic options built from the raw query param
    // values so the store reflects hasSelection=true and shows the selected label in
    // the UI before the async fetch resolves.
    // Only apply this fallback when the flag is on — when off, the filter is disabled
    // and should not hydrate any state from query params.
    if (matched.length === 0 && queryParams.length > 0 && (0, $dh538.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) return queryParams.map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return matched;
};
const $d50e01f0d3f87cf6$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'salesforceStage',
    requiresTopLevel3PDatasource: true,
    products: [
        ...$d50e01f0d3f87cf6$var$salesforceProducts,
        ...$d50e01f0d3f87cf6$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'salesforceStages',
        fetcher: async (queryParams, config)=>{
            return $d50e01f0d3f87cf6$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $d50e01f0d3f87cf6$var$getStageOptions(config);
        }
    }
});
module.exports["filter"] = $d50e01f0d3f87cf6$export$3dea766d36a8935f;

});

parcelRegister("iz3ta", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $4qT1X = parcelRequire("4qT1X");

const $000856820a5317c1$export$c5dfc39e7764783c = 'searchSlackChannels';
const $000856820a5317c1$export$c94f0ac2580f3d4 = `
query ${$000856820a5317c1$export$c5dfc39e7764783c}($cloudId: ID!, $limit: Int) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartySlackChannels(limit: $limit) {
        channels {
          id
          name
          isPrivate
        }
        nextCursor
      }
    }
  }
}`;
const $000856820a5317c1$export$4b8a3f4aff3d6261 = ()=>$000856820a5317c1$export$c94f0ac2580f3d4;


const $2edf39d6904e32af$export$74d737bad7014c80 = async ({ cloudId: cloudId, limit: limit, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    try {
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: (0, $000856820a5317c1$export$4b8a3f4aff3d6261)(),
            variables: {
                cloudId: cloudId,
                ...limit !== undefined && {
                    limit: limit
                }
            },
            operationName: (0, $000856820a5317c1$export$c5dfc39e7764783c),
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const payload = response.data?.search?.configuration?.thirdPartySlackChannels ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $000856820a5317c1$export$c5dfc39e7764783c)}] GraphQL errors for cloudId "${cloudId}":`, response.errors);
            if (!payload) throw new Error(`[${(0, $000856820a5317c1$export$c5dfc39e7764783c)}] GraphQL errors prevented loading Slack channels for cloudId "${cloudId}"`);
        }
        return payload;
    } catch (error) {
        console.error(`[${(0, $000856820a5317c1$export$c5dfc39e7764783c)}] Failed to fetch Slack channels:`, error);
        throw error;
    }
};



var $dOOW1 = parcelRequire("dOOW1");

/**
 * Generic fuzzy matching utility for filtering select filter options client-side.
 *
 * ## Normalization
 * Both the query and candidate text are normalized before comparison by:
 *   - Converting to lowercase
 *   - Stripping all non-alphanumeric characters (hyphens, underscores, spaces, punctuation, etc.)
 *
 * This means "trex" will match "t-rex", "t_rex", "T.Rex", "(T)Rex", etc.
 *
 * ## Matching strategy (applied to normalized strings)
 * 1. **Substring match** — normalized candidate contains normalized query as a contiguous substring.
 *    e.g. "flu" matches "confluence" → "confluence"
 * 2. **Subsequence match** — every character in the normalized query appears in the normalized
 *    candidate in the same relative order (but not necessarily contiguous).
 *    e.g. "cnf" matches "confluence" → "cnflue**n**ce" (c…n…f)
 *
 * An empty query matches everything.
 */ /** Strip all non-alphanumeric characters and lowercase. */ const $78f17cda00f34378$var$normalize = (text)=>text.toLowerCase().replace(/[^a-z0-9]/g, '');
/**
 * Returns true if every character in `query` appears in `text` in the same
 * relative order (subsequence match).
 */ const $78f17cda00f34378$var$isSubsequence = (text, query)=>{
    let queryIndex = 0;
    for(let i = 0; i < text.length && queryIndex < query.length; i++)if (text[i] === query[queryIndex]) queryIndex++;
    return queryIndex === query.length;
};
const $78f17cda00f34378$export$3ace64ce5180d918 = (query, candidate)=>{
    const normalizedQuery = $78f17cda00f34378$var$normalize(query);
    // Empty query matches everything
    if (!normalizedQuery) return true;
    const normalizedCandidate = $78f17cda00f34378$var$normalize(candidate);
    // Nothing left after stripping non-alphanumeric — can't match a non-empty query
    if (!normalizedCandidate) return false;
    // 1. Substring match (faster — try first)
    if (normalizedCandidate.includes(normalizedQuery)) return true;
    // 2. Subsequence match
    return $78f17cda00f34378$var$isSubsequence(normalizedCandidate, normalizedQuery);
};
const $78f17cda00f34378$export$775f9687cb3a8d8b = (query, items, getText)=>{
    if (!query) return items;
    return items.filter((item)=>$78f17cda00f34378$export$3ace64ce5180d918(query, getText(item)));
};



var $6Ea6j = parcelRequire("6Ea6j");

const $e3ef5d21a9795f09$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('slackChannel');
// 200 recommended by Slack as the max per request
// Select Filter does not support pagination, but the backend API does via cursor
// This filter can be enhanced in the future to support pagination on scroll/search if needed
const $e3ef5d21a9795f09$var$MAX_CHANNELS_TO_FETCH = 200;
/**
 * Session-level cache: maps cloudId → in-flight or resolved promise of channel options.
 * This deduplicates concurrent and repeated calls (e.g. queryParams.fetcher + initialOptions.fetcher
 * both fire on page load when a channel is pre-selected via URL param).
 * The cache is module-level so it persists for the browser session but resets on page navigation.
 */ const $e3ef5d21a9795f09$var$channelOptionsCache = new Map();
const $e3ef5d21a9795f09$export$687cc7f9972f010f = ()=>$e3ef5d21a9795f09$var$channelOptionsCache.clear();
async function $e3ef5d21a9795f09$var$doFetchSlackChannels(config) {
    const { cloudId: cloudId } = config;
    if (!cloudId) throw new Error('Cloud ID is required to fetch Slack channels');
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    try {
        const payload = await (0, $2edf39d6904e32af$export$74d737bad7014c80)({
            cloudId: cloudId,
            limit: $e3ef5d21a9795f09$var$MAX_CHANNELS_TO_FETCH,
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return (payload?.channels ?? []).map((channel)=>({
                value: channel.name,
                trackingKey: channel.id,
                queryParamValue: channel.name,
                label: channel.name,
                isDefault: false,
                isSelected: false,
                isSuggested: false,
                product: config.product
            }));
    } catch  {
        return [];
    }
}
const $e3ef5d21a9795f09$var$fetchSlackChannelOptions = (config)=>{
    const { cloudId: cloudId } = config;
    if (!cloudId) return Promise.resolve([]);
    // Return cached promise (handles both in-flight dedup and session-level caching).
    // If the fetch returns an empty result (e.g. network blip, auth error — doFetchSlackChannels
    // catches internally and returns []) or rejects unexpectedly, remove the cache entry so a
    // subsequent open/retry can attempt a fresh fetch rather than returning stale empty results.
    if (!$e3ef5d21a9795f09$var$channelOptionsCache.has(cloudId)) {
        const promise = $e3ef5d21a9795f09$var$doFetchSlackChannels(config);
        $e3ef5d21a9795f09$var$channelOptionsCache.set(cloudId, promise);
        promise.then((channels)=>{
            if (channels.length === 0) $e3ef5d21a9795f09$var$channelOptionsCache.delete(cloudId);
        }).catch(()=>{
            $e3ef5d21a9795f09$var$channelOptionsCache.delete(cloudId);
        });
    }
    return $e3ef5d21a9795f09$var$channelOptionsCache.get(cloudId);
};
const $e3ef5d21a9795f09$var$fetchQueryParams = async (queryParams, config)=>{
    // Hydrate selected channel names from URL params by client-side filtering
    // the full fetched list — no extra API call needed.
    const allOptions = await $e3ef5d21a9795f09$var$fetchSlackChannelOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $e3ef5d21a9795f09$var$lookupChannels = async (query, config)=>{
    const allOptions = await $e3ef5d21a9795f09$var$fetchSlackChannelOptions(config);
    if (!query) return allOptions;
    return (0, $78f17cda00f34378$export$775f9687cb3a8d8b)(query, allOptions, (option)=>option.label);
};
const $e3ef5d21a9795f09$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'slackChannel',
    products: $e3ef5d21a9795f09$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'slackChannels',
        fetcher: async (queryParams, config)=>{
            return $e3ef5d21a9795f09$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $e3ef5d21a9795f09$var$fetchSlackChannelOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $e3ef5d21a9795f09$var$lookupChannels(query, config);
        }
    }
});
module.exports["filter"] = $e3ef5d21a9795f09$export$3dea766d36a8935f;

});

parcelRegister("fJFyr", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");


var $cOUgi = parcelRequire("cOUgi");


var $aXWIB = parcelRequire("aXWIB");

const $7a5ccdfced43df4c$export$b351dad7e43554a2 = (0, $aXWIB.defineMessages)({
    relevance: {
        id: "relevance",
        defaultMessage: "Relevance"
    },
    updatedNewest: {
        id: "updatedNewest",
        defaultMessage: "Updated (newest)"
    },
    updatedOldest: {
        id: "updatedOldest",
        defaultMessage: "Updated (oldest)"
    },
    createdNewest: {
        id: "createdNewest",
        defaultMessage: "Created (newest)"
    },
    createdOldest: {
        id: "createdOldest",
        defaultMessage: "Created (oldest)"
    }
});


const $51425ca68cc0e4db$var$SORT_VALUES = [
    'updatedNewest',
    'updatedOldest',
    'createdNewest',
    'createdOldest'
];
const $51425ca68cc0e4db$var$sortCompareFn = (a, b)=>{
    return $51425ca68cc0e4db$var$SORT_VALUES.indexOf(a.queryParamValue) - $51425ca68cc0e4db$var$SORT_VALUES.indexOf(b.queryParamValue);
};
const $51425ca68cc0e4db$var$products = [
    (0, $b4tvS.ProductKeys).Confluence,
    (0, $b4tvS.ProductKeys).Jira
];
const $51425ca68cc0e4db$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'sort',
    products: $51425ca68cc0e4db$var$products,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'sort',
        fetcher: async (_, config)=>{
            return $51425ca68cc0e4db$var$SORT_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value]) || (0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: (0, $fKv9F.Sort).Relevance,
                    label: config.intl?.formatMessage((0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[(0, $fKv9F.Sort).Relevance]) || (0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[(0, $fKv9F.Sort).Relevance].defaultMessage,
                    value: (0, $fKv9F.Sort).Relevance,
                    isDefault: true,
                    queryParamValue: (0, $fKv9F.Sort).Relevance,
                    product: config.product
                },
                ...$51425ca68cc0e4db$var$SORT_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value]) || (0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $51425ca68cc0e4db$var$sortCompareFn,
    isSuggestedFilter: (primaryProduct)=>(primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).Confluence) && (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters')
});
module.exports["filter"] = $51425ca68cc0e4db$export$3dea766d36a8935f;

});

parcelRegister("b6IhR", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $gY9AU = parcelRequire("gY9AU");


var $6Ea6j = parcelRequire("6Ea6j");


var $aXWIB = parcelRequire("aXWIB");

const $95a633f70dbb240b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    OPEN: {
        id: "search-page.filter.status.open",
        defaultMessage: "Open"
    },
    DONE: {
        id: "search-page.filter.status.done",
        defaultMessage: "Done"
    },
    INDETERMINATE: {
        id: "search-page.filter.status.indeterminate",
        defaultMessage: "In Progress (Open)"
    },
    UNDEFINED: {
        id: "search-page.filter.status.undefined",
        defaultMessage: "Other"
    },
    NEW: {
        id: "search-page.filter.status.new",
        defaultMessage: "To Do (Open)"
    }
});


const $10d02868537a5b25$var$getProductKeys1P = ()=>{
    return [
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ];
};
const $10d02868537a5b25$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('statusFilter');
const $10d02868537a5b25$var$getAllIssueStatusOptions = (config)=>{
    // Only use allowedJiraIssueStatuses values for Jira issue statuses or else it will be ignored in
    // the GraphQL query request. See the getJiraIssueStatusFilterOptions function.
    const options = (0, $gY9AU.allowedJiraIssueStatuses).filter((status)=>{
        if (!(0, $dh538.fg)('rovo_search_in_jira_granular_status_filters')) return status === 'OPEN' || status === 'DONE';
        else return status !== 'OPEN';
    }).map((issueStatus)=>({
            value: issueStatus,
            trackingKey: issueStatus,
            queryParamValue: issueStatus,
            isDefault: false,
            label: config.intl?.formatMessage((0, $95a633f70dbb240b$export$a7357cdd1f0b0168)[issueStatus]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $10d02868537a5b25$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $10d02868537a5b25$var$getAllIssueStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $10d02868537a5b25$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'statusFilter',
    // This also sets the `id=statusFilter` attribute and unfortunately `id=status` contains a global CSS target
    products: [
        ...$10d02868537a5b25$var$getProductKeys1P(),
        ...$10d02868537a5b25$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'status',
        fetcher: async (queryParams, config)=>{
            return $10d02868537a5b25$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $10d02868537a5b25$var$getAllIssueStatusOptions(config);
        }
    }
});
module.exports["filter"] = $10d02868537a5b25$export$3dea766d36a8935f;

});

parcelRegister("iaYRG", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $d7ef0e88ac518c51$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $d7ef0e88ac518c51$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('onlyTitleMatch');
const $d7ef0e88ac518c51$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'onlyTitleMatch',
    queryParams: {
        key: 'titleMatch'
    },
    products: [
        ...$d7ef0e88ac518c51$var$productKeys1P,
        ...$d7ef0e88ac518c51$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $d7ef0e88ac518c51$export$3dea766d36a8935f;

});

parcelRegister("dUIpv", function(module, exports) {

var $5iakG = parcelRequire("5iakG");


var $b4tvS = parcelRequire("b4tvS");


var $cOUgi = parcelRequire("cOUgi");


var $3JX0d = parcelRequire("3JX0d");

const $8238dcc2ebd02683$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $3JX0d.getAllTypeOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $8238dcc2ebd02683$var$getInitialOptions = (config)=>{
    const allOptions = (0, $3JX0d.getAllTypeOptions)(config);
    return allOptions.map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $8238dcc2ebd02683$var$sortCompareFn = (a, b)=>{
    const allOption = (0, $3JX0d.getAllTypeOptions)({
        intl: undefined
    });
    return allOption.findIndex((option)=>option.queryParamValue === a.queryParamValue) - allOption.findIndex((option)=>option.queryParamValue === b.queryParamValue);
};
const $8238dcc2ebd02683$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: (0, $5iakG.universalTypeFilterId),
    products: (0, $b4tvS.allProductKeys),
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'type',
        fetcher: async (queryParams, config)=>{
            return $8238dcc2ebd02683$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8238dcc2ebd02683$var$getInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            // NOTE: this is the first step of filtering options
            //  the store does product specific filtering
            return (0, $3JX0d.lookupOptions)(query, config);
        }
    },
    sortCompareFn: $8238dcc2ebd02683$var$sortCompareFn
});
module.exports["filter"] = $8238dcc2ebd02683$export$3dea766d36a8935f;

});

parcelRegister("bF9JE", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $fdf2d9a71ec7e494$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $fdf2d9a71ec7e494$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('verified');
const $fdf2d9a71ec7e494$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'verified',
    queryParams: {
        key: 'verified'
    },
    products: [
        ...$fdf2d9a71ec7e494$var$productKeys1P,
        ...$fdf2d9a71ec7e494$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $fdf2d9a71ec7e494$export$3dea766d36a8935f;

});

parcelRegister("9DkM9", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $cxQs0 = parcelRequire("cxQs0");

const $2f03852ff203b88b$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $2f03852ff203b88b$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'watchedByMe',
    queryParams: {
        key: 'jWatchedByMe'
    },
    products: [
        ...$2f03852ff203b88b$var$productKeys1P
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $2f03852ff203b88b$export$3dea766d36a8935f;

});

parcelRegister("iQfUJ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $2XcAT = parcelRequire("2XcAT");

const $aee4092edb99d139$export$d2312e68e1f5ad00 = ({ initial: initial, state: state, config: config })=>{
    return (options)=>{
        const productBasedOptionsFilter = (0, $dh538.fg)('product_based_filter_options') ? (option)=>{
            return option.product === (0, $2XcAT.getProductForFilterOption)({
                config: config,
                isUniversal: initial.universal
            });
        } : ()=>true;
        const allSelectedValues = new Set([
            ...state.queryParams.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.initialOptions.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.lookup.options.filter(productBasedOptionsFilter).filter((lookupOption)=>lookupOption.isSelected).map((option)=>option.value)
        ]);
        if (options.isLookupActive) {
            const lookupResults = state.lookup.lookupResultOptions.map((option)=>({
                    ...option,
                    isSelected: allSelectedValues.has(option.value)
                })).sort((option1, option2)=>Number(option2.isSelected) - Number(option1.isSelected));
            return lookupResults;
        }
        const duplicateOptions = new Set();
        const newOptions = [
            ...state.queryParams.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.options,
            ...state.initialOptions.options
        ].filter(productBasedOptionsFilter).filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSelected: allSelectedValues.has(option.value)
            }));
        if (initial.sortCompareFn) return newOptions.sort(initial.sortCompareFn);
        return newOptions;
    };
};
module.exports["getOptions"] = $aee4092edb99d139$export$d2312e68e1f5ad00;

});

parcelRegister("6Ea6j", function(module, exports) {

var $k1VvQ = parcelRequire("k1VvQ");


var $8vGYx = parcelRequire("8vGYx");


var $iQfUJ = parcelRequire("iQfUJ");

const $bbb289b791cf3bdd$export$9c05e038f495cba8 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'multi-select',
        didMount: false,
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $8vGYx.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$bbb289b791cf3bdd$export$63027158d47e5479({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$bbb289b791cf3bdd$export$63027158d47e5479({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $bbb289b791cf3bdd$export$63027158d47e5479 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $k1VvQ.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $k1VvQ.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $k1VvQ.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $k1VvQ.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: (0, $k1VvQ.setOption)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $k1VvQ.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $k1VvQ.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $k1VvQ.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $k1VvQ.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
module.exports["createMultiSelectFilter"] = $bbb289b791cf3bdd$export$9c05e038f495cba8;
module.exports["MultiSelectFilter"] = $bbb289b791cf3bdd$export$63027158d47e5479;

});

parcelRegister("k1VvQ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $iQfUJ = parcelRequire("iQfUJ");


var $2XcAT = parcelRequire("2XcAT");


const $a744869393e3dad8$export$639eaf0f64f8fe4 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: $a744869393e3dad8$export$50fdfeece43146fd({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $a744869393e3dad8$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $a744869393e3dad8$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: $a744869393e3dad8$export$ad6c12f692e14555({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $a744869393e3dad8$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: $a744869393e3dad8$export$69017055aa8b346e({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: $a744869393e3dad8$export$92164aa84e23cd67({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: $a744869393e3dad8$export$bf7199a9ebcb84a9({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: $a744869393e3dad8$export$d0f857db6e3e26d7({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $a744869393e3dad8$export$50fdfeece43146fd = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = filter.getOptions({
            isLookupActive: false
        });
        const newOptions = filter.getOptions({
            isLookupActive: state.lookup.isActive
        });
        const selectedOptions = allOptions.filter((option)=>option.isSelected);
        const newState = {
            ...state,
            options: newOptions,
            selectedOptions: selectedOptions,
            hasSelection: selectedOptions.length > 0,
            value: filter.getValue()
        };
        return newState;
    };
};
const $a744869393e3dad8$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const filterWithNewOptions = filter.setOption(newOptions);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $a744869393e3dad8$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamValue = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.queryParamValue);
        return {
            [initial.queryParams.key]: queryParamValue
        };
    };
};
const $a744869393e3dad8$export$ad6c12f692e14555 = ({ initial: initial, state: state, config: config })=>{
    return async (onStateChange)=>{
        const didMount = (0, $dh538.fg)('product_based_filter_options') ? state.didMountPerProducts[(0, $2XcAT.getProductForFilterOption)({
            config: config,
            isUniversal: initial.universal
        })] : state.didMount;
        if (didMount) // Already loaded — return the current monad without dispatching a state change.
        // Calling onStateChange here would cause a no-op store write (new object identity
        // for the same data), which makes downstream selectors that return derived references
        // (e.g. useFilters() consumers that compute new arrays/Sets) re-render. When the
        // caller is a useEffect that depends on derived values, this can trigger an
        // infinite render loop. The store should only change when something actually changed.
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const newOptions = [
            ...state.initialOptions.options
        ];
        const fetcher = initial.initialOptions?.fetcher;
        if (fetcher) {
            const fetchingInitialOptionsState = {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    isLoading: true
                }
            };
            onStateChange?.(fetchingInitialOptionsState);
            try {
                const fetchedOptions = await fetcher(config);
                fetchedOptions.forEach((option)=>{
                    const mappedOption = {
                        isSelected: false,
                        trackingKey: option.trackingKey,
                        value: option.value,
                        queryParamValue: option.queryParamValue,
                        isSuggested: true,
                        isDefault: option.isDefault ?? false,
                        avatarUrl: option.avatarUrl,
                        label: option.label,
                        metadata: option.metadata,
                        product: (0, $2XcAT.getProductForFilterOption)({
                            config: config,
                            isUniversal: initial.universal
                        })
                    };
                    newOptions.push(mappedOption);
                });
            } catch  {
                const fetchFailedState = {
                    ...state,
                    initialOptions: {
                        ...state.initialOptions,
                        isLoading: false
                    }
                };
                onStateChange?.(fetchFailedState);
            }
        }
        const newInitialOptionsState = {
            ...state,
            didMount: true,
            didMountPerProducts: (0, $dh538.fg)('product_based_filter_options') ? {
                ...state.didMountPerProducts,
                [(0, $2XcAT.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })]: true
            } : state.didMountPerProducts,
            initialOptions: {
                ...state.initialOptions,
                options: newOptions,
                isLoading: false
            }
        };
        onStateChange?.(newInitialOptionsState);
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: newInitialOptionsState,
            config: config
        });
    };
};
const $a744869393e3dad8$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const optionsToChangeRecord = Object.fromEntries(optionsToChange.map((option)=>[
                option.value,
                option
            ]));
        const allExistingValues = new Set([
            ...state.queryParams.options.map((o)=>o.value),
            ...state.initialOptions.options.map((o)=>o.value),
            ...state.lookup.options.map((o)=>o.value),
            ...state.lookup.lookupResultOptions.map((o)=>o.value)
        ]);
        // Options being selected that don't exist in any list yet (e.g. dynamic async-loaded options
        // selected before the store has been populated) are added directly to queryParams.options so
        // they participate in URL param generation immediately.
        const newQueryParamOptions = optionsToChange.filter((o)=>o.isSelected && !allExistingValues.has(o.value)).map((o)=>({
                value: o.value,
                queryParamValue: o.value,
                trackingKey: o.value,
                label: o.value,
                isSelected: true,
                isSuggested: false,
                isDefault: false,
                product: (0, $2XcAT.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })
            }));
        const queryParamOptions = [
            ...state.queryParams.options.map((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value && ((0, $dh538.fg)('product_based_filter_options') ? (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    }) === option.product : true))) return option;
                return {
                    ...option,
                    isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
                };
            }),
            ...newQueryParamOptions
        ];
        const initialOptions = state.initialOptions.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value && ((0, $dh538.fg)('product_based_filter_options') ? (0, $2XcAT.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                }) === option.product : true))) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const duplicateOptions = new Set();
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSuggested: true,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? option.isSelected
            }));
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $a744869393e3dad8$export$69017055aa8b346e = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamOptions = state.queryParams.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const initialOptions = state.initialOptions.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const lookupOptions = state.lookup.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $a744869393e3dad8$export$92164aa84e23cd67 = ({ initial: initial, state: state, config: config })=>{
    return async (query, onStateChange)=>{
        if (!initial.lookup || query.length === 0 || state.lookup.input === query) {
            const noQueryState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: false
                }
            };
            onStateChange?.(noQueryState);
            return $a744869393e3dad8$export$639eaf0f64f8fe4({
                initial: initial,
                state: noQueryState,
                config: config
            });
        }
        const fetchingLookupOptionsState = {
            ...state,
            lookup: {
                ...state.lookup,
                input: query,
                isLoading: true,
                isActive: true
            }
        };
        onStateChange?.(fetchingLookupOptionsState);
        try {
            const fetchedLookupOptions = await initial.lookup.fetcher(query, config);
            const newLookupOptions = fetchedLookupOptions.map((option)=>{
                const mappedOption = {
                    isSelected: false,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                return mappedOption;
            });
            const newLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    lookupResultOptions: newLookupOptions,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(newLookupOptionsState);
            return $a744869393e3dad8$export$639eaf0f64f8fe4({
                initial: initial,
                state: newLookupOptionsState,
                config: config
            });
        } catch  {
            const failedLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(failedLookupOptionsState);
            return $a744869393e3dad8$export$639eaf0f64f8fe4({
                initial: initial,
                state: failedLookupOptionsState,
                config: config
            });
        }
    };
};
const $a744869393e3dad8$export$bf7199a9ebcb84a9 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.value);
    };
};
const $a744869393e3dad8$export$d0f857db6e3e26d7 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = [
            ...filter.getOptions({
                isLookupActive: true
            }),
            ...filter.getOptions({
                isLookupActive: false
            })
        ].map((option)=>({
                value: option.value,
                isSelected: false
            }));
        return filter.setOption(allOptions);
    };
};
module.exports["getState"] = $a744869393e3dad8$export$50fdfeece43146fd;
module.exports["getQueryParams"] = $a744869393e3dad8$export$e2de15bbd9edf9c6;
module.exports["setQueryParams"] = $a744869393e3dad8$export$7755017099c85a0d;
module.exports["loadInitialOptions"] = $a744869393e3dad8$export$ad6c12f692e14555;
module.exports["setOption"] = $a744869393e3dad8$export$b2a7969df3fe0aa3;
module.exports["clearOptions"] = $a744869393e3dad8$export$69017055aa8b346e;
module.exports["setLookupInput"] = $a744869393e3dad8$export$92164aa84e23cd67;
module.exports["getValue"] = $a744869393e3dad8$export$bf7199a9ebcb84a9;
module.exports["deselectOptions"] = $a744869393e3dad8$export$d0f857db6e3e26d7;

});

parcelRegister("8vGYx", function(module, exports) {
const $5ee914132ae7909c$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        return {
            ...initialState,
            value: queryParamValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $5ee914132ae7909c$export$64e49a0c7bd6f7a0;

});

parcelRegister("5A2fk", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");

const $c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY = 'atlassian.unified-search.oauth-banner-dismiss-counts';
const $c8070074de509682$export$afe8c16e492e553f = (product, enforceMaxDismissals)=>{
    const dismissCounts = $c8070074de509682$var$getLocalStorageData();
    const hasUserDismissedThisProductBefore = (dismissCounts[product] ?? 0) > 0;
    if (enforceMaxDismissals) return !(hasUserDismissedThisProductBefore || $c8070074de509682$export$67e3eb5caec4ff4c(dismissCounts));
    return !hasUserDismissedThisProductBefore;
};
/**
 * The max number of times the user dismisses **across products**
 */ const $c8070074de509682$var$MAX_DISMISSALS = 4;
const $c8070074de509682$export$67e3eb5caec4ff4c = (dismissCounts)=>{
    const totalDismissalsAcrossProducts = Object.values(dismissCounts).reduce((prev, curr)=>(prev ?? 0) + (curr ?? 0), 0);
    return (totalDismissalsAcrossProducts ?? 0) >= $c8070074de509682$var$MAX_DISMISSALS;
};
const $c8070074de509682$export$94f957a0ee1d39c8 = (product)=>{
    const dismissCounts = $c8070074de509682$var$getLocalStorageData();
    dismissCounts[product] = (dismissCounts[product] ?? 0) + 1;
    $c8070074de509682$var$saveToLocalStorage(dismissCounts);
};
/**
 * @returns the local storage object that stores products and their dismiss counts
 */ const $c8070074de509682$var$getLocalStorageData = ()=>{
    const serializedDismissCounts = (0, $5G9KX.getLocalStorageItemAsString)($c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY);
    if (!serializedDismissCounts) return {};
    let localStorageObject;
    try {
        localStorageObject = JSON.parse(serializedDismissCounts);
    } catch  {
        return {};
    }
    return localStorageObject;
};
/**
 * Saves the local storage object that stores products and their dismiss counts
 */ const $c8070074de509682$var$saveToLocalStorage = (localStorageObject)=>{
    (0, $5G9KX.setLocalStorageItem)($c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY, JSON.stringify(localStorageObject));
};
const $c8070074de509682$export$f24b3540a3490d2b = 'atlassian.unified-search.oauth-banner-snooze';
const $c8070074de509682$export$fa2e89afea4272f6 = 86400000;
const $c8070074de509682$export$b05c8721285367dc = [
    1,
    1,
    1,
    90
];
/**
 * @returns the full snooze data object from localStorage, or an empty object
 * if absent or unparseable.
 */ const $c8070074de509682$var$getSnoozeData = ()=>{
    try {
        const raw = (0, $5G9KX.getLocalStorageItemAsString)($c8070074de509682$export$f24b3540a3490d2b);
        if (!raw) return {};
        return JSON.parse(raw);
    } catch  {
        return {};
    }
};
/**
 * Persists the snooze data object to localStorage.
 */ const $c8070074de509682$var$saveSnoozeData = (data, logException)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)($c8070074de509682$export$f24b3540a3490d2b, JSON.stringify(data));
    } catch (error) {
        logException?.(error);
    }
};
const $c8070074de509682$export$2951fa9679f910c = (product)=>{
    const entry = $c8070074de509682$var$getSnoozeData()[product];
    if (!entry) return false;
    return Date.now() < entry.expiresAt;
};
const $c8070074de509682$export$4322d9b6ec307e17 = (product)=>{
    return $c8070074de509682$var$getSnoozeData()[product]?.dismissalCount ?? 0;
};
const $c8070074de509682$export$e173328a0c65b798 = (product, logException)=>{
    const data = $c8070074de509682$var$getSnoozeData();
    const storedCount = data[product]?.dismissalCount ?? 0;
    // If the previous cycle has completed (count === SNOOZE_DAYS.length),
    // reset to index 0 to restart the cycle on this dismiss.
    const dismissIndex = storedCount >= $c8070074de509682$export$b05c8721285367dc.length ? 0 : storedCount;
    const durationDays = $c8070074de509682$export$b05c8721285367dc[dismissIndex];
    const expiresAt = Date.now() + durationDays * $c8070074de509682$export$fa2e89afea4272f6;
    // The new stored count is the index we just used plus 1. This means after
    // the 4th dismiss the count is 4 (used to detect cycle completion on the
    // 5th dismiss), and after the 5th dismiss it resets to 1.
    const nextCount = dismissIndex + 1;
    data[product] = {
        expiresAt: expiresAt,
        dismissalCount: nextCount
    };
    $c8070074de509682$var$saveSnoozeData(data, logException);
};
module.exports["shouldShowOAuthBanner"] = $c8070074de509682$export$afe8c16e492e553f;
module.exports["increaseProductDismissCount"] = $c8070074de509682$export$94f957a0ee1d39c8;
module.exports["isProductSnoozed"] = $c8070074de509682$export$2951fa9679f910c;
module.exports["snoozeProduct"] = $c8070074de509682$export$e173328a0c65b798;

});

parcelRegister("dnIVK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ckkm9 = parcelRequire("ckkm9");


var $gRvZB = parcelRequire("gRvZB");


var $1ymk3 = parcelRequire("1ymk3");


var $3CshZ = parcelRequire("3CshZ");

const $8aec6073a00f3ac5$export$694cb0e3f167dbc8 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthStarted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $8aec6073a00f3ac5$export$cbd7e681ca5b8fd4 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthCompleted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $8aec6073a00f3ac5$export$cff3d5cd941b3b4d = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthFailed)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $8aec6073a00f3ac5$export$3168f7d5a2074317 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthConnectHovered)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
module.exports["useFireOAuthStarted"] = $8aec6073a00f3ac5$export$694cb0e3f167dbc8;
module.exports["useFireOAuthCompleted"] = $8aec6073a00f3ac5$export$cbd7e681ca5b8fd4;
module.exports["useFireOAuthFailed"] = $8aec6073a00f3ac5$export$cff3d5cd941b3b4d;
module.exports["useFireOAuthHovered"] = $8aec6073a00f3ac5$export$3168f7d5a2074317;

});

parcelRegister("kP8IJ", function(module, exports) {
const $0bc2da65dd976c36$export$bb417e0702eb86b5 = (isSelected)=>{
    if (isSelected) return "var(--ds-icon-selected, #1868DB)";
    return "var(--ds-icon-subtle, #505258)";
};
module.exports["getIconColor"] = $0bc2da65dd976c36$export$bb417e0702eb86b5;

});

parcelRegister("9bPlJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd6c6061ead1c7bf826f9b8997aa8670>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b0cf9138ae8faa3$var$_react = $6b0cf9138ae8faa3$var$_interopRequireDefault((parcelRequire("42omo")));

var $6b0cf9138ae8faa3$var$_baseNew = $6b0cf9138ae8faa3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6b0cf9138ae8faa3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Signature".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Toggle author visibility on sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b0cf9138ae8faa3$var$SignatureIcon = (props)=>/*#__PURE__*/ $6b0cf9138ae8faa3$var$_react.default.createElement($6b0cf9138ae8faa3$var$_baseNew.default, Object.assign({
        name: "SignatureIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 14H0v-1.5h16zM2.83 2.27c.62-.41 1.4-.47 2.24-.24.58.15 1.03.48 1.32.95.28.45.39.98.38 1.49-.02 1.01-.47 2.14-1.16 3.1-.33.46-.74.93-1.18 1.38q.03.03.05.06c.32.33.62.48.88.5.24.02.57-.05.99-.44.44-.4.94-1.09 1.47-2.23a.75.75 0 0 1 1.42.46v.02l-.01.08c-.01.07-.02.18-.04.31-.02.26-.03.59.01.9.05.32.14.56.25.7.09.11.23.21.55.21.83 0 1.35-.56 1.53-1.21a.75.75 0 0 1 1.47.15v-.01.02a1.1 1.1 0 0 0 .22.46c.19.23.65.6 1.78.6V11c-1.35 0-2.23-.41-2.77-.96.36-.4.61-.87.74-1.33l-.72-.21.75-.05-.75.05c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03c-.51.56-1.25.96-2.23.96-.74 0-1.32-.28-1.71-.76a2.4 2.4 0 0 1-.38-.66c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78q-.27.33-.55.58c-.65.6-1.38.89-2.13.82-.73-.06-1.34-.45-1.82-.94l-.06-.06q-.17.15-.32.29a35 35 0 0 1-1.54 1.29l-.02.02-.01.01L1 11l-.46-.59h.01l.02-.02a24 24 0 0 0 .41-.32 34 34 0 0 0 1.51-1.33 7 7 0 0 1-.24-.51c-.57-1.33-.84-2.99-.52-4.28.16-.65.49-1.29 1.1-1.69m.79 5.35c.29-.32.56-.63.77-.93.56-.79.86-1.63.88-2.26.01-.31-.06-.52-.14-.66-.08-.12-.2-.23-.44-.3-.56-.15-.87-.06-1.04.05-.18.12-.36.36-.46.79-.21.87-.05 2.17.44 3.31" clip-rule="evenodd"/><path fill="currentcolor" d="M7.91 9.58c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78m4.32.46c.36-.4.61-.87.74-1.33l-.72-.21c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03"/>`
    }, props));
$6b0cf9138ae8faa3$var$SignatureIcon.displayName = 'SignatureIcon';
var $6b0cf9138ae8faa3$var$_default = module.exports.default = $6b0cf9138ae8faa3$var$SignatureIcon;

});

parcelRegister("j5Jtm", function(module, exports) {
const $1c87d14600b4aeb4$export$2f5ba0d1129fe71 = (inputStr)=>{
    const htmlEntities = {
        '&nbsp;': ' ',
        '&lt;': '<',
        '&amp;': '&',
        '&quot;': '"',
        '&gt;': '>'
    };
    return Object.keys(htmlEntities).reduce((str, entity)=>{
        return str.replace(new RegExp(entity, 'g'), htmlEntities[entity]);
    }, inputStr);
};
module.exports["replaceHtmlEntities"] = $1c87d14600b4aeb4$export$2f5ba0d1129fe71;

});

parcelRegister("iwLe7", function(module, exports) {
const $d278cee22bfa7c6a$export$158516eb8829fc93 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const now = new Date();
    return (now.getTime() - new Date(timestamp).getTime()) / 1000;
};
module.exports["secondsSinceDate"] = $d278cee22bfa7c6a$export$158516eb8829fc93;

});

parcelRegister("akQ4J", function(module, exports) {
const $d91b88cf0ff2b3d5$export$c7b83231a41239c7 = [
    'document'
];
module.exports["SHAREPOINT_RESOURCE_TYPES"] = $d91b88cf0ff2b3d5$export$c7b83231a41239c7;

});

parcelRegister("9ohv9", function(module, exports) {
const $f137b14bb432c6ec$export$5c9d109db494cbec = [
    'message',
    'conversation',
    'video'
];
module.exports["TEAMS_RESOURCE_TYPES"] = $f137b14bb432c6ec$export$5c9d109db494cbec;

});

parcelRegister("7jUYs", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b8cf047080ff9c5f$export$9f8e6b98f3e412c5 = (0, $aXWIB.defineMessages)({
    all: {
        id: "search-page.filter.type.all",
        defaultMessage: "All"
    },
    position: {
        id: "search-page.filter.type.position",
        defaultMessage: "Positions"
    },
    document: {
        id: "search-page.filter.type.documents",
        defaultMessage: "Documents"
    },
    spreadsheet: {
        id: "search-page.filter.type.spreadsheet",
        defaultMessage: "Spreadsheets"
    },
    presentation: {
        id: "search-page.filter.type.presentation",
        defaultMessage: "Presentations"
    },
    repository: {
        id: "search-page.filter.type.repository",
        defaultMessage: "Repositories"
    },
    'pull-request': {
        id: "search-page.filter.type.pull-request",
        defaultMessage: "Pull requests"
    },
    branch: {
        id: "search-page.filter.type.branch",
        defaultMessage: "Branches"
    },
    commit: {
        id: "search-page.filter.type.commit",
        defaultMessage: "Commits"
    },
    conversation: {
        id: "search-page.filter.type.conversation",
        defaultMessage: "Channels"
    },
    message: {
        id: "search-page.filter.type.message",
        defaultMessage: "Messages"
    },
    video: {
        id: "search-page.filter.type.video",
        defaultMessage: "Videos"
    },
    design: {
        id: "search-page.filter.type.design",
        defaultMessage: "Designs"
    },
    pageAndLiveDoc: {
        id: "search-page.filter.type.pageAndLiveDoc",
        defaultMessage: "Pages and Live Docs"
    },
    page: {
        id: "search-page.filter.type.page",
        defaultMessage: "Pages"
    },
    blogpost: {
        id: "search-page.filter.type.blogpost",
        defaultMessage: "Blog posts"
    },
    attachment: {
        id: "search-page.filter.type.attachment",
        defaultMessage: "Attachments"
    },
    space: {
        id: "search-page.filter.type.space",
        defaultMessage: "Spaces"
    },
    whiteboard: {
        id: "search-page.filter.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    slide: {
        id: "search-page.filter.type.slide",
        defaultMessage: "Slides"
    },
    issue: {
        id: "search-page.filter.type.jira-work-item",
        defaultMessage: "Work items"
    },
    project: {
        id: "search-page.filter.type.project",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.filter.type.goal",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.filter.type.tag",
        defaultMessage: "Tags"
    },
    'web-page': {
        id: "search-page.filter.type.web-page",
        defaultMessage: "Web pages"
    },
    comment: {
        id: "search-page.filter.type.comment",
        defaultMessage: "Comments"
    },
    database: {
        id: "search-page.filter.type.database",
        defaultMessage: "Databases"
    },
    embed: {
        id: "search-page.filter.type.embed",
        defaultMessage: "Smart Links"
    },
    folder: {
        id: "search-page.filter.type.folder",
        defaultMessage: "Folders"
    },
    calendar: {
        id: "search-page.filter.type.calendar",
        defaultMessage: "Calendars"
    },
    'space-calendar': {
        id: "search-page.filter.type.space-calendar",
        defaultMessage: "Space calendars"
    },
    answer: {
        id: "search-page.filter.type.answer",
        defaultMessage: "Answers"
    },
    question: {
        id: "search-page.filter.type.question",
        defaultMessage: "Questions"
    },
    component: {
        id: "search-page.filter.type.component",
        defaultMessage: "Components"
    },
    'work-item': {
        id: "search-page.filter.type.work-item",
        defaultMessage: "Tasks"
    },
    card: {
        id: "search-page.filter.type.card",
        defaultMessage: "Cards"
    },
    incident: {
        id: "search-page.filter.type.incident",
        defaultMessage: "Incidents"
    },
    'focus-area': {
        id: "search-page.filter.type.focus-area",
        defaultMessage: "Focus areas"
    },
    ask: {
        id: "search-page.filter.type.ask",
        defaultMessage: "Asks"
    },
    dashboard: {
        id: "search-page.filter.type.dashboard",
        defaultMessage: "Dashboards"
    },
    invoice: {
        id: "search-page.filter.type.invoice",
        defaultMessage: "Invoices"
    },
    deal: {
        id: "search-page.filter.type.deal",
        defaultMessage: "Deals"
    },
    gliffy: {
        id: "search-page.filter.type.gliffy",
        defaultMessage: "Gliffy Diagrams"
    },
    'customer-contact': {
        id: "search-page.filter.type.customer-contact",
        defaultMessage: "Customer Contacts"
    },
    'customer-org': {
        id: "search-page.filter.type.customer-org",
        defaultMessage: "Customer Organizations"
    },
    board: {
        id: "search-page.filter.type.board",
        defaultMessage: "Boards"
    },
    plan: {
        id: "search-page.filter.type.plan",
        defaultMessage: "Plans"
    },
    filter: {
        id: "search-page.filter.type.filter",
        defaultMessage: "Filters"
    },
    'data-table': {
        id: "search-page.filter.type.data-table",
        defaultMessage: "Data tables"
    },
    object: {
        id: "search-page.filter.type.object",
        defaultMessage: "Objects"
    },
    schema: {
        id: "search-page.filter.type.schema",
        defaultMessage: "Schemas"
    },
    type: {
        id: "search-page.filter.type.type",
        defaultMessage: "Object types"
    },
    epic: {
        id: "search-page.filter.type.epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search-page.filter.type.bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search-page.filter.type.Story",
        defaultMessage: "Story"
    },
    task: {
        id: "search-page.filter.type.task",
        defaultMessage: "Task"
    },
    subtask: {
        id: "search-page.filter.type.subtask",
        defaultMessage: "Subtask"
    },
    image: {
        id: "search-page.filter.type.image",
        defaultMessage: "Images"
    },
    audio: {
        id: "search-page.filter.type.audio",
        defaultMessage: "Audio"
    },
    pdf: {
        id: "search-page.filter.type.pdf",
        defaultMessage: "PDF"
    },
    shortcut: {
        id: "search-page.filter.type.shortcut",
        defaultMessage: "Shortcut"
    },
    code: {
        id: "search-page.filter.type.code",
        defaultMessage: "Code"
    },
    archive: {
        id: "search-page.filter.type.archive",
        defaultMessage: "Archive"
    },
    form: {
        id: "search-page.filter.type.form",
        defaultMessage: "Form"
    },
    notebook: {
        id: "search-page.filter.type.notebook",
        defaultMessage: "Notebook"
    },
    other: {
        id: "search-page.filter.type.other",
        defaultMessage: "Other"
    },
    article: {
        id: "search-page.filter.type.article",
        defaultMessage: "Articles"
    },
    post: {
        id: "search-page.filter.type.post",
        defaultMessage: "Posts"
    },
    ticket: {
        id: "search-page.filter.type.ticket",
        defaultMessage: "Tickets"
    },
    'devops-work-item': {
        id: "search-page.filter.type.devops-work-item",
        defaultMessage: "Issues"
    },
    campaign: {
        id: "search-page.filter.type.campaign",
        defaultMessage: "Campaigns"
    },
    case: {
        id: "search-page.filter.type.case",
        defaultMessage: "Cases"
    },
    'catalog-item': {
        id: "search-page.filter.type.catalog-item",
        defaultMessage: "Catalog items"
    },
    'requested-item': {
        id: "search-page.filter.type.requested-item",
        defaultMessage: "Requested items"
    },
    'knowledge-article': {
        id: "search-page.filter.type.knowledge-article",
        defaultMessage: "Knowledge articles"
    },
    demand: {
        id: "search-page.filter.type.demand",
        defaultMessage: "Demands"
    }
});
module.exports["typeLabels"] = $b8cf047080ff9c5f$export$9f8e6b98f3e412c5;

});

parcelRegister("037Ux", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");

const $c714dd6f21c3b8da$export$a415be24ece1d149 = (params)=>{
    if (params.productToSet || params.isUniversal && // Universal Filters on Quick Find selects the primaryProduct until we do cross product search
    //https://atlassian.slack.com/archives/C050EC6FM28/p1763330594902229?thread_ts=1763092320.695409&cid=C050EC6FM28
    params.experience !== (0, $9rRKJ.SearchExperience).QUICK_FIND) return params.productToSet;
    const productToSelect = params.selectedProduct ?? params.primaryProduct ?? '';
    const safeProductKey = (0, $b4tvS.isProductKey)(productToSelect) ? productToSelect : undefined;
    return safeProductKey;
};
module.exports["getProductToSelect"] = $c714dd6f21c3b8da$export$a415be24ece1d149;

});

parcelRegister("euOzb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2W0qg = parcelRequire("2W0qg");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $7duAA = parcelRequire("7duAA");

const $9322f8cac61c7a30$var$ClearFilterButton = ({ text: text = (0, $7duAA.messages).clearFilterButtonLabel, xcss: xcss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        ...props,
        xcss: [
            $9322f8cac61c7a30$var$clearFilterOptionsButtonStyles,
            xcss
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(text)));
};
var $9322f8cac61c7a30$export$2e2bcd8739ae039 = $9322f8cac61c7a30$var$ClearFilterButton;
const $9322f8cac61c7a30$var$clearFilterOptionsButtonStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
module.exports["default"] = $9322f8cac61c7a30$export$2e2bcd8739ae039;

});

parcelRegister("2ZCkf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ghftu = parcelRequire("ghftu");


var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $kP8IJ = parcelRequire("kP8IJ");


var $76naE = parcelRequire("76naE");

const $18263ad7f172659f$var$defaultFilterButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    maxHeight: '32px',
    minHeight: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    maxWidth: '280px'
});
const $18263ad7f172659f$var$wideStyles = (0, $ecnYn.xcss)({
    width: '100%' // Allow the button to take up full width
});
const $18263ad7f172659f$var$compactContentFitStyles = (0, $ecnYn.xcss)({
    // This allows us to fit Dropdown button + App Selector + 2 product filters
    maxWidth: '180px'
});
const $18263ad7f172659f$var$filterButtonSelectedStateStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    border: `${"var(--ds-border-width, 1px)"} solid transparent` // Keep border consistent with non-selected state
});
const $18263ad7f172659f$var$filterButtonSelectedStateBorderStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`
});
const $18263ad7f172659f$var$compactSpacingStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050'
});
const $18263ad7f172659f$var$filterButtonContentStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexGrow: 1,
    // Allow the content to take up available space
    textAlign: 'left'
});
const $18263ad7f172659f$var$noBorderStyles = (0, $ecnYn.xcss)({
    border: 0
});
const $18263ad7f172659f$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function FilterButton({ children: children, contentFit: contentFit = 'default', iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, noBorder: noBorder, tooltip: tooltip, spacing: spacing = 'default', filterOrControlId: filterOrControlId, hasChevron: hasChevron = true, isFilterInDropdown: isFilterInDropdown, xcss: xcss, ...pressableProps }, ref) {
    const filterIcon = filterOrControlId ? (0, $76naE.getIcon)({
        filterOrControlId: filterOrControlId,
        isSelected: Boolean(isSelected)
    }) : null;
    const chevronIcon = hasChevron ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: (0, $kP8IJ.getIconColor)(isSelected),
        size: "small"
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip ?? null,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...pressableProps,
            xcss: [
                $18263ad7f172659f$var$defaultFilterButtonStyles,
                isSelected && $18263ad7f172659f$var$filterButtonSelectedStateStyles,
                !isFilterInDropdown && isSelected && $18263ad7f172659f$var$filterButtonSelectedStateBorderStyles,
                isFilterInDropdown && $18263ad7f172659f$var$wideStyles,
                spacing === 'compact' && $18263ad7f172659f$var$compactSpacingStyles,
                contentFit === 'compact' && $18263ad7f172659f$var$compactContentFitStyles,
                noBorder && $18263ad7f172659f$var$noBorderStyles,
                xcss
            ],
            ref: ref
        }, iconBefore, filterIcon, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $18263ad7f172659f$var$filterButtonContentStyles
        }, children), iconAfter, chevronIcon)));
});
module.exports["FilterButton"] = $18263ad7f172659f$export$fb46dd9777cc6db0;

});

parcelRegister("coCs8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ghftu = parcelRequire("ghftu");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $5G4YB = parcelRequire("5G4YB");

const $74f0107fbd8d1ca1$var$baseStyles = (0, $ecnYn.xcss)({
    height: '32px',
    paddingInline: 'space.150',
    width: '100%',
    borderRadius: 'radius.small',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $74f0107fbd8d1ca1$var$selectedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.accent.blue',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $74f0107fbd8d1ca1$var$buttonIconStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $74f0107fbd8d1ca1$var$ButtonIconOld = ({ filterOrControlId: filterOrControlId, isSelected: isSelected })=>{
    const buttonIcon = (0, $5G4YB.getIcon)({
        filterOrControlId: filterOrControlId,
        isSelected: isSelected
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $74f0107fbd8d1ca1$var$buttonIconStyles
    }, buttonIcon);
};
const $74f0107fbd8d1ca1$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $74f0107fbd8d1ca1$var$textStyles = (0, $ecnYn.xcss)({
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $74f0107fbd8d1ca1$export$cb33ef6b55cb85ab = ({ otherProps: otherProps, isSelected: isSelected, filterOrControlId: filterOrControlId, label: label, selectionBadge: selectionBadge, onClick: onClick, onKeyDown: onKeyDown, wide: wide, testId: testId, ariaLabel: ariaLabel, iconBefore: iconBefore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: !wide && $74f0107fbd8d1ca1$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: onClick,
        onKeyDown: onKeyDown,
        ...otherProps,
        ...ariaLabel && {
            ['aria-label']: ariaLabel
        },
        testId: testId,
        xcss: [
            $74f0107fbd8d1ca1$var$baseStyles,
            isSelected && $74f0107fbd8d1ca1$var$selectedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "start",
        space: "space.100",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        alignInline: "start",
        xcss: $74f0107fbd8d1ca1$var$textStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.075"
    }, iconBefore, filterOrControlId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74f0107fbd8d1ca1$var$ButtonIconOld, {
        filterOrControlId: filterOrControlId,
        isSelected: isSelected
    })), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $74f0107fbd8d1ca1$var$textStyles
    }, label), selectionBadge), filterOrControlId !== 'dropdown' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)",
        size: "small"
    }))));
module.exports["FilterButtonOld"] = $74f0107fbd8d1ca1$export$cb33ef6b55cb85ab;

});

parcelRegister("kfaxy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lvsjl = parcelRequire("lvsjl");


var $gdv5Z = parcelRequire("gdv5Z");

const $070b6b0e166fafc9$var$boxStyles = {
    wrapperStyles: "_vchhusvi"
};
const $070b6b0e166fafc9$var$HOVER_OUT_TIMEOUT = 400; // ms
const $070b6b0e166fafc9$var$HoverOutWrapper = ({ callback: callback, children: children })=>{
    const [handleHoverChange, cancel] = (0, $lvsjl.default)((hoveringOn)=>{
        if (!hoveringOn) callback();
    }, $070b6b0e166fafc9$var$HOVER_OUT_TIMEOUT);
    // We don't want callback if the component is unmounted
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cancel();
        };
    }, [
        cancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onMouseEnter: ()=>{
            cancel(); // Cancel any pending hover-out callback
            handleHoverChange(true);
        },
        onMouseLeave: ()=>handleHoverChange(false),
        xcss: $070b6b0e166fafc9$var$boxStyles.wrapperStyles
    }, children);
};
const $070b6b0e166fafc9$export$fd3814d10c81178d = ({ enabled: enabled = false, ...rest })=>{
    if (!enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, rest.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($070b6b0e166fafc9$var$HoverOutWrapper, rest);
};
module.exports["MaybeHoverOutWrapper"] = $070b6b0e166fafc9$export$fd3814d10c81178d;

});

parcelRegister("kC3Bu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $tvI67 = parcelRequire("tvI67");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $5iakG = parcelRequire("5iakG");


var $4EMbH = parcelRequire("4EMbH");


var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");
var $1yEFx = parcelRequire("1yEFx");


var $9d9t8 = parcelRequire("9d9t8");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $2OtFZ = parcelRequire("2OtFZ");


var $9ZAVx = parcelRequire("9ZAVx");


var $hrMXM = parcelRequire("hrMXM");


var $YqPsE = parcelRequire("YqPsE");


var $5cssW = parcelRequire("5cssW");


var $gGFxq = parcelRequire("gGFxq");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $8pHoH = parcelRequire("8pHoH");

const $95f217c3bcfdeef2$var$ALL_STATE_VALUE = 'all';
const $95f217c3bcfdeef2$var$getOptionLabel = (productKey, productConfig, thirdPartyConfigs)=>{
    // Edge case: This is to get the name of Confluence DC sites and Forge connectors
    const workspaceName = (0, $YqPsE.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
    if (workspaceName) return workspaceName;
    // For Forge connectors, productConfig will be undefined, so we can't access displayName
    if (productConfig && typeof productConfig.displayName === 'string') return productConfig.displayName;
    // In theory this we should not reach here as displayName is rendered as a string
    return '';
};
const $95f217c3bcfdeef2$var$AppSelectFilter = ({ isFilterInDropdown: isFilterInDropdown })=>{
    const [lookupInput, setLookupInput] = (0, $42omo.useState)('');
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const availableNouns = (0, $j4ply.useAvailableNouns)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [selectedDatasource] = (0, $djVCD.useSelectedDatasource)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns } = (0, $djVCD.useSearchActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [filterData] = (0, $5cssW.useUniversalSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId),
        optionsToProducts: {}
    });
    const onSelectChange = (0, $42omo.useCallback)((value)=>{
        const selectedValue = Array.isArray(value) ? value[0] : value;
        if (selectedValue.value === $95f217c3bcfdeef2$var$ALL_STATE_VALUE) {
            unselectProductFilter();
            return;
        }
        // Handle datasource selection for fanout products
        if (selectedValue.metadata?.datasource) {
            selectProductFilter(selectedValue.value, selectedValue.metadata.datasource);
            return;
        }
        // Atlas is ignored because we do not display Atlas as an app but as nouns which
        // handle handled in the next if statement.
        if ((0, $b4tvS.isProductKey)(selectedValue.value) && selectedValue.value !== (0, $b4tvS.ProductKeys).Atlas) {
            selectProductFilter(selectedValue.value);
            return;
        }
        if ((0, $4EMbH.isNounKey)(selectedValue.queryParamValue)) {
            unsafe_setAtlasNouns(selectedValue.queryParamValue);
            return;
        }
    }, [
        selectProductFilter,
        unsafe_setAtlasNouns,
        unselectProductFilter
    ]);
    const nounOptions = (0, $42omo.useMemo)(()=>{
        // When fanout flag is on, don't show AtlassianWebCrawler as a noun (it's shown as a product)
        // When fanout flag is off, show it as the original "Web pages" noun
        const shouldShowWebCrawlerAsNoun = !(0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled');
        const nounsIncludingAtlassianWebCrawler = [
            //  We use availableProducts to determine if AtlassianWebCrawler is avaialble
            ...availableNouns.filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler),
            ...shouldShowWebCrawlerAsNoun ? [
                (0, $b4tvS.ProductKeys).AtlassianWebCrawler
            ] : []
        ];
        return Object.entries((0, $4EMbH.nouns)).flatMap(([nounKey, config])=>(0, $4EMbH.isNounKey)(nounKey) ? [
                {
                    nounKey: nounKey,
                    config: config
                }
            ] : []).filter(({ nounKey: nounKey })=>nounsIncludingAtlassianWebCrawler.includes(nounKey)).map(({ nounKey: nounKey, config: config })=>{
            const label = formatMessage(config.displayNamePlural);
            const typeFilterValue = filterData?.selectedOptions[0];
            const isNounSelected = typeFilterValue?.queryParamValue === nounKey && selectedProduct === (0, $b4tvS.ProductKeys).Atlas;
            const isWebCrawlerSelected = nounKey === selectedProduct && selectedProduct === (0, $b4tvS.ProductKeys).AtlassianWebCrawler;
            return {
                value: nounKey,
                isSelected: isNounSelected || isWebCrawlerSelected,
                label: label,
                isDefault: false,
                trackingKey: nounKey,
                queryParamValue: nounKey,
                isSuggested: false
            };
        });
    }, [
        availableNouns,
        filterData?.selectedOptions,
        formatMessage,
        selectedProduct
    ]);
    const allAppOptions = (0, $42omo.useMemo)(()=>{
        const productsOrder = (0, $hrMXM.getProductsOrderByPrimaryProduct)(primaryProduct);
        const baseAppOptions = availableProducts.filter((productKey)=>{
            // Always exclude Atlas (handled in nounOptions)
            if (productKey === (0, $b4tvS.ProductKeys).Atlas) return false;
            // When fanout is enabled, include AtlassianWebCrawler as a product
            // When fanout is disabled, exclude it (handled in nounOptions)
            if (productKey === (0, $b4tvS.ProductKeys).AtlassianWebCrawler) return Boolean(thirdPartyConfigs[(0, $b4tvS.ProductKeys).AtlassianWebCrawler]?.fanOutConnectorSources) && (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled');
            return true;
        }).filter((productKey)=>{
            // Don't filter out fanout products that need OAuth - let them show with OAuth warnings
            const hasFanout = (0, $b4tvS.is3pProductKey)(productKey) && thirdPartyConfigs[productKey]?.fanOutConnectorSources;
            if (hasFanout) return true; // Include fanout products regardless of OAuth status
            const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.isUserOAuthed)(productKey, thirdPartyConfigs);
            return !userNeedsOAuth;
        }).filter((productKey)=>{
            // Forge connectors are dynamically added and won't be in the static productConfigs map
            if ((0, $9d9t8.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
            // For hardcoded products, check if they exist in productConfigs
            return !!productConfigs[productKey];
        }).sort((a, b)=>(0, $9ZAVx.getProductOrder)(a, b, productsOrder));
        // Apply fanout logic to products that have it enabled
        const expandedAppOptions = [];
        baseAppOptions.forEach((productKey)=>{
            const productConfig = productConfigs[productKey];
            const hasFanout = (0, $b4tvS.is3pProductKey)(productKey) && Boolean(thirdPartyConfigs[productKey]?.fanOutConnectorSources) && (productKey !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler || (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled'));
            if (hasFanout) {
                // For dropdown, show all datasources for fanout products when flag is on
                const datasources = thirdPartyConfigs[productKey]?.datasources || [];
                datasources.forEach((datasource)=>{
                    const isSelected = productKey === selectedProduct && datasource.datasourceId === selectedDatasource?.datasourceId;
                    expandedAppOptions.push({
                        value: productKey,
                        isSelected: isSelected,
                        label: datasource.workspaceName || datasource.workspaceUrl || $95f217c3bcfdeef2$var$getOptionLabel(productKey, productConfig, thirdPartyConfigs),
                        isDefault: false,
                        trackingKey: `${productKey}-${datasource.datasourceId}`,
                        queryParamValue: productKey,
                        isSuggested: false,
                        metadata: {
                            datasource: datasource
                        }
                    });
                });
            } else expandedAppOptions.push({
                value: productKey,
                isSelected: productKey === selectedProduct && !selectedDatasource,
                label: $95f217c3bcfdeef2$var$getOptionLabel(productKey, productConfig, thirdPartyConfigs),
                isDefault: false,
                trackingKey: productKey,
                queryParamValue: productKey,
                isSuggested: false
            });
        });
        const allOption = {
            label: formatMessage((0, $8pHoH.i18n).all),
            value: $95f217c3bcfdeef2$var$ALL_STATE_VALUE,
            isDefault: true,
            isSelected: false,
            trackingKey: '',
            queryParamValue: '',
            isSuggested: false
        };
        return [
            allOption,
            ...expandedAppOptions,
            ...nounOptions
        ];
    }, [
        availableProducts,
        formatMessage,
        nounOptions,
        productConfigs,
        selectedProduct,
        selectedDatasource,
        thirdPartyConfigs,
        primaryProduct
    ]);
    const selectedOption = (0, $42omo.useMemo)(()=>{
        const singleSelectedOption = allAppOptions.filter((option)=>option.isSelected)[0];
        return singleSelectedOption ? [
            singleSelectedOption
        ] : [];
    }, [
        allAppOptions
    ]);
    const optionIcon = (0, $42omo.useMemo)(()=>(0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>{
            const optionValue = option.value;
            if (typeof optionValue === 'number') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            if (optionValue === $95f217c3bcfdeef2$var$ALL_STATE_VALUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                paddingInline: "space.050",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                label: formatMessage((0, $8pHoH.i18n).app)
            }));
            if ((0, $4EMbH.isNounKey)(optionValue)) {
                const nounConfig = (0, $4EMbH.nouns)[optionValue];
                const NounIcon = nounConfig.Icon;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NounIcon, {
                    size: "small"
                });
            }
            if ((0, $b4tvS.isProductKey)(optionValue)) {
                const productConfig = productConfigs[optionValue];
                // Handle Forge connectors
                if ((0, $9d9t8.isForgeConnectorProductKey)(optionValue)) {
                    const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(optionValue);
                    if (forgeIcon) return forgeIcon({
                        size: 'small'
                    });
                }
                // Handle hardcoded products
                if (productConfig?.Icon) {
                    const Icon = productConfig.Icon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                        size: "small"
                    });
                }
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        }), [
        formatMessage,
        productConfigs
    ]);
    const serveWebPagesInTypeFilterExperiment = (0, $2OtFZ.serveWebPagesInTypeFilter)();
    const selectedStateIcon = (0, $42omo.useMemo)(()=>{
        const nounSelection = filterData?.selectedOptions[0]?.queryParamValue;
        const isANoun = nounSelection && (0, $4EMbH.isNounKey)(nounSelection);
        if (selectedProduct === (0, $b4tvS.ProductKeys).Atlas && isANoun) {
            const nounConfig = (0, $4EMbH.nouns)[nounSelection];
            const NounIcon = nounConfig.Icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NounIcon, {
                size: "small"
            });
        }
        // Control cohort: use special noun icon for web pages in app filter
        // Test cohort: if app is web pages, use the default app icon (app can only be web pages through the URL)
        if (!serveWebPagesInTypeFilterExperiment && selectedProduct === (0, $b4tvS.ProductKeys).AtlassianWebCrawler) {
            const nounConfig = (0, $4EMbH.nouns)[(0, $4EMbH.NounKeys).AtlassianWebCrawler];
            const NounIcon = nounConfig.Icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NounIcon, {
                size: "small"
            });
        }
        if ((0, $b4tvS.isProductKey)(selectedProduct) && selectedProduct !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler) {
            const productConfig = productConfigs[selectedProduct];
            // Handle Forge connectors
            if ((0, $9d9t8.isForgeConnectorProductKey)(selectedProduct)) {
                const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(selectedProduct);
                if (forgeIcon) return forgeIcon({
                    size: 'small'
                });
            }
            // Handle hardcoded products
            if (productConfig?.Icon) {
                const Icon = productConfig.Icon;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    size: "small"
                });
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
            label: formatMessage((0, $8pHoH.i18n).app)
        });
    }, [
        filterData?.selectedOptions,
        formatMessage,
        productConfigs,
        selectedProduct,
        serveWebPagesInTypeFilterExperiment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        onDropdownClose: ()=>setLookupInput(''),
        onSearchInputChange: setLookupInput,
        onSelectChange: onSelectChange,
        options: allAppOptions,
        selectedOptions: selectedOption,
        label: selectedOption.length === 0 ? formatMessage((0, $8pHoH.i18n).app) : '',
        placeholder: formatMessage((0, $8pHoH.i18n).appSelectPlaceholder),
        isSearchable: true,
        filterOption: null,
        searchInput: lookupInput,
        formatOptionLabel: optionIcon,
        iconBefore: selectedStateIcon,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};
var $95f217c3bcfdeef2$export$2e2bcd8739ae039 = $95f217c3bcfdeef2$var$AppSelectFilter;
module.exports["default"] = $95f217c3bcfdeef2$export$2e2bcd8739ae039;

});

parcelRegister("c4DtA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $fw303 = parcelRequire("fw303");


var $kdaqW = parcelRequire("kdaqW");

const $760f2c048a3236c0$var$ArchivedFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $fw303.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            toggle();
            onFilterChange?.({
                isSelected: value
            });
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $kdaqW.i18n).archived));
};
var $760f2c048a3236c0$export$2e2bcd8739ae039 = $760f2c048a3236c0$var$ArchivedFilter;
module.exports["default"] = $760f2c048a3236c0$export$2e2bcd8739ae039;

});

parcelRegister("5XOrc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $k7ise = parcelRequire("k7ise");


var $2E5eb = parcelRequire("2E5eb");

const $0bc40bc1e4bf742f$var$ArchivedAndPendingComponentsFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange, fit: fit })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $k7ise.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $2E5eb.i18n).archivedAndPendingComponents));
};
var $0bc40bc1e4bf742f$export$2e2bcd8739ae039 = $0bc40bc1e4bf742f$var$ArchivedAndPendingComponentsFilter;
module.exports["default"] = $0bc40bc1e4bf742f$export$2e2bcd8739ae039;

});

parcelRegister("1a3HI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5X4Ay = parcelRequire("5X4Ay");


var $2Hu9k = parcelRequire("2Hu9k");

const $74770ed762a3ef0d$var$AssigneeFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5X4Ay.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $2Hu9k.i18n).jiraFilterAssigneeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $2Hu9k.i18n).jiraFilterAssigneeLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $2Hu9k.i18n).assignee);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $2Hu9k.i18n).jiraFilterContributorPlaceholder),
        filterOrControlId: 'assignee',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5X4Ay.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $74770ed762a3ef0d$export$2e2bcd8739ae039 = $74770ed762a3ef0d$var$AssigneeFilter;
module.exports["default"] = $74770ed762a3ef0d$export$2e2bcd8739ae039;

});

parcelRegister("iK2jT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $dh538 = parcelRequire("dh538");


var $jUrPw = parcelRequire("jUrPw");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5VnRb = parcelRequire("5VnRb");


var $lixcy = parcelRequire("lixcy");

const $db3cd4572d6863e6$var$CampaignStatusFilter = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5VnRb.filter).id
    });
    const isCampaignStatusFilterEnabled = (0, $dh538.fg)('rovo-fps-3p-ux-sf-campaign-status-filter');
    const isRetryOnConfigLoadEnabled = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    // See SalesforceStageFilter for the rationale: when the retry FF is on, hold the
    // "did mount" flip until isConfigLoaded is true so the bootstrap-config race
    // cannot leave the filter permanently empty.
    const hasLoadedInitialOptions = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isCampaignStatusFilterEnabled || hasLoadedInitialOptions.current) return;
        if (isRetryOnConfigLoadEnabled && !isConfigLoaded) return;
        hasLoadedInitialOptions.current = true;
        loadInitialOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCampaignStatusFilterEnabled,
        isRetryOnConfigLoadEnabled,
        isConfigLoaded
    ]);
    if (!filterData || !isCampaignStatusFilterEnabled) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUrPw.default), {
        ...props,
        filterId: (0, $5VnRb.filter).id,
        label: formatMessage((0, $lixcy.i18n).campaignStatusFilterLabel),
        noOptionsMessage: formatMessage((0, $lixcy.i18n).campaignStatusFilterNoOptions),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            label: ""
        }),
        isLoading: isLoading,
        selectedOptions: selectedOptions,
        suggestedOptions: suggestedOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        loadInitialOptions: loadInitialOptions,
        setOption: (option)=>setOption(option),
        clearOptions: clearOptions
    });
};
var $db3cd4572d6863e6$export$2e2bcd8739ae039 = $db3cd4572d6863e6$var$CampaignStatusFilter;
module.exports["default"] = $db3cd4572d6863e6$export$2e2bcd8739ae039;

});

parcelRegister("5rAmH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $dh538 = parcelRequire("dh538");


var $jUrPw = parcelRequire("jUrPw");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $F3Hv6 = parcelRequire("F3Hv6");


var $iKLhF = parcelRequire("iKLhF");

const $98c68942e58b8f98$var$CaseStatusFilter = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $F3Hv6.filter).id
    });
    const isRetryOnConfigLoadEnabled = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    // See SalesforceStageFilter for the rationale: when the retry FF is on, hold the
    // "did mount" flip until isConfigLoaded is true so the bootstrap-config race
    // cannot leave the filter permanently empty.
    const hasLoadedInitialOptions = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasLoadedInitialOptions.current) return;
        if (isRetryOnConfigLoadEnabled && !isConfigLoaded) return;
        hasLoadedInitialOptions.current = true;
        loadInitialOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRetryOnConfigLoadEnabled,
        isConfigLoaded
    ]);
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUrPw.default), {
        ...props,
        filterId: (0, $F3Hv6.filter).id,
        label: formatMessage((0, $iKLhF.i18n).caseStatusFilterLabel),
        noOptionsMessage: formatMessage((0, $iKLhF.i18n).caseStatusFilterNoOptions),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            label: ""
        }),
        isLoading: isLoading,
        selectedOptions: selectedOptions,
        suggestedOptions: suggestedOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        loadInitialOptions: loadInitialOptions,
        setOption: (option)=>setOption(option),
        clearOptions: clearOptions
    });
};
var $98c68942e58b8f98$export$2e2bcd8739ae039 = $98c68942e58b8f98$var$CaseStatusFilter;
module.exports["default"] = $98c68942e58b8f98$export$2e2bcd8739ae039;

});

parcelRegister("3IsTa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gTpIM = parcelRequire("gTpIM");


var $3dgQu = parcelRequire("3dgQu");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $hHAPz = parcelRequire("hHAPz");


var $jf1P1 = parcelRequire("jf1P1");

const $3e2c7d743a0a4f19$var$CloseDateFilter = ({ testId: testId = 'salesforce-close-date-filter', isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $hHAPz.filter).id
    });
    if (!filterData) return null;
    const { options: options, selectedOptions: selectedOptions, customValue: customValue } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $jf1P1.i18n).closeDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gTpIM.default), {
        contentFit: fit,
        options: options,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        label: label,
        onDropdownOpen: loadInitialOptions,
        selectedOptions: selectedOptions,
        customDateValue: customValue?.closeDateVal || '',
        testId: testId,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $3e2c7d743a0a4f19$export$2e2bcd8739ae039 = $3e2c7d743a0a4f19$var$CloseDateFilter;
module.exports["default"] = $3e2c7d743a0a4f19$export$2e2bcd8739ae039;

});

parcelRegister("17vNL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $2a0ps = parcelRequire("2a0ps");


var $drVRR = parcelRequire("drVRR");

const $f85052d50a516be9$var$CommentedByMeFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $2a0ps.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $drVRR.i18n).commentedByMe));
};
var $f85052d50a516be9$export$2e2bcd8739ae039 = $f85052d50a516be9$var$CommentedByMeFilter;
module.exports["default"] = $f85052d50a516be9$export$2e2bcd8739ae039;

});

parcelRegister("9wx2v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eG1e2 = parcelRequire("eG1e2");


var $8hhCV = parcelRequire("8hhCV");


var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $dQXZO = parcelRequire("dQXZO");


var $dO5lX = parcelRequire("dO5lX");

const $9a55686875ae213f$var$formatContentIconOptionLabel = (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
        label: option.label
    }));
const $9a55686875ae213f$var$formatFolderIconOptionLabel = (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
        label: option.label,
        size: "small",
        spacing: "none",
        color: "var(--ds-icon-brand, #1868DB)"
    }));
const $9a55686875ae213f$var$ContentFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const formatOptionLabel = (0, $b4tvS.is3pProductKey)(selectedProduct ?? '') ? $9a55686875ae213f$var$formatFolderIconOptionLabel : $9a55686875ae213f$var$formatContentIconOptionLabel;
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dQXZO.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $dO5lX.i18n).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $dO5lX.i18n).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $dO5lX.i18n).content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $dO5lX.i18n).confluenceFilterPlaceholder),
        filterOrControlId: 'content',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dQXZO.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $9a55686875ae213f$export$2e2bcd8739ae039 = $9a55686875ae213f$var$ContentFilter;
module.exports["default"] = $9a55686875ae213f$export$2e2bcd8739ae039;

});

parcelRegister("D9B8R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $aGXLL = parcelRequire("aGXLL");


var $2RkQg = parcelRequire("2RkQg");

const $63dd324a0edc4686$var$ContributorFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $2RkQg.i18n).confluenceFilterContributorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $2RkQg.i18n).confluenceFilterContributorLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $2RkQg.i18n).contributor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $2RkQg.i18n).confluenceFilterContributorPlaceholder),
        filterOrControlId: 'contributor',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $aGXLL.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        }),
        hideOnHoverOut: hideOnHoverOut,
        testId: "contributor-filter"
    });
};
var $63dd324a0edc4686$export$2e2bcd8739ae039 = $63dd324a0edc4686$var$ContributorFilter;
module.exports["default"] = $63dd324a0edc4686$export$2e2bcd8739ae039;

});

parcelRegister("iKcwP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $c5dmm = parcelRequire("c5dmm");


var $35KZ1 = parcelRequire("35KZ1");

const $fe851101f0073867$var$CreatedByFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $c5dmm.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $35KZ1.i18n).confluenceFilterCreatorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $35KZ1.i18n).confluenceFilterCreatorLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $35KZ1.i18n).createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $35KZ1.i18n).confluenceFilterCreatorPlaceholder),
        filterOrControlId: 'createdBy',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $c5dmm.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $fe851101f0073867$export$2e2bcd8739ae039 = $fe851101f0073867$var$CreatedByFilter;
module.exports["default"] = $fe851101f0073867$export$2e2bcd8739ae039;

});

parcelRegister("5KTta", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2BDjU = parcelRequire("2BDjU");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $6jSbc = parcelRequire("6jSbc");


var $hiJnb = parcelRequire("hiJnb");

const $a99e0c61526ecafe$var$formatOptionLabel = (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2BDjU.default), {
        label: option.label
    }));
const $a99e0c61526ecafe$var$FocusAreaTypeFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $6jSbc.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $hiJnb.i18n).mercuryFilterFocusAreaTypeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $hiJnb.i18n).mercuryFilterFocusAreaTypeLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $hiJnb.i18n).focusAreaType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $hiJnb.i18n).mercuryFilterFocusAreaTypePlaceholder),
        filterOrControlId: 'focusAreaType',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $6jSbc.filter).id
            });
        },
        formatOptionLabel: $a99e0c61526ecafe$var$formatOptionLabel,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $a99e0c61526ecafe$export$2e2bcd8739ae039 = $a99e0c61526ecafe$var$FocusAreaTypeFilter;
module.exports["default"] = $a99e0c61526ecafe$export$2e2bcd8739ae039;

});

parcelRegister("3hfXG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $2BDjU = parcelRequire("2BDjU");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $e7L4o = parcelRequire("e7L4o");


var $1epJJ = parcelRequire("1epJJ");

const $20c6769ad7bce540$var$formatOptionLabel = (option)=>{
    const { label: label, metadata: metadata } = option;
    const type = metadata?.type || '';
    const owner = metadata?.owner || '';
    const status = metadata?.status;
    const health = metadata?.health;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2BDjU.default), {
        spacing: "spacious",
        status: status,
        health: health,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        size: "small"
    }, type, " \u2022 ", owner)));
};
const $20c6769ad7bce540$var$FocusAreaUnderFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $e7L4o.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabelLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabelPlaceholder),
        filterOrControlId: 'focusAreaUnder',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $20c6769ad7bce540$var$formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $e7L4o.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $20c6769ad7bce540$export$2e2bcd8739ae039 = $20c6769ad7bce540$var$FocusAreaUnderFilter;
module.exports["default"] = $20c6769ad7bce540$export$2e2bcd8739ae039;

});

parcelRegister("10wA9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $lPWNq = parcelRequire("lPWNq");


var $9WvAH = parcelRequire("9WvAH");

const $b5b91c7a9661f924$var$HasAttachmentFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $lPWNq.filter).id
    });
    if (!state || !(0, $dh538.fg)('rovo_fps_show_has_attachment_filter')) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: !value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $9WvAH.i18n).hasAttachment));
};
var $b5b91c7a9661f924$export$2e2bcd8739ae039 = $b5b91c7a9661f924$var$HasAttachmentFilter;
module.exports["default"] = $b5b91c7a9661f924$export$2e2bcd8739ae039;

});

parcelRegister("6alnB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $gwbWt = parcelRequire("gwbWt");


var $eDcMw = parcelRequire("eDcMw");

const $65f6ef9e8cb23703$var$LabelFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $gwbWt.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, options: options } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $eDcMw.i18n).selectedOptionsSection),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $eDcMw.i18n).suggestedOptionsSection),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $eDcMw.i18n).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        noOptionsMessage: formatMessage((0, $eDcMw.i18n).confluenceFilterLabelsNoText),
        placeholder: formatMessage((0, $eDcMw.i18n).confluenceFilterLabelPlaceholder),
        filterOrControlId: 'label',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $gwbWt.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $65f6ef9e8cb23703$export$2e2bcd8739ae039 = $65f6ef9e8cb23703$var$LabelFilter;
module.exports["default"] = $65f6ef9e8cb23703$export$2e2bcd8739ae039;

});

parcelRegister("aq7DS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $9PTlU = parcelRequire("9PTlU");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $1uGSo = parcelRequire("1uGSo");


var $hCRbr = parcelRequire("hCRbr");

const $414466d330b6ec26$var$LastUpdatedFilter = ({ testId: testId = 'universal-last-updated-filter', isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    // Trello only supports day/week/month/year options
    const trelloExcludedOptions = (0, $42omo.useMemo)(()=>[
            'custom',
            'yesterday'
        ], []);
    const optionsToExclude = selectedProduct === (0, $b4tvS.ProductKeys).Trello ? trelloExcludedOptions : [];
    const [filterData, { setOption: setOption, clearOptions: clearOptions, loadInitialOptions: loadInitialOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $1uGSo.filter).id,
        optionValuesToExclude: optionsToExclude
    });
    // This is a workaround to clear the options when the product is change to Trello
    // To avoid Trello query get filtered by un applicable options that might confuse the user
    // If Trello later served as indexed data that support all date options, this can be removed
    (0, $42omo.useEffect)(()=>{
        const isTrelloUnapplicableOptionsSelected = filterData?.selectedOptions && // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
        filterData?.selectedOptions.filter((option)=>trelloExcludedOptions.includes(option.value)).length > 0;
        if (selectedProduct === (0, $b4tvS.ProductKeys).Trello && isTrelloUnapplicableOptionsSelected) clearOptions();
    }, [
        clearOptions,
        filterData?.selectedOptions,
        selectedProduct,
        trelloExcludedOptions
    ]);
    if (!filterData) return null;
    const { options: options, selectedOptions: selectedOptions, customValue: customValue } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $hCRbr.i18n).lastUpdated);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9PTlU.default), {
        contentFit: fit,
        options: options,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        label: label,
        onDropdownOpen: loadInitialOptions,
        selectedOptions: selectedOptions,
        customDateRange: customValue || {
            from: '',
            to: ''
        },
        testId: testId,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $414466d330b6ec26$export$2e2bcd8739ae039 = $414466d330b6ec26$var$LastUpdatedFilter;
module.exports["default"] = $414466d330b6ec26$export$2e2bcd8739ae039;

});

parcelRegister("iLJVZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $huubg = parcelRequire("huubg");


var $mCz2w = parcelRequire("mCz2w");

const $e48d36c8a558b60d$var$LastUpdatedByFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $huubg.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $mCz2w.i18n).confluenceFilterCreatorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $mCz2w.i18n).confluenceFilterCreatorLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $mCz2w.i18n).lastUpdatedBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $mCz2w.i18n).confluenceFilterCreatorPlaceholder),
        filterOrControlId: 'lastUpdatedBy',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $huubg.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $e48d36c8a558b60d$export$2e2bcd8739ae039 = $e48d36c8a558b60d$var$LastUpdatedByFilter;
module.exports["default"] = $e48d36c8a558b60d$export$2e2bcd8739ae039;

});

parcelRegister("j8URb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dmbve = parcelRequire("dmbve");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $dFCIx = parcelRequire("dFCIx");


var $rdHwx = parcelRequire("rdHwx");

const $ce1bae4582862dab$var$OpportunityStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dFCIx.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    const allOptions = [
        ...selectedOptions,
        ...suggestedOptions
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $rdHwx.i18n).opportunityStatusFilterLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: allOptions,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'opportunityStatus',
        isLoading: isLoading,
        isSearchable: false,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dFCIx.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmbve))), {
            label: ""
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $ce1bae4582862dab$export$2e2bcd8739ae039 = $ce1bae4582862dab$var$OpportunityStatusFilter;
module.exports["default"] = $ce1bae4582862dab$export$2e2bcd8739ae039;

});

parcelRegister("d2tOF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5ousX = parcelRequire("5ousX");


var $ivrfM = parcelRequire("ivrfM");

const $b7439fb9901a187b$var$OwnerFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5ousX.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $ivrfM.i18n).confluenceFilterOwnerLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $ivrfM.i18n).confluenceFilterOwnerLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $ivrfM.i18n).owner);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $ivrfM.i18n).confluenceFilterOwnerPlaceholder),
        filterOrControlId: 'owner',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5ousX.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $b7439fb9901a187b$export$2e2bcd8739ae039 = $b7439fb9901a187b$var$OwnerFilter;
module.exports["default"] = $b7439fb9901a187b$export$2e2bcd8739ae039;

});

parcelRegister("90exq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $1sswv = parcelRequire("1sswv");


var $6yMPR = parcelRequire("6yMPR");

const $b04368215fe9d1c2$var$PageStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $1sswv.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $6yMPR.i18n).pageStatus);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'pageStatus',
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $b04368215fe9d1c2$export$2e2bcd8739ae039 = $b04368215fe9d1c2$var$PageStatusFilter;
module.exports["default"] = $b04368215fe9d1c2$export$2e2bcd8739ae039;

});

parcelRegister("lBO0P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c4sKh = parcelRequire("c4sKh");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $bbypI = parcelRequire("bbypI");

var $6Ipjn = parcelRequire("6Ipjn");


var $kIdP4 = parcelRequire("kIdP4");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $kjNCN = parcelRequire("kjNCN");


var $k5mzm = parcelRequire("k5mzm");


var $ls6iZ = parcelRequire("ls6iZ");


var $5eact = parcelRequire("5eact");

const $d42c8c4a4f54095c$var$badgeStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex'
});
const $d42c8c4a4f54095c$var$SelectFilter = ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, selectedOptions: selectedOptions, label: label, noOptionsMessage: noOptionsMessage, filterOrControlId: filterOrControlId, getFirstSelectedLabel: getFirstSelectedLabel, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, testId: testId, iconBefore: iconBefore, isFilterInDropdown: isFilterInDropdown, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, hideOnHoverOut: hideOnHoverOut, matchReferenceWidth: matchReferenceWidth = isFilterInDropdown, contentFit: contentFit, filterOption: filterOptionOverride })=>{
    const numSelectedOptions = selectedOptions.length;
    const firstSelected = selectedOptions[0];
    const filterButtonRef = (0, $42omo.useRef)(null);
    // We only use this state to control the open/close of the popup when hideOnHoverOut is enabled
    // Otherwise, the open/close is controlled by PopupSelect internally
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const debounceTimeout = (0, $42omo.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $42omo.useState)(searchInput);
    const customModifiers = [
        ...matchReferenceWidth ? [
            (0, $kjNCN.matchReferenceWidthModifier)
        ] : []
    ];
    const handleInputChange = (0, $42omo.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $42omo.useCallback)((value)=>{
        onSelectChange(value);
    }, [
        onSelectChange
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
        setCurrentSearchInput('');
        onDropdownClose?.();
    }, [
        onDropdownClose
    ]);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(true);
        onDropdownOpen?.();
    }, [
        onDropdownOpen
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        if (event.relatedTarget !== filterButtonRef.current) // Unblur is not from filter button
        handleClose();
    }, [
        handleClose
    ]);
    const controlOpenStateProps = hideOnHoverOut && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off') && {
        isOpen: isPopupOpen,
        onBlur: handleBlur
    };
    // Disable react-select's default client-side filtering so server results (e.g. matched by
    // project key) are not incorrectly filtered out because their label doesn't match the input.
    // Consumers can override this by passing filterOption={null} to preserve client-side filtering
    const filterOption = filterOptionOverride !== undefined ? filterOptionOverride ?? undefined : isSearchable ? ()=>true : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        callback: handleClose,
        enabled: hideOnHoverOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        ...controlOpenStateProps,
        placeholder: placeholder,
        onMenuOpen: handleOpen,
        onMenuClose: handleClose,
        minMenuWidth: minMenuWidth,
        maxMenuWidth: "22rem",
        maxMenuHeight: 400,
        menuPlacement: "bottom",
        defaultIsOpen: defaultIsOpen,
        closeMenuOnSelect: !checkboxIndicators,
        isSearchable: isSearchable,
        searchThreshold: -1,
        blurInputOnSelect: false,
        isClearable: false,
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        defaultOptions: false,
        isLoading: isLoading,
        inputValue: currentSearchInput,
        onInputChange: handleInputChange,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        canClearFilter: canClearFilter,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        options: options,
        isOptionSelected: (option)=>option.isSelected,
        shouldCloseMenuOnTab: false,
        label: label,
        filterOption: filterOption,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                },
                ...customModifiers
            ]
        },
        target: ({ isOpen: isOpen, ...triggerProps })=>{
            let firstSelectedLabel = getFirstSelectedLabel ? getFirstSelectedLabel(firstSelected) : firstSelected?.label;
            let labelElement = label;
            if (typeof label === 'string') labelElement = (0, $5eact.getButtonText)({
                label: label,
                firstSelectedLabel: firstSelectedLabel,
                numSelectedOptions: numSelectedOptions
            });
            const isSelected = isOpen || numSelectedOptions > 0;
            if (isFiltersDiscoverability2Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ...(0, $dh538.fg)('search_qf_close_dropdown_on_hover_off') && {
                    onClick: isOpen ? handleClose : handleOpen
                },
                ...triggerProps,
                ref: (0, $kIdP4.mergeRefs)(triggerProps.ref, filterButtonRef),
                testId: testId ? `${testId}-button` : undefined,
                isSelected: isSelected,
                iconBefore: iconBefore,
                filterOrControlId: filterOrControlId,
                isFilterInDropdown: isFilterInDropdown,
                contentFit: contentFit,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, numSelectedOptions > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $d42c8c4a4f54095c$var$badgeStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "information"
                }, `+${numSelectedOptions - 1}`)) : undefined)
            }, labelElement);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                ...(0, $dh538.fg)('search_qf_close_dropdown_on_hover_off') && {
                    onClick: isOpen ? handleClose : handleOpen
                },
                testId: testId ? `${testId}-button` : undefined,
                otherProps: triggerProps,
                isSelected: isSelected,
                label: labelElement,
                filterOrControlId: filterOrControlId,
                selectionBadge: numSelectedOptions > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "information"
                }, `+${numSelectedOptions - 1}`) : undefined,
                iconBefore: iconBefore
            });
        },
        // formatOptionLabel and components are Removing in Q3 FY25
        // https://hello.atlassian.net/wiki/x/oQnE8g
        formatOptionLabel: formatOptionLabel,
        components: {
            Control: $k5mzm.Control,
            MenuList: isFiltersDiscoverability2Enabled ? (0, $ls6iZ.MenuListWithoutClearFilterOptionLabel) : (0, $ls6iZ.MenuListWithClearFilterOptionLabel),
            ...checkboxIndicators ? {
                Option: (0, $bbypI.CheckboxOption)
            } : {}
        }
    }));
};
var $d42c8c4a4f54095c$export$2e2bcd8739ae039 = $d42c8c4a4f54095c$var$SelectFilter;
module.exports["default"] = $d42c8c4a4f54095c$export$2e2bcd8739ae039;

});

parcelRegister("epJdx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $2BDjU = parcelRequire("2BDjU");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $fLju9 = parcelRequire("fLju9");


var $FK90w = parcelRequire("FK90w");

const $bb9fb8a57488cc5c$var$formatOptionLabel = (option)=>{
    const { label: label, metadata: metadata } = option;
    const type = metadata?.type || '';
    const owner = metadata?.owner || '';
    const status = metadata?.status;
    const health = metadata?.health;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2BDjU.default), {
        spacing: "spacious",
        status: status,
        health: health,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        size: "small"
    }, type, " \u2022 ", owner)));
};
const $bb9fb8a57488cc5c$var$PositionFocusAreaFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $fLju9.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $FK90w.i18n).positionFilterFocusAreaLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $FK90w.i18n).positionFilterFocusAreaLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $FK90w.i18n).positionFilterFocusAreaLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        checkboxIndicators: true,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $FK90w.i18n).positionFilterFocusAreaPlaceholder),
        filterOrControlId: 'positionFocusArea',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $bb9fb8a57488cc5c$var$formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $fLju9.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $bb9fb8a57488cc5c$export$2e2bcd8739ae039 = $bb9fb8a57488cc5c$var$PositionFocusAreaFilter;
module.exports["default"] = $bb9fb8a57488cc5c$export$2e2bcd8739ae039;

});

parcelRegister("3xkiG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $dXdDw = parcelRequire("dXdDw");


var $1pFlR = parcelRequire("1pFlR");

const $8dff75f96ac62ec8$var$PositionJobFamilyFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dXdDw.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyPlaceholder),
        filterOrControlId: 'positionJobFamily',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dXdDw.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $8dff75f96ac62ec8$export$2e2bcd8739ae039 = $8dff75f96ac62ec8$var$PositionJobFamilyFilter;
module.exports["default"] = $8dff75f96ac62ec8$export$2e2bcd8739ae039;

});

parcelRegister("1zHCN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5eFo6 = parcelRequire("5eFo6");


var $7SF4k = parcelRequire("7SF4k");

const $5cc346db44a2bc60$var$PositionStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5eFo6.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $7SF4k.i18n).positionStatusFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $7SF4k.i18n).positionStatusFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $7SF4k.i18n).positionStatusFilterLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $7SF4k.i18n).positionStatusFilterPlaceholder),
        filterOrControlId: 'positionStatus',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5eFo6.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $5cc346db44a2bc60$export$2e2bcd8739ae039 = $5cc346db44a2bc60$var$PositionStatusFilter;
module.exports["default"] = $5cc346db44a2bc60$export$2e2bcd8739ae039;

});

parcelRegister("4VBuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $esRft = parcelRequire("esRft");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $aeffu = parcelRequire("aeffu");


var $7PdYY = parcelRequire("7PdYY");

const $65f732563275e7da$var$formatOptionLabel = (option)=>{
    const { label: label, avatarUrl: avatarUrl } = option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "circle",
        size: "xsmall",
        src: avatarUrl,
        name: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2
    }, label));
};
const $65f732563275e7da$var$PositionTeamFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aeffu.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $7PdYY.i18n).positionFilterTeamLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $7PdYY.i18n).positionFilterTeamLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $7PdYY.i18n).positionFilterTeamLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        checkboxIndicators: true,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $7PdYY.i18n).positionFilterTeamPlaceholder),
        filterOrControlId: 'positionTeam',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $65f732563275e7da$var$formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $aeffu.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $65f732563275e7da$export$2e2bcd8739ae039 = $65f732563275e7da$var$PositionTeamFilter;
module.exports["default"] = $65f732563275e7da$export$2e2bcd8739ae039;

});

parcelRegister("d8wvI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $gHwfH = parcelRequire("gHwfH");


var $dSRVv = parcelRequire("dSRVv");

const $52ec9760f4f0950e$var$ProjectFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $gHwfH.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $dSRVv.i18n).jiraFilterSpacesLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $dSRVv.i18n).jiraFilterSpacesLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $dSRVv.i18n).spaces);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $dSRVv.i18n).jiraFilterSpacesPlaceholder),
        filterOrControlId: 'project',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $gHwfH.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $52ec9760f4f0950e$export$2e2bcd8739ae039 = $52ec9760f4f0950e$var$ProjectFilter;
module.exports["default"] = $52ec9760f4f0950e$export$2e2bcd8739ae039;

});

parcelRegister("dHIx8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $3TPSi = parcelRequire("3TPSi");


var $kAzVs = parcelRequire("kAzVs");

const $c4896255d920ab91$var$PullRequestStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $3TPSi.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $kAzVs.i18n).pullRequestStatusLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'pullRequestStatus',
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        checkboxIndicators: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $c4896255d920ab91$export$2e2bcd8739ae039 = $c4896255d920ab91$var$PullRequestStatusFilter;
module.exports["default"] = $c4896255d920ab91$export$2e2bcd8739ae039;

});

parcelRegister("5HYjQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $f1JPm = parcelRequire("f1JPm");


var $41YG4 = parcelRequire("41YG4");

const $caaaefd429b3fb57$var$ReporterFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $f1JPm.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $41YG4.i18n).jiraFilterReporterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $41YG4.i18n).jiraFilterReporterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $41YG4.i18n).reporter);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $41YG4.i18n).jiraFilterContributorPlaceholder),
        filterOrControlId: 'reporter',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $f1JPm.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $caaaefd429b3fb57$export$2e2bcd8739ae039 = $caaaefd429b3fb57$var$ReporterFilter;
module.exports["default"] = $caaaefd429b3fb57$export$2e2bcd8739ae039;

});

parcelRegister("kvgSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $dzNsR = parcelRequire("dzNsR");


var $bbo8Q = parcelRequire("bbo8Q");

const $56e6a0048ca7663d$var$RepositoryFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, onClearOptions: onClearOptions, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dzNsR.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $bbo8Q.i18n).repositoryLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dzNsR.filter).id
            });
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: (0, $dzNsR.filter).id,
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        noOptionsMessage: formatMessage((0, $bbo8Q.i18n).noOptions),
        checkboxIndicators: true,
        isSearchable: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $56e6a0048ca7663d$export$2e2bcd8739ae039 = $56e6a0048ca7663d$var$RepositoryFilter;
module.exports["default"] = $56e6a0048ca7663d$export$2e2bcd8739ae039;

});

parcelRegister("dm37y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $2zuvB = parcelRequire("2zuvB");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $fJFyr = parcelRequire("fJFyr");


var $1zWkb = parcelRequire("1zWkb");

const $7564d17dfe6481a6$export$66a8c50d62eea7ce = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $fJFyr.filter).id
    });
    // also render in the All-apps view of Jira/Confluence FPS.
    const shouldRender = !selectedProduct && (primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira) && (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters') || selectedProduct === (0, $b4tvS.ProductKeys).Confluence || selectedProduct === (0, $b4tvS.ProductKeys).Jira;
    if (!shouldRender) return null;
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const selectedLabelKey = $7564d17dfe6481a6$var$selectedOptionToSelectedLabelKey(selectedOptions[0]);
    const label = selectedLabelKey ? formatMessage((0, $1zWkb.messages)[selectedLabelKey]) : formatMessage((0, $1zWkb.messages)[(0, $2zuvB.RESULTS_SORT_FIELDS).relevanceDESC.selectedLabelKey]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: (0, $fJFyr.filter).id,
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $fJFyr.filter).id
            });
        },
        getFirstSelectedLabel: ()=>''
    });
};
const $7564d17dfe6481a6$var$selectedOptionToSelectedLabelKey = (option)=>{
    switch(option?.value){
        case 'relevance':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).relevanceDESC.selectedLabelKey;
        case 'updatedNewest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).latestModifiedDateDESC.selectedLabelKey;
        case 'updatedOldest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).latestModifiedDateASC.selectedLabelKey;
        case 'createdNewest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).createdDateDESC.selectedLabelKey;
        case 'createdOldest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).createdDateASC.selectedLabelKey;
    }
};
module.exports["ResultsSort"] = $7564d17dfe6481a6$export$66a8c50d62eea7ce;

});

parcelRegister("2UnmY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9bPlJ = parcelRequire("9bPlJ");


var $dh538 = parcelRequire("dh538");


var $jUrPw = parcelRequire("jUrPw");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $720nW = parcelRequire("720nW");


var $16U2b = parcelRequire("16U2b");

const $90d4511f01f8af05$var$SalesforceStageFilter = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $720nW.filter).id
    });
    const shouldEagerLoadOptions = (0, $dh538.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter');
    const isRetryOnConfigLoadEnabled = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    // Treat as "loaded" once we have invoked loadInitialOptions with a populated bootstrap
    // config. When the retry FF is off this guard is a permanent one-shot (preserving the
    // legacy behaviour). When the FF is on, the effect below also waits for isConfigLoaded
    // to flip true before flipping this ref, so a race against the bootstrap config load
    // can no longer poison the filter into a permanent empty state.
    const hasLoadedInitialOptions = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!shouldEagerLoadOptions || hasLoadedInitialOptions.current) return;
        // When the retry FF is enabled, hold off until bootstrap config has loaded so
        // the store can actually resolve a datasource and fetch options. Without it,
        // fall back to the legacy fire-once-on-mount behaviour.
        if (isRetryOnConfigLoadEnabled && !isConfigLoaded) return;
        hasLoadedInitialOptions.current = true;
        loadInitialOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldEagerLoadOptions,
        isRetryOnConfigLoadEnabled,
        isConfigLoaded
    ]);
    if (!filterData || !shouldEagerLoadOptions) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUrPw.default), {
        ...props,
        filterId: (0, $720nW.filter).id,
        label: formatMessage((0, $16U2b.i18n).salesforceStageFilterLabel),
        noOptionsMessage: formatMessage((0, $16U2b.i18n).salesforceStageFilterNoOptions),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9bPlJ))), {
            label: ""
        }),
        isLoading: isLoading,
        selectedOptions: selectedOptions,
        suggestedOptions: suggestedOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        loadInitialOptions: loadInitialOptions,
        setOption: (option)=>setOption(option),
        clearOptions: clearOptions
    });
};
var $90d4511f01f8af05$export$2e2bcd8739ae039 = $90d4511f01f8af05$var$SalesforceStageFilter;
module.exports["default"] = $90d4511f01f8af05$export$2e2bcd8739ae039;

});

parcelRegister("1Ddz9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $iz3ta = parcelRequire("iz3ta");


var $13BpK = parcelRequire("13BpK");

const $66ea9455ebf8eb30$var$channelLabelStyles = null;
const $66ea9455ebf8eb30$var$SlackChannelFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $iz3ta.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $13BpK.i18n).label);
    const groupedOptions = [
        {
            label: formatMessage((0, $13BpK.i18n).selectedLabel),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $13BpK.i18n).suggestedLabel),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ $42omo.createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option)=>{
            setOption(option);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $13BpK.i18n).placeholder),
        filterOrControlId: "slackChannel",
        testId: "search-dialog-slack-channel-filter",
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $iz3ta.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        hideOnHoverOut: hideOnHoverOut,
        formatOptionLabel: (option)=>/*#__PURE__*/ $42omo.createElement("span", {
                className: (0, $gMc0m.default)([
                    "_1kt91ihd _is061rpy _eid3u2gc"
                ])
            }, option.label)
    });
};
var $66ea9455ebf8eb30$export$2e2bcd8739ae039 = $66ea9455ebf8eb30$var$SlackChannelFilter;
module.exports["default"] = $66ea9455ebf8eb30$export$2e2bcd8739ae039;

});

parcelRegister("6YAWs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");

parcelRequire("1yEFx");
var $1yEFx = parcelRequire("1yEFx");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $dQXZO = parcelRequire("dQXZO");


var $a97k3 = parcelRequire("a97k3");


var $8QBsF = parcelRequire("8QBsF");

const $e67ab6cca68b40e0$var$thirdPartySpaceLabels = {
    [(0, $b4tvS.ProductKeys).GoogleDrive]: {
        label: (0, $8QBsF.i18n).drive,
        placeholder: (0, $8QBsF.i18n).drivePlaceholder
    },
    [(0, $b4tvS.ProductKeys).Sharepoint]: {
        label: (0, $8QBsF.i18n).site,
        placeholder: (0, $8QBsF.i18n).sitePlaceholder
    }
};
const $e67ab6cca68b40e0$var$SpaceFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const products = (0, $1yEFx.useProductConfigs)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOptionForSelectFilter, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $a97k3.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const setOption = (option)=>{
        // Validate content filter when feature flag is enabled for Google Drive or SharePoint
        const shouldValidateContentFilter = selectedProduct === (0, $b4tvS.ProductKeys).GoogleDrive && (0, $dh538.fg)('rovo_fps_3p_folder_validation_on_space_change') || selectedProduct === (0, $b4tvS.ProductKeys).Sharepoint && (0, $dh538.fg)('rovo_fps_3p_folder_validation_on_space_sharepoint');
        const validateDependentFilterId = shouldValidateContentFilter ? (0, $dQXZO.filter).id : undefined;
        setOptionForSelectFilter(option, undefined, selectedProduct ?? (0, $b4tvS.ProductKeys).Confluence, validateDependentFilterId);
    };
    const groupedOptions = [
        {
            label: formatMessage((0, $8QBsF.i18n).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $8QBsF.i18n).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const thirdPartyLabels = selectedProduct ? $e67ab6cca68b40e0$var$thirdPartySpaceLabels[selectedProduct] : undefined;
    const spaceLabel = thirdPartyLabels ? formatMessage(thirdPartyLabels.label) : formatMessage((0, $8QBsF.i18n).space);
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : spaceLabel;
    const placeholder = thirdPartyLabels ? formatMessage(thirdPartyLabels.placeholder) : formatMessage((0, $8QBsF.i18n).confluenceFilterSpacePlaceholder);
    const isThirdPartySingleSelect = (0, $b4tvS.is3pProductKey)(selectedProduct ?? '');
    // For 3P single-select products, use the product's own icon instead of the avatar fallback
    // (which shows a person icon when avatarUrl is missing).
    const ProductIcon = isThirdPartySingleSelect && selectedProduct ? products[selectedProduct]?.Icon : undefined;
    const formatOptionLabel = ProductIcon ? (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ProductIcon, {
            label: option.label,
            size: "small"
        })) : (0, $jQ2up.formatAvatarOptionLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: !isThirdPartySingleSelect,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option)=>{
            setOption(option);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: placeholder,
        filterOrControlId: 'space',
        testId: "search-dialog-space-filter",
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $a97k3.filter).id
            });
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        hideOnHoverOut: hideOnHoverOut
    });
};
var $e67ab6cca68b40e0$export$2e2bcd8739ae039 = $e67ab6cca68b40e0$var$SpaceFilter;
module.exports["default"] = $e67ab6cca68b40e0$export$2e2bcd8739ae039;

});

parcelRegister("eCrxg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $b6IhR = parcelRequire("b6IhR");


var $6ebAl = parcelRequire("6ebAl");

const $e2fb3030ca8c5426$var$StatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $b6IhR.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $6ebAl.i18n).statusLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'statusFilter',
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        checkboxIndicators: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $e2fb3030ca8c5426$export$2e2bcd8739ae039 = $e2fb3030ca8c5426$var$StatusFilter;
module.exports["default"] = $e2fb3030ca8c5426$export$2e2bcd8739ae039;

});

parcelRegister("b7IiT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $iaYRG = parcelRequire("iaYRG");


var $316RU = parcelRequire("316RU");

const $4ece80b10dab95bf$var$TitleMatchOnlyFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $iaYRG.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        })
    }, formatMessage((0, $316RU.i18n).onlyTitleMatch));
};
var $4ece80b10dab95bf$export$2e2bcd8739ae039 = $4ece80b10dab95bf$var$TitleMatchOnlyFilter;
module.exports["default"] = $4ece80b10dab95bf$export$2e2bcd8739ae039;

});

parcelRegister("23zGK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $5iakG = parcelRequire("5iakG");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $1xk5k = parcelRequire("1xk5k");


var $5cssW = parcelRequire("5cssW");


var $gY9AU = parcelRequire("gY9AU");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $3JX0d = parcelRequire("3JX0d");


var $OOvdO = parcelRequire("OOvdO");

const $31ae16293dbaddfc$var$getOptionsToProducts = (typeMapping)=>{
    const optionsToProducts = {};
    (0, $3JX0d.getAllTypeFilterKeysForSearch)().forEach((type)=>{
        optionsToProducts[type] = typeMapping[type].products || [];
    });
    return optionsToProducts;
};
const $31ae16293dbaddfc$var$TypeFilter = ({ testId: testId = 'universal-type-filter', isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const optionsToProducts = $31ae16293dbaddfc$var$getOptionsToProducts(typeMapping);
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useUniversalSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId),
        optionsToProducts: optionsToProducts
    });
    if (!filterData) return null;
    // Do not show TypeFilter for Atlas since that is handled by Noun filters
    if (productSelected === (0, $b4tvS.ProductKeys).Atlas) return null;
    const { selectedOptions: selectedOptions, options: options, lookupInput: lookupInput } = filterData;
    const filteredOptions = (0, $dh538.fg)('rovo_jira_work_type') ? options : options.filter((option)=>!Object.keys((0, $gY9AU.jiraWorkTypesForRequest)).includes(option.value));
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $OOvdO.i18n).type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: filteredOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $OOvdO.i18n).filterTypePlaceholder),
        filterOrControlId: (0, $5iakG.universalTypeFilterId),
        searchInput: lookupInput,
        onSearchInputChange: setLookupInput,
        isSearchable: true,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5iakG.universalTypeFilterId)
            });
        },
        testId: testId,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $31ae16293dbaddfc$export$2e2bcd8739ae039 = $31ae16293dbaddfc$var$TypeFilter;
module.exports["default"] = $31ae16293dbaddfc$export$2e2bcd8739ae039;

});

parcelRegister("hTSDS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $bF9JE = parcelRequire("bF9JE");


var $iwoTl = parcelRequire("iwoTl");

const $40a9c469d3ed1fab$var$VerifiedFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $bF9JE.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $iwoTl.i18n).verified));
};
var $40a9c469d3ed1fab$export$2e2bcd8739ae039 = $40a9c469d3ed1fab$var$VerifiedFilter;
module.exports["default"] = $40a9c469d3ed1fab$export$2e2bcd8739ae039;

});

parcelRegister("5773E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $9DkM9 = parcelRequire("9DkM9");


var $hK6k5 = parcelRequire("hK6k5");

const $2e43cb3da58d96ce$var$WatchedFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $9DkM9.filter).id
    });
    if (!state || !(0, $dh538.fg)('rovo_search_jira_watched_by_me_filter')) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $hK6k5.i18n).watchedByMe));
};
var $2e43cb3da58d96ce$export$2e2bcd8739ae039 = $2e43cb3da58d96ce$var$WatchedFilter;
module.exports["default"] = $2e43cb3da58d96ce$export$2e2bcd8739ae039;

});

parcelRegister("brMqq", function(module, exports) {
// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx

var $42omo = parcelRequire("42omo");

const $4e83fd0c0cb31886$export$5427c633f31d110f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));
module.exports["TalentSearchResultIcon"] = $4e83fd0c0cb31886$export$5427c633f31d110f;

});

parcelRegister("kXY72", function(module, exports) {
const $60dfd9a904b326a0$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return {
            ...initialState,
            value: booleanValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $60dfd9a904b326a0$export$64e49a0c7bd6f7a0;

});

parcelRegister("cOUgi", function(module, exports) {

var $k1VvQ = parcelRequire("k1VvQ");


var $8vGYx = parcelRequire("8vGYx");


var $iQfUJ = parcelRequire("iQfUJ");

const $a80a8ee27d53487e$export$b77715d04a87c12b = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $8vGYx.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$a80a8ee27d53487e$export$767f444f15b8d660({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$a80a8ee27d53487e$export$767f444f15b8d660({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $a80a8ee27d53487e$export$767f444f15b8d660 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $k1VvQ.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $k1VvQ.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $k1VvQ.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $k1VvQ.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $a80a8ee27d53487e$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $k1VvQ.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $k1VvQ.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $k1VvQ.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $k1VvQ.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $a80a8ee27d53487e$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.firstSelectedOption?.value === option.value
        };
    };
const $a80a8ee27d53487e$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        // Theoretically this should only ever give you one option to change
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const firstSelectedOption = optionsToChange[0];
        const isOptionAlreadySelected = state.options.filter((x)=>x.isSelected).find((x)=>x.value === firstSelectedOption?.value);
        if (isOptionAlreadySelected) // do nothing
        return $a80a8ee27d53487e$export$767f444f15b8d660({
            initial: initial,
            state: state,
            config: config
        });
        const queryParamOptions = state.queryParams.options.map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const initialOptions = state.initialOptions.options.map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        return $a80a8ee27d53487e$export$767f444f15b8d660({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
module.exports["createSingleSelectFilter"] = $a80a8ee27d53487e$export$b77715d04a87c12b;
module.exports["SingleSelectFilter"] = $a80a8ee27d53487e$export$767f444f15b8d660;

});

parcelRegister("bxnmj", function(module, exports) {
// these are values for the query params
const $960a8dbfa01645b5$export$dbcc81d768a46013 = {
    RoughDraft: 'roughDraft',
    InProgress: 'inProgress',
    ReadyForReview: 'readyForReview',
    Verified: 'verified'
};
const $960a8dbfa01645b5$export$48932d85514b3629 = Object.values($960a8dbfa01645b5$export$dbcc81d768a46013);
const $960a8dbfa01645b5$export$106c1c66f1b4a23e = {
    [$960a8dbfa01645b5$export$dbcc81d768a46013.RoughDraft]: 'Rough draft',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.InProgress]: 'In progress',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.ReadyForReview]: 'Ready for review',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.Verified]: 'Verified'
};
const $960a8dbfa01645b5$export$1b1e4f3d8ba5c6c1 = (value)=>{
    return $960a8dbfa01645b5$export$48932d85514b3629.includes(value);
};
module.exports["PageStatusFilterValueKey"] = $960a8dbfa01645b5$export$dbcc81d768a46013;
module.exports["allPageStatusFilterValueKeys"] = $960a8dbfa01645b5$export$48932d85514b3629;
module.exports["PageStatusFilterValue"] = $960a8dbfa01645b5$export$106c1c66f1b4a23e;
module.exports["isPageStatusFilterValueKey"] = $960a8dbfa01645b5$export$1b1e4f3d8ba5c6c1;

});

parcelRegister("6l1Qf", function(module, exports) {

var $9d9t8 = parcelRequire("9d9t8");


var $8l0cM = parcelRequire("8l0cM");


var $9rRKJ = parcelRequire("9rRKJ");


var $dOOW1 = parcelRequire("dOOW1");

const $7e15bd977d5402c8$export$a97e25c038594c73 = (staticFilters, filterStates)=>{
    const staticFilterValues = Array.isArray(staticFilters) ? staticFilters : Object.values(staticFilters);
    const staticFiltersRecord = Array.isArray(staticFilters) ? Object.fromEntries(staticFilters.map((staticFilter)=>[
            staticFilter.id,
            staticFilter
        ])) : staticFilters;
    const filterStateValues = Array.isArray(filterStates) ? filterStates : Object.values(filterStates).filter((0, $dOOW1.notEmpty));
    const filterStatesRecord = Array.isArray(filterStates) ? Object.fromEntries(filterStates.map((filterState)=>[
            filterState.id,
            filterState
        ])) : filterStates;
    return {
        staticFilters: staticFiltersRecord,
        staticFilterValues: staticFilterValues,
        filterStates: filterStatesRecord,
        filterStateValues: filterStateValues,
        getSelectedProducts: (queryParams)=>{
            const productKey = (0, $8l0cM.productKeySchema).safeParse(queryParams.product);
            if (productKey.success) return [
                productKey.data
            ];
            const allProductsWithSelections = staticFilterValues.filter((staticFilter)=>!staticFilter.universal) // Ignore universal filters as they are relevant to every product
            .filter((staticFilter)=>queryParams[staticFilter.queryParams.key] !== undefined).map((staticFilter)=>staticFilter.products).flat();
            const selectedProducts = Array.from(new Set(allProductsWithSelections)); // might have to sort this based on some priority
            return selectedProducts;
        },
        isMissingProductSelection: (queryParams)=>{
            const selectedProducts = $7e15bd977d5402c8$export$a97e25c038594c73(staticFilters, filterStates).getSelectedProducts(queryParams);
            const productKey = (0, $8l0cM.productKeySchema).safeParse(queryParams.product).data;
            return selectedProducts.length > 0 && !productKey;
        },
        filtersByProduct: (products, experience, primaryProduct)=>{
            const staticFiltersByProduct = staticFilterValues.filter((staticFilterValue)=>{
                if (!products.length && experience === (0, $9rRKJ.SearchExperience).SEARCH_PAGE) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                if (!products.length && experience === (0, $9rRKJ.SearchExperience).QUICK_FIND) return staticFilterValue.products.find((product)=>product === primaryProduct);
                if (!products.length) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                // Universal filters should always be included for forge connectors
                // This is needed because forge connectors are dynamically loaded and not in the static products list
                if (staticFilterValue.universal && products.some((0, $9d9t8.isForgeConnectorProductKey))) return true;
                return staticFilterValue.products.some((product)=>products.includes(product));
            });
            const staticFiltersByProductKeys = staticFiltersByProduct.map((staticFilter)=>staticFilter.id);
            const filterStatesByProduct = filterStateValues.filter((filterState)=>staticFiltersByProductKeys.includes(filterState.id));
            return $7e15bd977d5402c8$export$a97e25c038594c73(staticFiltersByProduct, filterStatesByProduct);
        },
        getFiltersWithSelection: ()=>{
            const filterIDsWithSelection = filterStateValues.filter((x)=>x.hasSelection).map((x)=>x.id);
            return filterIDsWithSelection;
        }
    };
};
module.exports["FilterUtils"] = $7e15bd977d5402c8$export$a97e25c038594c73;

});

parcelRegister("3diYj", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gpcGZ = parcelRequire("gpcGZ");


var $khsIl = parcelRequire("khsIl");


var $a5RR2 = parcelRequire("a5RR2");

const $c573415f78fb4972$export$6702bcb53d02902a = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $gpcGZ.ProductKeys1P).Talent]: (0, $dh538.fg)('talent_global_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $a5RR2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.includes(productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $khsIl.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $gpcGZ.ProductKeys1P).JiraServiceManagement) && (0, $dh538.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $dh538.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $gpcGZ.ProductKeys1P).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};
module.exports["getSupportedAccessibleProducts"] = $c573415f78fb4972$export$6702bcb53d02902a;

});

parcelRegister("fHHuS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lIbf3 = parcelRequire("lIbf3");


var $lgPOO = parcelRequire("lgPOO");

const $010c68ce9602b050$export$1e8af0ff123020f2 = {
    queryParams: {},
    referrer: undefined,
    /**
   * Empty because it is falsy and then will be overridden during boostrap
   * Can't be uuid() because then won't be overridden!
   * Can't be undefined, because we want to be explicit about the fact that this should be set during bootstrap and not be optional
   */ searchSessionId: '',
    smartLinkUsage: undefined,
    smartLinkUsageAndTopApps: undefined,
    thirdPartyConfigs: undefined
};
const $010c68ce9602b050$export$6286a07f09af7d90 = ({ children: children, searchSessionId: searchSessionId, referrer: referrer, smartLinkUsage: smartLinkUsage, smartLinkUsageAndTopApps: smartLinkUsageAndTopApps, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs })=>{
    const parsedQueryParams = (0, $42omo.useMemo)(()=>{
        return (0, $lIbf3.parseQueryParams)(queryParams || $010c68ce9602b050$export$1e8af0ff123020f2.queryParams);
    }, [
        queryParams
    ]);
    // A classic anything-updates useMemo
    const dynamicProps = (0, $42omo.useMemo)(()=>{
        return {
            queryParams: parsedQueryParams,
            searchSessionId: // Passed directly through for easy hook access in code sites
            // TODO QS-9194 should all be prop drilled later
            searchSessionId,
            referrer: referrer,
            smartLinkUsage: smartLinkUsage,
            smartLinkUsageAndTopApps: smartLinkUsageAndTopApps,
            thirdPartyConfigs: thirdPartyConfigs
        };
    }, [
        parsedQueryParams,
        referrer,
        searchSessionId,
        smartLinkUsage,
        smartLinkUsageAndTopApps,
        thirdPartyConfigs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.DynamicBootstrapContext).Provider, {
        value: dynamicProps
    }, children);
};
module.exports["defaultDynamicContext"] = $010c68ce9602b050$export$1e8af0ff123020f2;
module.exports["DynamicContextProvider"] = $010c68ce9602b050$export$6286a07f09af7d90;

});

parcelRegister("32Kiv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $7f51d42f612977b1$export$38b0e736a3b4e542 = (initial)=>{
    let state = initial;
    const listeners = new Set();
    return {
        getSnapshot: ()=>state,
        setState: (next)=>{
            if (next !== state) {
                state = next;
                listeners.forEach((listener)=>listener());
            }
        },
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
};
function $7f51d42f612977b1$export$21fad0c5d7df52dc(store, selector) {
    const selectorRef = (0, $42omo.useRef)(selector);
    selectorRef.current = selector;
    const cachedRef = (0, $42omo.useRef)(null);
    const getSnapshot = (0, $42omo.useCallback)(()=>{
        const currentState = store.getSnapshot();
        // If the underlying state hasn't changed, return the cached selected value.
        // This ensures referential stability for object/array selectors.
        if (cachedRef.current !== null && cachedRef.current.state === currentState) return cachedRef.current.value;
        const newValue = selectorRef.current(currentState);
        cachedRef.current = {
            value: newValue,
            state: currentState
        };
        return newValue;
    }, [
        store
    ]);
    // Third argument (getServerSnapshot) is required for SSR compatibility.
    // We reuse getSnapshot because store.getSnapshot() has no browser dependencies —
    // it simply returns the current state, which during SSR is the default initial state.
    return (0, $42omo.useSyncExternalStore)(store.subscribe, getSnapshot, getSnapshot);
}
module.exports["createStaticBootstrapStore"] = $7f51d42f612977b1$export$38b0e736a3b4e542;
module.exports["useStaticBootstrapSelector"] = $7f51d42f612977b1$export$21fad0c5d7df52dc;

});

parcelRegister("9opb6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5d9b4 = parcelRequire("5d9b4");


var $c6GJD = parcelRequire("c6GJD");


var $gkXKl = parcelRequire("gkXKl");


var $aaNIP = parcelRequire("aaNIP");


var $5iakG = parcelRequire("5iakG");


var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");


var $2OtFZ = parcelRequire("2OtFZ");


var $1ikWy = parcelRequire("1ikWy");


var $c2HNo = parcelRequire("c2HNo");


var $5XpfZ = parcelRequire("5XpfZ");


var $lIbf3 = parcelRequire("lIbf3");


var $7Evbj = parcelRequire("7Evbj");


var $gSaNw = parcelRequire("gSaNw");


var $lgPOO = parcelRequire("lgPOO");


var $32Kiv = parcelRequire("32Kiv");

// Attempting to build defaultstate from the same underlying definitions to ease migration to minimise migration
// omit from initialState
const { queryParams: $2a86a6885f914460$var$_queryParams, referrer: $2a86a6885f914460$var$_referrer, searchSessionId: $2a86a6885f914460$var$_searchSessionId, thirdPartyConfigs: $2a86a6885f914460$var$_thirdPartyConfigs, prevQueryParams: $2a86a6885f914460$var$_prevQueryParams, initialSpaceARIs: $2a86a6885f914460$var$_initialSpaceARIs, ...$2a86a6885f914460$var$inheritedInitialState } = (0, $aaNIP.initialState);
const $2a86a6885f914460$export$30ed20aaeaed4b77 = {
    ...$2a86a6885f914460$var$inheritedInitialState,
    initialTextQueryParam: undefined,
    queryParamsCallback: ()=>{},
    refreshSearchSessionId: ()=>{},
    clearReferrer: ()=>{},
    setThirdPartyConfigs: ()=>{},
    onSearchCompleted: ()=>{},
    experience: (0, $9rRKJ.SearchExperience).SEARCH_PAGE,
    applicationMode: (0, $c2HNo.getApplicationMode)({
        isRovoEnabled: $2a86a6885f914460$var$inheritedInitialState.isRovoEnabled
    }),
    multiSiteSearchInRovo: (0, $2OtFZ.getMultiSiteSearchInRovo)($2a86a6885f914460$var$inheritedInitialState.experimentConfig),
    isHello: (0, $5XpfZ.isHello)($2a86a6885f914460$var$inheritedInitialState.cloudId),
    thirdPartyConfigs: {}
};
const $2a86a6885f914460$export$bc36689a336ce85c = ({ children: children, initialProps: props, queryParams: queryParams, queryParamsCallback: queryParamsCallback, refreshSearchSessionId: refreshSearchSessionId, initialText: initialText, clearReferrer: clearReferrer, initialThirdPartyConfigs: initialThirdPartyConfigs, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, experience: experience, accessibleProducts: accessibleProducts })=>{
    /**
   * Static lock version counter. The useMemo recomputes whenever this value changes.
   *
   * Version semantics:
   * - 0: Lock open (bootstrap config not yet loaded)
   * - 1: Lock closed (bootstrap config loaded, values frozen)
   * - >1: Lock was reopened post-bootstrap via setThirdPartyConfigs (the ONLY path that increments above 1)
   *
   * If isConfigLoaded is already true on first render, starts at 1 so values are immediately available
   * without an extra render cycle.
   *
   * Post-bootstrap, setThirdPartyConfigs can increment the counter above 1 to force the useMemo to
   * recompute with updated refs. This is an expensive action that should be used sparingly and only
   * in response to uncommon user actions (e.g. OAuth connect flow).
   *
   * IMPORTANT: effectiveLockVersion is the SOLE dependency of the static useMemo. Do not add other dependencies.
   * If you need the useMemo to recompute for a new value, store that value in a ref and reopen the lock by incrementing this counter.
   */ const [staticLockVersion, setStaticLockVersion] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(()=>$2a86a6885f914460$var$shouldStaticLockClose({
            isConfigLoaded: props.isConfigLoaded || false
        }) ? 1 : 0);
    /**
   * Close the static lock synchronously during render when isConfigLoaded becomes true.
   * Sets the version to exactly 1 (not an increment) so that only setThirdPartyConfigs can push the version above 1.
   */ if (staticLockVersion === 0 && $2a86a6885f914460$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    })) setStaticLockVersion(1);
    // Create a stable store instance once per component lifetime
    const storeRef = (0, $42omo.useRef)(null);
    /**
   * Derive the effective lock version synchronously from both the state counter AND props.isConfigLoaded.
   *
   * When isConfigLoaded transitions from false to true, the in-render setState above schedules a
   * state update, but staticLockVersion still reads as 0 on THIS render. Previously, the useMemo
   * (which depended solely on staticLockVersion) would not recompute until the NEXT render when
   * staticLockVersion became 1 — costing an extra render cycle (~100ms+ in a complex tree).
   *
   * effectiveLockVersion resolves this by treating the lock as closed immediately when
   * isConfigLoaded is true, even before the state update takes effect. The useMemo now depends
   * on effectiveLockVersion, so it recomputes on the same render that isConfigLoaded becomes true.
   *
   * For setThirdPartyConfigs (version > 1), the state-based counter still drives recomputation
   * as before, since isConfigLoaded is already true at that point.
   */ const effectiveLockVersion = staticLockVersion === 0 && $2a86a6885f914460$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    }) ? 1 : staticLockVersion;
    /**
   * thirdPartyConfigs is expected to be static after bootstrap, but can be overridden during OAuth workflow as a cheap "cache bust".
   *
   * Stored in a ref so that updates do not directly cause re-renders. Instead, the OAuth callback
   * (setThirdPartyConfigs) updates the ref and reopens the static lock for exactly one render,
   * allowing the useMemo to recompute with the new value.
   */ const thirdPartyConfigsRef = (0, $42omo.useRef)(initialThirdPartyConfigs || {});
    // Sync thirdPartyConfigs from props when config finishes loading (before static lock closes).
    // Uses staticLockVersion (not staticLockClosed/effectiveLockVersion) because when isConfigLoaded
    // transitions to true, effectiveLockVersion eagerly resolves to 1 on the same render. The ref
    // must be updated BEFORE the useMemo (which depends on effectiveLockVersion) recomputes, so we
    // check the underlying state which is still 0 on the transition render.
    if (staticLockVersion === 0 && props.isConfigLoaded) thirdPartyConfigsRef.current = initialThirdPartyConfigs || {};
    const setThirdPartyConfigs = (0, $42omo.useCallback)((configs)=>{
        thirdPartyConfigsRef.current = configs;
        // Reopen the static lock for exactly one render so the useMemo recomputes with the new thirdPartyConfigs
        setStaticLockVersion((v)=>v + 1);
    }, []);
    const useMemoStaticProps = (0, $42omo.useMemo)(()=>{
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        const parsedQueryParams = queryParams && enableRovoSearchOverrides ? (0, $lIbf3.parseQueryParams)(queryParams) : undefined;
        const isRovoEnabled = props.isRovoEnabled || $2a86a6885f914460$export$30ed20aaeaed4b77.isRovoEnabled;
        const cloudId = props.cloudId || $2a86a6885f914460$export$30ed20aaeaed4b77.cloudId;
        const primaryProduct = props.primaryProduct || $2a86a6885f914460$export$30ed20aaeaed4b77.primaryProduct;
        const primarySubProduct = props.primarySubProduct || $2a86a6885f914460$export$30ed20aaeaed4b77.primarySubProduct;
        const user = props.user || $2a86a6885f914460$export$30ed20aaeaed4b77.user;
        // Under rovo-search-remove-rss-bootstrap-fg, compute experimentConfig directly
        // via getExperimentConfig instead of receiving it through props from BootstrapStoreProvider.
        // This moves the experiment config computation into the static context where it belongs,
        // using props already available here. If a prop is explicitly provided, use it as an
        // override (supports backward compat during rollout and test scenarios).
        // Keep in sync with: bootstrap-store-provider/index.tsx
        const experimentConfig = (0, $gSaNw.serveBootstrapProviderExp)() ? props.experimentConfig || (0, $gkXKl.getExperimentConfig)({
            primaryProduct: primaryProduct,
            experimentLayers: props.experimentLayers ?? [],
            sideBySideExperiment: props.features?.sideBySide?.experiments,
            statsigLayer: undefined,
            onError: (error)=>(0, $7Evbj.logException)(error, user?.id, primaryProduct)
        }) : props.experimentConfig || $2a86a6885f914460$export$30ed20aaeaed4b77.experimentConfig;
        // This can contain duplicates from e.g. a full drive connector and a drive smartlink connector
        // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed here
        // instead of in bootstrap-store-provider. On the old path, products is already processed.
        const products = (0, $gSaNw.serveBootstrapProviderExp)() ? $2a86a6885f914460$var$dedupProducts((0, $1ikWy.getAccessibleProducts)({
            supportedProducts: (0, $b4tvS.getAllProductKeys)(),
            products: props.products,
            accessibleProducts: accessibleProducts
        }), $2a86a6885f914460$export$30ed20aaeaed4b77.products) : $2a86a6885f914460$var$dedupProducts(props.products || [], $2a86a6885f914460$export$30ed20aaeaed4b77.products);
        return {
            // Literal constant
            allFilterExcludedProducts: (0, $5iakG.ALL_FILTER_EXCLUDED_PRODUCTS),
            // Static from internal props to BootstrapProvider
            experience: experience || $2a86a6885f914460$export$30ed20aaeaed4b77.experience,
            // Static from host product props
            cloudId: cloudId,
            isHello: (0, $5XpfZ.isHello)(cloudId),
            aggregatorHostName: props.aggregatorHostName || $2a86a6885f914460$export$30ed20aaeaed4b77.aggregatorHostName,
            aggAbsoluteUrl: props.aggAbsoluteUrl || $2a86a6885f914460$export$30ed20aaeaed4b77.aggAbsoluteUrl,
            SAINHostName: props.SAINHostName || $2a86a6885f914460$export$30ed20aaeaed4b77.SAINHostName,
            orgId: props.orgId || $2a86a6885f914460$export$30ed20aaeaed4b77.orgId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            analyticsAttributes: props.analyticsAttributes || $2a86a6885f914460$export$30ed20aaeaed4b77.analyticsAttributes,
            features: props.features || $2a86a6885f914460$export$30ed20aaeaed4b77.features,
            experimentLayers: props.experimentLayers || $2a86a6885f914460$export$30ed20aaeaed4b77.experimentLayers,
            queryParamsCallback: queryParamsCallback || $2a86a6885f914460$export$30ed20aaeaed4b77.queryParamsCallback,
            onSearchCompleted: onSearchCompleted || props.onSearchCompleted || $2a86a6885f914460$export$30ed20aaeaed4b77.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess || props.onOAuthSuccess || $2a86a6885f914460$export$30ed20aaeaed4b77.onOAuthSuccess,
            user: user,
            // Extracted on first load from queryParams (host product props)
            initialTextQueryParam: initialText,
            // DYNAMIC: from bootstrap config -> isConfigLoaded
            isConfigLoaded: props.isConfigLoaded || $2a86a6885f914460$export$30ed20aaeaed4b77.isConfigLoaded,
            intercomHmac: props.intercomHmac || $2a86a6885f914460$export$30ed20aaeaed4b77.intercomHmac,
            isRovoEnabled: isRovoEnabled,
            applicationMode: (0, $c2HNo.getApplicationMode)({
                isRovoEnabled: isRovoEnabled
            }),
            nouns: props.nouns || $2a86a6885f914460$export$30ed20aaeaed4b77.nouns,
            productEdition: props.productEdition || $2a86a6885f914460$export$30ed20aaeaed4b77.productEdition,
            productDataRegions: props.productDataRegions || $2a86a6885f914460$export$30ed20aaeaed4b77.productDataRegions,
            rovoFeatures: props.rovoFeatures || $2a86a6885f914460$export$30ed20aaeaed4b77.rovoFeatures,
            linkedCloudARIs: props.linkedCloudARIs || $2a86a6885f914460$export$30ed20aaeaed4b77.linkedCloudARIs,
            isJiraIssueIndexed: props.isJiraIssueIndexed || $2a86a6885f914460$export$30ed20aaeaed4b77.isJiraIssueIndexed,
            hasEditOrViewPlanPermission: props.hasEditOrViewPlanPermission || $2a86a6885f914460$export$30ed20aaeaed4b77.hasEditOrViewPlanPermission,
            // when removing this feature flag, update the type to no longer be optional
            ...enableRovoSearchOverrides && {
                overrides: parsedQueryParams?.overrides || (0, $aaNIP.initialState).overrides
            },
            // Third party configs - static after bootstrap, mutable only via OAuth callback (read from ref)
            thirdPartyConfigs: thirdPartyConfigsRef.current,
            refreshSearchSessionId: // passed directly through from props
            refreshSearchSessionId,
            clearReferrer: clearReferrer,
            setThirdPartyConfigs: setThirdPartyConfigs,
            experimentConfig: // experimentConfig is now computed directly in this static context under
            // rovo-search-remove-rss-bootstrap-fg via getExperimentConfig, or falls back to props on the old path.
            experimentConfig,
            multiSiteSearchInRovo: (0, $2OtFZ.getMultiSiteSearchInRovo)(experimentConfig),
            products: products
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveLockVersion
    ]); // Do not expand this dependency. See effectiveLockVersion JSDoc. Reach out to #help-search-plex or #search-plex-perf-squad with any questions
    // Create or sync the external store.
    // On first render this creates the store; on subsequent renders it notifies
    // only subscribers whose selected slice actually changed.
    if (storeRef.current === null) storeRef.current = (0, $32Kiv.createStaticBootstrapStore)(useMemoStaticProps);
    else storeRef.current.setState(useMemoStaticProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.StaticBootstrapContext).Provider, {
        value: useMemoStaticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.StaticBootstrapStoreContext).Provider, {
        value: storeRef.current
    }, children));
};
/**
 * Lock static context values after config is loaded to ensure they do not change during the session, as they are expected to be static after the bootstrap phase.
 * This also allows us to remove any dependencies on props that would cause unnecessary re-renders of the static context provider and all of its children
 *
 * The only values that should be here are booleans set by ASYNC behaviour that we must wait for (e.g. the config network call(s))
 * To add a new async dependency, provide a boolean e.g. myAsyncValue that is false until the async behaviour is complete, and then add it to the shouldStaticLockClose function.
 *
 * Note: This is on the search query critical performance path, any additional values added here should be carefully considered.
 * Reach out to #help-search-plex or #search-plex-perf-squad with any questions
 */ const $2a86a6885f914460$var$shouldStaticLockClose = ({ isConfigLoaded: isConfigLoaded })=>{
    return isConfigLoaded; // Set by `useFetchConfig`, supported by promise-reuse and localStorage caching
};
/**
 * The set of `products` as passed in as a prop has duplicates due to smartlinks etc (drive can appear several times!)
 * We uniq() this list for use within search
 */ const $2a86a6885f914460$var$dedupProducts = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
module.exports["defaultStaticContext"] = $2a86a6885f914460$export$30ed20aaeaed4b77;
module.exports["StaticContextProvider"] = $2a86a6885f914460$export$bc36689a336ce85c;

});

parcelRegister("cxQs0", function(module, exports) {

var $kXY72 = parcelRequire("kXY72");

const $d05c83618c1962d4$export$2963583aeb05fcae = (initial)=>{
    const initialState = {
        ...initial,
        type: 'boolean',
        value: false,
        hasSelection: false,
        universal: initial.universal
    };
    return {
        id: initial.id,
        type: initialState.type,
        products: initial.products,
        universal: initial.universal,
        queryParams: {
            key: initialState.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $kXY72.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$d05c83618c1962d4$export$cd193ee4357dee7f({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$d05c83618c1962d4$export$cd193ee4357dee7f({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter
    };
};
const $d05c83618c1962d4$export$cd193ee4357dee7f = ({ initial: initial, state: state, config: config })=>{
    const filterState = {
        ...state,
        hasSelection: state.value
    };
    return {
        ...filterState,
        setValue: $d05c83618c1962d4$var$setValue({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: ()=>filterState.value,
        getState: ()=>filterState,
        queryParams: {
            key: initial.queryParams.key,
            get: $d05c83618c1962d4$var$getQueryParams({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $d05c83618c1962d4$var$setQueryParams({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        clear: $d05c83618c1962d4$var$clear({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $d05c83618c1962d4$var$setValue = ({ initial: initial, state: state, config: config })=>{
    return (value)=>{
        const newState = {
            ...state,
            value: value,
            hasSelection: value
        };
        return $d05c83618c1962d4$export$cd193ee4357dee7f({
            initial: initial,
            state: newState,
            config: config
        });
    };
};
const $d05c83618c1962d4$var$getQueryParams = ({ initial: initial, state: state })=>{
    return ()=>({
            [initial.queryParams.key]: state.value === true ? [
                'true'
            ] : undefined
        });
};
const $d05c83618c1962d4$var$setQueryParams = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams)=>{
        const queryParamValue = queryParams[initial.queryParams.key];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return $d05c83618c1962d4$export$cd193ee4357dee7f({
            initial: initial,
            state: {
                ...state,
                value: booleanValue,
                hasSelection: booleanValue
            },
            config: config
        });
    };
};
const $d05c83618c1962d4$var$clear = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $d05c83618c1962d4$export$cd193ee4357dee7f({
            initial: initial,
            state: state,
            config: config
        });
        return filter.setValue(false);
    };
};
module.exports["createBooleanFilter"] = $d05c83618c1962d4$export$2963583aeb05fcae;

});

parcelRegister("ewGgp", function(module, exports) {
const $43f3b865216ed187$export$6dbf555668213f9e = (primaryProduct)=>{
    // URS (User Recommendation Service) only supports 'confluence' and 'jira' as product keys.
    // Other values (e.g. 'townsquare', 'mercury') cause a 400 deserialization error.
    // Default to 'confluence' when the primary product is not one of these two.
    return primaryProduct === 'jira' || primaryProduct === 'confluence' ? primaryProduct : 'confluence';
};
module.exports["getUrsProductKey"] = $43f3b865216ed187$export$6dbf555668213f9e;

});

parcelRegister("4bHQd", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $cxsgw = parcelRequire("cxsgw");


var $i8MOh = parcelRequire("i8MOh");

const $3fbd92d1a753d7ae$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $3fbd92d1a753d7ae$export$8e839a938752e935 = async (config)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = (0, $i8MOh.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ], headers);
    const recommendedUserQuery = (0, $cxsgw.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $3fbd92d1a753d7ae$var$MAX_SMART_DEFAULT_OPTIONS
        },
        headers: headers
    });
    const [initialUsersReponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersReponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return recommendedUserOptions;
};
module.exports["loadRecommendedUsers"] = $3fbd92d1a753d7ae$export$8e839a938752e935;

});

parcelRegister("2zk4m", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jXNWU = parcelRequire("jXNWU");

/**
 * Module-level cache of in-flight (or resolved) promises for
 * `getThirdPartyFilterOptions`, keyed by `${cloudId}::${datasourceId}`.
 *
 * The endpoint returns **all** custom filters for an integration in a single
 * response, so multiple filters that share the same datasource (e.g. campaign
 * status, case status, deal stage) can reuse one promise instead of each
 * issuing an independent network request.
 *
 * Cache lifetime: a typical session has at most O(connected integrations)
 * entries (usually 1–5), so no eviction strategy is needed.  The cache is
 * intentionally kept for the lifetime of the page — filter-option data is
 * static per datasource within a search session.
 *
 * Rejection handling: failed entries are removed so subsequent callers can
 * retry rather than receive a permanently-stuck rejected promise.
 *
 * Cache key: `cloudId::datasourceId::orgId` so different orgs do not share a cached response.
 * `aggAbsoluteUrl` is
 * intentionally excluded — it is constant for a given (cloudId, datasourceId) pair within a
 * session and so cannot disambiguate entries.
 */ const $b97779762a60c162$var$cache = new Map();
const $b97779762a60c162$export$92d46a4d5ee2716c = (config)=>{
    const { cloudId: cloudId } = config;
    const datasourceId = config.selectedDatasource?.datasourceId;
    // Defensive guard: do not invoke (or cache) without a complete key.
    // Callers in filter index files are expected to short-circuit before this.
    if (!cloudId || !datasourceId) return Promise.resolve(null);
    const orgId = config.orgId;
    const orgSegment = config.orgId ?? '';
    const fetchOptions = {
        cloudId: cloudId,
        datasourceId: datasourceId,
        orgId: orgId,
        aggAbsoluteUrl: config.aggAbsoluteUrl
    };
    // Feature gate: when off, every caller fetches directly (no shared state,
    // one network request per caller).  When on, callers share a single
    // in-flight promise per datasource via the cache below.
    if (!(0, $dh538.fg)('rovo-fps-3p-ux-sf-shared-custom-filters')) return (0, $jXNWU.getThirdPartyFilterOptions)(fetchOptions);
    const key = `${cloudId}::${datasourceId}::${orgSegment}`;
    let promise = $b97779762a60c162$var$cache.get(key);
    if (!promise) {
        promise = (0, $jXNWU.getThirdPartyFilterOptions)(fetchOptions);
        // Evict on failure so the next call can retry.
        promise.catch(()=>$b97779762a60c162$var$cache.delete(key));
        $b97779762a60c162$var$cache.set(key, promise);
    }
    return promise;
};
const $b97779762a60c162$export$a54b0e43665cba85 = ()=>{
    $b97779762a60c162$var$cache.clear();
};
module.exports["getCachedThirdPartyFilterOptions"] = $b97779762a60c162$export$92d46a4d5ee2716c;

});

parcelRegister("2XcAT", function(module, exports) {
const $ee40169aabdb51a7$export$dc0a6726495eccc1 = (params)=>{
    if (params.isUniversal) return 'all';
    return(// If a product is selected, the filter option will be tied to the selected product
    params.config.product ?? // If no product is selected, such as the 'all' state it will use the primary product. This is the case for suggested space filters.
    // All suggested filters are sets the primary product as the product selected after a filter option selection.
    params.config.primaryProduct ?? 'all' // config.primaryProduct should always be defined but 'all' is used as a catch-all
    );
};
module.exports["getProductForFilterOption"] = $ee40169aabdb51a7$export$dc0a6726495eccc1;

});

parcelRegister("7GRRM", function(module, exports) {

var $7iBhV = parcelRequire("7iBhV");


var $k1VvQ = parcelRequire("k1VvQ");


var $8vGYx = parcelRequire("8vGYx");


var $iQfUJ = parcelRequire("iQfUJ");


var $2XcAT = parcelRequire("2XcAT");

const $89c49071fea602e5$export$711b0a1d273f9525 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $8vGYx.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$89c49071fea602e5$export$44d389225cc01eb5({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$89c49071fea602e5$export$44d389225cc01eb5({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: true,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $89c49071fea602e5$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const options = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        });
        const selectedOptions = options.filter((option)=>option.isSelected);
        const queryParamValue = selectedOptions.map((option)=>option.queryParamValue);
        const isCustomOptionSelected = selectedOptions.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE));
        const customValueQueryParam = isCustomOptionSelected && state.customValue ? state.customValue : {};
        return {
            [initial.queryParams.key]: queryParamValue,
            ...customValueQueryParam
        };
    };
};
const $89c49071fea602e5$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const isCustomOptionSelected = newOptions.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE))?.isSelected;
            const customValueParser = initial.queryParams.customValueParser;
            let customValue;
            if (isCustomOptionSelected) {
                if (customValueParser) customValue = customValueParser(queryParams);
                else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                        ...acc,
                        [field]: queryParams[field]?.[0] ?? ''
                    }), {}) : {};
            }
            const filterWithNewOptions = filter.setOption(newOptions, customValue);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        let customValue;
        const isCustomOptionSelected = selectedOptionsFromQueryParams.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE))?.isSelected;
        if (isCustomOptionSelected) {
            const customValueParser = initial.queryParams.customValueParser;
            if (customValueParser) customValue = customValueParser(queryParams);
            else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                    ...acc,
                    [field]: queryParams[field]?.[0] ?? ''
                }), {}) : {};
        }
        const hydratedQueryParams = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                },
                customValue: customValue
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $89c49071fea602e5$export$44d389225cc01eb5 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $k1VvQ.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $89c49071fea602e5$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $89c49071fea602e5$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $k1VvQ.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $89c49071fea602e5$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $k1VvQ.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $k1VvQ.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $k1VvQ.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $k1VvQ.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $89c49071fea602e5$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.selectedOption ? props.selectedOption.value === option.value : option.isSelected
        };
    };
const $89c49071fea602e5$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option, customValue)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const selectedOption = optionsToChange.filter((o)=>o.isSelected)[0];
        const queryParamOptions = state.queryParams.options.map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const initialOptions = state.initialOptions.options.map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        return $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                },
                customValue: customValue
            },
            config: config
        });
    };
};
module.exports["createSingleWithCustomOptionSelectFilter"] = $89c49071fea602e5$export$711b0a1d273f9525;

});

parcelRegister("ILLS9", function(module, exports) {

var $dOOW1 = parcelRequire("dOOW1");

const $e86a5d8a6b7a397e$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $e86a5d8a6b7a397e$export$cb0ede5f191413 = (queryParams)=>{
    const { to: to, from: from } = queryParams;
    const isToDateValid = $e86a5d8a6b7a397e$var$isIsoDate(to?.[0]);
    const isFromDateValid = $e86a5d8a6b7a397e$var$isIsoDate(from?.[0]);
    const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
    const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
    const invalidDateRange = (0, $dOOW1.getInvalidDateRange)(fromDate, toDate);
    if (!invalidDateRange) return {
        to: toDate,
        from: fromDate
    };
};
const $e86a5d8a6b7a397e$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        let customValue;
        if (Array.isArray(queryParamValue)) {
            value = queryParamValue;
            if (queryParamValue[0] === 'custom') customValue = $e86a5d8a6b7a397e$export$cb0ede5f191413(queryParams);
        }
        return {
            ...initialState,
            value: value || initialState.value,
            customValue: customValue || initialState.customValue
        };
    };
};
module.exports["customValueParser"] = $e86a5d8a6b7a397e$export$cb0ede5f191413;
module.exports["generateQueryParamsGetState"] = $e86a5d8a6b7a397e$export$64e49a0c7bd6f7a0;

});

parcelRegister("dcbm4", function(module, exports) {
// these are values for the query params
const $b6f5f787e66362db$export$d76b5866ae4061c8 = {
    Open: 'open',
    Closed: 'closed'
};
const $b6f5f787e66362db$export$ff1c9ca0ad19eecd = Object.values($b6f5f787e66362db$export$d76b5866ae4061c8);
const $b6f5f787e66362db$export$9e65f1e3288fbede = {
    [$b6f5f787e66362db$export$d76b5866ae4061c8.Open]: false,
    [$b6f5f787e66362db$export$d76b5866ae4061c8.Closed]: true
};
module.exports["allOpportunityStatusFilterValueKeys"] = $b6f5f787e66362db$export$ff1c9ca0ad19eecd;
module.exports["OpportunityStatusFilterValue"] = $b6f5f787e66362db$export$9e65f1e3288fbede;

});

parcelRegister("jreQ3", function(module, exports) {

var $bxnmj = parcelRequire("bxnmj");

const $ed4249dbaae74eea$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) {
            if (queryParamValue[0] === 'all') value = queryParamValue;
            else if ((0, $bxnmj.isPageStatusFilterValueKey)(queryParamValue[0])) value = [
                (0, $bxnmj.PageStatusFilterValue)[queryParamValue[0]]
            ];
        }
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $ed4249dbaae74eea$export$64e49a0c7bd6f7a0;

});

parcelRegister("cSPiD", function(module, exports) {
const $00471ffd3091ea63$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) value = queryParamValue.map((param)=>decodeURIComponent(param));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $00471ffd3091ea63$export$64e49a0c7bd6f7a0;

});

parcelRegister("5jwMp", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");

const $7b50c742549c43d5$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $7b50c742549c43d5$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams, cloudId)=>{
        const selectedProduct = (queryParams['product'] ?? [])[0];
        const queryParamValue = queryParams[queryParamKey] || [];
        const value = selectedProduct === (0, $b4tvS.ProductKeys).JiraDC || selectedProduct === (0, $b4tvS.ProductKeys).JsmDC ? queryParamValue : queryParamValue.map((projectId)=>$7b50c742549c43d5$var$projectIdToARI(cloudId || '', projectId));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $7b50c742549c43d5$export$64e49a0c7bd6f7a0;

});

parcelRegister("2GQhu", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6Gsan = parcelRequire("6Gsan");

const $4bbfa272a18169bc$export$98613a34994a7d63 = (cloudId, primaryProduct)=>primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_site_ari_query_enabled') ? `ari:cloud:jira::site/${cloudId}` : `ari:cloud:confluence::site/${cloudId}`;
module.exports["getCloudIdARI"] = $4bbfa272a18169bc$export$98613a34994a7d63;

});

parcelRegister("7duAA", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $02a110e3de96df9d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    clearFilterButtonLabel: {
        id: "search-page.common.ui.clear-filter-button.label",
        defaultMessage: "Clear filter"
    }
});
module.exports["messages"] = $02a110e3de96df9d$export$defe85febe8b728c;

});

parcelRegister("76naE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $226KS = parcelRequire("226KS");


var $hbYDZ = parcelRequire("hbYDZ");


var $eIlE7 = parcelRequire("eIlE7");


var $oeZjt = parcelRequire("oeZjt");


var $8DN9t = parcelRequire("8DN9t");


var $imt6g = parcelRequire("imt6g");


var $gXn1S = parcelRequire("gXn1S");


var $4AkKf = parcelRequire("4AkKf");


var $lFkSe = parcelRequire("lFkSe");


var $eG1e2 = parcelRequire("eG1e2");


var $la4Nn = parcelRequire("la4Nn");


var $cUQMr = parcelRequire("cUQMr");


var $6767u = parcelRequire("6767u");


var $l8mxb = parcelRequire("l8mxb");


var $7OYaz = parcelRequire("7OYaz");


var $dmsGX = parcelRequire("dmsGX");


var $bh5s2 = parcelRequire("bh5s2");


var $av0Vd = parcelRequire("av0Vd");


var $1dKyn = parcelRequire("1dKyn");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $2OtFZ = parcelRequire("2OtFZ");


var $kP8IJ = parcelRequire("kP8IJ");

const $8c9aa7fb9bbfda3b$export$16b26cd5e98d9100 = ({ filterOrControlId: filterOrControlId, isSelected: isSelected, label: label = '' })=>{
    const iconProps = {
        label: label,
        color: (0, $kP8IJ.getIconColor)(isSelected)
    };
    switch(filterOrControlId){
        case 'owner':
        case 'assignee':
        case 'reporter':
        case 'contributor':
        case 'createdBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                ...iconProps
            });
        case 'verified':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), iconProps);
        case 'label':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                spacing: "none",
                ...iconProps
            });
        case 'content':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                spacing: "none",
                ...iconProps
            });
        case 'focusAreaType':
        case 'focusAreaUnder':
        case 'positionFocusArea':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
                spacing: "none",
                ...iconProps
            });
        case 'lastUpdated':
        case 'closeDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                spacing: "none",
                ...iconProps
            });
        case 'project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                spacing: "none",
                ...iconProps
            });
        case 'space':
            return (0, $2OtFZ.serveConfluenceSpaceIconUpdate)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                spacing: "none",
                ...iconProps
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                spacing: "none",
                ...iconProps
            });
        case 'onlyTitleMatch':
            return null;
        // Title match doesn't show an icon, only a checkbox
        case 'statusFilter':
        case 'pageStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                spacing: "none",
                ...iconProps
            });
        case 'lastUpdatedBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                ...iconProps
            });
        case 'universalTypeFilter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                spacing: "none",
                ...iconProps
            });
        case 'dropdown':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                spacing: "none",
                ...iconProps
            });
        case 'sort':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
                spacing: "none",
                ...iconProps
            });
        case 'assetsSchema':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                spacing: "none",
                ...iconProps
            });
        case 'positionTeam':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                spacing: "none",
                ...iconProps
            });
        case 'positionEmploymentType':
        case 'positionStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l8mxb))), {
                spacing: "none",
                ...iconProps
            });
        case 'pullRequestStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))), {
                spacing: "none",
                ...iconProps
            });
        case 'repository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
                spacing: "none",
                ...iconProps
            });
        case 'slackChannel':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($la4Nn))), {
                spacing: "none",
                ...iconProps
            });
        case 'positionJobFamily':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))), {
                spacing: "none",
                ...iconProps
            });
    }
};
const $8c9aa7fb9bbfda3b$export$68a752ca64f3cf84 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8c9aa7fb9bbfda3b$var$filterButtonIconContainerStyles
    }, children);
};
const $8c9aa7fb9bbfda3b$var$filterButtonIconContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075'
});
module.exports["getIcon"] = $8c9aa7fb9bbfda3b$export$16b26cd5e98d9100;

});

parcelRegister("5G4YB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $226KS = parcelRequire("226KS");


var $oeZjt = parcelRequire("oeZjt");


var $8DN9t = parcelRequire("8DN9t");


var $imt6g = parcelRequire("imt6g");


var $isYda = parcelRequire("isYda");


var $gXn1S = parcelRequire("gXn1S");


var $lFkSe = parcelRequire("lFkSe");


var $5tmwS = parcelRequire("5tmwS");


var $cUQMr = parcelRequire("cUQMr");


var $6767u = parcelRequire("6767u");


var $l8mxb = parcelRequire("l8mxb");


var $bVHZY = parcelRequire("bVHZY");


var $dmsGX = parcelRequire("dmsGX");


var $bh5s2 = parcelRequire("bh5s2");


var $av0Vd = parcelRequire("av0Vd");


var $1dKyn = parcelRequire("1dKyn");

const $38da6198e137f268$export$16b26cd5e98d9100 = ({ filterOrControlId: filterOrControlId, isSelected: isSelected, label: label = '' })=>{
    switch(filterOrControlId){
        case 'owner':
        case 'assignee':
        case 'contributor':
        case 'createdBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'verified':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'label':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'content':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'focusAreaType':
        case 'focusAreaUnder':
        case 'positionFocusArea':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'lastUpdated':
        case 'closeDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'space':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'onlyTitleMatch':
            return null;
        // Title match doesn't show an icon, only a checkbox
        case 'pageStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'lastUpdatedBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'universalTypeFilter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'dropdown':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'sort':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'assetsSchema':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'positionTeam':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'positionEmploymentType':
        case 'positionStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l8mxb))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'positionJobFamily':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
    }
};
module.exports["getIcon"] = $38da6198e137f268$export$16b26cd5e98d9100;

});

parcelRegister("8pHoH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $340cf9254ea9b40a$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    app: {
        id: "search-page.filters.names.app-select",
        defaultMessage: "App"
    },
    all: {
        id: "search-page.filter.app-select.all",
        defaultMessage: "All"
    },
    appSelectPlaceholder: {
        id: "search-page.filter.app-select.placeholder",
        defaultMessage: "Find app"
    },
    appSelectLabelSelected: {
        id: "search-page.filter.app-select.label.selected",
        defaultMessage: "Selected"
    },
    appSelectLabelUnselected: {
        id: "search-page.filter.app-select.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $340cf9254ea9b40a$export$a7357cdd1f0b0168;

});

parcelRegister("1eaCj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7gpC4 = parcelRequire("7gpC4");


var $cvXh8 = parcelRequire("cvXh8");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $2ZCkf = parcelRequire("2ZCkf");

const $7bb98e88b60f66aa$var$containerStylesOld = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    boxSizing: 'border-box',
    borderRadius: 'radius.small',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $7bb98e88b60f66aa$var$containerStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.150',
    boxSizing: 'border-box',
    borderRadius: 'radius.small',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $7bb98e88b60f66aa$var$backgroundStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $7bb98e88b60f66aa$var$containerCheckedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected'
});
const $7bb98e88b60f66aa$var$labelStyles = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text.subtle',
    maxHeight: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $7bb98e88b60f66aa$var$labelInDropdownStyles = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    color: 'color.text.subtle',
    maxHeight: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $7bb98e88b60f66aa$var$labelStylesOld = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)",
    maxHeight: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $7bb98e88b60f66aa$var$labelActiveStyle = (0, $ecnYn.xcss)({
    color: 'color.text.selected'
});
const $7bb98e88b60f66aa$var$checkMarkContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.075',
    alignItems: 'center'
});
const $7bb98e88b60f66aa$export$2e955e9ca7bb51ef = ({ children: children, onChange: onChange, isChecked: isChecked, autoFocus: autoFocus = false, isFilterInDropdown: isFilterInDropdown = false, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, iconBefore: iconBefore })=>{
    if (isFiltersDiscoverability2Enabled) return isFilterInDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7bb98e88b60f66aa$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $7bb98e88b60f66aa$var$labelInDropdownStyles,
                isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
            ]
        }, children),
        onChange: onChange,
        isChecked: isChecked,
        autoFocus: autoFocus
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
        "aria-pressed": isChecked,
        onClick: ()=>onChange?.(),
        hasChevron: false,
        isSelected: isChecked,
        iconBefore: iconBefore
    }, isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7bb98e88b60f66aa$var$checkMarkContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $7bb98e88b60f66aa$var$labelStyles,
            isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
        ]
    }, children)), !isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $7bb98e88b60f66aa$var$labelStyles,
                isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
            ]
        }, children),
        onChange: onChange,
        isChecked: isChecked,
        autoFocus: autoFocus
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $7bb98e88b60f66aa$var$containerStylesOld,
            ...!isFilterInDropdown ? [
                $7bb98e88b60f66aa$var$backgroundStyles,
                isChecked && $7bb98e88b60f66aa$var$containerCheckedStyles
            ] : []
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $7bb98e88b60f66aa$var$labelStylesOld,
                isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
            ]
        }, children),
        onChange: onChange,
        isChecked: isChecked,
        autoFocus: autoFocus
    }));
};
module.exports["ToggleFilter"] = $7bb98e88b60f66aa$export$2e955e9ca7bb51ef;

});

parcelRegister("ffbvg", function(module, exports) {

var $djVCD = parcelRequire("djVCD");


var $037Ux = parcelRequire("037Ux");

const $2df2afcc09d5a44d$export$c97cd60200241832 = ({ filterId: filterId })=>{
    const [state, storeActions] = (0, $djVCD.useBooleanFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        toggle: ()=>{
            if (!state) return;
            const productToSelect = (0, $037Ux.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                selectedProduct: state?.selectedProducts[0]
            });
            storeActions.setBooleanFilterValue({
                filterId: filterId,
                value: !state.value,
                options: {
                    setSelectedProduct: productToSelect
                }
            });
        }
    };
    if (!state) return [
        ,
        viewActions
    ];
    const viewState = {
        value: state.value,
        autoFocus: state.alwaysVisible === false
    };
    return [
        viewState,
        viewActions
    ];
};
module.exports["useBooleanFilter"] = $2df2afcc09d5a44d$export$c97cd60200241832;

});

parcelRegister("kdaqW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $cf2c90d0c72b6c34$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    archived: {
        id: "search-page.filters.names.archived",
        defaultMessage: "Show archived content"
    }
});
module.exports["i18n"] = $cf2c90d0c72b6c34$export$a7357cdd1f0b0168;

});

parcelRegister("2E5eb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $4138c81ffd5f567f$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    archivedAndPendingComponents: {
        id: "search-page.filters.names.archivedAndPendingComponents",
        defaultMessage: "Show archived/pending components"
    }
});
module.exports["i18n"] = $4138c81ffd5f567f$export$a7357cdd1f0b0168;

});

parcelRegister("2Hu9k", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d91d36ccaf6ed3cb$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assignee: {
        id: "search-page.filters.names.assignee",
        defaultMessage: "Assignee"
    },
    jiraFilterContributorPlaceholder: {
        id: "search-page.jira.filter.assignee.placeholder",
        defaultMessage: "Find people"
    },
    jiraFilterAssigneeLabelSelected: {
        id: "search-page.jira.filter.assignee.selected",
        defaultMessage: "Selected"
    },
    jiraFilterAssigneeLabelUnselected: {
        id: "search-page.jira.filter.assignee.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $d91d36ccaf6ed3cb$export$a7357cdd1f0b0168;

});

parcelRegister("jUrPw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lBO0P = parcelRequire("lBO0P");

const $abd15e16e4598c95$var$SharedSalesforceDynamicMultiSelect = ({ filterId: filterId, label: label, noOptionsMessage: noOptionsMessage, iconBefore: iconBefore, isLoading: isLoading, selectedOptions: selectedOptions, suggestedOptions: suggestedOptions, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions, isFilterInDropdown: isFilterInDropdown, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const allOptions = [
        ...selectedOptions,
        ...suggestedOptions
    ];
    const resolvedLabel = fit === 'compact' && selectedOptions.length > 0 ? '' : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option)=>{
            setOption(option);
            onFilterChange?.(option);
        },
        options: allOptions,
        selectedOptions: selectedOptions,
        label: resolvedLabel,
        filterOrControlId: filterId,
        isLoading: isLoading,
        isSearchable: true,
        filterOption: null,
        noOptionsMessage: noOptionsMessage,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: filterId
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: iconBefore,
        hideOnHoverOut: hideOnHoverOut
    });
};
var $abd15e16e4598c95$export$2e2bcd8739ae039 = $abd15e16e4598c95$var$SharedSalesforceDynamicMultiSelect;
module.exports["default"] = $abd15e16e4598c95$export$2e2bcd8739ae039;

});

parcelRegister("lixcy", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8a38628c0c60fda4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    campaignStatusFilterLabel: {
        id: "search-page.salesforce.filter.campaignStatus",
        defaultMessage: "Campaign status"
    },
    campaignStatusFilterNoOptions: {
        id: "search-page.salesforce.filter.campaignStatus.no-options",
        defaultMessage: "No statuses available"
    }
});
module.exports["i18n"] = $8a38628c0c60fda4$export$a7357cdd1f0b0168;

});

parcelRegister("iKLhF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f42b5bc117eb61eb$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    caseStatusFilterLabel: {
        id: "search-page.salesforce.filter.caseStatus",
        defaultMessage: "Case status"
    },
    caseStatusFilterNoOptions: {
        id: "search-page.salesforce.filter.caseStatus.no-options",
        defaultMessage: "No statuses available"
    }
});
module.exports["i18n"] = $f42b5bc117eb61eb$export$a7357cdd1f0b0168;

});

parcelRegister("gTpIM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $c4Cbx = parcelRequire("c4Cbx");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $7iBhV = parcelRequire("7iBhV");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $cJ4TJ = parcelRequire("cJ4TJ");


var $kjNCN = parcelRequire("kjNCN");


var $deQ0D = parcelRequire("deQ0D");

const $aa678bf4826904b9$var$styles = {
    container: "_1reoewfl _18m9ewfl _2rko12b0 _vchhusvi _1bsbixjv _bfhk1bhr _16qs130s _1pbyb4wl _nt751r31 _49pcglyw _1hvw1o36"
};
const $aa678bf4826904b9$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ...props,
        paddingBlock: "space.100",
        ref: ref,
        xcss: $aa678bf4826904b9$var$styles.container,
        "data-testid": undefined
    }));
const $aa678bf4826904b9$export$3ae94a2503e890a1 = (dateString, locale)=>{
    const modifiedDateString = dateString.concat('T00:00');
    return new Date(modifiedDateString).toLocaleDateString(locale);
};
const $aa678bf4826904b9$export$d397f86d22f413e8 = (isSelected, isCustomDateSelected, selectedLabel, label, locale, closeDateVal)=>{
    if (!isSelected || !selectedLabel) return label;
    const prefix = label.length > 0 ? `${label}: ` : '';
    if (isCustomDateSelected && closeDateVal) {
        const valueLabel = $aa678bf4826904b9$export$3ae94a2503e890a1(closeDateVal, locale);
        return `${prefix}${valueLabel}`;
    }
    return `${prefix}${selectedLabel}`;
};
const $aa678bf4826904b9$var$CloseDateFilterWithDatePicker = ({ options: options, onDropdownOpen: onDropdownOpen, onSelectChange: onSelectChange, selectedOptions: selectedOptions, customDateValue: customDateValue, label: label, testId: testId, isFilterInDropdown: isFilterInDropdown, isDefaultOpen: isDefaultOpen = false, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, iconBefore: iconBefore, hideOnHoverOut: hideOnHoverOut, matchReferenceWidth: matchReferenceWidth = isFilterInDropdown, contentFit: contentFit })=>{
    const [open, setOpen] = (0, $42omo.useState)(isDefaultOpen);
    const [customDateOpen, setCustomDateOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [focusedOption, setFocusedOption] = (0, $42omo.useState)(0);
    const [mouseHovered, setMouseHovered] = (0, $42omo.useState)(false);
    const buttonRef = (0, $42omo.useRef)(null);
    const [selectedDate, setSelectedDate] = (0, $42omo.useState)(customDateValue);
    const isSelected = selectedOptions.length > 0 || open;
    const firstSelected = selectedOptions[0];
    const isCustomDateSelected = firstSelected?.value === (0, $7iBhV.CUSTOM_OPTION_VALUE);
    const customModifiers = [
        ...matchReferenceWidth ? [
            (0, $kjNCN.matchReferenceWidthModifier)
        ] : []
    ];
    const labelToDisplay = $aa678bf4826904b9$export$d397f86d22f413e8(isSelected, isCustomDateSelected, firstSelected?.label || '', label, locale, customDateValue);
    const handleOptionClick = (option)=>{
        if (option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE)) setCustomDateOpen(true);
        else {
            setCustomDateOpen(false);
            onSelectChange(option, {
                closeDateVal: ''
            });
            setOpen(false);
        }
    };
    const handleDateApply = ()=>{
        if (!selectedDate) return;
        const option = options.find((o)=>o.value === (0, $7iBhV.CUSTOM_OPTION_VALUE));
        if (!option) return;
        onSelectChange(option, {
            closeDateVal: selectedDate
        });
        setOpen(false);
    };
    const handleClickDropdownBtn = ()=>{
        if (!open && onDropdownOpen) onDropdownOpen();
        setOpen(!open);
        setFocusedOption(0);
        buttonRef.current?.focus();
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev + 1) % options.length);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev - 1 + options.length) % options.length);
        }
        if (event.key === 'Enter' && open) {
            event.preventDefault();
            handleOptionClick(options[focusedOption]);
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (isCustomDateSelected) setCustomDateOpen(true);
        else setCustomDateOpen(false);
    }, [
        isCustomDateSelected
    ]); // Get today's date in ISO format for maxDate
    const today = new Date().toISOString().split('T')[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        enabled: hideOnHoverOut,
        callback: ()=>setOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        onClose: ()=>setOpen(false),
        isOpen: open,
        autoFocus: false,
        popupComponent: $aa678bf4826904b9$var$PopupComponent,
        zIndex: (0, $dh538.fg)('platform-dst-motion-uplift-popup') ? 100 : undefined,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                role: "menu",
                onMouseOver: ()=>setMouseHovered(true),
                onMouseOut: ()=>setMouseHovered(false)
            }, options.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cJ4TJ.default), {
                    hovered: !mouseHovered && focusedOption === index,
                    key: option.value,
                    option: option,
                    onClick: ()=>handleOptionClick(option)
                })), customDateOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                paddingInline: "space.150",
                paddingBlock: "space.075",
                testId: testId ? `${testId}-date-picker` : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
                onChange: (date)=>setSelectedDate(date),
                defaultValue: customDateValue || undefined,
                placeholder: formatMessage((0, $deQ0D.i18n).closeDateFilterDatePlaceholder),
                locale: locale,
                label: formatMessage((0, $deQ0D.i18n).closeDateFilterDateLabel),
                shouldShowCalendarButton: true,
                maxDate: today
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                isDisabled: !selectedDate,
                onClick: handleDateApply
            }, formatMessage((0, $deQ0D.i18n).closeDateFilterUpdateButton)))))),
        trigger: (triggerProps)=>isFiltersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ...triggerProps,
                contentFit: contentFit,
                testId: testId ? `${testId}-button` : undefined,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                onKeyDown: handleKeyDown,
                filterOrControlId: "closeDate",
                isFilterInDropdown: isFilterInDropdown,
                iconBefore: iconBefore
            }, labelToDisplay) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                label: labelToDisplay,
                filterOrControlId: 'closeDate',
                otherProps: triggerProps,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                testId: testId ? `${testId}-button` : undefined,
                onKeyDown: handleKeyDown,
                wide: true,
                iconBefore: iconBefore
            }),
        modifiers: customModifiers
    }));
};
var $aa678bf4826904b9$export$2e2bcd8739ae039 = $aa678bf4826904b9$var$CloseDateFilterWithDatePicker;
module.exports["default"] = $aa678bf4826904b9$export$2e2bcd8739ae039;

});

parcelRegister("jf1P1", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $7b970749984af528$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    closeDate: {
        id: "search-page.filters.names.closeDate",
        defaultMessage: "Close date"
    }
});
module.exports["i18n"] = $7b970749984af528$export$a7357cdd1f0b0168;

});

parcelRegister("drVRR", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3d42a851790c0721$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentedByMe: {
        id: "search-page.filters.names.work-commented-on",
        defaultMessage: "Work I've commented on"
    }
});
module.exports["i18n"] = $3d42a851790c0721$export$a7357cdd1f0b0168;

});

parcelRegister("dO5lX", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f632168de68b9766$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    content: {
        id: "search-page.filters.names.content",
        defaultMessage: "Content under"
    },
    confluenceFilterPlaceholder: {
        id: "search-page.confluence.filter.content.placeholder",
        defaultMessage: "Find content"
    },
    confluenceFilterLabelSelected: {
        id: "search-page.confluence.filter.content.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "search-page.confluence.filter.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $f632168de68b9766$export$a7357cdd1f0b0168;

});

parcelRegister("2RkQg", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $ddb658b711162ced$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    contributor: {
        id: "search-page.filters.names.contributor",
        defaultMessage: "Contributor"
    },
    confluenceFilterContributorPlaceholder: {
        id: "search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterContributorLabelSelected: {
        id: "search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterContributorLabelUnselected: {
        id: "search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $ddb658b711162ced$export$a7357cdd1f0b0168;

});

parcelRegister("35KZ1", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9e4ae55be4be6ad4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    createdBy: {
        id: "search-page.filters.names.createdBy",
        defaultMessage: "Created by"
    },
    confluenceFilterCreatorPlaceholder: {
        id: "search-page.confluence.filter.creator.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterCreatorLabelSelected: {
        id: "search-page.confluence.filter.creator.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterCreatorLabelUnselected: {
        id: "search-page.confluence.filter.creator.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $9e4ae55be4be6ad4$export$a7357cdd1f0b0168;

});

parcelRegister("hiJnb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $ea5b4e70f5f59539$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    focusAreaType: {
        id: "search-page.filters.names.focusAreaType",
        defaultMessage: "Focus area type"
    },
    mercuryFilterFocusAreaTypePlaceholder: {
        id: "search-page.mercury.filter.focusAreaType.placeholder",
        defaultMessage: "Find focus area types"
    },
    mercuryFilterFocusAreaTypeLabelSelected: {
        id: "search-page.mercury.filter.focusAreaType.label.selected",
        defaultMessage: "Selected"
    },
    mercuryFilterFocusAreaTypeLabelUnselected: {
        id: "search-page.mercury.filter.focusAreaType.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $ea5b4e70f5f59539$export$a7357cdd1f0b0168;

});

parcelRegister("1epJJ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $cfc139e386a03391$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    mercuryFilterFocusAreaUnderLabel: {
        id: "search-page.filters.names.focusAreaUnder",
        defaultMessage: "Focus area under"
    },
    mercuryFilterFocusAreaUnderLabelPlaceholder: {
        id: "search-page.mercury.filter.content.placeholder",
        defaultMessage: "Find focus areas"
    },
    mercuryFilterFocusAreaUnderLabelLabelSelected: {
        id: "search-page.mercury.filter.content.selected",
        defaultMessage: "Selected"
    },
    mercuryFilterFocusAreaUnderLabelUnselected: {
        id: "search-page.mercury.filter.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $cfc139e386a03391$export$a7357cdd1f0b0168;

});

parcelRegister("9WvAH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $756ecd841137780b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    hasAttachment: {
        id: "search-page.filters.names.has-attachment",
        defaultMessage: "Has attachment"
    }
});
module.exports["i18n"] = $756ecd841137780b$export$a7357cdd1f0b0168;

});

parcelRegister("eDcMw", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $6f66574103527d20$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    label: {
        id: "search-page.filters.names.labels",
        defaultMessage: "Label"
    },
    confluenceFilterLabelPlaceholder: {
        id: "search-page.confluence.filter.labels.placeholder",
        defaultMessage: "Find labels"
    },
    selectedOptionsSection: {
        id: "search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelsNoText: {
        id: "advanced-search.labels.filter.no.text",
        defaultMessage: "Start typing to search for a label"
    },
    suggestedOptionsSection: {
        id: "search-page.filter.suggested.options.section",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $6f66574103527d20$export$a7357cdd1f0b0168;

});

parcelRegister("9PTlU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $7iBhV = parcelRequire("7iBhV");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $kjNCN = parcelRequire("kjNCN");


var $cJ4TJ = parcelRequire("cJ4TJ");


var $kiOcc = parcelRequire("kiOcc");


var $kmrEb = parcelRequire("kmrEb");

const $1ff899806b26058d$var$containerStyles = (0, $ecnYn.xcss)({
    boxSizing: 'border-box',
    width: '375px',
    overflow: 'visible',
    backgroundColor: 'elevation.surface.overlay',
    ':focus': {
        outline: 'none'
    },
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    zIndex: 'card'
});
const $1ff899806b26058d$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ...props,
        paddingBlock: "space.100",
        ref: ref,
        xcss: $1ff899806b26058d$var$containerStyles,
        "data-testid": undefined
    }));
const $1ff899806b26058d$export$3ae94a2503e890a1 = (dateString, locale)=>{
    // to keep date string in local time, not UTC:
    // https://stackoverflow.com/questions/39223481/incorrect-date-shown-in-new-date-in-javascript
    const modifiedDateString = dateString.concat('T00:00');
    return new Date(modifiedDateString).toLocaleDateString(locale);
};
const $1ff899806b26058d$export$7405c5f2f8c0840d = (locale, afterString, beforeString, from, to)=>{
    if (from && !to) {
        const localeFromDate = $1ff899806b26058d$export$3ae94a2503e890a1(from, locale);
        return `${afterString} ${localeFromDate}`;
    }
    if (!from && to) {
        const localeToDate = $1ff899806b26058d$export$3ae94a2503e890a1(to, locale);
        return `${beforeString} ${localeToDate}`;
    }
    if (from && to) {
        const localeFromDate = $1ff899806b26058d$export$3ae94a2503e890a1(from, locale);
        const localeToDate = $1ff899806b26058d$export$3ae94a2503e890a1(to, locale);
        return `${localeFromDate} - ${localeToDate}`;
    }
};
const $1ff899806b26058d$export$d397f86d22f413e8 = (isSelected, isCustomDateSelected, selectedLabel, label, afterString, beforeString, locale, from, to)=>{
    if (!isSelected || !selectedLabel) return label;
    const prefix = label.length > 0 ? `${label}: ` : '';
    if (isCustomDateSelected && (from || to)) {
        const valueLabel = $1ff899806b26058d$export$7405c5f2f8c0840d(locale, afterString, beforeString, from, to);
        return `${prefix}${valueLabel}`;
    }
    return `${prefix}${selectedLabel}`;
};
const $1ff899806b26058d$var$DateFilterWithCustomRangePicker = ({ options: options, onDropdownOpen: onDropdownOpen, onSelectChange: onSelectChange, selectedOptions: selectedOptions, customDateRange: customDateRange, label: label, testId: testId, isFilterInDropdown: isFilterInDropdown, isDefaultOpen: isDefaultOpen = false, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, iconBefore: iconBefore, hideOnHoverOut: hideOnHoverOut, matchReferenceWidth: matchReferenceWidth = isFilterInDropdown, contentFit: contentFit })=>{
    const [open, setOpen] = (0, $42omo.useState)(isDefaultOpen);
    const [customDateOpen, setCustomDateOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [focusedOption, setFocusedOption] = (0, $42omo.useState)(0);
    const [mouseHovered, setMouseHovered] = (0, $42omo.useState)(false);
    const buttonRef = (0, $42omo.useRef)(null);
    const isSelected = selectedOptions.length > 0 || open;
    const firstSelected = selectedOptions[0];
    const isCustomDateSelected = firstSelected?.value === (0, $7iBhV.CUSTOM_OPTION_VALUE);
    const customModifiers = [
        ...matchReferenceWidth ? [
            (0, $kjNCN.matchReferenceWidthModifier)
        ] : []
    ];
    const labelToDisplay = $1ff899806b26058d$export$d397f86d22f413e8(isSelected, isCustomDateSelected, firstSelected?.label || '', label, formatMessage((0, $kmrEb.i18n).dateFilterAfterLabel), formatMessage((0, $kmrEb.i18n).dateFilterBeforeLabel), locale, customDateRange.from, customDateRange.to);
    const handleOptionClick = (option)=>{
        if (option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE)) setCustomDateOpen(true);
        else {
            setCustomDateOpen(false);
            onSelectChange(option, customDateRange);
            setOpen(false);
        }
    };
    const handleCustomDateRangeChange = (from, to)=>{
        const option = options.find((o)=>o.value === (0, $7iBhV.CUSTOM_OPTION_VALUE));
        if (!option) return;
        onSelectChange(option, {
            from: from,
            to: to
        });
        setOpen(false);
    };
    const handleClickDropdownBtn = ()=>{
        if (!open && onDropdownOpen) onDropdownOpen();
        setOpen(!open);
        setFocusedOption(0);
        buttonRef.current?.focus();
    };
    const handleKeyDown = (event)=>{
        // Only handle arrow keys for menu option navigation when not in DatePicker
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev + 1) % options.length);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev - 1 + options.length) % options.length);
        }
        if (event.key === 'Enter' && open) {
            event.preventDefault();
            handleOptionClick(options[focusedOption]);
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (isCustomDateSelected) setCustomDateOpen(true);
        else setCustomDateOpen(false);
    }, [
        isCustomDateSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        enabled: hideOnHoverOut,
        callback: ()=>setOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        onClose: ()=>setOpen(false),
        isOpen: open,
        autoFocus: false,
        popupComponent: $1ff899806b26058d$var$PopupComponent,
        zIndex: (0, $dh538.fg)('platform-dst-motion-uplift-popup') ? 100 : undefined,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                role: "menu",
                onMouseOver: ()=>setMouseHovered(true),
                onMouseOut: ()=>setMouseHovered(false)
            }, options.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cJ4TJ.default), {
                    hovered: !mouseHovered && focusedOption === index,
                    key: option.value,
                    option: option,
                    onClick: ()=>handleOptionClick(option)
                })), customDateOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kiOcc.default), {
                onCustomDateRangeChange: handleCustomDateRangeChange,
                customDateRange: customDateRange,
                testId: testId ? `${testId}-custom-date-range-picker` : undefined
            })),
        trigger: (triggerProps)=>isFiltersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ...triggerProps,
                contentFit: contentFit,
                testId: testId ? `${testId}-button` : undefined,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                onKeyDown: handleKeyDown,
                filterOrControlId: "lastUpdated",
                isFilterInDropdown: isFilterInDropdown,
                iconBefore: iconBefore
            }, labelToDisplay) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                label: labelToDisplay,
                filterOrControlId: 'lastUpdated',
                otherProps: triggerProps,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                testId: testId ? `${testId}-button` : undefined,
                onKeyDown: handleKeyDown,
                wide: true,
                iconBefore: iconBefore
            }),
        modifiers: customModifiers
    }));
};
var $1ff899806b26058d$export$2e2bcd8739ae039 = $1ff899806b26058d$var$DateFilterWithCustomRangePicker;
module.exports["default"] = $1ff899806b26058d$export$2e2bcd8739ae039;

});

parcelRegister("hCRbr", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $6e59924e5f5416ed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    lastUpdated: {
        id: "search-page.filters.names.lastUpdated",
        defaultMessage: "Last updated"
    }
});
module.exports["i18n"] = $6e59924e5f5416ed$export$a7357cdd1f0b0168;

});

parcelRegister("mCz2w", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c609d4e7beffa18b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    lastUpdatedBy: {
        id: "search-page.filters.names.lastUpdatedBy",
        defaultMessage: "Last updated by"
    },
    confluenceFilterCreatorPlaceholder: {
        id: "search-page.confluence.filter.creator.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterCreatorLabelSelected: {
        id: "search-page.confluence.filter.creator.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterCreatorLabelUnselected: {
        id: "search-page.confluence.filter.creator.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $c609d4e7beffa18b$export$a7357cdd1f0b0168;

});

parcelRegister("rdHwx", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b8642f7d61b5dbdc$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    opportunityStatusFilterLabel: {
        id: "search-page.salesforce.filter.dealStatus",
        defaultMessage: "Deal status"
    }
});
module.exports["i18n"] = $b8642f7d61b5dbdc$export$a7357cdd1f0b0168;

});

parcelRegister("ivrfM", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $039964b2efeb1cde$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    owner: {
        id: "search-page.filters.names.owner",
        defaultMessage: "Owner"
    },
    confluenceFilterOwnerPlaceholder: {
        id: "search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterOwnerLabelSelected: {
        id: "search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterOwnerLabelUnselected: {
        id: "search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $039964b2efeb1cde$export$a7357cdd1f0b0168;

});

parcelRegister("6yMPR", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5be789084c01dbcc$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    pageStatus: {
        id: "search-page.filters.names.pageStatus",
        defaultMessage: "Status"
    }
});
module.exports["i18n"] = $5be789084c01dbcc$export$a7357cdd1f0b0168;

});

parcelRegister("kjNCN", function(module, exports) {
const $746d41e27aa45b74$export$5374bb854d0e41c8 = (value)=>{
    return typeof value === 'number' && value > 0;
};
const $746d41e27aa45b74$export$a8e9b369768a413a = {
    name: 'matchReferenceWidth',
    enabled: true,
    phase: 'beforeWrite',
    fn: ({ state: state })=>{
        if ($746d41e27aa45b74$export$5374bb854d0e41c8(state?.rects?.reference?.width)) state.styles.popper.width = `${state.rects.reference.width}px`;
    }
};
module.exports["matchReferenceWidthModifier"] = $746d41e27aa45b74$export$a8e9b369768a413a;

});

parcelRegister("5eact", function(module, exports) {
const $016b627a277b33e4$var$stripHighlightMarkers = (value)=>value.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $016b627a277b33e4$export$74e4b86c77a70501 = ({ label: label, firstSelectedLabel: firstSelectedLabel = '', numSelectedOptions: numSelectedOptions })=>{
    const sanitizedFirstSelectedLabel = $016b627a277b33e4$var$stripHighlightMarkers(firstSelectedLabel);
    const colon = sanitizedFirstSelectedLabel && label ? ': ' : '';
    const comma = sanitizedFirstSelectedLabel && numSelectedOptions > 1 ? ',' : '';
    return `${label}${colon}${sanitizedFirstSelectedLabel}${comma}`;
};
module.exports["getButtonText"] = $016b627a277b33e4$export$74e4b86c77a70501;

});

parcelRegister("FK90w", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b53f07eda24f4494$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterFocusAreaLabel: {
        id: "search-page.filters.names.positionFocusArea",
        defaultMessage: "Focus area"
    },
    positionFilterFocusAreaPlaceholder: {
        id: "search-page.talent.filter.focus-area.content.placeholder",
        defaultMessage: "Find focus areas"
    },
    positionFilterFocusAreaLabelSelected: {
        id: "search-page.talent.filter.focus-area.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterFocusAreaLabelUnselected: {
        id: "search-page.talent.filter.focus-area.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $b53f07eda24f4494$export$a7357cdd1f0b0168;

});

parcelRegister("1pFlR", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $23ec026d911c1d6c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterJobFamilyLabel: {
        id: "search-page.filters.names.positionJobFamily",
        defaultMessage: "Job family"
    },
    positionFilterJobFamilyPlaceholder: {
        id: "search-page.talent.filter.position-job-family.content.placeholder",
        defaultMessage: "Find job families"
    },
    positionFilterJobFamilyLabelSelected: {
        id: "search-page.talent.filter.position-job-family.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterJobFamilyLabelUnselected: {
        id: "search-page.talent.filter.position-job-family.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $23ec026d911c1d6c$export$a7357cdd1f0b0168;

});

parcelRegister("7SF4k", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $469bdda9d8c8bfa0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionStatusFilterLabel: {
        id: "search-page.filters.names.position-status-filter",
        defaultMessage: "Filled status"
    },
    positionStatusFilterPlaceholder: {
        id: "search-page.talent.filter.position-status-filter.content.placeholder",
        defaultMessage: "Find filled status"
    },
    positionStatusFilterLabelSelected: {
        id: "search-page.talent.filter.position-status-filter.content.selected",
        defaultMessage: "Selected"
    },
    positionStatusFilterLabelUnselected: {
        id: "search-page.talent.filter.position-status-filter.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $469bdda9d8c8bfa0$export$a7357cdd1f0b0168;

});

parcelRegister("7PdYY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $2f33d1c42b74a8be$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterTeamLabel: {
        id: "search-page.filters.names.positionTeam",
        defaultMessage: "Team"
    },
    positionFilterTeamPlaceholder: {
        id: "search-page.talent.filter.position-team.content.placeholder",
        defaultMessage: "Find teams"
    },
    positionFilterTeamLabelSelected: {
        id: "search-page.talent.filter.position-team.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterTeamLabelUnselected: {
        id: "search-page.talent.filter.position-team.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $2f33d1c42b74a8be$export$a7357cdd1f0b0168;

});

parcelRegister("dSRVv", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $86780f5cae351dc9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    project: {
        id: "search-page.filters.names.project",
        defaultMessage: "Project"
    },
    jiraFilterProjectPlaceholder: {
        id: "search-page.jira.filter.project.placeholder",
        defaultMessage: "Find projects"
    },
    jiraFilterProjectLabelSelected: {
        id: "search-page.jira.filter.project.selected",
        defaultMessage: "Selected"
    },
    jiraFilterProjectLabelUnselected: {
        id: "search-page.jira.filter.project.unselected",
        defaultMessage: "Suggested"
    },
    spaces: {
        id: "search-page.filters.names.spaces",
        defaultMessage: "Space"
    },
    jiraFilterSpacesPlaceholder: {
        id: "search-page.jira.filter.spaces.placeholder",
        defaultMessage: "Find spaces"
    },
    jiraFilterSpacesLabelSelected: {
        id: "search-page.jira.filter.spaces.selected",
        defaultMessage: "Selected"
    },
    jiraFilterSpacesLabelUnselected: {
        id: "search-page.jira.filter.spaces.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $86780f5cae351dc9$export$a7357cdd1f0b0168;

});

parcelRegister("kAzVs", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9bf8970e96f0ce5c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    pullRequestStatusLabel: {
        id: "search-page.filters.names.pull-request-status",
        defaultMessage: "PR status"
    }
});
module.exports["i18n"] = $9bf8970e96f0ce5c$export$a7357cdd1f0b0168;

});

parcelRegister("41YG4", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $67dca52cd4dd7a2d$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    reporter: {
        id: "search-page.filters.names.reporter",
        defaultMessage: "Reporter"
    },
    jiraFilterContributorPlaceholder: {
        id: "search-page.jira.filter.reporter.placeholder",
        defaultMessage: "Find people"
    },
    jiraFilterReporterLabelSelected: {
        id: "search-page.jira.filter.reporter.selected",
        defaultMessage: "Selected"
    },
    jiraFilterReporterLabelUnselected: {
        id: "search-page.jira.filter.reporter.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $67dca52cd4dd7a2d$export$a7357cdd1f0b0168;

});

parcelRegister("bbo8Q", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $40cd8354da07d7e9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    repositoryLabel: {
        id: "search-page.filters.names.repository",
        defaultMessage: "Repository"
    },
    noOptions: {
        id: "search-page.filters.names.repository.no-options",
        defaultMessage: "No repositories available"
    }
});
module.exports["i18n"] = $40cd8354da07d7e9$export$a7357cdd1f0b0168;

});

parcelRegister("1zWkb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $bda62529a18ff81f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    relevanceDESC: {
        id: "results-sort.relevanceDESC",
        defaultMessage: "Relevance"
    },
    relevanceDESCSelected: {
        id: "results-sort.relevanceDESC.selected",
        defaultMessage: "Sort by relevance"
    },
    latestModifiedDateDESC: {
        id: "results-sort.latestModifiedDateDESC",
        defaultMessage: "Updated (newest)"
    },
    latestModifiedDateDESCSelected: {
        id: "results-sort.latestModifiedDateDESC.selected",
        defaultMessage: "Sort by updated (newest)"
    },
    latestModifiedDateASC: {
        id: "results-sort.latestModifiedDateASC",
        defaultMessage: "Updated (oldest)"
    },
    latestModifiedDateASCSelected: {
        id: "results-sort.latestModifiedDateASC.selected",
        defaultMessage: "Sort by updated (oldest)"
    },
    createdDateDESC: {
        id: "results-sort.createdDateDESC",
        defaultMessage: "Created (newest)"
    },
    createdDateDESCSelected: {
        id: "results-sort.createdDate.selected",
        defaultMessage: "Sort by created (newest)"
    },
    createdDateASC: {
        id: "results-sort.createdDateASC",
        defaultMessage: "Created (oldest)"
    },
    createdDateASCSelected: {
        id: "results-sort.createdDateASCSelected.selected",
        defaultMessage: "Sort by created (oldest)"
    },
    sortOptionsLabel: {
        id: "results-sort.sort-options.label",
        defaultMessage: "Change list sorting"
    }
});
module.exports["messages"] = $bda62529a18ff81f$export$defe85febe8b728c;

});

parcelRegister("16U2b", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d8adca952eaf3df4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    salesforceStageFilterLabel: {
        id: "search-page.salesforce.filter.stage",
        defaultMessage: "Deal stage"
    },
    salesforceStageFilterNoOptions: {
        id: "search-page.salesforce.filter.stage.no-options",
        defaultMessage: "No stages available"
    }
});
module.exports["i18n"] = $d8adca952eaf3df4$export$a7357cdd1f0b0168;

});

parcelRegister("13BpK", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $85b64aa75c31bec0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    label: {
        id: "search-page-relay.filters.product-filters.slack-channel.label",
        defaultMessage: "Channel"
    },
    placeholder: {
        id: "search-page-relay.filters.product-filters.slack-channel.placeholder",
        defaultMessage: "Filter by channel"
    },
    selectedLabel: {
        id: "search-page-relay.filters.product-filters.slack-channel.selected-label",
        defaultMessage: "Selected"
    },
    suggestedLabel: {
        id: "search-page-relay.filters.product-filters.slack-channel.suggested-label",
        defaultMessage: "Channels"
    }
});
module.exports["i18n"] = $85b64aa75c31bec0$export$a7357cdd1f0b0168;

});

parcelRegister("8QBsF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b3b9a830e69616f9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    space: {
        id: "search-page.filters.names.space",
        defaultMessage: "Space"
    },
    drive: {
        id: "search-page.filters.names.drive",
        defaultMessage: "Drive"
    },
    drivePlaceholder: {
        id: "search-page.google-drive.filter.drive.placeholder",
        defaultMessage: "Find drives"
    },
    site: {
        id: "search-page.filters.names.site",
        defaultMessage: "Site"
    },
    sitePlaceholder: {
        id: "search-page.sharepoint.filter.site.placeholder",
        defaultMessage: "Find sites"
    },
    confluenceFilterSpacePlaceholder: {
        id: "search-page.confluence.filter.space.placeholder",
        defaultMessage: "Find spaces"
    },
    confluenceFilterLabelSelected: {
        id: "search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "search-page.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    },
    confluenceIconLabel: {
        id: "search-page.confluence.filter.icon.label",
        defaultMessage: "Confluence filter"
    }
});
module.exports["i18n"] = $b3b9a830e69616f9$export$a7357cdd1f0b0168;

});

parcelRegister("6ebAl", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9d4fe03134881c57$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    statusLabel: {
        id: "search-page.filters.names.status",
        defaultMessage: "Status"
    }
});
module.exports["i18n"] = $9d4fe03134881c57$export$a7357cdd1f0b0168;

});

parcelRegister("316RU", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $75b228b7e7645094$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    onlyTitleMatch: {
        id: "search-page.filters.names.titleMatchOnly",
        defaultMessage: "Search title only"
    }
});
module.exports["i18n"] = $75b228b7e7645094$export$a7357cdd1f0b0168;

});

parcelRegister("OOvdO", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d476884385e65d0e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    type: {
        id: "search-page.filters.names.type",
        defaultMessage: "Type"
    },
    filterTypePlaceholder: {
        id: "search-page.filter.type.placeholder",
        defaultMessage: "Find type"
    }
});
module.exports["i18n"] = $d476884385e65d0e$export$a7357cdd1f0b0168;

});

parcelRegister("iwoTl", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $885181c38aab6da0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    verified: {
        id: "search-page.filters.names.verified",
        defaultMessage: "Verified"
    }
});
module.exports["i18n"] = $885181c38aab6da0$export$a7357cdd1f0b0168;

});

parcelRegister("hK6k5", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1a47a81a1360c09a$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    watchedByMe: {
        id: "search-page.filters.names.work-watching",
        defaultMessage: "Work I\u2019m watching"
    }
});
module.exports["i18n"] = $1a47a81a1360c09a$export$a7357cdd1f0b0168;

});

parcelRegister("cJ4TJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");

const $a28365e4b08c6c91$var$itemStyles = (0, $ecnYn.xcss)({
    cursor: 'default',
    width: '100%',
    textAlign: 'left',
    borderLeftWidth: 'border.width.selected',
    borderLeftStyle: 'solid',
    borderColor: 'color.border.inverse',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        borderColor: 'color.border.selected',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $a28365e4b08c6c91$var$insideItemStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.025',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $a28365e4b08c6c91$var$itemHoveredStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $a28365e4b08c6c91$var$itemSelectedStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.selected'
});
const $a28365e4b08c6c91$var$DateOption = ({ option: option, hovered: hovered, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        role: "menuitem",
        xcss: [
            $a28365e4b08c6c91$var$itemStyles,
            option.isSelected && $a28365e4b08c6c91$var$itemSelectedStyles,
            hovered && $a28365e4b08c6c91$var$itemHoveredStyles
        ],
        key: option.label,
        onClick: onClick,
        paddingInline: "space.150",
        paddingBlock: "space.075",
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a28365e4b08c6c91$var$insideItemStyles
    }, option.label));
var $a28365e4b08c6c91$export$2e2bcd8739ae039 = $a28365e4b08c6c91$var$DateOption;
module.exports["default"] = $a28365e4b08c6c91$export$2e2bcd8739ae039;

});

parcelRegister("deQ0D", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b3781e667aa8f1e4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    closeDateFilterLabel: {
        id: "search-page.close-date-filter.label",
        defaultMessage: "Close date"
    },
    closeDateFilterUpdateButton: {
        id: "search-page.close-date-filter.update-button",
        defaultMessage: "Apply"
    },
    closeDateFilterDateLabel: {
        id: "search-page.close-date-filter.date-label",
        defaultMessage: "Select date"
    },
    closeDateFilterDatePlaceholder: {
        id: "search-page.close-date-filter.date-placeholder",
        defaultMessage: "Select a date"
    }
});
module.exports["i18n"] = $b3781e667aa8f1e4$export$a7357cdd1f0b0168;

});

parcelRegister("kiOcc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $c4Cbx = parcelRequire("c4Cbx");


var $a3fRD = parcelRequire("a3fRD");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $dOOW1 = parcelRequire("dOOW1");


var $kmrEb = parcelRequire("kmrEb");

const $2ff09c563d04787a$export$1dc6c6b3e4774b92 = {
    [(0, $dOOW1.DateRangeError).FROM_AFTER_TO_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kmrEb.i18n).dateFilterCustomInvalidDateAfterEnd),
    [(0, $dOOW1.DateRangeError).FROM_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kmrEb.i18n).dateFilterCustomInvalidDateAfterToday),
    [(0, $dOOW1.DateRangeError).TO_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kmrEb.i18n).dateFilterCustomInvalidToDateAfterToday)
};
const $2ff09c563d04787a$var$datePickerWrapper = (0, $ecnYn.xcss)({
    width: '155px'
});
const $2ff09c563d04787a$var$DateRangePicker = ({ onCustomDateRangeChange: onCustomDateRangeChange, customDateRange: customDateRange, testId: testId })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [selectedFromDate, setSelectedFromDate] = (0, $42omo.useState)(customDateRange.from);
    const [selectedToDate, setSelectedToDate] = (0, $42omo.useState)(customDateRange.to);
    const invalidDateRange = (0, $dOOW1.getInvalidDateRange)(selectedFromDate, selectedToDate);
    const handleUpdateSelectedDates = ()=>{
        if (Boolean(invalidDateRange)) return;
        onCustomDateRangeChange(selectedFromDate, selectedToDate);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.150",
        paddingBlock: "space.075",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "start",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2ff09c563d04787a$var$datePickerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
        onChange: (date)=>setSelectedFromDate(date),
        defaultValue: selectedFromDate,
        placeholder: formatMessage((0, $kmrEb.i18n).dateFilterFromTitle),
        isInvalid: Boolean(invalidDateRange),
        locale: locale,
        label: formatMessage((0, $kmrEb.i18n).dateFilterFromLabel),
        shouldShowCalendarButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, formatMessage((0, $kmrEb.i18n).dateFilterToRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2ff09c563d04787a$var$datePickerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
        onChange: (date)=>setSelectedToDate(date),
        defaultValue: selectedToDate,
        placeholder: formatMessage((0, $kmrEb.i18n).dateFilterToTitle),
        isInvalid: invalidDateRange === (0, $dOOW1.DateRangeError).FROM_AFTER_TO_ERROR,
        locale: locale,
        label: formatMessage((0, $kmrEb.i18n).dateFilterToLabel),
        shouldShowCalendarButton: true
    }))), invalidDateRange ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Date range error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.danger"
    }, $2ff09c563d04787a$export$1dc6c6b3e4774b92[invalidDateRange]))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        isDisabled: Boolean(invalidDateRange),
        onClick: handleUpdateSelectedDates
    }, formatMessage((0, $kmrEb.i18n).dateFilterUpdateButton)))));
};
var $2ff09c563d04787a$export$2e2bcd8739ae039 = $2ff09c563d04787a$var$DateRangePicker;
module.exports["default"] = $2ff09c563d04787a$export$2e2bcd8739ae039;

});

parcelRegister("kmrEb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $bb7b46309e681bed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    dateFilterTitle: {
        id: "date.filter.title",
        defaultMessage: "Last updated"
    },
    dateFilterFromTitle: {
        id: "date.filter.from.title",
        defaultMessage: "From"
    },
    dateFilterFromLabel: {
        id: "date.filter.from.label",
        defaultMessage: "Choose start date to filter"
    },
    dateFilterToTitle: {
        id: "date.filter.to.title",
        defaultMessage: "To"
    },
    dateFilterToLabel: {
        id: "date.filter.to.label",
        defaultMessage: "Choose end date to filter"
    },
    dateFilterDateInputPlaceholder: {
        id: "date.filter.input.placeholder",
        defaultMessage: "Choose a date"
    },
    dateFilterAnyTime: {
        id: "date.filter.any.time",
        defaultMessage: "Anytime"
    },
    dateFilterToday: {
        id: "date.filter.today",
        defaultMessage: "Today"
    },
    dateFilterYesterday: {
        id: "date.filter.yesterday",
        defaultMessage: "Yesterday"
    },
    dateFilterLastWeek: {
        id: "date.filter.last.week",
        defaultMessage: "Past 7 days"
    },
    dateFilterLastMonth: {
        id: "date.filter.last.month",
        defaultMessage: "Past 30 days"
    },
    dateFilterLastYear: {
        id: "date.filter.last.year",
        defaultMessage: "Past year"
    },
    dateFilterCustom: {
        id: "date.filter.custom",
        defaultMessage: "Custom"
    },
    dateFilterCustomInvalidDateAfterToday: {
        id: "date.filter.custom.invalid.after.today",
        defaultMessage: "The From date can\u2019t be in the future"
    },
    dateFilterCustomInvalidToDateAfterToday: {
        id: "date.filter.custom.invalid.to.after.today",
        defaultMessage: "The To date can\u2019t be in the future"
    },
    dateFilterCustomInvalidDateAfterEnd: {
        id: "date.filter.custom.invalid.after.end",
        defaultMessage: "The From date has to be before the To date"
    },
    dateFilterToRange: {
        id: "date.filter.to.range",
        defaultMessage: "to"
    },
    dateFilterUpdateButton: {
        id: "date.filter.update.button",
        defaultMessage: "Update"
    },
    dateFilterBeforeLabel: {
        id: "date.filter.before.label",
        defaultMessage: "before"
    },
    dateFilterAfterLabel: {
        id: "date.filter.after.label",
        defaultMessage: "after"
    }
});
module.exports["i18n"] = $bb7b46309e681bed$export$a7357cdd1f0b0168;

});


//# sourceMappingURL=QuickFind.f7ea8b9e.js.map
